/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _index = __webpack_require__(1);

	var _index2 = _interopRequireDefault(_index);

	var _index3 = __webpack_require__(3);

	var _index4 = _interopRequireDefault(_index3);

	var _index5 = __webpack_require__(4);

	var _index6 = _interopRequireDefault(_index5);

	var _main = __webpack_require__(5);

	var _main2 = _interopRequireDefault(_main);

	var _annotations = __webpack_require__(30);

	var _annotations2 = _interopRequireDefault(_annotations);

	var _annotationsUploader = __webpack_require__(103);

	var _annotationsUploader2 = _interopRequireDefault(_annotationsUploader);

	var _privacy = __webpack_require__(104);

	var _privacy2 = _interopRequireDefault(_privacy);

	var _login = __webpack_require__(114);

	var _login2 = _interopRequireDefault(_login);

	var _loginModal = __webpack_require__(115);

	var _loginModal2 = _interopRequireDefault(_loginModal);

	var _share = __webpack_require__(116);

	var _share2 = _interopRequireDefault(_share);

	var _flag = __webpack_require__(117);

	var _flag2 = _interopRequireDefault(_flag);

	var _embed = __webpack_require__(118);

	var _embed2 = _interopRequireDefault(_embed);

	var _unauthorized = __webpack_require__(119);

	var _unauthorized2 = _interopRequireDefault(_unauthorized);

	var _ouibounce = __webpack_require__(120);

	var _ouibounce2 = _interopRequireDefault(_ouibounce);

	var _upgrade = __webpack_require__(121);

	var _upgrade2 = _interopRequireDefault(_upgrade);

	var _item = __webpack_require__(122);

	var _item2 = _interopRequireDefault(_item);

	var _user = __webpack_require__(125);

	var _user2 = _interopRequireDefault(_user);

	var _storage = __webpack_require__(126);

	var _storage2 = _interopRequireDefault(_storage);

	var _api = __webpack_require__(127);

	var _api2 = _interopRequireDefault(_api);

	var _analytics = __webpack_require__(128);

	var _analytics2 = _interopRequireDefault(_analytics);

	var _pusher = __webpack_require__(129);

	var _pusher2 = _interopRequireDefault(_pusher);

	var _ability = __webpack_require__(130);

	var _ability2 = _interopRequireDefault(_ability);

	var _mimeType = __webpack_require__(131);

	var _mimeType2 = _interopRequireDefault(_mimeType);

	var _loading = __webpack_require__(132);

	var _loading2 = _interopRequireDefault(_loading);

	var _shareVia = __webpack_require__(133);

	var _shareVia2 = _interopRequireDefault(_shareVia);

	var _url = __webpack_require__(135);

	var _url2 = _interopRequireDefault(_url);

	var _flashMessages = __webpack_require__(137);

	var _flashMessages2 = _interopRequireDefault(_flashMessages);

	var _tout = __webpack_require__(138);

	var _tout2 = _interopRequireDefault(_tout);

	var _transcoding = __webpack_require__(139);

	var _transcoding2 = _interopRequireDefault(_transcoding);

	var _codeView = __webpack_require__(164);

	var _codeView2 = _interopRequireDefault(_codeView);

	var _imageView = __webpack_require__(165);

	var _imageView2 = _interopRequireDefault(_imageView);

	var _otherView = __webpack_require__(363);

	var _otherView2 = _interopRequireDefault(_otherView);

	var _pdfView = __webpack_require__(364);

	var _pdfView2 = _interopRequireDefault(_pdfView);

	var _textView = __webpack_require__(365);

	var _textView2 = _interopRequireDefault(_textView);

	var _videoView = __webpack_require__(366);

	var _videoView2 = _interopRequireDefault(_videoView);

	var _flashMessages3 = __webpack_require__(367);

	var _flashMessages4 = _interopRequireDefault(_flashMessages3);

	var _navbar = __webpack_require__(368);

	var _navbar2 = _interopRequireDefault(_navbar);

	var _analytics3 = __webpack_require__(373);

	var _analytics4 = _interopRequireDefault(_analytics3);

	var _teamSelector = __webpack_require__(374);

	var _teamSelector2 = _interopRequireDefault(_teamSelector);

	var _login3 = __webpack_require__(375);

	var _login4 = _interopRequireDefault(_login3);

	var _related = __webpack_require__(376);

	var _related2 = _interopRequireDefault(_related);

	var _sidebar = __webpack_require__(377);

	var _sidebar2 = _interopRequireDefault(_sidebar);

	var _sidebar3 = __webpack_require__(379);

	var _sidebar4 = _interopRequireDefault(_sidebar3);

	var _comments = __webpack_require__(380);

	var _comments2 = _interopRequireDefault(_comments);

	var _comment = __webpack_require__(382);

	var _comment2 = _interopRequireDefault(_comment);

	var _events = __webpack_require__(383);

	var _events2 = _interopRequireDefault(_events);

	var _event = __webpack_require__(384);

	var _event2 = _interopRequireDefault(_event);

	var _source = __webpack_require__(385);

	var _source2 = _interopRequireDefault(_source);

	var _tout3 = __webpack_require__(386);

	var _tout4 = _interopRequireDefault(_tout3);

	var _ouibounce3 = __webpack_require__(388);

	var _ouibounce4 = _interopRequireDefault(_ouibounce3);

	var _upgrade3 = __webpack_require__(389);

	var _upgrade4 = _interopRequireDefault(_upgrade3);

	var _chosen = __webpack_require__(390);

	var _chosen2 = _interopRequireDefault(_chosen);

	__webpack_require__(391);

	var _exceptionHandler = __webpack_require__(392);

	var _exceptionHandler2 = _interopRequireDefault(_exceptionHandler);

	var _browserDetect = __webpack_require__(395);

	var _browserDetect2 = _interopRequireDefault(_browserDetect);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var moduleName = (0, _browserDetect2.default)(); /* global filepicker, moment, Pusher, jQuery, fabric, _ */


	angular.module(moduleName, ['viewerConfig', 'ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngResource', 'ngRoute', 'hljs', 'cfp.hotkeys', 'angularMoment', 'ngSanitize', 'btford.markdown', 'ngTagsInput', 'angular-click-outside', 'ui.bootstrap.showErrors', 'ngSilent', 'ui.bootstrap.modal', 'ui.bootstrap.tooltip', 'ui.bootstrap.popover', 'ui.bootstrap.tpls', 'ui.bootstrap.alert', 'ngclipboard', 'angularLoad']).constant('moment', moment).constant('Pusher', Pusher).constant('$', jQuery).constant('_', _).constant('filepicker', filepicker).constant('fabric', fabric).config(_index2.default).config(_index4.default).run(_index6.default).factory('$exceptionHandler', _exceptionHandler2.default).service('Api', _api2.default).service('analyticsService', _analytics2.default).service('itemService', _item2.default).service('userService', _user2.default).service('storageService', _storage2.default).service('pusherService', _pusher2.default).service('abilityService', _ability2.default).service('commentService', _comment2.default).service('eventService', _event2.default).service('loadingService', _loading2.default).service('mimeTypeService', _mimeType2.default).service('shareViaService', _shareVia2.default).service('urlService', _url2.default).service('flashMessagesService', _flashMessages2.default).service('sourceService', _source2.default).service('toutService', _tout2.default).service('transcodingService', _transcoding2.default).controller('MainController', _main2.default).controller('AnnotationsController', _annotations2.default).controller('PrivacyController', _privacy2.default).controller('LoginController', _login2.default).controller('LoginModalController', _loginModal2.default).controller('ShareController', _share2.default).controller('FlagController', _flag2.default).controller('EmbedController', _embed2.default).controller('OuibounceController', _ouibounce2.default).controller('UpgradeController', _upgrade2.default).directive('codeView', function () {
	  return new _codeView2.default();
	}).directive('imageView', function () {
	  return new _imageView2.default();
	}).directive('otherView', function () {
	  return new _otherView2.default();
	}).directive('pdfView', function () {
	  return new _pdfView2.default();
	}).directive('sidebar', function () {
	  return new _sidebar2.default();
	}).directive('textView', function () {
	  return new _textView2.default();
	}).directive('videoView', function () {
	  return new _videoView2.default();
	}).directive('comments', function () {
	  return new _comments2.default();
	}).directive('events', function () {
	  return new _events2.default();
	}).directive('navbar', function () {
	  return new _navbar2.default();
	}).directive('analytics', function () {
	  return new _analytics4.default();
	}).directive('login', function () {
	  return new _login4.default();
	}).directive('upgrade', function () {
	  return new _upgrade4.default();
	}).directive('related', function () {
	  return new _related2.default();
	}).directive('flashMessages', function () {
	  return new _flashMessages4.default();
	}).directive('unauthorized', function () {
	  return new _unauthorized2.default();
	}).directive('chosenSelect', function () {
	  return new _chosen2.default();
	}).directive('teamSelector', function () {
	  return new _teamSelector2.default();
	}).directive('tout', function () {
	  return new _tout4.default();
	}).directive('ouibounce', function () {
	  return new _ouibounce4.default();
	}).factory('AnnotationsUploader', _annotationsUploader2.default).factory('sidebarFactory', _sidebar4.default);

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _segment = __webpack_require__(2);

	var _segment2 = _interopRequireDefault(_segment);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function configure(config, $animateProvider, $logProvider, $httpProvider, $sceDelegateProvider, filepicker, Pusher, $uibTooltipProvider) {
	  'ngInject';

	  filepicker.setKey(config.env.FILEPICKER_KEY);
	  $animateProvider.classNameFilter(/^(?:(?!ng-animate-disabled).)*$/);
	  $logProvider.debugEnabled(config.logger === true);

	  $sceDelegateProvider.resourceUrlWhitelist(['self', 'https://d2ffutrenqvap3.cloudfront.net/**', 'https://dha4w82d62smt.cloudfront.net/**', 'https://dr5mo5s7lqrtc.cloudfront.net/**', 'https://d26dzxoao6i3hh.cloudfront.net/**', 'https://d2ppvlu71ri8gs.cloudfront.net/**', 'https://d105kas4b86wc3.cloudfront.net/**', 'https://d3uepj124s5rcx.cloudfront.net/**', 'https://d17oy1vhnax1f7.cloudfront.net/**', 'https://d3dr1ze7164817.cloudfront.net/**', 'https://d3vv6lp55qjaqc.cloudfront.net/**', 'https://d15sd6k45tg31u.cloudfront.net/**', 'https://d7zby7rwtzqe4.cloudfront.net/**', 'https://d2wvs5jsbn4h49.cloudfront.net/**', 'https://d214l9ppd0b0q6.cloudfront.net/**', 'https://d1ax1i5f2y3x71.cloudfront.net/**', 'https://d3uik7083b30dy.cloudfront.net/**', 'https://d1nvcfeljt87mm.cloudfront.net/**', 'https://d2jaf1trmkrnj0.cloudfront.net/**', 'https://d1lbhbfgoue651.cloudfront.net/**', 'https://d3omwy4q2qio9v.cloudfront.net/**', 'https://d3uik7083b30dy.cloudfront.net/**', 'https://s3.amazonaws.com/**', 'http://s3.amazonaws.com/**', 'https://share.getcloudapp.com/**']);

	  $httpProvider.defaults.withCredentials = true;

	  Pusher.XHR = function () {
	    var xhr = new XMLHttpRequest();
	    xhr.withCredentials = true;
	    return xhr;
	  };

	  $uibTooltipProvider.options({
	    placement: 'bottom'
	  });

	  (0, _segment2.default)(config.env.SEGMENT_KEY);
	} /* global XMLHttpRequest:false */
	exports.default = configure;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	exports.default = function (key) {
	  var analytics = window.analytics = window.analytics || [];
	  if (!analytics.initialize) {
	    if (analytics.invoked) {
	      window.console && console.error && console.error("Segment snippet included twice.");
	    } else {
	      analytics.invoked = !0;
	      analytics.methods = ["trackSubmit", "trackClick", "trackLink", "trackForm", "pageview", "identify", "reset", "group", "track", "ready", "alias", "page", "once", "off", "on"];
	      analytics.factory = function (t) {
	        return function () {
	          var e = Array.prototype.slice.call(arguments);
	          e.unshift(t);
	          analytics.push(e);
	          return analytics;
	        };
	      };
	      for (var t = 0; t < analytics.methods.length; t++) {
	        var e = analytics.methods[t];
	        analytics[e] = analytics.factory(e);
	      }
	      analytics.load = function (t) {
	        var e = document.createElement("script");
	        e.type = "text/javascript";
	        e.async = !0;
	        e.src = ("https:" === document.location.protocol ? "https://" : "http://") + "cdn.segment.com/analytics.js/v1/" + t + "/analytics.min.js";
	        var n = document.getElementsByTagName("script")[0];
	        n.parentNode.insertBefore(e, n);
	      };
	    }
	  }
	  analytics.SNIPPET_VERSION = "3.1.0";

	  analytics.load(key);
	};

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function routerConfig($routeProvider, $locationProvider) {
	  'ngInject';

	  var mainController = {
	    templateUrl: 'app/main/main.html',
	    controller: 'MainController',
	    controllerAs: 'main'
	  };

	  var annotationsController = {
	    templateUrl: 'app/annotations/annotations.html',
	    controller: 'AnnotationsController',
	    controllerAs: 'annotate'
	  };

	  $routeProvider.when('/', { templateUrl: 'app/empty.html' }).when('/:slug', mainController).when('/:slug/annotate', annotationsController).when('/:slug/o', mainController).when('/:type/:slug/o', mainController).when('/:type/:slug', mainController).otherwise({ redirectTo: '/' });

	  $locationProvider.html5Mode(true);
	}

	exports.default = routerConfig;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function runBlock($log) {
	  'ngInject';

	  $log.debug('runBlock end');
	}

	exports.default = runBlock;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _classCallCheck2 = __webpack_require__(6);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(7);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _lodash = __webpack_require__(27);

	var _lodash2 = _interopRequireDefault(_lodash);

	var _flag = __webpack_require__(29);

	var _flag2 = _interopRequireDefault(_flag);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var MainController = function () {
	  function MainController($rootScope, $interval, shareViaService, urlService, $route, $location, itemService, abilityService, loadingService, storageService, hotkeys, $scope, $uibModal, filepicker, analyticsService, $window) {
	    'ngInject';

	    (0, _classCallCheck3.default)(this, MainController);
	    if ($route.current.params.revision) {
	      window.console.log("BUILD " + $route.current.params.revision);
	    }

	    if ($route.current.params._ga) {
	      $location.search('_ga', null);
	      $location.replace();
	      return;
	    }

	    if ($route.current.params.st) {
	      itemService.viewItemShare($route.current.params.st);
	      $location.search('st', null);
	      $location.replace();
	      return;
	    }

	    // if ($route.current.params.type) {
	    //   $location.search('type', null);
	    //   $location.replace();
	    //   return;
	    // }

	    if ($route.current.params.mode === "annotations") {
	      $location.path(urlService.annotate(itemService), {}).search('mode', null);
	      $location.replace();
	      return;
	    }

	    $interval(_lodash2.default.noop, 1000);

	    this._urlService = urlService;
	    this._filepicker = filepicker;
	    this.item = itemService;

	    if ($location.path().match("/o$")) {
	      itemService.zoom = true;
	    }
	    this._$modal = $uibModal;
	    abilityService.inject($rootScope);
	    loadingService.inject($rootScope);
	    this.ability = abilityService;
	    this._storageService = storageService;
	    this._hotkeys = hotkeys;
	    var main = this;
	    itemService.getItem();
	    itemService.getDetails().then(function (details) {
	      if (typeof details === "undefined" || !details || !itemService.data) {
	        $window.location.reload();
	      }

	      if (details) {
	        $('body').not(".theme-set").toggleClass('dark', details.theme === "dark");
	        if (details.custom_js) {
	          try {
	            $('head').append(details.custom_js);
	          } catch (e) {
	            window.console.error(e.message);
	          }
	        }
	        if (!!details.expires_at) {
	          var now = new Date();
	          var expires_at = new Date(details.expires_at);
	          if (now > expires_at) {
	            main.item.state = "expired";
	          };
	        }
	      }
	    });

	    hotkeys.bindTo($scope).add({ combo: ['n'], description: 'Toggle Noir', callback: function callback() {
	        return main.toggleNoir();
	      } }).add({
	      combo: ['e'], description: 'Save elsewhere',
	      callback: function callback() {
	        analyticsService.track('save_elsewhere_modal_opened', { campaign_medium: 'shortcut' });
	        main.saveElsewhere();
	      }
	    }).add({ combo: ['s'], description: 'View original file', callback: function callback() {
	        return main.showOriginal();
	      } }).add({ combo: ['d'], description: 'Download file', callback: function callback() {
	        return main.download();
	      } });

	    $("body").on("keypress", "textarea", function (e) {
	      if (e.which === 13 && !e.shiftKey) {
	        $(this).parents("form").find("input[type=submit]").trigger("submit");
	        e.preventDefault();
	      }
	    });
	    analyticsService.page();
	    main.cta = storageService.fetch('showCta', true);
	    // dataLayer is supplied from Google Tag manager and if you're not serving from viso it won't be available.
	    if (storageService.fetch('user_id') && window.dataLayer) {
	      window.dataLayer.push({ 'authedUser': true });
	    }
	  }

	  (0, _createClass3.default)(MainController, [{
	    key: 'init',
	    value: function init() {
	      this.item.viewItem();
	      this.ability.reset();
	    }
	  }, {
	    key: 'rhcAvailable',
	    value: function rhcAvailable() {
	      return this.ability.can('view_comments') || this.ability.can('view_events');
	    }
	  }, {
	    key: 'rhcHidden',
	    value: function rhcHidden() {
	      if (this.rhcAvailable()) {
	        return this._storageService.fetch("rhcHidden", false);
	      } else {
	        return true;
	      }
	    }
	  }, {
	    key: 'flag',
	    value: function flag() {
	      (0, _flag2.default)(this._$modal);
	    }
	  }, {
	    key: 'canFlag',
	    value: function canFlag() {
	      return !this._storageService.arrayHas("flags", this.item.slug());
	    }
	  }, {
	    key: 'download',
	    value: function download() {
	      window.location.href = this._urlService.downloadUrl(this.item);
	    }
	  }, {
	    key: 'showOriginal',
	    value: function showOriginal() {
	      window.location.href = this._urlService.originalUrl(this.item);
	    }
	  }, {
	    key: 'saveElsewhere',
	    value: function saveElsewhere() {
	      var data = _lodash2.default.get(this.item, "data");
	      if (!data) {
	        return;
	      }

	      this._filepicker.exportFile(data.source_url, {
	        mimetype: data.mimetype,
	        suggestedFilename: data.name
	      });
	    }
	  }, {
	    key: 'cheatsheet',
	    value: function cheatsheet() {
	      this._hotkeys.toggleCheatSheet();
	    }
	  }, {
	    key: 'toggleNoir',
	    value: function toggleNoir() {
	      $('body').toggleClass('dark').addClass("theme-set");
	    }
	  }]);
	  return MainController;
	}();
	/* global $, window */

	exports.default = MainController;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	"use strict";

	exports.__esModule = true;

	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _defineProperty = __webpack_require__(8);

	var _defineProperty2 = _interopRequireDefault(_defineProperty);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }

	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(9), __esModule: true };

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(10);
	var $Object = __webpack_require__(13).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(11);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(21), 'Object', { defineProperty: __webpack_require__(17).f });


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(12);
	var core = __webpack_require__(13);
	var ctx = __webpack_require__(14);
	var hide = __webpack_require__(16);
	var has = __webpack_require__(26);
	var PROTOTYPE = 'prototype';

	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 12 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 13 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.5.7' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(15);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 15 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(17);
	var createDesc = __webpack_require__(25);
	module.exports = __webpack_require__(21) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(18);
	var IE8_DOM_DEFINE = __webpack_require__(20);
	var toPrimitive = __webpack_require__(24);
	var dP = Object.defineProperty;

	exports.f = __webpack_require__(21) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(19);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 19 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(21) && !__webpack_require__(22)(function () {
	  return Object.defineProperty(__webpack_require__(23)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(22)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 22 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(19);
	var document = __webpack_require__(12).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(19);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 25 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 26 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/**
	 * @license
	 * lodash 3.10.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern -d -o ./index.js`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	;(function() {

	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;

	  /** Used as the semantic version number. */
	  var VERSION = '3.10.1';

	  /** Used to compose bitmasks for wrapper metadata. */
	  var BIND_FLAG = 1,
	      BIND_KEY_FLAG = 2,
	      CURRY_BOUND_FLAG = 4,
	      CURRY_FLAG = 8,
	      CURRY_RIGHT_FLAG = 16,
	      PARTIAL_FLAG = 32,
	      PARTIAL_RIGHT_FLAG = 64,
	      ARY_FLAG = 128,
	      REARG_FLAG = 256;

	  /** Used as default options for `_.trunc`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';

	  /** Used to detect when a function becomes hot. */
	  var HOT_COUNT = 150,
	      HOT_SPAN = 16;

	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;

	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2;

	  /** Used as the `TypeError` message for "Functions" methods. */
	  var FUNC_ERROR_TEXT = 'Expected a function';

	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';

	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      objectTag = '[object Object]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      weakMapTag = '[object WeakMap]';

	  var arrayBufferTag = '[object ArrayBuffer]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';

	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
	      reUnescapedHtml = /[&<>"'`]/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;

	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;

	  /**
	   * Used to match `RegExp` [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns)
	   * and those outlined by [`EscapeRegExpPattern`](http://ecma-international.org/ecma-262/6.0/#sec-escaperegexppattern).
	   */
	  var reRegExpChars = /^[:!,]|[\\^$.*+?()[\]{}|\/]|(^[0-9a-fA-Fnrtuvx])|([\n\r\u2028\u2029])/g,
	      reHasRegExpChars = RegExp(reRegExpChars.source);

	  /** Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks). */
	  var reComboMark = /[\u0300-\u036f\ufe20-\ufe23]/g;

	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;

	  /** Used to match [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components). */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;

	  /** Used to detect hexadecimal string values. */
	  var reHasHexPrefix = /^0[xX]/;

	  /** Used to detect host constructors (Safari > 5). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;

	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^\d+$/;

	  /** Used to match latin-1 supplementary letters (excluding mathematical operators). */
	  var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;

	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;

	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

	  /** Used to match words to create compound words. */
	  var reWords = (function() {
	    var upper = '[A-Z\\xc0-\\xd6\\xd8-\\xde]',
	        lower = '[a-z\\xdf-\\xf6\\xf8-\\xff]+';

	    return RegExp(upper + '+(?=' + upper + lower + ')|' + upper + '?' + lower + '|' + upper + '+|[0-9]+', 'g');
	  }());

	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'ArrayBuffer', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Math', 'Number',
	    'Object', 'RegExp', 'Set', 'String', '_', 'clearTimeout', 'isFinite',
	    'parseFloat', 'parseInt', 'setTimeout', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap'
	  ];

	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;

	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dateTag] = typedArrayTags[errorTag] =
	  typedArrayTags[funcTag] = typedArrayTags[mapTag] =
	  typedArrayTags[numberTag] = typedArrayTags[objectTag] =
	  typedArrayTags[regexpTag] = typedArrayTags[setTag] =
	  typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
	  cloneableTags[dateTag] = cloneableTags[float32Tag] =
	  cloneableTags[float64Tag] = cloneableTags[int8Tag] =
	  cloneableTags[int16Tag] = cloneableTags[int32Tag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[stringTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[mapTag] = cloneableTags[setTag] =
	  cloneableTags[weakMapTag] = false;

	  /** Used to map latin-1 supplementary letters to basic latin letters. */
	  var deburredLetters = {
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss'
	  };

	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;',
	    '`': '&#96;'
	  };

	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'",
	    '&#96;': '`'
	  };

	  /** Used to determine if values are of the language type `Object`. */
	  var objectTypes = {
	    'function': true,
	    'object': true
	  };

	  /** Used to escape characters for inclusion in compiled regexes. */
	  var regexpEscapes = {
	    '0': 'x30', '1': 'x31', '2': 'x32', '3': 'x33', '4': 'x34',
	    '5': 'x35', '6': 'x36', '7': 'x37', '8': 'x38', '9': 'x39',
	    'A': 'x41', 'B': 'x42', 'C': 'x43', 'D': 'x44', 'E': 'x45', 'F': 'x46',
	    'a': 'x61', 'b': 'x62', 'c': 'x63', 'd': 'x64', 'e': 'x65', 'f': 'x66',
	    'n': 'x6e', 'r': 'x72', 't': 'x74', 'u': 'x75', 'v': 'x76', 'x': 'x78'
	  };

	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };

	  /** Detect free variable `exports`. */
	  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;

	  /** Detect free variable `module`. */
	  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;

	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global && global.Object && global;

	  /** Detect free variable `self`. */
	  var freeSelf = objectTypes[typeof self] && self && self.Object && self;

	  /** Detect free variable `window`. */
	  var freeWindow = objectTypes[typeof window] && window && window.Object && window;

	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports && freeExports;

	  /**
	   * Used as a reference to the global object.
	   *
	   * The `this` value is used if it's the global object to avoid Greasemonkey's
	   * restricted `window` object, otherwise the `window` object is used.
	   */
	  var root = freeGlobal || ((freeWindow !== (this && this.window)) && freeWindow) || freeSelf || this;

	  /*--------------------------------------------------------------------------*/

	  /**
	   * The base implementation of `compareAscending` which compares values and
	   * sorts them in ascending order without guaranteeing a stable sort.
	   *
	   * @private
	   * @param {*} value The value to compare.
	   * @param {*} other The other value to compare.
	   * @returns {number} Returns the sort order indicator for `value`.
	   */
	  function baseCompareAscending(value, other) {
	    if (value !== other) {
	      var valIsNull = value === null,
	          valIsUndef = value === undefined,
	          valIsReflexive = value === value;

	      var othIsNull = other === null,
	          othIsUndef = other === undefined,
	          othIsReflexive = other === other;

	      if ((value > other && !othIsNull) || !valIsReflexive ||
	          (valIsNull && !othIsUndef && othIsReflexive) ||
	          (valIsUndef && othIsReflexive)) {
	        return 1;
	      }
	      if ((value < other && !valIsNull) || !othIsReflexive ||
	          (othIsNull && !valIsUndef && valIsReflexive) ||
	          (othIsUndef && valIsReflexive)) {
	        return -1;
	      }
	    }
	    return 0;
	  }

	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for callback shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromRight) {
	    var length = array.length,
	        index = fromRight ? length : -1;

	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }

	  /**
	   * The base implementation of `_.indexOf` without support for binary searches.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    if (value !== value) {
	      return indexOfNaN(array, fromIndex);
	    }
	    var index = fromIndex - 1,
	        length = array.length;

	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }

	  /**
	   * The base implementation of `_.isFunction` without support for environments
	   * with incorrect `typeof` results.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	   */
	  function baseIsFunction(value) {
	    // Avoid a Chakra JIT bug in compatibility modes of IE 11.
	    // See https://github.com/jashkenas/underscore/issues/1621 for more details.
	    return typeof value == 'function' || false;
	  }

	  /**
	   * Converts `value` to a string if it's not one. An empty string is returned
	   * for `null` or `undefined` values.
	   *
	   * @private
	   * @param {*} value The value to process.
	   * @returns {string} Returns the string.
	   */
	  function baseToString(value) {
	    return value == null ? '' : (value + '');
	  }

	  /**
	   * Used by `_.trim` and `_.trimLeft` to get the index of the first character
	   * of `string` that is not found in `chars`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @param {string} chars The characters to find.
	   * @returns {number} Returns the index of the first character not found in `chars`.
	   */
	  function charsLeftIndex(string, chars) {
	    var index = -1,
	        length = string.length;

	    while (++index < length && chars.indexOf(string.charAt(index)) > -1) {}
	    return index;
	  }

	  /**
	   * Used by `_.trim` and `_.trimRight` to get the index of the last character
	   * of `string` that is not found in `chars`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @param {string} chars The characters to find.
	   * @returns {number} Returns the index of the last character not found in `chars`.
	   */
	  function charsRightIndex(string, chars) {
	    var index = string.length;

	    while (index-- && chars.indexOf(string.charAt(index)) > -1) {}
	    return index;
	  }

	  /**
	   * Used by `_.sortBy` to compare transformed elements of a collection and stable
	   * sort them in ascending order.
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @returns {number} Returns the sort order indicator for `object`.
	   */
	  function compareAscending(object, other) {
	    return baseCompareAscending(object.criteria, other.criteria) || (object.index - other.index);
	  }

	  /**
	   * Used by `_.sortByOrder` to compare multiple properties of a value to another
	   * and stable sort them.
	   *
	   * If `orders` is unspecified, all valuess are sorted in ascending order. Otherwise,
	   * a value is sorted in ascending order if its corresponding order is "asc", and
	   * descending if "desc".
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @param {boolean[]} orders The order to sort by for each property.
	   * @returns {number} Returns the sort order indicator for `object`.
	   */
	  function compareMultiple(object, other, orders) {
	    var index = -1,
	        objCriteria = object.criteria,
	        othCriteria = other.criteria,
	        length = objCriteria.length,
	        ordersLength = orders.length;

	    while (++index < length) {
	      var result = baseCompareAscending(objCriteria[index], othCriteria[index]);
	      if (result) {
	        if (index >= ordersLength) {
	          return result;
	        }
	        var order = orders[index];
	        return result * ((order === 'asc' || order === true) ? 1 : -1);
	      }
	    }
	    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	    // that causes it, under certain circumstances, to provide the same value for
	    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	    // for more details.
	    //
	    // This also ensures a stable sort in V8 and other engines.
	    // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
	    return object.index - other.index;
	  }

	  /**
	   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  function deburrLetter(letter) {
	    return deburredLetters[letter];
	  }

	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeHtmlChar(chr) {
	    return htmlEscapes[chr];
	  }

	  /**
	   * Used by `_.escapeRegExp` to escape characters for inclusion in compiled regexes.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @param {string} leadingChar The capture group for a leading character.
	   * @param {string} whitespaceChar The capture group for a whitespace character.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeRegExpChar(chr, leadingChar, whitespaceChar) {
	    if (leadingChar) {
	      chr = regexpEscapes[chr];
	    } else if (whitespaceChar) {
	      chr = stringEscapes[chr];
	    }
	    return '\\' + chr;
	  }

	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }

	  /**
	   * Gets the index at which the first occurrence of `NaN` is found in `array`.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	   */
	  function indexOfNaN(array, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 0 : -1);

	    while ((fromRight ? index-- : ++index < length)) {
	      var other = array[index];
	      if (other !== other) {
	        return index;
	      }
	    }
	    return -1;
	  }

	  /**
	   * Checks if `value` is object-like.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	   */
	  function isObjectLike(value) {
	    return !!value && typeof value == 'object';
	  }

	  /**
	   * Used by `trimmedLeftIndex` and `trimmedRightIndex` to determine if a
	   * character code is whitespace.
	   *
	   * @private
	   * @param {number} charCode The character code to inspect.
	   * @returns {boolean} Returns `true` if `charCode` is whitespace, else `false`.
	   */
	  function isSpace(charCode) {
	    return ((charCode <= 160 && (charCode >= 9 && charCode <= 13) || charCode == 32 || charCode == 160) || charCode == 5760 || charCode == 6158 ||
	      (charCode >= 8192 && (charCode <= 8202 || charCode == 8232 || charCode == 8233 || charCode == 8239 || charCode == 8287 || charCode == 12288 || charCode == 65279)));
	  }

	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = -1,
	        result = [];

	    while (++index < length) {
	      if (array[index] === placeholder) {
	        array[index] = PLACEHOLDER;
	        result[++resIndex] = index;
	      }
	    }
	    return result;
	  }

	  /**
	   * An implementation of `_.uniq` optimized for sorted arrays without support
	   * for callback shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} [iteratee] The function invoked per iteration.
	   * @returns {Array} Returns the new duplicate-value-free array.
	   */
	  function sortedUniq(array, iteratee) {
	    var seen,
	        index = -1,
	        length = array.length,
	        resIndex = -1,
	        result = [];

	    while (++index < length) {
	      var value = array[index],
	          computed = iteratee ? iteratee(value, index, array) : value;

	      if (!index || seen !== computed) {
	        seen = computed;
	        result[++resIndex] = value;
	      }
	    }
	    return result;
	  }

	  /**
	   * Used by `_.trim` and `_.trimLeft` to get the index of the first non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the first non-whitespace character.
	   */
	  function trimmedLeftIndex(string) {
	    var index = -1,
	        length = string.length;

	    while (++index < length && isSpace(string.charCodeAt(index))) {}
	    return index;
	  }

	  /**
	   * Used by `_.trim` and `_.trimRight` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedRightIndex(string) {
	    var index = string.length;

	    while (index-- && isSpace(string.charCodeAt(index))) {}
	    return index;
	  }

	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  function unescapeHtmlChar(chr) {
	    return htmlUnescapes[chr];
	  }

	  /*--------------------------------------------------------------------------*/

	  /**
	   * Create a new pristine `lodash` function using the given `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @category Utility
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // using `context` to mock `Date#getTime` use in `_.now`
	   * var mock = _.runInContext({
	   *   'Date': function() {
	   *     return { 'getTime': getTimeMock };
	   *   }
	   * });
	   *
	   * // or creating a suped-up `defer` in Node.js
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  function runInContext(context) {
	    // Avoid issues with some ES3 environments that attempt to use values, named
	    // after built-in constructors like `Object`, for the creation of literals.
	    // ES5 clears this up by stating that literals must use built-in constructors.
	    // See https://es5.github.io/#x11.1.5 for more details.
	    context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;

	    /** Native constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Number = context.Number,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;

	    /** Used for native method references. */
	    var arrayProto = Array.prototype,
	        objectProto = Object.prototype,
	        stringProto = String.prototype;

	    /** Used to resolve the decompiled source of functions. */
	    var fnToString = Function.prototype.toString;

	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;

	    /** Used to generate unique IDs. */
	    var idCounter = 0;

	    /**
	     * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var objToString = objectProto.toString;

	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;

	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );

	    /** Native method references. */
	    var ArrayBuffer = context.ArrayBuffer,
	        clearTimeout = context.clearTimeout,
	        parseFloat = context.parseFloat,
	        pow = Math.pow,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        Set = getNative(context, 'Set'),
	        setTimeout = context.setTimeout,
	        splice = arrayProto.splice,
	        Uint8Array = context.Uint8Array,
	        WeakMap = getNative(context, 'WeakMap');

	    /* Native method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeCreate = getNative(Object, 'create'),
	        nativeFloor = Math.floor,
	        nativeIsArray = getNative(Array, 'isArray'),
	        nativeIsFinite = context.isFinite,
	        nativeKeys = getNative(Object, 'keys'),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = getNative(Date, 'now'),
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random;

	    /** Used as references for `-Infinity` and `Infinity`. */
	    var NEGATIVE_INFINITY = Number.NEGATIVE_INFINITY,
	        POSITIVE_INFINITY = Number.POSITIVE_INFINITY;

	    /** Used as references for the maximum length and index of an array. */
	    var MAX_ARRAY_LENGTH = 4294967295,
	        MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	        HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

	    /**
	     * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	     * of an array-like value.
	     */
	    var MAX_SAFE_INTEGER = 9007199254740991;

	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;

	    /** Used to lookup unminified function names. */
	    var realNames = {};

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit chaining.
	     * Methods that operate on and return arrays, collections, and functions can
	     * be chained together. Methods that retrieve a single value or may return a
	     * primitive value will automatically end the chain returning the unwrapped
	     * value. Explicit chaining may be enabled using `_.chain`. The execution of
	     * chained methods is lazy, that is, execution is deferred until `_#value`
	     * is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
	     * fusion is an optimization strategy which merge iteratee calls; this can help
	     * to avoid the creation of intermediate data structures and greatly reduce the
	     * number of iteratee executions.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`,
	     * `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `compact`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `filter`,
	     * `first`, `initial`, `last`, `map`, `pluck`, `reject`, `rest`, `reverse`,
	     * `slice`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `toArray`,
	     * and `where`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `at`, `before`, `bind`, `bindAll`, `bindKey`,
	     * `callback`, `chain`, `chunk`, `commit`, `compact`, `concat`, `constant`,
	     * `countBy`, `create`, `curry`, `debounce`, `defaults`, `defaultsDeep`,
	     * `defer`, `delay`, `difference`, `drop`, `dropRight`, `dropRightWhile`,
	     * `dropWhile`, `fill`, `filter`, `flatten`, `flattenDeep`, `flow`, `flowRight`,
	     * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
	     * `functions`, `groupBy`, `indexBy`, `initial`, `intersection`, `invert`,
	     * `invoke`, `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`,
	     * `matchesProperty`, `memoize`, `merge`, `method`, `methodOf`, `mixin`,
	     * `modArgs`, `negate`, `omit`, `once`, `pairs`, `partial`, `partialRight`,
	     * `partition`, `pick`, `plant`, `pluck`, `property`, `propertyOf`, `pull`,
	     * `pullAt`, `push`, `range`, `rearg`, `reject`, `remove`, `rest`, `restParam`,
	     * `reverse`, `set`, `shuffle`, `slice`, `sort`, `sortBy`, `sortByAll`,
	     * `sortByOrder`, `splice`, `spread`, `take`, `takeRight`, `takeRightWhile`,
	     * `takeWhile`, `tap`, `throttle`, `thru`, `times`, `toArray`, `toPlainObject`,
	     * `transform`, `union`, `uniq`, `unshift`, `unzip`, `unzipWith`, `values`,
	     * `valuesIn`, `where`, `without`, `wrap`, `xor`, `zip`, `zipObject`, `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clone`, `cloneDeep`,
	     * `deburr`, `endsWith`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`,
	     * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `findWhere`, `first`,
	     * `floor`, `get`, `gt`, `gte`, `has`, `identity`, `includes`, `indexOf`,
	     * `inRange`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`,
	     * `isEmpty`, `isEqual`, `isError`, `isFinite` `isFunction`, `isMatch`,
	     * `isNative`, `isNaN`, `isNull`, `isNumber`, `isObject`, `isPlainObject`,
	     * `isRegExp`, `isString`, `isUndefined`, `isTypedArray`, `join`, `kebabCase`,
	     * `last`, `lastIndexOf`, `lt`, `lte`, `max`, `min`, `noConflict`, `noop`,
	     * `now`, `pad`, `padLeft`, `padRight`, `parseInt`, `pop`, `random`, `reduce`,
	     * `reduceRight`, `repeat`, `result`, `round`, `runInContext`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedLastIndex`, `startCase`,
	     * `startsWith`, `sum`, `template`, `trim`, `trimLeft`, `trimRight`, `trunc`,
	     * `unescape`, `uniqueId`, `value`, and `words`
	     *
	     * The wrapper method `sample` will return a wrapped value when `n` is provided,
	     * otherwise an unwrapped value is returned.
	     *
	     * @name _
	     * @constructor
	     * @category Chain
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // returns an unwrapped value
	     * wrapped.reduce(function(total, n) {
	     *   return total + n;
	     * });
	     * // => 6
	     *
	     * // returns a wrapped value
	     * var squares = wrapped.map(function(n) {
	     *   return n * n;
	     * });
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__chain__') && hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }

	    /**
	     * The function whose prototype all chaining wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }

	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
	     * @param {Array} [actions=[]] Actions to peform to resolve the unwrapped value.
	     */
	    function LodashWrapper(value, chainAll, actions) {
	      this.__wrapped__ = value;
	      this.__actions__ = actions || [];
	      this.__chain__ = !!chainAll;
	    }

	    /**
	     * An object environment feature flags.
	     *
	     * @static
	     * @memberOf _
	     * @type Object
	     */
	    var support = lodash.support = {};

	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB). Change the following template settings to use
	     * alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type Object
	     */
	    lodash.templateSettings = {

	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'escape': reEscape,

	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'evaluate': reEvaluate,

	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'interpolate': reInterpolate,

	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type string
	       */
	      'variable': '',

	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type Object
	       */
	      'imports': {

	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type Function
	         */
	        '_': lodash
	      }
	    };

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = POSITIVE_INFINITY;
	      this.__views__ = [];
	    }

	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = arrayCopy(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = arrayCopy(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = arrayCopy(this.__views__);
	      return result;
	    }

	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }

	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);

	      if (!isArr || arrLength < LARGE_ARRAY_SIZE || (arrLength == length && takeCount == length)) {
	        return baseWrapperValue((isRight && isArr) ? array.reverse() : array, this.__actions__);
	      }
	      var result = [];

	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;

	        var iterIndex = -1,
	            value = array[index];

	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);

	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a cache object to store key/value pairs.
	     *
	     * @private
	     * @static
	     * @name Cache
	     * @memberOf _.memoize
	     */
	    function MapCache() {
	      this.__data__ = {};
	    }

	    /**
	     * Removes `key` and its value from the cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed successfully, else `false`.
	     */
	    function mapDelete(key) {
	      return this.has(key) && delete this.__data__[key];
	    }

	    /**
	     * Gets the cached value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the cached value.
	     */
	    function mapGet(key) {
	      return key == '__proto__' ? undefined : this.__data__[key];
	    }

	    /**
	     * Checks if a cached value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapHas(key) {
	      return key != '__proto__' && hasOwnProperty.call(this.__data__, key);
	    }

	    /**
	     * Sets `value` to `key` of the cache.
	     *
	     * @private
	     * @name set
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to cache.
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache object.
	     */
	    function mapSet(key, value) {
	      if (key != '__proto__') {
	        this.__data__[key] = value;
	      }
	      return this;
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     *
	     * Creates a cache object to store unique values.
	     *
	     * @private
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var length = values ? values.length : 0;

	      this.data = { 'hash': nativeCreate(null), 'set': new Set };
	      while (length--) {
	        this.push(values[length]);
	      }
	    }

	    /**
	     * Checks if `value` is in `cache` mimicking the return signature of
	     * `_.indexOf` by returning `0` if the value is found, else `-1`.
	     *
	     * @private
	     * @param {Object} cache The cache to search.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `0` if `value` is found, else `-1`.
	     */
	    function cacheIndexOf(cache, value) {
	      var data = cache.data,
	          result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];

	      return result ? 0 : -1;
	    }

	    /**
	     * Adds `value` to the cache.
	     *
	     * @private
	     * @name push
	     * @memberOf SetCache
	     * @param {*} value The value to cache.
	     */
	    function cachePush(value) {
	      var data = this.data;
	      if (typeof value == 'string' || isObject(value)) {
	        data.set.add(value);
	      } else {
	        data.hash[value] = true;
	      }
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a new array joining `array` with `other`.
	     *
	     * @private
	     * @param {Array} array The array to join.
	     * @param {Array} other The other array to join.
	     * @returns {Array} Returns the new concatenated array.
	     */
	    function arrayConcat(array, other) {
	      var index = -1,
	          length = array.length,
	          othIndex = -1,
	          othLength = other.length,
	          result = Array(length + othLength);

	      while (++index < length) {
	        result[index] = array[index];
	      }
	      while (++othIndex < othLength) {
	        result[index++] = other[othIndex];
	      }
	      return result;
	    }

	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayCopy(source, array) {
	      var index = -1,
	          length = source.length;

	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }

	    /**
	     * A specialized version of `_.forEach` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayEach(array, iteratee) {
	      var index = -1,
	          length = array.length;

	      while (++index < length) {
	        if (iteratee(array[index], index, array) === false) {
	          break;
	        }
	      }
	      return array;
	    }

	    /**
	     * A specialized version of `_.forEachRight` for arrays without support for
	     * callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayEachRight(array, iteratee) {
	      var length = array.length;

	      while (length--) {
	        if (iteratee(array[length], length, array) === false) {
	          break;
	        }
	      }
	      return array;
	    }

	    /**
	     * A specialized version of `_.every` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     */
	    function arrayEvery(array, predicate) {
	      var index = -1,
	          length = array.length;

	      while (++index < length) {
	        if (!predicate(array[index], index, array)) {
	          return false;
	        }
	      }
	      return true;
	    }

	    /**
	     * A specialized version of `baseExtremum` for arrays which invokes `iteratee`
	     * with one argument: (value).
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {*} Returns the extremum value.
	     */
	    function arrayExtremum(array, iteratee, comparator, exValue) {
	      var index = -1,
	          length = array.length,
	          computed = exValue,
	          result = computed;

	      while (++index < length) {
	        var value = array[index],
	            current = +iteratee(value);

	        if (comparator(current, computed)) {
	          computed = current;
	          result = value;
	        }
	      }
	      return result;
	    }

	    /**
	     * A specialized version of `_.filter` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function arrayFilter(array, predicate) {
	      var index = -1,
	          length = array.length,
	          resIndex = -1,
	          result = [];

	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }

	    /**
	     * A specialized version of `_.map` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function arrayMap(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          result = Array(length);

	      while (++index < length) {
	        result[index] = iteratee(array[index], index, array);
	      }
	      return result;
	    }

	    /**
	     * Appends the elements of `values` to `array`.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to append.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayPush(array, values) {
	      var index = -1,
	          length = values.length,
	          offset = array.length;

	      while (++index < length) {
	        array[offset + index] = values[index];
	      }
	      return array;
	    }

	    /**
	     * A specialized version of `_.reduce` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {boolean} [initFromArray] Specify using the first element of `array`
	     *  as the initial value.
	     * @returns {*} Returns the accumulated value.
	     */
	    function arrayReduce(array, iteratee, accumulator, initFromArray) {
	      var index = -1,
	          length = array.length;

	      if (initFromArray && length) {
	        accumulator = array[++index];
	      }
	      while (++index < length) {
	        accumulator = iteratee(accumulator, array[index], index, array);
	      }
	      return accumulator;
	    }

	    /**
	     * A specialized version of `_.reduceRight` for arrays without support for
	     * callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {boolean} [initFromArray] Specify using the last element of `array`
	     *  as the initial value.
	     * @returns {*} Returns the accumulated value.
	     */
	    function arrayReduceRight(array, iteratee, accumulator, initFromArray) {
	      var length = array.length;
	      if (initFromArray && length) {
	        accumulator = array[--length];
	      }
	      while (length--) {
	        accumulator = iteratee(accumulator, array[length], length, array);
	      }
	      return accumulator;
	    }

	    /**
	     * A specialized version of `_.some` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function arraySome(array, predicate) {
	      var index = -1,
	          length = array.length;

	      while (++index < length) {
	        if (predicate(array[index], index, array)) {
	          return true;
	        }
	      }
	      return false;
	    }

	    /**
	     * A specialized version of `_.sum` for arrays without support for callback
	     * shorthands and `this` binding..
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {number} Returns the sum.
	     */
	    function arraySum(array, iteratee) {
	      var length = array.length,
	          result = 0;

	      while (length--) {
	        result += +iteratee(array[length]) || 0;
	      }
	      return result;
	    }

	    /**
	     * Used by `_.defaults` to customize its `_.assign` use.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function assignDefaults(objectValue, sourceValue) {
	      return objectValue === undefined ? sourceValue : objectValue;
	    }

	    /**
	     * Used by `_.template` to customize its `_.assign` use.
	     *
	     * **Note:** This function is like `assignDefaults` except that it ignores
	     * inherited property values when checking if a property is `undefined`.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @param {string} key The key associated with the object and source values.
	     * @param {Object} object The destination object.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function assignOwnDefaults(objectValue, sourceValue, key, object) {
	      return (objectValue === undefined || !hasOwnProperty.call(object, key))
	        ? sourceValue
	        : objectValue;
	    }

	    /**
	     * A specialized version of `_.assign` for customizing assigned values without
	     * support for argument juggling, multiple sources, and `this` binding `customizer`
	     * functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     */
	    function assignWith(object, source, customizer) {
	      var index = -1,
	          props = keys(source),
	          length = props.length;

	      while (++index < length) {
	        var key = props[index],
	            value = object[key],
	            result = customizer(value, source[key], key, object, source);

	        if ((result === result ? (result !== value) : (value === value)) ||
	            (value === undefined && !(key in object))) {
	          object[key] = result;
	        }
	      }
	      return object;
	    }

	    /**
	     * The base implementation of `_.assign` without support for argument juggling,
	     * multiple sources, and `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return source == null
	        ? object
	        : baseCopy(source, keys(source), object);
	    }

	    /**
	     * The base implementation of `_.at` without support for string collections
	     * and individual key arguments.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {number[]|string[]} props The property names or indexes of elements to pick.
	     * @returns {Array} Returns the new array of picked elements.
	     */
	    function baseAt(collection, props) {
	      var index = -1,
	          isNil = collection == null,
	          isArr = !isNil && isArrayLike(collection),
	          length = isArr ? collection.length : 0,
	          propsLength = props.length,
	          result = Array(propsLength);

	      while(++index < propsLength) {
	        var key = props[index];
	        if (isArr) {
	          result[index] = isIndex(key, length) ? collection[key] : undefined;
	        } else {
	          result[index] = isNil ? undefined : collection[key];
	        }
	      }
	      return result;
	    }

	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property names to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @returns {Object} Returns `object`.
	     */
	    function baseCopy(source, props, object) {
	      object || (object = {});

	      var index = -1,
	          length = props.length;

	      while (++index < length) {
	        var key = props[index];
	        object[key] = source[key];
	      }
	      return object;
	    }

	    /**
	     * The base implementation of `_.callback` which supports specifying the
	     * number of arguments to provide to `func`.
	     *
	     * @private
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {number} [argCount] The number of arguments to provide to `func`.
	     * @returns {Function} Returns the callback.
	     */
	    function baseCallback(func, thisArg, argCount) {
	      var type = typeof func;
	      if (type == 'function') {
	        return thisArg === undefined
	          ? func
	          : bindCallback(func, thisArg, argCount);
	      }
	      if (func == null) {
	        return identity;
	      }
	      if (type == 'object') {
	        return baseMatches(func);
	      }
	      return thisArg === undefined
	        ? property(func)
	        : baseMatchesProperty(func, thisArg);
	    }

	    /**
	     * The base implementation of `_.clone` without support for argument juggling
	     * and `this` binding `customizer` functions.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The object `value` belongs to.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates clones with source counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
	      var result;
	      if (customizer) {
	        result = object ? customizer(value, key, object) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return arrayCopy(value, result);
	        }
	      } else {
	        var tag = objToString.call(value),
	            isFunc = tag == funcTag;

	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = initCloneObject(isFunc ? {} : value);
	          if (!isDeep) {
	            return baseAssign(result, value);
	          }
	        } else {
	          return cloneableTags[tag]
	            ? initCloneByTag(value, tag, isDeep)
	            : (object ? value : {});
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stackA || (stackA = []);
	      stackB || (stackB = []);

	      var length = stackA.length;
	      while (length--) {
	        if (stackA[length] == value) {
	          return stackB[length];
	        }
	      }
	      // Add the source value to the stack of traversed objects and associate it with its clone.
	      stackA.push(value);
	      stackB.push(result);

	      // Recursively populate clone (susceptible to call stack limits).
	      (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
	        result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
	      });
	      return result;
	    }

	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} prototype The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(prototype) {
	        if (isObject(prototype)) {
	          object.prototype = prototype;
	          var result = new object;
	          object.prototype = undefined;
	        }
	        return result || {};
	      };
	    }());

	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts an index
	     * of where to slice the arguments to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Object} args The arguments provide to `func`.
	     * @returns {number} Returns the timer id.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }

	    /**
	     * The base implementation of `_.difference` which accepts a single array
	     * of values to exclude.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values) {
	      var length = array ? array.length : 0,
	          result = [];

	      if (!length) {
	        return result;
	      }
	      var index = -1,
	          indexOf = getIndexOf(),
	          isCommon = indexOf == baseIndexOf,
	          cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
	          valuesLength = values.length;

	      if (cache) {
	        indexOf = cacheIndexOf;
	        isCommon = false;
	        values = cache;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index];

	        if (isCommon && value === value) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === value) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (indexOf(values, value, 0) < 0) {
	          result.push(value);
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.forEach` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object|string} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);

	    /**
	     * The base implementation of `_.forEachRight` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object|string} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);

	    /**
	     * The base implementation of `_.every` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }

	    /**
	     * Gets the extremum value of `collection` invoking `iteratee` for each value
	     * in `collection` to generate the criterion by which the value is ranked.
	     * The `iteratee` is invoked with three arguments: (value, index|key, collection).
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(collection, iteratee, comparator, exValue) {
	      var computed = exValue,
	          result = computed;

	      baseEach(collection, function(value, index, collection) {
	        var current = +iteratee(value, index, collection);
	        if (comparator(current, computed) || (current === exValue && current === result)) {
	          computed = current;
	          result = value;
	        }
	      });
	      return result;
	    }

	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;

	      start = start == null ? 0 : (+start || 0);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : (+end || 0);
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : (end >>> 0);
	      start >>>= 0;

	      while (start < length) {
	        array[start++] = value;
	      }
	      return array;
	    }

	    /**
	     * The base implementation of `_.filter` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }

	    /**
	     * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
	     * without support for callback shorthands and `this` binding, which iterates
	     * over `collection` using the provided `eachFunc`.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {Function} eachFunc The function to iterate over `collection`.
	     * @param {boolean} [retKey] Specify returning the key of the found element
	     *  instead of the element itself.
	     * @returns {*} Returns the found element or its key, else `undefined`.
	     */
	    function baseFind(collection, predicate, eachFunc, retKey) {
	      var result;
	      eachFunc(collection, function(value, key, collection) {
	        if (predicate(value, key, collection)) {
	          result = retKey ? key : value;
	          return false;
	        }
	      });
	      return result;
	    }

	    /**
	     * The base implementation of `_.flatten` with added support for restricting
	     * flattening and specifying the start index.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {boolean} [isDeep] Specify a deep flatten.
	     * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, isDeep, isStrict, result) {
	      result || (result = []);

	      var index = -1,
	          length = array.length;

	      while (++index < length) {
	        var value = array[index];
	        if (isObjectLike(value) && isArrayLike(value) &&
	            (isStrict || isArray(value) || isArguments(value))) {
	          if (isDeep) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, isDeep, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `baseForIn` and `baseForOwn` which iterates
	     * over `object` properties returned by `keysFunc` invoking `iteratee` for
	     * each property. Iteratee functions may exit iteration early by explicitly
	     * returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();

	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);

	    /**
	     * The base implementation of `_.forIn` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForIn(object, iteratee) {
	      return baseFor(object, iteratee, keysIn);
	    }

	    /**
	     * The base implementation of `_.forOwn` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return baseFor(object, iteratee, keys);
	    }

	    /**
	     * The base implementation of `_.forOwnRight` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return baseForRight(object, iteratee, keys);
	    }

	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from those provided.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the new array of filtered property names.
	     */
	    function baseFunctions(object, props) {
	      var index = -1,
	          length = props.length,
	          resIndex = -1,
	          result = [];

	      while (++index < length) {
	        var key = props[index];
	        if (isFunction(object[key])) {
	          result[++resIndex] = key;
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `get` without support for string paths
	     * and default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path of the property to get.
	     * @param {string} [pathKey] The key representation of path.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path, pathKey) {
	      if (object == null) {
	        return;
	      }
	      if (pathKey !== undefined && pathKey in toObject(object)) {
	        path = [pathKey];
	      }
	      var index = 0,
	          length = path.length;

	      while (object != null && index < length) {
	        object = object[path[index++]];
	      }
	      return (index && index == length) ? object : undefined;
	    }

	    /**
	     * The base implementation of `_.isEqual` without support for `this` binding
	     * `customizer` functions.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparing values.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
	    }

	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing objects.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA=[]] Tracks traversed `value` objects.
	     * @param {Array} [stackB=[]] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = arrayTag,
	          othTag = arrayTag;

	      if (!objIsArr) {
	        objTag = objToString.call(object);
	        if (objTag == argsTag) {
	          objTag = objectTag;
	        } else if (objTag != objectTag) {
	          objIsArr = isTypedArray(object);
	        }
	      }
	      if (!othIsArr) {
	        othTag = objToString.call(other);
	        if (othTag == argsTag) {
	          othTag = objectTag;
	        } else if (othTag != objectTag) {
	          othIsArr = isTypedArray(other);
	        }
	      }
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;

	      if (isSameTag && !(objIsArr || objIsObj)) {
	        return equalByTag(object, other, objTag);
	      }
	      if (!isLoose) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

	        if (objIsWrapped || othIsWrapped) {
	          return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      // For more information on detecting circular references see https://es5.github.io/#JO.
	      stackA || (stackA = []);
	      stackB || (stackB = []);

	      var length = stackA.length;
	      while (length--) {
	        if (stackA[length] == object) {
	          return stackB[length] == other;
	        }
	      }
	      // Add `object` and `other` to the stack of traversed objects.
	      stackA.push(object);
	      stackB.push(other);

	      var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);

	      stackA.pop();
	      stackB.pop();

	      return result;
	    }

	    /**
	     * The base implementation of `_.isMatch` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} matchData The propery names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparing objects.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;

	      if (object == null) {
	        return !length;
	      }
	      object = toObject(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];

	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var result = customizer ? customizer(objValue, srcValue, key) : undefined;
	          if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }

	    /**
	     * The base implementation of `_.map` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];

	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }

	    /**
	     * The base implementation of `_.matches` which does not clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        var key = matchData[0][0],
	            value = matchData[0][1];

	        return function(object) {
	          if (object == null) {
	            return false;
	          }
	          return object[key] === value && (value !== undefined || (key in toObject(object)));
	        };
	      }
	      return function(object) {
	        return baseIsMatch(object, matchData);
	      };
	    }

	    /**
	     * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to compare.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      var isArr = isArray(path),
	          isCommon = isKey(path) && isStrictComparable(srcValue),
	          pathKey = (path + '');

	      path = toPath(path);
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        var key = pathKey;
	        object = toObject(object);
	        if ((isArr || !isCommon) && !(key in object)) {
	          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	          if (object == null) {
	            return false;
	          }
	          key = last(path);
	          object = toObject(object);
	        }
	        return object[key] === srcValue
	          ? (srcValue !== undefined || (key in object))
	          : baseIsEqual(srcValue, object[key], undefined, true);
	      };
	    }

	    /**
	     * The base implementation of `_.merge` without support for argument juggling,
	     * multiple sources, and `this` binding `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates values with source counterparts.
	     * @returns {Object} Returns `object`.
	     */
	    function baseMerge(object, source, customizer, stackA, stackB) {
	      if (!isObject(object)) {
	        return object;
	      }
	      var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source)),
	          props = isSrcArr ? undefined : keys(source);

	      arrayEach(props || source, function(srcValue, key) {
	        if (props) {
	          key = srcValue;
	          srcValue = source[key];
	        }
	        if (isObjectLike(srcValue)) {
	          stackA || (stackA = []);
	          stackB || (stackB = []);
	          baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
	        }
	        else {
	          var value = object[key],
	              result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	              isCommon = result === undefined;

	          if (isCommon) {
	            result = srcValue;
	          }
	          if ((result !== undefined || (isSrcArr && !(key in object))) &&
	              (isCommon || (result === result ? (result !== value) : (value === value)))) {
	            object[key] = result;
	          }
	        }
	      });
	      return object;
	    }

	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates values with source counterparts.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
	      var length = stackA.length,
	          srcValue = source[key];

	      while (length--) {
	        if (stackA[length] == srcValue) {
	          object[key] = stackB[length];
	          return;
	        }
	      }
	      var value = object[key],
	          result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	          isCommon = result === undefined;

	      if (isCommon) {
	        result = srcValue;
	        if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) {
	          result = isArray(value)
	            ? value
	            : (isArrayLike(value) ? arrayCopy(value) : []);
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          result = isArguments(value)
	            ? toPlainObject(value)
	            : (isPlainObject(value) ? value : {});
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      // Add the source value to the stack of traversed objects and associate
	      // it with its merged value.
	      stackA.push(srcValue);
	      stackB.push(result);

	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
	      } else if (result === result ? (result !== value) : (value === value)) {
	        object[key] = result;
	      }
	    }

	    /**
	     * The base implementation of `_.property` without support for deep paths.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function baseProperty(key) {
	      return function(object) {
	        return object == null ? undefined : object[key];
	      };
	    }

	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function basePropertyDeep(path) {
	      var pathKey = (path + '');
	      path = toPath(path);
	      return function(object) {
	        return baseGet(object, path, pathKey);
	      };
	    }

	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * index arguments and capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0;
	      while (length--) {
	        var index = indexes[length];
	        if (index != previous && isIndex(index)) {
	          var previous = index;
	          splice.call(array, index, 1);
	        }
	      }
	      return array;
	    }

	    /**
	     * The base implementation of `_.random` without support for argument juggling
	     * and returning floating-point numbers.
	     *
	     * @private
	     * @param {number} min The minimum possible value.
	     * @param {number} max The maximum possible value.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(min, max) {
	      return min + nativeFloor(nativeRandom() * (max - min + 1));
	    }

	    /**
	     * The base implementation of `_.reduce` and `_.reduceRight` without support
	     * for callback shorthands and `this` binding, which iterates over `collection`
	     * using the provided `eachFunc`.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} accumulator The initial value.
	     * @param {boolean} initFromCollection Specify using the first or last element
	     *  of `collection` as the initial value.
	     * @param {Function} eachFunc The function to iterate over `collection`.
	     * @returns {*} Returns the accumulated value.
	     */
	    function baseReduce(collection, iteratee, accumulator, initFromCollection, eachFunc) {
	      eachFunc(collection, function(value, index, collection) {
	        accumulator = initFromCollection
	          ? (initFromCollection = false, value)
	          : iteratee(accumulator, value, index, collection);
	      });
	      return accumulator;
	    }

	    /**
	     * The base implementation of `setData` without support for hot loop detection.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };

	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;

	      start = start == null ? 0 : (+start || 0);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : (+end || 0);
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;

	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.some` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;

	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }

	    /**
	     * The base implementation of `_.sortBy` which uses `comparer` to define
	     * the sort order of `array` and replaces criteria objects with their
	     * corresponding values.
	     *
	     * @private
	     * @param {Array} array The array to sort.
	     * @param {Function} comparer The function to define sort order.
	     * @returns {Array} Returns `array`.
	     */
	    function baseSortBy(array, comparer) {
	      var length = array.length;

	      array.sort(comparer);
	      while (length--) {
	        array[length] = array[length].value;
	      }
	      return array;
	    }

	    /**
	     * The base implementation of `_.sortByOrder` without param guards.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {boolean[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseSortByOrder(collection, iteratees, orders) {
	      var callback = getCallback(),
	          index = -1;

	      iteratees = arrayMap(iteratees, function(iteratee) { return callback(iteratee); });

	      var result = baseMap(collection, function(value) {
	        var criteria = arrayMap(iteratees, function(iteratee) { return iteratee(value); });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });

	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }

	    /**
	     * The base implementation of `_.sum` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {number} Returns the sum.
	     */
	    function baseSum(collection, iteratee) {
	      var result = 0;
	      baseEach(collection, function(value, index, collection) {
	        result += +iteratee(value, index, collection) || 0;
	      });
	      return result;
	    }

	    /**
	     * The base implementation of `_.uniq` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The function invoked per iteration.
	     * @returns {Array} Returns the new duplicate-value-free array.
	     */
	    function baseUniq(array, iteratee) {
	      var index = -1,
	          indexOf = getIndexOf(),
	          length = array.length,
	          isCommon = indexOf == baseIndexOf,
	          isLarge = isCommon && length >= LARGE_ARRAY_SIZE,
	          seen = isLarge ? createCache() : null,
	          result = [];

	      if (seen) {
	        indexOf = cacheIndexOf;
	        isCommon = false;
	      } else {
	        isLarge = false;
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value, index, array) : value;

	        if (isCommon && value === value) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (indexOf(seen, computed, 0) < 0) {
	          if (iteratee || isLarge) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.values` and `_.valuesIn` which creates an
	     * array of `object` property values corresponding to the property names
	     * of `props`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} props The property names to get values for.
	     * @returns {Object} Returns the array of property values.
	     */
	    function baseValues(object, props) {
	      var index = -1,
	          length = props.length,
	          result = Array(length);

	      while (++index < length) {
	        result[index] = object[props[index]];
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.dropRightWhile`, `_.dropWhile`, `_.takeRightWhile`,
	     * and `_.takeWhile` without support for callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;

	      while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }

	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to peform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      var index = -1,
	          length = actions.length;

	      while (++index < length) {
	        var action = actions[index];
	        result = action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }
	      return result;
	    }

	    /**
	     * Performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function binaryIndex(array, value, retHighest) {
	      var low = 0,
	          high = array ? array.length : low;

	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];

	          if ((retHighest ? (computed <= value) : (computed < value)) && computed !== null) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return binaryIndexBy(array, value, identity, retHighest);
	    }

	    /**
	     * This function is like `binaryIndex` except that it invokes `iteratee` for
	     * `value` and each element of `array` to compute their sort ranking. The
	     * iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function binaryIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);

	      var low = 0,
	          high = array ? array.length : 0,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsUndef = value === undefined;

	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            isDef = computed !== undefined,
	            isReflexive = computed === computed;

	        if (valIsNaN) {
	          var setLow = isReflexive || retHighest;
	        } else if (valIsNull) {
	          setLow = isReflexive && isDef && (retHighest || computed != null);
	        } else if (valIsUndef) {
	          setLow = isReflexive && (retHighest || isDef);
	        } else if (computed == null) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }

	    /**
	     * A specialized version of `baseCallback` which only supports `this` binding
	     * and specifying the number of arguments to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {number} [argCount] The number of arguments to provide to `func`.
	     * @returns {Function} Returns the callback.
	     */
	    function bindCallback(func, thisArg, argCount) {
	      if (typeof func != 'function') {
	        return identity;
	      }
	      if (thisArg === undefined) {
	        return func;
	      }
	      switch (argCount) {
	        case 1: return function(value) {
	          return func.call(thisArg, value);
	        };
	        case 3: return function(value, index, collection) {
	          return func.call(thisArg, value, index, collection);
	        };
	        case 4: return function(accumulator, value, index, collection) {
	          return func.call(thisArg, accumulator, value, index, collection);
	        };
	        case 5: return function(value, other, key, object, source) {
	          return func.call(thisArg, value, other, key, object, source);
	        };
	      }
	      return function() {
	        return func.apply(thisArg, arguments);
	      };
	    }

	    /**
	     * Creates a clone of the given array buffer.
	     *
	     * @private
	     * @param {ArrayBuffer} buffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function bufferClone(buffer) {
	      var result = new ArrayBuffer(buffer.byteLength),
	          view = new Uint8Array(result);

	      view.set(new Uint8Array(buffer));
	      return result;
	    }

	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders) {
	      var holdersLength = holders.length,
	          argsIndex = -1,
	          argsLength = nativeMax(args.length - holdersLength, 0),
	          leftIndex = -1,
	          leftLength = partials.length,
	          result = Array(leftLength + argsLength);

	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        result[holders[argsIndex]] = args[argsIndex];
	      }
	      while (argsLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }

	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders) {
	      var holdersIndex = -1,
	          holdersLength = holders.length,
	          argsIndex = -1,
	          argsLength = nativeMax(args.length - holdersLength, 0),
	          rightIndex = -1,
	          rightLength = partials.length,
	          result = Array(argsLength + rightLength);

	      while (++argsIndex < argsLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        result[offset + holders[holdersIndex]] = args[argsIndex++];
	      }
	      return result;
	    }

	    /**
	     * Creates a `_.countBy`, `_.groupBy`, `_.indexBy`, or `_.partition` function.
	     *
	     * @private
	     * @param {Function} setter The function to set keys and values of the accumulator object.
	     * @param {Function} [initializer] The function to initialize the accumulator object.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee, thisArg) {
	        var result = initializer ? initializer() : {};
	        iteratee = getCallback(iteratee, thisArg, 3);

	        if (isArray(collection)) {
	          var index = -1,
	              length = collection.length;

	          while (++index < length) {
	            var value = collection[index];
	            setter(result, value, iteratee(value, index, collection), collection);
	          }
	        } else {
	          baseEach(collection, function(value, key, collection) {
	            setter(result, value, iteratee(value, key, collection), collection);
	          });
	        }
	        return result;
	      };
	    }

	    /**
	     * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return restParam(function(object, sources) {
	        var index = -1,
	            length = object == null ? 0 : sources.length,
	            customizer = length > 2 ? sources[length - 2] : undefined,
	            guard = length > 2 ? sources[2] : undefined,
	            thisArg = length > 1 ? sources[length - 1] : undefined;

	        if (typeof customizer == 'function') {
	          customizer = bindCallback(customizer, thisArg, 5);
	          length -= 2;
	        } else {
	          customizer = typeof thisArg == 'function' ? thisArg : undefined;
	          length -= (customizer ? 1 : 0);
	        }
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, customizer);
	          }
	        }
	        return object;
	      });
	    }

	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        var length = collection ? getLength(collection) : 0;
	        if (!isLength(length)) {
	          return eachFunc(collection, iteratee);
	        }
	        var index = fromRight ? length : -1,
	            iterable = toObject(collection);

	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }

	    /**
	     * Creates a base function for `_.forIn` or `_.forInRight`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var iterable = toObject(object),
	            props = keysFunc(object),
	            length = props.length,
	            index = fromRight ? length : -1;

	        while ((fromRight ? index-- : ++index < length)) {
	          var key = props[index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }

	    /**
	     * Creates a function that wraps `func` and invokes it with the `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to bind.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new bound function.
	     */
	    function createBindWrapper(func, thisArg) {
	      var Ctor = createCtorWrapper(func);

	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(thisArg, arguments);
	      }
	      return wrapper;
	    }

	    /**
	     * Creates a `Set` cache object to optimize linear searches of large arrays.
	     *
	     * @private
	     * @param {Array} [values] The values to cache.
	     * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
	     */
	    function createCache(values) {
	      return (nativeCreate && Set) ? new SetCache(values) : null;
	    }

	    /**
	     * Creates a function that produces compound words out of the words in a
	     * given string.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        var index = -1,
	            array = words(deburr(string)),
	            length = array.length,
	            result = '';

	        while (++index < length) {
	          result = callback(result, array[index], index);
	        }
	        return result;
	      };
	    }

	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtorWrapper(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors.
	        // See http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);

	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }

	    /**
	     * Creates a `_.curry` or `_.curryRight` function.
	     *
	     * @private
	     * @param {boolean} flag The curry bit flag.
	     * @returns {Function} Returns the new curry function.
	     */
	    function createCurry(flag) {
	      function curryFunc(func, arity, guard) {
	        if (guard && isIterateeCall(func, arity, guard)) {
	          arity = undefined;
	        }
	        var result = createWrapper(func, flag, undefined, undefined, undefined, undefined, undefined, arity);
	        result.placeholder = curryFunc.placeholder;
	        return result;
	      }
	      return curryFunc;
	    }

	    /**
	     * Creates a `_.defaults` or `_.defaultsDeep` function.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Function} Returns the new defaults function.
	     */
	    function createDefaults(assigner, customizer) {
	      return restParam(function(args) {
	        var object = args[0];
	        if (object == null) {
	          return object;
	        }
	        args.push(customizer);
	        return assigner.apply(undefined, args);
	      });
	    }

	    /**
	     * Creates a `_.max` or `_.min` function.
	     *
	     * @private
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {Function} Returns the new extremum function.
	     */
	    function createExtremum(comparator, exValue) {
	      return function(collection, iteratee, thisArg) {
	        if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	          iteratee = undefined;
	        }
	        iteratee = getCallback(iteratee, thisArg, 3);
	        if (iteratee.length == 1) {
	          collection = isArray(collection) ? collection : toIterable(collection);
	          var result = arrayExtremum(collection, iteratee, comparator, exValue);
	          if (!(collection.length && result === exValue)) {
	            return result;
	          }
	        }
	        return baseExtremum(collection, iteratee, comparator, exValue);
	      };
	    }

	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(eachFunc, fromRight) {
	      return function(collection, predicate, thisArg) {
	        predicate = getCallback(predicate, thisArg, 3);
	        if (isArray(collection)) {
	          var index = baseFindIndex(collection, predicate, fromRight);
	          return index > -1 ? collection[index] : undefined;
	        }
	        return baseFind(collection, predicate, eachFunc);
	      };
	    }

	    /**
	     * Creates a `_.findIndex` or `_.findLastIndex` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFindIndex(fromRight) {
	      return function(array, predicate, thisArg) {
	        if (!(array && array.length)) {
	          return -1;
	        }
	        predicate = getCallback(predicate, thisArg, 3);
	        return baseFindIndex(array, predicate, fromRight);
	      };
	    }

	    /**
	     * Creates a `_.findKey` or `_.findLastKey` function.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFindKey(objectFunc) {
	      return function(object, predicate, thisArg) {
	        predicate = getCallback(predicate, thisArg, 3);
	        return baseFind(object, predicate, objectFunc, true);
	      };
	    }

	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return function() {
	        var wrapper,
	            length = arguments.length,
	            index = fromRight ? length : -1,
	            leftIndex = 0,
	            funcs = Array(length);

	        while ((fromRight ? index-- : ++index < length)) {
	          var func = funcs[leftIndex++] = arguments[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (!wrapper && LodashWrapper.prototype.thru && getFuncName(func) == 'wrapper') {
	            wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? -1 : length;
	        while (++index < length) {
	          func = funcs[index];

	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;

	          if (data && isLaziable(data[0]) && data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) && !data[4].length && data[9] == 1) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func)) ? wrapper[funcName]() : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];

	          if (wrapper && args.length == 1 && isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;

	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      };
	    }

	    /**
	     * Creates a function for `_.forEach` or `_.forEachRight`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over an array.
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForEach(arrayFunc, eachFunc) {
	      return function(collection, iteratee, thisArg) {
	        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	          ? arrayFunc(collection, iteratee)
	          : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
	      };
	    }

	    /**
	     * Creates a function for `_.forIn` or `_.forInRight`.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForIn(objectFunc) {
	      return function(object, iteratee, thisArg) {
	        if (typeof iteratee != 'function' || thisArg !== undefined) {
	          iteratee = bindCallback(iteratee, thisArg, 3);
	        }
	        return objectFunc(object, iteratee, keysIn);
	      };
	    }

	    /**
	     * Creates a function for `_.forOwn` or `_.forOwnRight`.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForOwn(objectFunc) {
	      return function(object, iteratee, thisArg) {
	        if (typeof iteratee != 'function' || thisArg !== undefined) {
	          iteratee = bindCallback(iteratee, thisArg, 3);
	        }
	        return objectFunc(object, iteratee);
	      };
	    }

	    /**
	     * Creates a function for `_.mapKeys` or `_.mapValues`.
	     *
	     * @private
	     * @param {boolean} [isMapKeys] Specify mapping keys instead of values.
	     * @returns {Function} Returns the new map function.
	     */
	    function createObjectMapper(isMapKeys) {
	      return function(object, iteratee, thisArg) {
	        var result = {};
	        iteratee = getCallback(iteratee, thisArg, 3);

	        baseForOwn(object, function(value, key, object) {
	          var mapped = iteratee(value, key, object);
	          key = isMapKeys ? mapped : key;
	          value = isMapKeys ? value : mapped;
	          result[key] = value;
	        });
	        return result;
	      };
	    }

	    /**
	     * Creates a function for `_.padLeft` or `_.padRight`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify padding from the right.
	     * @returns {Function} Returns the new pad function.
	     */
	    function createPadDir(fromRight) {
	      return function(string, length, chars) {
	        string = baseToString(string);
	        return (fromRight ? string : '') + createPadding(string, length, chars) + (fromRight ? '' : string);
	      };
	    }

	    /**
	     * Creates a `_.partial` or `_.partialRight` function.
	     *
	     * @private
	     * @param {boolean} flag The partial bit flag.
	     * @returns {Function} Returns the new partial function.
	     */
	    function createPartial(flag) {
	      var partialFunc = restParam(function(func, partials) {
	        var holders = replaceHolders(partials, partialFunc.placeholder);
	        return createWrapper(func, flag, undefined, partials, holders);
	      });
	      return partialFunc;
	    }

	    /**
	     * Creates a function for `_.reduce` or `_.reduceRight`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over an array.
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @returns {Function} Returns the new each function.
	     */
	    function createReduce(arrayFunc, eachFunc) {
	      return function(collection, iteratee, accumulator, thisArg) {
	        var initFromArray = arguments.length < 3;
	        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	          ? arrayFunc(collection, iteratee, accumulator, initFromArray)
	          : baseReduce(collection, getCallback(iteratee, thisArg, 4), accumulator, initFromArray, eachFunc);
	      };
	    }

	    /**
	     * Creates a function that wraps `func` and invokes it with optional `this`
	     * binding of, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to reference.
	     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & ARY_FLAG,
	          isBind = bitmask & BIND_FLAG,
	          isBindKey = bitmask & BIND_KEY_FLAG,
	          isCurry = bitmask & CURRY_FLAG,
	          isCurryBound = bitmask & CURRY_BOUND_FLAG,
	          isCurryRight = bitmask & CURRY_RIGHT_FLAG,
	          Ctor = isBindKey ? undefined : createCtorWrapper(func);

	      function wrapper() {
	        // Avoid `arguments` object use disqualifying optimizations by
	        // converting it to an array before providing it to other functions.
	        var length = arguments.length,
	            index = length,
	            args = Array(length);

	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight);
	        }
	        if (isCurry || isCurryRight) {
	          var placeholder = wrapper.placeholder,
	              argsHolders = replaceHolders(args, placeholder);

	          length -= argsHolders.length;
	          if (length < arity) {
	            var newArgPos = argPos ? arrayCopy(argPos) : undefined,
	                newArity = nativeMax(arity - length, 0),
	                newsHolders = isCurry ? argsHolders : undefined,
	                newHoldersRight = isCurry ? undefined : argsHolders,
	                newPartials = isCurry ? args : undefined,
	                newPartialsRight = isCurry ? undefined : args;

	            bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	            bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);

	            if (!isCurryBound) {
	              bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	            }
	            var newData = [func, bitmask, thisArg, newPartials, newsHolders, newPartialsRight, newHoldersRight, newArgPos, ary, newArity],
	                result = createHybridWrapper.apply(undefined, newData);

	            if (isLaziable(func)) {
	              setData(result, newData);
	            }
	            result.placeholder = placeholder;
	            return result;
	          }
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;

	        if (argPos) {
	          args = reorder(args, argPos);
	        }
	        if (isAry && ary < args.length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtorWrapper(func);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }

	    /**
	     * Creates the padding required for `string` based on the given `length`.
	     * The `chars` string is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {string} string The string to create padding for.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the pad for `string`.
	     */
	    function createPadding(string, length, chars) {
	      var strLength = string.length;
	      length = +length;

	      if (strLength >= length || !nativeIsFinite(length)) {
	        return '';
	      }
	      var padLength = length - strLength;
	      chars = chars == null ? ' ' : (chars + '');
	      return repeat(chars, nativeCeil(padLength / chars.length)).slice(0, padLength);
	    }

	    /**
	     * Creates a function that wraps `func` and invokes it with the optional `this`
	     * binding of `thisArg` and the `partials` prepended to those provided to
	     * the wrapper.
	     *
	     * @private
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to the new function.
	     * @returns {Function} Returns the new bound function.
	     */
	    function createPartialWrapper(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & BIND_FLAG,
	          Ctor = createCtorWrapper(func);

	      function wrapper() {
	        // Avoid `arguments` object use disqualifying optimizations by
	        // converting it to an array before providing it `func`.
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength);

	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }

	    /**
	     * Creates a `_.ceil`, `_.floor`, or `_.round` function.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        precision = precision === undefined ? 0 : (+precision || 0);
	        if (precision) {
	          precision = pow(10, precision);
	          return func(number * precision) / precision;
	        }
	        return func(number);
	      };
	    }

	    /**
	     * Creates a `_.sortedIndex` or `_.sortedLastIndex` function.
	     *
	     * @private
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {Function} Returns the new index function.
	     */
	    function createSortedIndex(retHighest) {
	      return function(array, value, iteratee, thisArg) {
	        var callback = getCallback(iteratee);
	        return (iteratee == null && callback === baseCallback)
	          ? binaryIndex(array, value, retHighest)
	          : binaryIndexBy(array, value, callback(iteratee, thisArg, 1), retHighest);
	      };
	    }

	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to reference.
	     * @param {number} bitmask The bitmask of flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - `_.bind`
	     *     2 - `_.bindKey`
	     *     4 - `_.curry` or `_.curryRight` of a bound function
	     *     8 - `_.curry`
	     *    16 - `_.curryRight`
	     *    32 - `_.partial`
	     *    64 - `_.partialRight`
	     *   128 - `_.rearg`
	     *   256 - `_.ary`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      length -= (holders ? holders.length : 0);
	      if (bitmask & PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;

	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func),
	          newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];

	      if (data) {
	        mergeData(newData, data);
	        bitmask = newData[1];
	        arity = newData[9];
	      }
	      newData[9] = arity == null
	        ? (isBindKey ? 0 : func.length)
	        : (nativeMax(arity - length, 0) || 0);

	      if (bitmask == BIND_FLAG) {
	        var result = createBindWrapper(newData[0], newData[2]);
	      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !newData[4].length) {
	        result = createPartialWrapper.apply(undefined, newData);
	      } else {
	        result = createHybridWrapper.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setter(result, newData);
	    }

	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing arrays.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var index = -1,
	          arrLength = array.length,
	          othLength = other.length;

	      if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
	        return false;
	      }
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index],
	            result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;

	        if (result !== undefined) {
	          if (result) {
	            continue;
	          }
	          return false;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (isLoose) {
	          if (!arraySome(other, function(othValue) {
	                return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
	              })) {
	            return false;
	          }
	        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
	          return false;
	        }
	      }
	      return true;
	    }

	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag) {
	      switch (tag) {
	        case boolTag:
	        case dateTag:
	          // Coerce dates and booleans to numbers, dates to milliseconds and booleans
	          // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
	          return +object == +other;

	        case errorTag:
	          return object.name == other.name && object.message == other.message;

	        case numberTag:
	          // Treat `NaN` vs. `NaN` as equal.
	          return (object != +object)
	            ? other != +other
	            : object == +other;

	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings primitives and string
	          // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
	          return object == (other + '');
	      }
	      return false;
	    }

	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing values.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var objProps = keys(object),
	          objLength = objProps.length,
	          othProps = keys(other),
	          othLength = othProps.length;

	      if (objLength != othLength && !isLoose) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      var skipCtor = isLoose;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key],
	            result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;

	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
	          return false;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (!skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;

	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          return false;
	        }
	      }
	      return true;
	    }

	    /**
	     * Gets the appropriate "callback" function. If the `_.callback` method is
	     * customized this function returns the custom method, otherwise it returns
	     * the `baseCallback` function. If arguments are provided the chosen function
	     * is invoked with them and its result is returned.
	     *
	     * @private
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getCallback(func, thisArg, argCount) {
	      var result = lodash.callback || callback;
	      result = result === callback ? baseCallback : result;
	      return argCount ? result(func, thisArg, argCount) : result;
	    }

	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };

	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = func.name,
	          array = realNames[result],
	          length = array ? array.length : 0;

	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }

	    /**
	     * Gets the appropriate "indexOf" function. If the `_.indexOf` method is
	     * customized this function returns the custom method, otherwise it returns
	     * the `baseIndexOf` function. If arguments are provided the chosen function
	     * is invoked with them and its result is returned.
	     *
	     * @private
	     * @returns {Function|number} Returns the chosen function or its result.
	     */
	    function getIndexOf(collection, target, fromIndex) {
	      var result = lodash.indexOf || indexOf;
	      result = result === indexOf ? baseIndexOf : result;
	      return collection ? result(collection, target, fromIndex) : result;
	    }

	    /**
	     * Gets the "length" property value of `object`.
	     *
	     * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	     * that affects Safari on at least iOS 8.1-8.3 ARM64.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {*} Returns the "length" value.
	     */
	    var getLength = baseProperty('length');

	    /**
	     * Gets the propery names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = pairs(object),
	          length = result.length;

	      while (length--) {
	        result[length][2] = isStrictComparable(result[length][1]);
	      }
	      return result;
	    }

	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = object == null ? undefined : object[key];
	      return isNative(value) ? value : undefined;
	    }

	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;

	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;

	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }

	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);

	      // Add array properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }

	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      var Ctor = object.constructor;
	      if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
	        Ctor = Object;
	      }
	      return new Ctor;
	    }

	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return bufferClone(object);

	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);

	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          var buffer = object.buffer;
	          return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);

	        case numberTag:
	        case stringTag:
	          return new Ctor(object);

	        case regexpTag:
	          var result = new Ctor(object.source, reFlags.exec(object));
	          result.lastIndex = object.lastIndex;
	      }
	      return result;
	    }

	    /**
	     * Invokes the method at `path` on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function invokePath(object, path, args) {
	      if (object != null && !isKey(path, object)) {
	        path = toPath(path);
	        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	        path = last(path);
	      }
	      var func = object == null ? object : object[path];
	      return func == null ? undefined : func.apply(object, args);
	    }

	    /**
	     * Checks if `value` is array-like.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(getLength(value));
	    }

	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return value > -1 && value % 1 == 0 && value < length;
	    }

	    /**
	     * Checks if the provided arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	          ? (isArrayLike(object) && isIndex(index, object.length))
	          : (type == 'string' && index in object)) {
	        var other = object[index];
	        return value === value ? (value === other) : (other !== other);
	      }
	      return false;
	    }

	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      var type = typeof value;
	      if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
	        return true;
	      }
	      if (isArray(value)) {
	        return false;
	      }
	      var result = !reIsDeepProp.test(value);
	      return result || (object != null && value in toObject(object));
	    }

	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func);
	      if (!(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      var other = lodash[funcName];
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }

	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     */
	    function isLength(value) {
	      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }

	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }

	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers required to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
	     * augment function arguments, making the order in which they are executed important,
	     * preventing the merging of metadata. However, we make an exception for a safe
	     * common case where curried functions have `_.ary` and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < ARY_FLAG;

	      var isCombo =
	        (srcBitmask == ARY_FLAG && bitmask == CURRY_FLAG) ||
	        (srcBitmask == ARY_FLAG && bitmask == REARG_FLAG && data[7].length <= source[8]) ||
	        (srcBitmask == (ARY_FLAG | REARG_FLAG) && bitmask == CURRY_FLAG);

	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= (bitmask & BIND_FLAG) ? 0 : CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : arrayCopy(value);
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : arrayCopy(source[4]);
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : arrayCopy(value);
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : arrayCopy(source[6]);
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = arrayCopy(value);
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;

	      return data;
	    }

	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function mergeDefaults(objectValue, sourceValue) {
	      return objectValue === undefined ? sourceValue : merge(objectValue, sourceValue, mergeDefaults);
	    }

	    /**
	     * A specialized version of `_.pick` which picks `object` properties specified
	     * by `props`.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} props The property names to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function pickByArray(object, props) {
	      object = toObject(object);

	      var index = -1,
	          length = props.length,
	          result = {};

	      while (++index < length) {
	        var key = props[index];
	        if (key in object) {
	          result[key] = object[key];
	        }
	      }
	      return result;
	    }

	    /**
	     * A specialized version of `_.pick` which picks `object` properties `predicate`
	     * returns truthy for.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Object} Returns the new object.
	     */
	    function pickByCallback(object, predicate) {
	      var result = {};
	      baseForIn(object, function(value, key, object) {
	        if (predicate(value, key, object)) {
	          result[key] = value;
	        }
	      });
	      return result;
	    }

	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = arrayCopy(array);

	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }

	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity function
	     * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = (function() {
	      var count = 0,
	          lastCalled = 0;

	      return function(key, value) {
	        var stamp = now(),
	            remaining = HOT_SPAN - (stamp - lastCalled);

	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return key;
	          }
	        } else {
	          count = 0;
	        }
	        return baseSetData(key, value);
	      };
	    }());

	    /**
	     * A fallback implementation of `Object.keys` which creates an array of the
	     * own enumerable property names of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function shimKeys(object) {
	      var props = keysIn(object),
	          propsLength = props.length,
	          length = propsLength && object.length;

	      var allowIndexes = !!length && isLength(length) &&
	        (isArray(object) || isArguments(object));

	      var index = -1,
	          result = [];

	      while (++index < propsLength) {
	        var key = props[index];
	        if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }

	    /**
	     * Converts `value` to an array-like object if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Array|Object} Returns the array-like object.
	     */
	    function toIterable(value) {
	      if (value == null) {
	        return [];
	      }
	      if (!isArrayLike(value)) {
	        return values(value);
	      }
	      return isObject(value) ? value : Object(value);
	    }

	    /**
	     * Converts `value` to an object if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Object} Returns the object.
	     */
	    function toObject(value) {
	      return isObject(value) ? value : Object(value);
	    }

	    /**
	     * Converts `value` to property path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Array} Returns the property path array.
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return value;
	      }
	      var result = [];
	      baseToString(value).replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    }

	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      return wrapper instanceof LazyWrapper
	        ? wrapper.clone()
	        : new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__, arrayCopy(wrapper.__actions__));
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `collection` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the new array containing chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if (guard ? isIterateeCall(array, size, guard) : size == null) {
	        size = 1;
	      } else {
	        size = nativeMax(nativeFloor(size) || 1, 1);
	      }
	      var index = 0,
	          length = array ? array.length : 0,
	          resIndex = -1,
	          result = Array(nativeCeil(length / size));

	      while (index < length) {
	        result[++resIndex] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }

	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array ? array.length : 0,
	          resIndex = -1,
	          result = [];

	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }

	    /**
	     * Creates an array of unique `array` values not included in the other
	     * provided arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The arrays of values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.difference([1, 2, 3], [4, 2]);
	     * // => [1, 3]
	     */
	    var difference = restParam(function(array, values) {
	      return (isObjectLike(array) && isArrayLike(array))
	        ? baseDifference(array, baseFlatten(values, false, true))
	        : [];
	    });

	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      return baseSlice(array, n < 0 ? 0 : n);
	    }

	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      n = length - (+n || 0);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }

	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that match the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRightWhile([1, 2, 3], function(n) {
	     *   return n > 1;
	     * });
	     * // => [1]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.dropRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
	     * // => ['barney', 'fred']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.dropRightWhile(users, 'active', false), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.dropRightWhile(users, 'active'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), true, true)
	        : [];
	    }

	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropWhile([1, 2, 3], function(n) {
	     *   return n < 3;
	     * });
	     * // => [3]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.dropWhile(users, { 'user': 'barney', 'active': false }), 'user');
	     * // => ['fred', 'pebbles']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.dropWhile(users, 'active', false), 'user');
	     * // => ['pebbles']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.dropWhile(users, 'active'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), true)
	        : [];
	    }

	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8], '*', 1, 2);
	     * // => [4, '*', 8]
	     */
	    function fill(array, value, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }

	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(chr) {
	     *   return chr.user == 'barney';
	     * });
	     * // => 0
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findIndex(users, 'active', false);
	     * // => 0
	     *
	     * // using the `_.property` callback shorthand
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    var findIndex = createFindIndex();

	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(chr) {
	     *   return chr.user == 'pebbles';
	     * });
	     * // => 2
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findLastIndex(users, 'active', false);
	     * // => 2
	     *
	     * // using the `_.property` callback shorthand
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    var findLastIndex = createFindIndex(true);

	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @alias head
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.first([1, 2, 3]);
	     * // => 1
	     *
	     * _.first([]);
	     * // => undefined
	     */
	    function first(array) {
	      return array ? array[0] : undefined;
	    }

	    /**
	     * Flattens a nested array. If `isDeep` is `true` the array is recursively
	     * flattened, otherwise it is only flattened a single level.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {boolean} [isDeep] Specify a deep flatten.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, 3, [4]]]);
	     * // => [1, 2, 3, [4]]
	     *
	     * // using `isDeep`
	     * _.flatten([1, [2, 3, [4]]], true);
	     * // => [1, 2, 3, 4]
	     */
	    function flatten(array, isDeep, guard) {
	      var length = array ? array.length : 0;
	      if (guard && isIterateeCall(array, isDeep, guard)) {
	        isDeep = false;
	      }
	      return length ? baseFlatten(array, isDeep) : [];
	    }

	    /**
	     * Recursively flattens a nested array.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to recursively flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, 3, [4]]]);
	     * // => [1, 2, 3, 4]
	     */
	    function flattenDeep(array) {
	      var length = array ? array.length : 0;
	      return length ? baseFlatten(array, true) : [];
	    }

	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
	     * from the end of `array`. If `array` is sorted providing `true` for `fromIndex`
	     * performs a faster binary search.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {boolean|number} [fromIndex=0] The index to search from or `true`
	     *  to perform a binary search on a sorted array.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // using `fromIndex`
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     *
	     * // performing a binary search
	     * _.indexOf([1, 1, 2, 2], 2, true);
	     * // => 2
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      if (typeof fromIndex == 'number') {
	        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
	      } else if (fromIndex) {
	        var index = binaryIndex(array, value);
	        if (index < length &&
	            (value === value ? (value === array[index]) : (array[index] !== array[index]))) {
	          return index;
	        }
	        return -1;
	      }
	      return baseIndexOf(array, value, fromIndex || 0);
	    }

	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      return dropRight(array, 1);
	    }

	    /**
	     * Creates an array of unique values that are included in all of the provided
	     * arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of shared values.
	     * @example
	     * _.intersection([1, 2], [4, 2], [2, 1]);
	     * // => [2]
	     */
	    var intersection = restParam(function(arrays) {
	      var othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(length),
	          indexOf = getIndexOf(),
	          isCommon = indexOf == baseIndexOf,
	          result = [];

	      while (othIndex--) {
	        var value = arrays[othIndex] = isArrayLike(value = arrays[othIndex]) ? value : [];
	        caches[othIndex] = (isCommon && value.length >= 120) ? createCache(othIndex && value) : null;
	      }
	      var array = arrays[0],
	          index = -1,
	          length = array ? array.length : 0,
	          seen = caches[0];

	      outer:
	      while (++index < length) {
	        value = array[index];
	        if ((seen ? cacheIndexOf(seen, value) : indexOf(result, value, 0)) < 0) {
	          var othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if ((cache ? cacheIndexOf(cache, value) : indexOf(arrays[othIndex], value, 0)) < 0) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(value);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    });

	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array ? array.length : 0;
	      return length ? array[length - 1] : undefined;
	    }

	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {boolean|number} [fromIndex=array.length-1] The index to search from
	     *  or `true` to perform a binary search on a sorted array.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // using `fromIndex`
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     *
	     * // performing a binary search
	     * _.lastIndexOf([1, 1, 2, 2], 2, true);
	     * // => 3
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (typeof fromIndex == 'number') {
	        index = (fromIndex < 0 ? nativeMax(length + fromIndex, 0) : nativeMin(fromIndex || 0, length - 1)) + 1;
	      } else if (fromIndex) {
	        index = binaryIndex(array, value, true) - 1;
	        var other = array[index];
	        if (value === value ? (value === other) : (other !== other)) {
	          return index;
	        }
	        return -1;
	      }
	      if (value !== value) {
	        return indexOfNaN(array, index, true);
	      }
	      while (index--) {
	        if (array[index] === value) {
	          return index;
	        }
	      }
	      return -1;
	    }

	    /**
	     * Removes all provided values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3, 1, 2, 3];
	     *
	     * _.pull(array, 2, 3);
	     * console.log(array);
	     * // => [1, 1]
	     */
	    function pull() {
	      var args = arguments,
	          array = args[0];

	      if (!(array && array.length)) {
	        return array;
	      }
	      var index = 0,
	          indexOf = getIndexOf(),
	          length = args.length;

	      while (++index < length) {
	        var fromIndex = 0,
	            value = args[index];

	        while ((fromIndex = indexOf(array, value, fromIndex)) > -1) {
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }

	    /**
	     * Removes elements from `array` corresponding to the given indexes and returns
	     * an array of the removed elements. Indexes may be specified as an array of
	     * indexes or as individual arguments.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove,
	     *  specified as individual indexes or arrays of indexes.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [5, 10, 15, 20];
	     * var evens = _.pullAt(array, 1, 3);
	     *
	     * console.log(array);
	     * // => [5, 15]
	     *
	     * console.log(evens);
	     * // => [10, 20]
	     */
	    var pullAt = restParam(function(array, indexes) {
	      indexes = baseFlatten(indexes);

	      var result = baseAt(array, indexes);
	      basePullAt(array, indexes.sort(baseCompareAscending));
	      return result;
	    });

	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is bound to
	     * `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate, thisArg) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;

	      predicate = getCallback(predicate, thisArg, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }

	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @alias tail
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.rest([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function rest(array) {
	      return drop(array, 1);
	    }

	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of `Array#slice` to support node
	     * lists in IE < 9 and to ensure dense arrays are returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      return baseSlice(array, start, end);
	    }

	    /**
	     * Uses a binary search to determine the lowest index at which `value` should
	     * be inserted into `array` in order to maintain its sort order. If an iteratee
	     * function is provided it is invoked for `value` and each element of `array`
	     * to compute their sort ranking. The iteratee is bound to `thisArg` and
	     * invoked with one argument; (value).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     *
	     * _.sortedIndex([4, 4, 5, 5], 5);
	     * // => 2
	     *
	     * var dict = { 'data': { 'thirty': 30, 'forty': 40, 'fifty': 50 } };
	     *
	     * // using an iteratee function
	     * _.sortedIndex(['thirty', 'fifty'], 'forty', function(word) {
	     *   return this.data[word];
	     * }, dict);
	     * // => 1
	     *
	     * // using the `_.property` callback shorthand
	     * _.sortedIndex([{ 'x': 30 }, { 'x': 50 }], { 'x': 40 }, 'x');
	     * // => 1
	     */
	    var sortedIndex = createSortedIndex();

	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 4, 5, 5], 5);
	     * // => 4
	     */
	    var sortedLastIndex = createSortedIndex(true);

	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }

	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      n = length - (+n || 0);
	      return baseSlice(array, n < 0 ? 0 : n);
	    }

	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is bound to `thisArg`
	     * and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRightWhile([1, 2, 3], function(n) {
	     *   return n > 1;
	     * });
	     * // => [2, 3]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.takeRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
	     * // => ['pebbles']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.takeRightWhile(users, 'active', false), 'user');
	     * // => ['fred', 'pebbles']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.takeRightWhile(users, 'active'), 'user');
	     * // => []
	     */
	    function takeRightWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), false, true)
	        : [];
	    }

	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is bound to
	     * `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeWhile([1, 2, 3], function(n) {
	     *   return n < 3;
	     * });
	     * // => [1, 2]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false},
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.takeWhile(users, { 'user': 'barney', 'active': false }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.takeWhile(users, 'active', false), 'user');
	     * // => ['barney', 'fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.takeWhile(users, 'active'), 'user');
	     * // => []
	     */
	    function takeWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3))
	        : [];
	    }

	    /**
	     * Creates an array of unique values, in order, from all of the provided arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([1, 2], [4, 2], [2, 1]);
	     * // => [1, 2, 4]
	     */
	    var union = restParam(function(arrays) {
	      return baseUniq(baseFlatten(arrays, false, true));
	    });

	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurence of each element
	     * is kept. Providing `true` for `isSorted` performs a faster search algorithm
	     * for sorted arrays. If an iteratee function is provided it is invoked for
	     * each element in the array to generate the criterion by which uniqueness
	     * is computed. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, array).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias unique
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {boolean} [isSorted] Specify the array is sorted.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new duplicate-value-free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     *
	     * // using `isSorted`
	     * _.uniq([1, 1, 2], true);
	     * // => [1, 2]
	     *
	     * // using an iteratee function
	     * _.uniq([1, 2.5, 1.5, 2], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => [1, 2.5]
	     *
	     * // using the `_.property` callback shorthand
	     * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniq(array, isSorted, iteratee, thisArg) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (isSorted != null && typeof isSorted != 'boolean') {
	        thisArg = iteratee;
	        iteratee = isIterateeCall(array, isSorted, thisArg) ? undefined : isSorted;
	        isSorted = false;
	      }
	      var callback = getCallback();
	      if (!(iteratee == null && callback === baseCallback)) {
	        iteratee = callback(iteratee, thisArg, 3);
	      }
	      return (isSorted && getIndexOf() == baseIndexOf)
	        ? sortedUniq(array, iteratee)
	        : baseUniq(array, iteratee);
	    }

	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['fred', 'barney'], [30, 40], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var index = -1,
	          length = 0;

	      array = arrayFilter(array, function(group) {
	        if (isArrayLike(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = arrayMap(array, baseProperty(index));
	      }
	      return result;
	    }

	    /**
	     * This method is like `_.unzip` except that it accepts an iteratee to specify
	     * how regrouped values should be combined. The `iteratee` is bound to `thisArg`
	     * and invoked with four arguments: (accumulator, value, index, group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee] The function to combine regrouped values.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee, thisArg) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      iteratee = bindCallback(iteratee, thisArg, 4);
	      return arrayMap(result, function(group) {
	        return arrayReduce(group, iteratee, undefined, true);
	      });
	    }

	    /**
	     * Creates an array excluding all provided values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to filter.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.without([1, 2, 1, 3], 1, 2);
	     * // => [3]
	     */
	    var without = restParam(function(array, values) {
	      return isArrayLike(array)
	        ? baseDifference(array, values)
	        : [];
	    });

	    /**
	     * Creates an array of unique values that is the [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the provided arrays.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of values.
	     * @example
	     *
	     * _.xor([1, 2], [4, 2]);
	     * // => [1, 4]
	     */
	    function xor() {
	      var index = -1,
	          length = arguments.length;

	      while (++index < length) {
	        var array = arguments[index];
	        if (isArrayLike(array)) {
	          var result = result
	            ? arrayPush(baseDifference(result, array), baseDifference(array, result))
	            : array;
	        }
	      }
	      return result ? baseUniq(result) : [];
	    }

	    /**
	     * Creates an array of grouped elements, the first of which contains the first
	     * elements of the given arrays, the second of which contains the second elements
	     * of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     */
	    var zip = restParam(unzip);

	    /**
	     * The inverse of `_.pairs`; this method returns an object composed from arrays
	     * of property names and values. Provide either a single two dimensional array,
	     * e.g. `[[key1, value1], [key2, value2]]` or two arrays, one of property names
	     * and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @alias object
	     * @category Array
	     * @param {Array} props The property names.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject([['fred', 30], ['barney', 40]]);
	     * // => { 'fred': 30, 'barney': 40 }
	     *
	     * _.zipObject(['fred', 'barney'], [30, 40]);
	     * // => { 'fred': 30, 'barney': 40 }
	     */
	    function zipObject(props, values) {
	      var index = -1,
	          length = props ? props.length : 0,
	          result = {};

	      if (length && !values && !isArray(props[0])) {
	        values = [];
	      }
	      while (++index < length) {
	        var key = props[index];
	        if (values) {
	          result[key] = values[index];
	        } else if (key) {
	          result[key[0]] = key[1];
	        }
	      }
	      return result;
	    }

	    /**
	     * This method is like `_.zip` except that it accepts an iteratee to specify
	     * how grouped values should be combined. The `iteratee` is bound to `thisArg`
	     * and invoked with four arguments: (accumulator, value, index, group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee] The function to combine grouped values.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], _.add);
	     * // => [111, 222]
	     */
	    var zipWith = restParam(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 2 ? arrays[length - 2] : undefined,
	          thisArg = length > 1 ? arrays[length - 1] : undefined;

	      if (length > 2 && typeof iteratee == 'function') {
	        length -= 2;
	      } else {
	        iteratee = (length > 1 && typeof thisArg == 'function') ? (--length, thisArg) : undefined;
	        thisArg = undefined;
	      }
	      arrays.length = length;
	      return unzipWith(arrays, iteratee, thisArg);
	    });

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a `lodash` object that wraps `value` with explicit method
	     * chaining enabled.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _.chain(users)
	     *   .sortBy('age')
	     *   .map(function(chr) {
	     *     return chr.user + ' is ' + chr.age;
	     *   })
	     *   .first()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }

	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor is
	     * bound to `thisArg` and invoked with one argument; (value). The purpose of
	     * this method is to "tap into" a method chain in order to perform operations
	     * on intermediate results within the chain.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @param {*} [thisArg] The `this` binding of `interceptor`.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor, thisArg) {
	      interceptor.call(thisArg, value);
	      return value;
	    }

	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @param {*} [thisArg] The `this` binding of `interceptor`.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor, thisArg) {
	      return interceptor.call(thisArg, value);
	    }

	    /**
	     * Enables explicit method chaining on the wrapper object.
	     *
	     * @name chain
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // without explicit chaining
	     * _(users).first();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // with explicit chaining
	     * _(users).chain()
	     *   .first()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }

	    /**
	     * Executes the chained sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }

	    /**
	     * Creates a new array joining a wrapped array with any additional arrays
	     * and/or values.
	     *
	     * @name concat
	     * @memberOf _
	     * @category Chain
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var wrapped = _(array).concat(2, [3], [[4]]);
	     *
	     * console.log(wrapped.value());
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    var wrapperConcat = restParam(function(values) {
	      values = baseFlatten(values);
	      return this.thru(function(array) {
	        return arrayConcat(isArray(array) ? array : [toObject(array)], values);
	      });
	    });

	    /**
	     * Creates a clone of the chained sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).map(function(value) {
	     *   return Math.pow(value, 2);
	     * });
	     *
	     * var other = [3, 4];
	     * var otherWrapped = wrapped.plant(other);
	     *
	     * otherWrapped.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;

	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }

	    /**
	     * Reverses the wrapped array so the first element becomes the last, the
	     * second element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new reversed `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;

	      var interceptor = function(value) {
	        return (wrapped && wrapped.__dir__ < 0) ? value : value.reverse();
	      };
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(interceptor);
	    }

	    /**
	     * Produces the result of coercing the unwrapped value to a string.
	     *
	     * @name toString
	     * @memberOf _
	     * @category Chain
	     * @returns {string} Returns the coerced string value.
	     * @example
	     *
	     * _([1, 2, 3]).toString();
	     * // => '1,2,3'
	     */
	    function wrapperToString() {
	      return (this.value() + '');
	    }

	    /**
	     * Executes the chained sequence to extract the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @alias run, toJSON, valueOf
	     * @category Chain
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates an array of elements corresponding to the given keys, or indexes,
	     * of `collection`. Keys may be specified as individual arguments or as arrays
	     * of keys.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {...(number|number[]|string|string[])} [props] The property names
	     *  or indexes of elements to pick, specified individually or in arrays.
	     * @returns {Array} Returns the new array of picked elements.
	     * @example
	     *
	     * _.at(['a', 'b', 'c'], [0, 2]);
	     * // => ['a', 'c']
	     *
	     * _.at(['barney', 'fred', 'pebbles'], 0, 2);
	     * // => ['barney', 'pebbles']
	     */
	    var at = restParam(function(collection, props) {
	      return baseAt(collection, baseFlatten(props));
	    });

	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the number of times the key was returned by `iteratee`.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([4.3, 6.1, 6.4], function(n) {
	     *   return Math.floor(n);
	     * });
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy([4.3, 6.1, 6.4], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
	    });

	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * The predicate is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias all
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': false },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.every(users, 'active', false);
	     * // => true
	     *
	     * // using the `_.property` callback shorthand
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	        predicate = undefined;
	      }
	      if (typeof predicate != 'function' || thisArg !== undefined) {
	        predicate = getCallback(predicate, thisArg, 3);
	      }
	      return func(collection, predicate);
	    }

	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias select
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * _.filter([4, 5, 6], function(n) {
	     *   return n % 2 == 0;
	     * });
	     * // => [4, 6]
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.filter(users, { 'age': 36, 'active': true }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.filter(users, 'active', false), 'user');
	     * // => ['fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.filter(users, 'active'), 'user');
	     * // => ['barney']
	     */
	    function filter(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getCallback(predicate, thisArg, 3);
	      return func(collection, predicate);
	    }

	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias detect
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.result(_.find(users, function(chr) {
	     *   return chr.age < 40;
	     * }), 'user');
	     * // => 'barney'
	     *
	     * // using the `_.matches` callback shorthand
	     * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
	     * // => 'pebbles'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.result(_.find(users, 'active', false), 'user');
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.result(_.find(users, 'active'), 'user');
	     * // => 'barney'
	     */
	    var find = createFind(baseEach);

	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(baseEachRight, true);

	    /**
	     * Performs a deep comparison between each element in `collection` and the
	     * source object, returning the first element that has equivalent property
	     * values.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Object} source The object of property values to match.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.result(_.findWhere(users, { 'age': 36, 'active': true }), 'user');
	     * // => 'barney'
	     *
	     * _.result(_.findWhere(users, { 'age': 40, 'active': false }), 'user');
	     * // => 'fred'
	     */
	    function findWhere(collection, source) {
	      return find(collection, baseMatches(source));
	    }

	    /**
	     * Iterates over elements of `collection` invoking `iteratee` for each element.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection). Iteratee functions may exit iteration early
	     * by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length" property
	     * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
	     * may be used for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @alias each
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array|Object|string} Returns `collection`.
	     * @example
	     *
	     * _([1, 2]).forEach(function(n) {
	     *   console.log(n);
	     * }).value();
	     * // => logs each value from left to right and returns the array
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
	     *   console.log(n, key);
	     * });
	     * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
	     */
	    var forEach = createForEach(arrayEach, baseEach);

	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array|Object|string} Returns `collection`.
	     * @example
	     *
	     * _([1, 2]).forEachRight(function(n) {
	     *   console.log(n);
	     * }).value();
	     * // => logs each value from right to left and returns the array
	     */
	    var forEachRight = createForEach(arrayEachRight, baseEachRight);

	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is an array of the elements responsible for generating the key.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([4.2, 6.1, 6.4], function(n) {
	     *   return Math.floor(n);
	     * });
	     * // => { '4': [4.2], '6': [6.1, 6.4] }
	     *
	     * _.groupBy([4.2, 6.1, 6.4], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => { '4': [4.2], '6': [6.1, 6.4] }
	     *
	     * // using the `_.property` callback shorthand
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        result[key] = [value];
	      }
	    });

	    /**
	     * Checks if `value` is in `collection` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
	     * from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @alias contains, include
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {*} target The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	     * @returns {boolean} Returns `true` if a matching element is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
	     * // => true
	     *
	     * _.includes('pebbles', 'eb');
	     * // => true
	     */
	    function includes(collection, target, fromIndex, guard) {
	      var length = collection ? getLength(collection) : 0;
	      if (!isLength(length)) {
	        collection = values(collection);
	        length = collection.length;
	      }
	      if (typeof fromIndex != 'number' || (guard && isIterateeCall(target, fromIndex, guard))) {
	        fromIndex = 0;
	      } else {
	        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : (fromIndex || 0);
	      }
	      return (typeof collection == 'string' || !isArray(collection) && isString(collection))
	        ? (fromIndex <= length && collection.indexOf(target, fromIndex) > -1)
	        : (!!length && getIndexOf(collection, target, fromIndex) > -1);
	    }

	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the last element responsible for generating the key. The
	     * iteratee function is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var keyData = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.indexBy(keyData, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.indexBy(keyData, function(object) {
	     *   return String.fromCharCode(object.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.indexBy(keyData, function(object) {
	     *   return this.fromCharCode(object.code);
	     * }, String);
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     */
	    var indexBy = createAggregator(function(result, value, key) {
	      result[key] = value;
	    });

	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `methodName` is a function it is
	     * invoked for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invoke([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invoke = restParam(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          isProp = isKey(path),
	          result = isArrayLike(collection) ? Array(collection.length) : [];

	      baseEach(collection, function(value) {
	        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
	        result[++index] = func ? func.apply(value, args) : invokePath(value, path, args);
	      });
	      return result;
	    });

	    /**
	     * Creates an array of values by running each element in `collection` through
	     * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
	     * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
	     * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
	     * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
	     * `sum`, `uniq`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @alias collect
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function timesThree(n) {
	     *   return n * 3;
	     * }
	     *
	     * _.map([1, 2], timesThree);
	     * // => [3, 6]
	     *
	     * _.map({ 'a': 1, 'b': 2 }, timesThree);
	     * // => [3, 6] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // using the `_.property` callback shorthand
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee, thisArg) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      iteratee = getCallback(iteratee, thisArg, 3);
	      return func(collection, iteratee);
	    }

	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, while the second of which
	     * contains elements `predicate` returns falsey for. The predicate is bound
	     * to `thisArg` and invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * _.partition([1, 2, 3], function(n) {
	     *   return n % 2;
	     * });
	     * // => [[1, 3], [2]]
	     *
	     * _.partition([1.2, 2.3, 3.4], function(n) {
	     *   return this.floor(n) % 2;
	     * }, Math);
	     * // => [[1.2, 3.4], [2.3]]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * var mapper = function(array) {
	     *   return _.pluck(array, 'user');
	     * };
	     *
	     * // using the `_.matches` callback shorthand
	     * _.map(_.partition(users, { 'age': 1, 'active': false }), mapper);
	     * // => [['pebbles'], ['barney', 'fred']]
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.map(_.partition(users, 'active', false), mapper);
	     * // => [['barney', 'pebbles'], ['fred']]
	     *
	     * // using the `_.property` callback shorthand
	     * _.map(_.partition(users, 'active'), mapper);
	     * // => [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });

	    /**
	     * Gets the property value of `path` from all elements in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Array|string} path The path of the property to pluck.
	     * @returns {Array} Returns the property values.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.pluck(users, 'user');
	     * // => ['barney', 'fred']
	     *
	     * var userIndex = _.indexBy(users, 'user');
	     * _.pluck(userIndex, 'age');
	     * // => [36, 40] (iteration order is not guaranteed)
	     */
	    function pluck(collection, path) {
	      return map(collection, property(path));
	    }

	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` through `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not provided the first element of `collection` is used as the initial
	     * value. The `iteratee` is bound to `thisArg` and invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `sortByAll`,
	     * and `sortByOrder`
	     *
	     * @static
	     * @memberOf _
	     * @alias foldl, inject
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.reduce([1, 2], function(total, n) {
	     *   return total + n;
	     * });
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2 }, function(result, n, key) {
	     *   result[key] = n * 3;
	     *   return result;
	     * }, {});
	     * // => { 'a': 3, 'b': 6 } (iteration order is not guaranteed)
	     */
	    var reduce = createReduce(arrayReduce, baseEach);

	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias foldr
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    var reduceRight = createReduce(arrayReduceRight, baseEachRight);

	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * _.reject([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 0;
	     * });
	     * // => [1, 3]
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.reject(users, { 'age': 40, 'active': true }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.reject(users, 'active', false), 'user');
	     * // => ['fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.reject(users, 'active'), 'user');
	     * // => ['barney']
	     */
	    function reject(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getCallback(predicate, thisArg, 3);
	      return func(collection, function(value, index, collection) {
	        return !predicate(value, index, collection);
	      });
	    }

	    /**
	     * Gets a random element or `n` random elements from a collection.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to sample.
	     * @param {number} [n] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {*} Returns the random sample(s).
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     *
	     * _.sample([1, 2, 3, 4], 2);
	     * // => [3, 1]
	     */
	    function sample(collection, n, guard) {
	      if (guard ? isIterateeCall(collection, n, guard) : n == null) {
	        collection = toIterable(collection);
	        var length = collection.length;
	        return length > 0 ? collection[baseRandom(0, length - 1)] : undefined;
	      }
	      var index = -1,
	          result = toArray(collection),
	          length = result.length,
	          lastIndex = length - 1;

	      n = nativeMin(n < 0 ? 0 : (+n || 0), length);
	      while (++index < n) {
	        var rand = baseRandom(index, lastIndex),
	            value = result[rand];

	        result[rand] = result[index];
	        result[index] = value;
	      }
	      result.length = n;
	      return result;
	    }

	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      return sample(collection, POSITIVE_INFINITY);
	    }

	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the size of `collection`.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      var length = collection ? getLength(collection) : 0;
	      return isLength(length) ? length : keys(collection).length;
	    }

	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * The function returns as soon as it finds a passing value and does not iterate
	     * over the entire collection. The predicate is bound to `thisArg` and invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias any
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.some(users, 'active', false);
	     * // => true
	     *
	     * // using the `_.property` callback shorthand
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	        predicate = undefined;
	      }
	      if (typeof predicate != 'function' || thisArg !== undefined) {
	        predicate = getCallback(predicate, thisArg, 3);
	      }
	      return func(collection, predicate);
	    }

	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection through `iteratee`. This method performs
	     * a stable sort, that is, it preserves the original sort order of equal elements.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * _.sortBy([1, 2, 3], function(n) {
	     *   return Math.sin(n);
	     * });
	     * // => [3, 1, 2]
	     *
	     * _.sortBy([1, 2, 3], function(n) {
	     *   return this.sin(n);
	     * }, Math);
	     * // => [3, 1, 2]
	     *
	     * var users = [
	     *   { 'user': 'fred' },
	     *   { 'user': 'pebbles' },
	     *   { 'user': 'barney' }
	     * ];
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.sortBy(users, 'user'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function sortBy(collection, iteratee, thisArg) {
	      if (collection == null) {
	        return [];
	      }
	      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	        iteratee = undefined;
	      }
	      var index = -1;
	      iteratee = getCallback(iteratee, thisArg, 3);

	      var result = baseMap(collection, function(value, key, collection) {
	        return { 'criteria': iteratee(value, key, collection), 'index': ++index, 'value': value };
	      });
	      return baseSortBy(result, compareAscending);
	    }

	    /**
	     * This method is like `_.sortBy` except that it can sort by multiple iteratees
	     * or property names.
	     *
	     * If a property name is provided for an iteratee the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If an object is provided for an iteratee the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {...(Function|Function[]|Object|Object[]|string|string[])} iteratees
	     *  The iteratees to sort by, specified as individual values or arrays of values.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.map(_.sortByAll(users, ['user', 'age']), _.values);
	     * // => [['barney', 34], ['barney', 36], ['fred', 42], ['fred', 48]]
	     *
	     * _.map(_.sortByAll(users, 'user', function(chr) {
	     *   return Math.floor(chr.age / 10);
	     * }), _.values);
	     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    var sortByAll = restParam(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var guard = iteratees[2];
	      if (guard && isIterateeCall(iteratees[0], iteratees[1], guard)) {
	        iteratees.length = 1;
	      }
	      return baseSortByOrder(collection, baseFlatten(iteratees), []);
	    });

	    /**
	     * This method is like `_.sortByAll` except that it allows specifying the
	     * sort orders of the iteratees to sort by. If `orders` is unspecified, all
	     * values are sorted in ascending order. Otherwise, a value is sorted in
	     * ascending order if its corresponding order is "asc", and descending if "desc".
	     *
	     * If a property name is provided for an iteratee the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If an object is provided for an iteratee the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {boolean[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // sort by `user` in ascending order and by `age` in descending order
	     * _.map(_.sortByOrder(users, ['user', 'age'], ['asc', 'desc']), _.values);
	     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    function sortByOrder(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (guard && isIterateeCall(iteratees, orders, guard)) {
	        orders = undefined;
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseSortByOrder(collection, iteratees, orders);
	    }

	    /**
	     * Performs a deep comparison between each element in `collection` and the
	     * source object, returning an array of all elements that have equivalent
	     * property values.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Object} source The object of property values to match.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false, 'pets': ['hoppy'] },
	     *   { 'user': 'fred',   'age': 40, 'active': true, 'pets': ['baby puss', 'dino'] }
	     * ];
	     *
	     * _.pluck(_.where(users, { 'age': 36, 'active': false }), 'user');
	     * // => ['barney']
	     *
	     * _.pluck(_.where(users, { 'pets': ['dino'] }), 'user');
	     * // => ['fred']
	     */
	    function where(collection, source) {
	      return filter(collection, baseMatches(source));
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Gets the number of milliseconds that have elapsed since the Unix epoch
	     * (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @category Date
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => logs the number of milliseconds it took for the deferred function to be invoked
	     */
	    var now = nativeNow || function() {
	      return new Date().getTime();
	    };

	    /*------------------------------------------------------------------------*/

	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it is called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => logs 'done saving!' after the two async saves have completed
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        if (typeof n == 'function') {
	          var temp = n;
	          n = func;
	          func = temp;
	        } else {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	      }
	      n = nativeIsFinite(n = +n) ? n : 0;
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }

	    /**
	     * Creates a function that accepts up to `n` arguments ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      if (guard && isIterateeCall(func, n, guard)) {
	        n = undefined;
	      }
	      n = (func && n == null) ? func.length : nativeMax(+n || 0, 0);
	      return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }

	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it is called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery('#add').on('click', _.before(5, addContactToList));
	     * // => allows adding up to 4 contacts to the list
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        if (typeof n == 'function') {
	          var temp = n;
	          n = func;
	          func = temp;
	        } else {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	      }
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }

	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and prepends any additional `_.bind` arguments to those provided to the
	     * bound function.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind` this method does not set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var greet = function(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * };
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // using placeholders
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = restParam(function(func, thisArg, partials) {
	      var bitmask = BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, bind.placeholder);
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(func, bitmask, thisArg, partials, holders);
	    });

	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method. Method names may be specified as individual arguments or as arrays
	     * of method names. If no method names are provided all enumerable function
	     * properties, own and inherited, of `object` are bound.
	     *
	     * **Note:** This method does not set the "length" property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} [methodNames] The object method names to bind,
	     *  specified as individual method names or arrays of method names.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'onClick': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view);
	     * jQuery('#docs').on('click', view.onClick);
	     * // => logs 'clicked docs' when the element is clicked
	     */
	    var bindAll = restParam(function(object, methodNames) {
	      methodNames = methodNames.length ? baseFlatten(methodNames) : functions(object);

	      var index = -1,
	          length = methodNames.length;

	      while (++index < length) {
	        var key = methodNames[index];
	        object[key] = createWrapper(object[key], BIND_FLAG, object);
	      }
	      return object;
	    });

	    /**
	     * Creates a function that invokes the method at `object[key]` and prepends
	     * any additional `_.bindKey` arguments to those provided to the bound function.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist.
	     * See [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Object} object The object the method belongs to.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // using placeholders
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = restParam(function(object, key, partials) {
	      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, bindKey.placeholder);
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(key, bitmask, object, partials, holders);
	    });

	    /**
	     * Creates a function that accepts one or more arguments of `func` that when
	     * called either invokes `func` returning its result, if all `func` arguments
	     * have been provided, or returns a function that accepts one or more of the
	     * remaining `func` arguments, and so on. The arity of `func` may be specified
	     * if `func.length` is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method does not set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // using placeholders
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    var curry = createCurry(CURRY_FLAG);

	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method does not set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // using placeholders
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    var curryRight = createCurry(CURRY_RIGHT_FLAG);

	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed invocations. Provide an options object to indicate that `func`
	     * should be invoked on the leading and/or trailing edge of the `wait` timeout.
	     * Subsequent calls to the debounced function return the result of the last
	     * `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the the debounced function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=false] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {number} [options.maxWait] The maximum time `func` is allowed to be
	     *  delayed before it is invoked.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // avoid costly calculations while the window size is in flux
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
	     * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // ensure `batchLog` is invoked once after 1 second of debounced calls
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', _.debounce(batchLog, 250, {
	     *   'maxWait': 1000
	     * }));
	     *
	     * // cancel a debounced call
	     * var todoChanges = _.debounce(batchLog, 1000);
	     * Object.observe(models.todo, todoChanges);
	     *
	     * Object.observe(models, function(changes) {
	     *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
	     *     todoChanges.cancel();
	     *   }
	     * }, ['delete']);
	     *
	     * // ...at some point `models.todo` is changed
	     * models.todo.completed = true;
	     *
	     * // ...before 1 second has passed `models.todo` is deleted
	     * // which cancels the debounced `todoChanges` call
	     * delete models.todo;
	     */
	    function debounce(func, wait, options) {
	      var args,
	          maxTimeoutId,
	          result,
	          stamp,
	          thisArg,
	          timeoutId,
	          trailingCall,
	          lastCalled = 0,
	          maxWait = false,
	          trailing = true;

	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = wait < 0 ? 0 : (+wait || 0);
	      if (options === true) {
	        var leading = true;
	        trailing = false;
	      } else if (isObject(options)) {
	        leading = !!options.leading;
	        maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }

	      function cancel() {
	        if (timeoutId) {
	          clearTimeout(timeoutId);
	        }
	        if (maxTimeoutId) {
	          clearTimeout(maxTimeoutId);
	        }
	        lastCalled = 0;
	        maxTimeoutId = timeoutId = trailingCall = undefined;
	      }

	      function complete(isCalled, id) {
	        if (id) {
	          clearTimeout(id);
	        }
	        maxTimeoutId = timeoutId = trailingCall = undefined;
	        if (isCalled) {
	          lastCalled = now();
	          result = func.apply(thisArg, args);
	          if (!timeoutId && !maxTimeoutId) {
	            args = thisArg = undefined;
	          }
	        }
	      }

	      function delayed() {
	        var remaining = wait - (now() - stamp);
	        if (remaining <= 0 || remaining > wait) {
	          complete(trailingCall, maxTimeoutId);
	        } else {
	          timeoutId = setTimeout(delayed, remaining);
	        }
	      }

	      function maxDelayed() {
	        complete(trailing, timeoutId);
	      }

	      function debounced() {
	        args = arguments;
	        stamp = now();
	        thisArg = this;
	        trailingCall = trailing && (timeoutId || !leading);

	        if (maxWait === false) {
	          var leadingCall = leading && !timeoutId;
	        } else {
	          if (!maxTimeoutId && !leading) {
	            lastCalled = stamp;
	          }
	          var remaining = maxWait - (stamp - lastCalled),
	              isCalled = remaining <= 0 || remaining > maxWait;

	          if (isCalled) {
	            if (maxTimeoutId) {
	              maxTimeoutId = clearTimeout(maxTimeoutId);
	            }
	            lastCalled = stamp;
	            result = func.apply(thisArg, args);
	          }
	          else if (!maxTimeoutId) {
	            maxTimeoutId = setTimeout(maxDelayed, remaining);
	          }
	        }
	        if (isCalled && timeoutId) {
	          timeoutId = clearTimeout(timeoutId);
	        }
	        else if (!timeoutId && wait !== maxWait) {
	          timeoutId = setTimeout(delayed, wait);
	        }
	        if (leadingCall) {
	          isCalled = true;
	          result = func.apply(thisArg, args);
	        }
	        if (isCalled && !timeoutId && !maxTimeoutId) {
	          args = thisArg = undefined;
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      return debounced;
	    }

	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke the function with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // logs 'deferred' after one or more milliseconds
	     */
	    var defer = restParam(function(func, args) {
	      return baseDelay(func, 1, args);
	    });

	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke the function with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => logs 'later' after one second
	     */
	    var delay = restParam(function(func, wait, args) {
	      return baseDelay(func, wait, args);
	    });

	    /**
	     * Creates a function that returns the result of invoking the provided
	     * functions with the `this` binding of the created function, where each
	     * successive invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {...Function} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow(_.add, square);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();

	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the provided functions from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias backflow, compose
	     * @category Function
	     * @param {...Function} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight(square, _.add);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);

	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is coerced to a string and used as the
	     * cache key. The `func` is invoked with the `this` binding of the memoized
	     * function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoizing function.
	     * @example
	     *
	     * var upperCase = _.memoize(function(string) {
	     *   return string.toUpperCase();
	     * });
	     *
	     * upperCase('fred');
	     * // => 'FRED'
	     *
	     * // modifying the result cache
	     * upperCase.cache.set('fred', 'BARNEY');
	     * upperCase('fred');
	     * // => 'BARNEY'
	     *
	     * // replacing `_.memoize.Cache`
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'barney' };
	     * var identity = _.memoize(_.identity);
	     *
	     * identity(object);
	     * // => { 'user': 'fred' }
	     * identity(other);
	     * // => { 'user': 'fred' }
	     *
	     * _.memoize.Cache = WeakMap;
	     * var identity = _.memoize(_.identity);
	     *
	     * identity(object);
	     * // => { 'user': 'fred' }
	     * identity(other);
	     * // => { 'user': 'barney' }
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;

	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result);
	        return result;
	      };
	      memoized.cache = new memoize.Cache;
	      return memoized;
	    }

	    /**
	     * Creates a function that runs each argument through a corresponding
	     * transform function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms] The functions to transform
	     * arguments, specified as individual functions or arrays of functions.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var modded = _.modArgs(function(x, y) {
	     *   return [x, y];
	     * }, square, doubled);
	     *
	     * modded(1, 2);
	     * // => [1, 4]
	     *
	     * modded(5, 10);
	     * // => [25, 20]
	     */
	    var modArgs = restParam(function(func, transforms) {
	      transforms = baseFlatten(transforms);
	      if (typeof func != 'function' || !arrayEvery(transforms, baseIsFunction)) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = transforms.length;
	      return restParam(function(args) {
	        var index = nativeMin(args.length, length);
	        while (index--) {
	          args[index] = transforms[index](args[index]);
	        }
	        return func.apply(this, args);
	      });
	    });

	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        return !predicate.apply(this, arguments);
	      };
	    }

	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first call. The `func` is invoked
	     * with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // `initialize` invokes `createApplication` once
	     */
	    function once(func) {
	      return before(2, func);
	    }

	    /**
	     * Creates a function that invokes `func` with `partial` arguments prepended
	     * to those provided to the new function. This method is like `_.bind` except
	     * it does **not** alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method does not set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // using placeholders
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = createPartial(PARTIAL_FLAG);

	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to those provided to the new function.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method does not set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // using placeholders
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = createPartial(PARTIAL_RIGHT_FLAG);

	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified indexes where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes,
	     *  specified as individual indexes or arrays of indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, 2, 0, 1);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     *
	     * var map = _.rearg(_.map, [1, 0]);
	     * map(function(n) {
	     *   return n * 3;
	     * }, [1, 2, 3]);
	     * // => [3, 6, 9]
	     */
	    var rearg = restParam(function(func, indexes) {
	      return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes));
	    });

	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as an array.
	     *
	     * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.restParam(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function restParam(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            rest = Array(length);

	        while (++index < length) {
	          rest[index] = args[start + index];
	        }
	        switch (start) {
	          case 0: return func.call(this, rest);
	          case 1: return func.call(this, args[0], rest);
	          case 2: return func.call(this, args[0], args[1], rest);
	        }
	        var otherArgs = Array(start + 1);
	        index = -1;
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = rest;
	        return func.apply(this, otherArgs);
	      };
	    }

	    /**
	     * Creates a function that invokes `func` with the `this` binding of the created
	     * function and an array of arguments much like [`Function#apply`](https://es5.github.io/#x15.3.4.3).
	     *
	     * **Note:** This method is based on the [spread operator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * // with a Promise
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function(array) {
	        return func.apply(this, array);
	      };
	    }

	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed invocations. Provide an options object to indicate
	     * that `func` should be invoked on the leading and/or trailing edge of the
	     * `wait` timeout. Subsequent calls to the throttled function return the
	     * result of the last `func` call.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the the throttled function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=true] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // avoid excessively updating the position while scrolling
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // invoke `renewToken` when the click event is fired, but not more than once every 5 minutes
	     * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
	     *   'trailing': false
	     * }));
	     *
	     * // cancel a trailing throttled call
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;

	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (options === false) {
	        leading = false;
	      } else if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, { 'leading': leading, 'maxWait': +wait, 'trailing': trailing });
	    }

	    /**
	     * Creates a function that provides `value` to the wrapper function as its
	     * first argument. Any additional arguments provided to the function are
	     * appended to those provided to the wrapper function. The wrapper is invoked
	     * with the `this` binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} wrapper The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      wrapper = wrapper == null ? identity : wrapper;
	      return createWrapper(wrapper, PARTIAL_FLAG, undefined, [value], []);
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a clone of `value`. If `isDeep` is `true` nested objects are cloned,
	     * otherwise they are assigned by reference. If `customizer` is provided it is
	     * invoked to produce the cloned values. If `customizer` returns `undefined`
	     * cloning is handled by the method instead. The `customizer` is bound to
	     * `thisArg` and invoked with two argument; (value [, index|key, object]).
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	     * The enumerable properties of `arguments` objects and objects created by
	     * constructors other than `Object` are cloned to plain `Object` objects. An
	     * empty object is returned for uncloneable values such as functions, DOM nodes,
	     * Maps, Sets, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {*} Returns the cloned value.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * var shallow = _.clone(users);
	     * shallow[0] === users[0];
	     * // => true
	     *
	     * var deep = _.clone(users, true);
	     * deep[0] === users[0];
	     * // => false
	     *
	     * // using a customizer callback
	     * var el = _.clone(document.body, function(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * });
	     *
	     * el === document.body
	     * // => false
	     * el.nodeName
	     * // => BODY
	     * el.childNodes.length;
	     * // => 0
	     */
	    function clone(value, isDeep, customizer, thisArg) {
	      if (isDeep && typeof isDeep != 'boolean' && isIterateeCall(value, isDeep, customizer)) {
	        isDeep = false;
	      }
	      else if (typeof isDeep == 'function') {
	        thisArg = customizer;
	        customizer = isDeep;
	        isDeep = false;
	      }
	      return typeof customizer == 'function'
	        ? baseClone(value, isDeep, bindCallback(customizer, thisArg, 1))
	        : baseClone(value, isDeep);
	    }

	    /**
	     * Creates a deep clone of `value`. If `customizer` is provided it is invoked
	     * to produce the cloned values. If `customizer` returns `undefined` cloning
	     * is handled by the method instead. The `customizer` is bound to `thisArg`
	     * and invoked with two argument; (value [, index|key, object]).
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	     * The enumerable properties of `arguments` objects and objects created by
	     * constructors other than `Object` are cloned to plain `Object` objects. An
	     * empty object is returned for uncloneable values such as functions, DOM nodes,
	     * Maps, Sets, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {*} Returns the deep cloned value.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * var deep = _.cloneDeep(users);
	     * deep[0] === users[0];
	     * // => false
	     *
	     * // using a customizer callback
	     * var el = _.cloneDeep(document.body, function(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * });
	     *
	     * el === document.body
	     * // => false
	     * el.nodeName
	     * // => BODY
	     * el.childNodes.length;
	     * // => 20
	     */
	    function cloneDeep(value, customizer, thisArg) {
	      return typeof customizer == 'function'
	        ? baseClone(value, true, bindCallback(customizer, thisArg, 1))
	        : baseClone(value, true);
	    }

	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`, else `false`.
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    function gt(value, other) {
	      return value > other;
	    }

	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    function gte(value, other) {
	      return value >= other;
	    }

	    /**
	     * Checks if `value` is classified as an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    function isArguments(value) {
	      return isObjectLike(value) && isArrayLike(value) &&
	        hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
	    }

	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(function() { return arguments; }());
	     * // => false
	     */
	    var isArray = nativeIsArray || function(value) {
	      return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	    };

	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false || (isObjectLike(value) && objToString.call(value) == boolTag);
	    }

	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    function isDate(value) {
	      return isObjectLike(value) && objToString.call(value) == dateTag;
	    }

	    /**
	     * Checks if `value` is a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
	    }

	    /**
	     * Checks if `value` is empty. A value is considered empty unless it is an
	     * `arguments` object, array, string, or jQuery-like collection with a length
	     * greater than `0` or an object with own enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Array|Object|string} value The value to inspect.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) ||
	          (isObjectLike(value) && isFunction(value.splice)))) {
	        return !value.length;
	      }
	      return !keys(value).length;
	    }

	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent. If `customizer` is provided it is invoked to compare values.
	     * If `customizer` returns `undefined` comparisons are handled by the method
	     * instead. The `customizer` is bound to `thisArg` and invoked with three
	     * arguments: (value, other [, index|key]).
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. Functions and DOM nodes
	     * are **not** supported. Provide a customizer function to extend support
	     * for comparing other values.
	     *
	     * @static
	     * @memberOf _
	     * @alias eq
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize value comparisons.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'fred' };
	     *
	     * object == other;
	     * // => false
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * // using a customizer callback
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqual(array, other, function(value, other) {
	     *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
	     *     return true;
	     *   }
	     * });
	     * // => true
	     */
	    function isEqual(value, other, customizer, thisArg) {
	      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return  result === undefined ? baseIsEqual(value, other, customizer) : !!result;
	    }

	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      return isObjectLike(value) && typeof value.message == 'string' && objToString.call(value) == errorTag;
	    }

	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on [`Number.isFinite`](http://ecma-international.org/ecma-262/6.0/#sec-number.isfinite).
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(10);
	     * // => true
	     *
	     * _.isFinite('10');
	     * // => false
	     *
	     * _.isFinite(true);
	     * // => false
	     *
	     * _.isFinite(Object(10));
	     * // => false
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }

	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in older versions of Chrome and Safari which return 'function' for regexes
	      // and Safari 8 equivalents which return 'object' for typed array constructors.
	      return isObject(value) && objToString.call(value) == funcTag;
	    }

	    /**
	     * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	     * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(1);
	     * // => false
	     */
	    function isObject(value) {
	      // Avoid a V8 JIT bug in Chrome 19-20.
	      // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	      var type = typeof value;
	      return !!value && (type == 'object' || type == 'function');
	    }

	    /**
	     * Performs a deep comparison between `object` and `source` to determine if
	     * `object` contains equivalent property values. If `customizer` is provided
	     * it is invoked to compare values. If `customizer` returns `undefined`
	     * comparisons are handled by the method instead. The `customizer` is bound
	     * to `thisArg` and invoked with three arguments: (value, other, index|key).
	     *
	     * **Note:** This method supports comparing properties of arrays, booleans,
	     * `Date` objects, numbers, `Object` objects, regexes, and strings. Functions
	     * and DOM nodes are **not** supported. Provide a customizer function to extend
	     * support for comparing other values.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize value comparisons.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.isMatch(object, { 'age': 40 });
	     * // => true
	     *
	     * _.isMatch(object, { 'age': 36 });
	     * // => false
	     *
	     * // using a customizer callback
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatch(object, source, function(value, other) {
	     *   return _.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/) || undefined;
	     * });
	     * // => true
	     */
	    function isMatch(object, source, customizer, thisArg) {
	      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
	      return baseIsMatch(object, getMatchData(source), customizer);
	    }

	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is not the same as [`isNaN`](https://es5.github.io/#x15.1.2.4)
	     * which returns `true` for `undefined` and other non-numeric values.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some host objects in IE.
	      return isNumber(value) && value != +value;
	    }

	    /**
	     * Checks if `value` is a native function.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (value == null) {
	        return false;
	      }
	      if (isFunction(value)) {
	        return reIsNative.test(fnToString.call(value));
	      }
	      return isObjectLike(value) && reIsHostCtor.test(value);
	    }

	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }

	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
	     * as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isNumber(8.4);
	     * // => true
	     *
	     * _.isNumber(NaN);
	     * // => true
	     *
	     * _.isNumber('8.4');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' || (isObjectLike(value) && objToString.call(value) == numberTag);
	    }

	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * **Note:** This method assumes objects created by the `Object` constructor
	     * have no inherited enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      var Ctor;

	      // Exit early for non `Object` objects.
	      if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
	          (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
	        return false;
	      }
	      // IE < 9 iterates inherited properties before own properties. If the first
	      // iterated property is an object's own property then there are no inherited
	      // enumerable properties.
	      var result;
	      // In most environments an object's own properties are iterated before
	      // its inherited properties. If the last iterated property is an object's
	      // own property then there are no inherited enumerable properties.
	      baseForIn(value, function(subValue, key) {
	        result = key;
	      });
	      return result === undefined || hasOwnProperty.call(value, result);
	    }

	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    function isRegExp(value) {
	      return isObject(value) && objToString.call(value) == regexpTag;
	    }

	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
	    }

	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    function isTypedArray(value) {
	      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
	    }

	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }

	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`, else `false`.
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    function lt(value, other) {
	      return value < other;
	    }

	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    function lte(value, other) {
	      return value <= other;
	    }

	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * (function() {
	     *   return _.toArray(arguments).slice(1);
	     * }(1, 2, 3));
	     * // => [2, 3]
	     */
	    function toArray(value) {
	      var length = value ? getLength(value) : 0;
	      if (!isLength(length)) {
	        return values(value);
	      }
	      if (!length) {
	        return [];
	      }
	      return arrayCopy(value);
	    }

	    /**
	     * Converts `value` to a plain object flattening inherited enumerable
	     * properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return baseCopy(value, keysIn(value));
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Recursively merges own enumerable properties of the source object(s), that
	     * don't resolve to `undefined` into the destination object. Subsequent sources
	     * overwrite property assignments of previous sources. If `customizer` is
	     * provided it is invoked to produce the merged values of the destination and
	     * source properties. If `customizer` returns `undefined` merging is handled
	     * by the method instead. The `customizer` is bound to `thisArg` and invoked
	     * with five arguments: (objectValue, sourceValue, key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var users = {
	     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
	     * };
	     *
	     * var ages = {
	     *   'data': [{ 'age': 36 }, { 'age': 40 }]
	     * };
	     *
	     * _.merge(users, ages);
	     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
	     *
	     * // using a customizer callback
	     * var object = {
	     *   'fruits': ['apple'],
	     *   'vegetables': ['beet']
	     * };
	     *
	     * var other = {
	     *   'fruits': ['banana'],
	     *   'vegetables': ['carrot']
	     * };
	     *
	     * _.merge(object, other, function(a, b) {
	     *   if (_.isArray(a)) {
	     *     return a.concat(b);
	     *   }
	     * });
	     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
	     */
	    var merge = createAssigner(baseMerge);

	    /**
	     * Assigns own enumerable properties of source object(s) to the destination
	     * object. Subsequent sources overwrite property assignments of previous sources.
	     * If `customizer` is provided it is invoked to produce the assigned values.
	     * The `customizer` is bound to `thisArg` and invoked with five arguments:
	     * (objectValue, sourceValue, key, object, source).
	     *
	     * **Note:** This method mutates `object` and is based on
	     * [`Object.assign`](http://ecma-international.org/ecma-262/6.0/#sec-object.assign).
	     *
	     * @static
	     * @memberOf _
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
	     * // => { 'user': 'fred', 'age': 40 }
	     *
	     * // using a customizer callback
	     * var defaults = _.partialRight(_.assign, function(value, other) {
	     *   return _.isUndefined(value) ? other : value;
	     * });
	     *
	     * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var assign = createAssigner(function(object, source, customizer) {
	      return customizer
	        ? assignWith(object, source, customizer)
	        : baseAssign(object, source);
	    });

	    /**
	     * Creates an object that inherits from the given `prototype` object. If a
	     * `properties` object is provided its own enumerable properties are assigned
	     * to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties, guard) {
	      var result = baseCreate(prototype);
	      if (guard && isIterateeCall(prototype, properties, guard)) {
	        properties = undefined;
	      }
	      return properties ? baseAssign(result, properties) : result;
	    }

	    /**
	     * Assigns own enumerable properties of source object(s) to the destination
	     * object for all destination properties that resolve to `undefined`. Once a
	     * property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var defaults = createDefaults(assign, assignDefaults);

	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
	     * // => { 'user': { 'name': 'barney', 'age': 36 } }
	     *
	     */
	    var defaultsDeep = createDefaults(merge, mergeDefaults);

	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(chr) {
	     *   return chr.age < 40;
	     * });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findKey(users, 'active', false);
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    var findKey = createFindKey(baseForOwn);

	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(chr) {
	     *   return chr.age < 40;
	     * });
	     * // => returns `pebbles` assuming `_.findKey` returns `barney`
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findLastKey(users, 'active', false);
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    var findLastKey = createFindKey(baseForOwnRight);

	    /**
	     * Iterates over own and inherited enumerable properties of an object invoking
	     * `iteratee` for each property. The `iteratee` is bound to `thisArg` and invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a', 'b', and 'c' (iteration order is not guaranteed)
	     */
	    var forIn = createForIn(baseFor);

	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'c', 'b', and 'a' assuming `_.forIn ` logs 'a', 'b', and 'c'
	     */
	    var forInRight = createForIn(baseForRight);

	    /**
	     * Iterates over own enumerable properties of an object invoking `iteratee`
	     * for each property. The `iteratee` is bound to `thisArg` and invoked with
	     * three arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a' and 'b' (iteration order is not guaranteed)
	     */
	    var forOwn = createForOwn(baseForOwn);

	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'b' and 'a' assuming `_.forOwn` logs 'a' and 'b'
	     */
	    var forOwnRight = createForOwn(baseForOwnRight);

	    /**
	     * Creates an array of function property names from all enumerable properties,
	     * own and inherited, of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @alias methods
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the new array of property names.
	     * @example
	     *
	     * _.functions(_);
	     * // => ['after', 'ary', 'assign', ...]
	     */
	    function functions(object) {
	      return baseFunctions(object, keysIn(object));
	    }

	    /**
	     * Gets the property value at `path` of `object`. If the resolved value is
	     * `undefined` the `defaultValue` is used in its place.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, toPath(path), path + '');
	      return result === undefined ? defaultValue : result;
	    }

	    /**
	     * Checks if `path` is a direct property.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` is a direct property, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': { 'c': 3 } } };
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b.c');
	     * // => true
	     *
	     * _.has(object, ['a', 'b', 'c']);
	     * // => true
	     */
	    function has(object, path) {
	      if (object == null) {
	        return false;
	      }
	      var result = hasOwnProperty.call(object, path);
	      if (!result && !isKey(path)) {
	        path = toPath(path);
	        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	        if (object == null) {
	          return false;
	        }
	        path = last(path);
	        result = hasOwnProperty.call(object, path);
	      }
	      return result || (isLength(object.length) && isIndex(path, object.length) &&
	        (isArray(object) || isArguments(object)));
	    }

	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite property
	     * assignments of previous values unless `multiValue` is `true`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {boolean} [multiValue] Allow multiple values per key.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     *
	     * // with `multiValue`
	     * _.invert(object, true);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function invert(object, multiValue, guard) {
	      if (guard && isIterateeCall(object, multiValue, guard)) {
	        multiValue = undefined;
	      }
	      var index = -1,
	          props = keys(object),
	          length = props.length,
	          result = {};

	      while (++index < length) {
	        var key = props[index],
	            value = object[key];

	        if (multiValue) {
	          if (hasOwnProperty.call(result, value)) {
	            result[value].push(key);
	          } else {
	            result[value] = [key];
	          }
	        }
	        else {
	          result[value] = key;
	        }
	      }
	      return result;
	    }

	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    var keys = !nativeKeys ? shimKeys : function(object) {
	      var Ctor = object == null ? undefined : object.constructor;
	      if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	          (typeof object != 'function' && isArrayLike(object))) {
	        return shimKeys(object);
	      }
	      return isObject(object) ? nativeKeys(object) : [];
	    };

	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      if (object == null) {
	        return [];
	      }
	      if (!isObject(object)) {
	        object = Object(object);
	      }
	      var length = object.length;
	      length = (length && isLength(length) &&
	        (isArray(object) || isArguments(object)) && length) || 0;

	      var Ctor = object.constructor,
	          index = -1,
	          isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	          result = Array(length),
	          skipIndexes = length > 0;

	      while (++index < length) {
	        result[index] = (index + '');
	      }
	      for (var key in object) {
	        if (!(skipIndexes && isIndex(key, length)) &&
	            !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }

	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * property of `object` through `iteratee`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    var mapKeys = createObjectMapper(true);

	    /**
	     * Creates an object with the same keys as `object` and values generated by
	     * running each own enumerable property of `object` through `iteratee`. The
	     * iteratee function is bound to `thisArg` and invoked with three arguments:
	     * (value, key, object).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * _.mapValues({ 'a': 1, 'b': 2 }, function(n) {
	     *   return n * 3;
	     * });
	     * // => { 'a': 3, 'b': 6 }
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * // using the `_.property` callback shorthand
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    var mapValues = createObjectMapper();

	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable properties of `object` that are not omitted.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|...(string|string[])} [predicate] The function invoked per
	     *  iteration or property names to omit, specified as individual property
	     *  names or arrays of property names.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.omit(object, 'age');
	     * // => { 'user': 'fred' }
	     *
	     * _.omit(object, _.isNumber);
	     * // => { 'user': 'fred' }
	     */
	    var omit = restParam(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      if (typeof props[0] != 'function') {
	        var props = arrayMap(baseFlatten(props), String);
	        return pickByArray(object, baseDifference(keysIn(object), props));
	      }
	      var predicate = bindCallback(props[0], props[1], 3);
	      return pickByCallback(object, function(value, key, object) {
	        return !predicate(value, key, object);
	      });
	    });

	    /**
	     * Creates a two dimensional array of the key-value pairs for `object`,
	     * e.g. `[[key1, value1], [key2, value2]]`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the new array of key-value pairs.
	     * @example
	     *
	     * _.pairs({ 'barney': 36, 'fred': 40 });
	     * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
	     */
	    function pairs(object) {
	      object = toObject(object);

	      var index = -1,
	          props = keys(object),
	          length = props.length,
	          result = Array(length);

	      while (++index < length) {
	        var key = props[index];
	        result[index] = [key, object[key]];
	      }
	      return result;
	    }

	    /**
	     * Creates an object composed of the picked `object` properties. Property
	     * names may be specified as individual arguments or as arrays of property
	     * names. If `predicate` is provided it is invoked for each property of `object`
	     * picking the properties `predicate` returns truthy for. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|...(string|string[])} [predicate] The function invoked per
	     *  iteration or property names to pick, specified as individual property
	     *  names or arrays of property names.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.pick(object, 'user');
	     * // => { 'user': 'fred' }
	     *
	     * _.pick(object, _.isString);
	     * // => { 'user': 'fred' }
	     */
	    var pick = restParam(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      return typeof props[0] == 'function'
	        ? pickByCallback(object, bindCallback(props[0], props[1], 3))
	        : pickByArray(object, baseFlatten(props));
	    });

	    /**
	     * This method is like `_.get` except that if the resolved value is a function
	     * it is invoked with the `this` binding of its parent object and its result
	     * is returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a.b.c', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a.b.c', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      var result = object == null ? undefined : object[path];
	      if (result === undefined) {
	        if (object != null && !isKey(path, object)) {
	          path = toPath(path);
	          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	          result = object == null ? undefined : object[last(path)];
	        }
	        result = result === undefined ? defaultValue : result;
	      }
	      return isFunction(result) ? result.call(object) : result;
	    }

	    /**
	     * Sets the property value of `path` on `object`. If a portion of `path`
	     * does not exist it is created.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to augment.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, 'x[0].y.z', 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      if (object == null) {
	        return object;
	      }
	      var pathKey = (path + '');
	      path = (object[pathKey] != null || isKey(path, object)) ? [pathKey] : toPath(path);

	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;

	      while (nested != null && ++index < length) {
	        var key = path[index];
	        if (isObject(nested)) {
	          if (index == lastIndex) {
	            nested[key] = value;
	          } else if (nested[key] == null) {
	            nested[key] = isIndex(path[index + 1]) ? [] : {};
	          }
	        }
	        nested = nested[key];
	      }
	      return object;
	    }

	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own enumerable
	     * properties through `iteratee`, with each invocation potentially mutating
	     * the `accumulator` object. The `iteratee` is bound to `thisArg` and invoked
	     * with four arguments: (accumulator, value, key, object). Iteratee functions
	     * may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Array|Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * });
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2 }, function(result, n, key) {
	     *   result[key] = n * 3;
	     * });
	     * // => { 'a': 3, 'b': 6 }
	     */
	    function transform(object, iteratee, accumulator, thisArg) {
	      var isArr = isArray(object) || isTypedArray(object);
	      iteratee = getCallback(iteratee, thisArg, 4);

	      if (accumulator == null) {
	        if (isArr || isObject(object)) {
	          var Ctor = object.constructor;
	          if (isArr) {
	            accumulator = isArray(object) ? new Ctor : [];
	          } else {
	            accumulator = baseCreate(isFunction(Ctor) ? Ctor.prototype : undefined);
	          }
	        } else {
	          accumulator = {};
	        }
	      }
	      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }

	    /**
	     * Creates an array of the own enumerable property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return baseValues(object, keys(object));
	    }

	    /**
	     * Creates an array of the own and inherited enumerable property values
	     * of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return baseValues(object, keysIn(object));
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Checks if `n` is between `start` and up to but not including, `end`. If
	     * `end` is not specified it is set to `start` with `start` then set to `0`.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} n The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `n` is in the range, else `false`.
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     */
	    function inRange(value, start, end) {
	      start = +start || 0;
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = +end || 0;
	      }
	      return value >= nativeMin(start, end) && value < nativeMax(start, end);
	    }

	    /**
	     * Produces a random number between `min` and `max` (inclusive). If only one
	     * argument is provided a number between `0` and the given number is returned.
	     * If `floating` is `true`, or either `min` or `max` are floats, a floating-point
	     * number is returned instead of an integer.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} [min=0] The minimum possible value.
	     * @param {number} [max=1] The maximum possible value.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(min, max, floating) {
	      if (floating && isIterateeCall(min, max, floating)) {
	        max = floating = undefined;
	      }
	      var noMin = min == null,
	          noMax = max == null;

	      if (floating == null) {
	        if (noMax && typeof min == 'boolean') {
	          floating = min;
	          min = 1;
	        }
	        else if (typeof max == 'boolean') {
	          floating = max;
	          noMax = true;
	        }
	      }
	      if (noMin && noMax) {
	        max = 1;
	        noMax = false;
	      }
	      min = +min || 0;
	      if (noMax) {
	        max = min;
	        min = 0;
	      } else {
	        max = +max || 0;
	      }
	      if (floating || min % 1 || max % 1) {
	        var rand = nativeRandom();
	        return nativeMin(min + (rand * (max - min + parseFloat('1e-' + ((rand + '').length - 1)))), max);
	      }
	      return baseRandom(min, max);
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__foo_bar__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? (word.charAt(0).toUpperCase() + word.slice(1)) : word);
	    });

	    /**
	     * Capitalizes the first character of `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('fred');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      string = baseToString(string);
	      return string && (string.charAt(0).toUpperCase() + string.slice(1));
	    }

	    /**
	     * Deburrs `string` by converting [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * to basic latin letters and removing [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = baseToString(string);
	      return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
	    }

	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search from.
	     * @returns {boolean} Returns `true` if `string` ends with `target`, else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = baseToString(string);
	      target = (target + '');

	      var length = string.length;
	      position = position === undefined
	        ? length
	        : nativeMin(position < 0 ? 0 : (+position || 0), length);

	      position -= target.length;
	      return position >= 0 && string.indexOf(target, position) == position;
	    }

	    /**
	     * Converts the characters "&", "<", ">", '"', "'", and "\`", in `string` to
	     * their corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional characters
	     * use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value.
	     * See [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * Backticks are escaped because in Internet Explorer < 9, they can break out
	     * of attribute values or HTML comments. See [#59](https://html5sec.org/#59),
	     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
	     * [#133](https://html5sec.org/#133) of the [HTML5 Security Cheatsheet](https://html5sec.org/)
	     * for more details.
	     *
	     * When working with HTML you should always [quote attribute values](http://wonko.com/post/html-escaping)
	     * to reduce XSS vectors.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      // Reset `lastIndex` because in IE < 9 `String#replace` does not.
	      string = baseToString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }

	    /**
	     * Escapes the `RegExp` special characters "\", "/", "^", "$", ".", "|", "?",
	     * "*", "+", "(", ")", "[", "]", "{" and "}" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https:\/\/lodash\.com\/\)'
	     */
	    function escapeRegExp(string) {
	      string = baseToString(string);
	      return (string && reHasRegExpChars.test(string))
	        ? string.replace(reRegExpChars, escapeRegExpChar)
	        : (string || '(?:)');
	    }

	    /**
	     * Converts `string` to [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__foo_bar__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });

	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = baseToString(string);
	      length = +length;

	      var strLength = string.length;
	      if (strLength >= length || !nativeIsFinite(length)) {
	        return string;
	      }
	      var mid = (length - strLength) / 2,
	          leftLength = nativeFloor(mid),
	          rightLength = nativeCeil(mid);

	      chars = createPadding('', rightLength, chars);
	      return chars.slice(0, leftLength) + string + chars;
	    }

	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padLeft('abc', 6);
	     * // => '   abc'
	     *
	     * _.padLeft('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padLeft('abc', 3);
	     * // => 'abc'
	     */
	    var padLeft = createPadDir();

	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padRight('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padRight('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padRight('abc', 3);
	     * // => 'abc'
	     */
	    var padRight = createPadDir(true);

	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a hexadecimal,
	     * in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the [ES5 implementation](https://es5.github.io/#E)
	     * of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      // Firefox < 21 and Opera < 15 follow ES3 for `parseInt`.
	      // Chrome fails to trim leading <BOM> whitespace characters.
	      // See https://code.google.com/p/v8/issues/detail?id=3109 for more details.
	      if (guard ? isIterateeCall(string, radix, guard) : radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      string = trim(string);
	      return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
	    }

	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=0] The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n) {
	      var result = '';
	      string = baseToString(string);
	      n = +n;
	      if (n < 1 || !string || !nativeIsFinite(n)) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        string += string;
	      } while (n);

	      return result;
	    }

	    /**
	     * Converts `string` to [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--foo-bar');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });

	    /**
	     * Converts `string` to [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__foo_bar__');
	     * // => 'Foo Bar'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + (word.charAt(0).toUpperCase() + word.slice(1));
	    });

	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`, else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = baseToString(string);
	      position = position == null
	        ? 0
	        : nativeMin(position < 0 ? 0 : (+position || 0), string.length);

	      return string.lastIndexOf(target, position) == position;
	    }

	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is provided it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options] The options object.
	     * @param {RegExp} [options.escape] The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
	     * @param {Object} [options.imports] An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
	     * @param {string} [options.sourceURL] The sourceURL of the template's compiled source.
	     * @param {string} [options.variable] The data object variable name.
	     * @param- {Object} [otherOptions] Enables the legacy `options` param signature.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // using the "interpolate" delimiter to create a compiled template
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // using the HTML "escape" delimiter to escape data property values
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // using the "evaluate" delimiter to execute JavaScript and generate HTML
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // using the internal `print` function in "evaluate" delimiters
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // using the ES delimiter as an alternative to the default "interpolate" delimiter
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // using custom template delimiters
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // using backslashes to treat delimiters as plain text
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // using the `imports` option to import `jQuery` as `jq`
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // using the `sourceURL` option to specify a custom sourceURL for the template
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
	     *
	     * // using the `variable` option to ensure a with-statement isn't used in the compiled template
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // using the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and a stack trace
	     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, otherOptions) {
	      // Based on John Resig's `tmpl` implementation (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;

	      if (otherOptions && isIterateeCall(string, options, otherOptions)) {
	        options = otherOptions = undefined;
	      }
	      string = baseToString(string);
	      options = assignWith(baseAssign({}, otherOptions || options), settings, assignOwnDefaults);

	      var imports = assignWith(baseAssign({}, options.imports), settings.imports, assignOwnDefaults),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);

	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";

	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');

	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';

	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);

	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;

	        // The JS engine embedded in Adobe products requires returning the `match`
	        // string in order to produce the correct `offset` value.
	        return match;
	      });

	      source += "';\n";

	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');

	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';

	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
	      });

	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }

	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(trimmedLeftIndex(string), trimmedRightIndex(string) + 1);
	      }
	      chars = (chars + '');
	      return string.slice(charsLeftIndex(string, chars), charsRightIndex(string, chars) + 1);
	    }

	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimLeft('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimLeft('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimLeft(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(trimmedLeftIndex(string));
	      }
	      return string.slice(charsLeftIndex(string, (chars + '')));
	    }

	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimRight('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimRight('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimRight(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(0, trimmedRightIndex(string) + 1);
	      }
	      return string.slice(0, charsRightIndex(string, (chars + '')) + 1);
	    }

	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object|number} [options] The options object or maximum string length.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.trunc('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', 24);
	     * // => 'hi-diddly-ho there, n...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function trunc(string, options, guard) {
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;

	      if (options != null) {
	        if (isObject(options)) {
	          var separator = 'separator' in options ? options.separator : separator;
	          length = 'length' in options ? (+options.length || 0) : length;
	          omission = 'omission' in options ? baseToString(options.omission) : omission;
	        } else {
	          length = +options || 0;
	        }
	      }
	      string = baseToString(string);
	      if (length >= string.length) {
	        return string;
	      }
	      var end = length - omission.length;
	      if (end < 1) {
	        return omission;
	      }
	      var result = string.slice(0, end);
	      if (separator == null) {
	        return result + omission;
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              newEnd,
	              substring = string.slice(0, end);

	          if (!separator.global) {
	            separator = RegExp(separator.source, (reFlags.exec(separator) || '') + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            newEnd = match.index;
	          }
	          result = result.slice(0, newEnd == null ? end : newEnd);
	        }
	      } else if (string.indexOf(separator, end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }

	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to their
	     * corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional HTML
	     * entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = baseToString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }

	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      if (guard && isIterateeCall(string, pattern, guard)) {
	        pattern = undefined;
	      }
	      string = baseToString(string);
	      return string.match(pattern || reWords) || [];
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Function} func The function to attempt.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // avoid throwing errors for invalid selectors
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = restParam(function(func, args) {
	      try {
	        return func.apply(undefined, args);
	      } catch(e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });

	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and arguments of the created function. If `func` is a property name the
	     * created callback returns the property value for a given element. If `func`
	     * is an object the created callback returns `true` for elements that contain
	     * the equivalent object properties, otherwise it returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias iteratee
	     * @category Utility
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // wrap to create custom callback shorthands
	     * _.callback = _.wrap(_.callback, function(callback, func, thisArg) {
	     *   var match = /^(.+?)__([gl]t)(.+)$/.exec(func);
	     *   if (!match) {
	     *     return callback(func, thisArg);
	     *   }
	     *   return function(object) {
	     *     return match[2] == 'gt'
	     *       ? object[match[1]] > match[3]
	     *       : object[match[1]] < match[3];
	     *   };
	     * });
	     *
	     * _.filter(users, 'age__gt36');
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     */
	    function callback(func, thisArg, guard) {
	      if (guard && isIterateeCall(func, thisArg, guard)) {
	        thisArg = undefined;
	      }
	      return isObjectLike(func)
	        ? matches(func)
	        : baseCallback(func, thisArg);
	    }

	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var getter = _.constant(object);
	     *
	     * getter() === object;
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }

	    /**
	     * This method returns the first argument provided to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.identity(object) === object;
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }

	    /**
	     * Creates a function that performs a deep comparison between a given object
	     * and `source`, returning `true` if the given object has equivalent property
	     * values, else `false`.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
	     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, true));
	    }

	    /**
	     * Creates a function that compares the property value of `path` on a given
	     * object to `value`.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * _.find(users, _.matchesProperty('user', 'fred'));
	     * // => { 'user': 'fred' }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, true));
	    }

	    /**
	     * Creates a function that invokes the method at `path` on a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': _.constant(2) } } },
	     *   { 'a': { 'b': { 'c': _.constant(1) } } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.invoke(_.sortBy(objects, _.method(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    var method = restParam(function(path, args) {
	      return function(object) {
	        return invokePath(object, path, args);
	      };
	    });

	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path on `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = restParam(function(object, args) {
	      return function(path) {
	        return invokePath(object, path, args);
	      };
	    });

	    /**
	     * Adds all own enumerable function properties of a source object to the
	     * destination object. If `object` is a function then methods are added to
	     * its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.chain=true] Specify whether the functions added
	     *  are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      if (options == null) {
	        var isObj = isObject(source),
	            props = isObj ? keys(source) : undefined,
	            methodNames = (props && props.length) ? baseFunctions(source, props) : undefined;

	        if (!(methodNames ? methodNames.length : isObj)) {
	          methodNames = false;
	          options = source;
	          source = object;
	          object = this;
	        }
	      }
	      if (!methodNames) {
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = true,
	          index = -1,
	          isFunc = isFunction(object),
	          length = methodNames.length;

	      if (options === false) {
	        chain = false;
	      } else if (isObject(options) && 'chain' in options) {
	        chain = options.chain;
	      }
	      while (++index < length) {
	        var methodName = methodNames[index],
	            func = source[methodName];

	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = (function(func) {
	            return function() {
	              var chainAll = this.__chain__;
	              if (chain || chainAll) {
	                var result = object(this.__wrapped__),
	                    actions = result.__actions__ = arrayCopy(this.__actions__);

	                actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	                result.__chain__ = chainAll;
	                return result;
	              }
	              return func.apply(object, arrayPush([this.value()], arguments));
	            };
	          }(func));
	        }
	      }
	      return object;
	    }

	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      root._ = oldDash;
	      return this;
	    }

	    /**
	     * A no-operation function that returns `undefined` regardless of the
	     * arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.noop(object) === undefined;
	     * // => true
	     */
	    function noop() {
	      // No operation performed.
	    }

	    /**
	     * Creates a function that returns the property value at `path` on a
	     * given object.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': 2 } } },
	     *   { 'a': { 'b': { 'c': 1 } } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
	    }

	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the property value at a given path on `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return baseGet(object, toPath(path), path + '');
	      };
	    }

	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. If `end` is not specified it is
	     * set to `start` with `start` then set to `0`. If `end` is less than `start`
	     * a zero-length range is created unless a negative `step` is specified.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the new array of numbers.
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    function range(start, end, step) {
	      if (step && isIterateeCall(start, end, step)) {
	        end = step = undefined;
	      }
	      start = +start || 0;
	      step = step == null ? 1 : (+step || 0);

	      if (end == null) {
	        end = start;
	        start = 0;
	      } else {
	        end = +end || 0;
	      }
	      // Use `Array(length)` so engines like Chakra and V8 avoid slower modes.
	      // See https://youtu.be/XAqIpGU8ZZk#t=17m25s for more details.
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);

	      while (++index < length) {
	        result[index] = start;
	        start += step;
	      }
	      return result;
	    }

	    /**
	     * Invokes the iteratee function `n` times, returning an array of the results
	     * of each invocation. The `iteratee` is bound to `thisArg` and invoked with
	     * one argument; (index).
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * var diceRolls = _.times(3, _.partial(_.random, 1, 6, false));
	     * // => [3, 6, 4]
	     *
	     * _.times(3, function(n) {
	     *   mage.castSpell(n);
	     * });
	     * // => invokes `mage.castSpell(n)` three times with `n` of `0`, `1`, and `2`
	     *
	     * _.times(3, function(n) {
	     *   this.cast(n);
	     * }, mage);
	     * // => also invokes `mage.castSpell(n)` three times
	     */
	    function times(n, iteratee, thisArg) {
	      n = nativeFloor(n);

	      // Exit early to avoid a JSC JIT bug in Safari 8
	      // where `Array(0)` is treated as `Array(1)`.
	      if (n < 1 || !nativeIsFinite(n)) {
	        return [];
	      }
	      var index = -1,
	          result = Array(nativeMin(n, MAX_ARRAY_LENGTH));

	      iteratee = bindCallback(iteratee, thisArg, 1);
	      while (++index < n) {
	        if (index < MAX_ARRAY_LENGTH) {
	          result[index] = iteratee(index);
	        } else {
	          iteratee(index);
	        }
	      }
	      return result;
	    }

	    /**
	     * Generates a unique ID. If `prefix` is provided the ID is appended to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {string} [prefix] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return baseToString(prefix) + id;
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} augend The first number to add.
	     * @param {number} addend The second number to add.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    function add(augend, addend) {
	      return (+augend || 0) + (+addend || 0);
	    }

	    /**
	     * Calculates `n` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');

	    /**
	     * Calculates `n` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');

	    /**
	     * Gets the maximum value of `collection`. If `collection` is empty or falsey
	     * `-Infinity` is returned. If an iteratee function is provided it is invoked
	     * for each value in `collection` to generate the criterion by which the value
	     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => -Infinity
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.max(users, function(chr) {
	     *   return chr.age;
	     * });
	     * // => { 'user': 'fred', 'age': 40 }
	     *
	     * // using the `_.property` callback shorthand
	     * _.max(users, 'age');
	     * // => { 'user': 'fred', 'age': 40 }
	     */
	    var max = createExtremum(gt, NEGATIVE_INFINITY);

	    /**
	     * Gets the minimum value of `collection`. If `collection` is empty or falsey
	     * `Infinity` is returned. If an iteratee function is provided it is invoked
	     * for each value in `collection` to generate the criterion by which the value
	     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => Infinity
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.min(users, function(chr) {
	     *   return chr.age;
	     * });
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // using the `_.property` callback shorthand
	     * _.min(users, 'age');
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var min = createExtremum(lt, POSITIVE_INFINITY);

	    /**
	     * Calculates `n` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');

	    /**
	     * Gets the sum of the values in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 6]);
	     * // => 10
	     *
	     * _.sum({ 'a': 4, 'b': 6 });
	     * // => 10
	     *
	     * var objects = [
	     *   { 'n': 4 },
	     *   { 'n': 6 }
	     * ];
	     *
	     * _.sum(objects, function(object) {
	     *   return object.n;
	     * });
	     * // => 10
	     *
	     * // using the `_.property` callback shorthand
	     * _.sum(objects, 'n');
	     * // => 10
	     */
	    function sum(collection, iteratee, thisArg) {
	      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	        iteratee = undefined;
	      }
	      iteratee = getCallback(iteratee, thisArg, 3);
	      return iteratee.length == 1
	        ? arraySum(isArray(collection) ? collection : toIterable(collection), iteratee)
	        : baseSum(collection, iteratee);
	    }

	    /*------------------------------------------------------------------------*/

	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;

	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;

	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;

	    // Add functions to the `Map` cache.
	    MapCache.prototype['delete'] = mapDelete;
	    MapCache.prototype.get = mapGet;
	    MapCache.prototype.has = mapHas;
	    MapCache.prototype.set = mapSet;

	    // Add functions to the `Set` cache.
	    SetCache.prototype.push = cachePush;

	    // Assign cache to `_.memoize`.
	    memoize.Cache = MapCache;

	    // Add functions that return wrapped values when chaining.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.callback = callback;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.functions = functions;
	    lodash.groupBy = groupBy;
	    lodash.indexBy = indexBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.invert = invert;
	    lodash.invoke = invoke;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.modArgs = modArgs;
	    lodash.negate = negate;
	    lodash.omit = omit;
	    lodash.once = once;
	    lodash.pairs = pairs;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pluck = pluck;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.restParam = restParam;
	    lodash.set = set;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortByAll = sortByAll;
	    lodash.sortByOrder = sortByOrder;
	    lodash.spread = spread;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.times = times;
	    lodash.toArray = toArray;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.union = union;
	    lodash.uniq = uniq;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.where = where;
	    lodash.without = without;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipWith = zipWith;

	    // Add aliases.
	    lodash.backflow = flowRight;
	    lodash.collect = map;
	    lodash.compose = flowRight;
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.extend = assign;
	    lodash.iteratee = callback;
	    lodash.methods = functions;
	    lodash.object = zipObject;
	    lodash.select = filter;
	    lodash.tail = rest;
	    lodash.unique = uniq;

	    // Add functions to `lodash.prototype`.
	    mixin(lodash, lodash);

	    /*------------------------------------------------------------------------*/

	    // Add functions that return unwrapped values when chaining.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.deburr = deburr;
	    lodash.endsWith = endsWith;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.findWhere = findWhere;
	    lodash.first = first;
	    lodash.floor = floor;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isBoolean = isBoolean;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isMatch = isMatch;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isString = isString;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.min = min;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padLeft = padLeft;
	    lodash.padRight = padRight;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.sum = sum;
	    lodash.template = template;
	    lodash.trim = trim;
	    lodash.trimLeft = trimLeft;
	    lodash.trimRight = trimRight;
	    lodash.trunc = trunc;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.words = words;

	    // Add aliases.
	    lodash.all = every;
	    lodash.any = some;
	    lodash.contains = includes;
	    lodash.eq = isEqual;
	    lodash.detect = find;
	    lodash.foldl = reduce;
	    lodash.foldr = reduceRight;
	    lodash.head = first;
	    lodash.include = includes;
	    lodash.inject = reduce;

	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!lodash.prototype[methodName]) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), false);

	    /*------------------------------------------------------------------------*/

	    // Add functions capable of returning wrapped and unwrapped values when chaining.
	    lodash.sample = sample;

	    lodash.prototype.sample = function(n) {
	      if (!this.__chain__ && n == null) {
	        return sample(this.value());
	      }
	      return this.thru(function(value) {
	        return sample(value, n);
	      });
	    };

	    /*------------------------------------------------------------------------*/

	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type string
	     */
	    lodash.VERSION = VERSION;

	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });

	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        var filtered = this.__filtered__;
	        if (filtered && !index) {
	          return new LazyWrapper(this);
	        }
	        n = n == null ? 1 : nativeMax(nativeFloor(n) || 0, 0);

	        var result = this.clone();
	        if (filtered) {
	          result.__takeCount__ = nativeMin(result.__takeCount__, n);
	        } else {
	          result.__views__.push({ 'size': n, 'type': methodName + (result.__dir__ < 0 ? 'Right' : '') });
	        }
	        return result;
	      };

	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });

	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type != LAZY_MAP_FLAG;

	      LazyWrapper.prototype[methodName] = function(iteratee, thisArg) {
	        var result = this.clone();
	        result.__iteratees__.push({ 'iteratee': getCallback(iteratee, thisArg, 1), 'type': type });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });

	    // Add `LazyWrapper` methods for `_.first` and `_.last`.
	    arrayEach(['first', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');

	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });

	    // Add `LazyWrapper` methods for `_.initial` and `_.rest`.
	    arrayEach(['initial', 'rest'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');

	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });

	    // Add `LazyWrapper` methods for `_.pluck` and `_.where`.
	    arrayEach(['pluck', 'where'], function(methodName, index) {
	      var operationName = index ? 'filter' : 'map',
	          createCallback = index ? baseMatches : property;

	      LazyWrapper.prototype[methodName] = function(value) {
	        return this[operationName](createCallback(value));
	      };
	    });

	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };

	    LazyWrapper.prototype.reject = function(predicate, thisArg) {
	      predicate = getCallback(predicate, thisArg, 1);
	      return this.filter(function(value) {
	        return !predicate(value);
	      });
	    };

	    LazyWrapper.prototype.slice = function(start, end) {
	      start = start == null ? 0 : (+start || 0);

	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = (+end || 0);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };

	    LazyWrapper.prototype.takeRightWhile = function(predicate, thisArg) {
	      return this.reverse().takeWhile(predicate, thisArg).reverse();
	    };

	    LazyWrapper.prototype.toArray = function() {
	      return this.take(POSITIVE_INFINITY);
	    };

	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|map|reject)|While$/.test(methodName),
	          retUnwrapped = /^(?:first|last)$/.test(methodName),
	          lodashFunc = lodash[retUnwrapped ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName];

	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var args = retUnwrapped ? [1] : arguments,
	            chainAll = this.__chain__,
	            value = this.__wrapped__,
	            isHybrid = !!this.__actions__.length,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);

	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var interceptor = function(value) {
	          return (retUnwrapped && chainAll)
	            ? lodashFunc(value, 1)[0]
	            : lodashFunc.apply(undefined, arrayPush([value], args));
	        };

	        var action = { 'func': thru, 'args': [interceptor], 'thisArg': undefined },
	            onlyLazy = isLazy && !isHybrid;

	        if (retUnwrapped && !chainAll) {
	          if (onlyLazy) {
	            value = value.clone();
	            value.__actions__.push(action);
	            return func.call(value);
	          }
	          return lodashFunc.call(undefined, this.value())[0];
	        }
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push(action);
	          return new LodashWrapper(result, chainAll);
	        }
	        return this.thru(interceptor);
	      };
	    });

	    // Add `Array` and `String` methods to `lodash.prototype`.
	    arrayEach(['join', 'pop', 'push', 'replace', 'shift', 'sort', 'splice', 'split', 'unshift'], function(methodName) {
	      var func = (/^(?:replace|split)$/.test(methodName) ? stringProto : arrayProto)[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:join|pop|replace|shift)$/.test(methodName);

	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          return func.apply(this.value(), args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(value, args);
	        });
	      };
	    });

	    // Map minified function names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name,
	            names = realNames[key] || (realNames[key] = []);

	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });

	    realNames[createHybridWrapper(undefined, BIND_KEY_FLAG).name] = [{ 'name': 'wrapper', 'func': undefined }];

	    // Add functions to the lazy wrapper.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;

	    // Add chaining functions to the `lodash` wrapper.
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.concat = wrapperConcat;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toString = wrapperToString;
	    lodash.prototype.run = lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

	    // Add function aliases to the `lodash` wrapper.
	    lodash.prototype.collect = lodash.prototype.map;
	    lodash.prototype.head = lodash.prototype.first;
	    lodash.prototype.select = lodash.prototype.filter;
	    lodash.prototype.tail = lodash.prototype.rest;

	    return lodash;
	  }

	  /*--------------------------------------------------------------------------*/

	  // Export lodash.
	  var _ = runInContext();

	  // Some AMD build optimizers like r.js check for condition patterns like the following:
	  if (true) {
	    // Expose lodash to the global object when an AMD loader is present to avoid
	    // errors in cases where lodash is loaded by a script tag and not intended
	    // as an AMD module. See http://requirejs.org/docs/errors.html#mismatch for
	    // more details.
	    root._ = _;

	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
	  else if (freeExports && freeModule) {
	    // Export for Node.js or RingoJS.
	    if (moduleExports) {
	      (freeModule.exports = _)._ = _;
	    }
	    // Export for Rhino with CommonJS support.
	    else {
	      freeExports._ = _;
	    }
	  }
	  else {
	    // Export for a browser or Rhino.
	    root._ = _;
	  }
	}.call(this));

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)(module), (function() { return this; }())))

/***/ }),
/* 28 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 29 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var FlagModal = function FlagModal($uibModal) {
	  $uibModal.open({
	    templateUrl: 'app/flag/flag.html',
	    controller: 'FlagController',
	    controllerAs: 'vm'
	  });
	};

	exports.default = FlagModal;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _classCallCheck2 = __webpack_require__(6);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(7);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _lodash = __webpack_require__(27);

	var _lodash2 = _interopRequireDefault(_lodash);

	var _annotationsService = __webpack_require__(31);

	var _annotationsService2 = _interopRequireDefault(_annotationsService);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/* global $, window, document */

	var AnnotationsController = function () {
	  function AnnotationsController($scope, urlService, $location, itemService, $timeout, abilityService, AnnotationsUploader, config, hotkeys, analyticsService, storageService) {
	    'ngInject';

	    var _this = this;

	    (0, _classCallCheck3.default)(this, AnnotationsController);
	    this.redirect = function (path) {
	      $location.path(path);
	      $location.replace();
	      $(window).off('message', this.finishUpload);
	    };

	    this._urlService = urlService;
	    this.uploader = AnnotationsUploader;
	    this._$scope = $scope;
	    this.$timeout = $timeout;
	    this.item = itemService;
	    this._ability = abilityService;
	    this._analytics = analyticsService;
	    this._storage = storageService;
	    abilityService.inject($scope);
	    $scope.item = itemService;
	    this.getItem();

	    $scope.$watch("item.data.annotation_source_url", function (url) {
	      if (url) {
	        _this.annotate(url);
	      }
	    });
	    this.finishUpload = this.finishUpload.bind(this);
	    $scope.uploadFrameUrl = config.schema + "://s3.amazonaws.com/" + config.s3bucket + "/annotations/annotations.html";

	    if (!$scope.annoationsSet) {
	      $scope.annotationsSet = true;
	      $(window).on('message', this.finishUpload);
	    }

	    this.setUpHotkeys(hotkeys.bindTo($scope), itemService);
	  }

	  (0, _createClass3.default)(AnnotationsController, [{
	    key: 'finishUpload',
	    value: function finishUpload(event) {
	      if (event.originalEvent.origin.match(/amazon/)) {
	        this.item.annotations.uploader.onMessage(event.originalEvent);
	      }
	    }
	  }, {
	    key: 'setUpHotkeys',
	    value: function setUpHotkeys(hotkeys, itemService) {
	      function command(name) {
	        try {
	          return itemService.annotations.drawing.commands[name];
	        } catch (e) {
	          return _lodash2.default.noop;
	        }
	      }

	      hotkeys.add({
	        combo: ['del', 'backspace'], description: 'Delete element',
	        callback: function callback(event) {
	          event.preventDefault();
	          if (command('canRemove')()) {
	            command('removeActive')();
	          }
	        }
	      });

	      hotkeys.add({
	        combo: 'a', description: 'Arrow tool',
	        callback: function callback() {
	          command('addArrow')();
	        }
	      });

	      hotkeys.add({
	        combo: 'c', description: 'Circle tool',
	        callback: function callback() {
	          command('addCircle')();
	        }
	      });

	      hotkeys.add({
	        combo: 'f', description: 'Free draw tool',
	        callback: function callback() {
	          command('freeDraw')();
	        }
	      });

	      hotkeys.add({
	        combo: 'r', description: 'Rectangle tool',
	        callback: function callback() {
	          command('addRectangle')();
	        }
	      });

	      hotkeys.add({
	        combo: 't', description: 'Type tool',
	        callback: function callback(e) {
	          e.preventDefault();
	          command('addText')();
	        }
	      });

	      hotkeys.add({
	        combo: ['command+s', 'ctrl+s'], description: 'Save',
	        callback: function callback(event) {
	          itemService.annotations.save();
	          event.preventDefault();
	        }
	      });

	      hotkeys.add({
	        combo: ['command+x', 'ctrl+x'], description: 'Cut',
	        callback: function callback(event) {
	          command('clipboardCut')();
	          event.preventDefault();
	        }
	      });

	      hotkeys.add({
	        combo: ['command+c', 'ctrl+c'], description: 'Copy',
	        callback: function callback() {
	          command('clipboardCopy')();
	        }
	      });

	      hotkeys.add({
	        combo: ['command+v', 'ctrl+v'], description: 'Paste',
	        callback: function callback(event) {
	          command('clipboardPaste')();
	          event.preventDefault();
	        }
	      });

	      hotkeys.add({
	        combo: ['command+z', 'ctrl+z'], description: 'Undo',
	        callback: function callback(event) {
	          if (command('canUndo')()) {
	            command('undo')();
	          }
	          event.preventDefault();
	        }
	      });

	      hotkeys.add({
	        combo: ['command+shift+z', 'ctrl+y'], description: 'Redo',
	        callback: function callback(event) {
	          if (command('canRedo')()) {
	            command('redo')();
	          }
	          event.preventDefault();
	        }
	      });

	      hotkeys.add({
	        combo: ['escape'], description: 'Dismiss current tool',
	        callback: function callback(event) {
	          command('normal')();
	          event.preventDefault();
	        }
	      });

	      var colors = ["Red", "Orange", "Green", "Blue", "White", "Black"];

	      var colorCallback = function colorCallback(i) {
	        return function () {
	          command('setColor')(colors[i].toLowerCase());
	        };
	      };

	      for (var i = 0; i < 6; i++) {
	        hotkeys.add({
	          description: colors[i],
	          combo: (i + 1).toString(), callback: colorCallback(i)
	        });
	      }
	    }
	  }, {
	    key: 'getItem',
	    value: function getItem() {
	      var _this2 = this;

	      var itemService = this.item;
	      var request = itemService.lazyGetItem();

	      if (!request) {
	        return;
	      }
	      request.then(function (response) {
	        if (!_lodash2.default.has(response, "status") || response.status === 200) {
	          itemService.getDetails().then(function (details) {
	            $('body').toggleClass('dark', _lodash2.default.get(details, "theme") === "dark");
	          });
	          return;
	        }

	        _this2.redirect("/" + itemService.slug());
	      });
	    }
	  }, {
	    key: 'annotate',
	    value: function annotate(url) {
	      var _this3 = this;

	      this._ability.canAsync('annotate').then(function () {
	        _this3.service = new _annotationsService2.default(url, _this3);
	        _this3.service.on('change', function () {
	          _this3.$timeout();
	        });
	        _this3._$scope.item.annotations = _this3.service;
	      }, function () {
	        _this3.redirect("/" + _this3.item.slug());
	      });
	    }
	  }, {
	    key: 'finish',
	    value: function finish(data) {
	      var url;
	      if (data) {
	        var parser = document.createElement('a');
	        parser.href = data.url;
	        url = parser.pathname;
	      } else {
	        url = this._urlService.item(this.item);
	      }
	      this.redirect(url);
	    }
	  }]);
	  return AnnotationsController;
	}();

	exports.default = AnnotationsController;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _classCallCheck2 = __webpack_require__(6);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(7);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _canvas = __webpack_require__(32);

	var _canvas2 = _interopRequireDefault(_canvas);

	var _imageLoader = __webpack_require__(96);

	var _imageLoader2 = _interopRequireDefault(_imageLoader);

	var _annotations = __webpack_require__(102);

	var _annotations2 = _interopRequireDefault(_annotations);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var AnnotationsService = function () {
	  function AnnotationsService(url, controller) {
	    var _this = this;

	    (0, _classCallCheck3.default)(this, AnnotationsService);

	    this._controller = controller;
	    this._analytics = controller._analytics;
	    this._storage = controller._storage;
	    this._item = controller.item;
	    this._callbacks = {};
	    this.url = url;
	    this.state = 'pending';
	    this.slug = this._item.slug();

	    this.loadImage().then(function (object) {
	      _this.drawing = new _canvas2.default(_this, object.image, {
	        canvasContainer: '#canvas',
	        sticky: true
	      });
	      _this.injectCommands();
	      _this.annotationsStorage = new _annotations2.default(_this.slug, _this.drawing, _this._storage);
	      if (_this.annotationsStorage.hasData()) {
	        _this.annotationsStorage.restoreChanges().then(function () {
	          return _this.save();
	        });
	      }
	    });
	    this.image = { progress: 0 };
	    this._analytics.track('Annotations started');
	  }

	  (0, _createClass3.default)(AnnotationsService, [{
	    key: 'injectCommands',
	    value: function injectCommands() {
	      this.commands = this.drawing.commands;
	    }
	  }, {
	    key: 'loadImage',
	    value: function loadImage() {
	      var context = this;
	      var url = this.url;

	      return (0, _imageLoader2.default)(url, {
	        load: function load() {
	          context.state = "ready";
	        },

	        progress: function progress(event) {
	          if (!event.lengthComputable) {
	            return;
	          }
	          context.image.progress = Math.round(event.loaded / event.total * 100);
	          context.emit('change');
	        }
	      });
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this2 = this;

	      if (!_.include(["ready", "failed"], this.state)) {
	        return;
	      }

	      this._analytics.track("Annotations save", { campaign_medium: 'button' });

	      this.state = "saving";
	      this.uploader = this._controller.uploader(this);

	      this.uploader.save(function (data) {
	        if (data) {
	          _this2.state = "saved";
	          _this2.finish(data);
	        } else {
	          _this2.state = "failed";
	        }
	      });
	    }
	  }, {
	    key: 'finish',
	    value: function finish(data) {
	      if (!data) {
	        this._analytics.track("Annotations cancel", { campaign_medium: 'button' });
	      }
	      this._controller.finish(data);
	    }
	  }, {
	    key: 'on',
	    value: function on(event, callback) {
	      this._callbacks[event] = _.union(this._callbacks[event], [callback]);
	    }
	  }, {
	    key: 'emit',
	    value: function emit() {
	      var _this3 = this;

	      var events = arguments;
	      _.each(events, function (event) {
	        _.each(_this3._callbacks[event], function (callback) {
	          callback(_this3);
	        });
	      });
	    }
	  }]);
	  return AnnotationsService;
	}(); /* global _ */

	exports.default = AnnotationsService;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _classCallCheck2 = __webpack_require__(6);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(7);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _command_provider = __webpack_require__(33);

	var _command_provider2 = _interopRequireDefault(_command_provider);

	var _lodash = __webpack_require__(27);

	var _lodash2 = _interopRequireDefault(_lodash);

	var _modified2 = __webpack_require__(34);

	var _modified3 = _interopRequireDefault(_modified2);

	var _rect2 = __webpack_require__(35);

	var _rect3 = _interopRequireDefault(_rect2);

	var _ellipse2 = __webpack_require__(87);

	var _ellipse3 = _interopRequireDefault(_ellipse2);

	var _arrow2 = __webpack_require__(88);

	var _arrow3 = _interopRequireDefault(_arrow2);

	var _text2 = __webpack_require__(89);

	var _text3 = _interopRequireDefault(_text2);

	var _line2 = __webpack_require__(90);

	var _line3 = _interopRequireDefault(_line2);

	var _remove_active = __webpack_require__(91);

	var _remove_active2 = _interopRequireDefault(_remove_active);

	var _clipboard2 = __webpack_require__(92);

	var _clipboard3 = _interopRequireDefault(_clipboard2);

	var _free_draw2 = __webpack_require__(93);

	var _free_draw3 = _interopRequireDefault(_free_draw2);

	var _blur2 = __webpack_require__(94);

	var _blur3 = _interopRequireDefault(_blur2);

	var _util = __webpack_require__(95);

	var _util2 = _interopRequireDefault(_util);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	(0, _modified3.default)(_command_provider2.default); /* global window, $, document, fabric, console */

	(0, _rect3.default)(_command_provider2.default);
	(0, _ellipse3.default)(_command_provider2.default);
	(0, _arrow3.default)(_command_provider2.default);
	(0, _text3.default)(_command_provider2.default);
	(0, _line3.default)(_command_provider2.default);

	(0, _remove_active2.default)(_command_provider2.default);
	(0, _clipboard3.default)(_command_provider2.default);
	(0, _free_draw3.default)(_command_provider2.default);
	(0, _blur3.default)(_command_provider2.default);

	var blurObjects = {
	  el: undefined,
	  cntObj: 0
	};

	var getBlur = function getBlur() {
	  return blurObjects;
	};

	var AnnotationsCanvas = function () {
	  function AnnotationsCanvas(service, imageResponse, options) {
	    var _this = this;

	    (0, _classCallCheck3.default)(this, AnnotationsCanvas);

	    this.service = service;
	    this.mode = 'normal';
	    this.sticky = _lodash2.default.get(options, "sticky", true);

	    var originalImage = new fabric.Image(imageResponse, {
	      lockMovementX: true,
	      lockMovementY: true,
	      lockScalingX: true,
	      lockScalingY: true,
	      hasControls: false,
	      hoverCursor: 'crosshair',
	      borderColor: "rgba(255,255,255,0)"
	    });

	    var Image = fabric.util.object.clone(originalImage);
	    this.originalImage = originalImage;
	    this.Image = Image;

	    var width = $('.annotations_canvas').width();
	    this.modifierKeys = { shift: false };

	    $(document).on('keyup keydown', function (e) {
	      _this.modifierKeys.shift = e.shiftKey;
	    });

	    var height = Math.max(window.innerHeight - 75, $('.annotations_canvas').height());

	    var canvasElement = document.createElement('canvas');
	    canvasElement.width = width;
	    canvasElement.height = height;

	    if (_util2.default.getImageHeight(Image) > height) {
	      Image.scaleToHeight(height);
	    }
	    if (_util2.default.getImageWidth(Image) > width) {
	      Image.scaleToWidth(width);
	    }

	    var canvasContainer = $(options.canvasContainer).get(0);
	    canvasContainer.appendChild(canvasElement);

	    this._setCanvas(canvasElement);
	    this.canvas.add(Image);
	    Image.center();
	    Image.sendToBack();

	    this.setCommandProvider();

	    window._CANVAS = function () {
	      return _this.canvas;
	    };

	    this.autoSetMode();
	  }

	  (0, _createClass3.default)(AnnotationsCanvas, [{
	    key: 'autoSetMode',
	    value: function autoSetMode() {
	      var savedMode = this.service._storage.fetch("annotationsMode");
	      if (!savedMode) {
	        return;
	      }
	      this.setMode(savedMode, _lodash2.default.noop)();
	      this.service.emit("change");
	    }
	  }, {
	    key: 'setMode',
	    value: function setMode(newMode, callback) {
	      var _this2 = this;

	      return function () {
	        if (!callback) {
	          callback = _lodash2.default.noop;
	        }
	        var oldMode = _this2.mode;
	        if (oldMode !== newMode) {
	          if (oldMode !== "text") {
	            _this2.canvas.discardActiveObject();
	          }

	          _this2.canvas.isDrawingMode = newMode === "drawing";
	          _lodash2.default.each(_this2.canvas.getObjects(), function (object) {
	            if (_this2.sticky) {
	              object.set('selectable', newMode !== "blur");
	            } else {
	              object.set('selectable', newMode === "normal");
	            }
	          });

	          (_this2.drawingMode || {}).omitAction = false;

	          _this2._setMode(newMode);
	        }
	        callback();

	        if (oldMode === "blur") {
	          _this2.commands._blurCancel();
	        }
	      };
	    }
	  }, {
	    key: '_setMode',
	    value: function _setMode(newMode) {
	      this.service._storage.store("annotationsMode", newMode);
	      this.mode = newMode;
	    }
	  }, {
	    key: 'setCommandProvider',
	    value: function setCommandProvider() {
	      var _this3 = this;

	      var colors = {
	        red: '#FF3A30', orange: '#FFAD21', green: '#82D233',
	        blue: '#5C92E0', white: '#FFFFFF', black: '#1E1E1E'
	      };

	      var drawing = this;
	      var commandProvider = _command_provider2.default.init();
	      this.commandProvider = commandProvider;

	      commandProvider.inject({
	        drawing: drawing,
	        disableFreeDraw: function disableFreeDraw() {
	          console.log("DEPRACATED: disable free draw");
	        },
	        fabric: fabric,
	        getBlur: getBlur,
	        getStrokeWidth: function getStrokeWidth() {
	          return 4;
	        },
	        getColor: this.getColor.bind(this),
	        getModifierKeys: function getModifierKeys() {
	          return drawing.modifierKeys;
	        },
	        getCanvas: function getCanvas() {
	          return drawing.canvas;
	        },
	        getHeight: function getHeight() {
	          return _util2.default.getHeight(drawing.canvas);
	        },
	        getImage: function getImage() {
	          return drawing.Image;
	        },
	        getLeft: function getLeft() {
	          return _util2.default.getLeft(drawing.canvas);
	        },
	        getTop: function getTop() {
	          return _util2.default.getTop(drawing.canvas);
	        },
	        getWidth: function getWidth() {
	          return _util2.default.getWidth(drawing.canvas);
	        },
	        newDimension: _util2.default.newDimension
	      });

	      var rectModule = commandProvider.map('rect');
	      var removeActive = commandProvider.map('removeActive');

	      var blurModule = commandProvider.map('blur', {
	        createRect: rectModule.createRect,
	        getImageWidth: _util2.default.getImageWidth,
	        getImageHeight: _util2.default.getImageHeight
	      });

	      var clipboard = commandProvider.map('clipboard', { removeActive: removeActive });

	      var track = function track(event, lambda) {
	        return function () {
	          drawing.service._analytics.track("Annotations " + event, { campaign_medium: 'button' });
	          return lambda.apply(null, arguments);
	        };
	      };

	      this.commands = {
	        addText: track("text", drawing.setMode("text", _lodash2.default.noop)),
	        addArrow: track("arrow", drawing.setMode("arrow", _lodash2.default.noop)),
	        addLine: track("line", drawing.setMode("line", _lodash2.default.noop)),
	        addCircle: track("circle", drawing.setMode("circle", _lodash2.default.noop)),
	        addRectangle: track("rectangle", drawing.setMode("rectangle", _lodash2.default.noop)),
	        freeDraw: track("free draw", drawing.setMode("drawing", _lodash2.default.noop)),
	        removeActive: track("remove", commandProvider.map('removeActive')),
	        blurApply: track("blur apply", drawing.setMode("normal", blurModule.apply)),
	        blurClick: track("blur", drawing.setMode("blur", blurModule.click)),
	        blurCancel: track("blur cancel", drawing.setMode("normal", blurModule.cancel)),
	        addBlur: blurModule.addBlur,
	        _blurCancel: blurModule.cancel,
	        _freeDrawAddPath: commandProvider.map("freeDraw"),
	        normal: drawing.setMode("normal", _lodash2.default.noop),

	        draw: {
	          rectangle: commandProvider.map("rect").drawRect,
	          circle: commandProvider.map("ellipse"),
	          arrow: commandProvider.map("arrow"),
	          line: commandProvider.map("line"),
	          text: commandProvider.map("text"),
	          blur: blurModule.draw
	        },

	        clipboardCopy: track("clipboardCopy", clipboard.copy),
	        clipboardPaste: track("clipboardPaste", clipboard.paste),
	        clipboardCut: track("clipboardCut", clipboard.cut),
	        undo: track("undo", commandProvider.undo),
	        redo: track("redo", commandProvider.redo),

	        canUndo: function canUndo() {
	          return commandProvider.canUndo();
	        },

	        canRedo: function canRedo() {
	          return commandProvider.canRedo();
	        },

	        canRemove: function canRemove() {
	          if (drawing.commands.mode("blur")) {
	            return false;
	          }
	          return drawing.getActiveNonImageObject();
	        },
	        getColor: function getColor() {
	          return _lodash2.default.invert(colors)[_this3.getColor()];
	        },

	        setColor: function setColor(colorName) {
	          _this3.setColor(colors[colorName]);
	          _this3.service.emit("change");
	        },

	        mode: function mode(_mode) {
	          return _this3.mode === _mode;
	        }
	      };
	    }
	  }, {
	    key: '_setCanvas',
	    value: function _setCanvas(canvasElement) {
	      var _this4 = this;

	      this.globalColor = '#FF3A30';
	      this.canvas = new fabric.Canvas(canvasElement, {
	        selection: false,
	        enableRetinaScaling: false,
	        defaultCursor: 'crosshair'
	      });

	      this.service.emit("change");

	      var drawingMode = {
	        callback: null, unset: null, selected: false, omitAction: false
	      };

	      this.drawingMode = drawingMode;

	      this.canvas.on("mouse:down", function (event) {
	        if (drawingMode.omitAction && !_this4._getActiveObject()[1]) {
	          drawingMode.omitAction = false;
	          return drawingMode.selected = false;
	        }

	        if (_this4.sticky && (drawingMode.selected || _this4._getActiveObject()[1])) {
	          return drawingMode.selected = false;
	        }

	        if (_this4.commands.draw[_this4.mode]) {
	          _this4.commands.draw[_this4.mode](drawingMode, event);
	        }
	      });
	      this.canvas.on("mouse:move", function (event) {
	        if (drawingMode.callback) {
	          drawingMode.callback(_this4.canvas.getPointer(event.e));
	        }
	      });

	      this.canvas.on("mouse:up", function (event) {
	        if (drawingMode.unset) {
	          drawingMode.unset(event);
	          drawingMode.unset = null;
	        }

	        if (drawingMode.callback) {
	          drawingMode.callback = null;
	          if (!_this4.sticky) {
	            _this4.setMode("normal", _lodash2.default.noop)();
	          }
	        }
	        _this4.service.emit("change");
	      });

	      this.canvas.on("object:selected", function (event) {
	        if (_this4.sticky && event.target.type !== "image") {
	          drawingMode.selected = true;
	          drawingMode.omitAction = true;
	        }

	        _this4.service.emit("change");
	      });

	      this.canvas.on("path:created", function (event) {
	        _this4.service.emit("change");
	        if (_this4.canvas.isDrawingMode) {
	          _this4.commands._freeDrawAddPath(event.path);
	        }
	      });

	      this.canvas.freeDrawingBrush.color = this._getGlobalColor();
	      this.canvas.freeDrawingBrush.width = 4;
	    }
	  }, {
	    key: '_getGlobalColor',
	    value: function _getGlobalColor() {
	      return this.globalColor;
	    }
	  }, {
	    key: '_getLocalColor',
	    value: function _getLocalColor() {
	      var object = this._getActiveObject()[0],
	          property = this._getActiveObject()[1];

	      if (object && property) {
	        return object[property];
	      }

	      return null;
	    }
	  }, {
	    key: 'getColor',
	    value: function getColor() {
	      return this._getLocalColor() || this._getGlobalColor();
	    }
	  }, {
	    key: '_getActiveObject',
	    value: function _getActiveObject() {
	      var property = null,
	          object = this.canvas.getActiveObject();
	      if (object) {
	        switch (object.type) {
	          case 'i-text':
	            property = "fill";
	            break;
	          case 'image':
	            break;
	          default:
	            property = "stroke";
	        }
	      }

	      return [object, property];
	    }
	  }, {
	    key: 'getActiveNonImageObject',
	    value: function getActiveNonImageObject() {
	      var object = this.canvas.getActiveObject();
	      if (_lodash2.default.get(object, "type") === "image") {
	        return null;
	      }
	      return object;
	    }
	  }, {
	    key: 'setColor',
	    value: function setColor(colorName) {
	      var drawing = this;
	      var object = this._getActiveObject()[0],
	          property = this._getActiveObject()[1];

	      if (!property) {
	        this.canvas.freeDrawingBrush.color = colorName;
	        this.globalColor = colorName;
	        return false;
	      }

	      return this.commandProvider.execute(function () {
	        return {
	          _init: function _init() {
	            this.beforeColorName = drawing._getLocalColor();
	            this.afterColorName = colorName;
	          },

	          up: function up() {
	            object[property] = this.afterColorName;
	            if (object.trigger) {
	              object.trigger("color:changed");
	            }
	            drawing.globalColor = this.afterColorName;
	            drawing.canvas.renderAll();
	          },

	          down: function down() {
	            object[property] = this.beforeColorName;
	            if (object.trigger) {
	              object.trigger("color:changed");
	            }
	            drawing.globalColor = this.beforeColorName;
	            drawing.canvas.renderAll();
	          }
	        };
	      });
	    }
	  }]);
	  return AnnotationsCanvas;
	}();

	exports.default = AnnotationsCanvas;

/***/ }),
/* 33 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* global window */
	var CommandProvider = {
	  _commands: {},
	  register: function register(name, method) {
	    this._commands[name] = method;
	  },

	  init: function init() {
	    var klass = this;
	    var self = {
	      history: [],
	      index: -1,

	      base: {},

	      map: function map(name, module) {
	        if (!klass._commands[name]) {
	          return;
	        }
	        return klass._commands[name].bind(this, self)(self.base, module);
	      },

	      inject: function inject(module) {
	        for (var key in module) {
	          self.base[key] = module[key];
	        }
	      },

	      notify: function notify() {
	        // $('#canvas-container').trigger({type: "annotations:historyChanged"});
	      },

	      redo: function redo() {
	        if (!self.canRedo()) {
	          return;
	        }
	        self.index += 1;
	        self.history[self.index].up();
	        self.notify();
	        return true;
	      },

	      undo: function undo() {
	        if (!self.canUndo()) {
	          return;
	        }
	        self.history[self.index].down();
	        self.index -= 1;
	        self.notify();
	        return true;
	      },

	      canUndo: function canUndo() {
	        return !!self.history[self.index];
	      },

	      canRedo: function canRedo() {
	        return !!self.history[self.index + 1];
	      },

	      execute: function execute(command, object) {
	        self.history.splice(self.index += 1, self.history.length, command(object));
	        if (self.history[self.index]._init) {
	          self.history[self.index]._init();
	        }

	        self.history[self.index].up();
	        self.notify();
	        return self.history[self.index];
	      }
	    };

	    window.cmd = self;
	    return self;
	  }
	};

	exports.default = CommandProvider;

/***/ }),
/* 34 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var Modified = function Modified(CommandProvider) {
	  CommandProvider.register('modified', function (provider, base) {

	    return function (path, callback) {
	      var changedListener = function changedListener() {
	        var object = this;

	        return provider.execute(function () {
	          var properties = ["top", "left", "angle"];

	          if (object.textAlign) {
	            properties.push("text");
	          } else {
	            properties.push("width");
	            properties.push("height");
	          }

	          var self = {
	            after: {},
	            before: {},

	            _init: function _init() {
	              properties.forEach(function (property) {
	                self.after[property] = object[property];
	                self.before[property] = object.originalState[property];
	              });
	            },

	            up: function up() {
	              properties.forEach(function (property) {
	                object[property] = self.after[property];
	              });

	              if (typeof callback === "function") {
	                callback(self.after);
	              }
	              object.setCoords();
	              base.getCanvas().renderAll();
	            },

	            down: function down() {
	              properties.forEach(function (property) {
	                object[property] = self.before[property];
	              });

	              if (typeof callback === "function") {
	                callback(self.before);
	              }
	              object.setCoords();
	              base.getCanvas().renderAll();
	            }
	          };
	          return self;
	        });
	      };

	      path.on('modified', changedListener);

	      if (path.textAlign) {
	        var previousInitialText, currentCommand;
	        path.on('changed', function () {
	          if (!currentCommand) {
	            currentCommand = changedListener.bind(this)();
	            previousInitialText = this.originalState.text;
	          } else {
	            if (previousInitialText !== this.originalState.text) {
	              currentCommand = changedListener.bind(this)();
	            } else {
	              currentCommand.after.text = this.text;
	            }
	            previousInitialText = this.originalState.text;
	          }
	        });
	      }
	    };
	  });
	};

	exports.default = Modified;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _typeof2 = __webpack_require__(36);

	var _typeof3 = _interopRequireDefault(_typeof2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/* global $:false */

	var Rect = function Rect(CommandProvider) {
	  CommandProvider.register('rect', function (provider, base) {
	    var createRect = function createRect(options) {
	      var defaultOptions = {
	        lockScalingX: true,
	        lockScalingY: true,
	        hasRotatingPoint: false
	      };

	      if ((typeof options === 'undefined' ? 'undefined' : (0, _typeof3.default)(options)) === 'object') {
	        options = $.extend(defaultOptions, options);
	      } else {
	        options = defaultOptions;
	      }

	      var rect = new base.fabric.Rect(options);
	      rect.setControlsVisibility({ ml: false, mr: false, mt: false, mb: false });
	      rect.on('scaling', function (event) {
	        var newCords = base.getCanvas().getPointer(event.e);
	        var newDim = base.newDimension(this, newCords);
	        this.top = newDim.top;
	        this.left = newDim.left;
	        this.width = newDim.width;
	        this.height = newDim.height;
	      });
	      return rect;
	    };

	    var _addRect = function _addRect(left, top, width, height) {
	      var rect = createRect({
	        top: top,
	        left: left,
	        width: width,
	        height: height,
	        transparentCorners: false,
	        borderColor: "rgba(201,201,201,0.2)",
	        cornerColor: "rgba(193,193,193,0.8)",
	        cornerSize: 12,
	        padding: -2,
	        fill: 'transparent',
	        stroke: base.getColor(),
	        strokeWidth: base.getStrokeWidth(),
	        selectable: base.drawing.sticky,
	        ry: 3,
	        rx: 3
	      });

	      return rect;
	    };

	    var drawRectFromEvent = function drawRectFromEvent(mode, event) {
	      var origX, origY;
	      var canvas = base.getCanvas();

	      var pointer = canvas.getPointer(event.e);
	      origX = pointer.x;
	      origY = pointer.y;

	      var rect = _addRect(origX, origY, pointer.x - origX, pointer.y - origY);

	      provider.map("modified")(rect);

	      mode.callback = function (ptr) {
	        rect.set({
	          left: origX > ptr.x ? ptr.x : origX,
	          top: origY > ptr.y ? ptr.y : origY,
	          width: Math.abs(origX - ptr.x),
	          height: Math.abs(origY - ptr.y)
	        });
	        canvas.remove(rect);
	        canvas.add(rect);
	      };

	      mode.unset = function () {
	        canvas.remove(rect);
	        canvas.add(rect);
	        canvas.renderAll();
	      };

	      return rect;
	    };

	    var drawRect = function drawRect(mode, event) {
	      provider.execute(function () {
	        return {
	          init: function init() {
	            this.instance = drawRectFromEvent(mode, event);
	          },
	          up: function up() {
	            var canvas = base.getCanvas();

	            if (!this.instance) {
	              this.init();
	            }
	            canvas.add(this.instance);

	            return this.instance;
	          },

	          down: function down() {
	            base.getCanvas().remove(this.instance);
	          }
	        };
	      });
	    };

	    return {
	      createRect: createRect,
	      drawRect: drawRect,
	      addRect: function addRect() {
	        provider.execute(function () {
	          return {
	            init: function init() {
	              this.instance = _addRect();
	            },
	            up: function up() {
	              if (!this.instance) {
	                this.init();
	              }
	              var canvas = base.getCanvas();
	              canvas.add(this.instance);
	              canvas.setActiveObject(this.instance);
	              return this.instance;
	            },

	            down: function down() {
	              base.getCanvas().remove(this.instance);
	            }
	          };
	        });
	      }
	    };
	  });
	};

	exports.default = Rect;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _iterator = __webpack_require__(37);

	var _iterator2 = _interopRequireDefault(_iterator);

	var _symbol = __webpack_require__(72);

	var _symbol2 = _interopRequireDefault(_symbol);

	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(38), __esModule: true };

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(39);
	__webpack_require__(67);
	module.exports = __webpack_require__(71).f('iterator');


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(40)(true);

	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(43)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(41);
	var defined = __webpack_require__(42);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 41 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 42 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(44);
	var $export = __webpack_require__(11);
	var redefine = __webpack_require__(45);
	var hide = __webpack_require__(16);
	var Iterators = __webpack_require__(46);
	var $iterCreate = __webpack_require__(47);
	var setToStringTag = __webpack_require__(63);
	var getPrototypeOf = __webpack_require__(65);
	var ITERATOR = __webpack_require__(64)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';

	var returnThis = function () { return this; };

	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 44 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(16);


/***/ }),
/* 46 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(48);
	var descriptor = __webpack_require__(25);
	var setToStringTag = __webpack_require__(63);
	var IteratorPrototype = {};

	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(16)(IteratorPrototype, __webpack_require__(64)('iterator'), function () { return this; });

	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(18);
	var dPs = __webpack_require__(49);
	var enumBugKeys = __webpack_require__(61);
	var IE_PROTO = __webpack_require__(58)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';

	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(23)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(62).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};

	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(17);
	var anObject = __webpack_require__(18);
	var getKeys = __webpack_require__(50);

	module.exports = __webpack_require__(21) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(51);
	var enumBugKeys = __webpack_require__(61);

	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(26);
	var toIObject = __webpack_require__(52);
	var arrayIndexOf = __webpack_require__(55)(false);
	var IE_PROTO = __webpack_require__(58)('IE_PROTO');

	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(53);
	var defined = __webpack_require__(42);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(54);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 54 */
/***/ (function(module, exports) {

	var toString = {}.toString;

	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(52);
	var toLength = __webpack_require__(56);
	var toAbsoluteIndex = __webpack_require__(57);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(41);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(41);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(59)('keys');
	var uid = __webpack_require__(60);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(13);
	var global = __webpack_require__(12);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});

	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(44) ? 'pure' : 'global',
	  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 60 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 61 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(12).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(17).f;
	var has = __webpack_require__(26);
	var TAG = __webpack_require__(64)('toStringTag');

	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(59)('wks');
	var uid = __webpack_require__(60);
	var Symbol = __webpack_require__(12).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';

	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};

	$exports.store = store;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(26);
	var toObject = __webpack_require__(66);
	var IE_PROTO = __webpack_require__(58)('IE_PROTO');
	var ObjectProto = Object.prototype;

	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(42);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(68);
	var global = __webpack_require__(12);
	var hide = __webpack_require__(16);
	var Iterators = __webpack_require__(46);
	var TO_STRING_TAG = __webpack_require__(64)('toStringTag');

	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');

	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(69);
	var step = __webpack_require__(70);
	var Iterators = __webpack_require__(46);
	var toIObject = __webpack_require__(52);

	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(43)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');

	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;

	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 69 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 70 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(64);


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(73), __esModule: true };

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(74);
	__webpack_require__(84);
	__webpack_require__(85);
	__webpack_require__(86);
	module.exports = __webpack_require__(13).Symbol;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(12);
	var has = __webpack_require__(26);
	var DESCRIPTORS = __webpack_require__(21);
	var $export = __webpack_require__(11);
	var redefine = __webpack_require__(45);
	var META = __webpack_require__(75).KEY;
	var $fails = __webpack_require__(22);
	var shared = __webpack_require__(59);
	var setToStringTag = __webpack_require__(63);
	var uid = __webpack_require__(60);
	var wks = __webpack_require__(64);
	var wksExt = __webpack_require__(71);
	var wksDefine = __webpack_require__(76);
	var enumKeys = __webpack_require__(77);
	var isArray = __webpack_require__(80);
	var anObject = __webpack_require__(18);
	var isObject = __webpack_require__(19);
	var toIObject = __webpack_require__(52);
	var toPrimitive = __webpack_require__(24);
	var createDesc = __webpack_require__(25);
	var _create = __webpack_require__(48);
	var gOPNExt = __webpack_require__(81);
	var $GOPD = __webpack_require__(83);
	var $DP = __webpack_require__(17);
	var $keys = __webpack_require__(50);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;

	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};

	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};

	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};

	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });

	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(82).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(79).f = $propertyIsEnumerable;
	  __webpack_require__(78).f = $getOwnPropertySymbols;

	  if (DESCRIPTORS && !__webpack_require__(44)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }

	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}

	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});

	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});

	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});

	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(16)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(60)('meta');
	var isObject = __webpack_require__(19);
	var has = __webpack_require__(26);
	var setDesc = __webpack_require__(17).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(22)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(12);
	var core = __webpack_require__(13);
	var LIBRARY = __webpack_require__(44);
	var wksExt = __webpack_require__(71);
	var defineProperty = __webpack_require__(17).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(50);
	var gOPS = __webpack_require__(78);
	var pIE = __webpack_require__(79);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 78 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 79 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(54);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(52);
	var gOPN = __webpack_require__(82).f;
	var toString = {}.toString;

	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];

	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};

	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(51);
	var hiddenKeys = __webpack_require__(61).concat('length', 'prototype');

	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(79);
	var createDesc = __webpack_require__(25);
	var toIObject = __webpack_require__(52);
	var toPrimitive = __webpack_require__(24);
	var has = __webpack_require__(26);
	var IE8_DOM_DEFINE = __webpack_require__(20);
	var gOPD = Object.getOwnPropertyDescriptor;

	exports.f = __webpack_require__(21) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 84 */
/***/ (function(module, exports) {

	

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(76)('asyncIterator');


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(76)('observable');


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _typeof2 = __webpack_require__(36);

	var _typeof3 = _interopRequireDefault(_typeof2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/* global $:false */
	var Ellipse = function Ellipse(CommandProvider) {
	  CommandProvider.register('ellipse', function (provider, base) {
	    var createEllipse = function createEllipse(options) {
	      var defaultOptions = {
	        lockScalingX: true,
	        hasRotatingPoint: false,
	        transparentCorners: false,
	        borderColor: "rgba(201,201,201,0.2)",
	        cornerColor: "rgba(193,193,193,0.8)",
	        cornerSize: 12,
	        padding: -2,
	        fill: 'transparent',
	        selectable: base.drawing.sticky
	      };

	      if ((typeof options === "undefined" ? "undefined" : (0, _typeof3.default)(options)) === 'object') {
	        options = $.extend(defaultOptions, options);
	      } else {
	        options = defaultOptions;
	      }

	      var ellipse = new base.fabric.Ellipse(options);
	      ellipse.setControlsVisibility({ ml: false, mr: false, mt: false, mb: false });
	      ellipse.on('scaling', function (event) {
	        var newCords = base.getCanvas().getPointer(event.e);
	        var newDim = base.newDimension(this, newCords);
	        this.top = newDim.top;
	        this.left = newDim.left;
	        this.width = newDim.width;
	        this.height = newDim.height;
	        this.rx = this.width / 2;
	        this.ry = this.height / 2;
	      });
	      return ellipse;
	    };

	    var addEllipse = function addEllipse(left, top, width, height) {
	      var ellipse = createEllipse({
	        stroke: base.getColor(),
	        strokeWidth: base.getStrokeWidth(),
	        rx: width / 2,
	        ry: height / 2,
	        height: height, width: width, left: left, top: top
	      });

	      provider.map("modified")(ellipse, function (options) {
	        ellipse.rx = options.width / 2;
	        ellipse.ry = options.height / 2;
	      });
	      return ellipse;
	    };

	    var drawEllipseFromEvent = function drawEllipseFromEvent(mode, event) {
	      var origX, origY;
	      var canvas = base.getCanvas();

	      var pointer = canvas.getPointer(event.e);
	      origX = pointer.x;
	      origY = pointer.y;

	      var ellipse = addEllipse(origX, origY, pointer.x - origX, pointer.y - origY);

	      mode.callback = function (ptr) {
	        ellipse.set({
	          left: origX > ptr.x ? ptr.x : origX,
	          top: origY > ptr.y ? ptr.y : origY,
	          width: Math.abs(origX - ptr.x),
	          height: Math.abs(origY - ptr.y)
	        });

	        ellipse.set({ rx: ellipse.getWidth() / 2, ry: ellipse.getHeight() / 2 });
	        canvas.remove(ellipse);
	        canvas.add(ellipse);
	      };

	      mode.unset = function () {
	        canvas.remove(ellipse);
	        canvas.add(ellipse);
	        canvas.renderAll();
	      };

	      return ellipse;
	    };

	    return function (mode, event) {
	      provider.execute(function () {
	        return {
	          init: function init() {
	            this.instance = drawEllipseFromEvent(mode, event);
	          },
	          up: function up() {
	            var canvas = base.getCanvas();

	            if (!this.instance) {
	              this.init();
	            }
	            canvas.add(this.instance);
	            return this.instance;
	          },

	          down: function down() {
	            base.getCanvas().remove(this.instance);
	          }
	        };
	      });
	    };
	  });
	};

	exports.default = Ellipse;

/***/ }),
/* 88 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* global fabric, _ */

	var Arrow = function Arrow(CommandProvider) {
	  CommandProvider.register('arrow', function (provider, base) {
	    var addArrow = function addArrow(left, top) {
	      var canvas = base.getCanvas();
	      var path = new fabric.Path('M 0 0 L 0 0 M 0 0 L 0 0 M 0 0 L 0 0', {
	        stroke: base.getColor(),
	        strokeWidth: base.getStrokeWidth(),
	        fill: false,
	        lockRotation: true,
	        lockScalingX: true,
	        lockScalingY: true,
	        strokeLineCap: 'round',
	        transparentCorners: false,
	        hasRotatingPoint: false,
	        borderColor: "rgba(201,201,201,0.0)",
	        cornerColor: "rgba(193,193,193,0.8)",
	        cornerSize: 12,
	        padding: 2,
	        originX: 'left',
	        originY: 'top'
	      });
	      var armWidth = base.getStrokeWidth();

	      path.setAngle(45).set({ left: left, top: top });
	      path.setControlsVisibility({ tl: false, bl: false, tr: false, br: false, mt: false, mb: false });

	      path.on('scaling', function (event) {
	        var d, newCords, ang;
	        switch (this.__corner) {
	          case 'ml':
	            // end point
	            d = this.oCoords.mr;
	            // new start point
	            newCords = canvas.getPointer(event.e);
	            ang = Math.atan2(newCords.y - d.y, newCords.x - d.x) + Math.PI / 2;

	            this.width = Math.sqrt(Math.pow(newCords.y - d.y, 2) + Math.pow(newCords.x - d.x, 2));
	            this.angle = Math.atan2(newCords.y - d.y, newCords.x - d.x) * 180 / Math.PI + 180;
	            this.path[1][1] = this.width;
	            this.pathOffset.x = this.width / 2;

	            this.top = newCords.y + armWidth * Math.sin(ang);
	            this.left = newCords.x + armWidth * Math.cos(ang);
	            break;
	          case 'mr':
	            newCords = canvas.getPointer(event.e);
	            d = this.oCoords.ml;
	            ang = Math.atan2(d.y - newCords.y, d.x - newCords.x) + Math.PI / 2;

	            this.width = Math.sqrt(Math.pow(d.y - newCords.y, 2) + Math.pow(d.x - newCords.x, 2));
	            this.angle = Math.atan2(d.y - newCords.y, d.x - newCords.x) * 180 / Math.PI + 180;
	            this.path[1][1] = this.width;
	            this.pathOffset.x = this.width / 2;

	            this.top = d.y + armWidth * Math.sin(ang);
	            this.left = d.x + armWidth * Math.cos(ang);
	            break;
	          default:
	            break;
	        }
	      });

	      provider.map("modified")(path, function (options) {
	        path.path[1][1] = options.width;
	        path.pathOffset.x = options.width / 2;
	      });

	      return path;
	    };

	    var drawArrowFromEvent = function drawArrowFromEvent(mode, event) {
	      var origX, origY;
	      var canvas = base.getCanvas();

	      var pointer = canvas.getPointer(event.e);
	      origX = pointer.x;
	      origY = pointer.y;

	      var arrow = addArrow(origX, origY, pointer.x - origX, pointer.y - origY);

	      mode.callback = function (ptr) {

	        var d = { x: origX, y: origY };

	        arrow.width = Math.sqrt(Math.pow(ptr.y - d.y, 2) + Math.pow(ptr.x - d.x, 2));
	        arrow.angle = Math.atan2(ptr.y - d.y, ptr.x - d.x) * 180 / Math.PI + 180;

	        var minWidth = _.min([arrow.width, 100]);
	        arrow.path[3][1] = 0.2 * minWidth;
	        arrow.path[5][1] = 0.2 * minWidth;
	        arrow.path[3][2] = 0.15 * minWidth;
	        arrow.path[5][2] = -0.15 * minWidth;

	        arrow.path[1][1] = arrow.width;

	        arrow.pathOffset.x = arrow.width / 2;

	        arrow.top = ptr.y;
	        arrow.left = ptr.x;

	        canvas.remove(arrow);
	        canvas.add(arrow);
	      };

	      mode.unset = function () {
	        canvas.remove(arrow);
	        canvas.add(arrow);
	        canvas.renderAll();
	      };

	      return arrow;
	    };

	    return function (mode, event) {
	      provider.execute(function () {
	        var canvas = base.getCanvas();
	        return {
	          init: function init() {
	            this.instance = drawArrowFromEvent(mode, event);
	          },
	          up: function up() {
	            if (!this.instance) {
	              this.init();
	            }
	            canvas.add(this.instance);
	            return this.instance;
	          },

	          down: function down() {
	            canvas.remove(this.instance);
	          }
	        };
	      });
	    };
	  });
	};

	exports.default = Arrow;

/***/ }),
/* 89 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* global _, setTimeout */

	var Text = function Text(CommandProvider) {
	  CommandProvider.register('text', function (provider, base) {
	    var addText = function addText(text, left, top) {
	      base.disableFreeDraw();
	      var iText = new base.fabric.IText(text || '  ', {
	        transparentCorners: false,
	        borderColor: "rgba(201,201,201,0.2)",
	        editingBorderColor: "rgba(201,201,201,0.0)",
	        cornerColor: "rgba(193,193,193,0.8)",
	        cornerSize: 12,
	        padding: -2,
	        fontFamily: 'Helvetica, Arial',
	        fontSize: 28,
	        fill: base.getColor(),
	        top: top,
	        left: left,
	        originX: 'left',
	        originY: 'top'
	      });

	      var originalScale = 1;

	      iText.setControlsVisibility({
	        ml: false, mr: false, bl: false, mb: false, mt: false, tr: false
	      });

	      iText.on("scaling", function () {
	        originalScale = iText.getScaleX();
	      });

	      iText.on("editing:entered", function () {
	        if (iText.fill === "#FFFFFF") {
	          iText.backgroundColor = 'rgba(0, 0, 0, 0.7)';
	        } else {
	          iText.backgroundColor = 'rgba(255, 255, 255, 0.7)';
	        }
	      });

	      iText.on("color:changed", function () {
	        if (iText.backgroundColor) {
	          iText.trigger("editing:entered");
	        }
	      });

	      iText.on("editing:exited", function () {
	        iText.backgroundColor = null;
	      });

	      iText.on("changed", function () {
	        var txt = iText.text;

	        if (txt && txt.length === 3 && txt.trim().length === 1) {
	          iText.text = txt[0];
	        }

	        var canvas = base.getCanvas();
	        var maxWidth = canvas.width - iText.left - 10;

	        if (iText.width * originalScale > maxWidth) {
	          iText.scaleToWidth(maxWidth);
	        } else {
	          iText.scale(originalScale);
	        }

	        canvas.renderAll();
	      });

	      provider.map("modified")(iText);
	      return iText;
	    };

	    var addArrowFromEvent = function addArrowFromEvent(mode, event) {
	      var origX, origY;
	      var canvas = base.getCanvas();

	      var pointer = canvas.getPointer(event.e);
	      origX = pointer.x;
	      origY = pointer.y;

	      var text = addText(null, origX, origY);

	      var incrementSteps = 200;
	      var getValue = function getValue(origin, point) {
	        return Math.pow(_.max([0, point - origin + incrementSteps]), 2);
	      };

	      text.finished = false;
	      setTimeout(function () {
	        if (!text.finished) {
	          text.text = 'Text';
	        }
	      }, 100);

	      mode.callback = function (ptr) {
	        var scale = Math.sqrt(getValue(origX, ptr.x) + getValue(origY, ptr.y));
	        text.scale(_.max([0.10, scale / (incrementSteps * Math.sqrt(2))]));

	        text.trigger("scaling");

	        canvas.remove(text);
	        canvas.add(text);
	      };

	      mode.unset = function () {
	        text.finished = true;
	        canvas.setActiveObject(text);
	        text.text = "  ";
	        text.enterEditing();
	        text.hiddenTextarea.focus();
	      };

	      return text;
	    };

	    return function (mode, event) {
	      provider.execute(function () {
	        return {
	          init: function init() {
	            this.instance = addArrowFromEvent(mode, event);
	          },

	          up: function up() {
	            var initialized = !!this.instance;
	            if (!initialized) {
	              this.init();
	            }
	            var canvas = base.getCanvas();
	            canvas.add(this.instance);

	            if (initialized) {
	              canvas.setActiveObject(this.instance);
	              this.instance.enterEditing();
	              this.instance.selectAll();
	              this.instance.hiddenTextarea.focus();
	            }

	            return this.instance;
	          },

	          down: function down() {
	            base.getCanvas().remove(this.instance);
	          }
	        };
	      });
	    };
	  });
	};

	exports.default = Text;

/***/ }),
/* 90 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* global fabric */

	var Line = function Line(CommandProvider) {
	  CommandProvider.register('line', function (provider, base) {
	    var addLine = function addLine(left, top) {
	      var canvas = base.getCanvas();
	      var path = new fabric.Path('M 0 0 L 0 0', {
	        stroke: base.getColor(),
	        strokeWidth: base.getStrokeWidth(),
	        fill: false,
	        lockRotation: true,
	        lockScalingX: true,
	        lockScalingY: true,
	        strokeLineCap: 'round',
	        transparentCorners: false,
	        hasRotatingPoint: false,
	        borderColor: "rgba(201,201,201,0.0)",
	        cornerColor: "rgba(193,193,193,0.8)",
	        cornerSize: 12,
	        padding: 2,
	        originX: 'left',
	        originY: 'top'
	      });
	      var armWidth = base.getStrokeWidth();

	      path.setAngle(45).set({ left: left, top: top });
	      path.setControlsVisibility({ tl: false, bl: false, tr: false, br: false, mt: false, mb: false });

	      path.on('scaling', function (event) {
	        var d, newCords, ang;
	        switch (this.__corner) {
	          case 'ml':
	            // end point
	            d = this.oCoords.mr;
	            // new start point
	            newCords = canvas.getPointer(event.e);
	            ang = Math.atan2(newCords.y - d.y, newCords.x - d.x) + Math.PI / 2;

	            this.width = Math.sqrt(Math.pow(newCords.y - d.y, 2) + Math.pow(newCords.x - d.x, 2));
	            this.angle = Math.atan2(newCords.y - d.y, newCords.x - d.x) * 180 / Math.PI + 180;
	            this.path[1][1] = this.width;
	            this.pathOffset.x = this.width / 2;

	            this.top = newCords.y + armWidth * Math.sin(ang);
	            this.left = newCords.x + armWidth * Math.cos(ang);
	            break;
	          case 'mr':
	            newCords = canvas.getPointer(event.e);
	            d = this.oCoords.ml;
	            ang = Math.atan2(d.y - newCords.y, d.x - newCords.x) + Math.PI / 2;

	            this.width = Math.sqrt(Math.pow(d.y - newCords.y, 2) + Math.pow(d.x - newCords.x, 2));
	            this.angle = Math.atan2(d.y - newCords.y, d.x - newCords.x) * 180 / Math.PI + 180;
	            this.path[1][1] = this.width;
	            this.pathOffset.x = this.width / 2;

	            this.top = d.y + armWidth * Math.sin(ang);
	            this.left = d.x + armWidth * Math.cos(ang);
	            break;
	          default:
	            break;
	        }
	      });

	      provider.map("modified")(path, function (options) {
	        path.path[1][1] = options.width;
	        path.pathOffset.x = options.width / 2;
	      });

	      return path;
	    };

	    var drawLineFromEvent = function drawLineFromEvent(mode, event) {
	      var origX, origY;
	      var canvas = base.getCanvas();

	      var pointer = canvas.getPointer(event.e);
	      origX = pointer.x;
	      origY = pointer.y;

	      var line = addLine(origX, origY, pointer.x - origX, pointer.y - origY);

	      mode.callback = function (ptr) {

	        var d = { x: origX, y: origY };

	        line.width = Math.sqrt(Math.pow(ptr.y - d.y, 2) + Math.pow(ptr.x - d.x, 2));
	        line.angle = Math.atan2(ptr.y - d.y, ptr.x - d.x) * 180 / Math.PI + 180;
	        if (base.getModifierKeys().shift) {
	          // line.angle = util.roundAngle(line.angle);
	        }

	        line.path[1][1] = line.width;

	        line.pathOffset.x = line.width / 2;

	        line.top = ptr.y;
	        line.left = ptr.x;

	        canvas.remove(line);
	        canvas.add(line);
	      };

	      mode.unset = function () {
	        canvas.remove(line);
	        canvas.add(line);
	        canvas.renderAll();
	      };

	      return line;
	    };

	    return function (mode, event) {
	      provider.execute(function () {
	        var canvas = base.getCanvas();
	        return {
	          init: function init() {
	            this.instance = drawLineFromEvent(mode, event);
	          },
	          up: function up() {
	            if (!this.instance) {
	              this.init();
	            }
	            canvas.add(this.instance);
	            return this.instance;
	          },

	          down: function down() {
	            canvas.remove(this.instance);
	          }
	        };
	      });
	    };
	  });
	};

	exports.default = Line;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _typeof2 = __webpack_require__(36);

	var _typeof3 = _interopRequireDefault(_typeof2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var RemoveActive = function RemoveActive(CommandProvider) {
	  CommandProvider.register('removeActive', function (provider, base) {
	    var removeActive = function removeActive() {
	      var canvas = base.getCanvas();
	      if (typeof canvas === 'undefined') {
	        return false;
	      }
	      var obj = canvas.getActiveObject();
	      if (typeof obj !== 'undefined' && obj !== null) {
	        if (obj.type === 'i-text' && obj.isEditing || obj.type === 'image') {
	          return false;
	        }
	        return obj;
	      }
	      return false;
	    };

	    return function () {
	      if (!base.drawing.getActiveNonImageObject()) {
	        return;
	      }
	      provider.execute(function () {
	        return {
	          init: function init() {
	            this.instance = removeActive();
	          },

	          up: function up() {
	            if ((0, _typeof3.default)(this.instance) !== "object") {
	              this.init();
	            }
	            base.getCanvas().remove(this.instance);
	          },

	          down: function down() {
	            base.getCanvas().add(this.instance);
	            base.getCanvas().setActiveObject(this.instance);
	          }
	        };
	      });
	    };
	  });
	};

	exports.default = RemoveActive;

/***/ }),
/* 92 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* global $:false */
	var Clipboard = function Clipboard(CommandProvider) {
	  CommandProvider.register('clipboard', function (provider, base, opt) {
	    var self = {
	      _clipboard: null,
	      _clone: function _clone(path) {
	        var clone = base.fabric.util.object.clone(path);

	        if (clone.pathOffset) {
	          clone.pathOffset = $.extend(true, {}, clone.pathOffset);
	        }

	        if (clone.path) {
	          clone.path = $.extend(true, [], clone.path);
	        }
	        return clone;
	      },
	      copy: function copy() {
	        var canvas = base.getCanvas(),
	            active = canvas.getActiveObject();

	        if (!active || active.isEditing) {
	          return false;
	        }
	        self._clipboard = self._clone(active);
	        return true;
	      },

	      cut: function cut() {
	        if (self.copy()) {
	          opt.removeActive();
	          return true;
	        }
	        return false;
	      },

	      paste: function paste() {
	        if (!self._clipboard) {
	          return;
	        }
	        var canvas = base.getCanvas(),
	            active = canvas.getActiveObject(),
	            object = self._clone(self._clipboard);

	        if (active) {
	          if (active.isEditing) {
	            return false;
	          }
	          object.left = active.left + 10;
	          object.top = active.top + 10;
	        }

	        if (object) {
	          provider.execute(function () {
	            return {
	              up: function up() {
	                canvas.add(object);
	                canvas.setActiveObject(object);
	              },

	              down: function down() {
	                canvas.remove(object);
	              }
	            };
	          });
	        }
	        return true;
	      }
	    };

	    return self;
	  });
	};

	exports.default = Clipboard;

/***/ }),
/* 93 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var FreeDraw = function FreeDraw(CommandProvider) {
	  CommandProvider.register('freeDraw', function (provider, base) {
	    return function (path) {
	      provider.execute(function () {
	        var self = {
	          up: function up() {
	            if (self.instance) {
	              var canvas = base.getCanvas();
	              canvas.add(this.instance);
	            } else {
	              path.borderColor = "rgba(201,201,201,0.2)";
	              path.cornerColor = "rgba(193,193,193,0.8)";
	              path.transparentCorners = false;
	              path.hasRotatingPoint = false;
	              this.instance = path;
	            }
	          },

	          down: function down() {
	            var canvas = base.getCanvas();
	            canvas.remove(this.instance);
	          }
	        };

	        return self;
	      });
	    };
	  });
	};

	exports.default = FreeDraw;

/***/ }),
/* 94 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* eslint no-underscore-dangle: ["error", { "allow": ["_originalElement"] }] */
	/* global _ */

	var Blur = function Blur(CommandProvider) {
	  CommandProvider.register('blur', function (provider, base, opt) {
	    var blurFilter = function blurFilter(scale) {
	      var pixelate = new base.fabric.Image.filters.Pixelate({
	        blocksize: Math.floor(5 / scale)
	      });
	      return pixelate;
	    };

	    var blurClearSelect = function blurClearSelect() {
	      var blurObjects = base.getBlur();
	      if (blurObjects.mode) {
	        blurObjects.mode.selected = false;
	      }
	      base.getCanvas().remove(blurObjects.el);
	      blurObjects.el = undefined;
	    };

	    var addBlur = function addBlur(rect, callback) {
	      var image = base.getImage();
	      var left = rect.left,
	          top = rect.top,
	          width = rect.width,
	          height = rect.height,
	          scaleX = rect.scaleX,
	          scaleY = rect.scaleY;


	      image.clone(function (img) {
	        var newObject = img;
	        newObject.rect = { width: width, height: height, top: top, left: left, scaleX: scaleX, scaleY: scaleY };
	        newObject.subType = 'blur';
	        // FIXME: refactor
	        newObject.lockRotation = true;
	        newObject.lockMovementX = true;
	        newObject.lockMovementY = true;
	        newObject.lockScalingX = true;
	        newObject.lockScalingY = true;
	        newObject.hasControls = false;
	        newObject.hoverCursor = 'default';
	        newObject.borderColor = 'rgba(255,255,255,0)';

	        newObject.clipTo = function (ctx) {
	          return ctx.rect((-(opt.getImageWidth(image) / 2) + left) / image.scaleX, (-(opt.getImageHeight(image) / 2) + top) / image.scaleY, parseInt(width * scaleX / image.scaleX, 10), parseInt(height * scaleY / image.scaleY, 10));
	        };

	        var filter = blurFilter(Math.max(image.scaleX, image.scaleY));

	        newObject.applyFilters(function () {
	          callback(newObject);
	        }, [filter], image._originalElement);
	      });

	      blurClearSelect();
	      base.getCanvas().renderAll();
	    };

	    var fromObjects = function fromObjects() {
	      var blurObjects = base.getBlur();
	      var image = base.getImage();
	      var eLeft = blurObjects.el.get('left');
	      var eTop = blurObjects.el.get('top');
	      var left = eLeft - image.left;
	      var top = eTop - image.top;
	      var eWidth = blurObjects.el.get('width');
	      var eHeight = blurObjects.el.get('height');
	      var eScaleX = blurObjects.el.get('scaleX');
	      var eScaleY = blurObjects.el.get('scaleY');
	      var width = eWidth * 1;
	      var height = eHeight * 1;
	      return { width: width, height: height, top: top, left: left, scaleX: eScaleX, scaleY: eScaleY };
	    };

	    var blurClick = _.noop;

	    var addBlurRect = function addBlurRect(left, top, width, height) {
	      return opt.createRect({
	        fill: 'rgba(0,0,0,0.3)',
	        originX: 'left',
	        originY: 'top',
	        stroke: '#ccc',
	        strokeDashArray: [2, 2],
	        opacity: 1,
	        top: top,
	        left: left,
	        width: width,
	        height: height,
	        borderColor: '#36fd00',
	        cornerColor: 'green'
	      });
	    };

	    var performBlur = function performBlur(source) {
	      var promise = new Promise(function (resolve, reject) {
	        provider.execute(function () {
	          var self = {
	            init: function init(initCallback) {
	              addBlur(source, function (newObject) {
	                self.instance = newObject;
	                initCallback();
	              });
	            },
	            up: function up() {
	              var addToCanvas = function addToCanvas() {
	                try {
	                  base.getCanvas().add(self.instance);
	                  self.instance.sendToBack();
	                  self.instance.bringForward();
	                } catch (error) {
	                  reject(error);
	                }
	              };

	              if (self.instance) {
	                addToCanvas();
	              } else {
	                self.init(function () {
	                  addToCanvas();
	                  resolve();
	                });
	              }
	            },
	            down: function down() {
	              base.getCanvas().remove(self.instance);
	            }
	          };
	          return self;
	        });
	      });
	      return promise;
	    };

	    var methods = void 0;
	    var blurDraw = function blurDraw(blurMode, event) {
	      var mode = blurMode;
	      var canvas = base.getCanvas();
	      var image = base.getImage();
	      var blurObjects = base.getBlur();

	      if (blurObjects.el) {
	        return null;
	      }

	      blurObjects.object = image;
	      blurObjects.mode = mode;

	      var pointer = canvas.getPointer(event.e);
	      var origX = pointer.x;
	      var origY = pointer.y;

	      var rect = addBlurRect(origX, origY, pointer.x - origX, pointer.y - origY);

	      blurObjects.el = rect;

	      mode.callback = function (ptr) {
	        rect.set({
	          left: origX > ptr.x ? ptr.x : origX,
	          top: origY > ptr.y ? ptr.y : origY,
	          width: Math.abs(origX - ptr.x),
	          height: Math.abs(origY - ptr.y)
	        });
	        canvas.remove(rect);
	        canvas.add(rect);
	      };

	      mode.unset = function () {
	        canvas.remove(rect);
	        canvas.add(rect);
	        canvas.renderAll();
	        methods.apply();
	      };

	      canvas.add(rect);
	      return rect;
	    };

	    methods = {
	      draw: blurDraw,
	      click: blurClick,
	      cancel: blurClearSelect,
	      addBlur: performBlur,
	      apply: function apply() {
	        return performBlur(fromObjects());
	      }
	    };
	    return methods;
	  });
	};

	exports.default = Blur;

/***/ }),
/* 95 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* global _ */

	var getImageDimension = function getImageDimension(name, image, current) {
	  if (_.include([90, 270, -90, -270], image.angle)) {
	    name = name === "height" ? "width" : "height";
	  }

	  var dimensions = image._calculateCurrentDimensions();

	  if (current) {
	    return dimensions[name === "height" ? "y" : "x"];
	  }
	  return image[name];
	};

	var getImageHeight = function getImageHeight(image, original) {
	  if (original) {
	    return getImageDimension("height", image);
	  }
	  return getImageDimension("height", image, true) || getImageDimension("height", image);
	};

	var getImageWidth = function getImageWidth(image, original) {
	  if (original) {
	    return getImageDimension("width", image);
	  }
	  return getImageDimension("width", image, true) || getImageDimension("width", image);
	};

	var getHeight = function getHeight(canvas) {
	  return Math.min.apply(Math, [100, canvas.height / 2]);
	};

	var getWidth = function getWidth(canvas) {
	  return Math.min.apply(Math, [100, canvas.width / 2]);
	};

	var getTop = function getTop(canvas) {
	  return canvas.height / 3;
	};

	var getLeft = function getLeft(canvas) {
	  return canvas.width / 2;
	};

	var getMaxFromArray = function getMaxFromArray(arr) {
	  return Math.max.apply(null, arr);
	};

	var getMinFromArray = function getMinFromArray(arr) {
	  return Math.min.apply(null, arr);
	};

	var getObjectHeight = function getObjectHeight(el) {
	  if (el.type !== "path") {
	    return el.getHeight() + el.getStrokeWidth();
	  }
	  return Math.sin(el.getAngle() / 180 * Math.PI) * (el.getWidth() + el.getStrokeWidth());
	};

	var getObjectWidth = function getObjectWidth(el) {
	  if (el.type !== "path") {
	    return el.getWidth() + el.getStrokeWidth();
	  }
	  return Math.cos(el.getAngle() / 180 * Math.PI) * (el.getWidth() + el.getStrokeWidth());
	};

	var getTopPoint = function getTopPoint(canvas) {
	  return getPosition(canvas, function (el) {
	    return Math.min(el.getTop(), el.getTop() + getObjectHeight(el));
	  }, getMinFromArray, -1);
	};

	var getBottomPoint = function getBottomPoint(canvas) {
	  return getPosition(canvas, function (el) {
	    return Math.max(el.getTop(), el.getTop() + getObjectHeight(el));
	  }, getMaxFromArray, 1);
	};

	var getLeftPoint = function getLeftPoint(canvas) {
	  return getPosition(canvas, function (el) {
	    return Math.min(el.getLeft(), el.getLeft() + getObjectWidth(el));
	  }, getMinFromArray, -1);
	};

	var getRightPoint = function getRightPoint(canvas) {
	  return getPosition(canvas, function (el) {
	    return Math.max(el.getLeft(), el.getLeft() + getObjectWidth(el));
	  }, getMaxFromArray, 1);
	};

	var getPosition = function getPosition(canvas, aggr, finalize, margin) {
	  var elements = canvas.getObjects().map(function (el) {
	    var m = 2 * margin;
	    if (el.type === 'image') {
	      m = 0;
	    }
	    return aggr(el) + m;
	  });
	  return finalize(elements);
	};

	var newDimension = function newDimension(el, newCords) {
	  var dimension = {
	    top: el.top,
	    left: el.left,
	    width: el.width,
	    height: el.height
	  };
	  switch (el.__corner) {
	    case 'br':
	      if (newCords.x - el.left >= 0) {
	        dimension.width = newCords.x - el.left;
	      }
	      if (newCords.y - el.top >= 0) {
	        dimension.height = newCords.y - el.top;
	      }
	      break;
	    case 'bl':
	      if (el.oCoords.tr.x >= newCords.x) {
	        dimension.left = newCords.x;
	        dimension.width = el.oCoords.tr.x - newCords.x;
	      }
	      if (newCords.y >= el.oCoords.tl.y) {
	        dimension.height = newCords.y - el.oCoords.tl.y;
	      }
	      break;
	    case 'tl':
	      if (el.oCoords.tr.x >= newCords.x) {
	        dimension.left = newCords.x;
	        dimension.width = el.oCoords.tr.x - newCords.x;
	      }
	      if (el.oCoords.br.y >= newCords.y) {
	        dimension.top = newCords.y;
	        dimension.height = el.oCoords.br.y - newCords.y;
	      }
	      break;
	    case 'tr':
	      if (newCords.x - el.left >= 0) {
	        dimension.width = newCords.x - el.left;
	      }
	      if (el.oCoords.br.y >= newCords.y) {
	        dimension.top = newCords.y;
	        dimension.height = el.oCoords.br.y - newCords.y;
	      }
	      break;
	    default:
	      break;
	  }
	  return dimension;
	};

	var roundAngle = function roundAngle(angle) {
	  var base = 45;
	  return Math.floor(angle / base) * base;
	};

	var util = {
	  getImageDimension: getImageDimension,
	  getImageHeight: getImageHeight,
	  getImageWidth: getImageWidth,
	  getHeight: getHeight,
	  getWidth: getWidth,
	  getLeft: getLeft,
	  getTop: getTop,
	  getRightPoint: getRightPoint,
	  getLeftPoint: getLeftPoint,
	  getTopPoint: getTopPoint,
	  getBottomPoint: getBottomPoint,
	  newDimension: newDimension,
	  roundAngle: roundAngle
	};

	exports.default = util;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _rotateImage = __webpack_require__(97);

	var _rotateImage2 = _interopRequireDefault(_rotateImage);

	var _q = __webpack_require__(98);

	var _q2 = _interopRequireDefault(_q);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/* global window, EXIF, XMLHttpRequest */

	var imageLoader = function imageLoader(url, callbacks) {
	  callbacks = callbacks || {};

	  var deferred = _q2.default.defer();

	  var xhr = new XMLHttpRequest();
	  xhr.open("GET", url, true);

	  xhr.addEventListener("load", function (event) {
	    if (callbacks.load) {
	      callbacks.load(event);
	    }
	    var img = new window.Image();
	    img.src = window.URL.createObjectURL(event.target.response);

	    img.onload = function () {
	      EXIF.getData(img, function () {
	        var orientation = EXIF.getTag(this, "Orientation");
	        if (!orientation) {
	          return deferred.resolve({ image: img });
	        }

	        (0, _rotateImage2.default)(img, orientation).then(function (rotatedImg) {
	          deferred.resolve({
	            image: rotatedImg,
	            orientation: orientation
	          });
	        });
	      });
	    };
	  });

	  xhr.addEventListener("progress", function (event) {
	    if (callbacks.progress) {
	      callbacks.progress(event);
	    }
	  });

	  xhr.responseType = "blob";
	  xhr.send();

	  return deferred.promise;
	};

	exports.default = imageLoader;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _q = __webpack_require__(98);

	var _q2 = _interopRequireDefault(_q);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var getRotationData = function getRotationData(orientation) {
	  var _super = function _super(options) {
	    var params = {
	      angle: 0,
	      translateX: 0,
	      translateY: 0,
	      width: options.width,
	      height: options.height,
	      originalWidth: options.width,
	      originalHeight: options.height,
	      difference: Math.abs(options.width - options.height),
	      max: _.max([options.height, options.width]),
	      destX: 0,
	      destY: 0,
	      sourceX: 0,
	      sourceY: 0
	    };

	    params.translateX = params.max / 2;
	    params.translateY = params.max / 2;

	    return params;
	  };

	  var lambda = _.noop;

	  switch (orientation) {
	    case 3:
	      lambda = function lambda(options) {
	        var params = _.merge(_super(options), {
	          angle: Math.PI
	        });

	        if (params.originalWidth > params.originalHeight) {
	          params.destY = params.difference;
	        }

	        return params;
	      };
	      break;

	    case 6:
	      lambda = function lambda(options) {
	        var params = _.merge(_super(options), {
	          angle: Math.PI / 2,
	          height: options.width,
	          width: options.height
	        });

	        if (params.originalHeight < params.originalWidth) {
	          params.destY = params.difference;
	        }

	        return params;
	      };
	      break;

	    case 8:
	      lambda = function lambda(options) {
	        var params = _.merge(_super(options), {
	          angle: -Math.PI / 2,
	          height: options.width,
	          width: options.height
	        });

	        if (params.originalHeight > params.originalWidth) {
	          params.destX = params.difference;
	        }

	        return params;
	      };
	      break;
	  }

	  return lambda;
	}; /* global document, _ */


	var rotateImage = function rotateImage(img, orientation) {
	  var deferred = _q2.default.defer();

	  var options = { height: img.height, width: img.width };
	  var params = getRotationData(orientation)(options);

	  if (!params) {
	    deferred.resolve(img);
	    return deferred.promise;
	  }

	  var canvas = document.createElement('canvas');

	  canvas.width = params.width;
	  canvas.height = params.height;
	  var max = params.max;

	  var ctx = canvas.getContext('2d');

	  ctx.drawImage(img, 0, 0);

	  ctx.save();
	  ctx.clearRect(0, 0, max, max);

	  ctx.translate(max / 2, max / 2);
	  ctx.rotate(params.angle);
	  ctx.translate(-max / 2, -max / 2);

	  ctx.drawImage(img, params.sourceX, params.sourceY, params.originalWidth, params.originalHeight, params.destX, params.destY, params.originalWidth, params.originalHeight);
	  ctx.restore();
	  deferred.resolve(canvas);

	  return deferred.promise;
	};

	exports.default = rotateImage;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, setImmediate) {// vim:ts=4:sts=4:sw=4:
	/*!
	 *
	 * Copyright 2009-2012 Kris Kowal under the terms of the MIT
	 * license found at http://github.com/kriskowal/q/raw/master/LICENSE
	 *
	 * With parts by Tyler Close
	 * Copyright 2007-2009 Tyler Close under the terms of the MIT X license found
	 * at http://www.opensource.org/licenses/mit-license.html
	 * Forked at ref_send.js version: 2009-05-11
	 *
	 * With parts by Mark Miller
	 * Copyright (C) 2011 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 */

	(function (definition) {
	    "use strict";

	    // This file will function properly as a <script> tag, or a module
	    // using CommonJS and NodeJS or RequireJS module formats.  In
	    // Common/Node/RequireJS, the module exports the Q API and when
	    // executed as a simple <script>, it creates a Q global instead.

	    // Montage Require
	    if (typeof bootstrap === "function") {
	        bootstrap("promise", definition);

	    // CommonJS
	    } else if (true) {
	        module.exports = definition();

	    // RequireJS
	    } else if (typeof define === "function" && define.amd) {
	        define(definition);

	    // SES (Secure EcmaScript)
	    } else if (typeof ses !== "undefined") {
	        if (!ses.ok()) {
	            return;
	        } else {
	            ses.makeQ = definition;
	        }

	    // <script>
	    } else if (typeof window !== "undefined" || typeof self !== "undefined") {
	        // Prefer window over self for add-on scripts. Use self for
	        // non-windowed contexts.
	        var global = typeof window !== "undefined" ? window : self;

	        // Get the `window` object, save the previous Q global
	        // and initialize Q as a global.
	        var previousQ = global.Q;
	        global.Q = definition();

	        // Add a noConflict function so Q can be removed from the
	        // global namespace.
	        global.Q.noConflict = function () {
	            global.Q = previousQ;
	            return this;
	        };

	    } else {
	        throw new Error("This environment was not anticipated by Q. Please file a bug.");
	    }

	})(function () {
	"use strict";

	var hasStacks = false;
	try {
	    throw new Error();
	} catch (e) {
	    hasStacks = !!e.stack;
	}

	// All code after this point will be filtered from stack traces reported
	// by Q.
	var qStartingLine = captureLine();
	var qFileName;

	// shims

	// used for fallback in "allResolved"
	var noop = function () {};

	// Use the fastest possible means to execute a task in a future turn
	// of the event loop.
	var nextTick =(function () {
	    // linked list of tasks (single, with head node)
	    var head = {task: void 0, next: null};
	    var tail = head;
	    var flushing = false;
	    var requestTick = void 0;
	    var isNodeJS = false;
	    // queue for late tasks, used by unhandled rejection tracking
	    var laterQueue = [];

	    function flush() {
	        /* jshint loopfunc: true */
	        var task, domain;

	        while (head.next) {
	            head = head.next;
	            task = head.task;
	            head.task = void 0;
	            domain = head.domain;

	            if (domain) {
	                head.domain = void 0;
	                domain.enter();
	            }
	            runSingle(task, domain);

	        }
	        while (laterQueue.length) {
	            task = laterQueue.pop();
	            runSingle(task);
	        }
	        flushing = false;
	    }
	    // runs a single function in the async queue
	    function runSingle(task, domain) {
	        try {
	            task();

	        } catch (e) {
	            if (isNodeJS) {
	                // In node, uncaught exceptions are considered fatal errors.
	                // Re-throw them synchronously to interrupt flushing!

	                // Ensure continuation if the uncaught exception is suppressed
	                // listening "uncaughtException" events (as domains does).
	                // Continue in next event to avoid tick recursion.
	                if (domain) {
	                    domain.exit();
	                }
	                setTimeout(flush, 0);
	                if (domain) {
	                    domain.enter();
	                }

	                throw e;

	            } else {
	                // In browsers, uncaught exceptions are not fatal.
	                // Re-throw them asynchronously to avoid slow-downs.
	                setTimeout(function () {
	                    throw e;
	                }, 0);
	            }
	        }

	        if (domain) {
	            domain.exit();
	        }
	    }

	    nextTick = function (task) {
	        tail = tail.next = {
	            task: task,
	            domain: isNodeJS && process.domain,
	            next: null
	        };

	        if (!flushing) {
	            flushing = true;
	            requestTick();
	        }
	    };

	    if (typeof process === "object" &&
	        process.toString() === "[object process]" && process.nextTick) {
	        // Ensure Q is in a real Node environment, with a `process.nextTick`.
	        // To see through fake Node environments:
	        // * Mocha test runner - exposes a `process` global without a `nextTick`
	        // * Browserify - exposes a `process.nexTick` function that uses
	        //   `setTimeout`. In this case `setImmediate` is preferred because
	        //    it is faster. Browserify's `process.toString()` yields
	        //   "[object Object]", while in a real Node environment
	        //   `process.nextTick()` yields "[object process]".
	        isNodeJS = true;

	        requestTick = function () {
	            process.nextTick(flush);
	        };

	    } else if (typeof setImmediate === "function") {
	        // In IE10, Node.js 0.9+, or https://github.com/NobleJS/setImmediate
	        if (typeof window !== "undefined") {
	            requestTick = setImmediate.bind(window, flush);
	        } else {
	            requestTick = function () {
	                setImmediate(flush);
	            };
	        }

	    } else if (typeof MessageChannel !== "undefined") {
	        // modern browsers
	        // http://www.nonblocking.io/2011/06/windownexttick.html
	        var channel = new MessageChannel();
	        // At least Safari Version 6.0.5 (8536.30.1) intermittently cannot create
	        // working message ports the first time a page loads.
	        channel.port1.onmessage = function () {
	            requestTick = requestPortTick;
	            channel.port1.onmessage = flush;
	            flush();
	        };
	        var requestPortTick = function () {
	            // Opera requires us to provide a message payload, regardless of
	            // whether we use it.
	            channel.port2.postMessage(0);
	        };
	        requestTick = function () {
	            setTimeout(flush, 0);
	            requestPortTick();
	        };

	    } else {
	        // old browsers
	        requestTick = function () {
	            setTimeout(flush, 0);
	        };
	    }
	    // runs a task after all other tasks have been run
	    // this is useful for unhandled rejection tracking that needs to happen
	    // after all `then`d tasks have been run.
	    nextTick.runAfter = function (task) {
	        laterQueue.push(task);
	        if (!flushing) {
	            flushing = true;
	            requestTick();
	        }
	    };
	    return nextTick;
	})();

	// Attempt to make generics safe in the face of downstream
	// modifications.
	// There is no situation where this is necessary.
	// If you need a security guarantee, these primordials need to be
	// deeply frozen anyway, and if you don’t need a security guarantee,
	// this is just plain paranoid.
	// However, this **might** have the nice side-effect of reducing the size of
	// the minified code by reducing x.call() to merely x()
	// See Mark Miller’s explanation of what this does.
	// http://wiki.ecmascript.org/doku.php?id=conventions:safe_meta_programming
	var call = Function.call;
	function uncurryThis(f) {
	    return function () {
	        return call.apply(f, arguments);
	    };
	}
	// This is equivalent, but slower:
	// uncurryThis = Function_bind.bind(Function_bind.call);
	// http://jsperf.com/uncurrythis

	var array_slice = uncurryThis(Array.prototype.slice);

	var array_reduce = uncurryThis(
	    Array.prototype.reduce || function (callback, basis) {
	        var index = 0,
	            length = this.length;
	        // concerning the initial value, if one is not provided
	        if (arguments.length === 1) {
	            // seek to the first value in the array, accounting
	            // for the possibility that is is a sparse array
	            do {
	                if (index in this) {
	                    basis = this[index++];
	                    break;
	                }
	                if (++index >= length) {
	                    throw new TypeError();
	                }
	            } while (1);
	        }
	        // reduce
	        for (; index < length; index++) {
	            // account for the possibility that the array is sparse
	            if (index in this) {
	                basis = callback(basis, this[index], index);
	            }
	        }
	        return basis;
	    }
	);

	var array_indexOf = uncurryThis(
	    Array.prototype.indexOf || function (value) {
	        // not a very good shim, but good enough for our one use of it
	        for (var i = 0; i < this.length; i++) {
	            if (this[i] === value) {
	                return i;
	            }
	        }
	        return -1;
	    }
	);

	var array_map = uncurryThis(
	    Array.prototype.map || function (callback, thisp) {
	        var self = this;
	        var collect = [];
	        array_reduce(self, function (undefined, value, index) {
	            collect.push(callback.call(thisp, value, index, self));
	        }, void 0);
	        return collect;
	    }
	);

	var object_create = Object.create || function (prototype) {
	    function Type() { }
	    Type.prototype = prototype;
	    return new Type();
	};

	var object_hasOwnProperty = uncurryThis(Object.prototype.hasOwnProperty);

	var object_keys = Object.keys || function (object) {
	    var keys = [];
	    for (var key in object) {
	        if (object_hasOwnProperty(object, key)) {
	            keys.push(key);
	        }
	    }
	    return keys;
	};

	var object_toString = uncurryThis(Object.prototype.toString);

	function isObject(value) {
	    return value === Object(value);
	}

	// generator related shims

	// FIXME: Remove this function once ES6 generators are in SpiderMonkey.
	function isStopIteration(exception) {
	    return (
	        object_toString(exception) === "[object StopIteration]" ||
	        exception instanceof QReturnValue
	    );
	}

	// FIXME: Remove this helper and Q.return once ES6 generators are in
	// SpiderMonkey.
	var QReturnValue;
	if (typeof ReturnValue !== "undefined") {
	    QReturnValue = ReturnValue;
	} else {
	    QReturnValue = function (value) {
	        this.value = value;
	    };
	}

	// long stack traces

	var STACK_JUMP_SEPARATOR = "From previous event:";

	function makeStackTraceLong(error, promise) {
	    // If possible, transform the error stack trace by removing Node and Q
	    // cruft, then concatenating with the stack trace of `promise`. See #57.
	    if (hasStacks &&
	        promise.stack &&
	        typeof error === "object" &&
	        error !== null &&
	        error.stack &&
	        error.stack.indexOf(STACK_JUMP_SEPARATOR) === -1
	    ) {
	        var stacks = [];
	        for (var p = promise; !!p; p = p.source) {
	            if (p.stack) {
	                stacks.unshift(p.stack);
	            }
	        }
	        stacks.unshift(error.stack);

	        var concatedStacks = stacks.join("\n" + STACK_JUMP_SEPARATOR + "\n");
	        error.stack = filterStackString(concatedStacks);
	    }
	}

	function filterStackString(stackString) {
	    var lines = stackString.split("\n");
	    var desiredLines = [];
	    for (var i = 0; i < lines.length; ++i) {
	        var line = lines[i];

	        if (!isInternalFrame(line) && !isNodeFrame(line) && line) {
	            desiredLines.push(line);
	        }
	    }
	    return desiredLines.join("\n");
	}

	function isNodeFrame(stackLine) {
	    return stackLine.indexOf("(module.js:") !== -1 ||
	           stackLine.indexOf("(node.js:") !== -1;
	}

	function getFileNameAndLineNumber(stackLine) {
	    // Named functions: "at functionName (filename:lineNumber:columnNumber)"
	    // In IE10 function name can have spaces ("Anonymous function") O_o
	    var attempt1 = /at .+ \((.+):(\d+):(?:\d+)\)$/.exec(stackLine);
	    if (attempt1) {
	        return [attempt1[1], Number(attempt1[2])];
	    }

	    // Anonymous functions: "at filename:lineNumber:columnNumber"
	    var attempt2 = /at ([^ ]+):(\d+):(?:\d+)$/.exec(stackLine);
	    if (attempt2) {
	        return [attempt2[1], Number(attempt2[2])];
	    }

	    // Firefox style: "function@filename:lineNumber or @filename:lineNumber"
	    var attempt3 = /.*@(.+):(\d+)$/.exec(stackLine);
	    if (attempt3) {
	        return [attempt3[1], Number(attempt3[2])];
	    }
	}

	function isInternalFrame(stackLine) {
	    var fileNameAndLineNumber = getFileNameAndLineNumber(stackLine);

	    if (!fileNameAndLineNumber) {
	        return false;
	    }

	    var fileName = fileNameAndLineNumber[0];
	    var lineNumber = fileNameAndLineNumber[1];

	    return fileName === qFileName &&
	        lineNumber >= qStartingLine &&
	        lineNumber <= qEndingLine;
	}

	// discover own file name and line number range for filtering stack
	// traces
	function captureLine() {
	    if (!hasStacks) {
	        return;
	    }

	    try {
	        throw new Error();
	    } catch (e) {
	        var lines = e.stack.split("\n");
	        var firstLine = lines[0].indexOf("@") > 0 ? lines[1] : lines[2];
	        var fileNameAndLineNumber = getFileNameAndLineNumber(firstLine);
	        if (!fileNameAndLineNumber) {
	            return;
	        }

	        qFileName = fileNameAndLineNumber[0];
	        return fileNameAndLineNumber[1];
	    }
	}

	function deprecate(callback, name, alternative) {
	    return function () {
	        if (typeof console !== "undefined" &&
	            typeof console.warn === "function") {
	            console.warn(name + " is deprecated, use " + alternative +
	                         " instead.", new Error("").stack);
	        }
	        return callback.apply(callback, arguments);
	    };
	}

	// end of shims
	// beginning of real work

	/**
	 * Constructs a promise for an immediate reference, passes promises through, or
	 * coerces promises from different systems.
	 * @param value immediate reference or promise
	 */
	function Q(value) {
	    // If the object is already a Promise, return it directly.  This enables
	    // the resolve function to both be used to created references from objects,
	    // but to tolerably coerce non-promises to promises.
	    if (value instanceof Promise) {
	        return value;
	    }

	    // assimilate thenables
	    if (isPromiseAlike(value)) {
	        return coerce(value);
	    } else {
	        return fulfill(value);
	    }
	}
	Q.resolve = Q;

	/**
	 * Performs a task in a future turn of the event loop.
	 * @param {Function} task
	 */
	Q.nextTick = nextTick;

	/**
	 * Controls whether or not long stack traces will be on
	 */
	Q.longStackSupport = false;

	// enable long stacks if Q_DEBUG is set
	if (typeof process === "object" && process && process.env && process.env.Q_DEBUG) {
	    Q.longStackSupport = true;
	}

	/**
	 * Constructs a {promise, resolve, reject} object.
	 *
	 * `resolve` is a callback to invoke with a more resolved value for the
	 * promise. To fulfill the promise, invoke `resolve` with any value that is
	 * not a thenable. To reject the promise, invoke `resolve` with a rejected
	 * thenable, or invoke `reject` with the reason directly. To resolve the
	 * promise to another thenable, thus putting it in the same state, invoke
	 * `resolve` with that other thenable.
	 */
	Q.defer = defer;
	function defer() {
	    // if "messages" is an "Array", that indicates that the promise has not yet
	    // been resolved.  If it is "undefined", it has been resolved.  Each
	    // element of the messages array is itself an array of complete arguments to
	    // forward to the resolved promise.  We coerce the resolution value to a
	    // promise using the `resolve` function because it handles both fully
	    // non-thenable values and other thenables gracefully.
	    var messages = [], progressListeners = [], resolvedPromise;

	    var deferred = object_create(defer.prototype);
	    var promise = object_create(Promise.prototype);

	    promise.promiseDispatch = function (resolve, op, operands) {
	        var args = array_slice(arguments);
	        if (messages) {
	            messages.push(args);
	            if (op === "when" && operands[1]) { // progress operand
	                progressListeners.push(operands[1]);
	            }
	        } else {
	            Q.nextTick(function () {
	                resolvedPromise.promiseDispatch.apply(resolvedPromise, args);
	            });
	        }
	    };

	    // XXX deprecated
	    promise.valueOf = function () {
	        if (messages) {
	            return promise;
	        }
	        var nearerValue = nearer(resolvedPromise);
	        if (isPromise(nearerValue)) {
	            resolvedPromise = nearerValue; // shorten chain
	        }
	        return nearerValue;
	    };

	    promise.inspect = function () {
	        if (!resolvedPromise) {
	            return { state: "pending" };
	        }
	        return resolvedPromise.inspect();
	    };

	    if (Q.longStackSupport && hasStacks) {
	        try {
	            throw new Error();
	        } catch (e) {
	            // NOTE: don't try to use `Error.captureStackTrace` or transfer the
	            // accessor around; that causes memory leaks as per GH-111. Just
	            // reify the stack trace as a string ASAP.
	            //
	            // At the same time, cut off the first line; it's always just
	            // "[object Promise]\n", as per the `toString`.
	            promise.stack = e.stack.substring(e.stack.indexOf("\n") + 1);
	        }
	    }

	    // NOTE: we do the checks for `resolvedPromise` in each method, instead of
	    // consolidating them into `become`, since otherwise we'd create new
	    // promises with the lines `become(whatever(value))`. See e.g. GH-252.

	    function become(newPromise) {
	        resolvedPromise = newPromise;
	        promise.source = newPromise;

	        array_reduce(messages, function (undefined, message) {
	            Q.nextTick(function () {
	                newPromise.promiseDispatch.apply(newPromise, message);
	            });
	        }, void 0);

	        messages = void 0;
	        progressListeners = void 0;
	    }

	    deferred.promise = promise;
	    deferred.resolve = function (value) {
	        if (resolvedPromise) {
	            return;
	        }

	        become(Q(value));
	    };

	    deferred.fulfill = function (value) {
	        if (resolvedPromise) {
	            return;
	        }

	        become(fulfill(value));
	    };
	    deferred.reject = function (reason) {
	        if (resolvedPromise) {
	            return;
	        }

	        become(reject(reason));
	    };
	    deferred.notify = function (progress) {
	        if (resolvedPromise) {
	            return;
	        }

	        array_reduce(progressListeners, function (undefined, progressListener) {
	            Q.nextTick(function () {
	                progressListener(progress);
	            });
	        }, void 0);
	    };

	    return deferred;
	}

	/**
	 * Creates a Node-style callback that will resolve or reject the deferred
	 * promise.
	 * @returns a nodeback
	 */
	defer.prototype.makeNodeResolver = function () {
	    var self = this;
	    return function (error, value) {
	        if (error) {
	            self.reject(error);
	        } else if (arguments.length > 2) {
	            self.resolve(array_slice(arguments, 1));
	        } else {
	            self.resolve(value);
	        }
	    };
	};

	/**
	 * @param resolver {Function} a function that returns nothing and accepts
	 * the resolve, reject, and notify functions for a deferred.
	 * @returns a promise that may be resolved with the given resolve and reject
	 * functions, or rejected by a thrown exception in resolver
	 */
	Q.Promise = promise; // ES6
	Q.promise = promise;
	function promise(resolver) {
	    if (typeof resolver !== "function") {
	        throw new TypeError("resolver must be a function.");
	    }
	    var deferred = defer();
	    try {
	        resolver(deferred.resolve, deferred.reject, deferred.notify);
	    } catch (reason) {
	        deferred.reject(reason);
	    }
	    return deferred.promise;
	}

	promise.race = race; // ES6
	promise.all = all; // ES6
	promise.reject = reject; // ES6
	promise.resolve = Q; // ES6

	// XXX experimental.  This method is a way to denote that a local value is
	// serializable and should be immediately dispatched to a remote upon request,
	// instead of passing a reference.
	Q.passByCopy = function (object) {
	    //freeze(object);
	    //passByCopies.set(object, true);
	    return object;
	};

	Promise.prototype.passByCopy = function () {
	    //freeze(object);
	    //passByCopies.set(object, true);
	    return this;
	};

	/**
	 * If two promises eventually fulfill to the same value, promises that value,
	 * but otherwise rejects.
	 * @param x {Any*}
	 * @param y {Any*}
	 * @returns {Any*} a promise for x and y if they are the same, but a rejection
	 * otherwise.
	 *
	 */
	Q.join = function (x, y) {
	    return Q(x).join(y);
	};

	Promise.prototype.join = function (that) {
	    return Q([this, that]).spread(function (x, y) {
	        if (x === y) {
	            // TODO: "===" should be Object.is or equiv
	            return x;
	        } else {
	            throw new Error("Can't join: not the same: " + x + " " + y);
	        }
	    });
	};

	/**
	 * Returns a promise for the first of an array of promises to become settled.
	 * @param answers {Array[Any*]} promises to race
	 * @returns {Any*} the first promise to be settled
	 */
	Q.race = race;
	function race(answerPs) {
	    return promise(function (resolve, reject) {
	        // Switch to this once we can assume at least ES5
	        // answerPs.forEach(function (answerP) {
	        //     Q(answerP).then(resolve, reject);
	        // });
	        // Use this in the meantime
	        for (var i = 0, len = answerPs.length; i < len; i++) {
	            Q(answerPs[i]).then(resolve, reject);
	        }
	    });
	}

	Promise.prototype.race = function () {
	    return this.then(Q.race);
	};

	/**
	 * Constructs a Promise with a promise descriptor object and optional fallback
	 * function.  The descriptor contains methods like when(rejected), get(name),
	 * set(name, value), post(name, args), and delete(name), which all
	 * return either a value, a promise for a value, or a rejection.  The fallback
	 * accepts the operation name, a resolver, and any further arguments that would
	 * have been forwarded to the appropriate method above had a method been
	 * provided with the proper name.  The API makes no guarantees about the nature
	 * of the returned object, apart from that it is usable whereever promises are
	 * bought and sold.
	 */
	Q.makePromise = Promise;
	function Promise(descriptor, fallback, inspect) {
	    if (fallback === void 0) {
	        fallback = function (op) {
	            return reject(new Error(
	                "Promise does not support operation: " + op
	            ));
	        };
	    }
	    if (inspect === void 0) {
	        inspect = function () {
	            return {state: "unknown"};
	        };
	    }

	    var promise = object_create(Promise.prototype);

	    promise.promiseDispatch = function (resolve, op, args) {
	        var result;
	        try {
	            if (descriptor[op]) {
	                result = descriptor[op].apply(promise, args);
	            } else {
	                result = fallback.call(promise, op, args);
	            }
	        } catch (exception) {
	            result = reject(exception);
	        }
	        if (resolve) {
	            resolve(result);
	        }
	    };

	    promise.inspect = inspect;

	    // XXX deprecated `valueOf` and `exception` support
	    if (inspect) {
	        var inspected = inspect();
	        if (inspected.state === "rejected") {
	            promise.exception = inspected.reason;
	        }

	        promise.valueOf = function () {
	            var inspected = inspect();
	            if (inspected.state === "pending" ||
	                inspected.state === "rejected") {
	                return promise;
	            }
	            return inspected.value;
	        };
	    }

	    return promise;
	}

	Promise.prototype.toString = function () {
	    return "[object Promise]";
	};

	Promise.prototype.then = function (fulfilled, rejected, progressed) {
	    var self = this;
	    var deferred = defer();
	    var done = false;   // ensure the untrusted promise makes at most a
	                        // single call to one of the callbacks

	    function _fulfilled(value) {
	        try {
	            return typeof fulfilled === "function" ? fulfilled(value) : value;
	        } catch (exception) {
	            return reject(exception);
	        }
	    }

	    function _rejected(exception) {
	        if (typeof rejected === "function") {
	            makeStackTraceLong(exception, self);
	            try {
	                return rejected(exception);
	            } catch (newException) {
	                return reject(newException);
	            }
	        }
	        return reject(exception);
	    }

	    function _progressed(value) {
	        return typeof progressed === "function" ? progressed(value) : value;
	    }

	    Q.nextTick(function () {
	        self.promiseDispatch(function (value) {
	            if (done) {
	                return;
	            }
	            done = true;

	            deferred.resolve(_fulfilled(value));
	        }, "when", [function (exception) {
	            if (done) {
	                return;
	            }
	            done = true;

	            deferred.resolve(_rejected(exception));
	        }]);
	    });

	    // Progress propagator need to be attached in the current tick.
	    self.promiseDispatch(void 0, "when", [void 0, function (value) {
	        var newValue;
	        var threw = false;
	        try {
	            newValue = _progressed(value);
	        } catch (e) {
	            threw = true;
	            if (Q.onerror) {
	                Q.onerror(e);
	            } else {
	                throw e;
	            }
	        }

	        if (!threw) {
	            deferred.notify(newValue);
	        }
	    }]);

	    return deferred.promise;
	};

	Q.tap = function (promise, callback) {
	    return Q(promise).tap(callback);
	};

	/**
	 * Works almost like "finally", but not called for rejections.
	 * Original resolution value is passed through callback unaffected.
	 * Callback may return a promise that will be awaited for.
	 * @param {Function} callback
	 * @returns {Q.Promise}
	 * @example
	 * doSomething()
	 *   .then(...)
	 *   .tap(console.log)
	 *   .then(...);
	 */
	Promise.prototype.tap = function (callback) {
	    callback = Q(callback);

	    return this.then(function (value) {
	        return callback.fcall(value).thenResolve(value);
	    });
	};

	/**
	 * Registers an observer on a promise.
	 *
	 * Guarantees:
	 *
	 * 1. that fulfilled and rejected will be called only once.
	 * 2. that either the fulfilled callback or the rejected callback will be
	 *    called, but not both.
	 * 3. that fulfilled and rejected will not be called in this turn.
	 *
	 * @param value      promise or immediate reference to observe
	 * @param fulfilled  function to be called with the fulfilled value
	 * @param rejected   function to be called with the rejection exception
	 * @param progressed function to be called on any progress notifications
	 * @return promise for the return value from the invoked callback
	 */
	Q.when = when;
	function when(value, fulfilled, rejected, progressed) {
	    return Q(value).then(fulfilled, rejected, progressed);
	}

	Promise.prototype.thenResolve = function (value) {
	    return this.then(function () { return value; });
	};

	Q.thenResolve = function (promise, value) {
	    return Q(promise).thenResolve(value);
	};

	Promise.prototype.thenReject = function (reason) {
	    return this.then(function () { throw reason; });
	};

	Q.thenReject = function (promise, reason) {
	    return Q(promise).thenReject(reason);
	};

	/**
	 * If an object is not a promise, it is as "near" as possible.
	 * If a promise is rejected, it is as "near" as possible too.
	 * If it’s a fulfilled promise, the fulfillment value is nearer.
	 * If it’s a deferred promise and the deferred has been resolved, the
	 * resolution is "nearer".
	 * @param object
	 * @returns most resolved (nearest) form of the object
	 */

	// XXX should we re-do this?
	Q.nearer = nearer;
	function nearer(value) {
	    if (isPromise(value)) {
	        var inspected = value.inspect();
	        if (inspected.state === "fulfilled") {
	            return inspected.value;
	        }
	    }
	    return value;
	}

	/**
	 * @returns whether the given object is a promise.
	 * Otherwise it is a fulfilled value.
	 */
	Q.isPromise = isPromise;
	function isPromise(object) {
	    return object instanceof Promise;
	}

	Q.isPromiseAlike = isPromiseAlike;
	function isPromiseAlike(object) {
	    return isObject(object) && typeof object.then === "function";
	}

	/**
	 * @returns whether the given object is a pending promise, meaning not
	 * fulfilled or rejected.
	 */
	Q.isPending = isPending;
	function isPending(object) {
	    return isPromise(object) && object.inspect().state === "pending";
	}

	Promise.prototype.isPending = function () {
	    return this.inspect().state === "pending";
	};

	/**
	 * @returns whether the given object is a value or fulfilled
	 * promise.
	 */
	Q.isFulfilled = isFulfilled;
	function isFulfilled(object) {
	    return !isPromise(object) || object.inspect().state === "fulfilled";
	}

	Promise.prototype.isFulfilled = function () {
	    return this.inspect().state === "fulfilled";
	};

	/**
	 * @returns whether the given object is a rejected promise.
	 */
	Q.isRejected = isRejected;
	function isRejected(object) {
	    return isPromise(object) && object.inspect().state === "rejected";
	}

	Promise.prototype.isRejected = function () {
	    return this.inspect().state === "rejected";
	};

	//// BEGIN UNHANDLED REJECTION TRACKING

	// This promise library consumes exceptions thrown in handlers so they can be
	// handled by a subsequent promise.  The exceptions get added to this array when
	// they are created, and removed when they are handled.  Note that in ES6 or
	// shimmed environments, this would naturally be a `Set`.
	var unhandledReasons = [];
	var unhandledRejections = [];
	var reportedUnhandledRejections = [];
	var trackUnhandledRejections = true;

	function resetUnhandledRejections() {
	    unhandledReasons.length = 0;
	    unhandledRejections.length = 0;

	    if (!trackUnhandledRejections) {
	        trackUnhandledRejections = true;
	    }
	}

	function trackRejection(promise, reason) {
	    if (!trackUnhandledRejections) {
	        return;
	    }
	    if (typeof process === "object" && typeof process.emit === "function") {
	        Q.nextTick.runAfter(function () {
	            if (array_indexOf(unhandledRejections, promise) !== -1) {
	                process.emit("unhandledRejection", reason, promise);
	                reportedUnhandledRejections.push(promise);
	            }
	        });
	    }

	    unhandledRejections.push(promise);
	    if (reason && typeof reason.stack !== "undefined") {
	        unhandledReasons.push(reason.stack);
	    } else {
	        unhandledReasons.push("(no stack) " + reason);
	    }
	}

	function untrackRejection(promise) {
	    if (!trackUnhandledRejections) {
	        return;
	    }

	    var at = array_indexOf(unhandledRejections, promise);
	    if (at !== -1) {
	        if (typeof process === "object" && typeof process.emit === "function") {
	            Q.nextTick.runAfter(function () {
	                var atReport = array_indexOf(reportedUnhandledRejections, promise);
	                if (atReport !== -1) {
	                    process.emit("rejectionHandled", unhandledReasons[at], promise);
	                    reportedUnhandledRejections.splice(atReport, 1);
	                }
	            });
	        }
	        unhandledRejections.splice(at, 1);
	        unhandledReasons.splice(at, 1);
	    }
	}

	Q.resetUnhandledRejections = resetUnhandledRejections;

	Q.getUnhandledReasons = function () {
	    // Make a copy so that consumers can't interfere with our internal state.
	    return unhandledReasons.slice();
	};

	Q.stopUnhandledRejectionTracking = function () {
	    resetUnhandledRejections();
	    trackUnhandledRejections = false;
	};

	resetUnhandledRejections();

	//// END UNHANDLED REJECTION TRACKING

	/**
	 * Constructs a rejected promise.
	 * @param reason value describing the failure
	 */
	Q.reject = reject;
	function reject(reason) {
	    var rejection = Promise({
	        "when": function (rejected) {
	            // note that the error has been handled
	            if (rejected) {
	                untrackRejection(this);
	            }
	            return rejected ? rejected(reason) : this;
	        }
	    }, function fallback() {
	        return this;
	    }, function inspect() {
	        return { state: "rejected", reason: reason };
	    });

	    // Note that the reason has not been handled.
	    trackRejection(rejection, reason);

	    return rejection;
	}

	/**
	 * Constructs a fulfilled promise for an immediate reference.
	 * @param value immediate reference
	 */
	Q.fulfill = fulfill;
	function fulfill(value) {
	    return Promise({
	        "when": function () {
	            return value;
	        },
	        "get": function (name) {
	            return value[name];
	        },
	        "set": function (name, rhs) {
	            value[name] = rhs;
	        },
	        "delete": function (name) {
	            delete value[name];
	        },
	        "post": function (name, args) {
	            // Mark Miller proposes that post with no name should apply a
	            // promised function.
	            if (name === null || name === void 0) {
	                return value.apply(void 0, args);
	            } else {
	                return value[name].apply(value, args);
	            }
	        },
	        "apply": function (thisp, args) {
	            return value.apply(thisp, args);
	        },
	        "keys": function () {
	            return object_keys(value);
	        }
	    }, void 0, function inspect() {
	        return { state: "fulfilled", value: value };
	    });
	}

	/**
	 * Converts thenables to Q promises.
	 * @param promise thenable promise
	 * @returns a Q promise
	 */
	function coerce(promise) {
	    var deferred = defer();
	    Q.nextTick(function () {
	        try {
	            promise.then(deferred.resolve, deferred.reject, deferred.notify);
	        } catch (exception) {
	            deferred.reject(exception);
	        }
	    });
	    return deferred.promise;
	}

	/**
	 * Annotates an object such that it will never be
	 * transferred away from this process over any promise
	 * communication channel.
	 * @param object
	 * @returns promise a wrapping of that object that
	 * additionally responds to the "isDef" message
	 * without a rejection.
	 */
	Q.master = master;
	function master(object) {
	    return Promise({
	        "isDef": function () {}
	    }, function fallback(op, args) {
	        return dispatch(object, op, args);
	    }, function () {
	        return Q(object).inspect();
	    });
	}

	/**
	 * Spreads the values of a promised array of arguments into the
	 * fulfillment callback.
	 * @param fulfilled callback that receives variadic arguments from the
	 * promised array
	 * @param rejected callback that receives the exception if the promise
	 * is rejected.
	 * @returns a promise for the return value or thrown exception of
	 * either callback.
	 */
	Q.spread = spread;
	function spread(value, fulfilled, rejected) {
	    return Q(value).spread(fulfilled, rejected);
	}

	Promise.prototype.spread = function (fulfilled, rejected) {
	    return this.all().then(function (array) {
	        return fulfilled.apply(void 0, array);
	    }, rejected);
	};

	/**
	 * The async function is a decorator for generator functions, turning
	 * them into asynchronous generators.  Although generators are only part
	 * of the newest ECMAScript 6 drafts, this code does not cause syntax
	 * errors in older engines.  This code should continue to work and will
	 * in fact improve over time as the language improves.
	 *
	 * ES6 generators are currently part of V8 version 3.19 with the
	 * --harmony-generators runtime flag enabled.  SpiderMonkey has had them
	 * for longer, but under an older Python-inspired form.  This function
	 * works on both kinds of generators.
	 *
	 * Decorates a generator function such that:
	 *  - it may yield promises
	 *  - execution will continue when that promise is fulfilled
	 *  - the value of the yield expression will be the fulfilled value
	 *  - it returns a promise for the return value (when the generator
	 *    stops iterating)
	 *  - the decorated function returns a promise for the return value
	 *    of the generator or the first rejected promise among those
	 *    yielded.
	 *  - if an error is thrown in the generator, it propagates through
	 *    every following yield until it is caught, or until it escapes
	 *    the generator function altogether, and is translated into a
	 *    rejection for the promise returned by the decorated generator.
	 */
	Q.async = async;
	function async(makeGenerator) {
	    return function () {
	        // when verb is "send", arg is a value
	        // when verb is "throw", arg is an exception
	        function continuer(verb, arg) {
	            var result;

	            // Until V8 3.19 / Chromium 29 is released, SpiderMonkey is the only
	            // engine that has a deployed base of browsers that support generators.
	            // However, SM's generators use the Python-inspired semantics of
	            // outdated ES6 drafts.  We would like to support ES6, but we'd also
	            // like to make it possible to use generators in deployed browsers, so
	            // we also support Python-style generators.  At some point we can remove
	            // this block.

	            if (typeof StopIteration === "undefined") {
	                // ES6 Generators
	                try {
	                    result = generator[verb](arg);
	                } catch (exception) {
	                    return reject(exception);
	                }
	                if (result.done) {
	                    return Q(result.value);
	                } else {
	                    return when(result.value, callback, errback);
	                }
	            } else {
	                // SpiderMonkey Generators
	                // FIXME: Remove this case when SM does ES6 generators.
	                try {
	                    result = generator[verb](arg);
	                } catch (exception) {
	                    if (isStopIteration(exception)) {
	                        return Q(exception.value);
	                    } else {
	                        return reject(exception);
	                    }
	                }
	                return when(result, callback, errback);
	            }
	        }
	        var generator = makeGenerator.apply(this, arguments);
	        var callback = continuer.bind(continuer, "next");
	        var errback = continuer.bind(continuer, "throw");
	        return callback();
	    };
	}

	/**
	 * The spawn function is a small wrapper around async that immediately
	 * calls the generator and also ends the promise chain, so that any
	 * unhandled errors are thrown instead of forwarded to the error
	 * handler. This is useful because it's extremely common to run
	 * generators at the top-level to work with libraries.
	 */
	Q.spawn = spawn;
	function spawn(makeGenerator) {
	    Q.done(Q.async(makeGenerator)());
	}

	// FIXME: Remove this interface once ES6 generators are in SpiderMonkey.
	/**
	 * Throws a ReturnValue exception to stop an asynchronous generator.
	 *
	 * This interface is a stop-gap measure to support generator return
	 * values in older Firefox/SpiderMonkey.  In browsers that support ES6
	 * generators like Chromium 29, just use "return" in your generator
	 * functions.
	 *
	 * @param value the return value for the surrounding generator
	 * @throws ReturnValue exception with the value.
	 * @example
	 * // ES6 style
	 * Q.async(function* () {
	 *      var foo = yield getFooPromise();
	 *      var bar = yield getBarPromise();
	 *      return foo + bar;
	 * })
	 * // Older SpiderMonkey style
	 * Q.async(function () {
	 *      var foo = yield getFooPromise();
	 *      var bar = yield getBarPromise();
	 *      Q.return(foo + bar);
	 * })
	 */
	Q["return"] = _return;
	function _return(value) {
	    throw new QReturnValue(value);
	}

	/**
	 * The promised function decorator ensures that any promise arguments
	 * are settled and passed as values (`this` is also settled and passed
	 * as a value).  It will also ensure that the result of a function is
	 * always a promise.
	 *
	 * @example
	 * var add = Q.promised(function (a, b) {
	 *     return a + b;
	 * });
	 * add(Q(a), Q(B));
	 *
	 * @param {function} callback The function to decorate
	 * @returns {function} a function that has been decorated.
	 */
	Q.promised = promised;
	function promised(callback) {
	    return function () {
	        return spread([this, all(arguments)], function (self, args) {
	            return callback.apply(self, args);
	        });
	    };
	}

	/**
	 * sends a message to a value in a future turn
	 * @param object* the recipient
	 * @param op the name of the message operation, e.g., "when",
	 * @param args further arguments to be forwarded to the operation
	 * @returns result {Promise} a promise for the result of the operation
	 */
	Q.dispatch = dispatch;
	function dispatch(object, op, args) {
	    return Q(object).dispatch(op, args);
	}

	Promise.prototype.dispatch = function (op, args) {
	    var self = this;
	    var deferred = defer();
	    Q.nextTick(function () {
	        self.promiseDispatch(deferred.resolve, op, args);
	    });
	    return deferred.promise;
	};

	/**
	 * Gets the value of a property in a future turn.
	 * @param object    promise or immediate reference for target object
	 * @param name      name of property to get
	 * @return promise for the property value
	 */
	Q.get = function (object, key) {
	    return Q(object).dispatch("get", [key]);
	};

	Promise.prototype.get = function (key) {
	    return this.dispatch("get", [key]);
	};

	/**
	 * Sets the value of a property in a future turn.
	 * @param object    promise or immediate reference for object object
	 * @param name      name of property to set
	 * @param value     new value of property
	 * @return promise for the return value
	 */
	Q.set = function (object, key, value) {
	    return Q(object).dispatch("set", [key, value]);
	};

	Promise.prototype.set = function (key, value) {
	    return this.dispatch("set", [key, value]);
	};

	/**
	 * Deletes a property in a future turn.
	 * @param object    promise or immediate reference for target object
	 * @param name      name of property to delete
	 * @return promise for the return value
	 */
	Q.del = // XXX legacy
	Q["delete"] = function (object, key) {
	    return Q(object).dispatch("delete", [key]);
	};

	Promise.prototype.del = // XXX legacy
	Promise.prototype["delete"] = function (key) {
	    return this.dispatch("delete", [key]);
	};

	/**
	 * Invokes a method in a future turn.
	 * @param object    promise or immediate reference for target object
	 * @param name      name of method to invoke
	 * @param value     a value to post, typically an array of
	 *                  invocation arguments for promises that
	 *                  are ultimately backed with `resolve` values,
	 *                  as opposed to those backed with URLs
	 *                  wherein the posted value can be any
	 *                  JSON serializable object.
	 * @return promise for the return value
	 */
	// bound locally because it is used by other methods
	Q.mapply = // XXX As proposed by "Redsandro"
	Q.post = function (object, name, args) {
	    return Q(object).dispatch("post", [name, args]);
	};

	Promise.prototype.mapply = // XXX As proposed by "Redsandro"
	Promise.prototype.post = function (name, args) {
	    return this.dispatch("post", [name, args]);
	};

	/**
	 * Invokes a method in a future turn.
	 * @param object    promise or immediate reference for target object
	 * @param name      name of method to invoke
	 * @param ...args   array of invocation arguments
	 * @return promise for the return value
	 */
	Q.send = // XXX Mark Miller's proposed parlance
	Q.mcall = // XXX As proposed by "Redsandro"
	Q.invoke = function (object, name /*...args*/) {
	    return Q(object).dispatch("post", [name, array_slice(arguments, 2)]);
	};

	Promise.prototype.send = // XXX Mark Miller's proposed parlance
	Promise.prototype.mcall = // XXX As proposed by "Redsandro"
	Promise.prototype.invoke = function (name /*...args*/) {
	    return this.dispatch("post", [name, array_slice(arguments, 1)]);
	};

	/**
	 * Applies the promised function in a future turn.
	 * @param object    promise or immediate reference for target function
	 * @param args      array of application arguments
	 */
	Q.fapply = function (object, args) {
	    return Q(object).dispatch("apply", [void 0, args]);
	};

	Promise.prototype.fapply = function (args) {
	    return this.dispatch("apply", [void 0, args]);
	};

	/**
	 * Calls the promised function in a future turn.
	 * @param object    promise or immediate reference for target function
	 * @param ...args   array of application arguments
	 */
	Q["try"] =
	Q.fcall = function (object /* ...args*/) {
	    return Q(object).dispatch("apply", [void 0, array_slice(arguments, 1)]);
	};

	Promise.prototype.fcall = function (/*...args*/) {
	    return this.dispatch("apply", [void 0, array_slice(arguments)]);
	};

	/**
	 * Binds the promised function, transforming return values into a fulfilled
	 * promise and thrown errors into a rejected one.
	 * @param object    promise or immediate reference for target function
	 * @param ...args   array of application arguments
	 */
	Q.fbind = function (object /*...args*/) {
	    var promise = Q(object);
	    var args = array_slice(arguments, 1);
	    return function fbound() {
	        return promise.dispatch("apply", [
	            this,
	            args.concat(array_slice(arguments))
	        ]);
	    };
	};
	Promise.prototype.fbind = function (/*...args*/) {
	    var promise = this;
	    var args = array_slice(arguments);
	    return function fbound() {
	        return promise.dispatch("apply", [
	            this,
	            args.concat(array_slice(arguments))
	        ]);
	    };
	};

	/**
	 * Requests the names of the owned properties of a promised
	 * object in a future turn.
	 * @param object    promise or immediate reference for target object
	 * @return promise for the keys of the eventually settled object
	 */
	Q.keys = function (object) {
	    return Q(object).dispatch("keys", []);
	};

	Promise.prototype.keys = function () {
	    return this.dispatch("keys", []);
	};

	/**
	 * Turns an array of promises into a promise for an array.  If any of
	 * the promises gets rejected, the whole array is rejected immediately.
	 * @param {Array*} an array (or promise for an array) of values (or
	 * promises for values)
	 * @returns a promise for an array of the corresponding values
	 */
	// By Mark Miller
	// http://wiki.ecmascript.org/doku.php?id=strawman:concurrency&rev=1308776521#allfulfilled
	Q.all = all;
	function all(promises) {
	    return when(promises, function (promises) {
	        var pendingCount = 0;
	        var deferred = defer();
	        array_reduce(promises, function (undefined, promise, index) {
	            var snapshot;
	            if (
	                isPromise(promise) &&
	                (snapshot = promise.inspect()).state === "fulfilled"
	            ) {
	                promises[index] = snapshot.value;
	            } else {
	                ++pendingCount;
	                when(
	                    promise,
	                    function (value) {
	                        promises[index] = value;
	                        if (--pendingCount === 0) {
	                            deferred.resolve(promises);
	                        }
	                    },
	                    deferred.reject,
	                    function (progress) {
	                        deferred.notify({ index: index, value: progress });
	                    }
	                );
	            }
	        }, void 0);
	        if (pendingCount === 0) {
	            deferred.resolve(promises);
	        }
	        return deferred.promise;
	    });
	}

	Promise.prototype.all = function () {
	    return all(this);
	};

	/**
	 * Returns the first resolved promise of an array. Prior rejected promises are
	 * ignored.  Rejects only if all promises are rejected.
	 * @param {Array*} an array containing values or promises for values
	 * @returns a promise fulfilled with the value of the first resolved promise,
	 * or a rejected promise if all promises are rejected.
	 */
	Q.any = any;

	function any(promises) {
	    if (promises.length === 0) {
	        return Q.resolve();
	    }

	    var deferred = Q.defer();
	    var pendingCount = 0;
	    array_reduce(promises, function (prev, current, index) {
	        var promise = promises[index];

	        pendingCount++;

	        when(promise, onFulfilled, onRejected, onProgress);
	        function onFulfilled(result) {
	            deferred.resolve(result);
	        }
	        function onRejected() {
	            pendingCount--;
	            if (pendingCount === 0) {
	                deferred.reject(new Error(
	                    "Can't get fulfillment value from any promise, all " +
	                    "promises were rejected."
	                ));
	            }
	        }
	        function onProgress(progress) {
	            deferred.notify({
	                index: index,
	                value: progress
	            });
	        }
	    }, undefined);

	    return deferred.promise;
	}

	Promise.prototype.any = function () {
	    return any(this);
	};

	/**
	 * Waits for all promises to be settled, either fulfilled or
	 * rejected.  This is distinct from `all` since that would stop
	 * waiting at the first rejection.  The promise returned by
	 * `allResolved` will never be rejected.
	 * @param promises a promise for an array (or an array) of promises
	 * (or values)
	 * @return a promise for an array of promises
	 */
	Q.allResolved = deprecate(allResolved, "allResolved", "allSettled");
	function allResolved(promises) {
	    return when(promises, function (promises) {
	        promises = array_map(promises, Q);
	        return when(all(array_map(promises, function (promise) {
	            return when(promise, noop, noop);
	        })), function () {
	            return promises;
	        });
	    });
	}

	Promise.prototype.allResolved = function () {
	    return allResolved(this);
	};

	/**
	 * @see Promise#allSettled
	 */
	Q.allSettled = allSettled;
	function allSettled(promises) {
	    return Q(promises).allSettled();
	}

	/**
	 * Turns an array of promises into a promise for an array of their states (as
	 * returned by `inspect`) when they have all settled.
	 * @param {Array[Any*]} values an array (or promise for an array) of values (or
	 * promises for values)
	 * @returns {Array[State]} an array of states for the respective values.
	 */
	Promise.prototype.allSettled = function () {
	    return this.then(function (promises) {
	        return all(array_map(promises, function (promise) {
	            promise = Q(promise);
	            function regardless() {
	                return promise.inspect();
	            }
	            return promise.then(regardless, regardless);
	        }));
	    });
	};

	/**
	 * Captures the failure of a promise, giving an oportunity to recover
	 * with a callback.  If the given promise is fulfilled, the returned
	 * promise is fulfilled.
	 * @param {Any*} promise for something
	 * @param {Function} callback to fulfill the returned promise if the
	 * given promise is rejected
	 * @returns a promise for the return value of the callback
	 */
	Q.fail = // XXX legacy
	Q["catch"] = function (object, rejected) {
	    return Q(object).then(void 0, rejected);
	};

	Promise.prototype.fail = // XXX legacy
	Promise.prototype["catch"] = function (rejected) {
	    return this.then(void 0, rejected);
	};

	/**
	 * Attaches a listener that can respond to progress notifications from a
	 * promise's originating deferred. This listener receives the exact arguments
	 * passed to ``deferred.notify``.
	 * @param {Any*} promise for something
	 * @param {Function} callback to receive any progress notifications
	 * @returns the given promise, unchanged
	 */
	Q.progress = progress;
	function progress(object, progressed) {
	    return Q(object).then(void 0, void 0, progressed);
	}

	Promise.prototype.progress = function (progressed) {
	    return this.then(void 0, void 0, progressed);
	};

	/**
	 * Provides an opportunity to observe the settling of a promise,
	 * regardless of whether the promise is fulfilled or rejected.  Forwards
	 * the resolution to the returned promise when the callback is done.
	 * The callback can return a promise to defer completion.
	 * @param {Any*} promise
	 * @param {Function} callback to observe the resolution of the given
	 * promise, takes no arguments.
	 * @returns a promise for the resolution of the given promise when
	 * ``fin`` is done.
	 */
	Q.fin = // XXX legacy
	Q["finally"] = function (object, callback) {
	    return Q(object)["finally"](callback);
	};

	Promise.prototype.fin = // XXX legacy
	Promise.prototype["finally"] = function (callback) {
	    callback = Q(callback);
	    return this.then(function (value) {
	        return callback.fcall().then(function () {
	            return value;
	        });
	    }, function (reason) {
	        // TODO attempt to recycle the rejection with "this".
	        return callback.fcall().then(function () {
	            throw reason;
	        });
	    });
	};

	/**
	 * Terminates a chain of promises, forcing rejections to be
	 * thrown as exceptions.
	 * @param {Any*} promise at the end of a chain of promises
	 * @returns nothing
	 */
	Q.done = function (object, fulfilled, rejected, progress) {
	    return Q(object).done(fulfilled, rejected, progress);
	};

	Promise.prototype.done = function (fulfilled, rejected, progress) {
	    var onUnhandledError = function (error) {
	        // forward to a future turn so that ``when``
	        // does not catch it and turn it into a rejection.
	        Q.nextTick(function () {
	            makeStackTraceLong(error, promise);
	            if (Q.onerror) {
	                Q.onerror(error);
	            } else {
	                throw error;
	            }
	        });
	    };

	    // Avoid unnecessary `nextTick`ing via an unnecessary `when`.
	    var promise = fulfilled || rejected || progress ?
	        this.then(fulfilled, rejected, progress) :
	        this;

	    if (typeof process === "object" && process && process.domain) {
	        onUnhandledError = process.domain.bind(onUnhandledError);
	    }

	    promise.then(void 0, onUnhandledError);
	};

	/**
	 * Causes a promise to be rejected if it does not get fulfilled before
	 * some milliseconds time out.
	 * @param {Any*} promise
	 * @param {Number} milliseconds timeout
	 * @param {Any*} custom error message or Error object (optional)
	 * @returns a promise for the resolution of the given promise if it is
	 * fulfilled before the timeout, otherwise rejected.
	 */
	Q.timeout = function (object, ms, error) {
	    return Q(object).timeout(ms, error);
	};

	Promise.prototype.timeout = function (ms, error) {
	    var deferred = defer();
	    var timeoutId = setTimeout(function () {
	        if (!error || "string" === typeof error) {
	            error = new Error(error || "Timed out after " + ms + " ms");
	            error.code = "ETIMEDOUT";
	        }
	        deferred.reject(error);
	    }, ms);

	    this.then(function (value) {
	        clearTimeout(timeoutId);
	        deferred.resolve(value);
	    }, function (exception) {
	        clearTimeout(timeoutId);
	        deferred.reject(exception);
	    }, deferred.notify);

	    return deferred.promise;
	};

	/**
	 * Returns a promise for the given value (or promised value), some
	 * milliseconds after it resolved. Passes rejections immediately.
	 * @param {Any*} promise
	 * @param {Number} milliseconds
	 * @returns a promise for the resolution of the given promise after milliseconds
	 * time has elapsed since the resolution of the given promise.
	 * If the given promise rejects, that is passed immediately.
	 */
	Q.delay = function (object, timeout) {
	    if (timeout === void 0) {
	        timeout = object;
	        object = void 0;
	    }
	    return Q(object).delay(timeout);
	};

	Promise.prototype.delay = function (timeout) {
	    return this.then(function (value) {
	        var deferred = defer();
	        setTimeout(function () {
	            deferred.resolve(value);
	        }, timeout);
	        return deferred.promise;
	    });
	};

	/**
	 * Passes a continuation to a Node function, which is called with the given
	 * arguments provided as an array, and returns a promise.
	 *
	 *      Q.nfapply(FS.readFile, [__filename])
	 *      .then(function (content) {
	 *      })
	 *
	 */
	Q.nfapply = function (callback, args) {
	    return Q(callback).nfapply(args);
	};

	Promise.prototype.nfapply = function (args) {
	    var deferred = defer();
	    var nodeArgs = array_slice(args);
	    nodeArgs.push(deferred.makeNodeResolver());
	    this.fapply(nodeArgs).fail(deferred.reject);
	    return deferred.promise;
	};

	/**
	 * Passes a continuation to a Node function, which is called with the given
	 * arguments provided individually, and returns a promise.
	 * @example
	 * Q.nfcall(FS.readFile, __filename)
	 * .then(function (content) {
	 * })
	 *
	 */
	Q.nfcall = function (callback /*...args*/) {
	    var args = array_slice(arguments, 1);
	    return Q(callback).nfapply(args);
	};

	Promise.prototype.nfcall = function (/*...args*/) {
	    var nodeArgs = array_slice(arguments);
	    var deferred = defer();
	    nodeArgs.push(deferred.makeNodeResolver());
	    this.fapply(nodeArgs).fail(deferred.reject);
	    return deferred.promise;
	};

	/**
	 * Wraps a NodeJS continuation passing function and returns an equivalent
	 * version that returns a promise.
	 * @example
	 * Q.nfbind(FS.readFile, __filename)("utf-8")
	 * .then(console.log)
	 * .done()
	 */
	Q.nfbind =
	Q.denodeify = function (callback /*...args*/) {
	    var baseArgs = array_slice(arguments, 1);
	    return function () {
	        var nodeArgs = baseArgs.concat(array_slice(arguments));
	        var deferred = defer();
	        nodeArgs.push(deferred.makeNodeResolver());
	        Q(callback).fapply(nodeArgs).fail(deferred.reject);
	        return deferred.promise;
	    };
	};

	Promise.prototype.nfbind =
	Promise.prototype.denodeify = function (/*...args*/) {
	    var args = array_slice(arguments);
	    args.unshift(this);
	    return Q.denodeify.apply(void 0, args);
	};

	Q.nbind = function (callback, thisp /*...args*/) {
	    var baseArgs = array_slice(arguments, 2);
	    return function () {
	        var nodeArgs = baseArgs.concat(array_slice(arguments));
	        var deferred = defer();
	        nodeArgs.push(deferred.makeNodeResolver());
	        function bound() {
	            return callback.apply(thisp, arguments);
	        }
	        Q(bound).fapply(nodeArgs).fail(deferred.reject);
	        return deferred.promise;
	    };
	};

	Promise.prototype.nbind = function (/*thisp, ...args*/) {
	    var args = array_slice(arguments, 0);
	    args.unshift(this);
	    return Q.nbind.apply(void 0, args);
	};

	/**
	 * Calls a method of a Node-style object that accepts a Node-style
	 * callback with a given array of arguments, plus a provided callback.
	 * @param object an object that has the named method
	 * @param {String} name name of the method of object
	 * @param {Array} args arguments to pass to the method; the callback
	 * will be provided by Q and appended to these arguments.
	 * @returns a promise for the value or error
	 */
	Q.nmapply = // XXX As proposed by "Redsandro"
	Q.npost = function (object, name, args) {
	    return Q(object).npost(name, args);
	};

	Promise.prototype.nmapply = // XXX As proposed by "Redsandro"
	Promise.prototype.npost = function (name, args) {
	    var nodeArgs = array_slice(args || []);
	    var deferred = defer();
	    nodeArgs.push(deferred.makeNodeResolver());
	    this.dispatch("post", [name, nodeArgs]).fail(deferred.reject);
	    return deferred.promise;
	};

	/**
	 * Calls a method of a Node-style object that accepts a Node-style
	 * callback, forwarding the given variadic arguments, plus a provided
	 * callback argument.
	 * @param object an object that has the named method
	 * @param {String} name name of the method of object
	 * @param ...args arguments to pass to the method; the callback will
	 * be provided by Q and appended to these arguments.
	 * @returns a promise for the value or error
	 */
	Q.nsend = // XXX Based on Mark Miller's proposed "send"
	Q.nmcall = // XXX Based on "Redsandro's" proposal
	Q.ninvoke = function (object, name /*...args*/) {
	    var nodeArgs = array_slice(arguments, 2);
	    var deferred = defer();
	    nodeArgs.push(deferred.makeNodeResolver());
	    Q(object).dispatch("post", [name, nodeArgs]).fail(deferred.reject);
	    return deferred.promise;
	};

	Promise.prototype.nsend = // XXX Based on Mark Miller's proposed "send"
	Promise.prototype.nmcall = // XXX Based on "Redsandro's" proposal
	Promise.prototype.ninvoke = function (name /*...args*/) {
	    var nodeArgs = array_slice(arguments, 1);
	    var deferred = defer();
	    nodeArgs.push(deferred.makeNodeResolver());
	    this.dispatch("post", [name, nodeArgs]).fail(deferred.reject);
	    return deferred.promise;
	};

	/**
	 * If a function would like to support both Node continuation-passing-style and
	 * promise-returning-style, it can end its internal promise chain with
	 * `nodeify(nodeback)`, forwarding the optional nodeback argument.  If the user
	 * elects to use a nodeback, the result will be sent there.  If they do not
	 * pass a nodeback, they will receive the result promise.
	 * @param object a result (or a promise for a result)
	 * @param {Function} nodeback a Node.js-style callback
	 * @returns either the promise or nothing
	 */
	Q.nodeify = nodeify;
	function nodeify(object, nodeback) {
	    return Q(object).nodeify(nodeback);
	}

	Promise.prototype.nodeify = function (nodeback) {
	    if (nodeback) {
	        this.then(function (value) {
	            Q.nextTick(function () {
	                nodeback(null, value);
	            });
	        }, function (error) {
	            Q.nextTick(function () {
	                nodeback(error);
	            });
	        });
	    } else {
	        return this;
	    }
	};

	Q.noConflict = function() {
	    throw new Error("Q.noConflict only works when Q is used as a global");
	};

	// All code before this point will be filtered from stack traces.
	var qEndingLine = captureLine();

	return Q;

	});

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99), __webpack_require__(100).setImmediate))

/***/ }),
/* 99 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};

	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.

	var cachedSetTimeout;
	var cachedClearTimeout;

	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }


	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }



	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;

	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}

	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;

	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}

	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};

	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};

	function noop() {}

	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;

	process.listeners = function (name) { return [] }

	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};

	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;

	// DOM APIs, for completeness

	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};

	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};

	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};

	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};

	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);

	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};

	// setimmediate attaches itself to the global object
	__webpack_require__(101);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";

	    if (global.setImmediate) {
	        return;
	    }

	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;

	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }

	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }

	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }

	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }

	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }

	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }

	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };

	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }

	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }

	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };

	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }

	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }

	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }

	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();

	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();

	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();

	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();

	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }

	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(99)))

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _classCallCheck2 = __webpack_require__(6);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(7);

	var _createClass3 = _interopRequireDefault(_createClass2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/* global moment, fabric */
	var AnnotationsStorage = function () {
	  function AnnotationsStorage(slug, drawing, storage) {
	    (0, _classCallCheck3.default)(this, AnnotationsStorage);

	    this.slug = slug;
	    this.canvas = drawing.canvas;
	    this.commands = drawing.commands;
	    this.storage = storage;
	    this.KEY_NAME = 'last_annotations';
	  }

	  (0, _createClass3.default)(AnnotationsStorage, [{
	    key: 'hasData',
	    value: function hasData() {
	      var storedObjects = this.getStoredObjects(false);
	      if (!storedObjects) {
	        return false;
	      }
	      if (storedObjects.slug !== this.slug || moment(storedObjects.created_at) < moment().add(-10, 'minute')) {
	        this.removeStoredState();
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'restoreChanges',
	    value: function restoreChanges() {
	      var _this = this;

	      var stored = this.getStoredObjects();
	      var data = stored.data;

	      var blurObjects = data.filter(function (o) {
	        return o.type === 'blur';
	      });
	      var elementObjects = data.filter(function (obj) {
	        return blurObjects.indexOf(obj) === -1;
	      });

	      return this.applyPaths(elementObjects).then(function () {
	        return _this.applyBlur(blurObjects);
	      }).then(function () {
	        return _this.removeStoredState;
	      });
	    }
	  }, {
	    key: 'applyChanges',
	    value: function applyChanges(elementObjects, blurObjects) {
	      var _this2 = this;

	      return this.applyPaths(elementObjects).then(function () {
	        return _this2.applyBlur(blurObjects);
	      });
	    }
	  }, {
	    key: 'removeStoredState',
	    value: function removeStoredState() {
	      this.storage.remove(this.KEY_NAME);
	    }
	  }, {
	    key: 'applyPaths',
	    value: function applyPaths(pathObjects) {
	      var _this3 = this;

	      var promise = new Promise(function (resolve, reject) {
	        try {
	          fabric.util.enlivenObjects(pathObjects, function (objects) {
	            var origRenderOnAddRemove = _this3.canvas.renderOnAddRemove;
	            _this3.canvas.renderOnAddRemove = false;

	            objects.forEach(function (o) {
	              _this3.canvas.add(o);
	            });

	            _this3.canvas.renderOnAddRemove = origRenderOnAddRemove;
	            _this3.canvas.renderAll();
	            resolve(_this3);
	          });
	        } catch (error) {
	          reject(error);
	        }
	      });
	      return promise;
	    }
	  }, {
	    key: 'applyBlur',
	    value: function applyBlur(objects) {
	      var _this4 = this;

	      var blurs = objects.map(function (obj) {
	        return _this4.commands.addBlur(obj.rect);
	      });
	      return Promise.all(blurs);
	    }
	  }, {
	    key: 'getStoredObjects',
	    value: function getStoredObjects() {
	      var remove = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

	      try {
	        var raw = this.storage.fetch(this.KEY_NAME);
	        if (!raw) {
	          return null;
	        }

	        var parsed = JSON.parse(raw);

	        if (remove) {
	          this.removeStoredState();
	        }
	        return parsed;
	      } catch (err) {
	        return null;
	      }
	    }
	  }, {
	    key: 'storeChanges',
	    value: function storeChanges() {
	      try {
	        var objects = this.canvas.toJSON(['rect', 'subType']).objects;

	        var blurObjects = objects.filter(function (item) {
	          return item.type === 'image' && item.subType === 'blur';
	        }).map(function (item) {
	          return { type: item.subType, rect: item.rect };
	        });
	        var regObjects = objects.filter(function (item) {
	          return item.type !== 'image';
	        });

	        var toSerialize = regObjects.concat(blurObjects);

	        this.storage.store(this.KEY_NAME, JSON.stringify({
	          slug: this.slug,
	          data: toSerialize,
	          created_at: moment().toDate()
	        }));
	      } catch (err) {
	        return;
	      }
	    }
	  }]);
	  return AnnotationsStorage;
	}();

	exports.default = AnnotationsStorage;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _util = __webpack_require__(95);

	var _util2 = _interopRequireDefault(_util);

	var _lodash = __webpack_require__(27);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/* global _, document */

	function AnnotationsUploader($, $q, $window, $timeout, itemService, config, fabric, flashMessagesService) {
	  'ngInject';

	  return function (service) {
	    this.save = function (callback) {
	      var _this = this;

	      this.messageResolved = false;
	      var imageData;
	      return this.getImage().then(function (image) {
	        imageData = image;
	        return _this.prepareUpload();
	      }).then(function (params) {
	        return _this.uploadImage(imageData, params);
	      }).then(function (response) {
	        callback(response);
	      }, function () {
	        callback(false);
	      });
	    };

	    this.getImage = function () {
	      var deferred = $q.defer();

	      _lodash2.default.defer(function () {
	        var drawing = service.drawing;
	        var canvas = service.drawing.canvas;

	        $('#canvas').css('display', 'none');
	        canvas.discardActiveObject();
	        drawing.commands._blurCancel();

	        var t = (canvas.height - _util2.default.getImageHeight(drawing.Image)) / 2,
	            l = (canvas.width - _util2.default.getImageWidth(drawing.Image)) / 2;

	        // canvas dimensions
	        var _t = _util2.default.getTopPoint(canvas),
	            _h = _util2.default.getBottomPoint(canvas) - _t,
	            _l = _util2.default.getLeftPoint(canvas),
	            _w = _util2.default.getRightPoint(canvas) - _l;

	        var scaleX = _util2.default.getImageWidth(drawing.Image) / _util2.default.getImageWidth(drawing.originalImage, true);
	        var scaleY = _util2.default.getImageHeight(drawing.Image) / _util2.default.getImageHeight(drawing.originalImage, true);

	        var assertInDelta = function assertInDelta(expected, actual, delta) {
	          if (delta === undefined) {
	            delta = 0.001;
	          }
	          var rounded = Math.floor(actual / delta) * delta;
	          return delta >= Math.abs(expected - rounded);
	        };

	        var stack = [];
	        var s = function s(f) {
	          stack.push(function () {
	            f();return true;
	          });
	        };

	        canvas.discardActiveObject();
	        canvas.remove(drawing.Image);

	        var scalable = true;
	        if (assertInDelta(1, scaleX) && assertInDelta(1, scaleY)) {
	          scaleX = 1;
	          scaleY = 1;
	          scalable = false;
	        } else {
	          s(function (x) {
	            canvas.setWidth(x);
	          }.bind(this, canvas.width));
	          s(function (x) {
	            canvas.setHeight(x);
	          }.bind(this, canvas.height));
	          canvas.setWidth(canvas.width / scaleX);
	          canvas.setHeight(canvas.height / scaleY);

	          _.each(canvas.getObjects(), function (object) {
	            s(function (x) {
	              object.setScaleX(x);
	            }.bind(this, object.scaleX));
	            s(function (x) {
	              object.setScaleY(x);
	            }.bind(this, object.scaleY));
	            s(function (x) {
	              object.setLeft(x);
	            }.bind(this, object.getLeft()));
	            s(function (x) {
	              object.setTop(x);
	            }.bind(this, object.getTop()));
	            object.setScaleX(object.scaleX / scaleX);
	            object.setScaleY(object.scaleY / scaleY);
	            object.setLeft(_l + (object.getLeft() - _l) / scaleX);
	            object.setTop(_t + (object.getTop() - _t) / scaleY);
	          });
	        }

	        canvas.renderAll();

	        var emptyCanvas = document.createElement('canvas');
	        emptyCanvas.width = Math.round((_w - 1) / scaleX);
	        emptyCanvas.height = Math.round((_h - 1) / scaleY);

	        var exportCanvas = new fabric.StaticCanvas(emptyCanvas);

	        new fabric.Image.fromURL(canvas.toDataURL({ top: _t, left: _l, width: _w / scaleX, height: _h / scaleY }), function (img) {
	          exportCanvas.add(drawing.originalImage);
	          drawing.originalImage.left = Math.round((l - _l) / scaleX);
	          drawing.originalImage.top = Math.round((t - _t) / scaleY);
	          exportCanvas.add(img);
	          img.width = _w / scaleX;
	          img.height = _h / scaleY;
	          img.center();

	          deferred.resolve(exportCanvas.toDataURL({ format: "png" }));

	          while ((stack.shift() || _.noop)()) {}

	          canvas.add(drawing.Image);
	          drawing.Image.center();
	          drawing.Image.sendToBack();
	          $('#canvas').css('display', 'block');
	        });
	      });

	      return deferred.promise;
	    };

	    this.prepareUpload = function () {
	      var deferred = $q.defer();

	      itemService.annotationsSave().then(function (response) {
	        if (_lodash2.default.get(response.data, 'uploads_remaining') === 0) {
	          flashMessagesService.send({
	            text: "You've reached the upload limit allowed by the Free plan.",
	            type: "danger",
	            timeout: 3000
	          });
	          deferred.reject();
	        } else {
	          deferred.resolve(response.data);
	        }
	      }, function () {
	        deferred.reject();
	      });

	      return deferred.promise;
	    };

	    this.uploadImage = function (imageData, params) {
	      var deferred = $q.defer();
	      this.uploadPromise = deferred;

	      var msg = {
	        file: imageData,
	        url: params.url,
	        params: params.params,
	        event: 'file',
	        fileName: itemService.data.file_name,
	        slug: params.slug,
	        parent_slug: itemService.slug()
	      };

	      $("#add_file_frame")[0].contentWindow.postMessage(JSON.stringify(msg), config.schema + '://s3.amazonaws.com');

	      return deferred.promise;
	    };

	    this.onMessage = function (event) {
	      var message = JSON.parse(event.data);
	      var deferred = this.uploadPromise;

	      if (message.event === "uploaded") {
	        this.messageResolved = true;

	        itemService.saveImage({
	          bucket: message.bucket,
	          key: message.key,
	          slug: message.slug,
	          parent_slug: message.parent_slug,
	          format: 'json'
	        }).then(function (response) {
	          deferred.resolve(response.data);
	        }, function () {
	          deferred.reject();
	        });
	      }

	      if (message.event === "complete") {
	        if (!this.messageResolved) {
	          deferred.reject();
	        }
	      }
	    };

	    return this;
	  };
	}

	exports.default = AnnotationsUploader;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _slicedToArray2 = __webpack_require__(105);

	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

	var _lodash = __webpack_require__(27);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var PrivacyController = function PrivacyController($uibModalInstance, Api, itemService, storageService, $uibModal, $scope, moment) {
	  'ngInject';

	  var vm = this;

	  vm.item = itemService;
	  vm.privacy = {};
	  vm.privacy.expiration = {};

	  vm.getValue = function () {
	    if (vm.privacy.current_option === 'password') {
	      return _lodash2.default.pick(vm.privacy, ['password']);
	    } else {
	      return _lodash2.default.pick(vm.privacy, ['users', 'notify']);
	    }
	  };

	  itemService.getPrivacy().then(function () {
	    vm.privacy = angular.copy(vm.item.privacy);
	    if (vm.privacy.current_option !== 'password') {
	      vm.passwordInput = true;
	    }
	  });

	  vm.viewsLeft = function () {
	    return vm.item.details.expires_after_views - itemService.data.view_counter;
	  };

	  vm.getLastExpire = function () {
	    return storageService.fetch('last_expire_choice');
	  };

	  vm.getLastExpireMessage = function () {
	    var lastExpire = vm.getLastExpire();
	    if (lastExpire) {
	      var _lastExpire$split = lastExpire.split('/'),
	          _lastExpire$split2 = (0, _slicedToArray3.default)(_lastExpire$split, 2),
	          period = _lastExpire$split2[0],
	          views = _lastExpire$split2[1];

	      var expiresAt = period ? moment.duration(Number(period), 'seconds').humanize(true) : '';
	      var expiresAfterViews = views ? 'after ' + String(views) + ' view' + (Number(views) > 1 ? 's' : '') : '';
	      return expiresAt + (period && views ? ' or ' : ' ') + expiresAfterViews;
	    } else {
	      return '';
	    }
	  };

	  vm.advanced = function () {
	    var advanced = vm.privacy.advancedExpiration;
	    advanced.period = function () {
	      return Number(advanced.expirePeriodCount) * Number(advanced.expirePeriod);
	    };
	    advanced.numberOfSeconds = function () {
	      return advanced.time ? advanced.period() : '';
	    };
	    advanced.expiresAt = function () {
	      return advanced.time ? moment().add(advanced.period(), 'seconds') : '';
	    };
	    advanced.when = function () {
	      return moment().add(advanced.period(), 'seconds');
	    };
	  };

	  vm.invalid = function () {
	    return vm.privacyForm.$invalid;
	  };

	  vm.updateExpiration = function (value) {
	    if (value === 'advanced') {
	      vm.privacy.showAdvanced = true;
	      vm.privacy.advancedExpiration = {
	        'expirePeriodCount': 1,
	        'expiresAfterViews': 1,
	        'expirePeriod': '3600',
	        'time': true,
	        'views': true,
	        'period': 3600,
	        'when': function when() {
	          return moment().add(3600, 'seconds');
	        }
	      };
	      vm.advanced();
	    } else if (value) {
	      vm.privacy.showAdvanced = false;

	      var _value$split = value.split('/'),
	          _value$split2 = (0, _slicedToArray3.default)(_value$split, 2),
	          expiresAt = _value$split2[0],
	          expiresAfterViews = _value$split2[1];

	      vm.privacy.expiration = {
	        expires_at: expiresAt === 0 ? '' : moment().add(expiresAt, 'seconds'),
	        expires_after_views: expiresAfterViews
	      };
	    }
	  };

	  vm.removeExpiration = function () {
	    vm.privacy.expiration = {};
	    $('.js-expiration-on').addClass('ng-hide');
	    $('.js-expiration-off').removeClass('ng-hide');
	  };

	  vm.save = function () {
	    vm.selected = {
	      option: vm.privacy.current_option,
	      value: vm.getValue(vm.privacy)
	    };

	    $scope.$broadcast('show-errors-check-validity');
	    if (vm.privacy.showAdvanced) {
	      var advanced = vm.privacy.advancedExpiration;
	      vm.advanced();

	      vm.selected.expiration = {
	        expires_at: advanced.expiresAt(),
	        expires_after_views: advanced.views ? advanced.expiresAfterViews : ''
	      };

	      if (advanced.remember) {
	        storageService.store('last_expire_choice', advanced.numberOfSeconds() + '/' + (advanced.views ? advanced.expiresAfterViews : ''));
	      }
	    } else {
	      vm.selected.expiration = vm.privacy.expiration;
	    }

	    itemService.setPrivacy(vm.selected).then(function () {
	      vm.item.getDetails();
	      $uibModalInstance.close();
	    });
	  };

	  vm.cancel = function () {
	    $uibModalInstance.dismiss('close');
	  };
	}; /* global $ */
	exports.default = PrivacyController;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _isIterable2 = __webpack_require__(106);

	var _isIterable3 = _interopRequireDefault(_isIterable2);

	var _getIterator2 = __webpack_require__(110);

	var _getIterator3 = _interopRequireDefault(_getIterator2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;

	    try {
	      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);

	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }

	    return _arr;
	  }

	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if ((0, _isIterable3.default)(Object(arr))) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(107), __esModule: true };

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(67);
	__webpack_require__(39);
	module.exports = __webpack_require__(108);


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(109);
	var ITERATOR = __webpack_require__(64)('iterator');
	var Iterators = __webpack_require__(46);
	module.exports = __webpack_require__(13).isIterable = function (it) {
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    // eslint-disable-next-line no-prototype-builtins
	    || Iterators.hasOwnProperty(classof(O));
	};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(54);
	var TAG = __webpack_require__(64)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';

	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};

	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(111), __esModule: true };

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(67);
	__webpack_require__(39);
	module.exports = __webpack_require__(112);


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(18);
	var get = __webpack_require__(113);
	module.exports = __webpack_require__(13).getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(109);
	var ITERATOR = __webpack_require__(64)('iterator');
	var Iterators = __webpack_require__(46);
	module.exports = __webpack_require__(13).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _classCallCheck2 = __webpack_require__(6);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(7);

	var _createClass3 = _interopRequireDefault(_createClass2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/* global _ */
	var LoginController = function () {
	  function LoginController($scope, Api, config, urlService, itemService, sourceService, $window) {
	    'ngInject';

	    var _this = this;

	    (0, _classCallCheck3.default)(this, LoginController);
	    this._Api = Api;
	    this._urlService = urlService;
	    this._sourceService = sourceService;
	    this._$window = $window;

	    this.user = { email: '', password: '', accept_tos: true };
	    this.errors = [];
	    this.confirmation = false;
	    this.itemService = itemService;
	    this.resetUrl = urlService.resetPassword();
	    this.termsUrl = urlService.terms();
	    this.downloadAppUrl = urlService.downloadAppUrl();
	    this.setupCloudappUrl = urlService.setupCloudappUrl();
	    this.appBaseV2 = config.appBaseV2;

	    $scope.loginUrl = this.appBaseV2 + '/accounts/login';
	    $scope.signUpUrl = this.appBaseV2 + '/accounts';

	    $scope.$on('modal.closing', function () {
	      if (_this.action === 'confirmation') {
	        _this.signIn();
	      }
	    });
	  }

	  (0, _createClass3.default)(LoginController, [{
	    key: 'annotateStorage',
	    value: function annotateStorage() {
	      return _.get(this.itemService, 'annotations.annotationsStorage');
	    }
	  }, {
	    key: 'changed',
	    value: function changed() {
	      this.errors = [];
	    }
	  }, {
	    key: 'paramsWithReferrer',
	    value: function paramsWithReferrer() {
	      return Object.assign(this.params || {}, this._sourceService.sourceDirectOrOrganic());
	    }
	  }, {
	    key: 'signIn',
	    value: function signIn() {
	      var _this2 = this;

	      this._Api.signIn(this.user, this.paramsWithReferrer()).success(function () {
	        _this2.callback({ action: 'signIn', success: true });
	      }).error(function (response) {
	        _this2.errors = _.flatten(_.values(response.errors));
	      });
	    }
	  }, {
	    key: 'signUp',
	    value: function signUp() {
	      var _this3 = this;

	      this._Api.signUp(this.user, this.paramsWithReferrer()).success(function () {
	        _this3.confirmation = true;
	        _this3.callback({ action: 'confirmation' });
	      }).error(function (response) {
	        if (angular.equals(response, ['This email has been taken.'])) {
	          _this3.signIn(_this3.user);
	        } else {
	          _this3.errors = response;
	        }
	      });
	    }
	  }, {
	    key: 'google',
	    value: function google() {
	      this._$window.location.href = this.appBaseV2 + '/signup';
	    }
	  }, {
	    key: 'sso',
	    value: function sso() {
	      this.storeAnnotations();
	      this._$window.location.href = this._urlService.ssoUrl();
	    }
	  }, {
	    key: 'storeAnnotations',
	    value: function storeAnnotations() {
	      var annotationsStorage = this.annotateStorage();
	      if (annotationsStorage) {
	        annotationsStorage.storeChanges();
	      }
	    }
	  }]);
	  return LoginController;
	}();

	exports.default = LoginController;

/***/ }),
/* 115 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LoginModalController = function LoginModalController($uibModalInstance, Api, itemService, abilityService, action, params, success_callback) {
	  'ngInject';

	  var vm = this;
	  vm.action = action;
	  vm.params = params;
	  vm.success_callback = success_callback;

	  vm.close = function () {
	    $uibModalInstance.close();
	  };

	  vm.callback = function (success, action) {
	    if (action && !success) {
	      vm.action = action;
	      return;
	    }
	    if (success && vm.success_callback) {
	      vm.success_callback();
	      $uibModalInstance.close();
	    } else if (success) {
	      abilityService.reset();
	      itemService.getItem();
	      itemService.getDetails();
	      $uibModalInstance.close();
	    }
	  };
	};

	exports.default = LoginModalController;

/***/ }),
/* 116 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* global _ */

	var ShareController = function ShareController($uibModalInstance, itemService) {
	  'ngInject';

	  var vm = this;
	  vm.item = itemService;

	  itemService.getPrivacy();

	  vm.share = {
	    users: []
	  };

	  vm.item = itemService;

	  vm.save = function () {
	    if (vm.share.restricted) {
	      itemService.setPrivacy({
	        restricted: true,
	        users: _.union(vm.share.users, vm.item.privacy.users)
	      });
	    }

	    itemService.share({
	      recipients: vm.share.users,
	      message: vm.share.message
	    });

	    $uibModalInstance.close();
	  };

	  vm.invalid = function () {
	    return _.isEmpty(vm.share.users) || vm.shareForm.$invalid;
	  };

	  vm.cancel = function () {
	    $uibModalInstance.dismiss('close');
	  };
	};

	exports.default = ShareController;

/***/ }),
/* 117 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* global _ */

	var FlagController = function FlagController($uibModalInstance, itemService, storageService, $scope) {
	  'ngInject';

	  var vm = this;

	  vm.flag = {
	    reason: "DMCA"
	  };

	  vm.save = function () {
	    $scope.$broadcast('show-errors-check-validity');
	    if (vm.flagForm.$invalid) {
	      return false;
	    }

	    vm.flag = _.mapValues(vm.flag, function (val) {
	      return String(val);
	    });
	    itemService.setFlag(vm).then(function () {
	      storageService.arrayPush("flags", itemService.slug());
	      $uibModalInstance.close();
	    });
	  };

	  vm.cancel = function () {
	    $uibModalInstance.dismiss('close');
	  };
	};

	exports.default = FlagController;

/***/ }),
/* 118 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* global document */
	var EmbedController = function EmbedController($uibModalInstance, itemService, $timeout, $sce) {
	  'ngInject';

	  var vm = this;
	  vm.item = itemService;
	  vm.embed = {};
	  vm.notitle = false;
	  vm.nobranding = false;

	  itemService.getEmbed().then(function () {
	    vm.embed = angular.copy(vm.item.embed);
	    vm.current = vm.embed.embed_html_js;
	    vm.currentWithOptions = vm.current;
	    vm.type = 'js';
	    vm.trustedPreview = $sce.trustAsHtml(vm.embed.embed_preview);
	  });

	  $timeout(function () {
	    var input = document.querySelector('.embed-modal input');
	    input.focus();
	  });

	  var applyOption = function applyOption(option, embed) {
	    if (vm[option]) {
	      if (/iframe/.test(embed)) {
	        var slug = vm.item.slug();
	        return embed.replace('?', '&').replace(slug, slug + '?' + option + '=1');
	      }
	      if (/cloudapp-embed/.test(embed)) {
	        return embed.slice(0, 4) + ' ' + option + embed.slice(4);
	      }
	    }
	    return embed;
	  };

	  var applyOptions = function applyOptions(embed) {
	    return applyOption('nobranding', applyOption('notitle', embed));
	  };

	  vm.changeType = function (type) {
	    vm.type = type;
	    vm.updateCurrent();
	  };

	  vm.updateCurrent = function () {
	    vm.currentWithOptions = applyOptions(vm.current);
	    vm.trustedPreview = $sce.trustAsHtml(applyOptions(vm.type === 'html' ? vm.embed.embed_html : vm.embed.embed_preview));
	  };
	};

	exports.default = EmbedController;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass2 = __webpack_require__(7);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _classCallCheck2 = __webpack_require__(6);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/* global $*/
	var UnauthorizedDirective = function UnauthorizedDirective() {
	  'ngInject';

	  (0, _classCallCheck3.default)(this, UnauthorizedDirective);
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/unauthorized/unauthorized.html',
	    controller: UnauthorizedController,
	    controllerAs: 'vm',
	    bindToController: true
	  };

	  return directive;
	};

	var UnauthorizedController = function () {
	  function UnauthorizedController(itemService, abilityService) {
	    'ngInject';

	    (0, _classCallCheck3.default)(this, UnauthorizedController);
	    this.ability = abilityService;
	    this.item = itemService;

	    itemService.showAccessRequest();

	    this.passwordForm = {
	      password: "",
	      submit: function submit() {
	        itemService.setLocalPassword(this.password);
	        itemService.getItem();
	        itemService.getDetails().then(function (details) {
	          if (details) {
	            $('body').not(".theme-set").toggleClass('dark', details.theme === "dark");
	          }
	        });
	      }
	    };
	  }

	  (0, _createClass3.default)(UnauthorizedController, [{
	    key: 'action',
	    value: function action() {
	      var access = this.item.access;

	      if (!access) {
	        return;
	      }

	      if (access.access_required && !access.has_session) {
	        return "login";
	      }

	      if (access.access_required && !access.has_access) {
	        return "access";
	      }

	      if (access.password_required && !access.has_valid_password) {
	        return "password";
	      }

	      if (!access.has_valid_remote_addr) {
	        return "not_available";
	      }

	      return "not_available";
	    }
	  }, {
	    key: 'loginCallback',
	    value: function loginCallback() {
	      this.item.getItem();
	      this.item.getDetails().then(function (details) {
	        if (details) {
	          $('body').not(".theme-set").toggleClass('dark', details.theme === "dark");
	        }
	      });
	    }
	  }, {
	    key: 'createPasswordRequest',
	    value: function createPasswordRequest() {
	      this.item.createAccessRequest({ request_type: "password" });
	    }
	  }, {
	    key: 'createAccessRequest',
	    value: function createAccessRequest() {
	      var itemService = this.item;

	      this.item.createAccessRequest({ request_type: "access" }).then(function () {
	        itemService.showAccessRequest();
	      });
	    }
	  }]);
	  return UnauthorizedController;
	}();

	exports.default = UnauthorizedDirective;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _classCallCheck2 = __webpack_require__(6);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(7);

	var _createClass3 = _interopRequireDefault(_createClass2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/* global $, ouibounce, window */
	var OuibounceController = function () {
	  function OuibounceController($scope, abilityService, analyticsService, itemService) {
	    'ngInject';

	    (0, _classCallCheck3.default)(this, OuibounceController);
	    this.abilityService = abilityService;
	    this.analyticsService = analyticsService;
	    this.itemService = itemService;

	    this.initOuibounce();
	  }

	  (0, _createClass3.default)(OuibounceController, [{
	    key: 'close',
	    value: function close() {
	      $('#ouibounce-modal').hide();
	    }
	  }, {
	    key: 'cookieExpire',
	    value: function cookieExpire() {
	      return this.userType() === 'not_logged_in' ? 1 : 2;
	    }
	  }, {
	    key: 'initOuibounce',
	    value: function initOuibounce() {
	      var _this = this;

	      ouibounce($('#ouibounce-modal')[0], {
	        cookieExpire: this.cookieExpire(),
	        timer: 0,
	        callback: function callback() {
	          if ($('.modal-dialog').length) {
	            $('#ouibounce-modal').hide();
	            return;
	          }

	          _this.analyticsService.track('Ouibounce Modal Opened', {
	            source_referral: 'viewer_ouibounce'
	          });

	          if (window.dataLayer) {
	            window.dataLayer.push({ 'event': 'OuibounceShown', 'ouibounceUserType': _this.userType() });
	          }
	        }
	      });

	      $('#ouibounce-modal .modal').on('click', function (e) {
	        e.stopPropagation();
	      });
	      $('body').on('click', function () {
	        _this.close();
	      });

	      // dataLayer is supplied from Google Tag manager and if you're not serving from viso it won't be available.
	      if (window.dataLayer) {
	        window.dataLayer.push({ 'ouibounceUserType': this.userType() });
	        window.dataLayer.push({ 'event': 'optimize.activate' });
	      }
	    }

	    // Reloads user abilities and item details after interacting with ouibounce modal

	  }, {
	    key: 'ouibounceCallback',
	    value: function ouibounceCallback(success) {
	      if (success) {
	        this.abilityService.reset();
	        this.itemService.getItem();
	        this.itemService.getDetails();
	      }
	    }
	  }, {
	    key: 'userType',
	    value: function userType() {
	      return this.action === 'login' ? 'not_logged_in' : 'guest_free';
	    }
	  }]);
	  return OuibounceController;
	}();

	exports.default = OuibounceController;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _classCallCheck2 = __webpack_require__(6);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var UpgradeController = function UpgradeController(urlService) {
	  'ngInject';

	  (0, _classCallCheck3.default)(this, UpgradeController);
	  this.url = urlService;
	};

	exports.default = UpgradeController;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _classCallCheck2 = __webpack_require__(6);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(7);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _sha = __webpack_require__(123);

	var _sha2 = _interopRequireDefault(_sha);

	var _lodash = __webpack_require__(27);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var ItemService = function () {
	  function ItemService(Api, userService, pusherService, $route, commentService, eventService, mimeTypeService, storageService, $log, config, moment, $cookies, $timeout) {
	    'ngInject';

	    (0, _classCallCheck3.default)(this, ItemService);
	    this.slug = function () {
	      return $route.current.params.slug;
	    };

	    this._Api = Api;
	    this._userService = userService;
	    this._storageService = storageService;
	    this._mimeTypeService = mimeTypeService;
	    this._pusherService = pusherService;
	    this._commentService = commentService.setItem(this.slug());
	    this._$cookies = $cookies;
	    eventService.setItem(this.slug());
	    this._$log = $log;
	    this._config = config;
	    this._moment = moment;
	    this._$timeout = $timeout;
	    this.expire_period = '0';
	    this.state = 'empty';

	    this.annotationsSave = function () {
	      if (_lodash2.default.get(this.data, 'owner_id') === userService.getId()) {
	        return this.editImage();
	      } else {
	        return this.newImage();
	      }
	    };

	    this.state = 'empty';
	  }

	  (0, _createClass3.default)(ItemService, [{
	    key: 'commentCount',
	    value: function commentCount() {
	      return this._commentService.count;
	    }
	  }, {
	    key: 'getEmbed',
	    value: function getEmbed() {
	      var _this = this;

	      return this._Api.getEmbed(this.slug()).then(function (data) {
	        _this.embed = data;
	        return _this.embed;
	      });
	    }
	  }, {
	    key: 'getDetails',
	    value: function getDetails() {
	      var _this2 = this;

	      if (this.state === 'pending') {
	        return this._$timeout(function () {
	          _this2.getDetails();
	        }, 1000);
	      }

	      return this._Api.getDetails(this.slug()).then(function (data) {
	        _this2.details = data.details;
	        return _this2.details;
	      });
	    }
	  }, {
	    key: 'lazyGetItem',
	    value: function lazyGetItem() {
	      if (!this.data) {
	        return this.getItem();
	      }
	    }
	  }, {
	    key: 'viewItem',
	    value: function viewItem() {
	      var _this3 = this;

	      var apiCall = function apiCall() {
	        var event = !_this3._storageService.arrayHas("views", _this3.slug());

	        if (event) {
	          _this3._storageService.arrayPush("views", _this3.slug());
	        }

	        return _this3._Api.viewItem(_this3.slug(), {
	          format: 'json',
	          user_id: _this3._userService.getId(),
	          event: event
	        });
	      };

	      return this._userService.getter.then(apiCall, apiCall);
	    }
	  }, {
	    key: 'viewItemShare',
	    value: function viewItemShare(token) {
	      return this._Api.viewItemShare(this.slug(), token);
	    }
	  }, {
	    key: 'getItem',
	    value: function getItem() {
	      var _this4 = this;

	      if (this.state !== "pending") {
	        this.state = "empty";
	      }

	      this._Api.setHeaders(this);
	      var mime = this._mimeTypeService;
	      return this._Api.getItem(this.slug()).then(function (response) {
	        var item = response.item;

	        if (!item || !item.source_url || item.pending) {
	          _this4.state = "pending";
	          return _this4._$timeout(function () {
	            _this4.getItem();
	            _this4.getDetails();
	          }, 1000);
	        }

	        _this4.data = item;
	        _this4.state = 'success';
	        var hash = (0, _sha2.default)(item.updated_at).toString().substr(0, 8);
	        _this4.data.latest_source_url = item.source_url;

	        if (item.source_url && item.source_url.indexOf("X-Amz") === -1) {
	          if (item.source_url.indexOf("?") === -1) {
	            _this4.data.latest_source_url += "?v=" + hash;
	          } else {
	            _this4.data.latest_source_url += "&v=" + hash;
	          }
	        }

	        if (item) {
	          _this4.data.type = mime.getType(_this4);
	        }

	        if (_this4.data.type === "other") {
	          _this4._$log.debug(item.mimetype);
	        }
	        return item;
	      }, function (response) {
	        switch (response.status) {
	          case 401:
	            _this4.state = 'unauthorized';break;
	          case 403:
	            _this4.state = 'unauthorized';break;
	          case 404:
	            _this4.state = 'not_found';break;
	          default:
	            _this4.state = 'error';break;
	        }
	        return response;
	      });
	    }
	  }, {
	    key: 'getFavorite',
	    value: function getFavorite() {
	      if (this.data.favorite === undefined) {
	        this.eagerGetFavorite();
	      }
	    }
	  }, {
	    key: 'getPrivacy',
	    value: function getPrivacy() {
	      var _this5 = this;

	      var request = this._Api.getPrivacy(this.slug());
	      request.then(function (data) {
	        return _this5.privacy = data;
	      });
	      return request;
	    }
	  }, {
	    key: 'getRelated',
	    value: function getRelated() {
	      var _this6 = this;

	      var request = this._Api.getRelatedUrl(this.slug());
	      request.then(function (data) {
	        if (data && data.url) {
	          _this6._Api.getRelated(data.url).then(function (related) {
	            _this6.related = related;
	          });
	        }
	      });
	      return request;
	    }
	  }, {
	    key: 'setExpiration',
	    value: function setExpiration(period, views) {
	      var _this7 = this;

	      var expires_at = period ? this._moment().unix() + period : '';
	      var expires_after_views = views || '';
	      return this._Api.setExpiration(this.slug(), { expires_at: expires_at, expires_after_views: expires_after_views }).then(function () {
	        _this7.getDetails();
	      });
	    }
	  }, {
	    key: 'setPrivacy',
	    value: function setPrivacy(data) {
	      var _this8 = this;

	      var request = this._Api.setPrivacy(this.slug(), data);
	      request.then(function (data) {
	        return _this8.privacy = data.privacy;
	      });
	      return request;
	    }
	  }, {
	    key: 'share',
	    value: function share(data) {
	      var _this9 = this;

	      var request = this._Api.share(this.slug(), data);
	      request.then(function (data) {
	        return _this9.privacy = data.privacy;
	      });
	      return request;
	    }
	  }, {
	    key: 'setFlag',
	    value: function setFlag(data) {
	      var _this10 = this;

	      var request = this._Api.setFlag(this.slug(), data.flag);
	      request.then(function () {
	        return _this10.flag = true;
	      });
	      return request;
	    }
	  }, {
	    key: 'eagerGetFavorite',
	    value: function eagerGetFavorite() {
	      var _this11 = this;

	      this._Api.getFavorite(this.slug()).then(function (data) {
	        return _this11.favorite = data.favorite;
	      });
	    }
	  }, {
	    key: 'toggleFavorite',
	    value: function toggleFavorite() {
	      var _this12 = this;

	      var value = this.favorite ? "false" : "true";
	      this._Api.setFavorite(this.slug(), value).then(function () {
	        return _this12.favorite = !_this12.favorite;
	      });
	    }
	  }, {
	    key: 'editImage',
	    value: function editImage() {
	      return this._Api.editImage(this.slug());
	    }
	  }, {
	    key: 'newImage',
	    value: function newImage() {
	      return this._Api.newImage(this.slug());
	    }
	  }, {
	    key: 'saveImage',
	    value: function saveImage(data) {
	      return this._Api.saveImage(this.slug(), data);
	    }
	  }, {
	    key: 'enablePusher',
	    value: function enablePusher() {
	      this._pusherService.setup(this.slug());
	    }
	  }, {
	    key: 'isRestricted',
	    value: function isRestricted() {
	      return this.details && (this.details.restricted || this.details.password);
	    }
	  }, {
	    key: 'isExpiring',
	    value: function isExpiring() {
	      return this.details && (this.details.expires_at || this.details.expires_after_views);
	    }
	  }, {
	    key: 'thumbnail',
	    value: function thumbnail(modifiers) {
	      return "//" + this._config.thumbnails + "/" + this.slug() + '/' + modifiers || 'h200';
	    }
	  }, {
	    key: 'showAccessRequest',
	    value: function showAccessRequest() {
	      var _this13 = this;

	      return this._Api.showAccessRequest(this.slug()).success(function (response) {
	        _this13.access = response;
	      });
	    }
	  }, {
	    key: 'createAccessRequest',
	    value: function createAccessRequest(params) {
	      return this._Api.createAccessRequest(this.slug(), params);
	    }
	  }, {
	    key: 'getLocalPassword',
	    value: function getLocalPassword() {
	      var legacy_cookie = this._$cookies.get("secure_" + this.slug());
	      return this._storageService.fetch((0, _sha2.default)(this.slug()), legacy_cookie);
	    }
	  }, {
	    key: 'setLocalPassword',
	    value: function setLocalPassword(password) {
	      this._storageService.store((0, _sha2.default)(this.slug()), (0, _sha2.default)(password).toString());
	    }
	  }, {
	    key: 'fileWithoutExtension',
	    value: function fileWithoutExtension() {
	      var filename = _lodash2.default.get(this.data, "name").split(".");
	      if (filename.length < 2) {
	        return _lodash2.default.get(this.data, "name");
	      }
	      filename.pop();
	      return filename.join(".");
	    }
	  }, {
	    key: 'fileExtension',
	    value: function fileExtension() {
	      var filename = _lodash2.default.get(this.data, "name").split(".");
	      if (filename.length < 2) {
	        return "";
	      } else {
	        return filename.pop();
	      }
	    }
	  }]);
	  return ItemService;
	}();

	exports.default = ItemService;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(124));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {

		(function (Math) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var Hasher = C_lib.Hasher;
		    var C_algo = C.algo;

		    // Initialization and round constants tables
		    var H = [];
		    var K = [];

		    // Compute constants
		    (function () {
		        function isPrime(n) {
		            var sqrtN = Math.sqrt(n);
		            for (var factor = 2; factor <= sqrtN; factor++) {
		                if (!(n % factor)) {
		                    return false;
		                }
		            }

		            return true;
		        }

		        function getFractionalBits(n) {
		            return ((n - (n | 0)) * 0x100000000) | 0;
		        }

		        var n = 2;
		        var nPrime = 0;
		        while (nPrime < 64) {
		            if (isPrime(n)) {
		                if (nPrime < 8) {
		                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
		                }
		                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));

		                nPrime++;
		            }

		            n++;
		        }
		    }());

		    // Reusable object
		    var W = [];

		    /**
		     * SHA-256 hash algorithm.
		     */
		    var SHA256 = C_algo.SHA256 = Hasher.extend({
		        _doReset: function () {
		            this._hash = new WordArray.init(H.slice(0));
		        },

		        _doProcessBlock: function (M, offset) {
		            // Shortcut
		            var H = this._hash.words;

		            // Working variables
		            var a = H[0];
		            var b = H[1];
		            var c = H[2];
		            var d = H[3];
		            var e = H[4];
		            var f = H[5];
		            var g = H[6];
		            var h = H[7];

		            // Computation
		            for (var i = 0; i < 64; i++) {
		                if (i < 16) {
		                    W[i] = M[offset + i] | 0;
		                } else {
		                    var gamma0x = W[i - 15];
		                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
		                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
		                                   (gamma0x >>> 3);

		                    var gamma1x = W[i - 2];
		                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
		                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
		                                   (gamma1x >>> 10);

		                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
		                }

		                var ch  = (e & f) ^ (~e & g);
		                var maj = (a & b) ^ (a & c) ^ (b & c);

		                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
		                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));

		                var t1 = h + sigma1 + ch + K[i] + W[i];
		                var t2 = sigma0 + maj;

		                h = g;
		                g = f;
		                f = e;
		                e = (d + t1) | 0;
		                d = c;
		                c = b;
		                b = a;
		                a = (t1 + t2) | 0;
		            }

		            // Intermediate hash value
		            H[0] = (H[0] + a) | 0;
		            H[1] = (H[1] + b) | 0;
		            H[2] = (H[2] + c) | 0;
		            H[3] = (H[3] + d) | 0;
		            H[4] = (H[4] + e) | 0;
		            H[5] = (H[5] + f) | 0;
		            H[6] = (H[6] + g) | 0;
		            H[7] = (H[7] + h) | 0;
		        },

		        _doFinalize: function () {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;

		            var nBitsTotal = this._nDataBytes * 8;
		            var nBitsLeft = data.sigBytes * 8;

		            // Add padding
		            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
		            data.sigBytes = dataWords.length * 4;

		            // Hash final blocks
		            this._process();

		            // Return final computed hash
		            return this._hash;
		        },

		        clone: function () {
		            var clone = Hasher.clone.call(this);
		            clone._hash = this._hash.clone();

		            return clone;
		        }
		    });

		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA256('message');
		     *     var hash = CryptoJS.SHA256(wordArray);
		     */
		    C.SHA256 = Hasher._createHelper(SHA256);

		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA256(message, key);
		     */
		    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
		}(Math));


		return CryptoJS.SHA256;

	}));

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory();
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define([], factory);
		}
		else {
			// Global (browser)
			root.CryptoJS = factory();
		}
	}(this, function () {

		/**
		 * CryptoJS core components.
		 */
		var CryptoJS = CryptoJS || (function (Math, undefined) {
		    /**
		     * CryptoJS namespace.
		     */
		    var C = {};

		    /**
		     * Library namespace.
		     */
		    var C_lib = C.lib = {};

		    /**
		     * Base object for prototypal inheritance.
		     */
		    var Base = C_lib.Base = (function () {
		        function F() {}

		        return {
		            /**
		             * Creates a new object that inherits from this object.
		             *
		             * @param {Object} overrides Properties to copy into the new object.
		             *
		             * @return {Object} The new object.
		             *
		             * @static
		             *
		             * @example
		             *
		             *     var MyType = CryptoJS.lib.Base.extend({
		             *         field: 'value',
		             *
		             *         method: function () {
		             *         }
		             *     });
		             */
		            extend: function (overrides) {
		                // Spawn
		                F.prototype = this;
		                var subtype = new F();

		                // Augment
		                if (overrides) {
		                    subtype.mixIn(overrides);
		                }

		                // Create default initializer
		                if (!subtype.hasOwnProperty('init')) {
		                    subtype.init = function () {
		                        subtype.$super.init.apply(this, arguments);
		                    };
		                }

		                // Initializer's prototype is the subtype object
		                subtype.init.prototype = subtype;

		                // Reference supertype
		                subtype.$super = this;

		                return subtype;
		            },

		            /**
		             * Extends this object and runs the init method.
		             * Arguments to create() will be passed to init().
		             *
		             * @return {Object} The new object.
		             *
		             * @static
		             *
		             * @example
		             *
		             *     var instance = MyType.create();
		             */
		            create: function () {
		                var instance = this.extend();
		                instance.init.apply(instance, arguments);

		                return instance;
		            },

		            /**
		             * Initializes a newly created object.
		             * Override this method to add some logic when your objects are created.
		             *
		             * @example
		             *
		             *     var MyType = CryptoJS.lib.Base.extend({
		             *         init: function () {
		             *             // ...
		             *         }
		             *     });
		             */
		            init: function () {
		            },

		            /**
		             * Copies properties into this object.
		             *
		             * @param {Object} properties The properties to mix in.
		             *
		             * @example
		             *
		             *     MyType.mixIn({
		             *         field: 'value'
		             *     });
		             */
		            mixIn: function (properties) {
		                for (var propertyName in properties) {
		                    if (properties.hasOwnProperty(propertyName)) {
		                        this[propertyName] = properties[propertyName];
		                    }
		                }

		                // IE won't copy toString using the loop above
		                if (properties.hasOwnProperty('toString')) {
		                    this.toString = properties.toString;
		                }
		            },

		            /**
		             * Creates a copy of this object.
		             *
		             * @return {Object} The clone.
		             *
		             * @example
		             *
		             *     var clone = instance.clone();
		             */
		            clone: function () {
		                return this.init.prototype.extend(this);
		            }
		        };
		    }());

		    /**
		     * An array of 32-bit words.
		     *
		     * @property {Array} words The array of 32-bit words.
		     * @property {number} sigBytes The number of significant bytes in this word array.
		     */
		    var WordArray = C_lib.WordArray = Base.extend({
		        /**
		         * Initializes a newly created word array.
		         *
		         * @param {Array} words (Optional) An array of 32-bit words.
		         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.lib.WordArray.create();
		         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
		         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
		         */
		        init: function (words, sigBytes) {
		            words = this.words = words || [];

		            if (sigBytes != undefined) {
		                this.sigBytes = sigBytes;
		            } else {
		                this.sigBytes = words.length * 4;
		            }
		        },

		        /**
		         * Converts this word array to a string.
		         *
		         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
		         *
		         * @return {string} The stringified word array.
		         *
		         * @example
		         *
		         *     var string = wordArray + '';
		         *     var string = wordArray.toString();
		         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
		         */
		        toString: function (encoder) {
		            return (encoder || Hex).stringify(this);
		        },

		        /**
		         * Concatenates a word array to this word array.
		         *
		         * @param {WordArray} wordArray The word array to append.
		         *
		         * @return {WordArray} This word array.
		         *
		         * @example
		         *
		         *     wordArray1.concat(wordArray2);
		         */
		        concat: function (wordArray) {
		            // Shortcuts
		            var thisWords = this.words;
		            var thatWords = wordArray.words;
		            var thisSigBytes = this.sigBytes;
		            var thatSigBytes = wordArray.sigBytes;

		            // Clamp excess bits
		            this.clamp();

		            // Concat
		            if (thisSigBytes % 4) {
		                // Copy one byte at a time
		                for (var i = 0; i < thatSigBytes; i++) {
		                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
		                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
		                }
		            } else {
		                // Copy one word at a time
		                for (var i = 0; i < thatSigBytes; i += 4) {
		                    thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
		                }
		            }
		            this.sigBytes += thatSigBytes;

		            // Chainable
		            return this;
		        },

		        /**
		         * Removes insignificant bits.
		         *
		         * @example
		         *
		         *     wordArray.clamp();
		         */
		        clamp: function () {
		            // Shortcuts
		            var words = this.words;
		            var sigBytes = this.sigBytes;

		            // Clamp
		            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
		            words.length = Math.ceil(sigBytes / 4);
		        },

		        /**
		         * Creates a copy of this word array.
		         *
		         * @return {WordArray} The clone.
		         *
		         * @example
		         *
		         *     var clone = wordArray.clone();
		         */
		        clone: function () {
		            var clone = Base.clone.call(this);
		            clone.words = this.words.slice(0);

		            return clone;
		        },

		        /**
		         * Creates a word array filled with random bytes.
		         *
		         * @param {number} nBytes The number of random bytes to generate.
		         *
		         * @return {WordArray} The random word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.lib.WordArray.random(16);
		         */
		        random: function (nBytes) {
		            var words = [];

		            var r = (function (m_w) {
		                var m_w = m_w;
		                var m_z = 0x3ade68b1;
		                var mask = 0xffffffff;

		                return function () {
		                    m_z = (0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10)) & mask;
		                    m_w = (0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10)) & mask;
		                    var result = ((m_z << 0x10) + m_w) & mask;
		                    result /= 0x100000000;
		                    result += 0.5;
		                    return result * (Math.random() > .5 ? 1 : -1);
		                }
		            });

		            for (var i = 0, rcache; i < nBytes; i += 4) {
		                var _r = r((rcache || Math.random()) * 0x100000000);

		                rcache = _r() * 0x3ade67b7;
		                words.push((_r() * 0x100000000) | 0);
		            }

		            return new WordArray.init(words, nBytes);
		        }
		    });

		    /**
		     * Encoder namespace.
		     */
		    var C_enc = C.enc = {};

		    /**
		     * Hex encoding strategy.
		     */
		    var Hex = C_enc.Hex = {
		        /**
		         * Converts a word array to a hex string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The hex string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;

		            // Convert
		            var hexChars = [];
		            for (var i = 0; i < sigBytes; i++) {
		                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
		                hexChars.push((bite >>> 4).toString(16));
		                hexChars.push((bite & 0x0f).toString(16));
		            }

		            return hexChars.join('');
		        },

		        /**
		         * Converts a hex string to a word array.
		         *
		         * @param {string} hexStr The hex string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
		         */
		        parse: function (hexStr) {
		            // Shortcut
		            var hexStrLength = hexStr.length;

		            // Convert
		            var words = [];
		            for (var i = 0; i < hexStrLength; i += 2) {
		                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
		            }

		            return new WordArray.init(words, hexStrLength / 2);
		        }
		    };

		    /**
		     * Latin1 encoding strategy.
		     */
		    var Latin1 = C_enc.Latin1 = {
		        /**
		         * Converts a word array to a Latin1 string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The Latin1 string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;

		            // Convert
		            var latin1Chars = [];
		            for (var i = 0; i < sigBytes; i++) {
		                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
		                latin1Chars.push(String.fromCharCode(bite));
		            }

		            return latin1Chars.join('');
		        },

		        /**
		         * Converts a Latin1 string to a word array.
		         *
		         * @param {string} latin1Str The Latin1 string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
		         */
		        parse: function (latin1Str) {
		            // Shortcut
		            var latin1StrLength = latin1Str.length;

		            // Convert
		            var words = [];
		            for (var i = 0; i < latin1StrLength; i++) {
		                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
		            }

		            return new WordArray.init(words, latin1StrLength);
		        }
		    };

		    /**
		     * UTF-8 encoding strategy.
		     */
		    var Utf8 = C_enc.Utf8 = {
		        /**
		         * Converts a word array to a UTF-8 string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The UTF-8 string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            try {
		                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
		            } catch (e) {
		                throw new Error('Malformed UTF-8 data');
		            }
		        },

		        /**
		         * Converts a UTF-8 string to a word array.
		         *
		         * @param {string} utf8Str The UTF-8 string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
		         */
		        parse: function (utf8Str) {
		            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
		        }
		    };

		    /**
		     * Abstract buffered block algorithm template.
		     *
		     * The property blockSize must be implemented in a concrete subtype.
		     *
		     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
		     */
		    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
		        /**
		         * Resets this block algorithm's data buffer to its initial state.
		         *
		         * @example
		         *
		         *     bufferedBlockAlgorithm.reset();
		         */
		        reset: function () {
		            // Initial values
		            this._data = new WordArray.init();
		            this._nDataBytes = 0;
		        },

		        /**
		         * Adds new data to this block algorithm's buffer.
		         *
		         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
		         *
		         * @example
		         *
		         *     bufferedBlockAlgorithm._append('data');
		         *     bufferedBlockAlgorithm._append(wordArray);
		         */
		        _append: function (data) {
		            // Convert string to WordArray, else assume WordArray already
		            if (typeof data == 'string') {
		                data = Utf8.parse(data);
		            }

		            // Append
		            this._data.concat(data);
		            this._nDataBytes += data.sigBytes;
		        },

		        /**
		         * Processes available data blocks.
		         *
		         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
		         *
		         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
		         *
		         * @return {WordArray} The processed data.
		         *
		         * @example
		         *
		         *     var processedData = bufferedBlockAlgorithm._process();
		         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
		         */
		        _process: function (doFlush) {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
		            var dataSigBytes = data.sigBytes;
		            var blockSize = this.blockSize;
		            var blockSizeBytes = blockSize * 4;

		            // Count blocks ready
		            var nBlocksReady = dataSigBytes / blockSizeBytes;
		            if (doFlush) {
		                // Round up to include partial blocks
		                nBlocksReady = Math.ceil(nBlocksReady);
		            } else {
		                // Round down to include only full blocks,
		                // less the number of blocks that must remain in the buffer
		                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
		            }

		            // Count words ready
		            var nWordsReady = nBlocksReady * blockSize;

		            // Count bytes ready
		            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

		            // Process blocks
		            if (nWordsReady) {
		                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
		                    // Perform concrete-algorithm logic
		                    this._doProcessBlock(dataWords, offset);
		                }

		                // Remove processed words
		                var processedWords = dataWords.splice(0, nWordsReady);
		                data.sigBytes -= nBytesReady;
		            }

		            // Return processed words
		            return new WordArray.init(processedWords, nBytesReady);
		        },

		        /**
		         * Creates a copy of this object.
		         *
		         * @return {Object} The clone.
		         *
		         * @example
		         *
		         *     var clone = bufferedBlockAlgorithm.clone();
		         */
		        clone: function () {
		            var clone = Base.clone.call(this);
		            clone._data = this._data.clone();

		            return clone;
		        },

		        _minBufferSize: 0
		    });

		    /**
		     * Abstract hasher template.
		     *
		     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
		     */
		    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
		        /**
		         * Configuration options.
		         */
		        cfg: Base.extend(),

		        /**
		         * Initializes a newly created hasher.
		         *
		         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
		         *
		         * @example
		         *
		         *     var hasher = CryptoJS.algo.SHA256.create();
		         */
		        init: function (cfg) {
		            // Apply config defaults
		            this.cfg = this.cfg.extend(cfg);

		            // Set initial values
		            this.reset();
		        },

		        /**
		         * Resets this hasher to its initial state.
		         *
		         * @example
		         *
		         *     hasher.reset();
		         */
		        reset: function () {
		            // Reset data buffer
		            BufferedBlockAlgorithm.reset.call(this);

		            // Perform concrete-hasher logic
		            this._doReset();
		        },

		        /**
		         * Updates this hasher with a message.
		         *
		         * @param {WordArray|string} messageUpdate The message to append.
		         *
		         * @return {Hasher} This hasher.
		         *
		         * @example
		         *
		         *     hasher.update('message');
		         *     hasher.update(wordArray);
		         */
		        update: function (messageUpdate) {
		            // Append
		            this._append(messageUpdate);

		            // Update the hash
		            this._process();

		            // Chainable
		            return this;
		        },

		        /**
		         * Finalizes the hash computation.
		         * Note that the finalize operation is effectively a destructive, read-once operation.
		         *
		         * @param {WordArray|string} messageUpdate (Optional) A final message update.
		         *
		         * @return {WordArray} The hash.
		         *
		         * @example
		         *
		         *     var hash = hasher.finalize();
		         *     var hash = hasher.finalize('message');
		         *     var hash = hasher.finalize(wordArray);
		         */
		        finalize: function (messageUpdate) {
		            // Final message update
		            if (messageUpdate) {
		                this._append(messageUpdate);
		            }

		            // Perform concrete-hasher logic
		            var hash = this._doFinalize();

		            return hash;
		        },

		        blockSize: 512/32,

		        /**
		         * Creates a shortcut function to a hasher's object interface.
		         *
		         * @param {Hasher} hasher The hasher to create a helper for.
		         *
		         * @return {Function} The shortcut function.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
		         */
		        _createHelper: function (hasher) {
		            return function (message, cfg) {
		                return new hasher.init(cfg).finalize(message);
		            };
		        },

		        /**
		         * Creates a shortcut function to the HMAC's object interface.
		         *
		         * @param {Hasher} hasher The hasher to use in this HMAC helper.
		         *
		         * @return {Function} The shortcut function.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
		         */
		        _createHmacHelper: function (hasher) {
		            return function (message, key) {
		                return new C_algo.HMAC.init(hasher, key).finalize(message);
		            };
		        }
		    });

		    /**
		     * Algorithm namespace.
		     */
		    var C_algo = C.algo = {};

		    return C;
		}(Math));


		return CryptoJS;

	}));

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _classCallCheck2 = __webpack_require__(6);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(7);

	var _createClass3 = _interopRequireDefault(_createClass2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var UserService = function () {
	  function UserService(Api, $cookies, storageService) {
	    'ngInject';

	    (0, _classCallCheck3.default)(this, UserService);
	    this._Api = Api;
	    this._$cookies = $cookies;
	    this._storageService = storageService;
	    this.getter = this.get();
	  }

	  (0, _createClass3.default)(UserService, [{
	    key: 'get',
	    value: function get() {
	      var _this = this;

	      return this._Api.getUser().then(function (response) {
	        _this._user = response.user;
	        var userId = _this.getId();
	        if (userId) {
	          _this._$cookies.put('user_id', userId);
	          _this._storageService.store('user_id', userId);
	        }
	      }, function () {
	        _this._user = {};
	      });
	    }
	  }, {
	    key: 'isLoggedIn',
	    value: function isLoggedIn() {
	      return this.getId() !== undefined;
	    }
	  }, {
	    key: 'getId',
	    value: function getId() {
	      return (this._user || {}).id;
	    }
	  }, {
	    key: 'getEmail',
	    value: function getEmail() {
	      return (this._user || {}).email;
	    }
	  }, {
	    key: 'getRole',
	    value: function getRole() {
	      return (this._user || {}).role;
	    }
	  }, {
	    key: 'getTeam',
	    value: function getTeam() {
	      return (this._user || {}).team;
	    }
	  }, {
	    key: 'getSubscription',
	    value: function getSubscription() {
	      return (this._user || {}).subscription_type;
	    }
	  }, {
	    key: 'isTrial',
	    value: function isTrial() {
	      return (this._user || {}).on_trial_plan;
	    }
	  }, {
	    key: 'trialDaysLeft',
	    value: function trialDaysLeft() {
	      return (this._user || {}).trial_days_left;
	    }
	  }]);
	  return UserService;
	}();

	exports.default = UserService;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _classCallCheck2 = __webpack_require__(6);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(7);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _lodash = __webpack_require__(27);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var StorageService = function () {
	  function StorageService($log) {
	    'ngInject';

	    (0, _classCallCheck3.default)(this, StorageService);
	    this._$log = $log;
	  }

	  (0, _createClass3.default)(StorageService, [{
	    key: 'fetch',
	    value: function fetch(key, defaults) {
	      var value;
	      try {
	        value = localStorage.getItem(key);
	      } catch (e) {
	        this._$log.error("Local storage is not supported");
	        value = null;
	      }

	      if (value === null) {
	        return defaults;
	      }
	      if (value === "false") {
	        return false;
	      }
	      if (value === "true") {
	        return true;
	      }
	      return value;
	    }
	  }, {
	    key: 'store',
	    value: function store(key, value) {
	      try {
	        localStorage.setItem(key, value);
	      } catch (e) {
	        this._$log.error("Local storage is not supported");
	      }
	      return value;
	    }
	  }, {
	    key: 'arrayHas',
	    value: function arrayHas(key, value) {
	      return _lodash2.default.includes(this._getObject(key, []), value);
	    }
	  }, {
	    key: '_getObject',
	    value: function _getObject(key, defaults) {
	      var value = this.fetch(key);

	      var array;
	      try {
	        array = JSON.parse(value);
	      } catch (e) {
	        array = null;
	      }

	      return array || defaults;
	    }
	  }, {
	    key: '_setObject',
	    value: function _setObject(key, object) {
	      this.store(key, JSON.stringify(object));
	    }
	  }, {
	    key: 'arrayPush',
	    value: function arrayPush(key, value) {
	      this._setObject(key, _lodash2.default.union(this._getObject(key, []), [value]));
	    }
	  }, {
	    key: 'remove',
	    value: function remove(key) {
	      localStorage.removeItem(key);
	    }
	  }, {
	    key: 'isSupported',
	    value: function isSupported() {
	      var TEST = 'test';
	      try {
	        localStorage.setItem(TEST, TEST);
	        localStorage.removeItem(TEST);
	        return true;
	      } catch (e) {
	        return false;
	      }
	    }
	  }]);
	  return StorageService;
	}(); /* global localStorage */


	exports.default = StorageService;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _classCallCheck2 = __webpack_require__(6);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(7);

	var _createClass3 = _interopRequireDefault(_createClass2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var ApiService = function () {
	  function ApiService($http, config, loadingService, $q) {
	    'ngInject';

	    (0, _classCallCheck3.default)(this, ApiService);
	    this.$http = $http;
	    this.apiBase = config.apiBase;
	    this._$q = $q;

	    // this.$http.defaults.headers.common['X-CSRF-Token'] = $('meta[name="csrf-token"]').attr('content');
	    this.w = function (id) {
	      return loadingService.wrap(id);
	    };

	    this.lock();
	  }

	  (0, _createClass3.default)(ApiService, [{
	    key: 'withLock',
	    value: function withLock(method) {
	      var _this = this;

	      return function (a, b, c) {
	        var deferred = _this._$q.defer();
	        _this.wait().then(function () {
	          method(a, b, c).then(deferred.resolve, deferred.reject);
	        });

	        return deferred.promise;
	      };
	    }
	  }, {
	    key: 'lock',
	    value: function lock() {
	      this.unlock();
	      this._lock = this._$q.defer();
	      return this._lock;
	    }
	  }, {
	    key: 'unlock',
	    value: function unlock() {
	      if (this._lock) {
	        this._lock.resolve();
	        this._lock = undefined;
	      }
	    }
	  }, {
	    key: 'wait',
	    value: function wait() {
	      if (this._lock) {
	        return this._lock.promise;
	      } else {
	        var deferred = this._$q.defer();
	        deferred.resolve();
	        return deferred.promise;
	      }
	    }
	  }, {
	    key: 'setHeaders',
	    value: function setHeaders(item) {
	      this.$http.defaults.headers.common['Authenticate-Drop-Access'] = item.getLocalPassword();
	      this.$http.defaults.headers.common['X-Service'] = 'viewer';
	    }
	  }, {
	    key: 'url',
	    value: function url(path) {
	      return this.apiBase + path;
	    }

	    /* HTTP CALLS */

	  }, {
	    key: 'viewItem',
	    value: function viewItem(slug, data) {
	      return this.$http.post(this.url('/' + slug + '/view'), data);
	    }
	  }, {
	    key: 'viewItemShare',
	    value: function viewItemShare(slug, token) {
	      return this.$http.put(this.url('/drops/' + slug + '/share'), {
	        format: 'json',
	        share_token: token
	      });
	    }
	  }, {
	    key: 'getUser',
	    value: function getUser() {
	      return this.withLock(this.$http.get)(this.url('/v2/user')).then(function (response) {
	        return response.data;
	      });
	    }
	  }, {
	    key: 'getTeams',
	    value: function getTeams() {
	      return this.$http.get(this.url('/v2/teams')).then(function (response) {
	        return response.data;
	      });
	    }
	  }, {
	    key: 'getItem',
	    value: function getItem(slug) {
	      var _this2 = this;

	      var promise = this.$http.get(this.url('/v2/items/' + slug)).then(function (response) {
	        _this2.unlock();
	        return response.data;
	      });

	      promise.then(function () {}, function () {
	        _this2.unlock();
	      });

	      return promise;
	    }
	  }, {
	    key: 'getDetails',
	    value: function getDetails(slug) {
	      return this.withLock(this.$http.get)(this.url('/v2/items/' + slug + '/details')).then(function (response) {
	        return response.data;
	      });
	    }
	  }, {
	    key: 'getEmbed',
	    value: function getEmbed(slug) {
	      return this.$http.get(this.url('/v2/embeds/' + slug + '/')).then(function (response) {
	        return response.data;
	      });
	    }
	  }, {
	    key: 'getTout',
	    value: function getTout(slug) {
	      return this.w('getTout')(this.$http.get(this.url('/v2/items/' + slug + '/tout'))).then(function (response) {
	        return response.data;
	      });
	    }
	  }, {
	    key: 'hideTout',
	    value: function hideTout(slug) {
	      return this.w('hideTout')(this.$http.put(this.url('/v2/items/' + slug + '/tout'), { hide: true })).then(function (response) {
	        return response.data;
	      });
	    }
	  }, {
	    key: 'getRelatedUrl',
	    value: function getRelatedUrl(slug) {
	      return this.w('getRelatedUrl')(this.$http.post(this.url('/v2/items/' + slug + '/related'))).then(function (response) {
	        return response.data;
	      });
	    }
	  }, {
	    key: 'getRelated',
	    value: function getRelated(url) {
	      return this.$http.get(url, { withCredentials: false }).then(function (response) {
	        return response.data;
	      });
	    }
	  }, {
	    key: 'getAbilities',
	    value: function getAbilities(slug) {
	      return this.withLock(this.$http.get)(this.url('/v2/items/' + slug + '/abilities')).then(function (response) {
	        return response.data;
	      });
	    }
	  }, {
	    key: 'getEvents',
	    value: function getEvents(slug, params) {
	      return this.w('getEvents')(this.$http.get(this.url('/drops/' + slug + '/events'), { params: params })).then(function (response) {
	        return response.data;
	      });
	    }
	  }, {
	    key: 'getPusherStream',
	    value: function getPusherStream(slug) {
	      return this.$http.get(this.url('/pusher/' + slug + '/stream')).then(function (response) {
	        return response.data;
	      });
	    }
	  }, {
	    key: 'createComment',
	    value: function createComment(slug, data) {
	      return this.w('createComment')(this.$http.post(this.url('/v2/items/' + slug + '/comments'), data)).then(function (response) {
	        return response.data;
	      });
	    }
	  }, {
	    key: 'destroyComment',
	    value: function destroyComment(slug, commentId) {
	      return this.w('destroyComment')(this.$http.delete(this.url('/v2/items/' + slug + '/comments/' + commentId))).then(function (response) {
	        return response.data;
	      });
	    }
	  }, {
	    key: 'getComments',
	    value: function getComments(slug, params) {
	      return this.w('getComments')(this.$http.get(this.url('/v2/items/' + slug + '/comments'), { params: params })).then(function (response) {
	        return response.data;
	      });
	    }
	  }, {
	    key: 'getFavorite',
	    value: function getFavorite(slug) {
	      return this.$http.get(this.url('/drops/' + slug + '/favorite')).then(function (response) {
	        return response.data;
	      });
	    }
	  }, {
	    key: 'setFlag',
	    value: function setFlag(slug, data) {
	      return this.w('setFlag')(this.$http.post(this.url('/' + slug + '/flag'), data)).then(function (response) {
	        return response.data;
	      });
	    }
	  }, {
	    key: 'setFavorite',
	    value: function setFavorite(slug, favorite) {
	      return this.$http.post(this.url('/drops/' + slug + '/favorite'), { favorite: favorite }).then(function (response) {
	        return response.data;
	      });
	    }
	  }, {
	    key: 'getPrivacy',
	    value: function getPrivacy(slug) {
	      return this.w('getPrivacy')(this.$http.get(this.url('/v2/items/' + slug + '/security'))).then(function (response) {
	        return response.data;
	      });
	    }
	  }, {
	    key: 'setPrivacy',
	    value: function setPrivacy(slug, data) {
	      return this.w('setPrivacy')(this.$http.put(this.url('/v2/items/' + slug + '/security'), data)).then(function (response) {
	        return response.data;
	      });
	    }
	  }, {
	    key: 'setExpiration',
	    value: function setExpiration(slug, data) {
	      return this.w('expire')(this.$http.post(this.url('/drops/' + slug + '/expire'), data)).then(function (response) {
	        return response.data;
	      });
	    }
	  }, {
	    key: 'share',
	    value: function share(slug, data) {
	      return this.w('share')(this.$http.post(this.url('/drops/' + slug + '/share'), data)).then(function (response) {
	        return response.data;
	      });
	    }
	  }, {
	    key: 'editImage',
	    value: function editImage(slug) {
	      return this.$http.get(this.url('/annotations/' + slug + '/edit'), { params: { response: 'created', format: 'json' } });
	    }
	  }, {
	    key: 'newImage',
	    value: function newImage() {
	      return this.$http.get(this.url('/annotations/new'), { params: { response: 'created', format: 'json' } });
	    }
	  }, {
	    key: 'saveImage',
	    value: function saveImage(slug, params) {
	      return this.$http.get(this.url('/annotations/s3'), { params: params });
	    }
	  }, {
	    key: 'showAccessRequest',
	    value: function showAccessRequest(slug) {
	      return this.$http.get(this.url('/v2/items/' + slug + '/access_requests'));
	    }
	  }, {
	    key: 'createAccessRequest',
	    value: function createAccessRequest(slug, params) {
	      return this.$http.post(this.url('/v2/items/' + slug + '/access_requests'), params);
	    }
	  }, {
	    key: 'signUp',
	    value: function signUp(user) {
	      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	      return this.$http.post(this.url('/register'), Object.assign({
	        source_method: 'api_v1',
	        format: 'json',
	        user: user
	      }, params));
	    }
	  }, {
	    key: 'signIn',
	    value: function signIn(user) {
	      return this.$http.post(this.url('/login'), { format: 'json', user_session: user });
	    }
	  }, {
	    key: 'signOut',
	    value: function signOut() {
	      return this.$http.get(this.url('/v2/logout'));
	    }
	  }]);
	  return ApiService;
	}();

	exports.default = ApiService;

/***/ }),
/* 128 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* global analytics, _ */

	var AnalyticsService = function AnalyticsService($window, userService, storageService) {
	  'ngInject';

	  var service = this;
	  service.identified = false;
	  service.track = function (event, options) {
	    // Don't track anonymous users, it inflates Segment MTU pricing and we can't afford it.
	    // All anonymous tracking should be deliberate.
	    if (_.isEmpty(storageService.fetch('user_id'))) {
	      return;
	    }

	    if (!service.identified) {
	      service.identify();
	    }

	    options = _.merge({
	      user_id: userService.getId(),
	      user_agent: $window.navigator.userAgent,
	      campaign_source: 'viewer',
	      appName: 'web_app'
	    }, options);

	    if (service.identified === true) {
	      analytics.track(event, options);
	    }
	  };

	  service.identify = function (userId) {
	    userId = userId || userService.getId();
	    if (userId) {
	      service.identified = true;
	      analytics.identify(userId, {
	        email: userService.getEmail()
	      });
	    }
	  };

	  service.page = function () {
	    // Don't track anonymous users, it inflates Segment MTU pricing and we can't afford it.
	    // All anonymous tracking should be deliberate.
	    if (_.isEmpty(storageService.fetch('user_id'))) {
	      return;
	    }

	    if (service.identified === true) {
	      analytics.page({
	        hasBeenAuthed: !!storageService.fetch('user_id'),
	        campaign_source: 'viewer',
	        user_agent: $window.navigator.userAgent,
	        integrations: {
	          Madkudu: false
	        }
	      });
	    }
	  };

	  return service;
	};

	exports.default = AnalyticsService;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _classCallCheck2 = __webpack_require__(6);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(7);

	var _createClass3 = _interopRequireDefault(_createClass2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/* global _ */

	var PusherService = function () {
	  function PusherService(Api, Pusher) {
	    'ngInject';

	    (0, _classCallCheck3.default)(this, PusherService);
	    this.Api = Api;
	    this.Pusher = Pusher;

	    this.pusherSocket = null;
	    this.channels = {};
	    this.channelObservers = [];
	  }

	  (0, _createClass3.default)(PusherService, [{
	    key: "setup",
	    value: function setup(slug) {
	      var _this = this;

	      this.Api.getPusherStream(slug).then(function (data) {
	        _this.pusherSocket = new _this.Pusher(data.api_key, {
	          authEndpoint: data.auth_url
	        });

	        _this.setChannel("item", _this.pusherSocket.subscribe(data.channels.item));

	        _this.setChannel("items", _this.pusherSocket.subscribe(data.channels.items));
	      });
	    }
	  }, {
	    key: "setChannel",
	    value: function setChannel(name, channel) {
	      this.channels[name] = channel;

	      _.each(this.channelObservers, function (observer) {
	        if (observer[0] === name) {
	          channel.bind(observer[1], observer[2]);
	        }
	      });
	    }
	  }, {
	    key: "bindChannel",
	    value: function bindChannel(channelName, eventName, callback) {
	      var channel = this.channels[channelName];
	      this.channelObservers.push([channelName, eventName, callback]);

	      if (channel) {
	        channel.bind(eventName, callback);
	      }
	    }
	  }]);
	  return PusherService;
	}();

	exports.default = PusherService;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _classCallCheck2 = __webpack_require__(6);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(7);

	var _createClass3 = _interopRequireDefault(_createClass2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var AbilityService = function () {
	  function AbilityService($timeout, Api, itemService, userService, toutService, $q) {
	    'ngInject';

	    (0, _classCallCheck3.default)(this, AbilityService);
	    this.$timeout = $timeout;

	    this._$q = $q;
	    this.Api = Api;
	    this._itemService = itemService;
	    this._userService = userService;
	    this._toutService = toutService;

	    this._deferred = $q.defer();
	    this.getAccessData(this._itemService);
	  }

	  (0, _createClass3.default)(AbilityService, [{
	    key: "reset",
	    value: function reset() {
	      this._userService.get();
	      this._toutService.get();
	      this.getAccessData(this._itemService);
	    }
	  }, {
	    key: "getAccessData",
	    value: function getAccessData(itemService) {
	      var _this = this;

	      this.Api.getAbilities(itemService.slug()).then(function (data) {
	        _this.abilities = data.abilities;
	        _this._deferred.resolve();
	      }, function () {
	        _this.abilities = {};
	        _this._deferred.reject();
	      });
	    }
	  }, {
	    key: "can",
	    value: function can(method) {
	      var customMethod = this["can_" + method];
	      if (customMethod) {
	        return this["can_" + method]();
	      } else {
	        return !!(this.abilities && this.abilities[method]);
	      }
	    }
	  }, {
	    key: "canAsync",
	    value: function canAsync(method) {
	      var _this2 = this;

	      var deferred = this._$q.defer();

	      this._deferred.promise.then(function () {
	        if (_this2.can(method)) {
	          deferred.resolve();
	        } else {
	          deferred.reject();
	        }
	      }, function () {
	        deferred.reject();
	      });

	      return deferred.promise;
	    }
	  }, {
	    key: "inject",
	    value: function inject($rootScope) {
	      var _this3 = this;

	      $rootScope.can = function (method) {
	        return _this3.can(method);
	      };

	      $rootScope.is_trial = function () {
	        return _this3.is_trial();
	      };

	      $rootScope.is_pro = function () {
	        return _this3.is_pro();
	      };

	      $rootScope.trial_days_left = function () {
	        return _this3.trial_days_left();
	      };

	      $rootScope.is_free = function () {
	        return _this3.is_free();
	      };

	      $rootScope.has_team = function () {
	        return _this3.has_team();
	      };
	    }
	  }, {
	    key: "can_join",
	    value: function can_join() {
	      return !this._userService.getId();
	    }
	  }, {
	    key: "can_change_logo",
	    value: function can_change_logo() {
	      var user_id = this._userService.getId();
	      return user_id && this._itemService.data.owner_id === user_id;
	    }
	  }, {
	    key: "can_annotate",
	    value: function can_annotate() {
	      return (this.abilities || {}).annotate && (this._itemService.data || {}).type === 'image' && (this._itemService.data || {}).mimetype !== "image/gif";
	    }
	  }, {
	    key: "can_upgrade_annotate",
	    value: function can_upgrade_annotate() {
	      return this.can_join() && !this.can_annotate() && (this._itemService.data || {}).type === 'image' && (this._itemService.data || {}).mimetype !== "image/gif";
	    }
	  }, {
	    key: "can_share_email",
	    value: function can_share_email() {
	      return !this.can('join');
	    }
	  }, {
	    key: "can_disable_copy",
	    value: function can_disable_copy() {
	      return true;
	    }
	  }, {
	    key: "can_see_ads",
	    value: function can_see_ads() {
	      return this._toutService.isVisible();
	    }
	  }, {
	    key: "can_own",
	    value: function can_own() {
	      return (this._itemService.data || {}).owner_id === this._userService.getId();
	    }
	  }, {
	    key: "has_team",
	    value: function has_team() {
	      return !!this._userService.getTeam();
	    }
	  }, {
	    key: "can_admin",
	    value: function can_admin() {
	      return this._userService.getRole() === 'admin';
	    }
	  }, {
	    key: "is_trial",
	    value: function is_trial() {
	      return this._userService.isTrial();
	    }
	  }, {
	    key: "is_pro",
	    value: function is_pro() {
	      return this._userService.getSubscription() === 'Pro';
	    }
	  }, {
	    key: "is_free",
	    value: function is_free() {
	      var subscription = this._userService.getSubscription();
	      return subscription && subscription.toLowerCase() === 'free';
	    }
	  }, {
	    key: "trial_days_left",
	    value: function trial_days_left() {
	      return this._userService.trialDaysLeft();
	    }
	  }]);
	  return AbilityService;
	}();

	exports.default = AbilityService;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _classCallCheck2 = __webpack_require__(6);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(7);

	var _createClass3 = _interopRequireDefault(_createClass2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/* global _ */

	var mimeTypes = {
	  image: ["image/gif", "image/jpeg", "image/png"],
	  video: ["audio/webm", "video/mp4", "video/quicktime", "video/msvideo"],
	  audio: ["audio/ogg", "audio/wav", "audio/mpeg", "audio/aac", "audio/mp4"],
	  pdf: ["application/pdf"],
	  text: [],
	  code: ["application/javascript", "application/ruby", "application/xml", "text/css", "text/html", "text/javascript", "text/plain"]
	};

	var extensions = {
	  code: ["sass", "scss", "haml", "md"]
	};

	var MimeTypeService = function () {
	  function MimeTypeService() {
	    'ngInject';

	    (0, _classCallCheck3.default)(this, MimeTypeService);
	  }

	  (0, _createClass3.default)(MimeTypeService, [{
	    key: "getType",
	    value: function getType(item) {
	      return this.getTypeFromMime(item.data.mimetype) || this.getTypeFromFilename(item.fileExtension()) || "other";
	    }
	  }, {
	    key: "getTypeFromMime",
	    value: function getTypeFromMime(mimeType) {
	      var type;

	      _.each(mimeTypes, function (types, name) {
	        if (_.indexOf(types, mimeType) > -1) {
	          type = name;
	        }
	      });

	      return type;
	    }
	  }, {
	    key: "getTypeFromFilename",
	    value: function getTypeFromFilename(extension) {
	      var type;

	      _.each(extensions, function (types, name) {
	        if (_.indexOf(types, extension) > -1) {
	          type = name;
	        }
	      });

	      return type;
	    }
	  }]);
	  return MimeTypeService;
	}();

	exports.default = MimeTypeService;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _classCallCheck2 = __webpack_require__(6);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(7);

	var _createClass3 = _interopRequireDefault(_createClass2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var LoadingService = function () {
	  function LoadingService() {
	    (0, _classCallCheck3.default)(this, LoadingService);

	    this._states = {};
	  }

	  (0, _createClass3.default)(LoadingService, [{
	    key: "setState",
	    value: function setState(id, value) {
	      this._states[id] = value;
	    }
	  }, {
	    key: "getState",
	    value: function getState(id) {
	      return this._states[id];
	    }
	  }, {
	    key: "pending",
	    value: function pending(id) {
	      return this._states[id] === true ? "api-loading" : null;
	    }
	  }, {
	    key: "inject",
	    value: function inject($rootScope) {
	      var _this = this;

	      $rootScope.pending = function (method) {
	        return _this.pending(method);
	      };
	    }
	  }, {
	    key: "wrap",
	    value: function wrap(id) {
	      var _this2 = this;

	      return function (promise) {
	        return _this2.track(id, promise);
	      };
	    }
	  }, {
	    key: "track",
	    value: function track(id, promise) {
	      var _this3 = this;

	      this.setState(id, true);
	      promise.then(function () {
	        _this3.setState(id, false);
	      }, function () {
	        _this3.setState(id, false);
	      });

	      return promise;
	    }
	  }]);
	  return LoadingService;
	}();

	exports.default = LoadingService;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _lodash = __webpack_require__(27);

	var _lodash2 = _interopRequireDefault(_lodash);

	var _share = __webpack_require__(134);

	var _share2 = _interopRequireDefault(_share);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/* global window, console */

	var ShareViaService = function ShareViaService($uibModal, urlService, itemService, $, config, abilityService) {
	  'ngInject';

	  var share = this;

	  var wrap = function wrap(urlFunction) {
	    return function () {
	      window.open(urlFunction(), "_blank");
	    };
	  };

	  var shareUrl = function shareUrl() {
	    return urlService.share(itemService);
	  };

	  var shareName = function shareName() {
	    return _lodash2.default.get(itemService.data, 'name');
	  };

	  var shareThis = function shareThis(service) {
	    var st = window.stlib;

	    if (!st) {
	      window.console.log("ShareThis is not loaded");
	      return;
	    }

	    var options = {
	      url: shareUrl(),
	      short_url: shareUrl(),
	      shorten: "false",
	      title: shareName(),
	      destination: service
	    };

	    _lodash2.default.each(options, function (value, key) {
	      st.data.set(key, value, "shareInfo");
	    });

	    st.sharer.share();

	    if (service === "pinterest") {
	      st.sharer.sharePinterest();
	    }
	  };

	  var bindShareThis = function bindShareThis(context, key) {
	    context[key] = function () {
	      shareThis(key);
	    };
	  };

	  share.twitter = wrap(function () {
	    var url = "https://twitter.com/share?" + $.param({
	      text: 'Check out what I created #productivity #collaboration ' + shareName(),
	      url: shareUrl(),
	      via: "cloudapp"
	    });

	    return url;
	  });

	  share.facebook = wrap(function () {
	    var url = "https://www.facebook.com/sharer.php?" + $.param({
	      u: shareUrl()
	    });

	    return url;
	  });

	  bindShareThis(share, "pinterest");
	  bindShareThis(share, "googleplus");
	  bindShareThis(share, "linkedin");
	  bindShareThis(share, "blogger");
	  bindShareThis(share, "delicious");
	  bindShareThis(share, "flipboard");
	  bindShareThis(share, "reddit");
	  bindShareThis(share, "tumblr");

	  share.email = function () {
	    if (abilityService.can('share_email')) {
	      (0, _share2.default)($uibModal);
	    }
	  };

	  // LOAD SHARE THIS
	  var script = window.document.createElement("script");
	  script.type = "application/javascript";
	  script.src = window.location.protocol + "//ws.sharethis.com/button/buttons.js";
	  script.onload = function () {
	    var stLight = window.stLight || {};
	    if (!stLight.publisher) {
	      try {
	        stLight.options({
	          publisher: config.env.SHARETHIS_KEY,
	          doNotHash: false,
	          doNotCopy: abilityService.can_disable_copy(),
	          hashAddressBar: false
	        });
	      } catch (e) {
	        console.log(e);
	      }
	    }
	  };

	  try {
	    window.document.body.appendChild(script);
	  } catch (e) {
	    console.log(e);
	  }
	};

	exports.default = ShareViaService;

/***/ }),
/* 134 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ShareModal = function ShareModal($uibModal) {
	  $uibModal.open({
	    templateUrl: 'app/share/share.html',
	    controller: 'ShareController',
	    controllerAs: 'vm'
	  });
	};

	exports.default = ShareModal;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _lodash = __webpack_require__(27);

	var _lodash2 = _interopRequireDefault(_lodash);

	var _downloads = __webpack_require__(136);

	var _downloads2 = _interopRequireDefault(_downloads);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/* global platform */

	var UrlService = function UrlService($window, config, userService, $rootScope) {
	  'ngInject';

	  var service = this;
	  $rootScope.url = service;

	  service.back = function () {
	    return config.appBase + '/';
	  };

	  service.item = function (item) {
	    return '/' + item.slug();
	  };

	  service.secure = function (item) {
	    return '' + config.secureBase + item.slug();
	  };

	  service.share = function (item) {
	    return $window.location.origin + '/' + item.slug();
	  };

	  service.newTeam = function () {
	    return config.appBase + '/teams/new)';
	  };

	  service.resetPassword = function () {
	    return config.appBase + '/reset';
	  };

	  service.upgradePlan = function (utmParameter) {
	    return config.appBase + '/plans?' + utmParameter;
	  };

	  service.referFriend = function (utmParameter) {
	    return config.appBase + '/account/referrals?' + utmParameter;
	  };

	  service.marketing = function (path) {
	    if (userService.getId()) {
	      return config.appBase + '/';
	    }
	    return '' + config.marketingBase + (path || '');
	  };

	  service.originalUrl = function (item) {
	    var url = _lodash2.default.get(item, 'details.download_url', '');
	    return url.replace('/download/', '/');
	  };

	  service.torrentUrl = function (item) {
	    return item.data.source_url + '?torrent';
	  };

	  service.downloadUrl = function (item) {
	    return _lodash2.default.get(item.details, 'download_url');
	  };

	  service.downloadAppUrl = function () {
	    return _downloads2.default[platform.os.family] || 'https://www.getcloudapp.com/download';
	  };

	  service.setupCloudappUrl = function () {
	    return config.appBase + '/onboarding/teams/new';
	  };

	  service.annotate = function (item) {
	    return service.item(item) + '/annotate';
	  };

	  service.item = function (item) {
	    return '/' + item.slug();
	  };

	  service.terms = function () {
	    return config.appBase + '/terms';
	  };

	  service.quickCheckout = function () {
	    return config.appBase + '/teams/quick_checkout/new';
	  };

	  service.oauthUrl = function (name) {
	    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	    var url = config.appBase + '/auth/' + name;
	    var stateParams = encodeURIComponent(JSON.stringify(Object.assign(params, { return: true })));
	    return url + '?state=' + stateParams;
	  };

	  service.ssoUrl = function () {
	    return config.appBase + '/sso/new';
	  };

	  service.ensureExternalUrl = function (url) {
	    if (!url) {
	      return '';
	    }
	    return url.match(/^https?:\/\//) ? url : 'https://' + url;
	  };

	  service.viewOnAdmin = function (item) {
	    return config.appBase + '/admin/drops/' + item.slug();
	  };
	};

	exports.default = UrlService;

/***/ }),
/* 136 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var json = {
	  "OS X": "https://www.getcloudapp.com/download/direct/mac",
	  "Windows": "https://www.getcloudapp.com/download/direct/windows",
	  "iOS": "https://www.getcloudapp.com/download/direct/ios"
	};

	exports.default = json;

/***/ }),
/* 137 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* global _ */

	var FlashMessagesService = function FlashMessagesService($timeout) {
	  'ngInject';

	  var service = this;

	  service._items = [];

	  service.items = function () {
	    return _.where(service._items, { active: true });
	  };

	  service.send = function (message) {
	    $timeout(function () {
	      message.active = true;

	      message.close = function () {
	        message.active = false;
	      };
	      service._items.push(message);
	    });
	  };

	  return service;
	};

	exports.default = FlashMessagesService;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _classCallCheck2 = __webpack_require__(6);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(7);

	var _createClass3 = _interopRequireDefault(_createClass2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var ToutService = function () {
	  function ToutService(Api, itemService) {
	    'ngInject';

	    (0, _classCallCheck3.default)(this, ToutService);
	    this._Api = Api;
	    this._itemService = itemService;
	  }

	  (0, _createClass3.default)(ToutService, [{
	    key: 'get',
	    value: function get() {
	      var _this = this;

	      return this._Api.getTout(this._itemService.slug()).then(function (response) {
	        _this._toutData = response;
	      }, function () {
	        _this._toutData = {};
	      });
	    }
	  }, {
	    key: 'isVisible',
	    value: function isVisible() {
	      return (this._toutData || {}).visible;
	    }
	  }]);
	  return ToutService;
	}();

	exports.default = ToutService;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _regenerator = __webpack_require__(140);

	var _regenerator2 = _interopRequireDefault(_regenerator);

	var _asyncToGenerator2 = __webpack_require__(143);

	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

	var _classCallCheck2 = __webpack_require__(6);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(7);

	var _createClass3 = _interopRequireDefault(_createClass2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var TranscodingService = function () {
	  function TranscodingService($http, config) {
	    'ngInject';

	    (0, _classCallCheck3.default)(this, TranscodingService);
	    this.$http = $http;
	    this.transcodingBase = config.transcodingBase;
	    this.dashUrl = null;
	    this.thumbnailUrl = null;
	  }

	  // jshint ignore:start


	  (0, _createClass3.default)(TranscodingService, [{
	    key: 'get',
	    value: function () {
	      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(slug) {
	        var transcoding, thumbnailSources;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return this.$http.get(this.transcodingBase + '/' + slug, {
	                  withCredentials: false
	                });

	              case 2:
	                transcoding = _context.sent;
	                thumbnailSources = transcoding.data.data.sources.thumbnailSources['jpg:800x'] || transcoding.data.data.sources.thumbnailSources['jpg:600x'];

	                this.dashUrl = transcoding.data.data.sources.videoSources.httpstream.dash;
	                this.thumbnailUrl = thumbnailSources[0];

	              case 6:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));

	      function get(_x) {
	        return _ref.apply(this, arguments);
	      }

	      return get;
	    }()
	    // jshint ignore:end

	  }]);
	  return TranscodingService;
	}();

	exports.default = TranscodingService;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(141);


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */

	// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g = (function() { return this })() || Function("return this")();

	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;

	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;

	module.exports = __webpack_require__(142);

	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}


/***/ }),
/* 142 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */

	!(function(global) {
	  "use strict";

	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }

	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);

	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);

	    return generator;
	  }
	  runtime.wrap = wrap;

	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }

	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";

	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};

	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}

	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };

	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }

	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";

	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }

	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };

	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };

	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };

	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }

	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }

	    var previousPromise;

	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }

	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }

	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }

	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;

	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );

	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };

	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;

	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }

	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }

	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }

	      context.method = method;
	      context.arg = arg;

	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }

	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;

	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }

	          context.dispatchException(context.arg);

	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }

	        state = GenStateExecuting;

	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;

	          if (record.arg === ContinueSentinel) {
	            continue;
	          }

	          return {
	            value: record.arg,
	            done: context.done
	          };

	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }

	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;

	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);

	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }

	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }

	      return ContinueSentinel;
	    }

	    var record = tryCatch(method, delegate.iterator, context.arg);

	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }

	    var info = record.arg;

	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }

	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;

	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;

	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }

	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }

	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }

	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);

	  Gp[toStringTagSymbol] = "Generator";

	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };

	  Gp.toString = function() {
	    return "[object Generator]";
	  };

	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };

	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }

	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }

	    this.tryEntries.push(entry);
	  }

	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }

	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }

	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();

	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }

	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };

	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }

	      if (typeof iterable.next === "function") {
	        return iterable;
	      }

	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }

	          next.value = undefined;
	          next.done = true;

	          return next;
	        };

	        return next.next = next;
	      }
	    }

	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;

	  function doneResult() {
	    return { value: undefined, done: true };
	  }

	  Context.prototype = {
	    constructor: Context,

	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;

	      this.method = "next";
	      this.arg = undefined;

	      this.tryEntries.forEach(resetTryEntry);

	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },

	    stop: function() {
	      this.done = true;

	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }

	      return this.rval;
	    },

	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }

	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;

	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }

	        return !! caught;
	      }

	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;

	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }

	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");

	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }

	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }

	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }

	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },

	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }

	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }

	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;

	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }

	      return this.complete(record);
	    },

	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }

	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }

	      return ContinueSentinel;
	    },

	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },

	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }

	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },

	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };

	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }

	      return ContinueSentinel;
	    }
	  };
	})(
	  // In sloppy mode, unbound `this` refers to the global object, fallback to
	  // Function constructor if we're in global strict mode. That is sadly a form
	  // of indirect eval which violates Content Security Policy.
	  (function() { return this })() || Function("return this")()
	);


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _promise = __webpack_require__(144);

	var _promise2 = _interopRequireDefault(_promise);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = function (fn) {
	  return function () {
	    var gen = fn.apply(this, arguments);
	    return new _promise2.default(function (resolve, reject) {
	      function step(key, arg) {
	        try {
	          var info = gen[key](arg);
	          var value = info.value;
	        } catch (error) {
	          reject(error);
	          return;
	        }

	        if (info.done) {
	          resolve(value);
	        } else {
	          return _promise2.default.resolve(value).then(function (value) {
	            step("next", value);
	          }, function (err) {
	            step("throw", err);
	          });
	        }
	      }

	      return step("next");
	    });
	  };
	};

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(145), __esModule: true };

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(84);
	__webpack_require__(39);
	__webpack_require__(67);
	__webpack_require__(146);
	__webpack_require__(162);
	__webpack_require__(163);
	module.exports = __webpack_require__(13).Promise;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(44);
	var global = __webpack_require__(12);
	var ctx = __webpack_require__(14);
	var classof = __webpack_require__(109);
	var $export = __webpack_require__(11);
	var isObject = __webpack_require__(19);
	var aFunction = __webpack_require__(15);
	var anInstance = __webpack_require__(147);
	var forOf = __webpack_require__(148);
	var speciesConstructor = __webpack_require__(151);
	var task = __webpack_require__(152).set;
	var microtask = __webpack_require__(154)();
	var newPromiseCapabilityModule = __webpack_require__(155);
	var perform = __webpack_require__(156);
	var userAgent = __webpack_require__(157);
	var promiseResolve = __webpack_require__(158);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(64)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();

	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};

	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(159)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}

	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(63)($Promise, PROMISE);
	__webpack_require__(160)(PROMISE);
	Wrapper = __webpack_require__(13)[PROMISE];

	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(161)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 147 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(14);
	var call = __webpack_require__(149);
	var isArrayIter = __webpack_require__(150);
	var anObject = __webpack_require__(18);
	var toLength = __webpack_require__(56);
	var getIterFn = __webpack_require__(113);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(18);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(46);
	var ITERATOR = __webpack_require__(64)('iterator');
	var ArrayProto = Array.prototype;

	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(18);
	var aFunction = __webpack_require__(15);
	var SPECIES = __webpack_require__(64)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(14);
	var invoke = __webpack_require__(153);
	var html = __webpack_require__(62);
	var cel = __webpack_require__(23);
	var global = __webpack_require__(12);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(54)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 153 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(12);
	var macrotask = __webpack_require__(152).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(54)(process) == 'process';

	module.exports = function () {
	  var head, last, notify;

	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };

	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }

	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(15);

	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}

	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 156 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(12);
	var navigator = global.navigator;

	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(18);
	var isObject = __webpack_require__(19);
	var newPromiseCapability = __webpack_require__(155);

	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	var hide = __webpack_require__(16);
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    if (safe && target[key]) target[key] = src[key];
	    else hide(target, key, src[key]);
	  } return target;
	};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(12);
	var core = __webpack_require__(13);
	var dP = __webpack_require__(17);
	var DESCRIPTORS = __webpack_require__(21);
	var SPECIES = __webpack_require__(64)('species');

	module.exports = function (KEY) {
	  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(64)('iterator');
	var SAFE_CLOSING = false;

	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }

	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(11);
	var core = __webpack_require__(13);
	var global = __webpack_require__(12);
	var speciesConstructor = __webpack_require__(151);
	var promiseResolve = __webpack_require__(158);

	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(11);
	var newPromiseCapability = __webpack_require__(155);
	var perform = __webpack_require__(156);

	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _classCallCheck2 = __webpack_require__(6);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/* global XMLHttpRequest:false */
	var CodeViewDirective = function CodeViewDirective() {
	  'ngInject';

	  (0, _classCallCheck3.default)(this, CodeViewDirective);
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/codeView/codeView.html',
	    controller: CodeViewController,
	    controllerAs: 'vm',
	    bindToController: true
	  };

	  return directive;
	};

	var CodeViewController = function CodeViewController(itemService, $timeout, loadingService) {
	  'ngInject';

	  var service = this;

	  service.setCode = function (code) {
	    $timeout(function () {
	      service.code = code;
	    });
	  };

	  var languages = {
	    md: "markdown"
	  };

	  var language = languages[itemService.fileExtension()];
	  if (language) {
	    service.language = language;
	  }

	  service.getFile = function () {
	    var url = itemService.data.source_url;

	    var request = new XMLHttpRequest();
	    request.open('GET', url);
	    loadingService.setState("codeLoad", true);

	    request.onreadystatechange = function () {
	      if (!loadingService.getState("codeLoad")) {
	        return;
	      }
	      if (request.readyState === 4) {
	        if (request.response.length < 100000) {
	          loadingService.setState("codeLoad", false);
	          service.setCode(request.response);
	        } else {
	          loadingService.setState("codeLoad", false);
	          itemService.data.type = 'other';
	        }
	      }
	    };

	    request.send();

	    $timeout(function () {
	      if (!loadingService.getState("codeLoad")) {
	        return;
	      }
	      loadingService.setState("codeLoad", false);
	      itemService.data.type = 'other';
	    }, 10000);
	  };
	  service.getFile();

	  return service;
	};

	exports.default = CodeViewDirective;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass2 = __webpack_require__(7);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _classCallCheck2 = __webpack_require__(6);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _lodash = __webpack_require__(27);

	var _lodash2 = _interopRequireDefault(_lodash);

	var _pixi = __webpack_require__(166);

	var PIXI = _interopRequireWildcard(_pixi);

	var _urlSearchParams = __webpack_require__(356);

	var _urlSearchParams2 = _interopRequireDefault(_urlSearchParams);

	var _imageLoader = __webpack_require__(96);

	var _imageLoader2 = _interopRequireDefault(_imageLoader);

	var _CloudAppImage = __webpack_require__(357);

	var _CloudAppImage2 = _interopRequireDefault(_CloudAppImage);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var pixi = new PIXI.Application(1); /* global window, $, platform */

	var stage = pixi.stage;

	var ImageViewDirective = function ImageViewDirective() {
	    'ngInject';

	    (0, _classCallCheck3.default)(this, ImageViewDirective);
	    var directive = {
	        restrict: 'E',
	        templateUrl: 'app/imageView/imageView.html',
	        controller: ImageViewController,
	        controllerAs: 'vm',
	        bindToController: true
	    };

	    return directive;
	};

	var ImageViewController = function () {
	    function ImageViewController($ngSilentLocation, itemService, $, $timeout, $location) {
	        'ngInject';

	        var _this = this;

	        (0, _classCallCheck3.default)(this, ImageViewController);
	        this.item = itemService;
	        this._$location = $location;
	        this._$silent = $ngSilentLocation;
	        this._$timeout = $timeout;
	        var vm = this;

	        var viewport = $('#image_viewport');

	        var setImageCss = function setImageCss() {
	            var maxHeight = $(window).height() - 75;
	            var html = 'image-view img, image-view canvas { max-height: ' + maxHeight + 'px; }';
	            html += 'image-view .zoom img, image-view .zoom canvas { max-height: none; }';
	            $('#dynamicCss').get(0).innerHTML = html;
	        };

	        var setZoomable = function setZoomable() {
	            setImageCss();
	            var int = function int(n) {
	                return parseInt(n, 10);
	            };
	            var widthWithoutZoom = int(viewport.find('img, canvas').css('width'));
	            var heightWithoutZoom = int(viewport.find('img, canvas').css('height'));
	            viewport.toggleClass('zoom');
	            var widthWithZoom = int(viewport.find('img, canvas').css('width'));
	            var heightWithZoom = int(viewport.find('img, canvas').css('height'));
	            viewport.toggleClass('zoom');
	            vm.zoomable = widthWithoutZoom !== widthWithZoom || heightWithoutZoom !== heightWithZoom;
	            $timeout();
	        };

	        setImageCss();
	        viewport.find('img.raw_image').on('load', function () {
	            setZoomable();
	            _this.zoom = !!_this.item.zoom;
	        });

	        $(window).on('resize', _lodash2.default.debounce(setZoomable, 100));

	        var canvasLoader = this.loadCanvas();
	        if (canvasLoader) {
	            canvasLoader.then(setZoomable);
	        }
	    }

	    (0, _createClass3.default)(ImageViewController, [{
	        key: 'loadCanvas',
	        value: function loadCanvas() {
	            var vm = this;
	            if (this.item.data.mimetype !== 'image/jpeg') {
	                return;
	            }

	            var deeplinking = new _urlSearchParams2.default(window.location.search).get('deeplinking');

	            if (deeplinking) {
	                this._$timeout(5000).then(function () {
	                    vm.image = new _CloudAppImage2.default({
	                        src: vm.item.data.latest_source_url,
	                        canvas: document.getElementById('drop-canvas')
	                    });
	                }).catch(function (e) {
	                    return console.log('DEEPLINKER ERROR', e);
	                });
	            }

	            if (_lodash2.default.include(['iOS', 'Android'], platform.os.family)) {
	                return;
	            }
	            if (_lodash2.default.include(['Firefox'], platform.name)) {
	                return;
	            }

	            var viewport = $('#image_view-port');

	            return (0, _imageLoader2.default)(this.item.data.annotation_source_url).then(function (options) {
	                if (_lodash2.default.get(options, 'orientation', 1) > 1) {
	                    viewport.find('img.raw_image').hide();
	                    viewport[0].appendChild(options.image);
	                    viewport.find('img.raw_image').remove();
	                }
	            });
	        }
	    }, {
	        key: 'toggleZoom',
	        value: function toggleZoom() {
	            if (!this.zoomable) {
	                return;
	            }
	            this.zoom = !this.zoom;

	            var basePath = this._$location.path();
	            basePath = basePath.replace(/\/o$/, '');
	            var tout = $('tout');
	            tout.show();

	            if (this.zoom) {
	                basePath += '/o';
	                tout.hide();
	            }

	            this._$silent.silent(basePath, true);
	        }
	    }]);
	    return ImageViewController;
	}();

	exports.default = ImageViewDirective;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';

	exports.__esModule = true;
	exports.loader = exports.prepare = exports.particles = exports.mesh = exports.loaders = exports.interaction = exports.filters = exports.extras = exports.extract = exports.accessibility = undefined;

	var _polyfill = __webpack_require__(167);

	Object.keys(_polyfill).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _polyfill[key];
	        }
	    });
	});

	var _core = __webpack_require__(173);

	Object.keys(_core).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _core[key];
	        }
	    });
	});

	var _deprecation = __webpack_require__(292);

	var _deprecation2 = _interopRequireDefault(_deprecation);

	var _accessibility = __webpack_require__(293);

	var accessibility = _interopRequireWildcard(_accessibility);

	var _extract = __webpack_require__(296);

	var extract = _interopRequireWildcard(_extract);

	var _extras = __webpack_require__(299);

	var extras = _interopRequireWildcard(_extras);

	var _filters = __webpack_require__(307);

	var filters = _interopRequireWildcard(_filters);

	var _interaction = __webpack_require__(319);

	var interaction = _interopRequireWildcard(_interaction);

	var _loaders = __webpack_require__(325);

	var loaders = _interopRequireWildcard(_loaders);

	var _mesh = __webpack_require__(338);

	var mesh = _interopRequireWildcard(_mesh);

	var _particles = __webpack_require__(345);

	var particles = _interopRequireWildcard(_particles);

	var _prepare = __webpack_require__(350);

	var prepare = _interopRequireWildcard(_prepare);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	// export core
	_core.utils.mixins.performMixins();

	/**
	 * Alias for {@link PIXI.loaders.shared}.
	 * @name loader
	 * @memberof PIXI
	 * @type {PIXI.loader.Loader}
	 */


	// handle mixins now, after all code has been added, including deprecation


	// export libs
	// import polyfills. Done as an export to make sure polyfills are imported first
	var loader = loaders.shared || null;

	exports.accessibility = accessibility;
	exports.extract = extract;
	exports.extras = extras;
	exports.filters = filters;
	exports.interaction = interaction;
	exports.loaders = loaders;
	exports.mesh = mesh;
	exports.particles = particles;
	exports.prepare = prepare;
	exports.loader = loader;

	// Apply the deprecations

	if (typeof _deprecation2.default === 'function') {
	    (0, _deprecation2.default)(exports);
	}

	// Always export PixiJS globally.
	global.PIXI = exports; // eslint-disable-line
	//# sourceMappingURL=index.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	__webpack_require__(168);

	__webpack_require__(170);

	__webpack_require__(171);

	__webpack_require__(172);

	if (!window.ArrayBuffer) {
	    window.ArrayBuffer = Array;
	}

	if (!window.Float32Array) {
	    window.Float32Array = Array;
	}

	if (!window.Uint32Array) {
	    window.Uint32Array = Array;
	}

	if (!window.Uint16Array) {
	    window.Uint16Array = Array;
	}
	//# sourceMappingURL=index.js.map

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _objectAssign = __webpack_require__(169);

	var _objectAssign2 = _interopRequireDefault(_objectAssign);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	if (!Object.assign) {
	    Object.assign = _objectAssign2.default;
	} // References:
	// https://github.com/sindresorhus/object-assign
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
	//# sourceMappingURL=Object.assign.js.map

/***/ }),
/* 169 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/

	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}

			// Detect buggy property enumeration order in older V8 versions.

			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}

			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}

	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;

		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);

			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}

			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}

		return to;
	};


/***/ }),
/* 170 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';

	// References:
	// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
	// https://gist.github.com/1579671
	// http://updates.html5rocks.com/2012/05/requestAnimationFrame-API-now-with-sub-millisecond-precision
	// https://gist.github.com/timhall/4078614
	// https://github.com/Financial-Times/polyfill-service/tree/master/polyfills/requestAnimationFrame

	// Expected to be used with Browserfiy
	// Browserify automatically detects the use of `global` and passes the
	// correct reference of `global`, `self`, and finally `window`

	var ONE_FRAME_TIME = 16;

	// Date.now
	if (!(Date.now && Date.prototype.getTime)) {
	    Date.now = function now() {
	        return new Date().getTime();
	    };
	}

	// performance.now
	if (!(global.performance && global.performance.now)) {
	    var startTime = Date.now();

	    if (!global.performance) {
	        global.performance = {};
	    }

	    global.performance.now = function () {
	        return Date.now() - startTime;
	    };
	}

	// requestAnimationFrame
	var lastTime = Date.now();
	var vendors = ['ms', 'moz', 'webkit', 'o'];

	for (var x = 0; x < vendors.length && !global.requestAnimationFrame; ++x) {
	    var p = vendors[x];

	    global.requestAnimationFrame = global[p + 'RequestAnimationFrame'];
	    global.cancelAnimationFrame = global[p + 'CancelAnimationFrame'] || global[p + 'CancelRequestAnimationFrame'];
	}

	if (!global.requestAnimationFrame) {
	    global.requestAnimationFrame = function (callback) {
	        if (typeof callback !== 'function') {
	            throw new TypeError(callback + 'is not a function');
	        }

	        var currentTime = Date.now();
	        var delay = ONE_FRAME_TIME + lastTime - currentTime;

	        if (delay < 0) {
	            delay = 0;
	        }

	        lastTime = currentTime;

	        return setTimeout(function () {
	            lastTime = Date.now();
	            callback(performance.now());
	        }, delay);
	    };
	}

	if (!global.cancelAnimationFrame) {
	    global.cancelAnimationFrame = function (id) {
	        return clearTimeout(id);
	    };
	}
	//# sourceMappingURL=requestAnimationFrame.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 171 */
/***/ (function(module, exports) {

	"use strict";

	// References:
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/sign

	if (!Math.sign) {
	    Math.sign = function mathSign(x) {
	        x = Number(x);

	        if (x === 0 || isNaN(x)) {
	            return x;
	        }

	        return x > 0 ? 1 : -1;
	    };
	}
	//# sourceMappingURL=Math.sign.js.map

/***/ }),
/* 172 */
/***/ (function(module, exports) {

	'use strict';

	// References:
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isInteger

	if (!Number.isInteger) {
	    Number.isInteger = function numberIsInteger(value) {
	        return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
	    };
	}
	//# sourceMappingURL=Number.isInteger.js.map

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;
	exports.autoDetectRenderer = exports.Application = exports.Filter = exports.SpriteMaskFilter = exports.Quad = exports.RenderTarget = exports.ObjectRenderer = exports.WebGLManager = exports.Shader = exports.CanvasRenderTarget = exports.TextureUvs = exports.VideoBaseTexture = exports.BaseRenderTexture = exports.RenderTexture = exports.BaseTexture = exports.TextureMatrix = exports.Texture = exports.Spritesheet = exports.CanvasGraphicsRenderer = exports.GraphicsRenderer = exports.GraphicsData = exports.Graphics = exports.TextMetrics = exports.TextStyle = exports.Text = exports.SpriteRenderer = exports.CanvasTinter = exports.CanvasSpriteRenderer = exports.Sprite = exports.TransformBase = exports.TransformStatic = exports.Transform = exports.Container = exports.DisplayObject = exports.Bounds = exports.glCore = exports.WebGLRenderer = exports.CanvasRenderer = exports.ticker = exports.utils = exports.settings = undefined;

	var _const = __webpack_require__(174);

	Object.keys(_const).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _const[key];
	    }
	  });
	});

	var _math = __webpack_require__(175);

	Object.keys(_math).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _math[key];
	    }
	  });
	});

	var _pixiGlCore = __webpack_require__(185);

	Object.defineProperty(exports, 'glCore', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_pixiGlCore).default;
	  }
	});

	var _Bounds = __webpack_require__(202);

	Object.defineProperty(exports, 'Bounds', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Bounds).default;
	  }
	});

	var _DisplayObject = __webpack_require__(203);

	Object.defineProperty(exports, 'DisplayObject', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DisplayObject).default;
	  }
	});

	var _Container = __webpack_require__(212);

	Object.defineProperty(exports, 'Container', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Container).default;
	  }
	});

	var _Transform = __webpack_require__(211);

	Object.defineProperty(exports, 'Transform', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Transform).default;
	  }
	});

	var _TransformStatic = __webpack_require__(209);

	Object.defineProperty(exports, 'TransformStatic', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TransformStatic).default;
	  }
	});

	var _TransformBase = __webpack_require__(210);

	Object.defineProperty(exports, 'TransformBase', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TransformBase).default;
	  }
	});

	var _Sprite = __webpack_require__(219);

	Object.defineProperty(exports, 'Sprite', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Sprite).default;
	  }
	});

	var _CanvasSpriteRenderer = __webpack_require__(234);

	Object.defineProperty(exports, 'CanvasSpriteRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CanvasSpriteRenderer).default;
	  }
	});

	var _CanvasTinter = __webpack_require__(243);

	Object.defineProperty(exports, 'CanvasTinter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CanvasTinter).default;
	  }
	});

	var _SpriteRenderer = __webpack_require__(244);

	Object.defineProperty(exports, 'SpriteRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SpriteRenderer).default;
	  }
	});

	var _Text = __webpack_require__(273);

	Object.defineProperty(exports, 'Text', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Text).default;
	  }
	});

	var _TextStyle = __webpack_require__(274);

	Object.defineProperty(exports, 'TextStyle', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TextStyle).default;
	  }
	});

	var _TextMetrics = __webpack_require__(275);

	Object.defineProperty(exports, 'TextMetrics', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TextMetrics).default;
	  }
	});

	var _Graphics = __webpack_require__(277);

	Object.defineProperty(exports, 'Graphics', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Graphics).default;
	  }
	});

	var _GraphicsData = __webpack_require__(278);

	Object.defineProperty(exports, 'GraphicsData', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GraphicsData).default;
	  }
	});

	var _GraphicsRenderer = __webpack_require__(280);

	Object.defineProperty(exports, 'GraphicsRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GraphicsRenderer).default;
	  }
	});

	var _CanvasGraphicsRenderer = __webpack_require__(288);

	Object.defineProperty(exports, 'CanvasGraphicsRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CanvasGraphicsRenderer).default;
	  }
	});

	var _Spritesheet = __webpack_require__(289);

	Object.defineProperty(exports, 'Spritesheet', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Spritesheet).default;
	  }
	});

	var _Texture = __webpack_require__(220);

	Object.defineProperty(exports, 'Texture', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Texture).default;
	  }
	});

	var _TextureMatrix = __webpack_require__(256);

	Object.defineProperty(exports, 'TextureMatrix', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TextureMatrix).default;
	  }
	});

	var _BaseTexture = __webpack_require__(221);

	Object.defineProperty(exports, 'BaseTexture', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BaseTexture).default;
	  }
	});

	var _RenderTexture = __webpack_require__(237);

	Object.defineProperty(exports, 'RenderTexture', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RenderTexture).default;
	  }
	});

	var _BaseRenderTexture = __webpack_require__(238);

	Object.defineProperty(exports, 'BaseRenderTexture', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BaseRenderTexture).default;
	  }
	});

	var _VideoBaseTexture = __webpack_require__(229);

	Object.defineProperty(exports, 'VideoBaseTexture', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_VideoBaseTexture).default;
	  }
	});

	var _TextureUvs = __webpack_require__(233);

	Object.defineProperty(exports, 'TextureUvs', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TextureUvs).default;
	  }
	});

	var _CanvasRenderTarget = __webpack_require__(240);

	Object.defineProperty(exports, 'CanvasRenderTarget', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CanvasRenderTarget).default;
	  }
	});

	var _Shader = __webpack_require__(262);

	Object.defineProperty(exports, 'Shader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Shader).default;
	  }
	});

	var _WebGLManager = __webpack_require__(246);

	Object.defineProperty(exports, 'WebGLManager', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_WebGLManager).default;
	  }
	});

	var _ObjectRenderer = __webpack_require__(245);

	Object.defineProperty(exports, 'ObjectRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ObjectRenderer).default;
	  }
	});

	var _RenderTarget = __webpack_require__(259);

	Object.defineProperty(exports, 'RenderTarget', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RenderTarget).default;
	  }
	});

	var _Quad = __webpack_require__(260);

	Object.defineProperty(exports, 'Quad', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Quad).default;
	  }
	});

	var _SpriteMaskFilter = __webpack_require__(249);

	Object.defineProperty(exports, 'SpriteMaskFilter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SpriteMaskFilter).default;
	  }
	});

	var _Filter = __webpack_require__(250);

	Object.defineProperty(exports, 'Filter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Filter).default;
	  }
	});

	var _Application = __webpack_require__(290);

	Object.defineProperty(exports, 'Application', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Application).default;
	  }
	});

	var _autoDetectRenderer = __webpack_require__(291);

	Object.defineProperty(exports, 'autoDetectRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _autoDetectRenderer.autoDetectRenderer;
	  }
	});

	var _utils = __webpack_require__(213);

	var utils = _interopRequireWildcard(_utils);

	var _ticker = __webpack_require__(230);

	var ticker = _interopRequireWildcard(_ticker);

	var _settings = __webpack_require__(205);

	var _settings2 = _interopRequireDefault(_settings);

	var _CanvasRenderer = __webpack_require__(235);

	var _CanvasRenderer2 = _interopRequireDefault(_CanvasRenderer);

	var _WebGLRenderer = __webpack_require__(247);

	var _WebGLRenderer2 = _interopRequireDefault(_WebGLRenderer);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.settings = _settings2.default;
	exports.utils = utils;
	exports.ticker = ticker;
	exports.CanvasRenderer = _CanvasRenderer2.default;
	exports.WebGLRenderer = _WebGLRenderer2.default; /**
	                                                  * @namespace PIXI
	                                                  */
	//# sourceMappingURL=index.js.map

/***/ }),
/* 174 */
/***/ (function(module, exports) {

	'use strict';

	exports.__esModule = true;
	/**
	 * String of the current PIXI version.
	 *
	 * @static
	 * @constant
	 * @memberof PIXI
	 * @name VERSION
	 * @type {string}
	 */
	var VERSION = exports.VERSION = '4.8.2';

	/**
	 * Two Pi.
	 *
	 * @static
	 * @constant
	 * @memberof PIXI
	 * @type {number}
	 */
	var PI_2 = exports.PI_2 = Math.PI * 2;

	/**
	 * Conversion factor for converting radians to degrees.
	 *
	 * @static
	 * @constant
	 * @memberof PIXI
	 * @type {number}
	 */
	var RAD_TO_DEG = exports.RAD_TO_DEG = 180 / Math.PI;

	/**
	 * Conversion factor for converting degrees to radians.
	 *
	 * @static
	 * @constant
	 * @memberof PIXI
	 * @type {number}
	 */
	var DEG_TO_RAD = exports.DEG_TO_RAD = Math.PI / 180;

	/**
	 * Constant to identify the Renderer Type.
	 *
	 * @static
	 * @constant
	 * @memberof PIXI
	 * @name RENDERER_TYPE
	 * @type {object}
	 * @property {number} UNKNOWN - Unknown render type.
	 * @property {number} WEBGL - WebGL render type.
	 * @property {number} CANVAS - Canvas render type.
	 */
	var RENDERER_TYPE = exports.RENDERER_TYPE = {
	  UNKNOWN: 0,
	  WEBGL: 1,
	  CANVAS: 2
	};

	/**
	 * Various blend modes supported by PIXI.
	 *
	 * IMPORTANT - The WebGL renderer only supports the NORMAL, ADD, MULTIPLY and SCREEN blend modes.
	 * Anything else will silently act like NORMAL.
	 *
	 * @static
	 * @constant
	 * @memberof PIXI
	 * @name BLEND_MODES
	 * @type {object}
	 * @property {number} NORMAL
	 * @property {number} ADD
	 * @property {number} MULTIPLY
	 * @property {number} SCREEN
	 * @property {number} OVERLAY
	 * @property {number} DARKEN
	 * @property {number} LIGHTEN
	 * @property {number} COLOR_DODGE
	 * @property {number} COLOR_BURN
	 * @property {number} HARD_LIGHT
	 * @property {number} SOFT_LIGHT
	 * @property {number} DIFFERENCE
	 * @property {number} EXCLUSION
	 * @property {number} HUE
	 * @property {number} SATURATION
	 * @property {number} COLOR
	 * @property {number} LUMINOSITY
	 */
	var BLEND_MODES = exports.BLEND_MODES = {
	  NORMAL: 0,
	  ADD: 1,
	  MULTIPLY: 2,
	  SCREEN: 3,
	  OVERLAY: 4,
	  DARKEN: 5,
	  LIGHTEN: 6,
	  COLOR_DODGE: 7,
	  COLOR_BURN: 8,
	  HARD_LIGHT: 9,
	  SOFT_LIGHT: 10,
	  DIFFERENCE: 11,
	  EXCLUSION: 12,
	  HUE: 13,
	  SATURATION: 14,
	  COLOR: 15,
	  LUMINOSITY: 16,
	  NORMAL_NPM: 17,
	  ADD_NPM: 18,
	  SCREEN_NPM: 19
	};

	/**
	 * Various webgl draw modes. These can be used to specify which GL drawMode to use
	 * under certain situations and renderers.
	 *
	 * @static
	 * @constant
	 * @memberof PIXI
	 * @name DRAW_MODES
	 * @type {object}
	 * @property {number} POINTS
	 * @property {number} LINES
	 * @property {number} LINE_LOOP
	 * @property {number} LINE_STRIP
	 * @property {number} TRIANGLES
	 * @property {number} TRIANGLE_STRIP
	 * @property {number} TRIANGLE_FAN
	 */
	var DRAW_MODES = exports.DRAW_MODES = {
	  POINTS: 0,
	  LINES: 1,
	  LINE_LOOP: 2,
	  LINE_STRIP: 3,
	  TRIANGLES: 4,
	  TRIANGLE_STRIP: 5,
	  TRIANGLE_FAN: 6
	};

	/**
	 * The scale modes that are supported by pixi.
	 *
	 * The {@link PIXI.settings.SCALE_MODE} scale mode affects the default scaling mode of future operations.
	 * It can be re-assigned to either LINEAR or NEAREST, depending upon suitability.
	 *
	 * @static
	 * @constant
	 * @memberof PIXI
	 * @name SCALE_MODES
	 * @type {object}
	 * @property {number} LINEAR Smooth scaling
	 * @property {number} NEAREST Pixelating scaling
	 */
	var SCALE_MODES = exports.SCALE_MODES = {
	  LINEAR: 0,
	  NEAREST: 1
	};

	/**
	 * The wrap modes that are supported by pixi.
	 *
	 * The {@link PIXI.settings.WRAP_MODE} wrap mode affects the default wrapping mode of future operations.
	 * It can be re-assigned to either CLAMP or REPEAT, depending upon suitability.
	 * If the texture is non power of two then clamp will be used regardless as webGL can
	 * only use REPEAT if the texture is po2.
	 *
	 * This property only affects WebGL.
	 *
	 * @static
	 * @constant
	 * @name WRAP_MODES
	 * @memberof PIXI
	 * @type {object}
	 * @property {number} CLAMP - The textures uvs are clamped
	 * @property {number} REPEAT - The texture uvs tile and repeat
	 * @property {number} MIRRORED_REPEAT - The texture uvs tile and repeat with mirroring
	 */
	var WRAP_MODES = exports.WRAP_MODES = {
	  CLAMP: 0,
	  REPEAT: 1,
	  MIRRORED_REPEAT: 2
	};

	/**
	 * The gc modes that are supported by pixi.
	 *
	 * The {@link PIXI.settings.GC_MODE} Garbage Collection mode for PixiJS textures is AUTO
	 * If set to GC_MODE, the renderer will occasionally check textures usage. If they are not
	 * used for a specified period of time they will be removed from the GPU. They will of course
	 * be uploaded again when they are required. This is a silent behind the scenes process that
	 * should ensure that the GPU does not  get filled up.
	 *
	 * Handy for mobile devices!
	 * This property only affects WebGL.
	 *
	 * @static
	 * @constant
	 * @name GC_MODES
	 * @memberof PIXI
	 * @type {object}
	 * @property {number} AUTO - Garbage collection will happen periodically automatically
	 * @property {number} MANUAL - Garbage collection will need to be called manually
	 */
	var GC_MODES = exports.GC_MODES = {
	  AUTO: 0,
	  MANUAL: 1
	};

	/**
	 * Regexp for image type by extension.
	 *
	 * @static
	 * @constant
	 * @memberof PIXI
	 * @type {RegExp|string}
	 * @example `image.png`
	 */
	var URL_FILE_EXTENSION = exports.URL_FILE_EXTENSION = /\.(\w{3,4})(?:$|\?|#)/i;

	/**
	 * Regexp for data URI.
	 * Based on: {@link https://github.com/ragingwind/data-uri-regex}
	 *
	 * @static
	 * @constant
	 * @name DATA_URI
	 * @memberof PIXI
	 * @type {RegExp|string}
	 * @example data:image/png;base64
	 */
	var DATA_URI = exports.DATA_URI = /^\s*data:(?:([\w-]+)\/([\w+.-]+))?(?:;charset=([\w-]+))?(?:;(base64))?,(.*)/i;

	/**
	 * Regexp for SVG size.
	 *
	 * @static
	 * @constant
	 * @name SVG_SIZE
	 * @memberof PIXI
	 * @type {RegExp|string}
	 * @example &lt;svg width="100" height="100"&gt;&lt;/svg&gt;
	 */
	var SVG_SIZE = exports.SVG_SIZE = /<svg[^>]*(?:\s(width|height)=('|")(\d*(?:\.\d+)?)(?:px)?('|"))[^>]*(?:\s(width|height)=('|")(\d*(?:\.\d+)?)(?:px)?('|"))[^>]*>/i; // eslint-disable-line max-len

	/**
	 * Constants that identify shapes, mainly to prevent `instanceof` calls.
	 *
	 * @static
	 * @constant
	 * @name SHAPES
	 * @memberof PIXI
	 * @type {object}
	 * @property {number} POLY Polygon
	 * @property {number} RECT Rectangle
	 * @property {number} CIRC Circle
	 * @property {number} ELIP Ellipse
	 * @property {number} RREC Rounded Rectangle
	 */
	var SHAPES = exports.SHAPES = {
	  POLY: 0,
	  RECT: 1,
	  CIRC: 2,
	  ELIP: 3,
	  RREC: 4
	};

	/**
	 * Constants that specify float precision in shaders.
	 *
	 * @static
	 * @constant
	 * @name PRECISION
	 * @memberof PIXI
	 * @type {object}
	 * @property {string} LOW='lowp'
	 * @property {string} MEDIUM='mediump'
	 * @property {string} HIGH='highp'
	 */
	var PRECISION = exports.PRECISION = {
	  LOW: 'lowp',
	  MEDIUM: 'mediump',
	  HIGH: 'highp'
	};

	/**
	 * Constants that specify the transform type.
	 *
	 * @static
	 * @constant
	 * @name TRANSFORM_MODE
	 * @memberof PIXI
	 * @type {object}
	 * @property {number} STATIC
	 * @property {number} DYNAMIC
	 */
	var TRANSFORM_MODE = exports.TRANSFORM_MODE = {
	  STATIC: 0,
	  DYNAMIC: 1
	};

	/**
	 * Constants that define the type of gradient on text.
	 *
	 * @static
	 * @constant
	 * @name TEXT_GRADIENT
	 * @memberof PIXI
	 * @type {object}
	 * @property {number} LINEAR_VERTICAL Vertical gradient
	 * @property {number} LINEAR_HORIZONTAL Linear gradient
	 */
	var TEXT_GRADIENT = exports.TEXT_GRADIENT = {
	  LINEAR_VERTICAL: 0,
	  LINEAR_HORIZONTAL: 1
	};

	/**
	 * Represents the update priorities used by internal PIXI classes when registered with
	 * the {@link PIXI.ticker.Ticker} object. Higher priority items are updated first and lower
	 * priority items, such as render, should go later.
	 *
	 * @static
	 * @constant
	 * @name UPDATE_PRIORITY
	 * @memberof PIXI
	 * @type {object}
	 * @property {number} INTERACTION=50 Highest priority, used for {@link PIXI.interaction.InteractionManager}
	 * @property {number} HIGH=25 High priority updating, {@link PIXI.VideoBaseTexture} and {@link PIXI.extras.AnimatedSprite}
	 * @property {number} NORMAL=0 Default priority for ticker events, see {@link PIXI.ticker.Ticker#add}.
	 * @property {number} LOW=-25 Low priority used for {@link PIXI.Application} rendering.
	 * @property {number} UTILITY=-50 Lowest priority used for {@link PIXI.prepare.BasePrepare} utility.
	 */
	var UPDATE_PRIORITY = exports.UPDATE_PRIORITY = {
	  INTERACTION: 50,
	  HIGH: 25,
	  NORMAL: 0,
	  LOW: -25,
	  UTILITY: -50
	};
	//# sourceMappingURL=const.js.map

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _Point = __webpack_require__(176);

	Object.defineProperty(exports, 'Point', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Point).default;
	  }
	});

	var _ObservablePoint = __webpack_require__(177);

	Object.defineProperty(exports, 'ObservablePoint', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ObservablePoint).default;
	  }
	});

	var _Matrix = __webpack_require__(178);

	Object.defineProperty(exports, 'Matrix', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Matrix).default;
	  }
	});

	var _GroupD = __webpack_require__(179);

	Object.defineProperty(exports, 'GroupD8', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GroupD).default;
	  }
	});

	var _Circle = __webpack_require__(180);

	Object.defineProperty(exports, 'Circle', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Circle).default;
	  }
	});

	var _Ellipse = __webpack_require__(182);

	Object.defineProperty(exports, 'Ellipse', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Ellipse).default;
	  }
	});

	var _Polygon = __webpack_require__(183);

	Object.defineProperty(exports, 'Polygon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Polygon).default;
	  }
	});

	var _Rectangle = __webpack_require__(181);

	Object.defineProperty(exports, 'Rectangle', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Rectangle).default;
	  }
	});

	var _RoundedRectangle = __webpack_require__(184);

	Object.defineProperty(exports, 'RoundedRectangle', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RoundedRectangle).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=index.js.map

/***/ }),
/* 176 */
/***/ (function(module, exports) {

	"use strict";

	exports.__esModule = true;

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/**
	 * The Point object represents a location in a two-dimensional coordinate system, where x represents
	 * the horizontal axis and y represents the vertical axis.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var Point = function () {
	  /**
	   * @param {number} [x=0] - position of the point on the x axis
	   * @param {number} [y=0] - position of the point on the y axis
	   */
	  function Point() {
	    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

	    _classCallCheck(this, Point);

	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.x = x;

	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.y = y;
	  }

	  /**
	   * Creates a clone of this point
	   *
	   * @return {PIXI.Point} a copy of the point
	   */


	  Point.prototype.clone = function clone() {
	    return new Point(this.x, this.y);
	  };

	  /**
	   * Copies x and y from the given point
	   *
	   * @param {PIXI.Point} p - The point to copy.
	   */


	  Point.prototype.copy = function copy(p) {
	    this.set(p.x, p.y);
	  };

	  /**
	   * Returns true if the given point is equal to this point
	   *
	   * @param {PIXI.Point} p - The point to check
	   * @returns {boolean} Whether the given point equal to this point
	   */


	  Point.prototype.equals = function equals(p) {
	    return p.x === this.x && p.y === this.y;
	  };

	  /**
	   * Sets the point to a new x and y position.
	   * If y is omitted, both x and y will be set to x.
	   *
	   * @param {number} [x=0] - position of the point on the x axis
	   * @param {number} [y=0] - position of the point on the y axis
	   */


	  Point.prototype.set = function set(x, y) {
	    this.x = x || 0;
	    this.y = y || (y !== 0 ? this.x : 0);
	  };

	  return Point;
	}();

	exports.default = Point;
	//# sourceMappingURL=Point.js.map

/***/ }),
/* 177 */
/***/ (function(module, exports) {

	"use strict";

	exports.__esModule = true;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/**
	 * The Point object represents a location in a two-dimensional coordinate system, where x represents
	 * the horizontal axis and y represents the vertical axis.
	 * An observable point is a point that triggers a callback when the point's position is changed.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var ObservablePoint = function () {
	    /**
	     * @param {Function} cb - callback when changed
	     * @param {object} scope - owner of callback
	     * @param {number} [x=0] - position of the point on the x axis
	     * @param {number} [y=0] - position of the point on the y axis
	     */
	    function ObservablePoint(cb, scope) {
	        var x = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	        var y = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

	        _classCallCheck(this, ObservablePoint);

	        this._x = x;
	        this._y = y;

	        this.cb = cb;
	        this.scope = scope;
	    }

	    /**
	     * Creates a clone of this point.
	     * The callback and scope params can be overidden otherwise they will default
	     * to the clone object's values.
	     *
	     * @override
	     * @param {Function} [cb=null] - callback when changed
	     * @param {object} [scope=null] - owner of callback
	     * @return {PIXI.ObservablePoint} a copy of the point
	     */


	    ObservablePoint.prototype.clone = function clone() {
	        var cb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	        var _cb = cb || this.cb;
	        var _scope = scope || this.scope;

	        return new ObservablePoint(_cb, _scope, this._x, this._y);
	    };

	    /**
	     * Sets the point to a new x and y position.
	     * If y is omitted, both x and y will be set to x.
	     *
	     * @param {number} [x=0] - position of the point on the x axis
	     * @param {number} [y=0] - position of the point on the y axis
	     */


	    ObservablePoint.prototype.set = function set(x, y) {
	        var _x = x || 0;
	        var _y = y || (y !== 0 ? _x : 0);

	        if (this._x !== _x || this._y !== _y) {
	            this._x = _x;
	            this._y = _y;
	            this.cb.call(this.scope);
	        }
	    };

	    /**
	     * Copies the data from another point
	     *
	     * @param {PIXI.Point|PIXI.ObservablePoint} point - point to copy from
	     */


	    ObservablePoint.prototype.copy = function copy(point) {
	        if (this._x !== point.x || this._y !== point.y) {
	            this._x = point.x;
	            this._y = point.y;
	            this.cb.call(this.scope);
	        }
	    };

	    /**
	     * Returns true if the given point is equal to this point
	     *
	     * @param {PIXI.Point|PIXI.ObservablePoint} p - The point to check
	     * @returns {boolean} Whether the given point equal to this point
	     */


	    ObservablePoint.prototype.equals = function equals(p) {
	        return p.x === this._x && p.y === this._y;
	    };

	    /**
	     * The position of the displayObject on the x axis relative to the local coordinates of the parent.
	     *
	     * @member {number}
	     */


	    _createClass(ObservablePoint, [{
	        key: "x",
	        get: function get() {
	            return this._x;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            if (this._x !== value) {
	                this._x = value;
	                this.cb.call(this.scope);
	            }
	        }

	        /**
	         * The position of the displayObject on the x axis relative to the local coordinates of the parent.
	         *
	         * @member {number}
	         */

	    }, {
	        key: "y",
	        get: function get() {
	            return this._y;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            if (this._y !== value) {
	                this._y = value;
	                this.cb.call(this.scope);
	            }
	        }
	    }]);

	    return ObservablePoint;
	}();

	exports.default = ObservablePoint;
	//# sourceMappingURL=ObservablePoint.js.map

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _Point = __webpack_require__(176);

	var _Point2 = _interopRequireDefault(_Point);

	var _const = __webpack_require__(174);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/**
	 * The PixiJS Matrix class as an object, which makes it a lot faster,
	 * here is a representation of it :
	 * | a | c | tx|
	 * | b | d | ty|
	 * | 0 | 0 | 1 |
	 *
	 * @class
	 * @memberof PIXI
	 */
	var Matrix = function () {
	    /**
	     * @param {number} [a=1] - x scale
	     * @param {number} [b=0] - x skew
	     * @param {number} [c=0] - y skew
	     * @param {number} [d=1] - y scale
	     * @param {number} [tx=0] - x translation
	     * @param {number} [ty=0] - y translation
	     */
	    function Matrix() {
	        var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	        var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	        var c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	        var d = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
	        var tx = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
	        var ty = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

	        _classCallCheck(this, Matrix);

	        /**
	         * @member {number}
	         * @default 1
	         */
	        this.a = a;

	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.b = b;

	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.c = c;

	        /**
	         * @member {number}
	         * @default 1
	         */
	        this.d = d;

	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.tx = tx;

	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.ty = ty;

	        this.array = null;
	    }

	    /**
	     * Creates a Matrix object based on the given array. The Element to Matrix mapping order is as follows:
	     *
	     * a = array[0]
	     * b = array[1]
	     * c = array[3]
	     * d = array[4]
	     * tx = array[2]
	     * ty = array[5]
	     *
	     * @param {number[]} array - The array that the matrix will be populated from.
	     */


	    Matrix.prototype.fromArray = function fromArray(array) {
	        this.a = array[0];
	        this.b = array[1];
	        this.c = array[3];
	        this.d = array[4];
	        this.tx = array[2];
	        this.ty = array[5];
	    };

	    /**
	     * sets the matrix properties
	     *
	     * @param {number} a - Matrix component
	     * @param {number} b - Matrix component
	     * @param {number} c - Matrix component
	     * @param {number} d - Matrix component
	     * @param {number} tx - Matrix component
	     * @param {number} ty - Matrix component
	     *
	     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
	     */


	    Matrix.prototype.set = function set(a, b, c, d, tx, ty) {
	        this.a = a;
	        this.b = b;
	        this.c = c;
	        this.d = d;
	        this.tx = tx;
	        this.ty = ty;

	        return this;
	    };

	    /**
	     * Creates an array from the current Matrix object.
	     *
	     * @param {boolean} transpose - Whether we need to transpose the matrix or not
	     * @param {Float32Array} [out=new Float32Array(9)] - If provided the array will be assigned to out
	     * @return {number[]} the newly created array which contains the matrix
	     */


	    Matrix.prototype.toArray = function toArray(transpose, out) {
	        if (!this.array) {
	            this.array = new Float32Array(9);
	        }

	        var array = out || this.array;

	        if (transpose) {
	            array[0] = this.a;
	            array[1] = this.b;
	            array[2] = 0;
	            array[3] = this.c;
	            array[4] = this.d;
	            array[5] = 0;
	            array[6] = this.tx;
	            array[7] = this.ty;
	            array[8] = 1;
	        } else {
	            array[0] = this.a;
	            array[1] = this.c;
	            array[2] = this.tx;
	            array[3] = this.b;
	            array[4] = this.d;
	            array[5] = this.ty;
	            array[6] = 0;
	            array[7] = 0;
	            array[8] = 1;
	        }

	        return array;
	    };

	    /**
	     * Get a new position with the current transformation applied.
	     * Can be used to go from a child's coordinate space to the world coordinate space. (e.g. rendering)
	     *
	     * @param {PIXI.Point} pos - The origin
	     * @param {PIXI.Point} [newPos] - The point that the new position is assigned to (allowed to be same as input)
	     * @return {PIXI.Point} The new point, transformed through this matrix
	     */


	    Matrix.prototype.apply = function apply(pos, newPos) {
	        newPos = newPos || new _Point2.default();

	        var x = pos.x;
	        var y = pos.y;

	        newPos.x = this.a * x + this.c * y + this.tx;
	        newPos.y = this.b * x + this.d * y + this.ty;

	        return newPos;
	    };

	    /**
	     * Get a new position with the inverse of the current transformation applied.
	     * Can be used to go from the world coordinate space to a child's coordinate space. (e.g. input)
	     *
	     * @param {PIXI.Point} pos - The origin
	     * @param {PIXI.Point} [newPos] - The point that the new position is assigned to (allowed to be same as input)
	     * @return {PIXI.Point} The new point, inverse-transformed through this matrix
	     */


	    Matrix.prototype.applyInverse = function applyInverse(pos, newPos) {
	        newPos = newPos || new _Point2.default();

	        var id = 1 / (this.a * this.d + this.c * -this.b);

	        var x = pos.x;
	        var y = pos.y;

	        newPos.x = this.d * id * x + -this.c * id * y + (this.ty * this.c - this.tx * this.d) * id;
	        newPos.y = this.a * id * y + -this.b * id * x + (-this.ty * this.a + this.tx * this.b) * id;

	        return newPos;
	    };

	    /**
	     * Translates the matrix on the x and y.
	     *
	     * @param {number} x How much to translate x by
	     * @param {number} y How much to translate y by
	     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
	     */


	    Matrix.prototype.translate = function translate(x, y) {
	        this.tx += x;
	        this.ty += y;

	        return this;
	    };

	    /**
	     * Applies a scale transformation to the matrix.
	     *
	     * @param {number} x The amount to scale horizontally
	     * @param {number} y The amount to scale vertically
	     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
	     */


	    Matrix.prototype.scale = function scale(x, y) {
	        this.a *= x;
	        this.d *= y;
	        this.c *= x;
	        this.b *= y;
	        this.tx *= x;
	        this.ty *= y;

	        return this;
	    };

	    /**
	     * Applies a rotation transformation to the matrix.
	     *
	     * @param {number} angle - The angle in radians.
	     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
	     */


	    Matrix.prototype.rotate = function rotate(angle) {
	        var cos = Math.cos(angle);
	        var sin = Math.sin(angle);

	        var a1 = this.a;
	        var c1 = this.c;
	        var tx1 = this.tx;

	        this.a = a1 * cos - this.b * sin;
	        this.b = a1 * sin + this.b * cos;
	        this.c = c1 * cos - this.d * sin;
	        this.d = c1 * sin + this.d * cos;
	        this.tx = tx1 * cos - this.ty * sin;
	        this.ty = tx1 * sin + this.ty * cos;

	        return this;
	    };

	    /**
	     * Appends the given Matrix to this Matrix.
	     *
	     * @param {PIXI.Matrix} matrix - The matrix to append.
	     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
	     */


	    Matrix.prototype.append = function append(matrix) {
	        var a1 = this.a;
	        var b1 = this.b;
	        var c1 = this.c;
	        var d1 = this.d;

	        this.a = matrix.a * a1 + matrix.b * c1;
	        this.b = matrix.a * b1 + matrix.b * d1;
	        this.c = matrix.c * a1 + matrix.d * c1;
	        this.d = matrix.c * b1 + matrix.d * d1;

	        this.tx = matrix.tx * a1 + matrix.ty * c1 + this.tx;
	        this.ty = matrix.tx * b1 + matrix.ty * d1 + this.ty;

	        return this;
	    };

	    /**
	     * Sets the matrix based on all the available properties
	     *
	     * @param {number} x - Position on the x axis
	     * @param {number} y - Position on the y axis
	     * @param {number} pivotX - Pivot on the x axis
	     * @param {number} pivotY - Pivot on the y axis
	     * @param {number} scaleX - Scale on the x axis
	     * @param {number} scaleY - Scale on the y axis
	     * @param {number} rotation - Rotation in radians
	     * @param {number} skewX - Skew on the x axis
	     * @param {number} skewY - Skew on the y axis
	     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
	     */


	    Matrix.prototype.setTransform = function setTransform(x, y, pivotX, pivotY, scaleX, scaleY, rotation, skewX, skewY) {
	        this.a = Math.cos(rotation + skewY) * scaleX;
	        this.b = Math.sin(rotation + skewY) * scaleX;
	        this.c = -Math.sin(rotation - skewX) * scaleY;
	        this.d = Math.cos(rotation - skewX) * scaleY;

	        this.tx = x - (pivotX * this.a + pivotY * this.c);
	        this.ty = y - (pivotX * this.b + pivotY * this.d);

	        return this;
	    };

	    /**
	     * Prepends the given Matrix to this Matrix.
	     *
	     * @param {PIXI.Matrix} matrix - The matrix to prepend
	     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
	     */


	    Matrix.prototype.prepend = function prepend(matrix) {
	        var tx1 = this.tx;

	        if (matrix.a !== 1 || matrix.b !== 0 || matrix.c !== 0 || matrix.d !== 1) {
	            var a1 = this.a;
	            var c1 = this.c;

	            this.a = a1 * matrix.a + this.b * matrix.c;
	            this.b = a1 * matrix.b + this.b * matrix.d;
	            this.c = c1 * matrix.a + this.d * matrix.c;
	            this.d = c1 * matrix.b + this.d * matrix.d;
	        }

	        this.tx = tx1 * matrix.a + this.ty * matrix.c + matrix.tx;
	        this.ty = tx1 * matrix.b + this.ty * matrix.d + matrix.ty;

	        return this;
	    };

	    /**
	     * Decomposes the matrix (x, y, scaleX, scaleY, and rotation) and sets the properties on to a transform.
	     *
	     * @param {PIXI.Transform|PIXI.TransformStatic} transform - The transform to apply the properties to.
	     * @return {PIXI.Transform|PIXI.TransformStatic} The transform with the newly applied properties
	     */


	    Matrix.prototype.decompose = function decompose(transform) {
	        // sort out rotation / skew..
	        var a = this.a;
	        var b = this.b;
	        var c = this.c;
	        var d = this.d;

	        var skewX = -Math.atan2(-c, d);
	        var skewY = Math.atan2(b, a);

	        var delta = Math.abs(skewX + skewY);

	        if (delta < 0.00001 || Math.abs(_const.PI_2 - delta) < 0.00001) {
	            transform.rotation = skewY;

	            if (a < 0 && d >= 0) {
	                transform.rotation += transform.rotation <= 0 ? Math.PI : -Math.PI;
	            }

	            transform.skew.x = transform.skew.y = 0;
	        } else {
	            transform.rotation = 0;
	            transform.skew.x = skewX;
	            transform.skew.y = skewY;
	        }

	        // next set scale
	        transform.scale.x = Math.sqrt(a * a + b * b);
	        transform.scale.y = Math.sqrt(c * c + d * d);

	        // next set position
	        transform.position.x = this.tx;
	        transform.position.y = this.ty;

	        return transform;
	    };

	    /**
	     * Inverts this matrix
	     *
	     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
	     */


	    Matrix.prototype.invert = function invert() {
	        var a1 = this.a;
	        var b1 = this.b;
	        var c1 = this.c;
	        var d1 = this.d;
	        var tx1 = this.tx;
	        var n = a1 * d1 - b1 * c1;

	        this.a = d1 / n;
	        this.b = -b1 / n;
	        this.c = -c1 / n;
	        this.d = a1 / n;
	        this.tx = (c1 * this.ty - d1 * tx1) / n;
	        this.ty = -(a1 * this.ty - b1 * tx1) / n;

	        return this;
	    };

	    /**
	     * Resets this Matix to an identity (default) matrix.
	     *
	     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
	     */


	    Matrix.prototype.identity = function identity() {
	        this.a = 1;
	        this.b = 0;
	        this.c = 0;
	        this.d = 1;
	        this.tx = 0;
	        this.ty = 0;

	        return this;
	    };

	    /**
	     * Creates a new Matrix object with the same values as this one.
	     *
	     * @return {PIXI.Matrix} A copy of this matrix. Good for chaining method calls.
	     */


	    Matrix.prototype.clone = function clone() {
	        var matrix = new Matrix();

	        matrix.a = this.a;
	        matrix.b = this.b;
	        matrix.c = this.c;
	        matrix.d = this.d;
	        matrix.tx = this.tx;
	        matrix.ty = this.ty;

	        return matrix;
	    };

	    /**
	     * Changes the values of the given matrix to be the same as the ones in this matrix
	     *
	     * @param {PIXI.Matrix} matrix - The matrix to copy from.
	     * @return {PIXI.Matrix} The matrix given in parameter with its values updated.
	     */


	    Matrix.prototype.copy = function copy(matrix) {
	        matrix.a = this.a;
	        matrix.b = this.b;
	        matrix.c = this.c;
	        matrix.d = this.d;
	        matrix.tx = this.tx;
	        matrix.ty = this.ty;

	        return matrix;
	    };

	    /**
	     * A default (identity) matrix
	     *
	     * @static
	     * @const
	     */


	    _createClass(Matrix, null, [{
	        key: 'IDENTITY',
	        get: function get() {
	            return new Matrix();
	        }

	        /**
	         * A temp matrix
	         *
	         * @static
	         * @const
	         */

	    }, {
	        key: 'TEMP_MATRIX',
	        get: function get() {
	            return new Matrix();
	        }
	    }]);

	    return Matrix;
	}();

	exports.default = Matrix;
	//# sourceMappingURL=Matrix.js.map

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _Matrix = __webpack_require__(178);

	var _Matrix2 = _interopRequireDefault(_Matrix);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var ux = [1, 1, 0, -1, -1, -1, 0, 1, 1, 1, 0, -1, -1, -1, 0, 1]; // Your friendly neighbour https://en.wikipedia.org/wiki/Dihedral_group of order 16

	var uy = [0, 1, 1, 1, 0, -1, -1, -1, 0, 1, 1, 1, 0, -1, -1, -1];
	var vx = [0, -1, -1, -1, 0, 1, 1, 1, 0, 1, 1, 1, 0, -1, -1, -1];
	var vy = [1, 1, 0, -1, -1, -1, 0, 1, -1, -1, 0, 1, 1, 1, 0, -1];
	var tempMatrices = [];

	var mul = [];

	function signum(x) {
	    if (x < 0) {
	        return -1;
	    }
	    if (x > 0) {
	        return 1;
	    }

	    return 0;
	}

	function init() {
	    for (var i = 0; i < 16; i++) {
	        var row = [];

	        mul.push(row);

	        for (var j = 0; j < 16; j++) {
	            var _ux = signum(ux[i] * ux[j] + vx[i] * uy[j]);
	            var _uy = signum(uy[i] * ux[j] + vy[i] * uy[j]);
	            var _vx = signum(ux[i] * vx[j] + vx[i] * vy[j]);
	            var _vy = signum(uy[i] * vx[j] + vy[i] * vy[j]);

	            for (var k = 0; k < 16; k++) {
	                if (ux[k] === _ux && uy[k] === _uy && vx[k] === _vx && vy[k] === _vy) {
	                    row.push(k);
	                    break;
	                }
	            }
	        }
	    }

	    for (var _i = 0; _i < 16; _i++) {
	        var mat = new _Matrix2.default();

	        mat.set(ux[_i], uy[_i], vx[_i], vy[_i], 0, 0);
	        tempMatrices.push(mat);
	    }
	}

	init();

	/**
	 * Implements Dihedral Group D_8, see [group D4]{@link http://mathworld.wolfram.com/DihedralGroupD4.html},
	 * D8 is the same but with diagonals. Used for texture rotations.
	 *
	 * Vector xX(i), xY(i) is U-axis of sprite with rotation i
	 * Vector yY(i), yY(i) is V-axis of sprite with rotation i
	 * Rotations: 0 grad (0), 90 grad (2), 180 grad (4), 270 grad (6)
	 * Mirrors: vertical (8), main diagonal (10), horizontal (12), reverse diagonal (14)
	 * This is the small part of gameofbombs.com portal system. It works.
	 *
	 * @author Ivan @ivanpopelyshev
	 * @class
	 * @memberof PIXI
	 */
	var GroupD8 = {
	    E: 0,
	    SE: 1,
	    S: 2,
	    SW: 3,
	    W: 4,
	    NW: 5,
	    N: 6,
	    NE: 7,
	    MIRROR_VERTICAL: 8,
	    MIRROR_HORIZONTAL: 12,
	    uX: function uX(ind) {
	        return ux[ind];
	    },
	    uY: function uY(ind) {
	        return uy[ind];
	    },
	    vX: function vX(ind) {
	        return vx[ind];
	    },
	    vY: function vY(ind) {
	        return vy[ind];
	    },
	    inv: function inv(rotation) {
	        if (rotation & 8) {
	            return rotation & 15;
	        }

	        return -rotation & 7;
	    },
	    add: function add(rotationSecond, rotationFirst) {
	        return mul[rotationSecond][rotationFirst];
	    },
	    sub: function sub(rotationSecond, rotationFirst) {
	        return mul[rotationSecond][GroupD8.inv(rotationFirst)];
	    },

	    /**
	     * Adds 180 degrees to rotation. Commutative operation.
	     *
	     * @memberof PIXI.GroupD8
	     * @param {number} rotation - The number to rotate.
	     * @returns {number} rotated number
	     */
	    rotate180: function rotate180(rotation) {
	        return rotation ^ 4;
	    },

	    /**
	     * Direction of main vector can be horizontal, vertical or diagonal.
	     * Some objects work with vertical directions different.
	     *
	     * @memberof PIXI.GroupD8
	     * @param {number} rotation - The number to check.
	     * @returns {boolean} Whether or not the direction is vertical
	     */
	    isVertical: function isVertical(rotation) {
	        return (rotation & 3) === 2;
	    },

	    /**
	     * @memberof PIXI.GroupD8
	     * @param {number} dx - TODO
	     * @param {number} dy - TODO
	     *
	     * @return {number} TODO
	     */
	    byDirection: function byDirection(dx, dy) {
	        if (Math.abs(dx) * 2 <= Math.abs(dy)) {
	            if (dy >= 0) {
	                return GroupD8.S;
	            }

	            return GroupD8.N;
	        } else if (Math.abs(dy) * 2 <= Math.abs(dx)) {
	            if (dx > 0) {
	                return GroupD8.E;
	            }

	            return GroupD8.W;
	        } else if (dy > 0) {
	            if (dx > 0) {
	                return GroupD8.SE;
	            }

	            return GroupD8.SW;
	        } else if (dx > 0) {
	            return GroupD8.NE;
	        }

	        return GroupD8.NW;
	    },

	    /**
	     * Helps sprite to compensate texture packer rotation.
	     *
	     * @memberof PIXI.GroupD8
	     * @param {PIXI.Matrix} matrix - sprite world matrix
	     * @param {number} rotation - The rotation factor to use.
	     * @param {number} tx - sprite anchoring
	     * @param {number} ty - sprite anchoring
	     */
	    matrixAppendRotationInv: function matrixAppendRotationInv(matrix, rotation) {
	        var tx = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	        var ty = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

	        // Packer used "rotation", we use "inv(rotation)"
	        var mat = tempMatrices[GroupD8.inv(rotation)];

	        mat.tx = tx;
	        mat.ty = ty;
	        matrix.append(mat);
	    }
	};

	exports.default = GroupD8;
	//# sourceMappingURL=GroupD8.js.map

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _Rectangle = __webpack_require__(181);

	var _Rectangle2 = _interopRequireDefault(_Rectangle);

	var _const = __webpack_require__(174);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/**
	 * The Circle object can be used to specify a hit area for displayObjects
	 *
	 * @class
	 * @memberof PIXI
	 */
	var Circle = function () {
	  /**
	   * @param {number} [x=0] - The X coordinate of the center of this circle
	   * @param {number} [y=0] - The Y coordinate of the center of this circle
	   * @param {number} [radius=0] - The radius of the circle
	   */
	  function Circle() {
	    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    var radius = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

	    _classCallCheck(this, Circle);

	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.x = x;

	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.y = y;

	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.radius = radius;

	    /**
	     * The type of the object, mainly used to avoid `instanceof` checks
	     *
	     * @member {number}
	     * @readOnly
	     * @default PIXI.SHAPES.CIRC
	     * @see PIXI.SHAPES
	     */
	    this.type = _const.SHAPES.CIRC;
	  }

	  /**
	   * Creates a clone of this Circle instance
	   *
	   * @return {PIXI.Circle} a copy of the Circle
	   */


	  Circle.prototype.clone = function clone() {
	    return new Circle(this.x, this.y, this.radius);
	  };

	  /**
	   * Checks whether the x and y coordinates given are contained within this circle
	   *
	   * @param {number} x - The X coordinate of the point to test
	   * @param {number} y - The Y coordinate of the point to test
	   * @return {boolean} Whether the x/y coordinates are within this Circle
	   */


	  Circle.prototype.contains = function contains(x, y) {
	    if (this.radius <= 0) {
	      return false;
	    }

	    var r2 = this.radius * this.radius;
	    var dx = this.x - x;
	    var dy = this.y - y;

	    dx *= dx;
	    dy *= dy;

	    return dx + dy <= r2;
	  };

	  /**
	  * Returns the framing rectangle of the circle as a Rectangle object
	  *
	  * @return {PIXI.Rectangle} the framing rectangle
	  */


	  Circle.prototype.getBounds = function getBounds() {
	    return new _Rectangle2.default(this.x - this.radius, this.y - this.radius, this.radius * 2, this.radius * 2);
	  };

	  return Circle;
	}();

	exports.default = Circle;
	//# sourceMappingURL=Circle.js.map

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _const = __webpack_require__(174);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/**
	 * Rectangle object is an area defined by its position, as indicated by its top-left corner
	 * point (x, y) and by its width and its height.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var Rectangle = function () {
	    /**
	     * @param {number} [x=0] - The X coordinate of the upper-left corner of the rectangle
	     * @param {number} [y=0] - The Y coordinate of the upper-left corner of the rectangle
	     * @param {number} [width=0] - The overall width of this rectangle
	     * @param {number} [height=0] - The overall height of this rectangle
	     */
	    function Rectangle() {
	        var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	        var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	        var width = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	        var height = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

	        _classCallCheck(this, Rectangle);

	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.x = Number(x);

	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.y = Number(y);

	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.width = Number(width);

	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.height = Number(height);

	        /**
	         * The type of the object, mainly used to avoid `instanceof` checks
	         *
	         * @member {number}
	         * @readOnly
	         * @default PIXI.SHAPES.RECT
	         * @see PIXI.SHAPES
	         */
	        this.type = _const.SHAPES.RECT;
	    }

	    /**
	     * returns the left edge of the rectangle
	     *
	     * @member {number}
	     */


	    /**
	     * Creates a clone of this Rectangle
	     *
	     * @return {PIXI.Rectangle} a copy of the rectangle
	     */
	    Rectangle.prototype.clone = function clone() {
	        return new Rectangle(this.x, this.y, this.width, this.height);
	    };

	    /**
	     * Copies another rectangle to this one.
	     *
	     * @param {PIXI.Rectangle} rectangle - The rectangle to copy.
	     * @return {PIXI.Rectangle} Returns itself.
	     */


	    Rectangle.prototype.copy = function copy(rectangle) {
	        this.x = rectangle.x;
	        this.y = rectangle.y;
	        this.width = rectangle.width;
	        this.height = rectangle.height;

	        return this;
	    };

	    /**
	     * Checks whether the x and y coordinates given are contained within this Rectangle
	     *
	     * @param {number} x - The X coordinate of the point to test
	     * @param {number} y - The Y coordinate of the point to test
	     * @return {boolean} Whether the x/y coordinates are within this Rectangle
	     */


	    Rectangle.prototype.contains = function contains(x, y) {
	        if (this.width <= 0 || this.height <= 0) {
	            return false;
	        }

	        if (x >= this.x && x < this.x + this.width) {
	            if (y >= this.y && y < this.y + this.height) {
	                return true;
	            }
	        }

	        return false;
	    };

	    /**
	     * Pads the rectangle making it grow in all directions.
	     *
	     * @param {number} paddingX - The horizontal padding amount.
	     * @param {number} [paddingY] - The vertical padding amount.
	     */


	    Rectangle.prototype.pad = function pad(paddingX, paddingY) {
	        paddingX = paddingX || 0;
	        paddingY = paddingY || (paddingY !== 0 ? paddingX : 0);

	        this.x -= paddingX;
	        this.y -= paddingY;

	        this.width += paddingX * 2;
	        this.height += paddingY * 2;
	    };

	    /**
	     * Fits this rectangle around the passed one.
	     *
	     * @param {PIXI.Rectangle} rectangle - The rectangle to fit.
	     */


	    Rectangle.prototype.fit = function fit(rectangle) {
	        if (this.x < rectangle.x) {
	            this.width += this.x;
	            if (this.width < 0) {
	                this.width = 0;
	            }

	            this.x = rectangle.x;
	        }

	        if (this.y < rectangle.y) {
	            this.height += this.y;
	            if (this.height < 0) {
	                this.height = 0;
	            }
	            this.y = rectangle.y;
	        }

	        if (this.x + this.width > rectangle.x + rectangle.width) {
	            this.width = rectangle.width - this.x;
	            if (this.width < 0) {
	                this.width = 0;
	            }
	        }

	        if (this.y + this.height > rectangle.y + rectangle.height) {
	            this.height = rectangle.height - this.y;
	            if (this.height < 0) {
	                this.height = 0;
	            }
	        }
	    };

	    /**
	     * Enlarges this rectangle to include the passed rectangle.
	     *
	     * @param {PIXI.Rectangle} rectangle - The rectangle to include.
	     */


	    Rectangle.prototype.enlarge = function enlarge(rectangle) {
	        var x1 = Math.min(this.x, rectangle.x);
	        var x2 = Math.max(this.x + this.width, rectangle.x + rectangle.width);
	        var y1 = Math.min(this.y, rectangle.y);
	        var y2 = Math.max(this.y + this.height, rectangle.y + rectangle.height);

	        this.x = x1;
	        this.width = x2 - x1;
	        this.y = y1;
	        this.height = y2 - y1;
	    };

	    _createClass(Rectangle, [{
	        key: 'left',
	        get: function get() {
	            return this.x;
	        }

	        /**
	         * returns the right edge of the rectangle
	         *
	         * @member {number}
	         */

	    }, {
	        key: 'right',
	        get: function get() {
	            return this.x + this.width;
	        }

	        /**
	         * returns the top edge of the rectangle
	         *
	         * @member {number}
	         */

	    }, {
	        key: 'top',
	        get: function get() {
	            return this.y;
	        }

	        /**
	         * returns the bottom edge of the rectangle
	         *
	         * @member {number}
	         */

	    }, {
	        key: 'bottom',
	        get: function get() {
	            return this.y + this.height;
	        }

	        /**
	         * A constant empty rectangle.
	         *
	         * @static
	         * @constant
	         */

	    }], [{
	        key: 'EMPTY',
	        get: function get() {
	            return new Rectangle(0, 0, 0, 0);
	        }
	    }]);

	    return Rectangle;
	}();

	exports.default = Rectangle;
	//# sourceMappingURL=Rectangle.js.map

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _Rectangle = __webpack_require__(181);

	var _Rectangle2 = _interopRequireDefault(_Rectangle);

	var _const = __webpack_require__(174);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/**
	 * The Ellipse object can be used to specify a hit area for displayObjects
	 *
	 * @class
	 * @memberof PIXI
	 */
	var Ellipse = function () {
	  /**
	   * @param {number} [x=0] - The X coordinate of the center of this circle
	   * @param {number} [y=0] - The Y coordinate of the center of this circle
	   * @param {number} [width=0] - The half width of this ellipse
	   * @param {number} [height=0] - The half height of this ellipse
	   */
	  function Ellipse() {
	    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    var width = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	    var height = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

	    _classCallCheck(this, Ellipse);

	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.x = x;

	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.y = y;

	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.width = width;

	    /**
	     * @member {number}
	     * @default 0
	     */
	    this.height = height;

	    /**
	     * The type of the object, mainly used to avoid `instanceof` checks
	     *
	     * @member {number}
	     * @readOnly
	     * @default PIXI.SHAPES.ELIP
	     * @see PIXI.SHAPES
	     */
	    this.type = _const.SHAPES.ELIP;
	  }

	  /**
	   * Creates a clone of this Ellipse instance
	   *
	   * @return {PIXI.Ellipse} a copy of the ellipse
	   */


	  Ellipse.prototype.clone = function clone() {
	    return new Ellipse(this.x, this.y, this.width, this.height);
	  };

	  /**
	   * Checks whether the x and y coordinates given are contained within this ellipse
	   *
	   * @param {number} x - The X coordinate of the point to test
	   * @param {number} y - The Y coordinate of the point to test
	   * @return {boolean} Whether the x/y coords are within this ellipse
	   */


	  Ellipse.prototype.contains = function contains(x, y) {
	    if (this.width <= 0 || this.height <= 0) {
	      return false;
	    }

	    // normalize the coords to an ellipse with center 0,0
	    var normx = (x - this.x) / this.width;
	    var normy = (y - this.y) / this.height;

	    normx *= normx;
	    normy *= normy;

	    return normx + normy <= 1;
	  };

	  /**
	   * Returns the framing rectangle of the ellipse as a Rectangle object
	   *
	   * @return {PIXI.Rectangle} the framing rectangle
	   */


	  Ellipse.prototype.getBounds = function getBounds() {
	    return new _Rectangle2.default(this.x - this.width, this.y - this.height, this.width, this.height);
	  };

	  return Ellipse;
	}();

	exports.default = Ellipse;
	//# sourceMappingURL=Ellipse.js.map

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _Point = __webpack_require__(176);

	var _Point2 = _interopRequireDefault(_Point);

	var _const = __webpack_require__(174);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/**
	 * @class
	 * @memberof PIXI
	 */
	var Polygon = function () {
	    /**
	     * @param {PIXI.Point[]|number[]} points - This can be an array of Points
	     *  that form the polygon, a flat array of numbers that will be interpreted as [x,y, x,y, ...], or
	     *  the arguments passed can be all the points of the polygon e.g.
	     *  `new PIXI.Polygon(new PIXI.Point(), new PIXI.Point(), ...)`, or the arguments passed can be flat
	     *  x,y values e.g. `new Polygon(x,y, x,y, x,y, ...)` where `x` and `y` are Numbers.
	     */
	    function Polygon() {
	        for (var _len = arguments.length, points = Array(_len), _key = 0; _key < _len; _key++) {
	            points[_key] = arguments[_key];
	        }

	        _classCallCheck(this, Polygon);

	        if (Array.isArray(points[0])) {
	            points = points[0];
	        }

	        // if this is an array of points, convert it to a flat array of numbers
	        if (points[0] instanceof _Point2.default) {
	            var p = [];

	            for (var i = 0, il = points.length; i < il; i++) {
	                p.push(points[i].x, points[i].y);
	            }

	            points = p;
	        }

	        this.closed = true;

	        /**
	         * An array of the points of this polygon
	         *
	         * @member {number[]}
	         */
	        this.points = points;

	        /**
	         * The type of the object, mainly used to avoid `instanceof` checks
	         *
	         * @member {number}
	         * @readOnly
	         * @default PIXI.SHAPES.POLY
	         * @see PIXI.SHAPES
	         */
	        this.type = _const.SHAPES.POLY;
	    }

	    /**
	     * Creates a clone of this polygon
	     *
	     * @return {PIXI.Polygon} a copy of the polygon
	     */


	    Polygon.prototype.clone = function clone() {
	        return new Polygon(this.points.slice());
	    };

	    /**
	     * Closes the polygon, adding points if necessary.
	     *
	     */


	    Polygon.prototype.close = function close() {
	        var points = this.points;

	        // close the poly if the value is true!
	        if (points[0] !== points[points.length - 2] || points[1] !== points[points.length - 1]) {
	            points.push(points[0], points[1]);
	        }
	    };

	    /**
	     * Checks whether the x and y coordinates passed to this function are contained within this polygon
	     *
	     * @param {number} x - The X coordinate of the point to test
	     * @param {number} y - The Y coordinate of the point to test
	     * @return {boolean} Whether the x/y coordinates are within this polygon
	     */


	    Polygon.prototype.contains = function contains(x, y) {
	        var inside = false;

	        // use some raycasting to test hits
	        // https://github.com/substack/point-in-polygon/blob/master/index.js
	        var length = this.points.length / 2;

	        for (var i = 0, j = length - 1; i < length; j = i++) {
	            var xi = this.points[i * 2];
	            var yi = this.points[i * 2 + 1];
	            var xj = this.points[j * 2];
	            var yj = this.points[j * 2 + 1];
	            var intersect = yi > y !== yj > y && x < (xj - xi) * ((y - yi) / (yj - yi)) + xi;

	            if (intersect) {
	                inside = !inside;
	            }
	        }

	        return inside;
	    };

	    return Polygon;
	}();

	exports.default = Polygon;
	//# sourceMappingURL=Polygon.js.map

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _const = __webpack_require__(174);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/**
	 * The Rounded Rectangle object is an area that has nice rounded corners, as indicated by its
	 * top-left corner point (x, y) and by its width and its height and its radius.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var RoundedRectangle = function () {
	    /**
	     * @param {number} [x=0] - The X coordinate of the upper-left corner of the rounded rectangle
	     * @param {number} [y=0] - The Y coordinate of the upper-left corner of the rounded rectangle
	     * @param {number} [width=0] - The overall width of this rounded rectangle
	     * @param {number} [height=0] - The overall height of this rounded rectangle
	     * @param {number} [radius=20] - Controls the radius of the rounded corners
	     */
	    function RoundedRectangle() {
	        var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	        var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	        var width = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	        var height = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	        var radius = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 20;

	        _classCallCheck(this, RoundedRectangle);

	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.x = x;

	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.y = y;

	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.width = width;

	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.height = height;

	        /**
	         * @member {number}
	         * @default 20
	         */
	        this.radius = radius;

	        /**
	         * The type of the object, mainly used to avoid `instanceof` checks
	         *
	         * @member {number}
	         * @readonly
	         * @default PIXI.SHAPES.RREC
	         * @see PIXI.SHAPES
	         */
	        this.type = _const.SHAPES.RREC;
	    }

	    /**
	     * Creates a clone of this Rounded Rectangle
	     *
	     * @return {PIXI.RoundedRectangle} a copy of the rounded rectangle
	     */


	    RoundedRectangle.prototype.clone = function clone() {
	        return new RoundedRectangle(this.x, this.y, this.width, this.height, this.radius);
	    };

	    /**
	     * Checks whether the x and y coordinates given are contained within this Rounded Rectangle
	     *
	     * @param {number} x - The X coordinate of the point to test
	     * @param {number} y - The Y coordinate of the point to test
	     * @return {boolean} Whether the x/y coordinates are within this Rounded Rectangle
	     */


	    RoundedRectangle.prototype.contains = function contains(x, y) {
	        if (this.width <= 0 || this.height <= 0) {
	            return false;
	        }
	        if (x >= this.x && x <= this.x + this.width) {
	            if (y >= this.y && y <= this.y + this.height) {
	                if (y >= this.y + this.radius && y <= this.y + this.height - this.radius || x >= this.x + this.radius && x <= this.x + this.width - this.radius) {
	                    return true;
	                }
	                var dx = x - (this.x + this.radius);
	                var dy = y - (this.y + this.radius);
	                var radius2 = this.radius * this.radius;

	                if (dx * dx + dy * dy <= radius2) {
	                    return true;
	                }
	                dx = x - (this.x + this.width - this.radius);
	                if (dx * dx + dy * dy <= radius2) {
	                    return true;
	                }
	                dy = y - (this.y + this.height - this.radius);
	                if (dx * dx + dy * dy <= radius2) {
	                    return true;
	                }
	                dx = x - (this.x + this.radius);
	                if (dx * dx + dy * dy <= radius2) {
	                    return true;
	                }
	            }
	        }

	        return false;
	    };

	    return RoundedRectangle;
	}();

	exports.default = RoundedRectangle;
	//# sourceMappingURL=RoundedRectangle.js.map

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	var gl = {
	    createContext:          __webpack_require__(186),
	    setVertexAttribArrays:  __webpack_require__(187),
	    GLBuffer:               __webpack_require__(188),
	    GLFramebuffer:          __webpack_require__(189),
	    GLShader:               __webpack_require__(191),
	    GLTexture:              __webpack_require__(190),
	    VertexArrayObject:      __webpack_require__(200),
	    shader:                 __webpack_require__(201)
	};

	// Export for Node-compatible environments
	if (typeof module !== 'undefined' && module.exports)
	{
	    // Export the module
	    module.exports = gl;
	}

	// Add to the browser window pixi.gl
	if (typeof window !== 'undefined')
	{
	    // add the window object
	    window.PIXI = window.PIXI || {};
	    window.PIXI.glCore = gl;
	}


/***/ }),
/* 186 */
/***/ (function(module, exports) {

	
	/**
	 * Helper class to create a webGL Context
	 *
	 * @class
	 * @memberof PIXI.glCore
	 * @param canvas {HTMLCanvasElement} the canvas element that we will get the context from
	 * @param options {Object} An options object that gets passed in to the canvas element containing the context attributes,
	 *                         see https://developer.mozilla.org/en/docs/Web/API/HTMLCanvasElement/getContext for the options available
	 * @return {WebGLRenderingContext} the WebGL context
	 */
	var createContext = function(canvas, options)
	{
	    var gl = canvas.getContext('webgl', options) || 
	         canvas.getContext('experimental-webgl', options);

	    if (!gl)
	    {
	        // fail, not able to get a context
	        throw new Error('This browser does not support webGL. Try using the canvas renderer');
	    }

	    return gl;
	};

	module.exports = createContext;


/***/ }),
/* 187 */
/***/ (function(module, exports) {

	// var GL_MAP = {};

	/**
	 * @param gl {WebGLRenderingContext} The current WebGL context
	 * @param attribs {*}
	 * @param state {*}
	 */
	var setVertexAttribArrays = function (gl, attribs, state)
	{
	    var i;
	    if(state)
	    {
	        var tempAttribState = state.tempAttribState,
	            attribState = state.attribState;

	        for (i = 0; i < tempAttribState.length; i++)
	        {
	            tempAttribState[i] = false;
	        }

	        // set the new attribs
	        for (i = 0; i < attribs.length; i++)
	        {
	            tempAttribState[attribs[i].attribute.location] = true;
	        }

	        for (i = 0; i < attribState.length; i++)
	        {
	            if (attribState[i] !== tempAttribState[i])
	            {
	                attribState[i] = tempAttribState[i];

	                if (state.attribState[i])
	                {
	                    gl.enableVertexAttribArray(i);
	                }
	                else
	                {
	                    gl.disableVertexAttribArray(i);
	                }
	            }
	        }

	    }
	    else
	    {
	        for (i = 0; i < attribs.length; i++)
	        {
	            var attrib = attribs[i];
	            gl.enableVertexAttribArray(attrib.attribute.location);
	        }
	    }
	};

	module.exports = setVertexAttribArrays;


/***/ }),
/* 188 */
/***/ (function(module, exports) {

	var EMPTY_ARRAY_BUFFER = new ArrayBuffer(0);

	/**
	 * Helper class to create a webGL buffer
	 *
	 * @class
	 * @memberof PIXI.glCore
	 * @param gl {WebGLRenderingContext} The current WebGL rendering context
	 * @param type {gl.ARRAY_BUFFER | gl.ELEMENT_ARRAY_BUFFER} @mat
	 * @param data {ArrayBuffer| SharedArrayBuffer|ArrayBufferView} an array of data
	 * @param drawType {gl.STATIC_DRAW|gl.DYNAMIC_DRAW|gl.STREAM_DRAW}
	 */
	var Buffer = function(gl, type, data, drawType)
	{

		/**
	     * The current WebGL rendering context
	     *
	     * @member {WebGLRenderingContext}
	     */
		this.gl = gl;

		/**
	     * The WebGL buffer, created upon instantiation
	     *
	     * @member {WebGLBuffer}
	     */
		this.buffer = gl.createBuffer();

		/**
	     * The type of the buffer
	     *
	     * @member {gl.ARRAY_BUFFER|gl.ELEMENT_ARRAY_BUFFER}
	     */
		this.type = type || gl.ARRAY_BUFFER;

		/**
	     * The draw type of the buffer
	     *
	     * @member {gl.STATIC_DRAW|gl.DYNAMIC_DRAW|gl.STREAM_DRAW}
	     */
		this.drawType = drawType || gl.STATIC_DRAW;

		/**
	     * The data in the buffer, as a typed array
	     *
	     * @member {ArrayBuffer| SharedArrayBuffer|ArrayBufferView}
	     */
		this.data = EMPTY_ARRAY_BUFFER;

		if(data)
		{
			this.upload(data);
		}

		this._updateID = 0;
	};

	/**
	 * Uploads the buffer to the GPU
	 * @param data {ArrayBuffer| SharedArrayBuffer|ArrayBufferView} an array of data to upload
	 * @param offset {Number} if only a subset of the data should be uploaded, this is the amount of data to subtract
	 * @param dontBind {Boolean} whether to bind the buffer before uploading it
	 */
	Buffer.prototype.upload = function(data, offset, dontBind)
	{
		// todo - needed?
		if(!dontBind) this.bind();

		var gl = this.gl;

		data = data || this.data;
		offset = offset || 0;

		if(this.data.byteLength >= data.byteLength)
		{
			gl.bufferSubData(this.type, offset, data);
		}
		else
		{
			gl.bufferData(this.type, data, this.drawType);
		}

		this.data = data;
	};
	/**
	 * Binds the buffer
	 *
	 */
	Buffer.prototype.bind = function()
	{
		var gl = this.gl;
		gl.bindBuffer(this.type, this.buffer);
	};

	Buffer.createVertexBuffer = function(gl, data, drawType)
	{
		return new Buffer(gl, gl.ARRAY_BUFFER, data, drawType);
	};

	Buffer.createIndexBuffer = function(gl, data, drawType)
	{
		return new Buffer(gl, gl.ELEMENT_ARRAY_BUFFER, data, drawType);
	};

	Buffer.create = function(gl, type, data, drawType)
	{
		return new Buffer(gl, type, data, drawType);
	};

	/**
	 * Destroys the buffer
	 *
	 */
	Buffer.prototype.destroy = function(){
		this.gl.deleteBuffer(this.buffer);
	};

	module.exports = Buffer;


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	
	var Texture = __webpack_require__(190);

	/**
	 * Helper class to create a webGL Framebuffer
	 *
	 * @class
	 * @memberof PIXI.glCore
	 * @param gl {WebGLRenderingContext} The current WebGL rendering context
	 * @param width {Number} the width of the drawing area of the frame buffer
	 * @param height {Number} the height of the drawing area of the frame buffer
	 */
	var Framebuffer = function(gl, width, height)
	{
	    /**
	     * The current WebGL rendering context
	     *
	     * @member {WebGLRenderingContext}
	     */
	    this.gl = gl;

	    /**
	     * The frame buffer
	     *
	     * @member {WebGLFramebuffer}
	     */
	    this.framebuffer = gl.createFramebuffer();

	    /**
	     * The stencil buffer
	     *
	     * @member {WebGLRenderbuffer}
	     */
	    this.stencil = null;

	    /**
	     * The stencil buffer
	     *
	     * @member {PIXI.glCore.GLTexture}
	     */
	    this.texture = null;

	    /**
	     * The width of the drawing area of the buffer
	     *
	     * @member {Number}
	     */
	    this.width = width || 100;
	    /**
	     * The height of the drawing area of the buffer
	     *
	     * @member {Number}
	     */
	    this.height = height || 100;
	};

	/**
	 * Adds a texture to the frame buffer
	 * @param texture {PIXI.glCore.GLTexture}
	 */
	Framebuffer.prototype.enableTexture = function(texture)
	{
	    var gl = this.gl;

	    this.texture = texture || new Texture(gl);

	    this.texture.bind();

	    //gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA,  this.width, this.height, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);

	    this.bind();

	    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, this.texture.texture, 0);
	};

	/**
	 * Initialises the stencil buffer
	 */
	Framebuffer.prototype.enableStencil = function()
	{
	    if(this.stencil)return;

	    var gl = this.gl;

	    this.stencil = gl.createRenderbuffer();

	    gl.bindRenderbuffer(gl.RENDERBUFFER, this.stencil);

	    // TODO.. this is depth AND stencil?
	    gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_STENCIL_ATTACHMENT, gl.RENDERBUFFER, this.stencil);
	    gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_STENCIL,  this.width  , this.height );


	};

	/**
	 * Erases the drawing area and fills it with a colour
	 * @param  r {Number} the red value of the clearing colour
	 * @param  g {Number} the green value of the clearing colour
	 * @param  b {Number} the blue value of the clearing colour
	 * @param  a {Number} the alpha value of the clearing colour
	 */
	Framebuffer.prototype.clear = function( r, g, b, a )
	{
	    this.bind();

	    var gl = this.gl;

	    gl.clearColor(r, g, b, a);
	    gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
	};

	/**
	 * Binds the frame buffer to the WebGL context
	 */
	Framebuffer.prototype.bind = function()
	{
	    var gl = this.gl;
	    gl.bindFramebuffer(gl.FRAMEBUFFER, this.framebuffer );
	};

	/**
	 * Unbinds the frame buffer to the WebGL context
	 */
	Framebuffer.prototype.unbind = function()
	{
	    var gl = this.gl;
	    gl.bindFramebuffer(gl.FRAMEBUFFER, null );
	};
	/**
	 * Resizes the drawing area of the buffer to the given width and height
	 * @param  width  {Number} the new width
	 * @param  height {Number} the new height
	 */
	Framebuffer.prototype.resize = function(width, height)
	{
	    var gl = this.gl;

	    this.width = width;
	    this.height = height;

	    if ( this.texture )
	    {
	        this.texture.uploadData(null, width, height);
	    }

	    if ( this.stencil )
	    {
	        // update the stencil buffer width and height
	        gl.bindRenderbuffer(gl.RENDERBUFFER, this.stencil);
	        gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_STENCIL, width, height);
	    }
	};

	/**
	 * Destroys this buffer
	 */
	Framebuffer.prototype.destroy = function()
	{
	    var gl = this.gl;

	    //TODO
	    if(this.texture)
	    {
	        this.texture.destroy();
	    }

	    gl.deleteFramebuffer(this.framebuffer);

	    this.gl = null;

	    this.stencil = null;
	    this.texture = null;
	};

	/**
	 * Creates a frame buffer with a texture containing the given data
	 * @static
	 * @param gl {WebGLRenderingContext} The current WebGL rendering context
	 * @param width {Number} the width of the drawing area of the frame buffer
	 * @param height {Number} the height of the drawing area of the frame buffer
	 * @param data {ArrayBuffer| SharedArrayBuffer|ArrayBufferView} an array of data
	 */
	Framebuffer.createRGBA = function(gl, width, height, data)
	{
	    var texture = Texture.fromData(gl, null, width, height);
	    texture.enableNearestScaling();
	    texture.enableWrapClamp();

	    //now create the framebuffer object and attach the texture to it.
	    var fbo = new Framebuffer(gl, width, height);
	    fbo.enableTexture(texture);
	    //fbo.enableStencil(); // get this back on soon!

	    //fbo.enableStencil(); // get this back on soon!

	    fbo.unbind();

	    return fbo;
	};

	/**
	 * Creates a frame buffer with a texture containing the given data
	 * @static
	 * @param gl {WebGLRenderingContext} The current WebGL rendering context
	 * @param width {Number} the width of the drawing area of the frame buffer
	 * @param height {Number} the height of the drawing area of the frame buffer
	 * @param data {ArrayBuffer| SharedArrayBuffer|ArrayBufferView} an array of data
	 */
	Framebuffer.createFloat32 = function(gl, width, height, data)
	{
	    // create a new texture..
	    var texture = new Texture.fromData(gl, data, width, height);
	    texture.enableNearestScaling();
	    texture.enableWrapClamp();

	    //now create the framebuffer object and attach the texture to it.
	    var fbo = new Framebuffer(gl, width, height);
	    fbo.enableTexture(texture);

	    fbo.unbind();

	    return fbo;
	};

	module.exports = Framebuffer;


/***/ }),
/* 190 */
/***/ (function(module, exports) {

	
	/**
	 * Helper class to create a WebGL Texture
	 *
	 * @class
	 * @memberof PIXI.glCore
	 * @param gl {WebGLRenderingContext} The current WebGL context
	 * @param width {number} the width of the texture
	 * @param height {number} the height of the texture
	 * @param format {number} the pixel format of the texture. defaults to gl.RGBA
	 * @param type {number} the gl type of the texture. defaults to gl.UNSIGNED_BYTE
	 */
	var Texture = function(gl, width, height, format, type)
	{
		/**
		 * The current WebGL rendering context
		 *
		 * @member {WebGLRenderingContext}
		 */
		this.gl = gl;


		/**
		 * The WebGL texture
		 *
		 * @member {WebGLTexture}
		 */
		this.texture = gl.createTexture();

		/**
		 * If mipmapping was used for this texture, enable and disable with enableMipmap()
		 *
		 * @member {Boolean}
		 */
		// some settings..
		this.mipmap = false;


		/**
		 * Set to true to enable pre-multiplied alpha
		 *
		 * @member {Boolean}
		 */
		this.premultiplyAlpha = false;

		/**
		 * The width of texture
		 *
		 * @member {Number}
		 */
		this.width = width || -1;
		/**
		 * The height of texture
		 *
		 * @member {Number}
		 */
		this.height = height || -1;

		/**
		 * The pixel format of the texture. defaults to gl.RGBA
		 *
		 * @member {Number}
		 */
		this.format = format || gl.RGBA;

		/**
		 * The gl type of the texture. defaults to gl.UNSIGNED_BYTE
		 *
		 * @member {Number}
		 */
		this.type = type || gl.UNSIGNED_BYTE;


	};

	/**
	 * Uploads this texture to the GPU
	 * @param source {HTMLImageElement|ImageData|HTMLVideoElement} the source image of the texture
	 */
	Texture.prototype.upload = function(source)
	{
		this.bind();

		var gl = this.gl;


		gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, this.premultiplyAlpha);

		var newWidth = source.videoWidth || source.width;
		var newHeight = source.videoHeight || source.height;

		if(newHeight !== this.height || newWidth !== this.width)
		{
			gl.texImage2D(gl.TEXTURE_2D, 0, this.format, this.format, this.type, source);
		}
		else
		{
	    	gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, this.format, this.type, source);
		}

		// if the source is a video, we need to use the videoWidth / videoHeight properties as width / height will be incorrect.
		this.width = newWidth;
		this.height = newHeight;

	};

	var FLOATING_POINT_AVAILABLE = false;

	/**
	 * Use a data source and uploads this texture to the GPU
	 * @param data {TypedArray} the data to upload to the texture
	 * @param width {number} the new width of the texture
	 * @param height {number} the new height of the texture
	 */
	Texture.prototype.uploadData = function(data, width, height)
	{
		this.bind();

		var gl = this.gl;


		if(data instanceof Float32Array)
		{
			if(!FLOATING_POINT_AVAILABLE)
			{
				var ext = gl.getExtension("OES_texture_float");

				if(ext)
				{
					FLOATING_POINT_AVAILABLE = true;
				}
				else
				{
					throw new Error('floating point textures not available');
				}
			}

			this.type = gl.FLOAT;
		}
		else
		{
			// TODO support for other types
			this.type = this.type || gl.UNSIGNED_BYTE;
		}

		// what type of data?
		gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, this.premultiplyAlpha);


		if(width !== this.width || height !== this.height)
		{
			gl.texImage2D(gl.TEXTURE_2D, 0, this.format,  width, height, 0, this.format, this.type, data || null);
		}
		else
		{
			gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, width, height, this.format, this.type, data || null);
		}

		this.width = width;
		this.height = height;


	//	texSubImage2D
	};

	/**
	 * Binds the texture
	 * @param  location
	 */
	Texture.prototype.bind = function(location)
	{
		var gl = this.gl;

		if(location !== undefined)
		{
			gl.activeTexture(gl.TEXTURE0 + location);
		}

		gl.bindTexture(gl.TEXTURE_2D, this.texture);
	};

	/**
	 * Unbinds the texture
	 */
	Texture.prototype.unbind = function()
	{
		var gl = this.gl;
		gl.bindTexture(gl.TEXTURE_2D, null);
	};

	/**
	 * @param linear {Boolean} if we want to use linear filtering or nearest neighbour interpolation
	 */
	Texture.prototype.minFilter = function( linear )
	{
		var gl = this.gl;

		this.bind();

		if(this.mipmap)
		{
			gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, linear ? gl.LINEAR_MIPMAP_LINEAR : gl.NEAREST_MIPMAP_NEAREST);
		}
		else
		{
			gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, linear ? gl.LINEAR : gl.NEAREST);
		}
	};

	/**
	 * @param linear {Boolean} if we want to use linear filtering or nearest neighbour interpolation
	 */
	Texture.prototype.magFilter = function( linear )
	{
		var gl = this.gl;

		this.bind();

		gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, linear ? gl.LINEAR : gl.NEAREST);
	};

	/**
	 * Enables mipmapping
	 */
	Texture.prototype.enableMipmap = function()
	{
		var gl = this.gl;

		this.bind();

		this.mipmap = true;

		gl.generateMipmap(gl.TEXTURE_2D);
	};

	/**
	 * Enables linear filtering
	 */
	Texture.prototype.enableLinearScaling = function()
	{
		this.minFilter(true);
		this.magFilter(true);
	};

	/**
	 * Enables nearest neighbour interpolation
	 */
	Texture.prototype.enableNearestScaling = function()
	{
		this.minFilter(false);
		this.magFilter(false);
	};

	/**
	 * Enables clamping on the texture so WebGL will not repeat it
	 */
	Texture.prototype.enableWrapClamp = function()
	{
		var gl = this.gl;

		this.bind();

		gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
	    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
	};

	/**
	 * Enable tiling on the texture
	 */
	Texture.prototype.enableWrapRepeat = function()
	{
		var gl = this.gl;

		this.bind();

		gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.REPEAT);
	    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.REPEAT);
	};

	Texture.prototype.enableWrapMirrorRepeat = function()
	{
		var gl = this.gl;

		this.bind();

		gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.MIRRORED_REPEAT);
	    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.MIRRORED_REPEAT);
	};


	/**
	 * Destroys this texture
	 */
	Texture.prototype.destroy = function()
	{
		var gl = this.gl;
		//TODO
		gl.deleteTexture(this.texture);
	};

	/**
	 * @static
	 * @param gl {WebGLRenderingContext} The current WebGL context
	 * @param source {HTMLImageElement|ImageData} the source image of the texture
	 * @param premultiplyAlpha {Boolean} If we want to use pre-multiplied alpha
	 */
	Texture.fromSource = function(gl, source, premultiplyAlpha)
	{
		var texture = new Texture(gl);
		texture.premultiplyAlpha = premultiplyAlpha || false;
		texture.upload(source);

		return texture;
	};

	/**
	 * @static
	 * @param gl {WebGLRenderingContext} The current WebGL context
	 * @param data {TypedArray} the data to upload to the texture
	 * @param width {number} the new width of the texture
	 * @param height {number} the new height of the texture
	 */
	Texture.fromData = function(gl, data, width, height)
	{
		//console.log(data, width, height);
		var texture = new Texture(gl);
		texture.uploadData(data, width, height);

		return texture;
	};


	module.exports = Texture;


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	
	var compileProgram = __webpack_require__(192),
		extractAttributes = __webpack_require__(193),
		extractUniforms = __webpack_require__(196),
		setPrecision = __webpack_require__(198),
		generateUniformAccessObject = __webpack_require__(199);

	/**
	 * Helper class to create a webGL Shader
	 *
	 * @class
	 * @memberof PIXI.glCore
	 * @param gl {WebGLRenderingContext}
	 * @param vertexSrc {string|string[]} The vertex shader source as an array of strings.
	 * @param fragmentSrc {string|string[]} The fragment shader source as an array of strings.
	 * @param precision {string} The float precision of the shader. Options are 'lowp', 'mediump' or 'highp'.
	 * @param attributeLocations {object} A key value pair showing which location eact attribute should sit eg {position:0, uvs:1}
	 */
	var Shader = function(gl, vertexSrc, fragmentSrc, precision, attributeLocations)
	{
		/**
		 * The current WebGL rendering context
		 *
		 * @member {WebGLRenderingContext}
		 */
		this.gl = gl;

		if(precision)
		{
			vertexSrc = setPrecision(vertexSrc, precision);
			fragmentSrc = setPrecision(fragmentSrc, precision);
		}

		/**
		 * The shader program
		 *
		 * @member {WebGLProgram}
		 */
		// First compile the program..
		this.program = compileProgram(gl, vertexSrc, fragmentSrc, attributeLocations);

		/**
		 * The attributes of the shader as an object containing the following properties
		 * {
		 * 	type,
		 * 	size,
		 * 	location,
		 * 	pointer
		 * }
		 * @member {Object}
		 */
		// next extract the attributes
		this.attributes = extractAttributes(gl, this.program);

	    this.uniformData = extractUniforms(gl, this.program);

		/**
		 * The uniforms of the shader as an object containing the following properties
		 * {
		 * 	gl,
		 * 	data
		 * }
		 * @member {Object}
		 */
		this.uniforms = generateUniformAccessObject( gl, this.uniformData );

	};
	/**
	 * Uses this shader
	 * 
	 * @return {PIXI.glCore.GLShader} Returns itself.
	 */
	Shader.prototype.bind = function()
	{
		this.gl.useProgram(this.program);
		return this;
	};

	/**
	 * Destroys this shader
	 * TODO
	 */
	Shader.prototype.destroy = function()
	{
		this.attributes = null;
		this.uniformData = null;
		this.uniforms = null;

		var gl = this.gl;
		gl.deleteProgram(this.program);
	};


	module.exports = Shader;


/***/ }),
/* 192 */
/***/ (function(module, exports) {

	
	/**
	 * @class
	 * @memberof PIXI.glCore.shader
	 * @param gl {WebGLRenderingContext} The current WebGL context {WebGLProgram}
	 * @param vertexSrc {string|string[]} The vertex shader source as an array of strings.
	 * @param fragmentSrc {string|string[]} The fragment shader source as an array of strings.
	 * @param attributeLocations {Object} An attribute location map that lets you manually set the attribute locations
	 * @return {WebGLProgram} the shader program
	 */
	var compileProgram = function(gl, vertexSrc, fragmentSrc, attributeLocations)
	{
	    var glVertShader = compileShader(gl, gl.VERTEX_SHADER, vertexSrc);
	    var glFragShader = compileShader(gl, gl.FRAGMENT_SHADER, fragmentSrc);

	    var program = gl.createProgram();

	    gl.attachShader(program, glVertShader);
	    gl.attachShader(program, glFragShader);

	    // optionally, set the attributes manually for the program rather than letting WebGL decide..
	    if(attributeLocations)
	    {
	        for(var i in attributeLocations)
	        {
	            gl.bindAttribLocation(program, attributeLocations[i], i);
	        }
	    }


	    gl.linkProgram(program);

	    // if linking fails, then log and cleanup
	    if (!gl.getProgramParameter(program, gl.LINK_STATUS))
	    {
	        console.error('Pixi.js Error: Could not initialize shader.');
	        console.error('gl.VALIDATE_STATUS', gl.getProgramParameter(program, gl.VALIDATE_STATUS));
	        console.error('gl.getError()', gl.getError());

	        // if there is a program info log, log it
	        if (gl.getProgramInfoLog(program) !== '')
	        {
	            console.warn('Pixi.js Warning: gl.getProgramInfoLog()', gl.getProgramInfoLog(program));
	        }

	        gl.deleteProgram(program);
	        program = null;
	    }

	    // clean up some shaders
	    gl.deleteShader(glVertShader);
	    gl.deleteShader(glFragShader);

	    return program;
	};

	/**
	 * @private
	 * @param gl {WebGLRenderingContext} The current WebGL context {WebGLProgram}
	 * @param type {Number} the type, can be either VERTEX_SHADER or FRAGMENT_SHADER
	 * @param vertexSrc {string|string[]} The vertex shader source as an array of strings.
	 * @return {WebGLShader} the shader
	 */
	var compileShader = function (gl, type, src)
	{
	    var shader = gl.createShader(type);

	    gl.shaderSource(shader, src);
	    gl.compileShader(shader);

	    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS))
	    {
	        console.log(gl.getShaderInfoLog(shader));
	        return null;
	    }

	    return shader;
	};

	module.exports = compileProgram;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	
	var mapType = __webpack_require__(194);
	var mapSize = __webpack_require__(195);

	/**
	 * Extracts the attributes
	 * @class
	 * @memberof PIXI.glCore.shader
	 * @param gl {WebGLRenderingContext} The current WebGL rendering context
	 * @param program {WebGLProgram} The shader program to get the attributes from
	 * @return attributes {Object}
	 */
	var extractAttributes = function(gl, program)
	{
	    var attributes = {};

	    var totalAttributes = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);

	    for (var i = 0; i < totalAttributes; i++)
	    {
	        var attribData = gl.getActiveAttrib(program, i);
	        var type = mapType(gl, attribData.type);

	        attributes[attribData.name] = {
	            type:type,
	            size:mapSize(type),
	            location:gl.getAttribLocation(program, attribData.name),
	            //TODO - make an attribute object
	            pointer: pointer
	        };
	    }

	    return attributes;
	};

	var pointer = function(type, normalized, stride, start){
	    // console.log(this.location)
	    gl.vertexAttribPointer(this.location,this.size, type || gl.FLOAT, normalized || false, stride || 0, start || 0);
	};

	module.exports = extractAttributes;


/***/ }),
/* 194 */
/***/ (function(module, exports) {

	

	var mapType = function(gl, type) 
	{
	    if(!GL_TABLE) 
	    {
	        var typeNames = Object.keys(GL_TO_GLSL_TYPES);

	        GL_TABLE = {};

	        for(var i = 0; i < typeNames.length; ++i) 
	        {
	            var tn = typeNames[i];
	            GL_TABLE[ gl[tn] ] = GL_TO_GLSL_TYPES[tn];
	        }
	    }

	  return GL_TABLE[type];
	};

	var GL_TABLE = null;

	var GL_TO_GLSL_TYPES = {
	  'FLOAT':       'float',
	  'FLOAT_VEC2':  'vec2',
	  'FLOAT_VEC3':  'vec3',
	  'FLOAT_VEC4':  'vec4',

	  'INT':         'int',
	  'INT_VEC2':    'ivec2',
	  'INT_VEC3':    'ivec3',
	  'INT_VEC4':    'ivec4',
	  
	  'BOOL':        'bool',
	  'BOOL_VEC2':   'bvec2',
	  'BOOL_VEC3':   'bvec3',
	  'BOOL_VEC4':   'bvec4',
	  
	  'FLOAT_MAT2':  'mat2',
	  'FLOAT_MAT3':  'mat3',
	  'FLOAT_MAT4':  'mat4',
	  
	  'SAMPLER_2D':  'sampler2D'  
	};

	module.exports = mapType;


/***/ }),
/* 195 */
/***/ (function(module, exports) {

	/**
	 * @class
	 * @memberof PIXI.glCore.shader
	 * @param type {String}
	 * @return {Number}
	 */
	var mapSize = function(type) 
	{ 
	    return GLSL_TO_SIZE[type];
	};


	var GLSL_TO_SIZE = {
	    'float':    1,
	    'vec2':     2,
	    'vec3':     3,
	    'vec4':     4,

	    'int':      1,
	    'ivec2':    2,
	    'ivec3':    3,
	    'ivec4':    4,

	    'bool':     1,
	    'bvec2':    2,
	    'bvec3':    3,
	    'bvec4':    4,

	    'mat2':     4,
	    'mat3':     9,
	    'mat4':     16,

	    'sampler2D':  1
	};

	module.exports = mapSize;


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	var mapType = __webpack_require__(194);
	var defaultValue = __webpack_require__(197);

	/**
	 * Extracts the uniforms
	 * @class
	 * @memberof PIXI.glCore.shader
	 * @param gl {WebGLRenderingContext} The current WebGL rendering context
	 * @param program {WebGLProgram} The shader program to get the uniforms from
	 * @return uniforms {Object}
	 */
	var extractUniforms = function(gl, program)
	{
		var uniforms = {};

	    var totalUniforms = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);

	    for (var i = 0; i < totalUniforms; i++)
	    {
	    	var uniformData = gl.getActiveUniform(program, i);
	    	var name = uniformData.name.replace(/\[.*?\]/, "");
	        var type = mapType(gl, uniformData.type );

	    	uniforms[name] = {
	    		type:type,
	    		size:uniformData.size,
	    		location:gl.getUniformLocation(program, name),
	    		value:defaultValue(type, uniformData.size)
	    	};
	    }

		return uniforms;
	};

	module.exports = extractUniforms;


/***/ }),
/* 197 */
/***/ (function(module, exports) {

	/**
	 * @class
	 * @memberof PIXI.glCore.shader
	 * @param type {String} Type of value
	 * @param size {Number}
	 */
	var defaultValue = function(type, size) 
	{
	    switch (type)
	    {
	        case 'float':
	            return 0;

	        case 'vec2': 
	            return new Float32Array(2 * size);

	        case 'vec3':
	            return new Float32Array(3 * size);

	        case 'vec4':     
	            return new Float32Array(4 * size);
	            
	        case 'int':
	        case 'sampler2D':
	            return 0;

	        case 'ivec2':   
	            return new Int32Array(2 * size);

	        case 'ivec3':
	            return new Int32Array(3 * size);

	        case 'ivec4': 
	            return new Int32Array(4 * size);

	        case 'bool':     
	            return false;

	        case 'bvec2':

	            return booleanArray( 2 * size);

	        case 'bvec3':
	            return booleanArray(3 * size);

	        case 'bvec4':
	            return booleanArray(4 * size);

	        case 'mat2':
	            return new Float32Array([1, 0,
	                                     0, 1]);

	        case 'mat3': 
	            return new Float32Array([1, 0, 0,
	                                     0, 1, 0,
	                                     0, 0, 1]);

	        case 'mat4':
	            return new Float32Array([1, 0, 0, 0,
	                                     0, 1, 0, 0,
	                                     0, 0, 1, 0,
	                                     0, 0, 0, 1]);
	    }
	};

	var booleanArray = function(size)
	{
	    var array = new Array(size);

	    for (var i = 0; i < array.length; i++) 
	    {
	        array[i] = false;
	    }

	    return array;
	};

	module.exports = defaultValue;


/***/ }),
/* 198 */
/***/ (function(module, exports) {

	/**
	 * Sets the float precision on the shader. If the precision is already present this function will do nothing
	 * @param {string} src       the shader source
	 * @param {string} precision The float precision of the shader. Options are 'lowp', 'mediump' or 'highp'.
	 *
	 * @return {string} modified shader source
	 */
	var setPrecision = function(src, precision)
	{
	    if(src.substring(0, 9) !== 'precision')
	    {
	        return 'precision ' + precision + ' float;\n' + src;
	    }

	    return src;
	};

	module.exports = setPrecision;


/***/ }),
/* 199 */
/***/ (function(module, exports) {

	/**
	 * Extracts the attributes
	 * @class
	 * @memberof PIXI.glCore.shader
	 * @param gl {WebGLRenderingContext} The current WebGL rendering context
	 * @param uniforms {Array} @mat ?
	 * @return attributes {Object}
	 */
	var generateUniformAccessObject = function(gl, uniformData)
	{
	    // this is the object we will be sending back.
	    // an object hierachy will be created for structs
	    var uniforms = {data:{}};

	    uniforms.gl = gl;

	    var uniformKeys= Object.keys(uniformData);

	    for (var i = 0; i < uniformKeys.length; i++)
	    {
	        var fullName = uniformKeys[i];

	        var nameTokens = fullName.split('.');
	        var name = nameTokens[nameTokens.length - 1];


	        var uniformGroup = getUniformGroup(nameTokens, uniforms);

	        var uniform =  uniformData[fullName];
	        uniformGroup.data[name] = uniform;

	        uniformGroup.gl = gl;

	        Object.defineProperty(uniformGroup, name, {
	            get: generateGetter(name),
	            set: generateSetter(name, uniform)
	        });
	    }

	    return uniforms;
	};

	var generateGetter = function(name)
	{
	    return function() {
	        return this.data[name].value;
	    };
	};

	var GLSL_SINGLE_SETTERS = {
	    float: function setSingleFloat(gl, location, value) { gl.uniform1f(location, value); },
	    vec2: function setSingleVec2(gl, location, value) { gl.uniform2f(location, value[0], value[1]); },
	    vec3: function setSingleVec3(gl, location, value) { gl.uniform3f(location, value[0], value[1], value[2]); },
	    vec4: function setSingleVec4(gl, location, value) { gl.uniform4f(location, value[0], value[1], value[2], value[3]); },

	    int: function setSingleInt(gl, location, value) { gl.uniform1i(location, value); },
	    ivec2: function setSingleIvec2(gl, location, value) { gl.uniform2i(location, value[0], value[1]); },
	    ivec3: function setSingleIvec3(gl, location, value) { gl.uniform3i(location, value[0], value[1], value[2]); },
	    ivec4: function setSingleIvec4(gl, location, value) { gl.uniform4i(location, value[0], value[1], value[2], value[3]); },

	    bool: function setSingleBool(gl, location, value) { gl.uniform1i(location, value); },
	    bvec2: function setSingleBvec2(gl, location, value) { gl.uniform2i(location, value[0], value[1]); },
	    bvec3: function setSingleBvec3(gl, location, value) { gl.uniform3i(location, value[0], value[1], value[2]); },
	    bvec4: function setSingleBvec4(gl, location, value) { gl.uniform4i(location, value[0], value[1], value[2], value[3]); },

	    mat2: function setSingleMat2(gl, location, value) { gl.uniformMatrix2fv(location, false, value); },
	    mat3: function setSingleMat3(gl, location, value) { gl.uniformMatrix3fv(location, false, value); },
	    mat4: function setSingleMat4(gl, location, value) { gl.uniformMatrix4fv(location, false, value); },

	    sampler2D: function setSingleSampler2D(gl, location, value) { gl.uniform1i(location, value); },
	};

	var GLSL_ARRAY_SETTERS = {
	    float: function setFloatArray(gl, location, value) { gl.uniform1fv(location, value); },
	    vec2: function setVec2Array(gl, location, value) { gl.uniform2fv(location, value); },
	    vec3: function setVec3Array(gl, location, value) { gl.uniform3fv(location, value); },
	    vec4: function setVec4Array(gl, location, value) { gl.uniform4fv(location, value); },
	    int: function setIntArray(gl, location, value) { gl.uniform1iv(location, value); },
	    ivec2: function setIvec2Array(gl, location, value) { gl.uniform2iv(location, value); },
	    ivec3: function setIvec3Array(gl, location, value) { gl.uniform3iv(location, value); },
	    ivec4: function setIvec4Array(gl, location, value) { gl.uniform4iv(location, value); },
	    bool: function setBoolArray(gl, location, value) { gl.uniform1iv(location, value); },
	    bvec2: function setBvec2Array(gl, location, value) { gl.uniform2iv(location, value); },
	    bvec3: function setBvec3Array(gl, location, value) { gl.uniform3iv(location, value); },
	    bvec4: function setBvec4Array(gl, location, value) { gl.uniform4iv(location, value); },
	    sampler2D: function setSampler2DArray(gl, location, value) { gl.uniform1iv(location, value); },
	};

	function generateSetter(name, uniform)
	{
	    return function(value) {
	        this.data[name].value = value;
	        var location = this.data[name].location;
	        if (uniform.size === 1)
	        {
	            GLSL_SINGLE_SETTERS[uniform.type](this.gl, location, value);
	        }
	        else
	        {
	            // glslSetArray(gl, location, type, value) {
	            GLSL_ARRAY_SETTERS[uniform.type](this.gl, location, value);
	        }
	    };
	}

	function getUniformGroup(nameTokens, uniform)
	{
	    var cur = uniform;

	    for (var i = 0; i < nameTokens.length - 1; i++)
	    {
	        var o = cur[nameTokens[i]] || {data:{}};
	        cur[nameTokens[i]] = o;
	        cur = o;
	    }

	    return cur;
	}


	module.exports = generateUniformAccessObject;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	
	// state object//
	var setVertexAttribArrays = __webpack_require__( 187 );

	/**
	 * Helper class to work with WebGL VertexArrayObjects (vaos)
	 * Only works if WebGL extensions are enabled (they usually are)
	 *
	 * @class
	 * @memberof PIXI.glCore
	 * @param gl {WebGLRenderingContext} The current WebGL rendering context
	 */
	function VertexArrayObject(gl, state)
	{
	    this.nativeVaoExtension = null;

	    if(!VertexArrayObject.FORCE_NATIVE)
	    {
	        this.nativeVaoExtension = gl.getExtension('OES_vertex_array_object') ||
	                                  gl.getExtension('MOZ_OES_vertex_array_object') ||
	                                  gl.getExtension('WEBKIT_OES_vertex_array_object');
	    }

	    this.nativeState = state;

	    if(this.nativeVaoExtension)
	    {
	        this.nativeVao = this.nativeVaoExtension.createVertexArrayOES();

	        var maxAttribs = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);

	        // VAO - overwrite the state..
	        this.nativeState = {
	            tempAttribState: new Array(maxAttribs),
	            attribState: new Array(maxAttribs)
	        };
	    }

	    /**
	     * The current WebGL rendering context
	     *
	     * @member {WebGLRenderingContext}
	     */
	    this.gl = gl;

	    /**
	     * An array of attributes
	     *
	     * @member {Array}
	     */
	    this.attributes = [];

	    /**
	     * @member {PIXI.glCore.GLBuffer}
	     */
	    this.indexBuffer = null;

	    /**
	     * A boolean flag
	     *
	     * @member {Boolean}
	     */
	    this.dirty = false;
	}

	VertexArrayObject.prototype.constructor = VertexArrayObject;
	module.exports = VertexArrayObject;

	/**
	* Some devices behave a bit funny when using the newer extensions (im looking at you ipad 2!)
	* If you find on older devices that things have gone a bit weird then set this to true.
	*/
	/**
	 * Lets the VAO know if you should use the WebGL extension or the native methods.
	 * Some devices behave a bit funny when using the newer extensions (im looking at you ipad 2!)
	 * If you find on older devices that things have gone a bit weird then set this to true.
	 * @static
	 * @property {Boolean} FORCE_NATIVE
	 */
	VertexArrayObject.FORCE_NATIVE = false;

	/**
	 * Binds the buffer
	 */
	VertexArrayObject.prototype.bind = function()
	{
	    if(this.nativeVao)
	    {
	        this.nativeVaoExtension.bindVertexArrayOES(this.nativeVao);

	        if(this.dirty)
	        {
	            this.dirty = false;
	            this.activate();
	            return this;
	        }
	        if (this.indexBuffer)
	        {
	            this.indexBuffer.bind();
	        }
	    }
	    else
	    {
	        this.activate();
	    }

	    return this;
	};

	/**
	 * Unbinds the buffer
	 */
	VertexArrayObject.prototype.unbind = function()
	{
	    if(this.nativeVao)
	    {
	        this.nativeVaoExtension.bindVertexArrayOES(null);
	    }

	    return this;
	};

	/**
	 * Uses this vao
	 */
	VertexArrayObject.prototype.activate = function()
	{

	    var gl = this.gl;
	    var lastBuffer = null;

	    for (var i = 0; i < this.attributes.length; i++)
	    {
	        var attrib = this.attributes[i];

	        if(lastBuffer !== attrib.buffer)
	        {
	            attrib.buffer.bind();
	            lastBuffer = attrib.buffer;
	        }

	        gl.vertexAttribPointer(attrib.attribute.location,
	                               attrib.attribute.size,
	                               attrib.type || gl.FLOAT,
	                               attrib.normalized || false,
	                               attrib.stride || 0,
	                               attrib.start || 0);
	    }

	    setVertexAttribArrays(gl, this.attributes, this.nativeState);

	    if(this.indexBuffer)
	    {
	        this.indexBuffer.bind();
	    }

	    return this;
	};

	/**
	 *
	 * @param buffer     {PIXI.gl.GLBuffer}
	 * @param attribute  {*}
	 * @param type       {String}
	 * @param normalized {Boolean}
	 * @param stride     {Number}
	 * @param start      {Number}
	 */
	VertexArrayObject.prototype.addAttribute = function(buffer, attribute, type, normalized, stride, start)
	{
	    this.attributes.push({
	        buffer:     buffer,
	        attribute:  attribute,

	        location:   attribute.location,
	        type:       type || this.gl.FLOAT,
	        normalized: normalized || false,
	        stride:     stride || 0,
	        start:      start || 0
	    });

	    this.dirty = true;

	    return this;
	};

	/**
	 *
	 * @param buffer   {PIXI.gl.GLBuffer}
	 */
	VertexArrayObject.prototype.addIndex = function(buffer/*, options*/)
	{
	    this.indexBuffer = buffer;

	    this.dirty = true;

	    return this;
	};

	/**
	 * Unbinds this vao and disables it
	 */
	VertexArrayObject.prototype.clear = function()
	{
	    // var gl = this.gl;

	    // TODO - should this function unbind after clear?
	    // for now, no but lets see what happens in the real world!
	    if(this.nativeVao)
	    {
	        this.nativeVaoExtension.bindVertexArrayOES(this.nativeVao);
	    }

	    this.attributes.length = 0;
	    this.indexBuffer = null;

	    return this;
	};

	/**
	 * @param type  {Number}
	 * @param size  {Number}
	 * @param start {Number}
	 */
	VertexArrayObject.prototype.draw = function(type, size, start)
	{
	    var gl = this.gl;

	    if(this.indexBuffer)
	    {
	        gl.drawElements(type, size || this.indexBuffer.data.length, gl.UNSIGNED_SHORT, (start || 0) * 2 );
	    }
	    else
	    {
	        // TODO need a better way to calculate size..
	        gl.drawArrays(type, start, size || this.getSize());
	    }

	    return this;
	};

	/**
	 * Destroy this vao
	 */
	VertexArrayObject.prototype.destroy = function()
	{
	    // lose references
	    this.gl = null;
	    this.indexBuffer = null;
	    this.attributes = null;
	    this.nativeState = null;

	    if(this.nativeVao)
	    {
	        this.nativeVaoExtension.deleteVertexArrayOES(this.nativeVao);
	    }

	    this.nativeVaoExtension = null;
	    this.nativeVao = null;
	};

	VertexArrayObject.prototype.getSize = function()
	{
	    var attrib = this.attributes[0];
	    return attrib.buffer.data.length / (( attrib.stride/4 ) || attrib.attribute.size);
	};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = {
	    compileProgram: __webpack_require__(192),
	    defaultValue: __webpack_require__(197),
	    extractAttributes: __webpack_require__(193),
	    extractUniforms: __webpack_require__(196),
	    generateUniformAccessObject: __webpack_require__(199),
	    setPrecision: __webpack_require__(198),
	    mapSize: __webpack_require__(195),
	    mapType: __webpack_require__(194)
	};

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _math = __webpack_require__(175);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/**
	 * 'Builder' pattern for bounds rectangles
	 * Axis-Aligned Bounding Box
	 * It is not a shape! Its mutable thing, no 'EMPTY' or that kind of problems
	 *
	 * @class
	 * @memberof PIXI
	 */
	var Bounds = function () {
	    /**
	     *
	     */
	    function Bounds() {
	        _classCallCheck(this, Bounds);

	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.minX = Infinity;

	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.minY = Infinity;

	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.maxX = -Infinity;

	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.maxY = -Infinity;

	        this.rect = null;
	    }

	    /**
	     * Checks if bounds are empty.
	     *
	     * @return {boolean} True if empty.
	     */


	    Bounds.prototype.isEmpty = function isEmpty() {
	        return this.minX > this.maxX || this.minY > this.maxY;
	    };

	    /**
	     * Clears the bounds and resets.
	     *
	     */


	    Bounds.prototype.clear = function clear() {
	        this.updateID++;

	        this.minX = Infinity;
	        this.minY = Infinity;
	        this.maxX = -Infinity;
	        this.maxY = -Infinity;
	    };

	    /**
	     * Can return Rectangle.EMPTY constant, either construct new rectangle, either use your rectangle
	     * It is not guaranteed that it will return tempRect
	     *
	     * @param {PIXI.Rectangle} rect - temporary object will be used if AABB is not empty
	     * @returns {PIXI.Rectangle} A rectangle of the bounds
	     */


	    Bounds.prototype.getRectangle = function getRectangle(rect) {
	        if (this.minX > this.maxX || this.minY > this.maxY) {
	            return _math.Rectangle.EMPTY;
	        }

	        rect = rect || new _math.Rectangle(0, 0, 1, 1);

	        rect.x = this.minX;
	        rect.y = this.minY;
	        rect.width = this.maxX - this.minX;
	        rect.height = this.maxY - this.minY;

	        return rect;
	    };

	    /**
	     * This function should be inlined when its possible.
	     *
	     * @param {PIXI.Point} point - The point to add.
	     */


	    Bounds.prototype.addPoint = function addPoint(point) {
	        this.minX = Math.min(this.minX, point.x);
	        this.maxX = Math.max(this.maxX, point.x);
	        this.minY = Math.min(this.minY, point.y);
	        this.maxY = Math.max(this.maxY, point.y);
	    };

	    /**
	     * Adds a quad, not transformed
	     *
	     * @param {Float32Array} vertices - The verts to add.
	     */


	    Bounds.prototype.addQuad = function addQuad(vertices) {
	        var minX = this.minX;
	        var minY = this.minY;
	        var maxX = this.maxX;
	        var maxY = this.maxY;

	        var x = vertices[0];
	        var y = vertices[1];

	        minX = x < minX ? x : minX;
	        minY = y < minY ? y : minY;
	        maxX = x > maxX ? x : maxX;
	        maxY = y > maxY ? y : maxY;

	        x = vertices[2];
	        y = vertices[3];
	        minX = x < minX ? x : minX;
	        minY = y < minY ? y : minY;
	        maxX = x > maxX ? x : maxX;
	        maxY = y > maxY ? y : maxY;

	        x = vertices[4];
	        y = vertices[5];
	        minX = x < minX ? x : minX;
	        minY = y < minY ? y : minY;
	        maxX = x > maxX ? x : maxX;
	        maxY = y > maxY ? y : maxY;

	        x = vertices[6];
	        y = vertices[7];
	        minX = x < minX ? x : minX;
	        minY = y < minY ? y : minY;
	        maxX = x > maxX ? x : maxX;
	        maxY = y > maxY ? y : maxY;

	        this.minX = minX;
	        this.minY = minY;
	        this.maxX = maxX;
	        this.maxY = maxY;
	    };

	    /**
	     * Adds sprite frame, transformed.
	     *
	     * @param {PIXI.TransformBase} transform - TODO
	     * @param {number} x0 - TODO
	     * @param {number} y0 - TODO
	     * @param {number} x1 - TODO
	     * @param {number} y1 - TODO
	     */


	    Bounds.prototype.addFrame = function addFrame(transform, x0, y0, x1, y1) {
	        var matrix = transform.worldTransform;
	        var a = matrix.a;
	        var b = matrix.b;
	        var c = matrix.c;
	        var d = matrix.d;
	        var tx = matrix.tx;
	        var ty = matrix.ty;

	        var minX = this.minX;
	        var minY = this.minY;
	        var maxX = this.maxX;
	        var maxY = this.maxY;

	        var x = a * x0 + c * y0 + tx;
	        var y = b * x0 + d * y0 + ty;

	        minX = x < minX ? x : minX;
	        minY = y < minY ? y : minY;
	        maxX = x > maxX ? x : maxX;
	        maxY = y > maxY ? y : maxY;

	        x = a * x1 + c * y0 + tx;
	        y = b * x1 + d * y0 + ty;
	        minX = x < minX ? x : minX;
	        minY = y < minY ? y : minY;
	        maxX = x > maxX ? x : maxX;
	        maxY = y > maxY ? y : maxY;

	        x = a * x0 + c * y1 + tx;
	        y = b * x0 + d * y1 + ty;
	        minX = x < minX ? x : minX;
	        minY = y < minY ? y : minY;
	        maxX = x > maxX ? x : maxX;
	        maxY = y > maxY ? y : maxY;

	        x = a * x1 + c * y1 + tx;
	        y = b * x1 + d * y1 + ty;
	        minX = x < minX ? x : minX;
	        minY = y < minY ? y : minY;
	        maxX = x > maxX ? x : maxX;
	        maxY = y > maxY ? y : maxY;

	        this.minX = minX;
	        this.minY = minY;
	        this.maxX = maxX;
	        this.maxY = maxY;
	    };

	    /**
	     * Add an array of vertices
	     *
	     * @param {PIXI.TransformBase} transform - TODO
	     * @param {Float32Array} vertices - TODO
	     * @param {number} beginOffset - TODO
	     * @param {number} endOffset - TODO
	     */


	    Bounds.prototype.addVertices = function addVertices(transform, vertices, beginOffset, endOffset) {
	        var matrix = transform.worldTransform;
	        var a = matrix.a;
	        var b = matrix.b;
	        var c = matrix.c;
	        var d = matrix.d;
	        var tx = matrix.tx;
	        var ty = matrix.ty;

	        var minX = this.minX;
	        var minY = this.minY;
	        var maxX = this.maxX;
	        var maxY = this.maxY;

	        for (var i = beginOffset; i < endOffset; i += 2) {
	            var rawX = vertices[i];
	            var rawY = vertices[i + 1];
	            var x = a * rawX + c * rawY + tx;
	            var y = d * rawY + b * rawX + ty;

	            minX = x < minX ? x : minX;
	            minY = y < minY ? y : minY;
	            maxX = x > maxX ? x : maxX;
	            maxY = y > maxY ? y : maxY;
	        }

	        this.minX = minX;
	        this.minY = minY;
	        this.maxX = maxX;
	        this.maxY = maxY;
	    };

	    /**
	     * Adds other Bounds
	     *
	     * @param {PIXI.Bounds} bounds - TODO
	     */


	    Bounds.prototype.addBounds = function addBounds(bounds) {
	        var minX = this.minX;
	        var minY = this.minY;
	        var maxX = this.maxX;
	        var maxY = this.maxY;

	        this.minX = bounds.minX < minX ? bounds.minX : minX;
	        this.minY = bounds.minY < minY ? bounds.minY : minY;
	        this.maxX = bounds.maxX > maxX ? bounds.maxX : maxX;
	        this.maxY = bounds.maxY > maxY ? bounds.maxY : maxY;
	    };

	    /**
	     * Adds other Bounds, masked with Bounds
	     *
	     * @param {PIXI.Bounds} bounds - TODO
	     * @param {PIXI.Bounds} mask - TODO
	     */


	    Bounds.prototype.addBoundsMask = function addBoundsMask(bounds, mask) {
	        var _minX = bounds.minX > mask.minX ? bounds.minX : mask.minX;
	        var _minY = bounds.minY > mask.minY ? bounds.minY : mask.minY;
	        var _maxX = bounds.maxX < mask.maxX ? bounds.maxX : mask.maxX;
	        var _maxY = bounds.maxY < mask.maxY ? bounds.maxY : mask.maxY;

	        if (_minX <= _maxX && _minY <= _maxY) {
	            var minX = this.minX;
	            var minY = this.minY;
	            var maxX = this.maxX;
	            var maxY = this.maxY;

	            this.minX = _minX < minX ? _minX : minX;
	            this.minY = _minY < minY ? _minY : minY;
	            this.maxX = _maxX > maxX ? _maxX : maxX;
	            this.maxY = _maxY > maxY ? _maxY : maxY;
	        }
	    };

	    /**
	     * Adds other Bounds, masked with Rectangle
	     *
	     * @param {PIXI.Bounds} bounds - TODO
	     * @param {PIXI.Rectangle} area - TODO
	     */


	    Bounds.prototype.addBoundsArea = function addBoundsArea(bounds, area) {
	        var _minX = bounds.minX > area.x ? bounds.minX : area.x;
	        var _minY = bounds.minY > area.y ? bounds.minY : area.y;
	        var _maxX = bounds.maxX < area.x + area.width ? bounds.maxX : area.x + area.width;
	        var _maxY = bounds.maxY < area.y + area.height ? bounds.maxY : area.y + area.height;

	        if (_minX <= _maxX && _minY <= _maxY) {
	            var minX = this.minX;
	            var minY = this.minY;
	            var maxX = this.maxX;
	            var maxY = this.maxY;

	            this.minX = _minX < minX ? _minX : minX;
	            this.minY = _minY < minY ? _minY : minY;
	            this.maxX = _maxX > maxX ? _maxX : maxX;
	            this.maxY = _maxY > maxY ? _maxY : maxY;
	        }
	    };

	    return Bounds;
	}();

	exports.default = Bounds;
	//# sourceMappingURL=Bounds.js.map

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _eventemitter = __webpack_require__(204);

	var _eventemitter2 = _interopRequireDefault(_eventemitter);

	var _const = __webpack_require__(174);

	var _settings = __webpack_require__(205);

	var _settings2 = _interopRequireDefault(_settings);

	var _TransformStatic = __webpack_require__(209);

	var _TransformStatic2 = _interopRequireDefault(_TransformStatic);

	var _Transform = __webpack_require__(211);

	var _Transform2 = _interopRequireDefault(_Transform);

	var _Bounds = __webpack_require__(202);

	var _Bounds2 = _interopRequireDefault(_Bounds);

	var _math = __webpack_require__(175);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	// _tempDisplayObjectParent = new DisplayObject();

	/**
	 * The base class for all objects that are rendered on the screen.
	 * This is an abstract class and should not be used on its own rather it should be extended.
	 *
	 * @class
	 * @extends EventEmitter
	 * @memberof PIXI
	 */
	var DisplayObject = function (_EventEmitter) {
	    _inherits(DisplayObject, _EventEmitter);

	    /**
	     *
	     */
	    function DisplayObject() {
	        _classCallCheck(this, DisplayObject);

	        var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

	        var TransformClass = _settings2.default.TRANSFORM_MODE === _const.TRANSFORM_MODE.STATIC ? _TransformStatic2.default : _Transform2.default;

	        _this.tempDisplayObjectParent = null;

	        // TODO: need to create Transform from factory
	        /**
	         * World transform and local transform of this object.
	         * This will become read-only later, please do not assign anything there unless you know what are you doing
	         *
	         * @member {PIXI.TransformBase}
	         */
	        _this.transform = new TransformClass();

	        /**
	         * The opacity of the object.
	         *
	         * @member {number}
	         */
	        _this.alpha = 1;

	        /**
	         * The visibility of the object. If false the object will not be drawn, and
	         * the updateTransform function will not be called.
	         *
	         * Only affects recursive calls from parent. You can ask for bounds or call updateTransform manually
	         *
	         * @member {boolean}
	         */
	        _this.visible = true;

	        /**
	         * Can this object be rendered, if false the object will not be drawn but the updateTransform
	         * methods will still be called.
	         *
	         * Only affects recursive calls from parent. You can ask for bounds manually
	         *
	         * @member {boolean}
	         */
	        _this.renderable = true;

	        /**
	         * The display object container that contains this display object.
	         *
	         * @member {PIXI.Container}
	         * @readonly
	         */
	        _this.parent = null;

	        /**
	         * The multiplied alpha of the displayObject
	         *
	         * @member {number}
	         * @readonly
	         */
	        _this.worldAlpha = 1;

	        /**
	         * The area the filter is applied to. This is used as more of an optimisation
	         * rather than figuring out the dimensions of the displayObject each frame you can set this rectangle
	         *
	         * Also works as an interaction mask
	         *
	         * @member {PIXI.Rectangle}
	         */
	        _this.filterArea = null;

	        _this._filters = null;
	        _this._enabledFilters = null;

	        /**
	         * The bounds object, this is used to calculate and store the bounds of the displayObject
	         *
	         * @member {PIXI.Rectangle}
	         * @private
	         */
	        _this._bounds = new _Bounds2.default();
	        _this._boundsID = 0;
	        _this._lastBoundsID = -1;
	        _this._boundsRect = null;
	        _this._localBoundsRect = null;

	        /**
	         * The original, cached mask of the object
	         *
	         * @member {PIXI.Graphics|PIXI.Sprite}
	         * @private
	         */
	        _this._mask = null;

	        /**
	         * If the object has been destroyed via destroy(). If true, it should not be used.
	         *
	         * @member {boolean}
	         * @private
	         * @readonly
	         */
	        _this._destroyed = false;

	        /**
	         * Fired when this DisplayObject is added to a Container.
	         *
	         * @event PIXI.DisplayObject#added
	         * @param {PIXI.Container} container - The container added to.
	         */

	        /**
	         * Fired when this DisplayObject is removed from a Container.
	         *
	         * @event PIXI.DisplayObject#removed
	         * @param {PIXI.Container} container - The container removed from.
	         */
	        return _this;
	    }

	    /**
	     * @private
	     * @member {PIXI.DisplayObject}
	     */


	    /**
	     * Updates the object transform for rendering
	     *
	     * TODO - Optimization pass!
	     */
	    DisplayObject.prototype.updateTransform = function updateTransform() {
	        this.transform.updateTransform(this.parent.transform);
	        // multiply the alphas..
	        this.worldAlpha = this.alpha * this.parent.worldAlpha;

	        this._bounds.updateID++;
	    };

	    /**
	     * recursively updates transform of all objects from the root to this one
	     * internal function for toLocal()
	     */


	    DisplayObject.prototype._recursivePostUpdateTransform = function _recursivePostUpdateTransform() {
	        if (this.parent) {
	            this.parent._recursivePostUpdateTransform();
	            this.transform.updateTransform(this.parent.transform);
	        } else {
	            this.transform.updateTransform(this._tempDisplayObjectParent.transform);
	        }
	    };

	    /**
	     * Retrieves the bounds of the displayObject as a rectangle object.
	     *
	     * @param {boolean} skipUpdate - setting to true will stop the transforms of the scene graph from
	     *  being updated. This means the calculation returned MAY be out of date BUT will give you a
	     *  nice performance boost
	     * @param {PIXI.Rectangle} rect - Optional rectangle to store the result of the bounds calculation
	     * @return {PIXI.Rectangle} the rectangular bounding area
	     */


	    DisplayObject.prototype.getBounds = function getBounds(skipUpdate, rect) {
	        if (!skipUpdate) {
	            if (!this.parent) {
	                this.parent = this._tempDisplayObjectParent;
	                this.updateTransform();
	                this.parent = null;
	            } else {
	                this._recursivePostUpdateTransform();
	                this.updateTransform();
	            }
	        }

	        if (this._boundsID !== this._lastBoundsID) {
	            this.calculateBounds();
	        }

	        if (!rect) {
	            if (!this._boundsRect) {
	                this._boundsRect = new _math.Rectangle();
	            }

	            rect = this._boundsRect;
	        }

	        return this._bounds.getRectangle(rect);
	    };

	    /**
	     * Retrieves the local bounds of the displayObject as a rectangle object
	     *
	     * @param {PIXI.Rectangle} [rect] - Optional rectangle to store the result of the bounds calculation
	     * @return {PIXI.Rectangle} the rectangular bounding area
	     */


	    DisplayObject.prototype.getLocalBounds = function getLocalBounds(rect) {
	        var transformRef = this.transform;
	        var parentRef = this.parent;

	        this.parent = null;
	        this.transform = this._tempDisplayObjectParent.transform;

	        if (!rect) {
	            if (!this._localBoundsRect) {
	                this._localBoundsRect = new _math.Rectangle();
	            }

	            rect = this._localBoundsRect;
	        }

	        var bounds = this.getBounds(false, rect);

	        this.parent = parentRef;
	        this.transform = transformRef;

	        return bounds;
	    };

	    /**
	     * Calculates the global position of the display object
	     *
	     * @param {PIXI.Point} position - The world origin to calculate from
	     * @param {PIXI.Point} [point] - A Point object in which to store the value, optional
	     *  (otherwise will create a new Point)
	     * @param {boolean} [skipUpdate=false] - Should we skip the update transform.
	     * @return {PIXI.Point} A point object representing the position of this object
	     */


	    DisplayObject.prototype.toGlobal = function toGlobal(position, point) {
	        var skipUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

	        if (!skipUpdate) {
	            this._recursivePostUpdateTransform();

	            // this parent check is for just in case the item is a root object.
	            // If it is we need to give it a temporary parent so that displayObjectUpdateTransform works correctly
	            // this is mainly to avoid a parent check in the main loop. Every little helps for performance :)
	            if (!this.parent) {
	                this.parent = this._tempDisplayObjectParent;
	                this.displayObjectUpdateTransform();
	                this.parent = null;
	            } else {
	                this.displayObjectUpdateTransform();
	            }
	        }

	        // don't need to update the lot
	        return this.worldTransform.apply(position, point);
	    };

	    /**
	     * Calculates the local position of the display object relative to another point
	     *
	     * @param {PIXI.Point} position - The world origin to calculate from
	     * @param {PIXI.DisplayObject} [from] - The DisplayObject to calculate the global position from
	     * @param {PIXI.Point} [point] - A Point object in which to store the value, optional
	     *  (otherwise will create a new Point)
	     * @param {boolean} [skipUpdate=false] - Should we skip the update transform
	     * @return {PIXI.Point} A point object representing the position of this object
	     */


	    DisplayObject.prototype.toLocal = function toLocal(position, from, point, skipUpdate) {
	        if (from) {
	            position = from.toGlobal(position, point, skipUpdate);
	        }

	        if (!skipUpdate) {
	            this._recursivePostUpdateTransform();

	            // this parent check is for just in case the item is a root object.
	            // If it is we need to give it a temporary parent so that displayObjectUpdateTransform works correctly
	            // this is mainly to avoid a parent check in the main loop. Every little helps for performance :)
	            if (!this.parent) {
	                this.parent = this._tempDisplayObjectParent;
	                this.displayObjectUpdateTransform();
	                this.parent = null;
	            } else {
	                this.displayObjectUpdateTransform();
	            }
	        }

	        // simply apply the matrix..
	        return this.worldTransform.applyInverse(position, point);
	    };

	    /**
	     * Renders the object using the WebGL renderer
	     *
	     * @param {PIXI.WebGLRenderer} renderer - The renderer
	     */


	    DisplayObject.prototype.renderWebGL = function renderWebGL(renderer) // eslint-disable-line no-unused-vars
	    {}
	    // OVERWRITE;


	    /**
	     * Renders the object using the Canvas renderer
	     *
	     * @param {PIXI.CanvasRenderer} renderer - The renderer
	     */
	    ;

	    DisplayObject.prototype.renderCanvas = function renderCanvas(renderer) // eslint-disable-line no-unused-vars
	    {}
	    // OVERWRITE;


	    /**
	     * Set the parent Container of this DisplayObject
	     *
	     * @param {PIXI.Container} container - The Container to add this DisplayObject to
	     * @return {PIXI.Container} The Container that this DisplayObject was added to
	     */
	    ;

	    DisplayObject.prototype.setParent = function setParent(container) {
	        if (!container || !container.addChild) {
	            throw new Error('setParent: Argument must be a Container');
	        }

	        container.addChild(this);

	        return container;
	    };

	    /**
	     * Convenience function to set the position, scale, skew and pivot at once.
	     *
	     * @param {number} [x=0] - The X position
	     * @param {number} [y=0] - The Y position
	     * @param {number} [scaleX=1] - The X scale value
	     * @param {number} [scaleY=1] - The Y scale value
	     * @param {number} [rotation=0] - The rotation
	     * @param {number} [skewX=0] - The X skew value
	     * @param {number} [skewY=0] - The Y skew value
	     * @param {number} [pivotX=0] - The X pivot value
	     * @param {number} [pivotY=0] - The Y pivot value
	     * @return {PIXI.DisplayObject} The DisplayObject instance
	     */


	    DisplayObject.prototype.setTransform = function setTransform() {
	        var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	        var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	        var scaleX = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	        var scaleY = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
	        var rotation = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
	        var skewX = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	        var skewY = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
	        var pivotX = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
	        var pivotY = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : 0;

	        this.position.x = x;
	        this.position.y = y;
	        this.scale.x = !scaleX ? 1 : scaleX;
	        this.scale.y = !scaleY ? 1 : scaleY;
	        this.rotation = rotation;
	        this.skew.x = skewX;
	        this.skew.y = skewY;
	        this.pivot.x = pivotX;
	        this.pivot.y = pivotY;

	        return this;
	    };

	    /**
	     * Base destroy method for generic display objects. This will automatically
	     * remove the display object from its parent Container as well as remove
	     * all current event listeners and internal references. Do not use a DisplayObject
	     * after calling `destroy`.
	     *
	     */


	    DisplayObject.prototype.destroy = function destroy() {
	        this.removeAllListeners();
	        if (this.parent) {
	            this.parent.removeChild(this);
	        }
	        this.transform = null;

	        this.parent = null;

	        this._bounds = null;
	        this._currentBounds = null;
	        this._mask = null;

	        this.filterArea = null;

	        this.interactive = false;
	        this.interactiveChildren = false;

	        this._destroyed = true;
	    };

	    /**
	     * The position of the displayObject on the x axis relative to the local coordinates of the parent.
	     * An alias to position.x
	     *
	     * @member {number}
	     */


	    _createClass(DisplayObject, [{
	        key: '_tempDisplayObjectParent',
	        get: function get() {
	            if (this.tempDisplayObjectParent === null) {
	                this.tempDisplayObjectParent = new DisplayObject();
	            }

	            return this.tempDisplayObjectParent;
	        }
	    }, {
	        key: 'x',
	        get: function get() {
	            return this.position.x;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.transform.position.x = value;
	        }

	        /**
	         * The position of the displayObject on the y axis relative to the local coordinates of the parent.
	         * An alias to position.y
	         *
	         * @member {number}
	         */

	    }, {
	        key: 'y',
	        get: function get() {
	            return this.position.y;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.transform.position.y = value;
	        }

	        /**
	         * Current transform of the object based on world (parent) factors
	         *
	         * @member {PIXI.Matrix}
	         * @readonly
	         */

	    }, {
	        key: 'worldTransform',
	        get: function get() {
	            return this.transform.worldTransform;
	        }

	        /**
	         * Current transform of the object based on local factors: position, scale, other stuff
	         *
	         * @member {PIXI.Matrix}
	         * @readonly
	         */

	    }, {
	        key: 'localTransform',
	        get: function get() {
	            return this.transform.localTransform;
	        }

	        /**
	         * The coordinate of the object relative to the local coordinates of the parent.
	         * Assignment by value since pixi-v4.
	         *
	         * @member {PIXI.Point|PIXI.ObservablePoint}
	         */

	    }, {
	        key: 'position',
	        get: function get() {
	            return this.transform.position;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.transform.position.copy(value);
	        }

	        /**
	         * The scale factor of the object.
	         * Assignment by value since pixi-v4.
	         *
	         * @member {PIXI.Point|PIXI.ObservablePoint}
	         */

	    }, {
	        key: 'scale',
	        get: function get() {
	            return this.transform.scale;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.transform.scale.copy(value);
	        }

	        /**
	         * The pivot point of the displayObject that it rotates around.
	         * Assignment by value since pixi-v4.
	         *
	         * @member {PIXI.Point|PIXI.ObservablePoint}
	         */

	    }, {
	        key: 'pivot',
	        get: function get() {
	            return this.transform.pivot;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.transform.pivot.copy(value);
	        }

	        /**
	         * The skew factor for the object in radians.
	         * Assignment by value since pixi-v4.
	         *
	         * @member {PIXI.ObservablePoint}
	         */

	    }, {
	        key: 'skew',
	        get: function get() {
	            return this.transform.skew;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.transform.skew.copy(value);
	        }

	        /**
	         * The rotation of the object in radians.
	         *
	         * @member {number}
	         */

	    }, {
	        key: 'rotation',
	        get: function get() {
	            return this.transform.rotation;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.transform.rotation = value;
	        }

	        /**
	         * Indicates if the object is globally visible.
	         *
	         * @member {boolean}
	         * @readonly
	         */

	    }, {
	        key: 'worldVisible',
	        get: function get() {
	            var item = this;

	            do {
	                if (!item.visible) {
	                    return false;
	                }

	                item = item.parent;
	            } while (item);

	            return true;
	        }

	        /**
	         * Sets a mask for the displayObject. A mask is an object that limits the visibility of an
	         * object to the shape of the mask applied to it. In PIXI a regular mask must be a
	         * PIXI.Graphics or a PIXI.Sprite object. This allows for much faster masking in canvas as it
	         * utilises shape clipping. To remove a mask, set this property to null.
	         *
	         * @todo For the moment, PIXI.CanvasRenderer doesn't support PIXI.Sprite as mask.
	         *
	         * @member {PIXI.Graphics|PIXI.Sprite}
	         */

	    }, {
	        key: 'mask',
	        get: function get() {
	            return this._mask;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            if (this._mask) {
	                this._mask.renderable = true;
	                this._mask.isMask = false;
	            }

	            this._mask = value;

	            if (this._mask) {
	                this._mask.renderable = false;
	                this._mask.isMask = true;
	            }
	        }

	        /**
	         * Sets the filters for the displayObject.
	         * * IMPORTANT: This is a webGL only feature and will be ignored by the canvas renderer.
	         * To remove filters simply set this property to 'null'
	         *
	         * @member {PIXI.Filter[]}
	         */

	    }, {
	        key: 'filters',
	        get: function get() {
	            return this._filters && this._filters.slice();
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._filters = value && value.slice();
	        }
	    }]);

	    return DisplayObject;
	}(_eventemitter2.default);

	// performance increase to avoid using call.. (10x faster)


	exports.default = DisplayObject;
	DisplayObject.prototype.displayObjectUpdateTransform = DisplayObject.prototype.updateTransform;
	//# sourceMappingURL=DisplayObject.js.map

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var has = Object.prototype.hasOwnProperty
	  , prefix = '~';

	/**
	 * Constructor to create a storage for our `EE` objects.
	 * An `Events` instance is a plain object whose properties are event names.
	 *
	 * @constructor
	 * @api private
	 */
	function Events() {}

	//
	// We try to not inherit from `Object.prototype`. In some engines creating an
	// instance in this way is faster than calling `Object.create(null)` directly.
	// If `Object.create(null)` is not supported we prefix the event names with a
	// character to make sure that the built-in object properties are not
	// overridden or used as an attack vector.
	//
	if (Object.create) {
	  Events.prototype = Object.create(null);

	  //
	  // This hack is needed because the `__proto__` property is still inherited in
	  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
	  //
	  if (!new Events().__proto__) prefix = false;
	}

	/**
	 * Representation of a single event listener.
	 *
	 * @param {Function} fn The listener function.
	 * @param {Mixed} context The context to invoke the listener with.
	 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
	 * @constructor
	 * @api private
	 */
	function EE(fn, context, once) {
	  this.fn = fn;
	  this.context = context;
	  this.once = once || false;
	}

	/**
	 * Minimal `EventEmitter` interface that is molded against the Node.js
	 * `EventEmitter` interface.
	 *
	 * @constructor
	 * @api public
	 */
	function EventEmitter() {
	  this._events = new Events();
	  this._eventsCount = 0;
	}

	/**
	 * Return an array listing the events for which the emitter has registered
	 * listeners.
	 *
	 * @returns {Array}
	 * @api public
	 */
	EventEmitter.prototype.eventNames = function eventNames() {
	  var names = []
	    , events
	    , name;

	  if (this._eventsCount === 0) return names;

	  for (name in (events = this._events)) {
	    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
	  }

	  if (Object.getOwnPropertySymbols) {
	    return names.concat(Object.getOwnPropertySymbols(events));
	  }

	  return names;
	};

	/**
	 * Return the listeners registered for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Boolean} exists Only check if there are listeners.
	 * @returns {Array|Boolean}
	 * @api public
	 */
	EventEmitter.prototype.listeners = function listeners(event, exists) {
	  var evt = prefix ? prefix + event : event
	    , available = this._events[evt];

	  if (exists) return !!available;
	  if (!available) return [];
	  if (available.fn) return [available.fn];

	  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
	    ee[i] = available[i].fn;
	  }

	  return ee;
	};

	/**
	 * Calls each of the listeners registered for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @returns {Boolean} `true` if the event had listeners, else `false`.
	 * @api public
	 */
	EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
	  var evt = prefix ? prefix + event : event;

	  if (!this._events[evt]) return false;

	  var listeners = this._events[evt]
	    , len = arguments.length
	    , args
	    , i;

	  if (listeners.fn) {
	    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

	    switch (len) {
	      case 1: return listeners.fn.call(listeners.context), true;
	      case 2: return listeners.fn.call(listeners.context, a1), true;
	      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
	      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
	      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
	      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
	    }

	    for (i = 1, args = new Array(len -1); i < len; i++) {
	      args[i - 1] = arguments[i];
	    }

	    listeners.fn.apply(listeners.context, args);
	  } else {
	    var length = listeners.length
	      , j;

	    for (i = 0; i < length; i++) {
	      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

	      switch (len) {
	        case 1: listeners[i].fn.call(listeners[i].context); break;
	        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
	        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
	        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
	        default:
	          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
	            args[j - 1] = arguments[j];
	          }

	          listeners[i].fn.apply(listeners[i].context, args);
	      }
	    }
	  }

	  return true;
	};

	/**
	 * Add a listener for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {Mixed} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.on = function on(event, fn, context) {
	  var listener = new EE(fn, context || this)
	    , evt = prefix ? prefix + event : event;

	  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
	  else if (!this._events[evt].fn) this._events[evt].push(listener);
	  else this._events[evt] = [this._events[evt], listener];

	  return this;
	};

	/**
	 * Add a one-time listener for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {Mixed} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.once = function once(event, fn, context) {
	  var listener = new EE(fn, context || this, true)
	    , evt = prefix ? prefix + event : event;

	  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
	  else if (!this._events[evt].fn) this._events[evt].push(listener);
	  else this._events[evt] = [this._events[evt], listener];

	  return this;
	};

	/**
	 * Remove the listeners of a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Function} fn Only remove the listeners that match this function.
	 * @param {Mixed} context Only remove the listeners that have this context.
	 * @param {Boolean} once Only remove one-time listeners.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
	  var evt = prefix ? prefix + event : event;

	  if (!this._events[evt]) return this;
	  if (!fn) {
	    if (--this._eventsCount === 0) this._events = new Events();
	    else delete this._events[evt];
	    return this;
	  }

	  var listeners = this._events[evt];

	  if (listeners.fn) {
	    if (
	         listeners.fn === fn
	      && (!once || listeners.once)
	      && (!context || listeners.context === context)
	    ) {
	      if (--this._eventsCount === 0) this._events = new Events();
	      else delete this._events[evt];
	    }
	  } else {
	    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
	      if (
	           listeners[i].fn !== fn
	        || (once && !listeners[i].once)
	        || (context && listeners[i].context !== context)
	      ) {
	        events.push(listeners[i]);
	      }
	    }

	    //
	    // Reset the array, or remove it completely if we have no more listeners.
	    //
	    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
	    else if (--this._eventsCount === 0) this._events = new Events();
	    else delete this._events[evt];
	  }

	  return this;
	};

	/**
	 * Remove all listeners, or those of the specified event.
	 *
	 * @param {String|Symbol} [event] The event name.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
	  var evt;

	  if (event) {
	    evt = prefix ? prefix + event : event;
	    if (this._events[evt]) {
	      if (--this._eventsCount === 0) this._events = new Events();
	      else delete this._events[evt];
	    }
	  } else {
	    this._events = new Events();
	    this._eventsCount = 0;
	  }

	  return this;
	};

	//
	// Alias methods names because people roll like that.
	//
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	EventEmitter.prototype.addListener = EventEmitter.prototype.on;

	//
	// This function doesn't apply anymore.
	//
	EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
	  return this;
	};

	//
	// Expose the prefix.
	//
	EventEmitter.prefixed = prefix;

	//
	// Allow `EventEmitter` to be imported as module namespace.
	//
	EventEmitter.EventEmitter = EventEmitter;

	//
	// Expose the module.
	//
	if (true) {
	  module.exports = EventEmitter;
	}


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _maxRecommendedTextures = __webpack_require__(206);

	var _maxRecommendedTextures2 = _interopRequireDefault(_maxRecommendedTextures);

	var _canUploadSameBuffer = __webpack_require__(208);

	var _canUploadSameBuffer2 = _interopRequireDefault(_canUploadSameBuffer);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/**
	 * User's customizable globals for overriding the default PIXI settings, such
	 * as a renderer's default resolution, framerate, float percision, etc.
	 * @example
	 * // Use the native window resolution as the default resolution
	 * // will support high-density displays when rendering
	 * PIXI.settings.RESOLUTION = window.devicePixelRatio.
	 *
	 * // Disable interpolation when scaling, will make texture be pixelated
	 * PIXI.settings.SCALE_MODE = PIXI.SCALE_MODES.NEAREST;
	 * @namespace PIXI.settings
	 */
	exports.default = {

	  /**
	   * Target frames per millisecond.
	   *
	   * @static
	   * @memberof PIXI.settings
	   * @type {number}
	   * @default 0.06
	   */
	  TARGET_FPMS: 0.06,

	  /**
	   * If set to true WebGL will attempt make textures mimpaped by default.
	   * Mipmapping will only succeed if the base texture uploaded has power of two dimensions.
	   *
	   * @static
	   * @memberof PIXI.settings
	   * @type {boolean}
	   * @default true
	   */
	  MIPMAP_TEXTURES: true,

	  /**
	   * Default resolution / device pixel ratio of the renderer.
	   *
	   * @static
	   * @memberof PIXI.settings
	   * @type {number}
	   * @default 1
	   */
	  RESOLUTION: 1,

	  /**
	   * Default filter resolution.
	   *
	   * @static
	   * @memberof PIXI.settings
	   * @type {number}
	   * @default 1
	   */
	  FILTER_RESOLUTION: 1,

	  /**
	   * The maximum textures that this device supports.
	   *
	   * @static
	   * @memberof PIXI.settings
	   * @type {number}
	   * @default 32
	   */
	  SPRITE_MAX_TEXTURES: (0, _maxRecommendedTextures2.default)(32),

	  // TODO: maybe change to SPRITE.BATCH_SIZE: 2000
	  // TODO: maybe add PARTICLE.BATCH_SIZE: 15000

	  /**
	   * The default sprite batch size.
	   *
	   * The default aims to balance desktop and mobile devices.
	   *
	   * @static
	   * @memberof PIXI.settings
	   * @type {number}
	   * @default 4096
	   */
	  SPRITE_BATCH_SIZE: 4096,

	  /**
	   * The prefix that denotes a URL is for a retina asset.
	   *
	   * @static
	   * @memberof PIXI.settings
	   * @type {RegExp}
	   * @example `@2x`
	   * @default /@([0-9\.]+)x/
	   */
	  RETINA_PREFIX: /@([0-9\.]+)x/,

	  /**
	   * The default render options if none are supplied to {@link PIXI.WebGLRenderer}
	   * or {@link PIXI.CanvasRenderer}.
	   *
	   * @static
	   * @constant
	   * @memberof PIXI.settings
	   * @type {object}
	   * @property {HTMLCanvasElement} view=null
	   * @property {number} resolution=1
	   * @property {boolean} antialias=false
	   * @property {boolean} forceFXAA=false
	   * @property {boolean} autoResize=false
	   * @property {boolean} transparent=false
	   * @property {number} backgroundColor=0x000000
	   * @property {boolean} clearBeforeRender=true
	   * @property {boolean} preserveDrawingBuffer=false
	   * @property {boolean} roundPixels=false
	   * @property {number} width=800
	   * @property {number} height=600
	   * @property {boolean} legacy=false
	   */
	  RENDER_OPTIONS: {
	    view: null,
	    antialias: false,
	    forceFXAA: false,
	    autoResize: false,
	    transparent: false,
	    backgroundColor: 0x000000,
	    clearBeforeRender: true,
	    preserveDrawingBuffer: false,
	    roundPixels: false,
	    width: 800,
	    height: 600,
	    legacy: false
	  },

	  /**
	   * Default transform type.
	   *
	   * @static
	   * @memberof PIXI.settings
	   * @type {PIXI.TRANSFORM_MODE}
	   * @default PIXI.TRANSFORM_MODE.STATIC
	   */
	  TRANSFORM_MODE: 0,

	  /**
	   * Default Garbage Collection mode.
	   *
	   * @static
	   * @memberof PIXI.settings
	   * @type {PIXI.GC_MODES}
	   * @default PIXI.GC_MODES.AUTO
	   */
	  GC_MODE: 0,

	  /**
	   * Default Garbage Collection max idle.
	   *
	   * @static
	   * @memberof PIXI.settings
	   * @type {number}
	   * @default 3600
	   */
	  GC_MAX_IDLE: 60 * 60,

	  /**
	   * Default Garbage Collection maximum check count.
	   *
	   * @static
	   * @memberof PIXI.settings
	   * @type {number}
	   * @default 600
	   */
	  GC_MAX_CHECK_COUNT: 60 * 10,

	  /**
	   * Default wrap modes that are supported by pixi.
	   *
	   * @static
	   * @memberof PIXI.settings
	   * @type {PIXI.WRAP_MODES}
	   * @default PIXI.WRAP_MODES.CLAMP
	   */
	  WRAP_MODE: 0,

	  /**
	   * The scale modes that are supported by pixi.
	   *
	   * @static
	   * @memberof PIXI.settings
	   * @type {PIXI.SCALE_MODES}
	   * @default PIXI.SCALE_MODES.LINEAR
	   */
	  SCALE_MODE: 0,

	  /**
	   * Default specify float precision in vertex shader.
	   *
	   * @static
	   * @memberof PIXI.settings
	   * @type {PIXI.PRECISION}
	   * @default PIXI.PRECISION.HIGH
	   */
	  PRECISION_VERTEX: 'highp',

	  /**
	   * Default specify float precision in fragment shader.
	   *
	   * @static
	   * @memberof PIXI.settings
	   * @type {PIXI.PRECISION}
	   * @default PIXI.PRECISION.MEDIUM
	   */
	  PRECISION_FRAGMENT: 'mediump',

	  /**
	   * Can we upload the same buffer in a single frame?
	   *
	   * @static
	   * @constant
	   * @memberof PIXI.settings
	   * @type {boolean}
	   */
	  CAN_UPLOAD_SAME_BUFFER: (0, _canUploadSameBuffer2.default)(),

	  /**
	   * Default Mesh `canvasPadding`.
	   *
	   * @see PIXI.mesh.Mesh#canvasPadding
	   * @static
	   * @constant
	   * @memberof PIXI.settings
	   * @type {number}
	   */
	  MESH_CANVAS_PADDING: 0
	};
	//# sourceMappingURL=settings.js.map

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;
	exports.default = maxRecommendedTextures;

	var _ismobilejs = __webpack_require__(207);

	var _ismobilejs2 = _interopRequireDefault(_ismobilejs);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function maxRecommendedTextures(max) {
	    if (_ismobilejs2.default.tablet || _ismobilejs2.default.phone) {
	        // check if the res is iphone 6 or higher..
	        return 4;
	    }

	    // desktop should be ok
	    return max;
	}
	//# sourceMappingURL=maxRecommendedTextures.js.map

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * isMobile.js v0.4.1
	 *
	 * A simple library to detect Apple phones and tablets,
	 * Android phones and tablets, other mobile devices (like blackberry, mini-opera and windows phone),
	 * and any kind of seven inch device, via user agent sniffing.
	 *
	 * @author: Kai Mallea (kmallea@gmail.com)
	 *
	 * @license: http://creativecommons.org/publicdomain/zero/1.0/
	 */
	(function (global) {

	    var apple_phone         = /iPhone/i,
	        apple_ipod          = /iPod/i,
	        apple_tablet        = /iPad/i,
	        android_phone       = /(?=.*\bAndroid\b)(?=.*\bMobile\b)/i, // Match 'Android' AND 'Mobile'
	        android_tablet      = /Android/i,
	        amazon_phone        = /(?=.*\bAndroid\b)(?=.*\bSD4930UR\b)/i,
	        amazon_tablet       = /(?=.*\bAndroid\b)(?=.*\b(?:KFOT|KFTT|KFJWI|KFJWA|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|KFARWI|KFASWI|KFSAWI|KFSAWA)\b)/i,
	        windows_phone       = /Windows Phone/i,
	        windows_tablet      = /(?=.*\bWindows\b)(?=.*\bARM\b)/i, // Match 'Windows' AND 'ARM'
	        other_blackberry    = /BlackBerry/i,
	        other_blackberry_10 = /BB10/i,
	        other_opera         = /Opera Mini/i,
	        other_chrome        = /(CriOS|Chrome)(?=.*\bMobile\b)/i,
	        other_firefox       = /(?=.*\bFirefox\b)(?=.*\bMobile\b)/i, // Match 'Firefox' AND 'Mobile'
	        seven_inch = new RegExp(
	            '(?:' +         // Non-capturing group

	            'Nexus 7' +     // Nexus 7

	            '|' +           // OR

	            'BNTV250' +     // B&N Nook Tablet 7 inch

	            '|' +           // OR

	            'Kindle Fire' + // Kindle Fire

	            '|' +           // OR

	            'Silk' +        // Kindle Fire, Silk Accelerated

	            '|' +           // OR

	            'GT-P1000' +    // Galaxy Tab 7 inch

	            ')',            // End non-capturing group

	            'i');           // Case-insensitive matching

	    var match = function(regex, userAgent) {
	        return regex.test(userAgent);
	    };

	    var IsMobileClass = function(userAgent) {
	        var ua = userAgent || navigator.userAgent;

	        // Facebook mobile app's integrated browser adds a bunch of strings that
	        // match everything. Strip it out if it exists.
	        var tmp = ua.split('[FBAN');
	        if (typeof tmp[1] !== 'undefined') {
	            ua = tmp[0];
	        }

	        // Twitter mobile app's integrated browser on iPad adds a "Twitter for
	        // iPhone" string. Same probable happens on other tablet platforms.
	        // This will confuse detection so strip it out if it exists.
	        tmp = ua.split('Twitter');
	        if (typeof tmp[1] !== 'undefined') {
	            ua = tmp[0];
	        }

	        this.apple = {
	            phone:  match(apple_phone, ua),
	            ipod:   match(apple_ipod, ua),
	            tablet: !match(apple_phone, ua) && match(apple_tablet, ua),
	            device: match(apple_phone, ua) || match(apple_ipod, ua) || match(apple_tablet, ua)
	        };
	        this.amazon = {
	            phone:  match(amazon_phone, ua),
	            tablet: !match(amazon_phone, ua) && match(amazon_tablet, ua),
	            device: match(amazon_phone, ua) || match(amazon_tablet, ua)
	        };
	        this.android = {
	            phone:  match(amazon_phone, ua) || match(android_phone, ua),
	            tablet: !match(amazon_phone, ua) && !match(android_phone, ua) && (match(amazon_tablet, ua) || match(android_tablet, ua)),
	            device: match(amazon_phone, ua) || match(amazon_tablet, ua) || match(android_phone, ua) || match(android_tablet, ua)
	        };
	        this.windows = {
	            phone:  match(windows_phone, ua),
	            tablet: match(windows_tablet, ua),
	            device: match(windows_phone, ua) || match(windows_tablet, ua)
	        };
	        this.other = {
	            blackberry:   match(other_blackberry, ua),
	            blackberry10: match(other_blackberry_10, ua),
	            opera:        match(other_opera, ua),
	            firefox:      match(other_firefox, ua),
	            chrome:       match(other_chrome, ua),
	            device:       match(other_blackberry, ua) || match(other_blackberry_10, ua) || match(other_opera, ua) || match(other_firefox, ua) || match(other_chrome, ua)
	        };
	        this.seven_inch = match(seven_inch, ua);
	        this.any = this.apple.device || this.android.device || this.windows.device || this.other.device || this.seven_inch;

	        // excludes 'other' devices and ipods, targeting touchscreen phones
	        this.phone = this.apple.phone || this.android.phone || this.windows.phone;

	        // excludes 7 inch devices, classifying as phone or tablet is left to the user
	        this.tablet = this.apple.tablet || this.android.tablet || this.windows.tablet;

	        if (typeof window === 'undefined') {
	            return this;
	        }
	    };

	    var instantiate = function() {
	        var IM = new IsMobileClass();
	        IM.Class = IsMobileClass;
	        return IM;
	    };

	    if (typeof module !== 'undefined' && module.exports && typeof window === 'undefined') {
	        //node
	        module.exports = IsMobileClass;
	    } else if (typeof module !== 'undefined' && module.exports && typeof window !== 'undefined') {
	        //browserify
	        module.exports = instantiate();
	    } else if (true) {
	        //AMD
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (global.isMobile = instantiate()), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else {
	        global.isMobile = instantiate();
	    }

	})(this);


/***/ }),
/* 208 */
/***/ (function(module, exports) {

	"use strict";

	exports.__esModule = true;
	exports.default = canUploadSameBuffer;
	function canUploadSameBuffer() {
		// Uploading the same buffer multiple times in a single frame can cause perf issues.
		// Apparent on IOS so only check for that at the moment
		// this check may become more complex if this issue pops up elsewhere.
		var ios = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

		return !ios;
	}
	//# sourceMappingURL=canUploadSameBuffer.js.map

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _math = __webpack_require__(175);

	var _TransformBase2 = __webpack_require__(210);

	var _TransformBase3 = _interopRequireDefault(_TransformBase2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	/**
	 * Transform that takes care about its versions
	 *
	 * @class
	 * @extends PIXI.TransformBase
	 * @memberof PIXI
	 */
	var TransformStatic = function (_TransformBase) {
	    _inherits(TransformStatic, _TransformBase);

	    /**
	     *
	     */
	    function TransformStatic() {
	        _classCallCheck(this, TransformStatic);

	        /**
	        * The coordinate of the object relative to the local coordinates of the parent.
	        *
	        * @member {PIXI.ObservablePoint}
	        */
	        var _this = _possibleConstructorReturn(this, _TransformBase.call(this));

	        _this.position = new _math.ObservablePoint(_this.onChange, _this, 0, 0);

	        /**
	         * The scale factor of the object.
	         *
	         * @member {PIXI.ObservablePoint}
	         */
	        _this.scale = new _math.ObservablePoint(_this.onChange, _this, 1, 1);

	        /**
	         * The pivot point of the displayObject that it rotates around.
	         *
	         * @member {PIXI.ObservablePoint}
	         */
	        _this.pivot = new _math.ObservablePoint(_this.onChange, _this, 0, 0);

	        /**
	         * The skew amount, on the x and y axis.
	         *
	         * @member {PIXI.ObservablePoint}
	         */
	        _this.skew = new _math.ObservablePoint(_this.updateSkew, _this, 0, 0);

	        _this._rotation = 0;

	        _this._cx = 1; // cos rotation + skewY;
	        _this._sx = 0; // sin rotation + skewY;
	        _this._cy = 0; // cos rotation + Math.PI/2 - skewX;
	        _this._sy = 1; // sin rotation + Math.PI/2 - skewX;

	        _this._localID = 0;
	        _this._currentLocalID = 0;
	        return _this;
	    }

	    /**
	     * Called when a value changes.
	     *
	     * @private
	     */


	    TransformStatic.prototype.onChange = function onChange() {
	        this._localID++;
	    };

	    /**
	     * Called when skew or rotation changes
	     *
	     * @private
	     */


	    TransformStatic.prototype.updateSkew = function updateSkew() {
	        this._cx = Math.cos(this._rotation + this.skew._y);
	        this._sx = Math.sin(this._rotation + this.skew._y);
	        this._cy = -Math.sin(this._rotation - this.skew._x); // cos, added PI/2
	        this._sy = Math.cos(this._rotation - this.skew._x); // sin, added PI/2

	        this._localID++;
	    };

	    /**
	     * Updates only local matrix
	     */


	    TransformStatic.prototype.updateLocalTransform = function updateLocalTransform() {
	        var lt = this.localTransform;

	        if (this._localID !== this._currentLocalID) {
	            // get the matrix values of the displayobject based on its transform properties..
	            lt.a = this._cx * this.scale._x;
	            lt.b = this._sx * this.scale._x;
	            lt.c = this._cy * this.scale._y;
	            lt.d = this._sy * this.scale._y;

	            lt.tx = this.position._x - (this.pivot._x * lt.a + this.pivot._y * lt.c);
	            lt.ty = this.position._y - (this.pivot._x * lt.b + this.pivot._y * lt.d);
	            this._currentLocalID = this._localID;

	            // force an update..
	            this._parentID = -1;
	        }
	    };

	    /**
	     * Updates the values of the object and applies the parent's transform.
	     *
	     * @param {PIXI.Transform} parentTransform - The transform of the parent of this object
	     */


	    TransformStatic.prototype.updateTransform = function updateTransform(parentTransform) {
	        var lt = this.localTransform;

	        if (this._localID !== this._currentLocalID) {
	            // get the matrix values of the displayobject based on its transform properties..
	            lt.a = this._cx * this.scale._x;
	            lt.b = this._sx * this.scale._x;
	            lt.c = this._cy * this.scale._y;
	            lt.d = this._sy * this.scale._y;

	            lt.tx = this.position._x - (this.pivot._x * lt.a + this.pivot._y * lt.c);
	            lt.ty = this.position._y - (this.pivot._x * lt.b + this.pivot._y * lt.d);
	            this._currentLocalID = this._localID;

	            // force an update..
	            this._parentID = -1;
	        }

	        if (this._parentID !== parentTransform._worldID) {
	            // concat the parent matrix with the objects transform.
	            var pt = parentTransform.worldTransform;
	            var wt = this.worldTransform;

	            wt.a = lt.a * pt.a + lt.b * pt.c;
	            wt.b = lt.a * pt.b + lt.b * pt.d;
	            wt.c = lt.c * pt.a + lt.d * pt.c;
	            wt.d = lt.c * pt.b + lt.d * pt.d;
	            wt.tx = lt.tx * pt.a + lt.ty * pt.c + pt.tx;
	            wt.ty = lt.tx * pt.b + lt.ty * pt.d + pt.ty;

	            this._parentID = parentTransform._worldID;

	            // update the id of the transform..
	            this._worldID++;
	        }
	    };

	    /**
	     * Decomposes a matrix and sets the transforms properties based on it.
	     *
	     * @param {PIXI.Matrix} matrix - The matrix to decompose
	     */


	    TransformStatic.prototype.setFromMatrix = function setFromMatrix(matrix) {
	        matrix.decompose(this);
	        this._localID++;
	    };

	    /**
	     * The rotation of the object in radians.
	     *
	     * @member {number}
	     */


	    _createClass(TransformStatic, [{
	        key: 'rotation',
	        get: function get() {
	            return this._rotation;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._rotation = value;
	            this.updateSkew();
	        }
	    }]);

	    return TransformStatic;
	}(_TransformBase3.default);

	exports.default = TransformStatic;
	//# sourceMappingURL=TransformStatic.js.map

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _math = __webpack_require__(175);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/**
	 * Generic class to deal with traditional 2D matrix transforms
	 *
	 * @class
	 * @memberof PIXI
	 */
	var TransformBase = function () {
	  /**
	   *
	   */
	  function TransformBase() {
	    _classCallCheck(this, TransformBase);

	    /**
	     * The global matrix transform. It can be swapped temporarily by some functions like getLocalBounds()
	     *
	     * @member {PIXI.Matrix}
	     */
	    this.worldTransform = new _math.Matrix();

	    /**
	     * The local matrix transform
	     *
	     * @member {PIXI.Matrix}
	     */
	    this.localTransform = new _math.Matrix();

	    this._worldID = 0;
	    this._parentID = 0;
	  }

	  /**
	   * TransformBase does not have decomposition, so this function wont do anything
	   */


	  TransformBase.prototype.updateLocalTransform = function updateLocalTransform() {}
	  // empty


	  /**
	   * Updates the values of the object and applies the parent's transform.
	   *
	   * @param {PIXI.TransformBase} parentTransform - The transform of the parent of this object
	   */
	  ;

	  TransformBase.prototype.updateTransform = function updateTransform(parentTransform) {
	    var pt = parentTransform.worldTransform;
	    var wt = this.worldTransform;
	    var lt = this.localTransform;

	    // concat the parent matrix with the objects transform.
	    wt.a = lt.a * pt.a + lt.b * pt.c;
	    wt.b = lt.a * pt.b + lt.b * pt.d;
	    wt.c = lt.c * pt.a + lt.d * pt.c;
	    wt.d = lt.c * pt.b + lt.d * pt.d;
	    wt.tx = lt.tx * pt.a + lt.ty * pt.c + pt.tx;
	    wt.ty = lt.tx * pt.b + lt.ty * pt.d + pt.ty;

	    this._worldID++;
	  };

	  return TransformBase;
	}();

	/**
	 * Updates the values of the object and applies the parent's transform.
	 * @param  parentTransform {PIXI.Transform} The transform of the parent of this object
	 *
	 */


	exports.default = TransformBase;
	TransformBase.prototype.updateWorldTransform = TransformBase.prototype.updateTransform;

	TransformBase.IDENTITY = new TransformBase();
	//# sourceMappingURL=TransformBase.js.map

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _math = __webpack_require__(175);

	var _TransformBase2 = __webpack_require__(210);

	var _TransformBase3 = _interopRequireDefault(_TransformBase2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	/**
	 * Generic class to deal with traditional 2D matrix transforms
	 * local transformation is calculated from position,scale,skew and rotation
	 *
	 * @class
	 * @extends PIXI.TransformBase
	 * @memberof PIXI
	 */
	var Transform = function (_TransformBase) {
	  _inherits(Transform, _TransformBase);

	  /**
	   *
	   */
	  function Transform() {
	    _classCallCheck(this, Transform);

	    /**
	    * The coordinate of the object relative to the local coordinates of the parent.
	    *
	    * @member {PIXI.Point}
	    */
	    var _this = _possibleConstructorReturn(this, _TransformBase.call(this));

	    _this.position = new _math.Point(0, 0);

	    /**
	     * The scale factor of the object.
	     *
	     * @member {PIXI.Point}
	     */
	    _this.scale = new _math.Point(1, 1);

	    /**
	     * The skew amount, on the x and y axis.
	     *
	     * @member {PIXI.ObservablePoint}
	     */
	    _this.skew = new _math.ObservablePoint(_this.updateSkew, _this, 0, 0);

	    /**
	     * The pivot point of the displayObject that it rotates around.
	     *
	     * @member {PIXI.Point}
	     */
	    _this.pivot = new _math.Point(0, 0);

	    /**
	     * The rotation value of the object, in radians
	     *
	     * @member {Number}
	     * @private
	     */
	    _this._rotation = 0;

	    _this._cx = 1; // cos rotation + skewY;
	    _this._sx = 0; // sin rotation + skewY;
	    _this._cy = 0; // cos rotation + Math.PI/2 - skewX;
	    _this._sy = 1; // sin rotation + Math.PI/2 - skewX;
	    return _this;
	  }

	  /**
	   * Updates the skew values when the skew or rotation changes.
	   *
	   * @private
	   */


	  Transform.prototype.updateSkew = function updateSkew() {
	    this._cx = Math.cos(this._rotation + this.skew._y);
	    this._sx = Math.sin(this._rotation + this.skew._y);
	    this._cy = -Math.sin(this._rotation - this.skew._x); // cos, added PI/2
	    this._sy = Math.cos(this._rotation - this.skew._x); // sin, added PI/2
	  };

	  /**
	   * Updates only local matrix
	   */


	  Transform.prototype.updateLocalTransform = function updateLocalTransform() {
	    var lt = this.localTransform;

	    lt.a = this._cx * this.scale.x;
	    lt.b = this._sx * this.scale.x;
	    lt.c = this._cy * this.scale.y;
	    lt.d = this._sy * this.scale.y;

	    lt.tx = this.position.x - (this.pivot.x * lt.a + this.pivot.y * lt.c);
	    lt.ty = this.position.y - (this.pivot.x * lt.b + this.pivot.y * lt.d);
	  };

	  /**
	   * Updates the values of the object and applies the parent's transform.
	   *
	   * @param {PIXI.Transform} parentTransform - The transform of the parent of this object
	   */


	  Transform.prototype.updateTransform = function updateTransform(parentTransform) {
	    var lt = this.localTransform;

	    lt.a = this._cx * this.scale.x;
	    lt.b = this._sx * this.scale.x;
	    lt.c = this._cy * this.scale.y;
	    lt.d = this._sy * this.scale.y;

	    lt.tx = this.position.x - (this.pivot.x * lt.a + this.pivot.y * lt.c);
	    lt.ty = this.position.y - (this.pivot.x * lt.b + this.pivot.y * lt.d);

	    // concat the parent matrix with the objects transform.
	    var pt = parentTransform.worldTransform;
	    var wt = this.worldTransform;

	    wt.a = lt.a * pt.a + lt.b * pt.c;
	    wt.b = lt.a * pt.b + lt.b * pt.d;
	    wt.c = lt.c * pt.a + lt.d * pt.c;
	    wt.d = lt.c * pt.b + lt.d * pt.d;
	    wt.tx = lt.tx * pt.a + lt.ty * pt.c + pt.tx;
	    wt.ty = lt.tx * pt.b + lt.ty * pt.d + pt.ty;

	    this._worldID++;
	  };

	  /**
	   * Decomposes a matrix and sets the transforms properties based on it.
	   *
	   * @param {PIXI.Matrix} matrix - The matrix to decompose
	   */


	  Transform.prototype.setFromMatrix = function setFromMatrix(matrix) {
	    matrix.decompose(this);
	  };

	  /**
	   * The rotation of the object in radians.
	   *
	   * @member {number}
	   */


	  _createClass(Transform, [{
	    key: 'rotation',
	    get: function get() {
	      return this._rotation;
	    },
	    set: function set(value) // eslint-disable-line require-jsdoc
	    {
	      this._rotation = value;
	      this.updateSkew();
	    }
	  }]);

	  return Transform;
	}(_TransformBase3.default);

	exports.default = Transform;
	//# sourceMappingURL=Transform.js.map

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _utils = __webpack_require__(213);

	var _DisplayObject2 = __webpack_require__(203);

	var _DisplayObject3 = _interopRequireDefault(_DisplayObject2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	/**
	 * A Container represents a collection of display objects.
	 * It is the base class of all display objects that act as a container for other objects.
	 *
	 *```js
	 * let container = new PIXI.Container();
	 * container.addChild(sprite);
	 * ```
	 *
	 * @class
	 * @extends PIXI.DisplayObject
	 * @memberof PIXI
	 */
	var Container = function (_DisplayObject) {
	    _inherits(Container, _DisplayObject);

	    /**
	     *
	     */
	    function Container() {
	        _classCallCheck(this, Container);

	        /**
	         * The array of children of this container.
	         *
	         * @member {PIXI.DisplayObject[]}
	         * @readonly
	         */
	        var _this = _possibleConstructorReturn(this, _DisplayObject.call(this));

	        _this.children = [];
	        return _this;
	    }

	    /**
	     * Overridable method that can be used by Container subclasses whenever the children array is modified
	     *
	     * @private
	     */


	    Container.prototype.onChildrenChange = function onChildrenChange() {}
	    /* empty */


	    /**
	     * Adds one or more children to the container.
	     *
	     * Multiple items can be added like so: `myContainer.addChild(thingOne, thingTwo, thingThree)`
	     *
	     * @param {...PIXI.DisplayObject} child - The DisplayObject(s) to add to the container
	     * @return {PIXI.DisplayObject} The first child that was added.
	     */
	    ;

	    Container.prototype.addChild = function addChild(child) {
	        var argumentsLength = arguments.length;

	        // if there is only one argument we can bypass looping through the them
	        if (argumentsLength > 1) {
	            // loop through the arguments property and add all children
	            // use it the right way (.length and [i]) so that this function can still be optimised by JS runtimes
	            for (var i = 0; i < argumentsLength; i++) {
	                this.addChild(arguments[i]);
	            }
	        } else {
	            // if the child has a parent then lets remove it as PixiJS objects can only exist in one place
	            if (child.parent) {
	                child.parent.removeChild(child);
	            }

	            child.parent = this;
	            // ensure child transform will be recalculated
	            child.transform._parentID = -1;

	            this.children.push(child);

	            // ensure bounds will be recalculated
	            this._boundsID++;

	            // TODO - lets either do all callbacks or all events.. not both!
	            this.onChildrenChange(this.children.length - 1);
	            child.emit('added', this);
	        }

	        return child;
	    };

	    /**
	     * Adds a child to the container at a specified index. If the index is out of bounds an error will be thrown
	     *
	     * @param {PIXI.DisplayObject} child - The child to add
	     * @param {number} index - The index to place the child in
	     * @return {PIXI.DisplayObject} The child that was added.
	     */


	    Container.prototype.addChildAt = function addChildAt(child, index) {
	        if (index < 0 || index > this.children.length) {
	            throw new Error(child + 'addChildAt: The index ' + index + ' supplied is out of bounds ' + this.children.length);
	        }

	        if (child.parent) {
	            child.parent.removeChild(child);
	        }

	        child.parent = this;
	        // ensure child transform will be recalculated
	        child.transform._parentID = -1;

	        this.children.splice(index, 0, child);

	        // ensure bounds will be recalculated
	        this._boundsID++;

	        // TODO - lets either do all callbacks or all events.. not both!
	        this.onChildrenChange(index);
	        child.emit('added', this);

	        return child;
	    };

	    /**
	     * Swaps the position of 2 Display Objects within this container.
	     *
	     * @param {PIXI.DisplayObject} child - First display object to swap
	     * @param {PIXI.DisplayObject} child2 - Second display object to swap
	     */


	    Container.prototype.swapChildren = function swapChildren(child, child2) {
	        if (child === child2) {
	            return;
	        }

	        var index1 = this.getChildIndex(child);
	        var index2 = this.getChildIndex(child2);

	        this.children[index1] = child2;
	        this.children[index2] = child;
	        this.onChildrenChange(index1 < index2 ? index1 : index2);
	    };

	    /**
	     * Returns the index position of a child DisplayObject instance
	     *
	     * @param {PIXI.DisplayObject} child - The DisplayObject instance to identify
	     * @return {number} The index position of the child display object to identify
	     */


	    Container.prototype.getChildIndex = function getChildIndex(child) {
	        var index = this.children.indexOf(child);

	        if (index === -1) {
	            throw new Error('The supplied DisplayObject must be a child of the caller');
	        }

	        return index;
	    };

	    /**
	     * Changes the position of an existing child in the display object container
	     *
	     * @param {PIXI.DisplayObject} child - The child DisplayObject instance for which you want to change the index number
	     * @param {number} index - The resulting index number for the child display object
	     */


	    Container.prototype.setChildIndex = function setChildIndex(child, index) {
	        if (index < 0 || index >= this.children.length) {
	            throw new Error('The index ' + index + ' supplied is out of bounds ' + this.children.length);
	        }

	        var currentIndex = this.getChildIndex(child);

	        (0, _utils.removeItems)(this.children, currentIndex, 1); // remove from old position
	        this.children.splice(index, 0, child); // add at new position

	        this.onChildrenChange(index);
	    };

	    /**
	     * Returns the child at the specified index
	     *
	     * @param {number} index - The index to get the child at
	     * @return {PIXI.DisplayObject} The child at the given index, if any.
	     */


	    Container.prototype.getChildAt = function getChildAt(index) {
	        if (index < 0 || index >= this.children.length) {
	            throw new Error('getChildAt: Index (' + index + ') does not exist.');
	        }

	        return this.children[index];
	    };

	    /**
	     * Removes one or more children from the container.
	     *
	     * @param {...PIXI.DisplayObject} child - The DisplayObject(s) to remove
	     * @return {PIXI.DisplayObject} The first child that was removed.
	     */


	    Container.prototype.removeChild = function removeChild(child) {
	        var argumentsLength = arguments.length;

	        // if there is only one argument we can bypass looping through the them
	        if (argumentsLength > 1) {
	            // loop through the arguments property and add all children
	            // use it the right way (.length and [i]) so that this function can still be optimised by JS runtimes
	            for (var i = 0; i < argumentsLength; i++) {
	                this.removeChild(arguments[i]);
	            }
	        } else {
	            var index = this.children.indexOf(child);

	            if (index === -1) return null;

	            child.parent = null;
	            // ensure child transform will be recalculated
	            child.transform._parentID = -1;
	            (0, _utils.removeItems)(this.children, index, 1);

	            // ensure bounds will be recalculated
	            this._boundsID++;

	            // TODO - lets either do all callbacks or all events.. not both!
	            this.onChildrenChange(index);
	            child.emit('removed', this);
	        }

	        return child;
	    };

	    /**
	     * Removes a child from the specified index position.
	     *
	     * @param {number} index - The index to get the child from
	     * @return {PIXI.DisplayObject} The child that was removed.
	     */


	    Container.prototype.removeChildAt = function removeChildAt(index) {
	        var child = this.getChildAt(index);

	        // ensure child transform will be recalculated..
	        child.parent = null;
	        child.transform._parentID = -1;
	        (0, _utils.removeItems)(this.children, index, 1);

	        // ensure bounds will be recalculated
	        this._boundsID++;

	        // TODO - lets either do all callbacks or all events.. not both!
	        this.onChildrenChange(index);
	        child.emit('removed', this);

	        return child;
	    };

	    /**
	     * Removes all children from this container that are within the begin and end indexes.
	     *
	     * @param {number} [beginIndex=0] - The beginning position.
	     * @param {number} [endIndex=this.children.length] - The ending position. Default value is size of the container.
	     * @returns {DisplayObject[]} List of removed children
	     */


	    Container.prototype.removeChildren = function removeChildren() {
	        var beginIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	        var endIndex = arguments[1];

	        var begin = beginIndex;
	        var end = typeof endIndex === 'number' ? endIndex : this.children.length;
	        var range = end - begin;
	        var removed = void 0;

	        if (range > 0 && range <= end) {
	            removed = this.children.splice(begin, range);

	            for (var i = 0; i < removed.length; ++i) {
	                removed[i].parent = null;
	                if (removed[i].transform) {
	                    removed[i].transform._parentID = -1;
	                }
	            }

	            this._boundsID++;

	            this.onChildrenChange(beginIndex);

	            for (var _i = 0; _i < removed.length; ++_i) {
	                removed[_i].emit('removed', this);
	            }

	            return removed;
	        } else if (range === 0 && this.children.length === 0) {
	            return [];
	        }

	        throw new RangeError('removeChildren: numeric values are outside the acceptable range.');
	    };

	    /**
	     * Updates the transform on all children of this container for rendering
	     */


	    Container.prototype.updateTransform = function updateTransform() {
	        this._boundsID++;

	        this.transform.updateTransform(this.parent.transform);

	        // TODO: check render flags, how to process stuff here
	        this.worldAlpha = this.alpha * this.parent.worldAlpha;

	        for (var i = 0, j = this.children.length; i < j; ++i) {
	            var child = this.children[i];

	            if (child.visible) {
	                child.updateTransform();
	            }
	        }
	    };

	    /**
	     * Recalculates the bounds of the container.
	     *
	     */


	    Container.prototype.calculateBounds = function calculateBounds() {
	        this._bounds.clear();

	        this._calculateBounds();

	        for (var i = 0; i < this.children.length; i++) {
	            var child = this.children[i];

	            if (!child.visible || !child.renderable) {
	                continue;
	            }

	            child.calculateBounds();

	            // TODO: filter+mask, need to mask both somehow
	            if (child._mask) {
	                child._mask.calculateBounds();
	                this._bounds.addBoundsMask(child._bounds, child._mask._bounds);
	            } else if (child.filterArea) {
	                this._bounds.addBoundsArea(child._bounds, child.filterArea);
	            } else {
	                this._bounds.addBounds(child._bounds);
	            }
	        }

	        this._lastBoundsID = this._boundsID;
	    };

	    /**
	     * Recalculates the bounds of the object. Override this to
	     * calculate the bounds of the specific object (not including children).
	     *
	     */


	    Container.prototype._calculateBounds = function _calculateBounds() {}
	    // FILL IN//


	    /**
	     * Renders the object using the WebGL renderer
	     *
	     * @param {PIXI.WebGLRenderer} renderer - The renderer
	     */
	    ;

	    Container.prototype.renderWebGL = function renderWebGL(renderer) {
	        // if the object is not visible or the alpha is 0 then no need to render this element
	        if (!this.visible || this.worldAlpha <= 0 || !this.renderable) {
	            return;
	        }

	        // do a quick check to see if this element has a mask or a filter.
	        if (this._mask || this._filters) {
	            this.renderAdvancedWebGL(renderer);
	        } else {
	            this._renderWebGL(renderer);

	            // simple render children!
	            for (var i = 0, j = this.children.length; i < j; ++i) {
	                this.children[i].renderWebGL(renderer);
	            }
	        }
	    };

	    /**
	     * Render the object using the WebGL renderer and advanced features.
	     *
	     * @private
	     * @param {PIXI.WebGLRenderer} renderer - The renderer
	     */


	    Container.prototype.renderAdvancedWebGL = function renderAdvancedWebGL(renderer) {
	        renderer.flush();

	        var filters = this._filters;
	        var mask = this._mask;

	        // push filter first as we need to ensure the stencil buffer is correct for any masking
	        if (filters) {
	            if (!this._enabledFilters) {
	                this._enabledFilters = [];
	            }

	            this._enabledFilters.length = 0;

	            for (var i = 0; i < filters.length; i++) {
	                if (filters[i].enabled) {
	                    this._enabledFilters.push(filters[i]);
	                }
	            }

	            if (this._enabledFilters.length) {
	                renderer.filterManager.pushFilter(this, this._enabledFilters);
	            }
	        }

	        if (mask) {
	            renderer.maskManager.pushMask(this, this._mask);
	        }

	        // add this object to the batch, only rendered if it has a texture.
	        this._renderWebGL(renderer);

	        // now loop through the children and make sure they get rendered
	        for (var _i2 = 0, j = this.children.length; _i2 < j; _i2++) {
	            this.children[_i2].renderWebGL(renderer);
	        }

	        renderer.flush();

	        if (mask) {
	            renderer.maskManager.popMask(this, this._mask);
	        }

	        if (filters && this._enabledFilters && this._enabledFilters.length) {
	            renderer.filterManager.popFilter();
	        }
	    };

	    /**
	     * To be overridden by the subclasses.
	     *
	     * @private
	     * @param {PIXI.WebGLRenderer} renderer - The renderer
	     */


	    Container.prototype._renderWebGL = function _renderWebGL(renderer) // eslint-disable-line no-unused-vars
	    {}
	    // this is where content itself gets rendered...


	    /**
	     * To be overridden by the subclass
	     *
	     * @private
	     * @param {PIXI.CanvasRenderer} renderer - The renderer
	     */
	    ;

	    Container.prototype._renderCanvas = function _renderCanvas(renderer) // eslint-disable-line no-unused-vars
	    {}
	    // this is where content itself gets rendered...


	    /**
	     * Renders the object using the Canvas renderer
	     *
	     * @param {PIXI.CanvasRenderer} renderer - The renderer
	     */
	    ;

	    Container.prototype.renderCanvas = function renderCanvas(renderer) {
	        // if not visible or the alpha is 0 then no need to render this
	        if (!this.visible || this.worldAlpha <= 0 || !this.renderable) {
	            return;
	        }

	        if (this._mask) {
	            renderer.maskManager.pushMask(this._mask);
	        }

	        this._renderCanvas(renderer);
	        for (var i = 0, j = this.children.length; i < j; ++i) {
	            this.children[i].renderCanvas(renderer);
	        }

	        if (this._mask) {
	            renderer.maskManager.popMask(renderer);
	        }
	    };

	    /**
	     * Removes all internal references and listeners as well as removes children from the display list.
	     * Do not use a Container after calling `destroy`.
	     *
	     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
	     *  have been set to that value
	     * @param {boolean} [options.children=false] - if set to true, all the children will have their destroy
	     *  method called as well. 'options' will be passed on to those calls.
	     * @param {boolean} [options.texture=false] - Only used for child Sprites if options.children is set to true
	     *  Should it destroy the texture of the child sprite
	     * @param {boolean} [options.baseTexture=false] - Only used for child Sprites if options.children is set to true
	     *  Should it destroy the base texture of the child sprite
	     */


	    Container.prototype.destroy = function destroy(options) {
	        _DisplayObject.prototype.destroy.call(this);

	        var destroyChildren = typeof options === 'boolean' ? options : options && options.children;

	        var oldChildren = this.removeChildren(0, this.children.length);

	        if (destroyChildren) {
	            for (var i = 0; i < oldChildren.length; ++i) {
	                oldChildren[i].destroy(options);
	            }
	        }
	    };

	    /**
	     * The width of the Container, setting this will actually modify the scale to achieve the value set
	     *
	     * @member {number}
	     */


	    _createClass(Container, [{
	        key: 'width',
	        get: function get() {
	            return this.scale.x * this.getLocalBounds().width;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            var width = this.getLocalBounds().width;

	            if (width !== 0) {
	                this.scale.x = value / width;
	            } else {
	                this.scale.x = 1;
	            }

	            this._width = value;
	        }

	        /**
	         * The height of the Container, setting this will actually modify the scale to achieve the value set
	         *
	         * @member {number}
	         */

	    }, {
	        key: 'height',
	        get: function get() {
	            return this.scale.y * this.getLocalBounds().height;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            var height = this.getLocalBounds().height;

	            if (height !== 0) {
	                this.scale.y = value / height;
	            } else {
	                this.scale.y = 1;
	            }

	            this._height = value;
	        }
	    }]);

	    return Container;
	}(_DisplayObject3.default);

	// performance increase to avoid using call.. (10x faster)


	exports.default = Container;
	Container.prototype.containerUpdateTransform = Container.prototype.updateTransform;
	//# sourceMappingURL=Container.js.map

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;
	exports.premultiplyBlendMode = exports.BaseTextureCache = exports.TextureCache = exports.earcut = exports.mixins = exports.pluginTarget = exports.EventEmitter = exports.removeItems = exports.isMobile = undefined;
	exports.uid = uid;
	exports.hex2rgb = hex2rgb;
	exports.hex2string = hex2string;
	exports.rgb2hex = rgb2hex;
	exports.getResolutionOfUrl = getResolutionOfUrl;
	exports.decomposeDataUri = decomposeDataUri;
	exports.getUrlFileExtension = getUrlFileExtension;
	exports.getSvgSize = getSvgSize;
	exports.skipHello = skipHello;
	exports.sayHello = sayHello;
	exports.isWebGLSupported = isWebGLSupported;
	exports.sign = sign;
	exports.destroyTextureCache = destroyTextureCache;
	exports.clearTextureCache = clearTextureCache;
	exports.correctBlendMode = correctBlendMode;
	exports.premultiplyTint = premultiplyTint;
	exports.premultiplyRgba = premultiplyRgba;
	exports.premultiplyTintToRgba = premultiplyTintToRgba;

	var _const = __webpack_require__(174);

	var _settings = __webpack_require__(205);

	var _settings2 = _interopRequireDefault(_settings);

	var _eventemitter = __webpack_require__(204);

	var _eventemitter2 = _interopRequireDefault(_eventemitter);

	var _pluginTarget = __webpack_require__(214);

	var _pluginTarget2 = _interopRequireDefault(_pluginTarget);

	var _mixin = __webpack_require__(215);

	var mixins = _interopRequireWildcard(_mixin);

	var _ismobilejs = __webpack_require__(207);

	var isMobile = _interopRequireWildcard(_ismobilejs);

	var _removeArrayItems = __webpack_require__(216);

	var _removeArrayItems2 = _interopRequireDefault(_removeArrayItems);

	var _mapPremultipliedBlendModes = __webpack_require__(217);

	var _mapPremultipliedBlendModes2 = _interopRequireDefault(_mapPremultipliedBlendModes);

	var _earcut = __webpack_require__(218);

	var _earcut2 = _interopRequireDefault(_earcut);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var nextUid = 0;
	var saidHello = false;

	/**
	 * Generalized convenience utilities for PIXI.
	 * @example
	 * // Extend PIXI's internal Event Emitter.
	 * class MyEmitter extends PIXI.utils.EventEmitter {
	 *   constructor() {
	 *      super();
	 *      console.log("Emitter created!");
	 *   }
	 * }
	 *
	 * // Get info on current device
	 * console.log(PIXI.utils.isMobile);
	 *
	 * // Convert hex color to string
	 * console.log(PIXI.utils.hex2string(0xff00ff)); // returns: "#ff00ff"
	 * @namespace PIXI.utils
	 */
	exports.isMobile = isMobile;
	exports.removeItems = _removeArrayItems2.default;
	exports.EventEmitter = _eventemitter2.default;
	exports.pluginTarget = _pluginTarget2.default;
	exports.mixins = mixins;
	exports.earcut = _earcut2.default;

	/**
	 * Gets the next unique identifier
	 *
	 * @memberof PIXI.utils
	 * @function uid
	 * @return {number} The next unique identifier to use.
	 */

	function uid() {
	    return ++nextUid;
	}

	/**
	 * Converts a hex color number to an [R, G, B] array
	 *
	 * @memberof PIXI.utils
	 * @function hex2rgb
	 * @param {number} hex - The number to convert
	 * @param  {number[]} [out=[]] If supplied, this array will be used rather than returning a new one
	 * @return {number[]} An array representing the [R, G, B] of the color.
	 */
	function hex2rgb(hex, out) {
	    out = out || [];

	    out[0] = (hex >> 16 & 0xFF) / 255;
	    out[1] = (hex >> 8 & 0xFF) / 255;
	    out[2] = (hex & 0xFF) / 255;

	    return out;
	}

	/**
	 * Converts a hex color number to a string.
	 *
	 * @memberof PIXI.utils
	 * @function hex2string
	 * @param {number} hex - Number in hex
	 * @return {string} The string color.
	 */
	function hex2string(hex) {
	    hex = hex.toString(16);
	    hex = '000000'.substr(0, 6 - hex.length) + hex;

	    return '#' + hex;
	}

	/**
	 * Converts a color as an [R, G, B] array to a hex number
	 *
	 * @memberof PIXI.utils
	 * @function rgb2hex
	 * @param {number[]} rgb - rgb array
	 * @return {number} The color number
	 */
	function rgb2hex(rgb) {
	    return (rgb[0] * 255 << 16) + (rgb[1] * 255 << 8) + (rgb[2] * 255 | 0);
	}

	/**
	 * get the resolution / device pixel ratio of an asset by looking for the prefix
	 * used by spritesheets and image urls
	 *
	 * @memberof PIXI.utils
	 * @function getResolutionOfUrl
	 * @param {string} url - the image path
	 * @param {number} [defaultValue=1] - the defaultValue if no filename prefix is set.
	 * @return {number} resolution / device pixel ratio of an asset
	 */
	function getResolutionOfUrl(url, defaultValue) {
	    var resolution = _settings2.default.RETINA_PREFIX.exec(url);

	    if (resolution) {
	        return parseFloat(resolution[1]);
	    }

	    return defaultValue !== undefined ? defaultValue : 1;
	}

	/**
	 * Typedef for decomposeDataUri return object.
	 *
	 * @typedef {object} PIXI.utils~DecomposedDataUri
	 * @property {mediaType} Media type, eg. `image`
	 * @property {subType} Sub type, eg. `png`
	 * @property {encoding} Data encoding, eg. `base64`
	 * @property {data} The actual data
	 */

	/**
	 * Split a data URI into components. Returns undefined if
	 * parameter `dataUri` is not a valid data URI.
	 *
	 * @memberof PIXI.utils
	 * @function decomposeDataUri
	 * @param {string} dataUri - the data URI to check
	 * @return {PIXI.utils~DecomposedDataUri|undefined} The decomposed data uri or undefined
	 */
	function decomposeDataUri(dataUri) {
	    var dataUriMatch = _const.DATA_URI.exec(dataUri);

	    if (dataUriMatch) {
	        return {
	            mediaType: dataUriMatch[1] ? dataUriMatch[1].toLowerCase() : undefined,
	            subType: dataUriMatch[2] ? dataUriMatch[2].toLowerCase() : undefined,
	            charset: dataUriMatch[3] ? dataUriMatch[3].toLowerCase() : undefined,
	            encoding: dataUriMatch[4] ? dataUriMatch[4].toLowerCase() : undefined,
	            data: dataUriMatch[5]
	        };
	    }

	    return undefined;
	}

	/**
	 * Get type of the image by regexp for extension. Returns undefined for unknown extensions.
	 *
	 * @memberof PIXI.utils
	 * @function getUrlFileExtension
	 * @param {string} url - the image path
	 * @return {string|undefined} image extension
	 */
	function getUrlFileExtension(url) {
	    var extension = _const.URL_FILE_EXTENSION.exec(url);

	    if (extension) {
	        return extension[1].toLowerCase();
	    }

	    return undefined;
	}

	/**
	 * Typedef for Size object.
	 *
	 * @typedef {object} PIXI.utils~Size
	 * @property {width} Width component
	 * @property {height} Height component
	 */

	/**
	 * Get size from an svg string using regexp.
	 *
	 * @memberof PIXI.utils
	 * @function getSvgSize
	 * @param {string} svgString - a serialized svg element
	 * @return {PIXI.utils~Size|undefined} image extension
	 */
	function getSvgSize(svgString) {
	    var sizeMatch = _const.SVG_SIZE.exec(svgString);
	    var size = {};

	    if (sizeMatch) {
	        size[sizeMatch[1]] = Math.round(parseFloat(sizeMatch[3]));
	        size[sizeMatch[5]] = Math.round(parseFloat(sizeMatch[7]));
	    }

	    return size;
	}

	/**
	 * Skips the hello message of renderers that are created after this is run.
	 *
	 * @function skipHello
	 * @memberof PIXI.utils
	 */
	function skipHello() {
	    saidHello = true;
	}

	/**
	 * Logs out the version and renderer information for this running instance of PIXI.
	 * If you don't want to see this message you can run `PIXI.utils.skipHello()` before
	 * creating your renderer. Keep in mind that doing that will forever makes you a jerk face.
	 *
	 * @static
	 * @function sayHello
	 * @memberof PIXI.utils
	 * @param {string} type - The string renderer type to log.
	 */
	function sayHello(type) {
	    if (saidHello) {
	        return;
	    }

	    if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
	        var args = ['\n %c %c %c PixiJS ' + _const.VERSION + ' - \u2730 ' + type + ' \u2730  %c  %c  http://www.pixijs.com/  %c %c \u2665%c\u2665%c\u2665 \n\n', 'background: #ff66a5; padding:5px 0;', 'background: #ff66a5; padding:5px 0;', 'color: #ff66a5; background: #030307; padding:5px 0;', 'background: #ff66a5; padding:5px 0;', 'background: #ffc3dc; padding:5px 0;', 'background: #ff66a5; padding:5px 0;', 'color: #ff2424; background: #fff; padding:5px 0;', 'color: #ff2424; background: #fff; padding:5px 0;', 'color: #ff2424; background: #fff; padding:5px 0;'];

	        window.console.log.apply(console, args);
	    } else if (window.console) {
	        window.console.log('PixiJS ' + _const.VERSION + ' - ' + type + ' - http://www.pixijs.com/');
	    }

	    saidHello = true;
	}

	/**
	 * Helper for checking for webgl support
	 *
	 * @memberof PIXI.utils
	 * @function isWebGLSupported
	 * @return {boolean} is webgl supported
	 */
	function isWebGLSupported() {
	    var contextOptions = { stencil: true, failIfMajorPerformanceCaveat: true };

	    try {
	        if (!window.WebGLRenderingContext) {
	            return false;
	        }

	        var canvas = document.createElement('canvas');
	        var gl = canvas.getContext('webgl', contextOptions) || canvas.getContext('experimental-webgl', contextOptions);

	        var success = !!(gl && gl.getContextAttributes().stencil);

	        if (gl) {
	            var loseContext = gl.getExtension('WEBGL_lose_context');

	            if (loseContext) {
	                loseContext.loseContext();
	            }
	        }

	        gl = null;

	        return success;
	    } catch (e) {
	        return false;
	    }
	}

	/**
	 * Returns sign of number
	 *
	 * @memberof PIXI.utils
	 * @function sign
	 * @param {number} n - the number to check the sign of
	 * @returns {number} 0 if `n` is 0, -1 if `n` is negative, 1 if `n` is positive
	 */
	function sign(n) {
	    if (n === 0) return 0;

	    return n < 0 ? -1 : 1;
	}

	/**
	 * @todo Describe property usage
	 *
	 * @memberof PIXI.utils
	 * @private
	 */
	var TextureCache = exports.TextureCache = Object.create(null);

	/**
	 * @todo Describe property usage
	 *
	 * @memberof PIXI.utils
	 * @private
	 */
	var BaseTextureCache = exports.BaseTextureCache = Object.create(null);

	/**
	 * Destroys all texture in the cache
	 *
	 * @memberof PIXI.utils
	 * @function destroyTextureCache
	 */
	function destroyTextureCache() {
	    var key = void 0;

	    for (key in TextureCache) {
	        TextureCache[key].destroy();
	    }
	    for (key in BaseTextureCache) {
	        BaseTextureCache[key].destroy();
	    }
	}

	/**
	 * Removes all textures from cache, but does not destroy them
	 *
	 * @memberof PIXI.utils
	 * @function clearTextureCache
	 */
	function clearTextureCache() {
	    var key = void 0;

	    for (key in TextureCache) {
	        delete TextureCache[key];
	    }
	    for (key in BaseTextureCache) {
	        delete BaseTextureCache[key];
	    }
	}

	/**
	 * maps premultiply flag and blendMode to adjusted blendMode
	 * @memberof PIXI.utils
	 * @const premultiplyBlendMode
	 * @type {Array<number[]>}
	 */
	var premultiplyBlendMode = exports.premultiplyBlendMode = (0, _mapPremultipliedBlendModes2.default)();

	/**
	 * changes blendMode according to texture format
	 *
	 * @memberof PIXI.utils
	 * @function correctBlendMode
	 * @param {number} blendMode supposed blend mode
	 * @param {boolean} premultiplied  whether source is premultiplied
	 * @returns {number} true blend mode for this texture
	 */
	function correctBlendMode(blendMode, premultiplied) {
	    return premultiplyBlendMode[premultiplied ? 1 : 0][blendMode];
	}

	/**
	 * premultiplies tint
	 *
	 * @memberof PIXI.utils
	 * @param {number} tint integet RGB
	 * @param {number} alpha floating point alpha (0.0-1.0)
	 * @returns {number} tint multiplied by alpha
	 */
	function premultiplyTint(tint, alpha) {
	    if (alpha === 1.0) {
	        return (alpha * 255 << 24) + tint;
	    }
	    if (alpha === 0.0) {
	        return 0;
	    }
	    var R = tint >> 16 & 0xFF;
	    var G = tint >> 8 & 0xFF;
	    var B = tint & 0xFF;

	    R = R * alpha + 0.5 | 0;
	    G = G * alpha + 0.5 | 0;
	    B = B * alpha + 0.5 | 0;

	    return (alpha * 255 << 24) + (R << 16) + (G << 8) + B;
	}

	/**
	 * combines rgb and alpha to out array
	 *
	 * @memberof PIXI.utils
	 * @param {Float32Array|number[]} rgb input rgb
	 * @param {number} alpha alpha param
	 * @param {Float32Array} [out] output
	 * @param {boolean} [premultiply=true] do premultiply it
	 * @returns {Float32Array} vec4 rgba
	 */
	function premultiplyRgba(rgb, alpha, out, premultiply) {
	    out = out || new Float32Array(4);
	    if (premultiply || premultiply === undefined) {
	        out[0] = rgb[0] * alpha;
	        out[1] = rgb[1] * alpha;
	        out[2] = rgb[2] * alpha;
	    } else {
	        out[0] = rgb[0];
	        out[1] = rgb[1];
	        out[2] = rgb[2];
	    }
	    out[3] = alpha;

	    return out;
	}

	/**
	 * converts integer tint and float alpha to vec4 form, premultiplies by default
	 *
	 * @memberof PIXI.utils
	 * @param {number} tint input tint
	 * @param {number} alpha alpha param
	 * @param {Float32Array} [out] output
	 * @param {boolean} [premultiply=true] do premultiply it
	 * @returns {Float32Array} vec4 rgba
	 */
	function premultiplyTintToRgba(tint, alpha, out, premultiply) {
	    out = out || new Float32Array(4);
	    out[0] = (tint >> 16 & 0xFF) / 255.0;
	    out[1] = (tint >> 8 & 0xFF) / 255.0;
	    out[2] = (tint & 0xFF) / 255.0;
	    if (premultiply || premultiply === undefined) {
	        out[0] *= alpha;
	        out[1] *= alpha;
	        out[2] *= alpha;
	    }
	    out[3] = alpha;

	    return out;
	}
	//# sourceMappingURL=index.js.map

/***/ }),
/* 214 */
/***/ (function(module, exports) {

	"use strict";

	exports.__esModule = true;
	/**
	 * Mixins functionality to make an object have "plugins".
	 *
	 * @example
	 *      function MyObject() {}
	 *
	 *      pluginTarget.mixin(MyObject);
	 *
	 * @mixin
	 * @memberof PIXI.utils
	 * @param {object} obj - The object to mix into.
	 */
	function pluginTarget(obj) {
	    obj.__plugins = {};

	    /**
	     * Adds a plugin to an object
	     *
	     * @param {string} pluginName - The events that should be listed.
	     * @param {Function} ctor - The constructor function for the plugin.
	     */
	    obj.registerPlugin = function registerPlugin(pluginName, ctor) {
	        obj.__plugins[pluginName] = ctor;
	    };

	    /**
	     * Instantiates all the plugins of this object
	     *
	     */
	    obj.prototype.initPlugins = function initPlugins() {
	        this.plugins = this.plugins || {};

	        for (var o in obj.__plugins) {
	            this.plugins[o] = new obj.__plugins[o](this);
	        }
	    };

	    /**
	     * Removes all the plugins of this object
	     *
	     */
	    obj.prototype.destroyPlugins = function destroyPlugins() {
	        for (var o in this.plugins) {
	            this.plugins[o].destroy();
	            this.plugins[o] = null;
	        }

	        this.plugins = null;
	    };
	}

	exports.default = {
	    /**
	     * Mixes in the properties of the pluginTarget into another object
	     *
	     * @param {object} obj - The obj to mix into
	     */
	    mixin: function mixin(obj) {
	        pluginTarget(obj);
	    }
	};
	//# sourceMappingURL=pluginTarget.js.map

/***/ }),
/* 215 */
/***/ (function(module, exports) {

	"use strict";

	exports.__esModule = true;
	exports.mixin = mixin;
	exports.delayMixin = delayMixin;
	exports.performMixins = performMixins;
	/**
	 * Mixes all enumerable properties and methods from a source object to a target object.
	 *
	 * @memberof PIXI.utils.mixins
	 * @function mixin
	 * @param {object} target The prototype or instance that properties and methods should be added to.
	 * @param {object} source The source of properties and methods to mix in.
	 */
	function mixin(target, source) {
	    if (!target || !source) return;
	    // in ES8/ES2017, this would be really easy:
	    // Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));

	    // get all the enumerable property keys
	    var keys = Object.keys(source);

	    // loop through properties
	    for (var i = 0; i < keys.length; ++i) {
	        var propertyName = keys[i];

	        // Set the property using the property descriptor - this works for accessors and normal value properties
	        Object.defineProperty(target, propertyName, Object.getOwnPropertyDescriptor(source, propertyName));
	    }
	}

	var mixins = [];

	/**
	 * Queues a mixin to be handled towards the end of the initialization of PIXI, so that deprecation
	 * can take effect.
	 *
	 * @memberof PIXI.utils.mixins
	 * @function delayMixin
	 * @private
	 * @param {object} target The prototype or instance that properties and methods should be added to.
	 * @param {object} source The source of properties and methods to mix in.
	 */
	function delayMixin(target, source) {
	    mixins.push(target, source);
	}

	/**
	 * Handles all mixins queued via delayMixin().
	 *
	 * @memberof PIXI.utils.mixins
	 * @function performMixins
	 * @private
	 */
	function performMixins() {
	    for (var i = 0; i < mixins.length; i += 2) {
	        mixin(mixins[i], mixins[i + 1]);
	    }
	    mixins.length = 0;
	}
	//# sourceMappingURL=mixin.js.map

/***/ }),
/* 216 */
/***/ (function(module, exports) {

	'use strict';

	/**
	 * Remove a range of items from an array
	 *
	 * @function removeItems
	 * @param {Array<*>} arr The target array
	 * @param {number} startIdx The index to begin removing from (inclusive)
	 * @param {number} removeCount How many items to remove
	 */
	function removeItems(arr, startIdx, removeCount)
	{
	  var i, length = arr.length;

	  if (startIdx >= length || removeCount === 0) {
	    return
	  }

	  removeCount = (startIdx + removeCount > length ? length - startIdx : removeCount);

	  var len = length - removeCount;

	  for (i = startIdx; i < len; ++i) {
	    arr[i] = arr[i + removeCount];
	  }

	  arr.length = len;
	}

	module.exports = removeItems;


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;
	exports.default = mapPremultipliedBlendModes;

	var _const = __webpack_require__(174);

	/**
	 * Corrects PixiJS blend, takes premultiplied alpha into account
	 *
	 * @memberof PIXI
	 * @function mapPremultipliedBlendModes
	 * @private
	 * @param {Array<number[]>} [array] - The array to output into.
	 * @return {Array<number[]>} Mapped modes.
	 */

	function mapPremultipliedBlendModes() {
	    var pm = [];
	    var npm = [];

	    for (var i = 0; i < 32; i++) {
	        pm[i] = i;
	        npm[i] = i;
	    }

	    pm[_const.BLEND_MODES.NORMAL_NPM] = _const.BLEND_MODES.NORMAL;
	    pm[_const.BLEND_MODES.ADD_NPM] = _const.BLEND_MODES.ADD;
	    pm[_const.BLEND_MODES.SCREEN_NPM] = _const.BLEND_MODES.SCREEN;

	    npm[_const.BLEND_MODES.NORMAL] = _const.BLEND_MODES.NORMAL_NPM;
	    npm[_const.BLEND_MODES.ADD] = _const.BLEND_MODES.ADD_NPM;
	    npm[_const.BLEND_MODES.SCREEN] = _const.BLEND_MODES.SCREEN_NPM;

	    var array = [];

	    array.push(npm);
	    array.push(pm);

	    return array;
	}
	//# sourceMappingURL=mapPremultipliedBlendModes.js.map

/***/ }),
/* 218 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = earcut;
	module.exports.default = earcut;

	function earcut(data, holeIndices, dim) {

	    dim = dim || 2;

	    var hasHoles = holeIndices && holeIndices.length,
	        outerLen = hasHoles ? holeIndices[0] * dim : data.length,
	        outerNode = linkedList(data, 0, outerLen, dim, true),
	        triangles = [];

	    if (!outerNode) return triangles;

	    var minX, minY, maxX, maxY, x, y, invSize;

	    if (hasHoles) outerNode = eliminateHoles(data, holeIndices, outerNode, dim);

	    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
	    if (data.length > 80 * dim) {
	        minX = maxX = data[0];
	        minY = maxY = data[1];

	        for (var i = dim; i < outerLen; i += dim) {
	            x = data[i];
	            y = data[i + 1];
	            if (x < minX) minX = x;
	            if (y < minY) minY = y;
	            if (x > maxX) maxX = x;
	            if (y > maxY) maxY = y;
	        }

	        // minX, minY and invSize are later used to transform coords into integers for z-order calculation
	        invSize = Math.max(maxX - minX, maxY - minY);
	        invSize = invSize !== 0 ? 1 / invSize : 0;
	    }

	    earcutLinked(outerNode, triangles, dim, minX, minY, invSize);

	    return triangles;
	}

	// create a circular doubly linked list from polygon points in the specified winding order
	function linkedList(data, start, end, dim, clockwise) {
	    var i, last;

	    if (clockwise === (signedArea(data, start, end, dim) > 0)) {
	        for (i = start; i < end; i += dim) last = insertNode(i, data[i], data[i + 1], last);
	    } else {
	        for (i = end - dim; i >= start; i -= dim) last = insertNode(i, data[i], data[i + 1], last);
	    }

	    if (last && equals(last, last.next)) {
	        removeNode(last);
	        last = last.next;
	    }

	    return last;
	}

	// eliminate colinear or duplicate points
	function filterPoints(start, end) {
	    if (!start) return start;
	    if (!end) end = start;

	    var p = start,
	        again;
	    do {
	        again = false;

	        if (!p.steiner && (equals(p, p.next) || area(p.prev, p, p.next) === 0)) {
	            removeNode(p);
	            p = end = p.prev;
	            if (p === p.next) break;
	            again = true;

	        } else {
	            p = p.next;
	        }
	    } while (again || p !== end);

	    return end;
	}

	// main ear slicing loop which triangulates a polygon (given as a linked list)
	function earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
	    if (!ear) return;

	    // interlink polygon nodes in z-order
	    if (!pass && invSize) indexCurve(ear, minX, minY, invSize);

	    var stop = ear,
	        prev, next;

	    // iterate through ears, slicing them one by one
	    while (ear.prev !== ear.next) {
	        prev = ear.prev;
	        next = ear.next;

	        if (invSize ? isEarHashed(ear, minX, minY, invSize) : isEar(ear)) {
	            // cut off the triangle
	            triangles.push(prev.i / dim);
	            triangles.push(ear.i / dim);
	            triangles.push(next.i / dim);

	            removeNode(ear);

	            // skipping the next vertice leads to less sliver triangles
	            ear = next.next;
	            stop = next.next;

	            continue;
	        }

	        ear = next;

	        // if we looped through the whole remaining polygon and can't find any more ears
	        if (ear === stop) {
	            // try filtering points and slicing again
	            if (!pass) {
	                earcutLinked(filterPoints(ear), triangles, dim, minX, minY, invSize, 1);

	            // if this didn't work, try curing all small self-intersections locally
	            } else if (pass === 1) {
	                ear = cureLocalIntersections(ear, triangles, dim);
	                earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);

	            // as a last resort, try splitting the remaining polygon into two
	            } else if (pass === 2) {
	                splitEarcut(ear, triangles, dim, minX, minY, invSize);
	            }

	            break;
	        }
	    }
	}

	// check whether a polygon node forms a valid ear with adjacent nodes
	function isEar(ear) {
	    var a = ear.prev,
	        b = ear,
	        c = ear.next;

	    if (area(a, b, c) >= 0) return false; // reflex, can't be an ear

	    // now make sure we don't have other points inside the potential ear
	    var p = ear.next.next;

	    while (p !== ear.prev) {
	        if (pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) &&
	            area(p.prev, p, p.next) >= 0) return false;
	        p = p.next;
	    }

	    return true;
	}

	function isEarHashed(ear, minX, minY, invSize) {
	    var a = ear.prev,
	        b = ear,
	        c = ear.next;

	    if (area(a, b, c) >= 0) return false; // reflex, can't be an ear

	    // triangle bbox; min & max are calculated like this for speed
	    var minTX = a.x < b.x ? (a.x < c.x ? a.x : c.x) : (b.x < c.x ? b.x : c.x),
	        minTY = a.y < b.y ? (a.y < c.y ? a.y : c.y) : (b.y < c.y ? b.y : c.y),
	        maxTX = a.x > b.x ? (a.x > c.x ? a.x : c.x) : (b.x > c.x ? b.x : c.x),
	        maxTY = a.y > b.y ? (a.y > c.y ? a.y : c.y) : (b.y > c.y ? b.y : c.y);

	    // z-order range for the current triangle bbox;
	    var minZ = zOrder(minTX, minTY, minX, minY, invSize),
	        maxZ = zOrder(maxTX, maxTY, minX, minY, invSize);

	    var p = ear.prevZ,
	        n = ear.nextZ;

	    // look for points inside the triangle in both directions
	    while (p && p.z >= minZ && n && n.z <= maxZ) {
	        if (p !== ear.prev && p !== ear.next &&
	            pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) &&
	            area(p.prev, p, p.next) >= 0) return false;
	        p = p.prevZ;

	        if (n !== ear.prev && n !== ear.next &&
	            pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) &&
	            area(n.prev, n, n.next) >= 0) return false;
	        n = n.nextZ;
	    }

	    // look for remaining points in decreasing z-order
	    while (p && p.z >= minZ) {
	        if (p !== ear.prev && p !== ear.next &&
	            pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) &&
	            area(p.prev, p, p.next) >= 0) return false;
	        p = p.prevZ;
	    }

	    // look for remaining points in increasing z-order
	    while (n && n.z <= maxZ) {
	        if (n !== ear.prev && n !== ear.next &&
	            pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) &&
	            area(n.prev, n, n.next) >= 0) return false;
	        n = n.nextZ;
	    }

	    return true;
	}

	// go through all polygon nodes and cure small local self-intersections
	function cureLocalIntersections(start, triangles, dim) {
	    var p = start;
	    do {
	        var a = p.prev,
	            b = p.next.next;

	        if (!equals(a, b) && intersects(a, p, p.next, b) && locallyInside(a, b) && locallyInside(b, a)) {

	            triangles.push(a.i / dim);
	            triangles.push(p.i / dim);
	            triangles.push(b.i / dim);

	            // remove two nodes involved
	            removeNode(p);
	            removeNode(p.next);

	            p = start = b;
	        }
	        p = p.next;
	    } while (p !== start);

	    return p;
	}

	// try splitting polygon into two and triangulate them independently
	function splitEarcut(start, triangles, dim, minX, minY, invSize) {
	    // look for a valid diagonal that divides the polygon into two
	    var a = start;
	    do {
	        var b = a.next.next;
	        while (b !== a.prev) {
	            if (a.i !== b.i && isValidDiagonal(a, b)) {
	                // split the polygon in two by the diagonal
	                var c = splitPolygon(a, b);

	                // filter colinear points around the cuts
	                a = filterPoints(a, a.next);
	                c = filterPoints(c, c.next);

	                // run earcut on each half
	                earcutLinked(a, triangles, dim, minX, minY, invSize);
	                earcutLinked(c, triangles, dim, minX, minY, invSize);
	                return;
	            }
	            b = b.next;
	        }
	        a = a.next;
	    } while (a !== start);
	}

	// link every hole into the outer loop, producing a single-ring polygon without holes
	function eliminateHoles(data, holeIndices, outerNode, dim) {
	    var queue = [],
	        i, len, start, end, list;

	    for (i = 0, len = holeIndices.length; i < len; i++) {
	        start = holeIndices[i] * dim;
	        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
	        list = linkedList(data, start, end, dim, false);
	        if (list === list.next) list.steiner = true;
	        queue.push(getLeftmost(list));
	    }

	    queue.sort(compareX);

	    // process holes from left to right
	    for (i = 0; i < queue.length; i++) {
	        eliminateHole(queue[i], outerNode);
	        outerNode = filterPoints(outerNode, outerNode.next);
	    }

	    return outerNode;
	}

	function compareX(a, b) {
	    return a.x - b.x;
	}

	// find a bridge between vertices that connects hole with an outer ring and and link it
	function eliminateHole(hole, outerNode) {
	    outerNode = findHoleBridge(hole, outerNode);
	    if (outerNode) {
	        var b = splitPolygon(outerNode, hole);
	        filterPoints(b, b.next);
	    }
	}

	// David Eberly's algorithm for finding a bridge between hole and outer polygon
	function findHoleBridge(hole, outerNode) {
	    var p = outerNode,
	        hx = hole.x,
	        hy = hole.y,
	        qx = -Infinity,
	        m;

	    // find a segment intersected by a ray from the hole's leftmost point to the left;
	    // segment's endpoint with lesser x will be potential connection point
	    do {
	        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
	            var x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
	            if (x <= hx && x > qx) {
	                qx = x;
	                if (x === hx) {
	                    if (hy === p.y) return p;
	                    if (hy === p.next.y) return p.next;
	                }
	                m = p.x < p.next.x ? p : p.next;
	            }
	        }
	        p = p.next;
	    } while (p !== outerNode);

	    if (!m) return null;

	    if (hx === qx) return m.prev; // hole touches outer segment; pick lower endpoint

	    // look for points inside the triangle of hole point, segment intersection and endpoint;
	    // if there are no points found, we have a valid connection;
	    // otherwise choose the point of the minimum angle with the ray as connection point

	    var stop = m,
	        mx = m.x,
	        my = m.y,
	        tanMin = Infinity,
	        tan;

	    p = m.next;

	    while (p !== stop) {
	        if (hx >= p.x && p.x >= mx && hx !== p.x &&
	                pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {

	            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential

	            if ((tan < tanMin || (tan === tanMin && p.x > m.x)) && locallyInside(p, hole)) {
	                m = p;
	                tanMin = tan;
	            }
	        }

	        p = p.next;
	    }

	    return m;
	}

	// interlink polygon nodes in z-order
	function indexCurve(start, minX, minY, invSize) {
	    var p = start;
	    do {
	        if (p.z === null) p.z = zOrder(p.x, p.y, minX, minY, invSize);
	        p.prevZ = p.prev;
	        p.nextZ = p.next;
	        p = p.next;
	    } while (p !== start);

	    p.prevZ.nextZ = null;
	    p.prevZ = null;

	    sortLinked(p);
	}

	// Simon Tatham's linked list merge sort algorithm
	// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
	function sortLinked(list) {
	    var i, p, q, e, tail, numMerges, pSize, qSize,
	        inSize = 1;

	    do {
	        p = list;
	        list = null;
	        tail = null;
	        numMerges = 0;

	        while (p) {
	            numMerges++;
	            q = p;
	            pSize = 0;
	            for (i = 0; i < inSize; i++) {
	                pSize++;
	                q = q.nextZ;
	                if (!q) break;
	            }
	            qSize = inSize;

	            while (pSize > 0 || (qSize > 0 && q)) {

	                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
	                    e = p;
	                    p = p.nextZ;
	                    pSize--;
	                } else {
	                    e = q;
	                    q = q.nextZ;
	                    qSize--;
	                }

	                if (tail) tail.nextZ = e;
	                else list = e;

	                e.prevZ = tail;
	                tail = e;
	            }

	            p = q;
	        }

	        tail.nextZ = null;
	        inSize *= 2;

	    } while (numMerges > 1);

	    return list;
	}

	// z-order of a point given coords and inverse of the longer side of data bbox
	function zOrder(x, y, minX, minY, invSize) {
	    // coords are transformed into non-negative 15-bit integer range
	    x = 32767 * (x - minX) * invSize;
	    y = 32767 * (y - minY) * invSize;

	    x = (x | (x << 8)) & 0x00FF00FF;
	    x = (x | (x << 4)) & 0x0F0F0F0F;
	    x = (x | (x << 2)) & 0x33333333;
	    x = (x | (x << 1)) & 0x55555555;

	    y = (y | (y << 8)) & 0x00FF00FF;
	    y = (y | (y << 4)) & 0x0F0F0F0F;
	    y = (y | (y << 2)) & 0x33333333;
	    y = (y | (y << 1)) & 0x55555555;

	    return x | (y << 1);
	}

	// find the leftmost node of a polygon ring
	function getLeftmost(start) {
	    var p = start,
	        leftmost = start;
	    do {
	        if (p.x < leftmost.x) leftmost = p;
	        p = p.next;
	    } while (p !== start);

	    return leftmost;
	}

	// check if a point lies within a convex triangle
	function pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
	    return (cx - px) * (ay - py) - (ax - px) * (cy - py) >= 0 &&
	           (ax - px) * (by - py) - (bx - px) * (ay - py) >= 0 &&
	           (bx - px) * (cy - py) - (cx - px) * (by - py) >= 0;
	}

	// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
	function isValidDiagonal(a, b) {
	    return a.next.i !== b.i && a.prev.i !== b.i && !intersectsPolygon(a, b) &&
	           locallyInside(a, b) && locallyInside(b, a) && middleInside(a, b);
	}

	// signed area of a triangle
	function area(p, q, r) {
	    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
	}

	// check if two points are equal
	function equals(p1, p2) {
	    return p1.x === p2.x && p1.y === p2.y;
	}

	// check if two segments intersect
	function intersects(p1, q1, p2, q2) {
	    if ((equals(p1, q1) && equals(p2, q2)) ||
	        (equals(p1, q2) && equals(p2, q1))) return true;
	    return area(p1, q1, p2) > 0 !== area(p1, q1, q2) > 0 &&
	           area(p2, q2, p1) > 0 !== area(p2, q2, q1) > 0;
	}

	// check if a polygon diagonal intersects any polygon segments
	function intersectsPolygon(a, b) {
	    var p = a;
	    do {
	        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i &&
	                intersects(p, p.next, a, b)) return true;
	        p = p.next;
	    } while (p !== a);

	    return false;
	}

	// check if a polygon diagonal is locally inside the polygon
	function locallyInside(a, b) {
	    return area(a.prev, a, a.next) < 0 ?
	        area(a, b, a.next) >= 0 && area(a, a.prev, b) >= 0 :
	        area(a, b, a.prev) < 0 || area(a, a.next, b) < 0;
	}

	// check if the middle point of a polygon diagonal is inside the polygon
	function middleInside(a, b) {
	    var p = a,
	        inside = false,
	        px = (a.x + b.x) / 2,
	        py = (a.y + b.y) / 2;
	    do {
	        if (((p.y > py) !== (p.next.y > py)) && p.next.y !== p.y &&
	                (px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x))
	            inside = !inside;
	        p = p.next;
	    } while (p !== a);

	    return inside;
	}

	// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
	// if one belongs to the outer ring and another to a hole, it merges it into a single ring
	function splitPolygon(a, b) {
	    var a2 = new Node(a.i, a.x, a.y),
	        b2 = new Node(b.i, b.x, b.y),
	        an = a.next,
	        bp = b.prev;

	    a.next = b;
	    b.prev = a;

	    a2.next = an;
	    an.prev = a2;

	    b2.next = a2;
	    a2.prev = b2;

	    bp.next = b2;
	    b2.prev = bp;

	    return b2;
	}

	// create a node and optionally link it with previous one (in a circular doubly linked list)
	function insertNode(i, x, y, last) {
	    var p = new Node(i, x, y);

	    if (!last) {
	        p.prev = p;
	        p.next = p;

	    } else {
	        p.next = last.next;
	        p.prev = last;
	        last.next.prev = p;
	        last.next = p;
	    }
	    return p;
	}

	function removeNode(p) {
	    p.next.prev = p.prev;
	    p.prev.next = p.next;

	    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
	    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
	}

	function Node(i, x, y) {
	    // vertice index in coordinates array
	    this.i = i;

	    // vertex coordinates
	    this.x = x;
	    this.y = y;

	    // previous and next vertice nodes in a polygon ring
	    this.prev = null;
	    this.next = null;

	    // z-order curve value
	    this.z = null;

	    // previous and next nodes in z-order
	    this.prevZ = null;
	    this.nextZ = null;

	    // indicates whether this is a steiner point
	    this.steiner = false;
	}

	// return a percentage difference between the polygon area and its triangulation area;
	// used to verify correctness of triangulation
	earcut.deviation = function (data, holeIndices, dim, triangles) {
	    var hasHoles = holeIndices && holeIndices.length;
	    var outerLen = hasHoles ? holeIndices[0] * dim : data.length;

	    var polygonArea = Math.abs(signedArea(data, 0, outerLen, dim));
	    if (hasHoles) {
	        for (var i = 0, len = holeIndices.length; i < len; i++) {
	            var start = holeIndices[i] * dim;
	            var end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
	            polygonArea -= Math.abs(signedArea(data, start, end, dim));
	        }
	    }

	    var trianglesArea = 0;
	    for (i = 0; i < triangles.length; i += 3) {
	        var a = triangles[i] * dim;
	        var b = triangles[i + 1] * dim;
	        var c = triangles[i + 2] * dim;
	        trianglesArea += Math.abs(
	            (data[a] - data[c]) * (data[b + 1] - data[a + 1]) -
	            (data[a] - data[b]) * (data[c + 1] - data[a + 1]));
	    }

	    return polygonArea === 0 && trianglesArea === 0 ? 0 :
	        Math.abs((trianglesArea - polygonArea) / polygonArea);
	};

	function signedArea(data, start, end, dim) {
	    var sum = 0;
	    for (var i = start, j = end - dim; i < end; i += dim) {
	        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
	        j = i;
	    }
	    return sum;
	}

	// turn a polygon in a multi-dimensional array form (e.g. as in GeoJSON) into a form Earcut accepts
	earcut.flatten = function (data) {
	    var dim = data[0][0].length,
	        result = {vertices: [], holes: [], dimensions: dim},
	        holeIndex = 0;

	    for (var i = 0; i < data.length; i++) {
	        for (var j = 0; j < data[i].length; j++) {
	            for (var d = 0; d < dim; d++) result.vertices.push(data[i][j][d]);
	        }
	        if (i > 0) {
	            holeIndex += data[i - 1].length;
	            result.holes.push(holeIndex);
	        }
	    }
	    return result;
	};


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _math = __webpack_require__(175);

	var _utils = __webpack_require__(213);

	var _const = __webpack_require__(174);

	var _Texture = __webpack_require__(220);

	var _Texture2 = _interopRequireDefault(_Texture);

	var _Container2 = __webpack_require__(212);

	var _Container3 = _interopRequireDefault(_Container2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var tempPoint = new _math.Point();

	/**
	 * The Sprite object is the base for all textured objects that are rendered to the screen
	 *
	 * A sprite can be created directly from an image like this:
	 *
	 * ```js
	 * let sprite = new PIXI.Sprite.fromImage('assets/image.png');
	 * ```
	 *
	 * The more efficient way to create sprites is using a {@link PIXI.Spritesheet}:
	 *
	 * ```js
	 * PIXI.loader.add("assets/spritesheet.json").load(setup);
	 *
	 * function setup() {
	 *   let sheet = PIXI.loader.resources["assets/spritesheet.json"].spritesheet;
	 *   let sprite = new PIXI.Sprite(sheet.textures["image.png"]);
	 *   ...
	 * }
	 * ```
	 *
	 * @class
	 * @extends PIXI.Container
	 * @memberof PIXI
	 */

	var Sprite = function (_Container) {
	    _inherits(Sprite, _Container);

	    /**
	     * @param {PIXI.Texture} texture - The texture for this sprite
	     */
	    function Sprite(texture) {
	        _classCallCheck(this, Sprite);

	        /**
	         * The anchor sets the origin point of the texture.
	         * The default is 0,0 or taken from the {@link PIXI.Texture#defaultAnchor|Texture}
	         * passed to the constructor. A value of 0,0 means the texture's origin is the top left.
	         * Setting the anchor to 0.5,0.5 means the texture's origin is centered.
	         * Setting the anchor to 1,1 would mean the texture's origin point will be the bottom right corner.
	         * Note: Updating the {@link PIXI.Texture#defaultAnchor} after a Texture is
	         * created does _not_ update the Sprite's anchor values.
	         *
	         * @member {PIXI.ObservablePoint}
	         * @private
	         */
	        var _this = _possibleConstructorReturn(this, _Container.call(this));

	        _this._anchor = new _math.ObservablePoint(_this._onAnchorUpdate, _this, texture ? texture.defaultAnchor.x : 0, texture ? texture.defaultAnchor.y : 0);

	        /**
	         * The texture that the sprite is using
	         *
	         * @private
	         * @member {PIXI.Texture}
	         */
	        _this._texture = null;

	        /**
	         * The width of the sprite (this is initially set by the texture)
	         *
	         * @private
	         * @member {number}
	         */
	        _this._width = 0;

	        /**
	         * The height of the sprite (this is initially set by the texture)
	         *
	         * @private
	         * @member {number}
	         */
	        _this._height = 0;

	        /**
	         * The tint applied to the sprite. This is a hex value. A value of 0xFFFFFF will remove any tint effect.
	         *
	         * @private
	         * @member {number}
	         * @default 0xFFFFFF
	         */
	        _this._tint = null;
	        _this._tintRGB = null;
	        _this.tint = 0xFFFFFF;

	        /**
	         * The blend mode to be applied to the sprite. Apply a value of `PIXI.BLEND_MODES.NORMAL` to reset the blend mode.
	         *
	         * @member {number}
	         * @default PIXI.BLEND_MODES.NORMAL
	         * @see PIXI.BLEND_MODES
	         */
	        _this.blendMode = _const.BLEND_MODES.NORMAL;

	        /**
	         * The shader that will be used to render the sprite. Set to null to remove a current shader.
	         *
	         * @member {PIXI.Filter|PIXI.Shader}
	         */
	        _this.shader = null;

	        /**
	         * An internal cached value of the tint.
	         *
	         * @private
	         * @member {number}
	         * @default 0xFFFFFF
	         */
	        _this.cachedTint = 0xFFFFFF;

	        // call texture setter
	        _this.texture = texture || _Texture2.default.EMPTY;

	        /**
	         * this is used to store the vertex data of the sprite (basically a quad)
	         *
	         * @private
	         * @member {Float32Array}
	         */
	        _this.vertexData = new Float32Array(8);

	        /**
	         * This is used to calculate the bounds of the object IF it is a trimmed sprite
	         *
	         * @private
	         * @member {Float32Array}
	         */
	        _this.vertexTrimmedData = null;

	        _this._transformID = -1;
	        _this._textureID = -1;

	        _this._transformTrimmedID = -1;
	        _this._textureTrimmedID = -1;

	        /**
	         * Plugin that is responsible for rendering this element.
	         * Allows to customize the rendering process without overriding '_renderWebGL' & '_renderCanvas' methods.
	         *
	         * @member {string}
	         * @default 'sprite'
	         */
	        _this.pluginName = 'sprite';
	        return _this;
	    }

	    /**
	     * When the texture is updated, this event will fire to update the scale and frame
	     *
	     * @private
	     */


	    Sprite.prototype._onTextureUpdate = function _onTextureUpdate() {
	        this._textureID = -1;
	        this._textureTrimmedID = -1;
	        this.cachedTint = 0xFFFFFF;

	        // so if _width is 0 then width was not set..
	        if (this._width) {
	            this.scale.x = (0, _utils.sign)(this.scale.x) * this._width / this._texture.orig.width;
	        }

	        if (this._height) {
	            this.scale.y = (0, _utils.sign)(this.scale.y) * this._height / this._texture.orig.height;
	        }
	    };

	    /**
	     * Called when the anchor position updates.
	     *
	     * @private
	     */


	    Sprite.prototype._onAnchorUpdate = function _onAnchorUpdate() {
	        this._transformID = -1;
	        this._transformTrimmedID = -1;
	    };

	    /**
	     * calculates worldTransform * vertices, store it in vertexData
	     */


	    Sprite.prototype.calculateVertices = function calculateVertices() {
	        if (this._transformID === this.transform._worldID && this._textureID === this._texture._updateID) {
	            return;
	        }

	        this._transformID = this.transform._worldID;
	        this._textureID = this._texture._updateID;

	        // set the vertex data

	        var texture = this._texture;
	        var wt = this.transform.worldTransform;
	        var a = wt.a;
	        var b = wt.b;
	        var c = wt.c;
	        var d = wt.d;
	        var tx = wt.tx;
	        var ty = wt.ty;
	        var vertexData = this.vertexData;
	        var trim = texture.trim;
	        var orig = texture.orig;
	        var anchor = this._anchor;

	        var w0 = 0;
	        var w1 = 0;
	        var h0 = 0;
	        var h1 = 0;

	        if (trim) {
	            // if the sprite is trimmed and is not a tilingsprite then we need to add the extra
	            // space before transforming the sprite coords.
	            w1 = trim.x - anchor._x * orig.width;
	            w0 = w1 + trim.width;

	            h1 = trim.y - anchor._y * orig.height;
	            h0 = h1 + trim.height;
	        } else {
	            w1 = -anchor._x * orig.width;
	            w0 = w1 + orig.width;

	            h1 = -anchor._y * orig.height;
	            h0 = h1 + orig.height;
	        }

	        // xy
	        vertexData[0] = a * w1 + c * h1 + tx;
	        vertexData[1] = d * h1 + b * w1 + ty;

	        // xy
	        vertexData[2] = a * w0 + c * h1 + tx;
	        vertexData[3] = d * h1 + b * w0 + ty;

	        // xy
	        vertexData[4] = a * w0 + c * h0 + tx;
	        vertexData[5] = d * h0 + b * w0 + ty;

	        // xy
	        vertexData[6] = a * w1 + c * h0 + tx;
	        vertexData[7] = d * h0 + b * w1 + ty;
	    };

	    /**
	     * calculates worldTransform * vertices for a non texture with a trim. store it in vertexTrimmedData
	     * This is used to ensure that the true width and height of a trimmed texture is respected
	     */


	    Sprite.prototype.calculateTrimmedVertices = function calculateTrimmedVertices() {
	        if (!this.vertexTrimmedData) {
	            this.vertexTrimmedData = new Float32Array(8);
	        } else if (this._transformTrimmedID === this.transform._worldID && this._textureTrimmedID === this._texture._updateID) {
	            return;
	        }

	        this._transformTrimmedID = this.transform._worldID;
	        this._textureTrimmedID = this._texture._updateID;

	        // lets do some special trim code!
	        var texture = this._texture;
	        var vertexData = this.vertexTrimmedData;
	        var orig = texture.orig;
	        var anchor = this._anchor;

	        // lets calculate the new untrimmed bounds..
	        var wt = this.transform.worldTransform;
	        var a = wt.a;
	        var b = wt.b;
	        var c = wt.c;
	        var d = wt.d;
	        var tx = wt.tx;
	        var ty = wt.ty;

	        var w1 = -anchor._x * orig.width;
	        var w0 = w1 + orig.width;

	        var h1 = -anchor._y * orig.height;
	        var h0 = h1 + orig.height;

	        // xy
	        vertexData[0] = a * w1 + c * h1 + tx;
	        vertexData[1] = d * h1 + b * w1 + ty;

	        // xy
	        vertexData[2] = a * w0 + c * h1 + tx;
	        vertexData[3] = d * h1 + b * w0 + ty;

	        // xy
	        vertexData[4] = a * w0 + c * h0 + tx;
	        vertexData[5] = d * h0 + b * w0 + ty;

	        // xy
	        vertexData[6] = a * w1 + c * h0 + tx;
	        vertexData[7] = d * h0 + b * w1 + ty;
	    };

	    /**
	    *
	    * Renders the object using the WebGL renderer
	    *
	    * @private
	    * @param {PIXI.WebGLRenderer} renderer - The webgl renderer to use.
	    */


	    Sprite.prototype._renderWebGL = function _renderWebGL(renderer) {
	        this.calculateVertices();

	        renderer.setObjectRenderer(renderer.plugins[this.pluginName]);
	        renderer.plugins[this.pluginName].render(this);
	    };

	    /**
	    * Renders the object using the Canvas renderer
	    *
	    * @private
	    * @param {PIXI.CanvasRenderer} renderer - The renderer
	    */


	    Sprite.prototype._renderCanvas = function _renderCanvas(renderer) {
	        renderer.plugins[this.pluginName].render(this);
	    };

	    /**
	     * Updates the bounds of the sprite.
	     *
	     * @private
	     */


	    Sprite.prototype._calculateBounds = function _calculateBounds() {
	        var trim = this._texture.trim;
	        var orig = this._texture.orig;

	        // First lets check to see if the current texture has a trim..
	        if (!trim || trim.width === orig.width && trim.height === orig.height) {
	            // no trim! lets use the usual calculations..
	            this.calculateVertices();
	            this._bounds.addQuad(this.vertexData);
	        } else {
	            // lets calculate a special trimmed bounds...
	            this.calculateTrimmedVertices();
	            this._bounds.addQuad(this.vertexTrimmedData);
	        }
	    };

	    /**
	     * Gets the local bounds of the sprite object.
	     *
	     * @param {PIXI.Rectangle} rect - The output rectangle.
	     * @return {PIXI.Rectangle} The bounds.
	     */


	    Sprite.prototype.getLocalBounds = function getLocalBounds(rect) {
	        // we can do a fast local bounds if the sprite has no children!
	        if (this.children.length === 0) {
	            this._bounds.minX = this._texture.orig.width * -this._anchor._x;
	            this._bounds.minY = this._texture.orig.height * -this._anchor._y;
	            this._bounds.maxX = this._texture.orig.width * (1 - this._anchor._x);
	            this._bounds.maxY = this._texture.orig.height * (1 - this._anchor._y);

	            if (!rect) {
	                if (!this._localBoundsRect) {
	                    this._localBoundsRect = new _math.Rectangle();
	                }

	                rect = this._localBoundsRect;
	            }

	            return this._bounds.getRectangle(rect);
	        }

	        return _Container.prototype.getLocalBounds.call(this, rect);
	    };

	    /**
	     * Tests if a point is inside this sprite
	     *
	     * @param {PIXI.Point} point - the point to test
	     * @return {boolean} the result of the test
	     */


	    Sprite.prototype.containsPoint = function containsPoint(point) {
	        this.worldTransform.applyInverse(point, tempPoint);

	        var width = this._texture.orig.width;
	        var height = this._texture.orig.height;
	        var x1 = -width * this.anchor.x;
	        var y1 = 0;

	        if (tempPoint.x >= x1 && tempPoint.x < x1 + width) {
	            y1 = -height * this.anchor.y;

	            if (tempPoint.y >= y1 && tempPoint.y < y1 + height) {
	                return true;
	            }
	        }

	        return false;
	    };

	    /**
	     * Destroys this sprite and optionally its texture and children
	     *
	     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
	     *  have been set to that value
	     * @param {boolean} [options.children=false] - if set to true, all the children will have their destroy
	     *      method called as well. 'options' will be passed on to those calls.
	     * @param {boolean} [options.texture=false] - Should it destroy the current texture of the sprite as well
	     * @param {boolean} [options.baseTexture=false] - Should it destroy the base texture of the sprite as well
	     */


	    Sprite.prototype.destroy = function destroy(options) {
	        _Container.prototype.destroy.call(this, options);

	        this._texture.off('update', this._onTextureUpdate, this);

	        this._anchor = null;

	        var destroyTexture = typeof options === 'boolean' ? options : options && options.texture;

	        if (destroyTexture) {
	            var destroyBaseTexture = typeof options === 'boolean' ? options : options && options.baseTexture;

	            this._texture.destroy(!!destroyBaseTexture);
	        }

	        this._texture = null;
	        this.shader = null;
	    };

	    // some helper functions..

	    /**
	     * Helper function that creates a new sprite based on the source you provide.
	     * The source can be - frame id, image url, video url, canvas element, video element, base texture
	     *
	     * @static
	     * @param {number|string|PIXI.BaseTexture|HTMLCanvasElement|HTMLVideoElement} source Source to create texture from
	     * @return {PIXI.Sprite} The newly created sprite
	     */


	    Sprite.from = function from(source) {
	        return new Sprite(_Texture2.default.from(source));
	    };

	    /**
	     * Helper function that creates a sprite that will contain a texture from the TextureCache based on the frameId
	     * The frame ids are created when a Texture packer file has been loaded
	     *
	     * @static
	     * @param {string} frameId - The frame Id of the texture in the cache
	     * @return {PIXI.Sprite} A new Sprite using a texture from the texture cache matching the frameId
	     */


	    Sprite.fromFrame = function fromFrame(frameId) {
	        var texture = _utils.TextureCache[frameId];

	        if (!texture) {
	            throw new Error('The frameId "' + frameId + '" does not exist in the texture cache');
	        }

	        return new Sprite(texture);
	    };

	    /**
	     * Helper function that creates a sprite that will contain a texture based on an image url
	     * If the image is not in the texture cache it will be loaded
	     *
	     * @static
	     * @param {string} imageId - The image url of the texture
	     * @param {boolean} [crossorigin=(auto)] - if you want to specify the cross-origin parameter
	     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - if you want to specify the scale mode,
	     *  see {@link PIXI.SCALE_MODES} for possible values
	     * @return {PIXI.Sprite} A new Sprite using a texture from the texture cache matching the image id
	     */


	    Sprite.fromImage = function fromImage(imageId, crossorigin, scaleMode) {
	        return new Sprite(_Texture2.default.fromImage(imageId, crossorigin, scaleMode));
	    };

	    /**
	     * The width of the sprite, setting this will actually modify the scale to achieve the value set
	     *
	     * @member {number}
	     */


	    _createClass(Sprite, [{
	        key: 'width',
	        get: function get() {
	            return Math.abs(this.scale.x) * this._texture.orig.width;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            var s = (0, _utils.sign)(this.scale.x) || 1;

	            this.scale.x = s * value / this._texture.orig.width;
	            this._width = value;
	        }

	        /**
	         * The height of the sprite, setting this will actually modify the scale to achieve the value set
	         *
	         * @member {number}
	         */

	    }, {
	        key: 'height',
	        get: function get() {
	            return Math.abs(this.scale.y) * this._texture.orig.height;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            var s = (0, _utils.sign)(this.scale.y) || 1;

	            this.scale.y = s * value / this._texture.orig.height;
	            this._height = value;
	        }

	        /**
	         * The anchor sets the origin point of the texture.
	         * The default is 0,0 or taken from the {@link PIXI.Texture|Texture} passed to the constructor.
	         * Setting the texture at a later point of time does not change the anchor.
	         *
	         * 0,0 means the texture's origin is the top left, 0.5,0.5 is the center, 1,1 the bottom right corner.
	         *
	         * @member {PIXI.ObservablePoint}
	         */

	    }, {
	        key: 'anchor',
	        get: function get() {
	            return this._anchor;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._anchor.copy(value);
	        }

	        /**
	         * The tint applied to the sprite. This is a hex value.
	         * A value of 0xFFFFFF will remove any tint effect.
	         *
	         * @member {number}
	         * @default 0xFFFFFF
	         */

	    }, {
	        key: 'tint',
	        get: function get() {
	            return this._tint;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._tint = value;
	            this._tintRGB = (value >> 16) + (value & 0xff00) + ((value & 0xff) << 16);
	        }

	        /**
	         * The texture that the sprite is using
	         *
	         * @member {PIXI.Texture}
	         */

	    }, {
	        key: 'texture',
	        get: function get() {
	            return this._texture;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            if (this._texture === value) {
	                return;
	            }

	            this._texture = value || _Texture2.default.EMPTY;
	            this.cachedTint = 0xFFFFFF;

	            this._textureID = -1;
	            this._textureTrimmedID = -1;

	            if (value) {
	                // wait for the texture to load
	                if (value.baseTexture.hasLoaded) {
	                    this._onTextureUpdate();
	                } else {
	                    value.once('update', this._onTextureUpdate, this);
	                }
	            }
	        }
	    }]);

	    return Sprite;
	}(_Container3.default);

	exports.default = Sprite;
	//# sourceMappingURL=Sprite.js.map

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _BaseTexture = __webpack_require__(221);

	var _BaseTexture2 = _interopRequireDefault(_BaseTexture);

	var _VideoBaseTexture = __webpack_require__(229);

	var _VideoBaseTexture2 = _interopRequireDefault(_VideoBaseTexture);

	var _TextureUvs = __webpack_require__(233);

	var _TextureUvs2 = _interopRequireDefault(_TextureUvs);

	var _eventemitter = __webpack_require__(204);

	var _eventemitter2 = _interopRequireDefault(_eventemitter);

	var _math = __webpack_require__(175);

	var _utils = __webpack_require__(213);

	var _settings = __webpack_require__(205);

	var _settings2 = _interopRequireDefault(_settings);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	/**
	 * A texture stores the information that represents an image or part of an image. It cannot be added
	 * to the display list directly. Instead use it as the texture for a Sprite. If no frame is provided
	 * then the whole image is used.
	 *
	 * You can directly create a texture from an image and then reuse it multiple times like this :
	 *
	 * ```js
	 * let texture = PIXI.Texture.fromImage('assets/image.png');
	 * let sprite1 = new PIXI.Sprite(texture);
	 * let sprite2 = new PIXI.Sprite(texture);
	 * ```
	 *
	 * Textures made from SVGs, loaded or not, cannot be used before the file finishes processing.
	 * You can check for this by checking the sprite's _textureID property.
	 * ```js
	 * var texture = PIXI.Texture.fromImage('assets/image.svg');
	 * var sprite1 = new PIXI.Sprite(texture);
	 * //sprite1._textureID should not be undefined if the texture has finished processing the SVG file
	 * ```
	 * You can use a ticker or rAF to ensure your sprites load the finished textures after processing. See issue #3068.
	 *
	 * @class
	 * @extends EventEmitter
	 * @memberof PIXI
	 */
	var Texture = function (_EventEmitter) {
	    _inherits(Texture, _EventEmitter);

	    /**
	     * @param {PIXI.BaseTexture} baseTexture - The base texture source to create the texture from
	     * @param {PIXI.Rectangle} [frame] - The rectangle frame of the texture to show
	     * @param {PIXI.Rectangle} [orig] - The area of original texture
	     * @param {PIXI.Rectangle} [trim] - Trimmed rectangle of original texture
	     * @param {number} [rotate] - indicates how the texture was rotated by texture packer. See {@link PIXI.GroupD8}
	     * @param {PIXI.Point} [anchor] - Default anchor point used for sprite placement / rotation
	     */
	    function Texture(baseTexture, frame, orig, trim, rotate, anchor) {
	        _classCallCheck(this, Texture);

	        /**
	         * Does this Texture have any frame data assigned to it?
	         *
	         * @member {boolean}
	         */
	        var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

	        _this.noFrame = false;

	        if (!frame) {
	            _this.noFrame = true;
	            frame = new _math.Rectangle(0, 0, 1, 1);
	        }

	        if (baseTexture instanceof Texture) {
	            baseTexture = baseTexture.baseTexture;
	        }

	        /**
	         * The base texture that this texture uses.
	         *
	         * @member {PIXI.BaseTexture}
	         */
	        _this.baseTexture = baseTexture;

	        /**
	         * This is the area of the BaseTexture image to actually copy to the Canvas / WebGL when rendering,
	         * irrespective of the actual frame size or placement (which can be influenced by trimmed texture atlases)
	         *
	         * @member {PIXI.Rectangle}
	         */
	        _this._frame = frame;

	        /**
	         * This is the trimmed area of original texture, before it was put in atlas
	         * Please call `_updateUvs()` after you change coordinates of `trim` manually.
	         *
	         * @member {PIXI.Rectangle}
	         */
	        _this.trim = trim;

	        /**
	         * This will let the renderer know if the texture is valid. If it's not then it cannot be rendered.
	         *
	         * @member {boolean}
	         */
	        _this.valid = false;

	        /**
	         * This will let a renderer know that a texture has been updated (used mainly for webGL uv updates)
	         *
	         * @member {boolean}
	         */
	        _this.requiresUpdate = false;

	        /**
	         * The WebGL UV data cache.
	         *
	         * @member {PIXI.TextureUvs}
	         * @private
	         */
	        _this._uvs = null;

	        /**
	         * This is the area of original texture, before it was put in atlas
	         *
	         * @member {PIXI.Rectangle}
	         */
	        _this.orig = orig || frame; // new Rectangle(0, 0, 1, 1);

	        _this._rotate = Number(rotate || 0);

	        if (rotate === true) {
	            // this is old texturepacker legacy, some games/libraries are passing "true" for rotated textures
	            _this._rotate = 2;
	        } else if (_this._rotate % 2 !== 0) {
	            throw new Error('attempt to use diamond-shaped UVs. If you are sure, set rotation manually');
	        }

	        if (baseTexture.hasLoaded) {
	            if (_this.noFrame) {
	                frame = new _math.Rectangle(0, 0, baseTexture.width, baseTexture.height);

	                // if there is no frame we should monitor for any base texture changes..
	                baseTexture.on('update', _this.onBaseTextureUpdated, _this);
	            }
	            _this.frame = frame;
	        } else {
	            baseTexture.once('loaded', _this.onBaseTextureLoaded, _this);
	        }

	        /**
	         * Anchor point that is used as default if sprite is created with this texture.
	         * Changing the `defaultAnchor` at a later point of time will not update Sprite's anchor point.
	         * @member {PIXI.Point}
	         * @default {0,0}
	         */
	        _this.defaultAnchor = anchor ? new _math.Point(anchor.x, anchor.y) : new _math.Point(0, 0);

	        /**
	         * Fired when the texture is updated. This happens if the frame or the baseTexture is updated.
	         *
	         * @event PIXI.Texture#update
	         * @protected
	         * @param {PIXI.Texture} texture - Instance of texture being updated.
	         */

	        _this._updateID = 0;

	        /**
	         * Contains data for uvs. May contain clamp settings and some matrices.
	         * Its a bit heavy, so by default that object is not created.
	         * @member {PIXI.TextureMatrix}
	         * @default null
	         */
	        _this.transform = null;

	        /**
	         * The ids under which this Texture has been added to the texture cache. This is
	         * automatically set as long as Texture.addToCache is used, but may not be set if a
	         * Texture is added directly to the TextureCache array.
	         *
	         * @member {string[]}
	         */
	        _this.textureCacheIds = [];
	        return _this;
	    }

	    /**
	     * Updates this texture on the gpu.
	     *
	     */


	    Texture.prototype.update = function update() {
	        this.baseTexture.update();
	    };

	    /**
	     * Called when the base texture is loaded
	     *
	     * @private
	     * @param {PIXI.BaseTexture} baseTexture - The base texture.
	     */


	    Texture.prototype.onBaseTextureLoaded = function onBaseTextureLoaded(baseTexture) {
	        this._updateID++;

	        // TODO this code looks confusing.. boo to abusing getters and setters!
	        if (this.noFrame) {
	            this.frame = new _math.Rectangle(0, 0, baseTexture.width, baseTexture.height);
	        } else {
	            this.frame = this._frame;
	        }

	        this.baseTexture.on('update', this.onBaseTextureUpdated, this);
	        this.emit('update', this);
	    };

	    /**
	     * Called when the base texture is updated
	     *
	     * @private
	     * @param {PIXI.BaseTexture} baseTexture - The base texture.
	     */


	    Texture.prototype.onBaseTextureUpdated = function onBaseTextureUpdated(baseTexture) {
	        this._updateID++;

	        this._frame.width = baseTexture.width;
	        this._frame.height = baseTexture.height;

	        this.emit('update', this);
	    };

	    /**
	     * Destroys this texture
	     *
	     * @param {boolean} [destroyBase=false] Whether to destroy the base texture as well
	     */


	    Texture.prototype.destroy = function destroy(destroyBase) {
	        if (this.baseTexture) {
	            if (destroyBase) {
	                // delete the texture if it exists in the texture cache..
	                // this only needs to be removed if the base texture is actually destroyed too..
	                if (_utils.TextureCache[this.baseTexture.imageUrl]) {
	                    Texture.removeFromCache(this.baseTexture.imageUrl);
	                }

	                this.baseTexture.destroy();
	            }

	            this.baseTexture.off('update', this.onBaseTextureUpdated, this);
	            this.baseTexture.off('loaded', this.onBaseTextureLoaded, this);

	            this.baseTexture = null;
	        }

	        this._frame = null;
	        this._uvs = null;
	        this.trim = null;
	        this.orig = null;

	        this.valid = false;

	        Texture.removeFromCache(this);
	        this.textureCacheIds = null;
	    };

	    /**
	     * Creates a new texture object that acts the same as this one.
	     *
	     * @return {PIXI.Texture} The new texture
	     */


	    Texture.prototype.clone = function clone() {
	        return new Texture(this.baseTexture, this.frame, this.orig, this.trim, this.rotate);
	    };

	    /**
	     * Updates the internal WebGL UV cache. Use it after you change `frame` or `trim` of the texture.
	     */


	    Texture.prototype._updateUvs = function _updateUvs() {
	        if (!this._uvs) {
	            this._uvs = new _TextureUvs2.default();
	        }

	        this._uvs.set(this._frame, this.baseTexture, this.rotate);

	        this._updateID++;
	    };

	    /**
	     * Helper function that creates a Texture object from the given image url.
	     * If the image is not in the texture cache it will be  created and loaded.
	     *
	     * @static
	     * @param {string} imageUrl - The image url of the texture
	     * @param {boolean} [crossorigin] - Whether requests should be treated as crossorigin
	     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
	     * @param {number} [sourceScale=(auto)] - Scale for the original image, used with SVG images.
	     * @return {PIXI.Texture} The newly created texture
	     */


	    Texture.fromImage = function fromImage(imageUrl, crossorigin, scaleMode, sourceScale) {
	        var texture = _utils.TextureCache[imageUrl];

	        if (!texture) {
	            texture = new Texture(_BaseTexture2.default.fromImage(imageUrl, crossorigin, scaleMode, sourceScale));
	            Texture.addToCache(texture, imageUrl);
	        }

	        return texture;
	    };

	    /**
	     * Helper function that creates a sprite that will contain a texture from the TextureCache based on the frameId
	     * The frame ids are created when a Texture packer file has been loaded
	     *
	     * @static
	     * @param {string} frameId - The frame Id of the texture in the cache
	     * @return {PIXI.Texture} The newly created texture
	     */


	    Texture.fromFrame = function fromFrame(frameId) {
	        var texture = _utils.TextureCache[frameId];

	        if (!texture) {
	            throw new Error('The frameId "' + frameId + '" does not exist in the texture cache');
	        }

	        return texture;
	    };

	    /**
	     * Helper function that creates a new Texture based on the given canvas element.
	     *
	     * @static
	     * @param {HTMLCanvasElement} canvas - The canvas element source of the texture
	     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
	     * @param {string} [origin='canvas'] - A string origin of who created the base texture
	     * @return {PIXI.Texture} The newly created texture
	     */


	    Texture.fromCanvas = function fromCanvas(canvas, scaleMode) {
	        var origin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'canvas';

	        return new Texture(_BaseTexture2.default.fromCanvas(canvas, scaleMode, origin));
	    };

	    /**
	     * Helper function that creates a new Texture based on the given video element.
	     *
	     * @static
	     * @param {HTMLVideoElement|string} video - The URL or actual element of the video
	     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
	     * @return {PIXI.Texture} The newly created texture
	     */


	    Texture.fromVideo = function fromVideo(video, scaleMode) {
	        if (typeof video === 'string') {
	            return Texture.fromVideoUrl(video, scaleMode);
	        }

	        return new Texture(_VideoBaseTexture2.default.fromVideo(video, scaleMode));
	    };

	    /**
	     * Helper function that creates a new Texture based on the video url.
	     *
	     * @static
	     * @param {string} videoUrl - URL of the video
	     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
	     * @return {PIXI.Texture} The newly created texture
	     */


	    Texture.fromVideoUrl = function fromVideoUrl(videoUrl, scaleMode) {
	        return new Texture(_VideoBaseTexture2.default.fromUrl(videoUrl, scaleMode));
	    };

	    /**
	     * Helper function that creates a new Texture based on the source you provide.
	     * The source can be - frame id, image url, video url, canvas element, video element, base texture
	     *
	     * @static
	     * @param {number|string|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement|PIXI.BaseTexture}
	     *        source - Source to create texture from
	     * @return {PIXI.Texture} The newly created texture
	     */


	    Texture.from = function from(source) {
	        // TODO auto detect cross origin..
	        // TODO pass in scale mode?
	        if (typeof source === 'string') {
	            var texture = _utils.TextureCache[source];

	            if (!texture) {
	                // check if its a video..
	                var isVideo = source.match(/\.(mp4|webm|ogg|h264|avi|mov)$/) !== null;

	                if (isVideo) {
	                    return Texture.fromVideoUrl(source);
	                }

	                return Texture.fromImage(source);
	            }

	            return texture;
	        } else if (source instanceof HTMLImageElement) {
	            return new Texture(_BaseTexture2.default.from(source));
	        } else if (source instanceof HTMLCanvasElement) {
	            return Texture.fromCanvas(source, _settings2.default.SCALE_MODE, 'HTMLCanvasElement');
	        } else if (source instanceof HTMLVideoElement) {
	            return Texture.fromVideo(source);
	        } else if (source instanceof _BaseTexture2.default) {
	            return new Texture(source);
	        }

	        // lets assume its a texture!
	        return source;
	    };

	    /**
	     * Create a texture from a source and add to the cache.
	     *
	     * @static
	     * @param {HTMLImageElement|HTMLCanvasElement} source - The input source.
	     * @param {String} imageUrl - File name of texture, for cache and resolving resolution.
	     * @param {String} [name] - Human readible name for the texture cache. If no name is
	     *        specified, only `imageUrl` will be used as the cache ID.
	     * @return {PIXI.Texture} Output texture
	     */


	    Texture.fromLoader = function fromLoader(source, imageUrl, name) {
	        var baseTexture = new _BaseTexture2.default(source, undefined, (0, _utils.getResolutionOfUrl)(imageUrl));
	        var texture = new Texture(baseTexture);

	        baseTexture.imageUrl = imageUrl;

	        // No name, use imageUrl instead
	        if (!name) {
	            name = imageUrl;
	        }

	        // lets also add the frame to pixi's global cache for fromFrame and fromImage fucntions
	        _BaseTexture2.default.addToCache(texture.baseTexture, name);
	        Texture.addToCache(texture, name);

	        // also add references by url if they are different.
	        if (name !== imageUrl) {
	            _BaseTexture2.default.addToCache(texture.baseTexture, imageUrl);
	            Texture.addToCache(texture, imageUrl);
	        }

	        return texture;
	    };

	    /**
	     * Adds a Texture to the global TextureCache. This cache is shared across the whole PIXI object.
	     *
	     * @static
	     * @param {PIXI.Texture} texture - The Texture to add to the cache.
	     * @param {string} id - The id that the Texture will be stored against.
	     */


	    Texture.addToCache = function addToCache(texture, id) {
	        if (id) {
	            if (texture.textureCacheIds.indexOf(id) === -1) {
	                texture.textureCacheIds.push(id);
	            }

	            // @if DEBUG
	            /* eslint-disable no-console */
	            if (_utils.TextureCache[id]) {
	                console.warn('Texture added to the cache with an id [' + id + '] that already had an entry');
	            }
	            /* eslint-enable no-console */
	            // @endif

	            _utils.TextureCache[id] = texture;
	        }
	    };

	    /**
	     * Remove a Texture from the global TextureCache.
	     *
	     * @static
	     * @param {string|PIXI.Texture} texture - id of a Texture to be removed, or a Texture instance itself
	     * @return {PIXI.Texture|null} The Texture that was removed
	     */


	    Texture.removeFromCache = function removeFromCache(texture) {
	        if (typeof texture === 'string') {
	            var textureFromCache = _utils.TextureCache[texture];

	            if (textureFromCache) {
	                var index = textureFromCache.textureCacheIds.indexOf(texture);

	                if (index > -1) {
	                    textureFromCache.textureCacheIds.splice(index, 1);
	                }

	                delete _utils.TextureCache[texture];

	                return textureFromCache;
	            }
	        } else if (texture && texture.textureCacheIds) {
	            for (var i = 0; i < texture.textureCacheIds.length; ++i) {
	                // Check that texture matches the one being passed in before deleting it from the cache.
	                if (_utils.TextureCache[texture.textureCacheIds[i]] === texture) {
	                    delete _utils.TextureCache[texture.textureCacheIds[i]];
	                }
	            }

	            texture.textureCacheIds.length = 0;

	            return texture;
	        }

	        return null;
	    };

	    /**
	     * The frame specifies the region of the base texture that this texture uses.
	     * Please call `_updateUvs()` after you change coordinates of `frame` manually.
	     *
	     * @member {PIXI.Rectangle}
	     */


	    _createClass(Texture, [{
	        key: 'frame',
	        get: function get() {
	            return this._frame;
	        },
	        set: function set(frame) // eslint-disable-line require-jsdoc
	        {
	            this._frame = frame;

	            this.noFrame = false;

	            var x = frame.x,
	                y = frame.y,
	                width = frame.width,
	                height = frame.height;

	            var xNotFit = x + width > this.baseTexture.width;
	            var yNotFit = y + height > this.baseTexture.height;

	            if (xNotFit || yNotFit) {
	                var relationship = xNotFit && yNotFit ? 'and' : 'or';
	                var errorX = 'X: ' + x + ' + ' + width + ' = ' + (x + width) + ' > ' + this.baseTexture.width;
	                var errorY = 'Y: ' + y + ' + ' + height + ' = ' + (y + height) + ' > ' + this.baseTexture.height;

	                throw new Error('Texture Error: frame does not fit inside the base Texture dimensions: ' + (errorX + ' ' + relationship + ' ' + errorY));
	            }

	            // this.valid = width && height && this.baseTexture.source && this.baseTexture.hasLoaded;
	            this.valid = width && height && this.baseTexture.hasLoaded;

	            if (!this.trim && !this.rotate) {
	                this.orig = frame;
	            }

	            if (this.valid) {
	                this._updateUvs();
	            }
	        }

	        /**
	         * Indicates whether the texture is rotated inside the atlas
	         * set to 2 to compensate for texture packer rotation
	         * set to 6 to compensate for spine packer rotation
	         * can be used to rotate or mirror sprites
	         * See {@link PIXI.GroupD8} for explanation
	         *
	         * @member {number}
	         */

	    }, {
	        key: 'rotate',
	        get: function get() {
	            return this._rotate;
	        },
	        set: function set(rotate) // eslint-disable-line require-jsdoc
	        {
	            this._rotate = rotate;
	            if (this.valid) {
	                this._updateUvs();
	            }
	        }

	        /**
	         * The width of the Texture in pixels.
	         *
	         * @member {number}
	         */

	    }, {
	        key: 'width',
	        get: function get() {
	            return this.orig.width;
	        }

	        /**
	         * The height of the Texture in pixels.
	         *
	         * @member {number}
	         */

	    }, {
	        key: 'height',
	        get: function get() {
	            return this.orig.height;
	        }
	    }]);

	    return Texture;
	}(_eventemitter2.default);

	exports.default = Texture;


	function createWhiteTexture() {
	    var canvas = document.createElement('canvas');

	    canvas.width = 10;
	    canvas.height = 10;

	    var context = canvas.getContext('2d');

	    context.fillStyle = 'white';
	    context.fillRect(0, 0, 10, 10);

	    return new Texture(new _BaseTexture2.default(canvas));
	}

	function removeAllHandlers(tex) {
	    tex.destroy = function _emptyDestroy() {/* empty */};
	    tex.on = function _emptyOn() {/* empty */};
	    tex.once = function _emptyOnce() {/* empty */};
	    tex.emit = function _emptyEmit() {/* empty */};
	}

	/**
	 * An empty texture, used often to not have to create multiple empty textures.
	 * Can not be destroyed.
	 *
	 * @static
	 * @constant
	 */
	Texture.EMPTY = new Texture(new _BaseTexture2.default());
	removeAllHandlers(Texture.EMPTY);
	removeAllHandlers(Texture.EMPTY.baseTexture);

	/**
	 * A white texture of 10x10 size, used for graphics and other things
	 * Can not be destroyed.
	 *
	 * @static
	 * @constant
	 */
	Texture.WHITE = createWhiteTexture();
	removeAllHandlers(Texture.WHITE);
	removeAllHandlers(Texture.WHITE.baseTexture);
	//# sourceMappingURL=Texture.js.map

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _utils = __webpack_require__(213);

	var _settings = __webpack_require__(205);

	var _settings2 = _interopRequireDefault(_settings);

	var _eventemitter = __webpack_require__(204);

	var _eventemitter2 = _interopRequireDefault(_eventemitter);

	var _determineCrossOrigin = __webpack_require__(222);

	var _determineCrossOrigin2 = _interopRequireDefault(_determineCrossOrigin);

	var _bitTwiddle = __webpack_require__(228);

	var _bitTwiddle2 = _interopRequireDefault(_bitTwiddle);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	/**
	 * A texture stores the information that represents an image. All textures have a base texture.
	 *
	 * @class
	 * @extends EventEmitter
	 * @memberof PIXI
	 */
	var BaseTexture = function (_EventEmitter) {
	    _inherits(BaseTexture, _EventEmitter);

	    /**
	     * @param {HTMLImageElement|HTMLCanvasElement} [source] - the source object of the texture.
	     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
	     * @param {number} [resolution=1] - The resolution / device pixel ratio of the texture
	     */
	    function BaseTexture(source, scaleMode, resolution) {
	        _classCallCheck(this, BaseTexture);

	        var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

	        _this.uid = (0, _utils.uid)();

	        _this.touched = 0;

	        /**
	         * The resolution / device pixel ratio of the texture
	         *
	         * @member {number}
	         * @default 1
	         */
	        _this.resolution = resolution || _settings2.default.RESOLUTION;

	        /**
	         * The width of the base texture set when the image has loaded
	         *
	         * @readonly
	         * @member {number}
	         */
	        _this.width = 100;

	        /**
	         * The height of the base texture set when the image has loaded
	         *
	         * @readonly
	         * @member {number}
	         */
	        _this.height = 100;

	        // TODO docs
	        // used to store the actual dimensions of the source
	        /**
	         * Used to store the actual width of the source of this texture
	         *
	         * @readonly
	         * @member {number}
	         */
	        _this.realWidth = 100;
	        /**
	         * Used to store the actual height of the source of this texture
	         *
	         * @readonly
	         * @member {number}
	         */
	        _this.realHeight = 100;

	        /**
	         * The scale mode to apply when scaling this texture
	         *
	         * @member {number}
	         * @default PIXI.settings.SCALE_MODE
	         * @see PIXI.SCALE_MODES
	         */
	        _this.scaleMode = scaleMode !== undefined ? scaleMode : _settings2.default.SCALE_MODE;

	        /**
	         * Set to true once the base texture has successfully loaded.
	         *
	         * This is never true if the underlying source fails to load or has no texture data.
	         *
	         * @readonly
	         * @member {boolean}
	         */
	        _this.hasLoaded = false;

	        /**
	         * Set to true if the source is currently loading.
	         *
	         * If an Image source is loading the 'loaded' or 'error' event will be
	         * dispatched when the operation ends. An underyling source that is
	         * immediately-available bypasses loading entirely.
	         *
	         * @readonly
	         * @member {boolean}
	         */
	        _this.isLoading = false;

	        /**
	         * The image source that is used to create the texture.
	         *
	         * TODO: Make this a setter that calls loadSource();
	         *
	         * @readonly
	         * @member {HTMLImageElement|HTMLCanvasElement}
	         */
	        _this.source = null; // set in loadSource, if at all

	        /**
	         * The image source that is used to create the texture. This is used to
	         * store the original Svg source when it is replaced with a canvas element.
	         *
	         * TODO: Currently not in use but could be used when re-scaling svg.
	         *
	         * @readonly
	         * @member {Image}
	         */
	        _this.origSource = null; // set in loadSvg, if at all

	        /**
	         * Type of image defined in source, eg. `png` or `svg`
	         *
	         * @readonly
	         * @member {string}
	         */
	        _this.imageType = null; // set in updateImageType

	        /**
	         * Scale for source image. Used with Svg images to scale them before rasterization.
	         *
	         * @readonly
	         * @member {number}
	         */
	        _this.sourceScale = 1.0;

	        /**
	         * Controls if RGB channels should be pre-multiplied by Alpha  (WebGL only)
	         * All blend modes, and shaders written for default value. Change it on your own risk.
	         *
	         * @member {boolean}
	         * @default true
	         */
	        _this.premultipliedAlpha = true;

	        /**
	         * The image url of the texture
	         *
	         * @member {string}
	         */
	        _this.imageUrl = null;

	        /**
	         * Whether or not the texture is a power of two, try to use power of two textures as much
	         * as you can
	         *
	         * @private
	         * @member {boolean}
	         */
	        _this.isPowerOfTwo = false;

	        // used for webGL

	        /**
	         *
	         * Set this to true if a mipmap of this texture needs to be generated. This value needs
	         * to be set before the texture is used
	         * Also the texture must be a power of two size to work
	         *
	         * @member {boolean}
	         * @see PIXI.MIPMAP_TEXTURES
	         */
	        _this.mipmap = _settings2.default.MIPMAP_TEXTURES;

	        /**
	         *
	         * WebGL Texture wrap mode
	         *
	         * @member {number}
	         * @see PIXI.WRAP_MODES
	         */
	        _this.wrapMode = _settings2.default.WRAP_MODE;

	        /**
	         * A map of renderer IDs to webgl textures
	         *
	         * @private
	         * @member {object<number, WebGLTexture>}
	         */
	        _this._glTextures = {};

	        _this._enabled = 0;
	        _this._virtalBoundId = -1;

	        /**
	         * If the object has been destroyed via destroy(). If true, it should not be used.
	         *
	         * @member {boolean}
	         * @private
	         * @readonly
	         */
	        _this._destroyed = false;

	        /**
	         * The ids under which this BaseTexture has been added to the base texture cache. This is
	         * automatically set as long as BaseTexture.addToCache is used, but may not be set if a
	         * BaseTexture is added directly to the BaseTextureCache array.
	         *
	         * @member {string[]}
	         */
	        _this.textureCacheIds = [];

	        // if no source passed don't try to load
	        if (source) {
	            _this.loadSource(source);
	        }

	        /**
	         * Fired when a not-immediately-available source finishes loading.
	         *
	         * @protected
	         * @event PIXI.BaseTexture#loaded
	         * @param {PIXI.BaseTexture} baseTexture - Resource loaded.
	         */

	        /**
	         * Fired when a not-immediately-available source fails to load.
	         *
	         * @protected
	         * @event PIXI.BaseTexture#error
	         * @param {PIXI.BaseTexture} baseTexture - Resource errored.
	         */

	        /**
	         * Fired when BaseTexture is updated.
	         *
	         * @protected
	         * @event PIXI.BaseTexture#update
	         * @param {PIXI.BaseTexture} baseTexture - Instance of texture being updated.
	         */

	        /**
	         * Fired when BaseTexture is destroyed.
	         *
	         * @protected
	         * @event PIXI.BaseTexture#dispose
	         * @param {PIXI.BaseTexture} baseTexture - Instance of texture being destroyed.
	         */
	        return _this;
	    }

	    /**
	     * Updates the texture on all the webgl renderers, this also assumes the src has changed.
	     *
	     * @fires PIXI.BaseTexture#update
	     */


	    BaseTexture.prototype.update = function update() {
	        // Svg size is handled during load
	        if (this.imageType !== 'svg') {
	            this.realWidth = this.source.naturalWidth || this.source.videoWidth || this.source.width;
	            this.realHeight = this.source.naturalHeight || this.source.videoHeight || this.source.height;

	            this._updateDimensions();
	        }

	        this.emit('update', this);
	    };

	    /**
	     * Update dimensions from real values
	     */


	    BaseTexture.prototype._updateDimensions = function _updateDimensions() {
	        this.width = this.realWidth / this.resolution;
	        this.height = this.realHeight / this.resolution;

	        this.isPowerOfTwo = _bitTwiddle2.default.isPow2(this.realWidth) && _bitTwiddle2.default.isPow2(this.realHeight);
	    };

	    /**
	     * Load a source.
	     *
	     * If the source is not-immediately-available, such as an image that needs to be
	     * downloaded, then the 'loaded' or 'error' event will be dispatched in the future
	     * and `hasLoaded` will remain false after this call.
	     *
	     * The logic state after calling `loadSource` directly or indirectly (eg. `fromImage`, `new BaseTexture`) is:
	     *
	     *     if (texture.hasLoaded) {
	     *        // texture ready for use
	     *     } else if (texture.isLoading) {
	     *        // listen to 'loaded' and/or 'error' events on texture
	     *     } else {
	     *        // not loading, not going to load UNLESS the source is reloaded
	     *        // (it may still make sense to listen to the events)
	     *     }
	     *
	     * @protected
	     * @param {HTMLImageElement|HTMLCanvasElement} source - the source object of the texture.
	     */


	    BaseTexture.prototype.loadSource = function loadSource(source) {
	        var wasLoading = this.isLoading;

	        this.hasLoaded = false;
	        this.isLoading = false;

	        if (wasLoading && this.source) {
	            this.source.onload = null;
	            this.source.onerror = null;
	        }

	        var firstSourceLoaded = !this.source;

	        this.source = source;

	        // Apply source if loaded. Otherwise setup appropriate loading monitors.
	        if ((source.src && source.complete || source.getContext) && source.width && source.height) {
	            this._updateImageType();

	            if (this.imageType === 'svg') {
	                this._loadSvgSource();
	            } else {
	                this._sourceLoaded();
	            }

	            if (firstSourceLoaded) {
	                // send loaded event if previous source was null and we have been passed a pre-loaded IMG element
	                this.emit('loaded', this);
	            }
	        } else if (!source.getContext) {
	            // Image fail / not ready
	            this.isLoading = true;

	            var scope = this;

	            source.onload = function () {
	                scope._updateImageType();
	                source.onload = null;
	                source.onerror = null;

	                if (!scope.isLoading) {
	                    return;
	                }

	                scope.isLoading = false;
	                scope._sourceLoaded();

	                if (scope.imageType === 'svg') {
	                    scope._loadSvgSource();

	                    return;
	                }

	                scope.emit('loaded', scope);
	            };

	            source.onerror = function () {
	                source.onload = null;
	                source.onerror = null;

	                if (!scope.isLoading) {
	                    return;
	                }

	                scope.isLoading = false;
	                scope.emit('error', scope);
	            };

	            // Per http://www.w3.org/TR/html5/embedded-content-0.html#the-img-element
	            //   "The value of `complete` can thus change while a script is executing."
	            // So complete needs to be re-checked after the callbacks have been added..
	            // NOTE: complete will be true if the image has no src so best to check if the src is set.
	            if (source.complete && source.src) {
	                // ..and if we're complete now, no need for callbacks
	                source.onload = null;
	                source.onerror = null;

	                if (scope.imageType === 'svg') {
	                    scope._loadSvgSource();

	                    return;
	                }

	                this.isLoading = false;

	                if (source.width && source.height) {
	                    this._sourceLoaded();

	                    // If any previous subscribers possible
	                    if (wasLoading) {
	                        this.emit('loaded', this);
	                    }
	                }
	                // If any previous subscribers possible
	                else if (wasLoading) {
	                        this.emit('error', this);
	                    }
	            }
	        }
	    };

	    /**
	     * Updates type of the source image.
	     */


	    BaseTexture.prototype._updateImageType = function _updateImageType() {
	        if (!this.imageUrl) {
	            return;
	        }

	        var dataUri = (0, _utils.decomposeDataUri)(this.imageUrl);
	        var imageType = void 0;

	        if (dataUri && dataUri.mediaType === 'image') {
	            // Check for subType validity
	            var firstSubType = dataUri.subType.split('+')[0];

	            imageType = (0, _utils.getUrlFileExtension)('.' + firstSubType);

	            if (!imageType) {
	                throw new Error('Invalid image type in data URI.');
	            }
	        } else {
	            imageType = (0, _utils.getUrlFileExtension)(this.imageUrl);

	            if (!imageType) {
	                imageType = 'png';
	            }
	        }

	        this.imageType = imageType;
	    };

	    /**
	     * Checks if `source` is an SVG image and whether it's loaded via a URL or a data URI. Then calls
	     * `_loadSvgSourceUsingDataUri` or `_loadSvgSourceUsingXhr`.
	     */


	    BaseTexture.prototype._loadSvgSource = function _loadSvgSource() {
	        if (this.imageType !== 'svg') {
	            // Do nothing if source is not svg
	            return;
	        }

	        var dataUri = (0, _utils.decomposeDataUri)(this.imageUrl);

	        if (dataUri) {
	            this._loadSvgSourceUsingDataUri(dataUri);
	        } else {
	            // We got an URL, so we need to do an XHR to check the svg size
	            this._loadSvgSourceUsingXhr();
	        }
	    };

	    /**
	     * Reads an SVG string from data URI and then calls `_loadSvgSourceUsingString`.
	     *
	     * @param {string} dataUri - The data uri to load from.
	     */


	    BaseTexture.prototype._loadSvgSourceUsingDataUri = function _loadSvgSourceUsingDataUri(dataUri) {
	        var svgString = void 0;

	        if (dataUri.encoding === 'base64') {
	            if (!atob) {
	                throw new Error('Your browser doesn\'t support base64 conversions.');
	            }
	            svgString = atob(dataUri.data);
	        } else {
	            svgString = dataUri.data;
	        }

	        this._loadSvgSourceUsingString(svgString);
	    };

	    /**
	     * Loads an SVG string from `imageUrl` using XHR and then calls `_loadSvgSourceUsingString`.
	     */


	    BaseTexture.prototype._loadSvgSourceUsingXhr = function _loadSvgSourceUsingXhr() {
	        var _this2 = this;

	        var svgXhr = new XMLHttpRequest();

	        // This throws error on IE, so SVG Document can't be used
	        // svgXhr.responseType = 'document';

	        // This is not needed since we load the svg as string (breaks IE too)
	        // but overrideMimeType() can be used to force the response to be parsed as XML
	        // svgXhr.overrideMimeType('image/svg+xml');

	        svgXhr.onload = function () {
	            if (svgXhr.readyState !== svgXhr.DONE || svgXhr.status !== 200) {
	                throw new Error('Failed to load SVG using XHR.');
	            }

	            _this2._loadSvgSourceUsingString(svgXhr.response);
	        };

	        svgXhr.onerror = function () {
	            return _this2.emit('error', _this2);
	        };

	        svgXhr.open('GET', this.imageUrl, true);
	        svgXhr.send();
	    };

	    /**
	     * Loads texture using an SVG string. The original SVG Image is stored as `origSource` and the
	     * created canvas is the new `source`. The SVG is scaled using `sourceScale`. Called by
	     * `_loadSvgSourceUsingXhr` or `_loadSvgSourceUsingDataUri`.
	     *
	     * @param  {string} svgString SVG source as string
	     *
	     * @fires PIXI.BaseTexture#loaded
	     */


	    BaseTexture.prototype._loadSvgSourceUsingString = function _loadSvgSourceUsingString(svgString) {
	        var svgSize = (0, _utils.getSvgSize)(svgString);

	        var svgWidth = svgSize.width;
	        var svgHeight = svgSize.height;

	        if (!svgWidth || !svgHeight) {
	            throw new Error('The SVG image must have width and height defined (in pixels), canvas API needs them.');
	        }

	        // Scale realWidth and realHeight
	        this.realWidth = Math.round(svgWidth * this.sourceScale);
	        this.realHeight = Math.round(svgHeight * this.sourceScale);

	        this._updateDimensions();

	        // Create a canvas element
	        var canvas = document.createElement('canvas');

	        canvas.width = this.realWidth;
	        canvas.height = this.realHeight;
	        canvas._pixiId = 'canvas_' + (0, _utils.uid)();

	        // Draw the Svg to the canvas
	        canvas.getContext('2d').drawImage(this.source, 0, 0, svgWidth, svgHeight, 0, 0, this.realWidth, this.realHeight);

	        // Replace the original source image with the canvas
	        this.origSource = this.source;
	        this.source = canvas;

	        // Add also the canvas in cache (destroy clears by `imageUrl` and `source._pixiId`)
	        BaseTexture.addToCache(this, canvas._pixiId);

	        this.isLoading = false;
	        this._sourceLoaded();
	        this.emit('loaded', this);
	    };

	    /**
	     * Used internally to update the width, height, and some other tracking vars once
	     * a source has successfully loaded.
	     *
	     * @private
	     */


	    BaseTexture.prototype._sourceLoaded = function _sourceLoaded() {
	        this.hasLoaded = true;
	        this.update();
	    };

	    /**
	     * Destroys this base texture
	     *
	     */


	    BaseTexture.prototype.destroy = function destroy() {
	        if (this.imageUrl) {
	            delete _utils.TextureCache[this.imageUrl];

	            this.imageUrl = null;

	            if (!navigator.isCocoonJS) {
	                this.source.src = '';
	            }
	        }

	        this.source = null;

	        this.dispose();

	        BaseTexture.removeFromCache(this);
	        this.textureCacheIds = null;

	        this._destroyed = true;
	    };

	    /**
	     * Frees the texture from WebGL memory without destroying this texture object.
	     * This means you can still use the texture later which will upload it to GPU
	     * memory again.
	     *
	     * @fires PIXI.BaseTexture#dispose
	     */


	    BaseTexture.prototype.dispose = function dispose() {
	        this.emit('dispose', this);
	    };

	    /**
	     * Changes the source image of the texture.
	     * The original source must be an Image element.
	     *
	     * @param {string} newSrc - the path of the image
	     */


	    BaseTexture.prototype.updateSourceImage = function updateSourceImage(newSrc) {
	        this.source.src = newSrc;

	        this.loadSource(this.source);
	    };

	    /**
	     * Helper function that creates a base texture from the given image url.
	     * If the image is not in the base texture cache it will be created and loaded.
	     *
	     * @static
	     * @param {string} imageUrl - The image url of the texture
	     * @param {boolean} [crossorigin=(auto)] - Should use anonymous CORS? Defaults to true if the URL is not a data-URI.
	     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
	     * @param {number} [sourceScale=(auto)] - Scale for the original image, used with Svg images.
	     * @return {PIXI.BaseTexture} The new base texture.
	     */


	    BaseTexture.fromImage = function fromImage(imageUrl, crossorigin, scaleMode, sourceScale) {
	        var baseTexture = _utils.BaseTextureCache[imageUrl];

	        if (!baseTexture) {
	            // new Image() breaks tex loading in some versions of Chrome.
	            // See https://code.google.com/p/chromium/issues/detail?id=238071
	            var image = new Image(); // document.createElement('img');

	            if (crossorigin === undefined && imageUrl.indexOf('data:') !== 0) {
	                image.crossOrigin = (0, _determineCrossOrigin2.default)(imageUrl);
	            } else if (crossorigin) {
	                image.crossOrigin = typeof crossorigin === 'string' ? crossorigin : 'anonymous';
	            }

	            baseTexture = new BaseTexture(image, scaleMode);
	            baseTexture.imageUrl = imageUrl;

	            if (sourceScale) {
	                baseTexture.sourceScale = sourceScale;
	            }

	            // if there is an @2x at the end of the url we are going to assume its a highres image
	            baseTexture.resolution = (0, _utils.getResolutionOfUrl)(imageUrl);

	            image.src = imageUrl; // Setting this triggers load

	            BaseTexture.addToCache(baseTexture, imageUrl);
	        }

	        return baseTexture;
	    };

	    /**
	     * Helper function that creates a base texture from the given canvas element.
	     *
	     * @static
	     * @param {HTMLCanvasElement} canvas - The canvas element source of the texture
	     * @param {number} scaleMode - See {@link PIXI.SCALE_MODES} for possible values
	     * @param {string} [origin='canvas'] - A string origin of who created the base texture
	     * @return {PIXI.BaseTexture} The new base texture.
	     */


	    BaseTexture.fromCanvas = function fromCanvas(canvas, scaleMode) {
	        var origin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'canvas';

	        if (!canvas._pixiId) {
	            canvas._pixiId = origin + '_' + (0, _utils.uid)();
	        }

	        var baseTexture = _utils.BaseTextureCache[canvas._pixiId];

	        if (!baseTexture) {
	            baseTexture = new BaseTexture(canvas, scaleMode);
	            BaseTexture.addToCache(baseTexture, canvas._pixiId);
	        }

	        return baseTexture;
	    };

	    /**
	     * Helper function that creates a base texture based on the source you provide.
	     * The source can be - image url, image element, canvas element. If the
	     * source is an image url or an image element and not in the base texture
	     * cache, it will be created and loaded.
	     *
	     * @static
	     * @param {string|HTMLImageElement|HTMLCanvasElement} source - The source to create base texture from.
	     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
	     * @param {number} [sourceScale=(auto)] - Scale for the original image, used with Svg images.
	     * @return {PIXI.BaseTexture} The new base texture.
	     */


	    BaseTexture.from = function from(source, scaleMode, sourceScale) {
	        if (typeof source === 'string') {
	            return BaseTexture.fromImage(source, undefined, scaleMode, sourceScale);
	        } else if (source instanceof HTMLImageElement) {
	            var imageUrl = source.src;
	            var baseTexture = _utils.BaseTextureCache[imageUrl];

	            if (!baseTexture) {
	                baseTexture = new BaseTexture(source, scaleMode);
	                baseTexture.imageUrl = imageUrl;

	                if (sourceScale) {
	                    baseTexture.sourceScale = sourceScale;
	                }

	                // if there is an @2x at the end of the url we are going to assume its a highres image
	                baseTexture.resolution = (0, _utils.getResolutionOfUrl)(imageUrl);

	                BaseTexture.addToCache(baseTexture, imageUrl);
	            }

	            return baseTexture;
	        } else if (source instanceof HTMLCanvasElement) {
	            return BaseTexture.fromCanvas(source, scaleMode);
	        }

	        // lets assume its a base texture!
	        return source;
	    };

	    /**
	     * Adds a BaseTexture to the global BaseTextureCache. This cache is shared across the whole PIXI object.
	     *
	     * @static
	     * @param {PIXI.BaseTexture} baseTexture - The BaseTexture to add to the cache.
	     * @param {string} id - The id that the BaseTexture will be stored against.
	     */


	    BaseTexture.addToCache = function addToCache(baseTexture, id) {
	        if (id) {
	            if (baseTexture.textureCacheIds.indexOf(id) === -1) {
	                baseTexture.textureCacheIds.push(id);
	            }

	            // @if DEBUG
	            /* eslint-disable no-console */
	            if (_utils.BaseTextureCache[id]) {
	                console.warn('BaseTexture added to the cache with an id [' + id + '] that already had an entry');
	            }
	            /* eslint-enable no-console */
	            // @endif

	            _utils.BaseTextureCache[id] = baseTexture;
	        }
	    };

	    /**
	     * Remove a BaseTexture from the global BaseTextureCache.
	     *
	     * @static
	     * @param {string|PIXI.BaseTexture} baseTexture - id of a BaseTexture to be removed, or a BaseTexture instance itself.
	     * @return {PIXI.BaseTexture|null} The BaseTexture that was removed.
	     */


	    BaseTexture.removeFromCache = function removeFromCache(baseTexture) {
	        if (typeof baseTexture === 'string') {
	            var baseTextureFromCache = _utils.BaseTextureCache[baseTexture];

	            if (baseTextureFromCache) {
	                var index = baseTextureFromCache.textureCacheIds.indexOf(baseTexture);

	                if (index > -1) {
	                    baseTextureFromCache.textureCacheIds.splice(index, 1);
	                }

	                delete _utils.BaseTextureCache[baseTexture];

	                return baseTextureFromCache;
	            }
	        } else if (baseTexture && baseTexture.textureCacheIds) {
	            for (var i = 0; i < baseTexture.textureCacheIds.length; ++i) {
	                delete _utils.BaseTextureCache[baseTexture.textureCacheIds[i]];
	            }

	            baseTexture.textureCacheIds.length = 0;

	            return baseTexture;
	        }

	        return null;
	    };

	    return BaseTexture;
	}(_eventemitter2.default);

	exports.default = BaseTexture;
	//# sourceMappingURL=BaseTexture.js.map

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;
	exports.default = determineCrossOrigin;

	var _url2 = __webpack_require__(223);

	var _url3 = _interopRequireDefault(_url2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var tempAnchor = void 0;

	/**
	 * Sets the `crossOrigin` property for this resource based on if the url
	 * for this resource is cross-origin. If crossOrigin was manually set, this
	 * function does nothing.
	 * Nipped from the resource loader!
	 *
	 * @ignore
	 * @param {string} url - The url to test.
	 * @param {object} [loc=window.location] - The location object to test against.
	 * @return {string} The crossOrigin value to use (or empty string for none).
	 */
	function determineCrossOrigin(url) {
	    var loc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location;

	    // data: and javascript: urls are considered same-origin
	    if (url.indexOf('data:') === 0) {
	        return '';
	    }

	    // default is window.location
	    loc = loc || window.location;

	    if (!tempAnchor) {
	        tempAnchor = document.createElement('a');
	    }

	    // let the browser determine the full href for the url of this resource and then
	    // parse with the node url lib, we can't use the properties of the anchor element
	    // because they don't work in IE9 :(
	    tempAnchor.href = url;
	    url = _url3.default.parse(tempAnchor.href);

	    var samePort = !url.port && loc.port === '' || url.port === loc.port;

	    // if cross origin
	    if (url.hostname !== loc.hostname || !samePort || url.protocol !== loc.protocol) {
	        return 'anonymous';
	    }

	    return '';
	}
	//# sourceMappingURL=determineCrossOrigin.js.map

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	var punycode = __webpack_require__(224);

	exports.parse = urlParse;
	exports.resolve = urlResolve;
	exports.resolveObject = urlResolveObject;
	exports.format = urlFormat;

	exports.Url = Url;

	function Url() {
	  this.protocol = null;
	  this.slashes = null;
	  this.auth = null;
	  this.host = null;
	  this.port = null;
	  this.hostname = null;
	  this.hash = null;
	  this.search = null;
	  this.query = null;
	  this.pathname = null;
	  this.path = null;
	  this.href = null;
	}

	// Reference: RFC 3986, RFC 1808, RFC 2396

	// define these here so at least they only have to be
	// compiled once on the first module load.
	var protocolPattern = /^([a-z0-9.+-]+:)/i,
	    portPattern = /:[0-9]*$/,

	    // RFC 2396: characters reserved for delimiting URLs.
	    // We actually just auto-escape these.
	    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

	    // RFC 2396: characters not allowed for various reasons.
	    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

	    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
	    autoEscape = ['\''].concat(unwise),
	    // Characters that are never ever allowed in a hostname.
	    // Note that any invalid chars are also handled, but these
	    // are the ones that are *expected* to be seen, so we fast-path
	    // them.
	    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
	    hostEndingChars = ['/', '?', '#'],
	    hostnameMaxLen = 255,
	    hostnamePartPattern = /^[a-z0-9A-Z_-]{0,63}$/,
	    hostnamePartStart = /^([a-z0-9A-Z_-]{0,63})(.*)$/,
	    // protocols that can allow "unsafe" and "unwise" chars.
	    unsafeProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that never have a hostname.
	    hostlessProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that always contain a // bit.
	    slashedProtocol = {
	      'http': true,
	      'https': true,
	      'ftp': true,
	      'gopher': true,
	      'file': true,
	      'http:': true,
	      'https:': true,
	      'ftp:': true,
	      'gopher:': true,
	      'file:': true
	    },
	    querystring = __webpack_require__(225);

	function urlParse(url, parseQueryString, slashesDenoteHost) {
	  if (url && isObject(url) && url instanceof Url) return url;

	  var u = new Url;
	  u.parse(url, parseQueryString, slashesDenoteHost);
	  return u;
	}

	Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
	  if (!isString(url)) {
	    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
	  }

	  var rest = url;

	  // trim before proceeding.
	  // This is to support parse stuff like "  http://foo.com  \n"
	  rest = rest.trim();

	  var proto = protocolPattern.exec(rest);
	  if (proto) {
	    proto = proto[0];
	    var lowerProto = proto.toLowerCase();
	    this.protocol = lowerProto;
	    rest = rest.substr(proto.length);
	  }

	  // figure out if it's got a host
	  // user@server is *always* interpreted as a hostname, and url
	  // resolution will treat //foo/bar as host=foo,path=bar because that's
	  // how the browser resolves relative URLs.
	  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
	    var slashes = rest.substr(0, 2) === '//';
	    if (slashes && !(proto && hostlessProtocol[proto])) {
	      rest = rest.substr(2);
	      this.slashes = true;
	    }
	  }

	  if (!hostlessProtocol[proto] &&
	      (slashes || (proto && !slashedProtocol[proto]))) {

	    // there's a hostname.
	    // the first instance of /, ?, ;, or # ends the host.
	    //
	    // If there is an @ in the hostname, then non-host chars *are* allowed
	    // to the left of the last @ sign, unless some host-ending character
	    // comes *before* the @-sign.
	    // URLs are obnoxious.
	    //
	    // ex:
	    // http://a@b@c/ => user:a@b host:c
	    // http://a@b?@c => user:a host:c path:/?@c

	    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
	    // Review our test case against browsers more comprehensively.

	    // find the first instance of any hostEndingChars
	    var hostEnd = -1;
	    for (var i = 0; i < hostEndingChars.length; i++) {
	      var hec = rest.indexOf(hostEndingChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }

	    // at this point, either we have an explicit point where the
	    // auth portion cannot go past, or the last @ char is the decider.
	    var auth, atSign;
	    if (hostEnd === -1) {
	      // atSign can be anywhere.
	      atSign = rest.lastIndexOf('@');
	    } else {
	      // atSign must be in auth portion.
	      // http://a@b/c@d => host:b auth:a path:/c@d
	      atSign = rest.lastIndexOf('@', hostEnd);
	    }

	    // Now we have a portion which is definitely the auth.
	    // Pull that off.
	    if (atSign !== -1) {
	      auth = rest.slice(0, atSign);
	      rest = rest.slice(atSign + 1);
	      this.auth = decodeURIComponent(auth);
	    }

	    // the host is the remaining to the left of the first non-host char
	    hostEnd = -1;
	    for (var i = 0; i < nonHostChars.length; i++) {
	      var hec = rest.indexOf(nonHostChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	    // if we still have not hit it, then the entire thing is a host.
	    if (hostEnd === -1)
	      hostEnd = rest.length;

	    this.host = rest.slice(0, hostEnd);
	    rest = rest.slice(hostEnd);

	    // pull out port.
	    this.parseHost();

	    // we've indicated that there is a hostname,
	    // so even if it's empty, it has to be present.
	    this.hostname = this.hostname || '';

	    // if hostname begins with [ and ends with ]
	    // assume that it's an IPv6 address.
	    var ipv6Hostname = this.hostname[0] === '[' &&
	        this.hostname[this.hostname.length - 1] === ']';

	    // validate a little.
	    if (!ipv6Hostname) {
	      var hostparts = this.hostname.split(/\./);
	      for (var i = 0, l = hostparts.length; i < l; i++) {
	        var part = hostparts[i];
	        if (!part) continue;
	        if (!part.match(hostnamePartPattern)) {
	          var newpart = '';
	          for (var j = 0, k = part.length; j < k; j++) {
	            if (part.charCodeAt(j) > 127) {
	              // we replace non-ASCII char with a temporary placeholder
	              // we need this to make sure size of hostname is not
	              // broken by replacing non-ASCII by nothing
	              newpart += 'x';
	            } else {
	              newpart += part[j];
	            }
	          }
	          // we test again with ASCII char only
	          if (!newpart.match(hostnamePartPattern)) {
	            var validParts = hostparts.slice(0, i);
	            var notHost = hostparts.slice(i + 1);
	            var bit = part.match(hostnamePartStart);
	            if (bit) {
	              validParts.push(bit[1]);
	              notHost.unshift(bit[2]);
	            }
	            if (notHost.length) {
	              rest = '/' + notHost.join('.') + rest;
	            }
	            this.hostname = validParts.join('.');
	            break;
	          }
	        }
	      }
	    }

	    if (this.hostname.length > hostnameMaxLen) {
	      this.hostname = '';
	    } else {
	      // hostnames are always lower case.
	      this.hostname = this.hostname.toLowerCase();
	    }

	    if (!ipv6Hostname) {
	      // IDNA Support: Returns a puny coded representation of "domain".
	      // It only converts the part of the domain name that
	      // has non ASCII characters. I.e. it dosent matter if
	      // you call it with a domain that already is in ASCII.
	      var domainArray = this.hostname.split('.');
	      var newOut = [];
	      for (var i = 0; i < domainArray.length; ++i) {
	        var s = domainArray[i];
	        newOut.push(s.match(/[^A-Za-z0-9_-]/) ?
	            'xn--' + punycode.encode(s) : s);
	      }
	      this.hostname = newOut.join('.');
	    }

	    var p = this.port ? ':' + this.port : '';
	    var h = this.hostname || '';
	    this.host = h + p;
	    this.href += this.host;

	    // strip [ and ] from the hostname
	    // the host field still retains them, though
	    if (ipv6Hostname) {
	      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
	      if (rest[0] !== '/') {
	        rest = '/' + rest;
	      }
	    }
	  }

	  // now rest is set to the post-host stuff.
	  // chop off any delim chars.
	  if (!unsafeProtocol[lowerProto]) {

	    // First, make 100% sure that any "autoEscape" chars get
	    // escaped, even if encodeURIComponent doesn't think they
	    // need to be.
	    for (var i = 0, l = autoEscape.length; i < l; i++) {
	      var ae = autoEscape[i];
	      var esc = encodeURIComponent(ae);
	      if (esc === ae) {
	        esc = escape(ae);
	      }
	      rest = rest.split(ae).join(esc);
	    }
	  }


	  // chop off from the tail first.
	  var hash = rest.indexOf('#');
	  if (hash !== -1) {
	    // got a fragment string.
	    this.hash = rest.substr(hash);
	    rest = rest.slice(0, hash);
	  }
	  var qm = rest.indexOf('?');
	  if (qm !== -1) {
	    this.search = rest.substr(qm);
	    this.query = rest.substr(qm + 1);
	    if (parseQueryString) {
	      this.query = querystring.parse(this.query);
	    }
	    rest = rest.slice(0, qm);
	  } else if (parseQueryString) {
	    // no query string, but parseQueryString still requested
	    this.search = '';
	    this.query = {};
	  }
	  if (rest) this.pathname = rest;
	  if (slashedProtocol[lowerProto] &&
	      this.hostname && !this.pathname) {
	    this.pathname = '/';
	  }

	  //to support http.request
	  if (this.pathname || this.search) {
	    var p = this.pathname || '';
	    var s = this.search || '';
	    this.path = p + s;
	  }

	  // finally, reconstruct the href based on what has been validated.
	  this.href = this.format();
	  return this;
	};

	// format a parsed object into a url string
	function urlFormat(obj) {
	  // ensure it's an object, and not a string url.
	  // If it's an obj, this is a no-op.
	  // this way, you can call url_format() on strings
	  // to clean up potentially wonky urls.
	  if (isString(obj)) obj = urlParse(obj);
	  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
	  return obj.format();
	}

	Url.prototype.format = function() {
	  var auth = this.auth || '';
	  if (auth) {
	    auth = encodeURIComponent(auth);
	    auth = auth.replace(/%3A/i, ':');
	    auth += '@';
	  }

	  var protocol = this.protocol || '',
	      pathname = this.pathname || '',
	      hash = this.hash || '',
	      host = false,
	      query = '';

	  if (this.host) {
	    host = auth + this.host;
	  } else if (this.hostname) {
	    host = auth + (this.hostname.indexOf(':') === -1 ?
	        this.hostname :
	        '[' + this.hostname + ']');
	    if (this.port) {
	      host += ':' + this.port;
	    }
	  }

	  if (this.query &&
	      isObject(this.query) &&
	      Object.keys(this.query).length) {
	    query = querystring.stringify(this.query);
	  }

	  var search = this.search || (query && ('?' + query)) || '';

	  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

	  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
	  // unless they had them to begin with.
	  if (this.slashes ||
	      (!protocol || slashedProtocol[protocol]) && host !== false) {
	    host = '//' + (host || '');
	    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
	  } else if (!host) {
	    host = '';
	  }

	  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
	  if (search && search.charAt(0) !== '?') search = '?' + search;

	  pathname = pathname.replace(/[?#]/g, function(match) {
	    return encodeURIComponent(match);
	  });
	  search = search.replace('#', '%23');

	  return protocol + host + pathname + search + hash;
	};

	function urlResolve(source, relative) {
	  return urlParse(source, false, true).resolve(relative);
	}

	Url.prototype.resolve = function(relative) {
	  return this.resolveObject(urlParse(relative, false, true)).format();
	};

	function urlResolveObject(source, relative) {
	  if (!source) return relative;
	  return urlParse(source, false, true).resolveObject(relative);
	}

	Url.prototype.resolveObject = function(relative) {
	  if (isString(relative)) {
	    var rel = new Url();
	    rel.parse(relative, false, true);
	    relative = rel;
	  }

	  var result = new Url();
	  Object.keys(this).forEach(function(k) {
	    result[k] = this[k];
	  }, this);

	  // hash is always overridden, no matter what.
	  // even href="" will remove it.
	  result.hash = relative.hash;

	  // if the relative url is empty, then there's nothing left to do here.
	  if (relative.href === '') {
	    result.href = result.format();
	    return result;
	  }

	  // hrefs like //foo/bar always cut to the protocol.
	  if (relative.slashes && !relative.protocol) {
	    // take everything except the protocol from relative
	    Object.keys(relative).forEach(function(k) {
	      if (k !== 'protocol')
	        result[k] = relative[k];
	    });

	    //urlParse appends trailing / to urls like http://www.example.com
	    if (slashedProtocol[result.protocol] &&
	        result.hostname && !result.pathname) {
	      result.path = result.pathname = '/';
	    }

	    result.href = result.format();
	    return result;
	  }

	  if (relative.protocol && relative.protocol !== result.protocol) {
	    // if it's a known url protocol, then changing
	    // the protocol does weird things
	    // first, if it's not file:, then we MUST have a host,
	    // and if there was a path
	    // to begin with, then we MUST have a path.
	    // if it is file:, then the host is dropped,
	    // because that's known to be hostless.
	    // anything else is assumed to be absolute.
	    if (!slashedProtocol[relative.protocol]) {
	      Object.keys(relative).forEach(function(k) {
	        result[k] = relative[k];
	      });
	      result.href = result.format();
	      return result;
	    }

	    result.protocol = relative.protocol;
	    if (!relative.host && !hostlessProtocol[relative.protocol]) {
	      var relPath = (relative.pathname || '').split('/');
	      while (relPath.length && !(relative.host = relPath.shift()));
	      if (!relative.host) relative.host = '';
	      if (!relative.hostname) relative.hostname = '';
	      if (relPath[0] !== '') relPath.unshift('');
	      if (relPath.length < 2) relPath.unshift('');
	      result.pathname = relPath.join('/');
	    } else {
	      result.pathname = relative.pathname;
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    result.host = relative.host || '';
	    result.auth = relative.auth;
	    result.hostname = relative.hostname || relative.host;
	    result.port = relative.port;
	    // to support http.request
	    if (result.pathname || result.search) {
	      var p = result.pathname || '';
	      var s = result.search || '';
	      result.path = p + s;
	    }
	    result.slashes = result.slashes || relative.slashes;
	    result.href = result.format();
	    return result;
	  }

	  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
	      isRelAbs = (
	          relative.host ||
	          relative.pathname && relative.pathname.charAt(0) === '/'
	      ),
	      mustEndAbs = (isRelAbs || isSourceAbs ||
	                    (result.host && relative.pathname)),
	      removeAllDots = mustEndAbs,
	      srcPath = result.pathname && result.pathname.split('/') || [],
	      relPath = relative.pathname && relative.pathname.split('/') || [],
	      psychotic = result.protocol && !slashedProtocol[result.protocol];

	  // if the url is a non-slashed url, then relative
	  // links like ../.. should be able
	  // to crawl up to the hostname, as well.  This is strange.
	  // result.protocol has already been set by now.
	  // Later on, put the first path part into the host field.
	  if (psychotic) {
	    result.hostname = '';
	    result.port = null;
	    if (result.host) {
	      if (srcPath[0] === '') srcPath[0] = result.host;
	      else srcPath.unshift(result.host);
	    }
	    result.host = '';
	    if (relative.protocol) {
	      relative.hostname = null;
	      relative.port = null;
	      if (relative.host) {
	        if (relPath[0] === '') relPath[0] = relative.host;
	        else relPath.unshift(relative.host);
	      }
	      relative.host = null;
	    }
	    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
	  }

	  if (isRelAbs) {
	    // it's absolute.
	    result.host = (relative.host || relative.host === '') ?
	                  relative.host : result.host;
	    result.hostname = (relative.hostname || relative.hostname === '') ?
	                      relative.hostname : result.hostname;
	    result.search = relative.search;
	    result.query = relative.query;
	    srcPath = relPath;
	    // fall through to the dot-handling below.
	  } else if (relPath.length) {
	    // it's relative
	    // throw away the existing file, and take the new path instead.
	    if (!srcPath) srcPath = [];
	    srcPath.pop();
	    srcPath = srcPath.concat(relPath);
	    result.search = relative.search;
	    result.query = relative.query;
	  } else if (!isNullOrUndefined(relative.search)) {
	    // just pull out the search.
	    // like href='?foo'.
	    // Put this after the other two cases because it simplifies the booleans
	    if (psychotic) {
	      result.hostname = result.host = srcPath.shift();
	      //occationaly the auth can get stuck only in host
	      //this especialy happens in cases like
	      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	      var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                       result.host.split('@') : false;
	      if (authInHost) {
	        result.auth = authInHost.shift();
	        result.host = result.hostname = authInHost.shift();
	      }
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    //to support http.request
	    if (!isNull(result.pathname) || !isNull(result.search)) {
	      result.path = (result.pathname ? result.pathname : '') +
	                    (result.search ? result.search : '');
	    }
	    result.href = result.format();
	    return result;
	  }

	  if (!srcPath.length) {
	    // no path at all.  easy.
	    // we've already handled the other stuff above.
	    result.pathname = null;
	    //to support http.request
	    if (result.search) {
	      result.path = '/' + result.search;
	    } else {
	      result.path = null;
	    }
	    result.href = result.format();
	    return result;
	  }

	  // if a url ENDs in . or .., then it must get a trailing slash.
	  // however, if it ends in anything else non-slashy,
	  // then it must NOT get a trailing slash.
	  var last = srcPath.slice(-1)[0];
	  var hasTrailingSlash = (
	      (result.host || relative.host) && (last === '.' || last === '..') ||
	      last === '');

	  // strip single dots, resolve double dots to parent dir
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = srcPath.length; i >= 0; i--) {
	    last = srcPath[i];
	    if (last == '.') {
	      srcPath.splice(i, 1);
	    } else if (last === '..') {
	      srcPath.splice(i, 1);
	      up++;
	    } else if (up) {
	      srcPath.splice(i, 1);
	      up--;
	    }
	  }

	  // if the path is allowed to go above the root, restore leading ..s
	  if (!mustEndAbs && !removeAllDots) {
	    for (; up--; up) {
	      srcPath.unshift('..');
	    }
	  }

	  if (mustEndAbs && srcPath[0] !== '' &&
	      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
	    srcPath.unshift('');
	  }

	  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
	    srcPath.push('');
	  }

	  var isAbsolute = srcPath[0] === '' ||
	      (srcPath[0] && srcPath[0].charAt(0) === '/');

	  // put the host back
	  if (psychotic) {
	    result.hostname = result.host = isAbsolute ? '' :
	                                    srcPath.length ? srcPath.shift() : '';
	    //occationaly the auth can get stuck only in host
	    //this especialy happens in cases like
	    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	    var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                     result.host.split('@') : false;
	    if (authInHost) {
	      result.auth = authInHost.shift();
	      result.host = result.hostname = authInHost.shift();
	    }
	  }

	  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

	  if (mustEndAbs && !isAbsolute) {
	    srcPath.unshift('');
	  }

	  if (!srcPath.length) {
	    result.pathname = null;
	    result.path = null;
	  } else {
	    result.pathname = srcPath.join('/');
	  }

	  //to support request.http
	  if (!isNull(result.pathname) || !isNull(result.search)) {
	    result.path = (result.pathname ? result.pathname : '') +
	                  (result.search ? result.search : '');
	  }
	  result.auth = relative.auth || result.auth;
	  result.slashes = result.slashes || relative.slashes;
	  result.href = result.format();
	  return result;
	};

	Url.prototype.parseHost = function() {
	  var host = this.host;
	  var port = portPattern.exec(host);
	  if (port) {
	    port = port[0];
	    if (port !== ':') {
	      this.port = port.substr(1);
	    }
	    host = host.substr(0, host.length - port.length);
	  }
	  if (host) this.hostname = host;
	};

	function isString(arg) {
	  return typeof arg === "string";
	}

	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}

	function isNull(arg) {
	  return arg === null;
	}
	function isNullOrUndefined(arg) {
	  return  arg == null;
	}


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/punycode v1.3.2 by @mathias */
	;(function(root) {

		/** Detect free variables */
		var freeExports = typeof exports == 'object' && exports &&
			!exports.nodeType && exports;
		var freeModule = typeof module == 'object' && module &&
			!module.nodeType && module;
		var freeGlobal = typeof global == 'object' && global;
		if (
			freeGlobal.global === freeGlobal ||
			freeGlobal.window === freeGlobal ||
			freeGlobal.self === freeGlobal
		) {
			root = freeGlobal;
		}

		/**
		 * The `punycode` object.
		 * @name punycode
		 * @type Object
		 */
		var punycode,

		/** Highest positive signed 32-bit float value */
		maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

		/** Bootstring parameters */
		base = 36,
		tMin = 1,
		tMax = 26,
		skew = 38,
		damp = 700,
		initialBias = 72,
		initialN = 128, // 0x80
		delimiter = '-', // '\x2D'

		/** Regular expressions */
		regexPunycode = /^xn--/,
		regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
		regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

		/** Error messages */
		errors = {
			'overflow': 'Overflow: input needs wider integers to process',
			'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
			'invalid-input': 'Invalid input'
		},

		/** Convenience shortcuts */
		baseMinusTMin = base - tMin,
		floor = Math.floor,
		stringFromCharCode = String.fromCharCode,

		/** Temporary variable */
		key;

		/*--------------------------------------------------------------------------*/

		/**
		 * A generic error utility function.
		 * @private
		 * @param {String} type The error type.
		 * @returns {Error} Throws a `RangeError` with the applicable error message.
		 */
		function error(type) {
			throw RangeError(errors[type]);
		}

		/**
		 * A generic `Array#map` utility function.
		 * @private
		 * @param {Array} array The array to iterate over.
		 * @param {Function} callback The function that gets called for every array
		 * item.
		 * @returns {Array} A new array of values returned by the callback function.
		 */
		function map(array, fn) {
			var length = array.length;
			var result = [];
			while (length--) {
				result[length] = fn(array[length]);
			}
			return result;
		}

		/**
		 * A simple `Array#map`-like wrapper to work with domain name strings or email
		 * addresses.
		 * @private
		 * @param {String} domain The domain name or email address.
		 * @param {Function} callback The function that gets called for every
		 * character.
		 * @returns {Array} A new string of characters returned by the callback
		 * function.
		 */
		function mapDomain(string, fn) {
			var parts = string.split('@');
			var result = '';
			if (parts.length > 1) {
				// In email addresses, only the domain name should be punycoded. Leave
				// the local part (i.e. everything up to `@`) intact.
				result = parts[0] + '@';
				string = parts[1];
			}
			// Avoid `split(regex)` for IE8 compatibility. See #17.
			string = string.replace(regexSeparators, '\x2E');
			var labels = string.split('.');
			var encoded = map(labels, fn).join('.');
			return result + encoded;
		}

		/**
		 * Creates an array containing the numeric code points of each Unicode
		 * character in the string. While JavaScript uses UCS-2 internally,
		 * this function will convert a pair of surrogate halves (each of which
		 * UCS-2 exposes as separate characters) into a single code point,
		 * matching UTF-16.
		 * @see `punycode.ucs2.encode`
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode.ucs2
		 * @name decode
		 * @param {String} string The Unicode input string (UCS-2).
		 * @returns {Array} The new array of code points.
		 */
		function ucs2decode(string) {
			var output = [],
			    counter = 0,
			    length = string.length,
			    value,
			    extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}

		/**
		 * Creates a string based on an array of numeric code points.
		 * @see `punycode.ucs2.decode`
		 * @memberOf punycode.ucs2
		 * @name encode
		 * @param {Array} codePoints The array of numeric code points.
		 * @returns {String} The new Unicode string (UCS-2).
		 */
		function ucs2encode(array) {
			return map(array, function(value) {
				var output = '';
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
				return output;
			}).join('');
		}

		/**
		 * Converts a basic code point into a digit/integer.
		 * @see `digitToBasic()`
		 * @private
		 * @param {Number} codePoint The basic numeric code point value.
		 * @returns {Number} The numeric value of a basic code point (for use in
		 * representing integers) in the range `0` to `base - 1`, or `base` if
		 * the code point does not represent a value.
		 */
		function basicToDigit(codePoint) {
			if (codePoint - 48 < 10) {
				return codePoint - 22;
			}
			if (codePoint - 65 < 26) {
				return codePoint - 65;
			}
			if (codePoint - 97 < 26) {
				return codePoint - 97;
			}
			return base;
		}

		/**
		 * Converts a digit/integer into a basic code point.
		 * @see `basicToDigit()`
		 * @private
		 * @param {Number} digit The numeric value of a basic code point.
		 * @returns {Number} The basic code point whose value (when used for
		 * representing integers) is `digit`, which needs to be in the range
		 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
		 * used; else, the lowercase form is used. The behavior is undefined
		 * if `flag` is non-zero and `digit` has no uppercase form.
		 */
		function digitToBasic(digit, flag) {
			//  0..25 map to ASCII a..z or A..Z
			// 26..35 map to ASCII 0..9
			return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
		}

		/**
		 * Bias adaptation function as per section 3.4 of RFC 3492.
		 * http://tools.ietf.org/html/rfc3492#section-3.4
		 * @private
		 */
		function adapt(delta, numPoints, firstTime) {
			var k = 0;
			delta = firstTime ? floor(delta / damp) : delta >> 1;
			delta += floor(delta / numPoints);
			for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
				delta = floor(delta / baseMinusTMin);
			}
			return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
		}

		/**
		 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
		 * symbols.
		 * @memberOf punycode
		 * @param {String} input The Punycode string of ASCII-only symbols.
		 * @returns {String} The resulting string of Unicode symbols.
		 */
		function decode(input) {
			// Don't use UCS-2
			var output = [],
			    inputLength = input.length,
			    out,
			    i = 0,
			    n = initialN,
			    bias = initialBias,
			    basic,
			    j,
			    index,
			    oldi,
			    w,
			    k,
			    digit,
			    t,
			    /** Cached calculation results */
			    baseMinusT;

			// Handle the basic code points: let `basic` be the number of input code
			// points before the last delimiter, or `0` if there is none, then copy
			// the first basic code points to the output.

			basic = input.lastIndexOf(delimiter);
			if (basic < 0) {
				basic = 0;
			}

			for (j = 0; j < basic; ++j) {
				// if it's not a basic code point
				if (input.charCodeAt(j) >= 0x80) {
					error('not-basic');
				}
				output.push(input.charCodeAt(j));
			}

			// Main decoding loop: start just after the last delimiter if any basic code
			// points were copied; start at the beginning otherwise.

			for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

				// `index` is the index of the next character to be consumed.
				// Decode a generalized variable-length integer into `delta`,
				// which gets added to `i`. The overflow checking is easier
				// if we increase `i` as we go, then subtract off its starting
				// value at the end to obtain `delta`.
				for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

					if (index >= inputLength) {
						error('invalid-input');
					}

					digit = basicToDigit(input.charCodeAt(index++));

					if (digit >= base || digit > floor((maxInt - i) / w)) {
						error('overflow');
					}

					i += digit * w;
					t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

					if (digit < t) {
						break;
					}

					baseMinusT = base - t;
					if (w > floor(maxInt / baseMinusT)) {
						error('overflow');
					}

					w *= baseMinusT;

				}

				out = output.length + 1;
				bias = adapt(i - oldi, out, oldi == 0);

				// `i` was supposed to wrap around from `out` to `0`,
				// incrementing `n` each time, so we'll fix that now:
				if (floor(i / out) > maxInt - n) {
					error('overflow');
				}

				n += floor(i / out);
				i %= out;

				// Insert `n` at position `i` of the output
				output.splice(i++, 0, n);

			}

			return ucs2encode(output);
		}

		/**
		 * Converts a string of Unicode symbols (e.g. a domain name label) to a
		 * Punycode string of ASCII-only symbols.
		 * @memberOf punycode
		 * @param {String} input The string of Unicode symbols.
		 * @returns {String} The resulting Punycode string of ASCII-only symbols.
		 */
		function encode(input) {
			var n,
			    delta,
			    handledCPCount,
			    basicLength,
			    bias,
			    j,
			    m,
			    q,
			    k,
			    t,
			    currentValue,
			    output = [],
			    /** `inputLength` will hold the number of code points in `input`. */
			    inputLength,
			    /** Cached calculation results */
			    handledCPCountPlusOne,
			    baseMinusT,
			    qMinusT;

			// Convert the input in UCS-2 to Unicode
			input = ucs2decode(input);

			// Cache the length
			inputLength = input.length;

			// Initialize the state
			n = initialN;
			delta = 0;
			bias = initialBias;

			// Handle the basic code points
			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue < 0x80) {
					output.push(stringFromCharCode(currentValue));
				}
			}

			handledCPCount = basicLength = output.length;

			// `handledCPCount` is the number of code points that have been handled;
			// `basicLength` is the number of basic code points.

			// Finish the basic string - if it is not empty - with a delimiter
			if (basicLength) {
				output.push(delimiter);
			}

			// Main encoding loop:
			while (handledCPCount < inputLength) {

				// All non-basic code points < n have been handled already. Find the next
				// larger one:
				for (m = maxInt, j = 0; j < inputLength; ++j) {
					currentValue = input[j];
					if (currentValue >= n && currentValue < m) {
						m = currentValue;
					}
				}

				// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
				// but guard against overflow
				handledCPCountPlusOne = handledCPCount + 1;
				if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
					error('overflow');
				}

				delta += (m - n) * handledCPCountPlusOne;
				n = m;

				for (j = 0; j < inputLength; ++j) {
					currentValue = input[j];

					if (currentValue < n && ++delta > maxInt) {
						error('overflow');
					}

					if (currentValue == n) {
						// Represent delta as a generalized variable-length integer
						for (q = delta, k = base; /* no condition */; k += base) {
							t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
							if (q < t) {
								break;
							}
							qMinusT = q - t;
							baseMinusT = base - t;
							output.push(
								stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
							);
							q = floor(qMinusT / baseMinusT);
						}

						output.push(stringFromCharCode(digitToBasic(q, 0)));
						bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
						delta = 0;
						++handledCPCount;
					}
				}

				++delta;
				++n;

			}
			return output.join('');
		}

		/**
		 * Converts a Punycode string representing a domain name or an email address
		 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
		 * it doesn't matter if you call it on a string that has already been
		 * converted to Unicode.
		 * @memberOf punycode
		 * @param {String} input The Punycoded domain name or email address to
		 * convert to Unicode.
		 * @returns {String} The Unicode representation of the given Punycode
		 * string.
		 */
		function toUnicode(input) {
			return mapDomain(input, function(string) {
				return regexPunycode.test(string)
					? decode(string.slice(4).toLowerCase())
					: string;
			});
		}

		/**
		 * Converts a Unicode string representing a domain name or an email address to
		 * Punycode. Only the non-ASCII parts of the domain name will be converted,
		 * i.e. it doesn't matter if you call it with a domain that's already in
		 * ASCII.
		 * @memberOf punycode
		 * @param {String} input The domain name or email address to convert, as a
		 * Unicode string.
		 * @returns {String} The Punycode representation of the given domain name or
		 * email address.
		 */
		function toASCII(input) {
			return mapDomain(input, function(string) {
				return regexNonASCII.test(string)
					? 'xn--' + encode(string)
					: string;
			});
		}

		/*--------------------------------------------------------------------------*/

		/** Define the public API */
		punycode = {
			/**
			 * A string representing the current Punycode.js version number.
			 * @memberOf punycode
			 * @type String
			 */
			'version': '1.3.2',
			/**
			 * An object of methods to convert from JavaScript's internal character
			 * representation (UCS-2) to Unicode code points, and back.
			 * @see <https://mathiasbynens.be/notes/javascript-encoding>
			 * @memberOf punycode
			 * @type Object
			 */
			'ucs2': {
				'decode': ucs2decode,
				'encode': ucs2encode
			},
			'decode': decode,
			'encode': encode,
			'toASCII': toASCII,
			'toUnicode': toUnicode
		};

		/** Expose `punycode` */
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return punycode;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (freeExports && freeModule) {
			if (module.exports == freeExports) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = punycode;
			} else { // in Narwhal or RingoJS v0.7.0-
				for (key in punycode) {
					punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.punycode = punycode;
		}

	}(this));

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)(module), (function() { return this; }())))

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.decode = exports.parse = __webpack_require__(226);
	exports.encode = exports.stringify = __webpack_require__(227);


/***/ }),
/* 226 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	'use strict';

	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}

	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};

	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }

	  var regexp = /\+/g;
	  qs = qs.split(sep);

	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }

	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }

	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;

	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }

	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);

	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }

	  return obj;
	};


/***/ }),
/* 227 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	'use strict';

	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;

	    case 'boolean':
	      return v ? 'true' : 'false';

	    case 'number':
	      return isFinite(v) ? v : '';

	    default:
	      return '';
	  }
	};

	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }

	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);

	  }

	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};


/***/ }),
/* 228 */
/***/ (function(module, exports) {

	/**
	 * Bit twiddling hacks for JavaScript.
	 *
	 * Author: Mikola Lysenko
	 *
	 * Ported from Stanford bit twiddling hack library:
	 *    http://graphics.stanford.edu/~seander/bithacks.html
	 */

	"use strict"; "use restrict";

	//Number of bits in an integer
	var INT_BITS = 32;

	//Constants
	exports.INT_BITS  = INT_BITS;
	exports.INT_MAX   =  0x7fffffff;
	exports.INT_MIN   = -1<<(INT_BITS-1);

	//Returns -1, 0, +1 depending on sign of x
	exports.sign = function(v) {
	  return (v > 0) - (v < 0);
	}

	//Computes absolute value of integer
	exports.abs = function(v) {
	  var mask = v >> (INT_BITS-1);
	  return (v ^ mask) - mask;
	}

	//Computes minimum of integers x and y
	exports.min = function(x, y) {
	  return y ^ ((x ^ y) & -(x < y));
	}

	//Computes maximum of integers x and y
	exports.max = function(x, y) {
	  return x ^ ((x ^ y) & -(x < y));
	}

	//Checks if a number is a power of two
	exports.isPow2 = function(v) {
	  return !(v & (v-1)) && (!!v);
	}

	//Computes log base 2 of v
	exports.log2 = function(v) {
	  var r, shift;
	  r =     (v > 0xFFFF) << 4; v >>>= r;
	  shift = (v > 0xFF  ) << 3; v >>>= shift; r |= shift;
	  shift = (v > 0xF   ) << 2; v >>>= shift; r |= shift;
	  shift = (v > 0x3   ) << 1; v >>>= shift; r |= shift;
	  return r | (v >> 1);
	}

	//Computes log base 10 of v
	exports.log10 = function(v) {
	  return  (v >= 1000000000) ? 9 : (v >= 100000000) ? 8 : (v >= 10000000) ? 7 :
	          (v >= 1000000) ? 6 : (v >= 100000) ? 5 : (v >= 10000) ? 4 :
	          (v >= 1000) ? 3 : (v >= 100) ? 2 : (v >= 10) ? 1 : 0;
	}

	//Counts number of bits
	exports.popCount = function(v) {
	  v = v - ((v >>> 1) & 0x55555555);
	  v = (v & 0x33333333) + ((v >>> 2) & 0x33333333);
	  return ((v + (v >>> 4) & 0xF0F0F0F) * 0x1010101) >>> 24;
	}

	//Counts number of trailing zeros
	function countTrailingZeros(v) {
	  var c = 32;
	  v &= -v;
	  if (v) c--;
	  if (v & 0x0000FFFF) c -= 16;
	  if (v & 0x00FF00FF) c -= 8;
	  if (v & 0x0F0F0F0F) c -= 4;
	  if (v & 0x33333333) c -= 2;
	  if (v & 0x55555555) c -= 1;
	  return c;
	}
	exports.countTrailingZeros = countTrailingZeros;

	//Rounds to next power of 2
	exports.nextPow2 = function(v) {
	  v += v === 0;
	  --v;
	  v |= v >>> 1;
	  v |= v >>> 2;
	  v |= v >>> 4;
	  v |= v >>> 8;
	  v |= v >>> 16;
	  return v + 1;
	}

	//Rounds down to previous power of 2
	exports.prevPow2 = function(v) {
	  v |= v >>> 1;
	  v |= v >>> 2;
	  v |= v >>> 4;
	  v |= v >>> 8;
	  v |= v >>> 16;
	  return v - (v>>>1);
	}

	//Computes parity of word
	exports.parity = function(v) {
	  v ^= v >>> 16;
	  v ^= v >>> 8;
	  v ^= v >>> 4;
	  v &= 0xf;
	  return (0x6996 >>> v) & 1;
	}

	var REVERSE_TABLE = new Array(256);

	(function(tab) {
	  for(var i=0; i<256; ++i) {
	    var v = i, r = i, s = 7;
	    for (v >>>= 1; v; v >>>= 1) {
	      r <<= 1;
	      r |= v & 1;
	      --s;
	    }
	    tab[i] = (r << s) & 0xff;
	  }
	})(REVERSE_TABLE);

	//Reverse bits in a 32 bit word
	exports.reverse = function(v) {
	  return  (REVERSE_TABLE[ v         & 0xff] << 24) |
	          (REVERSE_TABLE[(v >>> 8)  & 0xff] << 16) |
	          (REVERSE_TABLE[(v >>> 16) & 0xff] << 8)  |
	           REVERSE_TABLE[(v >>> 24) & 0xff];
	}

	//Interleave bits of 2 coordinates with 16 bits.  Useful for fast quadtree codes
	exports.interleave2 = function(x, y) {
	  x &= 0xFFFF;
	  x = (x | (x << 8)) & 0x00FF00FF;
	  x = (x | (x << 4)) & 0x0F0F0F0F;
	  x = (x | (x << 2)) & 0x33333333;
	  x = (x | (x << 1)) & 0x55555555;

	  y &= 0xFFFF;
	  y = (y | (y << 8)) & 0x00FF00FF;
	  y = (y | (y << 4)) & 0x0F0F0F0F;
	  y = (y | (y << 2)) & 0x33333333;
	  y = (y | (y << 1)) & 0x55555555;

	  return x | (y << 1);
	}

	//Extracts the nth interleaved component
	exports.deinterleave2 = function(v, n) {
	  v = (v >>> n) & 0x55555555;
	  v = (v | (v >>> 1))  & 0x33333333;
	  v = (v | (v >>> 2))  & 0x0F0F0F0F;
	  v = (v | (v >>> 4))  & 0x00FF00FF;
	  v = (v | (v >>> 16)) & 0x000FFFF;
	  return (v << 16) >> 16;
	}


	//Interleave bits of 3 coordinates, each with 10 bits.  Useful for fast octree codes
	exports.interleave3 = function(x, y, z) {
	  x &= 0x3FF;
	  x  = (x | (x<<16)) & 4278190335;
	  x  = (x | (x<<8))  & 251719695;
	  x  = (x | (x<<4))  & 3272356035;
	  x  = (x | (x<<2))  & 1227133513;

	  y &= 0x3FF;
	  y  = (y | (y<<16)) & 4278190335;
	  y  = (y | (y<<8))  & 251719695;
	  y  = (y | (y<<4))  & 3272356035;
	  y  = (y | (y<<2))  & 1227133513;
	  x |= (y << 1);
	  
	  z &= 0x3FF;
	  z  = (z | (z<<16)) & 4278190335;
	  z  = (z | (z<<8))  & 251719695;
	  z  = (z | (z<<4))  & 3272356035;
	  z  = (z | (z<<2))  & 1227133513;
	  
	  return x | (z << 2);
	}

	//Extracts nth interleaved component of a 3-tuple
	exports.deinterleave3 = function(v, n) {
	  v = (v >>> n)       & 1227133513;
	  v = (v | (v>>>2))   & 3272356035;
	  v = (v | (v>>>4))   & 251719695;
	  v = (v | (v>>>8))   & 4278190335;
	  v = (v | (v>>>16))  & 0x3FF;
	  return (v<<22)>>22;
	}

	//Computes next combination in colexicographic order (this is mistakenly called nextPermutation on the bit twiddling hacks page)
	exports.nextCombination = function(v) {
	  var t = v | (v - 1);
	  return (t + 1) | (((~t & -~t) - 1) >>> (countTrailingZeros(v) + 1));
	}



/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _BaseTexture2 = __webpack_require__(221);

	var _BaseTexture3 = _interopRequireDefault(_BaseTexture2);

	var _utils = __webpack_require__(213);

	var _ticker = __webpack_require__(230);

	var _const = __webpack_require__(174);

	var _determineCrossOrigin = __webpack_require__(222);

	var _determineCrossOrigin2 = _interopRequireDefault(_determineCrossOrigin);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	/**
	 * A texture of a [playing] Video.
	 *
	 * Video base textures mimic PixiJS BaseTexture.from.... method in their creation process.
	 *
	 * This can be used in several ways, such as:
	 *
	 * ```js
	 * let texture = PIXI.VideoBaseTexture.fromUrl('http://mydomain.com/video.mp4');
	 *
	 * let texture = PIXI.VideoBaseTexture.fromUrl({ src: 'http://mydomain.com/video.mp4', mime: 'video/mp4' });
	 *
	 * let texture = PIXI.VideoBaseTexture.fromUrls(['/video.webm', '/video.mp4']);
	 *
	 * let texture = PIXI.VideoBaseTexture.fromUrls([
	 *     { src: '/video.webm', mime: 'video/webm' },
	 *     { src: '/video.mp4', mime: 'video/mp4' }
	 * ]);
	 * ```
	 *
	 * See the ["deus" demo](http://www.goodboydigital.com/pixijs/examples/deus/).
	 *
	 * @class
	 * @extends PIXI.BaseTexture
	 * @memberof PIXI
	 */
	var VideoBaseTexture = function (_BaseTexture) {
	    _inherits(VideoBaseTexture, _BaseTexture);

	    /**
	     * @param {HTMLVideoElement} source - Video source
	     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
	     */
	    function VideoBaseTexture(source, scaleMode) {
	        _classCallCheck(this, VideoBaseTexture);

	        if (!source) {
	            throw new Error('No video source element specified.');
	        }

	        // hook in here to check if video is already available.
	        // BaseTexture looks for a source.complete boolean, plus width & height.

	        if ((source.readyState === source.HAVE_ENOUGH_DATA || source.readyState === source.HAVE_FUTURE_DATA) && source.width && source.height) {
	            source.complete = true;
	        }

	        var _this = _possibleConstructorReturn(this, _BaseTexture.call(this, source, scaleMode));

	        _this.width = source.videoWidth;
	        _this.height = source.videoHeight;

	        _this._autoUpdate = true;
	        _this._isAutoUpdating = false;

	        /**
	         * When set to true will automatically play videos used by this texture once
	         * they are loaded. If false, it will not modify the playing state.
	         *
	         * @member {boolean}
	         * @default true
	         */
	        _this.autoPlay = true;

	        _this.update = _this.update.bind(_this);
	        _this._onCanPlay = _this._onCanPlay.bind(_this);

	        source.addEventListener('play', _this._onPlayStart.bind(_this));
	        source.addEventListener('pause', _this._onPlayStop.bind(_this));
	        _this.hasLoaded = false;
	        _this.__loaded = false;

	        if (!_this._isSourceReady()) {
	            source.addEventListener('canplay', _this._onCanPlay);
	            source.addEventListener('canplaythrough', _this._onCanPlay);
	        } else {
	            _this._onCanPlay();
	        }
	        return _this;
	    }

	    /**
	     * Returns true if the underlying source is playing.
	     *
	     * @private
	     * @return {boolean} True if playing.
	     */


	    VideoBaseTexture.prototype._isSourcePlaying = function _isSourcePlaying() {
	        var source = this.source;

	        return source.currentTime > 0 && source.paused === false && source.ended === false && source.readyState > 2;
	    };

	    /**
	     * Returns true if the underlying source is ready for playing.
	     *
	     * @private
	     * @return {boolean} True if ready.
	     */


	    VideoBaseTexture.prototype._isSourceReady = function _isSourceReady() {
	        return this.source.readyState === 3 || this.source.readyState === 4;
	    };

	    /**
	     * Runs the update loop when the video is ready to play
	     *
	     * @private
	     */


	    VideoBaseTexture.prototype._onPlayStart = function _onPlayStart() {
	        // Just in case the video has not received its can play even yet..
	        if (!this.hasLoaded) {
	            this._onCanPlay();
	        }

	        if (!this._isAutoUpdating && this.autoUpdate) {
	            _ticker.shared.add(this.update, this, _const.UPDATE_PRIORITY.HIGH);
	            this._isAutoUpdating = true;
	        }
	    };

	    /**
	     * Fired when a pause event is triggered, stops the update loop
	     *
	     * @private
	     */


	    VideoBaseTexture.prototype._onPlayStop = function _onPlayStop() {
	        if (this._isAutoUpdating) {
	            _ticker.shared.remove(this.update, this);
	            this._isAutoUpdating = false;
	        }
	    };

	    /**
	     * Fired when the video is loaded and ready to play
	     *
	     * @private
	     */


	    VideoBaseTexture.prototype._onCanPlay = function _onCanPlay() {
	        this.hasLoaded = true;

	        if (this.source) {
	            this.source.removeEventListener('canplay', this._onCanPlay);
	            this.source.removeEventListener('canplaythrough', this._onCanPlay);

	            this.width = this.source.videoWidth;
	            this.height = this.source.videoHeight;

	            // prevent multiple loaded dispatches..
	            if (!this.__loaded) {
	                this.__loaded = true;
	                this.emit('loaded', this);
	            }

	            if (this._isSourcePlaying()) {
	                this._onPlayStart();
	            } else if (this.autoPlay) {
	                this.source.play();
	            }
	        }
	    };

	    /**
	     * Destroys this texture
	     *
	     */


	    VideoBaseTexture.prototype.destroy = function destroy() {
	        if (this._isAutoUpdating) {
	            _ticker.shared.remove(this.update, this);
	        }

	        if (this.source && this.source._pixiId) {
	            _BaseTexture3.default.removeFromCache(this.source._pixiId);
	            delete this.source._pixiId;

	            this.source.pause();
	            this.source.src = '';
	            this.source.load();
	        }

	        _BaseTexture.prototype.destroy.call(this);
	    };

	    /**
	     * Mimic PixiJS BaseTexture.from.... method.
	     *
	     * @static
	     * @param {HTMLVideoElement} video - Video to create texture from
	     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
	     * @return {PIXI.VideoBaseTexture} Newly created VideoBaseTexture
	     */


	    VideoBaseTexture.fromVideo = function fromVideo(video, scaleMode) {
	        if (!video._pixiId) {
	            video._pixiId = 'video_' + (0, _utils.uid)();
	        }

	        var baseTexture = _utils.BaseTextureCache[video._pixiId];

	        if (!baseTexture) {
	            baseTexture = new VideoBaseTexture(video, scaleMode);
	            _BaseTexture3.default.addToCache(baseTexture, video._pixiId);
	        }

	        return baseTexture;
	    };

	    /**
	     * Helper function that creates a new BaseTexture based on the given video element.
	     * This BaseTexture can then be used to create a texture
	     *
	     * @static
	     * @param {string|object|string[]|object[]} videoSrc - The URL(s) for the video.
	     * @param {string} [videoSrc.src] - One of the source urls for the video
	     * @param {string} [videoSrc.mime] - The mimetype of the video (e.g. 'video/mp4'). If not specified
	     *  the url's extension will be used as the second part of the mime type.
	     * @param {number} scaleMode - See {@link PIXI.SCALE_MODES} for possible values
	     * @param {boolean} [crossorigin=(auto)] - Should use anonymous CORS? Defaults to true if the URL is not a data-URI.
	     * @return {PIXI.VideoBaseTexture} Newly created VideoBaseTexture
	     */


	    VideoBaseTexture.fromUrl = function fromUrl(videoSrc, scaleMode, crossorigin) {
	        var video = document.createElement('video');

	        video.setAttribute('webkit-playsinline', '');
	        video.setAttribute('playsinline', '');

	        var url = Array.isArray(videoSrc) ? videoSrc[0].src || videoSrc[0] : videoSrc.src || videoSrc;

	        if (crossorigin === undefined && url.indexOf('data:') !== 0) {
	            video.crossOrigin = (0, _determineCrossOrigin2.default)(url);
	        } else if (crossorigin) {
	            video.crossOrigin = typeof crossorigin === 'string' ? crossorigin : 'anonymous';
	        }

	        // array of objects or strings
	        if (Array.isArray(videoSrc)) {
	            for (var i = 0; i < videoSrc.length; ++i) {
	                video.appendChild(createSource(videoSrc[i].src || videoSrc[i], videoSrc[i].mime));
	            }
	        }
	        // single object or string
	        else {
	                video.appendChild(createSource(url, videoSrc.mime));
	            }

	        video.load();

	        return VideoBaseTexture.fromVideo(video, scaleMode);
	    };

	    /**
	     * Should the base texture automatically update itself, set to true by default
	     *
	     * @member {boolean}
	     */


	    _createClass(VideoBaseTexture, [{
	        key: 'autoUpdate',
	        get: function get() {
	            return this._autoUpdate;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            if (value !== this._autoUpdate) {
	                this._autoUpdate = value;

	                if (!this._autoUpdate && this._isAutoUpdating) {
	                    _ticker.shared.remove(this.update, this);
	                    this._isAutoUpdating = false;
	                } else if (this._autoUpdate && !this._isAutoUpdating) {
	                    _ticker.shared.add(this.update, this, _const.UPDATE_PRIORITY.HIGH);
	                    this._isAutoUpdating = true;
	                }
	            }
	        }
	    }]);

	    return VideoBaseTexture;
	}(_BaseTexture3.default);

	exports.default = VideoBaseTexture;


	VideoBaseTexture.fromUrls = VideoBaseTexture.fromUrl;

	function createSource(path, type) {
	    if (!type) {
	        path = path.split('?').shift().toLowerCase();
	        type = 'video/' + path.substr(path.lastIndexOf('.') + 1);
	    }

	    var source = document.createElement('source');

	    source.src = path;
	    source.type = type;

	    return source;
	}
	//# sourceMappingURL=VideoBaseTexture.js.map

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;
	exports.Ticker = exports.shared = undefined;

	var _Ticker = __webpack_require__(231);

	var _Ticker2 = _interopRequireDefault(_Ticker);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/**
	 * The shared ticker instance used by {@link PIXI.extras.AnimatedSprite}.
	 * and by {@link PIXI.interaction.InteractionManager}.
	 * The property {@link PIXI.ticker.Ticker#autoStart} is set to `true`
	 * for this instance. Please follow the examples for usage, including
	 * how to opt-out of auto-starting the shared ticker.
	 *
	 * @example
	 * let ticker = PIXI.ticker.shared;
	 * // Set this to prevent starting this ticker when listeners are added.
	 * // By default this is true only for the PIXI.ticker.shared instance.
	 * ticker.autoStart = false;
	 * // FYI, call this to ensure the ticker is stopped. It should be stopped
	 * // if you have not attempted to render anything yet.
	 * ticker.stop();
	 * // Call this when you are ready for a running shared ticker.
	 * ticker.start();
	 *
	 * @example
	 * // You may use the shared ticker to render...
	 * let renderer = PIXI.autoDetectRenderer(800, 600);
	 * let stage = new PIXI.Container();
	 * let interactionManager = PIXI.interaction.InteractionManager(renderer);
	 * document.body.appendChild(renderer.view);
	 * ticker.add(function (time) {
	 *     renderer.render(stage);
	 * });
	 *
	 * @example
	 * // Or you can just update it manually.
	 * ticker.autoStart = false;
	 * ticker.stop();
	 * function animate(time) {
	 *     ticker.update(time);
	 *     renderer.render(stage);
	 *     requestAnimationFrame(animate);
	 * }
	 * animate(performance.now());
	 *
	 * @type {PIXI.ticker.Ticker}
	 * @memberof PIXI.ticker
	 */
	var shared = new _Ticker2.default();

	shared.autoStart = true;
	shared.destroy = function () {
	  // protect destroying shared ticker
	  // this is used by other internal systems
	  // like AnimatedSprite and InteractionManager
	};

	/**
	 * This namespace contains an API for interacting with PIXI's internal global update loop.
	 *
	 * This ticker is used for rendering, {@link PIXI.extras.AnimatedSprite AnimatedSprite},
	 * {@link PIXI.interaction.InteractionManager InteractionManager} and many other time-based PIXI systems.
	 * @example
	 * const ticker = new PIXI.ticker.Ticker();
	 * ticker.stop();
	 * ticker.add((deltaTime) => {
	 *   // do something every frame
	 * });
	 * ticker.start();
	 * @namespace PIXI.ticker
	 */
	exports.shared = shared;
	exports.Ticker = _Ticker2.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _settings = __webpack_require__(205);

	var _settings2 = _interopRequireDefault(_settings);

	var _const = __webpack_require__(174);

	var _TickerListener = __webpack_require__(232);

	var _TickerListener2 = _interopRequireDefault(_TickerListener);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/**
	 * A Ticker class that runs an update loop that other objects listen to.
	 * This class is composed around listeners
	 * meant for execution on the next requested animation frame.
	 * Animation frames are requested only when necessary,
	 * e.g. When the ticker is started and the emitter has listeners.
	 *
	 * @class
	 * @memberof PIXI.ticker
	 */
	var Ticker = function () {
	    /**
	     *
	     */
	    function Ticker() {
	        var _this = this;

	        _classCallCheck(this, Ticker);

	        /**
	         * The first listener. All new listeners added are chained on this.
	         * @private
	         * @type {TickerListener}
	         */
	        this._head = new _TickerListener2.default(null, null, Infinity);

	        /**
	         * Internal current frame request ID
	         * @private
	         */
	        this._requestId = null;

	        /**
	         * Internal value managed by minFPS property setter and getter.
	         * This is the maximum allowed milliseconds between updates.
	         * @private
	         */
	        this._maxElapsedMS = 100;

	        /**
	         * Whether or not this ticker should invoke the method
	         * {@link PIXI.ticker.Ticker#start} automatically
	         * when a listener is added.
	         *
	         * @member {boolean}
	         * @default false
	         */
	        this.autoStart = false;

	        /**
	         * Scalar time value from last frame to this frame.
	         * This value is capped by setting {@link PIXI.ticker.Ticker#minFPS}
	         * and is scaled with {@link PIXI.ticker.Ticker#speed}.
	         * **Note:** The cap may be exceeded by scaling.
	         *
	         * @member {number}
	         * @default 1
	         */
	        this.deltaTime = 1;

	        /**
	         * Time elapsed in milliseconds from last frame to this frame.
	         * Opposed to what the scalar {@link PIXI.ticker.Ticker#deltaTime}
	         * is based, this value is neither capped nor scaled.
	         * If the platform supports DOMHighResTimeStamp,
	         * this value will have a precision of 1 µs.
	         * Defaults to target frame time
	         *
	         * @member {number}
	         * @default 16.66
	         */
	        this.elapsedMS = 1 / _settings2.default.TARGET_FPMS;

	        /**
	         * The last time {@link PIXI.ticker.Ticker#update} was invoked.
	         * This value is also reset internally outside of invoking
	         * update, but only when a new animation frame is requested.
	         * If the platform supports DOMHighResTimeStamp,
	         * this value will have a precision of 1 µs.
	         *
	         * @member {number}
	         * @default -1
	         */
	        this.lastTime = -1;

	        /**
	         * Factor of current {@link PIXI.ticker.Ticker#deltaTime}.
	         * @example
	         * // Scales ticker.deltaTime to what would be
	         * // the equivalent of approximately 120 FPS
	         * ticker.speed = 2;
	         *
	         * @member {number}
	         * @default 1
	         */
	        this.speed = 1;

	        /**
	         * Whether or not this ticker has been started.
	         * `true` if {@link PIXI.ticker.Ticker#start} has been called.
	         * `false` if {@link PIXI.ticker.Ticker#stop} has been called.
	         * While `false`, this value may change to `true` in the
	         * event of {@link PIXI.ticker.Ticker#autoStart} being `true`
	         * and a listener is added.
	         *
	         * @member {boolean}
	         * @default false
	         */
	        this.started = false;

	        /**
	         * Internal tick method bound to ticker instance.
	         * This is because in early 2015, Function.bind
	         * is still 60% slower in high performance scenarios.
	         * Also separating frame requests from update method
	         * so listeners may be called at any time and with
	         * any animation API, just invoke ticker.update(time).
	         *
	         * @private
	         * @param {number} time - Time since last tick.
	         */
	        this._tick = function (time) {
	            _this._requestId = null;

	            if (_this.started) {
	                // Invoke listeners now
	                _this.update(time);
	                // Listener side effects may have modified ticker state.
	                if (_this.started && _this._requestId === null && _this._head.next) {
	                    _this._requestId = requestAnimationFrame(_this._tick);
	                }
	            }
	        };
	    }

	    /**
	     * Conditionally requests a new animation frame.
	     * If a frame has not already been requested, and if the internal
	     * emitter has listeners, a new frame is requested.
	     *
	     * @private
	     */


	    Ticker.prototype._requestIfNeeded = function _requestIfNeeded() {
	        if (this._requestId === null && this._head.next) {
	            // ensure callbacks get correct delta
	            this.lastTime = performance.now();
	            this._requestId = requestAnimationFrame(this._tick);
	        }
	    };

	    /**
	     * Conditionally cancels a pending animation frame.
	     *
	     * @private
	     */


	    Ticker.prototype._cancelIfNeeded = function _cancelIfNeeded() {
	        if (this._requestId !== null) {
	            cancelAnimationFrame(this._requestId);
	            this._requestId = null;
	        }
	    };

	    /**
	     * Conditionally requests a new animation frame.
	     * If the ticker has been started it checks if a frame has not already
	     * been requested, and if the internal emitter has listeners. If these
	     * conditions are met, a new frame is requested. If the ticker has not
	     * been started, but autoStart is `true`, then the ticker starts now,
	     * and continues with the previous conditions to request a new frame.
	     *
	     * @private
	     */


	    Ticker.prototype._startIfPossible = function _startIfPossible() {
	        if (this.started) {
	            this._requestIfNeeded();
	        } else if (this.autoStart) {
	            this.start();
	        }
	    };

	    /**
	     * Register a handler for tick events. Calls continuously unless
	     * it is removed or the ticker is stopped.
	     *
	     * @param {Function} fn - The listener function to be added for updates
	     * @param {Function} [context] - The listener context
	     * @param {number} [priority=PIXI.UPDATE_PRIORITY.NORMAL] - The priority for emitting
	     * @returns {PIXI.ticker.Ticker} This instance of a ticker
	     */


	    Ticker.prototype.add = function add(fn, context) {
	        var priority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _const.UPDATE_PRIORITY.NORMAL;

	        return this._addListener(new _TickerListener2.default(fn, context, priority));
	    };

	    /**
	     * Add a handler for the tick event which is only execute once.
	     *
	     * @param {Function} fn - The listener function to be added for one update
	     * @param {Function} [context] - The listener context
	     * @param {number} [priority=PIXI.UPDATE_PRIORITY.NORMAL] - The priority for emitting
	     * @returns {PIXI.ticker.Ticker} This instance of a ticker
	     */


	    Ticker.prototype.addOnce = function addOnce(fn, context) {
	        var priority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _const.UPDATE_PRIORITY.NORMAL;

	        return this._addListener(new _TickerListener2.default(fn, context, priority, true));
	    };

	    /**
	     * Internally adds the event handler so that it can be sorted by priority.
	     * Priority allows certain handler (user, AnimatedSprite, Interaction) to be run
	     * before the rendering.
	     *
	     * @private
	     * @param {TickerListener} listener - Current listener being added.
	     * @returns {PIXI.ticker.Ticker} This instance of a ticker
	     */


	    Ticker.prototype._addListener = function _addListener(listener) {
	        // For attaching to head
	        var current = this._head.next;
	        var previous = this._head;

	        // Add the first item
	        if (!current) {
	            listener.connect(previous);
	        } else {
	            // Go from highest to lowest priority
	            while (current) {
	                if (listener.priority > current.priority) {
	                    listener.connect(previous);
	                    break;
	                }
	                previous = current;
	                current = current.next;
	            }

	            // Not yet connected
	            if (!listener.previous) {
	                listener.connect(previous);
	            }
	        }

	        this._startIfPossible();

	        return this;
	    };

	    /**
	     * Removes any handlers matching the function and context parameters.
	     * If no handlers are left after removing, then it cancels the animation frame.
	     *
	     * @param {Function} fn - The listener function to be removed
	     * @param {Function} [context] - The listener context to be removed
	     * @returns {PIXI.ticker.Ticker} This instance of a ticker
	     */


	    Ticker.prototype.remove = function remove(fn, context) {
	        var listener = this._head.next;

	        while (listener) {
	            // We found a match, lets remove it
	            // no break to delete all possible matches
	            // incase a listener was added 2+ times
	            if (listener.match(fn, context)) {
	                listener = listener.destroy();
	            } else {
	                listener = listener.next;
	            }
	        }

	        if (!this._head.next) {
	            this._cancelIfNeeded();
	        }

	        return this;
	    };

	    /**
	     * Starts the ticker. If the ticker has listeners
	     * a new animation frame is requested at this point.
	     */


	    Ticker.prototype.start = function start() {
	        if (!this.started) {
	            this.started = true;
	            this._requestIfNeeded();
	        }
	    };

	    /**
	     * Stops the ticker. If the ticker has requested
	     * an animation frame it is canceled at this point.
	     */


	    Ticker.prototype.stop = function stop() {
	        if (this.started) {
	            this.started = false;
	            this._cancelIfNeeded();
	        }
	    };

	    /**
	     * Destroy the ticker and don't use after this. Calling
	     * this method removes all references to internal events.
	     */


	    Ticker.prototype.destroy = function destroy() {
	        this.stop();

	        var listener = this._head.next;

	        while (listener) {
	            listener = listener.destroy(true);
	        }

	        this._head.destroy();
	        this._head = null;
	    };

	    /**
	     * Triggers an update. An update entails setting the
	     * current {@link PIXI.ticker.Ticker#elapsedMS},
	     * the current {@link PIXI.ticker.Ticker#deltaTime},
	     * invoking all listeners with current deltaTime,
	     * and then finally setting {@link PIXI.ticker.Ticker#lastTime}
	     * with the value of currentTime that was provided.
	     * This method will be called automatically by animation
	     * frame callbacks if the ticker instance has been started
	     * and listeners are added.
	     *
	     * @param {number} [currentTime=performance.now()] - the current time of execution
	     */


	    Ticker.prototype.update = function update() {
	        var currentTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();

	        var elapsedMS = void 0;

	        // If the difference in time is zero or negative, we ignore most of the work done here.
	        // If there is no valid difference, then should be no reason to let anyone know about it.
	        // A zero delta, is exactly that, nothing should update.
	        //
	        // The difference in time can be negative, and no this does not mean time traveling.
	        // This can be the result of a race condition between when an animation frame is requested
	        // on the current JavaScript engine event loop, and when the ticker's start method is invoked
	        // (which invokes the internal _requestIfNeeded method). If a frame is requested before
	        // _requestIfNeeded is invoked, then the callback for the animation frame the ticker requests,
	        // can receive a time argument that can be less than the lastTime value that was set within
	        // _requestIfNeeded. This difference is in microseconds, but this is enough to cause problems.
	        //
	        // This check covers this browser engine timing issue, as well as if consumers pass an invalid
	        // currentTime value. This may happen if consumers opt-out of the autoStart, and update themselves.

	        if (currentTime > this.lastTime) {
	            // Save uncapped elapsedMS for measurement
	            elapsedMS = this.elapsedMS = currentTime - this.lastTime;

	            // cap the milliseconds elapsed used for deltaTime
	            if (elapsedMS > this._maxElapsedMS) {
	                elapsedMS = this._maxElapsedMS;
	            }

	            this.deltaTime = elapsedMS * _settings2.default.TARGET_FPMS * this.speed;

	            // Cache a local reference, in-case ticker is destroyed
	            // during the emit, we can still check for head.next
	            var head = this._head;

	            // Invoke listeners added to internal emitter
	            var listener = head.next;

	            while (listener) {
	                listener = listener.emit(this.deltaTime);
	            }

	            if (!head.next) {
	                this._cancelIfNeeded();
	            }
	        } else {
	            this.deltaTime = this.elapsedMS = 0;
	        }

	        this.lastTime = currentTime;
	    };

	    /**
	     * The frames per second at which this ticker is running.
	     * The default is approximately 60 in most modern browsers.
	     * **Note:** This does not factor in the value of
	     * {@link PIXI.ticker.Ticker#speed}, which is specific
	     * to scaling {@link PIXI.ticker.Ticker#deltaTime}.
	     *
	     * @member {number}
	     * @readonly
	     */


	    _createClass(Ticker, [{
	        key: 'FPS',
	        get: function get() {
	            return 1000 / this.elapsedMS;
	        }

	        /**
	         * Manages the maximum amount of milliseconds allowed to
	         * elapse between invoking {@link PIXI.ticker.Ticker#update}.
	         * This value is used to cap {@link PIXI.ticker.Ticker#deltaTime},
	         * but does not effect the measured value of {@link PIXI.ticker.Ticker#FPS}.
	         * When setting this property it is clamped to a value between
	         * `0` and `PIXI.settings.TARGET_FPMS * 1000`.
	         *
	         * @member {number}
	         * @default 10
	         */

	    }, {
	        key: 'minFPS',
	        get: function get() {
	            return 1000 / this._maxElapsedMS;
	        },
	        set: function set(fps) // eslint-disable-line require-jsdoc
	        {
	            // Clamp: 0 to TARGET_FPMS
	            var minFPMS = Math.min(Math.max(0, fps) / 1000, _settings2.default.TARGET_FPMS);

	            this._maxElapsedMS = 1 / minFPMS;
	        }
	    }]);

	    return Ticker;
	}();

	exports.default = Ticker;
	//# sourceMappingURL=Ticker.js.map

/***/ }),
/* 232 */
/***/ (function(module, exports) {

	"use strict";

	exports.__esModule = true;

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/**
	 * Internal class for handling the priority sorting of ticker handlers.
	 *
	 * @private
	 * @class
	 * @memberof PIXI.ticker
	 */
	var TickerListener = function () {
	    /**
	     * Constructor
	     *
	     * @param {Function} fn - The listener function to be added for one update
	     * @param {Function} [context=null] - The listener context
	     * @param {number} [priority=0] - The priority for emitting
	     * @param {boolean} [once=false] - If the handler should fire once
	     */
	    function TickerListener(fn) {
	        var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	        var priority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	        var once = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

	        _classCallCheck(this, TickerListener);

	        /**
	         * The handler function to execute.
	         * @member {Function}
	         */
	        this.fn = fn;

	        /**
	         * The calling to execute.
	         * @member {Function}
	         */
	        this.context = context;

	        /**
	         * The current priority.
	         * @member {number}
	         */
	        this.priority = priority;

	        /**
	         * If this should only execute once.
	         * @member {boolean}
	         */
	        this.once = once;

	        /**
	         * The next item in chain.
	         * @member {TickerListener}
	         */
	        this.next = null;

	        /**
	         * The previous item in chain.
	         * @member {TickerListener}
	         */
	        this.previous = null;

	        /**
	         * `true` if this listener has been destroyed already.
	         * @member {boolean}
	         * @private
	         */
	        this._destroyed = false;
	    }

	    /**
	     * Simple compare function to figure out if a function and context match.
	     *
	     * @param {Function} fn - The listener function to be added for one update
	     * @param {Function} context - The listener context
	     * @return {boolean} `true` if the listener match the arguments
	     */


	    TickerListener.prototype.match = function match(fn, context) {
	        context = context || null;

	        return this.fn === fn && this.context === context;
	    };

	    /**
	     * Emit by calling the current function.
	     * @param {number} deltaTime - time since the last emit.
	     * @return {TickerListener} Next ticker
	     */


	    TickerListener.prototype.emit = function emit(deltaTime) {
	        if (this.fn) {
	            if (this.context) {
	                this.fn.call(this.context, deltaTime);
	            } else {
	                this.fn(deltaTime);
	            }
	        }

	        var redirect = this.next;

	        if (this.once) {
	            this.destroy(true);
	        }

	        // Soft-destroying should remove
	        // the next reference
	        if (this._destroyed) {
	            this.next = null;
	        }

	        return redirect;
	    };

	    /**
	     * Connect to the list.
	     * @param {TickerListener} previous - Input node, previous listener
	     */


	    TickerListener.prototype.connect = function connect(previous) {
	        this.previous = previous;
	        if (previous.next) {
	            previous.next.previous = this;
	        }
	        this.next = previous.next;
	        previous.next = this;
	    };

	    /**
	     * Destroy and don't use after this.
	     * @param {boolean} [hard = false] `true` to remove the `next` reference, this
	     *        is considered a hard destroy. Soft destroy maintains the next reference.
	     * @return {TickerListener} The listener to redirect while emitting or removing.
	     */


	    TickerListener.prototype.destroy = function destroy() {
	        var hard = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

	        this._destroyed = true;
	        this.fn = null;
	        this.context = null;

	        // Disconnect, hook up next and previous
	        if (this.previous) {
	            this.previous.next = this.next;
	        }

	        if (this.next) {
	            this.next.previous = this.previous;
	        }

	        // Redirect to the next item
	        var redirect = this.next;

	        // Remove references
	        this.next = hard ? null : redirect;
	        this.previous = null;

	        return redirect;
	    };

	    return TickerListener;
	}();

	exports.default = TickerListener;
	//# sourceMappingURL=TickerListener.js.map

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _GroupD = __webpack_require__(179);

	var _GroupD2 = _interopRequireDefault(_GroupD);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/**
	 * A standard object to store the Uvs of a texture
	 *
	 * @class
	 * @private
	 * @memberof PIXI
	 */
	var TextureUvs = function () {
	    /**
	     *
	     */
	    function TextureUvs() {
	        _classCallCheck(this, TextureUvs);

	        this.x0 = 0;
	        this.y0 = 0;

	        this.x1 = 1;
	        this.y1 = 0;

	        this.x2 = 1;
	        this.y2 = 1;

	        this.x3 = 0;
	        this.y3 = 1;

	        this.uvsUint32 = new Uint32Array(4);
	    }

	    /**
	     * Sets the texture Uvs based on the given frame information.
	     *
	     * @private
	     * @param {PIXI.Rectangle} frame - The frame of the texture
	     * @param {PIXI.Rectangle} baseFrame - The base frame of the texture
	     * @param {number} rotate - Rotation of frame, see {@link PIXI.GroupD8}
	     */


	    TextureUvs.prototype.set = function set(frame, baseFrame, rotate) {
	        var tw = baseFrame.width;
	        var th = baseFrame.height;

	        if (rotate) {
	            // width and height div 2 div baseFrame size
	            var w2 = frame.width / 2 / tw;
	            var h2 = frame.height / 2 / th;

	            // coordinates of center
	            var cX = frame.x / tw + w2;
	            var cY = frame.y / th + h2;

	            rotate = _GroupD2.default.add(rotate, _GroupD2.default.NW); // NW is top-left corner
	            this.x0 = cX + w2 * _GroupD2.default.uX(rotate);
	            this.y0 = cY + h2 * _GroupD2.default.uY(rotate);

	            rotate = _GroupD2.default.add(rotate, 2); // rotate 90 degrees clockwise
	            this.x1 = cX + w2 * _GroupD2.default.uX(rotate);
	            this.y1 = cY + h2 * _GroupD2.default.uY(rotate);

	            rotate = _GroupD2.default.add(rotate, 2);
	            this.x2 = cX + w2 * _GroupD2.default.uX(rotate);
	            this.y2 = cY + h2 * _GroupD2.default.uY(rotate);

	            rotate = _GroupD2.default.add(rotate, 2);
	            this.x3 = cX + w2 * _GroupD2.default.uX(rotate);
	            this.y3 = cY + h2 * _GroupD2.default.uY(rotate);
	        } else {
	            this.x0 = frame.x / tw;
	            this.y0 = frame.y / th;

	            this.x1 = (frame.x + frame.width) / tw;
	            this.y1 = frame.y / th;

	            this.x2 = (frame.x + frame.width) / tw;
	            this.y2 = (frame.y + frame.height) / th;

	            this.x3 = frame.x / tw;
	            this.y3 = (frame.y + frame.height) / th;
	        }

	        this.uvsUint32[0] = (this.y0 * 65535 & 0xFFFF) << 16 | this.x0 * 65535 & 0xFFFF;
	        this.uvsUint32[1] = (this.y1 * 65535 & 0xFFFF) << 16 | this.x1 * 65535 & 0xFFFF;
	        this.uvsUint32[2] = (this.y2 * 65535 & 0xFFFF) << 16 | this.x2 * 65535 & 0xFFFF;
	        this.uvsUint32[3] = (this.y3 * 65535 & 0xFFFF) << 16 | this.x3 * 65535 & 0xFFFF;
	    };

	    return TextureUvs;
	}();

	exports.default = TextureUvs;
	//# sourceMappingURL=TextureUvs.js.map

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _CanvasRenderer = __webpack_require__(235);

	var _CanvasRenderer2 = _interopRequireDefault(_CanvasRenderer);

	var _const = __webpack_require__(174);

	var _math = __webpack_require__(175);

	var _CanvasTinter = __webpack_require__(243);

	var _CanvasTinter2 = _interopRequireDefault(_CanvasTinter);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var canvasRenderWorldTransform = new _math.Matrix();

	/**
	 * @author Mat Groves
	 *
	 * Big thanks to the very clever Matt DesLauriers <mattdesl> https://github.com/mattdesl/
	 * for creating the original PixiJS version!
	 * Also a thanks to https://github.com/bchevalier for tweaking the tint and alpha so that they now
	 * share 4 bytes on the vertex buffer
	 *
	 * Heavily inspired by LibGDX's CanvasSpriteRenderer:
	 * https://github.com/libgdx/libgdx/blob/master/gdx/src/com/badlogic/gdx/graphics/g2d/CanvasSpriteRenderer.java
	 */

	/**
	 * Renderer dedicated to drawing and batching sprites.
	 *
	 * @class
	 * @private
	 * @memberof PIXI
	 */

	var CanvasSpriteRenderer = function () {
	    /**
	     * @param {PIXI.WebGLRenderer} renderer -The renderer sprite this batch works for.
	     */
	    function CanvasSpriteRenderer(renderer) {
	        _classCallCheck(this, CanvasSpriteRenderer);

	        this.renderer = renderer;
	    }

	    /**
	     * Renders the sprite object.
	     *
	     * @param {PIXI.Sprite} sprite - the sprite to render when using this spritebatch
	     */


	    CanvasSpriteRenderer.prototype.render = function render(sprite) {
	        var texture = sprite._texture;
	        var renderer = this.renderer;

	        var width = texture._frame.width;
	        var height = texture._frame.height;

	        var wt = sprite.transform.worldTransform;
	        var dx = 0;
	        var dy = 0;

	        if (texture.orig.width <= 0 || texture.orig.height <= 0 || !texture.baseTexture.source) {
	            return;
	        }

	        renderer.setBlendMode(sprite.blendMode);

	        //  Ignore null sources
	        if (texture.valid) {
	            renderer.context.globalAlpha = sprite.worldAlpha;

	            // If smoothingEnabled is supported and we need to change the smoothing property for sprite texture
	            var smoothingEnabled = texture.baseTexture.scaleMode === _const.SCALE_MODES.LINEAR;

	            if (renderer.smoothProperty && renderer.context[renderer.smoothProperty] !== smoothingEnabled) {
	                renderer.context[renderer.smoothProperty] = smoothingEnabled;
	            }

	            if (texture.trim) {
	                dx = texture.trim.width / 2 + texture.trim.x - sprite.anchor.x * texture.orig.width;
	                dy = texture.trim.height / 2 + texture.trim.y - sprite.anchor.y * texture.orig.height;
	            } else {
	                dx = (0.5 - sprite.anchor.x) * texture.orig.width;
	                dy = (0.5 - sprite.anchor.y) * texture.orig.height;
	            }

	            if (texture.rotate) {
	                wt.copy(canvasRenderWorldTransform);
	                wt = canvasRenderWorldTransform;
	                _math.GroupD8.matrixAppendRotationInv(wt, texture.rotate, dx, dy);
	                // the anchor has already been applied above, so lets set it to zero
	                dx = 0;
	                dy = 0;
	            }

	            dx -= width / 2;
	            dy -= height / 2;

	            // Allow for pixel rounding
	            if (renderer.roundPixels) {
	                renderer.context.setTransform(wt.a, wt.b, wt.c, wt.d, wt.tx * renderer.resolution | 0, wt.ty * renderer.resolution | 0);

	                dx = dx | 0;
	                dy = dy | 0;
	            } else {
	                renderer.context.setTransform(wt.a, wt.b, wt.c, wt.d, wt.tx * renderer.resolution, wt.ty * renderer.resolution);
	            }

	            var resolution = texture.baseTexture.resolution;

	            if (sprite.tint !== 0xFFFFFF) {
	                if (sprite.cachedTint !== sprite.tint || sprite.tintedTexture.tintId !== sprite._texture._updateID) {
	                    sprite.cachedTint = sprite.tint;

	                    // TODO clean up caching - how to clean up the caches?
	                    sprite.tintedTexture = _CanvasTinter2.default.getTintedTexture(sprite, sprite.tint);
	                }

	                renderer.context.drawImage(sprite.tintedTexture, 0, 0, width * resolution, height * resolution, dx * renderer.resolution, dy * renderer.resolution, width * renderer.resolution, height * renderer.resolution);
	            } else {
	                renderer.context.drawImage(texture.baseTexture.source, texture._frame.x * resolution, texture._frame.y * resolution, width * resolution, height * resolution, dx * renderer.resolution, dy * renderer.resolution, width * renderer.resolution, height * renderer.resolution);
	            }
	        }
	    };

	    /**
	     * destroy the sprite object.
	     *
	     */


	    CanvasSpriteRenderer.prototype.destroy = function destroy() {
	        this.renderer = null;
	    };

	    return CanvasSpriteRenderer;
	}();

	exports.default = CanvasSpriteRenderer;


	_CanvasRenderer2.default.registerPlugin('sprite', CanvasSpriteRenderer);
	//# sourceMappingURL=CanvasSpriteRenderer.js.map

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _SystemRenderer2 = __webpack_require__(236);

	var _SystemRenderer3 = _interopRequireDefault(_SystemRenderer2);

	var _CanvasMaskManager = __webpack_require__(239);

	var _CanvasMaskManager2 = _interopRequireDefault(_CanvasMaskManager);

	var _CanvasRenderTarget = __webpack_require__(240);

	var _CanvasRenderTarget2 = _interopRequireDefault(_CanvasRenderTarget);

	var _mapCanvasBlendModesToPixi = __webpack_require__(241);

	var _mapCanvasBlendModesToPixi2 = _interopRequireDefault(_mapCanvasBlendModesToPixi);

	var _utils = __webpack_require__(213);

	var _const = __webpack_require__(174);

	var _settings = __webpack_require__(205);

	var _settings2 = _interopRequireDefault(_settings);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	/**
	 * The CanvasRenderer draws the scene and all its content onto a 2d canvas. This renderer should
	 * be used for browsers that do not support WebGL. Don't forget to add the CanvasRenderer.view to
	 * your DOM or you will not see anything :)
	 *
	 * @class
	 * @memberof PIXI
	 * @extends PIXI.SystemRenderer
	 */
	var CanvasRenderer = function (_SystemRenderer) {
	    _inherits(CanvasRenderer, _SystemRenderer);

	    // eslint-disable-next-line valid-jsdoc
	    /**
	     * @param {object} [options] - The optional renderer parameters
	     * @param {number} [options.width=800] - the width of the screen
	     * @param {number} [options.height=600] - the height of the screen
	     * @param {HTMLCanvasElement} [options.view] - the canvas to use as a view, optional
	     * @param {boolean} [options.transparent=false] - If the render view is transparent, default false
	     * @param {boolean} [options.autoResize=false] - If the render view is automatically resized, default false
	     * @param {boolean} [options.antialias=false] - sets antialias (only applicable in chrome at the moment)
	     * @param {number} [options.resolution=1] - The resolution / device pixel ratio of the renderer. The
	     *  resolution of the renderer retina would be 2.
	     * @param {boolean} [options.preserveDrawingBuffer=false] - enables drawing buffer preservation,
	     *  enable this if you need to call toDataUrl on the webgl context.
	     * @param {boolean} [options.clearBeforeRender=true] - This sets if the renderer will clear the canvas or
	     *      not before the new render pass.
	     * @param {number} [options.backgroundColor=0x000000] - The background color of the rendered area
	     *  (shown if not transparent).
	     * @param {boolean} [options.roundPixels=false] - If true PixiJS will Math.floor() x/y values when rendering,
	     *  stopping pixel interpolation.
	     */
	    function CanvasRenderer(options, arg2, arg3) {
	        _classCallCheck(this, CanvasRenderer);

	        var _this = _possibleConstructorReturn(this, _SystemRenderer.call(this, 'Canvas', options, arg2, arg3));

	        _this.type = _const.RENDERER_TYPE.CANVAS;

	        /**
	         * The root canvas 2d context that everything is drawn with.
	         *
	         * @member {CanvasRenderingContext2D}
	         */
	        _this.rootContext = _this.view.getContext('2d', { alpha: _this.transparent });

	        /**
	         * The currently active canvas 2d context (could change with renderTextures)
	         *
	         * @member {CanvasRenderingContext2D}
	         */
	        _this.context = _this.rootContext;

	        /**
	         * Boolean flag controlling canvas refresh.
	         *
	         * @member {boolean}
	         */
	        _this.refresh = true;

	        /**
	         * Instance of a CanvasMaskManager, handles masking when using the canvas renderer.
	         *
	         * @member {PIXI.CanvasMaskManager}
	         */
	        _this.maskManager = new _CanvasMaskManager2.default(_this);

	        /**
	         * The canvas property used to set the canvas smoothing property.
	         *
	         * @member {string}
	         */
	        _this.smoothProperty = 'imageSmoothingEnabled';

	        if (!_this.rootContext.imageSmoothingEnabled) {
	            if (_this.rootContext.webkitImageSmoothingEnabled) {
	                _this.smoothProperty = 'webkitImageSmoothingEnabled';
	            } else if (_this.rootContext.mozImageSmoothingEnabled) {
	                _this.smoothProperty = 'mozImageSmoothingEnabled';
	            } else if (_this.rootContext.oImageSmoothingEnabled) {
	                _this.smoothProperty = 'oImageSmoothingEnabled';
	            } else if (_this.rootContext.msImageSmoothingEnabled) {
	                _this.smoothProperty = 'msImageSmoothingEnabled';
	            }
	        }

	        _this.initPlugins();

	        _this.blendModes = (0, _mapCanvasBlendModesToPixi2.default)();
	        _this._activeBlendMode = null;

	        _this.renderingToScreen = false;

	        _this.resize(_this.options.width, _this.options.height);

	        /**
	         * Fired after rendering finishes.
	         *
	         * @event PIXI.CanvasRenderer#postrender
	         */

	        /**
	         * Fired before rendering starts.
	         *
	         * @event PIXI.CanvasRenderer#prerender
	         */
	        return _this;
	    }

	    /**
	     * Renders the object to this canvas view
	     *
	     * @param {PIXI.DisplayObject} displayObject - The object to be rendered
	     * @param {PIXI.RenderTexture} [renderTexture] - A render texture to be rendered to.
	     *  If unset, it will render to the root context.
	     * @param {boolean} [clear=false] - Whether to clear the canvas before drawing
	     * @param {PIXI.Matrix} [transform] - A transformation to be applied
	     * @param {boolean} [skipUpdateTransform=false] - Whether to skip the update transform
	     */


	    CanvasRenderer.prototype.render = function render(displayObject, renderTexture, clear, transform, skipUpdateTransform) {
	        if (!this.view) {
	            return;
	        }

	        // can be handy to know!
	        this.renderingToScreen = !renderTexture;

	        this.emit('prerender');

	        var rootResolution = this.resolution;

	        if (renderTexture) {
	            renderTexture = renderTexture.baseTexture || renderTexture;

	            if (!renderTexture._canvasRenderTarget) {
	                renderTexture._canvasRenderTarget = new _CanvasRenderTarget2.default(renderTexture.width, renderTexture.height, renderTexture.resolution);
	                renderTexture.source = renderTexture._canvasRenderTarget.canvas;
	                renderTexture.valid = true;
	            }

	            this.context = renderTexture._canvasRenderTarget.context;
	            this.resolution = renderTexture._canvasRenderTarget.resolution;
	        } else {
	            this.context = this.rootContext;
	        }

	        var context = this.context;

	        if (!renderTexture) {
	            this._lastObjectRendered = displayObject;
	        }

	        if (!skipUpdateTransform) {
	            // update the scene graph
	            var cacheParent = displayObject.parent;
	            var tempWt = this._tempDisplayObjectParent.transform.worldTransform;

	            if (transform) {
	                transform.copy(tempWt);

	                // lets not forget to flag the parent transform as dirty...
	                this._tempDisplayObjectParent.transform._worldID = -1;
	            } else {
	                tempWt.identity();
	            }

	            displayObject.parent = this._tempDisplayObjectParent;

	            displayObject.updateTransform();
	            displayObject.parent = cacheParent;
	            // displayObject.hitArea = //TODO add a temp hit area
	        }

	        context.save();
	        context.setTransform(1, 0, 0, 1, 0, 0);
	        context.globalAlpha = 1;
	        this._activeBlendMode = _const.BLEND_MODES.NORMAL;
	        context.globalCompositeOperation = this.blendModes[_const.BLEND_MODES.NORMAL];

	        if (navigator.isCocoonJS && this.view.screencanvas) {
	            context.fillStyle = 'black';
	            context.clear();
	        }

	        if (clear !== undefined ? clear : this.clearBeforeRender) {
	            if (this.renderingToScreen) {
	                if (this.transparent) {
	                    context.clearRect(0, 0, this.width, this.height);
	                } else {
	                    context.fillStyle = this._backgroundColorString;
	                    context.fillRect(0, 0, this.width, this.height);
	                }
	            } // else {
	            // TODO: implement background for CanvasRenderTarget or RenderTexture?
	            // }
	        }

	        // TODO RENDER TARGET STUFF HERE..
	        var tempContext = this.context;

	        this.context = context;
	        displayObject.renderCanvas(this);
	        this.context = tempContext;

	        context.restore();

	        this.resolution = rootResolution;

	        this.emit('postrender');
	    };

	    /**
	     * Clear the canvas of renderer.
	     *
	     * @param {string} [clearColor] - Clear the canvas with this color, except the canvas is transparent.
	     */


	    CanvasRenderer.prototype.clear = function clear(clearColor) {
	        var context = this.context;

	        clearColor = clearColor || this._backgroundColorString;

	        if (!this.transparent && clearColor) {
	            context.fillStyle = clearColor;
	            context.fillRect(0, 0, this.width, this.height);
	        } else {
	            context.clearRect(0, 0, this.width, this.height);
	        }
	    };

	    /**
	     * Sets the blend mode of the renderer.
	     *
	     * @param {number} blendMode - See {@link PIXI.BLEND_MODES} for valid values.
	     */


	    CanvasRenderer.prototype.setBlendMode = function setBlendMode(blendMode) {
	        if (this._activeBlendMode === blendMode) {
	            return;
	        }

	        this._activeBlendMode = blendMode;
	        this.context.globalCompositeOperation = this.blendModes[blendMode];
	    };

	    /**
	     * Removes everything from the renderer and optionally removes the Canvas DOM element.
	     *
	     * @param {boolean} [removeView=false] - Removes the Canvas element from the DOM.
	     */


	    CanvasRenderer.prototype.destroy = function destroy(removeView) {
	        this.destroyPlugins();

	        // call the base destroy
	        _SystemRenderer.prototype.destroy.call(this, removeView);

	        this.context = null;

	        this.refresh = true;

	        this.maskManager.destroy();
	        this.maskManager = null;

	        this.smoothProperty = null;
	    };

	    /**
	     * Resizes the canvas view to the specified width and height.
	     *
	     * @extends PIXI.SystemRenderer#resize
	     *
	     * @param {number} screenWidth - the new width of the screen
	     * @param {number} screenHeight - the new height of the screen
	     */


	    CanvasRenderer.prototype.resize = function resize(screenWidth, screenHeight) {
	        _SystemRenderer.prototype.resize.call(this, screenWidth, screenHeight);

	        // reset the scale mode.. oddly this seems to be reset when the canvas is resized.
	        // surely a browser bug?? Let PixiJS fix that for you..
	        if (this.smoothProperty) {
	            this.rootContext[this.smoothProperty] = _settings2.default.SCALE_MODE === _const.SCALE_MODES.LINEAR;
	        }
	    };

	    /**
	     * Checks if blend mode has changed.
	     */


	    CanvasRenderer.prototype.invalidateBlendMode = function invalidateBlendMode() {
	        this._activeBlendMode = this.blendModes.indexOf(this.context.globalCompositeOperation);
	    };

	    return CanvasRenderer;
	}(_SystemRenderer3.default);

	/**
	 * Collection of installed plugins. These are included by default in PIXI, but can be excluded
	 * by creating a custom build. Consult the README for more information about creating custom
	 * builds and excluding plugins.
	 * @name PIXI.CanvasRenderer#plugins
	 * @type {object}
	 * @readonly
	 * @property {PIXI.accessibility.AccessibilityManager} accessibility Support tabbing interactive elements.
	 * @property {PIXI.extract.CanvasExtract} extract Extract image data from renderer.
	 * @property {PIXI.interaction.InteractionManager} interaction Handles mouse, touch and pointer events.
	 * @property {PIXI.prepare.CanvasPrepare} prepare Pre-render display objects.
	 */

	/**
	 * Adds a plugin to the renderer.
	 *
	 * @method PIXI.CanvasRenderer#registerPlugin
	 * @param {string} pluginName - The name of the plugin.
	 * @param {Function} ctor - The constructor function or class for the plugin.
	 */

	exports.default = CanvasRenderer;
	_utils.pluginTarget.mixin(CanvasRenderer);
	//# sourceMappingURL=CanvasRenderer.js.map

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _utils = __webpack_require__(213);

	var _math = __webpack_require__(175);

	var _const = __webpack_require__(174);

	var _settings = __webpack_require__(205);

	var _settings2 = _interopRequireDefault(_settings);

	var _Container = __webpack_require__(212);

	var _Container2 = _interopRequireDefault(_Container);

	var _RenderTexture = __webpack_require__(237);

	var _RenderTexture2 = _interopRequireDefault(_RenderTexture);

	var _eventemitter = __webpack_require__(204);

	var _eventemitter2 = _interopRequireDefault(_eventemitter);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var tempMatrix = new _math.Matrix();

	/**
	 * The SystemRenderer is the base for a PixiJS Renderer. It is extended by the {@link PIXI.CanvasRenderer}
	 * and {@link PIXI.WebGLRenderer} which can be used for rendering a PixiJS scene.
	 *
	 * @abstract
	 * @class
	 * @extends EventEmitter
	 * @memberof PIXI
	 */

	var SystemRenderer = function (_EventEmitter) {
	  _inherits(SystemRenderer, _EventEmitter);

	  // eslint-disable-next-line valid-jsdoc
	  /**
	   * @param {string} system - The name of the system this renderer is for.
	   * @param {object} [options] - The optional renderer parameters
	   * @param {number} [options.width=800] - the width of the screen
	   * @param {number} [options.height=600] - the height of the screen
	   * @param {HTMLCanvasElement} [options.view] - the canvas to use as a view, optional
	   * @param {boolean} [options.transparent=false] - If the render view is transparent, default false
	   * @param {boolean} [options.autoResize=false] - If the render view is automatically resized, default false
	   * @param {boolean} [options.antialias=false] - sets antialias (only applicable in chrome at the moment)
	   * @param {number} [options.resolution=1] - The resolution / device pixel ratio of the renderer. The
	   *  resolution of the renderer retina would be 2.
	   * @param {boolean} [options.preserveDrawingBuffer=false] - enables drawing buffer preservation,
	   *  enable this if you need to call toDataUrl on the webgl context.
	   * @param {boolean} [options.clearBeforeRender=true] - This sets if the renderer will clear the canvas or
	   *      not before the new render pass.
	   * @param {number} [options.backgroundColor=0x000000] - The background color of the rendered area
	   *  (shown if not transparent).
	   * @param {boolean} [options.roundPixels=false] - If true PixiJS will Math.floor() x/y values when rendering,
	   *  stopping pixel interpolation.
	   */
	  function SystemRenderer(system, options, arg2, arg3) {
	    _classCallCheck(this, SystemRenderer);

	    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

	    (0, _utils.sayHello)(system);

	    // Support for constructor(system, screenWidth, screenHeight, options)
	    if (typeof options === 'number') {
	      options = Object.assign({
	        width: options,
	        height: arg2 || _settings2.default.RENDER_OPTIONS.height
	      }, arg3);
	    }

	    // Add the default render options
	    options = Object.assign({}, _settings2.default.RENDER_OPTIONS, options);

	    /**
	     * The supplied constructor options.
	     *
	     * @member {Object}
	     * @readOnly
	     */
	    _this.options = options;

	    /**
	     * The type of the renderer.
	     *
	     * @member {number}
	     * @default PIXI.RENDERER_TYPE.UNKNOWN
	     * @see PIXI.RENDERER_TYPE
	     */
	    _this.type = _const.RENDERER_TYPE.UNKNOWN;

	    /**
	     * Measurements of the screen. (0, 0, screenWidth, screenHeight)
	     *
	     * Its safe to use as filterArea or hitArea for whole stage
	     *
	     * @member {PIXI.Rectangle}
	     */
	    _this.screen = new _math.Rectangle(0, 0, options.width, options.height);

	    /**
	     * The canvas element that everything is drawn to
	     *
	     * @member {HTMLCanvasElement}
	     */
	    _this.view = options.view || document.createElement('canvas');

	    /**
	     * The resolution / device pixel ratio of the renderer
	     *
	     * @member {number}
	     * @default 1
	     */
	    _this.resolution = options.resolution || _settings2.default.RESOLUTION;

	    /**
	     * Whether the render view is transparent
	     *
	     * @member {boolean}
	     */
	    _this.transparent = options.transparent;

	    /**
	     * Whether css dimensions of canvas view should be resized to screen dimensions automatically
	     *
	     * @member {boolean}
	     */
	    _this.autoResize = options.autoResize || false;

	    /**
	     * Tracks the blend modes useful for this renderer.
	     *
	     * @member {object<string, mixed>}
	     */
	    _this.blendModes = null;

	    /**
	     * The value of the preserveDrawingBuffer flag affects whether or not the contents of
	     * the stencil buffer is retained after rendering.
	     *
	     * @member {boolean}
	     */
	    _this.preserveDrawingBuffer = options.preserveDrawingBuffer;

	    /**
	     * This sets if the CanvasRenderer will clear the canvas or not before the new render pass.
	     * If the scene is NOT transparent PixiJS will use a canvas sized fillRect operation every
	     * frame to set the canvas background color. If the scene is transparent PixiJS will use clearRect
	     * to clear the canvas every frame. Disable this by setting this to false. For example if
	     * your game has a canvas filling background image you often don't need this set.
	     *
	     * @member {boolean}
	     * @default
	     */
	    _this.clearBeforeRender = options.clearBeforeRender;

	    /**
	     * If true PixiJS will Math.floor() x/y values when rendering, stopping pixel interpolation.
	     * Handy for crisp pixel art and speed on legacy devices.
	     *
	     * @member {boolean}
	     */
	    _this.roundPixels = options.roundPixels;

	    /**
	     * The background color as a number.
	     *
	     * @member {number}
	     * @private
	     */
	    _this._backgroundColor = 0x000000;

	    /**
	     * The background color as an [R, G, B] array.
	     *
	     * @member {number[]}
	     * @private
	     */
	    _this._backgroundColorRgba = [0, 0, 0, 0];

	    /**
	     * The background color as a string.
	     *
	     * @member {string}
	     * @private
	     */
	    _this._backgroundColorString = '#000000';

	    _this.backgroundColor = options.backgroundColor || _this._backgroundColor; // run bg color setter

	    /**
	     * This temporary display object used as the parent of the currently being rendered item
	     *
	     * @member {PIXI.DisplayObject}
	     * @private
	     */
	    _this._tempDisplayObjectParent = new _Container2.default();

	    /**
	     * The last root object that the renderer tried to render.
	     *
	     * @member {PIXI.DisplayObject}
	     * @private
	     */
	    _this._lastObjectRendered = _this._tempDisplayObjectParent;
	    return _this;
	  }

	  /**
	   * Same as view.width, actual number of pixels in the canvas by horizontal
	   *
	   * @member {number}
	   * @readonly
	   * @default 800
	   */


	  /**
	   * Resizes the screen and canvas to the specified width and height
	   * Canvas dimensions are multiplied by resolution
	   *
	   * @param {number} screenWidth - the new width of the screen
	   * @param {number} screenHeight - the new height of the screen
	   */
	  SystemRenderer.prototype.resize = function resize(screenWidth, screenHeight) {
	    this.screen.width = screenWidth;
	    this.screen.height = screenHeight;

	    this.view.width = screenWidth * this.resolution;
	    this.view.height = screenHeight * this.resolution;

	    if (this.autoResize) {
	      this.view.style.width = screenWidth + 'px';
	      this.view.style.height = screenHeight + 'px';
	    }
	  };

	  /**
	   * Useful function that returns a texture of the display object that can then be used to create sprites
	   * This can be quite useful if your displayObject is complicated and needs to be reused multiple times.
	   *
	   * @param {PIXI.DisplayObject} displayObject - The displayObject the object will be generated from
	   * @param {number} scaleMode - Should be one of the scaleMode consts
	   * @param {number} resolution - The resolution / device pixel ratio of the texture being generated
	   * @param {PIXI.Rectangle} [region] - The region of the displayObject, that shall be rendered,
	   *        if no region is specified, defaults to the local bounds of the displayObject.
	   * @return {PIXI.Texture} a texture of the graphics object
	   */


	  SystemRenderer.prototype.generateTexture = function generateTexture(displayObject, scaleMode, resolution, region) {
	    region = region || displayObject.getLocalBounds();

	    var renderTexture = _RenderTexture2.default.create(region.width | 0, region.height | 0, scaleMode, resolution);

	    tempMatrix.tx = -region.x;
	    tempMatrix.ty = -region.y;

	    this.render(displayObject, renderTexture, false, tempMatrix, !!displayObject.parent);

	    return renderTexture;
	  };

	  /**
	   * Removes everything from the renderer and optionally removes the Canvas DOM element.
	   *
	   * @param {boolean} [removeView=false] - Removes the Canvas element from the DOM.
	   */


	  SystemRenderer.prototype.destroy = function destroy(removeView) {
	    if (removeView && this.view.parentNode) {
	      this.view.parentNode.removeChild(this.view);
	    }

	    this.type = _const.RENDERER_TYPE.UNKNOWN;

	    this.view = null;

	    this.screen = null;

	    this.resolution = 0;

	    this.transparent = false;

	    this.autoResize = false;

	    this.blendModes = null;

	    this.options = null;

	    this.preserveDrawingBuffer = false;
	    this.clearBeforeRender = false;

	    this.roundPixels = false;

	    this._backgroundColor = 0;
	    this._backgroundColorRgba = null;
	    this._backgroundColorString = null;

	    this._tempDisplayObjectParent = null;
	    this._lastObjectRendered = null;
	  };

	  /**
	   * The background color to fill if not transparent
	   *
	   * @member {number}
	   */


	  _createClass(SystemRenderer, [{
	    key: 'width',
	    get: function get() {
	      return this.view.width;
	    }

	    /**
	     * Same as view.height, actual number of pixels in the canvas by vertical
	     *
	     * @member {number}
	     * @readonly
	     * @default 600
	     */

	  }, {
	    key: 'height',
	    get: function get() {
	      return this.view.height;
	    }
	  }, {
	    key: 'backgroundColor',
	    get: function get() {
	      return this._backgroundColor;
	    },
	    set: function set(value) // eslint-disable-line require-jsdoc
	    {
	      this._backgroundColor = value;
	      this._backgroundColorString = (0, _utils.hex2string)(value);
	      (0, _utils.hex2rgb)(value, this._backgroundColorRgba);
	    }
	  }]);

	  return SystemRenderer;
	}(_eventemitter2.default);

	exports.default = SystemRenderer;
	//# sourceMappingURL=SystemRenderer.js.map

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _BaseRenderTexture = __webpack_require__(238);

	var _BaseRenderTexture2 = _interopRequireDefault(_BaseRenderTexture);

	var _Texture2 = __webpack_require__(220);

	var _Texture3 = _interopRequireDefault(_Texture2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	/**
	 * A RenderTexture is a special texture that allows any PixiJS display object to be rendered to it.
	 *
	 * __Hint__: All DisplayObjects (i.e. Sprites) that render to a RenderTexture should be preloaded
	 * otherwise black rectangles will be drawn instead.
	 *
	 * A RenderTexture takes a snapshot of any Display Object given to its render method. For example:
	 *
	 * ```js
	 * let renderer = PIXI.autoDetectRenderer(1024, 1024, { view: canvas, ratio: 1 });
	 * let renderTexture = PIXI.RenderTexture.create(800, 600);
	 * let sprite = PIXI.Sprite.fromImage("spinObj_01.png");
	 *
	 * sprite.position.x = 800/2;
	 * sprite.position.y = 600/2;
	 * sprite.anchor.x = 0.5;
	 * sprite.anchor.y = 0.5;
	 *
	 * renderer.render(sprite, renderTexture);
	 * ```
	 *
	 * The Sprite in this case will be rendered using its local transform. To render this sprite at 0,0
	 * you can clear the transform
	 *
	 * ```js
	 *
	 * sprite.setTransform()
	 *
	 * let renderTexture = new PIXI.RenderTexture.create(100, 100);
	 *
	 * renderer.render(sprite, renderTexture);  // Renders to center of RenderTexture
	 * ```
	 *
	 * @class
	 * @extends PIXI.Texture
	 * @memberof PIXI
	 */
	var RenderTexture = function (_Texture) {
	    _inherits(RenderTexture, _Texture);

	    /**
	     * @param {PIXI.BaseRenderTexture} baseRenderTexture - The renderer used for this RenderTexture
	     * @param {PIXI.Rectangle} [frame] - The rectangle frame of the texture to show
	     */
	    function RenderTexture(baseRenderTexture, frame) {
	        _classCallCheck(this, RenderTexture);

	        // support for legacy..
	        var _legacyRenderer = null;

	        if (!(baseRenderTexture instanceof _BaseRenderTexture2.default)) {
	            /* eslint-disable prefer-rest-params, no-console */
	            var width = arguments[1];
	            var height = arguments[2];
	            var scaleMode = arguments[3];
	            var resolution = arguments[4];

	            // we have an old render texture..
	            console.warn('Please use RenderTexture.create(' + width + ', ' + height + ') instead of the ctor directly.');
	            _legacyRenderer = arguments[0];
	            /* eslint-enable prefer-rest-params, no-console */

	            frame = null;
	            baseRenderTexture = new _BaseRenderTexture2.default(width, height, scaleMode, resolution);
	        }

	        /**
	         * The base texture object that this texture uses
	         *
	         * @member {BaseTexture}
	         */

	        var _this = _possibleConstructorReturn(this, _Texture.call(this, baseRenderTexture, frame));

	        _this.legacyRenderer = _legacyRenderer;

	        /**
	         * This will let the renderer know if the texture is valid. If it's not then it cannot be rendered.
	         *
	         * @member {boolean}
	         */
	        _this.valid = true;

	        _this._updateUvs();
	        return _this;
	    }

	    /**
	     * Resizes the RenderTexture.
	     *
	     * @param {number} width - The width to resize to.
	     * @param {number} height - The height to resize to.
	     * @param {boolean} doNotResizeBaseTexture - Should the baseTexture.width and height values be resized as well?
	     */


	    RenderTexture.prototype.resize = function resize(width, height, doNotResizeBaseTexture) {
	        width = Math.ceil(width);
	        height = Math.ceil(height);

	        // TODO - could be not required..
	        this.valid = width > 0 && height > 0;

	        this._frame.width = this.orig.width = width;
	        this._frame.height = this.orig.height = height;

	        if (!doNotResizeBaseTexture) {
	            this.baseTexture.resize(width, height);
	        }

	        this._updateUvs();
	    };

	    /**
	     * A short hand way of creating a render texture.
	     *
	     * @param {number} [width=100] - The width of the render texture
	     * @param {number} [height=100] - The height of the render texture
	     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
	     * @param {number} [resolution=1] - The resolution / device pixel ratio of the texture being generated
	     * @return {PIXI.RenderTexture} The new render texture
	     */


	    RenderTexture.create = function create(width, height, scaleMode, resolution) {
	        return new RenderTexture(new _BaseRenderTexture2.default(width, height, scaleMode, resolution));
	    };

	    return RenderTexture;
	}(_Texture3.default);

	exports.default = RenderTexture;
	//# sourceMappingURL=RenderTexture.js.map

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _BaseTexture2 = __webpack_require__(221);

	var _BaseTexture3 = _interopRequireDefault(_BaseTexture2);

	var _settings = __webpack_require__(205);

	var _settings2 = _interopRequireDefault(_settings);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	/**
	 * A BaseRenderTexture is a special texture that allows any PixiJS display object to be rendered to it.
	 *
	 * __Hint__: All DisplayObjects (i.e. Sprites) that render to a BaseRenderTexture should be preloaded
	 * otherwise black rectangles will be drawn instead.
	 *
	 * A BaseRenderTexture takes a snapshot of any Display Object given to its render method. The position
	 * and rotation of the given Display Objects is ignored. For example:
	 *
	 * ```js
	 * let renderer = PIXI.autoDetectRenderer(1024, 1024, { view: canvas, ratio: 1 });
	 * let baseRenderTexture = new PIXI.BaseRenderTexture(renderer, 800, 600);
	 * let sprite = PIXI.Sprite.fromImage("spinObj_01.png");
	 *
	 * sprite.position.x = 800/2;
	 * sprite.position.y = 600/2;
	 * sprite.anchor.x = 0.5;
	 * sprite.anchor.y = 0.5;
	 *
	 * baseRenderTexture.render(sprite);
	 * ```
	 *
	 * The Sprite in this case will be rendered using its local transform. To render this sprite at 0,0
	 * you can clear the transform
	 *
	 * ```js
	 *
	 * sprite.setTransform()
	 *
	 * let baseRenderTexture = new PIXI.BaseRenderTexture(100, 100);
	 * let renderTexture = new PIXI.RenderTexture(baseRenderTexture);
	 *
	 * renderer.render(sprite, renderTexture);  // Renders to center of RenderTexture
	 * ```
	 *
	 * @class
	 * @extends PIXI.BaseTexture
	 * @memberof PIXI
	 */
	var BaseRenderTexture = function (_BaseTexture) {
	  _inherits(BaseRenderTexture, _BaseTexture);

	  /**
	   * @param {number} [width=100] - The width of the base render texture
	   * @param {number} [height=100] - The height of the base render texture
	   * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
	   * @param {number} [resolution=1] - The resolution / device pixel ratio of the texture being generated
	   */
	  function BaseRenderTexture() {
	    var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 100;
	    var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
	    var scaleMode = arguments[2];
	    var resolution = arguments[3];

	    _classCallCheck(this, BaseRenderTexture);

	    var _this = _possibleConstructorReturn(this, _BaseTexture.call(this, null, scaleMode));

	    _this.resolution = resolution || _settings2.default.RESOLUTION;

	    _this.width = Math.ceil(width);
	    _this.height = Math.ceil(height);

	    _this.realWidth = _this.width * _this.resolution;
	    _this.realHeight = _this.height * _this.resolution;

	    _this.scaleMode = scaleMode !== undefined ? scaleMode : _settings2.default.SCALE_MODE;
	    _this.hasLoaded = true;

	    /**
	     * A map of renderer IDs to webgl renderTargets
	     *
	     * @private
	     * @member {object<number, WebGLTexture>}
	     */
	    _this._glRenderTargets = {};

	    /**
	     * A reference to the canvas render target (we only need one as this can be shared across renderers)
	     *
	     * @private
	     * @member {object<number, WebGLTexture>}
	     */
	    _this._canvasRenderTarget = null;

	    /**
	     * This will let the renderer know if the texture is valid. If it's not then it cannot be rendered.
	     *
	     * @member {boolean}
	     */
	    _this.valid = false;
	    return _this;
	  }

	  /**
	   * Resizes the BaseRenderTexture.
	   *
	   * @param {number} width - The width to resize to.
	   * @param {number} height - The height to resize to.
	   */


	  BaseRenderTexture.prototype.resize = function resize(width, height) {
	    width = Math.ceil(width);
	    height = Math.ceil(height);

	    if (width === this.width && height === this.height) {
	      return;
	    }

	    this.valid = width > 0 && height > 0;

	    this.width = width;
	    this.height = height;

	    this.realWidth = this.width * this.resolution;
	    this.realHeight = this.height * this.resolution;

	    if (!this.valid) {
	      return;
	    }

	    this.emit('update', this);
	  };

	  /**
	   * Destroys this texture
	   *
	   */


	  BaseRenderTexture.prototype.destroy = function destroy() {
	    _BaseTexture.prototype.destroy.call(this, true);
	    this.renderer = null;
	  };

	  return BaseRenderTexture;
	}(_BaseTexture3.default);

	exports.default = BaseRenderTexture;
	//# sourceMappingURL=BaseRenderTexture.js.map

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _const = __webpack_require__(174);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/**
	 * A set of functions used to handle masking.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var CanvasMaskManager = function () {
	    /**
	     * @param {PIXI.CanvasRenderer} renderer - The canvas renderer.
	     */
	    function CanvasMaskManager(renderer) {
	        _classCallCheck(this, CanvasMaskManager);

	        this.renderer = renderer;
	    }

	    /**
	     * This method adds it to the current stack of masks.
	     *
	     * @param {object} maskData - the maskData that will be pushed
	     */


	    CanvasMaskManager.prototype.pushMask = function pushMask(maskData) {
	        var renderer = this.renderer;

	        renderer.context.save();

	        var cacheAlpha = maskData.alpha;
	        var transform = maskData.transform.worldTransform;
	        var resolution = renderer.resolution;

	        renderer.context.setTransform(transform.a * resolution, transform.b * resolution, transform.c * resolution, transform.d * resolution, transform.tx * resolution, transform.ty * resolution);

	        // TODO suport sprite alpha masks??
	        // lots of effort required. If demand is great enough..
	        if (!maskData._texture) {
	            this.renderGraphicsShape(maskData);
	            renderer.context.clip();
	        }

	        maskData.worldAlpha = cacheAlpha;
	    };

	    /**
	     * Renders a PIXI.Graphics shape.
	     *
	     * @param {PIXI.Graphics} graphics - The object to render.
	     */


	    CanvasMaskManager.prototype.renderGraphicsShape = function renderGraphicsShape(graphics) {
	        var context = this.renderer.context;
	        var len = graphics.graphicsData.length;

	        if (len === 0) {
	            return;
	        }

	        context.beginPath();

	        for (var i = 0; i < len; i++) {
	            var data = graphics.graphicsData[i];
	            var shape = data.shape;

	            if (data.type === _const.SHAPES.POLY) {
	                var points = shape.points;

	                context.moveTo(points[0], points[1]);

	                for (var j = 1; j < points.length / 2; j++) {
	                    context.lineTo(points[j * 2], points[j * 2 + 1]);
	                }

	                // if the first and last point are the same close the path - much neater :)
	                if (points[0] === points[points.length - 2] && points[1] === points[points.length - 1]) {
	                    context.closePath();
	                }
	            } else if (data.type === _const.SHAPES.RECT) {
	                context.rect(shape.x, shape.y, shape.width, shape.height);
	                context.closePath();
	            } else if (data.type === _const.SHAPES.CIRC) {
	                // TODO - need to be Undefined!
	                context.arc(shape.x, shape.y, shape.radius, 0, 2 * Math.PI);
	                context.closePath();
	            } else if (data.type === _const.SHAPES.ELIP) {
	                // ellipse code taken from: http://stackoverflow.com/questions/2172798/how-to-draw-an-oval-in-html5-canvas

	                var w = shape.width * 2;
	                var h = shape.height * 2;

	                var x = shape.x - w / 2;
	                var y = shape.y - h / 2;

	                var kappa = 0.5522848;
	                var ox = w / 2 * kappa; // control point offset horizontal
	                var oy = h / 2 * kappa; // control point offset vertical
	                var xe = x + w; // x-end
	                var ye = y + h; // y-end
	                var xm = x + w / 2; // x-middle
	                var ym = y + h / 2; // y-middle

	                context.moveTo(x, ym);
	                context.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
	                context.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
	                context.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
	                context.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);
	                context.closePath();
	            } else if (data.type === _const.SHAPES.RREC) {
	                var rx = shape.x;
	                var ry = shape.y;
	                var width = shape.width;
	                var height = shape.height;
	                var radius = shape.radius;

	                var maxRadius = Math.min(width, height) / 2 | 0;

	                radius = radius > maxRadius ? maxRadius : radius;

	                context.moveTo(rx, ry + radius);
	                context.lineTo(rx, ry + height - radius);
	                context.quadraticCurveTo(rx, ry + height, rx + radius, ry + height);
	                context.lineTo(rx + width - radius, ry + height);
	                context.quadraticCurveTo(rx + width, ry + height, rx + width, ry + height - radius);
	                context.lineTo(rx + width, ry + radius);
	                context.quadraticCurveTo(rx + width, ry, rx + width - radius, ry);
	                context.lineTo(rx + radius, ry);
	                context.quadraticCurveTo(rx, ry, rx, ry + radius);
	                context.closePath();
	            }
	        }
	    };

	    /**
	     * Restores the current drawing context to the state it was before the mask was applied.
	     *
	     * @param {PIXI.CanvasRenderer} renderer - The renderer context to use.
	     */


	    CanvasMaskManager.prototype.popMask = function popMask(renderer) {
	        renderer.context.restore();
	        renderer.invalidateBlendMode();
	    };

	    /**
	     * Destroys this canvas mask manager.
	     *
	     */


	    CanvasMaskManager.prototype.destroy = function destroy() {
	        /* empty */
	    };

	    return CanvasMaskManager;
	}();

	exports.default = CanvasMaskManager;
	//# sourceMappingURL=CanvasMaskManager.js.map

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _settings = __webpack_require__(205);

	var _settings2 = _interopRequireDefault(_settings);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/**
	 * Creates a Canvas element of the given size.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var CanvasRenderTarget = function () {
	  /**
	   * @param {number} width - the width for the newly created canvas
	   * @param {number} height - the height for the newly created canvas
	   * @param {number} [resolution=1] - The resolution / device pixel ratio of the canvas
	   */
	  function CanvasRenderTarget(width, height, resolution) {
	    _classCallCheck(this, CanvasRenderTarget);

	    /**
	     * The Canvas object that belongs to this CanvasRenderTarget.
	     *
	     * @member {HTMLCanvasElement}
	     */
	    this.canvas = document.createElement('canvas');

	    /**
	     * A CanvasRenderingContext2D object representing a two-dimensional rendering context.
	     *
	     * @member {CanvasRenderingContext2D}
	     */
	    this.context = this.canvas.getContext('2d');

	    this.resolution = resolution || _settings2.default.RESOLUTION;

	    this.resize(width, height);
	  }

	  /**
	   * Clears the canvas that was created by the CanvasRenderTarget class.
	   *
	   * @private
	   */


	  CanvasRenderTarget.prototype.clear = function clear() {
	    this.context.setTransform(1, 0, 0, 1, 0, 0);
	    this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
	  };

	  /**
	   * Resizes the canvas to the specified width and height.
	   *
	   * @param {number} width - the new width of the canvas
	   * @param {number} height - the new height of the canvas
	   */


	  CanvasRenderTarget.prototype.resize = function resize(width, height) {
	    this.canvas.width = width * this.resolution;
	    this.canvas.height = height * this.resolution;
	  };

	  /**
	   * Destroys this canvas.
	   *
	   */


	  CanvasRenderTarget.prototype.destroy = function destroy() {
	    this.context = null;
	    this.canvas = null;
	  };

	  /**
	   * The width of the canvas buffer in pixels.
	   *
	   * @member {number}
	   */


	  _createClass(CanvasRenderTarget, [{
	    key: 'width',
	    get: function get() {
	      return this.canvas.width;
	    },
	    set: function set(val) // eslint-disable-line require-jsdoc
	    {
	      this.canvas.width = val;
	    }

	    /**
	     * The height of the canvas buffer in pixels.
	     *
	     * @member {number}
	     */

	  }, {
	    key: 'height',
	    get: function get() {
	      return this.canvas.height;
	    },
	    set: function set(val) // eslint-disable-line require-jsdoc
	    {
	      this.canvas.height = val;
	    }
	  }]);

	  return CanvasRenderTarget;
	}();

	exports.default = CanvasRenderTarget;
	//# sourceMappingURL=CanvasRenderTarget.js.map

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;
	exports.default = mapCanvasBlendModesToPixi;

	var _const = __webpack_require__(174);

	var _canUseNewCanvasBlendModes = __webpack_require__(242);

	var _canUseNewCanvasBlendModes2 = _interopRequireDefault(_canUseNewCanvasBlendModes);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/**
	 * Maps blend combinations to Canvas.
	 *
	 * @memberof PIXI
	 * @function mapCanvasBlendModesToPixi
	 * @private
	 * @param {string[]} [array=[]] - The array to output into.
	 * @return {string[]} Mapped modes.
	 */
	function mapCanvasBlendModesToPixi() {
	    var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

	    if ((0, _canUseNewCanvasBlendModes2.default)()) {
	        array[_const.BLEND_MODES.NORMAL] = 'source-over';
	        array[_const.BLEND_MODES.ADD] = 'lighter'; // IS THIS OK???
	        array[_const.BLEND_MODES.MULTIPLY] = 'multiply';
	        array[_const.BLEND_MODES.SCREEN] = 'screen';
	        array[_const.BLEND_MODES.OVERLAY] = 'overlay';
	        array[_const.BLEND_MODES.DARKEN] = 'darken';
	        array[_const.BLEND_MODES.LIGHTEN] = 'lighten';
	        array[_const.BLEND_MODES.COLOR_DODGE] = 'color-dodge';
	        array[_const.BLEND_MODES.COLOR_BURN] = 'color-burn';
	        array[_const.BLEND_MODES.HARD_LIGHT] = 'hard-light';
	        array[_const.BLEND_MODES.SOFT_LIGHT] = 'soft-light';
	        array[_const.BLEND_MODES.DIFFERENCE] = 'difference';
	        array[_const.BLEND_MODES.EXCLUSION] = 'exclusion';
	        array[_const.BLEND_MODES.HUE] = 'hue';
	        array[_const.BLEND_MODES.SATURATION] = 'saturate';
	        array[_const.BLEND_MODES.COLOR] = 'color';
	        array[_const.BLEND_MODES.LUMINOSITY] = 'luminosity';
	    } else {
	        // this means that the browser does not support the cool new blend modes in canvas 'cough' ie 'cough'
	        array[_const.BLEND_MODES.NORMAL] = 'source-over';
	        array[_const.BLEND_MODES.ADD] = 'lighter'; // IS THIS OK???
	        array[_const.BLEND_MODES.MULTIPLY] = 'source-over';
	        array[_const.BLEND_MODES.SCREEN] = 'source-over';
	        array[_const.BLEND_MODES.OVERLAY] = 'source-over';
	        array[_const.BLEND_MODES.DARKEN] = 'source-over';
	        array[_const.BLEND_MODES.LIGHTEN] = 'source-over';
	        array[_const.BLEND_MODES.COLOR_DODGE] = 'source-over';
	        array[_const.BLEND_MODES.COLOR_BURN] = 'source-over';
	        array[_const.BLEND_MODES.HARD_LIGHT] = 'source-over';
	        array[_const.BLEND_MODES.SOFT_LIGHT] = 'source-over';
	        array[_const.BLEND_MODES.DIFFERENCE] = 'source-over';
	        array[_const.BLEND_MODES.EXCLUSION] = 'source-over';
	        array[_const.BLEND_MODES.HUE] = 'source-over';
	        array[_const.BLEND_MODES.SATURATION] = 'source-over';
	        array[_const.BLEND_MODES.COLOR] = 'source-over';
	        array[_const.BLEND_MODES.LUMINOSITY] = 'source-over';
	    }
	    // not-premultiplied, only for webgl
	    array[_const.BLEND_MODES.NORMAL_NPM] = array[_const.BLEND_MODES.NORMAL];
	    array[_const.BLEND_MODES.ADD_NPM] = array[_const.BLEND_MODES.ADD];
	    array[_const.BLEND_MODES.SCREEN_NPM] = array[_const.BLEND_MODES.SCREEN];

	    return array;
	}
	//# sourceMappingURL=mapCanvasBlendModesToPixi.js.map

/***/ }),
/* 242 */
/***/ (function(module, exports) {

	'use strict';

	exports.__esModule = true;
	exports.default = canUseNewCanvasBlendModes;
	/**
	 * Creates a little colored canvas
	 *
	 * @ignore
	 * @param {string} color - The color to make the canvas
	 * @return {canvas} a small canvas element
	 */
	function createColoredCanvas(color) {
	    var canvas = document.createElement('canvas');

	    canvas.width = 6;
	    canvas.height = 1;

	    var context = canvas.getContext('2d');

	    context.fillStyle = color;
	    context.fillRect(0, 0, 6, 1);

	    return canvas;
	}

	/**
	 * Checks whether the Canvas BlendModes are supported by the current browser
	 *
	 * @return {boolean} whether they are supported
	 */
	function canUseNewCanvasBlendModes() {
	    if (typeof document === 'undefined') {
	        return false;
	    }

	    var magenta = createColoredCanvas('#ff00ff');
	    var yellow = createColoredCanvas('#ffff00');

	    var canvas = document.createElement('canvas');

	    canvas.width = 6;
	    canvas.height = 1;

	    var context = canvas.getContext('2d');

	    context.globalCompositeOperation = 'multiply';
	    context.drawImage(magenta, 0, 0);
	    context.drawImage(yellow, 2, 0);

	    var imageData = context.getImageData(2, 0, 1, 1);

	    if (!imageData) {
	        return false;
	    }

	    var data = imageData.data;

	    return data[0] === 255 && data[1] === 0 && data[2] === 0;
	}
	//# sourceMappingURL=canUseNewCanvasBlendModes.js.map

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _utils = __webpack_require__(213);

	var _canUseNewCanvasBlendModes = __webpack_require__(242);

	var _canUseNewCanvasBlendModes2 = _interopRequireDefault(_canUseNewCanvasBlendModes);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/**
	 * Utility methods for Sprite/Texture tinting.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var CanvasTinter = {
	    /**
	     * Basically this method just needs a sprite and a color and tints the sprite with the given color.
	     *
	     * @memberof PIXI.CanvasTinter
	     * @param {PIXI.Sprite} sprite - the sprite to tint
	     * @param {number} color - the color to use to tint the sprite with
	     * @return {HTMLCanvasElement} The tinted canvas
	     */
	    getTintedTexture: function getTintedTexture(sprite, color) {
	        var texture = sprite._texture;

	        color = CanvasTinter.roundColor(color);

	        var stringColor = '#' + ('00000' + (color | 0).toString(16)).substr(-6);

	        texture.tintCache = texture.tintCache || {};

	        var cachedTexture = texture.tintCache[stringColor];

	        var canvas = void 0;

	        if (cachedTexture) {
	            if (cachedTexture.tintId === texture._updateID) {
	                return texture.tintCache[stringColor];
	            }

	            canvas = texture.tintCache[stringColor];
	        } else {
	            canvas = CanvasTinter.canvas || document.createElement('canvas');
	        }

	        CanvasTinter.tintMethod(texture, color, canvas);

	        canvas.tintId = texture._updateID;

	        if (CanvasTinter.convertTintToImage) {
	            // is this better?
	            var tintImage = new Image();

	            tintImage.src = canvas.toDataURL();

	            texture.tintCache[stringColor] = tintImage;
	        } else {
	            texture.tintCache[stringColor] = canvas;
	            // if we are not converting the texture to an image then we need to lose the reference to the canvas
	            CanvasTinter.canvas = null;
	        }

	        return canvas;
	    },

	    /**
	     * Tint a texture using the 'multiply' operation.
	     *
	     * @memberof PIXI.CanvasTinter
	     * @param {PIXI.Texture} texture - the texture to tint
	     * @param {number} color - the color to use to tint the sprite with
	     * @param {HTMLCanvasElement} canvas - the current canvas
	     */
	    tintWithMultiply: function tintWithMultiply(texture, color, canvas) {
	        var context = canvas.getContext('2d');
	        var crop = texture._frame.clone();
	        var resolution = texture.baseTexture.resolution;

	        crop.x *= resolution;
	        crop.y *= resolution;
	        crop.width *= resolution;
	        crop.height *= resolution;

	        canvas.width = Math.ceil(crop.width);
	        canvas.height = Math.ceil(crop.height);

	        context.save();
	        context.fillStyle = '#' + ('00000' + (color | 0).toString(16)).substr(-6);

	        context.fillRect(0, 0, crop.width, crop.height);

	        context.globalCompositeOperation = 'multiply';

	        context.drawImage(texture.baseTexture.source, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);

	        context.globalCompositeOperation = 'destination-atop';

	        context.drawImage(texture.baseTexture.source, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);
	        context.restore();
	    },

	    /**
	     * Tint a texture using the 'overlay' operation.
	     *
	     * @memberof PIXI.CanvasTinter
	     * @param {PIXI.Texture} texture - the texture to tint
	     * @param {number} color - the color to use to tint the sprite with
	     * @param {HTMLCanvasElement} canvas - the current canvas
	     */
	    tintWithOverlay: function tintWithOverlay(texture, color, canvas) {
	        var context = canvas.getContext('2d');
	        var crop = texture._frame.clone();
	        var resolution = texture.baseTexture.resolution;

	        crop.x *= resolution;
	        crop.y *= resolution;
	        crop.width *= resolution;
	        crop.height *= resolution;

	        canvas.width = Math.ceil(crop.width);
	        canvas.height = Math.ceil(crop.height);

	        context.save();
	        context.globalCompositeOperation = 'copy';
	        context.fillStyle = '#' + ('00000' + (color | 0).toString(16)).substr(-6);
	        context.fillRect(0, 0, crop.width, crop.height);

	        context.globalCompositeOperation = 'destination-atop';
	        context.drawImage(texture.baseTexture.source, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);

	        // context.globalCompositeOperation = 'copy';
	        context.restore();
	    },


	    /**
	     * Tint a texture pixel per pixel.
	     *
	     * @memberof PIXI.CanvasTinter
	     * @param {PIXI.Texture} texture - the texture to tint
	     * @param {number} color - the color to use to tint the sprite with
	     * @param {HTMLCanvasElement} canvas - the current canvas
	     */
	    tintWithPerPixel: function tintWithPerPixel(texture, color, canvas) {
	        var context = canvas.getContext('2d');
	        var crop = texture._frame.clone();
	        var resolution = texture.baseTexture.resolution;

	        crop.x *= resolution;
	        crop.y *= resolution;
	        crop.width *= resolution;
	        crop.height *= resolution;

	        canvas.width = Math.ceil(crop.width);
	        canvas.height = Math.ceil(crop.height);

	        context.save();
	        context.globalCompositeOperation = 'copy';
	        context.drawImage(texture.baseTexture.source, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);
	        context.restore();

	        var rgbValues = (0, _utils.hex2rgb)(color);
	        var r = rgbValues[0];
	        var g = rgbValues[1];
	        var b = rgbValues[2];

	        var pixelData = context.getImageData(0, 0, crop.width, crop.height);

	        var pixels = pixelData.data;

	        for (var i = 0; i < pixels.length; i += 4) {
	            pixels[i + 0] *= r;
	            pixels[i + 1] *= g;
	            pixels[i + 2] *= b;
	        }

	        context.putImageData(pixelData, 0, 0);
	    },

	    /**
	     * Rounds the specified color according to the CanvasTinter.cacheStepsPerColorChannel.
	     *
	     * @memberof PIXI.CanvasTinter
	     * @param {number} color - the color to round, should be a hex color
	     * @return {number} The rounded color.
	     */
	    roundColor: function roundColor(color) {
	        var step = CanvasTinter.cacheStepsPerColorChannel;

	        var rgbValues = (0, _utils.hex2rgb)(color);

	        rgbValues[0] = Math.min(255, rgbValues[0] / step * step);
	        rgbValues[1] = Math.min(255, rgbValues[1] / step * step);
	        rgbValues[2] = Math.min(255, rgbValues[2] / step * step);

	        return (0, _utils.rgb2hex)(rgbValues);
	    },

	    /**
	     * Number of steps which will be used as a cap when rounding colors.
	     *
	     * @memberof PIXI.CanvasTinter
	     * @type {number}
	     */
	    cacheStepsPerColorChannel: 8,

	    /**
	     * Tint cache boolean flag.
	     *
	     * @memberof PIXI.CanvasTinter
	     * @type {boolean}
	     */
	    convertTintToImage: false,

	    /**
	     * Whether or not the Canvas BlendModes are supported, consequently the ability to tint using the multiply method.
	     *
	     * @memberof PIXI.CanvasTinter
	     * @type {boolean}
	     */
	    canUseMultiply: (0, _canUseNewCanvasBlendModes2.default)(),

	    /**
	     * The tinting method that will be used.
	     *
	     * @memberof PIXI.CanvasTinter
	     * @type {tintMethodFunctionType}
	     */
	    tintMethod: 0
	};

	CanvasTinter.tintMethod = CanvasTinter.canUseMultiply ? CanvasTinter.tintWithMultiply : CanvasTinter.tintWithPerPixel;

	/**
	 * The tintMethod type.
	 *
	 * @memberof PIXI.CanvasTinter
	 * @callback tintMethodFunctionType
	 * @param texture {PIXI.Texture} the texture to tint
	 * @param color {number} the color to use to tint the sprite with
	 * @param canvas {HTMLCanvasElement} the current canvas
	 */

	exports.default = CanvasTinter;
	//# sourceMappingURL=CanvasTinter.js.map

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _ObjectRenderer2 = __webpack_require__(245);

	var _ObjectRenderer3 = _interopRequireDefault(_ObjectRenderer2);

	var _WebGLRenderer = __webpack_require__(247);

	var _WebGLRenderer2 = _interopRequireDefault(_WebGLRenderer);

	var _createIndicesForQuads = __webpack_require__(261);

	var _createIndicesForQuads2 = _interopRequireDefault(_createIndicesForQuads);

	var _generateMultiTextureShader = __webpack_require__(270);

	var _generateMultiTextureShader2 = _interopRequireDefault(_generateMultiTextureShader);

	var _checkMaxIfStatmentsInShader = __webpack_require__(271);

	var _checkMaxIfStatmentsInShader2 = _interopRequireDefault(_checkMaxIfStatmentsInShader);

	var _BatchBuffer = __webpack_require__(272);

	var _BatchBuffer2 = _interopRequireDefault(_BatchBuffer);

	var _settings = __webpack_require__(205);

	var _settings2 = _interopRequireDefault(_settings);

	var _utils = __webpack_require__(213);

	var _pixiGlCore = __webpack_require__(185);

	var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);

	var _bitTwiddle = __webpack_require__(228);

	var _bitTwiddle2 = _interopRequireDefault(_bitTwiddle);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var TICK = 0;
	var TEXTURE_TICK = 0;

	/**
	 * Renderer dedicated to drawing and batching sprites.
	 *
	 * @class
	 * @private
	 * @memberof PIXI
	 * @extends PIXI.ObjectRenderer
	 */

	var SpriteRenderer = function (_ObjectRenderer) {
	    _inherits(SpriteRenderer, _ObjectRenderer);

	    /**
	     * @param {PIXI.WebGLRenderer} renderer - The renderer this sprite batch works for.
	     */
	    function SpriteRenderer(renderer) {
	        _classCallCheck(this, SpriteRenderer);

	        /**
	         * Number of values sent in the vertex buffer.
	         * aVertexPosition(2), aTextureCoord(1), aColor(1), aTextureId(1) = 5
	         *
	         * @member {number}
	         */
	        var _this = _possibleConstructorReturn(this, _ObjectRenderer.call(this, renderer));

	        _this.vertSize = 5;

	        /**
	         * The size of the vertex information in bytes.
	         *
	         * @member {number}
	         */
	        _this.vertByteSize = _this.vertSize * 4;

	        /**
	         * The number of images in the SpriteRenderer before it flushes.
	         *
	         * @member {number}
	         */
	        _this.size = _settings2.default.SPRITE_BATCH_SIZE; // 2000 is a nice balance between mobile / desktop

	        // the total number of bytes in our batch
	        // let numVerts = this.size * 4 * this.vertByteSize;

	        _this.buffers = [];
	        for (var i = 1; i <= _bitTwiddle2.default.nextPow2(_this.size); i *= 2) {
	            _this.buffers.push(new _BatchBuffer2.default(i * 4 * _this.vertByteSize));
	        }

	        /**
	         * Holds the indices of the geometry (quads) to draw
	         *
	         * @member {Uint16Array}
	         */
	        _this.indices = (0, _createIndicesForQuads2.default)(_this.size);

	        /**
	         * The default shaders that is used if a sprite doesn't have a more specific one.
	         * there is a shader for each number of textures that can be rendererd.
	         * These shaders will also be generated on the fly as required.
	         * @member {PIXI.Shader[]}
	         */
	        _this.shader = null;

	        _this.currentIndex = 0;
	        _this.groups = [];

	        for (var k = 0; k < _this.size; k++) {
	            _this.groups[k] = { textures: [], textureCount: 0, ids: [], size: 0, start: 0, blend: 0 };
	        }

	        _this.sprites = [];

	        _this.vertexBuffers = [];
	        _this.vaos = [];

	        _this.vaoMax = 2;
	        _this.vertexCount = 0;

	        _this.renderer.on('prerender', _this.onPrerender, _this);
	        return _this;
	    }

	    /**
	     * Sets up the renderer context and necessary buffers.
	     *
	     * @private
	     */


	    SpriteRenderer.prototype.onContextChange = function onContextChange() {
	        var gl = this.renderer.gl;

	        if (this.renderer.legacy) {
	            this.MAX_TEXTURES = 1;
	        } else {
	            // step 1: first check max textures the GPU can handle.
	            this.MAX_TEXTURES = Math.min(gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS), _settings2.default.SPRITE_MAX_TEXTURES);

	            // step 2: check the maximum number of if statements the shader can have too..
	            this.MAX_TEXTURES = (0, _checkMaxIfStatmentsInShader2.default)(this.MAX_TEXTURES, gl);
	        }

	        this.shader = (0, _generateMultiTextureShader2.default)(gl, this.MAX_TEXTURES);

	        // create a couple of buffers
	        this.indexBuffer = _pixiGlCore2.default.GLBuffer.createIndexBuffer(gl, this.indices, gl.STATIC_DRAW);

	        // we use the second shader as the first one depending on your browser may omit aTextureId
	        // as it is not used by the shader so is optimized out.

	        this.renderer.bindVao(null);

	        var attrs = this.shader.attributes;

	        for (var i = 0; i < this.vaoMax; i++) {
	            /* eslint-disable max-len */
	            var vertexBuffer = this.vertexBuffers[i] = _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl, null, gl.STREAM_DRAW);
	            /* eslint-enable max-len */

	            // build the vao object that will render..
	            var vao = this.renderer.createVao().addIndex(this.indexBuffer).addAttribute(vertexBuffer, attrs.aVertexPosition, gl.FLOAT, false, this.vertByteSize, 0).addAttribute(vertexBuffer, attrs.aTextureCoord, gl.UNSIGNED_SHORT, true, this.vertByteSize, 2 * 4).addAttribute(vertexBuffer, attrs.aColor, gl.UNSIGNED_BYTE, true, this.vertByteSize, 3 * 4);

	            if (attrs.aTextureId) {
	                vao.addAttribute(vertexBuffer, attrs.aTextureId, gl.FLOAT, false, this.vertByteSize, 4 * 4);
	            }

	            this.vaos[i] = vao;
	        }

	        this.vao = this.vaos[0];
	        this.currentBlendMode = 99999;

	        this.boundTextures = new Array(this.MAX_TEXTURES);
	    };

	    /**
	     * Called before the renderer starts rendering.
	     *
	     */


	    SpriteRenderer.prototype.onPrerender = function onPrerender() {
	        this.vertexCount = 0;
	    };

	    /**
	     * Renders the sprite object.
	     *
	     * @param {PIXI.Sprite} sprite - the sprite to render when using this spritebatch
	     */


	    SpriteRenderer.prototype.render = function render(sprite) {
	        // TODO set blend modes..
	        // check texture..
	        if (this.currentIndex >= this.size) {
	            this.flush();
	        }

	        // get the uvs for the texture

	        // if the uvs have not updated then no point rendering just yet!
	        if (!sprite._texture._uvs) {
	            return;
	        }

	        // push a texture.
	        // increment the batchsize
	        this.sprites[this.currentIndex++] = sprite;
	    };

	    /**
	     * Renders the content and empties the current batch.
	     *
	     */


	    SpriteRenderer.prototype.flush = function flush() {
	        if (this.currentIndex === 0) {
	            return;
	        }

	        var gl = this.renderer.gl;
	        var MAX_TEXTURES = this.MAX_TEXTURES;

	        var np2 = _bitTwiddle2.default.nextPow2(this.currentIndex);
	        var log2 = _bitTwiddle2.default.log2(np2);
	        var buffer = this.buffers[log2];

	        var sprites = this.sprites;
	        var groups = this.groups;

	        var float32View = buffer.float32View;
	        var uint32View = buffer.uint32View;

	        var boundTextures = this.boundTextures;
	        var rendererBoundTextures = this.renderer.boundTextures;
	        var touch = this.renderer.textureGC.count;

	        var index = 0;
	        var nextTexture = void 0;
	        var currentTexture = void 0;
	        var groupCount = 1;
	        var textureCount = 0;
	        var currentGroup = groups[0];
	        var vertexData = void 0;
	        var uvs = void 0;
	        var blendMode = _utils.premultiplyBlendMode[sprites[0]._texture.baseTexture.premultipliedAlpha ? 1 : 0][sprites[0].blendMode];

	        currentGroup.textureCount = 0;
	        currentGroup.start = 0;
	        currentGroup.blend = blendMode;

	        TICK++;

	        var i = void 0;

	        // copy textures..
	        for (i = 0; i < MAX_TEXTURES; ++i) {
	            var bt = rendererBoundTextures[i];

	            if (bt._enabled === TICK) {
	                boundTextures[i] = this.renderer.emptyTextures[i];
	                continue;
	            }

	            boundTextures[i] = bt;
	            bt._virtalBoundId = i;
	            bt._enabled = TICK;
	        }
	        TICK++;

	        for (i = 0; i < this.currentIndex; ++i) {
	            // upload the sprite elemetns...
	            // they have all ready been calculated so we just need to push them into the buffer.
	            var sprite = sprites[i];

	            sprites[i] = null;

	            nextTexture = sprite._texture.baseTexture;

	            var spriteBlendMode = _utils.premultiplyBlendMode[Number(nextTexture.premultipliedAlpha)][sprite.blendMode];

	            if (blendMode !== spriteBlendMode) {
	                // finish a group..
	                blendMode = spriteBlendMode;

	                // force the batch to break!
	                currentTexture = null;
	                textureCount = MAX_TEXTURES;
	                TICK++;
	            }

	            if (currentTexture !== nextTexture) {
	                currentTexture = nextTexture;

	                if (nextTexture._enabled !== TICK) {
	                    if (textureCount === MAX_TEXTURES) {
	                        TICK++;

	                        currentGroup.size = i - currentGroup.start;

	                        textureCount = 0;

	                        currentGroup = groups[groupCount++];
	                        currentGroup.blend = blendMode;
	                        currentGroup.textureCount = 0;
	                        currentGroup.start = i;
	                    }

	                    nextTexture.touched = touch;

	                    if (nextTexture._virtalBoundId === -1) {
	                        for (var j = 0; j < MAX_TEXTURES; ++j) {
	                            var tIndex = (j + TEXTURE_TICK) % MAX_TEXTURES;

	                            var t = boundTextures[tIndex];

	                            if (t._enabled !== TICK) {
	                                TEXTURE_TICK++;

	                                t._virtalBoundId = -1;

	                                nextTexture._virtalBoundId = tIndex;

	                                boundTextures[tIndex] = nextTexture;
	                                break;
	                            }
	                        }
	                    }

	                    nextTexture._enabled = TICK;

	                    currentGroup.textureCount++;
	                    currentGroup.ids[textureCount] = nextTexture._virtalBoundId;
	                    currentGroup.textures[textureCount++] = nextTexture;
	                }
	            }

	            vertexData = sprite.vertexData;

	            // TODO this sum does not need to be set each frame..
	            uvs = sprite._texture._uvs.uvsUint32;

	            if (this.renderer.roundPixels) {
	                var resolution = this.renderer.resolution;

	                // xy
	                float32View[index] = (vertexData[0] * resolution | 0) / resolution;
	                float32View[index + 1] = (vertexData[1] * resolution | 0) / resolution;

	                // xy
	                float32View[index + 5] = (vertexData[2] * resolution | 0) / resolution;
	                float32View[index + 6] = (vertexData[3] * resolution | 0) / resolution;

	                // xy
	                float32View[index + 10] = (vertexData[4] * resolution | 0) / resolution;
	                float32View[index + 11] = (vertexData[5] * resolution | 0) / resolution;

	                // xy
	                float32View[index + 15] = (vertexData[6] * resolution | 0) / resolution;
	                float32View[index + 16] = (vertexData[7] * resolution | 0) / resolution;
	            } else {
	                // xy
	                float32View[index] = vertexData[0];
	                float32View[index + 1] = vertexData[1];

	                // xy
	                float32View[index + 5] = vertexData[2];
	                float32View[index + 6] = vertexData[3];

	                // xy
	                float32View[index + 10] = vertexData[4];
	                float32View[index + 11] = vertexData[5];

	                // xy
	                float32View[index + 15] = vertexData[6];
	                float32View[index + 16] = vertexData[7];
	            }

	            uint32View[index + 2] = uvs[0];
	            uint32View[index + 7] = uvs[1];
	            uint32View[index + 12] = uvs[2];
	            uint32View[index + 17] = uvs[3];
	            /* eslint-disable max-len */
	            var alpha = Math.min(sprite.worldAlpha, 1.0);
	            // we dont call extra function if alpha is 1.0, that's faster
	            var argb = alpha < 1.0 && nextTexture.premultipliedAlpha ? (0, _utils.premultiplyTint)(sprite._tintRGB, alpha) : sprite._tintRGB + (alpha * 255 << 24);

	            uint32View[index + 3] = uint32View[index + 8] = uint32View[index + 13] = uint32View[index + 18] = argb;
	            float32View[index + 4] = float32View[index + 9] = float32View[index + 14] = float32View[index + 19] = nextTexture._virtalBoundId;
	            /* eslint-enable max-len */

	            index += 20;
	        }

	        currentGroup.size = i - currentGroup.start;

	        if (!_settings2.default.CAN_UPLOAD_SAME_BUFFER) {
	            // this is still needed for IOS performance..
	            // it really does not like uploading to the same buffer in a single frame!
	            if (this.vaoMax <= this.vertexCount) {
	                this.vaoMax++;

	                var attrs = this.shader.attributes;

	                /* eslint-disable max-len */
	                var vertexBuffer = this.vertexBuffers[this.vertexCount] = _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl, null, gl.STREAM_DRAW);
	                /* eslint-enable max-len */

	                // build the vao object that will render..
	                var vao = this.renderer.createVao().addIndex(this.indexBuffer).addAttribute(vertexBuffer, attrs.aVertexPosition, gl.FLOAT, false, this.vertByteSize, 0).addAttribute(vertexBuffer, attrs.aTextureCoord, gl.UNSIGNED_SHORT, true, this.vertByteSize, 2 * 4).addAttribute(vertexBuffer, attrs.aColor, gl.UNSIGNED_BYTE, true, this.vertByteSize, 3 * 4);

	                if (attrs.aTextureId) {
	                    vao.addAttribute(vertexBuffer, attrs.aTextureId, gl.FLOAT, false, this.vertByteSize, 4 * 4);
	                }

	                this.vaos[this.vertexCount] = vao;
	            }

	            this.renderer.bindVao(this.vaos[this.vertexCount]);

	            this.vertexBuffers[this.vertexCount].upload(buffer.vertices, 0, false);

	            this.vertexCount++;
	        } else {
	            // lets use the faster option, always use buffer number 0
	            this.vertexBuffers[this.vertexCount].upload(buffer.vertices, 0, true);
	        }

	        for (i = 0; i < MAX_TEXTURES; ++i) {
	            rendererBoundTextures[i]._virtalBoundId = -1;
	        }

	        // render the groups..
	        for (i = 0; i < groupCount; ++i) {
	            var group = groups[i];
	            var groupTextureCount = group.textureCount;

	            for (var _j = 0; _j < groupTextureCount; _j++) {
	                currentTexture = group.textures[_j];

	                // reset virtual ids..
	                // lets do a quick check..
	                if (rendererBoundTextures[group.ids[_j]] !== currentTexture) {
	                    this.renderer.bindTexture(currentTexture, group.ids[_j], true);
	                }

	                // reset the virtualId..
	                currentTexture._virtalBoundId = -1;
	            }

	            // set the blend mode..
	            this.renderer.state.setBlendMode(group.blend);

	            gl.drawElements(gl.TRIANGLES, group.size * 6, gl.UNSIGNED_SHORT, group.start * 6 * 2);
	        }

	        // reset elements for the next flush
	        this.currentIndex = 0;
	    };

	    /**
	     * Starts a new sprite batch.
	     */


	    SpriteRenderer.prototype.start = function start() {
	        this.renderer.bindShader(this.shader);

	        if (_settings2.default.CAN_UPLOAD_SAME_BUFFER) {
	            // bind buffer #0, we don't need others
	            this.renderer.bindVao(this.vaos[this.vertexCount]);

	            this.vertexBuffers[this.vertexCount].bind();
	        }
	    };

	    /**
	     * Stops and flushes the current batch.
	     *
	     */


	    SpriteRenderer.prototype.stop = function stop() {
	        this.flush();
	    };

	    /**
	     * Destroys the SpriteRenderer.
	     *
	     */


	    SpriteRenderer.prototype.destroy = function destroy() {
	        for (var i = 0; i < this.vaoMax; i++) {
	            if (this.vertexBuffers[i]) {
	                this.vertexBuffers[i].destroy();
	            }
	            if (this.vaos[i]) {
	                this.vaos[i].destroy();
	            }
	        }

	        if (this.indexBuffer) {
	            this.indexBuffer.destroy();
	        }

	        this.renderer.off('prerender', this.onPrerender, this);

	        _ObjectRenderer.prototype.destroy.call(this);

	        if (this.shader) {
	            this.shader.destroy();
	            this.shader = null;
	        }

	        this.vertexBuffers = null;
	        this.vaos = null;
	        this.indexBuffer = null;
	        this.indices = null;

	        this.sprites = null;

	        for (var _i = 0; _i < this.buffers.length; ++_i) {
	            this.buffers[_i].destroy();
	        }
	    };

	    return SpriteRenderer;
	}(_ObjectRenderer3.default);

	exports.default = SpriteRenderer;


	_WebGLRenderer2.default.registerPlugin('sprite', SpriteRenderer);
	//# sourceMappingURL=SpriteRenderer.js.map

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _WebGLManager2 = __webpack_require__(246);

	var _WebGLManager3 = _interopRequireDefault(_WebGLManager2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	/**
	 * Base for a common object renderer that can be used as a system renderer plugin.
	 *
	 * @class
	 * @extends PIXI.WebGLManager
	 * @memberof PIXI
	 */
	var ObjectRenderer = function (_WebGLManager) {
	  _inherits(ObjectRenderer, _WebGLManager);

	  function ObjectRenderer() {
	    _classCallCheck(this, ObjectRenderer);

	    return _possibleConstructorReturn(this, _WebGLManager.apply(this, arguments));
	  }

	  /**
	   * Starts the renderer and sets the shader
	   *
	   */
	  ObjectRenderer.prototype.start = function start() {}
	  // set the shader..


	  /**
	   * Stops the renderer
	   *
	   */
	  ;

	  ObjectRenderer.prototype.stop = function stop() {
	    this.flush();
	  };

	  /**
	   * Stub method for rendering content and emptying the current batch.
	   *
	   */


	  ObjectRenderer.prototype.flush = function flush() {}
	  // flush!


	  /**
	   * Renders an object
	   *
	   * @param {PIXI.DisplayObject} object - The object to render.
	   */
	  ;

	  ObjectRenderer.prototype.render = function render(object) // eslint-disable-line no-unused-vars
	  {
	    // render the object
	  };

	  return ObjectRenderer;
	}(_WebGLManager3.default);

	exports.default = ObjectRenderer;
	//# sourceMappingURL=ObjectRenderer.js.map

/***/ }),
/* 246 */
/***/ (function(module, exports) {

	'use strict';

	exports.__esModule = true;

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/**
	 * @class
	 * @memberof PIXI
	 */
	var WebGLManager = function () {
	  /**
	   * @param {PIXI.WebGLRenderer} renderer - The renderer this manager works for.
	   */
	  function WebGLManager(renderer) {
	    _classCallCheck(this, WebGLManager);

	    /**
	     * The renderer this manager works for.
	     *
	     * @member {PIXI.WebGLRenderer}
	     */
	    this.renderer = renderer;

	    this.renderer.on('context', this.onContextChange, this);
	  }

	  /**
	   * Generic method called when there is a WebGL context change.
	   *
	   */


	  WebGLManager.prototype.onContextChange = function onContextChange() {}
	  // do some codes init!


	  /**
	   * Generic destroy methods to be overridden by the subclass
	   *
	   */
	  ;

	  WebGLManager.prototype.destroy = function destroy() {
	    this.renderer.off('context', this.onContextChange, this);

	    this.renderer = null;
	  };

	  return WebGLManager;
	}();

	exports.default = WebGLManager;
	//# sourceMappingURL=WebGLManager.js.map

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _SystemRenderer2 = __webpack_require__(236);

	var _SystemRenderer3 = _interopRequireDefault(_SystemRenderer2);

	var _MaskManager = __webpack_require__(248);

	var _MaskManager2 = _interopRequireDefault(_MaskManager);

	var _StencilManager = __webpack_require__(257);

	var _StencilManager2 = _interopRequireDefault(_StencilManager);

	var _FilterManager = __webpack_require__(258);

	var _FilterManager2 = _interopRequireDefault(_FilterManager);

	var _RenderTarget = __webpack_require__(259);

	var _RenderTarget2 = _interopRequireDefault(_RenderTarget);

	var _ObjectRenderer = __webpack_require__(245);

	var _ObjectRenderer2 = _interopRequireDefault(_ObjectRenderer);

	var _TextureManager = __webpack_require__(264);

	var _TextureManager2 = _interopRequireDefault(_TextureManager);

	var _BaseTexture = __webpack_require__(221);

	var _BaseTexture2 = _interopRequireDefault(_BaseTexture);

	var _TextureGarbageCollector = __webpack_require__(265);

	var _TextureGarbageCollector2 = _interopRequireDefault(_TextureGarbageCollector);

	var _WebGLState = __webpack_require__(266);

	var _WebGLState2 = _interopRequireDefault(_WebGLState);

	var _mapWebGLDrawModesToPixi = __webpack_require__(268);

	var _mapWebGLDrawModesToPixi2 = _interopRequireDefault(_mapWebGLDrawModesToPixi);

	var _validateContext = __webpack_require__(269);

	var _validateContext2 = _interopRequireDefault(_validateContext);

	var _utils = __webpack_require__(213);

	var _pixiGlCore = __webpack_require__(185);

	var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);

	var _const = __webpack_require__(174);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var CONTEXT_UID = 0;

	/**
	 * The WebGLRenderer draws the scene and all its content onto a webGL enabled canvas. This renderer
	 * should be used for browsers that support webGL. This Render works by automatically managing webGLBatchs.
	 * So no need for Sprite Batches or Sprite Clouds.
	 * Don't forget to add the view to your DOM or you will not see anything :)
	 *
	 * @class
	 * @memberof PIXI
	 * @extends PIXI.SystemRenderer
	 */

	var WebGLRenderer = function (_SystemRenderer) {
	    _inherits(WebGLRenderer, _SystemRenderer);

	    // eslint-disable-next-line valid-jsdoc
	    /**
	     *
	     * @param {object} [options] - The optional renderer parameters
	     * @param {number} [options.width=800] - the width of the screen
	     * @param {number} [options.height=600] - the height of the screen
	     * @param {HTMLCanvasElement} [options.view] - the canvas to use as a view, optional
	     * @param {boolean} [options.transparent=false] - If the render view is transparent, default false
	     * @param {boolean} [options.autoResize=false] - If the render view is automatically resized, default false
	     * @param {boolean} [options.antialias=false] - sets antialias. If not available natively then FXAA
	     *  antialiasing is used
	     * @param {boolean} [options.forceFXAA=false] - forces FXAA antialiasing to be used over native.
	     *  FXAA is faster, but may not always look as great
	     * @param {number} [options.resolution=1] - The resolution / device pixel ratio of the renderer.
	     *  The resolution of the renderer retina would be 2.
	     * @param {boolean} [options.clearBeforeRender=true] - This sets if the renderer will clear
	     *  the canvas or not before the new render pass. If you wish to set this to false, you *must* set
	     *  preserveDrawingBuffer to `true`.
	     * @param {boolean} [options.preserveDrawingBuffer=false] - enables drawing buffer preservation,
	     *  enable this if you need to call toDataUrl on the webgl context.
	     * @param {boolean} [options.roundPixels=false] - If true PixiJS will Math.floor() x/y values when
	     *  rendering, stopping pixel interpolation.
	     * @param {number} [options.backgroundColor=0x000000] - The background color of the rendered area
	     *  (shown if not transparent).
	     * @param {boolean} [options.legacy=false] - If true PixiJS will aim to ensure compatibility
	     *  with older / less advanced devices. If you experience unexplained flickering try setting this to true.
	     * @param {string} [options.powerPreference] - Parameter passed to webgl context, set to "high-performance"
	     *  for devices with dual graphics card
	     */
	    function WebGLRenderer(options, arg2, arg3) {
	        _classCallCheck(this, WebGLRenderer);

	        var _this = _possibleConstructorReturn(this, _SystemRenderer.call(this, 'WebGL', options, arg2, arg3));

	        _this.legacy = _this.options.legacy;

	        if (_this.legacy) {
	            _pixiGlCore2.default.VertexArrayObject.FORCE_NATIVE = true;
	        }

	        /**
	         * The type of this renderer as a standardised const
	         *
	         * @member {number}
	         * @see PIXI.RENDERER_TYPE
	         */
	        _this.type = _const.RENDERER_TYPE.WEBGL;

	        _this.handleContextLost = _this.handleContextLost.bind(_this);
	        _this.handleContextRestored = _this.handleContextRestored.bind(_this);

	        _this.view.addEventListener('webglcontextlost', _this.handleContextLost, false);
	        _this.view.addEventListener('webglcontextrestored', _this.handleContextRestored, false);

	        /**
	         * The options passed in to create a new webgl context.
	         *
	         * @member {object}
	         * @private
	         */
	        _this._contextOptions = {
	            alpha: _this.transparent,
	            antialias: _this.options.antialias,
	            premultipliedAlpha: _this.transparent && _this.transparent !== 'notMultiplied',
	            stencil: true,
	            preserveDrawingBuffer: _this.options.preserveDrawingBuffer,
	            powerPreference: _this.options.powerPreference
	        };

	        _this._backgroundColorRgba[3] = _this.transparent ? 0 : 1;

	        /**
	         * Manages the masks using the stencil buffer.
	         *
	         * @member {PIXI.MaskManager}
	         */
	        _this.maskManager = new _MaskManager2.default(_this);

	        /**
	         * Manages the stencil buffer.
	         *
	         * @member {PIXI.StencilManager}
	         */
	        _this.stencilManager = new _StencilManager2.default(_this);

	        /**
	         * An empty renderer.
	         *
	         * @member {PIXI.ObjectRenderer}
	         */
	        _this.emptyRenderer = new _ObjectRenderer2.default(_this);

	        /**
	         * The currently active ObjectRenderer.
	         *
	         * @member {PIXI.ObjectRenderer}
	         */
	        _this.currentRenderer = _this.emptyRenderer;

	        /**
	         * Manages textures
	         * @member {PIXI.TextureManager}
	         */
	        _this.textureManager = null;

	        /**
	         * Manages the filters.
	         *
	         * @member {PIXI.FilterManager}
	         */
	        _this.filterManager = null;

	        _this.initPlugins();

	        /**
	         * The current WebGL rendering context, it is created here
	         *
	         * @member {WebGLRenderingContext}
	         */
	        // initialize the context so it is ready for the managers.
	        if (_this.options.context) {
	            // checks to see if a context is valid..
	            (0, _validateContext2.default)(_this.options.context);
	        }

	        _this.gl = _this.options.context || _pixiGlCore2.default.createContext(_this.view, _this._contextOptions);

	        _this.CONTEXT_UID = CONTEXT_UID++;

	        /**
	         * The currently active ObjectRenderer.
	         *
	         * @member {PIXI.WebGLState}
	         */
	        _this.state = new _WebGLState2.default(_this.gl);

	        _this.renderingToScreen = true;

	        /**
	         * Holds the current state of textures bound to the GPU.
	         * @type {Array}
	         */
	        _this.boundTextures = null;

	        /**
	         * Holds the current shader
	         *
	         * @member {PIXI.Shader}
	         */
	        _this._activeShader = null;

	        _this._activeVao = null;

	        /**
	         * Holds the current render target
	         *
	         * @member {PIXI.RenderTarget}
	         */
	        _this._activeRenderTarget = null;

	        _this._initContext();

	        // map some webGL blend and drawmodes..
	        _this.drawModes = (0, _mapWebGLDrawModesToPixi2.default)(_this.gl);

	        _this._nextTextureLocation = 0;

	        _this.setBlendMode(0);

	        /**
	         * Fired after rendering finishes.
	         *
	         * @event PIXI.WebGLRenderer#postrender
	         */

	        /**
	         * Fired before rendering starts.
	         *
	         * @event PIXI.WebGLRenderer#prerender
	         */

	        /**
	         * Fired when the WebGL context is set.
	         *
	         * @event PIXI.WebGLRenderer#context
	         * @param {WebGLRenderingContext} gl - WebGL context.
	         */
	        return _this;
	    }

	    /**
	     * Creates the WebGL context
	     *
	     * @private
	     */


	    WebGLRenderer.prototype._initContext = function _initContext() {
	        var gl = this.gl;

	        // restore a context if it was previously lost
	        if (gl.isContextLost() && gl.getExtension('WEBGL_lose_context')) {
	            gl.getExtension('WEBGL_lose_context').restoreContext();
	        }

	        var maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);

	        this._activeShader = null;
	        this._activeVao = null;

	        this.boundTextures = new Array(maxTextures);
	        this.emptyTextures = new Array(maxTextures);

	        // create a texture manager...
	        this.textureManager = new _TextureManager2.default(this);
	        this.filterManager = new _FilterManager2.default(this);
	        this.textureGC = new _TextureGarbageCollector2.default(this);

	        this.state.resetToDefault();

	        this.rootRenderTarget = new _RenderTarget2.default(gl, this.width, this.height, null, this.resolution, true);
	        this.rootRenderTarget.clearColor = this._backgroundColorRgba;

	        this.bindRenderTarget(this.rootRenderTarget);

	        // now lets fill up the textures with empty ones!
	        var emptyGLTexture = new _pixiGlCore2.default.GLTexture.fromData(gl, null, 1, 1);

	        var tempObj = { _glTextures: {} };

	        tempObj._glTextures[this.CONTEXT_UID] = {};

	        for (var i = 0; i < maxTextures; i++) {
	            var empty = new _BaseTexture2.default();

	            empty._glTextures[this.CONTEXT_UID] = emptyGLTexture;

	            this.boundTextures[i] = tempObj;
	            this.emptyTextures[i] = empty;
	            this.bindTexture(null, i);
	        }

	        this.emit('context', gl);

	        // setup the width/height properties and gl viewport
	        this.resize(this.screen.width, this.screen.height);
	    };

	    /**
	     * Renders the object to its webGL view
	     *
	     * @param {PIXI.DisplayObject} displayObject - the object to be rendered
	     * @param {PIXI.RenderTexture} renderTexture - The render texture to render to.
	     * @param {boolean} [clear] - Should the canvas be cleared before the new render
	     * @param {PIXI.Matrix} [transform] - A transform to apply to the render texture before rendering.
	     * @param {boolean} [skipUpdateTransform] - Should we skip the update transform pass?
	     */


	    WebGLRenderer.prototype.render = function render(displayObject, renderTexture, clear, transform, skipUpdateTransform) {
	        // can be handy to know!
	        this.renderingToScreen = !renderTexture;

	        this.emit('prerender');

	        // no point rendering if our context has been blown up!
	        if (!this.gl || this.gl.isContextLost()) {
	            return;
	        }

	        this._nextTextureLocation = 0;

	        if (!renderTexture) {
	            this._lastObjectRendered = displayObject;
	        }

	        if (!skipUpdateTransform) {
	            // update the scene graph
	            var cacheParent = displayObject.parent;

	            displayObject.parent = this._tempDisplayObjectParent;
	            displayObject.updateTransform();
	            displayObject.parent = cacheParent;
	            // displayObject.hitArea = //TODO add a temp hit area
	        }

	        this.bindRenderTexture(renderTexture, transform);

	        this.currentRenderer.start();

	        if (clear !== undefined ? clear : this.clearBeforeRender) {
	            this._activeRenderTarget.clear();
	        }

	        displayObject.renderWebGL(this);

	        // apply transform..
	        this.currentRenderer.flush();

	        // this.setObjectRenderer(this.emptyRenderer);

	        this.textureGC.update();

	        this.emit('postrender');
	    };

	    /**
	     * Changes the current renderer to the one given in parameter
	     *
	     * @param {PIXI.ObjectRenderer} objectRenderer - The object renderer to use.
	     */


	    WebGLRenderer.prototype.setObjectRenderer = function setObjectRenderer(objectRenderer) {
	        if (this.currentRenderer === objectRenderer) {
	            return;
	        }

	        this.currentRenderer.stop();
	        this.currentRenderer = objectRenderer;
	        this.currentRenderer.start();
	    };

	    /**
	     * This should be called if you wish to do some custom rendering
	     * It will basically render anything that may be batched up such as sprites
	     *
	     */


	    WebGLRenderer.prototype.flush = function flush() {
	        this.setObjectRenderer(this.emptyRenderer);
	    };

	    /**
	     * Resizes the webGL view to the specified width and height.
	     *
	     * @param {number} screenWidth - the new width of the screen
	     * @param {number} screenHeight - the new height of the screen
	     */


	    WebGLRenderer.prototype.resize = function resize(screenWidth, screenHeight) {
	        //  if(width * this.resolution === this.width && height * this.resolution === this.height)return;

	        _SystemRenderer3.default.prototype.resize.call(this, screenWidth, screenHeight);

	        this.rootRenderTarget.resize(screenWidth, screenHeight);

	        if (this._activeRenderTarget === this.rootRenderTarget) {
	            this.rootRenderTarget.activate();

	            if (this._activeShader) {
	                this._activeShader.uniforms.projectionMatrix = this.rootRenderTarget.projectionMatrix.toArray(true);
	            }
	        }
	    };

	    /**
	     * Resizes the webGL view to the specified width and height.
	     *
	     * @param {number} blendMode - the desired blend mode
	     */


	    WebGLRenderer.prototype.setBlendMode = function setBlendMode(blendMode) {
	        this.state.setBlendMode(blendMode);
	    };

	    /**
	     * Erases the active render target and fills the drawing area with a colour
	     *
	     * @param {number} [clearColor] - The colour
	     */


	    WebGLRenderer.prototype.clear = function clear(clearColor) {
	        this._activeRenderTarget.clear(clearColor);
	    };

	    /**
	     * Sets the transform of the active render target to the given matrix
	     *
	     * @param {PIXI.Matrix} matrix - The transformation matrix
	     */


	    WebGLRenderer.prototype.setTransform = function setTransform(matrix) {
	        this._activeRenderTarget.transform = matrix;
	    };

	    /**
	     * Erases the render texture and fills the drawing area with a colour
	     *
	     * @param {PIXI.RenderTexture} renderTexture - The render texture to clear
	     * @param {number} [clearColor] - The colour
	     * @return {PIXI.WebGLRenderer} Returns itself.
	     */


	    WebGLRenderer.prototype.clearRenderTexture = function clearRenderTexture(renderTexture, clearColor) {
	        var baseTexture = renderTexture.baseTexture;
	        var renderTarget = baseTexture._glRenderTargets[this.CONTEXT_UID];

	        if (renderTarget) {
	            renderTarget.clear(clearColor);
	        }

	        return this;
	    };

	    /**
	     * Binds a render texture for rendering
	     *
	     * @param {PIXI.RenderTexture} renderTexture - The render texture to render
	     * @param {PIXI.Matrix} transform - The transform to be applied to the render texture
	     * @return {PIXI.WebGLRenderer} Returns itself.
	     */


	    WebGLRenderer.prototype.bindRenderTexture = function bindRenderTexture(renderTexture, transform) {
	        var renderTarget = void 0;

	        if (renderTexture) {
	            var baseTexture = renderTexture.baseTexture;

	            if (!baseTexture._glRenderTargets[this.CONTEXT_UID]) {
	                // bind the current texture
	                this.textureManager.updateTexture(baseTexture, 0);
	            }

	            this.unbindTexture(baseTexture);

	            renderTarget = baseTexture._glRenderTargets[this.CONTEXT_UID];
	            renderTarget.setFrame(renderTexture.frame);
	        } else {
	            renderTarget = this.rootRenderTarget;
	        }

	        renderTarget.transform = transform;
	        this.bindRenderTarget(renderTarget);

	        return this;
	    };

	    /**
	     * Changes the current render target to the one given in parameter
	     *
	     * @param {PIXI.RenderTarget} renderTarget - the new render target
	     * @return {PIXI.WebGLRenderer} Returns itself.
	     */


	    WebGLRenderer.prototype.bindRenderTarget = function bindRenderTarget(renderTarget) {
	        if (renderTarget !== this._activeRenderTarget) {
	            this._activeRenderTarget = renderTarget;
	            renderTarget.activate();

	            if (this._activeShader) {
	                this._activeShader.uniforms.projectionMatrix = renderTarget.projectionMatrix.toArray(true);
	            }

	            this.stencilManager.setMaskStack(renderTarget.stencilMaskStack);
	        }

	        return this;
	    };

	    /**
	     * Changes the current shader to the one given in parameter
	     *
	     * @param {PIXI.Shader} shader - the new shader
	     * @param {boolean} [autoProject=true] - Whether automatically set the projection matrix
	     * @return {PIXI.WebGLRenderer} Returns itself.
	     */


	    WebGLRenderer.prototype.bindShader = function bindShader(shader, autoProject) {
	        // TODO cache
	        if (this._activeShader !== shader) {
	            this._activeShader = shader;
	            shader.bind();

	            // `autoProject` normally would be a default parameter set to true
	            // but because of how Babel transpiles default parameters
	            // it hinders the performance of this method.
	            if (autoProject !== false) {
	                // automatically set the projection matrix
	                shader.uniforms.projectionMatrix = this._activeRenderTarget.projectionMatrix.toArray(true);
	            }
	        }

	        return this;
	    };

	    /**
	     * Binds the texture. This will return the location of the bound texture.
	     * It may not be the same as the one you pass in. This is due to optimisation that prevents
	     * needless binding of textures. For example if the texture is already bound it will return the
	     * current location of the texture instead of the one provided. To bypass this use force location
	     *
	     * @param {PIXI.Texture} texture - the new texture
	     * @param {number} location - the suggested texture location
	     * @param {boolean} forceLocation - force the location
	     * @return {number} bound texture location
	     */


	    WebGLRenderer.prototype.bindTexture = function bindTexture(texture, location, forceLocation) {
	        texture = texture || this.emptyTextures[location];
	        texture = texture.baseTexture || texture;
	        texture.touched = this.textureGC.count;

	        if (!forceLocation) {
	            // TODO - maybe look into adding boundIds.. save us the loop?
	            for (var i = 0; i < this.boundTextures.length; i++) {
	                if (this.boundTextures[i] === texture) {
	                    return i;
	                }
	            }

	            if (location === undefined) {
	                this._nextTextureLocation++;
	                this._nextTextureLocation %= this.boundTextures.length;
	                location = this.boundTextures.length - this._nextTextureLocation - 1;
	            }
	        } else {
	            location = location || 0;
	        }

	        var gl = this.gl;
	        var glTexture = texture._glTextures[this.CONTEXT_UID];

	        if (!glTexture) {
	            // this will also bind the texture..
	            this.textureManager.updateTexture(texture, location);
	        } else {
	            // bind the current texture
	            this.boundTextures[location] = texture;
	            gl.activeTexture(gl.TEXTURE0 + location);
	            gl.bindTexture(gl.TEXTURE_2D, glTexture.texture);
	        }

	        return location;
	    };

	    /**
	    * unbinds the texture ...
	    *
	    * @param {PIXI.Texture} texture - the texture to unbind
	    * @return {PIXI.WebGLRenderer} Returns itself.
	    */


	    WebGLRenderer.prototype.unbindTexture = function unbindTexture(texture) {
	        var gl = this.gl;

	        texture = texture.baseTexture || texture;

	        for (var i = 0; i < this.boundTextures.length; i++) {
	            if (this.boundTextures[i] === texture) {
	                this.boundTextures[i] = this.emptyTextures[i];

	                gl.activeTexture(gl.TEXTURE0 + i);
	                gl.bindTexture(gl.TEXTURE_2D, this.emptyTextures[i]._glTextures[this.CONTEXT_UID].texture);
	            }
	        }

	        return this;
	    };

	    /**
	     * Creates a new VAO from this renderer's context and state.
	     *
	     * @return {VertexArrayObject} The new VAO.
	     */


	    WebGLRenderer.prototype.createVao = function createVao() {
	        return new _pixiGlCore2.default.VertexArrayObject(this.gl, this.state.attribState);
	    };

	    /**
	     * Changes the current Vao to the one given in parameter
	     *
	     * @param {PIXI.VertexArrayObject} vao - the new Vao
	     * @return {PIXI.WebGLRenderer} Returns itself.
	     */


	    WebGLRenderer.prototype.bindVao = function bindVao(vao) {
	        if (this._activeVao === vao) {
	            return this;
	        }

	        if (vao) {
	            vao.bind();
	        } else if (this._activeVao) {
	            // TODO this should always be true i think?
	            this._activeVao.unbind();
	        }

	        this._activeVao = vao;

	        return this;
	    };

	    /**
	     * Resets the WebGL state so you can render things however you fancy!
	     *
	     * @return {PIXI.WebGLRenderer} Returns itself.
	     */


	    WebGLRenderer.prototype.reset = function reset() {
	        this.setObjectRenderer(this.emptyRenderer);

	        this.bindVao(null);
	        this._activeShader = null;
	        this._activeRenderTarget = this.rootRenderTarget;

	        for (var i = 0; i < this.boundTextures.length; i++) {
	            this.boundTextures[i] = this.emptyTextures[i];
	        }

	        // bind the main frame buffer (the screen);
	        this.rootRenderTarget.activate();

	        this.state.resetToDefault();

	        return this;
	    };

	    /**
	     * Handles a lost webgl context
	     *
	     * @private
	     * @param {WebGLContextEvent} event - The context lost event.
	     */


	    WebGLRenderer.prototype.handleContextLost = function handleContextLost(event) {
	        event.preventDefault();
	    };

	    /**
	     * Handles a restored webgl context
	     *
	     * @private
	     */


	    WebGLRenderer.prototype.handleContextRestored = function handleContextRestored() {
	        this.textureManager.removeAll();
	        this.filterManager.destroy(true);
	        this._initContext();
	    };

	    /**
	     * Removes everything from the renderer (event listeners, spritebatch, etc...)
	     *
	     * @param {boolean} [removeView=false] - Removes the Canvas element from the DOM.
	     *  See: https://github.com/pixijs/pixi.js/issues/2233
	     */


	    WebGLRenderer.prototype.destroy = function destroy(removeView) {
	        this.destroyPlugins();

	        // remove listeners
	        this.view.removeEventListener('webglcontextlost', this.handleContextLost);
	        this.view.removeEventListener('webglcontextrestored', this.handleContextRestored);

	        this.textureManager.destroy();

	        // call base destroy
	        _SystemRenderer.prototype.destroy.call(this, removeView);

	        this.uid = 0;

	        // destroy the managers
	        this.maskManager.destroy();
	        this.stencilManager.destroy();
	        this.filterManager.destroy();

	        this.maskManager = null;
	        this.filterManager = null;
	        this.textureManager = null;
	        this.currentRenderer = null;

	        this.handleContextLost = null;
	        this.handleContextRestored = null;

	        this._contextOptions = null;
	        this.gl.useProgram(null);

	        if (this.gl.getExtension('WEBGL_lose_context')) {
	            this.gl.getExtension('WEBGL_lose_context').loseContext();
	        }

	        this.gl = null;

	        // this = null;
	    };

	    return WebGLRenderer;
	}(_SystemRenderer3.default);

	/**
	 * Collection of installed plugins. These are included by default in PIXI, but can be excluded
	 * by creating a custom build. Consult the README for more information about creating custom
	 * builds and excluding plugins.
	 * @name PIXI.WebGLRenderer#plugins
	 * @type {object}
	 * @readonly
	 * @property {PIXI.accessibility.AccessibilityManager} accessibility Support tabbing interactive elements.
	 * @property {PIXI.extract.WebGLExtract} extract Extract image data from renderer.
	 * @property {PIXI.interaction.InteractionManager} interaction Handles mouse, touch and pointer events.
	 * @property {PIXI.prepare.WebGLPrepare} prepare Pre-render display objects.
	 */

	/**
	 * Adds a plugin to the renderer.
	 *
	 * @method PIXI.WebGLRenderer#registerPlugin
	 * @param {string} pluginName - The name of the plugin.
	 * @param {Function} ctor - The constructor function or class for the plugin.
	 */

	exports.default = WebGLRenderer;
	_utils.pluginTarget.mixin(WebGLRenderer);
	//# sourceMappingURL=WebGLRenderer.js.map

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _WebGLManager2 = __webpack_require__(246);

	var _WebGLManager3 = _interopRequireDefault(_WebGLManager2);

	var _SpriteMaskFilter = __webpack_require__(249);

	var _SpriteMaskFilter2 = _interopRequireDefault(_SpriteMaskFilter);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	/**
	 * @class
	 * @extends PIXI.WebGLManager
	 * @memberof PIXI
	 */
	var MaskManager = function (_WebGLManager) {
	    _inherits(MaskManager, _WebGLManager);

	    /**
	     * @param {PIXI.WebGLRenderer} renderer - The renderer this manager works for.
	     */
	    function MaskManager(renderer) {
	        _classCallCheck(this, MaskManager);

	        // TODO - we don't need both!
	        var _this = _possibleConstructorReturn(this, _WebGLManager.call(this, renderer));

	        _this.scissor = false;
	        _this.scissorData = null;
	        _this.scissorRenderTarget = null;

	        _this.enableScissor = true;

	        _this.alphaMaskPool = [];
	        _this.alphaMaskIndex = 0;
	        return _this;
	    }

	    /**
	     * Applies the Mask and adds it to the current filter stack.
	     *
	     * @param {PIXI.DisplayObject} target - Display Object to push the mask to
	     * @param {PIXI.Sprite|PIXI.Graphics} maskData - The masking data.
	     */


	    MaskManager.prototype.pushMask = function pushMask(target, maskData) {
	        // TODO the root check means scissor rect will not
	        // be used on render textures more info here:
	        // https://github.com/pixijs/pixi.js/pull/3545

	        if (maskData.texture) {
	            this.pushSpriteMask(target, maskData);
	        } else if (this.enableScissor && !this.scissor && this.renderer._activeRenderTarget.root && !this.renderer.stencilManager.stencilMaskStack.length && maskData.isFastRect()) {
	            var matrix = maskData.worldTransform;

	            var rot = Math.atan2(matrix.b, matrix.a);

	            // use the nearest degree!
	            rot = Math.round(rot * (180 / Math.PI));

	            if (rot % 90) {
	                this.pushStencilMask(maskData);
	            } else {
	                this.pushScissorMask(target, maskData);
	            }
	        } else {
	            this.pushStencilMask(maskData);
	        }
	    };

	    /**
	     * Removes the last mask from the mask stack and doesn't return it.
	     *
	     * @param {PIXI.DisplayObject} target - Display Object to pop the mask from
	     * @param {PIXI.Sprite|PIXI.Graphics} maskData - The masking data.
	     */


	    MaskManager.prototype.popMask = function popMask(target, maskData) {
	        if (maskData.texture) {
	            this.popSpriteMask(target, maskData);
	        } else if (this.enableScissor && !this.renderer.stencilManager.stencilMaskStack.length) {
	            this.popScissorMask(target, maskData);
	        } else {
	            this.popStencilMask(target, maskData);
	        }
	    };

	    /**
	     * Applies the Mask and adds it to the current filter stack.
	     *
	     * @param {PIXI.RenderTarget} target - Display Object to push the sprite mask to
	     * @param {PIXI.Sprite} maskData - Sprite to be used as the mask
	     */


	    MaskManager.prototype.pushSpriteMask = function pushSpriteMask(target, maskData) {
	        var alphaMaskFilter = this.alphaMaskPool[this.alphaMaskIndex];

	        if (!alphaMaskFilter) {
	            alphaMaskFilter = this.alphaMaskPool[this.alphaMaskIndex] = [new _SpriteMaskFilter2.default(maskData)];
	        }

	        alphaMaskFilter[0].resolution = this.renderer.resolution;
	        alphaMaskFilter[0].maskSprite = maskData;

	        // TODO - may cause issues!
	        target.filterArea = maskData.getBounds(true);

	        this.renderer.filterManager.pushFilter(target, alphaMaskFilter);

	        this.alphaMaskIndex++;
	    };

	    /**
	     * Removes the last filter from the filter stack and doesn't return it.
	     *
	     */


	    MaskManager.prototype.popSpriteMask = function popSpriteMask() {
	        this.renderer.filterManager.popFilter();
	        this.alphaMaskIndex--;
	    };

	    /**
	     * Applies the Mask and adds it to the current filter stack.
	     *
	     * @param {PIXI.Sprite|PIXI.Graphics} maskData - The masking data.
	     */


	    MaskManager.prototype.pushStencilMask = function pushStencilMask(maskData) {
	        this.renderer.currentRenderer.stop();
	        this.renderer.stencilManager.pushStencil(maskData);
	    };

	    /**
	     * Removes the last filter from the filter stack and doesn't return it.
	     *
	     */


	    MaskManager.prototype.popStencilMask = function popStencilMask() {
	        this.renderer.currentRenderer.stop();
	        this.renderer.stencilManager.popStencil();
	    };

	    /**
	     *
	     * @param {PIXI.DisplayObject} target - Display Object to push the mask to
	     * @param {PIXI.Graphics} maskData - The masking data.
	     */


	    MaskManager.prototype.pushScissorMask = function pushScissorMask(target, maskData) {
	        maskData.renderable = true;

	        var renderTarget = this.renderer._activeRenderTarget;

	        var bounds = maskData.getBounds();

	        bounds.fit(renderTarget.size);
	        maskData.renderable = false;

	        this.renderer.gl.enable(this.renderer.gl.SCISSOR_TEST);

	        var resolution = this.renderer.resolution;

	        this.renderer.gl.scissor(bounds.x * resolution, (renderTarget.root ? renderTarget.size.height - bounds.y - bounds.height : bounds.y) * resolution, bounds.width * resolution, bounds.height * resolution);

	        this.scissorRenderTarget = renderTarget;
	        this.scissorData = maskData;
	        this.scissor = true;
	    };

	    /**
	     *
	     *
	     */


	    MaskManager.prototype.popScissorMask = function popScissorMask() {
	        this.scissorRenderTarget = null;
	        this.scissorData = null;
	        this.scissor = false;

	        // must be scissor!
	        var gl = this.renderer.gl;

	        gl.disable(gl.SCISSOR_TEST);
	    };

	    return MaskManager;
	}(_WebGLManager3.default);

	exports.default = MaskManager;
	//# sourceMappingURL=MaskManager.js.map

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _Filter2 = __webpack_require__(250);

	var _Filter3 = _interopRequireDefault(_Filter2);

	var _math = __webpack_require__(175);

	var _path = __webpack_require__(252);

	var _TextureMatrix = __webpack_require__(256);

	var _TextureMatrix2 = _interopRequireDefault(_TextureMatrix);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	/**
	 * The SpriteMaskFilter class
	 *
	 * @class
	 * @extends PIXI.Filter
	 * @memberof PIXI
	 */
	var SpriteMaskFilter = function (_Filter) {
	    _inherits(SpriteMaskFilter, _Filter);

	    /**
	     * @param {PIXI.Sprite} sprite - the target sprite
	     */
	    function SpriteMaskFilter(sprite) {
	        _classCallCheck(this, SpriteMaskFilter);

	        var maskMatrix = new _math.Matrix();

	        var _this = _possibleConstructorReturn(this, _Filter.call(this, 'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 otherMatrix;\n\nvarying vec2 vMaskCoord;\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = aTextureCoord;\n    vMaskCoord = ( otherMatrix * vec3( aTextureCoord, 1.0)  ).xy;\n}\n', 'varying vec2 vMaskCoord;\nvarying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform sampler2D mask;\nuniform float alpha;\nuniform vec4 maskClamp;\n\nvoid main(void)\n{\n    float clip = step(3.5,\n        step(maskClamp.x, vMaskCoord.x) +\n        step(maskClamp.y, vMaskCoord.y) +\n        step(vMaskCoord.x, maskClamp.z) +\n        step(vMaskCoord.y, maskClamp.w));\n\n    vec4 original = texture2D(uSampler, vTextureCoord);\n    vec4 masky = texture2D(mask, vMaskCoord);\n\n    original *= (masky.r * masky.a * alpha * clip);\n\n    gl_FragColor = original;\n}\n'));

	        sprite.renderable = false;

	        _this.maskSprite = sprite;
	        _this.maskMatrix = maskMatrix;
	        return _this;
	    }

	    /**
	     * Applies the filter
	     *
	     * @param {PIXI.FilterManager} filterManager - The renderer to retrieve the filter from
	     * @param {PIXI.RenderTarget} input - The input render target.
	     * @param {PIXI.RenderTarget} output - The target to output to.
	     */


	    SpriteMaskFilter.prototype.apply = function apply(filterManager, input, output) {
	        var maskSprite = this.maskSprite;
	        var tex = this.maskSprite.texture;

	        if (!tex.valid) {
	            return;
	        }
	        if (!tex.transform) {
	            // margin = 0.0, let it bleed a bit, shader code becomes easier
	            // assuming that atlas textures were made with 1-pixel padding
	            tex.transform = new _TextureMatrix2.default(tex, 0.0);
	        }
	        tex.transform.update();

	        this.uniforms.mask = tex;
	        this.uniforms.otherMatrix = filterManager.calculateSpriteMatrix(this.maskMatrix, maskSprite).prepend(tex.transform.mapCoord);
	        this.uniforms.alpha = maskSprite.worldAlpha;
	        this.uniforms.maskClamp = tex.transform.uClampFrame;

	        filterManager.applyFilter(this, input, output);
	    };

	    return SpriteMaskFilter;
	}(_Filter3.default);

	exports.default = SpriteMaskFilter;
	//# sourceMappingURL=SpriteMaskFilter.js.map

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _extractUniformsFromSrc = __webpack_require__(251);

	var _extractUniformsFromSrc2 = _interopRequireDefault(_extractUniformsFromSrc);

	var _utils = __webpack_require__(213);

	var _const = __webpack_require__(174);

	var _settings = __webpack_require__(205);

	var _settings2 = _interopRequireDefault(_settings);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var SOURCE_KEY_MAP = {};

	// let math = require('../../../math');
	/**
	 * @class
	 * @memberof PIXI
	 * @extends PIXI.Shader
	 */

	var Filter = function () {
	  /**
	   * @param {string} [vertexSrc] - The source of the vertex shader.
	   * @param {string} [fragmentSrc] - The source of the fragment shader.
	   * @param {object} [uniforms] - Custom uniforms to use to augment the built-in ones.
	   */
	  function Filter(vertexSrc, fragmentSrc, uniforms) {
	    _classCallCheck(this, Filter);

	    /**
	     * The vertex shader.
	     *
	     * @member {string}
	     */
	    this.vertexSrc = vertexSrc || Filter.defaultVertexSrc;

	    /**
	     * The fragment shader.
	     *
	     * @member {string}
	     */
	    this.fragmentSrc = fragmentSrc || Filter.defaultFragmentSrc;

	    this._blendMode = _const.BLEND_MODES.NORMAL;

	    this.uniformData = uniforms || (0, _extractUniformsFromSrc2.default)(this.vertexSrc, this.fragmentSrc, 'projectionMatrix|uSampler');

	    /**
	     * An object containing the current values of custom uniforms.
	     * @example <caption>Updating the value of a custom uniform</caption>
	     * filter.uniforms.time = performance.now();
	     *
	     * @member {object}
	     */
	    this.uniforms = {};

	    for (var i in this.uniformData) {
	      this.uniforms[i] = this.uniformData[i].value;
	      if (this.uniformData[i].type) {
	        this.uniformData[i].type = this.uniformData[i].type.toLowerCase();
	      }
	    }

	    // this is where we store shader references..
	    // TODO we could cache this!
	    this.glShaders = {};

	    // used for caching.. sure there is a better way!
	    if (!SOURCE_KEY_MAP[this.vertexSrc + this.fragmentSrc]) {
	      SOURCE_KEY_MAP[this.vertexSrc + this.fragmentSrc] = (0, _utils.uid)();
	    }

	    this.glShaderKey = SOURCE_KEY_MAP[this.vertexSrc + this.fragmentSrc];

	    /**
	     * The padding of the filter. Some filters require extra space to breath such as a blur.
	     * Increasing this will add extra width and height to the bounds of the object that the
	     * filter is applied to.
	     *
	     * @member {number}
	     */
	    this.padding = 4;

	    /**
	     * The resolution of the filter. Setting this to be lower will lower the quality but
	     * increase the performance of the filter.
	     *
	     * @member {number}
	     */
	    this.resolution = _settings2.default.FILTER_RESOLUTION;

	    /**
	     * If enabled is true the filter is applied, if false it will not.
	     *
	     * @member {boolean}
	     */
	    this.enabled = true;

	    /**
	     * If enabled, PixiJS will fit the filter area into boundaries for better performance.
	     * Switch it off if it does not work for specific shader.
	     *
	     * @member {boolean}
	     */
	    this.autoFit = true;
	  }

	  /**
	   * Applies the filter
	   *
	   * @param {PIXI.FilterManager} filterManager - The renderer to retrieve the filter from
	   * @param {PIXI.RenderTarget} input - The input render target.
	   * @param {PIXI.RenderTarget} output - The target to output to.
	   * @param {boolean} clear - Should the output be cleared before rendering to it
	   * @param {object} [currentState] - It's current state of filter.
	   *        There are some useful properties in the currentState :
	   *        target, filters, sourceFrame, destinationFrame, renderTarget, resolution
	   */


	  Filter.prototype.apply = function apply(filterManager, input, output, clear, currentState) // eslint-disable-line no-unused-vars
	  {
	    // --- //
	    //  this.uniforms.filterMatrix = filterManager.calculateSpriteMatrix(tempMatrix, window.panda );

	    // do as you please!

	    filterManager.applyFilter(this, input, output, clear);

	    // or just do a regular render..
	  };

	  /**
	   * Sets the blendmode of the filter
	   *
	   * @member {number}
	   * @default PIXI.BLEND_MODES.NORMAL
	   */


	  _createClass(Filter, [{
	    key: 'blendMode',
	    get: function get() {
	      return this._blendMode;
	    },
	    set: function set(value) // eslint-disable-line require-jsdoc
	    {
	      this._blendMode = value;
	    }

	    /**
	     * The default vertex shader source
	     *
	     * @static
	     * @constant
	     */

	  }], [{
	    key: 'defaultVertexSrc',
	    get: function get() {
	      return ['attribute vec2 aVertexPosition;', 'attribute vec2 aTextureCoord;', 'uniform mat3 projectionMatrix;', 'uniform mat3 filterMatrix;', 'varying vec2 vTextureCoord;', 'varying vec2 vFilterCoord;', 'void main(void){', '   gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);', '   vFilterCoord = ( filterMatrix * vec3( aTextureCoord, 1.0)  ).xy;', '   vTextureCoord = aTextureCoord ;', '}'].join('\n');
	    }

	    /**
	     * The default fragment shader source
	     *
	     * @static
	     * @constant
	     */

	  }, {
	    key: 'defaultFragmentSrc',
	    get: function get() {
	      return ['varying vec2 vTextureCoord;', 'varying vec2 vFilterCoord;', 'uniform sampler2D uSampler;', 'uniform sampler2D filterSampler;', 'void main(void){', '   vec4 masky = texture2D(filterSampler, vFilterCoord);', '   vec4 sample = texture2D(uSampler, vTextureCoord);', '   vec4 color;', '   if(mod(vFilterCoord.x, 1.0) > 0.5)', '   {', '     color = vec4(1.0, 0.0, 0.0, 1.0);', '   }', '   else', '   {', '     color = vec4(0.0, 1.0, 0.0, 1.0);', '   }',
	      // '   gl_FragColor = vec4(mod(vFilterCoord.x, 1.5), vFilterCoord.y,0.0,1.0);',
	      '   gl_FragColor = mix(sample, masky, 0.5);', '   gl_FragColor *= sample.a;', '}'].join('\n');
	    }
	  }]);

	  return Filter;
	}();

	exports.default = Filter;
	//# sourceMappingURL=Filter.js.map

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;
	exports.default = extractUniformsFromSrc;

	var _pixiGlCore = __webpack_require__(185);

	var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var defaultValue = _pixiGlCore2.default.shader.defaultValue;

	function extractUniformsFromSrc(vertexSrc, fragmentSrc, mask) {
	    var vertUniforms = extractUniformsFromString(vertexSrc, mask);
	    var fragUniforms = extractUniformsFromString(fragmentSrc, mask);

	    return Object.assign(vertUniforms, fragUniforms);
	}

	function extractUniformsFromString(string) {
	    var maskRegex = new RegExp('^(projectionMatrix|uSampler|filterArea|filterClamp)$');

	    var uniforms = {};
	    var nameSplit = void 0;

	    // clean the lines a little - remove extra spaces / tabs etc
	    // then split along ';'
	    var lines = string.replace(/\s+/g, ' ').split(/\s*;\s*/);

	    // loop through..
	    for (var i = 0; i < lines.length; i++) {
	        var line = lines[i].trim();

	        if (line.indexOf('uniform') > -1) {
	            var splitLine = line.split(' ');
	            var type = splitLine[1];

	            var name = splitLine[2];
	            var size = 1;

	            if (name.indexOf('[') > -1) {
	                // array!
	                nameSplit = name.split(/\[|]/);
	                name = nameSplit[0];
	                size *= Number(nameSplit[1]);
	            }

	            if (!name.match(maskRegex)) {
	                uniforms[name] = {
	                    value: defaultValue(type, size),
	                    name: name,
	                    type: type
	                };
	            }
	        }
	    }

	    return uniforms;
	}
	//# sourceMappingURL=extractUniformsFromSrc.js.map

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	'use strict';


	var isWindows = process.platform === 'win32';
	var util = __webpack_require__(253);


	// resolves . and .. elements in a path array with directory names there
	// must be no slashes or device names (c:\) in the array
	// (so also no leading and trailing slashes - it does not distinguish
	// relative and absolute paths)
	function normalizeArray(parts, allowAboveRoot) {
	  var res = [];
	  for (var i = 0; i < parts.length; i++) {
	    var p = parts[i];

	    // ignore empty parts
	    if (!p || p === '.')
	      continue;

	    if (p === '..') {
	      if (res.length && res[res.length - 1] !== '..') {
	        res.pop();
	      } else if (allowAboveRoot) {
	        res.push('..');
	      }
	    } else {
	      res.push(p);
	    }
	  }

	  return res;
	}

	// returns an array with empty elements removed from either end of the input
	// array or the original array if no elements need to be removed
	function trimArray(arr) {
	  var lastIndex = arr.length - 1;
	  var start = 0;
	  for (; start <= lastIndex; start++) {
	    if (arr[start])
	      break;
	  }

	  var end = lastIndex;
	  for (; end >= 0; end--) {
	    if (arr[end])
	      break;
	  }

	  if (start === 0 && end === lastIndex)
	    return arr;
	  if (start > end)
	    return [];
	  return arr.slice(start, end + 1);
	}

	// Regex to split a windows path into three parts: [*, device, slash,
	// tail] windows-only
	var splitDeviceRe =
	    /^([a-zA-Z]:|[\\\/]{2}[^\\\/]+[\\\/]+[^\\\/]+)?([\\\/])?([\s\S]*?)$/;

	// Regex to split the tail part of the above into [*, dir, basename, ext]
	var splitTailRe =
	    /^([\s\S]*?)((?:\.{1,2}|[^\\\/]+?|)(\.[^.\/\\]*|))(?:[\\\/]*)$/;

	var win32 = {};

	// Function to split a filename into [root, dir, basename, ext]
	function win32SplitPath(filename) {
	  // Separate device+slash from tail
	  var result = splitDeviceRe.exec(filename),
	      device = (result[1] || '') + (result[2] || ''),
	      tail = result[3] || '';
	  // Split the tail into dir, basename and extension
	  var result2 = splitTailRe.exec(tail),
	      dir = result2[1],
	      basename = result2[2],
	      ext = result2[3];
	  return [device, dir, basename, ext];
	}

	function win32StatPath(path) {
	  var result = splitDeviceRe.exec(path),
	      device = result[1] || '',
	      isUnc = !!device && device[1] !== ':';
	  return {
	    device: device,
	    isUnc: isUnc,
	    isAbsolute: isUnc || !!result[2], // UNC paths are always absolute
	    tail: result[3]
	  };
	}

	function normalizeUNCRoot(device) {
	  return '\\\\' + device.replace(/^[\\\/]+/, '').replace(/[\\\/]+/g, '\\');
	}

	// path.resolve([from ...], to)
	win32.resolve = function() {
	  var resolvedDevice = '',
	      resolvedTail = '',
	      resolvedAbsolute = false;

	  for (var i = arguments.length - 1; i >= -1; i--) {
	    var path;
	    if (i >= 0) {
	      path = arguments[i];
	    } else if (!resolvedDevice) {
	      path = process.cwd();
	    } else {
	      // Windows has the concept of drive-specific current working
	      // directories. If we've resolved a drive letter but not yet an
	      // absolute path, get cwd for that drive. We're sure the device is not
	      // an unc path at this points, because unc paths are always absolute.
	      path = process.env['=' + resolvedDevice];
	      // Verify that a drive-local cwd was found and that it actually points
	      // to our drive. If not, default to the drive's root.
	      if (!path || path.substr(0, 3).toLowerCase() !==
	          resolvedDevice.toLowerCase() + '\\') {
	        path = resolvedDevice + '\\';
	      }
	    }

	    // Skip empty and invalid entries
	    if (!util.isString(path)) {
	      throw new TypeError('Arguments to path.resolve must be strings');
	    } else if (!path) {
	      continue;
	    }

	    var result = win32StatPath(path),
	        device = result.device,
	        isUnc = result.isUnc,
	        isAbsolute = result.isAbsolute,
	        tail = result.tail;

	    if (device &&
	        resolvedDevice &&
	        device.toLowerCase() !== resolvedDevice.toLowerCase()) {
	      // This path points to another device so it is not applicable
	      continue;
	    }

	    if (!resolvedDevice) {
	      resolvedDevice = device;
	    }
	    if (!resolvedAbsolute) {
	      resolvedTail = tail + '\\' + resolvedTail;
	      resolvedAbsolute = isAbsolute;
	    }

	    if (resolvedDevice && resolvedAbsolute) {
	      break;
	    }
	  }

	  // Convert slashes to backslashes when `resolvedDevice` points to an UNC
	  // root. Also squash multiple slashes into a single one where appropriate.
	  if (isUnc) {
	    resolvedDevice = normalizeUNCRoot(resolvedDevice);
	  }

	  // At this point the path should be resolved to a full absolute path,
	  // but handle relative paths to be safe (might happen when process.cwd()
	  // fails)

	  // Normalize the tail path
	  resolvedTail = normalizeArray(resolvedTail.split(/[\\\/]+/),
	                                !resolvedAbsolute).join('\\');

	  return (resolvedDevice + (resolvedAbsolute ? '\\' : '') + resolvedTail) ||
	         '.';
	};


	win32.normalize = function(path) {
	  var result = win32StatPath(path),
	      device = result.device,
	      isUnc = result.isUnc,
	      isAbsolute = result.isAbsolute,
	      tail = result.tail,
	      trailingSlash = /[\\\/]$/.test(tail);

	  // Normalize the tail path
	  tail = normalizeArray(tail.split(/[\\\/]+/), !isAbsolute).join('\\');

	  if (!tail && !isAbsolute) {
	    tail = '.';
	  }
	  if (tail && trailingSlash) {
	    tail += '\\';
	  }

	  // Convert slashes to backslashes when `device` points to an UNC root.
	  // Also squash multiple slashes into a single one where appropriate.
	  if (isUnc) {
	    device = normalizeUNCRoot(device);
	  }

	  return device + (isAbsolute ? '\\' : '') + tail;
	};


	win32.isAbsolute = function(path) {
	  return win32StatPath(path).isAbsolute;
	};

	win32.join = function() {
	  var paths = [];
	  for (var i = 0; i < arguments.length; i++) {
	    var arg = arguments[i];
	    if (!util.isString(arg)) {
	      throw new TypeError('Arguments to path.join must be strings');
	    }
	    if (arg) {
	      paths.push(arg);
	    }
	  }

	  var joined = paths.join('\\');

	  // Make sure that the joined path doesn't start with two slashes, because
	  // normalize() will mistake it for an UNC path then.
	  //
	  // This step is skipped when it is very clear that the user actually
	  // intended to point at an UNC path. This is assumed when the first
	  // non-empty string arguments starts with exactly two slashes followed by
	  // at least one more non-slash character.
	  //
	  // Note that for normalize() to treat a path as an UNC path it needs to
	  // have at least 2 components, so we don't filter for that here.
	  // This means that the user can use join to construct UNC paths from
	  // a server name and a share name; for example:
	  //   path.join('//server', 'share') -> '\\\\server\\share\')
	  if (!/^[\\\/]{2}[^\\\/]/.test(paths[0])) {
	    joined = joined.replace(/^[\\\/]{2,}/, '\\');
	  }

	  return win32.normalize(joined);
	};


	// path.relative(from, to)
	// it will solve the relative path from 'from' to 'to', for instance:
	// from = 'C:\\orandea\\test\\aaa'
	// to = 'C:\\orandea\\impl\\bbb'
	// The output of the function should be: '..\\..\\impl\\bbb'
	win32.relative = function(from, to) {
	  from = win32.resolve(from);
	  to = win32.resolve(to);

	  // windows is not case sensitive
	  var lowerFrom = from.toLowerCase();
	  var lowerTo = to.toLowerCase();

	  var toParts = trimArray(to.split('\\'));

	  var lowerFromParts = trimArray(lowerFrom.split('\\'));
	  var lowerToParts = trimArray(lowerTo.split('\\'));

	  var length = Math.min(lowerFromParts.length, lowerToParts.length);
	  var samePartsLength = length;
	  for (var i = 0; i < length; i++) {
	    if (lowerFromParts[i] !== lowerToParts[i]) {
	      samePartsLength = i;
	      break;
	    }
	  }

	  if (samePartsLength == 0) {
	    return to;
	  }

	  var outputParts = [];
	  for (var i = samePartsLength; i < lowerFromParts.length; i++) {
	    outputParts.push('..');
	  }

	  outputParts = outputParts.concat(toParts.slice(samePartsLength));

	  return outputParts.join('\\');
	};


	win32._makeLong = function(path) {
	  // Note: this will *probably* throw somewhere.
	  if (!util.isString(path))
	    return path;

	  if (!path) {
	    return '';
	  }

	  var resolvedPath = win32.resolve(path);

	  if (/^[a-zA-Z]\:\\/.test(resolvedPath)) {
	    // path is local filesystem path, which needs to be converted
	    // to long UNC path.
	    return '\\\\?\\' + resolvedPath;
	  } else if (/^\\\\[^?.]/.test(resolvedPath)) {
	    // path is network UNC path, which needs to be converted
	    // to long UNC path.
	    return '\\\\?\\UNC\\' + resolvedPath.substring(2);
	  }

	  return path;
	};


	win32.dirname = function(path) {
	  var result = win32SplitPath(path),
	      root = result[0],
	      dir = result[1];

	  if (!root && !dir) {
	    // No dirname whatsoever
	    return '.';
	  }

	  if (dir) {
	    // It has a dirname, strip trailing slash
	    dir = dir.substr(0, dir.length - 1);
	  }

	  return root + dir;
	};


	win32.basename = function(path, ext) {
	  var f = win32SplitPath(path)[2];
	  // TODO: make this comparison case-insensitive on windows?
	  if (ext && f.substr(-1 * ext.length) === ext) {
	    f = f.substr(0, f.length - ext.length);
	  }
	  return f;
	};


	win32.extname = function(path) {
	  return win32SplitPath(path)[3];
	};


	win32.format = function(pathObject) {
	  if (!util.isObject(pathObject)) {
	    throw new TypeError(
	        "Parameter 'pathObject' must be an object, not " + typeof pathObject
	    );
	  }

	  var root = pathObject.root || '';

	  if (!util.isString(root)) {
	    throw new TypeError(
	        "'pathObject.root' must be a string or undefined, not " +
	        typeof pathObject.root
	    );
	  }

	  var dir = pathObject.dir;
	  var base = pathObject.base || '';
	  if (!dir) {
	    return base;
	  }
	  if (dir[dir.length - 1] === win32.sep) {
	    return dir + base;
	  }
	  return dir + win32.sep + base;
	};


	win32.parse = function(pathString) {
	  if (!util.isString(pathString)) {
	    throw new TypeError(
	        "Parameter 'pathString' must be a string, not " + typeof pathString
	    );
	  }
	  var allParts = win32SplitPath(pathString);
	  if (!allParts || allParts.length !== 4) {
	    throw new TypeError("Invalid path '" + pathString + "'");
	  }
	  return {
	    root: allParts[0],
	    dir: allParts[0] + allParts[1].slice(0, -1),
	    base: allParts[2],
	    ext: allParts[3],
	    name: allParts[2].slice(0, allParts[2].length - allParts[3].length)
	  };
	};


	win32.sep = '\\';
	win32.delimiter = ';';


	// Split a filename into [root, dir, basename, ext], unix version
	// 'root' is just a slash, or nothing.
	var splitPathRe =
	    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
	var posix = {};


	function posixSplitPath(filename) {
	  return splitPathRe.exec(filename).slice(1);
	}


	// path.resolve([from ...], to)
	// posix version
	posix.resolve = function() {
	  var resolvedPath = '',
	      resolvedAbsolute = false;

	  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
	    var path = (i >= 0) ? arguments[i] : process.cwd();

	    // Skip empty and invalid entries
	    if (!util.isString(path)) {
	      throw new TypeError('Arguments to path.resolve must be strings');
	    } else if (!path) {
	      continue;
	    }

	    resolvedPath = path + '/' + resolvedPath;
	    resolvedAbsolute = path[0] === '/';
	  }

	  // At this point the path should be resolved to a full absolute path, but
	  // handle relative paths to be safe (might happen when process.cwd() fails)

	  // Normalize the path
	  resolvedPath = normalizeArray(resolvedPath.split('/'),
	                                !resolvedAbsolute).join('/');

	  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
	};

	// path.normalize(path)
	// posix version
	posix.normalize = function(path) {
	  var isAbsolute = posix.isAbsolute(path),
	      trailingSlash = path && path[path.length - 1] === '/';

	  // Normalize the path
	  path = normalizeArray(path.split('/'), !isAbsolute).join('/');

	  if (!path && !isAbsolute) {
	    path = '.';
	  }
	  if (path && trailingSlash) {
	    path += '/';
	  }

	  return (isAbsolute ? '/' : '') + path;
	};

	// posix version
	posix.isAbsolute = function(path) {
	  return path.charAt(0) === '/';
	};

	// posix version
	posix.join = function() {
	  var path = '';
	  for (var i = 0; i < arguments.length; i++) {
	    var segment = arguments[i];
	    if (!util.isString(segment)) {
	      throw new TypeError('Arguments to path.join must be strings');
	    }
	    if (segment) {
	      if (!path) {
	        path += segment;
	      } else {
	        path += '/' + segment;
	      }
	    }
	  }
	  return posix.normalize(path);
	};


	// path.relative(from, to)
	// posix version
	posix.relative = function(from, to) {
	  from = posix.resolve(from).substr(1);
	  to = posix.resolve(to).substr(1);

	  var fromParts = trimArray(from.split('/'));
	  var toParts = trimArray(to.split('/'));

	  var length = Math.min(fromParts.length, toParts.length);
	  var samePartsLength = length;
	  for (var i = 0; i < length; i++) {
	    if (fromParts[i] !== toParts[i]) {
	      samePartsLength = i;
	      break;
	    }
	  }

	  var outputParts = [];
	  for (var i = samePartsLength; i < fromParts.length; i++) {
	    outputParts.push('..');
	  }

	  outputParts = outputParts.concat(toParts.slice(samePartsLength));

	  return outputParts.join('/');
	};


	posix._makeLong = function(path) {
	  return path;
	};


	posix.dirname = function(path) {
	  var result = posixSplitPath(path),
	      root = result[0],
	      dir = result[1];

	  if (!root && !dir) {
	    // No dirname whatsoever
	    return '.';
	  }

	  if (dir) {
	    // It has a dirname, strip trailing slash
	    dir = dir.substr(0, dir.length - 1);
	  }

	  return root + dir;
	};


	posix.basename = function(path, ext) {
	  var f = posixSplitPath(path)[2];
	  // TODO: make this comparison case-insensitive on windows?
	  if (ext && f.substr(-1 * ext.length) === ext) {
	    f = f.substr(0, f.length - ext.length);
	  }
	  return f;
	};


	posix.extname = function(path) {
	  return posixSplitPath(path)[3];
	};


	posix.format = function(pathObject) {
	  if (!util.isObject(pathObject)) {
	    throw new TypeError(
	        "Parameter 'pathObject' must be an object, not " + typeof pathObject
	    );
	  }

	  var root = pathObject.root || '';

	  if (!util.isString(root)) {
	    throw new TypeError(
	        "'pathObject.root' must be a string or undefined, not " +
	        typeof pathObject.root
	    );
	  }

	  var dir = pathObject.dir ? pathObject.dir + posix.sep : '';
	  var base = pathObject.base || '';
	  return dir + base;
	};


	posix.parse = function(pathString) {
	  if (!util.isString(pathString)) {
	    throw new TypeError(
	        "Parameter 'pathString' must be a string, not " + typeof pathString
	    );
	  }
	  var allParts = posixSplitPath(pathString);
	  if (!allParts || allParts.length !== 4) {
	    throw new TypeError("Invalid path '" + pathString + "'");
	  }
	  allParts[1] = allParts[1] || '';
	  allParts[2] = allParts[2] || '';
	  allParts[3] = allParts[3] || '';

	  return {
	    root: allParts[0],
	    dir: allParts[0] + allParts[1].slice(0, -1),
	    base: allParts[2],
	    ext: allParts[3],
	    name: allParts[2].slice(0, allParts[2].length - allParts[3].length)
	  };
	};


	posix.sep = '/';
	posix.delimiter = ':';


	if (isWindows)
	  module.exports = win32;
	else /* posix */
	  module.exports = posix;

	module.exports.posix = posix;
	module.exports.win32 = win32;

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99)))

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }

	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};


	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }

	  if (process.noDeprecation === true) {
	    return fn;
	  }

	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }

	  return deprecated;
	};


	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = process.env.NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};


	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;


	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};

	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};


	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];

	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}


	function stylizeNoColor(str, styleType) {
	  return str;
	}


	function arrayToHash(array) {
	  var hash = {};

	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });

	  return hash;
	}


	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }

	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }

	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);

	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }

	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }

	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }

	  var base = '', array = false, braces = ['{', '}'];

	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }

	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }

	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }

	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }

	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }

	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }

	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }

	  ctx.seen.push(value);

	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }

	  ctx.seen.pop();

	  return reduceToSingleString(output, base, braces);
	}


	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}


	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}


	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}


	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }

	  return name + ': ' + str;
	}


	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);

	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }

	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}


	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;

	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;

	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;

	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;

	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;

	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;

	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;

	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;

	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;

	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;

	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;

	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;

	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;

	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;

	exports.isBuffer = __webpack_require__(254);

	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}


	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}


	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];

	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}


	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};


	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(255);

	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;

	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};

	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(99)))

/***/ }),
/* 254 */
/***/ (function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ }),
/* 255 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _Matrix = __webpack_require__(178);

	var _Matrix2 = _interopRequireDefault(_Matrix);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var tempMat = new _Matrix2.default();

	/**
	 * Class controls uv transform and frame clamp for texture
	 * Can be used in Texture "transform" field, or separately, you can use different clamp settings on the same texture.
	 * If you want to add support for texture region of certain feature or filter, that's what you're looking for.
	 *
	 * @see PIXI.Texture
	 * @see PIXI.mesh.Mesh
	 * @see PIXI.extras.TilingSprite
	 * @class
	 * @memberof PIXI
	 */

	var TextureMatrix = function () {
	    /**
	     *
	     * @param {PIXI.Texture} texture observed texture
	     * @param {number} [clampMargin] Changes frame clamping, 0.5 by default. Use -0.5 for extra border.
	     * @constructor
	     */
	    function TextureMatrix(texture, clampMargin) {
	        _classCallCheck(this, TextureMatrix);

	        this._texture = texture;

	        this.mapCoord = new _Matrix2.default();

	        this.uClampFrame = new Float32Array(4);

	        this.uClampOffset = new Float32Array(2);

	        this._lastTextureID = -1;

	        /**
	         * Changes frame clamping
	         * Works with TilingSprite and Mesh
	         * Change to 1.5 if you texture has repeated right and bottom lines, that leads to smoother borders
	         *
	         * @default 0
	         * @member {number}
	         */
	        this.clampOffset = 0;

	        /**
	         * Changes frame clamping
	         * Works with TilingSprite and Mesh
	         * Change to -0.5 to add a pixel to the edge, recommended for transparent trimmed textures in atlas
	         *
	         * @default 0.5
	         * @member {number}
	         */
	        this.clampMargin = typeof clampMargin === 'undefined' ? 0.5 : clampMargin;
	    }

	    /**
	     * texture property
	     * @member {PIXI.Texture}
	     */


	    /**
	     * Multiplies uvs array to transform
	     * @param {Float32Array} uvs mesh uvs
	     * @param {Float32Array} [out=uvs] output
	     * @returns {Float32Array} output
	     */
	    TextureMatrix.prototype.multiplyUvs = function multiplyUvs(uvs, out) {
	        if (out === undefined) {
	            out = uvs;
	        }

	        var mat = this.mapCoord;

	        for (var i = 0; i < uvs.length; i += 2) {
	            var x = uvs[i];
	            var y = uvs[i + 1];

	            out[i] = x * mat.a + y * mat.c + mat.tx;
	            out[i + 1] = x * mat.b + y * mat.d + mat.ty;
	        }

	        return out;
	    };

	    /**
	     * updates matrices if texture was changed
	     * @param {boolean} forceUpdate if true, matrices will be updated any case
	     * @returns {boolean} whether or not it was updated
	     */


	    TextureMatrix.prototype.update = function update(forceUpdate) {
	        var tex = this._texture;

	        if (!tex || !tex.valid) {
	            return false;
	        }

	        if (!forceUpdate && this._lastTextureID === tex._updateID) {
	            return false;
	        }

	        this._lastTextureID = tex._updateID;

	        var uvs = tex._uvs;

	        this.mapCoord.set(uvs.x1 - uvs.x0, uvs.y1 - uvs.y0, uvs.x3 - uvs.x0, uvs.y3 - uvs.y0, uvs.x0, uvs.y0);

	        var orig = tex.orig;
	        var trim = tex.trim;

	        if (trim) {
	            tempMat.set(orig.width / trim.width, 0, 0, orig.height / trim.height, -trim.x / trim.width, -trim.y / trim.height);
	            this.mapCoord.append(tempMat);
	        }

	        var texBase = tex.baseTexture;
	        var frame = this.uClampFrame;
	        var margin = this.clampMargin / texBase.resolution;
	        var offset = this.clampOffset;

	        frame[0] = (tex._frame.x + margin + offset) / texBase.width;
	        frame[1] = (tex._frame.y + margin + offset) / texBase.height;
	        frame[2] = (tex._frame.x + tex._frame.width - margin + offset) / texBase.width;
	        frame[3] = (tex._frame.y + tex._frame.height - margin + offset) / texBase.height;
	        this.uClampOffset[0] = offset / texBase.realWidth;
	        this.uClampOffset[1] = offset / texBase.realHeight;

	        return true;
	    };

	    _createClass(TextureMatrix, [{
	        key: 'texture',
	        get: function get() {
	            return this._texture;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._texture = value;
	            this._lastTextureID = -1;
	        }
	    }]);

	    return TextureMatrix;
	}();

	exports.default = TextureMatrix;
	//# sourceMappingURL=TextureMatrix.js.map

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _WebGLManager2 = __webpack_require__(246);

	var _WebGLManager3 = _interopRequireDefault(_WebGLManager2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	/**
	 * @class
	 * @extends PIXI.WebGLManager
	 * @memberof PIXI
	 */
	var StencilManager = function (_WebGLManager) {
	    _inherits(StencilManager, _WebGLManager);

	    /**
	     * @param {PIXI.WebGLRenderer} renderer - The renderer this manager works for.
	     */
	    function StencilManager(renderer) {
	        _classCallCheck(this, StencilManager);

	        var _this = _possibleConstructorReturn(this, _WebGLManager.call(this, renderer));

	        _this.stencilMaskStack = null;
	        return _this;
	    }

	    /**
	     * Changes the mask stack that is used by this manager.
	     *
	     * @param {PIXI.Graphics[]} stencilMaskStack - The mask stack
	     */


	    StencilManager.prototype.setMaskStack = function setMaskStack(stencilMaskStack) {
	        this.stencilMaskStack = stencilMaskStack;

	        var gl = this.renderer.gl;

	        if (stencilMaskStack.length === 0) {
	            gl.disable(gl.STENCIL_TEST);
	        } else {
	            gl.enable(gl.STENCIL_TEST);
	        }
	    };

	    /**
	     * Applies the Mask and adds it to the current stencil stack. @alvin
	     *
	     * @param {PIXI.Graphics} graphics - The mask
	     */


	    StencilManager.prototype.pushStencil = function pushStencil(graphics) {
	        this.renderer.setObjectRenderer(this.renderer.plugins.graphics);

	        this.renderer._activeRenderTarget.attachStencilBuffer();

	        var gl = this.renderer.gl;
	        var prevMaskCount = this.stencilMaskStack.length;

	        if (prevMaskCount === 0) {
	            gl.enable(gl.STENCIL_TEST);
	        }

	        this.stencilMaskStack.push(graphics);

	        // Increment the reference stencil value where the new mask overlaps with the old ones.
	        gl.colorMask(false, false, false, false);
	        gl.stencilFunc(gl.EQUAL, prevMaskCount, this._getBitwiseMask());
	        gl.stencilOp(gl.KEEP, gl.KEEP, gl.INCR);
	        this.renderer.plugins.graphics.render(graphics);

	        this._useCurrent();
	    };

	    /**
	     * Removes the last mask from the stencil stack. @alvin
	     */


	    StencilManager.prototype.popStencil = function popStencil() {
	        this.renderer.setObjectRenderer(this.renderer.plugins.graphics);

	        var gl = this.renderer.gl;
	        var graphics = this.stencilMaskStack.pop();

	        if (this.stencilMaskStack.length === 0) {
	            // the stack is empty!
	            gl.disable(gl.STENCIL_TEST);
	            gl.clear(gl.STENCIL_BUFFER_BIT);
	            gl.clearStencil(0);
	        } else {
	            // Decrement the reference stencil value where the popped mask overlaps with the other ones
	            gl.colorMask(false, false, false, false);
	            gl.stencilOp(gl.KEEP, gl.KEEP, gl.DECR);
	            this.renderer.plugins.graphics.render(graphics);

	            this._useCurrent();
	        }
	    };

	    /**
	     * Setup renderer to use the current stencil data.
	     */


	    StencilManager.prototype._useCurrent = function _useCurrent() {
	        var gl = this.renderer.gl;

	        gl.colorMask(true, true, true, true);
	        gl.stencilFunc(gl.EQUAL, this.stencilMaskStack.length, this._getBitwiseMask());
	        gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
	    };

	    /**
	     * Fill 1s equal to the number of acitve stencil masks.
	     *
	     * @return {number} The bitwise mask.
	     */


	    StencilManager.prototype._getBitwiseMask = function _getBitwiseMask() {
	        return (1 << this.stencilMaskStack.length) - 1;
	    };

	    /**
	     * Destroys the mask stack.
	     *
	     */


	    StencilManager.prototype.destroy = function destroy() {
	        _WebGLManager3.default.prototype.destroy.call(this);

	        this.stencilMaskStack.stencilStack = null;
	    };

	    return StencilManager;
	}(_WebGLManager3.default);

	exports.default = StencilManager;
	//# sourceMappingURL=StencilManager.js.map

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _WebGLManager2 = __webpack_require__(246);

	var _WebGLManager3 = _interopRequireDefault(_WebGLManager2);

	var _RenderTarget = __webpack_require__(259);

	var _RenderTarget2 = _interopRequireDefault(_RenderTarget);

	var _Quad = __webpack_require__(260);

	var _Quad2 = _interopRequireDefault(_Quad);

	var _math = __webpack_require__(175);

	var _Shader = __webpack_require__(262);

	var _Shader2 = _interopRequireDefault(_Shader);

	var _filterTransforms = __webpack_require__(263);

	var filterTransforms = _interopRequireWildcard(_filterTransforms);

	var _bitTwiddle = __webpack_require__(228);

	var _bitTwiddle2 = _interopRequireDefault(_bitTwiddle);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/**
	 * @ignore
	 * @class
	 */
	var FilterState = function () {
	    /**
	     *
	     */
	    function FilterState() {
	        _classCallCheck(this, FilterState);

	        this.renderTarget = null;
	        this.target = null;
	        this.resolution = 1;

	        // those three objects are used only for root
	        // re-assigned for everything else
	        this.sourceFrame = new _math.Rectangle();
	        this.destinationFrame = new _math.Rectangle();
	        this.filters = [];
	    }

	    /**
	     * clears the state
	     */


	    FilterState.prototype.clear = function clear() {
	        this.filters = null;
	        this.target = null;
	        this.renderTarget = null;
	    };

	    return FilterState;
	}();

	var screenKey = 'screen';

	/**
	 * @class
	 * @memberof PIXI
	 * @extends PIXI.WebGLManager
	 */

	var FilterManager = function (_WebGLManager) {
	    _inherits(FilterManager, _WebGLManager);

	    /**
	     * @param {PIXI.WebGLRenderer} renderer - The renderer this manager works for.
	     */
	    function FilterManager(renderer) {
	        _classCallCheck(this, FilterManager);

	        var _this = _possibleConstructorReturn(this, _WebGLManager.call(this, renderer));

	        _this.gl = _this.renderer.gl;
	        // know about sprites!
	        _this.quad = new _Quad2.default(_this.gl, renderer.state.attribState);

	        _this.shaderCache = {};
	        // todo add default!
	        _this.pool = {};

	        _this.filterData = null;

	        _this.managedFilters = [];

	        _this.renderer.on('prerender', _this.onPrerender, _this);

	        _this._screenWidth = renderer.view.width;
	        _this._screenHeight = renderer.view.height;
	        return _this;
	    }

	    /**
	     * Adds a new filter to the manager.
	     *
	     * @param {PIXI.DisplayObject} target - The target of the filter to render.
	     * @param {PIXI.Filter[]} filters - The filters to apply.
	     */


	    FilterManager.prototype.pushFilter = function pushFilter(target, filters) {
	        var renderer = this.renderer;

	        var filterData = this.filterData;

	        if (!filterData) {
	            filterData = this.renderer._activeRenderTarget.filterStack;

	            // add new stack
	            var filterState = new FilterState();

	            filterState.sourceFrame = filterState.destinationFrame = this.renderer._activeRenderTarget.size;
	            filterState.renderTarget = renderer._activeRenderTarget;

	            this.renderer._activeRenderTarget.filterData = filterData = {
	                index: 0,
	                stack: [filterState]
	            };

	            this.filterData = filterData;
	        }

	        // get the current filter state..
	        var currentState = filterData.stack[++filterData.index];
	        var renderTargetFrame = filterData.stack[0].destinationFrame;

	        if (!currentState) {
	            currentState = filterData.stack[filterData.index] = new FilterState();
	        }

	        var fullScreen = target.filterArea && target.filterArea.x === 0 && target.filterArea.y === 0 && target.filterArea.width === renderer.screen.width && target.filterArea.height === renderer.screen.height;

	        // for now we go off the filter of the first resolution..
	        var resolution = filters[0].resolution;
	        var padding = filters[0].padding | 0;
	        var targetBounds = fullScreen ? renderer.screen : target.filterArea || target.getBounds(true);
	        var sourceFrame = currentState.sourceFrame;
	        var destinationFrame = currentState.destinationFrame;

	        sourceFrame.x = (targetBounds.x * resolution | 0) / resolution;
	        sourceFrame.y = (targetBounds.y * resolution | 0) / resolution;
	        sourceFrame.width = (targetBounds.width * resolution | 0) / resolution;
	        sourceFrame.height = (targetBounds.height * resolution | 0) / resolution;

	        if (!fullScreen) {
	            if (filterData.stack[0].renderTarget.transform) {//

	                // TODO we should fit the rect around the transform..
	            } else if (filters[0].autoFit) {
	                sourceFrame.fit(renderTargetFrame);
	            }

	            // lets apply the padding After we fit the element to the screen.
	            // this should stop the strange side effects that can occur when cropping to the edges
	            sourceFrame.pad(padding);
	        }

	        destinationFrame.width = sourceFrame.width;
	        destinationFrame.height = sourceFrame.height;

	        // lets play the padding after we fit the element to the screen.
	        // this should stop the strange side effects that can occur when cropping to the edges

	        var renderTarget = this.getPotRenderTarget(renderer.gl, sourceFrame.width, sourceFrame.height, resolution);

	        currentState.target = target;
	        currentState.filters = filters;
	        currentState.resolution = resolution;
	        currentState.renderTarget = renderTarget;

	        // bind the render target to draw the shape in the top corner..

	        renderTarget.setFrame(destinationFrame, sourceFrame);

	        // bind the render target
	        renderer.bindRenderTarget(renderTarget);
	        renderTarget.clear();
	    };

	    /**
	     * Pops off the filter and applies it.
	     *
	     */


	    FilterManager.prototype.popFilter = function popFilter() {
	        var filterData = this.filterData;

	        var lastState = filterData.stack[filterData.index - 1];
	        var currentState = filterData.stack[filterData.index];

	        this.quad.map(currentState.renderTarget.size, currentState.sourceFrame).upload();

	        var filters = currentState.filters;

	        if (filters.length === 1) {
	            filters[0].apply(this, currentState.renderTarget, lastState.renderTarget, false, currentState);
	            this.freePotRenderTarget(currentState.renderTarget);
	        } else {
	            var flip = currentState.renderTarget;
	            var flop = this.getPotRenderTarget(this.renderer.gl, currentState.sourceFrame.width, currentState.sourceFrame.height, currentState.resolution);

	            flop.setFrame(currentState.destinationFrame, currentState.sourceFrame);

	            // finally lets clear the render target before drawing to it..
	            flop.clear();

	            var i = 0;

	            for (i = 0; i < filters.length - 1; ++i) {
	                filters[i].apply(this, flip, flop, true, currentState);

	                var t = flip;

	                flip = flop;
	                flop = t;
	            }

	            filters[i].apply(this, flip, lastState.renderTarget, false, currentState);

	            this.freePotRenderTarget(flip);
	            this.freePotRenderTarget(flop);
	        }

	        currentState.clear();
	        filterData.index--;

	        if (filterData.index === 0) {
	            this.filterData = null;
	        }
	    };

	    /**
	     * Draws a filter.
	     *
	     * @param {PIXI.Filter} filter - The filter to draw.
	     * @param {PIXI.RenderTarget} input - The input render target.
	     * @param {PIXI.RenderTarget} output - The target to output to.
	     * @param {boolean} clear - Should the output be cleared before rendering to it
	     */


	    FilterManager.prototype.applyFilter = function applyFilter(filter, input, output, clear) {
	        var renderer = this.renderer;
	        var gl = renderer.gl;

	        var shader = filter.glShaders[renderer.CONTEXT_UID];

	        // caching..
	        if (!shader) {
	            if (filter.glShaderKey) {
	                shader = this.shaderCache[filter.glShaderKey];

	                if (!shader) {
	                    shader = new _Shader2.default(this.gl, filter.vertexSrc, filter.fragmentSrc);

	                    filter.glShaders[renderer.CONTEXT_UID] = this.shaderCache[filter.glShaderKey] = shader;
	                    this.managedFilters.push(filter);
	                }
	            } else {
	                shader = filter.glShaders[renderer.CONTEXT_UID] = new _Shader2.default(this.gl, filter.vertexSrc, filter.fragmentSrc);
	                this.managedFilters.push(filter);
	            }

	            // TODO - this only needs to be done once?
	            renderer.bindVao(null);

	            this.quad.initVao(shader);
	        }

	        renderer.bindVao(this.quad.vao);

	        renderer.bindRenderTarget(output);

	        if (clear) {
	            gl.disable(gl.SCISSOR_TEST);
	            renderer.clear(); // [1, 1, 1, 1]);
	            gl.enable(gl.SCISSOR_TEST);
	        }

	        // in case the render target is being masked using a scissor rect
	        if (output === renderer.maskManager.scissorRenderTarget) {
	            renderer.maskManager.pushScissorMask(null, renderer.maskManager.scissorData);
	        }

	        renderer.bindShader(shader);

	        // free unit 0 for us, doesn't matter what was there
	        // don't try to restore it, because syncUniforms can upload it to another slot
	        // and it'll be a problem
	        var tex = this.renderer.emptyTextures[0];

	        this.renderer.boundTextures[0] = tex;
	        // this syncs the PixiJS filters  uniforms with glsl uniforms
	        this.syncUniforms(shader, filter);

	        renderer.state.setBlendMode(filter.blendMode);

	        gl.activeTexture(gl.TEXTURE0);
	        gl.bindTexture(gl.TEXTURE_2D, input.texture.texture);

	        this.quad.vao.draw(this.renderer.gl.TRIANGLES, 6, 0);

	        gl.bindTexture(gl.TEXTURE_2D, tex._glTextures[this.renderer.CONTEXT_UID].texture);
	    };

	    /**
	     * Uploads the uniforms of the filter.
	     *
	     * @param {GLShader} shader - The underlying gl shader.
	     * @param {PIXI.Filter} filter - The filter we are synchronizing.
	     */


	    FilterManager.prototype.syncUniforms = function syncUniforms(shader, filter) {
	        var uniformData = filter.uniformData;
	        var uniforms = filter.uniforms;

	        // 0 is reserved for the PixiJS texture so we start at 1!
	        var textureCount = 1;
	        var currentState = void 0;

	        // filterArea and filterClamp that are handled by FilterManager directly
	        // they must not appear in uniformData

	        if (shader.uniforms.filterArea) {
	            currentState = this.filterData.stack[this.filterData.index];

	            var filterArea = shader.uniforms.filterArea;

	            filterArea[0] = currentState.renderTarget.size.width;
	            filterArea[1] = currentState.renderTarget.size.height;
	            filterArea[2] = currentState.sourceFrame.x;
	            filterArea[3] = currentState.sourceFrame.y;

	            shader.uniforms.filterArea = filterArea;
	        }

	        // use this to clamp displaced texture coords so they belong to filterArea
	        // see displacementFilter fragment shader for an example
	        if (shader.uniforms.filterClamp) {
	            currentState = currentState || this.filterData.stack[this.filterData.index];

	            var filterClamp = shader.uniforms.filterClamp;

	            filterClamp[0] = 0;
	            filterClamp[1] = 0;
	            filterClamp[2] = (currentState.sourceFrame.width - 1) / currentState.renderTarget.size.width;
	            filterClamp[3] = (currentState.sourceFrame.height - 1) / currentState.renderTarget.size.height;

	            shader.uniforms.filterClamp = filterClamp;
	        }

	        // TODO Caching layer..
	        for (var i in uniformData) {
	            var type = uniformData[i].type;

	            if (type === 'sampler2d' && uniforms[i] !== 0) {
	                if (uniforms[i].baseTexture) {
	                    shader.uniforms[i] = this.renderer.bindTexture(uniforms[i].baseTexture, textureCount);
	                } else {
	                    shader.uniforms[i] = textureCount;

	                    // TODO
	                    // this is helpful as renderTargets can also be set.
	                    // Although thinking about it, we could probably
	                    // make the filter texture cache return a RenderTexture
	                    // rather than a renderTarget
	                    var gl = this.renderer.gl;

	                    this.renderer.boundTextures[textureCount] = this.renderer.emptyTextures[textureCount];
	                    gl.activeTexture(gl.TEXTURE0 + textureCount);

	                    uniforms[i].texture.bind();
	                }

	                textureCount++;
	            } else if (type === 'mat3') {
	                // check if its PixiJS matrix..
	                if (uniforms[i].a !== undefined) {
	                    shader.uniforms[i] = uniforms[i].toArray(true);
	                } else {
	                    shader.uniforms[i] = uniforms[i];
	                }
	            } else if (type === 'vec2') {
	                // check if its a point..
	                if (uniforms[i].x !== undefined) {
	                    var val = shader.uniforms[i] || new Float32Array(2);

	                    val[0] = uniforms[i].x;
	                    val[1] = uniforms[i].y;
	                    shader.uniforms[i] = val;
	                } else {
	                    shader.uniforms[i] = uniforms[i];
	                }
	            } else if (type === 'float') {
	                if (shader.uniforms.data[i].value !== uniformData[i]) {
	                    shader.uniforms[i] = uniforms[i];
	                }
	            } else {
	                shader.uniforms[i] = uniforms[i];
	            }
	        }
	    };

	    /**
	     * Gets a render target from the pool, or creates a new one.
	     *
	     * @param {boolean} clear - Should we clear the render texture when we get it?
	     * @param {number} resolution - The resolution of the target.
	     * @return {PIXI.RenderTarget} The new render target
	     */


	    FilterManager.prototype.getRenderTarget = function getRenderTarget(clear, resolution) {
	        var currentState = this.filterData.stack[this.filterData.index];
	        var renderTarget = this.getPotRenderTarget(this.renderer.gl, currentState.sourceFrame.width, currentState.sourceFrame.height, resolution || currentState.resolution);

	        renderTarget.setFrame(currentState.destinationFrame, currentState.sourceFrame);

	        return renderTarget;
	    };

	    /**
	     * Returns a render target to the pool.
	     *
	     * @param {PIXI.RenderTarget} renderTarget - The render target to return.
	     */


	    FilterManager.prototype.returnRenderTarget = function returnRenderTarget(renderTarget) {
	        this.freePotRenderTarget(renderTarget);
	    };

	    /**
	     * Calculates the mapped matrix.
	     *
	     * TODO playing around here.. this is temporary - (will end up in the shader)
	     * this returns a matrix that will normalise map filter cords in the filter to screen space
	     *
	     * @param {PIXI.Matrix} outputMatrix - the matrix to output to.
	     * @return {PIXI.Matrix} The mapped matrix.
	     */


	    FilterManager.prototype.calculateScreenSpaceMatrix = function calculateScreenSpaceMatrix(outputMatrix) {
	        var currentState = this.filterData.stack[this.filterData.index];

	        return filterTransforms.calculateScreenSpaceMatrix(outputMatrix, currentState.sourceFrame, currentState.renderTarget.size);
	    };

	    /**
	     * Multiply vTextureCoord to this matrix to achieve (0,0,1,1) for filterArea
	     *
	     * @param {PIXI.Matrix} outputMatrix - The matrix to output to.
	     * @return {PIXI.Matrix} The mapped matrix.
	     */


	    FilterManager.prototype.calculateNormalizedScreenSpaceMatrix = function calculateNormalizedScreenSpaceMatrix(outputMatrix) {
	        var currentState = this.filterData.stack[this.filterData.index];

	        return filterTransforms.calculateNormalizedScreenSpaceMatrix(outputMatrix, currentState.sourceFrame, currentState.renderTarget.size, currentState.destinationFrame);
	    };

	    /**
	     * This will map the filter coord so that a texture can be used based on the transform of a sprite
	     *
	     * @param {PIXI.Matrix} outputMatrix - The matrix to output to.
	     * @param {PIXI.Sprite} sprite - The sprite to map to.
	     * @return {PIXI.Matrix} The mapped matrix.
	     */


	    FilterManager.prototype.calculateSpriteMatrix = function calculateSpriteMatrix(outputMatrix, sprite) {
	        var currentState = this.filterData.stack[this.filterData.index];

	        return filterTransforms.calculateSpriteMatrix(outputMatrix, currentState.sourceFrame, currentState.renderTarget.size, sprite);
	    };

	    /**
	     * Destroys this Filter Manager.
	     *
	     * @param {boolean} [contextLost=false] context was lost, do not free shaders
	     *
	     */


	    FilterManager.prototype.destroy = function destroy() {
	        var contextLost = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

	        var renderer = this.renderer;
	        var filters = this.managedFilters;

	        renderer.off('prerender', this.onPrerender, this);

	        for (var i = 0; i < filters.length; i++) {
	            if (!contextLost) {
	                filters[i].glShaders[renderer.CONTEXT_UID].destroy();
	            }
	            delete filters[i].glShaders[renderer.CONTEXT_UID];
	        }

	        this.shaderCache = {};
	        if (!contextLost) {
	            this.emptyPool();
	        } else {
	            this.pool = {};
	        }
	    };

	    /**
	     * Gets a Power-of-Two render texture.
	     *
	     * TODO move to a separate class could be on renderer?
	     * also - could cause issue with multiple contexts?
	     *
	     * @private
	     * @param {WebGLRenderingContext} gl - The webgl rendering context
	     * @param {number} minWidth - The minimum width of the render target.
	     * @param {number} minHeight - The minimum height of the render target.
	     * @param {number} resolution - The resolution of the render target.
	     * @return {PIXI.RenderTarget} The new render target.
	     */


	    FilterManager.prototype.getPotRenderTarget = function getPotRenderTarget(gl, minWidth, minHeight, resolution) {
	        var key = screenKey;

	        minWidth *= resolution;
	        minHeight *= resolution;

	        if (minWidth !== this._screenWidth || minHeight !== this._screenHeight) {
	            // TODO you could return a bigger texture if there is not one in the pool?
	            minWidth = _bitTwiddle2.default.nextPow2(minWidth);
	            minHeight = _bitTwiddle2.default.nextPow2(minHeight);
	            key = (minWidth & 0xFFFF) << 16 | minHeight & 0xFFFF;
	        }

	        if (!this.pool[key]) {
	            this.pool[key] = [];
	        }

	        var renderTarget = this.pool[key].pop();

	        // creating render target will cause texture to be bound!
	        if (!renderTarget) {
	            // temporary bypass cache..
	            var tex = this.renderer.boundTextures[0];

	            gl.activeTexture(gl.TEXTURE0);

	            // internally - this will cause a texture to be bound..
	            renderTarget = new _RenderTarget2.default(gl, minWidth, minHeight, null, 1);

	            // set the current one back
	            gl.bindTexture(gl.TEXTURE_2D, tex._glTextures[this.renderer.CONTEXT_UID].texture);
	        }

	        // manually tweak the resolution...
	        // this will not modify the size of the frame buffer, just its resolution.
	        renderTarget.resolution = resolution;
	        renderTarget.defaultFrame.width = renderTarget.size.width = minWidth / resolution;
	        renderTarget.defaultFrame.height = renderTarget.size.height = minHeight / resolution;
	        renderTarget.filterPoolKey = key;

	        return renderTarget;
	    };

	    /**
	     * Empties the texture pool.
	     *
	     */


	    FilterManager.prototype.emptyPool = function emptyPool() {
	        for (var i in this.pool) {
	            var textures = this.pool[i];

	            if (textures) {
	                for (var j = 0; j < textures.length; j++) {
	                    textures[j].destroy(true);
	                }
	            }
	        }

	        this.pool = {};
	    };

	    /**
	     * Frees a render target back into the pool.
	     *
	     * @param {PIXI.RenderTarget} renderTarget - The renderTarget to free
	     */


	    FilterManager.prototype.freePotRenderTarget = function freePotRenderTarget(renderTarget) {
	        this.pool[renderTarget.filterPoolKey].push(renderTarget);
	    };

	    /**
	     * Called before the renderer starts rendering.
	     *
	     */


	    FilterManager.prototype.onPrerender = function onPrerender() {
	        if (this._screenWidth !== this.renderer.view.width || this._screenHeight !== this.renderer.view.height) {
	            this._screenWidth = this.renderer.view.width;
	            this._screenHeight = this.renderer.view.height;

	            var textures = this.pool[screenKey];

	            if (textures) {
	                for (var j = 0; j < textures.length; j++) {
	                    textures[j].destroy(true);
	                }
	            }
	            this.pool[screenKey] = [];
	        }
	    };

	    return FilterManager;
	}(_WebGLManager3.default);

	exports.default = FilterManager;
	//# sourceMappingURL=FilterManager.js.map

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _math = __webpack_require__(175);

	var _const = __webpack_require__(174);

	var _settings = __webpack_require__(205);

	var _settings2 = _interopRequireDefault(_settings);

	var _pixiGlCore = __webpack_require__(185);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/**
	 * @class
	 * @memberof PIXI
	 */
	var RenderTarget = function () {
	  /**
	   * @param {WebGLRenderingContext} gl - The current WebGL drawing context
	   * @param {number} [width=0] - the horizontal range of the filter
	   * @param {number} [height=0] - the vertical range of the filter
	   * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
	   * @param {number} [resolution=1] - The current resolution / device pixel ratio
	   * @param {boolean} [root=false] - Whether this object is the root element or not
	   */
	  function RenderTarget(gl, width, height, scaleMode, resolution, root) {
	    _classCallCheck(this, RenderTarget);

	    // TODO Resolution could go here ( eg low res blurs )

	    /**
	     * The current WebGL drawing context.
	     *
	     * @member {WebGLRenderingContext}
	     */
	    this.gl = gl;

	    // next time to create a frame buffer and texture

	    /**
	     * A frame buffer
	     *
	     * @member {PIXI.glCore.GLFramebuffer}
	     */
	    this.frameBuffer = null;

	    /**
	     * The texture
	     *
	     * @member {PIXI.glCore.GLTexture}
	     */
	    this.texture = null;

	    /**
	     * The background colour of this render target, as an array of [r,g,b,a] values
	     *
	     * @member {number[]}
	     */
	    this.clearColor = [0, 0, 0, 0];

	    /**
	     * The size of the object as a rectangle
	     *
	     * @member {PIXI.Rectangle}
	     */
	    this.size = new _math.Rectangle(0, 0, 1, 1);

	    /**
	     * The current resolution / device pixel ratio
	     *
	     * @member {number}
	     * @default 1
	     */
	    this.resolution = resolution || _settings2.default.RESOLUTION;

	    /**
	     * The projection matrix
	     *
	     * @member {PIXI.Matrix}
	     */
	    this.projectionMatrix = new _math.Matrix();

	    /**
	     * The object's transform
	     *
	     * @member {PIXI.Matrix}
	     */
	    this.transform = null;

	    /**
	     * The frame.
	     *
	     * @member {PIXI.Rectangle}
	     */
	    this.frame = null;

	    /**
	     * The stencil buffer stores masking data for the render target
	     *
	     * @member {glCore.GLBuffer}
	     */
	    this.defaultFrame = new _math.Rectangle();
	    this.destinationFrame = null;
	    this.sourceFrame = null;

	    /**
	     * The stencil buffer stores masking data for the render target
	     *
	     * @member {glCore.GLBuffer}
	     */
	    this.stencilBuffer = null;

	    /**
	     * The data structure for the stencil masks
	     *
	     * @member {PIXI.Graphics[]}
	     */
	    this.stencilMaskStack = [];

	    /**
	     * Stores filter data for the render target
	     *
	     * @member {object[]}
	     */
	    this.filterData = null;

	    /**
	     * The key for pooled texture of FilterSystem
	     * @private
	     * @member {string}
	     */
	    this.filterPoolKey = '';

	    /**
	     * The scale mode.
	     *
	     * @member {number}
	     * @default PIXI.settings.SCALE_MODE
	     * @see PIXI.SCALE_MODES
	     */
	    this.scaleMode = scaleMode !== undefined ? scaleMode : _settings2.default.SCALE_MODE;

	    /**
	     * Whether this object is the root element or not
	     *
	     * @member {boolean}
	     */
	    this.root = root;

	    if (!this.root) {
	      this.frameBuffer = _pixiGlCore.GLFramebuffer.createRGBA(gl, 100, 100);

	      if (this.scaleMode === _const.SCALE_MODES.NEAREST) {
	        this.frameBuffer.texture.enableNearestScaling();
	      } else {
	        this.frameBuffer.texture.enableLinearScaling();
	      }
	      /*
	          A frame buffer needs a target to render to..
	          create a texture and bind it attach it to the framebuffer..
	       */

	      // this is used by the base texture
	      this.texture = this.frameBuffer.texture;
	    } else {
	      // make it a null framebuffer..
	      this.frameBuffer = new _pixiGlCore.GLFramebuffer(gl, 100, 100);
	      this.frameBuffer.framebuffer = null;
	    }

	    this.setFrame();

	    this.resize(width, height);
	  }

	  /**
	   * Clears the filter texture.
	   *
	   * @param {number[]} [clearColor=this.clearColor] - Array of [r,g,b,a] to clear the framebuffer
	   */


	  RenderTarget.prototype.clear = function clear(clearColor) {
	    var cc = clearColor || this.clearColor;

	    this.frameBuffer.clear(cc[0], cc[1], cc[2], cc[3]); // r,g,b,a);
	  };

	  /**
	   * Binds the stencil buffer.
	   *
	   */


	  RenderTarget.prototype.attachStencilBuffer = function attachStencilBuffer() {
	    // TODO check if stencil is done?
	    /**
	     * The stencil buffer is used for masking in pixi
	     * lets create one and then add attach it to the framebuffer..
	     */
	    if (!this.root) {
	      this.frameBuffer.enableStencil();
	    }
	  };

	  /**
	   * Sets the frame of the render target.
	   *
	   * @param {Rectangle} destinationFrame - The destination frame.
	   * @param {Rectangle} sourceFrame - The source frame.
	   */


	  RenderTarget.prototype.setFrame = function setFrame(destinationFrame, sourceFrame) {
	    this.destinationFrame = destinationFrame || this.destinationFrame || this.defaultFrame;
	    this.sourceFrame = sourceFrame || this.sourceFrame || this.destinationFrame;
	  };

	  /**
	   * Binds the buffers and initialises the viewport.
	   *
	   */


	  RenderTarget.prototype.activate = function activate() {
	    // TODO refactor usage of frame..
	    var gl = this.gl;

	    // make sure the texture is unbound!
	    this.frameBuffer.bind();

	    this.calculateProjection(this.destinationFrame, this.sourceFrame);

	    if (this.transform) {
	      this.projectionMatrix.append(this.transform);
	    }

	    // TODO add a check as them may be the same!
	    if (this.destinationFrame !== this.sourceFrame) {
	      gl.enable(gl.SCISSOR_TEST);
	      gl.scissor(this.destinationFrame.x | 0, this.destinationFrame.y | 0, this.destinationFrame.width * this.resolution | 0, this.destinationFrame.height * this.resolution | 0);
	    } else {
	      gl.disable(gl.SCISSOR_TEST);
	    }

	    // TODO - does not need to be updated all the time??
	    gl.viewport(this.destinationFrame.x | 0, this.destinationFrame.y | 0, this.destinationFrame.width * this.resolution | 0, this.destinationFrame.height * this.resolution | 0);
	  };

	  /**
	   * Updates the projection matrix based on a projection frame (which is a rectangle)
	   *
	   * @param {Rectangle} destinationFrame - The destination frame.
	   * @param {Rectangle} sourceFrame - The source frame.
	   */


	  RenderTarget.prototype.calculateProjection = function calculateProjection(destinationFrame, sourceFrame) {
	    var pm = this.projectionMatrix;

	    sourceFrame = sourceFrame || destinationFrame;

	    pm.identity();

	    // TODO: make dest scale source
	    if (!this.root) {
	      pm.a = 1 / destinationFrame.width * 2;
	      pm.d = 1 / destinationFrame.height * 2;

	      pm.tx = -1 - sourceFrame.x * pm.a;
	      pm.ty = -1 - sourceFrame.y * pm.d;
	    } else {
	      pm.a = 1 / destinationFrame.width * 2;
	      pm.d = -1 / destinationFrame.height * 2;

	      pm.tx = -1 - sourceFrame.x * pm.a;
	      pm.ty = 1 - sourceFrame.y * pm.d;
	    }
	  };

	  /**
	   * Resizes the texture to the specified width and height
	   *
	   * @param {number} width - the new width of the texture
	   * @param {number} height - the new height of the texture
	   */


	  RenderTarget.prototype.resize = function resize(width, height) {
	    width = width | 0;
	    height = height | 0;

	    if (this.size.width === width && this.size.height === height) {
	      return;
	    }

	    this.size.width = width;
	    this.size.height = height;

	    this.defaultFrame.width = width;
	    this.defaultFrame.height = height;

	    this.frameBuffer.resize(width * this.resolution, height * this.resolution);

	    var projectionFrame = this.frame || this.size;

	    this.calculateProjection(projectionFrame);
	  };

	  /**
	   * Destroys the render target.
	   *
	   */


	  RenderTarget.prototype.destroy = function destroy() {
	    this.frameBuffer.destroy();

	    this.frameBuffer = null;
	    this.texture = null;
	  };

	  return RenderTarget;
	}();

	exports.default = RenderTarget;
	//# sourceMappingURL=RenderTarget.js.map

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _pixiGlCore = __webpack_require__(185);

	var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);

	var _createIndicesForQuads = __webpack_require__(261);

	var _createIndicesForQuads2 = _interopRequireDefault(_createIndicesForQuads);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/**
	 * Helper class to create a quad
	 *
	 * @class
	 * @memberof PIXI
	 */
	var Quad = function () {
	  /**
	   * @param {WebGLRenderingContext} gl - The gl context for this quad to use.
	   * @param {object} state - TODO: Description
	   */
	  function Quad(gl, state) {
	    _classCallCheck(this, Quad);

	    /**
	     * the current WebGL drawing context
	     *
	     * @member {WebGLRenderingContext}
	     */
	    this.gl = gl;

	    /**
	     * An array of vertices
	     *
	     * @member {Float32Array}
	     */
	    this.vertices = new Float32Array([-1, -1, 1, -1, 1, 1, -1, 1]);

	    /**
	     * The Uvs of the quad
	     *
	     * @member {Float32Array}
	     */
	    this.uvs = new Float32Array([0, 0, 1, 0, 1, 1, 0, 1]);

	    this.interleaved = new Float32Array(8 * 2);

	    for (var i = 0; i < 4; i++) {
	      this.interleaved[i * 4] = this.vertices[i * 2];
	      this.interleaved[i * 4 + 1] = this.vertices[i * 2 + 1];
	      this.interleaved[i * 4 + 2] = this.uvs[i * 2];
	      this.interleaved[i * 4 + 3] = this.uvs[i * 2 + 1];
	    }

	    /**
	     * An array containing the indices of the vertices
	     *
	     * @member {Uint16Array}
	     */
	    this.indices = (0, _createIndicesForQuads2.default)(1);

	    /**
	     * The vertex buffer
	     *
	     * @member {glCore.GLBuffer}
	     */
	    this.vertexBuffer = _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl, this.interleaved, gl.STATIC_DRAW);

	    /**
	     * The index buffer
	     *
	     * @member {glCore.GLBuffer}
	     */
	    this.indexBuffer = _pixiGlCore2.default.GLBuffer.createIndexBuffer(gl, this.indices, gl.STATIC_DRAW);

	    /**
	     * The vertex array object
	     *
	     * @member {glCore.VertexArrayObject}
	     */
	    this.vao = new _pixiGlCore2.default.VertexArrayObject(gl, state);
	  }

	  /**
	   * Initialises the vaos and uses the shader.
	   *
	   * @param {PIXI.Shader} shader - the shader to use
	   */


	  Quad.prototype.initVao = function initVao(shader) {
	    this.vao.clear().addIndex(this.indexBuffer).addAttribute(this.vertexBuffer, shader.attributes.aVertexPosition, this.gl.FLOAT, false, 4 * 4, 0).addAttribute(this.vertexBuffer, shader.attributes.aTextureCoord, this.gl.FLOAT, false, 4 * 4, 2 * 4);
	  };

	  /**
	   * Maps two Rectangle to the quad.
	   *
	   * @param {PIXI.Rectangle} targetTextureFrame - the first rectangle
	   * @param {PIXI.Rectangle} destinationFrame - the second rectangle
	   * @return {PIXI.Quad} Returns itself.
	   */


	  Quad.prototype.map = function map(targetTextureFrame, destinationFrame) {
	    var x = 0; // destinationFrame.x / targetTextureFrame.width;
	    var y = 0; // destinationFrame.y / targetTextureFrame.height;

	    this.uvs[0] = x;
	    this.uvs[1] = y;

	    this.uvs[2] = x + destinationFrame.width / targetTextureFrame.width;
	    this.uvs[3] = y;

	    this.uvs[4] = x + destinationFrame.width / targetTextureFrame.width;
	    this.uvs[5] = y + destinationFrame.height / targetTextureFrame.height;

	    this.uvs[6] = x;
	    this.uvs[7] = y + destinationFrame.height / targetTextureFrame.height;

	    x = destinationFrame.x;
	    y = destinationFrame.y;

	    this.vertices[0] = x;
	    this.vertices[1] = y;

	    this.vertices[2] = x + destinationFrame.width;
	    this.vertices[3] = y;

	    this.vertices[4] = x + destinationFrame.width;
	    this.vertices[5] = y + destinationFrame.height;

	    this.vertices[6] = x;
	    this.vertices[7] = y + destinationFrame.height;

	    return this;
	  };

	  /**
	   * Binds the buffer and uploads the data
	   *
	   * @return {PIXI.Quad} Returns itself.
	   */


	  Quad.prototype.upload = function upload() {
	    for (var i = 0; i < 4; i++) {
	      this.interleaved[i * 4] = this.vertices[i * 2];
	      this.interleaved[i * 4 + 1] = this.vertices[i * 2 + 1];
	      this.interleaved[i * 4 + 2] = this.uvs[i * 2];
	      this.interleaved[i * 4 + 3] = this.uvs[i * 2 + 1];
	    }

	    this.vertexBuffer.upload(this.interleaved);

	    return this;
	  };

	  /**
	   * Removes this quad from WebGL
	   */


	  Quad.prototype.destroy = function destroy() {
	    var gl = this.gl;

	    gl.deleteBuffer(this.vertexBuffer);
	    gl.deleteBuffer(this.indexBuffer);
	  };

	  return Quad;
	}();

	exports.default = Quad;
	//# sourceMappingURL=Quad.js.map

/***/ }),
/* 261 */
/***/ (function(module, exports) {

	"use strict";

	exports.__esModule = true;
	exports.default = createIndicesForQuads;
	/**
	 * Generic Mask Stack data structure
	 *
	 * @memberof PIXI
	 * @function createIndicesForQuads
	 * @private
	 * @param {number} size - Number of quads
	 * @return {Uint16Array} indices
	 */
	function createIndicesForQuads(size) {
	    // the total number of indices in our array, there are 6 points per quad.

	    var totalIndices = size * 6;

	    var indices = new Uint16Array(totalIndices);

	    // fill the indices with the quads to draw
	    for (var i = 0, j = 0; i < totalIndices; i += 6, j += 4) {
	        indices[i + 0] = j + 0;
	        indices[i + 1] = j + 1;
	        indices[i + 2] = j + 2;
	        indices[i + 3] = j + 0;
	        indices[i + 4] = j + 2;
	        indices[i + 5] = j + 3;
	    }

	    return indices;
	}
	//# sourceMappingURL=createIndicesForQuads.js.map

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _pixiGlCore = __webpack_require__(185);

	var _settings = __webpack_require__(205);

	var _settings2 = _interopRequireDefault(_settings);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	function checkPrecision(src, def) {
	    if (src instanceof Array) {
	        if (src[0].substring(0, 9) !== 'precision') {
	            var copy = src.slice(0);

	            copy.unshift('precision ' + def + ' float;');

	            return copy;
	        }
	    } else if (src.trim().substring(0, 9) !== 'precision') {
	        return 'precision ' + def + ' float;\n' + src;
	    }

	    return src;
	}

	/**
	 * Wrapper class, webGL Shader for Pixi.
	 * Adds precision string if vertexSrc or fragmentSrc have no mention of it.
	 *
	 * @class
	 * @extends GLShader
	 * @memberof PIXI
	 */

	var Shader = function (_GLShader) {
	    _inherits(Shader, _GLShader);

	    /**
	     *
	     * @param {WebGLRenderingContext} gl - The current WebGL rendering context
	     * @param {string|string[]} vertexSrc - The vertex shader source as an array of strings.
	     * @param {string|string[]} fragmentSrc - The fragment shader source as an array of strings.
	     * @param {object} [attributeLocations] - A key value pair showing which location eact attribute should sit.
	                       e.g. {position:0, uvs:1}.
	     * @param {string} [precision] - The float precision of the shader. Options are 'lowp', 'mediump' or 'highp'.
	     */
	    function Shader(gl, vertexSrc, fragmentSrc, attributeLocations, precision) {
	        _classCallCheck(this, Shader);

	        return _possibleConstructorReturn(this, _GLShader.call(this, gl, checkPrecision(vertexSrc, precision || _settings2.default.PRECISION_VERTEX), checkPrecision(fragmentSrc, precision || _settings2.default.PRECISION_FRAGMENT), undefined, attributeLocations));
	    }

	    return Shader;
	}(_pixiGlCore.GLShader);

	exports.default = Shader;
	//# sourceMappingURL=Shader.js.map

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;
	exports.calculateScreenSpaceMatrix = calculateScreenSpaceMatrix;
	exports.calculateNormalizedScreenSpaceMatrix = calculateNormalizedScreenSpaceMatrix;
	exports.calculateSpriteMatrix = calculateSpriteMatrix;

	var _math = __webpack_require__(175);

	/**
	 * Calculates the mapped matrix
	 * @param filterArea {Rectangle} The filter area
	 * @param sprite {Sprite} the target sprite
	 * @param outputMatrix {Matrix} @alvin
	 * @private
	 */
	// TODO playing around here.. this is temporary - (will end up in the shader)
	// this returns a matrix that will normalise map filter cords in the filter to screen space
	function calculateScreenSpaceMatrix(outputMatrix, filterArea, textureSize) {
	    // let worldTransform = sprite.worldTransform.copy(Matrix.TEMP_MATRIX),
	    // let texture = {width:1136, height:700};//sprite._texture.baseTexture;

	    // TODO unwrap?
	    var mappedMatrix = outputMatrix.identity();

	    mappedMatrix.translate(filterArea.x / textureSize.width, filterArea.y / textureSize.height);

	    mappedMatrix.scale(textureSize.width, textureSize.height);

	    return mappedMatrix;
	}

	function calculateNormalizedScreenSpaceMatrix(outputMatrix, filterArea, textureSize) {
	    var mappedMatrix = outputMatrix.identity();

	    mappedMatrix.translate(filterArea.x / textureSize.width, filterArea.y / textureSize.height);

	    var translateScaleX = textureSize.width / filterArea.width;
	    var translateScaleY = textureSize.height / filterArea.height;

	    mappedMatrix.scale(translateScaleX, translateScaleY);

	    return mappedMatrix;
	}

	// this will map the filter coord so that a texture can be used based on the transform of a sprite
	function calculateSpriteMatrix(outputMatrix, filterArea, textureSize, sprite) {
	    var orig = sprite._texture.orig;
	    var mappedMatrix = outputMatrix.set(textureSize.width, 0, 0, textureSize.height, filterArea.x, filterArea.y);
	    var worldTransform = sprite.worldTransform.copy(_math.Matrix.TEMP_MATRIX);

	    worldTransform.invert();
	    mappedMatrix.prepend(worldTransform);
	    mappedMatrix.scale(1.0 / orig.width, 1.0 / orig.height);
	    mappedMatrix.translate(sprite.anchor.x, sprite.anchor.y);

	    return mappedMatrix;
	}
	//# sourceMappingURL=filterTransforms.js.map

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _pixiGlCore = __webpack_require__(185);

	var _const = __webpack_require__(174);

	var _RenderTarget = __webpack_require__(259);

	var _RenderTarget2 = _interopRequireDefault(_RenderTarget);

	var _utils = __webpack_require__(213);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/**
	 * Helper class to create a webGL Texture
	 *
	 * @class
	 * @memberof PIXI
	 */
	var TextureManager = function () {
	    /**
	     * @param {PIXI.WebGLRenderer} renderer - A reference to the current renderer
	     */
	    function TextureManager(renderer) {
	        _classCallCheck(this, TextureManager);

	        /**
	         * A reference to the current renderer
	         *
	         * @member {PIXI.WebGLRenderer}
	         */
	        this.renderer = renderer;

	        /**
	         * The current WebGL rendering context
	         *
	         * @member {WebGLRenderingContext}
	         */
	        this.gl = renderer.gl;

	        /**
	         * Track textures in the renderer so we can no longer listen to them on destruction.
	         *
	         * @member {Array<*>}
	         * @private
	         */
	        this._managedTextures = [];
	    }

	    /**
	     * Binds a texture.
	     *
	     */


	    TextureManager.prototype.bindTexture = function bindTexture() {}
	    // empty


	    /**
	     * Gets a texture.
	     *
	     */
	    ;

	    TextureManager.prototype.getTexture = function getTexture() {}
	    // empty


	    /**
	     * Updates and/or Creates a WebGL texture for the renderer's context.
	     *
	     * @param {PIXI.BaseTexture|PIXI.Texture} texture - the texture to update
	     * @param {number} location - the location the texture will be bound to.
	     * @return {GLTexture} The gl texture.
	     */
	    ;

	    TextureManager.prototype.updateTexture = function updateTexture(texture, location) {
	        // assume it good!
	        // texture = texture.baseTexture || texture;

	        var gl = this.gl;

	        var isRenderTexture = !!texture._glRenderTargets;

	        if (!texture.hasLoaded) {
	            return null;
	        }

	        var boundTextures = this.renderer.boundTextures;

	        // if the location is undefined then this may have been called by n event.
	        // this being the case the texture may already be bound to a slot. As a texture can only be bound once
	        // we need to find its current location if it exists.
	        if (location === undefined) {
	            location = 0;

	            // TODO maybe we can use texture bound ids later on...
	            // check if texture is already bound..
	            for (var i = 0; i < boundTextures.length; ++i) {
	                if (boundTextures[i] === texture) {
	                    location = i;
	                    break;
	                }
	            }
	        }

	        boundTextures[location] = texture;

	        gl.activeTexture(gl.TEXTURE0 + location);

	        var glTexture = texture._glTextures[this.renderer.CONTEXT_UID];

	        if (!glTexture) {
	            if (isRenderTexture) {
	                var renderTarget = new _RenderTarget2.default(this.gl, texture.width, texture.height, texture.scaleMode, texture.resolution);

	                renderTarget.resize(texture.width, texture.height);
	                texture._glRenderTargets[this.renderer.CONTEXT_UID] = renderTarget;
	                glTexture = renderTarget.texture;
	            } else {
	                glTexture = new _pixiGlCore.GLTexture(this.gl, null, null, null, null);
	                glTexture.bind(location);
	                glTexture.premultiplyAlpha = true;
	                glTexture.upload(texture.source);
	            }

	            texture._glTextures[this.renderer.CONTEXT_UID] = glTexture;

	            texture.on('update', this.updateTexture, this);
	            texture.on('dispose', this.destroyTexture, this);

	            this._managedTextures.push(texture);

	            if (texture.isPowerOfTwo) {
	                if (texture.mipmap) {
	                    glTexture.enableMipmap();
	                }

	                if (texture.wrapMode === _const.WRAP_MODES.CLAMP) {
	                    glTexture.enableWrapClamp();
	                } else if (texture.wrapMode === _const.WRAP_MODES.REPEAT) {
	                    glTexture.enableWrapRepeat();
	                } else {
	                    glTexture.enableWrapMirrorRepeat();
	                }
	            } else {
	                glTexture.enableWrapClamp();
	            }

	            if (texture.scaleMode === _const.SCALE_MODES.NEAREST) {
	                glTexture.enableNearestScaling();
	            } else {
	                glTexture.enableLinearScaling();
	            }
	        }
	        // the texture already exists so we only need to update it..
	        else if (isRenderTexture) {
	                texture._glRenderTargets[this.renderer.CONTEXT_UID].resize(texture.width, texture.height);
	            } else {
	                glTexture.upload(texture.source);
	            }

	        return glTexture;
	    };

	    /**
	     * Deletes the texture from WebGL
	     *
	     * @param {PIXI.BaseTexture|PIXI.Texture} texture - the texture to destroy
	     * @param {boolean} [skipRemove=false] - Whether to skip removing the texture from the TextureManager.
	     */


	    TextureManager.prototype.destroyTexture = function destroyTexture(texture, skipRemove) {
	        texture = texture.baseTexture || texture;

	        if (!texture.hasLoaded) {
	            return;
	        }

	        var uid = this.renderer.CONTEXT_UID;
	        var glTextures = texture._glTextures;
	        var glRenderTargets = texture._glRenderTargets;

	        if (glTextures[uid]) {
	            this.renderer.unbindTexture(texture);

	            glTextures[uid].destroy();
	            texture.off('update', this.updateTexture, this);
	            texture.off('dispose', this.destroyTexture, this);

	            delete glTextures[uid];

	            if (!skipRemove) {
	                var i = this._managedTextures.indexOf(texture);

	                if (i !== -1) {
	                    (0, _utils.removeItems)(this._managedTextures, i, 1);
	                }
	            }
	        }

	        if (glRenderTargets && glRenderTargets[uid]) {
	            glRenderTargets[uid].destroy();
	            delete glRenderTargets[uid];
	        }
	    };

	    /**
	     * Deletes all the textures from WebGL
	     */


	    TextureManager.prototype.removeAll = function removeAll() {
	        // empty all the old gl textures as they are useless now
	        for (var i = 0; i < this._managedTextures.length; ++i) {
	            var texture = this._managedTextures[i];

	            if (texture._glTextures[this.renderer.CONTEXT_UID]) {
	                delete texture._glTextures[this.renderer.CONTEXT_UID];
	            }
	        }
	    };

	    /**
	     * Destroys this manager and removes all its textures
	     */


	    TextureManager.prototype.destroy = function destroy() {
	        // destroy managed textures
	        for (var i = 0; i < this._managedTextures.length; ++i) {
	            var texture = this._managedTextures[i];

	            this.destroyTexture(texture, true);

	            texture.off('update', this.updateTexture, this);
	            texture.off('dispose', this.destroyTexture, this);
	        }

	        this._managedTextures = null;
	    };

	    return TextureManager;
	}();

	exports.default = TextureManager;
	//# sourceMappingURL=TextureManager.js.map

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _const = __webpack_require__(174);

	var _settings = __webpack_require__(205);

	var _settings2 = _interopRequireDefault(_settings);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/**
	 * TextureGarbageCollector. This class manages the GPU and ensures that it does not get clogged
	 * up with textures that are no longer being used.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var TextureGarbageCollector = function () {
	    /**
	     * @param {PIXI.WebGLRenderer} renderer - The renderer this manager works for.
	     */
	    function TextureGarbageCollector(renderer) {
	        _classCallCheck(this, TextureGarbageCollector);

	        this.renderer = renderer;

	        this.count = 0;
	        this.checkCount = 0;
	        this.maxIdle = _settings2.default.GC_MAX_IDLE;
	        this.checkCountMax = _settings2.default.GC_MAX_CHECK_COUNT;
	        this.mode = _settings2.default.GC_MODE;
	    }

	    /**
	     * Checks to see when the last time a texture was used
	     * if the texture has not been used for a specified amount of time it will be removed from the GPU
	     */


	    TextureGarbageCollector.prototype.update = function update() {
	        this.count++;

	        if (this.mode === _const.GC_MODES.MANUAL) {
	            return;
	        }

	        this.checkCount++;

	        if (this.checkCount > this.checkCountMax) {
	            this.checkCount = 0;

	            this.run();
	        }
	    };

	    /**
	     * Checks to see when the last time a texture was used
	     * if the texture has not been used for a specified amount of time it will be removed from the GPU
	     */


	    TextureGarbageCollector.prototype.run = function run() {
	        var tm = this.renderer.textureManager;
	        var managedTextures = tm._managedTextures;
	        var wasRemoved = false;

	        for (var i = 0; i < managedTextures.length; i++) {
	            var texture = managedTextures[i];

	            // only supports non generated textures at the moment!
	            if (!texture._glRenderTargets && this.count - texture.touched > this.maxIdle) {
	                tm.destroyTexture(texture, true);
	                managedTextures[i] = null;
	                wasRemoved = true;
	            }
	        }

	        if (wasRemoved) {
	            var j = 0;

	            for (var _i = 0; _i < managedTextures.length; _i++) {
	                if (managedTextures[_i] !== null) {
	                    managedTextures[j++] = managedTextures[_i];
	                }
	            }

	            managedTextures.length = j;
	        }
	    };

	    /**
	     * Removes all the textures within the specified displayObject and its children from the GPU
	     *
	     * @param {PIXI.DisplayObject} displayObject - the displayObject to remove the textures from.
	     */


	    TextureGarbageCollector.prototype.unload = function unload(displayObject) {
	        var tm = this.renderer.textureManager;

	        // only destroy non generated textures
	        if (displayObject._texture && displayObject._texture._glRenderTargets) {
	            tm.destroyTexture(displayObject._texture, true);
	        }

	        for (var i = displayObject.children.length - 1; i >= 0; i--) {
	            this.unload(displayObject.children[i]);
	        }
	    };

	    return TextureGarbageCollector;
	}();

	exports.default = TextureGarbageCollector;
	//# sourceMappingURL=TextureGarbageCollector.js.map

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _mapWebGLBlendModesToPixi = __webpack_require__(267);

	var _mapWebGLBlendModesToPixi2 = _interopRequireDefault(_mapWebGLBlendModesToPixi);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var BLEND = 0;
	var DEPTH_TEST = 1;
	var FRONT_FACE = 2;
	var CULL_FACE = 3;
	var BLEND_FUNC = 4;

	/**
	 * A WebGL state machines
	 *
	 * @memberof PIXI
	 * @class
	 */

	var WebGLState = function () {
	    /**
	     * @param {WebGLRenderingContext} gl - The current WebGL rendering context
	     */
	    function WebGLState(gl) {
	        _classCallCheck(this, WebGLState);

	        /**
	         * The current active state
	         *
	         * @member {Uint8Array}
	         */
	        this.activeState = new Uint8Array(16);

	        /**
	         * The default state
	         *
	         * @member {Uint8Array}
	         */
	        this.defaultState = new Uint8Array(16);

	        // default blend mode..
	        this.defaultState[0] = 1;

	        /**
	         * The current state index in the stack
	         *
	         * @member {number}
	         * @private
	         */
	        this.stackIndex = 0;

	        /**
	         * The stack holding all the different states
	         *
	         * @member {Array<*>}
	         * @private
	         */
	        this.stack = [];

	        /**
	         * The current WebGL rendering context
	         *
	         * @member {WebGLRenderingContext}
	         */
	        this.gl = gl;

	        this.maxAttribs = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);

	        this.attribState = {
	            tempAttribState: new Array(this.maxAttribs),
	            attribState: new Array(this.maxAttribs)
	        };

	        this.blendModes = (0, _mapWebGLBlendModesToPixi2.default)(gl);

	        // check we have vao..
	        this.nativeVaoExtension = gl.getExtension('OES_vertex_array_object') || gl.getExtension('MOZ_OES_vertex_array_object') || gl.getExtension('WEBKIT_OES_vertex_array_object');
	    }

	    /**
	     * Pushes a new active state
	     */


	    WebGLState.prototype.push = function push() {
	        // next state..
	        var state = this.stack[this.stackIndex];

	        if (!state) {
	            state = this.stack[this.stackIndex] = new Uint8Array(16);
	        }

	        ++this.stackIndex;

	        // copy state..
	        // set active state so we can force overrides of gl state
	        for (var i = 0; i < this.activeState.length; i++) {
	            state[i] = this.activeState[i];
	        }
	    };

	    /**
	     * Pops a state out
	     */


	    WebGLState.prototype.pop = function pop() {
	        var state = this.stack[--this.stackIndex];

	        this.setState(state);
	    };

	    /**
	     * Sets the current state
	     *
	     * @param {*} state - The state to set.
	     */


	    WebGLState.prototype.setState = function setState(state) {
	        this.setBlend(state[BLEND]);
	        this.setDepthTest(state[DEPTH_TEST]);
	        this.setFrontFace(state[FRONT_FACE]);
	        this.setCullFace(state[CULL_FACE]);
	        this.setBlendMode(state[BLEND_FUNC]);
	    };

	    /**
	     * Enables or disabled blending.
	     *
	     * @param {boolean} value - Turn on or off webgl blending.
	     */


	    WebGLState.prototype.setBlend = function setBlend(value) {
	        value = value ? 1 : 0;

	        if (this.activeState[BLEND] === value) {
	            return;
	        }

	        this.activeState[BLEND] = value;
	        this.gl[value ? 'enable' : 'disable'](this.gl.BLEND);
	    };

	    /**
	     * Sets the blend mode.
	     *
	     * @param {number} value - The blend mode to set to.
	     */


	    WebGLState.prototype.setBlendMode = function setBlendMode(value) {
	        if (value === this.activeState[BLEND_FUNC]) {
	            return;
	        }

	        this.activeState[BLEND_FUNC] = value;

	        var mode = this.blendModes[value];

	        if (mode.length === 2) {
	            this.gl.blendFunc(mode[0], mode[1]);
	        } else {
	            this.gl.blendFuncSeparate(mode[0], mode[1], mode[2], mode[3]);
	        }
	    };

	    /**
	     * Sets whether to enable or disable depth test.
	     *
	     * @param {boolean} value - Turn on or off webgl depth testing.
	     */


	    WebGLState.prototype.setDepthTest = function setDepthTest(value) {
	        value = value ? 1 : 0;

	        if (this.activeState[DEPTH_TEST] === value) {
	            return;
	        }

	        this.activeState[DEPTH_TEST] = value;
	        this.gl[value ? 'enable' : 'disable'](this.gl.DEPTH_TEST);
	    };

	    /**
	     * Sets whether to enable or disable cull face.
	     *
	     * @param {boolean} value - Turn on or off webgl cull face.
	     */


	    WebGLState.prototype.setCullFace = function setCullFace(value) {
	        value = value ? 1 : 0;

	        if (this.activeState[CULL_FACE] === value) {
	            return;
	        }

	        this.activeState[CULL_FACE] = value;
	        this.gl[value ? 'enable' : 'disable'](this.gl.CULL_FACE);
	    };

	    /**
	     * Sets the gl front face.
	     *
	     * @param {boolean} value - true is clockwise and false is counter-clockwise
	     */


	    WebGLState.prototype.setFrontFace = function setFrontFace(value) {
	        value = value ? 1 : 0;

	        if (this.activeState[FRONT_FACE] === value) {
	            return;
	        }

	        this.activeState[FRONT_FACE] = value;
	        this.gl.frontFace(this.gl[value ? 'CW' : 'CCW']);
	    };

	    /**
	     * Disables all the vaos in use
	     *
	     */


	    WebGLState.prototype.resetAttributes = function resetAttributes() {
	        for (var i = 0; i < this.attribState.tempAttribState.length; i++) {
	            this.attribState.tempAttribState[i] = 0;
	        }

	        for (var _i = 0; _i < this.attribState.attribState.length; _i++) {
	            this.attribState.attribState[_i] = 0;
	        }

	        // im going to assume one is always active for performance reasons.
	        for (var _i2 = 1; _i2 < this.maxAttribs; _i2++) {
	            this.gl.disableVertexAttribArray(_i2);
	        }
	    };

	    // used
	    /**
	     * Resets all the logic and disables the vaos
	     */


	    WebGLState.prototype.resetToDefault = function resetToDefault() {
	        // unbind any VAO if they exist..
	        if (this.nativeVaoExtension) {
	            this.nativeVaoExtension.bindVertexArrayOES(null);
	        }

	        // reset all attributes..
	        this.resetAttributes();

	        // set active state so we can force overrides of gl state
	        for (var i = 0; i < this.activeState.length; ++i) {
	            this.activeState[i] = 32;
	        }

	        this.gl.pixelStorei(this.gl.UNPACK_FLIP_Y_WEBGL, false);

	        this.setState(this.defaultState);
	    };

	    return WebGLState;
	}();

	exports.default = WebGLState;
	//# sourceMappingURL=WebGLState.js.map

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;
	exports.default = mapWebGLBlendModesToPixi;

	var _const = __webpack_require__(174);

	/**
	 * Maps gl blend combinations to WebGL.
	 *
	 * @memberof PIXI
	 * @function mapWebGLBlendModesToPixi
	 * @private
	 * @param {WebGLRenderingContext} gl - The rendering context.
	 * @param {string[]} [array=[]] - The array to output into.
	 * @return {string[]} Mapped modes.
	 */
	function mapWebGLBlendModesToPixi(gl) {
	    var array = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

	    // TODO - premultiply alpha would be different.
	    // add a boolean for that!
	    array[_const.BLEND_MODES.NORMAL] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[_const.BLEND_MODES.ADD] = [gl.ONE, gl.DST_ALPHA];
	    array[_const.BLEND_MODES.MULTIPLY] = [gl.DST_COLOR, gl.ONE_MINUS_SRC_ALPHA];
	    array[_const.BLEND_MODES.SCREEN] = [gl.ONE, gl.ONE_MINUS_SRC_COLOR];
	    array[_const.BLEND_MODES.OVERLAY] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[_const.BLEND_MODES.DARKEN] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[_const.BLEND_MODES.LIGHTEN] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[_const.BLEND_MODES.COLOR_DODGE] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[_const.BLEND_MODES.COLOR_BURN] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[_const.BLEND_MODES.HARD_LIGHT] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[_const.BLEND_MODES.SOFT_LIGHT] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[_const.BLEND_MODES.DIFFERENCE] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[_const.BLEND_MODES.EXCLUSION] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[_const.BLEND_MODES.HUE] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[_const.BLEND_MODES.SATURATION] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[_const.BLEND_MODES.COLOR] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[_const.BLEND_MODES.LUMINOSITY] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];

	    // not-premultiplied blend modes
	    array[_const.BLEND_MODES.NORMAL_NPM] = [gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[_const.BLEND_MODES.ADD_NPM] = [gl.SRC_ALPHA, gl.DST_ALPHA, gl.ONE, gl.DST_ALPHA];
	    array[_const.BLEND_MODES.SCREEN_NPM] = [gl.SRC_ALPHA, gl.ONE_MINUS_SRC_COLOR, gl.ONE, gl.ONE_MINUS_SRC_COLOR];

	    return array;
	}
	//# sourceMappingURL=mapWebGLBlendModesToPixi.js.map

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;
	exports.default = mapWebGLDrawModesToPixi;

	var _const = __webpack_require__(174);

	/**
	 * Generic Mask Stack data structure.
	 *
	 * @memberof PIXI
	 * @function mapWebGLDrawModesToPixi
	 * @private
	 * @param {WebGLRenderingContext} gl - The current WebGL drawing context
	 * @param {object} [object={}] - The object to map into
	 * @return {object} The mapped draw modes.
	 */
	function mapWebGLDrawModesToPixi(gl) {
	  var object = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	  object[_const.DRAW_MODES.POINTS] = gl.POINTS;
	  object[_const.DRAW_MODES.LINES] = gl.LINES;
	  object[_const.DRAW_MODES.LINE_LOOP] = gl.LINE_LOOP;
	  object[_const.DRAW_MODES.LINE_STRIP] = gl.LINE_STRIP;
	  object[_const.DRAW_MODES.TRIANGLES] = gl.TRIANGLES;
	  object[_const.DRAW_MODES.TRIANGLE_STRIP] = gl.TRIANGLE_STRIP;
	  object[_const.DRAW_MODES.TRIANGLE_FAN] = gl.TRIANGLE_FAN;

	  return object;
	}
	//# sourceMappingURL=mapWebGLDrawModesToPixi.js.map

/***/ }),
/* 269 */
/***/ (function(module, exports) {

	'use strict';

	exports.__esModule = true;
	exports.default = validateContext;
	function validateContext(gl) {
	    var attributes = gl.getContextAttributes();

	    // this is going to be fairly simple for now.. but at least we have room to grow!
	    if (!attributes.stencil) {
	        /* eslint-disable no-console */
	        console.warn('Provided WebGL context does not have a stencil buffer, masks may not render correctly');
	        /* eslint-enable no-console */
	    }
	}
	//# sourceMappingURL=validateContext.js.map

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;
	exports.default = generateMultiTextureShader;

	var _Shader = __webpack_require__(262);

	var _Shader2 = _interopRequireDefault(_Shader);

	var _path = __webpack_require__(252);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var fragTemplate = ['varying vec2 vTextureCoord;', 'varying vec4 vColor;', 'varying float vTextureId;', 'uniform sampler2D uSamplers[%count%];', 'void main(void){', 'vec4 color;', 'float textureId = floor(vTextureId+0.5);', '%forloop%', 'gl_FragColor = color * vColor;', '}'].join('\n');

	function generateMultiTextureShader(gl, maxTextures) {
	    var vertexSrc = 'precision highp float;\nattribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\nattribute vec4 aColor;\nattribute float aTextureId;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\nvarying vec4 vColor;\nvarying float vTextureId;\n\nvoid main(void){\n    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = aTextureCoord;\n    vTextureId = aTextureId;\n    vColor = aColor;\n}\n';
	    var fragmentSrc = fragTemplate;

	    fragmentSrc = fragmentSrc.replace(/%count%/gi, maxTextures);
	    fragmentSrc = fragmentSrc.replace(/%forloop%/gi, generateSampleSrc(maxTextures));

	    var shader = new _Shader2.default(gl, vertexSrc, fragmentSrc);

	    var sampleValues = [];

	    for (var i = 0; i < maxTextures; i++) {
	        sampleValues[i] = i;
	    }

	    shader.bind();
	    shader.uniforms.uSamplers = sampleValues;

	    return shader;
	}

	function generateSampleSrc(maxTextures) {
	    var src = '';

	    src += '\n';
	    src += '\n';

	    for (var i = 0; i < maxTextures; i++) {
	        if (i > 0) {
	            src += '\nelse ';
	        }

	        if (i < maxTextures - 1) {
	            src += 'if(textureId == ' + i + '.0)';
	        }

	        src += '\n{';
	        src += '\n\tcolor = texture2D(uSamplers[' + i + '], vTextureCoord);';
	        src += '\n}';
	    }

	    src += '\n';
	    src += '\n';

	    return src;
	}
	//# sourceMappingURL=generateMultiTextureShader.js.map

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;
	exports.default = checkMaxIfStatmentsInShader;

	var _pixiGlCore = __webpack_require__(185);

	var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var fragTemplate = ['precision mediump float;', 'void main(void){', 'float test = 0.1;', '%forloop%', 'gl_FragColor = vec4(0.0);', '}'].join('\n');

	function checkMaxIfStatmentsInShader(maxIfs, gl) {
	    var createTempContext = !gl;

	    // @if DEBUG
	    if (maxIfs === 0) {
	        throw new Error('Invalid value of `0` passed to `checkMaxIfStatementsInShader`');
	    }
	    // @endif

	    if (createTempContext) {
	        var tinyCanvas = document.createElement('canvas');

	        tinyCanvas.width = 1;
	        tinyCanvas.height = 1;

	        gl = _pixiGlCore2.default.createContext(tinyCanvas);
	    }

	    var shader = gl.createShader(gl.FRAGMENT_SHADER);

	    while (true) // eslint-disable-line no-constant-condition
	    {
	        var fragmentSrc = fragTemplate.replace(/%forloop%/gi, generateIfTestSrc(maxIfs));

	        gl.shaderSource(shader, fragmentSrc);
	        gl.compileShader(shader);

	        if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
	            maxIfs = maxIfs / 2 | 0;
	        } else {
	            // valid!
	            break;
	        }
	    }

	    if (createTempContext) {
	        // get rid of context
	        if (gl.getExtension('WEBGL_lose_context')) {
	            gl.getExtension('WEBGL_lose_context').loseContext();
	        }
	    }

	    return maxIfs;
	}

	function generateIfTestSrc(maxIfs) {
	    var src = '';

	    for (var i = 0; i < maxIfs; ++i) {
	        if (i > 0) {
	            src += '\nelse ';
	        }

	        if (i < maxIfs - 1) {
	            src += 'if(test == ' + i + '.0){}';
	        }
	    }

	    return src;
	}
	//# sourceMappingURL=checkMaxIfStatmentsInShader.js.map

/***/ }),
/* 272 */
/***/ (function(module, exports) {

	"use strict";

	exports.__esModule = true;

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/**
	 * @class
	 * @memberof PIXI
	 */
	var Buffer = function () {
	  /**
	   * @param {number} size - The size of the buffer in bytes.
	   */
	  function Buffer(size) {
	    _classCallCheck(this, Buffer);

	    this.vertices = new ArrayBuffer(size);

	    /**
	     * View on the vertices as a Float32Array for positions
	     *
	     * @member {Float32Array}
	     */
	    this.float32View = new Float32Array(this.vertices);

	    /**
	     * View on the vertices as a Uint32Array for uvs
	     *
	     * @member {Float32Array}
	     */
	    this.uint32View = new Uint32Array(this.vertices);
	  }

	  /**
	   * Destroys the buffer.
	   *
	   */


	  Buffer.prototype.destroy = function destroy() {
	    this.vertices = null;
	    this.positions = null;
	    this.uvs = null;
	    this.colors = null;
	  };

	  return Buffer;
	}();

	exports.default = Buffer;
	//# sourceMappingURL=BatchBuffer.js.map

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _Sprite2 = __webpack_require__(219);

	var _Sprite3 = _interopRequireDefault(_Sprite2);

	var _Texture = __webpack_require__(220);

	var _Texture2 = _interopRequireDefault(_Texture);

	var _math = __webpack_require__(175);

	var _utils = __webpack_require__(213);

	var _const = __webpack_require__(174);

	var _settings = __webpack_require__(205);

	var _settings2 = _interopRequireDefault(_settings);

	var _TextStyle = __webpack_require__(274);

	var _TextStyle2 = _interopRequireDefault(_TextStyle);

	var _TextMetrics = __webpack_require__(275);

	var _TextMetrics2 = _interopRequireDefault(_TextMetrics);

	var _trimCanvas = __webpack_require__(276);

	var _trimCanvas2 = _interopRequireDefault(_trimCanvas);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint max-depth: [2, 8] */


	var defaultDestroyOptions = {
	    texture: true,
	    children: false,
	    baseTexture: true
	};

	/**
	 * A Text Object will create a line or multiple lines of text. To split a line you can use '\n' in your text string,
	 * or add a wordWrap property set to true and and wordWrapWidth property with a value in the style object.
	 *
	 * A Text can be created directly from a string and a style object,
	 * which can be generated [here](https://pixijs.io/pixi-text-style).
	 *
	 * ```js
	 * let text = new PIXI.Text('This is a PixiJS text',{fontFamily : 'Arial', fontSize: 24, fill : 0xff1010, align : 'center'});
	 * ```
	 *
	 * @class
	 * @extends PIXI.Sprite
	 * @memberof PIXI
	 */

	var Text = function (_Sprite) {
	    _inherits(Text, _Sprite);

	    /**
	     * @param {string} text - The string that you would like the text to display
	     * @param {object|PIXI.TextStyle} [style] - The style parameters
	     * @param {HTMLCanvasElement} [canvas] - The canvas element for drawing text
	     */
	    function Text(text, style, canvas) {
	        _classCallCheck(this, Text);

	        canvas = canvas || document.createElement('canvas');

	        canvas.width = 3;
	        canvas.height = 3;

	        var texture = _Texture2.default.fromCanvas(canvas, _settings2.default.SCALE_MODE, 'text');

	        texture.orig = new _math.Rectangle();
	        texture.trim = new _math.Rectangle();

	        // base texture is already automatically added to the cache, now adding the actual texture
	        var _this = _possibleConstructorReturn(this, _Sprite.call(this, texture));

	        _Texture2.default.addToCache(_this._texture, _this._texture.baseTexture.textureCacheIds[0]);

	        /**
	         * The canvas element that everything is drawn to
	         *
	         * @member {HTMLCanvasElement}
	         */
	        _this.canvas = canvas;

	        /**
	         * The canvas 2d context that everything is drawn with
	         * @member {CanvasRenderingContext2D}
	         */
	        _this.context = _this.canvas.getContext('2d');

	        /**
	         * The resolution / device pixel ratio of the canvas. This is set automatically by the renderer.
	         * @member {number}
	         * @default 1
	         */
	        _this.resolution = _settings2.default.RESOLUTION;

	        /**
	         * Private tracker for the current text.
	         *
	         * @member {string}
	         * @private
	         */
	        _this._text = null;

	        /**
	         * Private tracker for the current style.
	         *
	         * @member {object}
	         * @private
	         */
	        _this._style = null;
	        /**
	         * Private listener to track style changes.
	         *
	         * @member {Function}
	         * @private
	         */
	        _this._styleListener = null;

	        /**
	         * Private tracker for the current font.
	         *
	         * @member {string}
	         * @private
	         */
	        _this._font = '';

	        _this.text = text;
	        _this.style = style;

	        _this.localStyleID = -1;
	        return _this;
	    }

	    /**
	     * Renders text and updates it when needed.
	     *
	     * @private
	     * @param {boolean} respectDirty - Whether to abort updating the text if the Text isn't dirty and the function is called.
	     */


	    Text.prototype.updateText = function updateText(respectDirty) {
	        var style = this._style;

	        // check if style has changed..
	        if (this.localStyleID !== style.styleID) {
	            this.dirty = true;
	            this.localStyleID = style.styleID;
	        }

	        if (!this.dirty && respectDirty) {
	            return;
	        }

	        this._font = this._style.toFontString();

	        var context = this.context;
	        var measured = _TextMetrics2.default.measureText(this._text, this._style, this._style.wordWrap, this.canvas);
	        var width = measured.width;
	        var height = measured.height;
	        var lines = measured.lines;
	        var lineHeight = measured.lineHeight;
	        var lineWidths = measured.lineWidths;
	        var maxLineWidth = measured.maxLineWidth;
	        var fontProperties = measured.fontProperties;

	        this.canvas.width = Math.ceil((Math.max(1, width) + style.padding * 2) * this.resolution);
	        this.canvas.height = Math.ceil((Math.max(1, height) + style.padding * 2) * this.resolution);

	        context.scale(this.resolution, this.resolution);

	        context.clearRect(0, 0, this.canvas.width, this.canvas.height);

	        context.font = this._font;
	        context.strokeStyle = style.stroke;
	        context.lineWidth = style.strokeThickness;
	        context.textBaseline = style.textBaseline;
	        context.lineJoin = style.lineJoin;
	        context.miterLimit = style.miterLimit;

	        var linePositionX = void 0;
	        var linePositionY = void 0;

	        if (style.dropShadow) {
	            context.fillStyle = style.dropShadowColor;
	            context.globalAlpha = style.dropShadowAlpha;
	            context.shadowBlur = style.dropShadowBlur;

	            if (style.dropShadowBlur > 0) {
	                context.shadowColor = style.dropShadowColor;
	            }

	            var xShadowOffset = Math.cos(style.dropShadowAngle) * style.dropShadowDistance;
	            var yShadowOffset = Math.sin(style.dropShadowAngle) * style.dropShadowDistance;

	            for (var i = 0; i < lines.length; i++) {
	                linePositionX = style.strokeThickness / 2;
	                linePositionY = style.strokeThickness / 2 + i * lineHeight + fontProperties.ascent;

	                if (style.align === 'right') {
	                    linePositionX += maxLineWidth - lineWidths[i];
	                } else if (style.align === 'center') {
	                    linePositionX += (maxLineWidth - lineWidths[i]) / 2;
	                }

	                if (style.fill) {
	                    this.drawLetterSpacing(lines[i], linePositionX + xShadowOffset + style.padding, linePositionY + yShadowOffset + style.padding);

	                    if (style.stroke && style.strokeThickness) {
	                        context.strokeStyle = style.dropShadowColor;
	                        this.drawLetterSpacing(lines[i], linePositionX + xShadowOffset + style.padding, linePositionY + yShadowOffset + style.padding, true);
	                        context.strokeStyle = style.stroke;
	                    }
	                }
	            }
	        }

	        // reset the shadow blur and alpha that was set by the drop shadow, for the regular text
	        context.shadowBlur = 0;
	        context.globalAlpha = 1;

	        // set canvas text styles
	        context.fillStyle = this._generateFillStyle(style, lines);

	        // draw lines line by line
	        for (var _i = 0; _i < lines.length; _i++) {
	            linePositionX = style.strokeThickness / 2;
	            linePositionY = style.strokeThickness / 2 + _i * lineHeight + fontProperties.ascent;

	            if (style.align === 'right') {
	                linePositionX += maxLineWidth - lineWidths[_i];
	            } else if (style.align === 'center') {
	                linePositionX += (maxLineWidth - lineWidths[_i]) / 2;
	            }

	            if (style.stroke && style.strokeThickness) {
	                this.drawLetterSpacing(lines[_i], linePositionX + style.padding, linePositionY + style.padding, true);
	            }

	            if (style.fill) {
	                this.drawLetterSpacing(lines[_i], linePositionX + style.padding, linePositionY + style.padding);
	            }
	        }

	        this.updateTexture();
	    };

	    /**
	     * Render the text with letter-spacing.
	     * @param {string} text - The text to draw
	     * @param {number} x - Horizontal position to draw the text
	     * @param {number} y - Vertical position to draw the text
	     * @param {boolean} [isStroke=false] - Is this drawing for the outside stroke of the
	     *  text? If not, it's for the inside fill
	     * @private
	     */


	    Text.prototype.drawLetterSpacing = function drawLetterSpacing(text, x, y) {
	        var isStroke = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

	        var style = this._style;

	        // letterSpacing of 0 means normal
	        var letterSpacing = style.letterSpacing;

	        if (letterSpacing === 0) {
	            if (isStroke) {
	                this.context.strokeText(text, x, y);
	            } else {
	                this.context.fillText(text, x, y);
	            }

	            return;
	        }

	        var characters = String.prototype.split.call(text, '');
	        var currentPosition = x;
	        var index = 0;
	        var current = '';

	        while (index < text.length) {
	            current = characters[index++];
	            if (isStroke) {
	                this.context.strokeText(current, currentPosition, y);
	            } else {
	                this.context.fillText(current, currentPosition, y);
	            }
	            currentPosition += this.context.measureText(current).width + letterSpacing;
	        }
	    };

	    /**
	     * Updates texture size based on canvas size
	     *
	     * @private
	     */


	    Text.prototype.updateTexture = function updateTexture() {
	        var canvas = this.canvas;

	        if (this._style.trim) {
	            var trimmed = (0, _trimCanvas2.default)(canvas);

	            if (trimmed.data) {
	                canvas.width = trimmed.width;
	                canvas.height = trimmed.height;
	                this.context.putImageData(trimmed.data, 0, 0);
	            }
	        }

	        var texture = this._texture;
	        var style = this._style;
	        var padding = style.trim ? 0 : style.padding;
	        var baseTexture = texture.baseTexture;

	        baseTexture.hasLoaded = true;
	        baseTexture.resolution = this.resolution;

	        baseTexture.realWidth = canvas.width;
	        baseTexture.realHeight = canvas.height;
	        baseTexture.width = canvas.width / this.resolution;
	        baseTexture.height = canvas.height / this.resolution;

	        texture.trim.width = texture._frame.width = canvas.width / this.resolution;
	        texture.trim.height = texture._frame.height = canvas.height / this.resolution;
	        texture.trim.x = -padding;
	        texture.trim.y = -padding;

	        texture.orig.width = texture._frame.width - padding * 2;
	        texture.orig.height = texture._frame.height - padding * 2;

	        // call sprite onTextureUpdate to update scale if _width or _height were set
	        this._onTextureUpdate();

	        baseTexture.emit('update', baseTexture);

	        this.dirty = false;
	    };

	    /**
	     * Renders the object using the WebGL renderer
	     *
	     * @param {PIXI.WebGLRenderer} renderer - The renderer
	     */


	    Text.prototype.renderWebGL = function renderWebGL(renderer) {
	        if (this.resolution !== renderer.resolution) {
	            this.resolution = renderer.resolution;
	            this.dirty = true;
	        }

	        this.updateText(true);

	        _Sprite.prototype.renderWebGL.call(this, renderer);
	    };

	    /**
	     * Renders the object using the Canvas renderer
	     *
	     * @private
	     * @param {PIXI.CanvasRenderer} renderer - The renderer
	     */


	    Text.prototype._renderCanvas = function _renderCanvas(renderer) {
	        if (this.resolution !== renderer.resolution) {
	            this.resolution = renderer.resolution;
	            this.dirty = true;
	        }

	        this.updateText(true);

	        _Sprite.prototype._renderCanvas.call(this, renderer);
	    };

	    /**
	     * Gets the local bounds of the text object.
	     *
	     * @param {Rectangle} rect - The output rectangle.
	     * @return {Rectangle} The bounds.
	     */


	    Text.prototype.getLocalBounds = function getLocalBounds(rect) {
	        this.updateText(true);

	        return _Sprite.prototype.getLocalBounds.call(this, rect);
	    };

	    /**
	     * calculates the bounds of the Text as a rectangle. The bounds calculation takes the worldTransform into account.
	     */


	    Text.prototype._calculateBounds = function _calculateBounds() {
	        this.updateText(true);
	        this.calculateVertices();
	        // if we have already done this on THIS frame.
	        this._bounds.addQuad(this.vertexData);
	    };

	    /**
	     * Method to be called upon a TextStyle change.
	     * @private
	     */


	    Text.prototype._onStyleChange = function _onStyleChange() {
	        this.dirty = true;
	    };

	    /**
	     * Generates the fill style. Can automatically generate a gradient based on the fill style being an array
	     *
	     * @private
	     * @param {object} style - The style.
	     * @param {string[]} lines - The lines of text.
	     * @return {string|number|CanvasGradient} The fill style
	     */


	    Text.prototype._generateFillStyle = function _generateFillStyle(style, lines) {
	        if (!Array.isArray(style.fill)) {
	            return style.fill;
	        }

	        // cocoon on canvas+ cannot generate textures, so use the first colour instead
	        if (navigator.isCocoonJS) {
	            return style.fill[0];
	        }

	        // the gradient will be evenly spaced out according to how large the array is.
	        // ['#FF0000', '#00FF00', '#0000FF'] would created stops at 0.25, 0.5 and 0.75
	        var gradient = void 0;
	        var totalIterations = void 0;
	        var currentIteration = void 0;
	        var stop = void 0;

	        var width = this.canvas.width / this.resolution;
	        var height = this.canvas.height / this.resolution;

	        // make a copy of the style settings, so we can manipulate them later
	        var fill = style.fill.slice();
	        var fillGradientStops = style.fillGradientStops.slice();

	        // wanting to evenly distribute the fills. So an array of 4 colours should give fills of 0.25, 0.5 and 0.75
	        if (!fillGradientStops.length) {
	            var lengthPlus1 = fill.length + 1;

	            for (var i = 1; i < lengthPlus1; ++i) {
	                fillGradientStops.push(i / lengthPlus1);
	            }
	        }

	        // stop the bleeding of the last gradient on the line above to the top gradient of the this line
	        // by hard defining the first gradient colour at point 0, and last gradient colour at point 1
	        fill.unshift(style.fill[0]);
	        fillGradientStops.unshift(0);

	        fill.push(style.fill[style.fill.length - 1]);
	        fillGradientStops.push(1);

	        if (style.fillGradientType === _const.TEXT_GRADIENT.LINEAR_VERTICAL) {
	            // start the gradient at the top center of the canvas, and end at the bottom middle of the canvas
	            gradient = this.context.createLinearGradient(width / 2, 0, width / 2, height);

	            // we need to repeat the gradient so that each individual line of text has the same vertical gradient effect
	            // ['#FF0000', '#00FF00', '#0000FF'] over 2 lines would create stops at 0.125, 0.25, 0.375, 0.625, 0.75, 0.875
	            totalIterations = (fill.length + 1) * lines.length;
	            currentIteration = 0;
	            for (var _i2 = 0; _i2 < lines.length; _i2++) {
	                currentIteration += 1;
	                for (var j = 0; j < fill.length; j++) {
	                    if (typeof fillGradientStops[j] === 'number') {
	                        stop = fillGradientStops[j] / lines.length + _i2 / lines.length;
	                    } else {
	                        stop = currentIteration / totalIterations;
	                    }
	                    gradient.addColorStop(stop, fill[j]);
	                    currentIteration++;
	                }
	            }
	        } else {
	            // start the gradient at the center left of the canvas, and end at the center right of the canvas
	            gradient = this.context.createLinearGradient(0, height / 2, width, height / 2);

	            // can just evenly space out the gradients in this case, as multiple lines makes no difference
	            // to an even left to right gradient
	            totalIterations = fill.length + 1;
	            currentIteration = 1;

	            for (var _i3 = 0; _i3 < fill.length; _i3++) {
	                if (typeof fillGradientStops[_i3] === 'number') {
	                    stop = fillGradientStops[_i3];
	                } else {
	                    stop = currentIteration / totalIterations;
	                }
	                gradient.addColorStop(stop, fill[_i3]);
	                currentIteration++;
	            }
	        }

	        return gradient;
	    };

	    /**
	     * Destroys this text object.
	     * Note* Unlike a Sprite, a Text object will automatically destroy its baseTexture and texture as
	     * the majority of the time the texture will not be shared with any other Sprites.
	     *
	     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
	     *  have been set to that value
	     * @param {boolean} [options.children=false] - if set to true, all the children will have their
	     *  destroy method called as well. 'options' will be passed on to those calls.
	     * @param {boolean} [options.texture=true] - Should it destroy the current texture of the sprite as well
	     * @param {boolean} [options.baseTexture=true] - Should it destroy the base texture of the sprite as well
	     */


	    Text.prototype.destroy = function destroy(options) {
	        if (typeof options === 'boolean') {
	            options = { children: options };
	        }

	        options = Object.assign({}, defaultDestroyOptions, options);

	        _Sprite.prototype.destroy.call(this, options);

	        // make sure to reset the the context and canvas.. dont want this hanging around in memory!
	        this.context = null;
	        this.canvas = null;

	        this._style = null;
	    };

	    /**
	     * The width of the Text, setting this will actually modify the scale to achieve the value set
	     *
	     * @member {number}
	     */


	    _createClass(Text, [{
	        key: 'width',
	        get: function get() {
	            this.updateText(true);

	            return Math.abs(this.scale.x) * this._texture.orig.width;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.updateText(true);

	            var s = (0, _utils.sign)(this.scale.x) || 1;

	            this.scale.x = s * value / this._texture.orig.width;
	            this._width = value;
	        }

	        /**
	         * The height of the Text, setting this will actually modify the scale to achieve the value set
	         *
	         * @member {number}
	         */

	    }, {
	        key: 'height',
	        get: function get() {
	            this.updateText(true);

	            return Math.abs(this.scale.y) * this._texture.orig.height;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.updateText(true);

	            var s = (0, _utils.sign)(this.scale.y) || 1;

	            this.scale.y = s * value / this._texture.orig.height;
	            this._height = value;
	        }

	        /**
	         * Set the style of the text. Set up an event listener to listen for changes on the style
	         * object and mark the text as dirty.
	         *
	         * @member {object|PIXI.TextStyle}
	         */

	    }, {
	        key: 'style',
	        get: function get() {
	            return this._style;
	        },
	        set: function set(style) // eslint-disable-line require-jsdoc
	        {
	            style = style || {};

	            if (style instanceof _TextStyle2.default) {
	                this._style = style;
	            } else {
	                this._style = new _TextStyle2.default(style);
	            }

	            this.localStyleID = -1;
	            this.dirty = true;
	        }

	        /**
	         * Set the copy for the text object. To split a line you can use '\n'.
	         *
	         * @member {string}
	         */

	    }, {
	        key: 'text',
	        get: function get() {
	            return this._text;
	        },
	        set: function set(text) // eslint-disable-line require-jsdoc
	        {
	            text = String(text === '' || text === null || text === undefined ? ' ' : text);

	            if (this._text === text) {
	                return;
	            }
	            this._text = text;
	            this.dirty = true;
	        }
	    }]);

	    return Text;
	}(_Sprite3.default);

	exports.default = Text;
	//# sourceMappingURL=Text.js.map

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // disabling eslint for now, going to rewrite this in v5
	/* eslint-disable */

	var _const = __webpack_require__(174);

	var _utils = __webpack_require__(213);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var defaultStyle = {
	    align: 'left',
	    breakWords: false,
	    dropShadow: false,
	    dropShadowAlpha: 1,
	    dropShadowAngle: Math.PI / 6,
	    dropShadowBlur: 0,
	    dropShadowColor: 'black',
	    dropShadowDistance: 5,
	    fill: 'black',
	    fillGradientType: _const.TEXT_GRADIENT.LINEAR_VERTICAL,
	    fillGradientStops: [],
	    fontFamily: 'Arial',
	    fontSize: 26,
	    fontStyle: 'normal',
	    fontVariant: 'normal',
	    fontWeight: 'normal',
	    letterSpacing: 0,
	    lineHeight: 0,
	    lineJoin: 'miter',
	    miterLimit: 10,
	    padding: 0,
	    stroke: 'black',
	    strokeThickness: 0,
	    textBaseline: 'alphabetic',
	    trim: false,
	    whiteSpace: 'pre',
	    wordWrap: false,
	    wordWrapWidth: 100,
	    leading: 0
	};

	var genericFontFamilies = ['serif', 'sans-serif', 'monospace', 'cursive', 'fantasy', 'system-ui'];

	/**
	 * A TextStyle Object decorates a Text Object. It can be shared between
	 * multiple Text objects. Changing the style will update all text objects using it.
	 * It can be generated [here](https://pixijs.io/pixi-text-style).
	 *
	 * @class
	 * @memberof PIXI
	 */

	var TextStyle = function () {
	    /**
	     * @param {object} [style] - The style parameters
	     * @param {string} [style.align='left'] - Alignment for multiline text ('left', 'center' or 'right'),
	     *  does not affect single line text
	     * @param {boolean} [style.breakWords=false] - Indicates if lines can be wrapped within words, it
	     *  needs wordWrap to be set to true
	     * @param {boolean} [style.dropShadow=false] - Set a drop shadow for the text
	     * @param {number} [style.dropShadowAlpha=1] - Set alpha for the drop shadow
	     * @param {number} [style.dropShadowAngle=Math.PI/6] - Set a angle of the drop shadow
	     * @param {number} [style.dropShadowBlur=0] - Set a shadow blur radius
	     * @param {string|number} [style.dropShadowColor='black'] - A fill style to be used on the dropshadow e.g 'red', '#00FF00'
	     * @param {number} [style.dropShadowDistance=5] - Set a distance of the drop shadow
	     * @param {string|string[]|number|number[]|CanvasGradient|CanvasPattern} [style.fill='black'] - A canvas
	     *  fillstyle that will be used on the text e.g 'red', '#00FF00'. Can be an array to create a gradient
	     *  eg ['#000000','#FFFFFF']
	     * {@link https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/fillStyle|MDN}
	     * @param {number} [style.fillGradientType=PIXI.TEXT_GRADIENT.LINEAR_VERTICAL] - If fill is an array of colours
	     *  to create a gradient, this can change the type/direction of the gradient. See {@link PIXI.TEXT_GRADIENT}
	     * @param {number[]} [style.fillGradientStops] - If fill is an array of colours to create a gradient, this array can set
	     * the stop points (numbers between 0 and 1) for the color, overriding the default behaviour of evenly spacing them.
	     * @param {string|string[]} [style.fontFamily='Arial'] - The font family
	     * @param {number|string} [style.fontSize=26] - The font size (as a number it converts to px, but as a string,
	     *  equivalents are '26px','20pt','160%' or '1.6em')
	     * @param {string} [style.fontStyle='normal'] - The font style ('normal', 'italic' or 'oblique')
	     * @param {string} [style.fontVariant='normal'] - The font variant ('normal' or 'small-caps')
	     * @param {string} [style.fontWeight='normal'] - The font weight ('normal', 'bold', 'bolder', 'lighter' and '100',
	     *  '200', '300', '400', '500', '600', '700', 800' or '900')
	     * @param {number} [style.leading=0] - The space between lines
	     * @param {number} [style.letterSpacing=0] - The amount of spacing between letters, default is 0
	     * @param {number} [style.lineHeight] - The line height, a number that represents the vertical space that a letter uses
	     * @param {string} [style.lineJoin='miter'] - The lineJoin property sets the type of corner created, it can resolve
	     *      spiked text issues. Possible values "miter" (creates a sharp corner), "round" (creates a round corner) or "bevel"
	     *      (creates a squared corner).
	     * @param {number} [style.miterLimit=10] - The miter limit to use when using the 'miter' lineJoin mode. This can reduce
	     *      or increase the spikiness of rendered text.
	     * @param {number} [style.padding=0] - Occasionally some fonts are cropped. Adding some padding will prevent this from
	     *     happening by adding padding to all sides of the text.
	     * @param {string|number} [style.stroke='black'] - A canvas fillstyle that will be used on the text stroke
	     *  e.g 'blue', '#FCFF00'
	     * @param {number} [style.strokeThickness=0] - A number that represents the thickness of the stroke.
	     *  Default is 0 (no stroke)
	     * @param {boolean} [style.trim=false] - Trim transparent borders
	     * @param {string} [style.textBaseline='alphabetic'] - The baseline of the text that is rendered.
	     * @param {boolean} [style.whiteSpace='pre'] - Determines whether newlines & spaces are collapsed or preserved "normal"
	     *      (collapse, collapse), "pre" (preserve, preserve) | "pre-line" (preserve, collapse). It needs wordWrap to be set to true
	     * @param {boolean} [style.wordWrap=false] - Indicates if word wrap should be used
	     * @param {number} [style.wordWrapWidth=100] - The width at which text will wrap, it needs wordWrap to be set to true
	     */
	    function TextStyle(style) {
	        _classCallCheck(this, TextStyle);

	        this.styleID = 0;

	        this.reset();

	        deepCopyProperties(this, style, style);
	    }

	    /**
	     * Creates a new TextStyle object with the same values as this one.
	     * Note that the only the properties of the object are cloned.
	     *
	     * @return {PIXI.TextStyle} New cloned TextStyle object
	     */


	    TextStyle.prototype.clone = function clone() {
	        var clonedProperties = {};

	        deepCopyProperties(clonedProperties, this, defaultStyle);

	        return new TextStyle(clonedProperties);
	    };

	    /**
	     * Resets all properties to the defaults specified in TextStyle.prototype._default
	     */


	    TextStyle.prototype.reset = function reset() {
	        deepCopyProperties(this, defaultStyle, defaultStyle);
	    };

	    /**
	     * Alignment for multiline text ('left', 'center' or 'right'), does not affect single line text
	     *
	     * @member {string}
	     */


	    /**
	     * Generates a font style string to use for `TextMetrics.measureFont()`.
	     *
	     * @return {string} Font style string, for passing to `TextMetrics.measureFont()`
	     */
	    TextStyle.prototype.toFontString = function toFontString() {
	        // build canvas api font setting from individual components. Convert a numeric this.fontSize to px
	        var fontSizeString = typeof this.fontSize === 'number' ? this.fontSize + 'px' : this.fontSize;

	        // Clean-up fontFamily property by quoting each font name
	        // this will support font names with spaces
	        var fontFamilies = this.fontFamily;

	        if (!Array.isArray(this.fontFamily)) {
	            fontFamilies = this.fontFamily.split(',');
	        }

	        for (var i = fontFamilies.length - 1; i >= 0; i--) {
	            // Trim any extra white-space
	            var fontFamily = fontFamilies[i].trim();

	            // Check if font is already escaped in quotes except for CSS generic fonts
	            if (!/([\"\'])[^\'\"]+\1/.test(fontFamily) && genericFontFamilies.indexOf(fontFamily) < 0) {
	                fontFamily = '"' + fontFamily + '"';
	            }
	            fontFamilies[i] = fontFamily;
	        }

	        return this.fontStyle + ' ' + this.fontVariant + ' ' + this.fontWeight + ' ' + fontSizeString + ' ' + fontFamilies.join(',');
	    };

	    _createClass(TextStyle, [{
	        key: 'align',
	        get: function get() {
	            return this._align;
	        },
	        set: function set(align) // eslint-disable-line require-jsdoc
	        {
	            if (this._align !== align) {
	                this._align = align;
	                this.styleID++;
	            }
	        }

	        /**
	         * Indicates if lines can be wrapped within words, it needs wordWrap to be set to true
	         *
	         * @member {boolean}
	         */

	    }, {
	        key: 'breakWords',
	        get: function get() {
	            return this._breakWords;
	        },
	        set: function set(breakWords) // eslint-disable-line require-jsdoc
	        {
	            if (this._breakWords !== breakWords) {
	                this._breakWords = breakWords;
	                this.styleID++;
	            }
	        }

	        /**
	         * Set a drop shadow for the text
	         *
	         * @member {boolean}
	         */

	    }, {
	        key: 'dropShadow',
	        get: function get() {
	            return this._dropShadow;
	        },
	        set: function set(dropShadow) // eslint-disable-line require-jsdoc
	        {
	            if (this._dropShadow !== dropShadow) {
	                this._dropShadow = dropShadow;
	                this.styleID++;
	            }
	        }

	        /**
	         * Set alpha for the drop shadow
	         *
	         * @member {number}
	         */

	    }, {
	        key: 'dropShadowAlpha',
	        get: function get() {
	            return this._dropShadowAlpha;
	        },
	        set: function set(dropShadowAlpha) // eslint-disable-line require-jsdoc
	        {
	            if (this._dropShadowAlpha !== dropShadowAlpha) {
	                this._dropShadowAlpha = dropShadowAlpha;
	                this.styleID++;
	            }
	        }

	        /**
	         * Set a angle of the drop shadow
	         *
	         * @member {number}
	         */

	    }, {
	        key: 'dropShadowAngle',
	        get: function get() {
	            return this._dropShadowAngle;
	        },
	        set: function set(dropShadowAngle) // eslint-disable-line require-jsdoc
	        {
	            if (this._dropShadowAngle !== dropShadowAngle) {
	                this._dropShadowAngle = dropShadowAngle;
	                this.styleID++;
	            }
	        }

	        /**
	         * Set a shadow blur radius
	         *
	         * @member {number}
	         */

	    }, {
	        key: 'dropShadowBlur',
	        get: function get() {
	            return this._dropShadowBlur;
	        },
	        set: function set(dropShadowBlur) // eslint-disable-line require-jsdoc
	        {
	            if (this._dropShadowBlur !== dropShadowBlur) {
	                this._dropShadowBlur = dropShadowBlur;
	                this.styleID++;
	            }
	        }

	        /**
	         * A fill style to be used on the dropshadow e.g 'red', '#00FF00'
	         *
	         * @member {string|number}
	         */

	    }, {
	        key: 'dropShadowColor',
	        get: function get() {
	            return this._dropShadowColor;
	        },
	        set: function set(dropShadowColor) // eslint-disable-line require-jsdoc
	        {
	            var outputColor = getColor(dropShadowColor);
	            if (this._dropShadowColor !== outputColor) {
	                this._dropShadowColor = outputColor;
	                this.styleID++;
	            }
	        }

	        /**
	         * Set a distance of the drop shadow
	         *
	         * @member {number}
	         */

	    }, {
	        key: 'dropShadowDistance',
	        get: function get() {
	            return this._dropShadowDistance;
	        },
	        set: function set(dropShadowDistance) // eslint-disable-line require-jsdoc
	        {
	            if (this._dropShadowDistance !== dropShadowDistance) {
	                this._dropShadowDistance = dropShadowDistance;
	                this.styleID++;
	            }
	        }

	        /**
	         * A canvas fillstyle that will be used on the text e.g 'red', '#00FF00'.
	         * Can be an array to create a gradient eg ['#000000','#FFFFFF']
	         * {@link https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/fillStyle|MDN}
	         *
	         * @member {string|string[]|number|number[]|CanvasGradient|CanvasPattern}
	         */

	    }, {
	        key: 'fill',
	        get: function get() {
	            return this._fill;
	        },
	        set: function set(fill) // eslint-disable-line require-jsdoc
	        {
	            var outputColor = getColor(fill);
	            if (this._fill !== outputColor) {
	                this._fill = outputColor;
	                this.styleID++;
	            }
	        }

	        /**
	         * If fill is an array of colours to create a gradient, this can change the type/direction of the gradient.
	         * See {@link PIXI.TEXT_GRADIENT}
	         *
	         * @member {number}
	         */

	    }, {
	        key: 'fillGradientType',
	        get: function get() {
	            return this._fillGradientType;
	        },
	        set: function set(fillGradientType) // eslint-disable-line require-jsdoc
	        {
	            if (this._fillGradientType !== fillGradientType) {
	                this._fillGradientType = fillGradientType;
	                this.styleID++;
	            }
	        }

	        /**
	         * If fill is an array of colours to create a gradient, this array can set the stop points
	         * (numbers between 0 and 1) for the color, overriding the default behaviour of evenly spacing them.
	         *
	         * @member {number[]}
	         */

	    }, {
	        key: 'fillGradientStops',
	        get: function get() {
	            return this._fillGradientStops;
	        },
	        set: function set(fillGradientStops) // eslint-disable-line require-jsdoc
	        {
	            if (!areArraysEqual(this._fillGradientStops, fillGradientStops)) {
	                this._fillGradientStops = fillGradientStops;
	                this.styleID++;
	            }
	        }

	        /**
	         * The font family
	         *
	         * @member {string|string[]}
	         */

	    }, {
	        key: 'fontFamily',
	        get: function get() {
	            return this._fontFamily;
	        },
	        set: function set(fontFamily) // eslint-disable-line require-jsdoc
	        {
	            if (this.fontFamily !== fontFamily) {
	                this._fontFamily = fontFamily;
	                this.styleID++;
	            }
	        }

	        /**
	         * The font size
	         * (as a number it converts to px, but as a string, equivalents are '26px','20pt','160%' or '1.6em')
	         *
	         * @member {number|string}
	         */

	    }, {
	        key: 'fontSize',
	        get: function get() {
	            return this._fontSize;
	        },
	        set: function set(fontSize) // eslint-disable-line require-jsdoc
	        {
	            if (this._fontSize !== fontSize) {
	                this._fontSize = fontSize;
	                this.styleID++;
	            }
	        }

	        /**
	         * The font style
	         * ('normal', 'italic' or 'oblique')
	         *
	         * @member {string}
	         */

	    }, {
	        key: 'fontStyle',
	        get: function get() {
	            return this._fontStyle;
	        },
	        set: function set(fontStyle) // eslint-disable-line require-jsdoc
	        {
	            if (this._fontStyle !== fontStyle) {
	                this._fontStyle = fontStyle;
	                this.styleID++;
	            }
	        }

	        /**
	         * The font variant
	         * ('normal' or 'small-caps')
	         *
	         * @member {string}
	         */

	    }, {
	        key: 'fontVariant',
	        get: function get() {
	            return this._fontVariant;
	        },
	        set: function set(fontVariant) // eslint-disable-line require-jsdoc
	        {
	            if (this._fontVariant !== fontVariant) {
	                this._fontVariant = fontVariant;
	                this.styleID++;
	            }
	        }

	        /**
	         * The font weight
	         * ('normal', 'bold', 'bolder', 'lighter' and '100', '200', '300', '400', '500', '600', '700', 800' or '900')
	         *
	         * @member {string}
	         */

	    }, {
	        key: 'fontWeight',
	        get: function get() {
	            return this._fontWeight;
	        },
	        set: function set(fontWeight) // eslint-disable-line require-jsdoc
	        {
	            if (this._fontWeight !== fontWeight) {
	                this._fontWeight = fontWeight;
	                this.styleID++;
	            }
	        }

	        /**
	         * The amount of spacing between letters, default is 0
	         *
	         * @member {number}
	         */

	    }, {
	        key: 'letterSpacing',
	        get: function get() {
	            return this._letterSpacing;
	        },
	        set: function set(letterSpacing) // eslint-disable-line require-jsdoc
	        {
	            if (this._letterSpacing !== letterSpacing) {
	                this._letterSpacing = letterSpacing;
	                this.styleID++;
	            }
	        }

	        /**
	         * The line height, a number that represents the vertical space that a letter uses
	         *
	         * @member {number}
	         */

	    }, {
	        key: 'lineHeight',
	        get: function get() {
	            return this._lineHeight;
	        },
	        set: function set(lineHeight) // eslint-disable-line require-jsdoc
	        {
	            if (this._lineHeight !== lineHeight) {
	                this._lineHeight = lineHeight;
	                this.styleID++;
	            }
	        }

	        /**
	         * The space between lines
	         *
	         * @member {number}
	         */

	    }, {
	        key: 'leading',
	        get: function get() {
	            return this._leading;
	        },
	        set: function set(leading) // eslint-disable-line require-jsdoc
	        {
	            if (this._leading !== leading) {
	                this._leading = leading;
	                this.styleID++;
	            }
	        }

	        /**
	         * The lineJoin property sets the type of corner created, it can resolve spiked text issues.
	         * Default is 'miter' (creates a sharp corner).
	         *
	         * @member {string}
	         */

	    }, {
	        key: 'lineJoin',
	        get: function get() {
	            return this._lineJoin;
	        },
	        set: function set(lineJoin) // eslint-disable-line require-jsdoc
	        {
	            if (this._lineJoin !== lineJoin) {
	                this._lineJoin = lineJoin;
	                this.styleID++;
	            }
	        }

	        /**
	         * The miter limit to use when using the 'miter' lineJoin mode
	         * This can reduce or increase the spikiness of rendered text.
	         *
	         * @member {number}
	         */

	    }, {
	        key: 'miterLimit',
	        get: function get() {
	            return this._miterLimit;
	        },
	        set: function set(miterLimit) // eslint-disable-line require-jsdoc
	        {
	            if (this._miterLimit !== miterLimit) {
	                this._miterLimit = miterLimit;
	                this.styleID++;
	            }
	        }

	        /**
	         * Occasionally some fonts are cropped. Adding some padding will prevent this from happening
	         * by adding padding to all sides of the text.
	         *
	         * @member {number}
	         */

	    }, {
	        key: 'padding',
	        get: function get() {
	            return this._padding;
	        },
	        set: function set(padding) // eslint-disable-line require-jsdoc
	        {
	            if (this._padding !== padding) {
	                this._padding = padding;
	                this.styleID++;
	            }
	        }

	        /**
	         * A canvas fillstyle that will be used on the text stroke
	         * e.g 'blue', '#FCFF00'
	         *
	         * @member {string|number}
	         */

	    }, {
	        key: 'stroke',
	        get: function get() {
	            return this._stroke;
	        },
	        set: function set(stroke) // eslint-disable-line require-jsdoc
	        {
	            var outputColor = getColor(stroke);
	            if (this._stroke !== outputColor) {
	                this._stroke = outputColor;
	                this.styleID++;
	            }
	        }

	        /**
	         * A number that represents the thickness of the stroke.
	         * Default is 0 (no stroke)
	         *
	         * @member {number}
	         */

	    }, {
	        key: 'strokeThickness',
	        get: function get() {
	            return this._strokeThickness;
	        },
	        set: function set(strokeThickness) // eslint-disable-line require-jsdoc
	        {
	            if (this._strokeThickness !== strokeThickness) {
	                this._strokeThickness = strokeThickness;
	                this.styleID++;
	            }
	        }

	        /**
	         * The baseline of the text that is rendered.
	         *
	         * @member {string}
	         */

	    }, {
	        key: 'textBaseline',
	        get: function get() {
	            return this._textBaseline;
	        },
	        set: function set(textBaseline) // eslint-disable-line require-jsdoc
	        {
	            if (this._textBaseline !== textBaseline) {
	                this._textBaseline = textBaseline;
	                this.styleID++;
	            }
	        }

	        /**
	         * Trim transparent borders
	         *
	         * @member {boolean}
	         */

	    }, {
	        key: 'trim',
	        get: function get() {
	            return this._trim;
	        },
	        set: function set(trim) // eslint-disable-line require-jsdoc
	        {
	            if (this._trim !== trim) {
	                this._trim = trim;
	                this.styleID++;
	            }
	        }

	        /**
	         * How newlines and spaces should be handled.
	         * Default is 'pre' (preserve, preserve).
	         *
	         *  value       | New lines     |   Spaces
	         *  ---         | ---           |   ---
	         * 'normal'     | Collapse      |   Collapse
	         * 'pre'        | Preserve      |   Preserve
	         * 'pre-line'   | Preserve      |   Collapse
	         *
	         * @member {string}
	         */

	    }, {
	        key: 'whiteSpace',
	        get: function get() {
	            return this._whiteSpace;
	        },
	        set: function set(whiteSpace) // eslint-disable-line require-jsdoc
	        {
	            if (this._whiteSpace !== whiteSpace) {
	                this._whiteSpace = whiteSpace;
	                this.styleID++;
	            }
	        }

	        /**
	         * Indicates if word wrap should be used
	         *
	         * @member {boolean}
	         */

	    }, {
	        key: 'wordWrap',
	        get: function get() {
	            return this._wordWrap;
	        },
	        set: function set(wordWrap) // eslint-disable-line require-jsdoc
	        {
	            if (this._wordWrap !== wordWrap) {
	                this._wordWrap = wordWrap;
	                this.styleID++;
	            }
	        }

	        /**
	         * The width at which text will wrap, it needs wordWrap to be set to true
	         *
	         * @member {number}
	         */

	    }, {
	        key: 'wordWrapWidth',
	        get: function get() {
	            return this._wordWrapWidth;
	        },
	        set: function set(wordWrapWidth) // eslint-disable-line require-jsdoc
	        {
	            if (this._wordWrapWidth !== wordWrapWidth) {
	                this._wordWrapWidth = wordWrapWidth;
	                this.styleID++;
	            }
	        }
	    }]);

	    return TextStyle;
	}();

	/**
	 * Utility function to convert hexadecimal colors to strings, and simply return the color if it's a string.
	 * @private
	 * @param {number|number[]} color
	 * @return {string} The color as a string.
	 */


	exports.default = TextStyle;
	function getSingleColor(color) {
	    if (typeof color === 'number') {
	        return (0, _utils.hex2string)(color);
	    } else if (typeof color === 'string') {
	        if (color.indexOf('0x') === 0) {
	            color = color.replace('0x', '#');
	        }
	    }

	    return color;
	}

	/**
	 * Utility function to convert hexadecimal colors to strings, and simply return the color if it's a string.
	 * This version can also convert array of colors
	 * @private
	 * @param {number|number[]} color
	 * @return {string} The color as a string.
	 */
	function getColor(color) {
	    if (!Array.isArray(color)) {
	        return getSingleColor(color);
	    } else {
	        for (var i = 0; i < color.length; ++i) {
	            color[i] = getSingleColor(color[i]);
	        }

	        return color;
	    }
	}

	/**
	 * Utility function to convert hexadecimal colors to strings, and simply return the color if it's a string.
	 * This version can also convert array of colors
	 * @private
	 * @param {Array} array1 First array to compare
	 * @param {Array} array2 Second array to compare
	 * @return {boolean} Do the arrays contain the same values in the same order
	 */
	function areArraysEqual(array1, array2) {
	    if (!Array.isArray(array1) || !Array.isArray(array2)) {
	        return false;
	    }

	    if (array1.length !== array2.length) {
	        return false;
	    }

	    for (var i = 0; i < array1.length; ++i) {
	        if (array1[i] !== array2[i]) {
	            return false;
	        }
	    }

	    return true;
	}

	/**
	 * Utility function to ensure that object properties are copied by value, and not by reference
	 * @private
	 * @param {Object} target Target object to copy properties into
	 * @param {Object} source Source object for the proporties to copy
	 * @param {string} propertyObj Object containing properties names we want to loop over
	 */
	function deepCopyProperties(target, source, propertyObj) {
	    for (var prop in propertyObj) {
	        if (Array.isArray(source[prop])) {
	            target[prop] = source[prop].slice();
	        } else {
	            target[prop] = source[prop];
	        }
	    }
	}
	//# sourceMappingURL=TextStyle.js.map

/***/ }),
/* 275 */
/***/ (function(module, exports) {

	'use strict';

	exports.__esModule = true;

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/**
	 * The TextMetrics object represents the measurement of a block of text with a specified style.
	 *
	 * ```js
	 * let style = new PIXI.TextStyle({fontFamily : 'Arial', fontSize: 24, fill : 0xff1010, align : 'center'})
	 * let textMetrics = PIXI.TextMetrics.measureText('Your text', style)
	 * ```
	 *
	 * @class
	 * @memberOf PIXI
	 */
	var TextMetrics = function () {
	    /**
	     * @param {string} text - the text that was measured
	     * @param {PIXI.TextStyle} style - the style that was measured
	     * @param {number} width - the measured width of the text
	     * @param {number} height - the measured height of the text
	     * @param {array} lines - an array of the lines of text broken by new lines and wrapping if specified in style
	     * @param {array} lineWidths - an array of the line widths for each line matched to `lines`
	     * @param {number} lineHeight - the measured line height for this style
	     * @param {number} maxLineWidth - the maximum line width for all measured lines
	     * @param {Object} fontProperties - the font properties object from TextMetrics.measureFont
	     */
	    function TextMetrics(text, style, width, height, lines, lineWidths, lineHeight, maxLineWidth, fontProperties) {
	        _classCallCheck(this, TextMetrics);

	        this.text = text;
	        this.style = style;
	        this.width = width;
	        this.height = height;
	        this.lines = lines;
	        this.lineWidths = lineWidths;
	        this.lineHeight = lineHeight;
	        this.maxLineWidth = maxLineWidth;
	        this.fontProperties = fontProperties;
	    }

	    /**
	     * Measures the supplied string of text and returns a Rectangle.
	     *
	     * @param {string} text - the text to measure.
	     * @param {PIXI.TextStyle} style - the text style to use for measuring
	     * @param {boolean} [wordWrap] - optional override for if word-wrap should be applied to the text.
	     * @param {HTMLCanvasElement} [canvas] - optional specification of the canvas to use for measuring.
	     * @return {PIXI.TextMetrics} measured width and height of the text.
	     */


	    TextMetrics.measureText = function measureText(text, style, wordWrap) {
	        var canvas = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : TextMetrics._canvas;

	        wordWrap = wordWrap === undefined || wordWrap === null ? style.wordWrap : wordWrap;
	        var font = style.toFontString();
	        var fontProperties = TextMetrics.measureFont(font);
	        var context = canvas.getContext('2d');

	        context.font = font;

	        var outputText = wordWrap ? TextMetrics.wordWrap(text, style, canvas) : text;
	        var lines = outputText.split(/(?:\r\n|\r|\n)/);
	        var lineWidths = new Array(lines.length);
	        var maxLineWidth = 0;

	        for (var i = 0; i < lines.length; i++) {
	            var lineWidth = context.measureText(lines[i]).width + (lines[i].length - 1) * style.letterSpacing;

	            lineWidths[i] = lineWidth;
	            maxLineWidth = Math.max(maxLineWidth, lineWidth);
	        }
	        var width = maxLineWidth + style.strokeThickness;

	        if (style.dropShadow) {
	            width += style.dropShadowDistance;
	        }

	        var lineHeight = style.lineHeight || fontProperties.fontSize + style.strokeThickness;
	        var height = Math.max(lineHeight, fontProperties.fontSize + style.strokeThickness) + (lines.length - 1) * (lineHeight + style.leading);

	        if (style.dropShadow) {
	            height += style.dropShadowDistance;
	        }

	        return new TextMetrics(text, style, width, height, lines, lineWidths, lineHeight + style.leading, maxLineWidth, fontProperties);
	    };

	    /**
	     * Applies newlines to a string to have it optimally fit into the horizontal
	     * bounds set by the Text object's wordWrapWidth property.
	     *
	     * @private
	     * @param {string} text - String to apply word wrapping to
	     * @param {PIXI.TextStyle} style - the style to use when wrapping
	     * @param {HTMLCanvasElement} [canvas] - optional specification of the canvas to use for measuring.
	     * @return {string} New string with new lines applied where required
	     */


	    TextMetrics.wordWrap = function wordWrap(text, style) {
	        var canvas = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : TextMetrics._canvas;

	        var context = canvas.getContext('2d');

	        var width = 0;
	        var line = '';
	        var lines = '';

	        var cache = {};
	        var letterSpacing = style.letterSpacing,
	            whiteSpace = style.whiteSpace;

	        // How to handle whitespaces

	        var collapseSpaces = TextMetrics.collapseSpaces(whiteSpace);
	        var collapseNewlines = TextMetrics.collapseNewlines(whiteSpace);

	        // whether or not spaces may be added to the beginning of lines
	        var canPrependSpaces = !collapseSpaces;

	        // There is letterSpacing after every char except the last one
	        // t_h_i_s_' '_i_s_' '_a_n_' '_e_x_a_m_p_l_e_' '_!
	        // so for convenience the above needs to be compared to width + 1 extra letterSpace
	        // t_h_i_s_' '_i_s_' '_a_n_' '_e_x_a_m_p_l_e_' '_!_
	        // ________________________________________________
	        // And then the final space is simply no appended to each line
	        var wordWrapWidth = style.wordWrapWidth + letterSpacing;

	        // break text into words, spaces and newline chars
	        var tokens = TextMetrics.tokenize(text);

	        for (var i = 0; i < tokens.length; i++) {
	            // get the word, space or newlineChar
	            var token = tokens[i];

	            // if word is a new line
	            if (TextMetrics.isNewline(token)) {
	                // keep the new line
	                if (!collapseNewlines) {
	                    lines += TextMetrics.addLine(line);
	                    canPrependSpaces = !collapseSpaces;
	                    line = '';
	                    width = 0;
	                    continue;
	                }

	                // if we should collapse new lines
	                // we simply convert it into a space
	                token = ' ';
	            }

	            // if we should collapse repeated whitespaces
	            if (collapseSpaces) {
	                // check both this and the last tokens for spaces
	                var currIsBreakingSpace = TextMetrics.isBreakingSpace(token);
	                var lastIsBreakingSpace = TextMetrics.isBreakingSpace(line[line.length - 1]);

	                if (currIsBreakingSpace && lastIsBreakingSpace) {
	                    continue;
	                }
	            }

	            // get word width from cache if possible
	            var tokenWidth = TextMetrics.getFromCache(token, letterSpacing, cache, context);

	            // word is longer than desired bounds
	            if (tokenWidth > wordWrapWidth) {
	                // if we are not already at the beginning of a line
	                if (line !== '') {
	                    // start newlines for overflow words
	                    lines += TextMetrics.addLine(line);
	                    line = '';
	                    width = 0;
	                }

	                // break large word over multiple lines
	                if (TextMetrics.canBreakWords(token, style.breakWords)) {
	                    // break word into characters
	                    var characters = token.split('');

	                    // loop the characters
	                    for (var j = 0; j < characters.length; j++) {
	                        var char = characters[j];

	                        var k = 1;
	                        // we are not at the end of the token

	                        while (characters[j + k]) {
	                            var nextChar = characters[j + k];
	                            var lastChar = char[char.length - 1];

	                            // should not split chars
	                            if (!TextMetrics.canBreakChars(lastChar, nextChar, token, j, style.breakWords)) {
	                                // combine chars & move forward one
	                                char += nextChar;
	                            } else {
	                                break;
	                            }

	                            k++;
	                        }

	                        j += char.length - 1;

	                        var characterWidth = TextMetrics.getFromCache(char, letterSpacing, cache, context);

	                        if (characterWidth + width > wordWrapWidth) {
	                            lines += TextMetrics.addLine(line);
	                            canPrependSpaces = false;
	                            line = '';
	                            width = 0;
	                        }

	                        line += char;
	                        width += characterWidth;
	                    }
	                }

	                // run word out of the bounds
	                else {
	                        // if there are words in this line already
	                        // finish that line and start a new one
	                        if (line.length > 0) {
	                            lines += TextMetrics.addLine(line);
	                            line = '';
	                            width = 0;
	                        }

	                        var isLastToken = i === tokens.length - 1;

	                        // give it its own line if it's not the end
	                        lines += TextMetrics.addLine(token, !isLastToken);
	                        canPrependSpaces = false;
	                        line = '';
	                        width = 0;
	                    }
	            }

	            // word could fit
	            else {
	                    // word won't fit because of existing words
	                    // start a new line
	                    if (tokenWidth + width > wordWrapWidth) {
	                        // if its a space we don't want it
	                        canPrependSpaces = false;

	                        // add a new line
	                        lines += TextMetrics.addLine(line);

	                        // start a new line
	                        line = '';
	                        width = 0;
	                    }

	                    // don't add spaces to the beginning of lines
	                    if (line.length > 0 || !TextMetrics.isBreakingSpace(token) || canPrependSpaces) {
	                        // add the word to the current line
	                        line += token;

	                        // update width counter
	                        width += tokenWidth;
	                    }
	                }
	        }

	        lines += TextMetrics.addLine(line, false);

	        return lines;
	    };

	    /**
	     * Convienience function for logging each line added during the wordWrap
	     * method
	     *
	     * @private
	     * @param  {string}   line        - The line of text to add
	     * @param  {boolean}  newLine     - Add new line character to end
	     * @return {string}   A formatted line
	     */


	    TextMetrics.addLine = function addLine(line) {
	        var newLine = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

	        line = TextMetrics.trimRight(line);

	        line = newLine ? line + '\n' : line;

	        return line;
	    };

	    /**
	     * Gets & sets the widths of calculated characters in a cache object
	     *
	     * @private
	     * @param  {string}                    key            The key
	     * @param  {number}                    letterSpacing  The letter spacing
	     * @param  {object}                    cache          The cache
	     * @param  {CanvasRenderingContext2D}  context        The canvas context
	     * @return {number}                    The from cache.
	     */


	    TextMetrics.getFromCache = function getFromCache(key, letterSpacing, cache, context) {
	        var width = cache[key];

	        if (width === undefined) {
	            var spacing = key.length * letterSpacing;

	            width = context.measureText(key).width + spacing;
	            cache[key] = width;
	        }

	        return width;
	    };

	    /**
	     * Determines whether we should collapse breaking spaces
	     *
	     * @private
	     * @param  {string}   whiteSpace  The TextStyle property whiteSpace
	     * @return {boolean}  should collapse
	     */


	    TextMetrics.collapseSpaces = function collapseSpaces(whiteSpace) {
	        return whiteSpace === 'normal' || whiteSpace === 'pre-line';
	    };

	    /**
	     * Determines whether we should collapse newLine chars
	     *
	     * @private
	     * @param  {string}   whiteSpace  The white space
	     * @return {boolean}  should collapse
	     */


	    TextMetrics.collapseNewlines = function collapseNewlines(whiteSpace) {
	        return whiteSpace === 'normal';
	    };

	    /**
	     * trims breaking whitespaces from string
	     *
	     * @private
	     * @param  {string}  text  The text
	     * @return {string}  trimmed string
	     */


	    TextMetrics.trimRight = function trimRight(text) {
	        if (typeof text !== 'string') {
	            return '';
	        }

	        for (var i = text.length - 1; i >= 0; i--) {
	            var char = text[i];

	            if (!TextMetrics.isBreakingSpace(char)) {
	                break;
	            }

	            text = text.slice(0, -1);
	        }

	        return text;
	    };

	    /**
	     * Determines if char is a newline.
	     *
	     * @private
	     * @param  {string}  char  The character
	     * @return {boolean}  True if newline, False otherwise.
	     */


	    TextMetrics.isNewline = function isNewline(char) {
	        if (typeof char !== 'string') {
	            return false;
	        }

	        return TextMetrics._newlines.indexOf(char.charCodeAt(0)) >= 0;
	    };

	    /**
	     * Determines if char is a breaking whitespace.
	     *
	     * @private
	     * @param  {string}  char  The character
	     * @return {boolean}  True if whitespace, False otherwise.
	     */


	    TextMetrics.isBreakingSpace = function isBreakingSpace(char) {
	        if (typeof char !== 'string') {
	            return false;
	        }

	        return TextMetrics._breakingSpaces.indexOf(char.charCodeAt(0)) >= 0;
	    };

	    /**
	     * Splits a string into words, breaking-spaces and newLine characters
	     *
	     * @private
	     * @param  {string}  text       The text
	     * @return {array}  A tokenized array
	     */


	    TextMetrics.tokenize = function tokenize(text) {
	        var tokens = [];
	        var token = '';

	        if (typeof text !== 'string') {
	            return tokens;
	        }

	        for (var i = 0; i < text.length; i++) {
	            var char = text[i];

	            if (TextMetrics.isBreakingSpace(char) || TextMetrics.isNewline(char)) {
	                if (token !== '') {
	                    tokens.push(token);
	                    token = '';
	                }

	                tokens.push(char);

	                continue;
	            }

	            token += char;
	        }

	        if (token !== '') {
	            tokens.push(token);
	        }

	        return tokens;
	    };

	    /**
	     * This method exists to be easily overridden
	     * It allows one to customise which words should break
	     * Examples are if the token is CJK or numbers.
	     * It must return a boolean.
	     *
	     * @private
	     * @param  {string}  token       The token
	     * @param  {boolean}  breakWords  The style attr break words
	     * @return {boolean} whether to break word or not
	     */


	    TextMetrics.canBreakWords = function canBreakWords(token, breakWords) {
	        return breakWords;
	    };

	    /**
	     * This method exists to be easily overridden
	     * It allows one to determine whether a pair of characters
	     * should be broken by newlines
	     * For example certain characters in CJK langs or numbers.
	     * It must return a boolean.
	     *
	     * @private
	     * @param  {string}  char      The character
	     * @param  {string}  nextChar  The next character
	     * @param  {string}  token     The token/word the characters are from
	     * @param  {number}  index     The index in the token of the char
	     * @param  {boolean}  breakWords  The style attr break words
	     * @return {boolean} whether to break word or not
	     */


	    TextMetrics.canBreakChars = function canBreakChars(char, nextChar, token, index, breakWords) // eslint-disable-line no-unused-vars
	    {
	        return true;
	    };

	    /**
	     * Calculates the ascent, descent and fontSize of a given font-style
	     *
	     * @static
	     * @param {string} font - String representing the style of the font
	     * @return {PIXI.TextMetrics~FontMetrics} Font properties object
	     */


	    TextMetrics.measureFont = function measureFont(font) {
	        // as this method is used for preparing assets, don't recalculate things if we don't need to
	        if (TextMetrics._fonts[font]) {
	            return TextMetrics._fonts[font];
	        }

	        var properties = {};

	        var canvas = TextMetrics._canvas;
	        var context = TextMetrics._context;

	        context.font = font;

	        var metricsString = TextMetrics.METRICS_STRING + TextMetrics.BASELINE_SYMBOL;
	        var width = Math.ceil(context.measureText(metricsString).width);
	        var baseline = Math.ceil(context.measureText(TextMetrics.BASELINE_SYMBOL).width);
	        var height = 2 * baseline;

	        baseline = baseline * TextMetrics.BASELINE_MULTIPLIER | 0;

	        canvas.width = width;
	        canvas.height = height;

	        context.fillStyle = '#f00';
	        context.fillRect(0, 0, width, height);

	        context.font = font;

	        context.textBaseline = 'alphabetic';
	        context.fillStyle = '#000';
	        context.fillText(metricsString, 0, baseline);

	        var imagedata = context.getImageData(0, 0, width, height).data;
	        var pixels = imagedata.length;
	        var line = width * 4;

	        var i = 0;
	        var idx = 0;
	        var stop = false;

	        // ascent. scan from top to bottom until we find a non red pixel
	        for (i = 0; i < baseline; ++i) {
	            for (var j = 0; j < line; j += 4) {
	                if (imagedata[idx + j] !== 255) {
	                    stop = true;
	                    break;
	                }
	            }
	            if (!stop) {
	                idx += line;
	            } else {
	                break;
	            }
	        }

	        properties.ascent = baseline - i;

	        idx = pixels - line;
	        stop = false;

	        // descent. scan from bottom to top until we find a non red pixel
	        for (i = height; i > baseline; --i) {
	            for (var _j = 0; _j < line; _j += 4) {
	                if (imagedata[idx + _j] !== 255) {
	                    stop = true;
	                    break;
	                }
	            }

	            if (!stop) {
	                idx -= line;
	            } else {
	                break;
	            }
	        }

	        properties.descent = i - baseline;
	        properties.fontSize = properties.ascent + properties.descent;

	        TextMetrics._fonts[font] = properties;

	        return properties;
	    };

	    /**
	     * Clear font metrics in metrics cache.
	     *
	     * @static
	     * @param {string} [font] - font name. If font name not set then clear cache for all fonts.
	     */


	    TextMetrics.clearMetrics = function clearMetrics() {
	        var font = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

	        if (font) {
	            delete TextMetrics._fonts[font];
	        } else {
	            TextMetrics._fonts = {};
	        }
	    };

	    return TextMetrics;
	}();

	/**
	 * Internal return object for {@link PIXI.TextMetrics.measureFont `TextMetrics.measureFont`}.
	 * @class FontMetrics
	 * @memberof PIXI.TextMetrics~
	 * @property {number} ascent - The ascent distance
	 * @property {number} descent - The descent distance
	 * @property {number} fontSize - Font size from ascent to descent
	 */

	exports.default = TextMetrics;
	var canvas = document.createElement('canvas');

	canvas.width = canvas.height = 10;

	/**
	 * Cached canvas element for measuring text
	 * @memberof PIXI.TextMetrics
	 * @type {HTMLCanvasElement}
	 * @private
	 */
	TextMetrics._canvas = canvas;

	/**
	 * Cache for context to use.
	 * @memberof PIXI.TextMetrics
	 * @type {CanvasRenderingContext2D}
	 * @private
	 */
	TextMetrics._context = canvas.getContext('2d');

	/**
	 * Cache of PIXI.TextMetrics~FontMetrics objects.
	 * @memberof PIXI.TextMetrics
	 * @type {Object}
	 * @private
	 */
	TextMetrics._fonts = {};

	/**
	 * String used for calculate font metrics.
	 * @static
	 * @memberof PIXI.TextMetrics
	 * @name METRICS_STRING
	 * @type {string}
	 * @default |Éq
	 */
	TextMetrics.METRICS_STRING = '|Éq';

	/**
	 * Baseline symbol for calculate font metrics.
	 * @static
	 * @memberof PIXI.TextMetrics
	 * @name BASELINE_SYMBOL
	 * @type {string}
	 * @default M
	 */
	TextMetrics.BASELINE_SYMBOL = 'M';

	/**
	 * Baseline multiplier for calculate font metrics.
	 * @static
	 * @memberof PIXI.TextMetrics
	 * @name BASELINE_MULTIPLIER
	 * @type {number}
	 * @default 1.4
	 */
	TextMetrics.BASELINE_MULTIPLIER = 1.4;

	/**
	 * Cache of new line chars.
	 * @memberof PIXI.TextMetrics
	 * @type {number[]}
	 * @private
	 */
	TextMetrics._newlines = [0x000A, // line feed
	0x000D];

	/**
	 * Cache of breaking spaces.
	 * @memberof PIXI.TextMetrics
	 * @type {number[]}
	 * @private
	 */
	TextMetrics._breakingSpaces = [0x0009, // character tabulation
	0x0020, // space
	0x2000, // en quad
	0x2001, // em quad
	0x2002, // en space
	0x2003, // em space
	0x2004, // three-per-em space
	0x2005, // four-per-em space
	0x2006, // six-per-em space
	0x2008, // punctuation space
	0x2009, // thin space
	0x200A, // hair space
	0x205F, // medium mathematical space
	0x3000];
	//# sourceMappingURL=TextMetrics.js.map

/***/ }),
/* 276 */
/***/ (function(module, exports) {

	'use strict';

	exports.__esModule = true;
	exports.default = trimCanvas;
	/**
	 * Trim transparent borders from a canvas
	 *
	 * @memberof PIXI
	 * @function trimCanvas
	 * @private
	 * @param {HTMLCanvasElement} canvas - the canvas to trim
	 * @returns {object} Trim data
	 */
	function trimCanvas(canvas) {
	    // https://gist.github.com/remy/784508

	    var width = canvas.width;
	    var height = canvas.height;

	    var context = canvas.getContext('2d');
	    var imageData = context.getImageData(0, 0, width, height);
	    var pixels = imageData.data;
	    var len = pixels.length;

	    var bound = {
	        top: null,
	        left: null,
	        right: null,
	        bottom: null
	    };
	    var data = null;
	    var i = void 0;
	    var x = void 0;
	    var y = void 0;

	    for (i = 0; i < len; i += 4) {
	        if (pixels[i + 3] !== 0) {
	            x = i / 4 % width;
	            y = ~~(i / 4 / width);

	            if (bound.top === null) {
	                bound.top = y;
	            }

	            if (bound.left === null) {
	                bound.left = x;
	            } else if (x < bound.left) {
	                bound.left = x;
	            }

	            if (bound.right === null) {
	                bound.right = x + 1;
	            } else if (bound.right < x) {
	                bound.right = x + 1;
	            }

	            if (bound.bottom === null) {
	                bound.bottom = y;
	            } else if (bound.bottom < y) {
	                bound.bottom = y;
	            }
	        }
	    }

	    if (bound.top !== null) {
	        width = bound.right - bound.left;
	        height = bound.bottom - bound.top + 1;
	        data = context.getImageData(bound.left, bound.top, width, height);
	    }

	    return {
	        height: height,
	        width: width,
	        data: data
	    };
	}
	//# sourceMappingURL=trimCanvas.js.map

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _Container2 = __webpack_require__(212);

	var _Container3 = _interopRequireDefault(_Container2);

	var _RenderTexture = __webpack_require__(237);

	var _RenderTexture2 = _interopRequireDefault(_RenderTexture);

	var _Texture = __webpack_require__(220);

	var _Texture2 = _interopRequireDefault(_Texture);

	var _GraphicsData = __webpack_require__(278);

	var _GraphicsData2 = _interopRequireDefault(_GraphicsData);

	var _Sprite = __webpack_require__(219);

	var _Sprite2 = _interopRequireDefault(_Sprite);

	var _math = __webpack_require__(175);

	var _utils = __webpack_require__(213);

	var _const = __webpack_require__(174);

	var _Bounds = __webpack_require__(202);

	var _Bounds2 = _interopRequireDefault(_Bounds);

	var _bezierCurveTo2 = __webpack_require__(279);

	var _bezierCurveTo3 = _interopRequireDefault(_bezierCurveTo2);

	var _CanvasRenderer = __webpack_require__(235);

	var _CanvasRenderer2 = _interopRequireDefault(_CanvasRenderer);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var canvasRenderer = void 0;
	var tempMatrix = new _math.Matrix();
	var tempPoint = new _math.Point();
	var tempColor1 = new Float32Array(4);
	var tempColor2 = new Float32Array(4);

	/**
	 * The Graphics class contains methods used to draw primitive shapes such as lines, circles and
	 * rectangles to the display, and to color and fill them.
	 *
	 * @class
	 * @extends PIXI.Container
	 * @memberof PIXI
	 */

	var Graphics = function (_Container) {
	    _inherits(Graphics, _Container);

	    /**
	     *
	     * @param {boolean} [nativeLines=false] - If true the lines will be draw using LINES instead of TRIANGLE_STRIP
	     */
	    function Graphics() {
	        var nativeLines = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

	        _classCallCheck(this, Graphics);

	        /**
	         * The alpha value used when filling the Graphics object.
	         *
	         * @member {number}
	         * @default 1
	         */
	        var _this = _possibleConstructorReturn(this, _Container.call(this));

	        _this.fillAlpha = 1;

	        /**
	         * The width (thickness) of any lines drawn.
	         *
	         * @member {number}
	         * @default 0
	         */
	        _this.lineWidth = 0;

	        /**
	         * If true the lines will be draw using LINES instead of TRIANGLE_STRIP
	         *
	         * @member {boolean}
	         */
	        _this.nativeLines = nativeLines;

	        /**
	         * The color of any lines drawn.
	         *
	         * @member {string}
	         * @default 0
	         */
	        _this.lineColor = 0;

	        /**
	         * The alignment of any lines drawn (0.5 = middle, 1 = outter, 0 = inner).
	         *
	         * @member {number}
	         * @default 0
	         */
	        _this.lineAlignment = 0.5;

	        /**
	         * Graphics data
	         *
	         * @member {PIXI.GraphicsData[]}
	         * @private
	         */
	        _this.graphicsData = [];

	        /**
	         * The tint applied to the graphic shape. This is a hex value. Apply a value of 0xFFFFFF to
	         * reset the tint.
	         *
	         * @member {number}
	         * @default 0xFFFFFF
	         */
	        _this.tint = 0xFFFFFF;

	        /**
	         * The previous tint applied to the graphic shape. Used to compare to the current tint and
	         * check if theres change.
	         *
	         * @member {number}
	         * @private
	         * @default 0xFFFFFF
	         */
	        _this._prevTint = 0xFFFFFF;

	        /**
	         * The blend mode to be applied to the graphic shape. Apply a value of
	         * `PIXI.BLEND_MODES.NORMAL` to reset the blend mode.
	         *
	         * @member {number}
	         * @default PIXI.BLEND_MODES.NORMAL;
	         * @see PIXI.BLEND_MODES
	         */
	        _this.blendMode = _const.BLEND_MODES.NORMAL;

	        /**
	         * Current path
	         *
	         * @member {PIXI.GraphicsData}
	         * @private
	         */
	        _this.currentPath = null;

	        /**
	         * Array containing some WebGL-related properties used by the WebGL renderer.
	         *
	         * @member {object<number, object>}
	         * @private
	         */
	        // TODO - _webgl should use a prototype object, not a random undocumented object...
	        _this._webGL = {};

	        /**
	         * Whether this shape is being used as a mask.
	         *
	         * @member {boolean}
	         */
	        _this.isMask = false;

	        /**
	         * The bounds' padding used for bounds calculation.
	         *
	         * @member {number}
	         */
	        _this.boundsPadding = 0;

	        /**
	         * A cache of the local bounds to prevent recalculation.
	         *
	         * @member {PIXI.Rectangle}
	         * @private
	         */
	        _this._localBounds = new _Bounds2.default();

	        /**
	         * Used to detect if the graphics object has changed. If this is set to true then the graphics
	         * object will be recalculated.
	         *
	         * @member {boolean}
	         * @private
	         */
	        _this.dirty = 0;

	        /**
	         * Used to detect if we need to do a fast rect check using the id compare method
	         * @type {Number}
	         */
	        _this.fastRectDirty = -1;

	        /**
	         * Used to detect if we clear the graphics webGL data
	         * @type {Number}
	         */
	        _this.clearDirty = 0;

	        /**
	         * Used to detect if we we need to recalculate local bounds
	         * @type {Number}
	         */
	        _this.boundsDirty = -1;

	        /**
	         * Used to detect if the cached sprite object needs to be updated.
	         *
	         * @member {boolean}
	         * @private
	         */
	        _this.cachedSpriteDirty = false;

	        _this._spriteRect = null;
	        _this._fastRect = false;

	        _this._prevRectTint = null;
	        _this._prevRectFillColor = null;

	        /**
	         * When cacheAsBitmap is set to true the graphics object will be rendered as if it was a sprite.
	         * This is useful if your graphics element does not change often, as it will speed up the rendering
	         * of the object in exchange for taking up texture memory. It is also useful if you need the graphics
	         * object to be anti-aliased, because it will be rendered using canvas. This is not recommended if
	         * you are constantly redrawing the graphics element.
	         *
	         * @name cacheAsBitmap
	         * @member {boolean}
	         * @memberof PIXI.Graphics#
	         * @default false
	         */
	        return _this;
	    }

	    /**
	     * Creates a new Graphics object with the same values as this one.
	     * Note that the only the properties of the object are cloned, not its transform (position,scale,etc)
	     *
	     * @return {PIXI.Graphics} A clone of the graphics object
	     */


	    Graphics.prototype.clone = function clone() {
	        var clone = new Graphics();

	        clone.renderable = this.renderable;
	        clone.fillAlpha = this.fillAlpha;
	        clone.lineWidth = this.lineWidth;
	        clone.lineColor = this.lineColor;
	        clone.lineAlignment = this.lineAlignment;
	        clone.tint = this.tint;
	        clone.blendMode = this.blendMode;
	        clone.isMask = this.isMask;
	        clone.boundsPadding = this.boundsPadding;
	        clone.dirty = 0;
	        clone.cachedSpriteDirty = this.cachedSpriteDirty;

	        // copy graphics data
	        for (var i = 0; i < this.graphicsData.length; ++i) {
	            clone.graphicsData.push(this.graphicsData[i].clone());
	        }

	        clone.currentPath = clone.graphicsData[clone.graphicsData.length - 1];

	        clone.updateLocalBounds();

	        return clone;
	    };

	    /**
	     * Calculate length of quadratic curve
	     * @see {@link http://www.malczak.linuxpl.com/blog/quadratic-bezier-curve-length/}
	     * for the detailed explanation of math behind this.
	     *
	     * @private
	     * @param {number} fromX - x-coordinate of curve start point
	     * @param {number} fromY - y-coordinate of curve start point
	     * @param {number} cpX - x-coordinate of curve control point
	     * @param {number} cpY - y-coordinate of curve control point
	     * @param {number} toX - x-coordinate of curve end point
	     * @param {number} toY - y-coordinate of curve end point
	     * @return {number} Length of quadratic curve
	     */


	    Graphics.prototype._quadraticCurveLength = function _quadraticCurveLength(fromX, fromY, cpX, cpY, toX, toY) {
	        var ax = fromX - (2.0 * cpX + toX);
	        var ay = fromY - (2.0 * cpY + toY);
	        var bx = 2.0 * ((cpX - 2.0) * fromX);
	        var by = 2.0 * ((cpY - 2.0) * fromY);
	        var a = 4.0 * (ax * ax + ay * ay);
	        var b = 4.0 * (ax * bx + ay * by);
	        var c = bx * bx + by * by;

	        var s = 2.0 * Math.sqrt(a + b + c);
	        var a2 = Math.sqrt(a);
	        var a32 = 2.0 * a * a2;
	        var c2 = 2.0 * Math.sqrt(c);
	        var ba = b / a2;

	        return (a32 * s + a2 * b * (s - c2) + (4.0 * c * a - b * b) * Math.log((2.0 * a2 + ba + s) / (ba + c2))) / (4.0 * a32);
	    };

	    /**
	     * Calculate length of bezier curve.
	     * Analytical solution is impossible, since it involves an integral that does not integrate in general.
	     * Therefore numerical solution is used.
	     *
	     * @private
	     * @param {number} fromX - Starting point x
	     * @param {number} fromY - Starting point y
	     * @param {number} cpX - Control point x
	     * @param {number} cpY - Control point y
	     * @param {number} cpX2 - Second Control point x
	     * @param {number} cpY2 - Second Control point y
	     * @param {number} toX - Destination point x
	     * @param {number} toY - Destination point y
	     * @return {number} Length of bezier curve
	     */


	    Graphics.prototype._bezierCurveLength = function _bezierCurveLength(fromX, fromY, cpX, cpY, cpX2, cpY2, toX, toY) {
	        var n = 10;
	        var result = 0.0;
	        var t = 0.0;
	        var t2 = 0.0;
	        var t3 = 0.0;
	        var nt = 0.0;
	        var nt2 = 0.0;
	        var nt3 = 0.0;
	        var x = 0.0;
	        var y = 0.0;
	        var dx = 0.0;
	        var dy = 0.0;
	        var prevX = fromX;
	        var prevY = fromY;

	        for (var i = 1; i <= n; ++i) {
	            t = i / n;
	            t2 = t * t;
	            t3 = t2 * t;
	            nt = 1.0 - t;
	            nt2 = nt * nt;
	            nt3 = nt2 * nt;

	            x = nt3 * fromX + 3.0 * nt2 * t * cpX + 3.0 * nt * t2 * cpX2 + t3 * toX;
	            y = nt3 * fromY + 3.0 * nt2 * t * cpY + 3 * nt * t2 * cpY2 + t3 * toY;
	            dx = prevX - x;
	            dy = prevY - y;
	            prevX = x;
	            prevY = y;

	            result += Math.sqrt(dx * dx + dy * dy);
	        }

	        return result;
	    };

	    /**
	     * Calculate number of segments for the curve based on its length to ensure its smoothness.
	     *
	     * @private
	     * @param {number} length - length of curve
	     * @return {number} Number of segments
	     */


	    Graphics.prototype._segmentsCount = function _segmentsCount(length) {
	        var result = Math.ceil(length / Graphics.CURVES.maxLength);

	        if (result < Graphics.CURVES.minSegments) {
	            result = Graphics.CURVES.minSegments;
	        } else if (result > Graphics.CURVES.maxSegments) {
	            result = Graphics.CURVES.maxSegments;
	        }

	        return result;
	    };

	    /**
	     * Specifies the line style used for subsequent calls to Graphics methods such as the lineTo()
	     * method or the drawCircle() method.
	     *
	     * @param {number} [lineWidth=0] - width of the line to draw, will update the objects stored style
	     * @param {number} [color=0] - color of the line to draw, will update the objects stored style
	     * @param {number} [alpha=1] - alpha of the line to draw, will update the objects stored style
	     * @param {number} [alignment=0.5] - alignment of the line to draw, (0 = inner, 0.5 = middle, 1 = outter)
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */


	    Graphics.prototype.lineStyle = function lineStyle() {
	        var lineWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	        var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	        var alpha = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	        var alignment = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0.5;

	        this.lineWidth = lineWidth;
	        this.lineColor = color;
	        this.lineAlpha = alpha;
	        this.lineAlignment = alignment;

	        if (this.currentPath) {
	            if (this.currentPath.shape.points.length) {
	                // halfway through a line? start a new one!
	                var shape = new _math.Polygon(this.currentPath.shape.points.slice(-2));

	                shape.closed = false;

	                this.drawShape(shape);
	            } else {
	                // otherwise its empty so lets just set the line properties
	                this.currentPath.lineWidth = this.lineWidth;
	                this.currentPath.lineColor = this.lineColor;
	                this.currentPath.lineAlpha = this.lineAlpha;
	                this.currentPath.lineAlignment = this.lineAlignment;
	            }
	        }

	        return this;
	    };

	    /**
	     * Moves the current drawing position to x, y.
	     *
	     * @param {number} x - the X coordinate to move to
	     * @param {number} y - the Y coordinate to move to
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */


	    Graphics.prototype.moveTo = function moveTo(x, y) {
	        var shape = new _math.Polygon([x, y]);

	        shape.closed = false;
	        this.drawShape(shape);

	        return this;
	    };

	    /**
	     * Draws a line using the current line style from the current drawing position to (x, y);
	     * The current drawing position is then set to (x, y).
	     *
	     * @param {number} x - the X coordinate to draw to
	     * @param {number} y - the Y coordinate to draw to
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */


	    Graphics.prototype.lineTo = function lineTo(x, y) {
	        var points = this.currentPath.shape.points;

	        var fromX = points[points.length - 2];
	        var fromY = points[points.length - 1];

	        if (fromX !== x || fromY !== y) {
	            points.push(x, y);
	            this.dirty++;
	        }

	        return this;
	    };

	    /**
	     * Calculate the points for a quadratic bezier curve and then draws it.
	     * Based on: https://stackoverflow.com/questions/785097/how-do-i-implement-a-bezier-curve-in-c
	     *
	     * @param {number} cpX - Control point x
	     * @param {number} cpY - Control point y
	     * @param {number} toX - Destination point x
	     * @param {number} toY - Destination point y
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */


	    Graphics.prototype.quadraticCurveTo = function quadraticCurveTo(cpX, cpY, toX, toY) {
	        if (this.currentPath) {
	            if (this.currentPath.shape.points.length === 0) {
	                this.currentPath.shape.points = [0, 0];
	            }
	        } else {
	            this.moveTo(0, 0);
	        }

	        var points = this.currentPath.shape.points;
	        var xa = 0;
	        var ya = 0;

	        if (points.length === 0) {
	            this.moveTo(0, 0);
	        }

	        var fromX = points[points.length - 2];
	        var fromY = points[points.length - 1];
	        var n = Graphics.CURVES.adaptive ? this._segmentsCount(this._quadraticCurveLength(fromX, fromY, cpX, cpY, toX, toY)) : 20;

	        for (var i = 1; i <= n; ++i) {
	            var j = i / n;

	            xa = fromX + (cpX - fromX) * j;
	            ya = fromY + (cpY - fromY) * j;

	            points.push(xa + (cpX + (toX - cpX) * j - xa) * j, ya + (cpY + (toY - cpY) * j - ya) * j);
	        }

	        this.dirty++;

	        return this;
	    };

	    /**
	     * Calculate the points for a bezier curve and then draws it.
	     *
	     * @param {number} cpX - Control point x
	     * @param {number} cpY - Control point y
	     * @param {number} cpX2 - Second Control point x
	     * @param {number} cpY2 - Second Control point y
	     * @param {number} toX - Destination point x
	     * @param {number} toY - Destination point y
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */


	    Graphics.prototype.bezierCurveTo = function bezierCurveTo(cpX, cpY, cpX2, cpY2, toX, toY) {
	        if (this.currentPath) {
	            if (this.currentPath.shape.points.length === 0) {
	                this.currentPath.shape.points = [0, 0];
	            }
	        } else {
	            this.moveTo(0, 0);
	        }

	        var points = this.currentPath.shape.points;

	        var fromX = points[points.length - 2];
	        var fromY = points[points.length - 1];

	        points.length -= 2;

	        var n = Graphics.CURVES.adaptive ? this._segmentsCount(this._bezierCurveLength(fromX, fromY, cpX, cpY, cpX2, cpY2, toX, toY)) : 20;

	        (0, _bezierCurveTo3.default)(fromX, fromY, cpX, cpY, cpX2, cpY2, toX, toY, n, points);

	        this.dirty++;

	        return this;
	    };

	    /**
	     * The arcTo() method creates an arc/curve between two tangents on the canvas.
	     *
	     * "borrowed" from https://code.google.com/p/fxcanvas/ - thanks google!
	     *
	     * @param {number} x1 - The x-coordinate of the beginning of the arc
	     * @param {number} y1 - The y-coordinate of the beginning of the arc
	     * @param {number} x2 - The x-coordinate of the end of the arc
	     * @param {number} y2 - The y-coordinate of the end of the arc
	     * @param {number} radius - The radius of the arc
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */


	    Graphics.prototype.arcTo = function arcTo(x1, y1, x2, y2, radius) {
	        if (this.currentPath) {
	            if (this.currentPath.shape.points.length === 0) {
	                this.currentPath.shape.points.push(x1, y1);
	            }
	        } else {
	            this.moveTo(x1, y1);
	        }

	        var points = this.currentPath.shape.points;
	        var fromX = points[points.length - 2];
	        var fromY = points[points.length - 1];
	        var a1 = fromY - y1;
	        var b1 = fromX - x1;
	        var a2 = y2 - y1;
	        var b2 = x2 - x1;
	        var mm = Math.abs(a1 * b2 - b1 * a2);

	        if (mm < 1.0e-8 || radius === 0) {
	            if (points[points.length - 2] !== x1 || points[points.length - 1] !== y1) {
	                points.push(x1, y1);
	            }
	        } else {
	            var dd = a1 * a1 + b1 * b1;
	            var cc = a2 * a2 + b2 * b2;
	            var tt = a1 * a2 + b1 * b2;
	            var k1 = radius * Math.sqrt(dd) / mm;
	            var k2 = radius * Math.sqrt(cc) / mm;
	            var j1 = k1 * tt / dd;
	            var j2 = k2 * tt / cc;
	            var cx = k1 * b2 + k2 * b1;
	            var cy = k1 * a2 + k2 * a1;
	            var px = b1 * (k2 + j1);
	            var py = a1 * (k2 + j1);
	            var qx = b2 * (k1 + j2);
	            var qy = a2 * (k1 + j2);
	            var startAngle = Math.atan2(py - cy, px - cx);
	            var endAngle = Math.atan2(qy - cy, qx - cx);

	            this.arc(cx + x1, cy + y1, radius, startAngle, endAngle, b1 * a2 > b2 * a1);
	        }

	        this.dirty++;

	        return this;
	    };

	    /**
	     * The arc method creates an arc/curve (used to create circles, or parts of circles).
	     *
	     * @param {number} cx - The x-coordinate of the center of the circle
	     * @param {number} cy - The y-coordinate of the center of the circle
	     * @param {number} radius - The radius of the circle
	     * @param {number} startAngle - The starting angle, in radians (0 is at the 3 o'clock position
	     *  of the arc's circle)
	     * @param {number} endAngle - The ending angle, in radians
	     * @param {boolean} [anticlockwise=false] - Specifies whether the drawing should be
	     *  counter-clockwise or clockwise. False is default, and indicates clockwise, while true
	     *  indicates counter-clockwise.
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */


	    Graphics.prototype.arc = function arc(cx, cy, radius, startAngle, endAngle) {
	        var anticlockwise = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

	        if (startAngle === endAngle) {
	            return this;
	        }

	        if (!anticlockwise && endAngle <= startAngle) {
	            endAngle += _const.PI_2;
	        } else if (anticlockwise && startAngle <= endAngle) {
	            startAngle += _const.PI_2;
	        }

	        var sweep = endAngle - startAngle;
	        var segs = Graphics.CURVES.adaptive ? this._segmentsCount(Math.abs(sweep) * radius) : Math.ceil(Math.abs(sweep) / _const.PI_2) * 40;

	        if (sweep === 0) {
	            return this;
	        }

	        var startX = cx + Math.cos(startAngle) * radius;
	        var startY = cy + Math.sin(startAngle) * radius;

	        // If the currentPath exists, take its points. Otherwise call `moveTo` to start a path.
	        var points = this.currentPath ? this.currentPath.shape.points : null;

	        if (points) {
	            // We check how far our start is from the last existing point
	            var xDiff = Math.abs(points[points.length - 2] - startX);
	            var yDiff = Math.abs(points[points.length - 1] - startY);

	            if (xDiff < 0.001 && yDiff < 0.001) {
	                // If the point is very close, we don't add it, since this would lead to artifacts
	                // during tesselation due to floating point imprecision.
	            } else {
	                points.push(startX, startY);
	            }
	        } else {
	            this.moveTo(startX, startY);
	            points = this.currentPath.shape.points;
	        }

	        var theta = sweep / (segs * 2);
	        var theta2 = theta * 2;

	        var cTheta = Math.cos(theta);
	        var sTheta = Math.sin(theta);

	        var segMinus = segs - 1;

	        var remainder = segMinus % 1 / segMinus;

	        for (var i = 0; i <= segMinus; ++i) {
	            var real = i + remainder * i;

	            var angle = theta + startAngle + theta2 * real;

	            var c = Math.cos(angle);
	            var s = -Math.sin(angle);

	            points.push((cTheta * c + sTheta * s) * radius + cx, (cTheta * -s + sTheta * c) * radius + cy);
	        }

	        this.dirty++;

	        return this;
	    };

	    /**
	     * Specifies a simple one-color fill that subsequent calls to other Graphics methods
	     * (such as lineTo() or drawCircle()) use when drawing.
	     *
	     * @param {number} [color=0] - the color of the fill
	     * @param {number} [alpha=1] - the alpha of the fill
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */


	    Graphics.prototype.beginFill = function beginFill() {
	        var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	        var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

	        this.filling = true;
	        this.fillColor = color;
	        this.fillAlpha = alpha;

	        if (this.currentPath) {
	            if (this.currentPath.shape.points.length <= 2) {
	                this.currentPath.fill = this.filling;
	                this.currentPath.fillColor = this.fillColor;
	                this.currentPath.fillAlpha = this.fillAlpha;
	            }
	        }

	        return this;
	    };

	    /**
	     * Applies a fill to the lines and shapes that were added since the last call to the beginFill() method.
	     *
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */


	    Graphics.prototype.endFill = function endFill() {
	        this.filling = false;
	        this.fillColor = null;
	        this.fillAlpha = 1;

	        return this;
	    };

	    /**
	     *
	     * @param {number} x - The X coord of the top-left of the rectangle
	     * @param {number} y - The Y coord of the top-left of the rectangle
	     * @param {number} width - The width of the rectangle
	     * @param {number} height - The height of the rectangle
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */


	    Graphics.prototype.drawRect = function drawRect(x, y, width, height) {
	        this.drawShape(new _math.Rectangle(x, y, width, height));

	        return this;
	    };

	    /**
	     *
	     * @param {number} x - The X coord of the top-left of the rectangle
	     * @param {number} y - The Y coord of the top-left of the rectangle
	     * @param {number} width - The width of the rectangle
	     * @param {number} height - The height of the rectangle
	     * @param {number} radius - Radius of the rectangle corners
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */


	    Graphics.prototype.drawRoundedRect = function drawRoundedRect(x, y, width, height, radius) {
	        this.drawShape(new _math.RoundedRectangle(x, y, width, height, radius));

	        return this;
	    };

	    /**
	     * Draws a circle.
	     *
	     * @param {number} x - The X coordinate of the center of the circle
	     * @param {number} y - The Y coordinate of the center of the circle
	     * @param {number} radius - The radius of the circle
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */


	    Graphics.prototype.drawCircle = function drawCircle(x, y, radius) {
	        this.drawShape(new _math.Circle(x, y, radius));

	        return this;
	    };

	    /**
	     * Draws an ellipse.
	     *
	     * @param {number} x - The X coordinate of the center of the ellipse
	     * @param {number} y - The Y coordinate of the center of the ellipse
	     * @param {number} width - The half width of the ellipse
	     * @param {number} height - The half height of the ellipse
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */


	    Graphics.prototype.drawEllipse = function drawEllipse(x, y, width, height) {
	        this.drawShape(new _math.Ellipse(x, y, width, height));

	        return this;
	    };

	    /**
	     * Draws a polygon using the given path.
	     *
	     * @param {number[]|PIXI.Point[]|PIXI.Polygon} path - The path data used to construct the polygon.
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */


	    Graphics.prototype.drawPolygon = function drawPolygon(path) {
	        // prevents an argument assignment deopt
	        // see section 3.1: https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#3-managing-arguments
	        var points = path;

	        var closed = true;

	        if (points instanceof _math.Polygon) {
	            closed = points.closed;
	            points = points.points;
	        }

	        if (!Array.isArray(points)) {
	            // prevents an argument leak deopt
	            // see section 3.2: https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#3-managing-arguments
	            points = new Array(arguments.length);

	            for (var i = 0; i < points.length; ++i) {
	                points[i] = arguments[i]; // eslint-disable-line prefer-rest-params
	            }
	        }

	        var shape = new _math.Polygon(points);

	        shape.closed = closed;

	        this.drawShape(shape);

	        return this;
	    };

	    /**
	     * Draw a star shape with an abitrary number of points.
	     *
	     * @param {number} x - Center X position of the star
	     * @param {number} y - Center Y position of the star
	     * @param {number} points - The number of points of the star, must be > 1
	     * @param {number} radius - The outer radius of the star
	     * @param {number} [innerRadius] - The inner radius between points, default half `radius`
	     * @param {number} [rotation=0] - The rotation of the star in radians, where 0 is vertical
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */


	    Graphics.prototype.drawStar = function drawStar(x, y, points, radius, innerRadius) {
	        var rotation = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

	        innerRadius = innerRadius || radius / 2;

	        var startAngle = -1 * Math.PI / 2 + rotation;
	        var len = points * 2;
	        var delta = _const.PI_2 / len;
	        var polygon = [];

	        for (var i = 0; i < len; i++) {
	            var r = i % 2 ? innerRadius : radius;
	            var angle = i * delta + startAngle;

	            polygon.push(x + r * Math.cos(angle), y + r * Math.sin(angle));
	        }

	        return this.drawPolygon(polygon);
	    };

	    /**
	     * Clears the graphics that were drawn to this Graphics object, and resets fill and line style settings.
	     *
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */


	    Graphics.prototype.clear = function clear() {
	        if (this.lineWidth || this.filling || this.graphicsData.length > 0) {
	            this.lineWidth = 0;
	            this.lineAlignment = 0.5;

	            this.filling = false;

	            this.boundsDirty = -1;
	            this.canvasTintDirty = -1;
	            this.dirty++;
	            this.clearDirty++;
	            this.graphicsData.length = 0;
	        }

	        this.currentPath = null;
	        this._spriteRect = null;

	        return this;
	    };

	    /**
	     * True if graphics consists of one rectangle, and thus, can be drawn like a Sprite and
	     * masked with gl.scissor.
	     *
	     * @returns {boolean} True if only 1 rect.
	     */


	    Graphics.prototype.isFastRect = function isFastRect() {
	        return this.graphicsData.length === 1 && this.graphicsData[0].shape.type === _const.SHAPES.RECT && !this.graphicsData[0].lineWidth;
	    };

	    /**
	     * Renders the object using the WebGL renderer
	     *
	     * @private
	     * @param {PIXI.WebGLRenderer} renderer - The renderer
	     */


	    Graphics.prototype._renderWebGL = function _renderWebGL(renderer) {
	        // if the sprite is not visible or the alpha is 0 then no need to render this element
	        if (this.dirty !== this.fastRectDirty) {
	            this.fastRectDirty = this.dirty;
	            this._fastRect = this.isFastRect();
	        }

	        // TODO this check can be moved to dirty?
	        if (this._fastRect) {
	            this._renderSpriteRect(renderer);
	        } else {
	            renderer.setObjectRenderer(renderer.plugins.graphics);
	            renderer.plugins.graphics.render(this);
	        }
	    };

	    /**
	     * Renders a sprite rectangle.
	     *
	     * @private
	     * @param {PIXI.WebGLRenderer} renderer - The renderer
	     */


	    Graphics.prototype._renderSpriteRect = function _renderSpriteRect(renderer) {
	        var rect = this.graphicsData[0].shape;

	        if (!this._spriteRect) {
	            this._spriteRect = new _Sprite2.default(new _Texture2.default(_Texture2.default.WHITE));
	        }

	        var sprite = this._spriteRect;
	        var fillColor = this.graphicsData[0].fillColor;

	        if (this.tint === 0xffffff) {
	            sprite.tint = fillColor;
	        } else if (this.tint !== this._prevRectTint || fillColor !== this._prevRectFillColor) {
	            var t1 = tempColor1;
	            var t2 = tempColor2;

	            (0, _utils.hex2rgb)(fillColor, t1);
	            (0, _utils.hex2rgb)(this.tint, t2);

	            t1[0] *= t2[0];
	            t1[1] *= t2[1];
	            t1[2] *= t2[2];

	            sprite.tint = (0, _utils.rgb2hex)(t1);

	            this._prevRectTint = this.tint;
	            this._prevRectFillColor = fillColor;
	        }

	        sprite.alpha = this.graphicsData[0].fillAlpha;
	        sprite.worldAlpha = this.worldAlpha * sprite.alpha;
	        sprite.blendMode = this.blendMode;

	        sprite._texture._frame.width = rect.width;
	        sprite._texture._frame.height = rect.height;

	        sprite.transform.worldTransform = this.transform.worldTransform;

	        sprite.anchor.set(-rect.x / rect.width, -rect.y / rect.height);
	        sprite._onAnchorUpdate();

	        sprite._renderWebGL(renderer);
	    };

	    /**
	     * Renders the object using the Canvas renderer
	     *
	     * @private
	     * @param {PIXI.CanvasRenderer} renderer - The renderer
	     */


	    Graphics.prototype._renderCanvas = function _renderCanvas(renderer) {
	        if (this.isMask === true) {
	            return;
	        }

	        renderer.plugins.graphics.render(this);
	    };

	    /**
	     * Retrieves the bounds of the graphic shape as a rectangle object
	     *
	     * @private
	     */


	    Graphics.prototype._calculateBounds = function _calculateBounds() {
	        if (this.boundsDirty !== this.dirty) {
	            this.boundsDirty = this.dirty;
	            this.updateLocalBounds();

	            this.cachedSpriteDirty = true;
	        }

	        var lb = this._localBounds;

	        this._bounds.addFrame(this.transform, lb.minX, lb.minY, lb.maxX, lb.maxY);
	    };

	    /**
	     * Tests if a point is inside this graphics object
	     *
	     * @param {PIXI.Point} point - the point to test
	     * @return {boolean} the result of the test
	     */


	    Graphics.prototype.containsPoint = function containsPoint(point) {
	        this.worldTransform.applyInverse(point, tempPoint);

	        var graphicsData = this.graphicsData;

	        for (var i = 0; i < graphicsData.length; ++i) {
	            var data = graphicsData[i];

	            if (!data.fill) {
	                continue;
	            }

	            // only deal with fills..
	            if (data.shape) {
	                if (data.shape.contains(tempPoint.x, tempPoint.y)) {
	                    if (data.holes) {
	                        for (var _i = 0; _i < data.holes.length; _i++) {
	                            var hole = data.holes[_i];

	                            if (hole.contains(tempPoint.x, tempPoint.y)) {
	                                return false;
	                            }
	                        }
	                    }

	                    return true;
	                }
	            }
	        }

	        return false;
	    };

	    /**
	     * Update the bounds of the object
	     *
	     */


	    Graphics.prototype.updateLocalBounds = function updateLocalBounds() {
	        var minX = Infinity;
	        var maxX = -Infinity;

	        var minY = Infinity;
	        var maxY = -Infinity;

	        if (this.graphicsData.length) {
	            var shape = 0;
	            var x = 0;
	            var y = 0;
	            var w = 0;
	            var h = 0;

	            for (var i = 0; i < this.graphicsData.length; i++) {
	                var data = this.graphicsData[i];
	                var type = data.type;
	                var lineWidth = data.lineWidth;

	                shape = data.shape;

	                if (type === _const.SHAPES.RECT || type === _const.SHAPES.RREC) {
	                    x = shape.x - lineWidth / 2;
	                    y = shape.y - lineWidth / 2;
	                    w = shape.width + lineWidth;
	                    h = shape.height + lineWidth;

	                    minX = x < minX ? x : minX;
	                    maxX = x + w > maxX ? x + w : maxX;

	                    minY = y < minY ? y : minY;
	                    maxY = y + h > maxY ? y + h : maxY;
	                } else if (type === _const.SHAPES.CIRC) {
	                    x = shape.x;
	                    y = shape.y;
	                    w = shape.radius + lineWidth / 2;
	                    h = shape.radius + lineWidth / 2;

	                    minX = x - w < minX ? x - w : minX;
	                    maxX = x + w > maxX ? x + w : maxX;

	                    minY = y - h < minY ? y - h : minY;
	                    maxY = y + h > maxY ? y + h : maxY;
	                } else if (type === _const.SHAPES.ELIP) {
	                    x = shape.x;
	                    y = shape.y;
	                    w = shape.width + lineWidth / 2;
	                    h = shape.height + lineWidth / 2;

	                    minX = x - w < minX ? x - w : minX;
	                    maxX = x + w > maxX ? x + w : maxX;

	                    minY = y - h < minY ? y - h : minY;
	                    maxY = y + h > maxY ? y + h : maxY;
	                } else {
	                    // POLY
	                    var points = shape.points;
	                    var x2 = 0;
	                    var y2 = 0;
	                    var dx = 0;
	                    var dy = 0;
	                    var rw = 0;
	                    var rh = 0;
	                    var cx = 0;
	                    var cy = 0;

	                    for (var j = 0; j + 2 < points.length; j += 2) {
	                        x = points[j];
	                        y = points[j + 1];
	                        x2 = points[j + 2];
	                        y2 = points[j + 3];
	                        dx = Math.abs(x2 - x);
	                        dy = Math.abs(y2 - y);
	                        h = lineWidth;
	                        w = Math.sqrt(dx * dx + dy * dy);

	                        if (w < 1e-9) {
	                            continue;
	                        }

	                        rw = (h / w * dy + dx) / 2;
	                        rh = (h / w * dx + dy) / 2;
	                        cx = (x2 + x) / 2;
	                        cy = (y2 + y) / 2;

	                        minX = cx - rw < minX ? cx - rw : minX;
	                        maxX = cx + rw > maxX ? cx + rw : maxX;

	                        minY = cy - rh < minY ? cy - rh : minY;
	                        maxY = cy + rh > maxY ? cy + rh : maxY;
	                    }
	                }
	            }
	        } else {
	            minX = 0;
	            maxX = 0;
	            minY = 0;
	            maxY = 0;
	        }

	        var padding = this.boundsPadding;

	        this._localBounds.minX = minX - padding;
	        this._localBounds.maxX = maxX + padding;

	        this._localBounds.minY = minY - padding;
	        this._localBounds.maxY = maxY + padding;
	    };

	    /**
	     * Draws the given shape to this Graphics object. Can be any of Circle, Rectangle, Ellipse, Line or Polygon.
	     *
	     * @param {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle} shape - The shape object to draw.
	     * @return {PIXI.GraphicsData} The generated GraphicsData object.
	     */


	    Graphics.prototype.drawShape = function drawShape(shape) {
	        if (this.currentPath) {
	            // check current path!
	            if (this.currentPath.shape.points.length <= 2) {
	                this.graphicsData.pop();
	            }
	        }

	        this.currentPath = null;

	        var data = new _GraphicsData2.default(this.lineWidth, this.lineColor, this.lineAlpha, this.fillColor, this.fillAlpha, this.filling, this.nativeLines, shape, this.lineAlignment);

	        this.graphicsData.push(data);

	        if (data.type === _const.SHAPES.POLY) {
	            data.shape.closed = data.shape.closed;
	            this.currentPath = data;
	        }

	        this.dirty++;

	        return data;
	    };

	    /**
	     * Generates a canvas texture.
	     *
	     * @param {number} scaleMode - The scale mode of the texture.
	     * @param {number} resolution - The resolution of the texture.
	     * @return {PIXI.Texture} The new texture.
	     */


	    Graphics.prototype.generateCanvasTexture = function generateCanvasTexture(scaleMode) {
	        var resolution = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

	        var bounds = this.getLocalBounds();

	        var canvasBuffer = _RenderTexture2.default.create(bounds.width, bounds.height, scaleMode, resolution);

	        if (!canvasRenderer) {
	            canvasRenderer = new _CanvasRenderer2.default();
	        }

	        this.transform.updateLocalTransform();
	        this.transform.localTransform.copy(tempMatrix);

	        tempMatrix.invert();

	        tempMatrix.tx -= bounds.x;
	        tempMatrix.ty -= bounds.y;

	        canvasRenderer.render(this, canvasBuffer, true, tempMatrix);

	        var texture = _Texture2.default.fromCanvas(canvasBuffer.baseTexture._canvasRenderTarget.canvas, scaleMode, 'graphics');

	        texture.baseTexture.resolution = resolution;
	        texture.baseTexture.update();

	        return texture;
	    };

	    /**
	     * Closes the current path.
	     *
	     * @return {PIXI.Graphics} Returns itself.
	     */


	    Graphics.prototype.closePath = function closePath() {
	        // ok so close path assumes next one is a hole!
	        var currentPath = this.currentPath;

	        if (currentPath && currentPath.shape) {
	            currentPath.shape.close();
	        }

	        return this;
	    };

	    /**
	     * Adds a hole in the current path.
	     *
	     * @return {PIXI.Graphics} Returns itself.
	     */


	    Graphics.prototype.addHole = function addHole() {
	        // this is a hole!
	        var hole = this.graphicsData.pop();

	        this.currentPath = this.graphicsData[this.graphicsData.length - 1];

	        this.currentPath.addHole(hole.shape);
	        this.currentPath = null;

	        return this;
	    };

	    /**
	     * Destroys the Graphics object.
	     *
	     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all
	     *  options have been set to that value
	     * @param {boolean} [options.children=false] - if set to true, all the children will have
	     *  their destroy method called as well. 'options' will be passed on to those calls.
	     * @param {boolean} [options.texture=false] - Only used for child Sprites if options.children is set to true
	     *  Should it destroy the texture of the child sprite
	     * @param {boolean} [options.baseTexture=false] - Only used for child Sprites if options.children is set to true
	     *  Should it destroy the base texture of the child sprite
	     */


	    Graphics.prototype.destroy = function destroy(options) {
	        _Container.prototype.destroy.call(this, options);

	        // destroy each of the GraphicsData objects
	        for (var i = 0; i < this.graphicsData.length; ++i) {
	            this.graphicsData[i].destroy();
	        }

	        // for each webgl data entry, destroy the WebGLGraphicsData
	        for (var id in this._webGL) {
	            for (var j = 0; j < this._webGL[id].data.length; ++j) {
	                this._webGL[id].data[j].destroy();
	            }
	        }

	        if (this._spriteRect) {
	            this._spriteRect.destroy();
	        }

	        this.graphicsData = null;

	        this.currentPath = null;
	        this._webGL = null;
	        this._localBounds = null;
	    };

	    return Graphics;
	}(_Container3.default);

	exports.default = Graphics;


	Graphics._SPRITE_TEXTURE = null;

	/**
	 * Graphics curves resolution settings. If `adaptive` flag is set to `true`,
	 * the resolution is calculated based on the curve's length to ensure better visual quality.
	 * Adaptive draw works with `bezierCurveTo` and `quadraticCurveTo`.
	 *
	 * @static
	 * @constant
	 * @memberof PIXI.Graphics
	 * @name CURVES
	 * @type {object}
	 * @property {boolean} adaptive=false - flag indicating if the resolution should be adaptive
	 * @property {number} maxLength=10 - maximal length of a single segment of the curve (if adaptive = false, ignored)
	 * @property {number} minSegments=8 - minimal number of segments in the curve (if adaptive = false, ignored)
	 * @property {number} maxSegments=2048 - maximal number of segments in the curve (if adaptive = false, ignored)
	 */
	Graphics.CURVES = {
	    adaptive: false,
	    maxLength: 10,
	    minSegments: 8,
	    maxSegments: 2048
	};
	//# sourceMappingURL=Graphics.js.map

/***/ }),
/* 278 */
/***/ (function(module, exports) {

	"use strict";

	exports.__esModule = true;

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/**
	 * A GraphicsData object.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var GraphicsData = function () {
	  /**
	   *
	   * @param {number} lineWidth - the width of the line to draw
	   * @param {number} lineColor - the color of the line to draw
	   * @param {number} lineAlpha - the alpha of the line to draw
	   * @param {number} fillColor - the color of the fill
	   * @param {number} fillAlpha - the alpha of the fill
	   * @param {boolean} fill - whether or not the shape is filled with a colour
	   * @param {boolean} nativeLines - the method for drawing lines
	   * @param {PIXI.Circle|PIXI.Rectangle|PIXI.Ellipse|PIXI.Polygon} shape - The shape object to draw.
	   * @param {number} lineAlignment - the alignment of the line.
	   */
	  function GraphicsData(lineWidth, lineColor, lineAlpha, fillColor, fillAlpha, fill, nativeLines, shape, lineAlignment) {
	    _classCallCheck(this, GraphicsData);

	    /**
	     * the width of the line to draw
	     * @member {number}
	     */
	    this.lineWidth = lineWidth;

	    /**
	     * The alignment of any lines drawn (0.5 = middle, 1 = outter, 0 = inner).
	     *
	     * @member {number}
	     * @default 0
	     */
	    this.lineAlignment = lineAlignment;

	    /**
	     * if true the liens will be draw using LINES instead of TRIANGLE_STRIP
	     * @member {boolean}
	     */
	    this.nativeLines = nativeLines;

	    /**
	     * the color of the line to draw
	     * @member {number}
	     */
	    this.lineColor = lineColor;

	    /**
	     * the alpha of the line to draw
	     * @member {number}
	     */
	    this.lineAlpha = lineAlpha;

	    /**
	     * cached tint of the line to draw
	     * @member {number}
	     * @private
	     */
	    this._lineTint = lineColor;

	    /**
	     * the color of the fill
	     * @member {number}
	     */
	    this.fillColor = fillColor;

	    /**
	     * the alpha of the fill
	     * @member {number}
	     */
	    this.fillAlpha = fillAlpha;

	    /**
	     * cached tint of the fill
	     * @member {number}
	     * @private
	     */
	    this._fillTint = fillColor;

	    /**
	     * whether or not the shape is filled with a colour
	     * @member {boolean}
	     */
	    this.fill = fill;

	    this.holes = [];

	    /**
	     * The shape object to draw.
	     * @member {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle}
	     */
	    this.shape = shape;

	    /**
	     * The type of the shape, see the Const.Shapes file for all the existing types,
	     * @member {number}
	     */
	    this.type = shape.type;
	  }

	  /**
	   * Creates a new GraphicsData object with the same values as this one.
	   *
	   * @return {PIXI.GraphicsData} Cloned GraphicsData object
	   */


	  GraphicsData.prototype.clone = function clone() {
	    return new GraphicsData(this.lineWidth, this.lineColor, this.lineAlpha, this.fillColor, this.fillAlpha, this.fill, this.nativeLines, this.shape);
	  };

	  /**
	   * Adds a hole to the shape.
	   *
	   * @param {PIXI.Rectangle|PIXI.Circle} shape - The shape of the hole.
	   */


	  GraphicsData.prototype.addHole = function addHole(shape) {
	    this.holes.push(shape);
	  };

	  /**
	   * Destroys the Graphics data.
	   */


	  GraphicsData.prototype.destroy = function destroy() {
	    this.shape = null;
	    this.holes = null;
	  };

	  return GraphicsData;
	}();

	exports.default = GraphicsData;
	//# sourceMappingURL=GraphicsData.js.map

/***/ }),
/* 279 */
/***/ (function(module, exports) {

	"use strict";

	exports.__esModule = true;
	exports.default = bezierCurveTo;
	/**
	 * Calculate the points for a bezier curve and then draws it.
	 *
	 * Ignored from docs since it is not directly exposed.
	 *
	 * @ignore
	 * @param {number} fromX - Starting point x
	 * @param {number} fromY - Starting point y
	 * @param {number} cpX - Control point x
	 * @param {number} cpY - Control point y
	 * @param {number} cpX2 - Second Control point x
	 * @param {number} cpY2 - Second Control point y
	 * @param {number} toX - Destination point x
	 * @param {number} toY - Destination point y
	 * @param {number} n - Number of segments approximating the bezier curve
	 * @param {number[]} [path=[]] - Path array to push points into
	 * @return {number[]} Array of points of the curve
	 */
	function bezierCurveTo(fromX, fromY, cpX, cpY, cpX2, cpY2, toX, toY, n) {
	    var path = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : [];

	    var dt = 0;
	    var dt2 = 0;
	    var dt3 = 0;
	    var t2 = 0;
	    var t3 = 0;

	    path.push(fromX, fromY);

	    for (var i = 1, j = 0; i <= n; ++i) {
	        j = i / n;

	        dt = 1 - j;
	        dt2 = dt * dt;
	        dt3 = dt2 * dt;

	        t2 = j * j;
	        t3 = t2 * j;

	        path.push(dt3 * fromX + 3 * dt2 * j * cpX + 3 * dt * t2 * cpX2 + t3 * toX, dt3 * fromY + 3 * dt2 * j * cpY + 3 * dt * t2 * cpY2 + t3 * toY);
	    }

	    return path;
	}
	//# sourceMappingURL=bezierCurveTo.js.map

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _utils = __webpack_require__(213);

	var _const = __webpack_require__(174);

	var _ObjectRenderer2 = __webpack_require__(245);

	var _ObjectRenderer3 = _interopRequireDefault(_ObjectRenderer2);

	var _WebGLRenderer = __webpack_require__(247);

	var _WebGLRenderer2 = _interopRequireDefault(_WebGLRenderer);

	var _WebGLGraphicsData = __webpack_require__(281);

	var _WebGLGraphicsData2 = _interopRequireDefault(_WebGLGraphicsData);

	var _PrimitiveShader = __webpack_require__(282);

	var _PrimitiveShader2 = _interopRequireDefault(_PrimitiveShader);

	var _buildPoly = __webpack_require__(283);

	var _buildPoly2 = _interopRequireDefault(_buildPoly);

	var _buildRectangle = __webpack_require__(285);

	var _buildRectangle2 = _interopRequireDefault(_buildRectangle);

	var _buildRoundedRectangle = __webpack_require__(286);

	var _buildRoundedRectangle2 = _interopRequireDefault(_buildRoundedRectangle);

	var _buildCircle = __webpack_require__(287);

	var _buildCircle2 = _interopRequireDefault(_buildCircle);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	/**
	 * Renders the graphics object.
	 *
	 * @class
	 * @memberof PIXI
	 * @extends PIXI.ObjectRenderer
	 */
	var GraphicsRenderer = function (_ObjectRenderer) {
	    _inherits(GraphicsRenderer, _ObjectRenderer);

	    /**
	     * @param {PIXI.WebGLRenderer} renderer - The renderer this object renderer works for.
	     */
	    function GraphicsRenderer(renderer) {
	        _classCallCheck(this, GraphicsRenderer);

	        var _this = _possibleConstructorReturn(this, _ObjectRenderer.call(this, renderer));

	        _this.graphicsDataPool = [];

	        _this.primitiveShader = null;

	        _this.gl = renderer.gl;

	        // easy access!
	        _this.CONTEXT_UID = 0;
	        return _this;
	    }

	    /**
	     * Called when there is a WebGL context change
	     *
	     * @private
	     *
	     */


	    GraphicsRenderer.prototype.onContextChange = function onContextChange() {
	        this.gl = this.renderer.gl;
	        this.CONTEXT_UID = this.renderer.CONTEXT_UID;
	        this.primitiveShader = new _PrimitiveShader2.default(this.gl);
	    };

	    /**
	     * Destroys this renderer.
	     *
	     */


	    GraphicsRenderer.prototype.destroy = function destroy() {
	        _ObjectRenderer3.default.prototype.destroy.call(this);

	        for (var i = 0; i < this.graphicsDataPool.length; ++i) {
	            this.graphicsDataPool[i].destroy();
	        }

	        this.graphicsDataPool = null;
	    };

	    /**
	     * Renders a graphics object.
	     *
	     * @param {PIXI.Graphics} graphics - The graphics object to render.
	     */


	    GraphicsRenderer.prototype.render = function render(graphics) {
	        var renderer = this.renderer;
	        var gl = renderer.gl;

	        var webGLData = void 0;
	        var webGL = graphics._webGL[this.CONTEXT_UID];

	        if (!webGL || graphics.dirty !== webGL.dirty) {
	            this.updateGraphics(graphics);

	            webGL = graphics._webGL[this.CONTEXT_UID];
	        }

	        // This  could be speeded up for sure!
	        var shader = this.primitiveShader;

	        renderer.bindShader(shader);
	        renderer.state.setBlendMode(graphics.blendMode);

	        for (var i = 0, n = webGL.data.length; i < n; i++) {
	            webGLData = webGL.data[i];
	            var shaderTemp = webGLData.shader;

	            renderer.bindShader(shaderTemp);
	            shaderTemp.uniforms.translationMatrix = graphics.transform.worldTransform.toArray(true);
	            shaderTemp.uniforms.tint = (0, _utils.hex2rgb)(graphics.tint);
	            shaderTemp.uniforms.alpha = graphics.worldAlpha;

	            renderer.bindVao(webGLData.vao);

	            if (webGLData.nativeLines) {
	                gl.drawArrays(gl.LINES, 0, webGLData.points.length / 6);
	            } else {
	                webGLData.vao.draw(gl.TRIANGLE_STRIP, webGLData.indices.length);
	            }
	        }
	    };

	    /**
	     * Updates the graphics object
	     *
	     * @private
	     * @param {PIXI.Graphics} graphics - The graphics object to update
	     */


	    GraphicsRenderer.prototype.updateGraphics = function updateGraphics(graphics) {
	        var gl = this.renderer.gl;

	        // get the contexts graphics object
	        var webGL = graphics._webGL[this.CONTEXT_UID];

	        // if the graphics object does not exist in the webGL context time to create it!
	        if (!webGL) {
	            webGL = graphics._webGL[this.CONTEXT_UID] = { lastIndex: 0, data: [], gl: gl, clearDirty: -1, dirty: -1 };
	        }

	        // flag the graphics as not dirty as we are about to update it...
	        webGL.dirty = graphics.dirty;

	        // if the user cleared the graphics object we will need to clear every object
	        if (graphics.clearDirty !== webGL.clearDirty) {
	            webGL.clearDirty = graphics.clearDirty;

	            // loop through and return all the webGLDatas to the object pool so than can be reused later on
	            for (var i = 0; i < webGL.data.length; i++) {
	                this.graphicsDataPool.push(webGL.data[i]);
	            }

	            // clear the array and reset the index..
	            webGL.data.length = 0;
	            webGL.lastIndex = 0;
	        }

	        var webGLData = void 0;
	        var webGLDataNativeLines = void 0;

	        // loop through the graphics datas and construct each one..
	        // if the object is a complex fill then the new stencil buffer technique will be used
	        // other wise graphics objects will be pushed into a batch..
	        for (var _i = webGL.lastIndex; _i < graphics.graphicsData.length; _i++) {
	            var data = graphics.graphicsData[_i];

	            // TODO - this can be simplified
	            webGLData = this.getWebGLData(webGL, 0);

	            if (data.nativeLines && data.lineWidth) {
	                webGLDataNativeLines = this.getWebGLData(webGL, 0, true);
	                webGL.lastIndex++;
	            }

	            if (data.type === _const.SHAPES.POLY) {
	                (0, _buildPoly2.default)(data, webGLData, webGLDataNativeLines);
	            }
	            if (data.type === _const.SHAPES.RECT) {
	                (0, _buildRectangle2.default)(data, webGLData, webGLDataNativeLines);
	            } else if (data.type === _const.SHAPES.CIRC || data.type === _const.SHAPES.ELIP) {
	                (0, _buildCircle2.default)(data, webGLData, webGLDataNativeLines);
	            } else if (data.type === _const.SHAPES.RREC) {
	                (0, _buildRoundedRectangle2.default)(data, webGLData, webGLDataNativeLines);
	            }

	            webGL.lastIndex++;
	        }

	        this.renderer.bindVao(null);

	        // upload all the dirty data...
	        for (var _i2 = 0; _i2 < webGL.data.length; _i2++) {
	            webGLData = webGL.data[_i2];

	            if (webGLData.dirty) {
	                webGLData.upload();
	            }
	        }
	    };

	    /**
	     *
	     * @private
	     * @param {WebGLRenderingContext} gl - the current WebGL drawing context
	     * @param {number} type - TODO @Alvin
	     * @param {number} nativeLines - indicate whether the webGLData use for nativeLines.
	     * @return {*} TODO
	     */


	    GraphicsRenderer.prototype.getWebGLData = function getWebGLData(gl, type, nativeLines) {
	        var webGLData = gl.data[gl.data.length - 1];

	        if (!webGLData || webGLData.nativeLines !== nativeLines || webGLData.points.length > 320000) {
	            webGLData = this.graphicsDataPool.pop() || new _WebGLGraphicsData2.default(this.renderer.gl, this.primitiveShader, this.renderer.state.attribsState);
	            webGLData.nativeLines = nativeLines;
	            webGLData.reset(type);
	            gl.data.push(webGLData);
	        }

	        webGLData.dirty = true;

	        return webGLData;
	    };

	    return GraphicsRenderer;
	}(_ObjectRenderer3.default);

	exports.default = GraphicsRenderer;


	_WebGLRenderer2.default.registerPlugin('graphics', GraphicsRenderer);
	//# sourceMappingURL=GraphicsRenderer.js.map

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _pixiGlCore = __webpack_require__(185);

	var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/**
	 * An object containing WebGL specific properties to be used by the WebGL renderer
	 *
	 * @class
	 * @private
	 * @memberof PIXI
	 */
	var WebGLGraphicsData = function () {
	  /**
	   * @param {WebGLRenderingContext} gl - The current WebGL drawing context
	   * @param {PIXI.Shader} shader - The shader
	   * @param {object} attribsState - The state for the VAO
	   */
	  function WebGLGraphicsData(gl, shader, attribsState) {
	    _classCallCheck(this, WebGLGraphicsData);

	    /**
	     * The current WebGL drawing context
	     *
	     * @member {WebGLRenderingContext}
	     */
	    this.gl = gl;

	    // TODO does this need to be split before uploading??
	    /**
	     * An array of color components (r,g,b)
	     * @member {number[]}
	     */
	    this.color = [0, 0, 0]; // color split!

	    /**
	     * An array of points to draw
	     * @member {PIXI.Point[]}
	     */
	    this.points = [];

	    /**
	     * The indices of the vertices
	     * @member {number[]}
	     */
	    this.indices = [];
	    /**
	     * The main buffer
	     * @member {WebGLBuffer}
	     */
	    this.buffer = _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl);

	    /**
	     * The index buffer
	     * @member {WebGLBuffer}
	     */
	    this.indexBuffer = _pixiGlCore2.default.GLBuffer.createIndexBuffer(gl);

	    /**
	     * Whether this graphics is dirty or not
	     * @member {boolean}
	     */
	    this.dirty = true;

	    /**
	     * Whether this graphics is nativeLines or not
	     * @member {boolean}
	     */
	    this.nativeLines = false;

	    this.glPoints = null;
	    this.glIndices = null;

	    /**
	     *
	     * @member {PIXI.Shader}
	     */
	    this.shader = shader;

	    this.vao = new _pixiGlCore2.default.VertexArrayObject(gl, attribsState).addIndex(this.indexBuffer).addAttribute(this.buffer, shader.attributes.aVertexPosition, gl.FLOAT, false, 4 * 6, 0).addAttribute(this.buffer, shader.attributes.aColor, gl.FLOAT, false, 4 * 6, 2 * 4);
	  }

	  /**
	   * Resets the vertices and the indices
	   */


	  WebGLGraphicsData.prototype.reset = function reset() {
	    this.points.length = 0;
	    this.indices.length = 0;
	  };

	  /**
	   * Binds the buffers and uploads the data
	   */


	  WebGLGraphicsData.prototype.upload = function upload() {
	    this.glPoints = new Float32Array(this.points);
	    this.buffer.upload(this.glPoints);

	    this.glIndices = new Uint16Array(this.indices);
	    this.indexBuffer.upload(this.glIndices);

	    this.dirty = false;
	  };

	  /**
	   * Empties all the data
	   */


	  WebGLGraphicsData.prototype.destroy = function destroy() {
	    this.color = null;
	    this.points = null;
	    this.indices = null;

	    this.vao.destroy();
	    this.buffer.destroy();
	    this.indexBuffer.destroy();

	    this.gl = null;

	    this.buffer = null;
	    this.indexBuffer = null;

	    this.glPoints = null;
	    this.glIndices = null;
	  };

	  return WebGLGraphicsData;
	}();

	exports.default = WebGLGraphicsData;
	//# sourceMappingURL=WebGLGraphicsData.js.map

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _Shader2 = __webpack_require__(262);

	var _Shader3 = _interopRequireDefault(_Shader2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	/**
	 * This shader is used to draw simple primitive shapes for {@link PIXI.Graphics}.
	 *
	 * @class
	 * @memberof PIXI
	 * @extends PIXI.Shader
	 */
	var PrimitiveShader = function (_Shader) {
	    _inherits(PrimitiveShader, _Shader);

	    /**
	     * @param {WebGLRenderingContext} gl - The webgl shader manager this shader works for.
	     */
	    function PrimitiveShader(gl) {
	        _classCallCheck(this, PrimitiveShader);

	        return _possibleConstructorReturn(this, _Shader.call(this, gl,
	        // vertex shader
	        ['attribute vec2 aVertexPosition;', 'attribute vec4 aColor;', 'uniform mat3 translationMatrix;', 'uniform mat3 projectionMatrix;', 'uniform float alpha;', 'uniform vec3 tint;', 'varying vec4 vColor;', 'void main(void){', '   gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);', '   vColor = aColor * vec4(tint * alpha, alpha);', '}'].join('\n'),
	        // fragment shader
	        ['varying vec4 vColor;', 'void main(void){', '   gl_FragColor = vColor;', '}'].join('\n')));
	    }

	    return PrimitiveShader;
	}(_Shader3.default);

	exports.default = PrimitiveShader;
	//# sourceMappingURL=PrimitiveShader.js.map

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;
	exports.default = buildPoly;

	var _buildLine = __webpack_require__(284);

	var _buildLine2 = _interopRequireDefault(_buildLine);

	var _utils = __webpack_require__(213);

	var _earcut = __webpack_require__(218);

	var _earcut2 = _interopRequireDefault(_earcut);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/**
	 * Builds a polygon to draw
	 *
	 * Ignored from docs since it is not directly exposed.
	 *
	 * @ignore
	 * @private
	 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object containing all the necessary properties
	 * @param {object} webGLData - an object containing all the webGL-specific information to create this shape
	 * @param {object} webGLDataNativeLines - an object containing all the webGL-specific information to create nativeLines
	 */
	function buildPoly(graphicsData, webGLData, webGLDataNativeLines) {
	    graphicsData.points = graphicsData.shape.points.slice();

	    var points = graphicsData.points;

	    if (graphicsData.fill && points.length >= 6) {
	        var holeArray = [];
	        // Process holes..
	        var holes = graphicsData.holes;

	        for (var i = 0; i < holes.length; i++) {
	            var hole = holes[i];

	            holeArray.push(points.length / 2);

	            points = points.concat(hole.points);
	        }

	        // get first and last point.. figure out the middle!
	        var verts = webGLData.points;
	        var indices = webGLData.indices;

	        var length = points.length / 2;

	        // sort color
	        var color = (0, _utils.hex2rgb)(graphicsData.fillColor);
	        var alpha = graphicsData.fillAlpha;
	        var r = color[0] * alpha;
	        var g = color[1] * alpha;
	        var b = color[2] * alpha;

	        var triangles = (0, _earcut2.default)(points, holeArray, 2);

	        if (!triangles) {
	            return;
	        }

	        var vertPos = verts.length / 6;

	        for (var _i = 0; _i < triangles.length; _i += 3) {
	            indices.push(triangles[_i] + vertPos);
	            indices.push(triangles[_i] + vertPos);
	            indices.push(triangles[_i + 1] + vertPos);
	            indices.push(triangles[_i + 2] + vertPos);
	            indices.push(triangles[_i + 2] + vertPos);
	        }

	        for (var _i2 = 0; _i2 < length; _i2++) {
	            verts.push(points[_i2 * 2], points[_i2 * 2 + 1], r, g, b, alpha);
	        }
	    }

	    if (graphicsData.lineWidth > 0) {
	        (0, _buildLine2.default)(graphicsData, webGLData, webGLDataNativeLines);
	    }
	}
	//# sourceMappingURL=buildPoly.js.map

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	exports.default = function (graphicsData, webGLData, webGLDataNativeLines) {
	    if (graphicsData.nativeLines) {
	        buildNativeLine(graphicsData, webGLDataNativeLines);
	    } else {
	        buildLine(graphicsData, webGLData);
	    }
	};

	var _math = __webpack_require__(175);

	var _utils = __webpack_require__(213);

	/**
	 * Builds a line to draw using the poligon method.
	 *
	 * Ignored from docs since it is not directly exposed.
	 *
	 * @ignore
	 * @private
	 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object containing all the necessary properties
	 * @param {object} webGLData - an object containing all the webGL-specific information to create this shape
	 */
	function buildLine(graphicsData, webGLData) {
	    // TODO OPTIMISE!
	    var points = graphicsData.points;

	    if (points.length === 0) {
	        return;
	    }
	    // if the line width is an odd number add 0.5 to align to a whole pixel
	    // commenting this out fixes #711 and #1620
	    // if (graphicsData.lineWidth%2)
	    // {
	    //     for (i = 0; i < points.length; i++)
	    //     {
	    //         points[i] += 0.5;
	    //     }
	    // }

	    // get first and last point.. figure out the middle!
	    var firstPoint = new _math.Point(points[0], points[1]);
	    var lastPoint = new _math.Point(points[points.length - 2], points[points.length - 1]);

	    // if the first point is the last point - gonna have issues :)
	    if (firstPoint.x === lastPoint.x && firstPoint.y === lastPoint.y) {
	        // need to clone as we are going to slightly modify the shape..
	        points = points.slice();

	        points.pop();
	        points.pop();

	        lastPoint = new _math.Point(points[points.length - 2], points[points.length - 1]);

	        var midPointX = lastPoint.x + (firstPoint.x - lastPoint.x) * 0.5;
	        var midPointY = lastPoint.y + (firstPoint.y - lastPoint.y) * 0.5;

	        points.unshift(midPointX, midPointY);
	        points.push(midPointX, midPointY);
	    }

	    var verts = webGLData.points;
	    var indices = webGLData.indices;
	    var length = points.length / 2;
	    var indexCount = points.length;
	    var indexStart = verts.length / 6;

	    // DRAW the Line
	    var width = graphicsData.lineWidth / 2;

	    // sort color
	    var color = (0, _utils.hex2rgb)(graphicsData.lineColor);
	    var alpha = graphicsData.lineAlpha;
	    var r = color[0] * alpha;
	    var g = color[1] * alpha;
	    var b = color[2] * alpha;

	    var p1x = points[0];
	    var p1y = points[1];
	    var p2x = points[2];
	    var p2y = points[3];
	    var p3x = 0;
	    var p3y = 0;

	    var perpx = -(p1y - p2y);
	    var perpy = p1x - p2x;
	    var perp2x = 0;
	    var perp2y = 0;
	    var perp3x = 0;
	    var perp3y = 0;

	    var dist = Math.sqrt(perpx * perpx + perpy * perpy);

	    perpx /= dist;
	    perpy /= dist;
	    perpx *= width;
	    perpy *= width;

	    var ratio = graphicsData.lineAlignment; // 0.5;
	    var r1 = (1 - ratio) * 2;
	    var r2 = ratio * 2;

	    // start
	    verts.push(p1x - perpx * r1, p1y - perpy * r1, r, g, b, alpha);

	    verts.push(p1x + perpx * r2, p1y + perpy * r2, r, g, b, alpha);

	    for (var i = 1; i < length - 1; ++i) {
	        p1x = points[(i - 1) * 2];
	        p1y = points[(i - 1) * 2 + 1];

	        p2x = points[i * 2];
	        p2y = points[i * 2 + 1];

	        p3x = points[(i + 1) * 2];
	        p3y = points[(i + 1) * 2 + 1];

	        perpx = -(p1y - p2y);
	        perpy = p1x - p2x;

	        dist = Math.sqrt(perpx * perpx + perpy * perpy);
	        perpx /= dist;
	        perpy /= dist;
	        perpx *= width;
	        perpy *= width;

	        perp2x = -(p2y - p3y);
	        perp2y = p2x - p3x;

	        dist = Math.sqrt(perp2x * perp2x + perp2y * perp2y);
	        perp2x /= dist;
	        perp2y /= dist;
	        perp2x *= width;
	        perp2y *= width;

	        var a1 = -perpy + p1y - (-perpy + p2y);
	        var b1 = -perpx + p2x - (-perpx + p1x);
	        var c1 = (-perpx + p1x) * (-perpy + p2y) - (-perpx + p2x) * (-perpy + p1y);
	        var a2 = -perp2y + p3y - (-perp2y + p2y);
	        var b2 = -perp2x + p2x - (-perp2x + p3x);
	        var c2 = (-perp2x + p3x) * (-perp2y + p2y) - (-perp2x + p2x) * (-perp2y + p3y);

	        var denom = a1 * b2 - a2 * b1;

	        if (Math.abs(denom) < 0.1) {
	            denom += 10.1;
	            verts.push(p2x - perpx * r1, p2y - perpy * r1, r, g, b, alpha);

	            verts.push(p2x + perpx * r2, p2y + perpy * r2, r, g, b, alpha);

	            continue;
	        }

	        var px = (b1 * c2 - b2 * c1) / denom;
	        var py = (a2 * c1 - a1 * c2) / denom;
	        var pdist = (px - p2x) * (px - p2x) + (py - p2y) * (py - p2y);

	        if (pdist > 196 * width * width) {
	            perp3x = perpx - perp2x;
	            perp3y = perpy - perp2y;

	            dist = Math.sqrt(perp3x * perp3x + perp3y * perp3y);
	            perp3x /= dist;
	            perp3y /= dist;
	            perp3x *= width;
	            perp3y *= width;

	            verts.push(p2x - perp3x * r1, p2y - perp3y * r1);
	            verts.push(r, g, b, alpha);

	            verts.push(p2x + perp3x * r2, p2y + perp3y * r2);
	            verts.push(r, g, b, alpha);

	            verts.push(p2x - perp3x * r2 * r1, p2y - perp3y * r1);
	            verts.push(r, g, b, alpha);

	            indexCount++;
	        } else {
	            verts.push(p2x + (px - p2x) * r1, p2y + (py - p2y) * r1);
	            verts.push(r, g, b, alpha);

	            verts.push(p2x - (px - p2x) * r2, p2y - (py - p2y) * r2);
	            verts.push(r, g, b, alpha);
	        }
	    }

	    p1x = points[(length - 2) * 2];
	    p1y = points[(length - 2) * 2 + 1];

	    p2x = points[(length - 1) * 2];
	    p2y = points[(length - 1) * 2 + 1];

	    perpx = -(p1y - p2y);
	    perpy = p1x - p2x;

	    dist = Math.sqrt(perpx * perpx + perpy * perpy);
	    perpx /= dist;
	    perpy /= dist;
	    perpx *= width;
	    perpy *= width;

	    verts.push(p2x - perpx * r1, p2y - perpy * r1);
	    verts.push(r, g, b, alpha);

	    verts.push(p2x + perpx * r2, p2y + perpy * r2);
	    verts.push(r, g, b, alpha);

	    indices.push(indexStart);

	    for (var _i = 0; _i < indexCount; ++_i) {
	        indices.push(indexStart++);
	    }

	    indices.push(indexStart - 1);
	}

	/**
	 * Builds a line to draw using the gl.drawArrays(gl.LINES) method
	 *
	 * Ignored from docs since it is not directly exposed.
	 *
	 * @ignore
	 * @private
	 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object containing all the necessary properties
	 * @param {object} webGLData - an object containing all the webGL-specific information to create this shape
	 */


	/**
	 * Builds a line to draw
	 *
	 * Ignored from docs since it is not directly exposed.
	 *
	 * @ignore
	 * @private
	 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object containing all the necessary properties
	 * @param {object} webGLData - an object containing all the webGL-specific information to create this shape
	 * @param {object} webGLDataNativeLines - an object containing all the webGL-specific information to create nativeLines
	 */
	function buildNativeLine(graphicsData, webGLData) {
	    var i = 0;
	    var points = graphicsData.points;

	    if (points.length === 0) return;

	    var verts = webGLData.points;
	    var length = points.length / 2;

	    // sort color
	    var color = (0, _utils.hex2rgb)(graphicsData.lineColor);
	    var alpha = graphicsData.lineAlpha;
	    var r = color[0] * alpha;
	    var g = color[1] * alpha;
	    var b = color[2] * alpha;

	    for (i = 1; i < length; i++) {
	        var p1x = points[(i - 1) * 2];
	        var p1y = points[(i - 1) * 2 + 1];

	        var p2x = points[i * 2];
	        var p2y = points[i * 2 + 1];

	        verts.push(p1x, p1y);
	        verts.push(r, g, b, alpha);

	        verts.push(p2x, p2y);
	        verts.push(r, g, b, alpha);
	    }
	}
	//# sourceMappingURL=buildLine.js.map

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;
	exports.default = buildRectangle;

	var _buildLine = __webpack_require__(284);

	var _buildLine2 = _interopRequireDefault(_buildLine);

	var _utils = __webpack_require__(213);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/**
	 * Builds a rectangle to draw
	 *
	 * Ignored from docs since it is not directly exposed.
	 *
	 * @ignore
	 * @private
	 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object containing all the necessary properties
	 * @param {object} webGLData - an object containing all the webGL-specific information to create this shape
	 * @param {object} webGLDataNativeLines - an object containing all the webGL-specific information to create nativeLines
	 */
	function buildRectangle(graphicsData, webGLData, webGLDataNativeLines) {
	    // --- //
	    // need to convert points to a nice regular data
	    //
	    var rectData = graphicsData.shape;
	    var x = rectData.x;
	    var y = rectData.y;
	    var width = rectData.width;
	    var height = rectData.height;

	    if (graphicsData.fill) {
	        var color = (0, _utils.hex2rgb)(graphicsData.fillColor);
	        var alpha = graphicsData.fillAlpha;

	        var r = color[0] * alpha;
	        var g = color[1] * alpha;
	        var b = color[2] * alpha;

	        var verts = webGLData.points;
	        var indices = webGLData.indices;

	        var vertPos = verts.length / 6;

	        // start
	        verts.push(x, y);
	        verts.push(r, g, b, alpha);

	        verts.push(x + width, y);
	        verts.push(r, g, b, alpha);

	        verts.push(x, y + height);
	        verts.push(r, g, b, alpha);

	        verts.push(x + width, y + height);
	        verts.push(r, g, b, alpha);

	        // insert 2 dead triangles..
	        indices.push(vertPos, vertPos, vertPos + 1, vertPos + 2, vertPos + 3, vertPos + 3);
	    }

	    if (graphicsData.lineWidth) {
	        var tempPoints = graphicsData.points;

	        graphicsData.points = [x, y, x + width, y, x + width, y + height, x, y + height, x, y];

	        (0, _buildLine2.default)(graphicsData, webGLData, webGLDataNativeLines);

	        graphicsData.points = tempPoints;
	    }
	}
	//# sourceMappingURL=buildRectangle.js.map

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;
	exports.default = buildRoundedRectangle;

	var _earcut = __webpack_require__(218);

	var _earcut2 = _interopRequireDefault(_earcut);

	var _buildLine = __webpack_require__(284);

	var _buildLine2 = _interopRequireDefault(_buildLine);

	var _utils = __webpack_require__(213);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/**
	 * Builds a rounded rectangle to draw
	 *
	 * Ignored from docs since it is not directly exposed.
	 *
	 * @ignore
	 * @private
	 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object containing all the necessary properties
	 * @param {object} webGLData - an object containing all the webGL-specific information to create this shape
	 * @param {object} webGLDataNativeLines - an object containing all the webGL-specific information to create nativeLines
	 */
	function buildRoundedRectangle(graphicsData, webGLData, webGLDataNativeLines) {
	    var rrectData = graphicsData.shape;
	    var x = rrectData.x;
	    var y = rrectData.y;
	    var width = rrectData.width;
	    var height = rrectData.height;

	    var radius = rrectData.radius;

	    var recPoints = [];

	    recPoints.push(x, y + radius);
	    quadraticBezierCurve(x, y + height - radius, x, y + height, x + radius, y + height, recPoints);
	    quadraticBezierCurve(x + width - radius, y + height, x + width, y + height, x + width, y + height - radius, recPoints);
	    quadraticBezierCurve(x + width, y + radius, x + width, y, x + width - radius, y, recPoints);
	    quadraticBezierCurve(x + radius, y, x, y, x, y + radius + 0.0000000001, recPoints);

	    // this tiny number deals with the issue that occurs when points overlap and earcut fails to triangulate the item.
	    // TODO - fix this properly, this is not very elegant.. but it works for now.

	    if (graphicsData.fill) {
	        var color = (0, _utils.hex2rgb)(graphicsData.fillColor);
	        var alpha = graphicsData.fillAlpha;

	        var r = color[0] * alpha;
	        var g = color[1] * alpha;
	        var b = color[2] * alpha;

	        var verts = webGLData.points;
	        var indices = webGLData.indices;

	        var vecPos = verts.length / 6;

	        var triangles = (0, _earcut2.default)(recPoints, null, 2);

	        for (var i = 0, j = triangles.length; i < j; i += 3) {
	            indices.push(triangles[i] + vecPos);
	            indices.push(triangles[i] + vecPos);
	            indices.push(triangles[i + 1] + vecPos);
	            indices.push(triangles[i + 2] + vecPos);
	            indices.push(triangles[i + 2] + vecPos);
	        }

	        for (var _i = 0, _j = recPoints.length; _i < _j; _i++) {
	            verts.push(recPoints[_i], recPoints[++_i], r, g, b, alpha);
	        }
	    }

	    if (graphicsData.lineWidth) {
	        var tempPoints = graphicsData.points;

	        graphicsData.points = recPoints;

	        (0, _buildLine2.default)(graphicsData, webGLData, webGLDataNativeLines);

	        graphicsData.points = tempPoints;
	    }
	}

	/**
	 * Calculate a single point for a quadratic bezier curve.
	 * Utility function used by quadraticBezierCurve.
	 * Ignored from docs since it is not directly exposed.
	 *
	 * @ignore
	 * @private
	 * @param {number} n1 - first number
	 * @param {number} n2 - second number
	 * @param {number} perc - percentage
	 * @return {number} the result
	 *
	 */
	function getPt(n1, n2, perc) {
	    var diff = n2 - n1;

	    return n1 + diff * perc;
	}

	/**
	 * Calculate the points for a quadratic bezier curve. (helper function..)
	 * Based on: https://stackoverflow.com/questions/785097/how-do-i-implement-a-bezier-curve-in-c
	 *
	 * Ignored from docs since it is not directly exposed.
	 *
	 * @ignore
	 * @private
	 * @param {number} fromX - Origin point x
	 * @param {number} fromY - Origin point x
	 * @param {number} cpX - Control point x
	 * @param {number} cpY - Control point y
	 * @param {number} toX - Destination point x
	 * @param {number} toY - Destination point y
	 * @param {number[]} [out=[]] - The output array to add points into. If not passed, a new array is created.
	 * @return {number[]} an array of points
	 */
	function quadraticBezierCurve(fromX, fromY, cpX, cpY, toX, toY) {
	    var out = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];

	    var n = 20;
	    var points = out;

	    var xa = 0;
	    var ya = 0;
	    var xb = 0;
	    var yb = 0;
	    var x = 0;
	    var y = 0;

	    for (var i = 0, j = 0; i <= n; ++i) {
	        j = i / n;

	        // The Green Line
	        xa = getPt(fromX, cpX, j);
	        ya = getPt(fromY, cpY, j);
	        xb = getPt(cpX, toX, j);
	        yb = getPt(cpY, toY, j);

	        // The Black Dot
	        x = getPt(xa, xb, j);
	        y = getPt(ya, yb, j);

	        points.push(x, y);
	    }

	    return points;
	}
	//# sourceMappingURL=buildRoundedRectangle.js.map

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;
	exports.default = buildCircle;

	var _buildLine = __webpack_require__(284);

	var _buildLine2 = _interopRequireDefault(_buildLine);

	var _const = __webpack_require__(174);

	var _utils = __webpack_require__(213);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/**
	 * Builds a circle to draw
	 *
	 * Ignored from docs since it is not directly exposed.
	 *
	 * @ignore
	 * @private
	 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object to draw
	 * @param {object} webGLData - an object containing all the webGL-specific information to create this shape
	 * @param {object} webGLDataNativeLines - an object containing all the webGL-specific information to create nativeLines
	 */
	function buildCircle(graphicsData, webGLData, webGLDataNativeLines) {
	    // need to convert points to a nice regular data
	    var circleData = graphicsData.shape;
	    var x = circleData.x;
	    var y = circleData.y;
	    var width = void 0;
	    var height = void 0;

	    // TODO - bit hacky??
	    if (graphicsData.type === _const.SHAPES.CIRC) {
	        width = circleData.radius;
	        height = circleData.radius;
	    } else {
	        width = circleData.width;
	        height = circleData.height;
	    }

	    if (width === 0 || height === 0) {
	        return;
	    }

	    var totalSegs = Math.floor(30 * Math.sqrt(circleData.radius)) || Math.floor(15 * Math.sqrt(circleData.width + circleData.height));

	    var seg = Math.PI * 2 / totalSegs;

	    if (graphicsData.fill) {
	        var color = (0, _utils.hex2rgb)(graphicsData.fillColor);
	        var alpha = graphicsData.fillAlpha;

	        var r = color[0] * alpha;
	        var g = color[1] * alpha;
	        var b = color[2] * alpha;

	        var verts = webGLData.points;
	        var indices = webGLData.indices;

	        var vecPos = verts.length / 6;

	        indices.push(vecPos);

	        for (var i = 0; i < totalSegs + 1; i++) {
	            verts.push(x, y, r, g, b, alpha);

	            verts.push(x + Math.sin(seg * i) * width, y + Math.cos(seg * i) * height, r, g, b, alpha);

	            indices.push(vecPos++, vecPos++);
	        }

	        indices.push(vecPos - 1);
	    }

	    if (graphicsData.lineWidth) {
	        var tempPoints = graphicsData.points;

	        graphicsData.points = [];

	        for (var _i = 0; _i < totalSegs; _i++) {
	            graphicsData.points.push(x + Math.sin(seg * -_i) * width, y + Math.cos(seg * -_i) * height);
	        }

	        graphicsData.points.push(graphicsData.points[0], graphicsData.points[1]);

	        (0, _buildLine2.default)(graphicsData, webGLData, webGLDataNativeLines);

	        graphicsData.points = tempPoints;
	    }
	}
	//# sourceMappingURL=buildCircle.js.map

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _CanvasRenderer = __webpack_require__(235);

	var _CanvasRenderer2 = _interopRequireDefault(_CanvasRenderer);

	var _const = __webpack_require__(174);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/**
	 * @author Mat Groves
	 *
	 * Big thanks to the very clever Matt DesLauriers <mattdesl> https://github.com/mattdesl/
	 * for creating the original PixiJS version!
	 * Also a thanks to https://github.com/bchevalier for tweaking the tint and alpha so that they
	 * now share 4 bytes on the vertex buffer
	 *
	 * Heavily inspired by LibGDX's CanvasGraphicsRenderer:
	 * https://github.com/libgdx/libgdx/blob/1.0.0/gdx/src/com/badlogic/gdx/graphics/glutils/ShapeRenderer.java
	 */

	/**
	 * Renderer dedicated to drawing and batching graphics objects.
	 *
	 * @class
	 * @private
	 * @memberof PIXI
	 */
	var CanvasGraphicsRenderer = function () {
	    /**
	     * @param {PIXI.CanvasRenderer} renderer - The current PIXI renderer.
	     */
	    function CanvasGraphicsRenderer(renderer) {
	        _classCallCheck(this, CanvasGraphicsRenderer);

	        this.renderer = renderer;
	    }

	    /**
	     * Renders a Graphics object to a canvas.
	     *
	     * @param {PIXI.Graphics} graphics - the actual graphics object to render
	     */


	    CanvasGraphicsRenderer.prototype.render = function render(graphics) {
	        var renderer = this.renderer;
	        var context = renderer.context;
	        var worldAlpha = graphics.worldAlpha;
	        var transform = graphics.transform.worldTransform;
	        var resolution = renderer.resolution;

	        context.setTransform(transform.a * resolution, transform.b * resolution, transform.c * resolution, transform.d * resolution, transform.tx * resolution, transform.ty * resolution);

	        // update tint if graphics was dirty
	        if (graphics.canvasTintDirty !== graphics.dirty || graphics._prevTint !== graphics.tint) {
	            this.updateGraphicsTint(graphics);
	        }

	        renderer.setBlendMode(graphics.blendMode);

	        for (var i = 0; i < graphics.graphicsData.length; i++) {
	            var data = graphics.graphicsData[i];
	            var shape = data.shape;

	            var fillColor = data._fillTint;
	            var lineColor = data._lineTint;

	            context.lineWidth = data.lineWidth;

	            if (data.type === _const.SHAPES.POLY) {
	                context.beginPath();

	                this.renderPolygon(shape.points, shape.closed, context);

	                for (var j = 0; j < data.holes.length; j++) {
	                    this.renderPolygon(data.holes[j].points, true, context);
	                }

	                if (data.fill) {
	                    context.globalAlpha = data.fillAlpha * worldAlpha;
	                    context.fillStyle = '#' + ('00000' + (fillColor | 0).toString(16)).substr(-6);
	                    context.fill();
	                }
	                if (data.lineWidth) {
	                    context.globalAlpha = data.lineAlpha * worldAlpha;
	                    context.strokeStyle = '#' + ('00000' + (lineColor | 0).toString(16)).substr(-6);
	                    context.stroke();
	                }
	            } else if (data.type === _const.SHAPES.RECT) {
	                if (data.fillColor || data.fillColor === 0) {
	                    context.globalAlpha = data.fillAlpha * worldAlpha;
	                    context.fillStyle = '#' + ('00000' + (fillColor | 0).toString(16)).substr(-6);
	                    context.fillRect(shape.x, shape.y, shape.width, shape.height);
	                }
	                if (data.lineWidth) {
	                    context.globalAlpha = data.lineAlpha * worldAlpha;
	                    context.strokeStyle = '#' + ('00000' + (lineColor | 0).toString(16)).substr(-6);
	                    context.strokeRect(shape.x, shape.y, shape.width, shape.height);
	                }
	            } else if (data.type === _const.SHAPES.CIRC) {
	                // TODO - need to be Undefined!
	                context.beginPath();
	                context.arc(shape.x, shape.y, shape.radius, 0, 2 * Math.PI);
	                context.closePath();

	                if (data.fill) {
	                    context.globalAlpha = data.fillAlpha * worldAlpha;
	                    context.fillStyle = '#' + ('00000' + (fillColor | 0).toString(16)).substr(-6);
	                    context.fill();
	                }
	                if (data.lineWidth) {
	                    context.globalAlpha = data.lineAlpha * worldAlpha;
	                    context.strokeStyle = '#' + ('00000' + (lineColor | 0).toString(16)).substr(-6);
	                    context.stroke();
	                }
	            } else if (data.type === _const.SHAPES.ELIP) {
	                // ellipse code taken from: http://stackoverflow.com/questions/2172798/how-to-draw-an-oval-in-html5-canvas

	                var w = shape.width * 2;
	                var h = shape.height * 2;

	                var x = shape.x - w / 2;
	                var y = shape.y - h / 2;

	                context.beginPath();

	                var kappa = 0.5522848;
	                var ox = w / 2 * kappa; // control point offset horizontal
	                var oy = h / 2 * kappa; // control point offset vertical
	                var xe = x + w; // x-end
	                var ye = y + h; // y-end
	                var xm = x + w / 2; // x-middle
	                var ym = y + h / 2; // y-middle

	                context.moveTo(x, ym);
	                context.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
	                context.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
	                context.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
	                context.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);

	                context.closePath();

	                if (data.fill) {
	                    context.globalAlpha = data.fillAlpha * worldAlpha;
	                    context.fillStyle = '#' + ('00000' + (fillColor | 0).toString(16)).substr(-6);
	                    context.fill();
	                }
	                if (data.lineWidth) {
	                    context.globalAlpha = data.lineAlpha * worldAlpha;
	                    context.strokeStyle = '#' + ('00000' + (lineColor | 0).toString(16)).substr(-6);
	                    context.stroke();
	                }
	            } else if (data.type === _const.SHAPES.RREC) {
	                var rx = shape.x;
	                var ry = shape.y;
	                var width = shape.width;
	                var height = shape.height;
	                var radius = shape.radius;

	                var maxRadius = Math.min(width, height) / 2 | 0;

	                radius = radius > maxRadius ? maxRadius : radius;

	                context.beginPath();
	                context.moveTo(rx, ry + radius);
	                context.lineTo(rx, ry + height - radius);
	                context.quadraticCurveTo(rx, ry + height, rx + radius, ry + height);
	                context.lineTo(rx + width - radius, ry + height);
	                context.quadraticCurveTo(rx + width, ry + height, rx + width, ry + height - radius);
	                context.lineTo(rx + width, ry + radius);
	                context.quadraticCurveTo(rx + width, ry, rx + width - radius, ry);
	                context.lineTo(rx + radius, ry);
	                context.quadraticCurveTo(rx, ry, rx, ry + radius);
	                context.closePath();

	                if (data.fillColor || data.fillColor === 0) {
	                    context.globalAlpha = data.fillAlpha * worldAlpha;
	                    context.fillStyle = '#' + ('00000' + (fillColor | 0).toString(16)).substr(-6);
	                    context.fill();
	                }

	                if (data.lineWidth) {
	                    context.globalAlpha = data.lineAlpha * worldAlpha;
	                    context.strokeStyle = '#' + ('00000' + (lineColor | 0).toString(16)).substr(-6);
	                    context.stroke();
	                }
	            }
	        }
	    };

	    /**
	     * Updates the tint of a graphics object
	     *
	     * @private
	     * @param {PIXI.Graphics} graphics - the graphics that will have its tint updated
	     */


	    CanvasGraphicsRenderer.prototype.updateGraphicsTint = function updateGraphicsTint(graphics) {
	        graphics._prevTint = graphics.tint;
	        graphics.canvasTintDirty = graphics.dirty;

	        var tintR = (graphics.tint >> 16 & 0xFF) / 255;
	        var tintG = (graphics.tint >> 8 & 0xFF) / 255;
	        var tintB = (graphics.tint & 0xFF) / 255;

	        for (var i = 0; i < graphics.graphicsData.length; ++i) {
	            var data = graphics.graphicsData[i];

	            var fillColor = data.fillColor | 0;
	            var lineColor = data.lineColor | 0;

	            // super inline, cos optimization :)
	            data._fillTint = ((fillColor >> 16 & 0xFF) / 255 * tintR * 255 << 16) + ((fillColor >> 8 & 0xFF) / 255 * tintG * 255 << 8) + (fillColor & 0xFF) / 255 * tintB * 255;

	            data._lineTint = ((lineColor >> 16 & 0xFF) / 255 * tintR * 255 << 16) + ((lineColor >> 8 & 0xFF) / 255 * tintG * 255 << 8) + (lineColor & 0xFF) / 255 * tintB * 255;
	        }
	    };

	    /**
	     * Renders a polygon.
	     *
	     * @param {PIXI.Point[]} points - The points to render
	     * @param {boolean} close - Should the polygon be closed
	     * @param {CanvasRenderingContext2D} context - The rendering context to use
	     */


	    CanvasGraphicsRenderer.prototype.renderPolygon = function renderPolygon(points, close, context) {
	        context.moveTo(points[0], points[1]);

	        for (var j = 1; j < points.length / 2; ++j) {
	            context.lineTo(points[j * 2], points[j * 2 + 1]);
	        }

	        if (close) {
	            context.closePath();
	        }
	    };

	    /**
	     * destroy graphics object
	     *
	     */


	    CanvasGraphicsRenderer.prototype.destroy = function destroy() {
	        this.renderer = null;
	    };

	    return CanvasGraphicsRenderer;
	}();

	exports.default = CanvasGraphicsRenderer;


	_CanvasRenderer2.default.registerPlugin('graphics', CanvasGraphicsRenderer);
	//# sourceMappingURL=CanvasGraphicsRenderer.js.map

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _ = __webpack_require__(173);

	var _utils = __webpack_require__(213);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/**
	 * Utility class for maintaining reference to a collection
	 * of Textures on a single Spritesheet.
	 *
	 * To access a sprite sheet from your code pass its JSON data file to Pixi's loader:
	 *
	 * ```js
	 * PIXI.loader.add("images/spritesheet.json").load(setup);
	 *
	 * function setup() {
	 *   let sheet = PIXI.loader.resources["images/spritesheet.json"].spritesheet;
	 *   ...
	 * }
	 * ```
	 * With the `sheet.textures` you can create Sprite objects,`sheet.animations` can be used to create an AnimatedSprite.
	 *
	 * Sprite sheets can be packed using tools like {@link https://codeandweb.com/texturepacker|TexturePacker},
	 * {@link https://renderhjs.net/shoebox/|Shoebox} or {@link https://github.com/krzysztof-o/spritesheet.js|Spritesheet.js}.
	 * Default anchor points (see {@link PIXI.Texture#defaultAnchor}) and grouping of animation sprites are currently only
	 * supported by TexturePacker.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var Spritesheet = function () {
	    _createClass(Spritesheet, null, [{
	        key: 'BATCH_SIZE',

	        /**
	         * The maximum number of Textures to build per process.
	         *
	         * @type {number}
	         * @default 1000
	         */
	        get: function get() {
	            return 1000;
	        }

	        /**
	         * @param {PIXI.BaseTexture} baseTexture Reference to the source BaseTexture object.
	         * @param {Object} data - Spritesheet image data.
	         * @param {string} [resolutionFilename] - The filename to consider when determining
	         *        the resolution of the spritesheet. If not provided, the imageUrl will
	         *        be used on the BaseTexture.
	         */

	    }]);

	    function Spritesheet(baseTexture, data) {
	        var resolutionFilename = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

	        _classCallCheck(this, Spritesheet);

	        /**
	         * Reference to ths source texture
	         * @type {PIXI.BaseTexture}
	         */
	        this.baseTexture = baseTexture;

	        /**
	         * A map containing all textures of the sprite sheet.
	         * Can be used to create a {@link PIXI.Sprite|Sprite}:
	         * ```js
	         * new PIXI.Sprite(sheet.textures["image.png"]);
	         * ```
	         * @member {Object}
	         */
	        this.textures = {};

	        /**
	         * A map containing the textures for each animation.
	         * Can be used to create an {@link PIXI.extras.AnimatedSprite|AnimatedSprite}:
	         * ```js
	         * new PIXI.extras.AnimatedSprite(sheet.animations["anim_name"])
	         * ```
	         * @member {Object}
	         */
	        this.animations = {};

	        /**
	         * Reference to the original JSON data.
	         * @type {Object}
	         */
	        this.data = data;

	        /**
	         * The resolution of the spritesheet.
	         * @type {number}
	         */
	        this.resolution = this._updateResolution(resolutionFilename || this.baseTexture.imageUrl);

	        /**
	         * Map of spritesheet frames.
	         * @type {Object}
	         * @private
	         */
	        this._frames = this.data.frames;

	        /**
	         * Collection of frame names.
	         * @type {string[]}
	         * @private
	         */
	        this._frameKeys = Object.keys(this._frames);

	        /**
	         * Current batch index being processed.
	         * @type {number}
	         * @private
	         */
	        this._batchIndex = 0;

	        /**
	         * Callback when parse is completed.
	         * @type {Function}
	         * @private
	         */
	        this._callback = null;
	    }

	    /**
	     * Generate the resolution from the filename or fallback
	     * to the meta.scale field of the JSON data.
	     *
	     * @private
	     * @param {string} resolutionFilename - The filename to use for resolving
	     *        the default resolution.
	     * @return {number} Resolution to use for spritesheet.
	     */


	    Spritesheet.prototype._updateResolution = function _updateResolution(resolutionFilename) {
	        var scale = this.data.meta.scale;

	        // Use a defaultValue of `null` to check if a url-based resolution is set
	        var resolution = (0, _utils.getResolutionOfUrl)(resolutionFilename, null);

	        // No resolution found via URL
	        if (resolution === null) {
	            // Use the scale value or default to 1
	            resolution = scale !== undefined ? parseFloat(scale) : 1;
	        }

	        // For non-1 resolutions, update baseTexture
	        if (resolution !== 1) {
	            this.baseTexture.resolution = resolution;
	            this.baseTexture.update();
	        }

	        return resolution;
	    };

	    /**
	     * Parser spritesheet from loaded data. This is done asynchronously
	     * to prevent creating too many Texture within a single process.
	     *
	     * @param {Function} callback - Callback when complete returns
	     *        a map of the Textures for this spritesheet.
	     */


	    Spritesheet.prototype.parse = function parse(callback) {
	        this._batchIndex = 0;
	        this._callback = callback;

	        if (this._frameKeys.length <= Spritesheet.BATCH_SIZE) {
	            this._processFrames(0);
	            this._processAnimations();
	            this._parseComplete();
	        } else {
	            this._nextBatch();
	        }
	    };

	    /**
	     * Process a batch of frames
	     *
	     * @private
	     * @param {number} initialFrameIndex - The index of frame to start.
	     */


	    Spritesheet.prototype._processFrames = function _processFrames(initialFrameIndex) {
	        var frameIndex = initialFrameIndex;
	        var maxFrames = Spritesheet.BATCH_SIZE;
	        var sourceScale = this.baseTexture.sourceScale;

	        while (frameIndex - initialFrameIndex < maxFrames && frameIndex < this._frameKeys.length) {
	            var i = this._frameKeys[frameIndex];
	            var data = this._frames[i];
	            var rect = data.frame;

	            if (rect) {
	                var frame = null;
	                var trim = null;
	                var sourceSize = data.trimmed !== false && data.sourceSize ? data.sourceSize : data.frame;

	                var orig = new _.Rectangle(0, 0, Math.floor(sourceSize.w * sourceScale) / this.resolution, Math.floor(sourceSize.h * sourceScale) / this.resolution);

	                if (data.rotated) {
	                    frame = new _.Rectangle(Math.floor(rect.x * sourceScale) / this.resolution, Math.floor(rect.y * sourceScale) / this.resolution, Math.floor(rect.h * sourceScale) / this.resolution, Math.floor(rect.w * sourceScale) / this.resolution);
	                } else {
	                    frame = new _.Rectangle(Math.floor(rect.x * sourceScale) / this.resolution, Math.floor(rect.y * sourceScale) / this.resolution, Math.floor(rect.w * sourceScale) / this.resolution, Math.floor(rect.h * sourceScale) / this.resolution);
	                }

	                //  Check to see if the sprite is trimmed
	                if (data.trimmed !== false && data.spriteSourceSize) {
	                    trim = new _.Rectangle(Math.floor(data.spriteSourceSize.x * sourceScale) / this.resolution, Math.floor(data.spriteSourceSize.y * sourceScale) / this.resolution, Math.floor(rect.w * sourceScale) / this.resolution, Math.floor(rect.h * sourceScale) / this.resolution);
	                }

	                this.textures[i] = new _.Texture(this.baseTexture, frame, orig, trim, data.rotated ? 2 : 0, data.anchor);

	                // lets also add the frame to pixi's global cache for fromFrame and fromImage functions
	                _.Texture.addToCache(this.textures[i], i);
	            }

	            frameIndex++;
	        }
	    };

	    /**
	     * Parse animations config
	     *
	     * @private
	     */


	    Spritesheet.prototype._processAnimations = function _processAnimations() {
	        var animations = this.data.animations || {};

	        for (var animName in animations) {
	            this.animations[animName] = [];
	            for (var _iterator = animations[animName], _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	                var _ref;

	                if (_isArray) {
	                    if (_i >= _iterator.length) break;
	                    _ref = _iterator[_i++];
	                } else {
	                    _i = _iterator.next();
	                    if (_i.done) break;
	                    _ref = _i.value;
	                }

	                var frameName = _ref;

	                this.animations[animName].push(this.textures[frameName]);
	            }
	        }
	    };

	    /**
	     * The parse has completed.
	     *
	     * @private
	     */


	    Spritesheet.prototype._parseComplete = function _parseComplete() {
	        var callback = this._callback;

	        this._callback = null;
	        this._batchIndex = 0;
	        callback.call(this, this.textures);
	    };

	    /**
	     * Begin the next batch of textures.
	     *
	     * @private
	     */


	    Spritesheet.prototype._nextBatch = function _nextBatch() {
	        var _this = this;

	        this._processFrames(this._batchIndex * Spritesheet.BATCH_SIZE);
	        this._batchIndex++;
	        setTimeout(function () {
	            if (_this._batchIndex * Spritesheet.BATCH_SIZE < _this._frameKeys.length) {
	                _this._nextBatch();
	            } else {
	                _this._processAnimations();
	                _this._parseComplete();
	            }
	        }, 0);
	    };

	    /**
	     * Destroy Spritesheet and don't use after this.
	     *
	     * @param {boolean} [destroyBase=false] Whether to destroy the base texture as well
	     */


	    Spritesheet.prototype.destroy = function destroy() {
	        var destroyBase = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

	        for (var i in this.textures) {
	            this.textures[i].destroy();
	        }
	        this._frames = null;
	        this._frameKeys = null;
	        this.data = null;
	        this.textures = null;
	        if (destroyBase) {
	            this.baseTexture.destroy();
	        }
	        this.baseTexture = null;
	    };

	    return Spritesheet;
	}();

	exports.default = Spritesheet;
	//# sourceMappingURL=Spritesheet.js.map

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _autoDetectRenderer = __webpack_require__(291);

	var _Container = __webpack_require__(212);

	var _Container2 = _interopRequireDefault(_Container);

	var _ticker = __webpack_require__(230);

	var _settings = __webpack_require__(205);

	var _settings2 = _interopRequireDefault(_settings);

	var _const = __webpack_require__(174);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/**
	 * Convenience class to create a new PIXI application.
	 * This class automatically creates the renderer, ticker
	 * and root container.
	 *
	 * @example
	 * // Create the application
	 * const app = new PIXI.Application();
	 *
	 * // Add the view to the DOM
	 * document.body.appendChild(app.view);
	 *
	 * // ex, add display objects
	 * app.stage.addChild(PIXI.Sprite.fromImage('something.png'));
	 *
	 * @class
	 * @memberof PIXI
	 */
	var Application = function () {
	    // eslint-disable-next-line valid-jsdoc
	    /**
	     * @param {object} [options] - The optional renderer parameters
	     * @param {boolean} [options.autoStart=true] - automatically starts the rendering after the construction.
	     *     Note that setting this parameter to false does NOT stop the shared ticker even if you set
	     *     options.sharedTicker to true in case that it is already started. Stop it by your own.
	     * @param {number} [options.width=800] - the width of the renderers view
	     * @param {number} [options.height=600] - the height of the renderers view
	     * @param {HTMLCanvasElement} [options.view] - the canvas to use as a view, optional
	     * @param {boolean} [options.transparent=false] - If the render view is transparent, default false
	     * @param {boolean} [options.antialias=false] - sets antialias (only applicable in chrome at the moment)
	     * @param {boolean} [options.preserveDrawingBuffer=false] - enables drawing buffer preservation, enable this if you
	     *  need to call toDataUrl on the webgl context
	     * @param {number} [options.resolution=1] - The resolution / device pixel ratio of the renderer, retina would be 2
	     * @param {boolean} [options.forceCanvas=false] - prevents selection of WebGL renderer, even if such is present
	     * @param {number} [options.backgroundColor=0x000000] - The background color of the rendered area
	     *  (shown if not transparent).
	     * @param {boolean} [options.clearBeforeRender=true] - This sets if the renderer will clear the canvas or
	     *   not before the new render pass.
	     * @param {boolean} [options.roundPixels=false] - If true PixiJS will Math.floor() x/y values when rendering,
	     *  stopping pixel interpolation.
	     * @param {boolean} [options.forceFXAA=false] - forces FXAA antialiasing to be used over native.
	     *  FXAA is faster, but may not always look as great **webgl only**
	     * @param {boolean} [options.legacy=false] - `true` to ensure compatibility with older / less advanced devices.
	     *  If you experience unexplained flickering try setting this to true. **webgl only**
	     * @param {string} [options.powerPreference] - Parameter passed to webgl context, set to "high-performance"
	     *  for devices with dual graphics card **webgl only**
	     * @param {boolean} [options.sharedTicker=false] - `true` to use PIXI.ticker.shared, `false` to create new ticker.
	     * @param {boolean} [options.sharedLoader=false] - `true` to use PIXI.loaders.shared, `false` to create new Loader.
	     */
	    function Application(options, arg2, arg3, arg4, arg5) {
	        _classCallCheck(this, Application);

	        // Support for constructor(width, height, options, noWebGL, useSharedTicker)
	        if (typeof options === 'number') {
	            options = Object.assign({
	                width: options,
	                height: arg2 || _settings2.default.RENDER_OPTIONS.height,
	                forceCanvas: !!arg4,
	                sharedTicker: !!arg5
	            }, arg3);
	        }

	        /**
	         * The default options, so we mixin functionality later.
	         * @member {object}
	         * @protected
	         */
	        this._options = options = Object.assign({
	            autoStart: true,
	            sharedTicker: false,
	            forceCanvas: false,
	            sharedLoader: false
	        }, options);

	        /**
	         * WebGL renderer if available, otherwise CanvasRenderer
	         * @member {PIXI.WebGLRenderer|PIXI.CanvasRenderer}
	         */
	        this.renderer = (0, _autoDetectRenderer.autoDetectRenderer)(options);

	        /**
	         * The root display container that's rendered.
	         * @member {PIXI.Container}
	         */
	        this.stage = new _Container2.default();

	        /**
	         * Internal reference to the ticker
	         * @member {PIXI.ticker.Ticker}
	         * @private
	         */
	        this._ticker = null;

	        /**
	         * Ticker for doing render updates.
	         * @member {PIXI.ticker.Ticker}
	         * @default PIXI.ticker.shared
	         */
	        this.ticker = options.sharedTicker ? _ticker.shared : new _ticker.Ticker();

	        // Start the rendering
	        if (options.autoStart) {
	            this.start();
	        }
	    }

	    /**
	     * Render the current stage.
	     */
	    Application.prototype.render = function render() {
	        this.renderer.render(this.stage);
	    };

	    /**
	     * Convenience method for stopping the render.
	     */


	    Application.prototype.stop = function stop() {
	        this._ticker.stop();
	    };

	    /**
	     * Convenience method for starting the render.
	     */


	    Application.prototype.start = function start() {
	        this._ticker.start();
	    };

	    /**
	     * Reference to the renderer's canvas element.
	     * @member {HTMLCanvasElement}
	     * @readonly
	     */


	    /**
	     * Destroy and don't use after this.
	     * @param {Boolean} [removeView=false] Automatically remove canvas from DOM.
	     * @param {object|boolean} [stageOptions] - Options parameter. A boolean will act as if all options
	     *  have been set to that value
	     * @param {boolean} [stageOptions.children=false] - if set to true, all the children will have their destroy
	     *  method called as well. 'stageOptions' will be passed on to those calls.
	     * @param {boolean} [stageOptions.texture=false] - Only used for child Sprites if stageOptions.children is set
	     *  to true. Should it destroy the texture of the child sprite
	     * @param {boolean} [stageOptions.baseTexture=false] - Only used for child Sprites if stageOptions.children is set
	     *  to true. Should it destroy the base texture of the child sprite
	     */
	    Application.prototype.destroy = function destroy(removeView, stageOptions) {
	        if (this._ticker) {
	            var oldTicker = this._ticker;

	            this.ticker = null;
	            oldTicker.destroy();
	        }

	        this.stage.destroy(stageOptions);
	        this.stage = null;

	        this.renderer.destroy(removeView);
	        this.renderer = null;

	        this._options = null;
	    };

	    _createClass(Application, [{
	        key: 'ticker',
	        set: function set(ticker) // eslint-disable-line require-jsdoc
	        {
	            if (this._ticker) {
	                this._ticker.remove(this.render, this);
	            }
	            this._ticker = ticker;
	            if (ticker) {
	                ticker.add(this.render, this, _const.UPDATE_PRIORITY.LOW);
	            }
	        },
	        get: function get() // eslint-disable-line require-jsdoc
	        {
	            return this._ticker;
	        }
	    }, {
	        key: 'view',
	        get: function get() {
	            return this.renderer.view;
	        }

	        /**
	         * Reference to the renderer's screen rectangle. Its safe to use as filterArea or hitArea for whole screen
	         * @member {PIXI.Rectangle}
	         * @readonly
	         */

	    }, {
	        key: 'screen',
	        get: function get() {
	            return this.renderer.screen;
	        }
	    }]);

	    return Application;
	}();

	exports.default = Application;
	//# sourceMappingURL=Application.js.map

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;
	exports.autoDetectRenderer = autoDetectRenderer;

	var _utils = __webpack_require__(213);

	var utils = _interopRequireWildcard(_utils);

	var _CanvasRenderer = __webpack_require__(235);

	var _CanvasRenderer2 = _interopRequireDefault(_CanvasRenderer);

	var _WebGLRenderer = __webpack_require__(247);

	var _WebGLRenderer2 = _interopRequireDefault(_WebGLRenderer);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	// eslint-disable-next-line valid-jsdoc
	/**
	 * This helper function will automatically detect which renderer you should be using.
	 * WebGL is the preferred renderer as it is a lot faster. If webGL is not supported by
	 * the browser then this function will return a canvas renderer
	 *
	 * @memberof PIXI
	 * @function autoDetectRenderer
	 * @param {object} [options] - The optional renderer parameters
	 * @param {number} [options.width=800] - the width of the renderers view
	 * @param {number} [options.height=600] - the height of the renderers view
	 * @param {HTMLCanvasElement} [options.view] - the canvas to use as a view, optional
	 * @param {boolean} [options.transparent=false] - If the render view is transparent, default false
	 * @param {boolean} [options.antialias=false] - sets antialias (only applicable in chrome at the moment)
	 * @param {boolean} [options.preserveDrawingBuffer=false] - enables drawing buffer preservation, enable this if you
	 *  need to call toDataUrl on the webgl context
	 * @param {number} [options.backgroundColor=0x000000] - The background color of the rendered area
	 *  (shown if not transparent).
	 * @param {boolean} [options.clearBeforeRender=true] - This sets if the renderer will clear the canvas or
	 *   not before the new render pass.
	 * @param {number} [options.resolution=1] - The resolution / device pixel ratio of the renderer, retina would be 2
	 * @param {boolean} [options.forceCanvas=false] - prevents selection of WebGL renderer, even if such is present
	 * @param {boolean} [options.roundPixels=false] - If true PixiJS will Math.floor() x/y values when rendering,
	 *  stopping pixel interpolation.
	 * @param {boolean} [options.forceFXAA=false] - forces FXAA antialiasing to be used over native.
	 *  FXAA is faster, but may not always look as great **webgl only**
	 * @param {boolean} [options.legacy=false] - `true` to ensure compatibility with older / less advanced devices.
	 *  If you experience unexplained flickering try setting this to true. **webgl only**
	 * @param {string} [options.powerPreference] - Parameter passed to webgl context, set to "high-performance"
	 *  for devices with dual graphics card **webgl only**
	 * @return {PIXI.WebGLRenderer|PIXI.CanvasRenderer} Returns WebGL renderer if available, otherwise CanvasRenderer
	 */
	function autoDetectRenderer(options, arg1, arg2, arg3) {
	    // Backward-compatible support for noWebGL option
	    var forceCanvas = options && options.forceCanvas;

	    if (arg3 !== undefined) {
	        forceCanvas = arg3;
	    }

	    if (!forceCanvas && utils.isWebGLSupported()) {
	        return new _WebGLRenderer2.default(options, arg1, arg2);
	    }

	    return new _CanvasRenderer2.default(options, arg1, arg2);
	}
	//# sourceMappingURL=autoDetectRenderer.js.map

/***/ }),
/* 292 */
/***/ (function(module, exports) {

	'use strict';

	exports.__esModule = true;
	exports.default = deprecation;
	// provide method to give a stack track for warnings
	// useful for tracking-down where deprecated methods/properties/classes
	// are being used within the code

	// A map of warning messages already fired
	var warnings = {};

	// provide method to give a stack track for warnings
	// useful for tracking-down where deprecated methods/properties/classes
	// are being used within the code
	function warn(msg) {
	    // Ignore duplicat
	    if (warnings[msg]) {
	        return;
	    }

	    /* eslint-disable no-console */
	    var stack = new Error().stack;

	    // Handle IE < 10 and Safari < 6
	    if (typeof stack === 'undefined') {
	        console.warn('Deprecation Warning: ', msg);
	    } else {
	        // chop off the stack trace which includes pixi.js internal calls
	        stack = stack.split('\n').splice(3).join('\n');

	        if (console.groupCollapsed) {
	            console.groupCollapsed('%cDeprecation Warning: %c%s', 'color:#614108;background:#fffbe6', 'font-weight:normal;color:#614108;background:#fffbe6', msg);
	            console.warn(stack);
	            console.groupEnd();
	        } else {
	            console.warn('Deprecation Warning: ', msg);
	            console.warn(stack);
	        }
	    }
	    /* eslint-enable no-console */

	    warnings[msg] = true;
	}

	function deprecation(core) {
	    var mesh = core.mesh,
	        particles = core.particles,
	        extras = core.extras,
	        filters = core.filters,
	        prepare = core.prepare,
	        loaders = core.loaders,
	        interaction = core.interaction;


	    Object.defineProperties(core, {

	        /**
	         * @class
	         * @private
	         * @name SpriteBatch
	         * @memberof PIXI
	         * @see PIXI.ParticleContainer
	         * @throws {ReferenceError} SpriteBatch does not exist any more, please use the new ParticleContainer instead.
	         * @deprecated since version 3.0.0
	         */
	        SpriteBatch: {
	            get: function get() {
	                throw new ReferenceError('SpriteBatch does not exist any more, ' + 'please use the new ParticleContainer instead.');
	            }
	        },

	        /**
	         * @class
	         * @private
	         * @name AssetLoader
	         * @memberof PIXI
	         * @see PIXI.loaders.Loader
	         * @throws {ReferenceError} The loader system was overhauled in PixiJS v3,
	         * please see the new PIXI.loaders.Loader class.
	         * @deprecated since version 3.0.0
	         */
	        AssetLoader: {
	            get: function get() {
	                throw new ReferenceError('The loader system was overhauled in PixiJS v3, ' + 'please see the new PIXI.loaders.Loader class.');
	            }
	        },

	        /**
	         * @class
	         * @private
	         * @name Stage
	         * @memberof PIXI
	         * @see PIXI.Container
	         * @deprecated since version 3.0.0
	         */
	        Stage: {
	            get: function get() {
	                warn('You do not need to use a PIXI Stage any more, you can simply render any container.');

	                return core.Container;
	            }
	        },

	        /**
	         * @class
	         * @private
	         * @name DisplayObjectContainer
	         * @memberof PIXI
	         * @see PIXI.Container
	         * @deprecated since version 3.0.0
	         */
	        DisplayObjectContainer: {
	            get: function get() {
	                warn('DisplayObjectContainer has been shortened to Container, please use Container from now on.');

	                return core.Container;
	            }
	        },

	        /**
	         * @class
	         * @private
	         * @name Strip
	         * @memberof PIXI
	         * @see PIXI.mesh.Mesh
	         * @deprecated since version 3.0.0
	         */
	        Strip: {
	            get: function get() {
	                warn('The Strip class has been renamed to Mesh and moved to mesh.Mesh, please use mesh.Mesh from now on.');

	                return mesh.Mesh;
	            }
	        },

	        /**
	         * @class
	         * @private
	         * @name Rope
	         * @memberof PIXI
	         * @see PIXI.mesh.Rope
	         * @deprecated since version 3.0.0
	         */
	        Rope: {
	            get: function get() {
	                warn('The Rope class has been moved to mesh.Rope, please use mesh.Rope from now on.');

	                return mesh.Rope;
	            }
	        },

	        /**
	         * @class
	         * @private
	         * @name ParticleContainer
	         * @memberof PIXI
	         * @see PIXI.particles.ParticleContainer
	         * @deprecated since version 4.0.0
	         */
	        ParticleContainer: {
	            get: function get() {
	                warn('The ParticleContainer class has been moved to particles.ParticleContainer, ' + 'please use particles.ParticleContainer from now on.');

	                return particles.ParticleContainer;
	            }
	        },

	        /**
	         * @class
	         * @private
	         * @name MovieClip
	         * @memberof PIXI
	         * @see PIXI.extras.MovieClip
	         * @deprecated since version 3.0.0
	         */
	        MovieClip: {
	            get: function get() {
	                warn('The MovieClip class has been moved to extras.AnimatedSprite, please use extras.AnimatedSprite.');

	                return extras.AnimatedSprite;
	            }
	        },

	        /**
	         * @class
	         * @private
	         * @name TilingSprite
	         * @memberof PIXI
	         * @see PIXI.extras.TilingSprite
	         * @deprecated since version 3.0.0
	         */
	        TilingSprite: {
	            get: function get() {
	                warn('The TilingSprite class has been moved to extras.TilingSprite, ' + 'please use extras.TilingSprite from now on.');

	                return extras.TilingSprite;
	            }
	        },

	        /**
	         * @class
	         * @private
	         * @name BitmapText
	         * @memberof PIXI
	         * @see PIXI.extras.BitmapText
	         * @deprecated since version 3.0.0
	         */
	        BitmapText: {
	            get: function get() {
	                warn('The BitmapText class has been moved to extras.BitmapText, ' + 'please use extras.BitmapText from now on.');

	                return extras.BitmapText;
	            }
	        },

	        /**
	         * @class
	         * @private
	         * @name blendModes
	         * @memberof PIXI
	         * @see PIXI.BLEND_MODES
	         * @deprecated since version 3.0.0
	         */
	        blendModes: {
	            get: function get() {
	                warn('The blendModes has been moved to BLEND_MODES, please use BLEND_MODES from now on.');

	                return core.BLEND_MODES;
	            }
	        },

	        /**
	         * @class
	         * @private
	         * @name scaleModes
	         * @memberof PIXI
	         * @see PIXI.SCALE_MODES
	         * @deprecated since version 3.0.0
	         */
	        scaleModes: {
	            get: function get() {
	                warn('The scaleModes has been moved to SCALE_MODES, please use SCALE_MODES from now on.');

	                return core.SCALE_MODES;
	            }
	        },

	        /**
	         * @class
	         * @private
	         * @name BaseTextureCache
	         * @memberof PIXI
	         * @see PIXI.utils.BaseTextureCache
	         * @deprecated since version 3.0.0
	         */
	        BaseTextureCache: {
	            get: function get() {
	                warn('The BaseTextureCache class has been moved to utils.BaseTextureCache, ' + 'please use utils.BaseTextureCache from now on.');

	                return core.utils.BaseTextureCache;
	            }
	        },

	        /**
	         * @class
	         * @private
	         * @name TextureCache
	         * @memberof PIXI
	         * @see PIXI.utils.TextureCache
	         * @deprecated since version 3.0.0
	         */
	        TextureCache: {
	            get: function get() {
	                warn('The TextureCache class has been moved to utils.TextureCache, ' + 'please use utils.TextureCache from now on.');

	                return core.utils.TextureCache;
	            }
	        },

	        /**
	         * @namespace
	         * @private
	         * @name math
	         * @memberof PIXI
	         * @see PIXI
	         * @deprecated since version 3.0.6
	         */
	        math: {
	            get: function get() {
	                warn('The math namespace is deprecated, please access members already accessible on PIXI.');

	                return core;
	            }
	        },

	        /**
	         * @class
	         * @private
	         * @name PIXI.AbstractFilter
	         * @see PIXI.Filter
	         * @deprecated since version 3.0.6
	         */
	        AbstractFilter: {
	            get: function get() {
	                warn('AstractFilter has been renamed to Filter, please use PIXI.Filter');

	                return core.Filter;
	            }
	        },

	        /**
	         * @class
	         * @private
	         * @name PIXI.TransformManual
	         * @see PIXI.TransformBase
	         * @deprecated since version 4.0.0
	         */
	        TransformManual: {
	            get: function get() {
	                warn('TransformManual has been renamed to TransformBase, please update your pixi-spine');

	                return core.TransformBase;
	            }
	        },

	        /**
	         * @static
	         * @constant
	         * @name PIXI.TARGET_FPMS
	         * @see PIXI.settings.TARGET_FPMS
	         * @deprecated since version 4.2.0
	         */
	        TARGET_FPMS: {
	            get: function get() {
	                warn('PIXI.TARGET_FPMS has been deprecated, please use PIXI.settings.TARGET_FPMS');

	                return core.settings.TARGET_FPMS;
	            },
	            set: function set(value) {
	                warn('PIXI.TARGET_FPMS has been deprecated, please use PIXI.settings.TARGET_FPMS');

	                core.settings.TARGET_FPMS = value;
	            }
	        },

	        /**
	         * @static
	         * @constant
	         * @name PIXI.FILTER_RESOLUTION
	         * @see PIXI.settings.FILTER_RESOLUTION
	         * @deprecated since version 4.2.0
	         */
	        FILTER_RESOLUTION: {
	            get: function get() {
	                warn('PIXI.FILTER_RESOLUTION has been deprecated, please use PIXI.settings.FILTER_RESOLUTION');

	                return core.settings.FILTER_RESOLUTION;
	            },
	            set: function set(value) {
	                warn('PIXI.FILTER_RESOLUTION has been deprecated, please use PIXI.settings.FILTER_RESOLUTION');

	                core.settings.FILTER_RESOLUTION = value;
	            }
	        },

	        /**
	         * @static
	         * @constant
	         * @name PIXI.RESOLUTION
	         * @see PIXI.settings.RESOLUTION
	         * @deprecated since version 4.2.0
	         */
	        RESOLUTION: {
	            get: function get() {
	                warn('PIXI.RESOLUTION has been deprecated, please use PIXI.settings.RESOLUTION');

	                return core.settings.RESOLUTION;
	            },
	            set: function set(value) {
	                warn('PIXI.RESOLUTION has been deprecated, please use PIXI.settings.RESOLUTION');

	                core.settings.RESOLUTION = value;
	            }
	        },

	        /**
	         * @static
	         * @constant
	         * @name PIXI.MIPMAP_TEXTURES
	         * @see PIXI.settings.MIPMAP_TEXTURES
	         * @deprecated since version 4.2.0
	         */
	        MIPMAP_TEXTURES: {
	            get: function get() {
	                warn('PIXI.MIPMAP_TEXTURES has been deprecated, please use PIXI.settings.MIPMAP_TEXTURES');

	                return core.settings.MIPMAP_TEXTURES;
	            },
	            set: function set(value) {
	                warn('PIXI.MIPMAP_TEXTURES has been deprecated, please use PIXI.settings.MIPMAP_TEXTURES');

	                core.settings.MIPMAP_TEXTURES = value;
	            }
	        },

	        /**
	         * @static
	         * @constant
	         * @name PIXI.SPRITE_BATCH_SIZE
	         * @see PIXI.settings.SPRITE_BATCH_SIZE
	         * @deprecated since version 4.2.0
	         */
	        SPRITE_BATCH_SIZE: {
	            get: function get() {
	                warn('PIXI.SPRITE_BATCH_SIZE has been deprecated, please use PIXI.settings.SPRITE_BATCH_SIZE');

	                return core.settings.SPRITE_BATCH_SIZE;
	            },
	            set: function set(value) {
	                warn('PIXI.SPRITE_BATCH_SIZE has been deprecated, please use PIXI.settings.SPRITE_BATCH_SIZE');

	                core.settings.SPRITE_BATCH_SIZE = value;
	            }
	        },

	        /**
	         * @static
	         * @constant
	         * @name PIXI.SPRITE_MAX_TEXTURES
	         * @see PIXI.settings.SPRITE_MAX_TEXTURES
	         * @deprecated since version 4.2.0
	         */
	        SPRITE_MAX_TEXTURES: {
	            get: function get() {
	                warn('PIXI.SPRITE_MAX_TEXTURES has been deprecated, please use PIXI.settings.SPRITE_MAX_TEXTURES');

	                return core.settings.SPRITE_MAX_TEXTURES;
	            },
	            set: function set(value) {
	                warn('PIXI.SPRITE_MAX_TEXTURES has been deprecated, please use PIXI.settings.SPRITE_MAX_TEXTURES');

	                core.settings.SPRITE_MAX_TEXTURES = value;
	            }
	        },

	        /**
	         * @static
	         * @constant
	         * @name PIXI.RETINA_PREFIX
	         * @see PIXI.settings.RETINA_PREFIX
	         * @deprecated since version 4.2.0
	         */
	        RETINA_PREFIX: {
	            get: function get() {
	                warn('PIXI.RETINA_PREFIX has been deprecated, please use PIXI.settings.RETINA_PREFIX');

	                return core.settings.RETINA_PREFIX;
	            },
	            set: function set(value) {
	                warn('PIXI.RETINA_PREFIX has been deprecated, please use PIXI.settings.RETINA_PREFIX');

	                core.settings.RETINA_PREFIX = value;
	            }
	        },

	        /**
	         * @static
	         * @constant
	         * @name PIXI.DEFAULT_RENDER_OPTIONS
	         * @see PIXI.settings.RENDER_OPTIONS
	         * @deprecated since version 4.2.0
	         */
	        DEFAULT_RENDER_OPTIONS: {
	            get: function get() {
	                warn('PIXI.DEFAULT_RENDER_OPTIONS has been deprecated, please use PIXI.settings.DEFAULT_RENDER_OPTIONS');

	                return core.settings.RENDER_OPTIONS;
	            }
	        }
	    });

	    // Move the default properties to settings
	    var defaults = [{ parent: 'TRANSFORM_MODE', target: 'TRANSFORM_MODE' }, { parent: 'GC_MODES', target: 'GC_MODE' }, { parent: 'WRAP_MODES', target: 'WRAP_MODE' }, { parent: 'SCALE_MODES', target: 'SCALE_MODE' }, { parent: 'PRECISION', target: 'PRECISION_FRAGMENT' }];

	    var _loop = function _loop(i) {
	        var deprecation = defaults[i];

	        Object.defineProperty(core[deprecation.parent], 'DEFAULT', {
	            get: function get() {
	                warn('PIXI.' + deprecation.parent + '.DEFAULT has been deprecated, ' + ('please use PIXI.settings.' + deprecation.target));

	                return core.settings[deprecation.target];
	            },
	            set: function set(value) {
	                warn('PIXI.' + deprecation.parent + '.DEFAULT has been deprecated, ' + ('please use PIXI.settings.' + deprecation.target));

	                core.settings[deprecation.target] = value;
	            }
	        });
	    };

	    for (var i = 0; i < defaults.length; i++) {
	        _loop(i);
	    }

	    Object.defineProperties(core.settings, {

	        /**
	         * @static
	         * @name PRECISION
	         * @memberof PIXI.settings
	         * @see PIXI.PRECISION
	         * @deprecated since version 4.4.0
	         */
	        PRECISION: {
	            get: function get() {
	                warn('PIXI.settings.PRECISION has been deprecated, please use PIXI.settings.PRECISION_FRAGMENT');

	                return core.settings.PRECISION_FRAGMENT;
	            },
	            set: function set(value) {
	                warn('PIXI.settings.PRECISION has been deprecated, please use PIXI.settings.PRECISION_FRAGMENT');

	                core.settings.PRECISION_FRAGMENT = value;
	            }
	        }
	    });

	    if (extras.AnimatedSprite) {
	        Object.defineProperties(extras, {

	            /**
	             * @class
	             * @name MovieClip
	             * @memberof PIXI.extras
	             * @see PIXI.extras.AnimatedSprite
	             * @deprecated since version 4.2.0
	             */
	            MovieClip: {
	                get: function get() {
	                    warn('The MovieClip class has been renamed to AnimatedSprite, please use AnimatedSprite from now on.');

	                    return extras.AnimatedSprite;
	                }
	            }
	        });
	    }

	    if (extras) {
	        Object.defineProperties(extras, {
	            /**
	             * @class
	             * @name TextureTransform
	             * @memberof PIXI.extras
	             * @see PIXI.TextureMatrix
	             * @deprecated since version 4.6.0
	             */
	            TextureTransform: {
	                get: function get() {
	                    warn('The TextureTransform class has been renamed to TextureMatrix, ' + 'please use PIXI.TextureMatrix from now on.');

	                    return core.TextureMatrix;
	                }
	            }
	        });
	    }

	    core.DisplayObject.prototype.generateTexture = function generateTexture(renderer, scaleMode, resolution) {
	        warn('generateTexture has moved to the renderer, please use renderer.generateTexture(displayObject)');

	        return renderer.generateTexture(this, scaleMode, resolution);
	    };

	    core.Graphics.prototype.generateTexture = function generateTexture(scaleMode, resolution) {
	        warn('graphics generate texture has moved to the renderer. ' + 'Or to render a graphics to a texture using canvas please use generateCanvasTexture');

	        return this.generateCanvasTexture(scaleMode, resolution);
	    };

	    /**
	     * @method
	     * @name PIXI.GroupD8.isSwapWidthHeight
	     * @see PIXI.GroupD8.isVertical
	     * @param {number} rotation - The number to check.
	     * @returns {boolean} Whether or not the direction is vertical
	     * @deprecated since version 4.6.0
	     */
	    core.GroupD8.isSwapWidthHeight = function isSwapWidthHeight(rotation) {
	        warn('GroupD8.isSwapWidthHeight was renamed to GroupD8.isVertical');

	        return core.GroupD8.isVertical(rotation);
	    };

	    core.RenderTexture.prototype.render = function render(displayObject, matrix, clear, updateTransform) {
	        this.legacyRenderer.render(displayObject, this, clear, matrix, !updateTransform);
	        warn('RenderTexture.render is now deprecated, please use renderer.render(displayObject, renderTexture)');
	    };

	    core.RenderTexture.prototype.getImage = function getImage(target) {
	        warn('RenderTexture.getImage is now deprecated, please use renderer.extract.image(target)');

	        return this.legacyRenderer.extract.image(target);
	    };

	    core.RenderTexture.prototype.getBase64 = function getBase64(target) {
	        warn('RenderTexture.getBase64 is now deprecated, please use renderer.extract.base64(target)');

	        return this.legacyRenderer.extract.base64(target);
	    };

	    core.RenderTexture.prototype.getCanvas = function getCanvas(target) {
	        warn('RenderTexture.getCanvas is now deprecated, please use renderer.extract.canvas(target)');

	        return this.legacyRenderer.extract.canvas(target);
	    };

	    core.RenderTexture.prototype.getPixels = function getPixels(target) {
	        warn('RenderTexture.getPixels is now deprecated, please use renderer.extract.pixels(target)');

	        return this.legacyRenderer.pixels(target);
	    };

	    /**
	     * @method
	     * @private
	     * @name PIXI.Sprite#setTexture
	     * @see PIXI.Sprite#texture
	     * @deprecated since version 3.0.0
	     * @param {PIXI.Texture} texture - The texture to set to.
	     */
	    core.Sprite.prototype.setTexture = function setTexture(texture) {
	        this.texture = texture;
	        warn('setTexture is now deprecated, please use the texture property, e.g : sprite.texture = texture;');
	    };

	    if (extras.BitmapText) {
	        /**
	         * @method
	         * @name PIXI.extras.BitmapText#setText
	         * @see PIXI.extras.BitmapText#text
	         * @deprecated since version 3.0.0
	         * @param {string} text - The text to set to.
	         */
	        extras.BitmapText.prototype.setText = function setText(text) {
	            this.text = text;
	            warn('setText is now deprecated, please use the text property, e.g : myBitmapText.text = \'my text\';');
	        };
	    }

	    /**
	     * @method
	     * @name PIXI.Text#setText
	     * @see PIXI.Text#text
	     * @deprecated since version 3.0.0
	     * @param {string} text - The text to set to.
	     */
	    core.Text.prototype.setText = function setText(text) {
	        this.text = text;
	        warn('setText is now deprecated, please use the text property, e.g : myText.text = \'my text\';');
	    };

	    /**
	     * Calculates the ascent, descent and fontSize of a given fontStyle
	     *
	     * @name PIXI.Text.calculateFontProperties
	     * @see PIXI.TextMetrics.measureFont
	     * @deprecated since version 4.5.0
	     * @param {string} font - String representing the style of the font
	     * @return {Object} Font properties object
	     */
	    core.Text.calculateFontProperties = function calculateFontProperties(font) {
	        warn('Text.calculateFontProperties is now deprecated, please use the TextMetrics.measureFont');

	        return core.TextMetrics.measureFont(font);
	    };

	    Object.defineProperties(core.Text, {
	        fontPropertiesCache: {
	            get: function get() {
	                warn('Text.fontPropertiesCache is deprecated');

	                return core.TextMetrics._fonts;
	            }
	        },
	        fontPropertiesCanvas: {
	            get: function get() {
	                warn('Text.fontPropertiesCanvas is deprecated');

	                return core.TextMetrics._canvas;
	            }
	        },
	        fontPropertiesContext: {
	            get: function get() {
	                warn('Text.fontPropertiesContext is deprecated');

	                return core.TextMetrics._context;
	            }
	        }
	    });

	    /**
	     * @method
	     * @name PIXI.Text#setStyle
	     * @see PIXI.Text#style
	     * @deprecated since version 3.0.0
	     * @param {*} style - The style to set to.
	     */
	    core.Text.prototype.setStyle = function setStyle(style) {
	        this.style = style;
	        warn('setStyle is now deprecated, please use the style property, e.g : myText.style = style;');
	    };

	    /**
	     * @method
	     * @name PIXI.Text#determineFontProperties
	     * @see PIXI.Text#measureFontProperties
	     * @deprecated since version 4.2.0
	     * @private
	     * @param {string} fontStyle - String representing the style of the font
	     * @return {Object} Font properties object
	     */
	    core.Text.prototype.determineFontProperties = function determineFontProperties(fontStyle) {
	        warn('determineFontProperties is now deprecated, please use TextMetrics.measureFont method');

	        return core.TextMetrics.measureFont(fontStyle);
	    };

	    /**
	     * @method
	     * @name PIXI.Text.getFontStyle
	     * @see PIXI.TextMetrics.getFontStyle
	     * @deprecated since version 4.5.0
	     * @param {PIXI.TextStyle} style - The style to use.
	     * @return {string} Font string
	     */
	    core.Text.getFontStyle = function getFontStyle(style) {
	        warn('getFontStyle is now deprecated, please use TextStyle.toFontString() instead');

	        style = style || {};

	        if (!(style instanceof core.TextStyle)) {
	            style = new core.TextStyle(style);
	        }

	        return style.toFontString();
	    };

	    Object.defineProperties(core.TextStyle.prototype, {
	        /**
	         * Set all properties of a font as a single string
	         *
	         * @name PIXI.TextStyle#font
	         * @deprecated since version 4.0.0
	         */
	        font: {
	            get: function get() {
	                warn('text style property \'font\' is now deprecated, please use the ' + '\'fontFamily\', \'fontSize\', \'fontStyle\', \'fontVariant\' and \'fontWeight\' properties from now on');

	                var fontSizeString = typeof this._fontSize === 'number' ? this._fontSize + 'px' : this._fontSize;

	                return this._fontStyle + ' ' + this._fontVariant + ' ' + this._fontWeight + ' ' + fontSizeString + ' ' + this._fontFamily;
	            },
	            set: function set(font) {
	                warn('text style property \'font\' is now deprecated, please use the ' + '\'fontFamily\',\'fontSize\',fontStyle\',\'fontVariant\' and \'fontWeight\' properties from now on');

	                // can work out fontStyle from search of whole string
	                if (font.indexOf('italic') > 1) {
	                    this._fontStyle = 'italic';
	                } else if (font.indexOf('oblique') > -1) {
	                    this._fontStyle = 'oblique';
	                } else {
	                    this._fontStyle = 'normal';
	                }

	                // can work out fontVariant from search of whole string
	                if (font.indexOf('small-caps') > -1) {
	                    this._fontVariant = 'small-caps';
	                } else {
	                    this._fontVariant = 'normal';
	                }

	                // fontWeight and fontFamily are tricker to find, but it's easier to find the fontSize due to it's units
	                var splits = font.split(' ');
	                var fontSizeIndex = -1;

	                this._fontSize = 26;
	                for (var i = 0; i < splits.length; ++i) {
	                    if (splits[i].match(/(px|pt|em|%)/)) {
	                        fontSizeIndex = i;
	                        this._fontSize = splits[i];
	                        break;
	                    }
	                }

	                // we can now search for fontWeight as we know it must occur before the fontSize
	                this._fontWeight = 'normal';
	                for (var _i = 0; _i < fontSizeIndex; ++_i) {
	                    if (splits[_i].match(/(bold|bolder|lighter|100|200|300|400|500|600|700|800|900)/)) {
	                        this._fontWeight = splits[_i];
	                        break;
	                    }
	                }

	                // and finally join everything together after the fontSize in case the font family has multiple words
	                if (fontSizeIndex > -1 && fontSizeIndex < splits.length - 1) {
	                    this._fontFamily = '';
	                    for (var _i2 = fontSizeIndex + 1; _i2 < splits.length; ++_i2) {
	                        this._fontFamily += splits[_i2] + ' ';
	                    }

	                    this._fontFamily = this._fontFamily.slice(0, -1);
	                } else {
	                    this._fontFamily = 'Arial';
	                }

	                this.styleID++;
	            }
	        }
	    });

	    /**
	     * @method
	     * @name PIXI.Texture#setFrame
	     * @see PIXI.Texture#setFrame
	     * @deprecated since version 3.0.0
	     * @param {PIXI.Rectangle} frame - The frame to set.
	     */
	    core.Texture.prototype.setFrame = function setFrame(frame) {
	        this.frame = frame;
	        warn('setFrame is now deprecated, please use the frame property, e.g: myTexture.frame = frame;');
	    };

	    /**
	     * @static
	     * @function
	     * @name PIXI.Texture.addTextureToCache
	     * @see PIXI.Texture.addToCache
	     * @deprecated since 4.5.0
	     * @param {PIXI.Texture} texture - The Texture to add to the cache.
	     * @param {string} id - The id that the texture will be stored against.
	     */
	    core.Texture.addTextureToCache = function addTextureToCache(texture, id) {
	        core.Texture.addToCache(texture, id);
	        warn('Texture.addTextureToCache is deprecated, please use Texture.addToCache from now on.');
	    };

	    /**
	     * @static
	     * @function
	     * @name PIXI.Texture.removeTextureFromCache
	     * @see PIXI.Texture.removeFromCache
	     * @deprecated since 4.5.0
	     * @param {string} id - The id of the texture to be removed
	     * @return {PIXI.Texture|null} The texture that was removed
	     */
	    core.Texture.removeTextureFromCache = function removeTextureFromCache(id) {
	        warn('Texture.removeTextureFromCache is deprecated, please use Texture.removeFromCache from now on. ' + 'Be aware that Texture.removeFromCache does not automatically its BaseTexture from the BaseTextureCache. ' + 'For that, use BaseTexture.removeFromCache');

	        core.BaseTexture.removeFromCache(id);

	        return core.Texture.removeFromCache(id);
	    };

	    Object.defineProperties(filters, {

	        /**
	         * @class
	         * @private
	         * @name PIXI.filters.AbstractFilter
	         * @see PIXI.AbstractFilter
	         * @deprecated since version 3.0.6
	         */
	        AbstractFilter: {
	            get: function get() {
	                warn('AstractFilter has been renamed to Filter, please use PIXI.Filter');

	                return core.AbstractFilter;
	            }
	        },

	        /**
	         * @class
	         * @private
	         * @name PIXI.filters.SpriteMaskFilter
	         * @see PIXI.SpriteMaskFilter
	         * @deprecated since version 3.0.6
	         */
	        SpriteMaskFilter: {
	            get: function get() {
	                warn('filters.SpriteMaskFilter is an undocumented alias, please use SpriteMaskFilter from now on.');

	                return core.SpriteMaskFilter;
	            }
	        },

	        /**
	         * @class
	         * @private
	         * @name PIXI.filters.VoidFilter
	         * @see PIXI.filters.AlphaFilter
	         * @deprecated since version 4.5.7
	         */
	        VoidFilter: {
	            get: function get() {
	                warn('VoidFilter has been renamed to AlphaFilter, please use PIXI.filters.AlphaFilter');

	                return filters.AlphaFilter;
	            }
	        }
	    });

	    /**
	     * @method
	     * @name PIXI.utils.uuid
	     * @see PIXI.utils.uid
	     * @deprecated since version 3.0.6
	     * @return {number} The uid
	     */
	    core.utils.uuid = function () {
	        warn('utils.uuid() is deprecated, please use utils.uid() from now on.');

	        return core.utils.uid();
	    };

	    /**
	     * @method
	     * @name PIXI.utils.canUseNewCanvasBlendModes
	     * @see PIXI.CanvasTinter
	     * @deprecated
	     * @return {boolean} Can use blend modes.
	     */
	    core.utils.canUseNewCanvasBlendModes = function () {
	        warn('utils.canUseNewCanvasBlendModes() is deprecated, please use CanvasTinter.canUseMultiply from now on');

	        return core.CanvasTinter.canUseMultiply;
	    };

	    var saidHello = true;

	    /**
	     * @name PIXI.utils._saidHello
	     * @type {boolean}
	     * @see PIXI.utils.skipHello
	     * @deprecated since 4.1.0
	     */
	    Object.defineProperty(core.utils, '_saidHello', {
	        set: function set(bool) {
	            if (bool) {
	                warn('PIXI.utils._saidHello is deprecated, please use PIXI.utils.skipHello()');
	                this.skipHello();
	            }
	            saidHello = bool;
	        },
	        get: function get() {
	            return saidHello;
	        }
	    });

	    if (prepare.BasePrepare) {
	        /**
	         * @method
	         * @name PIXI.prepare.BasePrepare#register
	         * @see PIXI.prepare.BasePrepare#registerFindHook
	         * @deprecated since version 4.4.2
	         * @param {Function} [addHook] - Function call that takes two parameters: `item:*, queue:Array`
	         *        function must return `true` if it was able to add item to the queue.
	         * @param {Function} [uploadHook] - Function call that takes two parameters: `prepare:CanvasPrepare, item:*` and
	         *        function must return `true` if it was able to handle upload of item.
	         * @return {PIXI.BasePrepare} Instance of plugin for chaining.
	         */
	        prepare.BasePrepare.prototype.register = function register(addHook, uploadHook) {
	            warn('renderer.plugins.prepare.register is now deprecated, ' + 'please use renderer.plugins.prepare.registerFindHook & renderer.plugins.prepare.registerUploadHook');

	            if (addHook) {
	                this.registerFindHook(addHook);
	            }

	            if (uploadHook) {
	                this.registerUploadHook(uploadHook);
	            }

	            return this;
	        };
	    }

	    if (prepare.canvas) {
	        /**
	         * The number of graphics or textures to upload to the GPU.
	         *
	         * @name PIXI.prepare.canvas.UPLOADS_PER_FRAME
	         * @static
	         * @type {number}
	         * @see PIXI.prepare.BasePrepare.limiter
	         * @deprecated since 4.2.0
	         */
	        Object.defineProperty(prepare.canvas, 'UPLOADS_PER_FRAME', {
	            set: function set() {
	                warn('PIXI.CanvasPrepare.UPLOADS_PER_FRAME has been removed. Please set ' + 'renderer.plugins.prepare.limiter.maxItemsPerFrame on your renderer');
	                // because we don't have a reference to the renderer, we can't actually set
	                // the uploads per frame, so we'll have to stick with the warning.
	            },
	            get: function get() {
	                warn('PIXI.CanvasPrepare.UPLOADS_PER_FRAME has been removed. Please use ' + 'renderer.plugins.prepare.limiter');

	                return NaN;
	            }
	        });
	    }

	    if (prepare.webgl) {
	        /**
	         * The number of graphics or textures to upload to the GPU.
	         *
	         * @name PIXI.prepare.webgl.UPLOADS_PER_FRAME
	         * @static
	         * @type {number}
	         * @see PIXI.prepare.BasePrepare.limiter
	         * @deprecated since 4.2.0
	         */
	        Object.defineProperty(prepare.webgl, 'UPLOADS_PER_FRAME', {
	            set: function set() {
	                warn('PIXI.WebGLPrepare.UPLOADS_PER_FRAME has been removed. Please set ' + 'renderer.plugins.prepare.limiter.maxItemsPerFrame on your renderer');
	                // because we don't have a reference to the renderer, we can't actually set
	                // the uploads per frame, so we'll have to stick with the warning.
	            },
	            get: function get() {
	                warn('PIXI.WebGLPrepare.UPLOADS_PER_FRAME has been removed. Please use ' + 'renderer.plugins.prepare.limiter');

	                return NaN;
	            }
	        });
	    }

	    if (loaders.Loader) {
	        var Resource = loaders.Resource;
	        var Loader = loaders.Loader;

	        Object.defineProperties(Resource.prototype, {
	            isJson: {
	                get: function get() {
	                    warn('The isJson property is deprecated, please use `resource.type === Resource.TYPE.JSON`.');

	                    return this.type === Resource.TYPE.JSON;
	                }
	            },
	            isXml: {
	                get: function get() {
	                    warn('The isXml property is deprecated, please use `resource.type === Resource.TYPE.XML`.');

	                    return this.type === Resource.TYPE.XML;
	                }
	            },
	            isImage: {
	                get: function get() {
	                    warn('The isImage property is deprecated, please use `resource.type === Resource.TYPE.IMAGE`.');

	                    return this.type === Resource.TYPE.IMAGE;
	                }
	            },
	            isAudio: {
	                get: function get() {
	                    warn('The isAudio property is deprecated, please use `resource.type === Resource.TYPE.AUDIO`.');

	                    return this.type === Resource.TYPE.AUDIO;
	                }
	            },
	            isVideo: {
	                get: function get() {
	                    warn('The isVideo property is deprecated, please use `resource.type === Resource.TYPE.VIDEO`.');

	                    return this.type === Resource.TYPE.VIDEO;
	                }
	            }
	        });

	        Object.defineProperties(Loader.prototype, {
	            before: {
	                get: function get() {
	                    warn('The before() method is deprecated, please use pre().');

	                    return this.pre;
	                }
	            },
	            after: {
	                get: function get() {
	                    warn('The after() method is deprecated, please use use().');

	                    return this.use;
	                }
	            }
	        });
	    }

	    if (interaction.interactiveTarget) {
	        /**
	         * @name PIXI.interaction.interactiveTarget#defaultCursor
	         * @static
	         * @type {number}
	         * @see PIXI.interaction.interactiveTarget#cursor
	         * @deprecated since 4.3.0
	         */
	        Object.defineProperty(interaction.interactiveTarget, 'defaultCursor', {
	            set: function set(value) {
	                warn('Property defaultCursor has been replaced with \'cursor\'. ');
	                this.cursor = value;
	            },
	            get: function get() {
	                warn('Property defaultCursor has been replaced with \'cursor\'. ');

	                return this.cursor;
	            }
	        });
	    }

	    if (interaction.InteractionManager) {
	        /**
	         * @name PIXI.interaction.InteractionManager#defaultCursorStyle
	         * @static
	         * @type {string}
	         * @see PIXI.interaction.InteractionManager#cursorStyles
	         * @deprecated since 4.3.0
	         */
	        Object.defineProperty(interaction.InteractionManager, 'defaultCursorStyle', {
	            set: function set(value) {
	                warn('Property defaultCursorStyle has been replaced with \'cursorStyles.default\'. ');
	                this.cursorStyles.default = value;
	            },
	            get: function get() {
	                warn('Property defaultCursorStyle has been replaced with \'cursorStyles.default\'. ');

	                return this.cursorStyles.default;
	            }
	        });

	        /**
	         * @name PIXI.interaction.InteractionManager#currentCursorStyle
	         * @static
	         * @type {string}
	         * @see PIXI.interaction.InteractionManager#cursorStyles
	         * @deprecated since 4.3.0
	         */
	        Object.defineProperty(interaction.InteractionManager, 'currentCursorStyle', {
	            set: function set(value) {
	                warn('Property currentCursorStyle has been removed.' + 'See the currentCursorMode property, which works differently.');
	                this.currentCursorMode = value;
	            },
	            get: function get() {
	                warn('Property currentCursorStyle has been removed.' + 'See the currentCursorMode property, which works differently.');

	                return this.currentCursorMode;
	            }
	        });
	    }
	}
	//# sourceMappingURL=deprecation.js.map

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _accessibleTarget = __webpack_require__(294);

	Object.defineProperty(exports, 'accessibleTarget', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_accessibleTarget).default;
	  }
	});

	var _AccessibilityManager = __webpack_require__(295);

	Object.defineProperty(exports, 'AccessibilityManager', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AccessibilityManager).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=index.js.map

/***/ }),
/* 294 */
/***/ (function(module, exports) {

	"use strict";

	exports.__esModule = true;
	/**
	 * Default property values of accessible objects
	 * used by {@link PIXI.accessibility.AccessibilityManager}.
	 *
	 * @function accessibleTarget
	 * @memberof PIXI.accessibility
	 * @example
	 *      function MyObject() {}
	 *
	 *      Object.assign(
	 *          MyObject.prototype,
	 *          PIXI.accessibility.accessibleTarget
	 *      );
	 */
	exports.default = {
	  /**
	   *  Flag for if the object is accessible. If true AccessibilityManager will overlay a
	   *   shadow div with attributes set
	   *
	   * @member {boolean}
	   */
	  accessible: false,

	  /**
	   * Sets the title attribute of the shadow div
	   * If accessibleTitle AND accessibleHint has not been this will default to 'displayObject [tabIndex]'
	   *
	   * @member {string}
	   */
	  accessibleTitle: null,

	  /**
	   * Sets the aria-label attribute of the shadow div
	   *
	   * @member {string}
	   */
	  accessibleHint: null,

	  /**
	   * @todo Needs docs.
	   */
	  tabIndex: 0,

	  /**
	   * @todo Needs docs.
	   */
	  _accessibleActive: false,

	  /**
	   * @todo Needs docs.
	   */
	  _accessibleDiv: false
	};
	//# sourceMappingURL=accessibleTarget.js.map

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _core = __webpack_require__(173);

	var core = _interopRequireWildcard(_core);

	var _ismobilejs = __webpack_require__(207);

	var _ismobilejs2 = _interopRequireDefault(_ismobilejs);

	var _accessibleTarget = __webpack_require__(294);

	var _accessibleTarget2 = _interopRequireDefault(_accessibleTarget);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	// add some extra variables to the container..
	core.utils.mixins.delayMixin(core.DisplayObject.prototype, _accessibleTarget2.default);

	var KEY_CODE_TAB = 9;

	var DIV_TOUCH_SIZE = 100;
	var DIV_TOUCH_POS_X = 0;
	var DIV_TOUCH_POS_Y = 0;
	var DIV_TOUCH_ZINDEX = 2;

	var DIV_HOOK_SIZE = 1;
	var DIV_HOOK_POS_X = -1000;
	var DIV_HOOK_POS_Y = -1000;
	var DIV_HOOK_ZINDEX = 2;

	/**
	 * The Accessibility manager recreates the ability to tab and have content read by screen
	 * readers. This is very important as it can possibly help people with disabilities access pixi
	 * content.
	 *
	 * Much like interaction any DisplayObject can be made accessible. This manager will map the
	 * events as if the mouse was being used, minimizing the effort required to implement.
	 *
	 * An instance of this class is automatically created by default, and can be found at renderer.plugins.accessibility
	 *
	 * @class
	 * @memberof PIXI.accessibility
	 */

	var AccessibilityManager = function () {
	    /**
	     * @param {PIXI.CanvasRenderer|PIXI.WebGLRenderer} renderer - A reference to the current renderer
	     */
	    function AccessibilityManager(renderer) {
	        _classCallCheck(this, AccessibilityManager);

	        if ((_ismobilejs2.default.tablet || _ismobilejs2.default.phone) && !navigator.isCocoonJS) {
	            this.createTouchHook();
	        }

	        // first we create a div that will sit over the PixiJS element. This is where the div overlays will go.
	        var div = document.createElement('div');

	        div.style.width = DIV_TOUCH_SIZE + 'px';
	        div.style.height = DIV_TOUCH_SIZE + 'px';
	        div.style.position = 'absolute';
	        div.style.top = DIV_TOUCH_POS_X + 'px';
	        div.style.left = DIV_TOUCH_POS_Y + 'px';
	        div.style.zIndex = DIV_TOUCH_ZINDEX;

	        /**
	         * This is the dom element that will sit over the PixiJS element. This is where the div overlays will go.
	         *
	         * @type {HTMLElement}
	         * @private
	         */
	        this.div = div;

	        /**
	         * A simple pool for storing divs.
	         *
	         * @type {*}
	         * @private
	         */
	        this.pool = [];

	        /**
	         * This is a tick used to check if an object is no longer being rendered.
	         *
	         * @type {Number}
	         * @private
	         */
	        this.renderId = 0;

	        /**
	         * Setting this to true will visually show the divs.
	         *
	         * @type {boolean}
	         */
	        this.debug = false;

	        /**
	         * The renderer this accessibility manager works for.
	         *
	         * @member {PIXI.SystemRenderer}
	         */
	        this.renderer = renderer;

	        /**
	         * The array of currently active accessible items.
	         *
	         * @member {Array<*>}
	         * @private
	         */
	        this.children = [];

	        /**
	         * pre-bind the functions
	         *
	         * @private
	         */
	        this._onKeyDown = this._onKeyDown.bind(this);
	        this._onMouseMove = this._onMouseMove.bind(this);

	        /**
	         * stores the state of the manager. If there are no accessible objects or the mouse is moving, this will be false.
	         *
	         * @member {Array<*>}
	         * @private
	         */
	        this.isActive = false;
	        this.isMobileAccessabillity = false;

	        // let listen for tab.. once pressed we can fire up and show the accessibility layer
	        window.addEventListener('keydown', this._onKeyDown, false);
	    }

	    /**
	     * Creates the touch hooks.
	     *
	     */


	    AccessibilityManager.prototype.createTouchHook = function createTouchHook() {
	        var _this = this;

	        var hookDiv = document.createElement('button');

	        hookDiv.style.width = DIV_HOOK_SIZE + 'px';
	        hookDiv.style.height = DIV_HOOK_SIZE + 'px';
	        hookDiv.style.position = 'absolute';
	        hookDiv.style.top = DIV_HOOK_POS_X + 'px';
	        hookDiv.style.left = DIV_HOOK_POS_Y + 'px';
	        hookDiv.style.zIndex = DIV_HOOK_ZINDEX;
	        hookDiv.style.backgroundColor = '#FF0000';
	        hookDiv.title = 'HOOK DIV';

	        hookDiv.addEventListener('focus', function () {
	            _this.isMobileAccessabillity = true;
	            _this.activate();
	            document.body.removeChild(hookDiv);
	        });

	        document.body.appendChild(hookDiv);
	    };

	    /**
	     * Activating will cause the Accessibility layer to be shown. This is called when a user
	     * preses the tab key.
	     *
	     * @private
	     */


	    AccessibilityManager.prototype.activate = function activate() {
	        if (this.isActive) {
	            return;
	        }

	        this.isActive = true;

	        window.document.addEventListener('mousemove', this._onMouseMove, true);
	        window.removeEventListener('keydown', this._onKeyDown, false);

	        this.renderer.on('postrender', this.update, this);

	        if (this.renderer.view.parentNode) {
	            this.renderer.view.parentNode.appendChild(this.div);
	        }
	    };

	    /**
	     * Deactivating will cause the Accessibility layer to be hidden. This is called when a user moves
	     * the mouse.
	     *
	     * @private
	     */


	    AccessibilityManager.prototype.deactivate = function deactivate() {
	        if (!this.isActive || this.isMobileAccessabillity) {
	            return;
	        }

	        this.isActive = false;

	        window.document.removeEventListener('mousemove', this._onMouseMove, true);
	        window.addEventListener('keydown', this._onKeyDown, false);

	        this.renderer.off('postrender', this.update);

	        if (this.div.parentNode) {
	            this.div.parentNode.removeChild(this.div);
	        }
	    };

	    /**
	     * This recursive function will run through the scene graph and add any new accessible objects to the DOM layer.
	     *
	     * @private
	     * @param {PIXI.Container} displayObject - The DisplayObject to check.
	     */


	    AccessibilityManager.prototype.updateAccessibleObjects = function updateAccessibleObjects(displayObject) {
	        if (!displayObject.visible) {
	            return;
	        }

	        if (displayObject.accessible && displayObject.interactive) {
	            if (!displayObject._accessibleActive) {
	                this.addChild(displayObject);
	            }

	            displayObject.renderId = this.renderId;
	        }

	        var children = displayObject.children;

	        for (var i = 0; i < children.length; i++) {
	            this.updateAccessibleObjects(children[i]);
	        }
	    };

	    /**
	     * Before each render this function will ensure that all divs are mapped correctly to their DisplayObjects.
	     *
	     * @private
	     */


	    AccessibilityManager.prototype.update = function update() {
	        if (!this.renderer.renderingToScreen) {
	            return;
	        }

	        // update children...
	        this.updateAccessibleObjects(this.renderer._lastObjectRendered);

	        var rect = this.renderer.view.getBoundingClientRect();
	        var sx = rect.width / this.renderer.width;
	        var sy = rect.height / this.renderer.height;

	        var div = this.div;

	        div.style.left = rect.left + 'px';
	        div.style.top = rect.top + 'px';
	        div.style.width = this.renderer.width + 'px';
	        div.style.height = this.renderer.height + 'px';

	        for (var i = 0; i < this.children.length; i++) {
	            var child = this.children[i];

	            if (child.renderId !== this.renderId) {
	                child._accessibleActive = false;

	                core.utils.removeItems(this.children, i, 1);
	                this.div.removeChild(child._accessibleDiv);
	                this.pool.push(child._accessibleDiv);
	                child._accessibleDiv = null;

	                i--;

	                if (this.children.length === 0) {
	                    this.deactivate();
	                }
	            } else {
	                // map div to display..
	                div = child._accessibleDiv;
	                var hitArea = child.hitArea;
	                var wt = child.worldTransform;

	                if (child.hitArea) {
	                    div.style.left = (wt.tx + hitArea.x * wt.a) * sx + 'px';
	                    div.style.top = (wt.ty + hitArea.y * wt.d) * sy + 'px';

	                    div.style.width = hitArea.width * wt.a * sx + 'px';
	                    div.style.height = hitArea.height * wt.d * sy + 'px';
	                } else {
	                    hitArea = child.getBounds();

	                    this.capHitArea(hitArea);

	                    div.style.left = hitArea.x * sx + 'px';
	                    div.style.top = hitArea.y * sy + 'px';

	                    div.style.width = hitArea.width * sx + 'px';
	                    div.style.height = hitArea.height * sy + 'px';

	                    // update button titles and hints if they exist and they've changed
	                    if (div.title !== child.accessibleTitle && child.accessibleTitle !== null) {
	                        div.title = child.accessibleTitle;
	                    }
	                    if (div.getAttribute('aria-label') !== child.accessibleHint && child.accessibleHint !== null) {
	                        div.setAttribute('aria-label', child.accessibleHint);
	                    }
	                }
	            }
	        }

	        // increment the render id..
	        this.renderId++;
	    };

	    /**
	     * TODO: docs.
	     *
	     * @param {Rectangle} hitArea - TODO docs
	     */


	    AccessibilityManager.prototype.capHitArea = function capHitArea(hitArea) {
	        if (hitArea.x < 0) {
	            hitArea.width += hitArea.x;
	            hitArea.x = 0;
	        }

	        if (hitArea.y < 0) {
	            hitArea.height += hitArea.y;
	            hitArea.y = 0;
	        }

	        if (hitArea.x + hitArea.width > this.renderer.width) {
	            hitArea.width = this.renderer.width - hitArea.x;
	        }

	        if (hitArea.y + hitArea.height > this.renderer.height) {
	            hitArea.height = this.renderer.height - hitArea.y;
	        }
	    };

	    /**
	     * Adds a DisplayObject to the accessibility manager
	     *
	     * @private
	     * @param {DisplayObject} displayObject - The child to make accessible.
	     */


	    AccessibilityManager.prototype.addChild = function addChild(displayObject) {
	        //    this.activate();

	        var div = this.pool.pop();

	        if (!div) {
	            div = document.createElement('button');

	            div.style.width = DIV_TOUCH_SIZE + 'px';
	            div.style.height = DIV_TOUCH_SIZE + 'px';
	            div.style.backgroundColor = this.debug ? 'rgba(255,0,0,0.5)' : 'transparent';
	            div.style.position = 'absolute';
	            div.style.zIndex = DIV_TOUCH_ZINDEX;
	            div.style.borderStyle = 'none';

	            // ARIA attributes ensure that button title and hint updates are announced properly
	            if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
	                // Chrome doesn't need aria-live to work as intended; in fact it just gets more confused.
	                div.setAttribute('aria-live', 'off');
	            } else {
	                div.setAttribute('aria-live', 'polite');
	            }

	            if (navigator.userAgent.match(/rv:.*Gecko\//)) {
	                // FireFox needs this to announce only the new button name
	                div.setAttribute('aria-relevant', 'additions');
	            } else {
	                // required by IE, other browsers don't much care
	                div.setAttribute('aria-relevant', 'text');
	            }

	            div.addEventListener('click', this._onClick.bind(this));
	            div.addEventListener('focus', this._onFocus.bind(this));
	            div.addEventListener('focusout', this._onFocusOut.bind(this));
	        }

	        if (displayObject.accessibleTitle && displayObject.accessibleTitle !== null) {
	            div.title = displayObject.accessibleTitle;
	        } else if (!displayObject.accessibleHint || displayObject.accessibleHint === null) {
	            div.title = 'displayObject ' + displayObject.tabIndex;
	        }

	        if (displayObject.accessibleHint && displayObject.accessibleHint !== null) {
	            div.setAttribute('aria-label', displayObject.accessibleHint);
	        }

	        //

	        displayObject._accessibleActive = true;
	        displayObject._accessibleDiv = div;
	        div.displayObject = displayObject;

	        this.children.push(displayObject);
	        this.div.appendChild(displayObject._accessibleDiv);
	        displayObject._accessibleDiv.tabIndex = displayObject.tabIndex;
	    };

	    /**
	     * Maps the div button press to pixi's InteractionManager (click)
	     *
	     * @private
	     * @param {MouseEvent} e - The click event.
	     */


	    AccessibilityManager.prototype._onClick = function _onClick(e) {
	        var interactionManager = this.renderer.plugins.interaction;

	        interactionManager.dispatchEvent(e.target.displayObject, 'click', interactionManager.eventData);
	    };

	    /**
	     * Maps the div focus events to pixi's InteractionManager (mouseover)
	     *
	     * @private
	     * @param {FocusEvent} e - The focus event.
	     */


	    AccessibilityManager.prototype._onFocus = function _onFocus(e) {
	        if (!e.target.getAttribute('aria-live', 'off')) {
	            e.target.setAttribute('aria-live', 'assertive');
	        }
	        var interactionManager = this.renderer.plugins.interaction;

	        interactionManager.dispatchEvent(e.target.displayObject, 'mouseover', interactionManager.eventData);
	    };

	    /**
	     * Maps the div focus events to pixi's InteractionManager (mouseout)
	     *
	     * @private
	     * @param {FocusEvent} e - The focusout event.
	     */


	    AccessibilityManager.prototype._onFocusOut = function _onFocusOut(e) {
	        if (!e.target.getAttribute('aria-live', 'off')) {
	            e.target.setAttribute('aria-live', 'polite');
	        }
	        var interactionManager = this.renderer.plugins.interaction;

	        interactionManager.dispatchEvent(e.target.displayObject, 'mouseout', interactionManager.eventData);
	    };

	    /**
	     * Is called when a key is pressed
	     *
	     * @private
	     * @param {KeyboardEvent} e - The keydown event.
	     */


	    AccessibilityManager.prototype._onKeyDown = function _onKeyDown(e) {
	        if (e.keyCode !== KEY_CODE_TAB) {
	            return;
	        }

	        this.activate();
	    };

	    /**
	     * Is called when the mouse moves across the renderer element
	     *
	     * @private
	     * @param {MouseEvent} e - The mouse event.
	     */


	    AccessibilityManager.prototype._onMouseMove = function _onMouseMove(e) {
	        if (e.movementX === 0 && e.movementY === 0) {
	            return;
	        }

	        this.deactivate();
	    };

	    /**
	     * Destroys the accessibility manager
	     *
	     */


	    AccessibilityManager.prototype.destroy = function destroy() {
	        this.div = null;

	        for (var i = 0; i < this.children.length; i++) {
	            this.children[i].div = null;
	        }

	        window.document.removeEventListener('mousemove', this._onMouseMove, true);
	        window.removeEventListener('keydown', this._onKeyDown);

	        this.pool = null;
	        this.children = null;
	        this.renderer = null;
	    };

	    return AccessibilityManager;
	}();

	exports.default = AccessibilityManager;


	core.WebGLRenderer.registerPlugin('accessibility', AccessibilityManager);
	core.CanvasRenderer.registerPlugin('accessibility', AccessibilityManager);
	//# sourceMappingURL=AccessibilityManager.js.map

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _WebGLExtract = __webpack_require__(297);

	Object.defineProperty(exports, 'webgl', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_WebGLExtract).default;
	  }
	});

	var _CanvasExtract = __webpack_require__(298);

	Object.defineProperty(exports, 'canvas', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CanvasExtract).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=index.js.map

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _core = __webpack_require__(173);

	var core = _interopRequireWildcard(_core);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var TEMP_RECT = new core.Rectangle();
	var BYTES_PER_PIXEL = 4;

	/**
	 * The extract manager provides functionality to export content from the renderers.
	 *
	 * An instance of this class is automatically created by default, and can be found at renderer.plugins.extract
	 *
	 * @class
	 * @memberof PIXI.extract
	 */

	var WebGLExtract = function () {
	    /**
	     * @param {PIXI.WebGLRenderer} renderer - A reference to the current renderer
	     */
	    function WebGLExtract(renderer) {
	        _classCallCheck(this, WebGLExtract);

	        this.renderer = renderer;
	        /**
	         * Collection of methods for extracting data (image, pixels, etc.) from a display object or render texture
	         *
	         * @member {PIXI.extract.WebGLExtract} extract
	         * @memberof PIXI.WebGLRenderer#
	         * @see PIXI.extract.WebGLExtract
	         */
	        renderer.extract = this;
	    }

	    /**
	     * Will return a HTML Image of the target
	     *
	     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
	     *  to convert. If left empty will use use the main renderer
	     * @return {HTMLImageElement} HTML Image of the target
	     */


	    WebGLExtract.prototype.image = function image(target) {
	        var image = new Image();

	        image.src = this.base64(target);

	        return image;
	    };

	    /**
	     * Will return a a base64 encoded string of this target. It works by calling
	     *  `WebGLExtract.getCanvas` and then running toDataURL on that.
	     *
	     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
	     *  to convert. If left empty will use use the main renderer
	     * @return {string} A base64 encoded string of the texture.
	     */


	    WebGLExtract.prototype.base64 = function base64(target) {
	        return this.canvas(target).toDataURL();
	    };

	    /**
	     * Creates a Canvas element, renders this target to it and then returns it.
	     *
	     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
	     *  to convert. If left empty will use use the main renderer
	     * @return {HTMLCanvasElement} A Canvas element with the texture rendered on.
	     */


	    WebGLExtract.prototype.canvas = function canvas(target) {
	        var renderer = this.renderer;
	        var textureBuffer = void 0;
	        var resolution = void 0;
	        var frame = void 0;
	        var flipY = false;
	        var renderTexture = void 0;
	        var generated = false;

	        if (target) {
	            if (target instanceof core.RenderTexture) {
	                renderTexture = target;
	            } else {
	                renderTexture = this.renderer.generateTexture(target);
	                generated = true;
	            }
	        }

	        if (renderTexture) {
	            textureBuffer = renderTexture.baseTexture._glRenderTargets[this.renderer.CONTEXT_UID];
	            resolution = textureBuffer.resolution;
	            frame = renderTexture.frame;
	            flipY = false;
	        } else {
	            textureBuffer = this.renderer.rootRenderTarget;
	            resolution = textureBuffer.resolution;
	            flipY = true;

	            frame = TEMP_RECT;
	            frame.width = textureBuffer.size.width;
	            frame.height = textureBuffer.size.height;
	        }

	        var width = frame.width * resolution;
	        var height = frame.height * resolution;

	        var canvasBuffer = new core.CanvasRenderTarget(width, height, 1);

	        if (textureBuffer) {
	            // bind the buffer
	            renderer.bindRenderTarget(textureBuffer);

	            // set up an array of pixels
	            var webglPixels = new Uint8Array(BYTES_PER_PIXEL * width * height);

	            // read pixels to the array
	            var gl = renderer.gl;

	            gl.readPixels(frame.x * resolution, frame.y * resolution, width, height, gl.RGBA, gl.UNSIGNED_BYTE, webglPixels);

	            // add the pixels to the canvas
	            var canvasData = canvasBuffer.context.getImageData(0, 0, width, height);

	            canvasData.data.set(webglPixels);

	            canvasBuffer.context.putImageData(canvasData, 0, 0);

	            // pulling pixels
	            if (flipY) {
	                canvasBuffer.context.scale(1, -1);
	                canvasBuffer.context.drawImage(canvasBuffer.canvas, 0, -height);
	            }
	        }

	        if (generated) {
	            renderTexture.destroy(true);
	        }
	        // send the canvas back..

	        return canvasBuffer.canvas;
	    };

	    /**
	     * Will return a one-dimensional array containing the pixel data of the entire texture in RGBA
	     * order, with integer values between 0 and 255 (included).
	     *
	     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
	     *  to convert. If left empty will use use the main renderer
	     * @return {Uint8ClampedArray} One-dimensional array containing the pixel data of the entire texture
	     */


	    WebGLExtract.prototype.pixels = function pixels(target) {
	        var renderer = this.renderer;
	        var textureBuffer = void 0;
	        var resolution = void 0;
	        var frame = void 0;
	        var renderTexture = void 0;
	        var generated = false;

	        if (target) {
	            if (target instanceof core.RenderTexture) {
	                renderTexture = target;
	            } else {
	                renderTexture = this.renderer.generateTexture(target);
	                generated = true;
	            }
	        }

	        if (renderTexture) {
	            textureBuffer = renderTexture.baseTexture._glRenderTargets[this.renderer.CONTEXT_UID];
	            resolution = textureBuffer.resolution;
	            frame = renderTexture.frame;
	        } else {
	            textureBuffer = this.renderer.rootRenderTarget;
	            resolution = textureBuffer.resolution;

	            frame = TEMP_RECT;
	            frame.width = textureBuffer.size.width;
	            frame.height = textureBuffer.size.height;
	        }

	        var width = frame.width * resolution;
	        var height = frame.height * resolution;

	        var webglPixels = new Uint8Array(BYTES_PER_PIXEL * width * height);

	        if (textureBuffer) {
	            // bind the buffer
	            renderer.bindRenderTarget(textureBuffer);
	            // read pixels to the array
	            var gl = renderer.gl;

	            gl.readPixels(frame.x * resolution, frame.y * resolution, width, height, gl.RGBA, gl.UNSIGNED_BYTE, webglPixels);
	        }

	        if (generated) {
	            renderTexture.destroy(true);
	        }

	        return webglPixels;
	    };

	    /**
	     * Destroys the extract
	     *
	     */


	    WebGLExtract.prototype.destroy = function destroy() {
	        this.renderer.extract = null;
	        this.renderer = null;
	    };

	    return WebGLExtract;
	}();

	exports.default = WebGLExtract;


	core.WebGLRenderer.registerPlugin('extract', WebGLExtract);
	//# sourceMappingURL=WebGLExtract.js.map

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _core = __webpack_require__(173);

	var core = _interopRequireWildcard(_core);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var TEMP_RECT = new core.Rectangle();

	/**
	 * The extract manager provides functionality to export content from the renderers.
	 *
	 * An instance of this class is automatically created by default, and can be found at renderer.plugins.extract
	 *
	 * @class
	 * @memberof PIXI.extract
	 */

	var CanvasExtract = function () {
	    /**
	     * @param {PIXI.CanvasRenderer} renderer - A reference to the current renderer
	     */
	    function CanvasExtract(renderer) {
	        _classCallCheck(this, CanvasExtract);

	        this.renderer = renderer;
	        /**
	         * Collection of methods for extracting data (image, pixels, etc.) from a display object or render texture
	         *
	         * @member {PIXI.extract.CanvasExtract} extract
	         * @memberof PIXI.CanvasRenderer#
	         * @see PIXI.extract.CanvasExtract
	         */
	        renderer.extract = this;
	    }

	    /**
	     * Will return a HTML Image of the target
	     *
	     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
	     *  to convert. If left empty will use use the main renderer
	     * @return {HTMLImageElement} HTML Image of the target
	     */


	    CanvasExtract.prototype.image = function image(target) {
	        var image = new Image();

	        image.src = this.base64(target);

	        return image;
	    };

	    /**
	     * Will return a a base64 encoded string of this target. It works by calling
	     *  `CanvasExtract.getCanvas` and then running toDataURL on that.
	     *
	     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
	     *  to convert. If left empty will use use the main renderer
	     * @return {string} A base64 encoded string of the texture.
	     */


	    CanvasExtract.prototype.base64 = function base64(target) {
	        return this.canvas(target).toDataURL();
	    };

	    /**
	     * Creates a Canvas element, renders this target to it and then returns it.
	     *
	     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
	     *  to convert. If left empty will use use the main renderer
	     * @return {HTMLCanvasElement} A Canvas element with the texture rendered on.
	     */


	    CanvasExtract.prototype.canvas = function canvas(target) {
	        var renderer = this.renderer;
	        var context = void 0;
	        var resolution = void 0;
	        var frame = void 0;
	        var renderTexture = void 0;

	        if (target) {
	            if (target instanceof core.RenderTexture) {
	                renderTexture = target;
	            } else {
	                renderTexture = renderer.generateTexture(target);
	            }
	        }

	        if (renderTexture) {
	            context = renderTexture.baseTexture._canvasRenderTarget.context;
	            resolution = renderTexture.baseTexture._canvasRenderTarget.resolution;
	            frame = renderTexture.frame;
	        } else {
	            context = renderer.rootContext;

	            frame = TEMP_RECT;
	            frame.width = this.renderer.width;
	            frame.height = this.renderer.height;
	        }

	        var width = frame.width * resolution;
	        var height = frame.height * resolution;

	        var canvasBuffer = new core.CanvasRenderTarget(width, height, 1);
	        var canvasData = context.getImageData(frame.x * resolution, frame.y * resolution, width, height);

	        canvasBuffer.context.putImageData(canvasData, 0, 0);

	        // send the canvas back..
	        return canvasBuffer.canvas;
	    };

	    /**
	     * Will return a one-dimensional array containing the pixel data of the entire texture in RGBA
	     * order, with integer values between 0 and 255 (included).
	     *
	     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
	     *  to convert. If left empty will use use the main renderer
	     * @return {Uint8ClampedArray} One-dimensional array containing the pixel data of the entire texture
	     */


	    CanvasExtract.prototype.pixels = function pixels(target) {
	        var renderer = this.renderer;
	        var context = void 0;
	        var resolution = void 0;
	        var frame = void 0;
	        var renderTexture = void 0;

	        if (target) {
	            if (target instanceof core.RenderTexture) {
	                renderTexture = target;
	            } else {
	                renderTexture = renderer.generateTexture(target);
	            }
	        }

	        if (renderTexture) {
	            context = renderTexture.baseTexture._canvasRenderTarget.context;
	            resolution = renderTexture.baseTexture._canvasRenderTarget.resolution;
	            frame = renderTexture.frame;
	        } else {
	            context = renderer.rootContext;

	            frame = TEMP_RECT;
	            frame.width = renderer.width;
	            frame.height = renderer.height;
	        }

	        return context.getImageData(0, 0, frame.width * resolution, frame.height * resolution).data;
	    };

	    /**
	     * Destroys the extract
	     *
	     */


	    CanvasExtract.prototype.destroy = function destroy() {
	        this.renderer.extract = null;
	        this.renderer = null;
	    };

	    return CanvasExtract;
	}();

	exports.default = CanvasExtract;


	core.CanvasRenderer.registerPlugin('extract', CanvasExtract);
	//# sourceMappingURL=CanvasExtract.js.map

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;
	exports.BitmapText = exports.TilingSpriteRenderer = exports.TilingSprite = exports.AnimatedSprite = undefined;

	var _AnimatedSprite = __webpack_require__(300);

	Object.defineProperty(exports, 'AnimatedSprite', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AnimatedSprite).default;
	  }
	});

	var _TilingSprite = __webpack_require__(301);

	Object.defineProperty(exports, 'TilingSprite', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TilingSprite).default;
	  }
	});

	var _TilingSpriteRenderer = __webpack_require__(302);

	Object.defineProperty(exports, 'TilingSpriteRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TilingSpriteRenderer).default;
	  }
	});

	var _BitmapText = __webpack_require__(303);

	Object.defineProperty(exports, 'BitmapText', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BitmapText).default;
	  }
	});

	__webpack_require__(304);

	__webpack_require__(305);

	__webpack_require__(306);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	// imported for side effect of extending the prototype only, contains no exports
	//# sourceMappingURL=index.js.map

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _core = __webpack_require__(173);

	var core = _interopRequireWildcard(_core);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	/**
	 * @typedef PIXI.extras.AnimatedSprite~FrameObject
	 * @type {object}
	 * @property {PIXI.Texture} texture - The {@link PIXI.Texture} of the frame
	 * @property {number} time - the duration of the frame in ms
	 */

	/**
	 * An AnimatedSprite is a simple way to display an animation depicted by a list of textures.
	 *
	 * ```js
	 * let alienImages = ["image_sequence_01.png","image_sequence_02.png","image_sequence_03.png","image_sequence_04.png"];
	 * let textureArray = [];
	 *
	 * for (let i=0; i < 4; i++)
	 * {
	 *      let texture = PIXI.Texture.fromImage(alienImages[i]);
	 *      textureArray.push(texture);
	 * };
	 *
	 * let animatedSprite = new PIXI.extras.AnimatedSprite(textureArray);
	 * ```
	 *
	 * The more efficient and simpler way to create an animated sprite is using a {@link PIXI.Spritesheet}
	 * containing the animation definitions:
	 *
	 * ```js
	 * PIXI.loader.add("assets/spritesheet.json").load(setup);
	 *
	 * function setup() {
	 *   let sheet = PIXI.loader.resources["assets/spritesheet.json"].spritesheet;
	 *   animatedSprite = new PIXI.extras.AnimatedSprite(sheet.animations["image_sequence"]);
	 *   ...
	 * }
	 * ```
	 *
	 * @class
	 * @extends PIXI.Sprite
	 * @memberof PIXI.extras
	 */
	var AnimatedSprite = function (_core$Sprite) {
	    _inherits(AnimatedSprite, _core$Sprite);

	    /**
	     * @param {PIXI.Texture[]|PIXI.extras.AnimatedSprite~FrameObject[]} textures - an array of {@link PIXI.Texture} or frame
	     *  objects that make up the animation
	     * @param {boolean} [autoUpdate=true] - Whether to use PIXI.ticker.shared to auto update animation time.
	     */
	    function AnimatedSprite(textures, autoUpdate) {
	        _classCallCheck(this, AnimatedSprite);

	        /**
	         * @private
	         */
	        var _this = _possibleConstructorReturn(this, _core$Sprite.call(this, textures[0] instanceof core.Texture ? textures[0] : textures[0].texture));

	        _this._textures = null;

	        /**
	         * @private
	         */
	        _this._durations = null;

	        _this.textures = textures;

	        /**
	         * `true` uses PIXI.ticker.shared to auto update animation time.
	         * @type {boolean}
	         * @default true
	         * @private
	         */
	        _this._autoUpdate = autoUpdate !== false;

	        /**
	         * The speed that the AnimatedSprite will play at. Higher is faster, lower is slower
	         *
	         * @member {number}
	         * @default 1
	         */
	        _this.animationSpeed = 1;

	        /**
	         * Whether or not the animate sprite repeats after playing.
	         *
	         * @member {boolean}
	         * @default true
	         */
	        _this.loop = true;

	        /**
	         * Function to call when a AnimatedSprite finishes playing
	         *
	         * @member {Function}
	         */
	        _this.onComplete = null;

	        /**
	         * Function to call when a AnimatedSprite changes which texture is being rendered
	         *
	         * @member {Function}
	         */
	        _this.onFrameChange = null;

	        /**
	        * Function to call when 'loop' is true, and an AnimatedSprite is played and loops around to start again
	        *
	        * @member {Function}
	        */
	        _this.onLoop = null;

	        /**
	         * Elapsed time since animation has been started, used internally to display current texture
	         *
	         * @member {number}
	         * @private
	         */
	        _this._currentTime = 0;

	        /**
	         * Indicates if the AnimatedSprite is currently playing
	         *
	         * @member {boolean}
	         * @readonly
	         */
	        _this.playing = false;
	        return _this;
	    }

	    /**
	     * Stops the AnimatedSprite
	     *
	     */


	    AnimatedSprite.prototype.stop = function stop() {
	        if (!this.playing) {
	            return;
	        }

	        this.playing = false;
	        if (this._autoUpdate) {
	            core.ticker.shared.remove(this.update, this);
	        }
	    };

	    /**
	     * Plays the AnimatedSprite
	     *
	     */


	    AnimatedSprite.prototype.play = function play() {
	        if (this.playing) {
	            return;
	        }

	        this.playing = true;
	        if (this._autoUpdate) {
	            core.ticker.shared.add(this.update, this, core.UPDATE_PRIORITY.HIGH);
	        }
	    };

	    /**
	     * Stops the AnimatedSprite and goes to a specific frame
	     *
	     * @param {number} frameNumber - frame index to stop at
	     */


	    AnimatedSprite.prototype.gotoAndStop = function gotoAndStop(frameNumber) {
	        this.stop();

	        var previousFrame = this.currentFrame;

	        this._currentTime = frameNumber;

	        if (previousFrame !== this.currentFrame) {
	            this.updateTexture();
	        }
	    };

	    /**
	     * Goes to a specific frame and begins playing the AnimatedSprite
	     *
	     * @param {number} frameNumber - frame index to start at
	     */


	    AnimatedSprite.prototype.gotoAndPlay = function gotoAndPlay(frameNumber) {
	        var previousFrame = this.currentFrame;

	        this._currentTime = frameNumber;

	        if (previousFrame !== this.currentFrame) {
	            this.updateTexture();
	        }

	        this.play();
	    };

	    /**
	     * Updates the object transform for rendering.
	     *
	     * @private
	     * @param {number} deltaTime - Time since last tick.
	     */


	    AnimatedSprite.prototype.update = function update(deltaTime) {
	        var elapsed = this.animationSpeed * deltaTime;
	        var previousFrame = this.currentFrame;

	        if (this._durations !== null) {
	            var lag = this._currentTime % 1 * this._durations[this.currentFrame];

	            lag += elapsed / 60 * 1000;

	            while (lag < 0) {
	                this._currentTime--;
	                lag += this._durations[this.currentFrame];
	            }

	            var sign = Math.sign(this.animationSpeed * deltaTime);

	            this._currentTime = Math.floor(this._currentTime);

	            while (lag >= this._durations[this.currentFrame]) {
	                lag -= this._durations[this.currentFrame] * sign;
	                this._currentTime += sign;
	            }

	            this._currentTime += lag / this._durations[this.currentFrame];
	        } else {
	            this._currentTime += elapsed;
	        }

	        if (this._currentTime < 0 && !this.loop) {
	            this.gotoAndStop(0);

	            if (this.onComplete) {
	                this.onComplete();
	            }
	        } else if (this._currentTime >= this._textures.length && !this.loop) {
	            this.gotoAndStop(this._textures.length - 1);

	            if (this.onComplete) {
	                this.onComplete();
	            }
	        } else if (previousFrame !== this.currentFrame) {
	            if (this.loop && this.onLoop) {
	                if (this.animationSpeed > 0 && this.currentFrame < previousFrame) {
	                    this.onLoop();
	                } else if (this.animationSpeed < 0 && this.currentFrame > previousFrame) {
	                    this.onLoop();
	                }
	            }

	            this.updateTexture();
	        }
	    };

	    /**
	     * Updates the displayed texture to match the current frame index
	     *
	     * @private
	     */


	    AnimatedSprite.prototype.updateTexture = function updateTexture() {
	        this._texture = this._textures[this.currentFrame];
	        this._textureID = -1;
	        this.cachedTint = 0xFFFFFF;

	        if (this.onFrameChange) {
	            this.onFrameChange(this.currentFrame);
	        }
	    };

	    /**
	     * Stops the AnimatedSprite and destroys it
	     *
	     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
	     *  have been set to that value
	     * @param {boolean} [options.children=false] - if set to true, all the children will have their destroy
	     *      method called as well. 'options' will be passed on to those calls.
	     * @param {boolean} [options.texture=false] - Should it destroy the current texture of the sprite as well
	     * @param {boolean} [options.baseTexture=false] - Should it destroy the base texture of the sprite as well
	     */


	    AnimatedSprite.prototype.destroy = function destroy(options) {
	        this.stop();
	        _core$Sprite.prototype.destroy.call(this, options);
	    };

	    /**
	     * A short hand way of creating a movieclip from an array of frame ids
	     *
	     * @static
	     * @param {string[]} frames - The array of frames ids the movieclip will use as its texture frames
	     * @return {AnimatedSprite} The new animated sprite with the specified frames.
	     */


	    AnimatedSprite.fromFrames = function fromFrames(frames) {
	        var textures = [];

	        for (var i = 0; i < frames.length; ++i) {
	            textures.push(core.Texture.fromFrame(frames[i]));
	        }

	        return new AnimatedSprite(textures);
	    };

	    /**
	     * A short hand way of creating a movieclip from an array of image ids
	     *
	     * @static
	     * @param {string[]} images - the array of image urls the movieclip will use as its texture frames
	     * @return {AnimatedSprite} The new animate sprite with the specified images as frames.
	     */


	    AnimatedSprite.fromImages = function fromImages(images) {
	        var textures = [];

	        for (var i = 0; i < images.length; ++i) {
	            textures.push(core.Texture.fromImage(images[i]));
	        }

	        return new AnimatedSprite(textures);
	    };

	    /**
	     * totalFrames is the total number of frames in the AnimatedSprite. This is the same as number of textures
	     * assigned to the AnimatedSprite.
	     *
	     * @readonly
	     * @member {number}
	     * @default 0
	     */


	    _createClass(AnimatedSprite, [{
	        key: 'totalFrames',
	        get: function get() {
	            return this._textures.length;
	        }

	        /**
	         * The array of textures used for this AnimatedSprite
	         *
	         * @member {PIXI.Texture[]}
	         */

	    }, {
	        key: 'textures',
	        get: function get() {
	            return this._textures;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            if (value[0] instanceof core.Texture) {
	                this._textures = value;
	                this._durations = null;
	            } else {
	                this._textures = [];
	                this._durations = [];

	                for (var i = 0; i < value.length; i++) {
	                    this._textures.push(value[i].texture);
	                    this._durations.push(value[i].time);
	                }
	            }
	            this.gotoAndStop(0);
	            this.updateTexture();
	        }

	        /**
	        * The AnimatedSprites current frame index
	        *
	        * @member {number}
	        * @readonly
	        */

	    }, {
	        key: 'currentFrame',
	        get: function get() {
	            var currentFrame = Math.floor(this._currentTime) % this._textures.length;

	            if (currentFrame < 0) {
	                currentFrame += this._textures.length;
	            }

	            return currentFrame;
	        }
	    }]);

	    return AnimatedSprite;
	}(core.Sprite);

	exports.default = AnimatedSprite;
	//# sourceMappingURL=AnimatedSprite.js.map

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _core = __webpack_require__(173);

	var core = _interopRequireWildcard(_core);

	var _CanvasTinter = __webpack_require__(243);

	var _CanvasTinter2 = _interopRequireDefault(_CanvasTinter);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var tempPoint = new core.Point();

	/**
	 * A tiling sprite is a fast way of rendering a tiling image
	 *
	 * @class
	 * @extends PIXI.Sprite
	 * @memberof PIXI.extras
	 */

	var TilingSprite = function (_core$Sprite) {
	    _inherits(TilingSprite, _core$Sprite);

	    /**
	     * @param {PIXI.Texture} texture - the texture of the tiling sprite
	     * @param {number} [width=100] - the width of the tiling sprite
	     * @param {number} [height=100] - the height of the tiling sprite
	     */
	    function TilingSprite(texture) {
	        var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
	        var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;

	        _classCallCheck(this, TilingSprite);

	        /**
	         * Tile transform
	         *
	         * @member {PIXI.TransformStatic}
	         */
	        var _this = _possibleConstructorReturn(this, _core$Sprite.call(this, texture));

	        _this.tileTransform = new core.TransformStatic();

	        // /// private

	        /**
	         * The with of the tiling sprite
	         *
	         * @member {number}
	         * @private
	         */
	        _this._width = width;

	        /**
	         * The height of the tiling sprite
	         *
	         * @member {number}
	         * @private
	         */
	        _this._height = height;

	        /**
	         * Canvas pattern
	         *
	         * @type {CanvasPattern}
	         * @private
	         */
	        _this._canvasPattern = null;

	        /**
	         * transform that is applied to UV to get the texture coords
	         *
	         * @member {PIXI.TextureMatrix}
	         */
	        _this.uvTransform = texture.transform || new core.TextureMatrix(texture);

	        /**
	         * Plugin that is responsible for rendering this element.
	         * Allows to customize the rendering process without overriding '_renderWebGL' method.
	         *
	         * @member {string}
	         * @default 'tilingSprite'
	         */
	        _this.pluginName = 'tilingSprite';

	        /**
	         * Whether or not anchor affects uvs
	         *
	         * @member {boolean}
	         * @default false
	         */
	        _this.uvRespectAnchor = false;
	        return _this;
	    }
	    /**
	     * Changes frame clamping in corresponding textureTransform, shortcut
	     * Change to -0.5 to add a pixel to the edge, recommended for transparent trimmed textures in atlas
	     *
	     * @default 0.5
	     * @member {number}
	     */


	    /**
	     * @private
	     */
	    TilingSprite.prototype._onTextureUpdate = function _onTextureUpdate() {
	        if (this.uvTransform) {
	            this.uvTransform.texture = this._texture;
	        }
	        this.cachedTint = 0xFFFFFF;
	    };

	    /**
	     * Renders the object using the WebGL renderer
	     *
	     * @private
	     * @param {PIXI.WebGLRenderer} renderer - The renderer
	     */


	    TilingSprite.prototype._renderWebGL = function _renderWebGL(renderer) {
	        // tweak our texture temporarily..
	        var texture = this._texture;

	        if (!texture || !texture.valid) {
	            return;
	        }

	        this.tileTransform.updateLocalTransform();
	        this.uvTransform.update();

	        renderer.setObjectRenderer(renderer.plugins[this.pluginName]);
	        renderer.plugins[this.pluginName].render(this);
	    };

	    /**
	     * Renders the object using the Canvas renderer
	     *
	     * @private
	     * @param {PIXI.CanvasRenderer} renderer - a reference to the canvas renderer
	     */


	    TilingSprite.prototype._renderCanvas = function _renderCanvas(renderer) {
	        var texture = this._texture;

	        if (!texture.baseTexture.hasLoaded) {
	            return;
	        }

	        var context = renderer.context;
	        var transform = this.worldTransform;
	        var resolution = renderer.resolution;
	        var baseTexture = texture.baseTexture;
	        var baseTextureResolution = baseTexture.resolution;
	        var modX = this.tilePosition.x / this.tileScale.x % texture._frame.width * baseTextureResolution;
	        var modY = this.tilePosition.y / this.tileScale.y % texture._frame.height * baseTextureResolution;

	        // create a nice shiny pattern!
	        if (this._textureID !== this._texture._updateID || this.cachedTint !== this.tint) {
	            this._textureID = this._texture._updateID;
	            // cut an object from a spritesheet..
	            var tempCanvas = new core.CanvasRenderTarget(texture._frame.width, texture._frame.height, baseTextureResolution);

	            // Tint the tiling sprite
	            if (this.tint !== 0xFFFFFF) {
	                this.tintedTexture = _CanvasTinter2.default.getTintedTexture(this, this.tint);
	                tempCanvas.context.drawImage(this.tintedTexture, 0, 0);
	            } else {
	                tempCanvas.context.drawImage(baseTexture.source, -texture._frame.x * baseTextureResolution, -texture._frame.y * baseTextureResolution);
	            }
	            this.cachedTint = this.tint;
	            this._canvasPattern = tempCanvas.context.createPattern(tempCanvas.canvas, 'repeat');
	        }

	        // set context state..
	        context.globalAlpha = this.worldAlpha;
	        context.setTransform(transform.a * resolution, transform.b * resolution, transform.c * resolution, transform.d * resolution, transform.tx * resolution, transform.ty * resolution);

	        renderer.setBlendMode(this.blendMode);

	        // fill the pattern!
	        context.fillStyle = this._canvasPattern;

	        // TODO - this should be rolled into the setTransform above..
	        context.scale(this.tileScale.x / baseTextureResolution, this.tileScale.y / baseTextureResolution);

	        var anchorX = this.anchor.x * -this._width;
	        var anchorY = this.anchor.y * -this._height;

	        if (this.uvRespectAnchor) {
	            context.translate(modX, modY);

	            context.fillRect(-modX + anchorX, -modY + anchorY, this._width / this.tileScale.x * baseTextureResolution, this._height / this.tileScale.y * baseTextureResolution);
	        } else {
	            context.translate(modX + anchorX, modY + anchorY);

	            context.fillRect(-modX, -modY, this._width / this.tileScale.x * baseTextureResolution, this._height / this.tileScale.y * baseTextureResolution);
	        }
	    };

	    /**
	     * Updates the bounds of the tiling sprite.
	     *
	     * @private
	     */


	    TilingSprite.prototype._calculateBounds = function _calculateBounds() {
	        var minX = this._width * -this._anchor._x;
	        var minY = this._height * -this._anchor._y;
	        var maxX = this._width * (1 - this._anchor._x);
	        var maxY = this._height * (1 - this._anchor._y);

	        this._bounds.addFrame(this.transform, minX, minY, maxX, maxY);
	    };

	    /**
	     * Gets the local bounds of the sprite object.
	     *
	     * @param {PIXI.Rectangle} rect - The output rectangle.
	     * @return {PIXI.Rectangle} The bounds.
	     */


	    TilingSprite.prototype.getLocalBounds = function getLocalBounds(rect) {
	        // we can do a fast local bounds if the sprite has no children!
	        if (this.children.length === 0) {
	            this._bounds.minX = this._width * -this._anchor._x;
	            this._bounds.minY = this._height * -this._anchor._y;
	            this._bounds.maxX = this._width * (1 - this._anchor._x);
	            this._bounds.maxY = this._height * (1 - this._anchor._y);

	            if (!rect) {
	                if (!this._localBoundsRect) {
	                    this._localBoundsRect = new core.Rectangle();
	                }

	                rect = this._localBoundsRect;
	            }

	            return this._bounds.getRectangle(rect);
	        }

	        return _core$Sprite.prototype.getLocalBounds.call(this, rect);
	    };

	    /**
	     * Checks if a point is inside this tiling sprite.
	     *
	     * @param {PIXI.Point} point - the point to check
	     * @return {boolean} Whether or not the sprite contains the point.
	     */


	    TilingSprite.prototype.containsPoint = function containsPoint(point) {
	        this.worldTransform.applyInverse(point, tempPoint);

	        var width = this._width;
	        var height = this._height;
	        var x1 = -width * this.anchor._x;

	        if (tempPoint.x >= x1 && tempPoint.x < x1 + width) {
	            var y1 = -height * this.anchor._y;

	            if (tempPoint.y >= y1 && tempPoint.y < y1 + height) {
	                return true;
	            }
	        }

	        return false;
	    };

	    /**
	     * Destroys this sprite and optionally its texture and children
	     *
	     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
	     *  have been set to that value
	     * @param {boolean} [options.children=false] - if set to true, all the children will have their destroy
	     *      method called as well. 'options' will be passed on to those calls.
	     * @param {boolean} [options.texture=false] - Should it destroy the current texture of the sprite as well
	     * @param {boolean} [options.baseTexture=false] - Should it destroy the base texture of the sprite as well
	     */


	    TilingSprite.prototype.destroy = function destroy(options) {
	        _core$Sprite.prototype.destroy.call(this, options);

	        this.tileTransform = null;
	        this.uvTransform = null;
	    };

	    /**
	     * Helper function that creates a new tiling sprite based on the source you provide.
	     * The source can be - frame id, image url, video url, canvas element, video element, base texture
	     *
	     * @static
	     * @param {number|string|PIXI.BaseTexture|HTMLCanvasElement|HTMLVideoElement} source - Source to create texture from
	     * @param {number} width - the width of the tiling sprite
	     * @param {number} height - the height of the tiling sprite
	     * @return {PIXI.Texture} The newly created texture
	     */


	    TilingSprite.from = function from(source, width, height) {
	        return new TilingSprite(core.Texture.from(source), width, height);
	    };

	    /**
	     * Helper function that creates a tiling sprite that will use a texture from the TextureCache based on the frameId
	     * The frame ids are created when a Texture packer file has been loaded
	     *
	     * @static
	     * @param {string} frameId - The frame Id of the texture in the cache
	     * @param {number} width - the width of the tiling sprite
	     * @param {number} height - the height of the tiling sprite
	     * @return {PIXI.extras.TilingSprite} A new TilingSprite using a texture from the texture cache matching the frameId
	     */


	    TilingSprite.fromFrame = function fromFrame(frameId, width, height) {
	        var texture = core.utils.TextureCache[frameId];

	        if (!texture) {
	            throw new Error('The frameId "' + frameId + '" does not exist in the texture cache ' + this);
	        }

	        return new TilingSprite(texture, width, height);
	    };

	    /**
	     * Helper function that creates a sprite that will contain a texture based on an image url
	     * If the image is not in the texture cache it will be loaded
	     *
	     * @static
	     * @param {string} imageId - The image url of the texture
	     * @param {number} width - the width of the tiling sprite
	     * @param {number} height - the height of the tiling sprite
	     * @param {boolean} [crossorigin] - if you want to specify the cross-origin parameter
	     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - if you want to specify the scale mode,
	     *  see {@link PIXI.SCALE_MODES} for possible values
	     * @return {PIXI.extras.TilingSprite} A new TilingSprite using a texture from the texture cache matching the image id
	     */


	    TilingSprite.fromImage = function fromImage(imageId, width, height, crossorigin, scaleMode) {
	        return new TilingSprite(core.Texture.fromImage(imageId, crossorigin, scaleMode), width, height);
	    };

	    /**
	     * The width of the sprite, setting this will actually modify the scale to achieve the value set
	     *
	     * @member {number}
	     */


	    _createClass(TilingSprite, [{
	        key: 'clampMargin',
	        get: function get() {
	            return this.uvTransform.clampMargin;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.uvTransform.clampMargin = value;
	            this.uvTransform.update(true);
	        }

	        /**
	         * The scaling of the image that is being tiled
	         *
	         * @member {PIXI.ObservablePoint}
	         */

	    }, {
	        key: 'tileScale',
	        get: function get() {
	            return this.tileTransform.scale;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.tileTransform.scale.copy(value);
	        }

	        /**
	         * The offset of the image that is being tiled
	         *
	         * @member {PIXI.ObservablePoint}
	         */

	    }, {
	        key: 'tilePosition',
	        get: function get() {
	            return this.tileTransform.position;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.tileTransform.position.copy(value);
	        }
	    }, {
	        key: 'width',
	        get: function get() {
	            return this._width;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._width = value;
	        }

	        /**
	         * The height of the TilingSprite, setting this will actually modify the scale to achieve the value set
	         *
	         * @member {number}
	         */

	    }, {
	        key: 'height',
	        get: function get() {
	            return this._height;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._height = value;
	        }
	    }]);

	    return TilingSprite;
	}(core.Sprite);

	exports.default = TilingSprite;
	//# sourceMappingURL=TilingSprite.js.map

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _core = __webpack_require__(173);

	var core = _interopRequireWildcard(_core);

	var _const = __webpack_require__(174);

	var _path = __webpack_require__(252);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var tempMat = new core.Matrix();

	/**
	 * WebGL renderer plugin for tiling sprites
	 *
	 * @class
	 * @memberof PIXI.extras
	 * @extends PIXI.ObjectRenderer
	 */

	var TilingSpriteRenderer = function (_core$ObjectRenderer) {
	    _inherits(TilingSpriteRenderer, _core$ObjectRenderer);

	    /**
	     * constructor for renderer
	     *
	     * @param {WebGLRenderer} renderer The renderer this tiling awesomeness works for.
	     */
	    function TilingSpriteRenderer(renderer) {
	        _classCallCheck(this, TilingSpriteRenderer);

	        var _this = _possibleConstructorReturn(this, _core$ObjectRenderer.call(this, renderer));

	        _this.shader = null;
	        _this.simpleShader = null;
	        _this.quad = null;
	        return _this;
	    }

	    /**
	     * Sets up the renderer context and necessary buffers.
	     *
	     * @private
	     */


	    TilingSpriteRenderer.prototype.onContextChange = function onContextChange() {
	        var gl = this.renderer.gl;

	        this.shader = new core.Shader(gl, 'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 translationMatrix;\nuniform mat3 uTransform;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = (uTransform * vec3(aTextureCoord, 1.0)).xy;\n}\n', 'varying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform vec4 uColor;\nuniform mat3 uMapCoord;\nuniform vec4 uClampFrame;\nuniform vec2 uClampOffset;\n\nvoid main(void)\n{\n    vec2 coord = mod(vTextureCoord - uClampOffset, vec2(1.0, 1.0)) + uClampOffset;\n    coord = (uMapCoord * vec3(coord, 1.0)).xy;\n    coord = clamp(coord, uClampFrame.xy, uClampFrame.zw);\n\n    vec4 sample = texture2D(uSampler, coord);\n    gl_FragColor = sample * uColor;\n}\n');
	        this.simpleShader = new core.Shader(gl, 'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 translationMatrix;\nuniform mat3 uTransform;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = (uTransform * vec3(aTextureCoord, 1.0)).xy;\n}\n', 'varying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform vec4 uColor;\n\nvoid main(void)\n{\n    vec4 sample = texture2D(uSampler, vTextureCoord);\n    gl_FragColor = sample * uColor;\n}\n');

	        this.renderer.bindVao(null);
	        this.quad = new core.Quad(gl, this.renderer.state.attribState);
	        this.quad.initVao(this.shader);
	    };

	    /**
	     *
	     * @param {PIXI.extras.TilingSprite} ts tilingSprite to be rendered
	     */


	    TilingSpriteRenderer.prototype.render = function render(ts) {
	        var renderer = this.renderer;
	        var quad = this.quad;

	        renderer.bindVao(quad.vao);

	        var vertices = quad.vertices;

	        vertices[0] = vertices[6] = ts._width * -ts.anchor.x;
	        vertices[1] = vertices[3] = ts._height * -ts.anchor.y;

	        vertices[2] = vertices[4] = ts._width * (1.0 - ts.anchor.x);
	        vertices[5] = vertices[7] = ts._height * (1.0 - ts.anchor.y);

	        if (ts.uvRespectAnchor) {
	            vertices = quad.uvs;

	            vertices[0] = vertices[6] = -ts.anchor.x;
	            vertices[1] = vertices[3] = -ts.anchor.y;

	            vertices[2] = vertices[4] = 1.0 - ts.anchor.x;
	            vertices[5] = vertices[7] = 1.0 - ts.anchor.y;
	        }

	        quad.upload();

	        var tex = ts._texture;
	        var baseTex = tex.baseTexture;
	        var lt = ts.tileTransform.localTransform;
	        var uv = ts.uvTransform;
	        var isSimple = baseTex.isPowerOfTwo && tex.frame.width === baseTex.width && tex.frame.height === baseTex.height;

	        // auto, force repeat wrapMode for big tiling textures
	        if (isSimple) {
	            if (!baseTex._glTextures[renderer.CONTEXT_UID]) {
	                if (baseTex.wrapMode === _const.WRAP_MODES.CLAMP) {
	                    baseTex.wrapMode = _const.WRAP_MODES.REPEAT;
	                }
	            } else {
	                isSimple = baseTex.wrapMode !== _const.WRAP_MODES.CLAMP;
	            }
	        }

	        var shader = isSimple ? this.simpleShader : this.shader;

	        renderer.bindShader(shader);

	        var w = tex.width;
	        var h = tex.height;
	        var W = ts._width;
	        var H = ts._height;

	        tempMat.set(lt.a * w / W, lt.b * w / H, lt.c * h / W, lt.d * h / H, lt.tx / W, lt.ty / H);

	        // that part is the same as above:
	        // tempMat.identity();
	        // tempMat.scale(tex.width, tex.height);
	        // tempMat.prepend(lt);
	        // tempMat.scale(1.0 / ts._width, 1.0 / ts._height);

	        tempMat.invert();
	        if (isSimple) {
	            tempMat.prepend(uv.mapCoord);
	        } else {
	            shader.uniforms.uMapCoord = uv.mapCoord.toArray(true);
	            shader.uniforms.uClampFrame = uv.uClampFrame;
	            shader.uniforms.uClampOffset = uv.uClampOffset;
	        }

	        shader.uniforms.uTransform = tempMat.toArray(true);
	        shader.uniforms.uColor = core.utils.premultiplyTintToRgba(ts.tint, ts.worldAlpha, shader.uniforms.uColor, baseTex.premultipliedAlpha);
	        shader.uniforms.translationMatrix = ts.transform.worldTransform.toArray(true);

	        shader.uniforms.uSampler = renderer.bindTexture(tex);

	        renderer.setBlendMode(core.utils.correctBlendMode(ts.blendMode, baseTex.premultipliedAlpha));

	        quad.vao.draw(this.renderer.gl.TRIANGLES, 6, 0);
	    };

	    return TilingSpriteRenderer;
	}(core.ObjectRenderer);

	exports.default = TilingSpriteRenderer;


	core.WebGLRenderer.registerPlugin('tilingSprite', TilingSpriteRenderer);
	//# sourceMappingURL=TilingSpriteRenderer.js.map

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _core = __webpack_require__(173);

	var core = _interopRequireWildcard(_core);

	var _ObservablePoint = __webpack_require__(177);

	var _ObservablePoint2 = _interopRequireDefault(_ObservablePoint);

	var _utils = __webpack_require__(213);

	var _settings = __webpack_require__(205);

	var _settings2 = _interopRequireDefault(_settings);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	/**
	 * A BitmapText object will create a line or multiple lines of text using bitmap font. To
	 * split a line you can use '\n', '\r' or '\r\n' in your string. You can generate the fnt files using:
	 *
	 * A BitmapText can only be created when the font is loaded
	 *
	 * ```js
	 * // in this case the font is in a file called 'desyrel.fnt'
	 * let bitmapText = new PIXI.extras.BitmapText("text using a fancy font!", {font: "35px Desyrel", align: "right"});
	 * ```
	 *
	 * http://www.angelcode.com/products/bmfont/ for windows or
	 * http://www.bmglyph.com/ for mac.
	 *
	 * @class
	 * @extends PIXI.Container
	 * @memberof PIXI.extras
	 */
	var BitmapText = function (_core$Container) {
	    _inherits(BitmapText, _core$Container);

	    /**
	     * @param {string} text - The copy that you would like the text to display
	     * @param {object} style - The style parameters
	     * @param {string|object} style.font - The font descriptor for the object, can be passed as a string of form
	     *      "24px FontName" or "FontName" or as an object with explicit name/size properties.
	     * @param {string} [style.font.name] - The bitmap font id
	     * @param {number} [style.font.size] - The size of the font in pixels, e.g. 24
	     * @param {string} [style.align='left'] - Alignment for multiline text ('left', 'center' or 'right'), does not affect
	     *      single line text
	     * @param {number} [style.tint=0xFFFFFF] - The tint color
	     */
	    function BitmapText(text) {
	        var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	        _classCallCheck(this, BitmapText);

	        /**
	         * Private tracker for the width of the overall text
	         *
	         * @member {number}
	         * @private
	         */
	        var _this = _possibleConstructorReturn(this, _core$Container.call(this));

	        _this._textWidth = 0;

	        /**
	         * Private tracker for the height of the overall text
	         *
	         * @member {number}
	         * @private
	         */
	        _this._textHeight = 0;

	        /**
	         * Private tracker for the letter sprite pool.
	         *
	         * @member {PIXI.Sprite[]}
	         * @private
	         */
	        _this._glyphs = [];

	        /**
	         * Private tracker for the current style.
	         *
	         * @member {object}
	         * @private
	         */
	        _this._font = {
	            tint: style.tint !== undefined ? style.tint : 0xFFFFFF,
	            align: style.align || 'left',
	            name: null,
	            size: 0
	        };

	        /**
	         * Private tracker for the current font.
	         *
	         * @member {object}
	         * @private
	         */
	        _this.font = style.font; // run font setter

	        /**
	         * Private tracker for the current text.
	         *
	         * @member {string}
	         * @private
	         */
	        _this._text = text;

	        /**
	         * The max width of this bitmap text in pixels. If the text provided is longer than the
	         * value provided, line breaks will be automatically inserted in the last whitespace.
	         * Disable by setting value to 0
	         *
	         * @member {number}
	         * @private
	         */
	        _this._maxWidth = 0;

	        /**
	         * The max line height. This is useful when trying to use the total height of the Text,
	         * ie: when trying to vertically align.
	         *
	         * @member {number}
	         * @private
	         */
	        _this._maxLineHeight = 0;

	        /**
	         * Letter spacing. This is useful for setting the space between characters.
	         * @member {number}
	         * @private
	         */
	        _this._letterSpacing = 0;

	        /**
	         * Text anchor. read-only
	         *
	         * @member {PIXI.ObservablePoint}
	         * @private
	         */
	        _this._anchor = new _ObservablePoint2.default(function () {
	            _this.dirty = true;
	        }, _this, 0, 0);

	        /**
	         * The dirty state of this object.
	         *
	         * @member {boolean}
	         */
	        _this.dirty = false;

	        _this.updateText();
	        return _this;
	    }

	    /**
	     * Renders text and updates it when needed
	     *
	     * @private
	     */


	    BitmapText.prototype.updateText = function updateText() {
	        var data = BitmapText.fonts[this._font.name];
	        var scale = this._font.size / data.size;
	        var pos = new core.Point();
	        var chars = [];
	        var lineWidths = [];
	        var text = this.text.replace(/(?:\r\n|\r)/g, '\n');
	        var textLength = text.length;
	        var maxWidth = this._maxWidth * data.size / this._font.size;

	        var prevCharCode = null;
	        var lastLineWidth = 0;
	        var maxLineWidth = 0;
	        var line = 0;
	        var lastBreakPos = -1;
	        var lastBreakWidth = 0;
	        var spacesRemoved = 0;
	        var maxLineHeight = 0;

	        for (var i = 0; i < textLength; i++) {
	            var charCode = text.charCodeAt(i);
	            var char = text.charAt(i);

	            if (/(?:\s)/.test(char)) {
	                lastBreakPos = i;
	                lastBreakWidth = lastLineWidth;
	            }

	            if (char === '\r' || char === '\n') {
	                lineWidths.push(lastLineWidth);
	                maxLineWidth = Math.max(maxLineWidth, lastLineWidth);
	                ++line;
	                ++spacesRemoved;

	                pos.x = 0;
	                pos.y += data.lineHeight;
	                prevCharCode = null;
	                continue;
	            }

	            var charData = data.chars[charCode];

	            if (!charData) {
	                continue;
	            }

	            if (prevCharCode && charData.kerning[prevCharCode]) {
	                pos.x += charData.kerning[prevCharCode];
	            }

	            chars.push({
	                texture: charData.texture,
	                line: line,
	                charCode: charCode,
	                position: new core.Point(pos.x + charData.xOffset + this._letterSpacing / 2, pos.y + charData.yOffset)
	            });
	            pos.x += charData.xAdvance + this._letterSpacing;
	            lastLineWidth = pos.x;
	            maxLineHeight = Math.max(maxLineHeight, charData.yOffset + charData.texture.height);
	            prevCharCode = charCode;

	            if (lastBreakPos !== -1 && maxWidth > 0 && pos.x > maxWidth) {
	                ++spacesRemoved;
	                core.utils.removeItems(chars, 1 + lastBreakPos - spacesRemoved, 1 + i - lastBreakPos);
	                i = lastBreakPos;
	                lastBreakPos = -1;

	                lineWidths.push(lastBreakWidth);
	                maxLineWidth = Math.max(maxLineWidth, lastBreakWidth);
	                line++;

	                pos.x = 0;
	                pos.y += data.lineHeight;
	                prevCharCode = null;
	            }
	        }

	        var lastChar = text.charAt(text.length - 1);

	        if (lastChar !== '\r' && lastChar !== '\n') {
	            if (/(?:\s)/.test(lastChar)) {
	                lastLineWidth = lastBreakWidth;
	            }

	            lineWidths.push(lastLineWidth);
	            maxLineWidth = Math.max(maxLineWidth, lastLineWidth);
	        }

	        var lineAlignOffsets = [];

	        for (var _i = 0; _i <= line; _i++) {
	            var alignOffset = 0;

	            if (this._font.align === 'right') {
	                alignOffset = maxLineWidth - lineWidths[_i];
	            } else if (this._font.align === 'center') {
	                alignOffset = (maxLineWidth - lineWidths[_i]) / 2;
	            }

	            lineAlignOffsets.push(alignOffset);
	        }

	        var lenChars = chars.length;
	        var tint = this.tint;

	        for (var _i2 = 0; _i2 < lenChars; _i2++) {
	            var c = this._glyphs[_i2]; // get the next glyph sprite

	            if (c) {
	                c.texture = chars[_i2].texture;
	            } else {
	                c = new core.Sprite(chars[_i2].texture);
	                this._glyphs.push(c);
	            }

	            c.position.x = (chars[_i2].position.x + lineAlignOffsets[chars[_i2].line]) * scale;
	            c.position.y = chars[_i2].position.y * scale;
	            c.scale.x = c.scale.y = scale;
	            c.tint = tint;

	            if (!c.parent) {
	                this.addChild(c);
	            }
	        }

	        // remove unnecessary children.
	        for (var _i3 = lenChars; _i3 < this._glyphs.length; ++_i3) {
	            this.removeChild(this._glyphs[_i3]);
	        }

	        this._textWidth = maxLineWidth * scale;
	        this._textHeight = (pos.y + data.lineHeight) * scale;

	        // apply anchor
	        if (this.anchor.x !== 0 || this.anchor.y !== 0) {
	            for (var _i4 = 0; _i4 < lenChars; _i4++) {
	                this._glyphs[_i4].x -= this._textWidth * this.anchor.x;
	                this._glyphs[_i4].y -= this._textHeight * this.anchor.y;
	            }
	        }
	        this._maxLineHeight = maxLineHeight * scale;
	    };

	    /**
	     * Updates the transform of this object
	     *
	     * @private
	     */


	    BitmapText.prototype.updateTransform = function updateTransform() {
	        this.validate();
	        this.containerUpdateTransform();
	    };

	    /**
	     * Validates text before calling parent's getLocalBounds
	     *
	     * @return {PIXI.Rectangle} The rectangular bounding area
	     */


	    BitmapText.prototype.getLocalBounds = function getLocalBounds() {
	        this.validate();

	        return _core$Container.prototype.getLocalBounds.call(this);
	    };

	    /**
	     * Updates text when needed
	     *
	     * @private
	     */


	    BitmapText.prototype.validate = function validate() {
	        if (this.dirty) {
	            this.updateText();
	            this.dirty = false;
	        }
	    };

	    /**
	     * The tint of the BitmapText object
	     *
	     * @member {number}
	     */


	    /**
	     * Register a bitmap font with data and a texture.
	     *
	     * @static
	     * @param {XMLDocument} xml - The XML document data.
	     * @param {Object.<string, PIXI.Texture>|PIXI.Texture|PIXI.Texture[]} textures - List of textures for each page.
	     *  If providing an object, the key is the `<page>` element's `file` attribute in the FNT file.
	     * @return {Object} Result font object with font, size, lineHeight and char fields.
	     */
	    BitmapText.registerFont = function registerFont(xml, textures) {
	        var data = {};
	        var info = xml.getElementsByTagName('info')[0];
	        var common = xml.getElementsByTagName('common')[0];
	        var pages = xml.getElementsByTagName('page');
	        var res = (0, _utils.getResolutionOfUrl)(pages[0].getAttribute('file'), _settings2.default.RESOLUTION);
	        var pagesTextures = {};

	        data.font = info.getAttribute('face');
	        data.size = parseInt(info.getAttribute('size'), 10);
	        data.lineHeight = parseInt(common.getAttribute('lineHeight'), 10) / res;
	        data.chars = {};

	        // Single texture, convert to list
	        if (textures instanceof core.Texture) {
	            textures = [textures];
	        }

	        // Convert the input Texture, Textures or object
	        // into a page Texture lookup by "id"
	        for (var i = 0; i < pages.length; i++) {
	            var id = pages[i].getAttribute('id');
	            var file = pages[i].getAttribute('file');

	            pagesTextures[id] = textures instanceof Array ? textures[i] : textures[file];
	        }

	        // parse letters
	        var letters = xml.getElementsByTagName('char');

	        for (var _i5 = 0; _i5 < letters.length; _i5++) {
	            var letter = letters[_i5];
	            var charCode = parseInt(letter.getAttribute('id'), 10);
	            var page = letter.getAttribute('page') || 0;
	            var textureRect = new core.Rectangle(parseInt(letter.getAttribute('x'), 10) / res + pagesTextures[page].frame.x / res, parseInt(letter.getAttribute('y'), 10) / res + pagesTextures[page].frame.y / res, parseInt(letter.getAttribute('width'), 10) / res, parseInt(letter.getAttribute('height'), 10) / res);

	            data.chars[charCode] = {
	                xOffset: parseInt(letter.getAttribute('xoffset'), 10) / res,
	                yOffset: parseInt(letter.getAttribute('yoffset'), 10) / res,
	                xAdvance: parseInt(letter.getAttribute('xadvance'), 10) / res,
	                kerning: {},
	                texture: new core.Texture(pagesTextures[page].baseTexture, textureRect),
	                page: page
	            };
	        }

	        // parse kernings
	        var kernings = xml.getElementsByTagName('kerning');

	        for (var _i6 = 0; _i6 < kernings.length; _i6++) {
	            var kerning = kernings[_i6];
	            var first = parseInt(kerning.getAttribute('first'), 10) / res;
	            var second = parseInt(kerning.getAttribute('second'), 10) / res;
	            var amount = parseInt(kerning.getAttribute('amount'), 10) / res;

	            if (data.chars[second]) {
	                data.chars[second].kerning[first] = amount;
	            }
	        }

	        // I'm leaving this as a temporary fix so we can test the bitmap fonts in v3
	        // but it's very likely to change
	        BitmapText.fonts[data.font] = data;

	        return data;
	    };

	    _createClass(BitmapText, [{
	        key: 'tint',
	        get: function get() {
	            return this._font.tint;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._font.tint = typeof value === 'number' && value >= 0 ? value : 0xFFFFFF;

	            this.dirty = true;
	        }

	        /**
	         * The alignment of the BitmapText object
	         *
	         * @member {string}
	         * @default 'left'
	         */

	    }, {
	        key: 'align',
	        get: function get() {
	            return this._font.align;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._font.align = value || 'left';

	            this.dirty = true;
	        }

	        /**
	         * The anchor sets the origin point of the text.
	         * The default is 0,0 this means the text's origin is the top left
	         * Setting the anchor to 0.5,0.5 means the text's origin is centered
	         * Setting the anchor to 1,1 would mean the text's origin point will be the bottom right corner
	         *
	         * @member {PIXI.Point | number}
	         */

	    }, {
	        key: 'anchor',
	        get: function get() {
	            return this._anchor;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            if (typeof value === 'number') {
	                this._anchor.set(value);
	            } else {
	                this._anchor.copy(value);
	            }
	        }

	        /**
	         * The font descriptor of the BitmapText object
	         *
	         * @member {string|object}
	         */

	    }, {
	        key: 'font',
	        get: function get() {
	            return this._font;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            if (!value) {
	                return;
	            }

	            if (typeof value === 'string') {
	                value = value.split(' ');

	                this._font.name = value.length === 1 ? value[0] : value.slice(1).join(' ');
	                this._font.size = value.length >= 2 ? parseInt(value[0], 10) : BitmapText.fonts[this._font.name].size;
	            } else {
	                this._font.name = value.name;
	                this._font.size = typeof value.size === 'number' ? value.size : parseInt(value.size, 10);
	            }

	            this.dirty = true;
	        }

	        /**
	         * The text of the BitmapText object
	         *
	         * @member {string}
	         */

	    }, {
	        key: 'text',
	        get: function get() {
	            return this._text;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            value = value.toString() || ' ';
	            if (this._text === value) {
	                return;
	            }
	            this._text = value;
	            this.dirty = true;
	        }

	        /**
	         * The max width of this bitmap text in pixels. If the text provided is longer than the
	         * value provided, line breaks will be automatically inserted in the last whitespace.
	         * Disable by setting value to 0
	         *
	         * @member {number}
	         */

	    }, {
	        key: 'maxWidth',
	        get: function get() {
	            return this._maxWidth;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            if (this._maxWidth === value) {
	                return;
	            }
	            this._maxWidth = value;
	            this.dirty = true;
	        }

	        /**
	         * The max line height. This is useful when trying to use the total height of the Text,
	         * ie: when trying to vertically align.
	         *
	         * @member {number}
	         * @readonly
	         */

	    }, {
	        key: 'maxLineHeight',
	        get: function get() {
	            this.validate();

	            return this._maxLineHeight;
	        }

	        /**
	         * The width of the overall text, different from fontSize,
	         * which is defined in the style object
	         *
	         * @member {number}
	         * @readonly
	         */

	    }, {
	        key: 'textWidth',
	        get: function get() {
	            this.validate();

	            return this._textWidth;
	        }

	        /**
	         * Additional space between characters.
	         *
	         * @member {number}
	         */

	    }, {
	        key: 'letterSpacing',
	        get: function get() {
	            return this._letterSpacing;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            if (this._letterSpacing !== value) {
	                this._letterSpacing = value;
	                this.dirty = true;
	            }
	        }

	        /**
	         * The height of the overall text, different from fontSize,
	         * which is defined in the style object
	         *
	         * @member {number}
	         * @readonly
	         */

	    }, {
	        key: 'textHeight',
	        get: function get() {
	            this.validate();

	            return this._textHeight;
	        }
	    }]);

	    return BitmapText;
	}(core.Container);

	exports.default = BitmapText;


	BitmapText.fonts = {};
	//# sourceMappingURL=BitmapText.js.map

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _core = __webpack_require__(173);

	var core = _interopRequireWildcard(_core);

	var _Texture = __webpack_require__(220);

	var _Texture2 = _interopRequireDefault(_Texture);

	var _BaseTexture = __webpack_require__(221);

	var _BaseTexture2 = _interopRequireDefault(_BaseTexture);

	var _utils = __webpack_require__(213);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var DisplayObject = core.DisplayObject;
	var _tempMatrix = new core.Matrix();

	DisplayObject.prototype._cacheAsBitmap = false;
	DisplayObject.prototype._cacheData = false;

	// figured theres no point adding ALL the extra variables to prototype.
	// this model can hold the information needed. This can also be generated on demand as
	// most objects are not cached as bitmaps.
	/**
	 * @class
	 * @ignore
	 */

	var CacheData =
	/**
	 *
	 */
	function CacheData() {
	    _classCallCheck(this, CacheData);

	    this.textureCacheId = null;

	    this.originalRenderWebGL = null;
	    this.originalRenderCanvas = null;
	    this.originalCalculateBounds = null;
	    this.originalGetLocalBounds = null;

	    this.originalUpdateTransform = null;
	    this.originalHitTest = null;
	    this.originalDestroy = null;
	    this.originalMask = null;
	    this.originalFilterArea = null;
	    this.sprite = null;
	};

	Object.defineProperties(DisplayObject.prototype, {
	    /**
	     * Set this to true if you want this display object to be cached as a bitmap.
	     * This basically takes a snap shot of the display object as it is at that moment. It can
	     * provide a performance benefit for complex static displayObjects.
	     * To remove simply set this property to 'false'
	     *
	     * IMPORTANT GOTCHA - make sure that all your textures are preloaded BEFORE setting this property to true
	     * as it will take a snapshot of what is currently there. If the textures have not loaded then they will not appear.
	     *
	     * @member {boolean}
	     * @memberof PIXI.DisplayObject#
	     */
	    cacheAsBitmap: {
	        get: function get() {
	            return this._cacheAsBitmap;
	        },
	        set: function set(value) {
	            if (this._cacheAsBitmap === value) {
	                return;
	            }

	            this._cacheAsBitmap = value;

	            var data = void 0;

	            if (value) {
	                if (!this._cacheData) {
	                    this._cacheData = new CacheData();
	                }

	                data = this._cacheData;

	                data.originalRenderWebGL = this.renderWebGL;
	                data.originalRenderCanvas = this.renderCanvas;

	                data.originalUpdateTransform = this.updateTransform;
	                data.originalCalculateBounds = this._calculateBounds;
	                data.originalGetLocalBounds = this.getLocalBounds;

	                data.originalDestroy = this.destroy;

	                data.originalContainsPoint = this.containsPoint;

	                data.originalMask = this._mask;
	                data.originalFilterArea = this.filterArea;

	                this.renderWebGL = this._renderCachedWebGL;
	                this.renderCanvas = this._renderCachedCanvas;

	                this.destroy = this._cacheAsBitmapDestroy;
	            } else {
	                data = this._cacheData;

	                if (data.sprite) {
	                    this._destroyCachedDisplayObject();
	                }

	                this.renderWebGL = data.originalRenderWebGL;
	                this.renderCanvas = data.originalRenderCanvas;
	                this._calculateBounds = data.originalCalculateBounds;
	                this.getLocalBounds = data.originalGetLocalBounds;

	                this.destroy = data.originalDestroy;

	                this.updateTransform = data.originalUpdateTransform;
	                this.containsPoint = data.originalContainsPoint;

	                this._mask = data.originalMask;
	                this.filterArea = data.originalFilterArea;
	            }
	        }
	    }
	});

	/**
	 * Renders a cached version of the sprite with WebGL
	 *
	 * @private
	 * @memberof PIXI.DisplayObject#
	 * @param {PIXI.WebGLRenderer} renderer - the WebGL renderer
	 */
	DisplayObject.prototype._renderCachedWebGL = function _renderCachedWebGL(renderer) {
	    if (!this.visible || this.worldAlpha <= 0 || !this.renderable) {
	        return;
	    }

	    this._initCachedDisplayObject(renderer);

	    this._cacheData.sprite._transformID = -1;
	    this._cacheData.sprite.worldAlpha = this.worldAlpha;
	    this._cacheData.sprite._renderWebGL(renderer);
	};

	/**
	 * Prepares the WebGL renderer to cache the sprite
	 *
	 * @private
	 * @memberof PIXI.DisplayObject#
	 * @param {PIXI.WebGLRenderer} renderer - the WebGL renderer
	 */
	DisplayObject.prototype._initCachedDisplayObject = function _initCachedDisplayObject(renderer) {
	    if (this._cacheData && this._cacheData.sprite) {
	        return;
	    }

	    // make sure alpha is set to 1 otherwise it will get rendered as invisible!
	    var cacheAlpha = this.alpha;

	    this.alpha = 1;

	    // first we flush anything left in the renderer (otherwise it would get rendered to the cached texture)
	    renderer.currentRenderer.flush();
	    // this.filters= [];

	    // next we find the dimensions of the untransformed object
	    // this function also calls updatetransform on all its children as part of the measuring.
	    // This means we don't need to update the transform again in this function
	    // TODO pass an object to clone too? saves having to create a new one each time!
	    var bounds = this.getLocalBounds().clone();

	    // add some padding!
	    if (this._filters) {
	        var padding = this._filters[0].padding;

	        bounds.pad(padding);
	    }

	    // for now we cache the current renderTarget that the webGL renderer is currently using.
	    // this could be more elegent..
	    var cachedRenderTarget = renderer._activeRenderTarget;
	    // We also store the filter stack - I will definitely look to change how this works a little later down the line.
	    var stack = renderer.filterManager.filterStack;

	    // this renderTexture will be used to store the cached DisplayObject

	    var renderTexture = core.RenderTexture.create(bounds.width | 0, bounds.height | 0);

	    var textureCacheId = 'cacheAsBitmap_' + (0, _utils.uid)();

	    this._cacheData.textureCacheId = textureCacheId;

	    _BaseTexture2.default.addToCache(renderTexture.baseTexture, textureCacheId);
	    _Texture2.default.addToCache(renderTexture, textureCacheId);

	    // need to set //
	    var m = _tempMatrix;

	    m.tx = -bounds.x;
	    m.ty = -bounds.y;

	    // reset
	    this.transform.worldTransform.identity();

	    // set all properties to there original so we can render to a texture
	    this.renderWebGL = this._cacheData.originalRenderWebGL;

	    renderer.render(this, renderTexture, true, m, true);
	    // now restore the state be setting the new properties

	    renderer.bindRenderTarget(cachedRenderTarget);

	    renderer.filterManager.filterStack = stack;

	    this.renderWebGL = this._renderCachedWebGL;
	    this.updateTransform = this.displayObjectUpdateTransform;

	    this._mask = null;
	    this.filterArea = null;

	    // create our cached sprite
	    var cachedSprite = new core.Sprite(renderTexture);

	    cachedSprite.transform.worldTransform = this.transform.worldTransform;
	    cachedSprite.anchor.x = -(bounds.x / bounds.width);
	    cachedSprite.anchor.y = -(bounds.y / bounds.height);
	    cachedSprite.alpha = cacheAlpha;
	    cachedSprite._bounds = this._bounds;

	    // easy bounds..
	    this._calculateBounds = this._calculateCachedBounds;
	    this.getLocalBounds = this._getCachedLocalBounds;

	    this._cacheData.sprite = cachedSprite;

	    this.transform._parentID = -1;
	    // restore the transform of the cached sprite to avoid the nasty flicker..
	    if (!this.parent) {
	        this.parent = renderer._tempDisplayObjectParent;
	        this.updateTransform();
	        this.parent = null;
	    } else {
	        this.updateTransform();
	    }

	    // map the hit test..
	    this.containsPoint = cachedSprite.containsPoint.bind(cachedSprite);
	};

	/**
	 * Renders a cached version of the sprite with canvas
	 *
	 * @private
	 * @memberof PIXI.DisplayObject#
	 * @param {PIXI.WebGLRenderer} renderer - the WebGL renderer
	 */
	DisplayObject.prototype._renderCachedCanvas = function _renderCachedCanvas(renderer) {
	    if (!this.visible || this.worldAlpha <= 0 || !this.renderable) {
	        return;
	    }

	    this._initCachedDisplayObjectCanvas(renderer);

	    this._cacheData.sprite.worldAlpha = this.worldAlpha;

	    this._cacheData.sprite.renderCanvas(renderer);
	};

	// TODO this can be the same as the webGL verison.. will need to do a little tweaking first though..
	/**
	 * Prepares the Canvas renderer to cache the sprite
	 *
	 * @private
	 * @memberof PIXI.DisplayObject#
	 * @param {PIXI.WebGLRenderer} renderer - the WebGL renderer
	 */
	DisplayObject.prototype._initCachedDisplayObjectCanvas = function _initCachedDisplayObjectCanvas(renderer) {
	    if (this._cacheData && this._cacheData.sprite) {
	        return;
	    }

	    // get bounds actually transforms the object for us already!
	    var bounds = this.getLocalBounds();

	    var cacheAlpha = this.alpha;

	    this.alpha = 1;

	    var cachedRenderTarget = renderer.context;

	    var renderTexture = core.RenderTexture.create(bounds.width | 0, bounds.height | 0);

	    var textureCacheId = 'cacheAsBitmap_' + (0, _utils.uid)();

	    this._cacheData.textureCacheId = textureCacheId;

	    _BaseTexture2.default.addToCache(renderTexture.baseTexture, textureCacheId);
	    _Texture2.default.addToCache(renderTexture, textureCacheId);

	    // need to set //
	    var m = _tempMatrix;

	    this.transform.localTransform.copy(m);
	    m.invert();

	    m.tx -= bounds.x;
	    m.ty -= bounds.y;

	    // m.append(this.transform.worldTransform.)
	    // set all properties to there original so we can render to a texture
	    this.renderCanvas = this._cacheData.originalRenderCanvas;

	    // renderTexture.render(this, m, true);
	    renderer.render(this, renderTexture, true, m, false);

	    // now restore the state be setting the new properties
	    renderer.context = cachedRenderTarget;

	    this.renderCanvas = this._renderCachedCanvas;
	    this._calculateBounds = this._calculateCachedBounds;

	    this._mask = null;
	    this.filterArea = null;

	    // create our cached sprite
	    var cachedSprite = new core.Sprite(renderTexture);

	    cachedSprite.transform.worldTransform = this.transform.worldTransform;
	    cachedSprite.anchor.x = -(bounds.x / bounds.width);
	    cachedSprite.anchor.y = -(bounds.y / bounds.height);
	    cachedSprite._bounds = this._bounds;
	    cachedSprite.alpha = cacheAlpha;

	    if (!this.parent) {
	        this.parent = renderer._tempDisplayObjectParent;
	        this.updateTransform();
	        this.parent = null;
	    } else {
	        this.updateTransform();
	    }

	    this.updateTransform = this.displayObjectUpdateTransform;

	    this._cacheData.sprite = cachedSprite;

	    this.containsPoint = cachedSprite.containsPoint.bind(cachedSprite);
	};

	/**
	 * Calculates the bounds of the cached sprite
	 *
	 * @private
	 */
	DisplayObject.prototype._calculateCachedBounds = function _calculateCachedBounds() {
	    this._cacheData.sprite._calculateBounds();
	};

	/**
	 * Gets the bounds of the cached sprite.
	 *
	 * @private
	 * @return {Rectangle} The local bounds.
	 */
	DisplayObject.prototype._getCachedLocalBounds = function _getCachedLocalBounds() {
	    return this._cacheData.sprite.getLocalBounds();
	};

	/**
	 * Destroys the cached sprite.
	 *
	 * @private
	 */
	DisplayObject.prototype._destroyCachedDisplayObject = function _destroyCachedDisplayObject() {
	    this._cacheData.sprite._texture.destroy(true);
	    this._cacheData.sprite = null;

	    _BaseTexture2.default.removeFromCache(this._cacheData.textureCacheId);
	    _Texture2.default.removeFromCache(this._cacheData.textureCacheId);

	    this._cacheData.textureCacheId = null;
	};

	/**
	 * Destroys the cached object.
	 *
	 * @private
	 * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
	 *  have been set to that value.
	 *  Used when destroying containers, see the Container.destroy method.
	 */
	DisplayObject.prototype._cacheAsBitmapDestroy = function _cacheAsBitmapDestroy(options) {
	    this.cacheAsBitmap = false;
	    this.destroy(options);
	};
	//# sourceMappingURL=cacheAsBitmap.js.map

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _core = __webpack_require__(173);

	var core = _interopRequireWildcard(_core);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	/**
	 * The instance name of the object.
	 *
	 * @memberof PIXI.DisplayObject#
	 * @member {string} name
	 */
	core.DisplayObject.prototype.name = null;

	/**
	 * Returns the display object in the container
	 *
	 * @method getChildByName
	 * @memberof PIXI.Container#
	 * @param {string} name - instance name
	 * @return {PIXI.DisplayObject} The child with the specified name.
	 */
	core.Container.prototype.getChildByName = function getChildByName(name) {
	    for (var i = 0; i < this.children.length; i++) {
	        if (this.children[i].name === name) {
	            return this.children[i];
	        }
	    }

	    return null;
	};
	//# sourceMappingURL=getChildByName.js.map

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _core = __webpack_require__(173);

	var core = _interopRequireWildcard(_core);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	/**
	 * Returns the global position of the displayObject. Does not depend on object scale, rotation and pivot.
	 *
	 * @method getGlobalPosition
	 * @memberof PIXI.DisplayObject#
	 * @param {Point} point - the point to write the global value to. If null a new point will be returned
	 * @param {boolean} skipUpdate - setting to true will stop the transforms of the scene graph from
	 *  being updated. This means the calculation returned MAY be out of date BUT will give you a
	 *  nice performance boost
	 * @return {Point} The updated point
	 */
	core.DisplayObject.prototype.getGlobalPosition = function getGlobalPosition() {
	    var point = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new core.Point();
	    var skipUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

	    if (this.parent) {
	        this.parent.toGlobal(this.position, point, skipUpdate);
	    } else {
	        point.x = this.position.x;
	        point.y = this.position.y;
	    }

	    return point;
	};
	//# sourceMappingURL=getGlobalPosition.js.map

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _FXAAFilter = __webpack_require__(308);

	Object.defineProperty(exports, 'FXAAFilter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FXAAFilter).default;
	  }
	});

	var _NoiseFilter = __webpack_require__(309);

	Object.defineProperty(exports, 'NoiseFilter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_NoiseFilter).default;
	  }
	});

	var _DisplacementFilter = __webpack_require__(310);

	Object.defineProperty(exports, 'DisplacementFilter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DisplacementFilter).default;
	  }
	});

	var _BlurFilter = __webpack_require__(311);

	Object.defineProperty(exports, 'BlurFilter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BlurFilter).default;
	  }
	});

	var _BlurXFilter = __webpack_require__(312);

	Object.defineProperty(exports, 'BlurXFilter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BlurXFilter).default;
	  }
	});

	var _BlurYFilter = __webpack_require__(316);

	Object.defineProperty(exports, 'BlurYFilter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BlurYFilter).default;
	  }
	});

	var _ColorMatrixFilter = __webpack_require__(317);

	Object.defineProperty(exports, 'ColorMatrixFilter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ColorMatrixFilter).default;
	  }
	});

	var _AlphaFilter = __webpack_require__(318);

	Object.defineProperty(exports, 'AlphaFilter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AlphaFilter).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=index.js.map

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _core = __webpack_require__(173);

	var core = _interopRequireWildcard(_core);

	var _path = __webpack_require__(252);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	/**
	 *
	 * Basic FXAA implementation based on the code on geeks3d.com with the
	 * modification that the texture2DLod stuff was removed since it's
	 * unsupported by WebGL.
	 *
	 * @see https://github.com/mitsuhiko/webgl-meincraft
	 *
	 * @class
	 * @extends PIXI.Filter
	 * @memberof PIXI.filters
	 *
	 */
	var FXAAFilter = function (_core$Filter) {
	    _inherits(FXAAFilter, _core$Filter);

	    /**
	     *
	     */
	    function FXAAFilter() {
	        _classCallCheck(this, FXAAFilter);

	        // TODO - needs work
	        return _possibleConstructorReturn(this, _core$Filter.call(this,
	        // vertex shader
	        '\nattribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 v_rgbNW;\nvarying vec2 v_rgbNE;\nvarying vec2 v_rgbSW;\nvarying vec2 v_rgbSE;\nvarying vec2 v_rgbM;\n\nuniform vec4 filterArea;\n\nvarying vec2 vTextureCoord;\n\nvec2 mapCoord( vec2 coord )\n{\n    coord *= filterArea.xy;\n    coord += filterArea.zw;\n\n    return coord;\n}\n\nvec2 unmapCoord( vec2 coord )\n{\n    coord -= filterArea.zw;\n    coord /= filterArea.xy;\n\n    return coord;\n}\n\nvoid texcoords(vec2 fragCoord, vec2 resolution,\n               out vec2 v_rgbNW, out vec2 v_rgbNE,\n               out vec2 v_rgbSW, out vec2 v_rgbSE,\n               out vec2 v_rgbM) {\n    vec2 inverseVP = 1.0 / resolution.xy;\n    v_rgbNW = (fragCoord + vec2(-1.0, -1.0)) * inverseVP;\n    v_rgbNE = (fragCoord + vec2(1.0, -1.0)) * inverseVP;\n    v_rgbSW = (fragCoord + vec2(-1.0, 1.0)) * inverseVP;\n    v_rgbSE = (fragCoord + vec2(1.0, 1.0)) * inverseVP;\n    v_rgbM = vec2(fragCoord * inverseVP);\n}\n\nvoid main(void) {\n\n   gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n   vTextureCoord = aTextureCoord;\n\n   vec2 fragCoord = vTextureCoord * filterArea.xy;\n\n   texcoords(fragCoord, filterArea.xy, v_rgbNW, v_rgbNE, v_rgbSW, v_rgbSE, v_rgbM);\n}',
	        // fragment shader
	        'varying vec2 v_rgbNW;\nvarying vec2 v_rgbNE;\nvarying vec2 v_rgbSW;\nvarying vec2 v_rgbSE;\nvarying vec2 v_rgbM;\n\nvarying vec2 vTextureCoord;\nuniform sampler2D uSampler;\nuniform vec4 filterArea;\n\n/**\n Basic FXAA implementation based on the code on geeks3d.com with the\n modification that the texture2DLod stuff was removed since it\'s\n unsupported by WebGL.\n \n --\n \n From:\n https://github.com/mitsuhiko/webgl-meincraft\n \n Copyright (c) 2011 by Armin Ronacher.\n \n Some rights reserved.\n \n Redistribution and use in source and binary forms, with or without\n modification, are permitted provided that the following conditions are\n met:\n \n * Redistributions of source code must retain the above copyright\n notice, this list of conditions and the following disclaimer.\n \n * Redistributions in binary form must reproduce the above\n copyright notice, this list of conditions and the following\n disclaimer in the documentation and/or other materials provided\n with the distribution.\n \n * The names of the contributors may not be used to endorse or\n promote products derived from this software without specific\n prior written permission.\n \n THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS\n "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT\n LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR\n A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT\n OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,\n SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT\n LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,\n DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY\n THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT\n (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE\n OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.\n */\n\n#ifndef FXAA_REDUCE_MIN\n#define FXAA_REDUCE_MIN   (1.0/ 128.0)\n#endif\n#ifndef FXAA_REDUCE_MUL\n#define FXAA_REDUCE_MUL   (1.0 / 8.0)\n#endif\n#ifndef FXAA_SPAN_MAX\n#define FXAA_SPAN_MAX     8.0\n#endif\n\n//optimized version for mobile, where dependent\n//texture reads can be a bottleneck\nvec4 fxaa(sampler2D tex, vec2 fragCoord, vec2 resolution,\n          vec2 v_rgbNW, vec2 v_rgbNE,\n          vec2 v_rgbSW, vec2 v_rgbSE,\n          vec2 v_rgbM) {\n    vec4 color;\n    mediump vec2 inverseVP = vec2(1.0 / resolution.x, 1.0 / resolution.y);\n    vec3 rgbNW = texture2D(tex, v_rgbNW).xyz;\n    vec3 rgbNE = texture2D(tex, v_rgbNE).xyz;\n    vec3 rgbSW = texture2D(tex, v_rgbSW).xyz;\n    vec3 rgbSE = texture2D(tex, v_rgbSE).xyz;\n    vec4 texColor = texture2D(tex, v_rgbM);\n    vec3 rgbM  = texColor.xyz;\n    vec3 luma = vec3(0.299, 0.587, 0.114);\n    float lumaNW = dot(rgbNW, luma);\n    float lumaNE = dot(rgbNE, luma);\n    float lumaSW = dot(rgbSW, luma);\n    float lumaSE = dot(rgbSE, luma);\n    float lumaM  = dot(rgbM,  luma);\n    float lumaMin = min(lumaM, min(min(lumaNW, lumaNE), min(lumaSW, lumaSE)));\n    float lumaMax = max(lumaM, max(max(lumaNW, lumaNE), max(lumaSW, lumaSE)));\n    \n    mediump vec2 dir;\n    dir.x = -((lumaNW + lumaNE) - (lumaSW + lumaSE));\n    dir.y =  ((lumaNW + lumaSW) - (lumaNE + lumaSE));\n    \n    float dirReduce = max((lumaNW + lumaNE + lumaSW + lumaSE) *\n                          (0.25 * FXAA_REDUCE_MUL), FXAA_REDUCE_MIN);\n    \n    float rcpDirMin = 1.0 / (min(abs(dir.x), abs(dir.y)) + dirReduce);\n    dir = min(vec2(FXAA_SPAN_MAX, FXAA_SPAN_MAX),\n              max(vec2(-FXAA_SPAN_MAX, -FXAA_SPAN_MAX),\n                  dir * rcpDirMin)) * inverseVP;\n    \n    vec3 rgbA = 0.5 * (\n                       texture2D(tex, fragCoord * inverseVP + dir * (1.0 / 3.0 - 0.5)).xyz +\n                       texture2D(tex, fragCoord * inverseVP + dir * (2.0 / 3.0 - 0.5)).xyz);\n    vec3 rgbB = rgbA * 0.5 + 0.25 * (\n                                     texture2D(tex, fragCoord * inverseVP + dir * -0.5).xyz +\n                                     texture2D(tex, fragCoord * inverseVP + dir * 0.5).xyz);\n    \n    float lumaB = dot(rgbB, luma);\n    if ((lumaB < lumaMin) || (lumaB > lumaMax))\n        color = vec4(rgbA, texColor.a);\n    else\n        color = vec4(rgbB, texColor.a);\n    return color;\n}\n\nvoid main() {\n\n      vec2 fragCoord = vTextureCoord * filterArea.xy;\n\n      vec4 color;\n\n    color = fxaa(uSampler, fragCoord, filterArea.xy, v_rgbNW, v_rgbNE, v_rgbSW, v_rgbSE, v_rgbM);\n\n      gl_FragColor = color;\n}\n'));
	    }

	    return FXAAFilter;
	}(core.Filter);

	exports.default = FXAAFilter;
	//# sourceMappingURL=FXAAFilter.js.map

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _core = __webpack_require__(173);

	var core = _interopRequireWildcard(_core);

	var _path = __webpack_require__(252);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	/**
	 * @author Vico @vicocotea
	 * original filter: https://github.com/evanw/glfx.js/blob/master/src/filters/adjust/noise.js
	 */

	/**
	 * A Noise effect filter.
	 *
	 * @class
	 * @extends PIXI.Filter
	 * @memberof PIXI.filters
	 */
	var NoiseFilter = function (_core$Filter) {
	    _inherits(NoiseFilter, _core$Filter);

	    /**
	     * @param {number} noise - The noise intensity, should be a normalized value in the range [0, 1].
	     * @param {number} seed - A random seed for the noise generation. Default is `Math.random()`.
	     */
	    function NoiseFilter() {
	        var noise = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.5;
	        var seed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Math.random();

	        _classCallCheck(this, NoiseFilter);

	        var _this = _possibleConstructorReturn(this, _core$Filter.call(this,
	        // vertex shader
	        'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n    vTextureCoord = aTextureCoord;\n}',
	        // fragment shader
	        'precision highp float;\n\nvarying vec2 vTextureCoord;\nvarying vec4 vColor;\n\nuniform float uNoise;\nuniform float uSeed;\nuniform sampler2D uSampler;\n\nfloat rand(vec2 co)\n{\n    return fract(sin(dot(co.xy, vec2(12.9898, 78.233))) * 43758.5453);\n}\n\nvoid main()\n{\n    vec4 color = texture2D(uSampler, vTextureCoord);\n    float randomValue = rand(gl_FragCoord.xy * uSeed);\n    float diff = (randomValue - 0.5) * uNoise;\n\n    // Un-premultiply alpha before applying the color matrix. See issue #3539.\n    if (color.a > 0.0) {\n        color.rgb /= color.a;\n    }\n\n    color.r += diff;\n    color.g += diff;\n    color.b += diff;\n\n    // Premultiply alpha again.\n    color.rgb *= color.a;\n\n    gl_FragColor = color;\n}\n'));

	        _this.noise = noise;
	        _this.seed = seed;
	        return _this;
	    }

	    /**
	     * The amount of noise to apply, this value should be in the range (0, 1].
	     *
	     * @member {number}
	     * @default 0.5
	     */


	    _createClass(NoiseFilter, [{
	        key: 'noise',
	        get: function get() {
	            return this.uniforms.uNoise;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.uniforms.uNoise = value;
	        }

	        /**
	         * A seed value to apply to the random noise generation. `Math.random()` is a good value to use.
	         *
	         * @member {number}
	         */

	    }, {
	        key: 'seed',
	        get: function get() {
	            return this.uniforms.uSeed;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.uniforms.uSeed = value;
	        }
	    }]);

	    return NoiseFilter;
	}(core.Filter);

	exports.default = NoiseFilter;
	//# sourceMappingURL=NoiseFilter.js.map

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _core = __webpack_require__(173);

	var core = _interopRequireWildcard(_core);

	var _path = __webpack_require__(252);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	/**
	 * The DisplacementFilter class uses the pixel values from the specified texture
	 * (called the displacement map) to perform a displacement of an object. You can
	 * use this filter to apply all manor of crazy warping effects. Currently the r
	 * property of the texture is used to offset the x and the g property of the texture
	 * is used to offset the y.
	 *
	 * @class
	 * @extends PIXI.Filter
	 * @memberof PIXI.filters
	 */
	var DisplacementFilter = function (_core$Filter) {
	    _inherits(DisplacementFilter, _core$Filter);

	    /**
	     * @param {PIXI.Sprite} sprite - The sprite used for the displacement map. (make sure its added to the scene!)
	     * @param {number} scale - The scale of the displacement
	     */
	    function DisplacementFilter(sprite, scale) {
	        _classCallCheck(this, DisplacementFilter);

	        var maskMatrix = new core.Matrix();

	        sprite.renderable = false;

	        var _this = _possibleConstructorReturn(this, _core$Filter.call(this,
	        // vertex shader
	        'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 filterMatrix;\n\nvarying vec2 vTextureCoord;\nvarying vec2 vFilterCoord;\n\nvoid main(void)\n{\n   gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n   vFilterCoord = ( filterMatrix * vec3( aTextureCoord, 1.0)  ).xy;\n   vTextureCoord = aTextureCoord;\n}',
	        // fragment shader
	        'varying vec2 vFilterCoord;\nvarying vec2 vTextureCoord;\n\nuniform vec2 scale;\n\nuniform sampler2D uSampler;\nuniform sampler2D mapSampler;\n\nuniform vec4 filterArea;\nuniform vec4 filterClamp;\n\nvoid main(void)\n{\n  vec4 map =  texture2D(mapSampler, vFilterCoord);\n\n  map -= 0.5;\n  map.xy *= scale / filterArea.xy;\n\n  gl_FragColor = texture2D(uSampler, clamp(vec2(vTextureCoord.x + map.x, vTextureCoord.y + map.y), filterClamp.xy, filterClamp.zw));\n}\n'));

	        _this.maskSprite = sprite;
	        _this.maskMatrix = maskMatrix;

	        _this.uniforms.mapSampler = sprite._texture;
	        _this.uniforms.filterMatrix = maskMatrix;
	        _this.uniforms.scale = { x: 1, y: 1 };

	        if (scale === null || scale === undefined) {
	            scale = 20;
	        }

	        _this.scale = new core.Point(scale, scale);
	        return _this;
	    }

	    /**
	     * Applies the filter.
	     *
	     * @param {PIXI.FilterManager} filterManager - The manager.
	     * @param {PIXI.RenderTarget} input - The input target.
	     * @param {PIXI.RenderTarget} output - The output target.
	     */


	    DisplacementFilter.prototype.apply = function apply(filterManager, input, output) {
	        this.uniforms.filterMatrix = filterManager.calculateSpriteMatrix(this.maskMatrix, this.maskSprite);
	        this.uniforms.scale.x = this.scale.x;
	        this.uniforms.scale.y = this.scale.y;

	        // draw the filter...
	        filterManager.applyFilter(this, input, output);
	    };

	    /**
	     * The texture used for the displacement map. Must be power of 2 sized texture.
	     *
	     * @member {PIXI.Texture}
	     */


	    _createClass(DisplacementFilter, [{
	        key: 'map',
	        get: function get() {
	            return this.uniforms.mapSampler;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.uniforms.mapSampler = value;
	        }
	    }]);

	    return DisplacementFilter;
	}(core.Filter);

	exports.default = DisplacementFilter;
	//# sourceMappingURL=DisplacementFilter.js.map

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _core = __webpack_require__(173);

	var core = _interopRequireWildcard(_core);

	var _BlurXFilter = __webpack_require__(312);

	var _BlurXFilter2 = _interopRequireDefault(_BlurXFilter);

	var _BlurYFilter = __webpack_require__(316);

	var _BlurYFilter2 = _interopRequireDefault(_BlurYFilter);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	/**
	 * The BlurFilter applies a Gaussian blur to an object.
	 * The strength of the blur can be set for x- and y-axis separately.
	 *
	 * @class
	 * @extends PIXI.Filter
	 * @memberof PIXI.filters
	 */
	var BlurFilter = function (_core$Filter) {
	    _inherits(BlurFilter, _core$Filter);

	    /**
	     * @param {number} strength - The strength of the blur filter.
	     * @param {number} quality - The quality of the blur filter.
	     * @param {number} resolution - The resolution of the blur filter.
	     * @param {number} [kernelSize=5] - The kernelSize of the blur filter.Options: 5, 7, 9, 11, 13, 15.
	     */
	    function BlurFilter(strength, quality, resolution, kernelSize) {
	        _classCallCheck(this, BlurFilter);

	        var _this = _possibleConstructorReturn(this, _core$Filter.call(this));

	        _this.blurXFilter = new _BlurXFilter2.default(strength, quality, resolution, kernelSize);
	        _this.blurYFilter = new _BlurYFilter2.default(strength, quality, resolution, kernelSize);

	        _this.padding = 0;
	        _this.resolution = resolution || core.settings.RESOLUTION;
	        _this.quality = quality || 4;
	        _this.blur = strength || 8;
	        return _this;
	    }

	    /**
	     * Applies the filter.
	     *
	     * @param {PIXI.FilterManager} filterManager - The manager.
	     * @param {PIXI.RenderTarget} input - The input target.
	     * @param {PIXI.RenderTarget} output - The output target.
	     */


	    BlurFilter.prototype.apply = function apply(filterManager, input, output) {
	        var renderTarget = filterManager.getRenderTarget(true);

	        this.blurXFilter.apply(filterManager, input, renderTarget, true);
	        this.blurYFilter.apply(filterManager, renderTarget, output, false);

	        filterManager.returnRenderTarget(renderTarget);
	    };

	    /**
	     * Sets the strength of both the blurX and blurY properties simultaneously
	     *
	     * @member {number}
	     * @default 2
	     */


	    _createClass(BlurFilter, [{
	        key: 'blur',
	        get: function get() {
	            return this.blurXFilter.blur;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.blurXFilter.blur = this.blurYFilter.blur = value;
	            this.padding = Math.max(Math.abs(this.blurXFilter.strength), Math.abs(this.blurYFilter.strength)) * 2;
	        }

	        /**
	         * Sets the number of passes for blur. More passes means higher quaility bluring.
	         *
	         * @member {number}
	         * @default 1
	         */

	    }, {
	        key: 'quality',
	        get: function get() {
	            return this.blurXFilter.quality;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.blurXFilter.quality = this.blurYFilter.quality = value;
	        }

	        /**
	         * Sets the strength of the blurX property
	         *
	         * @member {number}
	         * @default 2
	         */

	    }, {
	        key: 'blurX',
	        get: function get() {
	            return this.blurXFilter.blur;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.blurXFilter.blur = value;
	            this.padding = Math.max(Math.abs(this.blurXFilter.strength), Math.abs(this.blurYFilter.strength)) * 2;
	        }

	        /**
	         * Sets the strength of the blurY property
	         *
	         * @member {number}
	         * @default 2
	         */

	    }, {
	        key: 'blurY',
	        get: function get() {
	            return this.blurYFilter.blur;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.blurYFilter.blur = value;
	            this.padding = Math.max(Math.abs(this.blurXFilter.strength), Math.abs(this.blurYFilter.strength)) * 2;
	        }

	        /**
	         * Sets the blendmode of the filter
	         *
	         * @member {number}
	         * @default PIXI.BLEND_MODES.NORMAL
	         */

	    }, {
	        key: 'blendMode',
	        get: function get() {
	            return this.blurYFilter._blendMode;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.blurYFilter._blendMode = value;
	        }
	    }]);

	    return BlurFilter;
	}(core.Filter);

	exports.default = BlurFilter;
	//# sourceMappingURL=BlurFilter.js.map

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _core = __webpack_require__(173);

	var core = _interopRequireWildcard(_core);

	var _generateBlurVertSource = __webpack_require__(313);

	var _generateBlurVertSource2 = _interopRequireDefault(_generateBlurVertSource);

	var _generateBlurFragSource = __webpack_require__(314);

	var _generateBlurFragSource2 = _interopRequireDefault(_generateBlurFragSource);

	var _getMaxBlurKernelSize = __webpack_require__(315);

	var _getMaxBlurKernelSize2 = _interopRequireDefault(_getMaxBlurKernelSize);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	/**
	 * The BlurXFilter applies a horizontal Gaussian blur to an object.
	 *
	 * @class
	 * @extends PIXI.Filter
	 * @memberof PIXI.filters
	 */
	var BlurXFilter = function (_core$Filter) {
	    _inherits(BlurXFilter, _core$Filter);

	    /**
	     * @param {number} strength - The strength of the blur filter.
	     * @param {number} quality - The quality of the blur filter.
	     * @param {number} resolution - The resolution of the blur filter.
	     * @param {number} [kernelSize=5] - The kernelSize of the blur filter.Options: 5, 7, 9, 11, 13, 15.
	     */
	    function BlurXFilter(strength, quality, resolution, kernelSize) {
	        _classCallCheck(this, BlurXFilter);

	        kernelSize = kernelSize || 5;
	        var vertSrc = (0, _generateBlurVertSource2.default)(kernelSize, true);
	        var fragSrc = (0, _generateBlurFragSource2.default)(kernelSize);

	        var _this = _possibleConstructorReturn(this, _core$Filter.call(this,
	        // vertex shader
	        vertSrc,
	        // fragment shader
	        fragSrc));

	        _this.resolution = resolution || core.settings.RESOLUTION;

	        _this._quality = 0;

	        _this.quality = quality || 4;
	        _this.strength = strength || 8;

	        _this.firstRun = true;
	        return _this;
	    }

	    /**
	     * Applies the filter.
	     *
	     * @param {PIXI.FilterManager} filterManager - The manager.
	     * @param {PIXI.RenderTarget} input - The input target.
	     * @param {PIXI.RenderTarget} output - The output target.
	     * @param {boolean} clear - Should the output be cleared before rendering?
	     */


	    BlurXFilter.prototype.apply = function apply(filterManager, input, output, clear) {
	        if (this.firstRun) {
	            var gl = filterManager.renderer.gl;
	            var kernelSize = (0, _getMaxBlurKernelSize2.default)(gl);

	            this.vertexSrc = (0, _generateBlurVertSource2.default)(kernelSize, true);
	            this.fragmentSrc = (0, _generateBlurFragSource2.default)(kernelSize);

	            this.firstRun = false;
	        }

	        this.uniforms.strength = 1 / output.size.width * (output.size.width / input.size.width);

	        // screen space!
	        this.uniforms.strength *= this.strength;
	        this.uniforms.strength /= this.passes; // / this.passes//Math.pow(1, this.passes);

	        if (this.passes === 1) {
	            filterManager.applyFilter(this, input, output, clear);
	        } else {
	            var renderTarget = filterManager.getRenderTarget(true);
	            var flip = input;
	            var flop = renderTarget;

	            for (var i = 0; i < this.passes - 1; i++) {
	                filterManager.applyFilter(this, flip, flop, true);

	                var temp = flop;

	                flop = flip;
	                flip = temp;
	            }

	            filterManager.applyFilter(this, flip, output, clear);

	            filterManager.returnRenderTarget(renderTarget);
	        }
	    };

	    /**
	     * Sets the strength of both the blur.
	     *
	     * @member {number}
	     * @default 16
	     */


	    _createClass(BlurXFilter, [{
	        key: 'blur',
	        get: function get() {
	            return this.strength;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.padding = Math.abs(value) * 2;
	            this.strength = value;
	        }

	        /**
	        * Sets the quality of the blur by modifying the number of passes. More passes means higher
	        * quaility bluring but the lower the performance.
	        *
	        * @member {number}
	        * @default 4
	        */

	    }, {
	        key: 'quality',
	        get: function get() {
	            return this._quality;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._quality = value;
	            this.passes = value;
	        }
	    }]);

	    return BlurXFilter;
	}(core.Filter);

	exports.default = BlurXFilter;
	//# sourceMappingURL=BlurXFilter.js.map

/***/ }),
/* 313 */
/***/ (function(module, exports) {

	'use strict';

	exports.__esModule = true;
	exports.default = generateVertBlurSource;
	var vertTemplate = ['attribute vec2 aVertexPosition;', 'attribute vec2 aTextureCoord;', 'uniform float strength;', 'uniform mat3 projectionMatrix;', 'varying vec2 vBlurTexCoords[%size%];', 'void main(void)', '{', 'gl_Position = vec4((projectionMatrix * vec3((aVertexPosition), 1.0)).xy, 0.0, 1.0);', '%blur%', '}'].join('\n');

	function generateVertBlurSource(kernelSize, x) {
	    var halfLength = Math.ceil(kernelSize / 2);

	    var vertSource = vertTemplate;

	    var blurLoop = '';
	    var template = void 0;
	    // let value;

	    if (x) {
	        template = 'vBlurTexCoords[%index%] = aTextureCoord + vec2(%sampleIndex% * strength, 0.0);';
	    } else {
	        template = 'vBlurTexCoords[%index%] = aTextureCoord + vec2(0.0, %sampleIndex% * strength);';
	    }

	    for (var i = 0; i < kernelSize; i++) {
	        var blur = template.replace('%index%', i);

	        // value = i;

	        // if(i >= halfLength)
	        // {
	        //     value = kernelSize - i - 1;
	        // }

	        blur = blur.replace('%sampleIndex%', i - (halfLength - 1) + '.0');

	        blurLoop += blur;
	        blurLoop += '\n';
	    }

	    vertSource = vertSource.replace('%blur%', blurLoop);
	    vertSource = vertSource.replace('%size%', kernelSize);

	    return vertSource;
	}
	//# sourceMappingURL=generateBlurVertSource.js.map

/***/ }),
/* 314 */
/***/ (function(module, exports) {

	'use strict';

	exports.__esModule = true;
	exports.default = generateFragBlurSource;
	var GAUSSIAN_VALUES = {
	    5: [0.153388, 0.221461, 0.250301],
	    7: [0.071303, 0.131514, 0.189879, 0.214607],
	    9: [0.028532, 0.067234, 0.124009, 0.179044, 0.20236],
	    11: [0.0093, 0.028002, 0.065984, 0.121703, 0.175713, 0.198596],
	    13: [0.002406, 0.009255, 0.027867, 0.065666, 0.121117, 0.174868, 0.197641],
	    15: [0.000489, 0.002403, 0.009246, 0.02784, 0.065602, 0.120999, 0.174697, 0.197448]
	};

	var fragTemplate = ['varying vec2 vBlurTexCoords[%size%];', 'uniform sampler2D uSampler;', 'void main(void)', '{', '    gl_FragColor = vec4(0.0);', '    %blur%', '}'].join('\n');

	function generateFragBlurSource(kernelSize) {
	    var kernel = GAUSSIAN_VALUES[kernelSize];
	    var halfLength = kernel.length;

	    var fragSource = fragTemplate;

	    var blurLoop = '';
	    var template = 'gl_FragColor += texture2D(uSampler, vBlurTexCoords[%index%]) * %value%;';
	    var value = void 0;

	    for (var i = 0; i < kernelSize; i++) {
	        var blur = template.replace('%index%', i);

	        value = i;

	        if (i >= halfLength) {
	            value = kernelSize - i - 1;
	        }

	        blur = blur.replace('%value%', kernel[value]);

	        blurLoop += blur;
	        blurLoop += '\n';
	    }

	    fragSource = fragSource.replace('%blur%', blurLoop);
	    fragSource = fragSource.replace('%size%', kernelSize);

	    return fragSource;
	}
	//# sourceMappingURL=generateBlurFragSource.js.map

/***/ }),
/* 315 */
/***/ (function(module, exports) {

	"use strict";

	exports.__esModule = true;
	exports.default = getMaxKernelSize;
	function getMaxKernelSize(gl) {
	    var maxVaryings = gl.getParameter(gl.MAX_VARYING_VECTORS);
	    var kernelSize = 15;

	    while (kernelSize > maxVaryings) {
	        kernelSize -= 2;
	    }

	    return kernelSize;
	}
	//# sourceMappingURL=getMaxBlurKernelSize.js.map

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _core = __webpack_require__(173);

	var core = _interopRequireWildcard(_core);

	var _generateBlurVertSource = __webpack_require__(313);

	var _generateBlurVertSource2 = _interopRequireDefault(_generateBlurVertSource);

	var _generateBlurFragSource = __webpack_require__(314);

	var _generateBlurFragSource2 = _interopRequireDefault(_generateBlurFragSource);

	var _getMaxBlurKernelSize = __webpack_require__(315);

	var _getMaxBlurKernelSize2 = _interopRequireDefault(_getMaxBlurKernelSize);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	/**
	 * The BlurYFilter applies a horizontal Gaussian blur to an object.
	 *
	 * @class
	 * @extends PIXI.Filter
	 * @memberof PIXI.filters
	 */
	var BlurYFilter = function (_core$Filter) {
	    _inherits(BlurYFilter, _core$Filter);

	    /**
	     * @param {number} strength - The strength of the blur filter.
	     * @param {number} quality - The quality of the blur filter.
	     * @param {number} resolution - The resolution of the blur filter.
	     * @param {number} [kernelSize=5] - The kernelSize of the blur filter.Options: 5, 7, 9, 11, 13, 15.
	     */
	    function BlurYFilter(strength, quality, resolution, kernelSize) {
	        _classCallCheck(this, BlurYFilter);

	        kernelSize = kernelSize || 5;
	        var vertSrc = (0, _generateBlurVertSource2.default)(kernelSize, false);
	        var fragSrc = (0, _generateBlurFragSource2.default)(kernelSize);

	        var _this = _possibleConstructorReturn(this, _core$Filter.call(this,
	        // vertex shader
	        vertSrc,
	        // fragment shader
	        fragSrc));

	        _this.resolution = resolution || core.settings.RESOLUTION;

	        _this._quality = 0;

	        _this.quality = quality || 4;
	        _this.strength = strength || 8;

	        _this.firstRun = true;
	        return _this;
	    }

	    /**
	     * Applies the filter.
	     *
	     * @param {PIXI.FilterManager} filterManager - The manager.
	     * @param {PIXI.RenderTarget} input - The input target.
	     * @param {PIXI.RenderTarget} output - The output target.
	     * @param {boolean} clear - Should the output be cleared before rendering?
	     */


	    BlurYFilter.prototype.apply = function apply(filterManager, input, output, clear) {
	        if (this.firstRun) {
	            var gl = filterManager.renderer.gl;
	            var kernelSize = (0, _getMaxBlurKernelSize2.default)(gl);

	            this.vertexSrc = (0, _generateBlurVertSource2.default)(kernelSize, false);
	            this.fragmentSrc = (0, _generateBlurFragSource2.default)(kernelSize);

	            this.firstRun = false;
	        }

	        this.uniforms.strength = 1 / output.size.height * (output.size.height / input.size.height);

	        this.uniforms.strength *= this.strength;
	        this.uniforms.strength /= this.passes;

	        if (this.passes === 1) {
	            filterManager.applyFilter(this, input, output, clear);
	        } else {
	            var renderTarget = filterManager.getRenderTarget(true);
	            var flip = input;
	            var flop = renderTarget;

	            for (var i = 0; i < this.passes - 1; i++) {
	                filterManager.applyFilter(this, flip, flop, true);

	                var temp = flop;

	                flop = flip;
	                flip = temp;
	            }

	            filterManager.applyFilter(this, flip, output, clear);

	            filterManager.returnRenderTarget(renderTarget);
	        }
	    };

	    /**
	     * Sets the strength of both the blur.
	     *
	     * @member {number}
	     * @default 2
	     */


	    _createClass(BlurYFilter, [{
	        key: 'blur',
	        get: function get() {
	            return this.strength;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.padding = Math.abs(value) * 2;
	            this.strength = value;
	        }

	        /**
	         * Sets the quality of the blur by modifying the number of passes. More passes means higher
	         * quaility bluring but the lower the performance.
	         *
	         * @member {number}
	         * @default 4
	         */

	    }, {
	        key: 'quality',
	        get: function get() {
	            return this._quality;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._quality = value;
	            this.passes = value;
	        }
	    }]);

	    return BlurYFilter;
	}(core.Filter);

	exports.default = BlurYFilter;
	//# sourceMappingURL=BlurYFilter.js.map

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _core = __webpack_require__(173);

	var core = _interopRequireWildcard(_core);

	var _path = __webpack_require__(252);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	/**
	 * The ColorMatrixFilter class lets you apply a 5x4 matrix transformation on the RGBA
	 * color and alpha values of every pixel on your displayObject to produce a result
	 * with a new set of RGBA color and alpha values. It's pretty powerful!
	 *
	 * ```js
	 *  let colorMatrix = new PIXI.filters.ColorMatrixFilter();
	 *  container.filters = [colorMatrix];
	 *  colorMatrix.contrast(2);
	 * ```
	 * @author Clément Chenebault <clement@goodboydigital.com>
	 * @class
	 * @extends PIXI.Filter
	 * @memberof PIXI.filters
	 */
	var ColorMatrixFilter = function (_core$Filter) {
	    _inherits(ColorMatrixFilter, _core$Filter);

	    /**
	     *
	     */
	    function ColorMatrixFilter() {
	        _classCallCheck(this, ColorMatrixFilter);

	        var _this = _possibleConstructorReturn(this, _core$Filter.call(this,
	        // vertex shader
	        'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n    vTextureCoord = aTextureCoord;\n}',
	        // fragment shader
	        'varying vec2 vTextureCoord;\nuniform sampler2D uSampler;\nuniform float m[20];\nuniform float uAlpha;\n\nvoid main(void)\n{\n    vec4 c = texture2D(uSampler, vTextureCoord);\n\n    if (uAlpha == 0.0) {\n        gl_FragColor = c;\n        return;\n    }\n\n    // Un-premultiply alpha before applying the color matrix. See issue #3539.\n    if (c.a > 0.0) {\n      c.rgb /= c.a;\n    }\n\n    vec4 result;\n\n    result.r = (m[0] * c.r);\n        result.r += (m[1] * c.g);\n        result.r += (m[2] * c.b);\n        result.r += (m[3] * c.a);\n        result.r += m[4];\n\n    result.g = (m[5] * c.r);\n        result.g += (m[6] * c.g);\n        result.g += (m[7] * c.b);\n        result.g += (m[8] * c.a);\n        result.g += m[9];\n\n    result.b = (m[10] * c.r);\n       result.b += (m[11] * c.g);\n       result.b += (m[12] * c.b);\n       result.b += (m[13] * c.a);\n       result.b += m[14];\n\n    result.a = (m[15] * c.r);\n       result.a += (m[16] * c.g);\n       result.a += (m[17] * c.b);\n       result.a += (m[18] * c.a);\n       result.a += m[19];\n\n    vec3 rgb = mix(c.rgb, result.rgb, uAlpha);\n\n    // Premultiply alpha again.\n    rgb *= result.a;\n\n    gl_FragColor = vec4(rgb, result.a);\n}\n'));

	        _this.uniforms.m = [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0];

	        _this.alpha = 1;
	        return _this;
	    }

	    /**
	     * Transforms current matrix and set the new one
	     *
	     * @param {number[]} matrix - 5x4 matrix
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */


	    ColorMatrixFilter.prototype._loadMatrix = function _loadMatrix(matrix) {
	        var multiply = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

	        var newMatrix = matrix;

	        if (multiply) {
	            this._multiply(newMatrix, this.uniforms.m, matrix);
	            newMatrix = this._colorMatrix(newMatrix);
	        }

	        // set the new matrix
	        this.uniforms.m = newMatrix;
	    };

	    /**
	     * Multiplies two mat5's
	     *
	     * @private
	     * @param {number[]} out - 5x4 matrix the receiving matrix
	     * @param {number[]} a - 5x4 matrix the first operand
	     * @param {number[]} b - 5x4 matrix the second operand
	     * @returns {number[]} 5x4 matrix
	     */


	    ColorMatrixFilter.prototype._multiply = function _multiply(out, a, b) {
	        // Red Channel
	        out[0] = a[0] * b[0] + a[1] * b[5] + a[2] * b[10] + a[3] * b[15];
	        out[1] = a[0] * b[1] + a[1] * b[6] + a[2] * b[11] + a[3] * b[16];
	        out[2] = a[0] * b[2] + a[1] * b[7] + a[2] * b[12] + a[3] * b[17];
	        out[3] = a[0] * b[3] + a[1] * b[8] + a[2] * b[13] + a[3] * b[18];
	        out[4] = a[0] * b[4] + a[1] * b[9] + a[2] * b[14] + a[3] * b[19] + a[4];

	        // Green Channel
	        out[5] = a[5] * b[0] + a[6] * b[5] + a[7] * b[10] + a[8] * b[15];
	        out[6] = a[5] * b[1] + a[6] * b[6] + a[7] * b[11] + a[8] * b[16];
	        out[7] = a[5] * b[2] + a[6] * b[7] + a[7] * b[12] + a[8] * b[17];
	        out[8] = a[5] * b[3] + a[6] * b[8] + a[7] * b[13] + a[8] * b[18];
	        out[9] = a[5] * b[4] + a[6] * b[9] + a[7] * b[14] + a[8] * b[19] + a[9];

	        // Blue Channel
	        out[10] = a[10] * b[0] + a[11] * b[5] + a[12] * b[10] + a[13] * b[15];
	        out[11] = a[10] * b[1] + a[11] * b[6] + a[12] * b[11] + a[13] * b[16];
	        out[12] = a[10] * b[2] + a[11] * b[7] + a[12] * b[12] + a[13] * b[17];
	        out[13] = a[10] * b[3] + a[11] * b[8] + a[12] * b[13] + a[13] * b[18];
	        out[14] = a[10] * b[4] + a[11] * b[9] + a[12] * b[14] + a[13] * b[19] + a[14];

	        // Alpha Channel
	        out[15] = a[15] * b[0] + a[16] * b[5] + a[17] * b[10] + a[18] * b[15];
	        out[16] = a[15] * b[1] + a[16] * b[6] + a[17] * b[11] + a[18] * b[16];
	        out[17] = a[15] * b[2] + a[16] * b[7] + a[17] * b[12] + a[18] * b[17];
	        out[18] = a[15] * b[3] + a[16] * b[8] + a[17] * b[13] + a[18] * b[18];
	        out[19] = a[15] * b[4] + a[16] * b[9] + a[17] * b[14] + a[18] * b[19] + a[19];

	        return out;
	    };

	    /**
	     * Create a Float32 Array and normalize the offset component to 0-1
	     *
	     * @private
	     * @param {number[]} matrix - 5x4 matrix
	     * @return {number[]} 5x4 matrix with all values between 0-1
	     */


	    ColorMatrixFilter.prototype._colorMatrix = function _colorMatrix(matrix) {
	        // Create a Float32 Array and normalize the offset component to 0-1
	        var m = new Float32Array(matrix);

	        m[4] /= 255;
	        m[9] /= 255;
	        m[14] /= 255;
	        m[19] /= 255;

	        return m;
	    };

	    /**
	     * Adjusts brightness
	     *
	     * @param {number} b - value of the brigthness (0-1, where 0 is black)
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */


	    ColorMatrixFilter.prototype.brightness = function brightness(b, multiply) {
	        var matrix = [b, 0, 0, 0, 0, 0, b, 0, 0, 0, 0, 0, b, 0, 0, 0, 0, 0, 1, 0];

	        this._loadMatrix(matrix, multiply);
	    };

	    /**
	     * Set the matrices in grey scales
	     *
	     * @param {number} scale - value of the grey (0-1, where 0 is black)
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */


	    ColorMatrixFilter.prototype.greyscale = function greyscale(scale, multiply) {
	        var matrix = [scale, scale, scale, 0, 0, scale, scale, scale, 0, 0, scale, scale, scale, 0, 0, 0, 0, 0, 1, 0];

	        this._loadMatrix(matrix, multiply);
	    };

	    /**
	     * Set the black and white matrice.
	     *
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */


	    ColorMatrixFilter.prototype.blackAndWhite = function blackAndWhite(multiply) {
	        var matrix = [0.3, 0.6, 0.1, 0, 0, 0.3, 0.6, 0.1, 0, 0, 0.3, 0.6, 0.1, 0, 0, 0, 0, 0, 1, 0];

	        this._loadMatrix(matrix, multiply);
	    };

	    /**
	     * Set the hue property of the color
	     *
	     * @param {number} rotation - in degrees
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */


	    ColorMatrixFilter.prototype.hue = function hue(rotation, multiply) {
	        rotation = (rotation || 0) / 180 * Math.PI;

	        var cosR = Math.cos(rotation);
	        var sinR = Math.sin(rotation);
	        var sqrt = Math.sqrt;

	        /* a good approximation for hue rotation
	         This matrix is far better than the versions with magic luminance constants
	         formerly used here, but also used in the starling framework (flash) and known from this
	         old part of the internet: quasimondo.com/archives/000565.php
	          This new matrix is based on rgb cube rotation in space. Look here for a more descriptive
	         implementation as a shader not a general matrix:
	         https://github.com/evanw/glfx.js/blob/58841c23919bd59787effc0333a4897b43835412/src/filters/adjust/huesaturation.js
	          This is the source for the code:
	         see http://stackoverflow.com/questions/8507885/shift-hue-of-an-rgb-color/8510751#8510751
	         */

	        var w = 1 / 3;
	        var sqrW = sqrt(w); // weight is

	        var a00 = cosR + (1.0 - cosR) * w;
	        var a01 = w * (1.0 - cosR) - sqrW * sinR;
	        var a02 = w * (1.0 - cosR) + sqrW * sinR;

	        var a10 = w * (1.0 - cosR) + sqrW * sinR;
	        var a11 = cosR + w * (1.0 - cosR);
	        var a12 = w * (1.0 - cosR) - sqrW * sinR;

	        var a20 = w * (1.0 - cosR) - sqrW * sinR;
	        var a21 = w * (1.0 - cosR) + sqrW * sinR;
	        var a22 = cosR + w * (1.0 - cosR);

	        var matrix = [a00, a01, a02, 0, 0, a10, a11, a12, 0, 0, a20, a21, a22, 0, 0, 0, 0, 0, 1, 0];

	        this._loadMatrix(matrix, multiply);
	    };

	    /**
	     * Set the contrast matrix, increase the separation between dark and bright
	     * Increase contrast : shadows darker and highlights brighter
	     * Decrease contrast : bring the shadows up and the highlights down
	     *
	     * @param {number} amount - value of the contrast (0-1)
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */


	    ColorMatrixFilter.prototype.contrast = function contrast(amount, multiply) {
	        var v = (amount || 0) + 1;
	        var o = -0.5 * (v - 1);

	        var matrix = [v, 0, 0, 0, o, 0, v, 0, 0, o, 0, 0, v, 0, o, 0, 0, 0, 1, 0];

	        this._loadMatrix(matrix, multiply);
	    };

	    /**
	     * Set the saturation matrix, increase the separation between colors
	     * Increase saturation : increase contrast, brightness, and sharpness
	     *
	     * @param {number} amount - The saturation amount (0-1)
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */


	    ColorMatrixFilter.prototype.saturate = function saturate() {
	        var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	        var multiply = arguments[1];

	        var x = amount * 2 / 3 + 1;
	        var y = (x - 1) * -0.5;

	        var matrix = [x, y, y, 0, 0, y, x, y, 0, 0, y, y, x, 0, 0, 0, 0, 0, 1, 0];

	        this._loadMatrix(matrix, multiply);
	    };

	    /**
	     * Desaturate image (remove color)
	     *
	     * Call the saturate function
	     *
	     */


	    ColorMatrixFilter.prototype.desaturate = function desaturate() // eslint-disable-line no-unused-vars
	    {
	        this.saturate(-1);
	    };

	    /**
	     * Negative image (inverse of classic rgb matrix)
	     *
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */


	    ColorMatrixFilter.prototype.negative = function negative(multiply) {
	        var matrix = [-1, 0, 0, 1, 0, 0, -1, 0, 1, 0, 0, 0, -1, 1, 0, 0, 0, 0, 1, 0];

	        this._loadMatrix(matrix, multiply);
	    };

	    /**
	     * Sepia image
	     *
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */


	    ColorMatrixFilter.prototype.sepia = function sepia(multiply) {
	        var matrix = [0.393, 0.7689999, 0.18899999, 0, 0, 0.349, 0.6859999, 0.16799999, 0, 0, 0.272, 0.5339999, 0.13099999, 0, 0, 0, 0, 0, 1, 0];

	        this._loadMatrix(matrix, multiply);
	    };

	    /**
	     * Color motion picture process invented in 1916 (thanks Dominic Szablewski)
	     *
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */


	    ColorMatrixFilter.prototype.technicolor = function technicolor(multiply) {
	        var matrix = [1.9125277891456083, -0.8545344976951645, -0.09155508482755585, 0, 11.793603434377337, -0.3087833385928097, 1.7658908555458428, -0.10601743074722245, 0, -70.35205161461398, -0.231103377548616, -0.7501899197440212, 1.847597816108189, 0, 30.950940869491138, 0, 0, 0, 1, 0];

	        this._loadMatrix(matrix, multiply);
	    };

	    /**
	     * Polaroid filter
	     *
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */


	    ColorMatrixFilter.prototype.polaroid = function polaroid(multiply) {
	        var matrix = [1.438, -0.062, -0.062, 0, 0, -0.122, 1.378, -0.122, 0, 0, -0.016, -0.016, 1.483, 0, 0, 0, 0, 0, 1, 0];

	        this._loadMatrix(matrix, multiply);
	    };

	    /**
	     * Filter who transforms : Red -> Blue and Blue -> Red
	     *
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */


	    ColorMatrixFilter.prototype.toBGR = function toBGR(multiply) {
	        var matrix = [0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 1, 0];

	        this._loadMatrix(matrix, multiply);
	    };

	    /**
	     * Color reversal film introduced by Eastman Kodak in 1935. (thanks Dominic Szablewski)
	     *
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */


	    ColorMatrixFilter.prototype.kodachrome = function kodachrome(multiply) {
	        var matrix = [1.1285582396593525, -0.3967382283601348, -0.03992559172921793, 0, 63.72958762196502, -0.16404339962244616, 1.0835251566291304, -0.05498805115633132, 0, 24.732407896706203, -0.16786010706155763, -0.5603416277695248, 1.6014850761964943, 0, 35.62982807460946, 0, 0, 0, 1, 0];

	        this._loadMatrix(matrix, multiply);
	    };

	    /**
	     * Brown delicious browni filter (thanks Dominic Szablewski)
	     *
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */


	    ColorMatrixFilter.prototype.browni = function browni(multiply) {
	        var matrix = [0.5997023498159715, 0.34553243048391263, -0.2708298674538042, 0, 47.43192855600873, -0.037703249837783157, 0.8609577587992641, 0.15059552388459913, 0, -36.96841498319127, 0.24113635128153335, -0.07441037908422492, 0.44972182064877153, 0, -7.562075277591283, 0, 0, 0, 1, 0];

	        this._loadMatrix(matrix, multiply);
	    };

	    /**
	     * Vintage filter (thanks Dominic Szablewski)
	     *
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */


	    ColorMatrixFilter.prototype.vintage = function vintage(multiply) {
	        var matrix = [0.6279345635605994, 0.3202183420819367, -0.03965408211312453, 0, 9.651285835294123, 0.02578397704808868, 0.6441188644374771, 0.03259127616149294, 0, 7.462829176470591, 0.0466055556782719, -0.0851232987247891, 0.5241648018700465, 0, 5.159190588235296, 0, 0, 0, 1, 0];

	        this._loadMatrix(matrix, multiply);
	    };

	    /**
	     * We don't know exactly what it does, kind of gradient map, but funny to play with!
	     *
	     * @param {number} desaturation - Tone values.
	     * @param {number} toned - Tone values.
	     * @param {string} lightColor - Tone values, example: `0xFFE580`
	     * @param {string} darkColor - Tone values, example: `0xFFE580`
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */


	    ColorMatrixFilter.prototype.colorTone = function colorTone(desaturation, toned, lightColor, darkColor, multiply) {
	        desaturation = desaturation || 0.2;
	        toned = toned || 0.15;
	        lightColor = lightColor || 0xFFE580;
	        darkColor = darkColor || 0x338000;

	        var lR = (lightColor >> 16 & 0xFF) / 255;
	        var lG = (lightColor >> 8 & 0xFF) / 255;
	        var lB = (lightColor & 0xFF) / 255;

	        var dR = (darkColor >> 16 & 0xFF) / 255;
	        var dG = (darkColor >> 8 & 0xFF) / 255;
	        var dB = (darkColor & 0xFF) / 255;

	        var matrix = [0.3, 0.59, 0.11, 0, 0, lR, lG, lB, desaturation, 0, dR, dG, dB, toned, 0, lR - dR, lG - dG, lB - dB, 0, 0];

	        this._loadMatrix(matrix, multiply);
	    };

	    /**
	     * Night effect
	     *
	     * @param {number} intensity - The intensity of the night effect.
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */


	    ColorMatrixFilter.prototype.night = function night(intensity, multiply) {
	        intensity = intensity || 0.1;
	        var matrix = [intensity * -2.0, -intensity, 0, 0, 0, -intensity, 0, intensity, 0, 0, 0, intensity, intensity * 2.0, 0, 0, 0, 0, 0, 1, 0];

	        this._loadMatrix(matrix, multiply);
	    };

	    /**
	     * Predator effect
	     *
	     * Erase the current matrix by setting a new indepent one
	     *
	     * @param {number} amount - how much the predator feels his future victim
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */


	    ColorMatrixFilter.prototype.predator = function predator(amount, multiply) {
	        var matrix = [
	        // row 1
	        11.224130630493164 * amount, -4.794486999511719 * amount, -2.8746118545532227 * amount, 0 * amount, 0.40342438220977783 * amount,
	        // row 2
	        -3.6330697536468506 * amount, 9.193157196044922 * amount, -2.951810836791992 * amount, 0 * amount, -1.316135048866272 * amount,
	        // row 3
	        -3.2184197902679443 * amount, -4.2375030517578125 * amount, 7.476448059082031 * amount, 0 * amount, 0.8044459223747253 * amount,
	        // row 4
	        0, 0, 0, 1, 0];

	        this._loadMatrix(matrix, multiply);
	    };

	    /**
	     * LSD effect
	     *
	     * Multiply the current matrix
	     *
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */


	    ColorMatrixFilter.prototype.lsd = function lsd(multiply) {
	        var matrix = [2, -0.4, 0.5, 0, 0, -0.5, 2, -0.4, 0, 0, -0.4, -0.5, 3, 0, 0, 0, 0, 0, 1, 0];

	        this._loadMatrix(matrix, multiply);
	    };

	    /**
	     * Erase the current matrix by setting the default one
	     *
	     */


	    ColorMatrixFilter.prototype.reset = function reset() {
	        var matrix = [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0];

	        this._loadMatrix(matrix, false);
	    };

	    /**
	     * The matrix of the color matrix filter
	     *
	     * @member {number[]}
	     * @default [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0]
	     */


	    _createClass(ColorMatrixFilter, [{
	        key: 'matrix',
	        get: function get() {
	            return this.uniforms.m;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.uniforms.m = value;
	        }

	        /**
	         * The opacity value to use when mixing the original and resultant colors.
	         *
	         * When the value is 0, the original color is used without modification.
	         * When the value is 1, the result color is used.
	         * When in the range (0, 1) the color is interpolated between the original and result by this amount.
	         *
	         * @member {number}
	         * @default 1
	         */

	    }, {
	        key: 'alpha',
	        get: function get() {
	            return this.uniforms.uAlpha;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.uniforms.uAlpha = value;
	        }
	    }]);

	    return ColorMatrixFilter;
	}(core.Filter);

	// Americanized alias


	exports.default = ColorMatrixFilter;
	ColorMatrixFilter.prototype.grayscale = ColorMatrixFilter.prototype.greyscale;
	//# sourceMappingURL=ColorMatrixFilter.js.map

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _core = __webpack_require__(173);

	var core = _interopRequireWildcard(_core);

	var _path = __webpack_require__(252);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	/**
	 * Simplest filter - applies alpha
	 *
	 * Use this instead of Container's alpha property to avoid visual layering of individual elements.
	 * AlphaFilter applies alpha evenly across the entire display object and any opaque elements it contains.
	 * If elements are not opaque, they will blend with each other anyway.
	 *
	 * Very handy if you want to use common features of all filters:
	 *
	 * 1. Assign a blendMode to this filter, blend all elements inside display object with background.
	 *
	 * 2. To use clipping in display coordinates, assign a filterArea to the same container that has this filter.
	 *
	 * @class
	 * @extends PIXI.Filter
	 * @memberof PIXI.filters
	 */
	var AlphaFilter = function (_core$Filter) {
	    _inherits(AlphaFilter, _core$Filter);

	    /**
	     * @param {number} [alpha=1] Amount of alpha from 0 to 1, where 0 is transparent
	     */
	    function AlphaFilter() {
	        var alpha = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1.0;

	        _classCallCheck(this, AlphaFilter);

	        var _this = _possibleConstructorReturn(this, _core$Filter.call(this,
	        // vertex shader
	        'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n    vTextureCoord = aTextureCoord;\n}',
	        // fragment shader
	        'varying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform float uAlpha;\n\nvoid main(void)\n{\n   gl_FragColor = texture2D(uSampler, vTextureCoord) * uAlpha;\n}\n'));

	        _this.alpha = alpha;
	        _this.glShaderKey = 'alpha';
	        return _this;
	    }

	    /**
	     * Coefficient for alpha multiplication
	     *
	     * @member {number}
	     * @default 1
	     */


	    _createClass(AlphaFilter, [{
	        key: 'alpha',
	        get: function get() {
	            return this.uniforms.uAlpha;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.uniforms.uAlpha = value;
	        }
	    }]);

	    return AlphaFilter;
	}(core.Filter);

	exports.default = AlphaFilter;
	//# sourceMappingURL=AlphaFilter.js.map

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _InteractionData = __webpack_require__(320);

	Object.defineProperty(exports, 'InteractionData', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InteractionData).default;
	  }
	});

	var _InteractionManager = __webpack_require__(321);

	Object.defineProperty(exports, 'InteractionManager', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InteractionManager).default;
	  }
	});

	var _interactiveTarget = __webpack_require__(324);

	Object.defineProperty(exports, 'interactiveTarget', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_interactiveTarget).default;
	  }
	});

	var _InteractionTrackingData = __webpack_require__(323);

	Object.defineProperty(exports, 'InteractionTrackingData', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InteractionTrackingData).default;
	  }
	});

	var _InteractionEvent = __webpack_require__(322);

	Object.defineProperty(exports, 'InteractionEvent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InteractionEvent).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=index.js.map

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _core = __webpack_require__(173);

	var core = _interopRequireWildcard(_core);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/**
	 * Holds all information related to an Interaction event
	 *
	 * @class
	 * @memberof PIXI.interaction
	 */
	var InteractionData = function () {
	  /**
	   *
	   */
	  function InteractionData() {
	    _classCallCheck(this, InteractionData);

	    /**
	     * This point stores the global coords of where the touch/mouse event happened
	     *
	     * @member {PIXI.Point}
	     */
	    this.global = new core.Point();

	    /**
	     * The target DisplayObject that was interacted with
	     *
	     * @member {PIXI.DisplayObject}
	     */
	    this.target = null;

	    /**
	     * When passed to an event handler, this will be the original DOM Event that was captured
	     *
	     * @see https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent
	     * @see https://developer.mozilla.org/en-US/docs/Web/API/TouchEvent
	     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent
	     * @member {MouseEvent|TouchEvent|PointerEvent}
	     */
	    this.originalEvent = null;

	    /**
	     * Unique identifier for this interaction
	     *
	     * @member {number}
	     */
	    this.identifier = null;

	    /**
	     * Indicates whether or not the pointer device that created the event is the primary pointer.
	     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/isPrimary
	     * @type {Boolean}
	     */
	    this.isPrimary = false;

	    /**
	     * Indicates which button was pressed on the mouse or pointer device to trigger the event.
	     * @see https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
	     * @type {number}
	     */
	    this.button = 0;

	    /**
	     * Indicates which buttons are pressed on the mouse or pointer device when the event is triggered.
	     * @see https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/buttons
	     * @type {number}
	     */
	    this.buttons = 0;

	    /**
	     * The width of the pointer's contact along the x-axis, measured in CSS pixels.
	     * radiusX of TouchEvents will be represented by this value.
	     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/width
	     * @type {number}
	     */
	    this.width = 0;

	    /**
	     * The height of the pointer's contact along the y-axis, measured in CSS pixels.
	     * radiusY of TouchEvents will be represented by this value.
	     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/height
	     * @type {number}
	     */
	    this.height = 0;

	    /**
	     * The angle, in degrees, between the pointer device and the screen.
	     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/tiltX
	     * @type {number}
	     */
	    this.tiltX = 0;

	    /**
	     * The angle, in degrees, between the pointer device and the screen.
	     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/tiltY
	     * @type {number}
	     */
	    this.tiltY = 0;

	    /**
	     * The type of pointer that triggered the event.
	     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/pointerType
	     * @type {string}
	     */
	    this.pointerType = null;

	    /**
	     * Pressure applied by the pointing device during the event. A Touch's force property
	     * will be represented by this value.
	     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/pressure
	     * @type {number}
	     */
	    this.pressure = 0;

	    /**
	     * From TouchEvents (not PointerEvents triggered by touches), the rotationAngle of the Touch.
	     * @see https://developer.mozilla.org/en-US/docs/Web/API/Touch/rotationAngle
	     * @type {number}
	     */
	    this.rotationAngle = 0;

	    /**
	     * Twist of a stylus pointer.
	     * @see https://w3c.github.io/pointerevents/#pointerevent-interface
	     * @type {number}
	     */
	    this.twist = 0;

	    /**
	     * Barrel pressure on a stylus pointer.
	     * @see https://w3c.github.io/pointerevents/#pointerevent-interface
	     * @type {number}
	     */
	    this.tangentialPressure = 0;
	  }

	  /**
	   * The unique identifier of the pointer. It will be the same as `identifier`.
	   * @readonly
	   * @member {number}
	   * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/pointerId
	   */


	  /**
	   * This will return the local coordinates of the specified displayObject for this InteractionData
	   *
	   * @param {PIXI.DisplayObject} displayObject - The DisplayObject that you would like the local
	   *  coords off
	   * @param {PIXI.Point} [point] - A Point object in which to store the value, optional (otherwise
	   *  will create a new point)
	   * @param {PIXI.Point} [globalPos] - A Point object containing your custom global coords, optional
	   *  (otherwise will use the current global coords)
	   * @return {PIXI.Point} A point containing the coordinates of the InteractionData position relative
	   *  to the DisplayObject
	   */
	  InteractionData.prototype.getLocalPosition = function getLocalPosition(displayObject, point, globalPos) {
	    return displayObject.worldTransform.applyInverse(globalPos || this.global, point);
	  };

	  /**
	   * Copies properties from normalized event data.
	   *
	   * @param {Touch|MouseEvent|PointerEvent} event The normalized event data
	   */


	  InteractionData.prototype.copyEvent = function copyEvent(event) {
	    // isPrimary should only change on touchstart/pointerdown, so we don't want to overwrite
	    // it with "false" on later events when our shim for it on touch events might not be
	    // accurate
	    if (event.isPrimary) {
	      this.isPrimary = true;
	    }
	    this.button = event.button;
	    // event.buttons is not available in all browsers (ie. Safari), but it does have a non-standard
	    // event.which property instead, which conveys the same information.
	    this.buttons = Number.isInteger(event.buttons) ? event.buttons : event.which;
	    this.width = event.width;
	    this.height = event.height;
	    this.tiltX = event.tiltX;
	    this.tiltY = event.tiltY;
	    this.pointerType = event.pointerType;
	    this.pressure = event.pressure;
	    this.rotationAngle = event.rotationAngle;
	    this.twist = event.twist || 0;
	    this.tangentialPressure = event.tangentialPressure || 0;
	  };

	  /**
	   * Resets the data for pooling.
	   */


	  InteractionData.prototype.reset = function reset() {
	    // isPrimary is the only property that we really need to reset - everything else is
	    // guaranteed to be overwritten
	    this.isPrimary = false;
	  };

	  _createClass(InteractionData, [{
	    key: 'pointerId',
	    get: function get() {
	      return this.identifier;
	    }
	  }]);

	  return InteractionData;
	}();

	exports.default = InteractionData;
	//# sourceMappingURL=InteractionData.js.map

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var _core = __webpack_require__(173);

	var core = _interopRequireWildcard(_core);

	var _InteractionData = __webpack_require__(320);

	var _InteractionData2 = _interopRequireDefault(_InteractionData);

	var _InteractionEvent = __webpack_require__(322);

	var _InteractionEvent2 = _interopRequireDefault(_InteractionEvent);

	var _InteractionTrackingData = __webpack_require__(323);

	var _InteractionTrackingData2 = _interopRequireDefault(_InteractionTrackingData);

	var _eventemitter = __webpack_require__(204);

	var _eventemitter2 = _interopRequireDefault(_eventemitter);

	var _interactiveTarget = __webpack_require__(324);

	var _interactiveTarget2 = _interopRequireDefault(_interactiveTarget);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	// Mix interactiveTarget into core.DisplayObject.prototype, after deprecation has been handled
	core.utils.mixins.delayMixin(core.DisplayObject.prototype, _interactiveTarget2.default);

	var MOUSE_POINTER_ID = 1;

	// helpers for hitTest() - only used inside hitTest()
	var hitTestEvent = {
	    target: null,
	    data: {
	        global: null
	    }
	};

	/**
	 * The interaction manager deals with mouse, touch and pointer events. Any DisplayObject can be interactive
	 * if its interactive parameter is set to true
	 * This manager also supports multitouch.
	 *
	 * An instance of this class is automatically created by default, and can be found at renderer.plugins.interaction
	 *
	 * @class
	 * @extends EventEmitter
	 * @memberof PIXI.interaction
	 */

	var InteractionManager = function (_EventEmitter) {
	    _inherits(InteractionManager, _EventEmitter);

	    /**
	     * @param {PIXI.CanvasRenderer|PIXI.WebGLRenderer} renderer - A reference to the current renderer
	     * @param {object} [options] - The options for the manager.
	     * @param {boolean} [options.autoPreventDefault=true] - Should the manager automatically prevent default browser actions.
	     * @param {number} [options.interactionFrequency=10] - Frequency increases the interaction events will be checked.
	     */
	    function InteractionManager(renderer, options) {
	        _classCallCheck(this, InteractionManager);

	        var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

	        options = options || {};

	        /**
	         * The renderer this interaction manager works for.
	         *
	         * @member {PIXI.SystemRenderer}
	         */
	        _this.renderer = renderer;

	        /**
	         * Should default browser actions automatically be prevented.
	         * Does not apply to pointer events for backwards compatibility
	         * preventDefault on pointer events stops mouse events from firing
	         * Thus, for every pointer event, there will always be either a mouse of touch event alongside it.
	         *
	         * @member {boolean}
	         * @default true
	         */
	        _this.autoPreventDefault = options.autoPreventDefault !== undefined ? options.autoPreventDefault : true;

	        /**
	         * Frequency in milliseconds that the mousemove, moveover & mouseout interaction events will be checked.
	         *
	         * @member {number}
	         * @default 10
	         */
	        _this.interactionFrequency = options.interactionFrequency || 10;

	        /**
	         * The mouse data
	         *
	         * @member {PIXI.interaction.InteractionData}
	         */
	        _this.mouse = new _InteractionData2.default();
	        _this.mouse.identifier = MOUSE_POINTER_ID;

	        // setting the mouse to start off far off screen will mean that mouse over does
	        //  not get called before we even move the mouse.
	        _this.mouse.global.set(-999999);

	        /**
	         * Actively tracked InteractionData
	         *
	         * @private
	         * @member {Object.<number,PIXI.interation.InteractionData>}
	         */
	        _this.activeInteractionData = {};
	        _this.activeInteractionData[MOUSE_POINTER_ID] = _this.mouse;

	        /**
	         * Pool of unused InteractionData
	         *
	         * @private
	         * @member {PIXI.interation.InteractionData[]}
	         */
	        _this.interactionDataPool = [];

	        /**
	         * An event data object to handle all the event tracking/dispatching
	         *
	         * @member {object}
	         */
	        _this.eventData = new _InteractionEvent2.default();

	        /**
	         * The DOM element to bind to.
	         *
	         * @private
	         * @member {HTMLElement}
	         */
	        _this.interactionDOMElement = null;

	        /**
	         * This property determines if mousemove and touchmove events are fired only when the cursor
	         * is over the object.
	         * Setting to true will make things work more in line with how the DOM verison works.
	         * Setting to false can make things easier for things like dragging
	         * It is currently set to false as this is how PixiJS used to work. This will be set to true in
	         * future versions of pixi.
	         *
	         * @member {boolean}
	         * @default false
	         */
	        _this.moveWhenInside = false;

	        /**
	         * Have events been attached to the dom element?
	         *
	         * @private
	         * @member {boolean}
	         */
	        _this.eventsAdded = false;

	        /**
	         * Is the mouse hovering over the renderer?
	         *
	         * @private
	         * @member {boolean}
	         */
	        _this.mouseOverRenderer = false;

	        /**
	         * Does the device support touch events
	         * https://www.w3.org/TR/touch-events/
	         *
	         * @readonly
	         * @member {boolean}
	         */
	        _this.supportsTouchEvents = 'ontouchstart' in window;

	        /**
	         * Does the device support pointer events
	         * https://www.w3.org/Submission/pointer-events/
	         *
	         * @readonly
	         * @member {boolean}
	         */
	        _this.supportsPointerEvents = !!window.PointerEvent;

	        // this will make it so that you don't have to call bind all the time

	        /**
	         * @private
	         * @member {Function}
	         */
	        _this.onPointerUp = _this.onPointerUp.bind(_this);
	        _this.processPointerUp = _this.processPointerUp.bind(_this);

	        /**
	         * @private
	         * @member {Function}
	         */
	        _this.onPointerCancel = _this.onPointerCancel.bind(_this);
	        _this.processPointerCancel = _this.processPointerCancel.bind(_this);

	        /**
	         * @private
	         * @member {Function}
	         */
	        _this.onPointerDown = _this.onPointerDown.bind(_this);
	        _this.processPointerDown = _this.processPointerDown.bind(_this);

	        /**
	         * @private
	         * @member {Function}
	         */
	        _this.onPointerMove = _this.onPointerMove.bind(_this);
	        _this.processPointerMove = _this.processPointerMove.bind(_this);

	        /**
	         * @private
	         * @member {Function}
	         */
	        _this.onPointerOut = _this.onPointerOut.bind(_this);
	        _this.processPointerOverOut = _this.processPointerOverOut.bind(_this);

	        /**
	         * @private
	         * @member {Function}
	         */
	        _this.onPointerOver = _this.onPointerOver.bind(_this);

	        /**
	         * Dictionary of how different cursor modes are handled. Strings are handled as CSS cursor
	         * values, objects are handled as dictionaries of CSS values for interactionDOMElement,
	         * and functions are called instead of changing the CSS.
	         * Default CSS cursor values are provided for 'default' and 'pointer' modes.
	         * @member {Object.<string, (string|Function|Object.<string, string>)>}
	         */
	        _this.cursorStyles = {
	            default: 'inherit',
	            pointer: 'pointer'
	        };

	        /**
	         * The mode of the cursor that is being used.
	         * The value of this is a key from the cursorStyles dictionary.
	         *
	         * @member {string}
	         */
	        _this.currentCursorMode = null;

	        /**
	         * Internal cached let.
	         *
	         * @private
	         * @member {string}
	         */
	        _this.cursor = null;

	        /**
	         * Internal cached let.
	         *
	         * @private
	         * @member {PIXI.Point}
	         */
	        _this._tempPoint = new core.Point();

	        /**
	         * The current resolution / device pixel ratio.
	         *
	         * @member {number}
	         * @default 1
	         */
	        _this.resolution = 1;

	        _this.setTargetElement(_this.renderer.view, _this.renderer.resolution);

	        /**
	         * Fired when a pointer device button (usually a mouse left-button) is pressed on the display
	         * object.
	         *
	         * @event PIXI.interaction.InteractionManager#mousedown
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when a pointer device secondary button (usually a mouse right-button) is pressed
	         * on the display object.
	         *
	         * @event PIXI.interaction.InteractionManager#rightdown
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when a pointer device button (usually a mouse left-button) is released over the display
	         * object.
	         *
	         * @event PIXI.interaction.InteractionManager#mouseup
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when a pointer device secondary button (usually a mouse right-button) is released
	         * over the display object.
	         *
	         * @event PIXI.interaction.InteractionManager#rightup
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when a pointer device button (usually a mouse left-button) is pressed and released on
	         * the display object.
	         *
	         * @event PIXI.interaction.InteractionManager#click
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when a pointer device secondary button (usually a mouse right-button) is pressed
	         * and released on the display object.
	         *
	         * @event PIXI.interaction.InteractionManager#rightclick
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when a pointer device button (usually a mouse left-button) is released outside the
	         * display object that initially registered a
	         * [mousedown]{@link PIXI.interaction.InteractionManager#event:mousedown}.
	         *
	         * @event PIXI.interaction.InteractionManager#mouseupoutside
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when a pointer device secondary button (usually a mouse right-button) is released
	         * outside the display object that initially registered a
	         * [rightdown]{@link PIXI.interaction.InteractionManager#event:rightdown}.
	         *
	         * @event PIXI.interaction.InteractionManager#rightupoutside
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when a pointer device (usually a mouse) is moved while over the display object
	         *
	         * @event PIXI.interaction.InteractionManager#mousemove
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when a pointer device (usually a mouse) is moved onto the display object
	         *
	         * @event PIXI.interaction.InteractionManager#mouseover
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when a pointer device (usually a mouse) is moved off the display object
	         *
	         * @event PIXI.interaction.InteractionManager#mouseout
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when a pointer device button is pressed on the display object.
	         *
	         * @event PIXI.interaction.InteractionManager#pointerdown
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when a pointer device button is released over the display object.
	         * Not always fired when some buttons are held down while others are released. In those cases,
	         * use [mousedown]{@link PIXI.interaction.InteractionManager#event:mousedown} and
	         * [mouseup]{@link PIXI.interaction.InteractionManager#event:mouseup} instead.
	         *
	         * @event PIXI.interaction.InteractionManager#pointerup
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when the operating system cancels a pointer event
	         *
	         * @event PIXI.interaction.InteractionManager#pointercancel
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when a pointer device button is pressed and released on the display object.
	         *
	         * @event PIXI.interaction.InteractionManager#pointertap
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when a pointer device button is released outside the display object that initially
	         * registered a [pointerdown]{@link PIXI.interaction.InteractionManager#event:pointerdown}.
	         *
	         * @event PIXI.interaction.InteractionManager#pointerupoutside
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when a pointer device is moved while over the display object
	         *
	         * @event PIXI.interaction.InteractionManager#pointermove
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when a pointer device is moved onto the display object
	         *
	         * @event PIXI.interaction.InteractionManager#pointerover
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when a pointer device is moved off the display object
	         *
	         * @event PIXI.interaction.InteractionManager#pointerout
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when a touch point is placed on the display object.
	         *
	         * @event PIXI.interaction.InteractionManager#touchstart
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when a touch point is removed from the display object.
	         *
	         * @event PIXI.interaction.InteractionManager#touchend
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when the operating system cancels a touch
	         *
	         * @event PIXI.interaction.InteractionManager#touchcancel
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when a touch point is placed and removed from the display object.
	         *
	         * @event PIXI.interaction.InteractionManager#tap
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when a touch point is removed outside of the display object that initially
	         * registered a [touchstart]{@link PIXI.interaction.InteractionManager#event:touchstart}.
	         *
	         * @event PIXI.interaction.InteractionManager#touchendoutside
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when a touch point is moved along the display object.
	         *
	         * @event PIXI.interaction.InteractionManager#touchmove
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when a pointer device button (usually a mouse left-button) is pressed on the display.
	         * object. DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#mousedown
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when a pointer device secondary button (usually a mouse right-button) is pressed
	         * on the display object. DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#rightdown
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when a pointer device button (usually a mouse left-button) is released over the display
	         * object. DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#mouseup
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when a pointer device secondary button (usually a mouse right-button) is released
	         * over the display object. DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#rightup
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when a pointer device button (usually a mouse left-button) is pressed and released on
	         * the display object. DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#click
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when a pointer device secondary button (usually a mouse right-button) is pressed
	         * and released on the display object. DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#rightclick
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when a pointer device button (usually a mouse left-button) is released outside the
	         * display object that initially registered a
	         * [mousedown]{@link PIXI.DisplayObject#event:mousedown}.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#mouseupoutside
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when a pointer device secondary button (usually a mouse right-button) is released
	         * outside the display object that initially registered a
	         * [rightdown]{@link PIXI.DisplayObject#event:rightdown}.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#rightupoutside
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when a pointer device (usually a mouse) is moved while over the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#mousemove
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when a pointer device (usually a mouse) is moved onto the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#mouseover
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when a pointer device (usually a mouse) is moved off the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#mouseout
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when a pointer device button is pressed on the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#pointerdown
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when a pointer device button is released over the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#pointerup
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when the operating system cancels a pointer event.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#pointercancel
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when a pointer device button is pressed and released on the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#pointertap
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when a pointer device button is released outside the display object that initially
	         * registered a [pointerdown]{@link PIXI.DisplayObject#event:pointerdown}.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#pointerupoutside
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when a pointer device is moved while over the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#pointermove
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when a pointer device is moved onto the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#pointerover
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when a pointer device is moved off the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#pointerout
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when a touch point is placed on the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#touchstart
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when a touch point is removed from the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#touchend
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when the operating system cancels a touch.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#touchcancel
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when a touch point is placed and removed from the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#tap
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when a touch point is removed outside of the display object that initially
	         * registered a [touchstart]{@link PIXI.DisplayObject#event:touchstart}.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#touchendoutside
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */

	        /**
	         * Fired when a touch point is moved along the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#touchmove
	         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
	         */
	        return _this;
	    }

	    /**
	     * Hit tests a point against the display tree, returning the first interactive object that is hit.
	     *
	     * @param {PIXI.Point} globalPoint - A point to hit test with, in global space.
	     * @param {PIXI.Container} [root] - The root display object to start from. If omitted, defaults
	     * to the last rendered root of the associated renderer.
	     * @return {PIXI.DisplayObject} The hit display object, if any.
	     */


	    InteractionManager.prototype.hitTest = function hitTest(globalPoint, root) {
	        // clear the target for our hit test
	        hitTestEvent.target = null;
	        // assign the global point
	        hitTestEvent.data.global = globalPoint;
	        // ensure safety of the root
	        if (!root) {
	            root = this.renderer._lastObjectRendered;
	        }
	        // run the hit test
	        this.processInteractive(hitTestEvent, root, null, true);
	        // return our found object - it'll be null if we didn't hit anything

	        return hitTestEvent.target;
	    };

	    /**
	     * Sets the DOM element which will receive mouse/touch events. This is useful for when you have
	     * other DOM elements on top of the renderers Canvas element. With this you'll be bale to deletegate
	     * another DOM element to receive those events.
	     *
	     * @param {HTMLCanvasElement} element - the DOM element which will receive mouse and touch events.
	     * @param {number} [resolution=1] - The resolution / device pixel ratio of the new element (relative to the canvas).
	     */


	    InteractionManager.prototype.setTargetElement = function setTargetElement(element) {
	        var resolution = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

	        this.removeEvents();

	        this.interactionDOMElement = element;

	        this.resolution = resolution;

	        this.addEvents();
	    };

	    /**
	     * Registers all the DOM events
	     *
	     * @private
	     */


	    InteractionManager.prototype.addEvents = function addEvents() {
	        if (!this.interactionDOMElement) {
	            return;
	        }

	        core.ticker.shared.add(this.update, this, core.UPDATE_PRIORITY.INTERACTION);

	        if (window.navigator.msPointerEnabled) {
	            this.interactionDOMElement.style['-ms-content-zooming'] = 'none';
	            this.interactionDOMElement.style['-ms-touch-action'] = 'none';
	        } else if (this.supportsPointerEvents) {
	            this.interactionDOMElement.style['touch-action'] = 'none';
	        }

	        /**
	         * These events are added first, so that if pointer events are normalised, they are fired
	         * in the same order as non-normalised events. ie. pointer event 1st, mouse / touch 2nd
	         */
	        if (this.supportsPointerEvents) {
	            window.document.addEventListener('pointermove', this.onPointerMove, true);
	            this.interactionDOMElement.addEventListener('pointerdown', this.onPointerDown, true);
	            // pointerout is fired in addition to pointerup (for touch events) and pointercancel
	            // we already handle those, so for the purposes of what we do in onPointerOut, we only
	            // care about the pointerleave event
	            this.interactionDOMElement.addEventListener('pointerleave', this.onPointerOut, true);
	            this.interactionDOMElement.addEventListener('pointerover', this.onPointerOver, true);
	            window.addEventListener('pointercancel', this.onPointerCancel, true);
	            window.addEventListener('pointerup', this.onPointerUp, true);
	        } else {
	            window.document.addEventListener('mousemove', this.onPointerMove, true);
	            this.interactionDOMElement.addEventListener('mousedown', this.onPointerDown, true);
	            this.interactionDOMElement.addEventListener('mouseout', this.onPointerOut, true);
	            this.interactionDOMElement.addEventListener('mouseover', this.onPointerOver, true);
	            window.addEventListener('mouseup', this.onPointerUp, true);
	        }

	        // always look directly for touch events so that we can provide original data
	        // In a future version we should change this to being just a fallback and rely solely on
	        // PointerEvents whenever available
	        if (this.supportsTouchEvents) {
	            this.interactionDOMElement.addEventListener('touchstart', this.onPointerDown, true);
	            this.interactionDOMElement.addEventListener('touchcancel', this.onPointerCancel, true);
	            this.interactionDOMElement.addEventListener('touchend', this.onPointerUp, true);
	            this.interactionDOMElement.addEventListener('touchmove', this.onPointerMove, true);
	        }

	        this.eventsAdded = true;
	    };

	    /**
	     * Removes all the DOM events that were previously registered
	     *
	     * @private
	     */


	    InteractionManager.prototype.removeEvents = function removeEvents() {
	        if (!this.interactionDOMElement) {
	            return;
	        }

	        core.ticker.shared.remove(this.update, this);

	        if (window.navigator.msPointerEnabled) {
	            this.interactionDOMElement.style['-ms-content-zooming'] = '';
	            this.interactionDOMElement.style['-ms-touch-action'] = '';
	        } else if (this.supportsPointerEvents) {
	            this.interactionDOMElement.style['touch-action'] = '';
	        }

	        if (this.supportsPointerEvents) {
	            window.document.removeEventListener('pointermove', this.onPointerMove, true);
	            this.interactionDOMElement.removeEventListener('pointerdown', this.onPointerDown, true);
	            this.interactionDOMElement.removeEventListener('pointerleave', this.onPointerOut, true);
	            this.interactionDOMElement.removeEventListener('pointerover', this.onPointerOver, true);
	            window.removeEventListener('pointercancel', this.onPointerCancel, true);
	            window.removeEventListener('pointerup', this.onPointerUp, true);
	        } else {
	            window.document.removeEventListener('mousemove', this.onPointerMove, true);
	            this.interactionDOMElement.removeEventListener('mousedown', this.onPointerDown, true);
	            this.interactionDOMElement.removeEventListener('mouseout', this.onPointerOut, true);
	            this.interactionDOMElement.removeEventListener('mouseover', this.onPointerOver, true);
	            window.removeEventListener('mouseup', this.onPointerUp, true);
	        }

	        if (this.supportsTouchEvents) {
	            this.interactionDOMElement.removeEventListener('touchstart', this.onPointerDown, true);
	            this.interactionDOMElement.removeEventListener('touchcancel', this.onPointerCancel, true);
	            this.interactionDOMElement.removeEventListener('touchend', this.onPointerUp, true);
	            this.interactionDOMElement.removeEventListener('touchmove', this.onPointerMove, true);
	        }

	        this.interactionDOMElement = null;

	        this.eventsAdded = false;
	    };

	    /**
	     * Updates the state of interactive objects.
	     * Invoked by a throttled ticker update from {@link PIXI.ticker.shared}.
	     *
	     * @param {number} deltaTime - time delta since last tick
	     */


	    InteractionManager.prototype.update = function update(deltaTime) {
	        this._deltaTime += deltaTime;

	        if (this._deltaTime < this.interactionFrequency) {
	            return;
	        }

	        this._deltaTime = 0;

	        if (!this.interactionDOMElement) {
	            return;
	        }

	        // if the user move the mouse this check has already been done using the mouse move!
	        if (this.didMove) {
	            this.didMove = false;

	            return;
	        }

	        this.cursor = null;

	        // Resets the flag as set by a stopPropagation call. This flag is usually reset by a user interaction of any kind,
	        // but there was a scenario of a display object moving under a static mouse cursor.
	        // In this case, mouseover and mouseevents would not pass the flag test in dispatchEvent function
	        for (var k in this.activeInteractionData) {
	            // eslint-disable-next-line no-prototype-builtins
	            if (this.activeInteractionData.hasOwnProperty(k)) {
	                var interactionData = this.activeInteractionData[k];

	                if (interactionData.originalEvent && interactionData.pointerType !== 'touch') {
	                    var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, interactionData.originalEvent, interactionData);

	                    this.processInteractive(interactionEvent, this.renderer._lastObjectRendered, this.processPointerOverOut, true);
	                }
	            }
	        }

	        this.setCursorMode(this.cursor);

	        // TODO
	    };

	    /**
	     * Sets the current cursor mode, handling any callbacks or CSS style changes.
	     *
	     * @param {string} mode - cursor mode, a key from the cursorStyles dictionary
	     */


	    InteractionManager.prototype.setCursorMode = function setCursorMode(mode) {
	        mode = mode || 'default';
	        // if the mode didn't actually change, bail early
	        if (this.currentCursorMode === mode) {
	            return;
	        }
	        this.currentCursorMode = mode;
	        var style = this.cursorStyles[mode];

	        // only do things if there is a cursor style for it
	        if (style) {
	            switch (typeof style === 'undefined' ? 'undefined' : _typeof(style)) {
	                case 'string':
	                    // string styles are handled as cursor CSS
	                    this.interactionDOMElement.style.cursor = style;
	                    break;
	                case 'function':
	                    // functions are just called, and passed the cursor mode
	                    style(mode);
	                    break;
	                case 'object':
	                    // if it is an object, assume that it is a dictionary of CSS styles,
	                    // apply it to the interactionDOMElement
	                    Object.assign(this.interactionDOMElement.style, style);
	                    break;
	            }
	        } else if (typeof mode === 'string' && !Object.prototype.hasOwnProperty.call(this.cursorStyles, mode)) {
	            // if it mode is a string (not a Symbol) and cursorStyles doesn't have any entry
	            // for the mode, then assume that the dev wants it to be CSS for the cursor.
	            this.interactionDOMElement.style.cursor = mode;
	        }
	    };

	    /**
	     * Dispatches an event on the display object that was interacted with
	     *
	     * @param {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} displayObject - the display object in question
	     * @param {string} eventString - the name of the event (e.g, mousedown)
	     * @param {object} eventData - the event data object
	     * @private
	     */


	    InteractionManager.prototype.dispatchEvent = function dispatchEvent(displayObject, eventString, eventData) {
	        if (!eventData.stopped) {
	            eventData.currentTarget = displayObject;
	            eventData.type = eventString;

	            displayObject.emit(eventString, eventData);

	            if (displayObject[eventString]) {
	                displayObject[eventString](eventData);
	            }
	        }
	    };

	    /**
	     * Maps x and y coords from a DOM object and maps them correctly to the PixiJS view. The
	     * resulting value is stored in the point. This takes into account the fact that the DOM
	     * element could be scaled and positioned anywhere on the screen.
	     *
	     * @param  {PIXI.Point} point - the point that the result will be stored in
	     * @param  {number} x - the x coord of the position to map
	     * @param  {number} y - the y coord of the position to map
	     */


	    InteractionManager.prototype.mapPositionToPoint = function mapPositionToPoint(point, x, y) {
	        var rect = void 0;

	        // IE 11 fix
	        if (!this.interactionDOMElement.parentElement) {
	            rect = { x: 0, y: 0, width: 0, height: 0 };
	        } else {
	            rect = this.interactionDOMElement.getBoundingClientRect();
	        }

	        var resolutionMultiplier = navigator.isCocoonJS ? this.resolution : 1.0 / this.resolution;

	        point.x = (x - rect.left) * (this.interactionDOMElement.width / rect.width) * resolutionMultiplier;
	        point.y = (y - rect.top) * (this.interactionDOMElement.height / rect.height) * resolutionMultiplier;
	    };

	    /**
	     * This function is provides a neat way of crawling through the scene graph and running a
	     * specified function on all interactive objects it finds. It will also take care of hit
	     * testing the interactive objects and passes the hit across in the function.
	     *
	     * @private
	     * @param {PIXI.interaction.InteractionEvent} interactionEvent - event containing the point that
	     *  is tested for collision
	     * @param {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} displayObject - the displayObject
	     *  that will be hit test (recursively crawls its children)
	     * @param {Function} [func] - the function that will be called on each interactive object. The
	     *  interactionEvent, displayObject and hit will be passed to the function
	     * @param {boolean} [hitTest] - this indicates if the objects inside should be hit test against the point
	     * @param {boolean} [interactive] - Whether the displayObject is interactive
	     * @return {boolean} returns true if the displayObject hit the point
	     */


	    InteractionManager.prototype.processInteractive = function processInteractive(interactionEvent, displayObject, func, hitTest, interactive) {
	        if (!displayObject || !displayObject.visible) {
	            return false;
	        }

	        var point = interactionEvent.data.global;

	        // Took a little while to rework this function correctly! But now it is done and nice and optimised. ^_^
	        //
	        // This function will now loop through all objects and then only hit test the objects it HAS
	        // to, not all of them. MUCH faster..
	        // An object will be hit test if the following is true:
	        //
	        // 1: It is interactive.
	        // 2: It belongs to a parent that is interactive AND one of the parents children have not already been hit.
	        //
	        // As another little optimisation once an interactive object has been hit we can carry on
	        // through the scenegraph, but we know that there will be no more hits! So we can avoid extra hit tests
	        // A final optimisation is that an object is not hit test directly if a child has already been hit.

	        interactive = displayObject.interactive || interactive;

	        var hit = false;
	        var interactiveParent = interactive;

	        // Flag here can set to false if the event is outside the parents hitArea or mask
	        var hitTestChildren = true;

	        // If there is a hitArea, no need to test against anything else if the pointer is not within the hitArea
	        // There is also no longer a need to hitTest children.
	        if (displayObject.hitArea) {
	            if (hitTest) {
	                displayObject.worldTransform.applyInverse(point, this._tempPoint);
	                if (!displayObject.hitArea.contains(this._tempPoint.x, this._tempPoint.y)) {
	                    hitTest = false;
	                    hitTestChildren = false;
	                } else {
	                    hit = true;
	                }
	            }
	            interactiveParent = false;
	        }
	        // If there is a mask, no need to test against anything else if the pointer is not within the mask
	        else if (displayObject._mask) {
	                if (hitTest) {
	                    if (!displayObject._mask.containsPoint(point)) {
	                        hitTest = false;
	                        hitTestChildren = false;
	                    }
	                }
	            }

	        // ** FREE TIP **! If an object is not interactive or has no buttons in it
	        // (such as a game scene!) set interactiveChildren to false for that displayObject.
	        // This will allow PixiJS to completely ignore and bypass checking the displayObjects children.
	        if (hitTestChildren && displayObject.interactiveChildren && displayObject.children) {
	            var children = displayObject.children;

	            for (var i = children.length - 1; i >= 0; i--) {
	                var child = children[i];

	                // time to get recursive.. if this function will return if something is hit..
	                var childHit = this.processInteractive(interactionEvent, child, func, hitTest, interactiveParent);

	                if (childHit) {
	                    // its a good idea to check if a child has lost its parent.
	                    // this means it has been removed whilst looping so its best
	                    if (!child.parent) {
	                        continue;
	                    }

	                    // we no longer need to hit test any more objects in this container as we we
	                    // now know the parent has been hit
	                    interactiveParent = false;

	                    // If the child is interactive , that means that the object hit was actually
	                    // interactive and not just the child of an interactive object.
	                    // This means we no longer need to hit test anything else. We still need to run
	                    // through all objects, but we don't need to perform any hit tests.

	                    if (childHit) {
	                        if (interactionEvent.target) {
	                            hitTest = false;
	                        }
	                        hit = true;
	                    }
	                }
	            }
	        }

	        // no point running this if the item is not interactive or does not have an interactive parent.
	        if (interactive) {
	            // if we are hit testing (as in we have no hit any objects yet)
	            // We also don't need to worry about hit testing if once of the displayObjects children
	            // has already been hit - but only if it was interactive, otherwise we need to keep
	            // looking for an interactive child, just in case we hit one
	            if (hitTest && !interactionEvent.target) {
	                // already tested against hitArea if it is defined
	                if (!displayObject.hitArea && displayObject.containsPoint) {
	                    if (displayObject.containsPoint(point)) {
	                        hit = true;
	                    }
	                }
	            }

	            if (displayObject.interactive) {
	                if (hit && !interactionEvent.target) {
	                    interactionEvent.target = displayObject;
	                }

	                if (func) {
	                    func(interactionEvent, displayObject, !!hit);
	                }
	            }
	        }

	        return hit;
	    };

	    /**
	     * Is called when the pointer button is pressed down on the renderer element
	     *
	     * @private
	     * @param {PointerEvent} originalEvent - The DOM event of a pointer button being pressed down
	     */


	    InteractionManager.prototype.onPointerDown = function onPointerDown(originalEvent) {
	        // if we support touch events, then only use those for touch events, not pointer events
	        if (this.supportsTouchEvents && originalEvent.pointerType === 'touch') return;

	        var events = this.normalizeToPointerData(originalEvent);

	        /**
	         * No need to prevent default on natural pointer events, as there are no side effects
	         * Normalized events, however, may have the double mousedown/touchstart issue on the native android browser,
	         * so still need to be prevented.
	         */

	        // Guaranteed that there will be at least one event in events, and all events must have the same pointer type

	        if (this.autoPreventDefault && events[0].isNormalized) {
	            originalEvent.preventDefault();
	        }

	        var eventLen = events.length;

	        for (var i = 0; i < eventLen; i++) {
	            var event = events[i];

	            var interactionData = this.getInteractionDataForPointerId(event);

	            var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, event, interactionData);

	            interactionEvent.data.originalEvent = originalEvent;

	            this.processInteractive(interactionEvent, this.renderer._lastObjectRendered, this.processPointerDown, true);

	            this.emit('pointerdown', interactionEvent);
	            if (event.pointerType === 'touch') {
	                this.emit('touchstart', interactionEvent);
	            }
	            // emit a mouse event for "pen" pointers, the way a browser would emit a fallback event
	            else if (event.pointerType === 'mouse' || event.pointerType === 'pen') {
	                    var isRightButton = event.button === 2;

	                    this.emit(isRightButton ? 'rightdown' : 'mousedown', this.eventData);
	                }
	        }
	    };

	    /**
	     * Processes the result of the pointer down check and dispatches the event if need be
	     *
	     * @private
	     * @param {PIXI.interaction.InteractionEvent} interactionEvent - The interaction event wrapping the DOM event
	     * @param {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} displayObject - The display object that was tested
	     * @param {boolean} hit - the result of the hit test on the display object
	     */


	    InteractionManager.prototype.processPointerDown = function processPointerDown(interactionEvent, displayObject, hit) {
	        var data = interactionEvent.data;
	        var id = interactionEvent.data.identifier;

	        if (hit) {
	            if (!displayObject.trackedPointers[id]) {
	                displayObject.trackedPointers[id] = new _InteractionTrackingData2.default(id);
	            }
	            this.dispatchEvent(displayObject, 'pointerdown', interactionEvent);

	            if (data.pointerType === 'touch') {
	                this.dispatchEvent(displayObject, 'touchstart', interactionEvent);
	            } else if (data.pointerType === 'mouse' || data.pointerType === 'pen') {
	                var isRightButton = data.button === 2;

	                if (isRightButton) {
	                    displayObject.trackedPointers[id].rightDown = true;
	                } else {
	                    displayObject.trackedPointers[id].leftDown = true;
	                }

	                this.dispatchEvent(displayObject, isRightButton ? 'rightdown' : 'mousedown', interactionEvent);
	            }
	        }
	    };

	    /**
	     * Is called when the pointer button is released on the renderer element
	     *
	     * @private
	     * @param {PointerEvent} originalEvent - The DOM event of a pointer button being released
	     * @param {boolean} cancelled - true if the pointer is cancelled
	     * @param {Function} func - Function passed to {@link processInteractive}
	     */


	    InteractionManager.prototype.onPointerComplete = function onPointerComplete(originalEvent, cancelled, func) {
	        var events = this.normalizeToPointerData(originalEvent);

	        var eventLen = events.length;

	        // if the event wasn't targeting our canvas, then consider it to be pointerupoutside
	        // in all cases (unless it was a pointercancel)
	        var eventAppend = originalEvent.target !== this.interactionDOMElement ? 'outside' : '';

	        for (var i = 0; i < eventLen; i++) {
	            var event = events[i];

	            var interactionData = this.getInteractionDataForPointerId(event);

	            var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, event, interactionData);

	            interactionEvent.data.originalEvent = originalEvent;

	            // perform hit testing for events targeting our canvas or cancel events
	            this.processInteractive(interactionEvent, this.renderer._lastObjectRendered, func, cancelled || !eventAppend);

	            this.emit(cancelled ? 'pointercancel' : 'pointerup' + eventAppend, interactionEvent);

	            if (event.pointerType === 'mouse' || event.pointerType === 'pen') {
	                var isRightButton = event.button === 2;

	                this.emit(isRightButton ? 'rightup' + eventAppend : 'mouseup' + eventAppend, interactionEvent);
	            } else if (event.pointerType === 'touch') {
	                this.emit(cancelled ? 'touchcancel' : 'touchend' + eventAppend, interactionEvent);
	                this.releaseInteractionDataForPointerId(event.pointerId, interactionData);
	            }
	        }
	    };

	    /**
	     * Is called when the pointer button is cancelled
	     *
	     * @private
	     * @param {PointerEvent} event - The DOM event of a pointer button being released
	     */


	    InteractionManager.prototype.onPointerCancel = function onPointerCancel(event) {
	        // if we support touch events, then only use those for touch events, not pointer events
	        if (this.supportsTouchEvents && event.pointerType === 'touch') return;

	        this.onPointerComplete(event, true, this.processPointerCancel);
	    };

	    /**
	     * Processes the result of the pointer cancel check and dispatches the event if need be
	     *
	     * @private
	     * @param {PIXI.interaction.InteractionEvent} interactionEvent - The interaction event wrapping the DOM event
	     * @param {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} displayObject - The display object that was tested
	     */


	    InteractionManager.prototype.processPointerCancel = function processPointerCancel(interactionEvent, displayObject) {
	        var data = interactionEvent.data;

	        var id = interactionEvent.data.identifier;

	        if (displayObject.trackedPointers[id] !== undefined) {
	            delete displayObject.trackedPointers[id];
	            this.dispatchEvent(displayObject, 'pointercancel', interactionEvent);

	            if (data.pointerType === 'touch') {
	                this.dispatchEvent(displayObject, 'touchcancel', interactionEvent);
	            }
	        }
	    };

	    /**
	     * Is called when the pointer button is released on the renderer element
	     *
	     * @private
	     * @param {PointerEvent} event - The DOM event of a pointer button being released
	     */


	    InteractionManager.prototype.onPointerUp = function onPointerUp(event) {
	        // if we support touch events, then only use those for touch events, not pointer events
	        if (this.supportsTouchEvents && event.pointerType === 'touch') return;

	        this.onPointerComplete(event, false, this.processPointerUp);
	    };

	    /**
	     * Processes the result of the pointer up check and dispatches the event if need be
	     *
	     * @private
	     * @param {PIXI.interaction.InteractionEvent} interactionEvent - The interaction event wrapping the DOM event
	     * @param {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} displayObject - The display object that was tested
	     * @param {boolean} hit - the result of the hit test on the display object
	     */


	    InteractionManager.prototype.processPointerUp = function processPointerUp(interactionEvent, displayObject, hit) {
	        var data = interactionEvent.data;

	        var id = interactionEvent.data.identifier;

	        var trackingData = displayObject.trackedPointers[id];

	        var isTouch = data.pointerType === 'touch';

	        var isMouse = data.pointerType === 'mouse' || data.pointerType === 'pen';
	        // need to track mouse down status in the mouse block so that we can emit
	        // event in a later block
	        var isMouseTap = false;

	        // Mouse only
	        if (isMouse) {
	            var isRightButton = data.button === 2;

	            var flags = _InteractionTrackingData2.default.FLAGS;

	            var test = isRightButton ? flags.RIGHT_DOWN : flags.LEFT_DOWN;

	            var isDown = trackingData !== undefined && trackingData.flags & test;

	            if (hit) {
	                this.dispatchEvent(displayObject, isRightButton ? 'rightup' : 'mouseup', interactionEvent);

	                if (isDown) {
	                    this.dispatchEvent(displayObject, isRightButton ? 'rightclick' : 'click', interactionEvent);
	                    // because we can confirm that the mousedown happened on this object, flag for later emit of pointertap
	                    isMouseTap = true;
	                }
	            } else if (isDown) {
	                this.dispatchEvent(displayObject, isRightButton ? 'rightupoutside' : 'mouseupoutside', interactionEvent);
	            }
	            // update the down state of the tracking data
	            if (trackingData) {
	                if (isRightButton) {
	                    trackingData.rightDown = false;
	                } else {
	                    trackingData.leftDown = false;
	                }
	            }
	        }

	        // Pointers and Touches, and Mouse
	        if (hit) {
	            this.dispatchEvent(displayObject, 'pointerup', interactionEvent);
	            if (isTouch) this.dispatchEvent(displayObject, 'touchend', interactionEvent);

	            if (trackingData) {
	                // emit pointertap if not a mouse, or if the mouse block decided it was a tap
	                if (!isMouse || isMouseTap) {
	                    this.dispatchEvent(displayObject, 'pointertap', interactionEvent);
	                }
	                if (isTouch) {
	                    this.dispatchEvent(displayObject, 'tap', interactionEvent);
	                    // touches are no longer over (if they ever were) when we get the touchend
	                    // so we should ensure that we don't keep pretending that they are
	                    trackingData.over = false;
	                }
	            }
	        } else if (trackingData) {
	            this.dispatchEvent(displayObject, 'pointerupoutside', interactionEvent);
	            if (isTouch) this.dispatchEvent(displayObject, 'touchendoutside', interactionEvent);
	        }
	        // Only remove the tracking data if there is no over/down state still associated with it
	        if (trackingData && trackingData.none) {
	            delete displayObject.trackedPointers[id];
	        }
	    };

	    /**
	     * Is called when the pointer moves across the renderer element
	     *
	     * @private
	     * @param {PointerEvent} originalEvent - The DOM event of a pointer moving
	     */


	    InteractionManager.prototype.onPointerMove = function onPointerMove(originalEvent) {
	        // if we support touch events, then only use those for touch events, not pointer events
	        if (this.supportsTouchEvents && originalEvent.pointerType === 'touch') return;

	        var events = this.normalizeToPointerData(originalEvent);

	        if (events[0].pointerType === 'mouse' || events[0].pointerType === 'pen') {
	            this.didMove = true;

	            this.cursor = null;
	        }

	        var eventLen = events.length;

	        for (var i = 0; i < eventLen; i++) {
	            var event = events[i];

	            var interactionData = this.getInteractionDataForPointerId(event);

	            var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, event, interactionData);

	            interactionEvent.data.originalEvent = originalEvent;

	            var interactive = event.pointerType === 'touch' ? this.moveWhenInside : true;

	            this.processInteractive(interactionEvent, this.renderer._lastObjectRendered, this.processPointerMove, interactive);
	            this.emit('pointermove', interactionEvent);
	            if (event.pointerType === 'touch') this.emit('touchmove', interactionEvent);
	            if (event.pointerType === 'mouse' || event.pointerType === 'pen') this.emit('mousemove', interactionEvent);
	        }

	        if (events[0].pointerType === 'mouse') {
	            this.setCursorMode(this.cursor);

	            // TODO BUG for parents interactive object (border order issue)
	        }
	    };

	    /**
	     * Processes the result of the pointer move check and dispatches the event if need be
	     *
	     * @private
	     * @param {PIXI.interaction.InteractionEvent} interactionEvent - The interaction event wrapping the DOM event
	     * @param {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} displayObject - The display object that was tested
	     * @param {boolean} hit - the result of the hit test on the display object
	     */


	    InteractionManager.prototype.processPointerMove = function processPointerMove(interactionEvent, displayObject, hit) {
	        var data = interactionEvent.data;

	        var isTouch = data.pointerType === 'touch';

	        var isMouse = data.pointerType === 'mouse' || data.pointerType === 'pen';

	        if (isMouse) {
	            this.processPointerOverOut(interactionEvent, displayObject, hit);
	        }

	        if (!this.moveWhenInside || hit) {
	            this.dispatchEvent(displayObject, 'pointermove', interactionEvent);
	            if (isTouch) this.dispatchEvent(displayObject, 'touchmove', interactionEvent);
	            if (isMouse) this.dispatchEvent(displayObject, 'mousemove', interactionEvent);
	        }
	    };

	    /**
	     * Is called when the pointer is moved out of the renderer element
	     *
	     * @private
	     * @param {PointerEvent} originalEvent - The DOM event of a pointer being moved out
	     */


	    InteractionManager.prototype.onPointerOut = function onPointerOut(originalEvent) {
	        // if we support touch events, then only use those for touch events, not pointer events
	        if (this.supportsTouchEvents && originalEvent.pointerType === 'touch') return;

	        var events = this.normalizeToPointerData(originalEvent);

	        // Only mouse and pointer can call onPointerOut, so events will always be length 1
	        var event = events[0];

	        if (event.pointerType === 'mouse') {
	            this.mouseOverRenderer = false;
	            this.setCursorMode(null);
	        }

	        var interactionData = this.getInteractionDataForPointerId(event);

	        var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, event, interactionData);

	        interactionEvent.data.originalEvent = event;

	        this.processInteractive(interactionEvent, this.renderer._lastObjectRendered, this.processPointerOverOut, false);

	        this.emit('pointerout', interactionEvent);
	        if (event.pointerType === 'mouse' || event.pointerType === 'pen') {
	            this.emit('mouseout', interactionEvent);
	        } else {
	            // we can get touchleave events after touchend, so we want to make sure we don't
	            // introduce memory leaks
	            this.releaseInteractionDataForPointerId(interactionData.identifier);
	        }
	    };

	    /**
	     * Processes the result of the pointer over/out check and dispatches the event if need be
	     *
	     * @private
	     * @param {PIXI.interaction.InteractionEvent} interactionEvent - The interaction event wrapping the DOM event
	     * @param {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} displayObject - The display object that was tested
	     * @param {boolean} hit - the result of the hit test on the display object
	     */


	    InteractionManager.prototype.processPointerOverOut = function processPointerOverOut(interactionEvent, displayObject, hit) {
	        var data = interactionEvent.data;

	        var id = interactionEvent.data.identifier;

	        var isMouse = data.pointerType === 'mouse' || data.pointerType === 'pen';

	        var trackingData = displayObject.trackedPointers[id];

	        // if we just moused over the display object, then we need to track that state
	        if (hit && !trackingData) {
	            trackingData = displayObject.trackedPointers[id] = new _InteractionTrackingData2.default(id);
	        }

	        if (trackingData === undefined) return;

	        if (hit && this.mouseOverRenderer) {
	            if (!trackingData.over) {
	                trackingData.over = true;
	                this.dispatchEvent(displayObject, 'pointerover', interactionEvent);
	                if (isMouse) {
	                    this.dispatchEvent(displayObject, 'mouseover', interactionEvent);
	                }
	            }

	            // only change the cursor if it has not already been changed (by something deeper in the
	            // display tree)
	            if (isMouse && this.cursor === null) {
	                this.cursor = displayObject.cursor;
	            }
	        } else if (trackingData.over) {
	            trackingData.over = false;
	            this.dispatchEvent(displayObject, 'pointerout', this.eventData);
	            if (isMouse) {
	                this.dispatchEvent(displayObject, 'mouseout', interactionEvent);
	            }
	            // if there is no mouse down information for the pointer, then it is safe to delete
	            if (trackingData.none) {
	                delete displayObject.trackedPointers[id];
	            }
	        }
	    };

	    /**
	     * Is called when the pointer is moved into the renderer element
	     *
	     * @private
	     * @param {PointerEvent} originalEvent - The DOM event of a pointer button being moved into the renderer view
	     */


	    InteractionManager.prototype.onPointerOver = function onPointerOver(originalEvent) {
	        var events = this.normalizeToPointerData(originalEvent);

	        // Only mouse and pointer can call onPointerOver, so events will always be length 1
	        var event = events[0];

	        var interactionData = this.getInteractionDataForPointerId(event);

	        var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, event, interactionData);

	        interactionEvent.data.originalEvent = event;

	        if (event.pointerType === 'mouse') {
	            this.mouseOverRenderer = true;
	        }

	        this.emit('pointerover', interactionEvent);
	        if (event.pointerType === 'mouse' || event.pointerType === 'pen') {
	            this.emit('mouseover', interactionEvent);
	        }
	    };

	    /**
	     * Get InteractionData for a given pointerId. Store that data as well
	     *
	     * @private
	     * @param {PointerEvent} event - Normalized pointer event, output from normalizeToPointerData
	     * @return {PIXI.interaction.InteractionData} - Interaction data for the given pointer identifier
	     */


	    InteractionManager.prototype.getInteractionDataForPointerId = function getInteractionDataForPointerId(event) {
	        var pointerId = event.pointerId;

	        var interactionData = void 0;

	        if (pointerId === MOUSE_POINTER_ID || event.pointerType === 'mouse') {
	            interactionData = this.mouse;
	        } else if (this.activeInteractionData[pointerId]) {
	            interactionData = this.activeInteractionData[pointerId];
	        } else {
	            interactionData = this.interactionDataPool.pop() || new _InteractionData2.default();
	            interactionData.identifier = pointerId;
	            this.activeInteractionData[pointerId] = interactionData;
	        }
	        // copy properties from the event, so that we can make sure that touch/pointer specific
	        // data is available
	        interactionData.copyEvent(event);

	        return interactionData;
	    };

	    /**
	     * Return unused InteractionData to the pool, for a given pointerId
	     *
	     * @private
	     * @param {number} pointerId - Identifier from a pointer event
	     */


	    InteractionManager.prototype.releaseInteractionDataForPointerId = function releaseInteractionDataForPointerId(pointerId) {
	        var interactionData = this.activeInteractionData[pointerId];

	        if (interactionData) {
	            delete this.activeInteractionData[pointerId];
	            interactionData.reset();
	            this.interactionDataPool.push(interactionData);
	        }
	    };

	    /**
	     * Configure an InteractionEvent to wrap a DOM PointerEvent and InteractionData
	     *
	     * @private
	     * @param {PIXI.interaction.InteractionEvent} interactionEvent - The event to be configured
	     * @param {PointerEvent} pointerEvent - The DOM event that will be paired with the InteractionEvent
	     * @param {PIXI.interaction.InteractionData} interactionData - The InteractionData that will be paired
	     *        with the InteractionEvent
	     * @return {PIXI.interaction.InteractionEvent} the interaction event that was passed in
	     */


	    InteractionManager.prototype.configureInteractionEventForDOMEvent = function configureInteractionEventForDOMEvent(interactionEvent, pointerEvent, interactionData) {
	        interactionEvent.data = interactionData;

	        this.mapPositionToPoint(interactionData.global, pointerEvent.clientX, pointerEvent.clientY);

	        // This is the way InteractionManager processed touch events before the refactoring, so I've kept
	        // it here. But it doesn't make that much sense to me, since mapPositionToPoint already factors
	        // in this.resolution, so this just divides by this.resolution twice for touch events...
	        if (navigator.isCocoonJS && pointerEvent.pointerType === 'touch') {
	            interactionData.global.x = interactionData.global.x / this.resolution;
	            interactionData.global.y = interactionData.global.y / this.resolution;
	        }

	        // Not really sure why this is happening, but it's how a previous version handled things
	        if (pointerEvent.pointerType === 'touch') {
	            pointerEvent.globalX = interactionData.global.x;
	            pointerEvent.globalY = interactionData.global.y;
	        }

	        interactionData.originalEvent = pointerEvent;
	        interactionEvent.reset();

	        return interactionEvent;
	    };

	    /**
	     * Ensures that the original event object contains all data that a regular pointer event would have
	     *
	     * @private
	     * @param {TouchEvent|MouseEvent|PointerEvent} event - The original event data from a touch or mouse event
	     * @return {PointerEvent[]} An array containing a single normalized pointer event, in the case of a pointer
	     *  or mouse event, or a multiple normalized pointer events if there are multiple changed touches
	     */


	    InteractionManager.prototype.normalizeToPointerData = function normalizeToPointerData(event) {
	        var normalizedEvents = [];

	        if (this.supportsTouchEvents && event instanceof TouchEvent) {
	            for (var i = 0, li = event.changedTouches.length; i < li; i++) {
	                var touch = event.changedTouches[i];

	                if (typeof touch.button === 'undefined') touch.button = event.touches.length ? 1 : 0;
	                if (typeof touch.buttons === 'undefined') touch.buttons = event.touches.length ? 1 : 0;
	                if (typeof touch.isPrimary === 'undefined') {
	                    touch.isPrimary = event.touches.length === 1 && event.type === 'touchstart';
	                }
	                if (typeof touch.width === 'undefined') touch.width = touch.radiusX || 1;
	                if (typeof touch.height === 'undefined') touch.height = touch.radiusY || 1;
	                if (typeof touch.tiltX === 'undefined') touch.tiltX = 0;
	                if (typeof touch.tiltY === 'undefined') touch.tiltY = 0;
	                if (typeof touch.pointerType === 'undefined') touch.pointerType = 'touch';
	                if (typeof touch.pointerId === 'undefined') touch.pointerId = touch.identifier || 0;
	                if (typeof touch.pressure === 'undefined') touch.pressure = touch.force || 0.5;
	                touch.twist = 0;
	                touch.tangentialPressure = 0;
	                // TODO: Remove these, as layerX/Y is not a standard, is deprecated, has uneven
	                // support, and the fill ins are not quite the same
	                // offsetX/Y might be okay, but is not the same as clientX/Y when the canvas's top
	                // left is not 0,0 on the page
	                if (typeof touch.layerX === 'undefined') touch.layerX = touch.offsetX = touch.clientX;
	                if (typeof touch.layerY === 'undefined') touch.layerY = touch.offsetY = touch.clientY;

	                // mark the touch as normalized, just so that we know we did it
	                touch.isNormalized = true;

	                normalizedEvents.push(touch);
	            }
	        }
	        // apparently PointerEvent subclasses MouseEvent, so yay
	        else if (event instanceof MouseEvent && (!this.supportsPointerEvents || !(event instanceof window.PointerEvent))) {
	                if (typeof event.isPrimary === 'undefined') event.isPrimary = true;
	                if (typeof event.width === 'undefined') event.width = 1;
	                if (typeof event.height === 'undefined') event.height = 1;
	                if (typeof event.tiltX === 'undefined') event.tiltX = 0;
	                if (typeof event.tiltY === 'undefined') event.tiltY = 0;
	                if (typeof event.pointerType === 'undefined') event.pointerType = 'mouse';
	                if (typeof event.pointerId === 'undefined') event.pointerId = MOUSE_POINTER_ID;
	                if (typeof event.pressure === 'undefined') event.pressure = 0.5;
	                event.twist = 0;
	                event.tangentialPressure = 0;

	                // mark the mouse event as normalized, just so that we know we did it
	                event.isNormalized = true;

	                normalizedEvents.push(event);
	            } else {
	                normalizedEvents.push(event);
	            }

	        return normalizedEvents;
	    };

	    /**
	     * Destroys the interaction manager
	     *
	     */


	    InteractionManager.prototype.destroy = function destroy() {
	        this.removeEvents();

	        this.removeAllListeners();

	        this.renderer = null;

	        this.mouse = null;

	        this.eventData = null;

	        this.interactionDOMElement = null;

	        this.onPointerDown = null;
	        this.processPointerDown = null;

	        this.onPointerUp = null;
	        this.processPointerUp = null;

	        this.onPointerCancel = null;
	        this.processPointerCancel = null;

	        this.onPointerMove = null;
	        this.processPointerMove = null;

	        this.onPointerOut = null;
	        this.processPointerOverOut = null;

	        this.onPointerOver = null;

	        this._tempPoint = null;
	    };

	    return InteractionManager;
	}(_eventemitter2.default);

	exports.default = InteractionManager;


	core.WebGLRenderer.registerPlugin('interaction', InteractionManager);
	core.CanvasRenderer.registerPlugin('interaction', InteractionManager);
	//# sourceMappingURL=InteractionManager.js.map

/***/ }),
/* 322 */
/***/ (function(module, exports) {

	"use strict";

	exports.__esModule = true;

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/**
	 * Event class that mimics native DOM events.
	 *
	 * @class
	 * @memberof PIXI.interaction
	 */
	var InteractionEvent = function () {
	  /**
	   *
	   */
	  function InteractionEvent() {
	    _classCallCheck(this, InteractionEvent);

	    /**
	     * Whether this event will continue propagating in the tree
	     *
	     * @member {boolean}
	     */
	    this.stopped = false;

	    /**
	     * The object which caused this event to be dispatched.
	     * For listener callback see {@link PIXI.interaction.InteractionEvent.currentTarget}.
	     *
	     * @member {PIXI.DisplayObject}
	     */
	    this.target = null;

	    /**
	     * The object whose event listener’s callback is currently being invoked.
	     *
	     * @member {PIXI.DisplayObject}
	     */
	    this.currentTarget = null;

	    /**
	     * Type of the event
	     *
	     * @member {string}
	     */
	    this.type = null;

	    /**
	     * InteractionData related to this event
	     *
	     * @member {PIXI.interaction.InteractionData}
	     */
	    this.data = null;
	  }

	  /**
	   * Prevents event from reaching any objects other than the current object.
	   *
	   */


	  InteractionEvent.prototype.stopPropagation = function stopPropagation() {
	    this.stopped = true;
	  };

	  /**
	   * Resets the event.
	   */


	  InteractionEvent.prototype.reset = function reset() {
	    this.stopped = false;
	    this.currentTarget = null;
	    this.target = null;
	  };

	  return InteractionEvent;
	}();

	exports.default = InteractionEvent;
	//# sourceMappingURL=InteractionEvent.js.map

/***/ }),
/* 323 */
/***/ (function(module, exports) {

	"use strict";

	exports.__esModule = true;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/**
	 * DisplayObjects with the {@link PIXI.interaction.interactiveTarget} mixin use this class to track interactions
	 *
	 * @class
	 * @private
	 * @memberof PIXI.interaction
	 */
	var InteractionTrackingData = function () {
	    /**
	     * @param {number} pointerId - Unique pointer id of the event
	     */
	    function InteractionTrackingData(pointerId) {
	        _classCallCheck(this, InteractionTrackingData);

	        this._pointerId = pointerId;
	        this._flags = InteractionTrackingData.FLAGS.NONE;
	    }

	    /**
	     *
	     * @private
	     * @param {number} flag - The interaction flag to set
	     * @param {boolean} yn - Should the flag be set or unset
	     */


	    InteractionTrackingData.prototype._doSet = function _doSet(flag, yn) {
	        if (yn) {
	            this._flags = this._flags | flag;
	        } else {
	            this._flags = this._flags & ~flag;
	        }
	    };

	    /**
	     * Unique pointer id of the event
	     *
	     * @readonly
	     * @member {number}
	     */


	    _createClass(InteractionTrackingData, [{
	        key: "pointerId",
	        get: function get() {
	            return this._pointerId;
	        }

	        /**
	         * State of the tracking data, expressed as bit flags
	         *
	         * @member {number}
	         * @memberof PIXI.interaction.InteractionTrackingData#
	         */

	    }, {
	        key: "flags",
	        get: function get() {
	            return this._flags;
	        }

	        /**
	         * Set the flags for the tracking data
	         *
	         * @param {number} flags - Flags to set
	         */
	        ,
	        set: function set(flags) {
	            this._flags = flags;
	        }

	        /**
	         * Is the tracked event inactive (not over or down)?
	         *
	         * @member {number}
	         * @memberof PIXI.interaction.InteractionTrackingData#
	         */

	    }, {
	        key: "none",
	        get: function get() {
	            return this._flags === this.constructor.FLAGS.NONE;
	        }

	        /**
	         * Is the tracked event over the DisplayObject?
	         *
	         * @member {boolean}
	         * @memberof PIXI.interaction.InteractionTrackingData#
	         */

	    }, {
	        key: "over",
	        get: function get() {
	            return (this._flags & this.constructor.FLAGS.OVER) !== 0;
	        }

	        /**
	         * Set the over flag
	         *
	         * @param {boolean} yn - Is the event over?
	         */
	        ,
	        set: function set(yn) {
	            this._doSet(this.constructor.FLAGS.OVER, yn);
	        }

	        /**
	         * Did the right mouse button come down in the DisplayObject?
	         *
	         * @member {boolean}
	         * @memberof PIXI.interaction.InteractionTrackingData#
	         */

	    }, {
	        key: "rightDown",
	        get: function get() {
	            return (this._flags & this.constructor.FLAGS.RIGHT_DOWN) !== 0;
	        }

	        /**
	         * Set the right down flag
	         *
	         * @param {boolean} yn - Is the right mouse button down?
	         */
	        ,
	        set: function set(yn) {
	            this._doSet(this.constructor.FLAGS.RIGHT_DOWN, yn);
	        }

	        /**
	         * Did the left mouse button come down in the DisplayObject?
	         *
	         * @member {boolean}
	         * @memberof PIXI.interaction.InteractionTrackingData#
	         */

	    }, {
	        key: "leftDown",
	        get: function get() {
	            return (this._flags & this.constructor.FLAGS.LEFT_DOWN) !== 0;
	        }

	        /**
	         * Set the left down flag
	         *
	         * @param {boolean} yn - Is the left mouse button down?
	         */
	        ,
	        set: function set(yn) {
	            this._doSet(this.constructor.FLAGS.LEFT_DOWN, yn);
	        }
	    }]);

	    return InteractionTrackingData;
	}();

	exports.default = InteractionTrackingData;


	InteractionTrackingData.FLAGS = Object.freeze({
	    NONE: 0,
	    OVER: 1 << 0,
	    LEFT_DOWN: 1 << 1,
	    RIGHT_DOWN: 1 << 2
	});
	//# sourceMappingURL=InteractionTrackingData.js.map

/***/ }),
/* 324 */
/***/ (function(module, exports) {

	'use strict';

	exports.__esModule = true;
	/**
	 * Default property values of interactive objects
	 * Used by {@link PIXI.interaction.InteractionManager} to automatically give all DisplayObjects these properties
	 *
	 * @private
	 * @name interactiveTarget
	 * @memberof PIXI.interaction
	 * @example
	 *      function MyObject() {}
	 *
	 *      Object.assign(
	 *          core.DisplayObject.prototype,
	 *          PIXI.interaction.interactiveTarget
	 *      );
	 */
	exports.default = {

	  /**
	   * Enable interaction events for the DisplayObject. Touch, pointer and mouse
	   * events will not be emitted unless `interactive` is set to `true`.
	   *
	   * @example
	   * const sprite = new PIXI.Sprite(texture);
	   * sprite.interactive = true;
	   * sprite.on('tap', (event) => {
	   *    //handle event
	   * });
	   * @member {boolean}
	   * @memberof PIXI.DisplayObject#
	   */
	  interactive: false,

	  /**
	   * Determines if the children to the displayObject can be clicked/touched
	   * Setting this to false allows PixiJS to bypass a recursive `hitTest` function
	   *
	   * @member {boolean}
	   * @memberof PIXI.Container#
	   */
	  interactiveChildren: true,

	  /**
	   * Interaction shape. Children will be hit first, then this shape will be checked.
	   * Setting this will cause this shape to be checked in hit tests rather than the displayObject's bounds.
	   *
	   * @example
	   * const sprite = new PIXI.Sprite(texture);
	   * sprite.interactive = true;
	   * sprite.hitArea = new PIXI.Rectangle(0, 0, 100, 100);
	   * @member {PIXI.Rectangle|PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.RoundedRectangle}
	   * @memberof PIXI.DisplayObject#
	   */
	  hitArea: null,

	  /**
	   * If enabled, the mouse cursor use the pointer behavior when hovered over the displayObject if it is interactive
	   * Setting this changes the 'cursor' property to `'pointer'`.
	   *
	   * @example
	   * const sprite = new PIXI.Sprite(texture);
	   * sprite.interactive = true;
	   * sprite.buttonMode = true;
	   * @member {boolean}
	   * @memberof PIXI.DisplayObject#
	   */
	  get buttonMode() {
	    return this.cursor === 'pointer';
	  },
	  set buttonMode(value) {
	    if (value) {
	      this.cursor = 'pointer';
	    } else if (this.cursor === 'pointer') {
	      this.cursor = null;
	    }
	  },

	  /**
	   * This defines what cursor mode is used when the mouse cursor
	   * is hovered over the displayObject.
	   *
	   * @example
	   * const sprite = new PIXI.Sprite(texture);
	   * sprite.interactive = true;
	   * sprite.cursor = 'wait';
	   * @see https://developer.mozilla.org/en/docs/Web/CSS/cursor
	   *
	   * @member {string}
	   * @memberof PIXI.DisplayObject#
	   */
	  cursor: null,

	  /**
	   * Internal set of all active pointers, by identifier
	   *
	   * @member {Map<number, InteractionTrackingData>}
	   * @memberof PIXI.DisplayObject#
	   * @private
	   */
	  get trackedPointers() {
	    if (this._trackedPointers === undefined) this._trackedPointers = {};

	    return this._trackedPointers;
	  },

	  /**
	   * Map of all tracked pointers, by identifier. Use trackedPointers to access.
	   *
	   * @private
	   * @type {Map<number, InteractionTrackingData>}
	   */
	  _trackedPointers: undefined
	};
	//# sourceMappingURL=interactiveTarget.js.map

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;
	exports.shared = exports.Resource = exports.textureParser = exports.getResourcePath = exports.spritesheetParser = exports.parseBitmapFontData = exports.bitmapFontParser = exports.Loader = undefined;

	var _bitmapFontParser = __webpack_require__(326);

	Object.defineProperty(exports, 'bitmapFontParser', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_bitmapFontParser).default;
	    }
	});
	Object.defineProperty(exports, 'parseBitmapFontData', {
	    enumerable: true,
	    get: function get() {
	        return _bitmapFontParser.parse;
	    }
	});

	var _spritesheetParser = __webpack_require__(334);

	Object.defineProperty(exports, 'spritesheetParser', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_spritesheetParser).default;
	    }
	});
	Object.defineProperty(exports, 'getResourcePath', {
	    enumerable: true,
	    get: function get() {
	        return _spritesheetParser.getResourcePath;
	    }
	});

	var _textureParser = __webpack_require__(335);

	Object.defineProperty(exports, 'textureParser', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_textureParser).default;
	    }
	});

	var _resourceLoader = __webpack_require__(327);

	Object.defineProperty(exports, 'Resource', {
	    enumerable: true,
	    get: function get() {
	        return _resourceLoader.Resource;
	    }
	});

	var _Application = __webpack_require__(290);

	var _Application2 = _interopRequireDefault(_Application);

	var _loader = __webpack_require__(336);

	var _loader2 = _interopRequireDefault(_loader);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/**
	 * This namespace contains APIs which extends the {@link https://github.com/englercj/resource-loader resource-loader} module
	 * for loading assets, data, and other resources dynamically.
	 * @example
	 * const loader = new PIXI.loaders.Loader();
	 * loader.add('bunny', 'data/bunny.png')
	 *       .add('spaceship', 'assets/spritesheet.json');
	 * loader.load((loader, resources) => {
	 *    // resources.bunny
	 *    // resources.spaceship
	 * });
	 * @namespace PIXI.loaders
	 */
	exports.Loader = _loader2.default;


	/**
	 * A premade instance of the loader that can be used to load resources.
	 * @name shared
	 * @memberof PIXI.loaders
	 * @type {PIXI.loaders.Loader}
	 */
	var shared = new _loader2.default();

	shared.destroy = function () {
	    // protect destroying shared loader
	};

	exports.shared = shared;

	// Mixin the loader construction

	var AppPrototype = _Application2.default.prototype;

	AppPrototype._loader = null;

	/**
	 * Loader instance to help with asset loading.
	 * @name PIXI.Application#loader
	 * @type {PIXI.loaders.Loader}
	 */
	Object.defineProperty(AppPrototype, 'loader', {
	    get: function get() {
	        if (!this._loader) {
	            var sharedLoader = this._options.sharedLoader;

	            this._loader = sharedLoader ? shared : new _loader2.default();
	        }

	        return this._loader;
	    }
	});

	// Override the destroy function
	// making sure to destroy the current Loader
	AppPrototype._parentDestroy = AppPrototype.destroy;
	AppPrototype.destroy = function destroy(removeView, stageOptions) {
	    if (this._loader) {
	        this._loader.destroy();
	        this._loader = null;
	    }
	    this._parentDestroy(removeView, stageOptions);
	};
	//# sourceMappingURL=index.js.map

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;
	exports.parse = parse;

	exports.default = function () {
	    return function bitmapFontParser(resource, next) {
	        // skip if no data or not xml data
	        if (!resource.data || resource.type !== _resourceLoader.Resource.TYPE.XML) {
	            next();

	            return;
	        }

	        // skip if not bitmap font data, using some silly duck-typing
	        if (resource.data.getElementsByTagName('page').length === 0 || resource.data.getElementsByTagName('info').length === 0 || resource.data.getElementsByTagName('info')[0].getAttribute('face') === null) {
	            next();

	            return;
	        }

	        var xmlUrl = !resource.isDataUrl ? path.dirname(resource.url) : '';

	        if (resource.isDataUrl) {
	            if (xmlUrl === '.') {
	                xmlUrl = '';
	            }

	            if (this.baseUrl && xmlUrl) {
	                // if baseurl has a trailing slash then add one to xmlUrl so the replace works below
	                if (this.baseUrl.charAt(this.baseUrl.length - 1) === '/') {
	                    xmlUrl += '/';
	                }
	            }
	        }

	        // remove baseUrl from xmlUrl
	        xmlUrl = xmlUrl.replace(this.baseUrl, '');

	        // if there is an xmlUrl now, it needs a trailing slash. Ensure that it does if the string isn't empty.
	        if (xmlUrl && xmlUrl.charAt(xmlUrl.length - 1) !== '/') {
	            xmlUrl += '/';
	        }

	        var pages = resource.data.getElementsByTagName('page');
	        var textures = {};

	        // Handle completed, when the number of textures
	        // load is the same number as references in the fnt file
	        var completed = function completed(page) {
	            textures[page.metadata.pageFile] = page.texture;

	            if (Object.keys(textures).length === pages.length) {
	                parse(resource, textures);
	                next();
	            }
	        };

	        for (var i = 0; i < pages.length; ++i) {
	            var pageFile = pages[i].getAttribute('file');
	            var url = xmlUrl + pageFile;
	            var exists = false;

	            // incase the image is loaded outside
	            // using the same loader, resource will be available
	            for (var name in this.resources) {
	                var bitmapResource = this.resources[name];

	                if (bitmapResource.url === url) {
	                    bitmapResource.metadata.pageFile = pageFile;
	                    if (bitmapResource.texture) {
	                        completed(bitmapResource);
	                    } else {
	                        bitmapResource.onAfterMiddleware.add(completed);
	                    }
	                    exists = true;
	                    break;
	                }
	            }

	            // texture is not loaded, we'll attempt to add
	            // it to the load and add the texture to the list
	            if (!exists) {
	                // Standard loading options for images
	                var options = {
	                    crossOrigin: resource.crossOrigin,
	                    loadType: _resourceLoader.Resource.LOAD_TYPE.IMAGE,
	                    metadata: Object.assign({ pageFile: pageFile }, resource.metadata.imageMetadata),
	                    parentResource: resource
	                };

	                this.add(url, options, completed);
	            }
	        }
	    };
	};

	var _path = __webpack_require__(252);

	var path = _interopRequireWildcard(_path);

	var _resourceLoader = __webpack_require__(327);

	var _extras = __webpack_require__(299);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	/**
	 * Register a BitmapText font from loader resource.
	 *
	 * @function parseBitmapFontData
	 * @memberof PIXI.loaders
	 * @param {PIXI.loaders.Resource} resource - Loader resource.
	 * @param {PIXI.Texture|PIXI.Texture[]} textures - List of textures for each page.
	 */
	function parse(resource, textures) {
	    resource.bitmapFont = _extras.BitmapText.registerFont(resource.data, textures);
	}
	//# sourceMappingURL=bitmapFontParser.js.map

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	// import Loader from './Loader';
	// import Resource from './Resource';
	// import * as async from './async';
	// import * as b64 from './b64';

	/* eslint-disable no-undef */

	var Loader = __webpack_require__(328).default;
	var Resource = __webpack_require__(332).default;
	var async = __webpack_require__(331);
	var b64 = __webpack_require__(333);

	Loader.Resource = Resource;
	Loader.async = async;
	Loader.base64 = b64;

	// export manually, and also as default
	module.exports = Loader;
	// export default Loader;
	module.exports.default = Loader;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _miniSignals = __webpack_require__(329);

	var _miniSignals2 = _interopRequireDefault(_miniSignals);

	var _parseUri = __webpack_require__(330);

	var _parseUri2 = _interopRequireDefault(_parseUri);

	var _async = __webpack_require__(331);

	var async = _interopRequireWildcard(_async);

	var _Resource = __webpack_require__(332);

	var _Resource2 = _interopRequireDefault(_Resource);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	// some constants
	var MAX_PROGRESS = 100;
	var rgxExtractUrlHash = /(#[\w-]+)?$/;

	/**
	 * Manages the state and loading of multiple resources to load.
	 *
	 * @class
	 */

	var Loader = function () {
	    /**
	     * @param {string} [baseUrl=''] - The base url for all resources loaded by this loader.
	     * @param {number} [concurrency=10] - The number of resources to load concurrently.
	     */
	    function Loader() {
	        var _this = this;

	        var baseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	        var concurrency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;

	        _classCallCheck(this, Loader);

	        /**
	         * The base url for all resources loaded by this loader.
	         *
	         * @member {string}
	         */
	        this.baseUrl = baseUrl;

	        /**
	         * The progress percent of the loader going through the queue.
	         *
	         * @member {number}
	         */
	        this.progress = 0;

	        /**
	         * Loading state of the loader, true if it is currently loading resources.
	         *
	         * @member {boolean}
	         */
	        this.loading = false;

	        /**
	         * A querystring to append to every URL added to the loader.
	         *
	         * This should be a valid query string *without* the question-mark (`?`). The loader will
	         * also *not* escape values for you. Make sure to escape your parameters with
	         * [`encodeURIComponent`](https://mdn.io/encodeURIComponent) before assigning this property.
	         *
	         * @example
	         * const loader = new Loader();
	         *
	         * loader.defaultQueryString = 'user=me&password=secret';
	         *
	         * // This will request 'image.png?user=me&password=secret'
	         * loader.add('image.png').load();
	         *
	         * loader.reset();
	         *
	         * // This will request 'image.png?v=1&user=me&password=secret'
	         * loader.add('iamge.png?v=1').load();
	         */
	        this.defaultQueryString = '';

	        /**
	         * The middleware to run before loading each resource.
	         *
	         * @member {function[]}
	         */
	        this._beforeMiddleware = [];

	        /**
	         * The middleware to run after loading each resource.
	         *
	         * @member {function[]}
	         */
	        this._afterMiddleware = [];

	        /**
	         * The tracks the resources we are currently completing parsing for.
	         *
	         * @member {Resource[]}
	         */
	        this._resourcesParsing = [];

	        /**
	         * The `_loadResource` function bound with this object context.
	         *
	         * @private
	         * @member {function}
	         * @param {Resource} r - The resource to load
	         * @param {Function} d - The dequeue function
	         * @return {undefined}
	         */
	        this._boundLoadResource = function (r, d) {
	            return _this._loadResource(r, d);
	        };

	        /**
	         * The resources waiting to be loaded.
	         *
	         * @private
	         * @member {Resource[]}
	         */
	        this._queue = async.queue(this._boundLoadResource, concurrency);

	        this._queue.pause();

	        /**
	         * All the resources for this loader keyed by name.
	         *
	         * @member {object<string, Resource>}
	         */
	        this.resources = {};

	        /**
	         * Dispatched once per loaded or errored resource.
	         *
	         * The callback looks like {@link Loader.OnProgressSignal}.
	         *
	         * @member {Signal}
	         */
	        this.onProgress = new _miniSignals2.default();

	        /**
	         * Dispatched once per errored resource.
	         *
	         * The callback looks like {@link Loader.OnErrorSignal}.
	         *
	         * @member {Signal}
	         */
	        this.onError = new _miniSignals2.default();

	        /**
	         * Dispatched once per loaded resource.
	         *
	         * The callback looks like {@link Loader.OnLoadSignal}.
	         *
	         * @member {Signal}
	         */
	        this.onLoad = new _miniSignals2.default();

	        /**
	         * Dispatched when the loader begins to process the queue.
	         *
	         * The callback looks like {@link Loader.OnStartSignal}.
	         *
	         * @member {Signal}
	         */
	        this.onStart = new _miniSignals2.default();

	        /**
	         * Dispatched when the queued resources all load.
	         *
	         * The callback looks like {@link Loader.OnCompleteSignal}.
	         *
	         * @member {Signal}
	         */
	        this.onComplete = new _miniSignals2.default();

	        /**
	         * When the progress changes the loader and resource are disaptched.
	         *
	         * @memberof Loader
	         * @callback OnProgressSignal
	         * @param {Loader} loader - The loader the progress is advancing on.
	         * @param {Resource} resource - The resource that has completed or failed to cause the progress to advance.
	         */

	        /**
	         * When an error occurrs the loader and resource are disaptched.
	         *
	         * @memberof Loader
	         * @callback OnErrorSignal
	         * @param {Loader} loader - The loader the error happened in.
	         * @param {Resource} resource - The resource that caused the error.
	         */

	        /**
	         * When a load completes the loader and resource are disaptched.
	         *
	         * @memberof Loader
	         * @callback OnLoadSignal
	         * @param {Loader} loader - The loader that laoded the resource.
	         * @param {Resource} resource - The resource that has completed loading.
	         */

	        /**
	         * When the loader starts loading resources it dispatches this callback.
	         *
	         * @memberof Loader
	         * @callback OnStartSignal
	         * @param {Loader} loader - The loader that has started loading resources.
	         */

	        /**
	         * When the loader completes loading resources it dispatches this callback.
	         *
	         * @memberof Loader
	         * @callback OnCompleteSignal
	         * @param {Loader} loader - The loader that has finished loading resources.
	         */
	    }

	    /**
	     * Adds a resource (or multiple resources) to the loader queue.
	     *
	     * This function can take a wide variety of different parameters. The only thing that is always
	     * required the url to load. All the following will work:
	     *
	     * ```js
	     * loader
	     *     // normal param syntax
	     *     .add('key', 'http://...', function () {})
	     *     .add('http://...', function () {})
	     *     .add('http://...')
	     *
	     *     // object syntax
	     *     .add({
	     *         name: 'key2',
	     *         url: 'http://...'
	     *     }, function () {})
	     *     .add({
	     *         url: 'http://...'
	     *     }, function () {})
	     *     .add({
	     *         name: 'key3',
	     *         url: 'http://...'
	     *         onComplete: function () {}
	     *     })
	     *     .add({
	     *         url: 'https://...',
	     *         onComplete: function () {},
	     *         crossOrigin: true
	     *     })
	     *
	     *     // you can also pass an array of objects or urls or both
	     *     .add([
	     *         { name: 'key4', url: 'http://...', onComplete: function () {} },
	     *         { url: 'http://...', onComplete: function () {} },
	     *         'http://...'
	     *     ])
	     *
	     *     // and you can use both params and options
	     *     .add('key', 'http://...', { crossOrigin: true }, function () {})
	     *     .add('http://...', { crossOrigin: true }, function () {});
	     * ```
	     *
	     * @param {string} [name] - The name of the resource to load, if not passed the url is used.
	     * @param {string} [url] - The url for this resource, relative to the baseUrl of this loader.
	     * @param {object} [options] - The options for the load.
	     * @param {boolean} [options.crossOrigin] - Is this request cross-origin? Default is to determine automatically.
	     * @param {Resource.LOAD_TYPE} [options.loadType=Resource.LOAD_TYPE.XHR] - How should this resource be loaded?
	     * @param {Resource.XHR_RESPONSE_TYPE} [options.xhrType=Resource.XHR_RESPONSE_TYPE.DEFAULT] - How should
	     *      the data being loaded be interpreted when using XHR?
	     * @param {object} [options.metadata] - Extra configuration for middleware and the Resource object.
	     * @param {HTMLImageElement|HTMLAudioElement|HTMLVideoElement} [options.metadata.loadElement=null] - The
	     *      element to use for loading, instead of creating one.
	     * @param {boolean} [options.metadata.skipSource=false] - Skips adding source(s) to the load element. This
	     *      is useful if you want to pass in a `loadElement` that you already added load sources to.
	     * @param {function} [cb] - Function to call when this specific resource completes loading.
	     * @return {Loader} Returns itself.
	     */


	    Loader.prototype.add = function add(name, url, options, cb) {
	        // special case of an array of objects or urls
	        if (Array.isArray(name)) {
	            for (var i = 0; i < name.length; ++i) {
	                this.add(name[i]);
	            }

	            return this;
	        }

	        // if an object is passed instead of params
	        if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
	            cb = url || name.callback || name.onComplete;
	            options = name;
	            url = name.url;
	            name = name.name || name.key || name.url;
	        }

	        // case where no name is passed shift all args over by one.
	        if (typeof url !== 'string') {
	            cb = options;
	            options = url;
	            url = name;
	        }

	        // now that we shifted make sure we have a proper url.
	        if (typeof url !== 'string') {
	            throw new Error('No url passed to add resource to loader.');
	        }

	        // options are optional so people might pass a function and no options
	        if (typeof options === 'function') {
	            cb = options;
	            options = null;
	        }

	        // if loading already you can only add resources that have a parent.
	        if (this.loading && (!options || !options.parentResource)) {
	            throw new Error('Cannot add resources while the loader is running.');
	        }

	        // check if resource already exists.
	        if (this.resources[name]) {
	            throw new Error('Resource named "' + name + '" already exists.');
	        }

	        // add base url if this isn't an absolute url
	        url = this._prepareUrl(url);

	        // create the store the resource
	        this.resources[name] = new _Resource2.default(name, url, options);

	        if (typeof cb === 'function') {
	            this.resources[name].onAfterMiddleware.once(cb);
	        }

	        // if actively loading, make sure to adjust progress chunks for that parent and its children
	        if (this.loading) {
	            var parent = options.parentResource;
	            var incompleteChildren = [];

	            for (var _i = 0; _i < parent.children.length; ++_i) {
	                if (!parent.children[_i].isComplete) {
	                    incompleteChildren.push(parent.children[_i]);
	                }
	            }

	            var fullChunk = parent.progressChunk * (incompleteChildren.length + 1); // +1 for parent
	            var eachChunk = fullChunk / (incompleteChildren.length + 2); // +2 for parent & new child

	            parent.children.push(this.resources[name]);
	            parent.progressChunk = eachChunk;

	            for (var _i2 = 0; _i2 < incompleteChildren.length; ++_i2) {
	                incompleteChildren[_i2].progressChunk = eachChunk;
	            }

	            this.resources[name].progressChunk = eachChunk;
	        }

	        // add the resource to the queue
	        this._queue.push(this.resources[name]);

	        return this;
	    };

	    /**
	     * Sets up a middleware function that will run *before* the
	     * resource is loaded.
	     *
	     * @method before
	     * @param {function} fn - The middleware function to register.
	     * @return {Loader} Returns itself.
	     */


	    Loader.prototype.pre = function pre(fn) {
	        this._beforeMiddleware.push(fn);

	        return this;
	    };

	    /**
	     * Sets up a middleware function that will run *after* the
	     * resource is loaded.
	     *
	     * @alias use
	     * @method after
	     * @param {function} fn - The middleware function to register.
	     * @return {Loader} Returns itself.
	     */


	    Loader.prototype.use = function use(fn) {
	        this._afterMiddleware.push(fn);

	        return this;
	    };

	    /**
	     * Resets the queue of the loader to prepare for a new load.
	     *
	     * @return {Loader} Returns itself.
	     */


	    Loader.prototype.reset = function reset() {
	        this.progress = 0;
	        this.loading = false;

	        this._queue.kill();
	        this._queue.pause();

	        // abort all resource loads
	        for (var k in this.resources) {
	            var res = this.resources[k];

	            if (res._onLoadBinding) {
	                res._onLoadBinding.detach();
	            }

	            if (res.isLoading) {
	                res.abort();
	            }
	        }

	        this.resources = {};

	        return this;
	    };

	    /**
	     * Starts loading the queued resources.
	     *
	     * @param {function} [cb] - Optional callback that will be bound to the `complete` event.
	     * @return {Loader} Returns itself.
	     */


	    Loader.prototype.load = function load(cb) {
	        // register complete callback if they pass one
	        if (typeof cb === 'function') {
	            this.onComplete.once(cb);
	        }

	        // if the queue has already started we are done here
	        if (this.loading) {
	            return this;
	        }

	        if (this._queue.idle()) {
	            this._onStart();
	            this._onComplete();
	        } else {
	            // distribute progress chunks
	            var numTasks = this._queue._tasks.length;
	            var chunk = 100 / numTasks;

	            for (var i = 0; i < this._queue._tasks.length; ++i) {
	                this._queue._tasks[i].data.progressChunk = chunk;
	            }

	            // notify we are starting
	            this._onStart();

	            // start loading
	            this._queue.resume();
	        }

	        return this;
	    };

	    /**
	     * The number of resources to load concurrently.
	     *
	     * @member {number}
	     * @default 10
	     */


	    /**
	     * Prepares a url for usage based on the configuration of this object
	     *
	     * @private
	     * @param {string} url - The url to prepare.
	     * @return {string} The prepared url.
	     */
	    Loader.prototype._prepareUrl = function _prepareUrl(url) {
	        var parsedUrl = (0, _parseUri2.default)(url, { strictMode: true });
	        var result = void 0;

	        // absolute url, just use it as is.
	        if (parsedUrl.protocol || !parsedUrl.path || url.indexOf('//') === 0) {
	            result = url;
	        }
	        // if baseUrl doesn't end in slash and url doesn't start with slash, then add a slash inbetween
	        else if (this.baseUrl.length && this.baseUrl.lastIndexOf('/') !== this.baseUrl.length - 1 && url.charAt(0) !== '/') {
	                result = this.baseUrl + '/' + url;
	            } else {
	                result = this.baseUrl + url;
	            }

	        // if we need to add a default querystring, there is a bit more work
	        if (this.defaultQueryString) {
	            var hash = rgxExtractUrlHash.exec(result)[0];

	            result = result.substr(0, result.length - hash.length);

	            if (result.indexOf('?') !== -1) {
	                result += '&' + this.defaultQueryString;
	            } else {
	                result += '?' + this.defaultQueryString;
	            }

	            result += hash;
	        }

	        return result;
	    };

	    /**
	     * Loads a single resource.
	     *
	     * @private
	     * @param {Resource} resource - The resource to load.
	     * @param {function} dequeue - The function to call when we need to dequeue this item.
	     */


	    Loader.prototype._loadResource = function _loadResource(resource, dequeue) {
	        var _this2 = this;

	        resource._dequeue = dequeue;

	        // run before middleware
	        async.eachSeries(this._beforeMiddleware, function (fn, next) {
	            fn.call(_this2, resource, function () {
	                // if the before middleware marks the resource as complete,
	                // break and don't process any more before middleware
	                next(resource.isComplete ? {} : null);
	            });
	        }, function () {
	            if (resource.isComplete) {
	                _this2._onLoad(resource);
	            } else {
	                resource._onLoadBinding = resource.onComplete.once(_this2._onLoad, _this2);
	                resource.load();
	            }
	        }, true);
	    };

	    /**
	     * Called once loading has started.
	     *
	     * @private
	     */


	    Loader.prototype._onStart = function _onStart() {
	        this.progress = 0;
	        this.loading = true;
	        this.onStart.dispatch(this);
	    };

	    /**
	     * Called once each resource has loaded.
	     *
	     * @private
	     */


	    Loader.prototype._onComplete = function _onComplete() {
	        this.progress = MAX_PROGRESS;
	        this.loading = false;
	        this.onComplete.dispatch(this, this.resources);
	    };

	    /**
	     * Called each time a resources is loaded.
	     *
	     * @private
	     * @param {Resource} resource - The resource that was loaded
	     */


	    Loader.prototype._onLoad = function _onLoad(resource) {
	        var _this3 = this;

	        resource._onLoadBinding = null;

	        // remove this resource from the async queue, and add it to our list of resources that are being parsed
	        this._resourcesParsing.push(resource);
	        resource._dequeue();

	        // run all the after middleware for this resource
	        async.eachSeries(this._afterMiddleware, function (fn, next) {
	            fn.call(_this3, resource, next);
	        }, function () {
	            resource.onAfterMiddleware.dispatch(resource);

	            _this3.progress += resource.progressChunk;
	            _this3.onProgress.dispatch(_this3, resource);

	            if (resource.error) {
	                _this3.onError.dispatch(resource.error, _this3, resource);
	            } else {
	                _this3.onLoad.dispatch(_this3, resource);
	            }

	            _this3._resourcesParsing.splice(_this3._resourcesParsing.indexOf(resource), 1);

	            // do completion check
	            if (_this3._queue.idle() && _this3._resourcesParsing.length === 0) {
	                _this3._onComplete();
	            }
	        }, true);
	    };

	    _createClass(Loader, [{
	        key: 'concurrency',
	        get: function get() {
	            return this._queue.concurrency;
	        }
	        // eslint-disable-next-line require-jsdoc
	        ,
	        set: function set(concurrency) {
	            this._queue.concurrency = concurrency;
	        }
	    }]);

	    return Loader;
	}();

	exports.default = Loader;
	//# sourceMappingURL=Loader.js.map

/***/ }),
/* 329 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	  value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var MiniSignalBinding = (function () {
	  function MiniSignalBinding(fn, once, thisArg) {
	    if (once === undefined) once = false;

	    _classCallCheck(this, MiniSignalBinding);

	    this._fn = fn;
	    this._once = once;
	    this._thisArg = thisArg;
	    this._next = this._prev = this._owner = null;
	  }

	  _createClass(MiniSignalBinding, [{
	    key: 'detach',
	    value: function detach() {
	      if (this._owner === null) return false;
	      this._owner.detach(this);
	      return true;
	    }
	  }]);

	  return MiniSignalBinding;
	})();

	function _addMiniSignalBinding(self, node) {
	  if (!self._head) {
	    self._head = node;
	    self._tail = node;
	  } else {
	    self._tail._next = node;
	    node._prev = self._tail;
	    self._tail = node;
	  }

	  node._owner = self;

	  return node;
	}

	var MiniSignal = (function () {
	  function MiniSignal() {
	    _classCallCheck(this, MiniSignal);

	    this._head = this._tail = undefined;
	  }

	  _createClass(MiniSignal, [{
	    key: 'handlers',
	    value: function handlers() {
	      var exists = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];

	      var node = this._head;

	      if (exists) return !!node;

	      var ee = [];

	      while (node) {
	        ee.push(node);
	        node = node._next;
	      }

	      return ee;
	    }
	  }, {
	    key: 'has',
	    value: function has(node) {
	      if (!(node instanceof MiniSignalBinding)) {
	        throw new Error('MiniSignal#has(): First arg must be a MiniSignalBinding object.');
	      }

	      return node._owner === this;
	    }
	  }, {
	    key: 'dispatch',
	    value: function dispatch() {
	      var node = this._head;

	      if (!node) return false;

	      while (node) {
	        if (node._once) this.detach(node);
	        node._fn.apply(node._thisArg, arguments);
	        node = node._next;
	      }

	      return true;
	    }
	  }, {
	    key: 'add',
	    value: function add(fn) {
	      var thisArg = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];

	      if (typeof fn !== 'function') {
	        throw new Error('MiniSignal#add(): First arg must be a Function.');
	      }
	      return _addMiniSignalBinding(this, new MiniSignalBinding(fn, false, thisArg));
	    }
	  }, {
	    key: 'once',
	    value: function once(fn) {
	      var thisArg = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];

	      if (typeof fn !== 'function') {
	        throw new Error('MiniSignal#once(): First arg must be a Function.');
	      }
	      return _addMiniSignalBinding(this, new MiniSignalBinding(fn, true, thisArg));
	    }
	  }, {
	    key: 'detach',
	    value: function detach(node) {
	      if (!(node instanceof MiniSignalBinding)) {
	        throw new Error('MiniSignal#detach(): First arg must be a MiniSignalBinding object.');
	      }
	      if (node._owner !== this) return this;

	      if (node._prev) node._prev._next = node._next;
	      if (node._next) node._next._prev = node._prev;

	      if (node === this._head) {
	        this._head = node._next;
	        if (node._next === null) {
	          this._tail = null;
	        }
	      } else if (node === this._tail) {
	        this._tail = node._prev;
	        this._tail._next = null;
	      }

	      node._owner = null;
	      return this;
	    }
	  }, {
	    key: 'detachAll',
	    value: function detachAll() {
	      var node = this._head;
	      if (!node) return this;

	      this._head = this._tail = null;

	      while (node) {
	        node._owner = null;
	        node = node._next;
	      }
	      return this;
	    }
	  }]);

	  return MiniSignal;
	})();

	MiniSignal.MiniSignalBinding = MiniSignalBinding;

	exports['default'] = MiniSignal;
	module.exports = exports['default'];


/***/ }),
/* 330 */
/***/ (function(module, exports) {

	'use strict'

	module.exports = function parseURI (str, opts) {
	  opts = opts || {}

	  var o = {
	    key: ['source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'],
	    q: {
	      name: 'queryKey',
	      parser: /(?:^|&)([^&=]*)=?([^&]*)/g
	    },
	    parser: {
	      strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
	      loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/
	    }
	  }

	  var m = o.parser[opts.strictMode ? 'strict' : 'loose'].exec(str)
	  var uri = {}
	  var i = 14

	  while (i--) uri[o.key[i]] = m[i] || ''

	  uri[o.q.name] = {}
	  uri[o.key[12]].replace(o.q.parser, function ($0, $1, $2) {
	    if ($1) uri[o.q.name][$1] = $2
	  })

	  return uri
	}


/***/ }),
/* 331 */
/***/ (function(module, exports) {

	'use strict';

	exports.__esModule = true;
	exports.eachSeries = eachSeries;
	exports.queue = queue;
	/**
	 * Smaller version of the async library constructs.
	 *
	 */
	function _noop() {} /* empty */

	/**
	 * Iterates an array in series.
	 *
	 * @param {Array.<*>} array - Array to iterate.
	 * @param {function} iterator - Function to call for each element.
	 * @param {function} callback - Function to call when done, or on error.
	 * @param {boolean} [deferNext=false] - Break synchronous each loop by calling next with a setTimeout of 1.
	 */
	function eachSeries(array, iterator, callback, deferNext) {
	    var i = 0;
	    var len = array.length;

	    (function next(err) {
	        if (err || i === len) {
	            if (callback) {
	                callback(err);
	            }

	            return;
	        }

	        if (deferNext) {
	            setTimeout(function () {
	                iterator(array[i++], next);
	            }, 1);
	        } else {
	            iterator(array[i++], next);
	        }
	    })();
	}

	/**
	 * Ensures a function is only called once.
	 *
	 * @param {function} fn - The function to wrap.
	 * @return {function} The wrapping function.
	 */
	function onlyOnce(fn) {
	    return function onceWrapper() {
	        if (fn === null) {
	            throw new Error('Callback was already called.');
	        }

	        var callFn = fn;

	        fn = null;
	        callFn.apply(this, arguments);
	    };
	}

	/**
	 * Async queue implementation,
	 *
	 * @param {function} worker - The worker function to call for each task.
	 * @param {number} concurrency - How many workers to run in parrallel.
	 * @return {*} The async queue object.
	 */
	function queue(worker, concurrency) {
	    if (concurrency == null) {
	        // eslint-disable-line no-eq-null,eqeqeq
	        concurrency = 1;
	    } else if (concurrency === 0) {
	        throw new Error('Concurrency must not be zero');
	    }

	    var workers = 0;
	    var q = {
	        _tasks: [],
	        concurrency: concurrency,
	        saturated: _noop,
	        unsaturated: _noop,
	        buffer: concurrency / 4,
	        empty: _noop,
	        drain: _noop,
	        error: _noop,
	        started: false,
	        paused: false,
	        push: function push(data, callback) {
	            _insert(data, false, callback);
	        },
	        kill: function kill() {
	            workers = 0;
	            q.drain = _noop;
	            q.started = false;
	            q._tasks = [];
	        },
	        unshift: function unshift(data, callback) {
	            _insert(data, true, callback);
	        },
	        process: function process() {
	            while (!q.paused && workers < q.concurrency && q._tasks.length) {
	                var task = q._tasks.shift();

	                if (q._tasks.length === 0) {
	                    q.empty();
	                }

	                workers += 1;

	                if (workers === q.concurrency) {
	                    q.saturated();
	                }

	                worker(task.data, onlyOnce(_next(task)));
	            }
	        },
	        length: function length() {
	            return q._tasks.length;
	        },
	        running: function running() {
	            return workers;
	        },
	        idle: function idle() {
	            return q._tasks.length + workers === 0;
	        },
	        pause: function pause() {
	            if (q.paused === true) {
	                return;
	            }

	            q.paused = true;
	        },
	        resume: function resume() {
	            if (q.paused === false) {
	                return;
	            }

	            q.paused = false;

	            // Need to call q.process once per concurrent
	            // worker to preserve full concurrency after pause
	            for (var w = 1; w <= q.concurrency; w++) {
	                q.process();
	            }
	        }
	    };

	    function _insert(data, insertAtFront, callback) {
	        if (callback != null && typeof callback !== 'function') {
	            // eslint-disable-line no-eq-null,eqeqeq
	            throw new Error('task callback must be a function');
	        }

	        q.started = true;

	        if (data == null && q.idle()) {
	            // eslint-disable-line no-eq-null,eqeqeq
	            // call drain immediately if there are no tasks
	            setTimeout(function () {
	                return q.drain();
	            }, 1);

	            return;
	        }

	        var item = {
	            data: data,
	            callback: typeof callback === 'function' ? callback : _noop
	        };

	        if (insertAtFront) {
	            q._tasks.unshift(item);
	        } else {
	            q._tasks.push(item);
	        }

	        setTimeout(function () {
	            return q.process();
	        }, 1);
	    }

	    function _next(task) {
	        return function next() {
	            workers -= 1;

	            task.callback.apply(task, arguments);

	            if (arguments[0] != null) {
	                // eslint-disable-line no-eq-null,eqeqeq
	                q.error(arguments[0], task.data);
	            }

	            if (workers <= q.concurrency - q.buffer) {
	                q.unsaturated();
	            }

	            if (q.idle()) {
	                q.drain();
	            }

	            q.process();
	        };
	    }

	    return q;
	}
	//# sourceMappingURL=async.js.map

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _parseUri = __webpack_require__(330);

	var _parseUri2 = _interopRequireDefault(_parseUri);

	var _miniSignals = __webpack_require__(329);

	var _miniSignals2 = _interopRequireDefault(_miniSignals);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	// tests is CORS is supported in XHR, if not we need to use XDR
	var useXdr = !!(window.XDomainRequest && !('withCredentials' in new XMLHttpRequest()));
	var tempAnchor = null;

	// some status constants
	var STATUS_NONE = 0;
	var STATUS_OK = 200;
	var STATUS_EMPTY = 204;
	var STATUS_IE_BUG_EMPTY = 1223;
	var STATUS_TYPE_OK = 2;

	// noop
	function _noop() {} /* empty */

	/**
	 * Manages the state and loading of a resource and all child resources.
	 *
	 * @class
	 */

	var Resource = function () {
	    /**
	     * Sets the load type to be used for a specific extension.
	     *
	     * @static
	     * @param {string} extname - The extension to set the type for, e.g. "png" or "fnt"
	     * @param {Resource.LOAD_TYPE} loadType - The load type to set it to.
	     */
	    Resource.setExtensionLoadType = function setExtensionLoadType(extname, loadType) {
	        setExtMap(Resource._loadTypeMap, extname, loadType);
	    };

	    /**
	     * Sets the load type to be used for a specific extension.
	     *
	     * @static
	     * @param {string} extname - The extension to set the type for, e.g. "png" or "fnt"
	     * @param {Resource.XHR_RESPONSE_TYPE} xhrType - The xhr type to set it to.
	     */


	    Resource.setExtensionXhrType = function setExtensionXhrType(extname, xhrType) {
	        setExtMap(Resource._xhrTypeMap, extname, xhrType);
	    };

	    /**
	     * @param {string} name - The name of the resource to load.
	     * @param {string|string[]} url - The url for this resource, for audio/video loads you can pass
	     *      an array of sources.
	     * @param {object} [options] - The options for the load.
	     * @param {string|boolean} [options.crossOrigin] - Is this request cross-origin? Default is to
	     *      determine automatically.
	     * @param {Resource.LOAD_TYPE} [options.loadType=Resource.LOAD_TYPE.XHR] - How should this resource
	     *      be loaded?
	     * @param {Resource.XHR_RESPONSE_TYPE} [options.xhrType=Resource.XHR_RESPONSE_TYPE.DEFAULT] - How
	     *      should the data being loaded be interpreted when using XHR?
	     * @param {object} [options.metadata] - Extra configuration for middleware and the Resource object.
	     * @param {HTMLImageElement|HTMLAudioElement|HTMLVideoElement} [options.metadata.loadElement=null] - The
	     *      element to use for loading, instead of creating one.
	     * @param {boolean} [options.metadata.skipSource=false] - Skips adding source(s) to the load element. This
	     *      is useful if you want to pass in a `loadElement` that you already added load sources to.
	     * @param {string|string[]} [options.metadata.mimeType] - The mime type to use for the source element of a video/audio
	     *      elment. If the urls are an array, you can pass this as an array as well where each index is the mime type to
	     *      use for the corresponding url index.
	     */


	    function Resource(name, url, options) {
	        _classCallCheck(this, Resource);

	        if (typeof name !== 'string' || typeof url !== 'string') {
	            throw new Error('Both name and url are required for constructing a resource.');
	        }

	        options = options || {};

	        /**
	         * The state flags of this resource.
	         *
	         * @member {number}
	         */
	        this._flags = 0;

	        // set data url flag, needs to be set early for some _determineX checks to work.
	        this._setFlag(Resource.STATUS_FLAGS.DATA_URL, url.indexOf('data:') === 0);

	        /**
	         * The name of this resource.
	         *
	         * @member {string}
	         * @readonly
	         */
	        this.name = name;

	        /**
	         * The url used to load this resource.
	         *
	         * @member {string}
	         * @readonly
	         */
	        this.url = url;

	        /**
	         * The extension used to load this resource.
	         *
	         * @member {string}
	         * @readonly
	         */
	        this.extension = this._getExtension();

	        /**
	         * The data that was loaded by the resource.
	         *
	         * @member {any}
	         */
	        this.data = null;

	        /**
	         * Is this request cross-origin? If unset, determined automatically.
	         *
	         * @member {string}
	         */
	        this.crossOrigin = options.crossOrigin === true ? 'anonymous' : options.crossOrigin;

	        /**
	         * The method of loading to use for this resource.
	         *
	         * @member {Resource.LOAD_TYPE}
	         */
	        this.loadType = options.loadType || this._determineLoadType();

	        /**
	         * The type used to load the resource via XHR. If unset, determined automatically.
	         *
	         * @member {string}
	         */
	        this.xhrType = options.xhrType;

	        /**
	         * Extra info for middleware, and controlling specifics about how the resource loads.
	         *
	         * Note that if you pass in a `loadElement`, the Resource class takes ownership of it.
	         * Meaning it will modify it as it sees fit.
	         *
	         * @member {object}
	         * @property {HTMLImageElement|HTMLAudioElement|HTMLVideoElement} [loadElement=null] - The
	         *  element to use for loading, instead of creating one.
	         * @property {boolean} [skipSource=false] - Skips adding source(s) to the load element. This
	         *  is useful if you want to pass in a `loadElement` that you already added load sources
	         *  to.
	         */
	        this.metadata = options.metadata || {};

	        /**
	         * The error that occurred while loading (if any).
	         *
	         * @member {Error}
	         * @readonly
	         */
	        this.error = null;

	        /**
	         * The XHR object that was used to load this resource. This is only set
	         * when `loadType` is `Resource.LOAD_TYPE.XHR`.
	         *
	         * @member {XMLHttpRequest}
	         * @readonly
	         */
	        this.xhr = null;

	        /**
	         * The child resources this resource owns.
	         *
	         * @member {Resource[]}
	         * @readonly
	         */
	        this.children = [];

	        /**
	         * The resource type.
	         *
	         * @member {Resource.TYPE}
	         * @readonly
	         */
	        this.type = Resource.TYPE.UNKNOWN;

	        /**
	         * The progress chunk owned by this resource.
	         *
	         * @member {number}
	         * @readonly
	         */
	        this.progressChunk = 0;

	        /**
	         * The `dequeue` method that will be used a storage place for the async queue dequeue method
	         * used privately by the loader.
	         *
	         * @private
	         * @member {function}
	         */
	        this._dequeue = _noop;

	        /**
	         * Used a storage place for the on load binding used privately by the loader.
	         *
	         * @private
	         * @member {function}
	         */
	        this._onLoadBinding = null;

	        /**
	         * The `complete` function bound to this resource's context.
	         *
	         * @private
	         * @member {function}
	         */
	        this._boundComplete = this.complete.bind(this);

	        /**
	         * The `_onError` function bound to this resource's context.
	         *
	         * @private
	         * @member {function}
	         */
	        this._boundOnError = this._onError.bind(this);

	        /**
	         * The `_onProgress` function bound to this resource's context.
	         *
	         * @private
	         * @member {function}
	         */
	        this._boundOnProgress = this._onProgress.bind(this);

	        // xhr callbacks
	        this._boundXhrOnError = this._xhrOnError.bind(this);
	        this._boundXhrOnAbort = this._xhrOnAbort.bind(this);
	        this._boundXhrOnLoad = this._xhrOnLoad.bind(this);
	        this._boundXdrOnTimeout = this._xdrOnTimeout.bind(this);

	        /**
	         * Dispatched when the resource beings to load.
	         *
	         * The callback looks like {@link Resource.OnStartSignal}.
	         *
	         * @member {Signal}
	         */
	        this.onStart = new _miniSignals2.default();

	        /**
	         * Dispatched each time progress of this resource load updates.
	         * Not all resources types and loader systems can support this event
	         * so sometimes it may not be available. If the resource
	         * is being loaded on a modern browser, using XHR, and the remote server
	         * properly sets Content-Length headers, then this will be available.
	         *
	         * The callback looks like {@link Resource.OnProgressSignal}.
	         *
	         * @member {Signal}
	         */
	        this.onProgress = new _miniSignals2.default();

	        /**
	         * Dispatched once this resource has loaded, if there was an error it will
	         * be in the `error` property.
	         *
	         * The callback looks like {@link Resource.OnCompleteSignal}.
	         *
	         * @member {Signal}
	         */
	        this.onComplete = new _miniSignals2.default();

	        /**
	         * Dispatched after this resource has had all the *after* middleware run on it.
	         *
	         * The callback looks like {@link Resource.OnCompleteSignal}.
	         *
	         * @member {Signal}
	         */
	        this.onAfterMiddleware = new _miniSignals2.default();

	        /**
	         * When the resource starts to load.
	         *
	         * @memberof Resource
	         * @callback OnStartSignal
	         * @param {Resource} resource - The resource that the event happened on.
	         */

	        /**
	         * When the resource reports loading progress.
	         *
	         * @memberof Resource
	         * @callback OnProgressSignal
	         * @param {Resource} resource - The resource that the event happened on.
	         * @param {number} percentage - The progress of the load in the range [0, 1].
	         */

	        /**
	         * When the resource finishes loading.
	         *
	         * @memberof Resource
	         * @callback OnCompleteSignal
	         * @param {Resource} resource - The resource that the event happened on.
	         */
	    }

	    /**
	     * Stores whether or not this url is a data url.
	     *
	     * @member {boolean}
	     * @readonly
	     */


	    /**
	     * Marks the resource as complete.
	     *
	     */
	    Resource.prototype.complete = function complete() {
	        // TODO: Clean this up in a wrapper or something...gross....
	        if (this.data && this.data.removeEventListener) {
	            this.data.removeEventListener('error', this._boundOnError, false);
	            this.data.removeEventListener('load', this._boundComplete, false);
	            this.data.removeEventListener('progress', this._boundOnProgress, false);
	            this.data.removeEventListener('canplaythrough', this._boundComplete, false);
	        }

	        if (this.xhr) {
	            if (this.xhr.removeEventListener) {
	                this.xhr.removeEventListener('error', this._boundXhrOnError, false);
	                this.xhr.removeEventListener('abort', this._boundXhrOnAbort, false);
	                this.xhr.removeEventListener('progress', this._boundOnProgress, false);
	                this.xhr.removeEventListener('load', this._boundXhrOnLoad, false);
	            } else {
	                this.xhr.onerror = null;
	                this.xhr.ontimeout = null;
	                this.xhr.onprogress = null;
	                this.xhr.onload = null;
	            }
	        }

	        if (this.isComplete) {
	            throw new Error('Complete called again for an already completed resource.');
	        }

	        this._setFlag(Resource.STATUS_FLAGS.COMPLETE, true);
	        this._setFlag(Resource.STATUS_FLAGS.LOADING, false);

	        this.onComplete.dispatch(this);
	    };

	    /**
	     * Aborts the loading of this resource, with an optional message.
	     *
	     * @param {string} message - The message to use for the error
	     */


	    Resource.prototype.abort = function abort(message) {
	        // abort can be called multiple times, ignore subsequent calls.
	        if (this.error) {
	            return;
	        }

	        // store error
	        this.error = new Error(message);

	        // abort the actual loading
	        if (this.xhr) {
	            this.xhr.abort();
	        } else if (this.xdr) {
	            this.xdr.abort();
	        } else if (this.data) {
	            // single source
	            if (this.data.src) {
	                this.data.src = Resource.EMPTY_GIF;
	            }
	            // multi-source
	            else {
	                    while (this.data.firstChild) {
	                        this.data.removeChild(this.data.firstChild);
	                    }
	                }
	        }

	        // done now.
	        this.complete();
	    };

	    /**
	     * Kicks off loading of this resource. This method is asynchronous.
	     *
	     * @param {function} [cb] - Optional callback to call once the resource is loaded.
	     */


	    Resource.prototype.load = function load(cb) {
	        var _this = this;

	        if (this.isLoading) {
	            return;
	        }

	        if (this.isComplete) {
	            if (cb) {
	                setTimeout(function () {
	                    return cb(_this);
	                }, 1);
	            }

	            return;
	        } else if (cb) {
	            this.onComplete.once(cb);
	        }

	        this._setFlag(Resource.STATUS_FLAGS.LOADING, true);

	        this.onStart.dispatch(this);

	        // if unset, determine the value
	        if (this.crossOrigin === false || typeof this.crossOrigin !== 'string') {
	            this.crossOrigin = this._determineCrossOrigin(this.url);
	        }

	        switch (this.loadType) {
	            case Resource.LOAD_TYPE.IMAGE:
	                this.type = Resource.TYPE.IMAGE;
	                this._loadElement('image');
	                break;

	            case Resource.LOAD_TYPE.AUDIO:
	                this.type = Resource.TYPE.AUDIO;
	                this._loadSourceElement('audio');
	                break;

	            case Resource.LOAD_TYPE.VIDEO:
	                this.type = Resource.TYPE.VIDEO;
	                this._loadSourceElement('video');
	                break;

	            case Resource.LOAD_TYPE.XHR:
	            /* falls through */
	            default:
	                if (useXdr && this.crossOrigin) {
	                    this._loadXdr();
	                } else {
	                    this._loadXhr();
	                }
	                break;
	        }
	    };

	    /**
	     * Checks if the flag is set.
	     *
	     * @private
	     * @param {number} flag - The flag to check.
	     * @return {boolean} True if the flag is set.
	     */


	    Resource.prototype._hasFlag = function _hasFlag(flag) {
	        return !!(this._flags & flag);
	    };

	    /**
	     * (Un)Sets the flag.
	     *
	     * @private
	     * @param {number} flag - The flag to (un)set.
	     * @param {boolean} value - Whether to set or (un)set the flag.
	     */


	    Resource.prototype._setFlag = function _setFlag(flag, value) {
	        this._flags = value ? this._flags | flag : this._flags & ~flag;
	    };

	    /**
	     * Loads this resources using an element that has a single source,
	     * like an HTMLImageElement.
	     *
	     * @private
	     * @param {string} type - The type of element to use.
	     */


	    Resource.prototype._loadElement = function _loadElement(type) {
	        if (this.metadata.loadElement) {
	            this.data = this.metadata.loadElement;
	        } else if (type === 'image' && typeof window.Image !== 'undefined') {
	            this.data = new Image();
	        } else {
	            this.data = document.createElement(type);
	        }

	        if (this.crossOrigin) {
	            this.data.crossOrigin = this.crossOrigin;
	        }

	        if (!this.metadata.skipSource) {
	            this.data.src = this.url;
	        }

	        this.data.addEventListener('error', this._boundOnError, false);
	        this.data.addEventListener('load', this._boundComplete, false);
	        this.data.addEventListener('progress', this._boundOnProgress, false);
	    };

	    /**
	     * Loads this resources using an element that has multiple sources,
	     * like an HTMLAudioElement or HTMLVideoElement.
	     *
	     * @private
	     * @param {string} type - The type of element to use.
	     */


	    Resource.prototype._loadSourceElement = function _loadSourceElement(type) {
	        if (this.metadata.loadElement) {
	            this.data = this.metadata.loadElement;
	        } else if (type === 'audio' && typeof window.Audio !== 'undefined') {
	            this.data = new Audio();
	        } else {
	            this.data = document.createElement(type);
	        }

	        if (this.data === null) {
	            this.abort('Unsupported element: ' + type);

	            return;
	        }

	        if (!this.metadata.skipSource) {
	            // support for CocoonJS Canvas+ runtime, lacks document.createElement('source')
	            if (navigator.isCocoonJS) {
	                this.data.src = Array.isArray(this.url) ? this.url[0] : this.url;
	            } else if (Array.isArray(this.url)) {
	                var mimeTypes = this.metadata.mimeType;

	                for (var i = 0; i < this.url.length; ++i) {
	                    this.data.appendChild(this._createSource(type, this.url[i], Array.isArray(mimeTypes) ? mimeTypes[i] : mimeTypes));
	                }
	            } else {
	                var _mimeTypes = this.metadata.mimeType;

	                this.data.appendChild(this._createSource(type, this.url, Array.isArray(_mimeTypes) ? _mimeTypes[0] : _mimeTypes));
	            }
	        }

	        this.data.addEventListener('error', this._boundOnError, false);
	        this.data.addEventListener('load', this._boundComplete, false);
	        this.data.addEventListener('progress', this._boundOnProgress, false);
	        this.data.addEventListener('canplaythrough', this._boundComplete, false);

	        this.data.load();
	    };

	    /**
	     * Loads this resources using an XMLHttpRequest.
	     *
	     * @private
	     */


	    Resource.prototype._loadXhr = function _loadXhr() {
	        // if unset, determine the value
	        if (typeof this.xhrType !== 'string') {
	            this.xhrType = this._determineXhrType();
	        }

	        var xhr = this.xhr = new XMLHttpRequest();

	        // set the request type and url
	        xhr.open('GET', this.url, true);

	        // load json as text and parse it ourselves. We do this because some browsers
	        // *cough* safari *cough* can't deal with it.
	        if (this.xhrType === Resource.XHR_RESPONSE_TYPE.JSON || this.xhrType === Resource.XHR_RESPONSE_TYPE.DOCUMENT) {
	            xhr.responseType = Resource.XHR_RESPONSE_TYPE.TEXT;
	        } else {
	            xhr.responseType = this.xhrType;
	        }

	        xhr.addEventListener('error', this._boundXhrOnError, false);
	        xhr.addEventListener('abort', this._boundXhrOnAbort, false);
	        xhr.addEventListener('progress', this._boundOnProgress, false);
	        xhr.addEventListener('load', this._boundXhrOnLoad, false);

	        xhr.send();
	    };

	    /**
	     * Loads this resources using an XDomainRequest. This is here because we need to support IE9 (gross).
	     *
	     * @private
	     */


	    Resource.prototype._loadXdr = function _loadXdr() {
	        // if unset, determine the value
	        if (typeof this.xhrType !== 'string') {
	            this.xhrType = this._determineXhrType();
	        }

	        var xdr = this.xhr = new XDomainRequest();

	        // XDomainRequest has a few quirks. Occasionally it will abort requests
	        // A way to avoid this is to make sure ALL callbacks are set even if not used
	        // More info here: http://stackoverflow.com/questions/15786966/xdomainrequest-aborts-post-on-ie-9
	        xdr.timeout = 5000;

	        xdr.onerror = this._boundXhrOnError;
	        xdr.ontimeout = this._boundXdrOnTimeout;
	        xdr.onprogress = this._boundOnProgress;
	        xdr.onload = this._boundXhrOnLoad;

	        xdr.open('GET', this.url, true);

	        // Note: The xdr.send() call is wrapped in a timeout to prevent an
	        // issue with the interface where some requests are lost if multiple
	        // XDomainRequests are being sent at the same time.
	        // Some info here: https://github.com/photonstorm/phaser/issues/1248
	        setTimeout(function () {
	            return xdr.send();
	        }, 1);
	    };

	    /**
	     * Creates a source used in loading via an element.
	     *
	     * @private
	     * @param {string} type - The element type (video or audio).
	     * @param {string} url - The source URL to load from.
	     * @param {string} [mime] - The mime type of the video
	     * @return {HTMLSourceElement} The source element.
	     */


	    Resource.prototype._createSource = function _createSource(type, url, mime) {
	        if (!mime) {
	            mime = type + '/' + this._getExtension(url);
	        }

	        var source = document.createElement('source');

	        source.src = url;
	        source.type = mime;

	        return source;
	    };

	    /**
	     * Called if a load errors out.
	     *
	     * @param {Event} event - The error event from the element that emits it.
	     * @private
	     */


	    Resource.prototype._onError = function _onError(event) {
	        this.abort('Failed to load element using: ' + event.target.nodeName);
	    };

	    /**
	     * Called if a load progress event fires for xhr/xdr.
	     *
	     * @private
	     * @param {XMLHttpRequestProgressEvent|Event} event - Progress event.
	     */


	    Resource.prototype._onProgress = function _onProgress(event) {
	        if (event && event.lengthComputable) {
	            this.onProgress.dispatch(this, event.loaded / event.total);
	        }
	    };

	    /**
	     * Called if an error event fires for xhr/xdr.
	     *
	     * @private
	     * @param {XMLHttpRequestErrorEvent|Event} event - Error event.
	     */


	    Resource.prototype._xhrOnError = function _xhrOnError() {
	        var xhr = this.xhr;

	        this.abort(reqType(xhr) + ' Request failed. Status: ' + xhr.status + ', text: "' + xhr.statusText + '"');
	    };

	    /**
	     * Called if an abort event fires for xhr.
	     *
	     * @private
	     * @param {XMLHttpRequestAbortEvent} event - Abort Event
	     */


	    Resource.prototype._xhrOnAbort = function _xhrOnAbort() {
	        this.abort(reqType(this.xhr) + ' Request was aborted by the user.');
	    };

	    /**
	     * Called if a timeout event fires for xdr.
	     *
	     * @private
	     * @param {Event} event - Timeout event.
	     */


	    Resource.prototype._xdrOnTimeout = function _xdrOnTimeout() {
	        this.abort(reqType(this.xhr) + ' Request timed out.');
	    };

	    /**
	     * Called when data successfully loads from an xhr/xdr request.
	     *
	     * @private
	     * @param {XMLHttpRequestLoadEvent|Event} event - Load event
	     */


	    Resource.prototype._xhrOnLoad = function _xhrOnLoad() {
	        var xhr = this.xhr;
	        var text = '';
	        var status = typeof xhr.status === 'undefined' ? STATUS_OK : xhr.status; // XDR has no `.status`, assume 200.

	        // responseText is accessible only if responseType is '' or 'text' and on older browsers
	        if (xhr.responseType === '' || xhr.responseType === 'text' || typeof xhr.responseType === 'undefined') {
	            text = xhr.responseText;
	        }

	        // status can be 0 when using the `file://` protocol so we also check if a response is set.
	        // If it has a response, we assume 200; otherwise a 0 status code with no contents is an aborted request.
	        if (status === STATUS_NONE && (text.length > 0 || xhr.responseType === Resource.XHR_RESPONSE_TYPE.BUFFER)) {
	            status = STATUS_OK;
	        }
	        // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
	        else if (status === STATUS_IE_BUG_EMPTY) {
	                status = STATUS_EMPTY;
	            }

	        var statusType = status / 100 | 0;

	        if (statusType === STATUS_TYPE_OK) {
	            // if text, just return it
	            if (this.xhrType === Resource.XHR_RESPONSE_TYPE.TEXT) {
	                this.data = text;
	                this.type = Resource.TYPE.TEXT;
	            }
	            // if json, parse into json object
	            else if (this.xhrType === Resource.XHR_RESPONSE_TYPE.JSON) {
	                    try {
	                        this.data = JSON.parse(text);
	                        this.type = Resource.TYPE.JSON;
	                    } catch (e) {
	                        this.abort('Error trying to parse loaded json: ' + e);

	                        return;
	                    }
	                }
	                // if xml, parse into an xml document or div element
	                else if (this.xhrType === Resource.XHR_RESPONSE_TYPE.DOCUMENT) {
	                        try {
	                            if (window.DOMParser) {
	                                var domparser = new DOMParser();

	                                this.data = domparser.parseFromString(text, 'text/xml');
	                            } else {
	                                var div = document.createElement('div');

	                                div.innerHTML = text;

	                                this.data = div;
	                            }

	                            this.type = Resource.TYPE.XML;
	                        } catch (e) {
	                            this.abort('Error trying to parse loaded xml: ' + e);

	                            return;
	                        }
	                    }
	                    // other types just return the response
	                    else {
	                            this.data = xhr.response || text;
	                        }
	        } else {
	            this.abort('[' + xhr.status + '] ' + xhr.statusText + ': ' + xhr.responseURL);

	            return;
	        }

	        this.complete();
	    };

	    /**
	     * Sets the `crossOrigin` property for this resource based on if the url
	     * for this resource is cross-origin. If crossOrigin was manually set, this
	     * function does nothing.
	     *
	     * @private
	     * @param {string} url - The url to test.
	     * @param {object} [loc=window.location] - The location object to test against.
	     * @return {string} The crossOrigin value to use (or empty string for none).
	     */


	    Resource.prototype._determineCrossOrigin = function _determineCrossOrigin(url, loc) {
	        // data: and javascript: urls are considered same-origin
	        if (url.indexOf('data:') === 0) {
	            return '';
	        }

	        // default is window.location
	        loc = loc || window.location;

	        if (!tempAnchor) {
	            tempAnchor = document.createElement('a');
	        }

	        // let the browser determine the full href for the url of this resource and then
	        // parse with the node url lib, we can't use the properties of the anchor element
	        // because they don't work in IE9 :(
	        tempAnchor.href = url;
	        url = (0, _parseUri2.default)(tempAnchor.href, { strictMode: true });

	        var samePort = !url.port && loc.port === '' || url.port === loc.port;
	        var protocol = url.protocol ? url.protocol + ':' : '';

	        // if cross origin
	        if (url.host !== loc.hostname || !samePort || protocol !== loc.protocol) {
	            return 'anonymous';
	        }

	        return '';
	    };

	    /**
	     * Determines the responseType of an XHR request based on the extension of the
	     * resource being loaded.
	     *
	     * @private
	     * @return {Resource.XHR_RESPONSE_TYPE} The responseType to use.
	     */


	    Resource.prototype._determineXhrType = function _determineXhrType() {
	        return Resource._xhrTypeMap[this.extension] || Resource.XHR_RESPONSE_TYPE.TEXT;
	    };

	    /**
	     * Determines the loadType of a resource based on the extension of the
	     * resource being loaded.
	     *
	     * @private
	     * @return {Resource.LOAD_TYPE} The loadType to use.
	     */


	    Resource.prototype._determineLoadType = function _determineLoadType() {
	        return Resource._loadTypeMap[this.extension] || Resource.LOAD_TYPE.XHR;
	    };

	    /**
	     * Extracts the extension (sans '.') of the file being loaded by the resource.
	     *
	     * @private
	     * @return {string} The extension.
	     */


	    Resource.prototype._getExtension = function _getExtension() {
	        var url = this.url;
	        var ext = '';

	        if (this.isDataUrl) {
	            var slashIndex = url.indexOf('/');

	            ext = url.substring(slashIndex + 1, url.indexOf(';', slashIndex));
	        } else {
	            var queryStart = url.indexOf('?');
	            var hashStart = url.indexOf('#');
	            var index = Math.min(queryStart > -1 ? queryStart : url.length, hashStart > -1 ? hashStart : url.length);

	            url = url.substring(0, index);
	            ext = url.substring(url.lastIndexOf('.') + 1);
	        }

	        return ext.toLowerCase();
	    };

	    /**
	     * Determines the mime type of an XHR request based on the responseType of
	     * resource being loaded.
	     *
	     * @private
	     * @param {Resource.XHR_RESPONSE_TYPE} type - The type to get a mime type for.
	     * @return {string} The mime type to use.
	     */


	    Resource.prototype._getMimeFromXhrType = function _getMimeFromXhrType(type) {
	        switch (type) {
	            case Resource.XHR_RESPONSE_TYPE.BUFFER:
	                return 'application/octet-binary';

	            case Resource.XHR_RESPONSE_TYPE.BLOB:
	                return 'application/blob';

	            case Resource.XHR_RESPONSE_TYPE.DOCUMENT:
	                return 'application/xml';

	            case Resource.XHR_RESPONSE_TYPE.JSON:
	                return 'application/json';

	            case Resource.XHR_RESPONSE_TYPE.DEFAULT:
	            case Resource.XHR_RESPONSE_TYPE.TEXT:
	            /* falls through */
	            default:
	                return 'text/plain';

	        }
	    };

	    _createClass(Resource, [{
	        key: 'isDataUrl',
	        get: function get() {
	            return this._hasFlag(Resource.STATUS_FLAGS.DATA_URL);
	        }

	        /**
	         * Describes if this resource has finished loading. Is true when the resource has completely
	         * loaded.
	         *
	         * @member {boolean}
	         * @readonly
	         */

	    }, {
	        key: 'isComplete',
	        get: function get() {
	            return this._hasFlag(Resource.STATUS_FLAGS.COMPLETE);
	        }

	        /**
	         * Describes if this resource is currently loading. Is true when the resource starts loading,
	         * and is false again when complete.
	         *
	         * @member {boolean}
	         * @readonly
	         */

	    }, {
	        key: 'isLoading',
	        get: function get() {
	            return this._hasFlag(Resource.STATUS_FLAGS.LOADING);
	        }
	    }]);

	    return Resource;
	}();

	/**
	 * The types of resources a resource could represent.
	 *
	 * @static
	 * @readonly
	 * @enum {number}
	 */


	exports.default = Resource;
	Resource.STATUS_FLAGS = {
	    NONE: 0,
	    DATA_URL: 1 << 0,
	    COMPLETE: 1 << 1,
	    LOADING: 1 << 2
	};

	/**
	 * The types of resources a resource could represent.
	 *
	 * @static
	 * @readonly
	 * @enum {number}
	 */
	Resource.TYPE = {
	    UNKNOWN: 0,
	    JSON: 1,
	    XML: 2,
	    IMAGE: 3,
	    AUDIO: 4,
	    VIDEO: 5,
	    TEXT: 6
	};

	/**
	 * The types of loading a resource can use.
	 *
	 * @static
	 * @readonly
	 * @enum {number}
	 */
	Resource.LOAD_TYPE = {
	    /** Uses XMLHttpRequest to load the resource. */
	    XHR: 1,
	    /** Uses an `Image` object to load the resource. */
	    IMAGE: 2,
	    /** Uses an `Audio` object to load the resource. */
	    AUDIO: 3,
	    /** Uses a `Video` object to load the resource. */
	    VIDEO: 4
	};

	/**
	 * The XHR ready states, used internally.
	 *
	 * @static
	 * @readonly
	 * @enum {string}
	 */
	Resource.XHR_RESPONSE_TYPE = {
	    /** string */
	    DEFAULT: 'text',
	    /** ArrayBuffer */
	    BUFFER: 'arraybuffer',
	    /** Blob */
	    BLOB: 'blob',
	    /** Document */
	    DOCUMENT: 'document',
	    /** Object */
	    JSON: 'json',
	    /** String */
	    TEXT: 'text'
	};

	Resource._loadTypeMap = {
	    // images
	    gif: Resource.LOAD_TYPE.IMAGE,
	    png: Resource.LOAD_TYPE.IMAGE,
	    bmp: Resource.LOAD_TYPE.IMAGE,
	    jpg: Resource.LOAD_TYPE.IMAGE,
	    jpeg: Resource.LOAD_TYPE.IMAGE,
	    tif: Resource.LOAD_TYPE.IMAGE,
	    tiff: Resource.LOAD_TYPE.IMAGE,
	    webp: Resource.LOAD_TYPE.IMAGE,
	    tga: Resource.LOAD_TYPE.IMAGE,
	    svg: Resource.LOAD_TYPE.IMAGE,
	    'svg+xml': Resource.LOAD_TYPE.IMAGE, // for SVG data urls

	    // audio
	    mp3: Resource.LOAD_TYPE.AUDIO,
	    ogg: Resource.LOAD_TYPE.AUDIO,
	    wav: Resource.LOAD_TYPE.AUDIO,

	    // videos
	    mp4: Resource.LOAD_TYPE.VIDEO,
	    webm: Resource.LOAD_TYPE.VIDEO
	};

	Resource._xhrTypeMap = {
	    // xml
	    xhtml: Resource.XHR_RESPONSE_TYPE.DOCUMENT,
	    html: Resource.XHR_RESPONSE_TYPE.DOCUMENT,
	    htm: Resource.XHR_RESPONSE_TYPE.DOCUMENT,
	    xml: Resource.XHR_RESPONSE_TYPE.DOCUMENT,
	    tmx: Resource.XHR_RESPONSE_TYPE.DOCUMENT,
	    svg: Resource.XHR_RESPONSE_TYPE.DOCUMENT,

	    // This was added to handle Tiled Tileset XML, but .tsx is also a TypeScript React Component.
	    // Since it is way less likely for people to be loading TypeScript files instead of Tiled files,
	    // this should probably be fine.
	    tsx: Resource.XHR_RESPONSE_TYPE.DOCUMENT,

	    // images
	    gif: Resource.XHR_RESPONSE_TYPE.BLOB,
	    png: Resource.XHR_RESPONSE_TYPE.BLOB,
	    bmp: Resource.XHR_RESPONSE_TYPE.BLOB,
	    jpg: Resource.XHR_RESPONSE_TYPE.BLOB,
	    jpeg: Resource.XHR_RESPONSE_TYPE.BLOB,
	    tif: Resource.XHR_RESPONSE_TYPE.BLOB,
	    tiff: Resource.XHR_RESPONSE_TYPE.BLOB,
	    webp: Resource.XHR_RESPONSE_TYPE.BLOB,
	    tga: Resource.XHR_RESPONSE_TYPE.BLOB,

	    // json
	    json: Resource.XHR_RESPONSE_TYPE.JSON,

	    // text
	    text: Resource.XHR_RESPONSE_TYPE.TEXT,
	    txt: Resource.XHR_RESPONSE_TYPE.TEXT,

	    // fonts
	    ttf: Resource.XHR_RESPONSE_TYPE.BUFFER,
	    otf: Resource.XHR_RESPONSE_TYPE.BUFFER
	};

	// We can't set the `src` attribute to empty string, so on abort we set it to this 1px transparent gif
	Resource.EMPTY_GIF = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';

	/**
	 * Quick helper to set a value on one of the extension maps. Ensures there is no
	 * dot at the start of the extension.
	 *
	 * @ignore
	 * @param {object} map - The map to set on.
	 * @param {string} extname - The extension (or key) to set.
	 * @param {number} val - The value to set.
	 */
	function setExtMap(map, extname, val) {
	    if (extname && extname.indexOf('.') === 0) {
	        extname = extname.substring(1);
	    }

	    if (!extname) {
	        return;
	    }

	    map[extname] = val;
	}

	/**
	 * Quick helper to get string xhr type.
	 *
	 * @ignore
	 * @param {XMLHttpRequest|XDomainRequest} xhr - The request to check.
	 * @return {string} The type.
	 */
	function reqType(xhr) {
	    return xhr.toString().replace('object ', '');
	}
	//# sourceMappingURL=Resource.js.map

/***/ }),
/* 333 */
/***/ (function(module, exports) {

	'use strict';

	exports.__esModule = true;
	exports.encodeBinary = encodeBinary;
	var _keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

	function encodeBinary(input) {
	    var output = '';
	    var inx = 0;

	    while (inx < input.length) {
	        // Fill byte buffer array
	        var bytebuffer = [0, 0, 0];
	        var encodedCharIndexes = [0, 0, 0, 0];

	        for (var jnx = 0; jnx < bytebuffer.length; ++jnx) {
	            if (inx < input.length) {
	                // throw away high-order byte, as documented at:
	                // https://developer.mozilla.org/En/Using_XMLHttpRequest#Handling_binary_data
	                bytebuffer[jnx] = input.charCodeAt(inx++) & 0xff;
	            } else {
	                bytebuffer[jnx] = 0;
	            }
	        }

	        // Get each encoded character, 6 bits at a time
	        // index 1: first 6 bits
	        encodedCharIndexes[0] = bytebuffer[0] >> 2;

	        // index 2: second 6 bits (2 least significant bits from input byte 1 + 4 most significant bits from byte 2)
	        encodedCharIndexes[1] = (bytebuffer[0] & 0x3) << 4 | bytebuffer[1] >> 4;

	        // index 3: third 6 bits (4 least significant bits from input byte 2 + 2 most significant bits from byte 3)
	        encodedCharIndexes[2] = (bytebuffer[1] & 0x0f) << 2 | bytebuffer[2] >> 6;

	        // index 3: forth 6 bits (6 least significant bits from input byte 3)
	        encodedCharIndexes[3] = bytebuffer[2] & 0x3f;

	        // Determine whether padding happened, and adjust accordingly
	        var paddingBytes = inx - (input.length - 1);

	        switch (paddingBytes) {
	            case 2:
	                // Set last 2 characters to padding char
	                encodedCharIndexes[3] = 64;
	                encodedCharIndexes[2] = 64;
	                break;

	            case 1:
	                // Set last character to padding char
	                encodedCharIndexes[3] = 64;
	                break;

	            default:
	                break; // No padding - proceed
	        }

	        // Now we will grab each appropriate character out of our keystring
	        // based on our index array and append it to the output string
	        for (var _jnx = 0; _jnx < encodedCharIndexes.length; ++_jnx) {
	            output += _keyStr.charAt(encodedCharIndexes[_jnx]);
	        }
	    }

	    return output;
	}
	//# sourceMappingURL=b64.js.map

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	exports.default = function () {
	    return function spritesheetParser(resource, next) {
	        var imageResourceName = resource.name + '_image';

	        // skip if no data, its not json, it isn't spritesheet data, or the image resource already exists
	        if (!resource.data || resource.type !== _resourceLoader.Resource.TYPE.JSON || !resource.data.frames || this.resources[imageResourceName]) {
	            next();

	            return;
	        }

	        var loadOptions = {
	            crossOrigin: resource.crossOrigin,
	            metadata: resource.metadata.imageMetadata,
	            parentResource: resource
	        };

	        var resourcePath = getResourcePath(resource, this.baseUrl);

	        // load the image for this sheet
	        this.add(imageResourceName, resourcePath, loadOptions, function onImageLoad(res) {
	            if (res.error) {
	                next(res.error);

	                return;
	            }

	            var spritesheet = new _core.Spritesheet(res.texture.baseTexture, resource.data, resource.url);

	            spritesheet.parse(function () {
	                resource.spritesheet = spritesheet;
	                resource.textures = spritesheet.textures;
	                next();
	            });
	        });
	    };
	};

	exports.getResourcePath = getResourcePath;

	var _resourceLoader = __webpack_require__(327);

	var _url = __webpack_require__(223);

	var _url2 = _interopRequireDefault(_url);

	var _core = __webpack_require__(173);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function getResourcePath(resource, baseUrl) {
	    // Prepend url path unless the resource image is a data url
	    if (resource.isDataUrl) {
	        return resource.data.meta.image;
	    }

	    return _url2.default.resolve(resource.url.replace(baseUrl, ''), resource.data.meta.image);
	}
	//# sourceMappingURL=spritesheetParser.js.map

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	exports.default = function () {
	    return function textureParser(resource, next) {
	        // create a new texture if the data is an Image object
	        if (resource.data && resource.type === _resourceLoader.Resource.TYPE.IMAGE) {
	            resource.texture = _Texture2.default.fromLoader(resource.data, resource.url, resource.name);
	        }
	        next();
	    };
	};

	var _resourceLoader = __webpack_require__(327);

	var _Texture = __webpack_require__(220);

	var _Texture2 = _interopRequireDefault(_Texture);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=textureParser.js.map

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _resourceLoader = __webpack_require__(327);

	var _resourceLoader2 = _interopRequireDefault(_resourceLoader);

	var _blob = __webpack_require__(337);

	var _eventemitter = __webpack_require__(204);

	var _eventemitter2 = _interopRequireDefault(_eventemitter);

	var _textureParser = __webpack_require__(335);

	var _textureParser2 = _interopRequireDefault(_textureParser);

	var _spritesheetParser = __webpack_require__(334);

	var _spritesheetParser2 = _interopRequireDefault(_spritesheetParser);

	var _bitmapFontParser = __webpack_require__(326);

	var _bitmapFontParser2 = _interopRequireDefault(_bitmapFontParser);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	/**
	 *
	 * The new loader, extends Resource Loader by Chad Engler: https://github.com/englercj/resource-loader
	 *
	 * ```js
	 * const loader = PIXI.loader; // PixiJS exposes a premade instance for you to use.
	 * //or
	 * const loader = new PIXI.loaders.Loader(); // you can also create your own if you want
	 *
	 * const sprites = {};
	 *
	 * // Chainable `add` to enqueue a resource
	 * loader.add('bunny', 'data/bunny.png')
	 *       .add('spaceship', 'assets/spritesheet.json');
	 * loader.add('scoreFont', 'assets/score.fnt');
	 *
	 * // Chainable `pre` to add a middleware that runs for each resource, *before* loading that resource.
	 * // This is useful to implement custom caching modules (using filesystem, indexeddb, memory, etc).
	 * loader.pre(cachingMiddleware);
	 *
	 * // Chainable `use` to add a middleware that runs for each resource, *after* loading that resource.
	 * // This is useful to implement custom parsing modules (like spritesheet parsers, spine parser, etc).
	 * loader.use(parsingMiddleware);
	 *
	 * // The `load` method loads the queue of resources, and calls the passed in callback called once all
	 * // resources have loaded.
	 * loader.load((loader, resources) => {
	 *     // resources is an object where the key is the name of the resource loaded and the value is the resource object.
	 *     // They have a couple default properties:
	 *     // - `url`: The URL that the resource was loaded from
	 *     // - `error`: The error that happened when trying to load (if any)
	 *     // - `data`: The raw data that was loaded
	 *     // also may contain other properties based on the middleware that runs.
	 *     sprites.bunny = new PIXI.TilingSprite(resources.bunny.texture);
	 *     sprites.spaceship = new PIXI.TilingSprite(resources.spaceship.texture);
	 *     sprites.scoreFont = new PIXI.TilingSprite(resources.scoreFont.texture);
	 * });
	 *
	 * // throughout the process multiple signals can be dispatched.
	 * loader.onProgress.add(() => {}); // called once per loaded/errored file
	 * loader.onError.add(() => {}); // called once per errored file
	 * loader.onLoad.add(() => {}); // called once per loaded file
	 * loader.onComplete.add(() => {}); // called once when the queued resources all load.
	 * ```
	 *
	 * @see https://github.com/englercj/resource-loader
	 *
	 * @class
	 * @extends module:resource-loader.ResourceLoader
	 * @memberof PIXI.loaders
	 */
	var Loader = function (_ResourceLoader) {
	    _inherits(Loader, _ResourceLoader);

	    /**
	     * @param {string} [baseUrl=''] - The base url for all resources loaded by this loader.
	     * @param {number} [concurrency=10] - The number of resources to load concurrently.
	     */
	    function Loader(baseUrl, concurrency) {
	        _classCallCheck(this, Loader);

	        var _this = _possibleConstructorReturn(this, _ResourceLoader.call(this, baseUrl, concurrency));

	        _eventemitter2.default.call(_this);

	        for (var i = 0; i < Loader._pixiMiddleware.length; ++i) {
	            _this.use(Loader._pixiMiddleware[i]());
	        }

	        // Compat layer, translate the new v2 signals into old v1 events.
	        _this.onStart.add(function (l) {
	            return _this.emit('start', l);
	        });
	        _this.onProgress.add(function (l, r) {
	            return _this.emit('progress', l, r);
	        });
	        _this.onError.add(function (e, l, r) {
	            return _this.emit('error', e, l, r);
	        });
	        _this.onLoad.add(function (l, r) {
	            return _this.emit('load', l, r);
	        });
	        _this.onComplete.add(function (l, r) {
	            return _this.emit('complete', l, r);
	        });
	        return _this;
	    }

	    /**
	     * Adds a default middleware to the PixiJS loader.
	     *
	     * @static
	     * @param {Function} fn - The middleware to add.
	     */


	    Loader.addPixiMiddleware = function addPixiMiddleware(fn) {
	        Loader._pixiMiddleware.push(fn);
	    };

	    /**
	     * Destroy the loader, removes references.
	     */


	    Loader.prototype.destroy = function destroy() {
	        this.removeAllListeners();
	        this.reset();
	    };

	    return Loader;
	}(_resourceLoader2.default);

	// Copy EE3 prototype (mixin)


	exports.default = Loader;
	for (var k in _eventemitter2.default.prototype) {
	    Loader.prototype[k] = _eventemitter2.default.prototype[k];
	}

	Loader._pixiMiddleware = [
	// parse any blob into more usable objects (e.g. Image)
	_blob.blobMiddlewareFactory,
	// parse any Image objects into textures
	_textureParser2.default,
	// parse any spritesheet data into multiple textures
	_spritesheetParser2.default,
	// parse bitmap font data into multiple textures
	_bitmapFontParser2.default];

	// Add custom extentions
	var Resource = _resourceLoader2.default.Resource;

	Resource.setExtensionXhrType('fnt', Resource.XHR_RESPONSE_TYPE.DOCUMENT);
	//# sourceMappingURL=loader.js.map

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	exports.blobMiddlewareFactory = blobMiddlewareFactory;

	var _Resource = __webpack_require__(332);

	var _Resource2 = _interopRequireDefault(_Resource);

	var _b = __webpack_require__(333);

	var _b2 = _interopRequireDefault(_b);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var Url = window.URL || window.webkitURL;

	// a middleware for transforming XHR loaded Blobs into more useful objects
	function blobMiddlewareFactory() {
	    return function blobMiddleware(resource, next) {
	        if (!resource.data) {
	            next();

	            return;
	        }

	        // if this was an XHR load of a blob
	        if (resource.xhr && resource.xhrType === _Resource2.default.XHR_RESPONSE_TYPE.BLOB) {
	            // if there is no blob support we probably got a binary string back
	            if (!window.Blob || typeof resource.data === 'string') {
	                var type = resource.xhr.getResponseHeader('content-type');

	                // this is an image, convert the binary string into a data url
	                if (type && type.indexOf('image') === 0) {
	                    resource.data = new Image();
	                    resource.data.src = 'data:' + type + ';base64,' + _b2.default.encodeBinary(resource.xhr.responseText);

	                    resource.type = _Resource2.default.TYPE.IMAGE;

	                    // wait until the image loads and then callback
	                    resource.data.onload = function () {
	                        resource.data.onload = null;

	                        next();
	                    };

	                    // next will be called on load
	                    return;
	                }
	            }
	            // if content type says this is an image, then we should transform the blob into an Image object
	            else if (resource.data.type.indexOf('image') === 0) {
	                    var _ret = function () {
	                        var src = Url.createObjectURL(resource.data);

	                        resource.blob = resource.data;
	                        resource.data = new Image();
	                        resource.data.src = src;

	                        resource.type = _Resource2.default.TYPE.IMAGE;

	                        // cleanup the no longer used blob after the image loads
	                        // TODO: Is this correct? Will the image be invalid after revoking?
	                        resource.data.onload = function () {
	                            Url.revokeObjectURL(src);
	                            resource.data.onload = null;

	                            next();
	                        };

	                        // next will be called on load.
	                        return {
	                            v: void 0
	                        };
	                    }();

	                    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	                }
	        }

	        next();
	    };
	}
	//# sourceMappingURL=blob.js.map

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _Mesh = __webpack_require__(339);

	Object.defineProperty(exports, 'Mesh', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Mesh).default;
	  }
	});

	var _MeshRenderer = __webpack_require__(340);

	Object.defineProperty(exports, 'MeshRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MeshRenderer).default;
	  }
	});

	var _CanvasMeshRenderer = __webpack_require__(341);

	Object.defineProperty(exports, 'CanvasMeshRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CanvasMeshRenderer).default;
	  }
	});

	var _Plane = __webpack_require__(342);

	Object.defineProperty(exports, 'Plane', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Plane).default;
	  }
	});

	var _NineSlicePlane = __webpack_require__(343);

	Object.defineProperty(exports, 'NineSlicePlane', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_NineSlicePlane).default;
	  }
	});

	var _Rope = __webpack_require__(344);

	Object.defineProperty(exports, 'Rope', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Rope).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=index.js.map

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _core = __webpack_require__(173);

	var core = _interopRequireWildcard(_core);

	var _Texture = __webpack_require__(220);

	var _Texture2 = _interopRequireDefault(_Texture);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var tempPoint = new core.Point();
	var tempPolygon = new core.Polygon();

	/**
	 * Base mesh class
	 * @class
	 * @extends PIXI.Container
	 * @memberof PIXI.mesh
	 */

	var Mesh = function (_core$Container) {
	    _inherits(Mesh, _core$Container);

	    /**
	     * @param {PIXI.Texture} texture - The texture to use
	     * @param {Float32Array} [vertices] - if you want to specify the vertices
	     * @param {Float32Array} [uvs] - if you want to specify the uvs
	     * @param {Uint16Array} [indices] - if you want to specify the indices
	     * @param {number} [drawMode] - the drawMode, can be any of the Mesh.DRAW_MODES consts
	     */
	    function Mesh(texture, vertices, uvs, indices, drawMode) {
	        _classCallCheck(this, Mesh);

	        /**
	         * The texture of the Mesh
	         *
	         * @member {PIXI.Texture}
	         * @default PIXI.Texture.EMPTY
	         * @private
	         */
	        var _this = _possibleConstructorReturn(this, _core$Container.call(this));

	        _this._texture = texture || _Texture2.default.EMPTY;

	        /**
	         * The Uvs of the Mesh
	         *
	         * @member {Float32Array}
	         */
	        _this.uvs = uvs || new Float32Array([0, 0, 1, 0, 1, 1, 0, 1]);

	        /**
	         * An array of vertices
	         *
	         * @member {Float32Array}
	         */
	        _this.vertices = vertices || new Float32Array([0, 0, 100, 0, 100, 100, 0, 100]);

	        /**
	         * An array containing the indices of the vertices
	         *
	         * @member {Uint16Array}
	         */
	        //  TODO auto generate this based on draw mode!
	        _this.indices = indices || new Uint16Array([0, 1, 3, 2]);

	        /**
	         * Version of mesh uvs are dirty or not
	         *
	         * @member {number}
	         */
	        _this.dirty = 0;

	        /**
	         * Version of mesh indices
	         *
	         * @member {number}
	         */
	        _this.indexDirty = 0;

	        /**
	         * Version of mesh verticies array
	         *
	         * @member {number}
	         */
	        _this.vertexDirty = 0;

	        /**
	         * For backwards compatibility the default is to re-upload verticies each render call.
	         * Set this to `false` and increase `vertexDirty` to manually re-upload the buffer.
	         *
	         * @member {boolean}
	         */
	        _this.autoUpdate = true;

	        /**
	         * The blend mode to be applied to the sprite. Set to `PIXI.BLEND_MODES.NORMAL` to remove
	         * any blend mode.
	         *
	         * @member {number}
	         * @default PIXI.BLEND_MODES.NORMAL
	         * @see PIXI.BLEND_MODES
	         */
	        _this.blendMode = core.BLEND_MODES.NORMAL;

	        /**
	         * Triangles in canvas mode are automatically antialiased, use this value to force triangles
	         * to overlap a bit with each other.
	         *
	         * @member {number}
	         */
	        _this.canvasPadding = core.settings.MESH_CANVAS_PADDING;

	        /**
	         * The way the Mesh should be drawn, can be any of the {@link PIXI.mesh.Mesh.DRAW_MODES} consts
	         *
	         * @member {number}
	         * @see PIXI.mesh.Mesh.DRAW_MODES
	         */
	        _this.drawMode = drawMode || Mesh.DRAW_MODES.TRIANGLE_MESH;

	        /**
	         * The default shader that is used if a mesh doesn't have a more specific one.
	         *
	         * @member {PIXI.Shader}
	         */
	        _this.shader = null;

	        /**
	         * The tint applied to the mesh. This is a [r,g,b] value. A value of [1,1,1] will remove any
	         * tint effect.
	         *
	         * @member {number}
	         */
	        _this.tintRgb = new Float32Array([1, 1, 1]);

	        /**
	         * A map of renderer IDs to webgl render data
	         *
	         * @private
	         * @member {object<number, object>}
	         */
	        _this._glDatas = {};

	        /**
	         * transform that is applied to UV to get the texture coords
	         * its updated independently from texture uvTransform
	         * updates of uvs are tied to that thing
	         *
	         * @member {PIXI.TextureMatrix}
	         * @private
	         */
	        _this._uvTransform = new core.TextureMatrix(_this._texture);

	        /**
	         * whether or not upload uvTransform to shader
	         * if its false, then uvs should be pre-multiplied
	         * if you change it for generated mesh, please call 'refresh(true)'
	         * @member {boolean}
	         * @default false
	         */
	        _this.uploadUvTransform = false;

	        /**
	         * Plugin that is responsible for rendering this element.
	         * Allows to customize the rendering process without overriding '_renderWebGL' & '_renderCanvas' methods.
	         * @member {string}
	         * @default 'mesh'
	         */
	        _this.pluginName = 'mesh';
	        return _this;
	    }

	    /**
	     * Renders the object using the WebGL renderer
	     *
	     * @private
	     * @param {PIXI.WebGLRenderer} renderer - a reference to the WebGL renderer
	     */


	    Mesh.prototype._renderWebGL = function _renderWebGL(renderer) {
	        this.refresh();
	        renderer.setObjectRenderer(renderer.plugins[this.pluginName]);
	        renderer.plugins[this.pluginName].render(this);
	    };

	    /**
	     * Renders the object using the Canvas renderer
	     *
	     * @private
	     * @param {PIXI.CanvasRenderer} renderer - The canvas renderer.
	     */


	    Mesh.prototype._renderCanvas = function _renderCanvas(renderer) {
	        this.refresh();
	        renderer.plugins[this.pluginName].render(this);
	    };

	    /**
	     * When the texture is updated, this event will fire to update the scale and frame
	     *
	     * @private
	     */


	    Mesh.prototype._onTextureUpdate = function _onTextureUpdate() {
	        this._uvTransform.texture = this._texture;
	        this.refresh();
	    };

	    /**
	     * multiplies uvs only if uploadUvTransform is false
	     * call it after you change uvs manually
	     * make sure that texture is valid
	     */


	    Mesh.prototype.multiplyUvs = function multiplyUvs() {
	        if (!this.uploadUvTransform) {
	            this._uvTransform.multiplyUvs(this.uvs);
	        }
	    };

	    /**
	     * Refreshes uvs for generated meshes (rope, plane)
	     * sometimes refreshes vertices too
	     *
	     * @param {boolean} [forceUpdate=false] if true, matrices will be updated any case
	     */


	    Mesh.prototype.refresh = function refresh(forceUpdate) {
	        if (this.autoUpdate) {
	            this.vertexDirty++;
	        }
	        if (this._uvTransform.update(forceUpdate)) {
	            this._refresh();
	        }
	    };

	    /**
	     * re-calculates mesh coords
	     * @protected
	     */


	    Mesh.prototype._refresh = function _refresh() {}
	    /* empty */


	    /**
	     * Returns the bounds of the mesh as a rectangle. The bounds calculation takes the worldTransform into account.
	     *
	     */
	    ;

	    Mesh.prototype._calculateBounds = function _calculateBounds() {
	        // TODO - we can cache local bounds and use them if they are dirty (like graphics)
	        this._bounds.addVertices(this.transform, this.vertices, 0, this.vertices.length);
	    };

	    /**
	     * Tests if a point is inside this mesh. Works only for TRIANGLE_MESH
	     *
	     * @param {PIXI.Point} point - the point to test
	     * @return {boolean} the result of the test
	     */


	    Mesh.prototype.containsPoint = function containsPoint(point) {
	        if (!this.getBounds().contains(point.x, point.y)) {
	            return false;
	        }

	        this.worldTransform.applyInverse(point, tempPoint);

	        var vertices = this.vertices;
	        var points = tempPolygon.points;
	        var indices = this.indices;
	        var len = this.indices.length;
	        var step = this.drawMode === Mesh.DRAW_MODES.TRIANGLES ? 3 : 1;

	        for (var i = 0; i + 2 < len; i += step) {
	            var ind0 = indices[i] * 2;
	            var ind1 = indices[i + 1] * 2;
	            var ind2 = indices[i + 2] * 2;

	            points[0] = vertices[ind0];
	            points[1] = vertices[ind0 + 1];
	            points[2] = vertices[ind1];
	            points[3] = vertices[ind1 + 1];
	            points[4] = vertices[ind2];
	            points[5] = vertices[ind2 + 1];

	            if (tempPolygon.contains(tempPoint.x, tempPoint.y)) {
	                return true;
	            }
	        }

	        return false;
	    };

	    /**
	     * The texture that the mesh uses.
	     *
	     * @member {PIXI.Texture}
	     */


	    /**
	     * Destroys the Mesh object.
	     *
	     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all
	     *  options have been set to that value
	     * @param {boolean} [options.children=false] - if set to true, all the children will have
	     *  their destroy method called as well. 'options' will be passed on to those calls.
	     * @param {boolean} [options.texture=false] - Only used for child Sprites if options.children is set to true
	     *  Should it destroy the texture of the child sprite
	     * @param {boolean} [options.baseTexture=false] - Only used for child Sprites if options.children is set to true
	     *  Should it destroy the base texture of the child sprite
	     */
	    Mesh.prototype.destroy = function destroy(options) {
	        // for each webgl data entry, destroy the WebGLGraphicsData
	        for (var id in this._glDatas) {
	            var data = this._glDatas[id];

	            if (data.destroy) {
	                data.destroy();
	            } else {
	                if (data.vertexBuffer) {
	                    data.vertexBuffer.destroy();
	                    data.vertexBuffer = null;
	                }
	                if (data.indexBuffer) {
	                    data.indexBuffer.destroy();
	                    data.indexBuffer = null;
	                }
	                if (data.uvBuffer) {
	                    data.uvBuffer.destroy();
	                    data.uvBuffer = null;
	                }
	                if (data.vao) {
	                    data.vao.destroy();
	                    data.vao = null;
	                }
	            }
	        }

	        this._glDatas = null;

	        _core$Container.prototype.destroy.call(this, options);
	    };

	    _createClass(Mesh, [{
	        key: 'texture',
	        get: function get() {
	            return this._texture;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            if (this._texture === value) {
	                return;
	            }

	            this._texture = value;

	            if (value) {
	                // wait for the texture to load
	                if (value.baseTexture.hasLoaded) {
	                    this._onTextureUpdate();
	                } else {
	                    value.once('update', this._onTextureUpdate, this);
	                }
	            }
	        }

	        /**
	         * The tint applied to the mesh. This is a hex value. A value of 0xFFFFFF will remove any tint effect.
	         *
	         * @member {number}
	         * @default 0xFFFFFF
	         */

	    }, {
	        key: 'tint',
	        get: function get() {
	            return core.utils.rgb2hex(this.tintRgb);
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this.tintRgb = core.utils.hex2rgb(value, this.tintRgb);
	        }
	    }]);

	    return Mesh;
	}(core.Container);

	/**
	 * Different drawing buffer modes supported
	 *
	 * @static
	 * @constant
	 * @type {object}
	 * @property {number} TRIANGLE_MESH
	 * @property {number} TRIANGLES
	 */


	exports.default = Mesh;
	Mesh.DRAW_MODES = {
	    TRIANGLE_MESH: 0,
	    TRIANGLES: 1
	};
	//# sourceMappingURL=Mesh.js.map

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _core = __webpack_require__(173);

	var core = _interopRequireWildcard(_core);

	var _pixiGlCore = __webpack_require__(185);

	var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);

	var _Mesh = __webpack_require__(339);

	var _Mesh2 = _interopRequireDefault(_Mesh);

	var _path = __webpack_require__(252);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var matrixIdentity = core.Matrix.IDENTITY;

	/**
	 * WebGL renderer plugin for tiling sprites
	 *
	 * @class
	 * @memberof PIXI
	 * @extends PIXI.ObjectRenderer
	 */

	var MeshRenderer = function (_core$ObjectRenderer) {
	    _inherits(MeshRenderer, _core$ObjectRenderer);

	    /**
	     * constructor for renderer
	     *
	     * @param {WebGLRenderer} renderer The renderer this tiling awesomeness works for.
	     */
	    function MeshRenderer(renderer) {
	        _classCallCheck(this, MeshRenderer);

	        var _this = _possibleConstructorReturn(this, _core$ObjectRenderer.call(this, renderer));

	        _this.shader = null;
	        return _this;
	    }

	    /**
	     * Sets up the renderer context and necessary buffers.
	     *
	     * @private
	     */


	    MeshRenderer.prototype.onContextChange = function onContextChange() {
	        var gl = this.renderer.gl;

	        this.shader = new core.Shader(gl, 'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 translationMatrix;\nuniform mat3 uTransform;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = (uTransform * vec3(aTextureCoord, 1.0)).xy;\n}\n', 'varying vec2 vTextureCoord;\nuniform vec4 uColor;\n\nuniform sampler2D uSampler;\n\nvoid main(void)\n{\n    gl_FragColor = texture2D(uSampler, vTextureCoord) * uColor;\n}\n');
	    };

	    /**
	     * renders mesh
	     *
	     * @param {PIXI.mesh.Mesh} mesh mesh instance
	     */


	    MeshRenderer.prototype.render = function render(mesh) {
	        var renderer = this.renderer;
	        var gl = renderer.gl;
	        var texture = mesh._texture;

	        if (!texture.valid) {
	            return;
	        }

	        var glData = mesh._glDatas[renderer.CONTEXT_UID];

	        if (!glData) {
	            renderer.bindVao(null);

	            glData = {
	                shader: this.shader,
	                vertexBuffer: _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl, mesh.vertices, gl.STREAM_DRAW),
	                uvBuffer: _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl, mesh.uvs, gl.STREAM_DRAW),
	                indexBuffer: _pixiGlCore2.default.GLBuffer.createIndexBuffer(gl, mesh.indices, gl.STATIC_DRAW),
	                // build the vao object that will render..
	                vao: null,
	                dirty: mesh.dirty,
	                indexDirty: mesh.indexDirty,
	                vertexDirty: mesh.vertexDirty
	            };

	            // build the vao object that will render..
	            glData.vao = new _pixiGlCore2.default.VertexArrayObject(gl).addIndex(glData.indexBuffer).addAttribute(glData.vertexBuffer, glData.shader.attributes.aVertexPosition, gl.FLOAT, false, 2 * 4, 0).addAttribute(glData.uvBuffer, glData.shader.attributes.aTextureCoord, gl.FLOAT, false, 2 * 4, 0);

	            mesh._glDatas[renderer.CONTEXT_UID] = glData;
	        }

	        renderer.bindVao(glData.vao);

	        if (mesh.dirty !== glData.dirty) {
	            glData.dirty = mesh.dirty;
	            glData.uvBuffer.upload(mesh.uvs);
	        }

	        if (mesh.indexDirty !== glData.indexDirty) {
	            glData.indexDirty = mesh.indexDirty;
	            glData.indexBuffer.upload(mesh.indices);
	        }

	        if (mesh.vertexDirty !== glData.vertexDirty) {
	            glData.vertexDirty = mesh.vertexDirty;
	            glData.vertexBuffer.upload(mesh.vertices);
	        }

	        renderer.bindShader(glData.shader);

	        glData.shader.uniforms.uSampler = renderer.bindTexture(texture);

	        renderer.state.setBlendMode(core.utils.correctBlendMode(mesh.blendMode, texture.baseTexture.premultipliedAlpha));

	        if (glData.shader.uniforms.uTransform) {
	            if (mesh.uploadUvTransform) {
	                glData.shader.uniforms.uTransform = mesh._uvTransform.mapCoord.toArray(true);
	            } else {
	                glData.shader.uniforms.uTransform = matrixIdentity.toArray(true);
	            }
	        }
	        glData.shader.uniforms.translationMatrix = mesh.worldTransform.toArray(true);

	        glData.shader.uniforms.uColor = core.utils.premultiplyRgba(mesh.tintRgb, mesh.worldAlpha, glData.shader.uniforms.uColor, texture.baseTexture.premultipliedAlpha);

	        var drawMode = mesh.drawMode === _Mesh2.default.DRAW_MODES.TRIANGLE_MESH ? gl.TRIANGLE_STRIP : gl.TRIANGLES;

	        glData.vao.draw(drawMode, mesh.indices.length, 0);
	    };

	    return MeshRenderer;
	}(core.ObjectRenderer);

	exports.default = MeshRenderer;


	core.WebGLRenderer.registerPlugin('mesh', MeshRenderer);
	//# sourceMappingURL=MeshRenderer.js.map

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _core = __webpack_require__(173);

	var core = _interopRequireWildcard(_core);

	var _Mesh = __webpack_require__(339);

	var _Mesh2 = _interopRequireDefault(_Mesh);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/**
	 * Renderer dedicated to meshes.
	 *
	 * @class
	 * @private
	 * @memberof PIXI
	 */
	var MeshSpriteRenderer = function () {
	    /**
	     * @param {PIXI.CanvasRenderer} renderer - The renderer this downport works for
	     */
	    function MeshSpriteRenderer(renderer) {
	        _classCallCheck(this, MeshSpriteRenderer);

	        this.renderer = renderer;
	    }

	    /**
	     * Renders the Mesh
	     *
	     * @param {PIXI.mesh.Mesh} mesh - the Mesh to render
	     */


	    MeshSpriteRenderer.prototype.render = function render(mesh) {
	        var renderer = this.renderer;
	        var context = renderer.context;

	        var transform = mesh.worldTransform;
	        var res = renderer.resolution;

	        if (renderer.roundPixels) {
	            context.setTransform(transform.a * res, transform.b * res, transform.c * res, transform.d * res, transform.tx * res | 0, transform.ty * res | 0);
	        } else {
	            context.setTransform(transform.a * res, transform.b * res, transform.c * res, transform.d * res, transform.tx * res, transform.ty * res);
	        }

	        renderer.context.globalAlpha = mesh.worldAlpha;
	        renderer.setBlendMode(mesh.blendMode);

	        if (mesh.drawMode === _Mesh2.default.DRAW_MODES.TRIANGLE_MESH) {
	            this._renderTriangleMesh(mesh);
	        } else {
	            this._renderTriangles(mesh);
	        }
	    };

	    /**
	     * Draws the object in Triangle Mesh mode
	     *
	     * @private
	     * @param {PIXI.mesh.Mesh} mesh - the Mesh to render
	     */


	    MeshSpriteRenderer.prototype._renderTriangleMesh = function _renderTriangleMesh(mesh) {
	        // draw triangles!!
	        var length = mesh.vertices.length / 2;

	        for (var i = 0; i < length - 2; i++) {
	            // draw some triangles!
	            var index = i * 2;

	            this._renderDrawTriangle(mesh, index, index + 2, index + 4);
	        }
	    };

	    /**
	     * Draws the object in triangle mode using canvas
	     *
	     * @private
	     * @param {PIXI.mesh.Mesh} mesh - the current mesh
	     */


	    MeshSpriteRenderer.prototype._renderTriangles = function _renderTriangles(mesh) {
	        // draw triangles!!
	        var indices = mesh.indices;
	        var length = indices.length;

	        for (var i = 0; i < length; i += 3) {
	            // draw some triangles!
	            var index0 = indices[i] * 2;
	            var index1 = indices[i + 1] * 2;
	            var index2 = indices[i + 2] * 2;

	            this._renderDrawTriangle(mesh, index0, index1, index2);
	        }
	    };

	    /**
	     * Draws one of the triangles that from the Mesh
	     *
	     * @private
	     * @param {PIXI.mesh.Mesh} mesh - the current mesh
	     * @param {number} index0 - the index of the first vertex
	     * @param {number} index1 - the index of the second vertex
	     * @param {number} index2 - the index of the third vertex
	     */


	    MeshSpriteRenderer.prototype._renderDrawTriangle = function _renderDrawTriangle(mesh, index0, index1, index2) {
	        var context = this.renderer.context;
	        var uvs = mesh.uvs;
	        var vertices = mesh.vertices;
	        var texture = mesh._texture;

	        if (!texture.valid) {
	            return;
	        }

	        var base = texture.baseTexture;
	        var textureSource = base.source;
	        var textureWidth = base.width;
	        var textureHeight = base.height;

	        var u0 = void 0;
	        var u1 = void 0;
	        var u2 = void 0;
	        var v0 = void 0;
	        var v1 = void 0;
	        var v2 = void 0;

	        if (mesh.uploadUvTransform) {
	            var ut = mesh._uvTransform.mapCoord;

	            u0 = (uvs[index0] * ut.a + uvs[index0 + 1] * ut.c + ut.tx) * base.width;
	            u1 = (uvs[index1] * ut.a + uvs[index1 + 1] * ut.c + ut.tx) * base.width;
	            u2 = (uvs[index2] * ut.a + uvs[index2 + 1] * ut.c + ut.tx) * base.width;
	            v0 = (uvs[index0] * ut.b + uvs[index0 + 1] * ut.d + ut.ty) * base.height;
	            v1 = (uvs[index1] * ut.b + uvs[index1 + 1] * ut.d + ut.ty) * base.height;
	            v2 = (uvs[index2] * ut.b + uvs[index2 + 1] * ut.d + ut.ty) * base.height;
	        } else {
	            u0 = uvs[index0] * base.width;
	            u1 = uvs[index1] * base.width;
	            u2 = uvs[index2] * base.width;
	            v0 = uvs[index0 + 1] * base.height;
	            v1 = uvs[index1 + 1] * base.height;
	            v2 = uvs[index2 + 1] * base.height;
	        }

	        var x0 = vertices[index0];
	        var x1 = vertices[index1];
	        var x2 = vertices[index2];
	        var y0 = vertices[index0 + 1];
	        var y1 = vertices[index1 + 1];
	        var y2 = vertices[index2 + 1];

	        var canvasPadding = mesh.canvasPadding / this.renderer.resolution;

	        if (canvasPadding > 0) {
	            var paddingX = canvasPadding / Math.abs(mesh.worldTransform.a);
	            var paddingY = canvasPadding / Math.abs(mesh.worldTransform.d);
	            var centerX = (x0 + x1 + x2) / 3;
	            var centerY = (y0 + y1 + y2) / 3;

	            var normX = x0 - centerX;
	            var normY = y0 - centerY;

	            var dist = Math.sqrt(normX * normX + normY * normY);

	            x0 = centerX + normX / dist * (dist + paddingX);
	            y0 = centerY + normY / dist * (dist + paddingY);

	            //

	            normX = x1 - centerX;
	            normY = y1 - centerY;

	            dist = Math.sqrt(normX * normX + normY * normY);
	            x1 = centerX + normX / dist * (dist + paddingX);
	            y1 = centerY + normY / dist * (dist + paddingY);

	            normX = x2 - centerX;
	            normY = y2 - centerY;

	            dist = Math.sqrt(normX * normX + normY * normY);
	            x2 = centerX + normX / dist * (dist + paddingX);
	            y2 = centerY + normY / dist * (dist + paddingY);
	        }

	        context.save();
	        context.beginPath();

	        context.moveTo(x0, y0);
	        context.lineTo(x1, y1);
	        context.lineTo(x2, y2);

	        context.closePath();

	        context.clip();

	        // Compute matrix transform
	        var delta = u0 * v1 + v0 * u2 + u1 * v2 - v1 * u2 - v0 * u1 - u0 * v2;
	        var deltaA = x0 * v1 + v0 * x2 + x1 * v2 - v1 * x2 - v0 * x1 - x0 * v2;
	        var deltaB = u0 * x1 + x0 * u2 + u1 * x2 - x1 * u2 - x0 * u1 - u0 * x2;
	        var deltaC = u0 * v1 * x2 + v0 * x1 * u2 + x0 * u1 * v2 - x0 * v1 * u2 - v0 * u1 * x2 - u0 * x1 * v2;
	        var deltaD = y0 * v1 + v0 * y2 + y1 * v2 - v1 * y2 - v0 * y1 - y0 * v2;
	        var deltaE = u0 * y1 + y0 * u2 + u1 * y2 - y1 * u2 - y0 * u1 - u0 * y2;
	        var deltaF = u0 * v1 * y2 + v0 * y1 * u2 + y0 * u1 * v2 - y0 * v1 * u2 - v0 * u1 * y2 - u0 * y1 * v2;

	        context.transform(deltaA / delta, deltaD / delta, deltaB / delta, deltaE / delta, deltaC / delta, deltaF / delta);

	        context.drawImage(textureSource, 0, 0, textureWidth * base.resolution, textureHeight * base.resolution, 0, 0, textureWidth, textureHeight);

	        context.restore();
	        this.renderer.invalidateBlendMode();
	    };

	    /**
	     * Renders a flat Mesh
	     *
	     * @private
	     * @param {PIXI.mesh.Mesh} mesh - The Mesh to render
	     */


	    MeshSpriteRenderer.prototype.renderMeshFlat = function renderMeshFlat(mesh) {
	        var context = this.renderer.context;
	        var vertices = mesh.vertices;
	        var length = vertices.length / 2;

	        // this.count++;

	        context.beginPath();

	        for (var i = 1; i < length - 2; ++i) {
	            // draw some triangles!
	            var index = i * 2;

	            var x0 = vertices[index];
	            var y0 = vertices[index + 1];

	            var x1 = vertices[index + 2];
	            var y1 = vertices[index + 3];

	            var x2 = vertices[index + 4];
	            var y2 = vertices[index + 5];

	            context.moveTo(x0, y0);
	            context.lineTo(x1, y1);
	            context.lineTo(x2, y2);
	        }

	        context.fillStyle = '#FF0000';
	        context.fill();
	        context.closePath();
	    };

	    /**
	     * destroy the the renderer.
	     *
	     */


	    MeshSpriteRenderer.prototype.destroy = function destroy() {
	        this.renderer = null;
	    };

	    return MeshSpriteRenderer;
	}();

	exports.default = MeshSpriteRenderer;


	core.CanvasRenderer.registerPlugin('mesh', MeshSpriteRenderer);
	//# sourceMappingURL=CanvasMeshRenderer.js.map

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _Mesh2 = __webpack_require__(339);

	var _Mesh3 = _interopRequireDefault(_Mesh2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	/**
	 * The Plane allows you to draw a texture across several points and them manipulate these points
	 *
	 *```js
	 * for (let i = 0; i < 20; i++) {
	 *     points.push(new PIXI.Point(i * 50, 0));
	 * };
	 * let Plane = new PIXI.Plane(PIXI.Texture.fromImage("snake.png"), points);
	 *  ```
	 *
	 * @class
	 * @extends PIXI.mesh.Mesh
	 * @memberof PIXI.mesh
	 *
	 */
	var Plane = function (_Mesh) {
	    _inherits(Plane, _Mesh);

	    /**
	     * @param {PIXI.Texture} texture - The texture to use on the Plane.
	     * @param {number} [verticesX=10] - The number of vertices in the x-axis
	     * @param {number} [verticesY=10] - The number of vertices in the y-axis
	     */
	    function Plane(texture, verticesX, verticesY) {
	        _classCallCheck(this, Plane);

	        /**
	         * Tracker for if the Plane is ready to be drawn. Needed because Mesh ctor can
	         * call _onTextureUpdated which could call refresh too early.
	         *
	         * @member {boolean}
	         * @private
	         */
	        var _this = _possibleConstructorReturn(this, _Mesh.call(this, texture));

	        _this._ready = true;

	        _this.verticesX = verticesX || 10;
	        _this.verticesY = verticesY || 10;

	        _this.drawMode = _Mesh3.default.DRAW_MODES.TRIANGLES;
	        _this.refresh();
	        return _this;
	    }

	    /**
	     * Refreshes plane coordinates
	     *
	     */


	    Plane.prototype._refresh = function _refresh() {
	        var texture = this._texture;
	        var total = this.verticesX * this.verticesY;
	        var verts = [];
	        var colors = [];
	        var uvs = [];
	        var indices = [];

	        var segmentsX = this.verticesX - 1;
	        var segmentsY = this.verticesY - 1;

	        var sizeX = texture.width / segmentsX;
	        var sizeY = texture.height / segmentsY;

	        for (var i = 0; i < total; i++) {
	            var x = i % this.verticesX;
	            var y = i / this.verticesX | 0;

	            verts.push(x * sizeX, y * sizeY);

	            uvs.push(x / segmentsX, y / segmentsY);
	        }

	        //  cons

	        var totalSub = segmentsX * segmentsY;

	        for (var _i = 0; _i < totalSub; _i++) {
	            var xpos = _i % segmentsX;
	            var ypos = _i / segmentsX | 0;

	            var value = ypos * this.verticesX + xpos;
	            var value2 = ypos * this.verticesX + xpos + 1;
	            var value3 = (ypos + 1) * this.verticesX + xpos;
	            var value4 = (ypos + 1) * this.verticesX + xpos + 1;

	            indices.push(value, value2, value3);
	            indices.push(value2, value4, value3);
	        }

	        // console.log(indices)
	        this.vertices = new Float32Array(verts);
	        this.uvs = new Float32Array(uvs);
	        this.colors = new Float32Array(colors);
	        this.indices = new Uint16Array(indices);

	        this.dirty++;
	        this.indexDirty++;

	        this.multiplyUvs();
	    };

	    /**
	     * Clear texture UVs when new texture is set
	     *
	     * @private
	     */


	    Plane.prototype._onTextureUpdate = function _onTextureUpdate() {
	        _Mesh3.default.prototype._onTextureUpdate.call(this);

	        // wait for the Plane ctor to finish before calling refresh
	        if (this._ready) {
	            this.refresh();
	        }
	    };

	    return Plane;
	}(_Mesh3.default);

	exports.default = Plane;
	//# sourceMappingURL=Plane.js.map

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _Plane2 = __webpack_require__(342);

	var _Plane3 = _interopRequireDefault(_Plane2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var DEFAULT_BORDER_SIZE = 10;

	/**
	 * The NineSlicePlane allows you to stretch a texture using 9-slice scaling. The corners will remain unscaled (useful
	 * for buttons with rounded corners for example) and the other areas will be scaled horizontally and or vertically
	 *
	 *```js
	 * let Plane9 = new PIXI.NineSlicePlane(PIXI.Texture.fromImage('BoxWithRoundedCorners.png'), 15, 15, 15, 15);
	 *  ```
	 * <pre>
	 *      A                          B
	 *    +---+----------------------+---+
	 *  C | 1 |          2           | 3 |
	 *    +---+----------------------+---+
	 *    |   |                      |   |
	 *    | 4 |          5           | 6 |
	 *    |   |                      |   |
	 *    +---+----------------------+---+
	 *  D | 7 |          8           | 9 |
	 *    +---+----------------------+---+

	 *  When changing this objects width and/or height:
	 *     areas 1 3 7 and 9 will remain unscaled.
	 *     areas 2 and 8 will be stretched horizontally
	 *     areas 4 and 6 will be stretched vertically
	 *     area 5 will be stretched both horizontally and vertically
	 * </pre>
	 *
	 * @class
	 * @extends PIXI.mesh.Plane
	 * @memberof PIXI.mesh
	 *
	 */

	var NineSlicePlane = function (_Plane) {
	    _inherits(NineSlicePlane, _Plane);

	    /**
	     * @param {PIXI.Texture} texture - The texture to use on the NineSlicePlane.
	     * @param {int} [leftWidth=10] size of the left vertical bar (A)
	     * @param {int} [topHeight=10] size of the top horizontal bar (C)
	     * @param {int} [rightWidth=10] size of the right vertical bar (B)
	     * @param {int} [bottomHeight=10] size of the bottom horizontal bar (D)
	     */
	    function NineSlicePlane(texture, leftWidth, topHeight, rightWidth, bottomHeight) {
	        _classCallCheck(this, NineSlicePlane);

	        var _this = _possibleConstructorReturn(this, _Plane.call(this, texture, 4, 4));

	        _this._origWidth = texture.orig.width;
	        _this._origHeight = texture.orig.height;

	        /**
	         * The width of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane
	         *
	         * @member {number}
	         * @memberof PIXI.NineSlicePlane#
	         * @override
	         */
	        _this._width = _this._origWidth;

	        /**
	         * The height of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane
	         *
	         * @member {number}
	         * @memberof PIXI.NineSlicePlane#
	         * @override
	         */
	        _this._height = _this._origHeight;

	        /**
	         * The width of the left column (a)
	         *
	         * @member {number}
	         * @memberof PIXI.NineSlicePlane#
	         * @override
	         */
	        _this._leftWidth = typeof leftWidth !== 'undefined' ? leftWidth : DEFAULT_BORDER_SIZE;

	        /**
	         * The width of the right column (b)
	         *
	         * @member {number}
	         * @memberof PIXI.NineSlicePlane#
	         * @override
	         */
	        _this._rightWidth = typeof rightWidth !== 'undefined' ? rightWidth : DEFAULT_BORDER_SIZE;

	        /**
	         * The height of the top row (c)
	         *
	         * @member {number}
	         * @memberof PIXI.NineSlicePlane#
	         * @override
	         */
	        _this._topHeight = typeof topHeight !== 'undefined' ? topHeight : DEFAULT_BORDER_SIZE;

	        /**
	         * The height of the bottom row (d)
	         *
	         * @member {number}
	         * @memberof PIXI.NineSlicePlane#
	         * @override
	         */
	        _this._bottomHeight = typeof bottomHeight !== 'undefined' ? bottomHeight : DEFAULT_BORDER_SIZE;

	        _this.refresh(true);
	        return _this;
	    }

	    /**
	     * Updates the horizontal vertices.
	     *
	     */


	    NineSlicePlane.prototype.updateHorizontalVertices = function updateHorizontalVertices() {
	        var vertices = this.vertices;

	        var h = this._topHeight + this._bottomHeight;
	        var scale = this._height > h ? 1.0 : this._height / h;

	        vertices[9] = vertices[11] = vertices[13] = vertices[15] = this._topHeight * scale;
	        vertices[17] = vertices[19] = vertices[21] = vertices[23] = this._height - this._bottomHeight * scale;
	        vertices[25] = vertices[27] = vertices[29] = vertices[31] = this._height;
	    };

	    /**
	     * Updates the vertical vertices.
	     *
	     */


	    NineSlicePlane.prototype.updateVerticalVertices = function updateVerticalVertices() {
	        var vertices = this.vertices;

	        var w = this._leftWidth + this._rightWidth;
	        var scale = this._width > w ? 1.0 : this._width / w;

	        vertices[2] = vertices[10] = vertices[18] = vertices[26] = this._leftWidth * scale;
	        vertices[4] = vertices[12] = vertices[20] = vertices[28] = this._width - this._rightWidth * scale;
	        vertices[6] = vertices[14] = vertices[22] = vertices[30] = this._width;
	    };

	    /**
	     * Renders the object using the Canvas renderer
	     *
	     * @private
	     * @param {PIXI.CanvasRenderer} renderer - The canvas renderer to render with.
	     */


	    NineSlicePlane.prototype._renderCanvas = function _renderCanvas(renderer) {
	        var context = renderer.context;

	        context.globalAlpha = this.worldAlpha;
	        renderer.setBlendMode(this.blendMode);

	        var transform = this.worldTransform;
	        var res = renderer.resolution;

	        if (renderer.roundPixels) {
	            context.setTransform(transform.a * res, transform.b * res, transform.c * res, transform.d * res, transform.tx * res | 0, transform.ty * res | 0);
	        } else {
	            context.setTransform(transform.a * res, transform.b * res, transform.c * res, transform.d * res, transform.tx * res, transform.ty * res);
	        }

	        var base = this._texture.baseTexture;
	        var textureSource = base.source;
	        var w = base.width * base.resolution;
	        var h = base.height * base.resolution;

	        this.drawSegment(context, textureSource, w, h, 0, 1, 10, 11);
	        this.drawSegment(context, textureSource, w, h, 2, 3, 12, 13);
	        this.drawSegment(context, textureSource, w, h, 4, 5, 14, 15);
	        this.drawSegment(context, textureSource, w, h, 8, 9, 18, 19);
	        this.drawSegment(context, textureSource, w, h, 10, 11, 20, 21);
	        this.drawSegment(context, textureSource, w, h, 12, 13, 22, 23);
	        this.drawSegment(context, textureSource, w, h, 16, 17, 26, 27);
	        this.drawSegment(context, textureSource, w, h, 18, 19, 28, 29);
	        this.drawSegment(context, textureSource, w, h, 20, 21, 30, 31);
	    };

	    /**
	     * Renders one segment of the plane.
	     * to mimic the exact drawing behavior of stretching the image like WebGL does, we need to make sure
	     * that the source area is at least 1 pixel in size, otherwise nothing gets drawn when a slice size of 0 is used.
	     *
	     * @private
	     * @param {CanvasRenderingContext2D} context - The context to draw with.
	     * @param {CanvasImageSource} textureSource - The source to draw.
	     * @param {number} w - width of the texture
	     * @param {number} h - height of the texture
	     * @param {number} x1 - x index 1
	     * @param {number} y1 - y index 1
	     * @param {number} x2 - x index 2
	     * @param {number} y2 - y index 2
	     */


	    NineSlicePlane.prototype.drawSegment = function drawSegment(context, textureSource, w, h, x1, y1, x2, y2) {
	        // otherwise you get weird results when using slices of that are 0 wide or high.
	        var uvs = this.uvs;
	        var vertices = this.vertices;

	        var sw = (uvs[x2] - uvs[x1]) * w;
	        var sh = (uvs[y2] - uvs[y1]) * h;
	        var dw = vertices[x2] - vertices[x1];
	        var dh = vertices[y2] - vertices[y1];

	        // make sure the source is at least 1 pixel wide and high, otherwise nothing will be drawn.
	        if (sw < 1) {
	            sw = 1;
	        }

	        if (sh < 1) {
	            sh = 1;
	        }

	        // make sure destination is at least 1 pixel wide and high, otherwise you get
	        // lines when rendering close to original size.
	        if (dw < 1) {
	            dw = 1;
	        }

	        if (dh < 1) {
	            dh = 1;
	        }

	        context.drawImage(textureSource, uvs[x1] * w, uvs[y1] * h, sw, sh, vertices[x1], vertices[y1], dw, dh);
	    };

	    /**
	     * The width of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane
	     *
	     * @member {number}
	     */


	    /**
	     * Refreshes NineSlicePlane coords. All of them.
	     */
	    NineSlicePlane.prototype._refresh = function _refresh() {
	        _Plane.prototype._refresh.call(this);

	        var uvs = this.uvs;
	        var texture = this._texture;

	        this._origWidth = texture.orig.width;
	        this._origHeight = texture.orig.height;

	        var _uvw = 1.0 / this._origWidth;
	        var _uvh = 1.0 / this._origHeight;

	        uvs[0] = uvs[8] = uvs[16] = uvs[24] = 0;
	        uvs[1] = uvs[3] = uvs[5] = uvs[7] = 0;
	        uvs[6] = uvs[14] = uvs[22] = uvs[30] = 1;
	        uvs[25] = uvs[27] = uvs[29] = uvs[31] = 1;

	        uvs[2] = uvs[10] = uvs[18] = uvs[26] = _uvw * this._leftWidth;
	        uvs[4] = uvs[12] = uvs[20] = uvs[28] = 1 - _uvw * this._rightWidth;
	        uvs[9] = uvs[11] = uvs[13] = uvs[15] = _uvh * this._topHeight;
	        uvs[17] = uvs[19] = uvs[21] = uvs[23] = 1 - _uvh * this._bottomHeight;

	        this.updateHorizontalVertices();
	        this.updateVerticalVertices();

	        this.dirty++;

	        this.multiplyUvs();
	    };

	    _createClass(NineSlicePlane, [{
	        key: 'width',
	        get: function get() {
	            return this._width;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._width = value;
	            this._refresh();
	        }

	        /**
	         * The height of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane
	         *
	         * @member {number}
	         */

	    }, {
	        key: 'height',
	        get: function get() {
	            return this._height;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._height = value;
	            this._refresh();
	        }

	        /**
	         * The width of the left column
	         *
	         * @member {number}
	         */

	    }, {
	        key: 'leftWidth',
	        get: function get() {
	            return this._leftWidth;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._leftWidth = value;
	            this._refresh();
	        }

	        /**
	         * The width of the right column
	         *
	         * @member {number}
	         */

	    }, {
	        key: 'rightWidth',
	        get: function get() {
	            return this._rightWidth;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._rightWidth = value;
	            this._refresh();
	        }

	        /**
	         * The height of the top row
	         *
	         * @member {number}
	         */

	    }, {
	        key: 'topHeight',
	        get: function get() {
	            return this._topHeight;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._topHeight = value;
	            this._refresh();
	        }

	        /**
	         * The height of the bottom row
	         *
	         * @member {number}
	         */

	    }, {
	        key: 'bottomHeight',
	        get: function get() {
	            return this._bottomHeight;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._bottomHeight = value;
	            this._refresh();
	        }
	    }]);

	    return NineSlicePlane;
	}(_Plane3.default);

	exports.default = NineSlicePlane;
	//# sourceMappingURL=NineSlicePlane.js.map

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _Mesh2 = __webpack_require__(339);

	var _Mesh3 = _interopRequireDefault(_Mesh2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	/**
	 * The rope allows you to draw a texture across several points and them manipulate these points
	 *
	 *```js
	 * for (let i = 0; i < 20; i++) {
	 *     points.push(new PIXI.Point(i * 50, 0));
	 * };
	 * let rope = new PIXI.Rope(PIXI.Texture.fromImage("snake.png"), points);
	 *  ```
	 *
	 * @class
	 * @extends PIXI.mesh.Mesh
	 * @memberof PIXI.mesh
	 *
	 */
	var Rope = function (_Mesh) {
	    _inherits(Rope, _Mesh);

	    /**
	     * @param {PIXI.Texture} texture - The texture to use on the rope.
	     * @param {PIXI.Point[]} points - An array of {@link PIXI.Point} objects to construct this rope.
	     */
	    function Rope(texture, points) {
	        _classCallCheck(this, Rope);

	        /**
	         * An array of points that determine the rope
	         *
	         * @member {PIXI.Point[]}
	         */
	        var _this = _possibleConstructorReturn(this, _Mesh.call(this, texture));

	        _this.points = points;

	        /**
	         * An array of vertices used to construct this rope.
	         *
	         * @member {Float32Array}
	         */
	        _this.vertices = new Float32Array(points.length * 4);

	        /**
	         * The WebGL Uvs of the rope.
	         *
	         * @member {Float32Array}
	         */
	        _this.uvs = new Float32Array(points.length * 4);

	        /**
	         * An array containing the color components
	         *
	         * @member {Float32Array}
	         */
	        _this.colors = new Float32Array(points.length * 2);

	        /**
	         * An array containing the indices of the vertices
	         *
	         * @member {Uint16Array}
	         */
	        _this.indices = new Uint16Array(points.length * 2);

	        /**
	         * refreshes vertices on every updateTransform
	         * @member {boolean}
	         * @default true
	         */
	        _this.autoUpdate = true;

	        _this.refresh();
	        return _this;
	    }

	    /**
	     * Refreshes
	     *
	     */


	    Rope.prototype._refresh = function _refresh() {
	        var points = this.points;

	        // if too little points, or texture hasn't got UVs set yet just move on.
	        if (points.length < 1 || !this._texture._uvs) {
	            return;
	        }

	        // if the number of points has changed we will need to recreate the arraybuffers
	        if (this.vertices.length / 4 !== points.length) {
	            this.vertices = new Float32Array(points.length * 4);
	            this.uvs = new Float32Array(points.length * 4);
	            this.colors = new Float32Array(points.length * 2);
	            this.indices = new Uint16Array(points.length * 2);
	        }

	        var uvs = this.uvs;

	        var indices = this.indices;
	        var colors = this.colors;

	        uvs[0] = 0;
	        uvs[1] = 0;
	        uvs[2] = 0;
	        uvs[3] = 1;

	        colors[0] = 1;
	        colors[1] = 1;

	        indices[0] = 0;
	        indices[1] = 1;

	        var total = points.length;

	        for (var i = 1; i < total; i++) {
	            // time to do some smart drawing!
	            var index = i * 4;
	            var amount = i / (total - 1);

	            uvs[index] = amount;
	            uvs[index + 1] = 0;

	            uvs[index + 2] = amount;
	            uvs[index + 3] = 1;

	            index = i * 2;
	            colors[index] = 1;
	            colors[index + 1] = 1;

	            index = i * 2;
	            indices[index] = index;
	            indices[index + 1] = index + 1;
	        }

	        // ensure that the changes are uploaded
	        this.dirty++;
	        this.indexDirty++;

	        this.multiplyUvs();
	        this.refreshVertices();
	    };

	    /**
	     * refreshes vertices of Rope mesh
	     */


	    Rope.prototype.refreshVertices = function refreshVertices() {
	        var points = this.points;

	        if (points.length < 1) {
	            return;
	        }

	        var lastPoint = points[0];
	        var nextPoint = void 0;
	        var perpX = 0;
	        var perpY = 0;

	        // this.count -= 0.2;

	        var vertices = this.vertices;
	        var total = points.length;

	        for (var i = 0; i < total; i++) {
	            var point = points[i];
	            var index = i * 4;

	            if (i < points.length - 1) {
	                nextPoint = points[i + 1];
	            } else {
	                nextPoint = point;
	            }

	            perpY = -(nextPoint.x - lastPoint.x);
	            perpX = nextPoint.y - lastPoint.y;

	            var ratio = (1 - i / (total - 1)) * 10;

	            if (ratio > 1) {
	                ratio = 1;
	            }

	            var perpLength = Math.sqrt(perpX * perpX + perpY * perpY);
	            var num = this._texture.height / 2; // (20 + Math.abs(Math.sin((i + this.count) * 0.3) * 50) )* ratio;

	            perpX /= perpLength;
	            perpY /= perpLength;

	            perpX *= num;
	            perpY *= num;

	            vertices[index] = point.x + perpX;
	            vertices[index + 1] = point.y + perpY;
	            vertices[index + 2] = point.x - perpX;
	            vertices[index + 3] = point.y - perpY;

	            lastPoint = point;
	        }
	    };

	    /**
	     * Updates the object transform for rendering
	     *
	     * @private
	     */


	    Rope.prototype.updateTransform = function updateTransform() {
	        if (this.autoUpdate) {
	            this.refreshVertices();
	        }
	        this.containerUpdateTransform();
	    };

	    return Rope;
	}(_Mesh3.default);

	exports.default = Rope;
	//# sourceMappingURL=Rope.js.map

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _ParticleContainer = __webpack_require__(346);

	Object.defineProperty(exports, 'ParticleContainer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ParticleContainer).default;
	  }
	});

	var _ParticleRenderer = __webpack_require__(347);

	Object.defineProperty(exports, 'ParticleRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ParticleRenderer).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=index.js.map

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _core = __webpack_require__(173);

	var core = _interopRequireWildcard(_core);

	var _utils = __webpack_require__(213);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	/**
	 * The ParticleContainer class is a really fast version of the Container built solely for speed,
	 * so use when you need a lot of sprites or particles. The tradeoff of the ParticleContainer is that most advanced
	 * functionality will not work. ParticleContainer implements the basic object transform (position, scale, rotation)
	 * and some advanced functionality like tint (as of v4.5.6).
	 * Other more advanced functionality like masking, children, filters, etc will not work on sprites in this batch.
	 *
	 * It's extremely easy to use :
	 *
	 * ```js
	 * let container = new ParticleContainer();
	 *
	 * for (let i = 0; i < 100; ++i)
	 * {
	 *     let sprite = new PIXI.Sprite.fromImage("myImage.png");
	 *     container.addChild(sprite);
	 * }
	 * ```
	 *
	 * And here you have a hundred sprites that will be rendered at the speed of light.
	 *
	 * @class
	 * @extends PIXI.Container
	 * @memberof PIXI.particles
	 */
	var ParticleContainer = function (_core$Container) {
	    _inherits(ParticleContainer, _core$Container);

	    /**
	     * @param {number} [maxSize=1500] - The maximum number of particles that can be rendered by the container.
	     *  Affects size of allocated buffers.
	     * @param {object} [properties] - The properties of children that should be uploaded to the gpu and applied.
	     * @param {boolean} [properties.vertices=false] - When true, vertices be uploaded and applied.
	     *                  if sprite's ` scale/anchor/trim/frame/orig` is dynamic, please set `true`.
	     * @param {boolean} [properties.position=true] - When true, position be uploaded and applied.
	     * @param {boolean} [properties.rotation=false] - When true, rotation be uploaded and applied.
	     * @param {boolean} [properties.uvs=false] - When true, uvs be uploaded and applied.
	     * @param {boolean} [properties.tint=false] - When true, alpha and tint be uploaded and applied.
	     * @param {number} [batchSize=16384] - Number of particles per batch. If less than maxSize, it uses maxSize instead.
	     * @param {boolean} [autoResize=false] If true, container allocates more batches in case
	     *  there are more than `maxSize` particles.
	     */
	    function ParticleContainer() {
	        var maxSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1500;
	        var properties = arguments[1];
	        var batchSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 16384;
	        var autoResize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

	        _classCallCheck(this, ParticleContainer);

	        // Making sure the batch size is valid
	        // 65535 is max vertex index in the index buffer (see ParticleRenderer)
	        // so max number of particles is 65536 / 4 = 16384
	        var _this = _possibleConstructorReturn(this, _core$Container.call(this));

	        var maxBatchSize = 16384;

	        if (batchSize > maxBatchSize) {
	            batchSize = maxBatchSize;
	        }

	        if (batchSize > maxSize) {
	            batchSize = maxSize;
	        }

	        /**
	         * Set properties to be dynamic (true) / static (false)
	         *
	         * @member {boolean[]}
	         * @private
	         */
	        _this._properties = [false, true, false, false, false];

	        /**
	         * @member {number}
	         * @private
	         */
	        _this._maxSize = maxSize;

	        /**
	         * @member {number}
	         * @private
	         */
	        _this._batchSize = batchSize;

	        /**
	         * @member {object<number, WebGLBuffer>}
	         * @private
	         */
	        _this._glBuffers = {};

	        /**
	         * for every batch stores _updateID corresponding to the last change in that batch
	         * @member {number[]}
	         * @private
	         */
	        _this._bufferUpdateIDs = [];

	        /**
	         * when child inserted, removed or changes position this number goes up
	         * @member {number[]}
	         * @private
	         */
	        _this._updateID = 0;

	        /**
	         * @member {boolean}
	         *
	         */
	        _this.interactiveChildren = false;

	        /**
	         * The blend mode to be applied to the sprite. Apply a value of `PIXI.BLEND_MODES.NORMAL`
	         * to reset the blend mode.
	         *
	         * @member {number}
	         * @default PIXI.BLEND_MODES.NORMAL
	         * @see PIXI.BLEND_MODES
	         */
	        _this.blendMode = core.BLEND_MODES.NORMAL;

	        /**
	         * If true, container allocates more batches in case there are more than `maxSize` particles.
	         * @member {boolean}
	         * @default false
	         */
	        _this.autoResize = autoResize;

	        /**
	         * Used for canvas renderering. If true then the elements will be positioned at the
	         * nearest pixel. This provides a nice speed boost.
	         *
	         * @member {boolean}
	         * @default true;
	         */
	        _this.roundPixels = true;

	        /**
	         * The texture used to render the children.
	         *
	         * @readonly
	         * @member {BaseTexture}
	         */
	        _this.baseTexture = null;

	        _this.setProperties(properties);

	        /**
	         * The tint applied to the container.
	         * This is a hex value. A value of 0xFFFFFF will remove any tint effect.
	         *
	         * @private
	         * @member {number}
	         * @default 0xFFFFFF
	         */
	        _this._tint = 0;
	        _this.tintRgb = new Float32Array(4);
	        _this.tint = 0xFFFFFF;
	        return _this;
	    }

	    /**
	     * Sets the private properties array to dynamic / static based on the passed properties object
	     *
	     * @param {object} properties - The properties to be uploaded
	     */


	    ParticleContainer.prototype.setProperties = function setProperties(properties) {
	        if (properties) {
	            this._properties[0] = 'vertices' in properties || 'scale' in properties ? !!properties.vertices || !!properties.scale : this._properties[0];
	            this._properties[1] = 'position' in properties ? !!properties.position : this._properties[1];
	            this._properties[2] = 'rotation' in properties ? !!properties.rotation : this._properties[2];
	            this._properties[3] = 'uvs' in properties ? !!properties.uvs : this._properties[3];
	            this._properties[4] = 'tint' in properties || 'alpha' in properties ? !!properties.tint || !!properties.alpha : this._properties[4];
	        }
	    };

	    /**
	     * Updates the object transform for rendering
	     *
	     * @private
	     */


	    ParticleContainer.prototype.updateTransform = function updateTransform() {
	        // TODO don't need to!
	        this.displayObjectUpdateTransform();
	        //  PIXI.Container.prototype.updateTransform.call( this );
	    };

	    /**
	     * The tint applied to the container. This is a hex value.
	     * A value of 0xFFFFFF will remove any tint effect.
	     ** IMPORTANT: This is a webGL only feature and will be ignored by the canvas renderer.
	     * @member {number}
	     * @default 0xFFFFFF
	     */


	    /**
	     * Renders the container using the WebGL renderer
	     *
	     * @private
	     * @param {PIXI.WebGLRenderer} renderer - The webgl renderer
	     */
	    ParticleContainer.prototype.renderWebGL = function renderWebGL(renderer) {
	        var _this2 = this;

	        if (!this.visible || this.worldAlpha <= 0 || !this.children.length || !this.renderable) {
	            return;
	        }

	        if (!this.baseTexture) {
	            this.baseTexture = this.children[0]._texture.baseTexture;
	            if (!this.baseTexture.hasLoaded) {
	                this.baseTexture.once('update', function () {
	                    return _this2.onChildrenChange(0);
	                });
	            }
	        }

	        renderer.setObjectRenderer(renderer.plugins.particle);
	        renderer.plugins.particle.render(this);
	    };

	    /**
	     * Set the flag that static data should be updated to true
	     *
	     * @private
	     * @param {number} smallestChildIndex - The smallest child index
	     */


	    ParticleContainer.prototype.onChildrenChange = function onChildrenChange(smallestChildIndex) {
	        var bufferIndex = Math.floor(smallestChildIndex / this._batchSize);

	        while (this._bufferUpdateIDs.length < bufferIndex) {
	            this._bufferUpdateIDs.push(0);
	        }
	        this._bufferUpdateIDs[bufferIndex] = ++this._updateID;
	    };

	    /**
	     * Renders the object using the Canvas renderer
	     *
	     * @private
	     * @param {PIXI.CanvasRenderer} renderer - The canvas renderer
	     */


	    ParticleContainer.prototype.renderCanvas = function renderCanvas(renderer) {
	        if (!this.visible || this.worldAlpha <= 0 || !this.children.length || !this.renderable) {
	            return;
	        }

	        var context = renderer.context;
	        var transform = this.worldTransform;
	        var isRotated = true;

	        var positionX = 0;
	        var positionY = 0;

	        var finalWidth = 0;
	        var finalHeight = 0;

	        renderer.setBlendMode(this.blendMode);

	        context.globalAlpha = this.worldAlpha;

	        this.displayObjectUpdateTransform();

	        for (var i = 0; i < this.children.length; ++i) {
	            var child = this.children[i];

	            if (!child.visible) {
	                continue;
	            }

	            var frame = child._texture.frame;

	            context.globalAlpha = this.worldAlpha * child.alpha;

	            if (child.rotation % (Math.PI * 2) === 0) {
	                // this is the fastest  way to optimise! - if rotation is 0 then we can avoid any kind of setTransform call
	                if (isRotated) {
	                    context.setTransform(transform.a, transform.b, transform.c, transform.d, transform.tx * renderer.resolution, transform.ty * renderer.resolution);

	                    isRotated = false;
	                }

	                positionX = child.anchor.x * (-frame.width * child.scale.x) + child.position.x + 0.5;
	                positionY = child.anchor.y * (-frame.height * child.scale.y) + child.position.y + 0.5;

	                finalWidth = frame.width * child.scale.x;
	                finalHeight = frame.height * child.scale.y;
	            } else {
	                if (!isRotated) {
	                    isRotated = true;
	                }

	                child.displayObjectUpdateTransform();

	                var childTransform = child.worldTransform;

	                if (renderer.roundPixels) {
	                    context.setTransform(childTransform.a, childTransform.b, childTransform.c, childTransform.d, childTransform.tx * renderer.resolution | 0, childTransform.ty * renderer.resolution | 0);
	                } else {
	                    context.setTransform(childTransform.a, childTransform.b, childTransform.c, childTransform.d, childTransform.tx * renderer.resolution, childTransform.ty * renderer.resolution);
	                }

	                positionX = child.anchor.x * -frame.width + 0.5;
	                positionY = child.anchor.y * -frame.height + 0.5;

	                finalWidth = frame.width;
	                finalHeight = frame.height;
	            }

	            var resolution = child._texture.baseTexture.resolution;

	            context.drawImage(child._texture.baseTexture.source, frame.x * resolution, frame.y * resolution, frame.width * resolution, frame.height * resolution, positionX * renderer.resolution, positionY * renderer.resolution, finalWidth * renderer.resolution, finalHeight * renderer.resolution);
	        }
	    };

	    /**
	     * Destroys the container
	     *
	     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
	     *  have been set to that value
	     * @param {boolean} [options.children=false] - if set to true, all the children will have their
	     *  destroy method called as well. 'options' will be passed on to those calls.
	     * @param {boolean} [options.texture=false] - Only used for child Sprites if options.children is set to true
	     *  Should it destroy the texture of the child sprite
	     * @param {boolean} [options.baseTexture=false] - Only used for child Sprites if options.children is set to true
	     *  Should it destroy the base texture of the child sprite
	     */


	    ParticleContainer.prototype.destroy = function destroy(options) {
	        _core$Container.prototype.destroy.call(this, options);

	        if (this._buffers) {
	            for (var i = 0; i < this._buffers.length; ++i) {
	                this._buffers[i].destroy();
	            }
	        }

	        this._properties = null;
	        this._buffers = null;
	        this._bufferUpdateIDs = null;
	    };

	    _createClass(ParticleContainer, [{
	        key: 'tint',
	        get: function get() {
	            return this._tint;
	        },
	        set: function set(value) // eslint-disable-line require-jsdoc
	        {
	            this._tint = value;
	            (0, _utils.hex2rgb)(value, this.tintRgb);
	        }
	    }]);

	    return ParticleContainer;
	}(core.Container);

	exports.default = ParticleContainer;
	//# sourceMappingURL=ParticleContainer.js.map

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _core = __webpack_require__(173);

	var core = _interopRequireWildcard(_core);

	var _ParticleShader = __webpack_require__(348);

	var _ParticleShader2 = _interopRequireDefault(_ParticleShader);

	var _ParticleBuffer = __webpack_require__(349);

	var _ParticleBuffer2 = _interopRequireDefault(_ParticleBuffer);

	var _utils = __webpack_require__(213);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	/**
	 * @author Mat Groves
	 *
	 * Big thanks to the very clever Matt DesLauriers <mattdesl> https://github.com/mattdesl/
	 * for creating the original PixiJS version!
	 * Also a thanks to https://github.com/bchevalier for tweaking the tint and alpha so that they now
	 * share 4 bytes on the vertex buffer
	 *
	 * Heavily inspired by LibGDX's ParticleRenderer:
	 * https://github.com/libgdx/libgdx/blob/master/gdx/src/com/badlogic/gdx/graphics/g2d/ParticleRenderer.java
	 */

	/**
	 *
	 * @class
	 * @private
	 * @memberof PIXI
	 */
	var ParticleRenderer = function (_core$ObjectRenderer) {
	    _inherits(ParticleRenderer, _core$ObjectRenderer);

	    /**
	     * @param {PIXI.WebGLRenderer} renderer - The renderer this sprite batch works for.
	     */
	    function ParticleRenderer(renderer) {
	        _classCallCheck(this, ParticleRenderer);

	        // 65535 is max vertex index in the index buffer (see ParticleRenderer)
	        // so max number of particles is 65536 / 4 = 16384
	        // and max number of element in the index buffer is 16384 * 6 = 98304
	        // Creating a full index buffer, overhead is 98304 * 2 = 196Ko
	        // let numIndices = 98304;

	        /**
	         * The default shader that is used if a sprite doesn't have a more specific one.
	         *
	         * @member {PIXI.Shader}
	         */
	        var _this = _possibleConstructorReturn(this, _core$ObjectRenderer.call(this, renderer));

	        _this.shader = null;

	        _this.indexBuffer = null;

	        _this.properties = null;

	        _this.tempMatrix = new core.Matrix();

	        _this.CONTEXT_UID = 0;
	        return _this;
	    }

	    /**
	     * When there is a WebGL context change
	     *
	     * @private
	     */


	    ParticleRenderer.prototype.onContextChange = function onContextChange() {
	        var gl = this.renderer.gl;

	        this.CONTEXT_UID = this.renderer.CONTEXT_UID;

	        // setup default shader
	        this.shader = new _ParticleShader2.default(gl);

	        this.properties = [
	        // verticesData
	        {
	            attribute: this.shader.attributes.aVertexPosition,
	            size: 2,
	            uploadFunction: this.uploadVertices,
	            offset: 0
	        },
	        // positionData
	        {
	            attribute: this.shader.attributes.aPositionCoord,
	            size: 2,
	            uploadFunction: this.uploadPosition,
	            offset: 0
	        },
	        // rotationData
	        {
	            attribute: this.shader.attributes.aRotation,
	            size: 1,
	            uploadFunction: this.uploadRotation,
	            offset: 0
	        },
	        // uvsData
	        {
	            attribute: this.shader.attributes.aTextureCoord,
	            size: 2,
	            uploadFunction: this.uploadUvs,
	            offset: 0
	        },
	        // tintData
	        {
	            attribute: this.shader.attributes.aColor,
	            size: 1,
	            unsignedByte: true,
	            uploadFunction: this.uploadTint,
	            offset: 0
	        }];
	    };

	    /**
	     * Starts a new particle batch.
	     *
	     */


	    ParticleRenderer.prototype.start = function start() {
	        this.renderer.bindShader(this.shader);
	    };

	    /**
	     * Renders the particle container object.
	     *
	     * @param {PIXI.ParticleContainer} container - The container to render using this ParticleRenderer
	     */


	    ParticleRenderer.prototype.render = function render(container) {
	        var children = container.children;
	        var maxSize = container._maxSize;
	        var batchSize = container._batchSize;
	        var renderer = this.renderer;
	        var totalChildren = children.length;

	        if (totalChildren === 0) {
	            return;
	        } else if (totalChildren > maxSize) {
	            totalChildren = maxSize;
	        }

	        var buffers = container._glBuffers[renderer.CONTEXT_UID];

	        if (!buffers) {
	            buffers = container._glBuffers[renderer.CONTEXT_UID] = this.generateBuffers(container);
	        }

	        var baseTexture = children[0]._texture.baseTexture;

	        // if the uvs have not updated then no point rendering just yet!
	        this.renderer.setBlendMode(core.utils.correctBlendMode(container.blendMode, baseTexture.premultipliedAlpha));

	        var gl = renderer.gl;

	        var m = container.worldTransform.copy(this.tempMatrix);

	        m.prepend(renderer._activeRenderTarget.projectionMatrix);

	        this.shader.uniforms.projectionMatrix = m.toArray(true);

	        this.shader.uniforms.uColor = core.utils.premultiplyRgba(container.tintRgb, container.worldAlpha, this.shader.uniforms.uColor, baseTexture.premultipliedAlpha);

	        // make sure the texture is bound..
	        this.shader.uniforms.uSampler = renderer.bindTexture(baseTexture);

	        var updateStatic = false;

	        // now lets upload and render the buffers..
	        for (var i = 0, j = 0; i < totalChildren; i += batchSize, j += 1) {
	            var amount = totalChildren - i;

	            if (amount > batchSize) {
	                amount = batchSize;
	            }

	            if (j >= buffers.length) {
	                if (!container.autoResize) {
	                    break;
	                }
	                buffers.push(this._generateOneMoreBuffer(container));
	            }

	            var buffer = buffers[j];

	            // we always upload the dynamic
	            buffer.uploadDynamic(children, i, amount);

	            var bid = container._bufferUpdateIDs[j] || 0;

	            updateStatic = updateStatic || buffer._updateID < bid;
	            // we only upload the static content when we have to!
	            if (updateStatic) {
	                buffer._updateID = container._updateID;
	                buffer.uploadStatic(children, i, amount);
	            }

	            // bind the buffer
	            renderer.bindVao(buffer.vao);
	            buffer.vao.draw(gl.TRIANGLES, amount * 6);
	        }
	    };

	    /**
	     * Creates one particle buffer for each child in the container we want to render and updates internal properties
	     *
	     * @param {PIXI.ParticleContainer} container - The container to render using this ParticleRenderer
	     * @return {PIXI.ParticleBuffer[]} The buffers
	     */


	    ParticleRenderer.prototype.generateBuffers = function generateBuffers(container) {
	        var gl = this.renderer.gl;
	        var buffers = [];
	        var size = container._maxSize;
	        var batchSize = container._batchSize;
	        var dynamicPropertyFlags = container._properties;

	        for (var i = 0; i < size; i += batchSize) {
	            buffers.push(new _ParticleBuffer2.default(gl, this.properties, dynamicPropertyFlags, batchSize));
	        }

	        return buffers;
	    };

	    /**
	     * Creates one more particle buffer, because container has autoResize feature
	     *
	     * @param {PIXI.ParticleContainer} container - The container to render using this ParticleRenderer
	     * @return {PIXI.ParticleBuffer} generated buffer
	     * @private
	     */


	    ParticleRenderer.prototype._generateOneMoreBuffer = function _generateOneMoreBuffer(container) {
	        var gl = this.renderer.gl;
	        var batchSize = container._batchSize;
	        var dynamicPropertyFlags = container._properties;

	        return new _ParticleBuffer2.default(gl, this.properties, dynamicPropertyFlags, batchSize);
	    };

	    /**
	     * Uploads the verticies.
	     *
	     * @param {PIXI.DisplayObject[]} children - the array of display objects to render
	     * @param {number} startIndex - the index to start from in the children array
	     * @param {number} amount - the amount of children that will have their vertices uploaded
	     * @param {number[]} array - The vertices to upload.
	     * @param {number} stride - Stride to use for iteration.
	     * @param {number} offset - Offset to start at.
	     */


	    ParticleRenderer.prototype.uploadVertices = function uploadVertices(children, startIndex, amount, array, stride, offset) {
	        var w0 = 0;
	        var w1 = 0;
	        var h0 = 0;
	        var h1 = 0;

	        for (var i = 0; i < amount; ++i) {
	            var sprite = children[startIndex + i];
	            var texture = sprite._texture;
	            var sx = sprite.scale.x;
	            var sy = sprite.scale.y;
	            var trim = texture.trim;
	            var orig = texture.orig;

	            if (trim) {
	                // if the sprite is trimmed and is not a tilingsprite then we need to add the
	                // extra space before transforming the sprite coords..
	                w1 = trim.x - sprite.anchor.x * orig.width;
	                w0 = w1 + trim.width;

	                h1 = trim.y - sprite.anchor.y * orig.height;
	                h0 = h1 + trim.height;
	            } else {
	                w0 = orig.width * (1 - sprite.anchor.x);
	                w1 = orig.width * -sprite.anchor.x;

	                h0 = orig.height * (1 - sprite.anchor.y);
	                h1 = orig.height * -sprite.anchor.y;
	            }

	            array[offset] = w1 * sx;
	            array[offset + 1] = h1 * sy;

	            array[offset + stride] = w0 * sx;
	            array[offset + stride + 1] = h1 * sy;

	            array[offset + stride * 2] = w0 * sx;
	            array[offset + stride * 2 + 1] = h0 * sy;

	            array[offset + stride * 3] = w1 * sx;
	            array[offset + stride * 3 + 1] = h0 * sy;

	            offset += stride * 4;
	        }
	    };

	    /**
	     *
	     * @param {PIXI.DisplayObject[]} children - the array of display objects to render
	     * @param {number} startIndex - the index to start from in the children array
	     * @param {number} amount - the amount of children that will have their positions uploaded
	     * @param {number[]} array - The vertices to upload.
	     * @param {number} stride - Stride to use for iteration.
	     * @param {number} offset - Offset to start at.
	     */


	    ParticleRenderer.prototype.uploadPosition = function uploadPosition(children, startIndex, amount, array, stride, offset) {
	        for (var i = 0; i < amount; i++) {
	            var spritePosition = children[startIndex + i].position;

	            array[offset] = spritePosition.x;
	            array[offset + 1] = spritePosition.y;

	            array[offset + stride] = spritePosition.x;
	            array[offset + stride + 1] = spritePosition.y;

	            array[offset + stride * 2] = spritePosition.x;
	            array[offset + stride * 2 + 1] = spritePosition.y;

	            array[offset + stride * 3] = spritePosition.x;
	            array[offset + stride * 3 + 1] = spritePosition.y;

	            offset += stride * 4;
	        }
	    };

	    /**
	     *
	     * @param {PIXI.DisplayObject[]} children - the array of display objects to render
	     * @param {number} startIndex - the index to start from in the children array
	     * @param {number} amount - the amount of children that will have their rotation uploaded
	     * @param {number[]} array - The vertices to upload.
	     * @param {number} stride - Stride to use for iteration.
	     * @param {number} offset - Offset to start at.
	     */


	    ParticleRenderer.prototype.uploadRotation = function uploadRotation(children, startIndex, amount, array, stride, offset) {
	        for (var i = 0; i < amount; i++) {
	            var spriteRotation = children[startIndex + i].rotation;

	            array[offset] = spriteRotation;
	            array[offset + stride] = spriteRotation;
	            array[offset + stride * 2] = spriteRotation;
	            array[offset + stride * 3] = spriteRotation;

	            offset += stride * 4;
	        }
	    };

	    /**
	     *
	     * @param {PIXI.DisplayObject[]} children - the array of display objects to render
	     * @param {number} startIndex - the index to start from in the children array
	     * @param {number} amount - the amount of children that will have their rotation uploaded
	     * @param {number[]} array - The vertices to upload.
	     * @param {number} stride - Stride to use for iteration.
	     * @param {number} offset - Offset to start at.
	     */


	    ParticleRenderer.prototype.uploadUvs = function uploadUvs(children, startIndex, amount, array, stride, offset) {
	        for (var i = 0; i < amount; ++i) {
	            var textureUvs = children[startIndex + i]._texture._uvs;

	            if (textureUvs) {
	                array[offset] = textureUvs.x0;
	                array[offset + 1] = textureUvs.y0;

	                array[offset + stride] = textureUvs.x1;
	                array[offset + stride + 1] = textureUvs.y1;

	                array[offset + stride * 2] = textureUvs.x2;
	                array[offset + stride * 2 + 1] = textureUvs.y2;

	                array[offset + stride * 3] = textureUvs.x3;
	                array[offset + stride * 3 + 1] = textureUvs.y3;

	                offset += stride * 4;
	            } else {
	                // TODO you know this can be easier!
	                array[offset] = 0;
	                array[offset + 1] = 0;

	                array[offset + stride] = 0;
	                array[offset + stride + 1] = 0;

	                array[offset + stride * 2] = 0;
	                array[offset + stride * 2 + 1] = 0;

	                array[offset + stride * 3] = 0;
	                array[offset + stride * 3 + 1] = 0;

	                offset += stride * 4;
	            }
	        }
	    };

	    /**
	     *
	     * @param {PIXI.DisplayObject[]} children - the array of display objects to render
	     * @param {number} startIndex - the index to start from in the children array
	     * @param {number} amount - the amount of children that will have their rotation uploaded
	     * @param {number[]} array - The vertices to upload.
	     * @param {number} stride - Stride to use for iteration.
	     * @param {number} offset - Offset to start at.
	     */


	    ParticleRenderer.prototype.uploadTint = function uploadTint(children, startIndex, amount, array, stride, offset) {
	        for (var i = 0; i < amount; ++i) {
	            var sprite = children[startIndex + i];
	            var premultiplied = sprite._texture.baseTexture.premultipliedAlpha;
	            var alpha = sprite.alpha;
	            // we dont call extra function if alpha is 1.0, that's faster
	            var argb = alpha < 1.0 && premultiplied ? (0, _utils.premultiplyTint)(sprite._tintRGB, alpha) : sprite._tintRGB + (alpha * 255 << 24);

	            array[offset] = argb;
	            array[offset + stride] = argb;
	            array[offset + stride * 2] = argb;
	            array[offset + stride * 3] = argb;

	            offset += stride * 4;
	        }
	    };

	    /**
	     * Destroys the ParticleRenderer.
	     *
	     */


	    ParticleRenderer.prototype.destroy = function destroy() {
	        if (this.renderer.gl) {
	            this.renderer.gl.deleteBuffer(this.indexBuffer);
	        }

	        _core$ObjectRenderer.prototype.destroy.call(this);

	        this.shader.destroy();

	        this.indices = null;
	        this.tempMatrix = null;
	    };

	    return ParticleRenderer;
	}(core.ObjectRenderer);

	exports.default = ParticleRenderer;


	core.WebGLRenderer.registerPlugin('particle', ParticleRenderer);
	//# sourceMappingURL=ParticleRenderer.js.map

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _Shader2 = __webpack_require__(262);

	var _Shader3 = _interopRequireDefault(_Shader2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	/**
	 * @class
	 * @extends PIXI.Shader
	 * @memberof PIXI
	 */
	var ParticleShader = function (_Shader) {
	    _inherits(ParticleShader, _Shader);

	    /**
	     * @param {PIXI.Shader} gl - The webgl shader manager this shader works for.
	     */
	    function ParticleShader(gl) {
	        _classCallCheck(this, ParticleShader);

	        return _possibleConstructorReturn(this, _Shader.call(this, gl,
	        // vertex shader
	        ['attribute vec2 aVertexPosition;', 'attribute vec2 aTextureCoord;', 'attribute vec4 aColor;', 'attribute vec2 aPositionCoord;', 'attribute float aRotation;', 'uniform mat3 projectionMatrix;', 'uniform vec4 uColor;', 'varying vec2 vTextureCoord;', 'varying vec4 vColor;', 'void main(void){', '   float x = (aVertexPosition.x) * cos(aRotation) - (aVertexPosition.y) * sin(aRotation);', '   float y = (aVertexPosition.x) * sin(aRotation) + (aVertexPosition.y) * cos(aRotation);', '   vec2 v = vec2(x, y);', '   v = v + aPositionCoord;', '   gl_Position = vec4((projectionMatrix * vec3(v, 1.0)).xy, 0.0, 1.0);', '   vTextureCoord = aTextureCoord;', '   vColor = aColor * uColor;', '}'].join('\n'),
	        // hello
	        ['varying vec2 vTextureCoord;', 'varying vec4 vColor;', 'uniform sampler2D uSampler;', 'void main(void){', '  vec4 color = texture2D(uSampler, vTextureCoord) * vColor;', '  gl_FragColor = color;', '}'].join('\n')));
	    }

	    return ParticleShader;
	}(_Shader3.default);

	exports.default = ParticleShader;
	//# sourceMappingURL=ParticleShader.js.map

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _pixiGlCore = __webpack_require__(185);

	var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);

	var _createIndicesForQuads = __webpack_require__(261);

	var _createIndicesForQuads2 = _interopRequireDefault(_createIndicesForQuads);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/**
	 * @author Mat Groves
	 *
	 * Big thanks to the very clever Matt DesLauriers <mattdesl> https://github.com/mattdesl/
	 * for creating the original PixiJS version!
	 * Also a thanks to https://github.com/bchevalier for tweaking the tint and alpha so that
	 * they now share 4 bytes on the vertex buffer
	 *
	 * Heavily inspired by LibGDX's ParticleBuffer:
	 * https://github.com/libgdx/libgdx/blob/master/gdx/src/com/badlogic/gdx/graphics/g2d/ParticleBuffer.java
	 */

	/**
	 * The particle buffer manages the static and dynamic buffers for a particle container.
	 *
	 * @class
	 * @private
	 * @memberof PIXI
	 */
	var ParticleBuffer = function () {
	    /**
	     * @param {WebGLRenderingContext} gl - The rendering context.
	     * @param {object} properties - The properties to upload.
	     * @param {boolean[]} dynamicPropertyFlags - Flags for which properties are dynamic.
	     * @param {number} size - The size of the batch.
	     */
	    function ParticleBuffer(gl, properties, dynamicPropertyFlags, size) {
	        _classCallCheck(this, ParticleBuffer);

	        /**
	         * The current WebGL drawing context.
	         *
	         * @member {WebGLRenderingContext}
	         */
	        this.gl = gl;

	        /**
	         * The number of particles the buffer can hold
	         *
	         * @member {number}
	         */
	        this.size = size;

	        /**
	         * A list of the properties that are dynamic.
	         *
	         * @member {object[]}
	         */
	        this.dynamicProperties = [];

	        /**
	         * A list of the properties that are static.
	         *
	         * @member {object[]}
	         */
	        this.staticProperties = [];

	        for (var i = 0; i < properties.length; ++i) {
	            var property = properties[i];

	            // Make copy of properties object so that when we edit the offset it doesn't
	            // change all other instances of the object literal
	            property = {
	                attribute: property.attribute,
	                size: property.size,
	                uploadFunction: property.uploadFunction,
	                unsignedByte: property.unsignedByte,
	                offset: property.offset
	            };

	            if (dynamicPropertyFlags[i]) {
	                this.dynamicProperties.push(property);
	            } else {
	                this.staticProperties.push(property);
	            }
	        }

	        this.staticStride = 0;
	        this.staticBuffer = null;
	        this.staticData = null;
	        this.staticDataUint32 = null;

	        this.dynamicStride = 0;
	        this.dynamicBuffer = null;
	        this.dynamicData = null;
	        this.dynamicDataUint32 = null;

	        this._updateID = 0;

	        this.initBuffers();
	    }

	    /**
	     * Sets up the renderer context and necessary buffers.
	     *
	     * @private
	     */


	    ParticleBuffer.prototype.initBuffers = function initBuffers() {
	        var gl = this.gl;
	        var dynamicOffset = 0;

	        /**
	         * Holds the indices of the geometry (quads) to draw
	         *
	         * @member {Uint16Array}
	         */
	        this.indices = (0, _createIndicesForQuads2.default)(this.size);
	        this.indexBuffer = _pixiGlCore2.default.GLBuffer.createIndexBuffer(gl, this.indices, gl.STATIC_DRAW);

	        this.dynamicStride = 0;

	        for (var i = 0; i < this.dynamicProperties.length; ++i) {
	            var property = this.dynamicProperties[i];

	            property.offset = dynamicOffset;
	            dynamicOffset += property.size;
	            this.dynamicStride += property.size;
	        }

	        var dynBuffer = new ArrayBuffer(this.size * this.dynamicStride * 4 * 4);

	        this.dynamicData = new Float32Array(dynBuffer);
	        this.dynamicDataUint32 = new Uint32Array(dynBuffer);
	        this.dynamicBuffer = _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl, dynBuffer, gl.STREAM_DRAW);

	        // static //
	        var staticOffset = 0;

	        this.staticStride = 0;

	        for (var _i = 0; _i < this.staticProperties.length; ++_i) {
	            var _property = this.staticProperties[_i];

	            _property.offset = staticOffset;
	            staticOffset += _property.size;
	            this.staticStride += _property.size;
	        }

	        var statBuffer = new ArrayBuffer(this.size * this.staticStride * 4 * 4);

	        this.staticData = new Float32Array(statBuffer);
	        this.staticDataUint32 = new Uint32Array(statBuffer);
	        this.staticBuffer = _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl, statBuffer, gl.STATIC_DRAW);

	        this.vao = new _pixiGlCore2.default.VertexArrayObject(gl).addIndex(this.indexBuffer);

	        for (var _i2 = 0; _i2 < this.dynamicProperties.length; ++_i2) {
	            var _property2 = this.dynamicProperties[_i2];

	            if (_property2.unsignedByte) {
	                this.vao.addAttribute(this.dynamicBuffer, _property2.attribute, gl.UNSIGNED_BYTE, true, this.dynamicStride * 4, _property2.offset * 4);
	            } else {
	                this.vao.addAttribute(this.dynamicBuffer, _property2.attribute, gl.FLOAT, false, this.dynamicStride * 4, _property2.offset * 4);
	            }
	        }

	        for (var _i3 = 0; _i3 < this.staticProperties.length; ++_i3) {
	            var _property3 = this.staticProperties[_i3];

	            if (_property3.unsignedByte) {
	                this.vao.addAttribute(this.staticBuffer, _property3.attribute, gl.UNSIGNED_BYTE, true, this.staticStride * 4, _property3.offset * 4);
	            } else {
	                this.vao.addAttribute(this.staticBuffer, _property3.attribute, gl.FLOAT, false, this.staticStride * 4, _property3.offset * 4);
	            }
	        }
	    };

	    /**
	     * Uploads the dynamic properties.
	     *
	     * @param {PIXI.DisplayObject[]} children - The children to upload.
	     * @param {number} startIndex - The index to start at.
	     * @param {number} amount - The number to upload.
	     */


	    ParticleBuffer.prototype.uploadDynamic = function uploadDynamic(children, startIndex, amount) {
	        for (var i = 0; i < this.dynamicProperties.length; i++) {
	            var property = this.dynamicProperties[i];

	            property.uploadFunction(children, startIndex, amount, property.unsignedByte ? this.dynamicDataUint32 : this.dynamicData, this.dynamicStride, property.offset);
	        }

	        this.dynamicBuffer.upload();
	    };

	    /**
	     * Uploads the static properties.
	     *
	     * @param {PIXI.DisplayObject[]} children - The children to upload.
	     * @param {number} startIndex - The index to start at.
	     * @param {number} amount - The number to upload.
	     */


	    ParticleBuffer.prototype.uploadStatic = function uploadStatic(children, startIndex, amount) {
	        for (var i = 0; i < this.staticProperties.length; i++) {
	            var property = this.staticProperties[i];

	            property.uploadFunction(children, startIndex, amount, property.unsignedByte ? this.staticDataUint32 : this.staticData, this.staticStride, property.offset);
	        }

	        this.staticBuffer.upload();
	    };

	    /**
	     * Destroys the ParticleBuffer.
	     *
	     */


	    ParticleBuffer.prototype.destroy = function destroy() {
	        this.dynamicProperties = null;
	        this.dynamicBuffer.destroy();
	        this.dynamicBuffer = null;
	        this.dynamicData = null;
	        this.dynamicDataUint32 = null;

	        this.staticProperties = null;
	        this.staticBuffer.destroy();
	        this.staticBuffer = null;
	        this.staticData = null;
	        this.staticDataUint32 = null;
	    };

	    return ParticleBuffer;
	}();

	exports.default = ParticleBuffer;
	//# sourceMappingURL=ParticleBuffer.js.map

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _WebGLPrepare = __webpack_require__(351);

	Object.defineProperty(exports, 'webgl', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_WebGLPrepare).default;
	  }
	});

	var _CanvasPrepare = __webpack_require__(354);

	Object.defineProperty(exports, 'canvas', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CanvasPrepare).default;
	  }
	});

	var _BasePrepare = __webpack_require__(352);

	Object.defineProperty(exports, 'BasePrepare', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BasePrepare).default;
	  }
	});

	var _CountLimiter = __webpack_require__(353);

	Object.defineProperty(exports, 'CountLimiter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CountLimiter).default;
	  }
	});

	var _TimeLimiter = __webpack_require__(355);

	Object.defineProperty(exports, 'TimeLimiter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TimeLimiter).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=index.js.map

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _core = __webpack_require__(173);

	var core = _interopRequireWildcard(_core);

	var _BasePrepare2 = __webpack_require__(352);

	var _BasePrepare3 = _interopRequireDefault(_BasePrepare2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	/**
	 * The prepare manager provides functionality to upload content to the GPU.
	 *
	 * An instance of this class is automatically created by default, and can be found at renderer.plugins.prepare
	 *
	 * @class
	 * @extends PIXI.prepare.BasePrepare
	 * @memberof PIXI.prepare
	 */
	var WebGLPrepare = function (_BasePrepare) {
	    _inherits(WebGLPrepare, _BasePrepare);

	    /**
	     * @param {PIXI.WebGLRenderer} renderer - A reference to the current renderer
	     */
	    function WebGLPrepare(renderer) {
	        _classCallCheck(this, WebGLPrepare);

	        var _this = _possibleConstructorReturn(this, _BasePrepare.call(this, renderer));

	        _this.uploadHookHelper = _this.renderer;

	        // Add textures and graphics to upload
	        _this.registerFindHook(findGraphics);
	        _this.registerUploadHook(uploadBaseTextures);
	        _this.registerUploadHook(uploadGraphics);
	        return _this;
	    }

	    return WebGLPrepare;
	}(_BasePrepare3.default);
	/**
	 * Built-in hook to upload PIXI.Texture objects to the GPU.
	 *
	 * @private
	 * @param {PIXI.WebGLRenderer} renderer - instance of the webgl renderer
	 * @param {PIXI.DisplayObject} item - Item to check
	 * @return {boolean} If item was uploaded.
	 */


	exports.default = WebGLPrepare;
	function uploadBaseTextures(renderer, item) {
	    if (item instanceof core.BaseTexture) {
	        // if the texture already has a GL texture, then the texture has been prepared or rendered
	        // before now. If the texture changed, then the changer should be calling texture.update() which
	        // reuploads the texture without need for preparing it again
	        if (!item._glTextures[renderer.CONTEXT_UID]) {
	            renderer.textureManager.updateTexture(item);
	        }

	        return true;
	    }

	    return false;
	}

	/**
	 * Built-in hook to upload PIXI.Graphics to the GPU.
	 *
	 * @private
	 * @param {PIXI.WebGLRenderer} renderer - instance of the webgl renderer
	 * @param {PIXI.DisplayObject} item - Item to check
	 * @return {boolean} If item was uploaded.
	 */
	function uploadGraphics(renderer, item) {
	    if (item instanceof core.Graphics) {
	        // if the item is not dirty and already has webgl data, then it got prepared or rendered
	        // before now and we shouldn't waste time updating it again
	        if (item.dirty || item.clearDirty || !item._webGL[renderer.plugins.graphics.CONTEXT_UID]) {
	            renderer.plugins.graphics.updateGraphics(item);
	        }

	        return true;
	    }

	    return false;
	}

	/**
	 * Built-in hook to find graphics.
	 *
	 * @private
	 * @param {PIXI.DisplayObject} item - Display object to check
	 * @param {Array<*>} queue - Collection of items to upload
	 * @return {boolean} if a PIXI.Graphics object was found.
	 */
	function findGraphics(item, queue) {
	    if (item instanceof core.Graphics) {
	        queue.push(item);

	        return true;
	    }

	    return false;
	}

	core.WebGLRenderer.registerPlugin('prepare', WebGLPrepare);
	//# sourceMappingURL=WebGLPrepare.js.map

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _core = __webpack_require__(173);

	var core = _interopRequireWildcard(_core);

	var _CountLimiter = __webpack_require__(353);

	var _CountLimiter2 = _interopRequireDefault(_CountLimiter);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var SharedTicker = core.ticker.shared;

	/**
	 * Default number of uploads per frame using prepare plugin.
	 *
	 * @static
	 * @memberof PIXI.settings
	 * @name UPLOADS_PER_FRAME
	 * @type {number}
	 * @default 4
	 */
	core.settings.UPLOADS_PER_FRAME = 4;

	/**
	 * The prepare manager provides functionality to upload content to the GPU. BasePrepare handles
	 * basic queuing functionality and is extended by {@link PIXI.prepare.WebGLPrepare} and {@link PIXI.prepare.CanvasPrepare}
	 * to provide preparation capabilities specific to their respective renderers.
	 *
	 * @example
	 * // Create a sprite
	 * const sprite = new PIXI.Sprite.fromImage('something.png');
	 *
	 * // Load object into GPU
	 * app.renderer.plugins.prepare.upload(sprite, () => {
	 *
	 *     //Texture(s) has been uploaded to GPU
	 *     app.stage.addChild(sprite);
	 *
	 * })
	 *
	 * @abstract
	 * @class
	 * @memberof PIXI.prepare
	 */

	var BasePrepare = function () {
	    /**
	     * @param {PIXI.SystemRenderer} renderer - A reference to the current renderer
	     */
	    function BasePrepare(renderer) {
	        var _this = this;

	        _classCallCheck(this, BasePrepare);

	        /**
	         * The limiter to be used to control how quickly items are prepared.
	         * @type {PIXI.prepare.CountLimiter|PIXI.prepare.TimeLimiter}
	         */
	        this.limiter = new _CountLimiter2.default(core.settings.UPLOADS_PER_FRAME);

	        /**
	         * Reference to the renderer.
	         * @type {PIXI.SystemRenderer}
	         * @protected
	         */
	        this.renderer = renderer;

	        /**
	         * The only real difference between CanvasPrepare and WebGLPrepare is what they pass
	         * to upload hooks. That different parameter is stored here.
	         * @type {PIXI.prepare.CanvasPrepare|PIXI.WebGLRenderer}
	         * @protected
	         */
	        this.uploadHookHelper = null;

	        /**
	         * Collection of items to uploads at once.
	         * @type {Array<*>}
	         * @private
	         */
	        this.queue = [];

	        /**
	         * Collection of additional hooks for finding assets.
	         * @type {Array<Function>}
	         * @private
	         */
	        this.addHooks = [];

	        /**
	         * Collection of additional hooks for processing assets.
	         * @type {Array<Function>}
	         * @private
	         */
	        this.uploadHooks = [];

	        /**
	         * Callback to call after completed.
	         * @type {Array<Function>}
	         * @private
	         */
	        this.completes = [];

	        /**
	         * If prepare is ticking (running).
	         * @type {boolean}
	         * @private
	         */
	        this.ticking = false;

	        /**
	         * 'bound' call for prepareItems().
	         * @type {Function}
	         * @private
	         */
	        this.delayedTick = function () {
	            // unlikely, but in case we were destroyed between tick() and delayedTick()
	            if (!_this.queue) {
	                return;
	            }
	            _this.prepareItems();
	        };

	        // hooks to find the correct texture
	        this.registerFindHook(findText);
	        this.registerFindHook(findTextStyle);
	        this.registerFindHook(findMultipleBaseTextures);
	        this.registerFindHook(findBaseTexture);
	        this.registerFindHook(findTexture);

	        // upload hooks
	        this.registerUploadHook(drawText);
	        this.registerUploadHook(calculateTextStyle);
	    }

	    /**
	     * Upload all the textures and graphics to the GPU.
	     *
	     * @param {Function|PIXI.DisplayObject|PIXI.Container|PIXI.BaseTexture|PIXI.Texture|PIXI.Graphics|PIXI.Text} item -
	     *        Either the container or display object to search for items to upload, the items to upload themselves,
	     *        or the callback function, if items have been added using `prepare.add`.
	     * @param {Function} [done] - Optional callback when all queued uploads have completed
	     */


	    BasePrepare.prototype.upload = function upload(item, done) {
	        if (typeof item === 'function') {
	            done = item;
	            item = null;
	        }

	        // If a display object, search for items
	        // that we could upload
	        if (item) {
	            this.add(item);
	        }

	        // Get the items for upload from the display
	        if (this.queue.length) {
	            if (done) {
	                this.completes.push(done);
	            }

	            if (!this.ticking) {
	                this.ticking = true;
	                SharedTicker.addOnce(this.tick, this, core.UPDATE_PRIORITY.UTILITY);
	            }
	        } else if (done) {
	            done();
	        }
	    };

	    /**
	     * Handle tick update
	     *
	     * @private
	     */


	    BasePrepare.prototype.tick = function tick() {
	        setTimeout(this.delayedTick, 0);
	    };

	    /**
	     * Actually prepare items. This is handled outside of the tick because it will take a while
	     * and we do NOT want to block the current animation frame from rendering.
	     *
	     * @private
	     */


	    BasePrepare.prototype.prepareItems = function prepareItems() {
	        this.limiter.beginFrame();
	        // Upload the graphics
	        while (this.queue.length && this.limiter.allowedToUpload()) {
	            var item = this.queue[0];
	            var uploaded = false;

	            if (item && !item._destroyed) {
	                for (var i = 0, len = this.uploadHooks.length; i < len; i++) {
	                    if (this.uploadHooks[i](this.uploadHookHelper, item)) {
	                        this.queue.shift();
	                        uploaded = true;
	                        break;
	                    }
	                }
	            }

	            if (!uploaded) {
	                this.queue.shift();
	            }
	        }

	        // We're finished
	        if (!this.queue.length) {
	            this.ticking = false;

	            var completes = this.completes.slice(0);

	            this.completes.length = 0;

	            for (var _i = 0, _len = completes.length; _i < _len; _i++) {
	                completes[_i]();
	            }
	        } else {
	            // if we are not finished, on the next rAF do this again
	            SharedTicker.addOnce(this.tick, this, core.UPDATE_PRIORITY.UTILITY);
	        }
	    };

	    /**
	     * Adds hooks for finding items.
	     *
	     * @param {Function} addHook - Function call that takes two parameters: `item:*, queue:Array`
	     *          function must return `true` if it was able to add item to the queue.
	     * @return {PIXI.BasePrepare} Instance of plugin for chaining.
	     */


	    BasePrepare.prototype.registerFindHook = function registerFindHook(addHook) {
	        if (addHook) {
	            this.addHooks.push(addHook);
	        }

	        return this;
	    };

	    /**
	     * Adds hooks for uploading items.
	     *
	     * @param {Function} uploadHook - Function call that takes two parameters: `prepare:CanvasPrepare, item:*` and
	     *          function must return `true` if it was able to handle upload of item.
	     * @return {PIXI.BasePrepare} Instance of plugin for chaining.
	     */


	    BasePrepare.prototype.registerUploadHook = function registerUploadHook(uploadHook) {
	        if (uploadHook) {
	            this.uploadHooks.push(uploadHook);
	        }

	        return this;
	    };

	    /**
	     * Manually add an item to the uploading queue.
	     *
	     * @param {PIXI.DisplayObject|PIXI.Container|PIXI.BaseTexture|PIXI.Texture|PIXI.Graphics|PIXI.Text|*} item - Object to
	     *        add to the queue
	     * @return {PIXI.CanvasPrepare} Instance of plugin for chaining.
	     */


	    BasePrepare.prototype.add = function add(item) {
	        // Add additional hooks for finding elements on special
	        // types of objects that
	        for (var i = 0, len = this.addHooks.length; i < len; i++) {
	            if (this.addHooks[i](item, this.queue)) {
	                break;
	            }
	        }

	        // Get childen recursively
	        if (item instanceof core.Container) {
	            for (var _i2 = item.children.length - 1; _i2 >= 0; _i2--) {
	                this.add(item.children[_i2]);
	            }
	        }

	        return this;
	    };

	    /**
	     * Destroys the plugin, don't use after this.
	     *
	     */


	    BasePrepare.prototype.destroy = function destroy() {
	        if (this.ticking) {
	            SharedTicker.remove(this.tick, this);
	        }
	        this.ticking = false;
	        this.addHooks = null;
	        this.uploadHooks = null;
	        this.renderer = null;
	        this.completes = null;
	        this.queue = null;
	        this.limiter = null;
	        this.uploadHookHelper = null;
	    };

	    return BasePrepare;
	}();

	/**
	 * Built-in hook to find multiple textures from objects like AnimatedSprites.
	 *
	 * @private
	 * @param {PIXI.DisplayObject} item - Display object to check
	 * @param {Array<*>} queue - Collection of items to upload
	 * @return {boolean} if a PIXI.Texture object was found.
	 */


	exports.default = BasePrepare;
	function findMultipleBaseTextures(item, queue) {
	    var result = false;

	    // Objects with mutliple textures
	    if (item && item._textures && item._textures.length) {
	        for (var i = 0; i < item._textures.length; i++) {
	            if (item._textures[i] instanceof core.Texture) {
	                var baseTexture = item._textures[i].baseTexture;

	                if (queue.indexOf(baseTexture) === -1) {
	                    queue.push(baseTexture);
	                    result = true;
	                }
	            }
	        }
	    }

	    return result;
	}

	/**
	 * Built-in hook to find BaseTextures from Sprites.
	 *
	 * @private
	 * @param {PIXI.DisplayObject} item - Display object to check
	 * @param {Array<*>} queue - Collection of items to upload
	 * @return {boolean} if a PIXI.Texture object was found.
	 */
	function findBaseTexture(item, queue) {
	    // Objects with textures, like Sprites/Text
	    if (item instanceof core.BaseTexture) {
	        if (queue.indexOf(item) === -1) {
	            queue.push(item);
	        }

	        return true;
	    }

	    return false;
	}

	/**
	 * Built-in hook to find textures from objects.
	 *
	 * @private
	 * @param {PIXI.DisplayObject} item - Display object to check
	 * @param {Array<*>} queue - Collection of items to upload
	 * @return {boolean} if a PIXI.Texture object was found.
	 */
	function findTexture(item, queue) {
	    if (item._texture && item._texture instanceof core.Texture) {
	        var texture = item._texture.baseTexture;

	        if (queue.indexOf(texture) === -1) {
	            queue.push(texture);
	        }

	        return true;
	    }

	    return false;
	}

	/**
	 * Built-in hook to draw PIXI.Text to its texture.
	 *
	 * @private
	 * @param {PIXI.WebGLRenderer|PIXI.CanvasPrepare} helper - Not used by this upload handler
	 * @param {PIXI.DisplayObject} item - Item to check
	 * @return {boolean} If item was uploaded.
	 */
	function drawText(helper, item) {
	    if (item instanceof core.Text) {
	        // updating text will return early if it is not dirty
	        item.updateText(true);

	        return true;
	    }

	    return false;
	}

	/**
	 * Built-in hook to calculate a text style for a PIXI.Text object.
	 *
	 * @private
	 * @param {PIXI.WebGLRenderer|PIXI.CanvasPrepare} helper - Not used by this upload handler
	 * @param {PIXI.DisplayObject} item - Item to check
	 * @return {boolean} If item was uploaded.
	 */
	function calculateTextStyle(helper, item) {
	    if (item instanceof core.TextStyle) {
	        var font = item.toFontString();

	        core.TextMetrics.measureFont(font);

	        return true;
	    }

	    return false;
	}

	/**
	 * Built-in hook to find Text objects.
	 *
	 * @private
	 * @param {PIXI.DisplayObject} item - Display object to check
	 * @param {Array<*>} queue - Collection of items to upload
	 * @return {boolean} if a PIXI.Text object was found.
	 */
	function findText(item, queue) {
	    if (item instanceof core.Text) {
	        // push the text style to prepare it - this can be really expensive
	        if (queue.indexOf(item.style) === -1) {
	            queue.push(item.style);
	        }
	        // also push the text object so that we can render it (to canvas/texture) if needed
	        if (queue.indexOf(item) === -1) {
	            queue.push(item);
	        }
	        // also push the Text's texture for upload to GPU
	        var texture = item._texture.baseTexture;

	        if (queue.indexOf(texture) === -1) {
	            queue.push(texture);
	        }

	        return true;
	    }

	    return false;
	}

	/**
	 * Built-in hook to find TextStyle objects.
	 *
	 * @private
	 * @param {PIXI.TextStyle} item - Display object to check
	 * @param {Array<*>} queue - Collection of items to upload
	 * @return {boolean} if a PIXI.TextStyle object was found.
	 */
	function findTextStyle(item, queue) {
	    if (item instanceof core.TextStyle) {
	        if (queue.indexOf(item) === -1) {
	            queue.push(item);
	        }

	        return true;
	    }

	    return false;
	}
	//# sourceMappingURL=BasePrepare.js.map

/***/ }),
/* 353 */
/***/ (function(module, exports) {

	"use strict";

	exports.__esModule = true;

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/**
	 * CountLimiter limits the number of items handled by a {@link PIXI.prepare.BasePrepare} to a specified
	 * number of items per frame.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var CountLimiter = function () {
	  /**
	   * @param {number} maxItemsPerFrame - The maximum number of items that can be prepared each frame.
	   */
	  function CountLimiter(maxItemsPerFrame) {
	    _classCallCheck(this, CountLimiter);

	    /**
	     * The maximum number of items that can be prepared each frame.
	     * @private
	     */
	    this.maxItemsPerFrame = maxItemsPerFrame;
	    /**
	     * The number of items that can be prepared in the current frame.
	     * @type {number}
	     * @private
	     */
	    this.itemsLeft = 0;
	  }

	  /**
	   * Resets any counting properties to start fresh on a new frame.
	   */


	  CountLimiter.prototype.beginFrame = function beginFrame() {
	    this.itemsLeft = this.maxItemsPerFrame;
	  };

	  /**
	   * Checks to see if another item can be uploaded. This should only be called once per item.
	   * @return {boolean} If the item is allowed to be uploaded.
	   */


	  CountLimiter.prototype.allowedToUpload = function allowedToUpload() {
	    return this.itemsLeft-- > 0;
	  };

	  return CountLimiter;
	}();

	exports.default = CountLimiter;
	//# sourceMappingURL=CountLimiter.js.map

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _core = __webpack_require__(173);

	var core = _interopRequireWildcard(_core);

	var _BasePrepare2 = __webpack_require__(352);

	var _BasePrepare3 = _interopRequireDefault(_BasePrepare2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var CANVAS_START_SIZE = 16;

	/**
	 * The prepare manager provides functionality to upload content to the GPU
	 * This cannot be done directly for Canvas like in WebGL, but the effect can be achieved by drawing
	 * textures to an offline canvas.
	 * This draw call will force the texture to be moved onto the GPU.
	 *
	 * An instance of this class is automatically created by default, and can be found at renderer.plugins.prepare
	 *
	 * @class
	 * @extends PIXI.prepare.BasePrepare
	 * @memberof PIXI.prepare
	 */

	var CanvasPrepare = function (_BasePrepare) {
	    _inherits(CanvasPrepare, _BasePrepare);

	    /**
	     * @param {PIXI.CanvasRenderer} renderer - A reference to the current renderer
	     */
	    function CanvasPrepare(renderer) {
	        _classCallCheck(this, CanvasPrepare);

	        var _this = _possibleConstructorReturn(this, _BasePrepare.call(this, renderer));

	        _this.uploadHookHelper = _this;

	        /**
	        * An offline canvas to render textures to
	        * @type {HTMLCanvasElement}
	        * @private
	        */
	        _this.canvas = document.createElement('canvas');
	        _this.canvas.width = CANVAS_START_SIZE;
	        _this.canvas.height = CANVAS_START_SIZE;

	        /**
	         * The context to the canvas
	        * @type {CanvasRenderingContext2D}
	        * @private
	        */
	        _this.ctx = _this.canvas.getContext('2d');

	        // Add textures to upload
	        _this.registerUploadHook(uploadBaseTextures);
	        return _this;
	    }

	    /**
	     * Destroys the plugin, don't use after this.
	     *
	     */


	    CanvasPrepare.prototype.destroy = function destroy() {
	        _BasePrepare.prototype.destroy.call(this);
	        this.ctx = null;
	        this.canvas = null;
	    };

	    return CanvasPrepare;
	}(_BasePrepare3.default);

	/**
	 * Built-in hook to upload PIXI.Texture objects to the GPU.
	 *
	 * @private
	 * @param {*} prepare - Instance of CanvasPrepare
	 * @param {*} item - Item to check
	 * @return {boolean} If item was uploaded.
	 */


	exports.default = CanvasPrepare;
	function uploadBaseTextures(prepare, item) {
	    if (item instanceof core.BaseTexture) {
	        var image = item.source;

	        // Sometimes images (like atlas images) report a size of zero, causing errors on windows phone.
	        // So if the width or height is equal to zero then use the canvas size
	        // Otherwise use whatever is smaller, the image dimensions or the canvas dimensions.
	        var imageWidth = image.width === 0 ? prepare.canvas.width : Math.min(prepare.canvas.width, image.width);
	        var imageHeight = image.height === 0 ? prepare.canvas.height : Math.min(prepare.canvas.height, image.height);

	        // Only a small subsections is required to be drawn to have the whole texture uploaded to the GPU
	        // A smaller draw can be faster.
	        prepare.ctx.drawImage(image, 0, 0, imageWidth, imageHeight, 0, 0, prepare.canvas.width, prepare.canvas.height);

	        return true;
	    }

	    return false;
	}

	core.CanvasRenderer.registerPlugin('prepare', CanvasPrepare);
	//# sourceMappingURL=CanvasPrepare.js.map

/***/ }),
/* 355 */
/***/ (function(module, exports) {

	"use strict";

	exports.__esModule = true;

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/**
	 * TimeLimiter limits the number of items handled by a {@link PIXI.BasePrepare} to a specified
	 * number of milliseconds per frame.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var TimeLimiter = function () {
	  /**
	   * @param {number} maxMilliseconds - The maximum milliseconds that can be spent preparing items each frame.
	   */
	  function TimeLimiter(maxMilliseconds) {
	    _classCallCheck(this, TimeLimiter);

	    /**
	     * The maximum milliseconds that can be spent preparing items each frame.
	     * @private
	     */
	    this.maxMilliseconds = maxMilliseconds;
	    /**
	     * The start time of the current frame.
	     * @type {number}
	     * @private
	     */
	    this.frameStart = 0;
	  }

	  /**
	   * Resets any counting properties to start fresh on a new frame.
	   */


	  TimeLimiter.prototype.beginFrame = function beginFrame() {
	    this.frameStart = Date.now();
	  };

	  /**
	   * Checks to see if another item can be uploaded. This should only be called once per item.
	   * @return {boolean} If the item is allowed to be uploaded.
	   */


	  TimeLimiter.prototype.allowedToUpload = function allowedToUpload() {
	    return Date.now() - this.frameStart < this.maxMilliseconds;
	  };

	  return TimeLimiter;
	}();

	exports.default = TimeLimiter;
	//# sourceMappingURL=TimeLimiter.js.map

/***/ }),
/* 356 */
/***/ (function(module, exports) {

	/*! (c) Andrea Giammarchi - ISC */
	var self = this || /* istanbul ignore next */ {};
	try {
	  (function (URLSearchParams, plus) {
	    if (
	      new URLSearchParams('q=%2B').get('q') !== plus ||
	      new URLSearchParams({q: plus}).get('q') !== plus ||
	      new URLSearchParams([['q', plus]]).get('q') !== plus ||
	      new URLSearchParams('q=\n').toString() !== 'q=%0A' ||
	      new URLSearchParams({q: ' &'}).toString() !== 'q=+%26'
	    )
	      throw URLSearchParams;
	    self.URLSearchParams = URLSearchParams;
	  }(URLSearchParams, '+'));
	} catch(URLSearchParams) {
	  (function (Object, String, isArray) {'use strict';
	    var create = Object.create;
	    var defineProperty = Object.defineProperty;
	    var find = /[!'\(\)~]|%20|%00/g;
	    var plus = /\+/g;
	    var replace = {
	      '!': '%21',
	      "'": '%27',
	      '(': '%28',
	      ')': '%29',
	      '~': '%7E',
	      '%20': '+',
	      '%00': '\x00'
	    };
	    var proto = {
	      append: function (key, value) {
	        appendTo(this._ungap, key, value);
	      },
	      delete: function (key) {
	        delete this._ungap[key];
	      },
	      get: function (key) {
	        return this.has(key) ? this._ungap[key][0] : null;
	      },
	      getAll: function (key) {
	        return this.has(key) ? this._ungap[key].slice(0) : [];
	      },
	      has: function (key) {
	        return key in this._ungap;
	      },
	      set: function (key, value) {
	        this._ungap[key] = [String(value)];
	      },
	      forEach: function (callback, thisArg) {
	        var self = this;
	        for (var key in self._ungap)
	          self._ungap[key].forEach(invoke, key);
	        function invoke(value) {
	          callback.call(thisArg, value, String(key), self);
	        }
	      },
	      toJSON: function () {
	        return {};
	      },
	      toString: function () {
	        var query = [];
	        for (var key in this._ungap) {
	          var encoded = encode(key);
	          for (var
	            i = 0,
	            value = this._ungap[key];
	            i < value.length; i++
	          ) {
	            query.push(encoded + '=' + encode(value[i]));
	          }
	        }
	        return query.join('&');
	      }
	    };
	    for (var key in proto)
	      defineProperty(URLSearchParams.prototype, key, {
	        configurable: true,
	        writable: true,
	        value: proto[key]
	      });
	    self.URLSearchParams = URLSearchParams;
	    function URLSearchParams(query) {
	      var dict = create(null);
	      defineProperty(this, '_ungap', {value: dict});
	      switch (true) {
	        case !query:
	          break;
	        case typeof query === 'string':
	          if (query.charAt(0) === '?') {
	            query = query.slice(1);
	          }
	          for (var
	            pairs = query.split('&'),
	            i = 0,
	            length = pairs.length; i < length; i++
	          ) {
	            var value = pairs[i];
	            var index = value.indexOf('=');
	            if (-1 < index) {
	              appendTo(
	                dict,
	                decode(value.slice(0, index)),
	                decode(value.slice(index + 1))
	              );
	            } else if (value.length){
	              appendTo(
	                dict,
	                decode(value),
	                ''
	              );
	            }
	          }
	          break;
	        case isArray(query):
	          for (var
	            i = 0,
	            length = query.length; i < length; i++
	          ) {
	            var value = query[i];
	            appendTo(dict, value[0], value[1]);
	          }
	          break;
	        case 'forEach' in query:
	          query.forEach(addEach, dict);
	          break;
	        default:
	          for (var key in query)
	            appendTo(dict, key, query[key]);
	      }
	    }

	    function addEach(value, key) {
	      appendTo(this, key, value);
	    }
	    
	    function appendTo(dict, key, value) {
	      var res = isArray(value) ? value.join(',') : value;
	      if (key in dict)
	        dict[key].push(res);
	      else
	        dict[key] = [res];
	    }
	    
	    function decode(str) {
	      return decodeURIComponent(str.replace(plus, ' '));
	    }
	    
	    function encode(str) {
	      return encodeURIComponent(str).replace(find, replacer);
	    }

	    function replacer(match) {
	      return replace[match];
	    }

	  }(Object, String, Array.isArray));
	}

	(function (URLSearchParamsProto) {

	  var iterable = false;
	  try { iterable = !!Symbol.iterator; } catch (o_O) {}

	  /* istanbul ignore else */
	  if (!('forEach' in URLSearchParamsProto)) {
	    URLSearchParamsProto.forEach = function forEach(callback, thisArg) {
	      var self = this;
	      var names = Object.create(null);
	      this.toString()
	          .replace(/=[\s\S]*?(?:&|$)/g, '=')
	          .split('=')
	          .forEach(function (name) {
	            if (!name.length || name in names)
	              return;
	            (names[name] = self.getAll(name)).forEach(function(value) {
	              callback.call(thisArg, value, name, self);
	            });
	          });
	    };
	  }

	  /* istanbul ignore else */
	  if (!('keys' in URLSearchParamsProto)) {
	    URLSearchParamsProto.keys = function keys() {
	      return iterator(this, function(value, key) { this.push(key); });
	    };
	  }

	   /* istanbul ignore else */
	  if (!('values' in URLSearchParamsProto)) {
	    URLSearchParamsProto.values = function values() {
	      return iterator(this, function(value, key) { this.push(value); });
	    };
	  }

	  /* istanbul ignore else */
	  if (!('entries' in URLSearchParamsProto)) {
	    URLSearchParamsProto.entries = function entries() {
	      return iterator(this, function(value, key) { this.push([key, value]); });
	    };
	  }

	  /* istanbul ignore else */
	  if (iterable && !(Symbol.iterator in URLSearchParamsProto)) {
	    URLSearchParamsProto[Symbol.iterator] = URLSearchParamsProto.entries;
	  }

	  /* istanbul ignore else */
	  if (!('sort' in URLSearchParamsProto)) {
	    URLSearchParamsProto.sort = function sort() {
	      var
	        entries = this.entries(),
	        entry = entries.next(),
	        done = entry.done,
	        keys = [],
	        values = Object.create(null),
	        i, key, value
	      ;
	      while (!done) {
	        value = entry.value;
	        key = value[0];
	        keys.push(key);
	        if (!(key in values)) {
	          values[key] = [];
	        }
	        values[key].push(value[1]);
	        entry = entries.next();
	        done = entry.done;
	      }
	      // not the champion in efficiency
	      // but these two bits just do the job
	      keys.sort();
	      for (i = 0; i < keys.length; i++) {
	        this.delete(keys[i]);
	      }
	      for (i = 0; i < keys.length; i++) {
	        key = keys[i];
	        this.append(key, values[key].shift());
	      }
	    };
	  }

	  function iterator(self, callback) {
	    var items = [];
	    self.forEach(callback, items);
	    return iterable ?
	      items[Symbol.iterator]() :
	      {
	        next: function() {
	          var value = items.shift();
	          return {done: value === undefined, value: value};
	        }
	      };
	  }

	  /* istanbul ignore next */
	  (function (Object) {
	    var
	      dP = Object.defineProperty,
	      gOPD = Object.getOwnPropertyDescriptor,
	      createSearchParamsPollute = function (search) {
	        function append(name, value) {
	          URLSearchParamsProto.append.call(this, name, value);
	          name = this.toString();
	          search.set.call(this._usp, name ? ('?' + name) : '');
	        }
	        function del(name) {
	          URLSearchParamsProto.delete.call(this, name);
	          name = this.toString();
	          search.set.call(this._usp, name ? ('?' + name) : '');
	        }
	        function set(name, value) {
	          URLSearchParamsProto.set.call(this, name, value);
	          name = this.toString();
	          search.set.call(this._usp, name ? ('?' + name) : '');
	        }
	        return function (sp, value) {
	          sp.append = append;
	          sp.delete = del;
	          sp.set = set;
	          return dP(sp, '_usp', {
	            configurable: true,
	            writable: true,
	            value: value
	          });
	        };
	      },
	      createSearchParamsCreate = function (polluteSearchParams) {
	        return function (obj, sp) {
	          dP(
	            obj, '_searchParams', {
	              configurable: true,
	              writable: true,
	              value: polluteSearchParams(sp, obj)
	            }
	          );
	          return sp;
	        };
	      },
	      updateSearchParams = function (sp) {
	        var append = sp.append;
	        sp.append = URLSearchParamsProto.append;
	        URLSearchParams.call(sp, sp._usp.search.slice(1));
	        sp.append = append;
	      },
	      verifySearchParams = function (obj, Class) {
	        if (!(obj instanceof Class)) throw new TypeError(
	          "'searchParams' accessed on an object that " +
	          "does not implement interface " + Class.name
	        );
	      },
	      upgradeClass = function (Class) {
	        var
	          ClassProto = Class.prototype,
	          searchParams = gOPD(ClassProto, 'searchParams'),
	          href = gOPD(ClassProto, 'href'),
	          search = gOPD(ClassProto, 'search'),
	          createSearchParams
	        ;
	        if (!searchParams && search && search.set) {
	          createSearchParams = createSearchParamsCreate(
	            createSearchParamsPollute(search)
	          );
	          Object.defineProperties(
	            ClassProto,
	            {
	              href: {
	                get: function () {
	                  return href.get.call(this);
	                },
	                set: function (value) {
	                  var sp = this._searchParams;
	                  href.set.call(this, value);
	                  if (sp) updateSearchParams(sp);
	                }
	              },
	              search: {
	                get: function () {
	                  return search.get.call(this);
	                },
	                set: function (value) {
	                  var sp = this._searchParams;
	                  search.set.call(this, value);
	                  if (sp) updateSearchParams(sp);
	                }
	              },
	              searchParams: {
	                get: function () {
	                  verifySearchParams(this, Class);
	                  return this._searchParams || createSearchParams(
	                    this,
	                    new URLSearchParams(this.search.slice(1))
	                  );
	                },
	                set: function (sp) {
	                  verifySearchParams(this, Class);
	                  createSearchParams(this, sp);
	                }
	              }
	            }
	          );
	        }
	      }
	    ;
	    try {
	      upgradeClass(HTMLAnchorElement);
	      if (/^function|object$/.test(typeof URL) && URL.prototype)
	        upgradeClass(URL);
	    } catch (meh) {}
	  }(Object));

	}(self.URLSearchParams.prototype, Object));
	module.exports = self.URLSearchParams;


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _toConsumableArray2 = __webpack_require__(358);

	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

	var _regenerator = __webpack_require__(140);

	var _regenerator2 = _interopRequireDefault(_regenerator);

	var _asyncToGenerator2 = __webpack_require__(143);

	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

	var _classCallCheck2 = __webpack_require__(6);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(7);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _pixi = __webpack_require__(166);

	var PIXI = _interopRequireWildcard(_pixi);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var DEEPLINK_HOST = "deeplinker.cl.ly";
	var DEEPLINK_PORT = 443;
	var DEEPLINK_PROTOCOL = "https";
	var DEEPLINK_ENDPOINT = "/ocr";
	var DEEPLINK_URL = DEEPLINK_PROTOCOL + "://" + DEEPLINK_HOST + ":" + DEEPLINK_PORT + DEEPLINK_ENDPOINT;

	var annotationBoxes = new Map();

	var CloudAppImage = function () {
	    /*
	    opts = {
	        //MUST
	        src                 : image url or image base64
	        canvas              : html canvas selector like document.getElementById("canvas");
	         //OPTIONAL
	        width               : width of final canvas
	        height              : height of final canvas
	        backgroundColor     : hex color like 0xDADDDE by default its transparent
	        ocr_endpoint        : ocr_endpoint to be called
	    }
	    */
	    function CloudAppImage(opts) {
	        (0, _classCallCheck3.default)(this, CloudAppImage);

	        this.opts = opts;

	        this._run();
	    }

	    (0, _createClass3.default)(CloudAppImage, [{
	        key: "load_image",
	        value: function () {
	            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(src) {
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                return _context.abrupt("return", new Promise(function (resolve, reject) {
	                                    var img = new Image();

	                                    img.onload = function () {
	                                        resolve(img);
	                                    };
	                                    img.src = src;
	                                }));

	                            case 1:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));

	            function load_image(_x) {
	                return _ref.apply(this, arguments);
	            }

	            return load_image;
	        }()
	    }, {
	        key: "ocr",
	        value: function () {
	            var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(url) {
	                var res;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                console.log("OCR on", url);
	                                _context2.next = 3;
	                                return fetch(DEEPLINK_URL + "/image?url=" + encodeURIComponent(url), { mode: 'cors' }).catch(function (e) {
	                                    console.log(e);
	                                    throw e;
	                                });

	                            case 3:
	                                res = _context2.sent;
	                                return _context2.abrupt("return", res.json());

	                            case 5:
	                            case "end":
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));

	            function ocr(_x2) {
	                return _ref2.apply(this, arguments);
	            }

	            return ocr;
	        }()
	    }, {
	        key: "_run",
	        value: function () {
	            var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
	                var html_img, ocr;
	                return _regenerator2.default.wrap(function _callee3$(_context3) {
	                    while (1) {
	                        switch (_context3.prev = _context3.next) {
	                            case 0:
	                                _context3.next = 2;
	                                return this.load_image(this.opts.src);

	                            case 2:
	                                html_img = _context3.sent;
	                                _context3.next = 5;
	                                return this.ocr(this.opts.src);

	                            case 5:
	                                ocr = _context3.sent;

	                                if (ocr.success) {
	                                    _context3.next = 8;
	                                    break;
	                                }

	                                throw ocr.error || 'Unknown error processing the image';

	                            case 8:

	                                this._draw_image(html_img, ocr);

	                            case 9:
	                            case "end":
	                                return _context3.stop();
	                        }
	                    }
	                }, _callee3, this);
	            }));

	            function _run() {
	                return _ref3.apply(this, arguments);
	            }

	            return _run;
	        }()
	    }, {
	        key: "_draw_image",
	        value: function () {
	            var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(html_img, ocr) {
	                var _this = this;

	                var width, height, canvas, scaleShape, pixi, stage, ocr_container, img_sp, clickable, createAnnotationSprite, draw_annotation;
	                return _regenerator2.default.wrap(function _callee4$(_context4) {
	                    while (1) {
	                        switch (_context4.prev = _context4.next) {
	                            case 0:
	                                createAnnotationSprite = function createAnnotationSprite(annotation) {
	                                    var vert = annotation.boundingPoly.vertices;
	                                    var color = ['CC', 'SECRET'].includes(annotation.ner) ? 0xff0000 : 0x00ffff;

	                                    var p = new PIXI.Graphics();

	                                    var pointFromVert = function pointFromVert(_ref6) {
	                                        var x = _ref6.x,
	                                            y = _ref6.y;
	                                        return new PIXI.Point(x, y);
	                                    };
	                                    var polygonFromVerts = function polygonFromVerts(shape) {
	                                        return p.drawPolygon.apply(p, (0, _toConsumableArray3.default)(shape.map(pointFromVert)).concat([pointFromVert(shape[0])]));
	                                    };

	                                    function includes_cc(ner) {
	                                        if (!['CC'].includes(ner)) {
	                                            return 0;
	                                        } else {
	                                            return 1;
	                                        }
	                                    }

	                                    var CC_includes_ner = includes_cc(annotation.ner);
	                                    // draw shape

	                                    p.beginFill(color, CC_includes_ner);
	                                    p.lineStyle(2, color, 1);

	                                    polygonFromVerts(vert.map(scaleShape));

	                                    p.endFill();

	                                    var corner = vert[0];
	                                    var key = "(" + corner.x + "," + corner.y + ")";
	                                    if (['EMAIL', 'URL', 'PHONE'].includes(annotation.ner)) {
	                                        var box = clickable(corner, p, annotation);

	                                        annotationBoxes.set(key, box);

	                                        ocr_container.addChild(box);
	                                    } else {
	                                        ocr_container.addChild(p);
	                                        annotationBoxes.set(key, p);
	                                    }
	                                };

	                                width = this.opts.width || html_img.width;
	                                height = this.opts.height || html_img.height;
	                                canvas = this.opts.canvas;

	                                canvas.width = width;
	                                canvas.height = height;

	                                scaleShape = function scaleShape(_ref5) {
	                                    var x = _ref5.x,
	                                        y = _ref5.y;
	                                    return { x: x, y: y };
	                                };

	                                pixi = new PIXI.Application(width, height, { antialias: true, transparent: true, view: canvas, backgroundColor: this.opts.backgroundColor });
	                                stage = pixi.stage;
	                                ocr_container = new PIXI.Container();

	                                stage.addChild(ocr_container);

	                                img_sp = new PIXI.Sprite.fromImage(html_img.src, true);


	                                ocr_container.addChild(img_sp);

	                                clickable = function clickable(vert, p, annotation) {
	                                    var bbox = new PIXI.Sprite(p.generateTexture());

	                                    bbox.interactive = true;
	                                    bbox.buttonMode = true;

	                                    bbox.x = vert.x;
	                                    bbox.y = vert.y;

	                                    bbox.on('pointerdown', function () {
	                                        _this.isClicking = true;
	                                        setTimeout(function () {
	                                            return _this.isClicking = false;
	                                        }, 500);
	                                        console.log("pointer down");
	                                        if (annotation.ner === 'URL') {
	                                            window.open(annotation.description);
	                                        }

	                                        if (annotation.ner === 'EMAIL') {
	                                            window.open("mailto:" + annotation.description);
	                                        }

	                                        if (annotation.ner === 'PHONE') {
	                                            window.open("tel:" + annotation.description);
	                                        }
	                                    });

	                                    return bbox;
	                                };

	                                ;

	                                draw_annotation = function draw_annotation(annotation) {
	                                    return createAnnotationSprite(annotation);
	                                };

	                                setTimeout(function () {
	                                    var data = ocr.responses[0];

	                                    if (data.textAnnotations) {
	                                        var annotations_ = [];

	                                        for (var i = 0; i < data.textAnnotations.length; i++) {
	                                            var annotation = data.textAnnotations[i];

	                                            if (annotation.ner) {
	                                                draw_annotation(annotation);
	                                                annotations_.push(annotation);
	                                            }
	                                        }
	                                    }
	                                }, 1000);

	                            case 17:
	                            case "end":
	                                return _context4.stop();
	                        }
	                    }
	                }, _callee4, this);
	            }));

	            function _draw_image(_x3, _x4) {
	                return _ref4.apply(this, arguments);
	            }

	            return _draw_image;
	        }()
	    }]);
	    return CloudAppImage;
	}();

	exports.default = CloudAppImage;

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _from = __webpack_require__(359);

	var _from2 = _interopRequireDefault(_from);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }

	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(360), __esModule: true };

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(39);
	__webpack_require__(361);
	module.exports = __webpack_require__(13).Array.from;


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(14);
	var $export = __webpack_require__(11);
	var toObject = __webpack_require__(66);
	var call = __webpack_require__(149);
	var isArrayIter = __webpack_require__(150);
	var toLength = __webpack_require__(56);
	var createProperty = __webpack_require__(362);
	var getIterFn = __webpack_require__(113);

	$export($export.S + $export.F * !__webpack_require__(161)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(17);
	var createDesc = __webpack_require__(25);

	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _classCallCheck2 = __webpack_require__(6);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var OtherViewDirective = function OtherViewDirective() {
	  'ngInject';

	  (0, _classCallCheck3.default)(this, OtherViewDirective);
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/otherView/otherView.html',
	    controller: OtherViewController,
	    controllerAs: 'vm',
	    bindToController: true
	  };

	  return directive;
	};

	var OtherViewController = function OtherViewController(itemService) {
	  'ngInject';

	  (0, _classCallCheck3.default)(this, OtherViewController);
	  this.item = itemService;
	};

	exports.default = OtherViewDirective;

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass2 = __webpack_require__(7);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _classCallCheck2 = __webpack_require__(6);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/* global $, PDFJS, window, _ */
	var PdfViewDirective = function PdfViewDirective() {
	  'ngInject';

	  (0, _classCallCheck3.default)(this, PdfViewDirective);
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/pdfView/pdfView.html',
	    controller: PdfViewController,
	    controllerAs: 'vm',
	    bindToController: true
	  };

	  return directive;
	};

	var PdfViewController = function () {
	  function PdfViewController($window, itemService, $timeout, config, loadingService) {
	    'ngInject';

	    (0, _classCallCheck3.default)(this, PdfViewController);
	    this.item = itemService;
	    this._config = config;
	    this._$timeout = $timeout;
	    this._loadingService = loadingService;
	    this._$window = $window;
	    this.init();
	  }

	  (0, _createClass3.default)(PdfViewController, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;

	      if (this.initialized) {
	        return;
	      }

	      if (window.PDFJS && PDFJS.PDFViewer && PDFJS.getDocument) {
	        this.initialized = true;
	        this.initPdf();
	      } else {
	        window.setTimeout(function () {
	          _this.init();
	        }, 100);
	      }

	      var resize = _.debounce(function () {
	        _this.resizePdf();
	      }, 500);

	      $(this._$window).on('resize', resize);
	    }
	  }, {
	    key: 'resizePdf',
	    value: function resizePdf() {
	      this.pdfViewer.currentScaleValue = 'page-width';
	      this.pdfViewer.forceRendering();
	    }
	  }, {
	    key: 'initPdf',
	    value: function initPdf() {
	      var _this2 = this;

	      var loadingService = this._loadingService;
	      var $timeout = this._$timeout;
	      var itemService = this.item;

	      PDFJS.workerSrc = this._config.vendorPath + '/pdf.worker.js';

	      if (!PDFJS.PDFViewer || !PDFJS.getDocument) {
	        window.alert('Something went wrong.');
	      }

	      var container = $('section#pdf').get(0);
	      this.pdfViewer = new PDFJS.PDFViewer({
	        container: container
	      });

	      container.addEventListener('pagesinit', function () {
	        _this2.pdfViewer.currentScaleValue = 'page-width';
	      });

	      var url = this.item.data.source_url;
	      loadingService.setState('pdfLoad', true);

	      PDFJS.getDocument(url).then(function (pdfDocument) {
	        if (!loadingService.getState('pdfLoad')) {
	          return;
	        }
	        _this2.pdfViewer.setDocument(pdfDocument);
	        $timeout(function () {
	          loadingService.setState('pdfLoad', false);
	        });
	      }, function () {
	        $timeout(function () {
	          loadingService.setState('pdfLoad', false);
	          itemService.data.type = 'other';
	        });
	      });

	      $timeout(function () {
	        if (!loadingService.getState('pdfLoad')) {
	          return;
	        }
	        loadingService.setState('pdfLoad', false);
	        itemService.data.type = 'other';
	      }, 5000);
	    }
	  }]);
	  return PdfViewController;
	}();

	exports.default = PdfViewDirective;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _classCallCheck2 = __webpack_require__(6);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var TextViewDirective = function TextViewDirective() {
	  'ngInject';

	  (0, _classCallCheck3.default)(this, TextViewDirective);
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/textView/textView.html',
	    controller: TextViewController,
	    controllerAs: 'vm',
	    bindToController: true
	  };

	  return directive;
	};

	var TextViewController = function TextViewController(itemService) {
	  'ngInject';

	  (0, _classCallCheck3.default)(this, TextViewController);
	  this.item = itemService;
	};

	exports.default = TextViewDirective;

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _regenerator = __webpack_require__(140);

	var _regenerator2 = _interopRequireDefault(_regenerator);

	var _asyncToGenerator2 = __webpack_require__(143);

	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

	var _createClass2 = __webpack_require__(7);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _classCallCheck2 = __webpack_require__(6);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/* global _, console, dashjs, playerjs, videojs */
	/* global $ */

	var VideoViewDirective = function VideoViewDirective() {
	  'ngInject';

	  (0, _classCallCheck3.default)(this, VideoViewDirective);
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/videoView/videoView.html',
	    controller: VideoViewController,
	    controllerAs: 'vm',
	    bindToController: true
	  };

	  return directive;
	};

	var VideoViewController = function () {
	  function VideoViewController(itemService, transcodingService, config, angularLoad, userService) {
	    'ngInject';

	    (0, _classCallCheck3.default)(this, VideoViewController);
	    this.angularLoad = angularLoad;
	    this.item = itemService;
	    this.transcoding = transcodingService;
	    this.vendorPath = config.vendorPath;
	    this._userService = userService;
	    this.init();
	  }

	  // jshint ignore:start


	  (0, _createClass3.default)(VideoViewController, [{
	    key: 'loadScript',
	    value: function () {
	      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(name) {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return this.angularLoad.loadScript(this.vendorPath + '/' + name);

	              case 2:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));

	      function loadScript(_x) {
	        return _ref.apply(this, arguments);
	      }

	      return loadScript;
	    }()
	    // jshint ignore:end

	    // jshint ignore:start

	  }, {
	    key: 'init',
	    value: function () {
	      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
	        var isMobile;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.prev = 0;
	                _context2.next = 3;
	                return this.loadScript('video.js');

	              case 3:
	                _context2.next = 5;
	                return this.loadScript('player-0.1.0.min.js');

	              case 5:
	                if (!(this.item.data.type === 'video')) {
	                  _context2.next = 24;
	                  break;
	                }

	                isMobile = /iPad|iPhone|iPod|Android/.test(platform.toString());

	                if (!isMobile) {
	                  _context2.next = 11;
	                  break;
	                }

	                throw 'Transcoding unsupported';

	              case 11:
	                if (!this.item.data.coconut_enabled) {
	                  _context2.next = 14;
	                  break;
	                }

	                _context2.next = 14;
	                return this.transcoding.get(this.item.data.slug);

	              case 14:
	                ;
	                _context2.next = 17;
	                return this.loadScript('vjs-quality-picker.js');

	              case 17:
	                _context2.next = 19;
	                return this.loadScript('dash.all.min.js');

	              case 19:
	                _context2.next = 21;
	                return this.loadScript('videojs-dash.min.js');

	              case 21:
	                this.player({
	                  sourceUrl: this.transcoding.dashUrl,
	                  poster: this.transcoding.thumbnailUrl,
	                  type: 'video/mp4'
	                });

	              case 22:
	                _context2.next = 25;
	                break;

	              case 24:
	                this.player({
	                  type: 'audio/mp3',
	                  poster: this.vendorPath + '/../assets/images/bg_audio@2x.png'
	                });

	              case 25:
	                _context2.next = 30;
	                break;

	              case 27:
	                _context2.prev = 27;
	                _context2.t0 = _context2['catch'](0);

	                this.player({ type: 'video/mp4' });

	              case 30:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this, [[0, 27]]);
	      }));

	      function init() {
	        return _ref2.apply(this, arguments);
	      }

	      return init;
	    }()
	    // jshint ignore:end

	  }, {
	    key: 'player',
	    value: function player() {
	      var _this = this;

	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	      var playerSetup = {
	        sources: [{
	          src: options.sourceUrl || this.item.data.source_url,
	          type: options.type || 'video/mp4'
	        }],
	        html5: {
	          nativeCaptions: false,
	          dash: {
	            setFastSwitchEnabled: true,
	            setInitialRepresentationRatioFor: ['video', 0.5625]
	          }
	        },
	        poster: options.poster,
	        constrols: true,
	        preload: 'auto'
	      };
	      this.videoJsPlayer = videojs('player', playerSetup, function () {
	        var adapter = new playerjs.VideoJSAdapter(_this.videoJsPlayer);
	        if (_this.videoJsPlayer.dash) {
	          var dashPlayer = _this.videoJsPlayer.dash.mediaPlayer;
	          dashPlayer.getDebug().setLogToBrowserConsole(false);
	          // will be removed
	          dashPlayer.on(dashjs.MediaPlayer.events.QUALITY_CHANGE_REQUESTED, function (e) {
	            console.log('QUALITY_CHANGE_REQUESTED', e);
	          });
	          dashPlayer.on(dashjs.MediaPlayer.events.QUALITY_CHANGE_RENDERED, function (e) {
	            console.log('QUALITY_CHANGE_RENDERED', e);
	          });
	          _this.videoJsPlayer.qualityPickerPlugin();
	          dashPlayer.on(dashjs.MediaPlayer.events.STREAM_INITIALIZED, function () {
	            _this.initQualityPicker();
	          });
	        }

	        if (_this.shouldShowAd()) {
	          _this.showCloudappAd();
	        }

	        adapter.ready();
	        console.log("Player.js Adapter Ready");
	      });
	    }
	  }, {
	    key: 'initQualityPicker',
	    value: function initQualityPicker() {
	      var dashPlayer = this.videoJsPlayer.dash.mediaPlayer;
	      var tech = this.videoJsPlayer.tech({
	        IWillNotUseThisInPlugins: true
	      });
	      var bitrates = dashPlayer.getBitrateInfoListFor('video');
	      var videoData = [{
	        id: { qualityIndex: -1 },
	        label: 'Auto',
	        selected: true
	      }];
	      bitrates.forEach(function (bitrate) {
	        var bitrateIndex = _.findIndex(videoData, function (b) {
	          return b.label === bitrate.height + 'p';
	        });
	        if (bitrate.qualityIndex !== 0 && bitrateIndex === -1) {
	          videoData.unshift({
	            id: bitrate,
	            label: bitrate.height + 'p',
	            selected: false
	          });
	        }
	      });
	      var payload = {
	        qualityData: {
	          video: videoData
	        },
	        qualitySwitchCallback: function qualitySwitchCallback(bitrate) {
	          if (bitrate.qualityIndex === -1) {
	            dashPlayer.setAutoSwitchQualityFor('video', true);
	          } else {
	            dashPlayer.setAutoSwitchQualityFor('video', false);
	            dashPlayer.setQualityFor('video', bitrate.qualityIndex);
	          }
	        }
	      };
	      tech.trigger('loadedqualitydata', payload);
	    }
	  }, {
	    key: 'shouldShowAd',
	    value: function shouldShowAd() {
	      var currentUserIsFree = !this._userService.isLoggedIn() || this._userService.isTrial();
	      return currentUserIsFree && !!this.item.data.free_user;
	    }
	  }, {
	    key: 'showCloudappAd',
	    value: function showCloudappAd() {
	      var htmlContent = ["<div class='video-ad' style='box-sizing: border-box; bottom: 30px; left: 0px; right: 0px; top: 0px; background-color: rgba(0, 0, 0, 0.8); color: rgb(255, 255, 255); text-align: center; font-size: 15px; position: absolute; z-index: 100; display: flex; justify-content: center; align-items: center;'>", "<a href='https://my.cl.ly/register?source_referral=viewer_video_end_cta' style='color: rgb(255, 255, 255);'>", "<p style='margin: 0px 0px 10px; padding: 80px 0px 0px; background-image: url(https://s3.amazonaws.com/embed.cl.ly/cloudapp_icon_white.png); background-repeat: no-repeat; background-position: center 20px; background-size: 60px 48px;'>Create videos and share them easily</p>", "<div style='color: rgb(255, 255, 255); font-size: 18px;'>Learn more about CloudApp</div>", "</p>", "</a>", "</div>"].join('');

	      this.videoJsPlayer.on('ended', function () {
	        $("#player").append(htmlContent);
	        $(".vjs-control-bar > .vjs-play-control").click(function () {
	          $('.video-ad').remove();
	        });
	      });
	    }
	  }]);
	  return VideoViewController;
	}();

	exports.default = VideoViewDirective;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _classCallCheck2 = __webpack_require__(6);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var FlashMessagesDirective = function FlashMessagesDirective() {
	  'ngInject';

	  (0, _classCallCheck3.default)(this, FlashMessagesDirective);
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/flashMessages/flashMessages.html',
	    controller: FlashMessagesController,
	    controllerAs: 'flashVm',
	    bindToController: true
	  };

	  return directive;
	};

	var FlashMessagesController = function FlashMessagesController(flashMessagesService) {
	  'ngInject';

	  (0, _classCallCheck3.default)(this, FlashMessagesController);
	  var vm = this;
	  vm.flashMessages = flashMessagesService;
	};

	exports.default = FlashMessagesDirective;

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _classCallCheck2 = __webpack_require__(6);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _navbar = __webpack_require__(369);

	var _navbar2 = _interopRequireDefault(_navbar);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var NavbarDirective = function NavbarDirective() {
	  'ngInject';

	  (0, _classCallCheck3.default)(this, NavbarDirective);
	  return {
	    restrict: 'E',
	    templateUrl: 'app/navbar/navbar.html',
	    controller: _navbar2.default,
	    controllerAs: 'vm',
	    bindToController: true,
	    link: function link(scope, element, attrs) {
	      scope.attrs = attrs;
	    }
	  };
	};

	exports.default = NavbarDirective;

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _classCallCheck2 = __webpack_require__(6);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _privacy = __webpack_require__(370);

	var _privacy2 = _interopRequireDefault(_privacy);

	var _login = __webpack_require__(371);

	var _login2 = _interopRequireDefault(_login);

	var _embed = __webpack_require__(372);

	var _embed2 = _interopRequireDefault(_embed);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var NavbarController = function NavbarController($scope, $timeout, $interval, $uibModal, Api, itemService, config, filepicker, storageService, $, shareViaService, abilityService, hotkeys, moment, flashMessagesService, sidebarFactory, userService) {
	  'ngInject';

	  var _this = this;

	  (0, _classCallCheck3.default)(this, NavbarController);
	  this.scope = $scope;
	  this.sidebarFactory = sidebarFactory;

	  $timeout(function () {
	    _this.mode = $scope.attrs.mode;
	    _this.annotations = $scope.attrs.annotations;
	  });

	  this.item = itemService;
	  this.privacy = function () {
	    (0, _privacy2.default)($uibModal);
	  };
	  this.signIn = function () {
	    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	    (0, _login2.default)($uibModal, 'signIn', params);
	  };
	  this.signUp = function () {
	    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	    (0, _login2.default)($uibModal, 'signUp', params);
	  };
	  this.userService = userService;
	  this.plansPath = config.appBase + '/plans';
	  this.redirectSignup = config.appBaseV2 + '/signup';
	  this.chromeExtensionUrl = 'https://chrome.google.com/webstore/detail/ojnikmlgjpfiogeijjkpeakbedjhjcch';

	  this.toggleComments = function () {
	    _this.sidebarFactory.changeTab('comments');
	    _this.sidebarFactory.toggle();
	  };

	  this.toggleEvents = function () {
	    _this.sidebarFactory.changeTab('events');
	    _this.sidebarFactory.toggle();
	  };

	  this.openEmbedModal = function () {
	    _this.ui.toggleMenu(false);
	    (0, _embed2.default)($uibModal);
	  };

	  this.signUpAnnotate = function () {
	    return (0, _login2.default)($uibModal, 'signUp', { source_referral: 'viewer_annotate' }, function () {
	      return itemService.annotations.save();
	    });
	  };

	  this.signOut = function () {
	    Api.signOut().then(function () {
	      abilityService.reset();
	      itemService.getItem();
	      itemService.getDetails();
	    });
	  };

	  this.share = function () {
	    if (abilityService.can('share_email')) {
	      shareViaService.email();
	    } else {
	      _this.signUp();
	    }
	  };

	  this.annotate = function () {
	    return _.get(itemService, 'annotations.drawing.commands');
	  };

	  this.modeClass = function (mode) {
	    var annotate = _this.annotate();
	    return annotate && annotate.mode(mode) ? 'btn_active' : '';
	  };

	  this.setAnnotate = function (mode) {
	    if (!_this.annotate()) {
	      return;
	    }
	    var modes = {
	      rectangle: function rectangle() {
	        return _this.annotate().addRectangle();
	      },
	      circle: function circle() {
	        return _this.annotate().addCircle();
	      },
	      drawing: function drawing() {
	        return _this.annotate().freeDraw();
	      },
	      arrow: function arrow() {
	        return _this.annotate().addArrow();
	      },
	      text: function text() {
	        return _this.annotate().addText();
	      },
	      line: function line() {
	        return _this.annotate().addLine();
	      }
	    };

	    if (_this.annotate().mode(mode)) {
	      _this.annotate().normal();
	    } else {
	      modes[mode]();
	    }
	  };

	  this.setColor = function (color) {
	    if (_this.annotate()) {
	      return _this.annotate().setColor(color);
	    }
	    return null;
	  };

	  this.ui = {
	    toggleMenu: function toggleMenu(value) {
	      _this.menu = typeof value === 'undefined' ? !_this.menu : value;
	      $timeout();
	    },
	    toggleShareMenu: function toggleShareMenu(value) {
	      _this.share_menu = typeof value === 'undefined' ? !_this.share_menu : value;
	      $timeout();
	    }
	  };

	  this.initClipboard = function () {
	    $('.btn_copy').on('click', function (e) {
	      _this.ui.toggleMenu(false);
	      flashMessagesService.send({
	        type: 'success',
	        text: 'Copied to clipboard',
	        timeout: 1750
	      });
	      e.preventDefault();
	    });
	  };

	  this.saveElsewhere = function () {
	    filepicker.exportFile(_this.item.data.source_url, {
	      mimetype: _this.item.data.mimetype,
	      suggestedFilename: _this.item.data.name
	    });
	  };

	  this.shareVia = shareViaService;

	  this.toggleCheatSheet = function () {
	    hotkeys.toggleCheatSheet();
	  };

	  this.enginesTeamMembershipPath = function () {
	    var teamName = _this.userService.getTeam().name;
	    if (teamName) {
	      var name = teamName.replace(/\s+/g, '-').toLowerCase();
	      return config.appBase + '/teams/' + name + '/memberships?slack_invite=true';
	    }
	  };

	  this.showChromeInstallButton = function () {
	    return (!_this.userService.isLoggedIn() || _this.item.data.free_user) && platform.name === 'Chrome';
	  };

	  this.chromeInlineInstall = function () {
	    chrome && chrome.webstore && chrome.webstore.install(_this.chromeExtensionUrl, _this.successCallback, _this.failureCallback);
	  };

	  this.successCallback = function () {
	    console.log('success!!!');
	  };

	  this.failureCallback = function (e) {
	    console.log('Chrome extension error:');
	    console.log(e);
	  };
	}; /* global _, console, platform, chrome */


	exports.default = NavbarController;

/***/ }),
/* 370 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var PrivacyModal = function PrivacyModal($uibModal) {
	  $uibModal.open({
	    templateUrl: 'app/privacy/privacy.html',
	    controller: 'PrivacyController',
	    controllerAs: 'vm'
	  });
	};

	exports.default = PrivacyModal;

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _loginModal = __webpack_require__(115);

	var _loginModal2 = _interopRequireDefault(_loginModal);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var LoginModal = function LoginModal($uibModal, _action, _params, _success_callback) {
	  $uibModal.open({
	    templateUrl: 'app/login/login.modal.html',
	    controller: _loginModal2.default,
	    controllerAs: 'vm',
	    windowClass: 'login_modal',
	    resolve: {
	      action: function action() {
	        return _action;
	      },
	      params: function params() {
	        return _params;
	      },
	      success_callback: function success_callback() {
	        return _success_callback;
	      }
	    }
	  });
	};

	exports.default = LoginModal;

/***/ }),
/* 372 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var embedModal = function embedModal($uibModal) {
	  $uibModal.open({
	    templateUrl: 'app/embed/embed.html',
	    controller: 'EmbedController',
	    controllerAs: 'vm'
	  });
	};

	exports.default = embedModal;

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _classCallCheck2 = __webpack_require__(6);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/* global _ */

	var AnalyticsDirective = function AnalyticsDirective() {
	  (0, _classCallCheck3.default)(this, AnalyticsDirective);

	  var directive = {
	    restrict: 'A',
	    controller: function controller(analyticsService) {
	      'ngInject';

	      this.track = function (name, options) {
	        analyticsService.track(name, options);
	      };
	    },
	    bindToController: true,

	    link: function link(scope, element, attrs, ctrl) {
	      var prefix = "analytics-";
	      element.on("click", function () {
	        var specialAttrs = _.pick(attrs.$attr, function (value) {
	          return value.indexOf(prefix) === 0;
	        });

	        var options = {};
	        _.each(specialAttrs, function (value, key) {
	          var newKey = value.replace(prefix, "");
	          options[newKey] = attrs[key];
	        });
	        ctrl.track(attrs.analytics, options);
	      });
	    }
	  };

	  return directive;
	};

	exports.default = AnalyticsDirective;

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass2 = __webpack_require__(7);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _classCallCheck2 = __webpack_require__(6);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/* global _ */

	var TeamSelectorDirective = function TeamSelectorDirective() {
	  'ngInject';

	  (0, _classCallCheck3.default)(this, TeamSelectorDirective);
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/teamSelector/teamSelector.html',
	    controller: TeamSelectorController,
	    controllerAs: 'vm',
	    bindToController: true,
	    scope: {
	      ngModel: '='
	    }
	  };

	  return directive;
	};

	var TeamSelectorController = function () {
	  function TeamSelectorController(Api, userService) {
	    'ngInject';

	    var _this = this;

	    (0, _classCallCheck3.default)(this, TeamSelectorController);
	    this._users = _.map(this.ngModel.users, function (email) {
	      var user = { text: email };
	      if (email === userService.getEmail()) {
	        user.class = "owner_tag";
	      }
	      return user;
	    });

	    Api.getTeams().then(function (response) {
	      _this.teams = response.teams;
	      _this.filterTeams();
	      _this.team_members = _.chain(response.teams).pluck('member_emails').flatten().uniq().value();
	    });
	  }

	  (0, _createClass3.default)(TeamSelectorController, [{
	    key: 'change',
	    value: function change() {
	      this.ngModel.users = _.pluck(this._users, 'text');
	      this.filterTeams();
	    }
	  }, {
	    key: 'filterTeams',
	    value: function filterTeams() {
	      var currentEmails = _.pluck(this._users, 'text');
	      this.availableTeams = _.filter(this.teams, function (team) {
	        return _.difference(team.member_emails, currentEmails).length > 0;
	      });
	    }
	  }, {
	    key: 'teamSelect',
	    value: function teamSelect(value) {
	      var _this2 = this;

	      var team = _.find(this.teams, { id: Number(value) });
	      if (!team) {
	        return;
	      }
	      var currentEmails = _.pluck(this._users, 'text');
	      _.each(_.difference(team.member_emails, currentEmails), function (email) {
	        _this2._users.push({ text: email });
	      });

	      this.change();
	    }
	  }, {
	    key: 'newTag',
	    value: function newTag(tag) {
	      tag.class = "new_tag";
	      this.change();
	    }
	  }, {
	    key: 'autocomplete',
	    value: function autocomplete() {
	      return this.team_members;
	    }
	  }]);
	  return TeamSelectorController;
	}();

	exports.default = TeamSelectorDirective;

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _classCallCheck2 = __webpack_require__(6);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _login = __webpack_require__(114);

	var _login2 = _interopRequireDefault(_login);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var LoginDirective = function LoginDirective() {
	  'ngInject';

	  (0, _classCallCheck3.default)(this, LoginDirective);
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/login/login.html',
	    controller: _login2.default,
	    controllerAs: 'vm',
	    bindToController: true,
	    scope: {
	      callback: '&',
	      close: '&',
	      action: '=',
	      advertised: '=',
	      params: '='
	    }
	  };

	  return directive;
	};

	exports.default = LoginDirective;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass2 = __webpack_require__(7);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _classCallCheck2 = __webpack_require__(6);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/* global $ */
	var RelatedDirective = function RelatedDirective() {
	  'ngInject';

	  (0, _classCallCheck3.default)(this, RelatedDirective);
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/related/related.html',
	    controller: RelatedController,
	    controllerAs: 'relatedVm',
	    bindToController: true
	  };

	  return directive;
	};

	var RelatedController = function () {
	  function RelatedController(config, itemService) {
	    'ngInject';

	    (0, _classCallCheck3.default)(this, RelatedController);
	    itemService.getRelated();
	    this._config = config;
	    this._itemService = itemService;
	  }

	  (0, _createClass3.default)(RelatedController, [{
	    key: 'related',
	    value: function related() {
	      var related = this._itemService.related || [];
	      $('#sidebar').toggleClass('show_related_drops', related.length > 1); // HACK
	      return related;
	    }
	  }, {
	    key: 'thumbnail',
	    value: function thumbnail(item) {
	      return "//" + this._config.thumbnails + "/" + item;
	    }
	  }]);
	  return RelatedController;
	}();

	exports.default = RelatedDirective;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _classCallCheck2 = __webpack_require__(6);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _sidebar = __webpack_require__(378);

	var _sidebar2 = _interopRequireDefault(_sidebar);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var SidebarDirective = function SidebarDirective() {
	  'ngInject';

	  (0, _classCallCheck3.default)(this, SidebarDirective);
	  return {
	    restrict: 'E',
	    templateUrl: 'app/sidebar/sidebar.html',
	    controller: _sidebar2.default,
	    controllerAs: 'vm',
	    bindToController: true
	  };
	};

	exports.default = SidebarDirective;

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _classCallCheck2 = __webpack_require__(6);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(7);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _embed = __webpack_require__(372);

	var _embed2 = _interopRequireDefault(_embed);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var SidebarController = function () {
	  function SidebarController($scope, $window, itemService, storageService, $timeout, abilityService, sidebarFactory, shareViaService, analyticsService, $uibModal) {
	    'ngInject';

	    var _this = this;

	    (0, _classCallCheck3.default)(this, SidebarController);
	    this.item = itemService;
	    this.storageService = storageService;
	    this.$timeout = $timeout;
	    this.$window = $window;
	    this.ability = abilityService;
	    this.sidebarFactory = sidebarFactory;
	    this.shareVia = shareViaService;
	    this.analyticsService = analyticsService;

	    itemService.enablePusher();
	    this.sidebarFactory.changeTab('comments');
	    storageService.fetch('sidebarTab', 'comments');
	    this.tab = 'comments';

	    this.setTab(storageService.fetch('sidebarTab', 'comments'));

	    $scope.$watch('vm.sidebarFactory.hidden', function () {
	      _this.toggle();
	    });

	    $scope.copyText = 'Copy Link!';
	    $scope.copyClass = '';

	    this.copyFeedback = function () {
	      $scope.copyText = 'Copied!';
	      $scope.copyClass = 'copied';

	      _this.analyticsService.track('Link Copied', {
	        source_referral: 'viewer_share_widget'
	      });

	      $timeout(function () {
	        $scope.copyText = 'Copy Link!';
	        $scope.copyClass = '';
	      }, 1500);
	    };

	    this.openEmbedModal = function () {
	      (0, _embed2.default)($uibModal);
	    };
	  }

	  (0, _createClass3.default)(SidebarController, [{
	    key: 'submitComment',
	    value: function submitComment() {
	      var $t = this.$timeout;

	      var animate = function animate(selector, klass) {
	        return $('.join_to_team .animation').find(selector).removeClass('hidden').addClass('animated').addClass(klass);
	      };

	      $t(function () {
	        return $('.join_to_team .comments').addClass('animated fadeOut').then(function () {
	          return $t(function () {
	            animate('.js-first', 'fadeInDown');
	          }, 1000);
	        }).then(function () {
	          return $t(function () {
	            animate('.js-second', 'fadeInDown');
	          }, 1000);
	        }).then(function () {
	          return $t(function () {
	            animate('.js-third', 'fadeInDown');
	          }, 1000);
	        });
	      });
	    }
	  }, {
	    key: 'toggleHidden',
	    value: function toggleHidden() {
	      this.sidebarFactory.toggle();
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle() {
	      $(this.$window).trigger('resize');
	    }
	  }, {
	    key: 'isTab',
	    value: function isTab(tab) {
	      return this.sidebarFactory.selectedTab === tab;
	    }
	  }, {
	    key: 'isEventsTab',
	    value: function isEventsTab() {
	      return this.isTab('events');
	    }
	  }, {
	    key: 'isCommentsTab',
	    value: function isCommentsTab() {
	      return this.isTab('comments');
	    }
	  }, {
	    key: 'setTab',
	    value: function setTab(tab) {
	      this.sidebarFactory.changeTab(tab);
	    }
	  }]);
	  return SidebarController;
	}(); /* global $ */


	exports.default = SidebarController;

/***/ }),
/* 379 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = SidebarFactory;
	function SidebarFactory(storageService) {
	  'ngInject';

	  var hidden = storageService.fetch('rhcHidden', false);
	  var selectedTab = storageService.fetch('sidebarTab', 'comments');

	  return {
	    hidden: hidden,
	    selectedTab: selectedTab,
	    toggle: function toggle() {
	      this.hidden = storageService.store('rhcHidden', !this.hidden);
	    },
	    changeTab: function changeTab(newTab) {
	      this.selectedTab = storageService.store('sidebarTab', newTab);
	    }
	  };
	}

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass2 = __webpack_require__(7);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _classCallCheck2 = __webpack_require__(6);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _md = __webpack_require__(381);

	var _md2 = _interopRequireDefault(_md);

	var _login = __webpack_require__(371);

	var _login2 = _interopRequireDefault(_login);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/* global $, _, Autolinker, window */
	var CommentsDirective = function CommentsDirective() {
	  'ngInject';

	  (0, _classCallCheck3.default)(this, CommentsDirective);
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/comments/comments.html',
	    controller: CommentsController,
	    controllerAs: 'vm',
	    bindToController: true
	  };

	  return directive;
	};

	var CommentsController = function () {
	  function CommentsController(Api, itemService, userService, commentService, storageService, loadingService, config, $uibModal) {
	    'ngInject';

	    (0, _classCallCheck3.default)(this, CommentsController);
	    this._config = config;
	    this.commentService = commentService;
	    this._storageService = storageService;
	    this._loadingService = loadingService;
	    this._itemService = itemService;
	    commentService.get();
	    this.newComment = {};
	    this.absoluteDate = storageService.fetch("absoluteDate", false);
	    this.userService = userService;
	    this.modal = $uibModal;

	    $(".comments_list").on("scroll", _.debounce(function () {
	      var scrollHeight = $(this).get(0).scrollHeight;
	      if ($(this).height() + $(this).scrollTop() > scrollHeight - 10) {
	        commentService.next();
	      }
	    }, 200));
	  }

	  (0, _createClass3.default)(CommentsController, [{
	    key: 'submitComment',
	    value: function submitComment() {
	      var _this = this;

	      if (this.newCommentForm.$valid) {
	        if (this.userService.isLoggedIn()) {
	          this.commentService.create(this.newComment);
	          this.newCommentForm.$setPristine();
	          this.newComment = {};
	        } else {
	          (0, _login2.default)(this.modal, 'signUp', { source_referral: 'viewer_comment' }, function () {
	            _this.commentService.create(_this.newComment);
	            window.location.reload();
	          });
	        }
	      }
	    }
	  }, {
	    key: 'canDestroy',
	    value: function canDestroy(comment) {
	      var userId = this.userService.getId();
	      var ownerId = this._itemService.data.owner_id;
	      return !comment._deleted && userId && (comment.user_id === userId || ownerId === userId);
	    }
	  }, {
	    key: 'toggleAbsoluteDate',
	    value: function toggleAbsoluteDate() {
	      this.absoluteDate = this._storageService.store("absoluteDate", !this.absoluteDate);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy(comment) {
	      this.commentService.destroy(comment);
	    }
	  }, {
	    key: 'commentContent',
	    value: function commentContent(comment) {
	      return Autolinker.link(comment.content, {
	        stripPrefix: false
	      }).replace(/\n/g, "<br />");
	    }
	  }, {
	    key: 'avatar',
	    value: function avatar(comment) {
	      var hash = (0, _md2.default)(comment.user).toString();
	      return "https://s.gravatar.com/avatar/" + hash + "?s=80&d=blank";
	    }
	  }]);
	  return CommentsController;
	}();

	exports.default = CommentsDirective;

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(124));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {

		(function (Math) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var Hasher = C_lib.Hasher;
		    var C_algo = C.algo;

		    // Constants table
		    var T = [];

		    // Compute constants
		    (function () {
		        for (var i = 0; i < 64; i++) {
		            T[i] = (Math.abs(Math.sin(i + 1)) * 0x100000000) | 0;
		        }
		    }());

		    /**
		     * MD5 hash algorithm.
		     */
		    var MD5 = C_algo.MD5 = Hasher.extend({
		        _doReset: function () {
		            this._hash = new WordArray.init([
		                0x67452301, 0xefcdab89,
		                0x98badcfe, 0x10325476
		            ]);
		        },

		        _doProcessBlock: function (M, offset) {
		            // Swap endian
		            for (var i = 0; i < 16; i++) {
		                // Shortcuts
		                var offset_i = offset + i;
		                var M_offset_i = M[offset_i];

		                M[offset_i] = (
		                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
		                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
		                );
		            }

		            // Shortcuts
		            var H = this._hash.words;

		            var M_offset_0  = M[offset + 0];
		            var M_offset_1  = M[offset + 1];
		            var M_offset_2  = M[offset + 2];
		            var M_offset_3  = M[offset + 3];
		            var M_offset_4  = M[offset + 4];
		            var M_offset_5  = M[offset + 5];
		            var M_offset_6  = M[offset + 6];
		            var M_offset_7  = M[offset + 7];
		            var M_offset_8  = M[offset + 8];
		            var M_offset_9  = M[offset + 9];
		            var M_offset_10 = M[offset + 10];
		            var M_offset_11 = M[offset + 11];
		            var M_offset_12 = M[offset + 12];
		            var M_offset_13 = M[offset + 13];
		            var M_offset_14 = M[offset + 14];
		            var M_offset_15 = M[offset + 15];

		            // Working varialbes
		            var a = H[0];
		            var b = H[1];
		            var c = H[2];
		            var d = H[3];

		            // Computation
		            a = FF(a, b, c, d, M_offset_0,  7,  T[0]);
		            d = FF(d, a, b, c, M_offset_1,  12, T[1]);
		            c = FF(c, d, a, b, M_offset_2,  17, T[2]);
		            b = FF(b, c, d, a, M_offset_3,  22, T[3]);
		            a = FF(a, b, c, d, M_offset_4,  7,  T[4]);
		            d = FF(d, a, b, c, M_offset_5,  12, T[5]);
		            c = FF(c, d, a, b, M_offset_6,  17, T[6]);
		            b = FF(b, c, d, a, M_offset_7,  22, T[7]);
		            a = FF(a, b, c, d, M_offset_8,  7,  T[8]);
		            d = FF(d, a, b, c, M_offset_9,  12, T[9]);
		            c = FF(c, d, a, b, M_offset_10, 17, T[10]);
		            b = FF(b, c, d, a, M_offset_11, 22, T[11]);
		            a = FF(a, b, c, d, M_offset_12, 7,  T[12]);
		            d = FF(d, a, b, c, M_offset_13, 12, T[13]);
		            c = FF(c, d, a, b, M_offset_14, 17, T[14]);
		            b = FF(b, c, d, a, M_offset_15, 22, T[15]);

		            a = GG(a, b, c, d, M_offset_1,  5,  T[16]);
		            d = GG(d, a, b, c, M_offset_6,  9,  T[17]);
		            c = GG(c, d, a, b, M_offset_11, 14, T[18]);
		            b = GG(b, c, d, a, M_offset_0,  20, T[19]);
		            a = GG(a, b, c, d, M_offset_5,  5,  T[20]);
		            d = GG(d, a, b, c, M_offset_10, 9,  T[21]);
		            c = GG(c, d, a, b, M_offset_15, 14, T[22]);
		            b = GG(b, c, d, a, M_offset_4,  20, T[23]);
		            a = GG(a, b, c, d, M_offset_9,  5,  T[24]);
		            d = GG(d, a, b, c, M_offset_14, 9,  T[25]);
		            c = GG(c, d, a, b, M_offset_3,  14, T[26]);
		            b = GG(b, c, d, a, M_offset_8,  20, T[27]);
		            a = GG(a, b, c, d, M_offset_13, 5,  T[28]);
		            d = GG(d, a, b, c, M_offset_2,  9,  T[29]);
		            c = GG(c, d, a, b, M_offset_7,  14, T[30]);
		            b = GG(b, c, d, a, M_offset_12, 20, T[31]);

		            a = HH(a, b, c, d, M_offset_5,  4,  T[32]);
		            d = HH(d, a, b, c, M_offset_8,  11, T[33]);
		            c = HH(c, d, a, b, M_offset_11, 16, T[34]);
		            b = HH(b, c, d, a, M_offset_14, 23, T[35]);
		            a = HH(a, b, c, d, M_offset_1,  4,  T[36]);
		            d = HH(d, a, b, c, M_offset_4,  11, T[37]);
		            c = HH(c, d, a, b, M_offset_7,  16, T[38]);
		            b = HH(b, c, d, a, M_offset_10, 23, T[39]);
		            a = HH(a, b, c, d, M_offset_13, 4,  T[40]);
		            d = HH(d, a, b, c, M_offset_0,  11, T[41]);
		            c = HH(c, d, a, b, M_offset_3,  16, T[42]);
		            b = HH(b, c, d, a, M_offset_6,  23, T[43]);
		            a = HH(a, b, c, d, M_offset_9,  4,  T[44]);
		            d = HH(d, a, b, c, M_offset_12, 11, T[45]);
		            c = HH(c, d, a, b, M_offset_15, 16, T[46]);
		            b = HH(b, c, d, a, M_offset_2,  23, T[47]);

		            a = II(a, b, c, d, M_offset_0,  6,  T[48]);
		            d = II(d, a, b, c, M_offset_7,  10, T[49]);
		            c = II(c, d, a, b, M_offset_14, 15, T[50]);
		            b = II(b, c, d, a, M_offset_5,  21, T[51]);
		            a = II(a, b, c, d, M_offset_12, 6,  T[52]);
		            d = II(d, a, b, c, M_offset_3,  10, T[53]);
		            c = II(c, d, a, b, M_offset_10, 15, T[54]);
		            b = II(b, c, d, a, M_offset_1,  21, T[55]);
		            a = II(a, b, c, d, M_offset_8,  6,  T[56]);
		            d = II(d, a, b, c, M_offset_15, 10, T[57]);
		            c = II(c, d, a, b, M_offset_6,  15, T[58]);
		            b = II(b, c, d, a, M_offset_13, 21, T[59]);
		            a = II(a, b, c, d, M_offset_4,  6,  T[60]);
		            d = II(d, a, b, c, M_offset_11, 10, T[61]);
		            c = II(c, d, a, b, M_offset_2,  15, T[62]);
		            b = II(b, c, d, a, M_offset_9,  21, T[63]);

		            // Intermediate hash value
		            H[0] = (H[0] + a) | 0;
		            H[1] = (H[1] + b) | 0;
		            H[2] = (H[2] + c) | 0;
		            H[3] = (H[3] + d) | 0;
		        },

		        _doFinalize: function () {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;

		            var nBitsTotal = this._nDataBytes * 8;
		            var nBitsLeft = data.sigBytes * 8;

		            // Add padding
		            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);

		            var nBitsTotalH = Math.floor(nBitsTotal / 0x100000000);
		            var nBitsTotalL = nBitsTotal;
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = (
		                (((nBitsTotalH << 8)  | (nBitsTotalH >>> 24)) & 0x00ff00ff) |
		                (((nBitsTotalH << 24) | (nBitsTotalH >>> 8))  & 0xff00ff00)
		            );
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
		                (((nBitsTotalL << 8)  | (nBitsTotalL >>> 24)) & 0x00ff00ff) |
		                (((nBitsTotalL << 24) | (nBitsTotalL >>> 8))  & 0xff00ff00)
		            );

		            data.sigBytes = (dataWords.length + 1) * 4;

		            // Hash final blocks
		            this._process();

		            // Shortcuts
		            var hash = this._hash;
		            var H = hash.words;

		            // Swap endian
		            for (var i = 0; i < 4; i++) {
		                // Shortcut
		                var H_i = H[i];

		                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
		                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
		            }

		            // Return final computed hash
		            return hash;
		        },

		        clone: function () {
		            var clone = Hasher.clone.call(this);
		            clone._hash = this._hash.clone();

		            return clone;
		        }
		    });

		    function FF(a, b, c, d, x, s, t) {
		        var n = a + ((b & c) | (~b & d)) + x + t;
		        return ((n << s) | (n >>> (32 - s))) + b;
		    }

		    function GG(a, b, c, d, x, s, t) {
		        var n = a + ((b & d) | (c & ~d)) + x + t;
		        return ((n << s) | (n >>> (32 - s))) + b;
		    }

		    function HH(a, b, c, d, x, s, t) {
		        var n = a + (b ^ c ^ d) + x + t;
		        return ((n << s) | (n >>> (32 - s))) + b;
		    }

		    function II(a, b, c, d, x, s, t) {
		        var n = a + (c ^ (b | ~d)) + x + t;
		        return ((n << s) | (n >>> (32 - s))) + b;
		    }

		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.MD5('message');
		     *     var hash = CryptoJS.MD5(wordArray);
		     */
		    C.MD5 = Hasher._createHelper(MD5);

		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacMD5(message, key);
		     */
		    C.HmacMD5 = Hasher._createHmacHelper(MD5);
		}(Math));


		return CryptoJS.MD5;

	}));

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _classCallCheck2 = __webpack_require__(6);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(7);

	var _createClass3 = _interopRequireDefault(_createClass2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/* global _ */

	var CommentService = function () {
	  function CommentService(Api, pusherService, $timeout) {
	    'ngInject';

	    var _this = this;

	    (0, _classCallCheck3.default)(this, CommentService);
	    this.Api = Api;
	    this.$timeout = $timeout;

	    this.comments = [];
	    this.count = 0;
	    this._perPage = 20;
	    this._pages = {};

	    pusherService.bindChannel('item', 'new-comment', function (data) {
	      _this._add(data);
	    });

	    pusherService.bindChannel('item', 'delete-comment', function (data) {
	      _this._destroy(data);
	    });
	  }

	  (0, _createClass3.default)(CommentService, [{
	    key: 'setItem',
	    value: function setItem(slug) {
	      this.slug = slug;
	      return this;
	    }
	  }, {
	    key: 'get',
	    value: function get(_page) {
	      var _this2 = this;

	      var page = _page || 1;

	      if (this._pages[page]) {
	        return;
	      }
	      this._pages[page] = true;

	      var response = this.Api.getComments(this.slug, {
	        page: page
	      });

	      response.then(function (data) {
	        _this2.comments = _.uniq(_.union(data.comments, _this2.comments), 'id');
	        _this2.count = data.meta.count;
	      });

	      return response;
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy(comment) {
	      if (comment._deleted) {
	        return;
	      }
	      comment._deleted = true;

	      this.Api.destroyComment(this.slug, comment.id);
	    }
	  }, {
	    key: '_destroy',
	    value: function _destroy(data) {
	      var _this3 = this;

	      var item = _.find(this.comments, { id: data.id });
	      if (!item) {
	        return;
	      }
	      this.$timeout(function () {
	        _this3.count -= 1;
	        _this3.comments = _.difference(_this3.comments, [item]);
	      });
	    }
	  }, {
	    key: '_add',
	    value: function _add(item) {
	      var _this4 = this;

	      this.$timeout(function () {
	        _this4.count += 1;
	        _this4.comments = _.uniq(_.union(_this4.comments, [item]), 'id');
	      });
	    }
	  }, {
	    key: 'create',
	    value: function create(data) {
	      return this.Api.createComment(this.slug, { comment: data });
	    }
	  }, {
	    key: 'next',
	    value: function next() {
	      var nextPage = Math.floor(this.comments.length / this._perPage) + 1;
	      this.get(nextPage);
	    }
	  }]);
	  return CommentService;
	}();

	exports.default = CommentService;

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass2 = __webpack_require__(7);

	var _createClass3 = _interopRequireDefault(_createClass2);

	var _classCallCheck2 = __webpack_require__(6);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/* global $, _ */

	var EventsDirective = function EventsDirective() {
	  'ngInject';

	  (0, _classCallCheck3.default)(this, EventsDirective);
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/events/events.html',
	    controller: EventsController,
	    controllerAs: 'vm',
	    bindToController: true
	  };

	  return directive;
	};

	var EventsController = function () {
	  function EventsController(itemService, eventService, storageService) {
	    'ngInject';

	    (0, _classCallCheck3.default)(this, EventsController);
	    this.eventService = eventService;
	    this._storageService = storageService;
	    eventService.get();
	    this.absoluteDate = storageService.fetch("absoluteDate", false);

	    $(".right_hand_column .events").on("scroll", _.debounce(function () {
	      var scrollHeight = $(this).get(0).scrollHeight;
	      if ($(this).height() + $(this).scrollTop() > scrollHeight - 10) {
	        eventService.next();
	      }
	    }, 200));
	  }

	  (0, _createClass3.default)(EventsController, [{
	    key: 'toggleAbsoluteDate',
	    value: function toggleAbsoluteDate() {
	      this.absoluteDate = this._storageService.store("absoluteDate", !this.absoluteDate);
	    }
	  }]);
	  return EventsController;
	}();

	exports.default = EventsDirective;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _classCallCheck2 = __webpack_require__(6);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(7);

	var _createClass3 = _interopRequireDefault(_createClass2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/* global _ */

	var EventService = function () {
	  function EventService(Api, pusherService, $timeout) {
	    'ngInject';

	    (0, _classCallCheck3.default)(this, EventService);
	    this.Api = Api;
	    this.$timeout = $timeout;
	    this._pusherService = pusherService;

	    this.events = [];
	    this.count = 0;
	    this._perPage = 20;
	    this._pages = {};
	  }

	  (0, _createClass3.default)(EventService, [{
	    key: 'setItem',
	    value: function setItem(slug) {
	      var _this = this;

	      this.slug = slug;
	      this._pusherService.bindChannel('items', 'new-event-item-' + slug, function (data) {
	        _this._add(data);
	      });

	      return this;
	    }
	  }, {
	    key: 'get',
	    value: function get(_page) {
	      var _this2 = this;

	      var page = _page || 1;
	      if (this._pages[page]) {
	        return;
	      }
	      this._pages[page] = true;

	      var response = this.Api.getEvents(this.slug, {
	        page: page
	      });

	      response.then(function (data) {
	        _this2.events = _.uniq(_.union(data.events, _this2.events), 'id');
	        _this2.count = data.meta.count;
	      });

	      return response;
	    }
	  }, {
	    key: '_add',
	    value: function _add(item) {
	      var _this3 = this;

	      this.$timeout(function () {
	        _this3.count += 1;
	        _this3.events = _.uniq(_.union(_this3.events, [item]), 'id');
	      });
	    }
	  }, {
	    key: 'next',
	    value: function next() {
	      var nextPage = Math.floor(this.events.length / this._perPage) + 1;
	      this.get(nextPage);
	    }
	  }]);
	  return EventService;
	}();

	exports.default = EventService;

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _classCallCheck2 = __webpack_require__(6);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(7);

	var _createClass3 = _interopRequireDefault(_createClass2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/* global document */

	var SourceService = function () {
	  function SourceService() {
	    (0, _classCallCheck3.default)(this, SourceService);
	  }

	  (0, _createClass3.default)(SourceService, [{
	    key: "sourceDirectOrOrganic",
	    value: function sourceDirectOrOrganic() {
	      var referrer = document.referrer;

	      var fromOurSites = function fromOurSites() {
	        return !!(referrer.match(/[\/\.]viewer\.dev/) || referrer.match(/[\/\.]getcloudapp\.com/));
	      };

	      if (referrer === "") {
	        return { source_direct: true };
	      } else if (!fromOurSites()) {
	        return { source_organic: referrer };
	      } else {
	        return {};
	      }
	    }
	  }]);
	  return SourceService;
	}();

	exports.default = SourceService;

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _classCallCheck2 = __webpack_require__(6);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _tout = __webpack_require__(387);

	var _tout2 = _interopRequireDefault(_tout);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var ToutDirective = function ToutDirective() {
	  'ngInject';

	  (0, _classCallCheck3.default)(this, ToutDirective);
	  return {
	    restrict: 'E',
	    templateUrl: 'app/tout/tout.html',
	    controller: _tout2.default,
	    controllerAs: 'vm',
	    bindToController: true,
	    scope: true
	  };
	};

	exports.default = ToutDirective;

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _classCallCheck2 = __webpack_require__(6);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _createClass2 = __webpack_require__(7);

	var _createClass3 = _interopRequireDefault(_createClass2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/* global window */
	var ToutController = function () {
	  function ToutController($scope, storageService, analyticsService, itemService, Api) {
	    'ngInject';

	    var _this = this;

	    (0, _classCallCheck3.default)(this, ToutController);
	    this.scope = $scope;
	    this.storageService = storageService;
	    this.itemService = itemService;
	    this.analyticsService = analyticsService;
	    this.apiService = Api;

	    this.apiService.getTout(this.itemService.slug()).then(function (data) {
	      return _this.initializeTout(data);
	    });
	  }

	  (0, _createClass3.default)(ToutController, [{
	    key: 'initializeTout',
	    value: function initializeTout(toutData) {
	      var _this2 = this;

	      var tout = toutData;
	      this.scope.tout = tout;

	      if (tout.user_type !== 'not_logged_in') {
	        this.checkToutDisplayStatus();
	      }

	      if (tout.visible === true) {
	        this.scope.isVisibleClassName = 'tout_visible';

	        var utmTerm = tout.expanded === true ? 'expanded' : 'minimized';

	        if (tout.button_url !== null) {
	          tout.button_url += '&utm_term=' + utmTerm;
	        }
	        this.analyticsService.track('ToutShown', {
	          expanded: tout.expanded,
	          offer: tout.button_msg,
	          user: tout.user_type
	        });

	        // dataLayer is supplied from Google Tag manager and if you're not serving from viso it won't be available.
	        if (window.dataLayer) {
	          window.dataLayer.push({
	            event: 'ToutShown',
	            toutUserType: tout.user_type
	          });
	          window.dataLayer.push({ event: 'optimize.activate' });
	        }
	      }

	      tout.onClick = function () {
	        if (tout.button_url !== null) {
	          window.location.href = tout.button_url;
	        } else {
	          _this2.apiService.hideTout(_this2.itemService.slug()).then(function () {
	            return tout.visible = false;
	          });
	        }
	      };
	    }
	  }, {
	    key: 'checkToutDisplayStatus',
	    value: function checkToutDisplayStatus() {
	      var expiredTime = 24 * 60 * 60 * 1000;
	      var currentDate = new Date();

	      var previousDay = this.storageService.fetch('toutLastSeen');
	      this.storageService.store('toutLastSeen', currentDate.getTime());
	      if (previousDay !== undefined && currentDate.getTime() - previousDay <= expiredTime) {
	        this.scope.tout.visible = false;
	      }
	    }
	  }]);
	  return ToutController;
	}();

	exports.default = ToutController;

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _classCallCheck2 = __webpack_require__(6);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _ouibounce = __webpack_require__(120);

	var _ouibounce2 = _interopRequireDefault(_ouibounce);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var OuibounceDirective = function OuibounceDirective() {
	  'ngInject';

	  (0, _classCallCheck3.default)(this, OuibounceDirective);
	  return {
	    restrict: 'E',
	    templateUrl: 'app/ouibounce/ouibounce.html',
	    controller: _ouibounce2.default,
	    controllerAs: 'vm',
	    bindToController: true,
	    scope: {
	      action: '='
	    }
	  };
	};

	exports.default = OuibounceDirective;

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _classCallCheck2 = __webpack_require__(6);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	var _upgrade = __webpack_require__(121);

	var _upgrade2 = _interopRequireDefault(_upgrade);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var UpgradeDirective = function UpgradeDirective() {
	  'ngInject';

	  (0, _classCallCheck3.default)(this, UpgradeDirective);
	  return {
	    restrict: 'E',
	    templateUrl: 'app/upgrade/upgrade.html',
	    controller: _upgrade2.default,
	    controllerAs: 'vm',
	    bindToController: true,
	    scope: true
	  };
	};

	exports.default = UpgradeDirective;

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _classCallCheck2 = __webpack_require__(6);

	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/* globals $, _ */

	var ChosenSelect = function ChosenSelect() {
	  'ngInject';

	  (0, _classCallCheck3.default)(this, ChosenSelect);
	  var directive = {
	    restrict: 'C',
	    scope: {
	      ngModel: '=?',
	      change: '&',
	      options: '=?'
	    },
	    link: function link(scope, element) {
	      element.chosen({
	        disable_search_threshold: 9
	      });

	      element.on("change", function () {
	        scope.change({ value: $(this).val() });
	      });

	      scope.$watch("options", function () {
	        _.defer(function () {
	          return element.trigger("chosen:updated");
	        });
	      });

	      scope.$watch("ngModel", function () {
	        _.defer(function () {
	          return element.trigger("chosen:updated");
	        });
	      });
	    }
	  };

	  return directive;
	};

	exports.default = ChosenSelect;

/***/ }),
/* 391 */
/***/ (function(module, exports) {

	"use strict";

	angular.module("viewerConfig", []).constant("config", {
		"apiBase": "https://my.cl.ly",
		"appBase": "https://my.cl.ly",
		"appBaseV2": "https://share.getcloudapp.com",
		"secureBase": "https://cl.ly/",
		"marketingBase": "https://www.getcloudapp.com",
		"transcodingBase": "https://transcodings.cl.ly/transcodings",
		"thumbnails": "a3a68up577.execute-api.us-east-1.amazonaws.com/production/t",
		"vendorPath": "//s3.amazonaws.com/static.cl.ly/vendor",
		"s3bucket": "static.cl.ly",
		"schema": "https",
		"env": {
			"FILEPICKER_KEY": "Auiv8dTyGQSGrUA6TLwKez",
			"AIRBRAKE_ID": "114043",
			"AIRBRAKE_KEY": "8a2815dfa77e69605776062fb959280c",
			"NODE_ENV": "production",
			"SHARETHIS_KEY": "83992abc-7c26-4434-8609-c6bad278d4d8",
			"SEGMENT_KEY": "g9l0ckpunp",
			"ROLLBAR_TOKEN": "e377da1666874356a57c786619be489e"
		}
	});

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = ExceptionHandler;

	var _rollbar = __webpack_require__(393);

	var _rollbar2 = _interopRequireDefault(_rollbar);

	var _rollbar3 = __webpack_require__(394);

	var _rollbar4 = _interopRequireDefault(_rollbar3);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function ExceptionHandler($log, config) {
	    'ngInject';

	    var __is_deployed = config.env.NODE_ENV == 'staging' || config.env.NODE_ENV == 'production';
	    if (__is_deployed) {
	        var rollbar = _rollbar4.default.init({
	            accessToken: config.env.ROLLBAR_TOKEN,
	            captureUncaught: true,
	            captureUnhandledRejections: true
	        });

	        rollbar.configure({
	            environment: config.env.NODE_ENV
	        });
	    }

	    var rollbarHandler = (0, _rollbar2.default)($log, config, rollbar);

	    return function (exception, cause) {
	        $('body').addClass('exception');
	        $log.error(exception);

	        if (__is_deployed) {
	            try {
	                exception.params = { angular_cause: cause };
	            } catch (e) {}

	            // rollbarHandler(exception, cause);
	        }
	    };
	}

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = ExceptionHandler;

	var _rollbar = __webpack_require__(394);

	var _rollbar2 = _interopRequireDefault(_rollbar);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function ExceptionHandler($log, config, rollbar) {

	    return function (exception, cause) {
	        rollbar.error(exception, cause);
	    };
	}

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.rollbar=e():t.rollbar=e()}(this,function(){return function(t){function e(n){if(r[n])return r[n].exports;var o=r[n]={exports:{},id:n,loaded:!1};return t[n].call(o.exports,o,o.exports,e),o.loaded=!0,o.exports}var r={};return e.m=t,e.c=r,e.p="",e(0)}([function(t,e,r){t.exports=r(1)},function(t,e,r){"use strict";var n=r(2),o="undefined"!=typeof window&&window._rollbarConfig,i=o&&o.globalAlias||"Rollbar",a="undefined"!=typeof window&&window[i]&&"function"==typeof window[i].shimId&&void 0!==window[i].shimId();if("undefined"==typeof window||window._rollbarStartTime||(window._rollbarStartTime=(new Date).getTime()),!a&&o){var s=new n(o);window[i]=s}else"undefined"!=typeof window?(window.rollbar=n,window._rollbarDidLoad=!0):"undefined"!=typeof self&&(self.rollbar=n,self._rollbarDidLoad=!0);t.exports=n},function(t,e,r){"use strict";function n(t,e){this.options=c.handleOptions(x,t);var r=new l(this.options,h,d);this.client=e||new u(this.options,r,p,"browser");var n="undefined"!=typeof window&&window||"undefined"!=typeof self&&self,o="undefined"!=typeof document&&document;i(this.client.notifier),a(this.client.queue),(this.options.captureUncaught||this.options.handleUncaughtExceptions)&&(f.captureUncaughtExceptions(n,this),f.wrapGlobals(n,this)),(this.options.captureUnhandledRejections||this.options.handleUnhandledRejections)&&f.captureUnhandledRejections(n,this),this.instrumenter=new w(this.options,this.client.telemeter,this,n,o),this.instrumenter.instrument()}function o(t){var e="Rollbar is not initialized";p.error(e),t&&t(new Error(e))}function i(t){t.addTransform(m.handleItemWithError).addTransform(m.ensureItemHasSomethingToSay).addTransform(m.addBaseInfo).addTransform(m.addRequestInfo(window)).addTransform(m.addClientInfo(window)).addTransform(m.addPluginInfo(window)).addTransform(m.addBody).addTransform(g.addMessageWithError).addTransform(g.addTelemetryData).addTransform(g.addConfigToPayload).addTransform(m.scrubPayload).addTransform(g.userTransform(p)).addTransform(g.itemToPayload)}function a(t){t.addPredicate(y.checkLevel).addPredicate(v.checkIgnore).addPredicate(y.userCheckIgnore(p)).addPredicate(y.urlIsNotBlacklisted(p)).addPredicate(y.urlIsWhitelisted(p)).addPredicate(y.messageIsIgnored(p))}function s(t){for(var e=0,r=t.length;e<r;++e)if(c.isFunction(t[e]))return t[e]}var u=r(3),c=r(5),l=r(11),p=r(13),f=r(16),h=r(17),d=r(19),m=r(20),g=r(24),v=r(25),y=r(26),b=r(21),w=r(27),_=null;n.init=function(t,e){return _?_.global(t).configure(t):_=new n(t,e)},n.prototype.global=function(t){return this.client.global(t),this},n.global=function(t){return _?_.global(t):void o()},n.prototype.configure=function(t,e){var r=this.options,n={};return e&&(n={payload:e}),this.options=c.handleOptions(r,t,n),this.client.configure(this.options,e),this.instrumenter.configure(this.options),this},n.configure=function(t,e){return _?_.configure(t,e):void o()},n.prototype.lastError=function(){return this.client.lastError},n.lastError=function(){return _?_.lastError():void o()},n.prototype.log=function(){var t=this._createItem(arguments),e=t.uuid;return this.client.log(t),{uuid:e}},n.log=function(){if(_)return _.log.apply(_,arguments);var t=s(arguments);o(t)},n.prototype.debug=function(){var t=this._createItem(arguments),e=t.uuid;return this.client.debug(t),{uuid:e}},n.debug=function(){if(_)return _.debug.apply(_,arguments);var t=s(arguments);o(t)},n.prototype.info=function(){var t=this._createItem(arguments),e=t.uuid;return this.client.info(t),{uuid:e}},n.info=function(){if(_)return _.info.apply(_,arguments);var t=s(arguments);o(t)},n.prototype.warn=function(){var t=this._createItem(arguments),e=t.uuid;return this.client.warn(t),{uuid:e}},n.warn=function(){if(_)return _.warn.apply(_,arguments);var t=s(arguments);o(t)},n.prototype.warning=function(){var t=this._createItem(arguments),e=t.uuid;return this.client.warning(t),{uuid:e}},n.warning=function(){if(_)return _.warning.apply(_,arguments);var t=s(arguments);o(t)},n.prototype.error=function(){var t=this._createItem(arguments),e=t.uuid;return this.client.error(t),{uuid:e}},n.error=function(){if(_)return _.error.apply(_,arguments);var t=s(arguments);o(t)},n.prototype.critical=function(){var t=this._createItem(arguments),e=t.uuid;return this.client.critical(t),{uuid:e}},n.critical=function(){if(_)return _.critical.apply(_,arguments);var t=s(arguments);o(t)},n.prototype.handleUncaughtException=function(t,e,r,n,o,i){var a,s=c.makeUnhandledStackInfo(t,e,r,n,o,"onerror","uncaught exception",b);c.isError(o)?(a=this._createItem([t,o,i]),a._unhandledStackInfo=s):c.isError(e)?(a=this._createItem([t,e,i]),a._unhandledStackInfo=s):(a=this._createItem([t,i]),a.stackInfo=s),a.level=this.options.uncaughtErrorLevel,a._isUncaught=!0,this.client.log(a)},n.prototype.handleUnhandledRejection=function(t,e){var r="unhandled rejection was null or undefined!";if(t)if(t.message)r=t.message;else{var n=c.stringify(t);n.value&&(r=n.value)}var o,i=t&&t._rollbarContext||e&&e._rollbarContext;c.isError(t)?o=this._createItem([r,t,i]):(o=this._createItem([r,t,i]),o.stackInfo=c.makeUnhandledStackInfo(r,"",0,0,null,"unhandledrejection","",b)),o.level=this.options.uncaughtErrorLevel,o._isUncaught=!0,o._originalArgs=o._originalArgs||[],o._originalArgs.push(e),this.client.log(o)},n.prototype.wrap=function(t,e,r){try{var n;if(n=c.isFunction(e)?e:function(){return e||{}},!c.isFunction(t))return t;if(t._isWrap)return t;if(!t._rollbar_wrapped&&(t._rollbar_wrapped=function(){r&&c.isFunction(r)&&r.apply(this,arguments);try{return t.apply(this,arguments)}catch(r){var e=r;throw e&&(c.isType(e,"string")&&(e=new String(e)),e._rollbarContext=n()||{},e._rollbarContext._wrappedSource=t.toString(),window._rollbarWrappedError=e),e}},t._rollbar_wrapped._isWrap=!0,t.hasOwnProperty))for(var o in t)t.hasOwnProperty(o)&&(t._rollbar_wrapped[o]=t[o]);return t._rollbar_wrapped}catch(e){return t}},n.wrap=function(t,e){return _?_.wrap(t,e):void o()},n.prototype.captureEvent=function(t,e){return this.client.captureEvent(t,e)},n.captureEvent=function(t,e){return _?_.captureEvent(t,e):void o()},n.prototype.captureDomContentLoaded=function(t,e){return e||(e=new Date),this.client.captureDomContentLoaded(e)},n.prototype.captureLoad=function(t,e){return e||(e=new Date),this.client.captureLoad(e)},n.prototype._createItem=function(t){return c.createItem(t,p,this)};var x={version:"2.5.0",scrubFields:["pw","pass","passwd","password","secret","confirm_password","confirmPassword","password_confirmation","passwordConfirmation","access_token","accessToken","secret_key","secretKey","secretToken","cc-number","card number","cardnumber","cardnum","ccnum","ccnumber","cc num","creditcardnumber","credit card number","newcreditcardnumber","new credit card","creditcardno","credit card no","card#","card #","cc-csc","cvc2","cvv2","ccv2","security code","card verification","name on credit card","name on card","nameoncard","cardholder","card holder","name des karteninhabers","card type","cardtype","cc type","cctype","payment type","expiration date","expirationdate","expdate","cc-exp"],logLevel:"debug",reportLevel:"debug",uncaughtErrorLevel:"error",endpoint:"api.rollbar.com/api/1/item/",verbose:!1,enabled:!0,sendConfig:!1,includeItemsInTelemetry:!0,captureIp:!0};t.exports=n},function(t,e,r){"use strict";function n(t,e,r,o){this.options=c.merge(t),this.logger=r,n.rateLimiter.configureGlobal(this.options),n.rateLimiter.setPlatformOptions(o,this.options),this.queue=new a(n.rateLimiter,e,r,this.options),this.notifier=new s(this.queue,this.options),this.telemeter=new u(this.options),this.lastError=null,this.lastErrorHash="none"}function o(t){var e=t.message||"",r=(t.err||{}).stack||String(t.err);return e+"::"+r}var i=r(4),a=r(8),s=r(9),u=r(10),c=r(5),l={maxItems:0,itemsPerMinute:60};n.rateLimiter=new i(l),n.prototype.global=function(t){return n.rateLimiter.configureGlobal(t),this},n.prototype.configure=function(t,e){var r=this.options,n={};return e&&(n={payload:e}),this.options=c.merge(r,t,n),this.notifier&&this.notifier.configure(this.options),this.telemeter&&this.telemeter.configure(this.options),this.global(this.options),this},n.prototype.log=function(t){var e=this._defaultLogLevel();return this._log(e,t)},n.prototype.debug=function(t){this._log("debug",t)},n.prototype.info=function(t){this._log("info",t)},n.prototype.warn=function(t){this._log("warning",t)},n.prototype.warning=function(t){this._log("warning",t)},n.prototype.error=function(t){this._log("error",t)},n.prototype.critical=function(t){this._log("critical",t)},n.prototype.wait=function(t){this.queue.wait(t)},n.prototype.captureEvent=function(t,e){return this.telemeter.captureEvent(t,e)},n.prototype.captureDomContentLoaded=function(t){return this.telemeter.captureDomContentLoaded(t)},n.prototype.captureLoad=function(t){return this.telemeter.captureLoad(t)},n.prototype._log=function(t,e){var r;if(e.callback&&(r=e.callback,delete e.callback),this._sameAsLastError(e)){if(r){var n=new Error("ignored identical item");n.item=e,r(n)}}else try{e.level=e.level||t,this.telemeter._captureRollbarItem(e),e.telemetryEvents=this.telemeter.copyEvents(),this.notifier.log(e,r)}catch(t){this.logger.error(t)}},n.prototype._defaultLogLevel=function(){return this.options.logLevel||"debug"},n.prototype._sameAsLastError=function(t){if(!t._isUncaught)return!1;var e=o(t);return this.lastErrorHash===e||(this.lastError=t.err,this.lastErrorHash=e,!1)},t.exports=n},function(t,e,r){"use strict";function n(t){this.startTime=s.now(),this.counter=0,this.perMinCounter=0,this.platform=null,this.platformOptions={},this.configureGlobal(t)}function o(t,e,r){return!t.ignoreRateLimit&&e>=1&&r>e}function i(t,e,r,n,o,i,s){var u=null;return r&&(r=new Error(r)),r||n||(u=a(t,e,o,i,s)),{error:r,shouldSend:n,payload:u}}function a(t,e,r,n,o){var i,a=e.environment||e.payload&&e.payload.environment;i=o?"item per minute limit reached, ignoring errors until timeout":"maxItems has been hit, ignoring errors until reset.";var s={body:{message:{body:i,extra:{maxItems:r,itemsPerMinute:n}}},language:"javascript",environment:a,notifier:{version:e.notifier&&e.notifier.version||e.version}};return"browser"===t?(s.platform="browser",s.framework="browser-js",s.notifier.name="rollbar-browser-js"):"server"===t?(s.framework=e.framework||"node-js",s.notifier.name=e.notifier.name):"react-native"===t&&(s.framework=e.framework||"react-native",s.notifier.name=e.notifier.name),s}var s=r(5);n.globalSettings={startTime:s.now(),maxItems:void 0,itemsPerMinute:void 0},n.prototype.configureGlobal=function(t){void 0!==t.startTime&&(n.globalSettings.startTime=t.startTime),void 0!==t.maxItems&&(n.globalSettings.maxItems=t.maxItems),void 0!==t.itemsPerMinute&&(n.globalSettings.itemsPerMinute=t.itemsPerMinute)},n.prototype.shouldSend=function(t,e){e=e||s.now();var r=e-this.startTime;(r<0||r>=6e4)&&(this.startTime=e,this.perMinCounter=0);var a=n.globalSettings.maxItems,u=n.globalSettings.itemsPerMinute;if(o(t,a,this.counter))return i(this.platform,this.platformOptions,a+" max items reached",!1);if(o(t,u,this.perMinCounter))return i(this.platform,this.platformOptions,u+" items per minute reached",!1);this.counter++,this.perMinCounter++;var c=!o(t,a,this.counter),l=c;return c=c&&!o(t,u,this.perMinCounter),i(this.platform,this.platformOptions,null,c,a,u,l)},n.prototype.setPlatformOptions=function(t,e){this.platform=t,this.platformOptions=e},t.exports=n},function(t,e,r){"use strict";function n(){if(!F&&(F=!0,c(JSON)&&(s(JSON.stringify)&&(A.stringify=JSON.stringify),s(JSON.parse)&&(A.parse=JSON.parse)),!a(A.stringify)||!a(A.parse))){var t=r(7);t(A)}}function o(t,e){return e===i(t)}function i(t){var e=typeof t;return"object"!==e?e:t?t instanceof Error?"error":{}.toString.call(t).match(/\s([a-zA-Z]+)/)[1].toLowerCase():"null"}function a(t){return o(t,"function")}function s(t){var e=/[\\^$.*+?()[\]{}|]/g,r=Function.prototype.toString.call(Object.prototype.hasOwnProperty).replace(e,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?"),n=RegExp("^"+r+"$");return u(t)&&n.test(t)}function u(t){var e=typeof t;return null!=t&&("object"==e||"function"==e)}function c(t){return!o(t,"undefined")}function l(t){var e=i(t);return"object"===e||"array"===e}function p(t){return o(t,"error")}function f(t,e,r){var n,i,a,s=o(t,"object"),u=o(t,"array"),c=[];if(s&&r.indexOf(t)!==-1)return t;if(r.push(t),s)for(n in t)Object.prototype.hasOwnProperty.call(t,n)&&c.push(n);else if(u)for(a=0;a<t.length;++a)c.push(a);var l=s?{}:[],p=!0;for(a=0;a<c.length;++a)n=c[a],i=t[n],l[n]=e(n,i,r),p=p&&l[n]===t[n];return 0==c.length||p?t:l}function h(){return"********"}function d(){var t=N(),e="xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,function(e){var r=(t+16*Math.random())%16|0;return t=Math.floor(t/16),("x"===e?r:7&r|8).toString(16)});return e}function m(t){var e=g(t);return e?(""===e.anchor&&(e.source=e.source.replace("#","")),t=e.source.replace("?"+e.query,"")):"(unknown)"}function g(t){if(o(t,"string")){for(var e=P,r=e.parser[e.strictMode?"strict":"loose"].exec(t),n={},i=e.key.length;i--;)n[e.key[i]]=r[i]||"";return n[e.q.name]={},n[e.key[12]].replace(e.q.parser,function(t,r,o){r&&(n[e.q.name][r]=o)}),n}}function v(t,e,r){r=r||{},r.access_token=t;var n,o=[];for(n in r)Object.prototype.hasOwnProperty.call(r,n)&&o.push([n,r[n]].join("="));var i="?"+o.sort().join("&");e=e||{},e.path=e.path||"";var a,s=e.path.indexOf("?"),u=e.path.indexOf("#");s!==-1&&(u===-1||u>s)?(a=e.path,e.path=a.substring(0,s)+i+"&"+a.substring(s+1)):u!==-1?(a=e.path,e.path=a.substring(0,u)+i+a.substring(u)):e.path=e.path+i}function y(t,e){if(e=e||t.protocol,!e&&t.port&&(80===t.port?e="http:":443===t.port&&(e="https:")),e=e||"https:",!t.hostname)return null;var r=e+"//"+t.hostname;return t.port&&(r=r+":"+t.port),t.path&&(r+=t.path),r}function b(t,e){var r,n;try{r=A.stringify(t)}catch(o){if(e&&a(e))try{r=e(t)}catch(t){n=t}else n=o}return{error:n,value:r}}function w(t){var e,r;try{e=A.parse(t)}catch(t){r=t}return{error:r,value:e}}function _(t,e,r,n,o,i,a,s){var u={url:e||"",line:r,column:n};u.func=s.guessFunctionName(u.url,u.line),u.context=s.gatherContext(u.url,u.line);var c=document&&document.location&&document.location.href,l=window&&window.navigator&&window.navigator.userAgent;return{mode:i,message:o?String(o):t||a,url:c,stack:[u],useragent:l}}function x(t,e){return function(r,n){try{e(r,n)}catch(e){t.error(e)}}}function k(t,e,r,n,o){for(var a,s,u,c,l,p,f=[],h=0,m=t.length;h<m;++h){p=t[h];var g=i(p);switch(g){case"undefined":break;case"string":a?f.push(p):a=p;break;case"function":c=x(e,p);break;case"date":f.push(p);break;case"error":case"domexception":s?f.push(p):s=p;break;case"object":case"array":if(p instanceof Error||"undefined"!=typeof DOMException&&p instanceof DOMException){s?f.push(p):s=p;break}if(n&&"object"===g&&!l){for(var v=0,y=n.length;v<y;++v)if(void 0!==p[n[v]]){l=p;break}if(l)break}u?f.push(p):u=p;break;default:if(p instanceof Error||"undefined"!=typeof DOMException&&p instanceof DOMException){s?f.push(p):s=p;break}f.push(p)}}f.length>0&&(u=R(u),u.extraArgs=f);var b={message:a,err:s,custom:u,timestamp:N(),callback:c,uuid:d()};return u&&void 0!==u.level&&(b.level=u.level,delete u.level),n&&l&&(b.request=l),o&&(b.lambdaContext=o),b._originalArgs=t,b}function E(t,e){if(t){var r=e.split("."),n=t;try{for(var o=0,i=r.length;o<i;++o)n=n[r[o]]}catch(t){n=void 0}return n}}function I(t,e,r){if(t){var n=e.split("."),o=n.length;if(!(o<1)){if(1===o)return void(t[n[0]]=r);try{for(var i=t[n[0]]||{},a=i,s=1;s<o-1;s++)i[n[s]]=i[n[s]]||{},i=i[n[s]];i[n[o-1]]=r,t[n[0]]=a}catch(t){return}}}}function T(t,e){function r(t,e,r,n,o,i){return e+h(i)}function n(t){var e;if(o(t,"string"))for(e=0;e<u.length;++e)t=t.replace(u[e],r);return t}function i(t,e){var r;for(r=0;r<s.length;++r)if(s[r].test(t)){e=h(e);break}return e}function a(t,e,r){var s=i(t,e);return s===e?o(e,"object")||o(e,"array")?f(e,a,r):n(s):s}e=e||[];var s=S(e),u=O(e);return f(t,a,[])}function S(t){for(var e,r=[],n=0;n<t.length;++n)e="^\\[?(%5[bB])?"+t[n]+"\\[?(%5[bB])?\\]?(%5[dD])?$",r.push(new RegExp(e,"i"));return r}function O(t){for(var e,r=[],n=0;n<t.length;++n)e="\\[?(%5[bB])?"+t[n]+"\\[?(%5[bB])?\\]?(%5[dD])?",r.push(new RegExp("("+e+"=)([^&\\n]+)","igm"));return r}function L(t){var e,r,n,o=[];for(e=0,r=t.length;e<r;e++){switch(n=t[e],i(n)){case"object":n=b(n),n=n.error||n.value,n.length>500&&(n=n.substr(0,497)+"...");break;case"null":n="null";break;case"undefined":n="undefined";break;case"symbol":n=n.toString()}o.push(n)}return o.join(" ")}function N(){return Date.now?+Date.now():+new Date}function C(t,e){if(t&&t.user_ip&&e!==!0){var r=t.user_ip;if(e)try{var n;if(r.indexOf(".")!==-1)n=r.split("."),n.pop(),n.push("0"),r=n.join(".");else if(r.indexOf(":")!==-1){if(n=r.split(":"),n.length>2){var o=n.slice(0,3),i=o[2].indexOf("/");i!==-1&&(o[2]=o[2].substring(0,i));var a="0000:0000:0000:0000:0000";r=o.concat(a).join(":")}}else r=null}catch(t){r=null}else r=null;t.user_ip=r}}function j(t,e,r){var n=R(t,e,r);return!e||e.overwriteScrubFields?n:(e.scrubFields&&(n.scrubFields=(t.scrubFields||[]).concat(e.scrubFields)),n)}var R=r(6),A={},F=!1;n();var q={debug:0,info:1,warning:2,error:3,critical:4},P={strictMode:!1,key:["source","protocol","authority","userInfo","user","password","host","port","relative","path","directory","file","query","anchor"],q:{name:"queryKey",parser:/(?:^|&)([^&=]*)=?([^&]*)/g},parser:{strict:/^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,loose:/^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/}};t.exports={addParamsAndAccessTokenToPath:v,createItem:k,filterIp:C,formatArgsAsString:L,formatUrl:y,get:E,handleOptions:j,isError:p,isFunction:a,isIterable:l,isNativeFunction:s,isType:o,jsonParse:w,LEVELS:q,makeUnhandledStackInfo:_,merge:R,now:N,redact:h,sanitizeUrl:m,scrub:T,set:I,stringify:b,traverse:f,typeName:i,uuid4:d}},function(t,e){"use strict";function r(){var t,e,n,o,a,s={},u=null,c=arguments.length;for(t=0;t<c;t++)if(u=arguments[t],null!=u)for(a in u)e=s[a],n=u[a],s!==n&&(n&&i(n)?(o=e&&i(e)?e:{},s[a]=r(o,n)):"undefined"!=typeof n&&(s[a]=n));return s}var n=Object.prototype.hasOwnProperty,o=Object.prototype.toString,i=function(t){if(!t||"[object Object]"!==o.call(t))return!1;var e=n.call(t,"constructor"),r=t.constructor&&t.constructor.prototype&&n.call(t.constructor.prototype,"isPrototypeOf");if(t.constructor&&!e&&!r)return!1;var i;for(i in t);return"undefined"==typeof i||n.call(t,i)};t.exports=r},function(t,e){var r=function(t){function e(t){return t<10?"0"+t:t}function r(){return this.valueOf()}function n(t){return i.lastIndex=0,i.test(t)?'"'+t.replace(i,function(t){var e=u[t];return"string"==typeof e?e:"\\u"+("0000"+t.charCodeAt(0).toString(16)).slice(-4)})+'"':'"'+t+'"'}function o(t,e){var r,i,u,l,p,f=a,h=e[t];switch(h&&"object"==typeof h&&"function"==typeof h.toJSON&&(h=h.toJSON(t)),"function"==typeof c&&(h=c.call(e,t,h)),typeof h){case"string":return n(h);case"number":return isFinite(h)?String(h):"null";case"boolean":case"null":return String(h);case"object":if(!h)return"null";if(a+=s,p=[],"[object Array]"===Object.prototype.toString.apply(h)){for(l=h.length,r=0;r<l;r+=1)p[r]=o(r,h)||"null";return u=0===p.length?"[]":a?"[\n"+a+p.join(",\n"+a)+"\n"+f+"]":"["+p.join(",")+"]",a=f,u}if(c&&"object"==typeof c)for(l=c.length,r=0;r<l;r+=1)"string"==typeof c[r]&&(i=c[r],u=o(i,h),u&&p.push(n(i)+(a?": ":":")+u));else for(i in h)Object.prototype.hasOwnProperty.call(h,i)&&(u=o(i,h),u&&p.push(n(i)+(a?": ":":")+u));return u=0===p.length?"{}":a?"{\n"+a+p.join(",\n"+a)+"\n"+f+"}":"{"+p.join(",")+"}",a=f,u}}var i=/[\\"\u0000-\u001f\u007f-\u009f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;"function"!=typeof Date.prototype.toJSON&&(Date.prototype.toJSON=function(){return isFinite(this.valueOf())?this.getUTCFullYear()+"-"+e(this.getUTCMonth()+1)+"-"+e(this.getUTCDate())+"T"+e(this.getUTCHours())+":"+e(this.getUTCMinutes())+":"+e(this.getUTCSeconds())+"Z":null},Boolean.prototype.toJSON=r,Number.prototype.toJSON=r,String.prototype.toJSON=r);var a,s,u,c;"function"!=typeof t.stringify&&(u={"\b":"\\b","\t":"\\t","\n":"\\n","\f":"\\f","\r":"\\r",'"':'\\"',"\\":"\\\\"},t.stringify=function(t,e,r){var n;if(a="",s="","number"==typeof r)for(n=0;n<r;n+=1)s+=" ";else"string"==typeof r&&(s=r);if(c=e,e&&"function"!=typeof e&&("object"!=typeof e||"number"!=typeof e.length))throw new Error("JSON.stringify");return o("",{"":t})}),"function"!=typeof t.parse&&(t.parse=function(){function t(t){return t.replace(/\\(?:u(.{4})|([^u]))/g,function(t,e,r){return e?String.fromCharCode(parseInt(e,16)):a[r]})}var e,r,n,o,i,a={"\\":"\\",'"':'"',"/":"/",t:"\t",n:"\n",r:"\r",f:"\f",b:"\b"},s={go:function(){e="ok"},firstokey:function(){o=i,e="colon"},okey:function(){o=i,e="colon"},ovalue:function(){e="ocomma"},firstavalue:function(){e="acomma"},avalue:function(){e="acomma"}},u={go:function(){e="ok"},ovalue:function(){e="ocomma"},firstavalue:function(){e="acomma"},avalue:function(){e="acomma"}},c={"{":{go:function(){r.push({state:"ok"}),n={},e="firstokey"},ovalue:function(){r.push({container:n,state:"ocomma",key:o}),n={},e="firstokey"},firstavalue:function(){r.push({container:n,state:"acomma"}),n={},e="firstokey"},avalue:function(){r.push({container:n,state:"acomma"}),n={},e="firstokey"}},"}":{firstokey:function(){var t=r.pop();i=n,n=t.container,o=t.key,e=t.state},ocomma:function(){var t=r.pop();n[o]=i,i=n,n=t.container,o=t.key,e=t.state}},"[":{go:function(){r.push({state:"ok"}),n=[],e="firstavalue"},ovalue:function(){r.push({container:n,state:"ocomma",key:o}),n=[],e="firstavalue"},firstavalue:function(){r.push({container:n,state:"acomma"}),n=[],e="firstavalue"},avalue:function(){r.push({container:n,state:"acomma"}),n=[],e="firstavalue"}},"]":{firstavalue:function(){var t=r.pop();i=n,n=t.container,o=t.key,e=t.state},acomma:function(){var t=r.pop();n.push(i),i=n,n=t.container,o=t.key,e=t.state}},":":{colon:function(){if(Object.hasOwnProperty.call(n,o))throw new SyntaxError("Duplicate key '"+o+'"');e="ovalue"}},",":{ocomma:function(){n[o]=i,e="okey"},acomma:function(){n.push(i),e="avalue"}},true:{go:function(){i=!0,e="ok"},ovalue:function(){i=!0,e="ocomma"},firstavalue:function(){i=!0,e="acomma"},avalue:function(){i=!0,e="acomma"}},false:{go:function(){i=!1,e="ok"},ovalue:function(){i=!1,e="ocomma"},firstavalue:function(){i=!1,e="acomma"},avalue:function(){i=!1,e="acomma"}},null:{go:function(){i=null,e="ok"},ovalue:function(){i=null,e="ocomma"},firstavalue:function(){i=null,e="acomma"},avalue:function(){i=null,e="acomma"}}};return function(n,o){var a,l=/^[\u0020\t\n\r]*(?:([,:\[\]{}]|true|false|null)|(-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)|"((?:[^\r\n\t\\\"]|\\(?:["\\\/trnfb]|u[0-9a-fA-F]{4}))*)")/;e="go",r=[];try{for(;;){if(a=l.exec(n),!a)break;a[1]?c[a[1]][e]():a[2]?(i=+a[2],u[e]()):(i=t(a[3]),s[e]()),n=n.slice(a[0].length)}}catch(t){e=t}if("ok"!==e||/[^\u0020\t\n\r]/.test(n))throw e instanceof SyntaxError?e:new SyntaxError("JSON");return"function"==typeof o?function t(e,r){var n,a,s=e[r];if(s&&"object"==typeof s)for(n in i)Object.prototype.hasOwnProperty.call(s,n)&&(a=t(s,n),void 0!==a?s[n]=a:delete s[n]);return o.call(e,r,s)}({"":i},""):i}}())};t.exports=r},function(t,e,r){"use strict";function n(t,e,r,n){this.rateLimiter=t,this.api=e,this.logger=r,this.options=n,this.predicates=[],this.pendingItems=[],this.pendingRequests=[],this.retryQueue=[],this.retryHandle=null,this.waitCallback=null,this.waitIntervalID=null}var o=r(5);n.prototype.configure=function(t){this.api&&this.api.configure(t);var e=this.options;return this.options=o.merge(e,t),this},n.prototype.addPredicate=function(t){return o.isFunction(t)&&this.predicates.push(t),this},n.prototype.addPendingItem=function(t){this.pendingItems.push(t)},n.prototype.removePendingItem=function(t){var e=this.pendingItems.indexOf(t);e!==-1&&this.pendingItems.splice(e,1)},n.prototype.addItem=function(t,e,r,n){e&&o.isFunction(e)||(e=function(){});var i=this._applyPredicates(t);if(i.stop)return this.removePendingItem(n),void e(i.err);this._maybeLog(t,r),this.removePendingItem(n),this.pendingRequests.push(t);try{this._makeApiRequest(t,function(r,n){this._dequeuePendingRequest(t),e(r,n)}.bind(this))}catch(r){this._dequeuePendingRequest(t),e(r)}},n.prototype.wait=function(t){o.isFunction(t)&&(this.waitCallback=t,this._maybeCallWait()||(this.waitIntervalID&&(this.waitIntervalID=clearInterval(this.waitIntervalID)),this.waitIntervalID=setInterval(function(){this._maybeCallWait()}.bind(this),500)))},n.prototype._applyPredicates=function(t){for(var e=null,r=0,n=this.predicates.length;r<n;r++)if(e=this.predicates[r](t,this.options),!e||void 0!==e.err)return{stop:!0,err:e.err};return{stop:!1,err:null}},n.prototype._makeApiRequest=function(t,e){var r=this.rateLimiter.shouldSend(t);r.shouldSend?this.api.postItem(t,function(r,n){r?this._maybeRetry(r,t,e):e(r,n)}.bind(this)):r.error?e(r.error):this.api.postItem(r.payload,e)};var i=["ECONNRESET","ENOTFOUND","ESOCKETTIMEDOUT","ETIMEDOUT","ECONNREFUSED","EHOSTUNREACH","EPIPE","EAI_AGAIN"];n.prototype._maybeRetry=function(t,e,r){var n=!1;if(this.options.retryInterval)for(var o=0,a=i.length;o<a;o++)if(t.code===i[o]){n=!0;break}n?this._retryApiRequest(e,r):r(t)},n.prototype._retryApiRequest=function(t,e){this.retryQueue.push({item:t,callback:e}),this.retryHandle||(this.retryHandle=setInterval(function(){for(;this.retryQueue.length;){var t=this.retryQueue.shift();this._makeApiRequest(t.item,t.callback)}}.bind(this),this.options.retryInterval))},n.prototype._dequeuePendingRequest=function(t){var e=this.pendingRequests.indexOf(t);e!==-1&&(this.pendingRequests.splice(e,1),this._maybeCallWait())},n.prototype._maybeLog=function(t,e){if(this.logger&&this.options.verbose){var r=e;if(r=r||o.get(t,"body.trace.exception.message"),r=r||o.get(t,"body.trace_chain.0.exception.message"))return void this.logger.error(r);r=o.get(t,"body.message.body"),r&&this.logger.log(r)}},n.prototype._maybeCallWait=function(){return!(!o.isFunction(this.waitCallback)||0!==this.pendingItems.length||0!==this.pendingRequests.length)&&(this.waitIntervalID&&(this.waitIntervalID=clearInterval(this.waitIntervalID)),this.waitCallback(),!0)},t.exports=n},function(t,e,r){"use strict";function n(t,e){this.queue=t,this.options=e,this.transforms=[]}var o=r(5);n.prototype.configure=function(t){this.queue&&this.queue.configure(t);var e=this.options;return this.options=o.merge(e,t),this},n.prototype.addTransform=function(t){return o.isFunction(t)&&this.transforms.push(t),this},n.prototype.log=function(t,e){if(e&&o.isFunction(e)||(e=function(){}),!this.options.enabled)return e(new Error("Rollbar is not enabled"));this.queue.addPendingItem(t);var r=t.err;this._applyTransforms(t,function(n,o){return n?(this.queue.removePendingItem(t),e(n,null)):void this.queue.addItem(o,e,r,t)}.bind(this))},n.prototype._applyTransforms=function(t,e){var r=-1,n=this.transforms.length,o=this.transforms,i=this.options,a=function(t,s){return t?void e(t,null):(r++,r===n?void e(null,s):void o[r](s,i,a))};a(null,t)},t.exports=n},function(t,e,r){"use strict";function n(t){this.queue=[],this.options=i.merge(t);var e=this.options.maxTelemetryEvents||a;this.maxQueueSize=Math.max(0,Math.min(e,a))}function o(t,e){if(e)return e;var r={error:"error",manual:"info"};return r[t]||"info"}var i=r(5),a=100;n.prototype.configure=function(t){var e=this.options;this.options=i.merge(e,t);var r=this.options.maxTelemetryEvents||a,n=Math.max(0,Math.min(r,a)),o=0;this.maxQueueSize>n&&(o=this.maxQueueSize-n),this.maxQueueSize=n,this.queue.splice(0,o)},n.prototype.copyEvents=function(){var t=Array.prototype.slice.call(this.queue,0);if(i.isFunction(this.options.filterTelemetry))try{for(var e=t.length;e--;)this.options.filterTelemetry(t[e])&&t.splice(e,1)}catch(t){this.options.filterTelemetry=null}return t},n.prototype.capture=function(t,e,r,n,a){var s={level:o(t,r),type:t,timestamp_ms:a||i.now(),body:e,source:"client"};n&&(s.uuid=n);try{if(i.isFunction(this.options.filterTelemetry)&&this.options.filterTelemetry(s))return!1}catch(t){this.options.filterTelemetry=null}return this.push(s),s},n.prototype.captureEvent=function(t,e,r){return this.capture("manual",t,e,r)},n.prototype.captureError=function(t,e,r,n){var o={message:t.message||String(t)};return t.stack&&(o.stack=t.stack),this.capture("error",o,e,r,n)},n.prototype.captureLog=function(t,e,r,n){return this.capture("log",{message:t},e,r,n)},n.prototype.captureNetwork=function(t,e,r,n){e=e||"xhr",t.subtype=t.subtype||e,n&&(t.request=n);var o=this.levelFromStatus(t.status_code);return this.capture("network",t,o,r)},n.prototype.levelFromStatus=function(t){return t>=200&&t<400?"info":0===t||t>=400?"error":"info"},n.prototype.captureDom=function(t,e,r,n,o){var i={subtype:t,element:e};return void 0!==r&&(i.value=r),void 0!==n&&(i.checked=n),this.capture("dom",i,"info",o)},n.prototype.captureNavigation=function(t,e,r){return this.capture("navigation",{from:t,to:e},"info",r)},n.prototype.captureDomContentLoaded=function(t){return this.capture("navigation",{subtype:"DOMContentLoaded"},"info",void 0,t&&t.getTime())},n.prototype.captureLoad=function(t){return this.capture("navigation",{subtype:"load"},"info",void 0,t&&t.getTime())},n.prototype.captureConnectivityChange=function(t,e){return this.captureNetwork({change:t},"connectivity",e)},n.prototype._captureRollbarItem=function(t){if(this.options.includeItemsInTelemetry)return t.err?this.captureError(t.err,t.level,t.uuid,t.timestamp):t.message?this.captureLog(t.message,t.level,t.uuid,t.timestamp):t.custom?this.capture("log",t.custom,t.level,t.uuid,t.timestamp):void 0},n.prototype.push=function(t){this.queue.push(t),this.queue.length>this.maxQueueSize&&this.queue.shift()},t.exports=n},function(t,e,r){"use strict";function n(t,e,r,n){this.options=t,this.transport=e,this.url=r,this.jsonBackup=n,this.accessToken=t.accessToken,this.transportOptions=o(t,r)}function o(t,e){return a.getTransportFromOptions(t,s,e)}var i=r(5),a=r(12),s={hostname:"api.rollbar.com",path:"/api/1/item/",search:null,version:"1",protocol:"https:",port:443};n.prototype.postItem=function(t,e){var r=a.transportOptions(this.transportOptions,"POST"),n=a.buildPayload(this.accessToken,t,this.jsonBackup);this.transport.post(this.accessToken,r,n,e)},n.prototype.configure=function(t){var e=this.oldOptions;return this.options=i.merge(e,t),this.transportOptions=o(this.options,this.url),void 0!==this.options.accessToken&&(this.accessToken=this.options.accessToken),this},t.exports=n},function(t,e,r){"use strict";function n(t,e,r){if(!s.isType(e.context,"string")){var n=s.stringify(e.context,r);n.error?e.context="Error: could not serialize 'context'":e.context=n.value||"",e.context.length>255&&(e.context=e.context.substr(0,255))}return{access_token:t,data:e}}function o(t,e,r){var n=e.hostname,o=e.protocol,i=e.port,a=e.path,s=e.search,u=t.proxy;if(t.endpoint){var c=r.parse(t.endpoint);n=c.hostname,o=c.protocol,i=c.port,a=c.pathname,s=c.search}return{hostname:n,protocol:o,port:i,path:a,search:s,proxy:u}}function i(t,e){var r=t.protocol||"https:",n=t.port||("http:"===r?80:"https:"===r?443:void 0),o=t.hostname,i=t.path;return t.search&&(i+=t.search),t.proxy&&(i=r+"//"+o+i,o=t.proxy.host||t.proxy.hostname,n=t.proxy.port,r=t.proxy.protocol||r),{protocol:r,hostname:o,path:i,port:n,method:e}}function a(t,e){var r=/\/$/.test(t),n=/^\//.test(e);return r&&n?e=e.substring(1):r||n||(e="/"+e),t+e}var s=r(5);t.exports={buildPayload:n,getTransportFromOptions:o,transportOptions:i,appendPathToPath:a}},function(t,e,r){"use strict";function n(){var t=Array.prototype.slice.call(arguments,0);t.unshift("Rollbar:"),a.ieVersion()<=8?console.error(s.formatArgsAsString(t)):console.error.apply(console,t);
	}function o(){var t=Array.prototype.slice.call(arguments,0);t.unshift("Rollbar:"),a.ieVersion()<=8?console.info(s.formatArgsAsString(t)):console.info.apply(console,t)}function i(){var t=Array.prototype.slice.call(arguments,0);t.unshift("Rollbar:"),a.ieVersion()<=8?console.log(s.formatArgsAsString(t)):console.log.apply(console,t)}r(14);var a=r(15),s=r(5);t.exports={error:n,info:o,log:i}},function(t,e){!function(t){"use strict";t.console||(t.console={});for(var e,r,n=t.console,o=function(){},i=["memory"],a="assert,clear,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn".split(",");e=i.pop();)n[e]||(n[e]={});for(;r=a.pop();)n[r]||(n[r]=o)}("undefined"==typeof window?this:window)},function(t,e){"use strict";function r(){var t;if(!document)return t;for(var e=3,r=document.createElement("div"),n=r.getElementsByTagName("i");r.innerHTML="<!--[if gt IE "+ ++e+"]><i></i><![endif]-->",n[0];);return e>4?e:t}var n={ieVersion:r};t.exports=n},function(t,e){"use strict";function r(t,e,r){if(t){var o;if("function"==typeof e._rollbarOldOnError)o=e._rollbarOldOnError;else if(t.onerror){for(o=t.onerror;o._rollbarOldOnError;)o=o._rollbarOldOnError;e._rollbarOldOnError=o}var i=function(){var r=Array.prototype.slice.call(arguments,0);n(t,e,o,r)};r&&(i._rollbarOldOnError=o),t.onerror=i}}function n(t,e,r,n){t._rollbarWrappedError&&(n[4]||(n[4]=t._rollbarWrappedError),n[5]||(n[5]=t._rollbarWrappedError._rollbarContext),t._rollbarWrappedError=null),e.handleUncaughtException.apply(e,n),r&&r.apply(t,n)}function o(t,e,r){if(t){"function"==typeof t._rollbarURH&&t._rollbarURH.belongsToShim&&t.removeEventListener("unhandledrejection",t._rollbarURH);var n=function(t){var r,n,o;try{r=t.reason}catch(t){r=void 0}try{n=t.promise}catch(t){n="[unhandledrejection] error getting `promise` from event"}try{o=t.detail,!r&&o&&(r=o.reason,n=o.promise)}catch(t){o="[unhandledrejection] error getting `detail` from event"}r||(r="[unhandledrejection] error getting `reason` from event"),e&&e.handleUnhandledRejection&&e.handleUnhandledRejection(r,n)};n.belongsToShim=r,t._rollbarURH=n,t.addEventListener("unhandledrejection",n)}}function i(t,e,r){if(t){var n,o,i="EventTarget,Window,Node,ApplicationCache,AudioTrackList,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload".split(",");for(n=0;n<i.length;++n)o=i[n],t[o]&&t[o].prototype&&a(e,t[o].prototype,r)}}function a(t,e,r){if(e.hasOwnProperty&&e.hasOwnProperty("addEventListener")){for(var n=e.addEventListener;n._rollbarOldAdd&&n.belongsToShim;)n=n._rollbarOldAdd;var o=function(e,r,o){n.call(this,e,t.wrap(r),o)};o._rollbarOldAdd=n,o.belongsToShim=r,e.addEventListener=o;for(var i=e.removeEventListener;i._rollbarOldRemove&&i.belongsToShim;)i=i._rollbarOldRemove;var a=function(t,e,r){i.call(this,t,e&&e._rollbar_wrapped||e,r)};a._rollbarOldRemove=i,a.belongsToShim=r,e.removeEventListener=a}}t.exports={captureUncaughtExceptions:r,captureUnhandledRejections:o,wrapGlobals:i}},function(t,e,r){"use strict";function n(t,e,r,n,o){n&&l.isFunction(n)||(n=function(){}),l.addParamsAndAccessTokenToPath(t,e,r);var a="GET",s=l.formatUrl(e);i(t,s,a,null,n,o)}function o(t,e,r,n,o){if(n&&l.isFunction(n)||(n=function(){}),!r)return n(new Error("Cannot send empty request"));var a=p.truncate(r);if(a.error)return n(a.error);var s=a.value,u="POST",c=l.formatUrl(e);i(t,c,u,s,n,o)}function i(t,e,r,n,o,i){var p;if(p=i?i():a(),!p)return o(new Error("No way to send a request"));try{try{var h=function(){try{if(h&&4===p.readyState){h=void 0;var t=l.jsonParse(p.responseText);if(s(p))return void o(t.error,t.value);if(u(p)){if(403===p.status){var e=t.value&&t.value.message;f.error(e)}o(new Error(String(p.status)))}else{var r="XHR response had no status code (likely connection failure)";o(c(r))}}}catch(t){var n;n=t&&t.stack?t:new Error(t),o(n)}};p.open(r,e,!0),p.setRequestHeader&&(p.setRequestHeader("Content-Type","application/json"),p.setRequestHeader("X-Rollbar-Access-Token",t)),p.onreadystatechange=h,p.send(n)}catch(t){if("undefined"!=typeof XDomainRequest){if(!window||!window.location)return o(new Error("No window available during request, unknown environment"));"http:"===window.location.href.substring(0,5)&&"https"===e.substring(0,5)&&(e="http"+e.substring(5));var d=new XDomainRequest;d.onprogress=function(){},d.ontimeout=function(){var t="Request timed out",e="ETIMEDOUT";o(c(t,e))},d.onerror=function(){o(new Error("Error during request"))},d.onload=function(){var t=l.jsonParse(d.responseText);o(t.error,t.value)},d.open(r,e,!0),d.send(n)}else o(new Error("Cannot find a method to transport a request"))}}catch(t){o(t)}}function a(){var t,e,r=[function(){return new XMLHttpRequest},function(){return new ActiveXObject("Msxml2.XMLHTTP")},function(){return new ActiveXObject("Msxml3.XMLHTTP")},function(){return new ActiveXObject("Microsoft.XMLHTTP")}],n=r.length;for(e=0;e<n;e++)try{t=r[e]();break}catch(t){}return t}function s(t){return t&&t.status&&200===t.status}function u(t){return t&&l.isType(t.status,"number")&&t.status>=400&&t.status<600}function c(t,e){var r=new Error(t);return r.code=e||"ENOTFOUND",r}var l=r(5),p=r(18),f=r(13);t.exports={get:n,post:o}},function(t,e,r){"use strict";function n(t,e){return[t,f.stringify(t,e)]}function o(t,e){var r=t.length;return r>2*e?t.slice(0,e).concat(t.slice(r-e)):t}function i(t,e,r){r="undefined"==typeof r?30:r;var n,i=t.data.body;if(i.trace_chain)for(var a=i.trace_chain,s=0;s<a.length;s++)n=a[s].frames,n=o(n,r),a[s].frames=n;else i.trace&&(n=i.trace.frames,n=o(n,r),i.trace.frames=n);return[t,f.stringify(t,e)]}function a(t,e){return e&&e.length>t?e.slice(0,t-3).concat("..."):e}function s(t,e,r){function n(e,r,o){switch(f.typeName(r)){case"string":return a(t,r);case"object":case"array":return f.traverse(r,n,o);default:return r}}return e=f.traverse(e,n,[]),[e,f.stringify(e,r)]}function u(t){return t.exception&&(delete t.exception.description,t.exception.message=a(255,t.exception.message)),t.frames=o(t.frames,1),t}function c(t,e){var r=t.data.body;if(r.trace_chain)for(var n=r.trace_chain,o=0;o<n.length;o++)n[o]=u(n[o]);else r.trace&&(r.trace=u(r.trace));return[t,f.stringify(t,e)]}function l(t,e){return t.length>e}function p(t,e,r){r="undefined"==typeof r?524288:r;for(var o,a,u,p=[n,i,s.bind(null,1024),s.bind(null,512),s.bind(null,256),c];o=p.shift();)if(a=o(t,e),t=a[0],u=a[1],u.error||!l(u.value,r))return u;return u}var f=r(5);t.exports={truncate:p,raw:n,truncateFrames:i,truncateStrings:s,maybeTruncateValue:a}},function(t,e){"use strict";function r(t){var e,r,n={protocol:null,auth:null,host:null,path:null,hash:null,href:t,hostname:null,port:null,pathname:null,search:null,query:null};if(e=t.indexOf("//"),e!==-1?(n.protocol=t.substring(0,e),r=e+2):r=0,e=t.indexOf("@",r),e!==-1&&(n.auth=t.substring(r,e),r=e+1),e=t.indexOf("/",r),e===-1){if(e=t.indexOf("?",r),e===-1)return e=t.indexOf("#",r),e===-1?n.host=t.substring(r):(n.host=t.substring(r,e),n.hash=t.substring(e)),n.hostname=n.host.split(":")[0],n.port=n.host.split(":")[1],n.port&&(n.port=parseInt(n.port,10)),n;n.host=t.substring(r,e),n.hostname=n.host.split(":")[0],n.port=n.host.split(":")[1],n.port&&(n.port=parseInt(n.port,10)),r=e}else n.host=t.substring(r,e),n.hostname=n.host.split(":")[0],n.port=n.host.split(":")[1],n.port&&(n.port=parseInt(n.port,10)),r=e;if(e=t.indexOf("#",r),e===-1?n.path=t.substring(r):(n.path=t.substring(r,e),n.hash=t.substring(e)),n.path){var o=n.path.split("?");n.pathname=o[0],n.query=o[1],n.search=n.query?"?"+n.query:null}return n}t.exports={parse:r}},function(t,e,r){"use strict";function n(t,e,r){if(t.data=t.data||{},t.err)try{t.stackInfo=t.err._savedStackTrace||d.parse(t.err)}catch(e){m.error("Error while parsing the error object.",e);try{t.message=t.err.message||t.err.description||t.message||String(t.err)}catch(e){t.message=String(t.err)||String(e)}delete t.err}r(null,t)}function o(t,e,r){t.message||t.stackInfo||t.custom||r(new Error("No message, stack info, or custom data"),null),r(null,t)}function i(t,e,r){var n=e.payload&&e.payload.environment||e.environment;t.data=h.merge(t.data,{environment:n,level:t.level,endpoint:e.endpoint,platform:"browser",framework:"browser-js",language:"javascript",server:{},uuid:t.uuid,notifier:{name:"rollbar-browser-js",version:e.version}}),r(null,t)}function a(t){return function(e,r,n){if(!t||!t.location)return n(null,e);var o="$remote_ip";r.captureIp?r.captureIp!==!0&&(o+="_anonymize"):o=null,h.set(e,"data.request",{url:t.location.href,query_string:t.location.search,user_ip:o}),n(null,e)}}function s(t){return function(e,r,n){if(!t)return n(null,e);var o=t.navigator||{},i=t.screen||{};h.set(e,"data.client",{runtime_ms:e.timestamp-t._rollbarStartTime,timestamp:Math.round(e.timestamp/1e3),javascript:{browser:o.userAgent,language:o.language,cookie_enabled:o.cookieEnabled,screen:{width:i.width,height:i.height}}}),n(null,e)}}function u(t){return function(e,r,n){if(!t||!t.navigator)return n(null,e);for(var o,i=[],a=t.navigator.plugins||[],s=0,u=a.length;s<u;++s)o=a[s],i.push({name:o.name,description:o.description});h.set(e,"data.client.javascript.plugins",i),n(null,e)}}function c(t,e,r){t.stackInfo?p(t,e,r):l(t,e,r)}function l(t,e,r){var n=t.message,o=t.custom;if(!n)if(o){var i=e.scrubFields,a=h.stringify(h.scrub(o,i));n=a.error||a.value||""}else n="";var s={body:n};o&&(s.extra=h.merge(o)),h.set(t,"data.body",{message:s}),r(null,t)}function p(t,e,r){var n=t.data.description,o=t.stackInfo,i=t.custom,a=d.guessErrorClass(o.message),s=o.name||a[0],u=a[1],c={exception:{class:s,message:u}};n&&(c.exception.description=n);var p=o.stack;if(p&&0===p.length&&t._unhandledStackInfo&&t._unhandledStackInfo.stack&&(p=t._unhandledStackInfo.stack),p){0===p.length&&(c.exception.stack=o.rawStack,c.exception.raw=String(o.rawException));var f,m,g,v,y,b,w,_;for(c.frames=[],w=0;w<p.length;++w)f=p[w],m={filename:f.url?h.sanitizeUrl(f.url):"(unknown)",lineno:f.line||null,method:f.func&&"?"!==f.func?f.func:"[anonymous]",colno:f.column},e.sendFrameUrl&&(m.url=f.url),m.method&&m.method.endsWith&&m.method.endsWith("_rollbar_wrapped")||(g=v=y=null,b=f.context?f.context.length:0,b&&(_=Math.floor(b/2),v=f.context.slice(0,_),g=f.context[_],y=f.context.slice(_)),g&&(m.code=g),(v||y)&&(m.context={},v&&v.length&&(m.context.pre=v),y&&y.length&&(m.context.post=y)),f.args&&(m.args=f.args),c.frames.push(m));c.frames.reverse(),i&&(c.extra=h.merge(i)),h.set(t,"data.body",{trace:c}),r(null,t)}else t.message=s+": "+u,l(t,e,r)}function f(t,e,r){var n=e.scrubFields;t.data=h.scrub(t.data,n),r(null,t)}var h=r(5),d=r(21),m=r(13);t.exports={handleItemWithError:n,ensureItemHasSomethingToSay:o,addBaseInfo:i,addRequestInfo:a,addClientInfo:s,addPluginInfo:u,addBody:c,scrubPayload:f}},function(t,e,r){"use strict";function n(){return l}function o(){return null}function i(t){var e={};return e._stackFrame=t,e.url=t.fileName,e.line=t.lineNumber,e.func=t.functionName,e.column=t.columnNumber,e.args=t.args,e.context=o(e.url,e.line),e}function a(t){function e(){var e,r=[];if(t.stack)e=t;else try{throw t}catch(t){e=t}try{r=c.parse(e)}catch(t){r=[]}for(var n=[],o=0;o<r.length;o++)n.push(new i(r[o]));return n}return{stack:e(),message:t.message,name:t.name,rawStack:t.stack,rawException:t}}function s(t){return new a(t)}function u(t){if(!t||!t.match)return["Unknown error. There was no error message to display.",""];var e=t.match(p),r="(unknown)";return e&&(r=e[e.length-1],t=t.replace((e[e.length-2]||"")+r+":",""),t=t.replace(/(^[\s]+|[\s]+$)/g,"")),[r,t]}var c=r(22),l="?",p=new RegExp("^(([a-zA-Z0-9-_$ ]*): *)?(Uncaught )?([a-zA-Z0-9-_$ ]*): ");t.exports={guessFunctionName:n,guessErrorClass:u,gatherContext:o,parse:s,Stack:a,Frame:i}},function(t,e,r){var n,o,i;!function(a,s){"use strict";o=[r(23)],n=s,i="function"==typeof n?n.apply(e,o):n,!(void 0!==i&&(t.exports=i))}(this,function(t){"use strict";function e(t,e,r){if("function"==typeof Array.prototype.map)return t.map(e,r);for(var n=new Array(t.length),o=0;o<t.length;o++)n[o]=e.call(r,t[o]);return n}function r(t,e,r){if("function"==typeof Array.prototype.filter)return t.filter(e,r);for(var n=[],o=0;o<t.length;o++)e.call(r,t[o])&&n.push(t[o]);return n}var n=/(^|@)\S+\:\d+/,o=/^\s*at .*(\S+\:\d+|\(native\))/m,i=/^(eval@)?(\[native code\])?$/;return{parse:function(t){if("undefined"!=typeof t.stacktrace||"undefined"!=typeof t["opera#sourceloc"])return this.parseOpera(t);if(t.stack&&t.stack.match(o))return this.parseV8OrIE(t);if(t.stack)return this.parseFFOrSafari(t);throw new Error("Cannot parse given Error object")},extractLocation:function(t){if(t.indexOf(":")===-1)return[t];var e=t.replace(/[\(\)\s]/g,"").split(":"),r=e.pop(),n=e[e.length-1];if(!isNaN(parseFloat(n))&&isFinite(n)){var o=e.pop();return[e.join(":"),o,r]}return[e.join(":"),r,void 0]},parseV8OrIE:function(n){var i=r(n.stack.split("\n"),function(t){return!!t.match(o)},this);return e(i,function(e){e.indexOf("(eval ")>-1&&(e=e.replace(/eval code/g,"eval").replace(/(\(eval at [^\()]*)|(\)\,.*$)/g,""));var r=e.replace(/^\s+/,"").replace(/\(eval code/g,"(").split(/\s+/).slice(1),n=this.extractLocation(r.pop()),o=r.join(" ")||void 0,i="eval"===n[0]?void 0:n[0];return new t(o,void 0,i,n[1],n[2],e)},this)},parseFFOrSafari:function(n){var o=r(n.stack.split("\n"),function(t){return!t.match(i)},this);return e(o,function(e){if(e.indexOf(" > eval")>-1&&(e=e.replace(/ line (\d+)(?: > eval line \d+)* > eval\:\d+\:\d+/g,":$1")),e.indexOf("@")===-1&&e.indexOf(":")===-1)return new t(e);var r=e.split("@"),n=this.extractLocation(r.pop()),o=r.shift()||void 0;return new t(o,void 0,n[0],n[1],n[2],e)},this)},parseOpera:function(t){return!t.stacktrace||t.message.indexOf("\n")>-1&&t.message.split("\n").length>t.stacktrace.split("\n").length?this.parseOpera9(t):t.stack?this.parseOpera11(t):this.parseOpera10(t)},parseOpera9:function(e){for(var r=/Line (\d+).*script (?:in )?(\S+)/i,n=e.message.split("\n"),o=[],i=2,a=n.length;i<a;i+=2){var s=r.exec(n[i]);s&&o.push(new t(void 0,void 0,s[2],s[1],void 0,n[i]))}return o},parseOpera10:function(e){for(var r=/Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i,n=e.stacktrace.split("\n"),o=[],i=0,a=n.length;i<a;i+=2){var s=r.exec(n[i]);s&&o.push(new t(s[3]||void 0,void 0,s[2],s[1],void 0,n[i]))}return o},parseOpera11:function(o){var i=r(o.stack.split("\n"),function(t){return!!t.match(n)&&!t.match(/^Error created at/)},this);return e(i,function(e){var r,n=e.split("@"),o=this.extractLocation(n.pop()),i=n.shift()||"",a=i.replace(/<anonymous function(: (\w+))?>/,"$2").replace(/\([^\)]*\)/g,"")||void 0;i.match(/\(([^\)]*)\)/)&&(r=i.replace(/^[^\(]+\(([^\)]*)\)$/,"$1"));var s=void 0===r||"[arguments not available]"===r?void 0:r.split(",");return new t(a,s,o[0],o[1],o[2],e)},this)}}})},function(t,e,r){var n,o,i;!function(r,a){"use strict";o=[],n=a,i="function"==typeof n?n.apply(e,o):n,!(void 0!==i&&(t.exports=i))}(this,function(){"use strict";function t(t){return!isNaN(parseFloat(t))&&isFinite(t)}function e(t,e,r,n,o,i){void 0!==t&&this.setFunctionName(t),void 0!==e&&this.setArgs(e),void 0!==r&&this.setFileName(r),void 0!==n&&this.setLineNumber(n),void 0!==o&&this.setColumnNumber(o),void 0!==i&&this.setSource(i)}return e.prototype={getFunctionName:function(){return this.functionName},setFunctionName:function(t){this.functionName=String(t)},getArgs:function(){return this.args},setArgs:function(t){if("[object Array]"!==Object.prototype.toString.call(t))throw new TypeError("Args must be an Array");this.args=t},getFileName:function(){return this.fileName},setFileName:function(t){this.fileName=String(t)},getLineNumber:function(){return this.lineNumber},setLineNumber:function(e){if(!t(e))throw new TypeError("Line Number must be a Number");this.lineNumber=Number(e)},getColumnNumber:function(){return this.columnNumber},setColumnNumber:function(e){if(!t(e))throw new TypeError("Column Number must be a Number");this.columnNumber=Number(e)},getSource:function(){return this.source},setSource:function(t){this.source=String(t)},toString:function(){var e=this.getFunctionName()||"{anonymous}",r="("+(this.getArgs()||[]).join(",")+")",n=this.getFileName()?"@"+this.getFileName():"",o=t(this.getLineNumber())?":"+this.getLineNumber():"",i=t(this.getColumnNumber())?":"+this.getColumnNumber():"";return e+r+n+o+i}},e})},function(t,e,r){"use strict";function n(t,e,r){var n=e.payload||{};n.body&&delete n.body;var o=u.merge(t.data,n);t._isUncaught&&(o._isUncaught=!0),t._originalArgs&&(o._originalArgs=t._originalArgs),r(null,o)}function o(t,e,r){t.telemetryEvents&&u.set(t,"data.body.telemetry",t.telemetryEvents),r(null,t)}function i(t,e,r){if(!t.message)return void r(null,t);var n="data.body.trace_chain.0",o=u.get(t,n);if(o||(n="data.body.trace",o=u.get(t,n)),o){if(!o.exception||!o.exception.description)return u.set(t,n+".exception.description",t.message),void r(null,t);var i=u.get(t,n+".extra")||{},a=u.merge(i,{message:t.message});u.set(t,n+".extra",a)}r(null,t)}function a(t){return function(e,r,n){var o=u.merge(e);try{u.isFunction(r.transform)&&r.transform(o.data,e)}catch(o){return r.transform=null,t.error("Error while calling custom transform() function. Removing custom transform().",o),void n(null,e)}n(null,o)}}function s(t,e,r){if(!e.sendConfig)return r(null,t);var n="_rollbarConfig",o=u.get(t,"data.custom")||{};o[n]=e,t.data.custom=o,r(null,t)}var u=r(5);t.exports={itemToPayload:n,addTelemetryData:o,addMessageWithError:i,userTransform:a,addConfigToPayload:s}},function(t,e,r){"use strict";function n(t,e){return!o.get(e,"plugins.jquery.ignoreAjaxErrors")||!o.get(t,"body.message.extra.isAjax")}var o=r(5);t.exports={checkIgnore:n}},function(t,e,r){"use strict";function n(t,e){var r=t.level,n=c.LEVELS[r]||0,o=e.reportLevel,i=c.LEVELS[o]||0;return!(n<i)}function o(t){return function(e,r){var n=!!e._isUncaught;delete e._isUncaught;var o=e._originalArgs;delete e._originalArgs;try{c.isFunction(r.onSendCallback)&&r.onSendCallback(n,o,e)}catch(e){r.onSendCallback=null,t.error("Error while calling onSendCallback, removing",e)}try{if(c.isFunction(r.checkIgnore)&&r.checkIgnore(n,o,e))return!1}catch(e){r.checkIgnore=null,t.error("Error while calling custom checkIgnore(), removing",e)}return!0}}function i(t){return function(e,r){return!s(e,r,"blacklist",t)}}function a(t){return function(e,r){return s(e,r,"whitelist",t)}}function s(t,e,r,n){var o=!1;"blacklist"===r&&(o=!0);var i,a,s,u,l,p,f,h,d,m;try{if(i=o?e.hostBlackList:e.hostWhiteList,f=i&&i.length,a=c.get(t,"body.trace"),!i||0===f)return!o;if(!a||!a.frames||0===a.frames.length)return!o;for(l=a.frames.length,d=0;d<l;d++){if(s=a.frames[d],u=s.filename,!c.isType(u,"string"))return!o;for(m=0;m<f;m++)if(p=i[m],h=new RegExp(p),h.test(u))return!0}}catch(t){o?e.hostBlackList=null:e.hostWhiteList=null;var g=o?"hostBlackList":"hostWhiteList";return n.error("Error while reading your configuration's "+g+" option. Removing custom "+g+".",t),!o}return!1}function u(t){return function(e,r){var n,o,i,a,s,u,l,p,f;try{if(s=!1,i=r.ignoredMessages,!i||0===i.length)return!0;if(l=e.body,p=c.get(l,"trace.exception.message"),f=c.get(l,"message.body"),n=p||f,!n)return!0;for(a=i.length,o=0;o<a&&(u=new RegExp(i[o],"gi"),!(s=u.test(n)));o++);}catch(e){r.ignoredMessages=null,t.error("Error while reading your configuration's ignoredMessages option. Removing custom ignoredMessages.")}return!s}}var c=r(5);t.exports={checkLevel:n,userCheckIgnore:o,urlIsNotBlacklisted:i,urlIsWhitelisted:a,messageIsIgnored:u}},function(t,e,r){"use strict";function n(t,e,r,n,o){var i=t[e];t[e]=r(i),n&&n[o].push([t,e,i])}function o(t,e){for(var r;t[e].length;)r=t[e].shift(),r[0][r[1]]=r[2]}function i(t){if(!t||!t.attributes)return null;for(var e=t.attributes,r=0;r<e.length;++r)if("name"===e[r].key)return e[r].value;return null}function a(t){for(var e=[],r=0;r<t.length;++r)e.push(new RegExp(t[r],"i"));return function(t){var r=i(t);if(!r)return!1;for(var n=0;n<e.length;++n)if(e[n].test(r))return!0;return!1}}function s(t,e,r,n,o){var i=t.autoInstrument;t.enabled===!1||i===!1?this.autoInstrument={}:(u.isType(i,"object")||(i=p),this.autoInstrument=u.merge(p,i)),this.scrubTelemetryInputs=!!t.scrubTelemetryInputs,this.telemetryScrubber=t.telemetryScrubber,this.defaultValueScrubber=a(t.scrubFields),this.telemeter=e,this.rollbar=r,this._window=n||{},this._document=o||{},this.replacements={network:[],log:[],navigation:[],connectivity:[]},this.eventRemovers={dom:[],connectivity:[]},this._location=this._window.location,this._lastHref=this._location&&this._location.href}var u=r(5),c=r(19),l=r(28),p={network:!0,networkResponseHeaders:!1,networkResponseBody:!1,networkRequestBody:!1,log:!0,dom:!0,navigation:!0,connectivity:!0};s.prototype.configure=function(t){var e=t.autoInstrument,r=u.merge(this.autoInstrument);t.enabled===!1||e===!1?this.autoInstrument={}:(u.isType(e,"object")||(e=p),this.autoInstrument=u.merge(p,e)),this.instrument(r),void 0!==t.scrubTelemetryInputs&&(this.scrubTelemetryInputs=!!t.scrubTelemetryInputs),void 0!==t.telemetryScrubber&&(this.telemetryScrubber=t.telemetryScrubber)},s.prototype.instrument=function(t){!this.autoInstrument.network||t&&t.network?!this.autoInstrument.network&&t&&t.network&&this.deinstrumentNetwork():this.instrumentNetwork(),!this.autoInstrument.log||t&&t.log?!this.autoInstrument.log&&t&&t.log&&this.deinstrumentConsole():this.instrumentConsole(),!this.autoInstrument.dom||t&&t.dom?!this.autoInstrument.dom&&t&&t.dom&&this.deinstrumentDom():this.instrumentDom(),!this.autoInstrument.navigation||t&&t.navigation?!this.autoInstrument.navigation&&t&&t.navigation&&this.deinstrumentNavigation():this.instrumentNavigation(),!this.autoInstrument.connectivity||t&&t.connectivity?!this.autoInstrument.connectivity&&t&&t.connectivity&&this.deinstrumentConnectivity():this.instrumentConnectivity()},s.prototype.deinstrumentNetwork=function(){o(this.replacements,"network")},s.prototype.instrumentNetwork=function(){function t(t,r){t in r&&u.isFunction(r[t])&&n(r,t,function(t){return e.rollbar.wrap(t)})}var e=this;if("XMLHttpRequest"in this._window){var r=this._window.XMLHttpRequest.prototype;n(r,"open",function(t){return function(e,r){return u.isType(r,"string")&&(this.__rollbar_xhr={method:e,url:r,status_code:null,start_time_ms:u.now(),end_time_ms:null}),t.apply(this,arguments)}},this.replacements,"network"),n(r,"send",function(r){return function(o){function i(){if(a.__rollbar_xhr){if(null===a.__rollbar_xhr.status_code){a.__rollbar_xhr.status_code=0;var t=null;e.autoInstrument.networkRequestBody&&(t=o),a.__rollbar_event=e.telemeter.captureNetwork(a.__rollbar_xhr,"xhr",void 0,t)}if(a.readyState<2&&(a.__rollbar_xhr.start_time_ms=u.now()),a.readyState>3){a.__rollbar_xhr.end_time_ms=u.now();var r=null;if(e.autoInstrument.networkResponseHeaders){var n=e.autoInstrument.networkResponseHeaders;r={};try{var i,s;if(n===!0){var c=a.getAllResponseHeaders();if(c){var l,p,f=c.trim().split(/[\r\n]+/);for(s=0;s<f.length;s++)l=f[s].split(": "),i=l.shift(),p=l.join(": "),r[i]=p}}else for(s=0;s<n.length;s++)i=n[s],r[i]=a.getResponseHeader(i)}catch(t){}}var h=null;if(e.autoInstrument.networkResponseBody)try{h=a.responseText}catch(t){}var d=null;(h||r)&&(d={},h&&(d.body=h),r&&(d.headers=r)),d&&(a.__rollbar_xhr.response=d);try{var m=a.status;m=1223===m?204:m,a.__rollbar_xhr.status_code=m,a.__rollbar_event.level=e.telemeter.levelFromStatus(m)}catch(t){}}}}var a=this;return t("onload",a),t("onerror",a),t("onprogress",a),"onreadystatechange"in a&&u.isFunction(a.onreadystatechange)?n(a,"onreadystatechange",function(t){return e.rollbar.wrap(t,void 0,i)}):a.onreadystatechange=i,r.apply(this,arguments)}},this.replacements,"network")}"fetch"in this._window&&n(this._window,"fetch",function(t){return function(r,n){for(var o=new Array(arguments.length),i=0,a=o.length;i<a;i++)o[i]=arguments[i];var s,c=o[0],l="GET";u.isType(c,"string")?s=c:c&&(s=c.url,c.method&&(l=c.method)),o[1]&&o[1].method&&(l=o[1].method);var p={method:l,url:s,status_code:null,start_time_ms:u.now(),end_time_ms:null},f=null;return e.autoInstrument.networkRequestBody&&(o[1]&&o[1].body?f=o[1].body:o[0]&&!u.isType(o[0],"string")&&o[0].body&&(f=o[0].body)),e.telemeter.captureNetwork(p,"fetch",void 0,f),t.apply(this,o).then(function(t){p.end_time_ms=u.now(),p.status_code=t.status;var r=null;if(e.autoInstrument.networkResponseHeaders){var n=e.autoInstrument.networkResponseHeaders;r={};try{if(n===!0);else for(var o=0;o<n.length;o++){var i=n[o];r[i]=t.headers.get(i)}}catch(t){}}var a=null;return r&&(a={headers:r}),a&&(p.response=a),t})}},this.replacements,"network")},s.prototype.deinstrumentConsole=function(){if("console"in this._window&&this._window.console.log)for(var t;this.replacements.log.length;)t=this.replacements.log.shift(),this._window.console[t[0]]=t[1]},s.prototype.instrumentConsole=function(){function t(t){var n=r[t],o=r,i="warn"===t?"warning":t;r[t]=function(){var t=Array.prototype.slice.call(arguments),r=u.formatArgsAsString(t);e.telemeter.captureLog(r,i),n&&Function.prototype.apply.call(n,o,t)},e.replacements.log.push([t,n])}if("console"in this._window&&this._window.console.log)for(var e=this,r=this._window.console,n=["debug","info","warn","error","log"],o=0,i=n.length;o<i;o++)t(n[o])},s.prototype.deinstrumentDom=function(){("addEventListener"in this._window||"attachEvent"in this._window)&&this.removeListeners("dom")},s.prototype.instrumentDom=function(){if("addEventListener"in this._window||"attachEvent"in this._window){var t=this.handleClick.bind(this),e=this.handleBlur.bind(this);this.addListener("dom",this._window,"click","onclick",t,!0),this.addListener("dom",this._window,"blur","onfocusout",e,!0)}},s.prototype.handleClick=function(t){try{var e=l.getElementFromEvent(t,this._document),r=e&&e.tagName,n=l.isDescribedElement(e,"a")||l.isDescribedElement(e,"button");r&&(n||l.isDescribedElement(e,"input",["button","submit"]))?this.captureDomEvent("click",e):l.isDescribedElement(e,"input",["checkbox","radio"])&&this.captureDomEvent("input",e,e.value,e.checked)}catch(t){}},s.prototype.handleBlur=function(t){try{var e=l.getElementFromEvent(t,this._document);e&&e.tagName&&(l.isDescribedElement(e,"textarea")?this.captureDomEvent("input",e,e.value):l.isDescribedElement(e,"select")&&e.options&&e.options.length?this.handleSelectInputChanged(e):l.isDescribedElement(e,"input")&&!l.isDescribedElement(e,"input",["button","submit","hidden","checkbox","radio"])&&this.captureDomEvent("input",e,e.value))}catch(t){}},s.prototype.handleSelectInputChanged=function(t){if(t.multiple)for(var e=0;e<t.options.length;e++)t.options[e].selected&&this.captureDomEvent("input",t,t.options[e].value);else t.selectedIndex>=0&&t.options[t.selectedIndex]&&this.captureDomEvent("input",t,t.options[t.selectedIndex].value)},s.prototype.captureDomEvent=function(t,e,r,n){if(void 0!==r)if(this.scrubTelemetryInputs||"password"===l.getElementType(e))r="[scrubbed]";else{var o=l.describeElement(e);this.telemetryScrubber?this.telemetryScrubber(o)&&(r="[scrubbed]"):this.defaultValueScrubber(o)&&(r="[scrubbed]")}var i=l.elementArrayToString(l.treeToArray(e));this.telemeter.captureDom(t,i,r,n)},s.prototype.deinstrumentNavigation=function(){var t=this._window.chrome,e=t&&t.app&&t.app.runtime,r=!e&&this._window.history&&this._window.history.pushState;r&&o(this.replacements,"navigation")},s.prototype.instrumentNavigation=function(){var t=this._window.chrome,e=t&&t.app&&t.app.runtime,r=!e&&this._window.history&&this._window.history.pushState;if(r){var o=this;n(this._window,"onpopstate",function(t){return function(){var e=o._location.href;o.handleUrlChange(o._lastHref,e),t&&t.apply(this,arguments)}},this.replacements,"navigation"),n(this._window.history,"pushState",function(t){return function(){var e=arguments.length>2?arguments[2]:void 0;return e&&o.handleUrlChange(o._lastHref,e+""),t.apply(this,arguments)}},this.replacements,"navigation")}},s.prototype.handleUrlChange=function(t,e){var r=c.parse(this._location.href),n=c.parse(e),o=c.parse(t);this._lastHref=e,r.protocol===n.protocol&&r.host===n.host&&(e=n.path+(n.hash||"")),r.protocol===o.protocol&&r.host===o.host&&(t=o.path+(o.hash||"")),this.telemeter.captureNavigation(t,e)},s.prototype.deinstrumentConnectivity=function(){("addEventListener"in this._window||"body"in this._document)&&(this._window.addEventListener?this.removeListeners("connectivity"):o(this.replacements,"connectivity"))},s.prototype.instrumentConnectivity=function(){if("addEventListener"in this._window||"body"in this._document)if(this._window.addEventListener)this.addListener("connectivity",this._window,"online",void 0,function(){this.telemeter.captureConnectivityChange("online")}.bind(this),!0),this.addListener("connectivity",this._window,"offline",void 0,function(){this.telemeter.captureConnectivityChange("offline")}.bind(this),!0);else{var t=this;n(this._document.body,"ononline",function(e){return function(){t.telemeter.captureConnectivityChange("online"),e&&e.apply(this,arguments)}},this.replacements,"connectivity"),n(this._document.body,"onoffline",function(e){return function(){t.telemeter.captureConnectivityChange("offline"),e&&e.apply(this,arguments)}},this.replacements,"connectivity")}},s.prototype.addListener=function(t,e,r,n,o,i){e.addEventListener?(e.addEventListener(r,o,i),this.eventRemovers[t].push(function(){e.removeEventListener(r,o,i)})):n&&(e.attachEvent(n,o),this.eventRemovers[t].push(function(){e.detachEvent(n,o)}))},s.prototype.removeListeners=function(t){for(var e;this.eventRemovers[t].length;)(e=this.eventRemovers[t].shift())()},t.exports=s},function(t,e){"use strict";function r(t){return(t.getAttribute("type")||"").toLowerCase()}function n(t,e,n){if(t.tagName.toLowerCase()!==e.toLowerCase())return!1;if(!n)return!0;t=r(t);for(var o=0;o<n.length;o++)if(n[o]===t)return!0;return!1}function o(t,e){return t.target?t.target:e&&e.elementFromPoint?e.elementFromPoint(t.clientX,t.clientY):void 0}function i(t){for(var e,r=5,n=[],o=0;t&&o<r&&(e=u(t),"html"!==e.tagName);o++)n.unshift(e),t=t.parentNode;return n}function a(t){for(var e,r,n=80,o=" > ",i=o.length,a=[],u=0,c=t.length-1;c>=0;c--){if(e=s(t[c]),r=u+a.length*i+e.length,c<t.length-1&&r>=n+3){a.unshift("...");break}a.unshift(e),u+=e.length}return a.join(o)}function s(t){if(!t||!t.tagName)return"";var e=[t.tagName];t.id&&e.push("#"+t.id),t.classes&&e.push("."+t.classes.join("."));for(var r=0;r<t.attributes.length;r++)e.push("["+t.attributes[r].key+'="'+t.attributes[r].value+'"]');return e.join("")}function u(t){if(!t||!t.tagName)return null;var e,r,n,o,i={};i.tagName=t.tagName.toLowerCase(),t.id&&(i.id=t.id),e=t.className,e&&"string"==typeof e&&(i.classes=e.split(/\s+/));var a=["type","name","title","alt"];for(i.attributes=[],o=0;o<a.length;o++)r=a[o],n=t.getAttribute(r),n&&i.attributes.push({key:r,value:n});return i}t.exports={describeElement:u,descriptionToString:s,elementArrayToString:a,treeToArray:i,getElementFromEvent:o,isDescribedElement:n,getElementType:r}}])});
	//# sourceMappingURL=rollbar.umd.min.js.map

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _lodash = __webpack_require__(27);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var legacy = function legacy(skipMessage) {
	  var link = document.getElementById('download_file_url');

	  if (!skipMessage) {
	    jQuery('body').prepend('<div class="browsehappy">You are using an <strong>outdated</strong> browser. Please <a href="http://browsehappy.com/">upgrade your browser</a> to improve your experience.<div><a href="' + link.href + '" class="button btn_primary">Download file</a></div></div>');
	    jQuery('[ng-view]').hide();
	  }

	  var config = _lodash2.default.get(angular.module('viewerConfig'), '_invokeQueue.0.2.1', {});

	  angular.module('viewer', []);

	  if (window.console) {
	    window.console.log('incompatible');
	  }
	  return 'incompatible';
	}; /* global document, window, platform, jQuery */

	var detect = function detect() {
	  var moduleName = 'viewer';

	  try {
	    if (jQuery('.browsehappy').length) {
	      moduleName = legacy(true);
	    }
	    var name = platform.name,
	        version = parseInt(platform.version);

	    if (name === 'Opera' && version < 12) {
	      return legacy();
	    }
	    if (name === 'Safari' && platform.os.family === 'iOS' && version < 6) {
	      return legacy();
	    }
	    if (!_lodash2.default.include(['Android', 'iOS'], platform.os.family)) {
	      if (name === 'Firefox' && version < 9) {
	        moduleName = legacy();
	      }
	      if (name === 'Chrome' && version < 20) {
	        moduleName = legacy();
	      }
	    }
	  } catch (e) {
	    if (window.console) {
	      window.console.log(e);
	    }
	  }
	  return moduleName;
	};

	exports.default = detect;

/***/ })
/******/ ]);
angular.module("viewer").run(["$templateCache", function($templateCache) {$templateCache.put("app/empty.html","<div class=\"big-cloudapp-logo\"></div>");
$templateCache.put("app/annotations/annotations.html","<iframe id=\"add_file_frame\" ng-src=\"{{ uploadFrameUrl }}\" style=\"display: none;\"></iframe><div ng-if=\"annotate.item.state == \'success\'\" class=\"annotations_canvas\"><navbar mode=\"annotate\"></navbar><flash-messages></flash-messages><div id=\"canvas\" ng-class=\"{non_sticky: !annotate.service.drawing.sticky}\" class=\"cursor_{{annotate.service.drawing.mode}} {{annotate.service.drawing.commands.getColor()}}\"><div ng-if=\"annotate.service.state == \'pending\'\" class=\"progressbar_container\"><div style=\"width: {{ annotate.service.image.progress }}%;\" class=\"progressbar\"></div><span>{{ annotate.service.image.progress }}%</span></div></div></div><div ng-if=\"annotate.item.state == \'pending\'\" class=\"loading\"><div class=\"big-cloudapp-logo\"></div></div>");
$templateCache.put("app/codeView/codeView.html","<div class=\"spinner\"></div><div ng-switch=\"vm.language\"><div id=\"markdown\" ng-switch-when=\"markdown\" btf-markdown=\"vm.code\"></div><div ng-switch-default=\"\" hljs=\"\" hljs-source=\"vm.code\" hljs-language=\"{{ vm.language }}\"></div></div>");
$templateCache.put("app/comments/comments.html","<form ng-class=\"pending(\'createComment\')\" name=\"vm.newCommentForm\" ng-submit=\"vm.submitComment()\" class=\"add_comment_form\"><span class=\"comments_title\">Comments</span><div ng-if=\"pending(\'createComment\')\"></div><textarea ng-model=\"vm.newComment.content\" required=\"\" placeholder=\"Comment\" ng-maxlength=\"1000\" class=\"form-control\"></textarea> <input type=\"submit\" value=\"Comment\" ng-disabled=\"vm.newCommentForm.$invalid\" class=\"button btn_primary pull-right\"><span ng-if=\"vm.newCommentForm.$error.maxlength\" class=\"error_msg\">Text is too long</span><span ng-if=\"vm.newCommentForm.$error.required\" class=\"error_msg\">Text cannot be empty</span><div class=\"clear\"></div></form><div ng-if=\"vm.commentService.count == 0\"><div class=\"comments_emptystate\">Hey, don’t let it go unsaid! Add your comments that your teammates can review and reply to.</div></div><div ng-class=\"pending(\'getComments\')\" class=\"comments_list\"><div ng-repeat=\"comment in vm.commentService.comments | orderBy: \'-created_at\'\" class=\"event\"><div class=\"type_icon\"><img ng-src=\"{{ vm.avatar(comment) }}\"><span>{{ comment.user[0] }}</span></div><div class=\"event_details\"><strong>{{ comment.user }}</strong><p ng-bind-html=\"vm.commentContent(comment)\"></p><span ng-click=\"vm.toggleAbsoluteDate()\"><span ng-if=\"vm.absoluteDate\">{{ comment.created_at | amCalendar }}</span><span ng-if=\"!vm.absoluteDate\">{{ comment.created_at | amTimeAgo }}</span></span><a ng-if=\"vm.canDestroy(comment)\" ng-click=\"vm.destroy(comment)\" class=\"delete_comment\">Delete</a><div class=\"clear\"></div></div><div class=\"clear\"></div></div></div>");
$templateCache.put("app/embed/embed.html","<div class=\"embed-modal\"><div class=\"modal-header\"><h4>Embed HTML</h4></div><div class=\"modal-body\"><div class=\"form-group\"><label>Add this drop to your website by copying the code below</label><div class=\"copy_embed_html\"><input id=\"embed-html\" type=\"text\" ng-model=\"vm.currentWithOptions\" ng-readonly=\"true\" class=\"form-control\"> <button ngclipboard=\"\" data-clipboard-target=\"#embed-html\" analytics=\"item_copied\" analytics-type=\"embed_html\" analytics-campaign_medium=\"button\" class=\"button btn_primary\">Copy</button></div></div><div class=\"form-group\"><label>Where would you like to embed this drop ?</label><div class=\"single_box\"><div class=\"radio\"><label><input type=\"radio\" ng-model=\"vm.current\" ng-value=\"vm.embed.embed_html_js\" ng-change=\"vm.changeType(\'js\')\">Web page</label> <label><input type=\"radio\" ng-model=\"vm.current\" ng-value=\"vm.embed.embed_html_iframe\" ng-change=\"vm.changeType(\'iframe\')\">Web page (iframe)</label> <label><input type=\"radio\" ng-model=\"vm.current\" ng-value=\"vm.embed.embed_html\" ng-change=\"vm.changeType(\'html\')\">HTML</label></div></div></div><div class=\"form-group\"><div class=\"single_box\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.notitle\" ng-change=\"vm.updateCurrent()\">Hide Title in Embed</label></div><div class=\"checkbox\"><label ng-class=\"{\'muted\': vm.item.details.branding}\"><input type=\"checkbox\" ng-model=\"vm.nobranding\" ng-change=\"vm.updateCurrent()\" ng-disabled=\"vm.item.details.branding\">Hide Branding in Embed</label><a ng-if=\"vm.item.details.branding\" ng-href=\"{{url.upgradePlan(\'source_referral=viewer_embed_modal_upgrade\')}}\" target=\"_self\" class=\"upgrade\">Upgrade</a></div></div></div><div class=\"preview\"><h5>Preview</h5><div ng-bind-html=\"vm.trustedPreview\"></div></div></div></div>");
$templateCache.put("app/events/events.html","<div ng-class=\"pending(\'getEvents\')\" class=\"events_list\"><div ng-repeat=\"event in vm.eventService.events | orderBy: \'-created_at\'\" class=\"event-animation div\"><div ng-class=\"[event.event_type, event.action]\" class=\"event\"><div class=\"type_icon\"></div><div class=\"event_details\"><strong>{{ event.user }}</strong> {{ event.description }}<br><span ng-click=\"vm.toggleAbsoluteDate()\"><span ng-if=\"vm.absoluteDate\">{{ event.created_at | amCalendar }}</span><span ng-if=\"!vm.absoluteDate\">{{ event.created_at | amTimeAgo }}</span></span></div><div class=\"clear\"></div></div></div></div>");
$templateCache.put("app/flag/flag.html","<div class=\"flag-modal\"><div class=\"modal-header\"><h4>Flag this drop</h4></div><div class=\"modal-body\"><ng-form name=\"vm.flagForm\"><div class=\"form-group\"><input type=\"hidden\" ng-model=\"vm.flag.reason\" required=\"\"> <label class=\"block\">Reason for flagging*</label> <label class=\"radio-inline\"><input name=\"reason\" ng-model=\"vm.flag.reason\" type=\"radio\" value=\"DMCA\" class=\"js-checkox-input\">DMCA</label> <label class=\"radio-inline\"><input name=\"reason\" ng-model=\"vm.flag.reason\" type=\"radio\" value=\"Copyright\" class=\"js-checkox-input\">Copyright</label> <label class=\"radio-inline\"><input name=\"reason\" ng-model=\"vm.flag.reason\" type=\"radio\" value=\"Malware\" class=\"js-checkox-input\">Malware</label> <label class=\"radio-inline\"><input name=\"reason\" ng-model=\"vm.flag.reason\" type=\"radio\" value=\"Other\" class=\"js-checkox-input\">Other</label></div><div class=\"row sm_space\"><div class=\"col-sm-4\"><div show-errors=\"\" class=\"form-group\"><label>Email*</label> <input name=\"email\" ng-model=\"vm.flag.email\" placeholder=\"Your email\" type=\"email\" required=\"\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div show-errors=\"\" class=\"form-group\"><label>Name*</label> <input name=\"name\" ng-model=\"vm.flag.name\" placeholder=\"Your name\" type=\"text\" required=\"\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label>Organization</label> <input ng-model=\"vm.flag.organization\" placeholder=\"Organization\" type=\"text\" class=\"form-control\"></div></div></div><div class=\"form-group\"><label>Comments</label> <textarea class=\"form-control\"></textarea></div><br><h6>By checking the following boxes, I state UNDER PENALTY OF PERJURY of law that:</h6><div ng-if=\"[\'DMCA\', \'Copyright\'].indexOf(vm.flag.reason) != -1\" class=\"form-group\"><div show-errors=\"\" class=\"checkbox input-group\"><label><input name=\"proclamation_1\" ng-model=\"vm.flag.proclamation_1\" type=\"checkbox\" required=\"\" class=\"form-control\">I hereby state that I have a good faith belief that the sharing of copyrighted material at the location above is not authorized by the copyright owner, its agent or the law (e.g., as a fair use).</label></div><div show-errors=\"\" class=\"checkbox input-group\"><label><input name=\"proclamation_2\" ng-model=\"vm.flag.proclamation_2\" type=\"checkbox\" required=\"\" class=\"form-control\">I hereby state that the information in this Notice is accurate and under penalty of perjury, that I am the owner or authorised to act on behalf of the owner, of the copyright or of an exclusive right under the copyright that is allegedly infringed.</label></div><div show-errors=\"\" class=\"checkbox input-group\"><label><input name=\"proclamation_3\" ng-model=\"vm.flag.proclamation_3\" type=\"checkbox\" required=\"\" class=\"form-control\">I acknowledge that under Section 512(f) any person who knowingly materially misrepresents that material or activity is infringing may be subject to liability for damages.</label></div></div><div ng-if=\"[\'Malware\', \'Other\'].indexOf(vm.flag.reason) != -1\" class=\"form-group\"><div show-errors=\"\" class=\"checkbox input-group\"><label><input name=\"proclamation_4\" ng-model=\"vm.flag.proclamation_4\" type=\"checkbox\" required=\"\" class=\"form-control\">It is believed that the mentioned drops are in violation of the CloudApp Terms of Service.</label></div></div><br><div show-errors=\"\" class=\"form-group\"><label>Typing your full name in this box will act as your digital signature</label> <input name=\"signature\" ng-model=\"vm.flag.signature\" placeholder=\"Your full name\" type=\"text\" required=\"\" class=\"w50 form-control\"></div><div class=\"modal-footer\"><button type=\"submit\" ng-click=\"vm.save()\" class=\"button btn_primary\">Flag drop</button><a href=\"#\" ng-click=\"vm.cancel()\" class=\"button btn_secondary\">Cancel</a></div></ng-form></div></div>");
$templateCache.put("app/flashMessages/flashMessages.html","<div style=\"margin: auto; width: 500px;\" class=\"flash-messages\"><uib-alert ng-repeat=\"message in flashVm.flashMessages.items()\" type=\"{{ message.type }}\" dismiss-on-timeout=\"{{ message.timeout }}\" close=\"message.close()\">{{ message.text }}</uib-alert></div>");
$templateCache.put("app/imageView/imageView.html","<div id=\"image_viewport\" ng-class=\"{\'zoom\': vm.zoom, zoomable: vm.zoomable}\"><div class=\"image_wrapper\"><img id=\"drop-image\" ng-src=\"{{ vm.item.data.latest_source_url }}\" class=\"raw_image\"><canvas id=\"drop-canvas\" style=\"padding-bottom:0px;position:absolute;top:0;left:0;height:100%;\" ng-click=\"vm.toggleZoom()\"></canvas></div><style type=\"text/css\" id=\"dynamicCss\"></style></div>");
$templateCache.put("app/login/login.html","<div ng-switch=\"vm.action\" class=\"modal-header\"><h4 ng-init=\"vm.changed()\" ng-switch-when=\"signIn\" class=\"with_logo\">Login to CloudApp</h4><h4 ng-hide=\"vm.confirmation\" ng-init=\"vm.changed()\" ng-switch-default=\"\" class=\"with_logo\">Created with CloudApp</h4><h1 ng-show=\"vm.confirmation\">Welcome to CloudApp!</h1><p ng-hide=\"vm.confirmation\" class=\"muted f14 text-center\"><em>CloudApp is a productivity tool to share and communicate visually. Capture + Share: HD Videos, Screen Recordings, GIFs, and Annotated Screenshots.</em></p></div><div class=\"modal-body\"><p ng-show=\"vm.confirmation\" class=\"f14 text-center with_big_logo\">Your account has been created.<br>Now download CloudApp and get started creating screen recording, GIFs, annotated screenshots and sharing them with others.</p><div ng-hide=\"vm.confirmation\"><form method=\"POST\" action=\"{{ loginUrl }}\"><div class=\"form-group\"><label>Email address</label> <input placeholder=\"email@example.com\" type=\"email\" name=\"email\" class=\"form-control\"></div><div class=\"form-group\"><label>Password</label> <input type=\"password\" name=\"password\" class=\"form-control\"><div ng-show=\"vm.errors.length\" class=\"errors\"><p ng-repeat=\"error in vm.errors\" ng-bind-html=\"error\"></p></div></div><div ng-if=\"vm.action == \'signIn\'\"><button type=\"submit\" class=\"w100 button btn_primary\">Login</button></div><div ng-if=\"vm.action != \'signIn\'\"><p class=\"terms\">By signing up you accept our&nbsp;<a ng-href=\"{{ vm.termsUrl }}\">Terms of Use</a></p><button type=\"submit\" class=\"w100 button btn_carnation\">Join Now - Free Forever</button> <button ng-if=\"vm.advertised\" analytics=\"OuibounceRegularSignupClicked\" ng-click=\"vm.signUp()\" class=\"w100 button btn_carnation\">GET STARTED FOR FREE</button></div><div class=\"or\">or</div><a ng-if=\"!vm.advertised\" ng-click=\"vm.google()\" class=\"w100 button btn_primary button_google\">Sign up using Google</a><a ng-if=\"vm.advertised\" analytics=\"OuibounceGoogleSignupClicked\" ng-click=\"vm.google()\" class=\"w100 button btn_primary button_google\">Sign up using Google</a></form></div><div ng-switch=\"vm.action\" class=\"additional_links\"><a ng-hide=\"vm.confirmation\" ng-click=\"vm.sso()\">Sign in with SSO</a><a ng-hide=\"vm.confirmation\" ng-switch-when=\"signIn\" ng-click=\"vm.action = \'signUp\'\">Don\'t have a CloudApp account?</a><a ng-show=\"vm.confirmation\" ng-href=\"{{ vm.setupCloudappUrl }}\" class=\"button btn_primary w100\">DOWNLOAD CLOUDAPP</a><div ng-show=\"vm.confirmation\"><br><a ng-click=\"vm.close()\">No thanks, stay on the page</a></div><a ng-hide=\"vm.confirmation\" ng-switch-default=\"\" ng-click=\"vm.action = \'signIn\'\">Already have an account?</a><a ng-hide=\"vm.confirmation\" ng-switch-when=\"signIn\" ng-href=\"{{ vm.resetUrl }}\" target=\"_self\">Forgot your password?</a></div></div>");
$templateCache.put("app/login/login.modal.html","<div class=\"login-modal\"><login callback=\"vm.callback(success, action)\" close=\"vm.close()\" action=\"vm.action\" params=\"vm.params\"></login></div>");
$templateCache.put("app/main/main.html","<div ng-switch=\"main.item.state\" class=\"main_div\"><flash-messages></flash-messages><div ng-switch-when=\"success\" class=\"success\"><div ng-hide=\"main.item.details\" class=\"big-cloudapp-logo animated pulse infinite ng-animate-disabled\"></div><div id=\"main\" ng-show=\"main.item.details\" ng-init=\"main.init()\"><navbar></navbar><div ng-switch=\"main.item.data.type\" ng-class=\"{\'rhc_hidden\': main.rhcHidden(), \'rhc_available\': main.rhcAvailable()}\" class=\"item_view\"><tout ng-class=\"isVisibleClassName\"></tout><image-view ng-switch-when=\"image\"></image-view><video-view ng-switch-when=\"video\"></video-view><video-view ng-switch-when=\"audio\"></video-view><pdf-view ng-switch-when=\"pdf\" ng-class=\"pending(\'pdfLoad\')\"></pdf-view><code-view ng-switch-when=\"code\" ng-class=\"pending(\'codeLoad\')\"></code-view><other-view ng-switch-when=\"other\"></other-view></div><sidebar ng-if=\"can(\'view_related\') || can(\'view_comments\') || can(\'view_events\')\" ng-model=\"main\"></sidebar></div></div><div ng-switch-when=\"empty\" class=\"empty\"><div class=\"big-cloudapp-logo animated pulse infinite\"></div><div class=\"exception-handler\"><div class=\"unauthorized\"><div class=\"unauthorized_container\"><h1>Something went wrong</h1></div></div></div></div><div ng-switch-when=\"pending\" class=\"pending\"><div class=\"big-cloudapp-logo animated pulse infinite\"></div><h2>Uploading...</h2></div><div ng-switch-when=\"not_found\" class=\"unauthorized error\"><div class=\"unauthorized_container\"><h1>CloudApp</h1><h2>Nothing lives here.</h2><p>Perhaps the person who shared this link with you deleted it. Or they’re not ready to share it. Or maybe a Yeti has taken it to a cave. And that Yeti has children. And those children love CloudApp links.</p></div></div><div ng-switch-when=\"expired\" class=\"unauthorized error\"><div class=\"unauthorized_container\"><h1>CloudApp</h1><h2>The item you are looking for has expired.</h2></div></div><div ng-switch-when=\"error\" class=\"unauthorized error\"><div class=\"unauthorized_container\"><h1>CloudApp</h1><h2>Oops! Surprised?</h2><p>So are we. No one should ever have to see pages like this. Sorry about that!<br>Contact us at<a href=\"mailto:support@getcloudapp.com\">support@getcloudapp.com</a>or<a href=\"https://www.getcloudapp.com/help/\">our support site</a> if you think we can help. Or if you’d like us to share our GIF of the day with you. Or a poem.</p></div></div><unauthorized ng-switch-when=\"unauthorized\"></unauthorized></div>");
$templateCache.put("app/navbar/actions.html","<div class=\"actions_menu\"><div class=\"main_menu ng-animate-disabled\"><a ng-if=\"can(\'join\') &amp;&amp; vm.item.details.branding\" ng-href=\"{{ vm.redirectSignup }}\" class=\"button btn_carnation hidden-xs\">Get Started</a><a ng-if=\"can(\'view_comments\')\" uib-tooltip=\"Add comment\" ng-click=\"vm.toggleComments()\" ng-class=\"{btn_active: !vm.sidebarFactory.hidden}\" class=\"btn_icon btn_comments hidden-xs\"></a><div ng-click=\"vm.ui.toggleShareMenu()\" class=\"btn_icon btn_share ng-animate-disabled\"><div ng-if=\"vm.item\" ng-class=\"{\'hidden\': !vm.share_menu}\" outside-if-not=\"menu_share_dropdown,btn_share\" click-outside=\"vm.ui.toggleShareMenu(false)\" class=\"menu_share_dropdown\"><ul><li><a class=\"muted\">Share file via:</a></li><li><a ng-click=\"vm.share()\" analytics=\"Share Drop Modal Opened\" analytics-campaign_medium=\"menu\" class=\"ico_email ico_dropdown\">Email</a></li><li><a ng-click=\"vm.shareVia.facebook()\" analytics=\"Drop Shared\" analytics-campaign_medium=\"menu\" analytics-type=\"facebook\" class=\"ico_facebook ico_dropdown\">Facebook</a></li><li><a ng-click=\"vm.shareVia.twitter()\" analytics=\"Drop Shared\" analytics-campaign_medium=\"menu\" analytics-type=\"twitter\" class=\"ico_twitter ico_dropdown\">Twitter</a></li><li><a ng-click=\"vm.shareVia.googleplus()\" analytics=\"Drop Shared\" analytics-campaign_medium=\"menu\" analytics-type=\"googleplus\" class=\"ico_googleplus ico_dropdown\">Googleplus</a></li><li><a ng-click=\"vm.shareVia.pinterest()\" analytics=\"Drop Shared\" analytics-campaign_medium=\"menu\" analytics-type=\"pinterest\" class=\"ico_pinterest ico_dropdown\">Pinterest</a></li><li><a ng-click=\"vm.shareVia.tumblr()\" analytics=\"Drop Shared\" analytics-campaign_medium=\"menu\" analytics-type=\"tumblr\" class=\"ico_tumblr ico_dropdown\">Tumblr</a></li><li><a ng-click=\"vm.shareVia.reddit()\" analytics=\"Drop Shared\" analytics-campaign_medium=\"menu\" analytics-type=\"reddit\" class=\"ico_reddit ico_dropdown\">Reddit</a></li><li><a ng-click=\"vm.shareVia.linkedin()\" analytics=\"Drop Shared\" analytics-campaign_medium=\"menu\" analytics-type=\"linkedin\" class=\"ico_linkedin ico_dropdown\">Linkedin</a></li><li><a ng-click=\"vm.shareVia.blogger()\" analytics=\"Drop Shared\" analytics-campaign_medium=\"menu\" analytics-type=\"blogger\" class=\"ico_blogger ico_dropdown\">Blogger</a></li><li><a ng-click=\"vm.shareVia.delicious()\" analytics=\"Drop Shared\" analytics-campaign_medium=\"menu\" analytics-type=\"delicious\" class=\"ico_delicious ico_dropdown\">Delicious</a></li><li><a ng-click=\"vm.shareVia.flipboard()\" analytics=\"Drop Shared\" analytics-campaign_medium=\"menu\" analytics-type=\"flipboard\" class=\"ico_flipboard ico_dropdown\">Flipboard</a></li></ul></div></div><a href=\"#\" ng-if=\"can(\'upgrade_restrict\')\" ng-click=\"vm.privacy()\" class=\"btn_icon btn_privacy hidden-xs\"></a><a ng-if=\"can(\'restrict\')\" ng-click=\"vm.privacy()\" ng-init=\"vm.item.getPrivacy()\" ng-class=\"{\'active\': can(\'restrict_remote_ip\') || vm.item.isRestricted() }\" uib-tooltip=\"Share settings\" analytics=\"security_modal_opened\" analytics-campaign_medium=\"button\" class=\"btn_icon btn_privacy hidden-xs\"></a><a ng-if=\"can(\'annotate\')\" ng-href=\"{{ url.annotate(vm.item) }}\" analytics=\"Drop Open With Annotation\" analytics-campaign_medium=\"button\" class=\"btn_icon btn_label btn_annotate hidden-xs\">Annotate</a><a ng-if=\"can(\'upgrade_annotate\')\" ng-click=\"vm.signUp()\" class=\"btn_icon btn_label btn_annotate hidden-xs\">Annotate</a><a ng-if=\"vm.showChromeInstallButton()\" ng-click=\"vm.chromeInlineInstall()\" class=\"btn_icon btn_label btn_chrome hidden-xs\">Install Chrome Extension</a><a ng-if=\"can(\'join\') &amp;&amp; vm.item.details.branding\" ng-click=\"vm.signUp({ source_referral: \'viewer_favorites\' })\" class=\"button btn_default hidden-xs\">Add to Favorites</a><a ng-if=\"can(\'join\') &amp;&amp; vm.item.details.branding\" ng-click=\"vm.signUp({ source_referral: \'viewer_collections\' })\" class=\"button btn_default hidden-xs\">Add to Collection</a><a ng-if=\"can(\'admin\')\" ng-href=\"{{ url.viewOnAdmin(vm.item) }}\" class=\"button btn_default hidden-xs\">View on Admin</a><a ng-if=\"is_pro()\" ng-click=\"vm.toggleEvents()\" class=\"button btn_default hidden-xs\">Analytics</a><a ng-if=\"is_trial()\" ng-href=\"{{ url.upgradePlan(\'source_referral=viewer_upgrade_daysintrial\') }}\" class=\"pay_link\">{{ trial_days_left() }} days left on trial, join CloudApp</a><a ng-if=\"is_free()\" ng-href=\"{{ vm.plansPath }}\" uib-tooltip=\"You can remove this if you have a plan\" class=\"q-mark hidden-xs\">?</a><a ng-href=\"{{ vm.item.details.download_url }}\" target=\"_self\" class=\"button btn_default hidden-xs\">Download</a><div class=\"clear\"></div></div><div class=\"clear\"></div></div><div class=\"clear\"></div>");
$templateCache.put("app/navbar/annotations.html","<div class=\"actions_menu\"><div state=\"{{ vm.item.annotations.state }}\" class=\"annotations_menu\"><div class=\"annotations_final_actions\"><button ng-if=\"can(\'save_annotate\')\" ng-click=\"vm.item.annotations.save()\" class=\"button btn_primary\"></button> <button ng-if=\"!can(\'save_annotate\')\" ng-click=\"vm.signUpAnnotate()\" class=\"button btn_primary\"></button> <button ng-click=\"vm.item.annotations.finish()\" class=\"button btn_secondary\"></button></div><div ng-if=\"vm.item.annotations.state != \'pending\'\" class=\"annotations_options\"><button ng-click=\"vm.annotate().removeActive()\" ng-disabled=\"!vm.annotate().canRemove()\" class=\"btn_icon btn_trash btn_right\"></button> <button ng-class=\"vm.modeClass(\'blur\')\" ng-click=\"vm.annotate().blurClick()\" tooltip-enable=\"!vm.annotate().mode(\'blur\')\" uib-tooltip=\"Blur\" class=\"btn_icon btn_blur\"></button> <button ng-class=\"vm.modeClass(\'text\')\" ng-click=\"vm.setAnnotate(\'text\')\" uib-tooltip=\"Type\" class=\"btn_icon btn_text\"></button> <button ng-class=\"vm.modeClass(\'rectangle\')\" ng-click=\"vm.setAnnotate(\'rectangle\')\" uib-tooltip=\"Rectangle\" class=\"btn_icon btn_rectangle\"></button> <button ng-class=\"vm.modeClass(\'circle\')\" ng-click=\"vm.setAnnotate(\'circle\')\" uib-tooltip=\"Ellipse\" class=\"btn_icon btn_circle\"></button> <button ng-class=\"vm.modeClass(\'drawing\')\" ng-click=\"vm.setAnnotate(\'drawing\')\" uib-tooltip=\"Draw\" class=\"btn_icon btn_draw\"></button> <button ng-class=\"vm.modeClass(\'line\')\" ng-click=\"vm.setAnnotate(\'line\')\" uib-tooltip=\"Line\" class=\"btn_icon btn_line\"></button> <button ng-class=\"vm.modeClass(\'arrow\')\" ng-click=\"vm.setAnnotate(\'arrow\')\" uib-tooltip=\"Arrow\" class=\"btn_icon btn_arrow btn_left\"></button><span ng-hide=\"vm.annotate().mode(\'blur\')\"><select ng-class=\"vm.annotate().getColor()\" change=\"vm.setColor(value)\" class=\"chosen-select btn_color btn_icon\"><option value=\"red\" class=\"circle red\">Red</option><option value=\"orange\" class=\"circle orange\">Orange</option><option value=\"green\" class=\"circle green\">Green</option><option value=\"blue\" class=\"circle blue\">Blue</option><option value=\"white\" class=\"circle white\">White</option><option value=\"black\" class=\"circle black\">Black</option></select></span><a ng-click=\"vm.annotate().redo()\" ng-disabled=\"!vm.annotate().canRedo()\" uib-tooltip=\"Redo\" class=\"btn_icon btn_redo btn_right\"></a><a ng-click=\"vm.annotate().undo()\" ng-disabled=\"!vm.annotate().canUndo()\" uib-tooltip=\"Undo\" class=\"btn_icon btn_undo btn_left\"></a><div class=\"clear\"></div></div><div class=\"clear\"></div></div></div><div class=\"clear\"></div>");
$templateCache.put("app/navbar/brand-popover.html","<div class=\"upgrade_popover\"><p>Replace this logo with your own by upgrading or inviting a friend.</p><a ng-href=\"{{ url.upgradePlan(\'source_referral=viewer_cloudapp_logo\') }}\" target=\"_self\" class=\"button btn_primary\">Upgrade</a><a ng-href=\"{{ url.referFriend(\'source_referral=viewer_cloudapp_logo\') }}\" class=\"link_secondary\">Invite a friend</a></div>");
$templateCache.put("app/navbar/menu.html","<a ng-click=\"vm.ui.toggleMenu()\" analytics=\"file_more_clicked\" analytics-campaign_medium=\"menu\" class=\"menu_icon ng-animate-disabled\"></a><div ng-if=\"vm.item\" ng-class=\"{\'hidden\': !vm.menu}\" ng-init=\"vm.initClipboard()\" outside-if-not=\"menu_dropdown,menu_icon\" click-outside=\"vm.ui.toggleMenu(false)\" class=\"menu_dropdown\"><ul class=\"mobile_actions visible-xs\"><li ng-if=\"can(\'annotate\')\"><a ng-href=\"{{ url.annotate(vm.item) }}\" class=\"ico_annotation ico_dropdown\">Add annotation</a></li><li ng-if=\"can(\'upgrade_restrict\')\"><a href=\"#\" ng-click=\"vm.privacy()\" class=\"ico_privacy ico_dropdown\">Share settings</a></li><li ng-if=\"can(\'restrict\')\"><a ng-if=\"can(\'restrict\')\" ng-init=\"vm.item.getPrivacy()\" ng-click=\"vm.privacy()\" analytics=\"security_modal_opened\" analytics-campaign_medium=\"menu\" class=\"ico_privacy ico_dropdown\">Share settings</a></li><li><a ng-click=\"vm.openEmbedModal()\" analytics=\"embed_modal_opened\" analytics-campaign_medium=\"menu\" class=\"ico_embed ico_dropdown\">Embed HTML</a></li></ul><ul><li><a ng-href=\"{{ url.originalUrl(vm.item) }}\" target=\"_self\">View original file<div ngclipboard=\"\" data-clipboard-text=\"{{ url.originalUrl(vm.item) }}\" uib-tooltip=\"Copy link\" tooltip-placement=\"left\" analytics=\"item_copied\" analytics-type=\"link_direct\" analytics-campaign_medium=\"button\" class=\"btn_icon btn_copy\"></div></a></li><li><a ng-href=\"{{ url.secure(vm.item) }}\" class=\"hidden-xs\">View secure link<div ngclipboard=\"\" data-clipboard-text=\"{{ url.secure(vm.item) }}\" uib-tooltip=\"Copy link\" tooltip-placement=\"left\" analytics=\"item_copied\" analytics-type=\"link_secure\" analytics-campaign_medium=\"button\" class=\"btn_icon btn_copy\"></div></a></li><li><a class=\"hidden-xs\">Embed<div ng-click=\"vm.openEmbedModal()\" uib-tooltip=\"Copy Embed HTML\" tooltip-placement=\"left\" analytics=\"embed_modal_opened\" analytics-campaign_medium=\"button\" class=\"btn_icon btn_copy\"></div></a></li><li class=\"hidden-xs\"><a ng-click=\"vm.toggleCheatSheet()\" analytics=\"shortcuts_shown\" analytics-type=\"general\" analytics-campaign_medium=\"menu\">Show shortcuts<div class=\"shortcut\">⇧?</div></a></li><li class=\"hidden-xs\"><a ng-if=\"main.canFlag()\" ng-click=\"main.flag()\" analytics=\"flag_file_modal_opened\" analytics-campaign_medium=\"menu\">Flag this drop</a></li></ul><ul class=\"not_signedin\"><li ng-click=\"vm.signIn({ source_referral: \'viewer_join_menu_link\' })\" ng-if=\"can(\'join\')\"><a>Login</a></li><li ng-click=\"vm.signUp({ source_referral: \'viewer_join_menu_link\' })\" ng-if=\"can(\'join\')\"><a>Join CloudApp</a></li><li ng-click=\"vm.signOut()\" ng-if=\"!can(\'join\')\" analytics=\"user_signed_out\" analytics-campaign_medium=\"menu\"><a>Sign out</a></li></ul></div>");
$templateCache.put("app/navbar/navbar.html","<link rel=\"stylesheet\" type=\"text/css\" href=\"//s3.amazonaws.com/static.cl.ly/vendor/buttons.css\"><ng-include src=\"\'app/navbar/annotations.html\'\" ng-if=\"vm.mode == \'annotate\'\"></ng-include><div ng-if=\"vm.mode != \'annotate\'\"><a href=\"{{ url.back() }}\" uib-tooltip=\"Back to your files\" tooltip-placement=\"right\" ng-if=\"!can(\'join\')\" analytics=\"file_list_opened\" analytics-campaign_medium=\"button\" class=\"back_to_list\"></a><div ng-if=\"vm.item.details.custom_logo\" class=\"brand\"><a ng-href=\"{{ url.ensureExternalUrl(vm.item.details.homepage_url) }}\" analytics=\"logo_clicked\" analytics-campaign_medium=\"image\" analytics-type=\"brand\"><img ng-src=\"{{ vm.item.details.custom_logo }}\"></a></div><a ng-if=\"can(\'change_logo\') &amp;&amp; vm.item.details.branding\" ng-href=\"#\" analytics=\"logo_clicked\" analytics-campaign_medium=\"image\" analytics-type=\"cloudapp_popover\" popover-trigger=\"outsideClick\" uib-popover-template=\"\'app/navbar/brand-popover.html\'\" class=\"hidden-xs cloudapp_brand\"></a><a ng-if=\"!can(\'change_logo\') &amp;&amp; vm.item.details.branding\" ng-href=\"{{ url.marketing(\'?source_referral=viewer_cloudapp_logo\') }}\" target=\"_blank\" analytics=\"logo_clicked\" analytics-campaign_medium=\"image\" analytics-type=\"cloudapp\" class=\"hidden-xs cloudapp_brand\"></a><a ng-if=\"vm.item.details.branding\" ng-href=\"{{ url.marketing(\'?source_referral=viewer_cloudapp_logo\') }}\" target=\"_blank\" analytics=\"logo_clicked\" analytics-campaign_medium=\"image\" analytics-type=\"cloudapp\" class=\"visible-xs cloudapp_brand\"></a><a ng-if=\"false\" ng-href=\"{{ vm.enginesTeamMembershipPath() }}\" class=\"button slack-button hidden-xs\">Invite teammates from Slack</a><h2><span>{{ vm.item.data.name }}</span><a uib-tooltip=\"Add to favorites\" ng-click=\"vm.item.toggleFavorite()\" ng-class=\"{\'active\': vm.item.favorite}\" ng-init=\"vm.item.getFavorite()\" ng-if=\"can(\'favorite\')\" class=\"btn_favorite\"></a></h2><ng-include src=\"\'app/navbar/menu.html\'\"></ng-include><ng-include src=\"\'app/navbar/actions.html\'\"></ng-include><ouibounce ng-if=\"can(\'see_ads\')\" action=\"can(\'join\') ? \'login\' : \'upgrade\'\"></ouibounce></div>");
$templateCache.put("app/navbar/share-popover.html","<div class=\"share-via\"><span ng-click=\"vm.shareVia.facebook()\" class=\"facebook\"></span><span ng-click=\"vm.shareVia.twitter()\" class=\"twitter\"></span><span ng-click=\"vm.shareVia.pinterest()\" class=\"pinterest\"></span><span ng-click=\"vm.shareVia.googleplus()\" class=\"googleplus\"></span><span ng-click=\"vm.shareVia.linkedin()\" class=\"linkedin\"></span><span ng-click=\"vm.shareVia.blogger()\" class=\"blogger\"></span><span ng-click=\"vm.shareVia.delicious()\" class=\"delicious\"></span><span ng-click=\"vm.shareVia.flipboard()\" class=\"flipboard\"></span><span ng-click=\"vm.shareVia.reddit()\" class=\"reddit\"></span><span ng-click=\"vm.shareVia.tumblr()\" class=\"tumblr\"></span><span ng-click=\"vm.shareVia.email()\" class=\"email\"></span></div>");
$templateCache.put("app/otherView/otherView.html","<div class=\"file_exapmle\"><div class=\"extension\">{{ vm.item.fileExtension() }}</div></div><a ng-if=\"vm.item.details.download_url\" ng-href=\"{{ vm.item.details.download_url }}\" target=\"_self\" class=\"button btn_primary\">Download {{ vm.item.fileWithoutExtension() }}.{{ vm.item.fileExtension() }}</a><p ng-if=\"vm.item.data.mimetype == \'application/pdf\'\" class=\"file_too_big\">Your file was huge, so we’re not displaying our typical preview for the sake of speed!</p>");
$templateCache.put("app/ouibounce/ouibounce.html","<div id=\"ouibounce-modal\"><div class=\"underlay\"></div><div class=\"modal\"><div ng-switch=\"vm.action\" class=\"modal-ouibounce-content\"><login ng-switch-when=\"login\" action=\"\'signUp\'\" advertised=\"true\" close=\"vm.close()\" callback=\"vm.ouibounceCallback(success, action)\" params=\"{source_referral: \'viewer_ouibounce\'}\"></login><upgrade ng-switch-when=\"upgrade\"></upgrade></div></div></div>");
$templateCache.put("app/pdfView/pdfView.html","<link rel=\"stylesheet\" type=\"text/css\" href=\"//s3.amazonaws.com/static.cl.ly/vendor/pdf_viewer.css\"><script src=\"//s3.amazonaws.com/static.cl.ly/vendor/pdf.js\"></script><script src=\"//s3.amazonaws.com/static.cl.ly/vendor/pdf_viewer.js\"></script><div class=\"spinner\"></div><section id=\"pdf\" ng-class=\"pending(\'pdfLoad\')\"><div id=\"viewer\" class=\"pdfViewer\"></div></section>");
$templateCache.put("app/privacy/expiration.html","<div ng-class=\"[pending(\'expire\')]\"><div class=\"form-inline\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.privacy.advancedExpiration.time\">in&nbsp;</label></div><div show-errors=\"\" class=\"form-group\"><input name=\"expire_time\" type=\"number\" min=\"1\" ng-model=\"vm.privacy.advancedExpiration.expirePeriodCount\" ng-required=\"vm.privacy.advancedExpiration.time\" class=\"form-control short_input\"><select ng-model=\"vm.privacy.advancedExpiration.expirePeriod\" class=\"chosen-select\"><option value=\"3600\">hour(s)</option><option value=\"86400\">day(s)</option><option value=\"604800\">week(s)</option><option value=\"2592000\">month(s)</option></select><span ng-show=\"vm.privacy.advancedExpiration.expirePeriodCount\" class=\"f12 muted hidden-xs\">({{ vm.privacy.advancedExpiration.when() | amDateFormat:\'MMM Do YYYY, h:mm a\' }})</span></div></div><div class=\"form-inline\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.privacy.advancedExpiration.views\">after&nbsp;</label></div><div show-errors=\"\" class=\"form-group\"><input name=\"expire_views\" type=\"number\" min=\"1\" ng-model=\"vm.privacy.advancedExpiration.expiresAfterViews\" ng-required=\"vm.privacy.advancedExpiration.views\" class=\"form-control short_input\">views</div></div></div><div class=\"checkbox checkbox_remember\"><label><input type=\"checkbox\" ng-model=\"vm.privacy.advancedExpiration.remember\">Remember this custom setting</label></div>");
$templateCache.put("app/privacy/privacy.html","<div ng-class=\"[pending(\'getPrivacy\'), pending(\'setPrivacy\')]\" class=\"share_settings_modal\"><div ng-if=\"can(\'upgrade_restrict\')\" class=\"turn_on_security\"><div class=\"box\"><div class=\"ico_privacy\"></div><h3>Want to add security to your shared files?</h3><p class=\"f14\">Upgrade to any paying plan or invite a friend and get up to 12 months of CloudApp Pro.</p><br><a ng-href=\"{{ url.upgradePlan(\'source_referral=viewer_privacy_upgrade_button\') }}\" target=\"_self\" class=\"button btn_primary\">Upgrade</a><a ng-href=\"{{ url.referFriend(\'source_referral=viewer_privacy_invite_friend_button\') }}\" class=\"link_secondary\">Invite a friend</a><br><a ng-click=\"vm.cancel()\" class=\"no_thanks\">No, thanks</a></div></div><form name=\"vm.privacyForm\"><div class=\"modal-header\"><h4>Share settings</h4></div><div class=\"modal-body\"><h6>Who can access this link?</h6><div ng-if=\"can(\'restrict_remote_ip\')\" class=\"checkbox\"><label class=\"bold\"><input type=\"checkbox\" checked=\"\" disabled=\"\">This drop is restricted to your IP address</label></div><div ng-repeat=\"option in vm.privacy.options\" ng-class=\"{\'active\': vm.privacy.current_option == option.name}\" class=\"single_box\"><div class=\"radio\"><label><input type=\"radio\" ng-model=\"vm.privacy.current_option\" value=\"{{ option.name }}\"><span class=\"radio_label\">{{ option.label }}</span><div ng-if=\"option.type == \'password\'\" class=\"password inline-block\"><div ng-if=\"vm.privacy.current_option == \'password\'\" class=\"form-group inline-block\"><a ng-click=\"vm.passwordInput = true\" ng-if=\"!vm.passwordInput\" class=\"link_change_password\">Change</a> <input ng-if=\"vm.passwordInput\" ng-model=\"vm.privacy.password\" type=\"password\" required=\"\" class=\"form-control\"></div></div></label></div><div ng-if=\"option.type == \'members\'\" class=\"users\"><div ng-if=\"vm.privacy.current_option == \'users\'\" class=\"access_box\"><team-selector ng-model=\"vm.privacy\"></team-selector><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.privacy.notify\"><span class=\"regular f11\">Notify added people via email</span></label></div></div></div></div><br><div ng-if=\"can(\'expire\')\" class=\"expiration_settings\"><h6>When does this link expire?</h6><div class=\"light_box\">Expires &nbsp;<div class=\"inline-block\"><div ng-show=\"vm.item.isExpiring()\" class=\"btn_icon btn_expiration_on ng-animate-disabled js-expiration-on\"><span ng-click=\"vm.toggleAbsoluteDate()\" ng-if=\"vm.absoluteDate\">{{ vm.item.details.expires_at | amCalendar }}</span><span ng-click=\"vm.toggleAbsoluteDate()\" ng-if=\"!vm.absoluteDate\">{{ vm.item.details.expires_at | amTimeAgo }}</span><span ng-if=\"vm.privacy.expiration.expires_after_views &amp;&amp; vm.privacy.expiration.expires_at\">&nbsp;or&nbsp;</span><span ng-if=\"vm.privacy.expiration.expires_after_views\">after {{ vm.viewsLeft() }}&nbsp;<ng-pluralize count=\"vm.viewsLeft()\" when=\"{\'1\': \'view\', \'other\': \'views\'}\"></ng-pluralize></span><a ng-click=\"vm.removeExpiration()\" class=\"btn_cancel btn_icon\"></a></div><div ng-hide=\"vm.item.isExpiring()\" ng-animate=\"false\" class=\"js-expiration-off\"><select ng-model=\"vm.updateExpiration\" data-placeholder=\"Never\" ng-model-options=\"{ getterSetter: true }\" class=\"btn_icon chosen-select ng-animate-disabled\"><option value=\"0/\" class=\"border\">Never</option><option value=\"{{ vm.getLastExpire() }}\" ng-if=\"vm.getLastExpire()\" class=\"border\">{{ vm.getLastExpireMessage() }}</option><option value=\"3600/\">in 1 hour</option><option value=\"86400/\">in 1 day</option><option value=\"604800/\" class=\"border\">in 1 week</option><option value=\"0/1\">after 1 view</option><option value=\"0/10\" class=\"border\">after 10 views</option><option value=\"advanced\">Advanced settings</option></select></div></div><div ng-if=\"vm.privacy.showAdvanced\" class=\"advanced_settings\"><ng-include src=\"\'app/privacy/expiration.html\'\"></ng-include></div></div></div></div><div class=\"modal-footer\"><button ng-click=\"vm.save()\" ng-disabled=\"vm.invalid()\" class=\"button btn_primary\">Save</button> <button ng-click=\"vm.cancel()\" class=\"button btn_secondary\">Cancel</button></div></form></div>");
$templateCache.put("app/related/related.html","<div ng-if=\"relatedVm.related().length\"><h2>Related drops</h2><ul><li ng-repeat=\"item in relatedVm.related()\"><a href=\"/{{ item }}\" target=\"_self\"><img ng-src=\"{{ relatedVm.thumbnail(item) }}\" style=\"width: 95px\"></a></li></ul></div>");
$templateCache.put("app/share/share.html","<div class=\"modal-header share_header\"><h1>Share this link to anyone</h1><span class=\"muted\">{{ vm.item.data.name }}</span><div class=\"preview\"><img ng-src=\"{{ vm.item.thumbnail(\'h40w40\') }}\"></div></div><div class=\"modal-body\"><div class=\"share_content\"><ng-form name=\"vm.shareForm\" class=\"share_form\"><team-selector ng-model=\"vm.share\"></team-selector><textarea ng-model=\"vm.share.message\" placeholder=\"Message (optional)\" class=\"form-control\"></textarea></ng-form></div><div ng-if=\"can(\'restrict\')\" class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.share.restricted\"><span ng-if=\"!vm.item.privacy.restricted\">Make this drop accessible only for selected people</span><span ng-if=\"vm.item.privacy.restricted\">Add these friends to your VIP list for this classified, private content.</span></label></div></div><div class=\"modal-footer\"><button ng-click=\"vm.save()\" ng-disabled=\"vm.invalid()\" class=\"button btn_primary\">Share</button> <button ng-click=\"vm.cancel()\" class=\"button btn_secondary\">Cancel</button></div>");
$templateCache.put("app/sidebar/sidebar.html","<div id=\"sidebar\" class=\"right_hand_column\"><a ng-click=\"vm.toggleHidden()\" class=\"ico_close\"></a><div class=\"sidebar_share\"><span class=\"sidebar_title\">Share this link</span><div class=\"link_box\">{{ url.share(vm.item) }}<a ngclipboard=\"\" ng-click=\"vm.copyFeedback()\" data-clipboard-text=\"{{ url.share(vm.item) }}\" class=\"link_box_copy {{copyClass}}\">{{copyText}}</a></div><div class=\"share_options\"><a ng-click=\"vm.shareVia.facebook()\" analytics=\"Drop Shared\" analytics-campaign_medium=\"button\" analytics-type=\"facebook\" class=\"ico_facebook\"></a><a ng-click=\"vm.shareVia.twitter()\" analytics=\"Drop Shared\" analytics-campaign_medium=\"button\" analytics-type=\"twitter\" class=\"ico_twitter\"></a><a href=\"mailto:?subject=Check%20out%20what%20I%20created%20with%20CloudApp&amp;body=Check%20my%20drop%20at%20{{ url.share(vm.item) }}.\" analytics=\"Share Drop Modal Opened\" analytics-campaign_medium=\"button\" ng-if=\"can(\'share_email\')\" class=\"ico_email\"></a><a ng-click=\"vm.openEmbedModal()\" analytics=\"embed_modal_opened\" analytics-campaign_medium=\"button\" class=\"ico_embed\"></a></div></div><div ng-if=\"is_free() &amp;&amp; can(\'own\')\" class=\"sidebar_share\"><span class=\"sidebar_title\">Who viewed your link?</span><div class=\"invite_text\">Invite someone to CloudApp and unlock the ability to see who views your link after they create their first drop. You can also upgrade to Pro to use this and other pro features.</div><div class=\"invite_text\"><a ng-href=\"{{ url.referFriend(\'utm_campaign=refer_a_friend_to_unlock\') }}\" class=\"button btn_primary\">Refer to unlock</a></div><div class=\"events_list\"><div class=\"event\"><div class=\"type_icon\"><img src=\"https://s.gravatar.com/avatar/aaf19dea642b17e842190909640cb215?s=80&amp;d=blank\"><span>j</span></div><div class=\"event_details\"><strong>john@doe.com</strong>&nbsp; viewed file<br><span>30 minutes ago</span></div></div><div class=\"event\"><div class=\"type_icon\"><img src=\"https://s.gravatar.com/avatar/aaf19dea642b17e842190909640cb215?s=80&amp;d=blank\"><span>j</span></div><div class=\"event_details\"><strong>john@doe.com</strong>&nbsp; viewed file<br><span>2 days ago</span></div></div><div class=\"vanish_layer\"></div></div></div><related ng-if=\"can(\'view_related\')\"></related><div ng-click=\"vm.toggleHidden()\" ng-if=\"vm.sidebarFactory.hidden\" class=\"rhc_arrow\"></div><div ng-if=\"false\" class=\"rhc_nav\"><a ng-if=\"can(\'view_comments\')\" ng-class=\"{active: vm.isCommentsTab()}\" ng-click=\"vm.setTab(\'comments\')\" class=\"tab_el tab_comments\"><span>Comments</span><span class=\"number\">{{ vm.item.commentCount() }}</span></a><span ng-if=\"can(\'view_comments\') &amp;&amp; can(\'view_events\')\" class=\"separator\">&nbsp;|&nbsp;</span><a ng-if=\"can(\'view_events\')\" ng-class=\"{active: vm.isEventsTab()}\" ng-click=\"vm.setTab(\'events\')\" analytics=\"Viewer Events Tab Opened\" class=\"tab_el tab_events new_event\"><span>Events</span></a><a ng-click=\"vm.toggleHidden()\" class=\"ico_close\"></a><div class=\"clear\"></div></div><div ng-show=\"vm.isCommentsTab()\"><comments ng-if=\"can(\'view_comments\')\" class=\"comments\"></comments><div ng-if=\"!can(\'comment\') &amp;&amp; false\" class=\"join_to_team\"><div class=\"comments\"><form name=\"vm.newCommentForm\" ng-submit=\"vm.submitComment()\" class=\"add_comment_form\"><textarea ng-model=\"vm.newComment.content\" required=\"\" placeholder=\"Comment\" class=\"form-control\"></textarea> <input type=\"submit\" value=\"Comment\" ng-disabled=\"vm.newCommentForm.$invalid\" class=\"button btn_primary pull-right\"><span class=\"error_msg\"></span><div class=\"clear\"></div></form><div class=\"comments_emptystate\">Hey, don’t let it go unsaid! Add your comments that your teammates can review and reply to.</div></div><div class=\"clear\"></div><div class=\"animation\"><h4 class=\"js-first hidden\">Want to get team feedback?</h4><p class=\"f14 js-second hidden\">Create a team and accelerate your workflow.</p><a ng-href=\"{{ url.newTeam() }}\" class=\"js-third button btn_primary hidden w100\">Get Started & Claim your team</a></div></div></div><div ng-show=\"vm.isEventsTab()\"><events ng-if=\"can(\'view_events\')\" class=\"events\"></events></div></div>");
$templateCache.put("app/signup/signup.html","<div class=\"signup\"><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 text-center\"><div class=\"logo_cloudapp\"></div><h3>Show, don\'t tell</h3></div></div><div class=\"row\"><div class=\"col-sm-2 hidden-xs\"></div><div class=\"col-md-4 download_app\"><video></video><p>Free for <strong>Mac, Windows, Linux</strong>and <strong>iOS.</strong></p><button class=\"button\">Download CloudApp</button></div><div class=\"col-sm-4 create_account\"><ng-include src=\"\'app/login/login.html\'\"></ng-include></div><div class=\"col-sm-2 hidden-xs\"></div></div><div class=\"row\"><div class=\"col-sm-2 hidden-xs\"></div><div class=\"col-sm-8\"><div class=\"partners_logos\"></div></div><div class=\"col-sm-2 hidden-xs\"></div></div></div></div>");
$templateCache.put("app/teamSelector/teamSelector.html","<div class=\"add_team\"><div ng-if=\"vm.availableTeams.length &gt; 1\" class=\"many_teams\"><span class=\"label_name\">Add members from your team</span><select options=\"vm.availableTeams\" change=\"vm.teamSelect(value)\" class=\"chosen-select\"><option>Select a team</option><option ng-repeat=\"team in vm.availableTeams\" value=\"{{ team.id }}\">{{ team.name }}</option></select></div><div ng-if=\"vm.availableTeams.length == 1\" ng-repeat=\"team in vm.availableTeams\" class=\"one_team\"><button ng-click=\"vm.teamSelect(team.id)\">+ Add {{ team.name }} members</button></div></div><div class=\"multiselect\"><tags-input template=\"app/teamSelector/teamSelectorTemplate.html\" ng-model=\"vm._users\" add-on-space=\"true\" placeholder=\"Add an email\" allowed-tags-pattern=\"^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$\" on-tag-added=\"vm.newTag($tag)\" on-tag-removed=\"vm.change()\"><auto-complete source=\"vm.autocomplete($query)\" select-first-match=\"false\"></auto-complete></tags-input></div>");
$templateCache.put("app/teamSelector/teamSelectorTemplate.html","<div ng-class=\"data.class\" class=\"tag-template\"><span>{{ $getDisplayText() }}</span><a ng-click=\"$removeTag()\" class=\"remove-button\">&#10006;</a></div>");
$templateCache.put("app/textView/textView.html","<h1>TEXT</h1>");
$templateCache.put("app/tout/tout.html","<div ng-if=\"tout.visible\" class=\"tout hidden-xs\"><span>{{tout.message}}</span><div class=\"tout_cta\"><div ng-if=\"tout.expanded\" class=\"expanded\"><div ng-click=\"tout.expanded = false\" analytics=\"ToutMinimized\" analytics-content=\"{{ tout.message}}\" analytics-expanded=\"yes\" analytics-user=\"{{ tout.toutFor }}\" analytics-offer=\"{{ tout.buttonMsg }}\" class=\"ico_close\"></div><h4>{{ tout.headline }}</h4><p>{{ tout.tagline }}</p><a href=\"{{ tout.button_url }}\" analytics=\"ToutClicked\" analytics-expanded=\"yes\" analytics-content=\"{{ tout.message}}\" analytics-user=\"{{ tout.user_type }}\" analytics-offer=\"{{ tout.button_msg }}\" class=\"btn_icon btn_expanded\">{{tout.button_msg}}</a></div><a ng-if=\"!tout.expanded\" analytics=\"ToutClicked\" analytics-content=\"{{ tout.message}}\" analytics-expanded=\"no\" analytics-user=\"{{ tout.user_type }}\" analytics-offer=\"{{ tout.button_msg }}\" ng-click=\"tout.onClick()\" class=\"btn_icon btn_minimized\">{{tout.button_msg}}</a></div></div>");
$templateCache.put("app/unauthorized/unauthorized.html","<div ng-switch=\"vm.action()\" class=\"unauthorized\"><div class=\"unauthorized_container\"><div ng-switch-when=\"password\"><div class=\"unauthorized_permission_page\"><div class=\"unauthorized_logo\"></div><form class=\"password_form\"><div class=\"input-group\"><input type=\"password\" ng-model=\"vm.passwordForm.password\" placeholder=\"Password required\" class=\"form-control\"><div class=\"input-group-btn\"><button ng-click=\"vm.passwordForm.submit()\" class=\"btn button btn_primary\">Unlock</button><a ng-if=\"vm.item.access.has_session\" ng-click=\"vm.createPasswordRequest()\" class=\"btn button btn_primary\">Send request</a></div></div></form></div></div><div ng-switch-when=\"login\"><login callback=\"vm.loginCallback(success)\"></login></div><div ng-switch-when=\"access\"><div ng-if=\"vm.item.access.can_send_request\" class=\"unauthorized_permission_page\"><div class=\"unauthorized_logo\"></div><h1>You need permission to see this file</h1><a ng-click=\"vm.createAccessRequest()\" class=\"button btn_primary\">Request access</a></div><div ng-if=\"!vm.item.access.can_send_request\" class=\"unauthorized_permission_page\"><div class=\"unauthorized_logo\"></div><div class=\"text-center\"><h1 class=\"check\">Request already sent</h1></div></div></div><div ng-switch-when=\"not_available\" class=\"unauthorized_permission_page\"><div class=\"unauthorized_logo\"></div><div class=\"text-center\"><h1>Drop is not available</h1></div></div><div ng-switch-default=\"\"></div></div></div>");
$templateCache.put("app/upgrade/upgrade.html","<div class=\"modal-header\"><h4 class=\"with_logo\">Upgrade to CloudApp Pro</h4><p class=\"muted f14 text-center\"></p><em>Communicate faster with unlimited screen recordings,<br>secure sharing, longer GIF capture, 1GB max file size and 2GB/file daily bandwidth.</em></div><div class=\"modal-body\"><a ng-href=\"{{ vm.url.upgradePlan(\'source_referral=viewer_ouibounce\') }}\" analytics=\"OuibounceUpgradeClicked\" class=\"button btn_primary\">UPGRADE NOW</a></div>");
$templateCache.put("app/videoView/videoView.html","<div ng-if=\"vm.item.data.source_url\" ng-switch=\"vm.item.data.type\"><div ng-switch-when=\"audio\" class=\"audio_view\"><audio id=\"player\" controls=\"\" preload=\"auto\" class=\"video-js vjs-default-skin\"></audio></div><div ng-switch-when=\"video\" class=\"video_view\"><video id=\"player\" controls=\"\" preload=\"auto\" width=\"900\" height=\"560\" class=\"video-js vjs-default-skin\"></video></div></div>");}]);